/*!
* sweetalert2 v11.22.4
* Released under the MIT License.
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Sweetalert2=t()}(this,function(){"use strict";function e(e,t,n){if("function"==typeof e?e===t:e.has(t))return arguments.length<3?t:n;throw new TypeError("Private element is not present on this object")}function t(t,n){return t.get(e(t,n))}function n(e,t,n){(function(e,t){if(t.has(e))throw new TypeError("Cannot initialize the same private elements twice on an object")})(e,t),t.set(e,n)}const o={},i=e=>new Promise(t=>{if(!e)return t();const n=window.scrollX,i=window.scrollY;o.restoreFocusTimeout=setTimeout(()=>{o.previousActiveElement instanceof HTMLElement?(o.previousActiveElement.focus(),o.previousActiveElement=null):document.body&&document.body.focus(),t()},100),window.scrollTo(n,i)}),s="swal2-",r=["container","shown","height-auto","iosfix","popup","modal","no-backdrop","no-transition","toast","toast-shown","show","hide","close","title","html-container","actions","confirm","deny","cancel","footer","icon","icon-content","image","input","file","range","select","radio","checkbox","label","textarea","inputerror","input-label","validation-message","progress-steps","active-progress-step","progress-step","progress-step-line","loader","loading","styled","top","top-start","top-end","top-left","top-right","center","center-start","center-end","center-left","center-right","bottom","bottom-start","bottom-end","bottom-left","bottom-right","grow-row","grow-column","grow-fullscreen","rtl","timer-progress-bar","timer-progress-bar-container","scrollbar-measure","icon-success","icon-warning","icon-info","icon-question","icon-error","draggable","dragging"].reduce((e,t)=>(e[t]=s+t,e),{}),a=["success","warning","info","question","error"].reduce((e,t)=>(e[t]=s+t,e),{}),l="SweetAlert2:",c=e=>e.charAt(0).toUpperCase()+e.slice(1),u=e=>{console.warn(`${l} ${"object"==typeof e?e.join(" "):e}`)},d=e=>{console.error(`${l} ${e}`)},p=[],m=(e,t=null)=>{var n;n=`"${e}" is deprecated and will be removed in the next major release.${t?` Use "${t}" instead.`:""}`,p.includes(n)||(p.push(n),u(n))},h=e=>"function"==typeof e?e():e,g=e=>e&&"function"==typeof e.toPromise,f=e=>g(e)?e.toPromise():Promise.resolve(e),b=e=>e&&Promise.resolve(e)===e,y=()=>document.body.querySelector(`.${r.container}`),v=e=>{const t=y();return t?t.querySelector(e):null},w=e=>v(`.${e}`),C=()=>w(r.popup),A=()=>w(r.icon),E=()=>w(r.title),k=()=>w(r["html-container"]),B=()=>w(r.image),$=()=>w(r["progress-steps"]),L=()=>w(r["validation-message"]),P=()=>v(`.${r.actions} .${r.confirm}`),x=()=>v(`.${r.actions} .${r.cancel}`),T=()=>v(`.${r.actions} .${r.deny}`),S=()=>v(`.${r.loader}`),O=()=>w(r.actions),M=()=>w(r.footer),j=()=>w(r["timer-progress-bar"]),H=()=>w(r.close),I=()=>{const e=C();if(!e)return[];const t=e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'),n=Array.from(t).sort((e,t)=>{const n=parseInt(e.getAttribute("tabindex")||"0"),o=parseInt(t.getAttribute("tabindex")||"0");return n>o?1:n<o?-1:0}),o=e.querySelectorAll('\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n'),i=Array.from(o).filter(e=>"-1"!==e.getAttribute("tabindex"));return[...new Set(n.concat(i))].filter(e=>ee(e))},D=()=>N(document.body,r.shown)&&!N(document.body,r["toast-shown"])&&!N(document.body,r["no-backdrop"]),V=()=>{const e=C();return!!e&&N(e,r.toast)},q=(e,t)=>{if(e.textContent="",t){const n=(new DOMParser).parseFromString(t,"text/html"),o=n.querySelector("head");o&&Array.from(o.childNodes).forEach(t=>{e.appendChild(t)});const i=n.querySelector("body");i&&Array.from(i.childNodes).forEach(t=>{t instanceof HTMLVideoElement||t instanceof HTMLAudioElement?e.appendChild(t.cloneNode(!0)):e.appendChild(t)})}},N=(e,t)=>{if(!t)return!1;const n=t.split(/\s+/);for(let t=0;t<n.length;t++)if(!e.classList.contains(n[t]))return!1;return!0},_=(e,t,n)=>{if(((e,t)=>{Array.from(e.classList).forEach(n=>{Object.values(r).includes(n)||Object.values(a).includes(n)||Object.values(t.showClass||{}).includes(n)||e.classList.remove(n)})})(e,t),!t.customClass)return;const o=t.customClass[n];o&&("string"==typeof o||o.forEach?z(e,o):u(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`))},F=(e,t)=>{if(!t)return null;switch(t){case"select":case"textarea":case"file":return e.querySelector(`.${r.popup} > .${r[t]}`);case"checkbox":return e.querySelector(`.${r.popup} > .${r.checkbox} input`);case"radio":return e.querySelector(`.${r.popup} > .${r.radio} input:checked`)||e.querySelector(`.${r.popup} > .${r.radio} input:first-child`);case"range":return e.querySelector(`.${r.popup} > .${r.range} input`);default:return e.querySelector(`.${r.popup} > .${r.input}`)}},R=e=>{if(e.focus(),"file"!==e.type){const t=e.value;e.value="",e.value=t}},U=(e,t,n)=>{e&&t&&("string"==typeof t&&(t=t.split(/\s+/).filter(Boolean)),t.forEach(t=>{Array.isArray(e)?e.forEach(e=>{n?e.classList.add(t):e.classList.remove(t)}):n?e.classList.add(t):e.classList.remove(t)}))},z=(e,t)=>{U(e,t,!0)},W=(e,t)=>{U(e,t,!1)},K=(e,t)=>{const n=Array.from(e.children);for(let e=0;e<n.length;e++){const o=n[e];if(o instanceof HTMLElement&&N(o,t))return o}},Y=(e,t,n)=>{n===`${parseInt(n)}`&&(n=parseInt(n)),n||0===parseInt(n)?e.style.setProperty(t,"number"==typeof n?`${n}px`:n):e.style.removeProperty(t)},X=(e,t="flex")=>{e&&(e.style.display=t)},Z=e=>{e&&(e.style.display="none")},J=(e,t="block")=>{e&&new MutationObserver(()=>{Q(e,e.innerHTML,t)}).observe(e,{childList:!0,subtree:!0})},G=(e,t,n,o)=>{const i=e.querySelector(t);i&&i.style.setProperty(n,o)},Q=(e,t,n="flex")=>{t?X(e,n):Z(e)},ee=e=>!(!e||!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)),te=e=>!!(e.scrollHeight>e.clientHeight),ne=e=>{const t=window.getComputedStyle(e),n=parseFloat(t.getPropertyValue("animation-duration")||"0"),o=parseFloat(t.getPropertyValue("transition-duration")||"0");return n>0||o>0},oe=(e,t=!1)=>{const n=j();n&&ee(n)&&(t&&(n.style.transition="none",n.style.width="100%"),setTimeout(()=>{n.style.transition=`width ${e/1e3}s linear`,n.style.width="0%"},10))},ie=`\n <div aria-labelledby="${r.title}" aria-describedby="${r["html-container"]}" class="${r.popup}" tabindex="-1">\n   <button type="button" class="${r.close}"></button>\n   <ul class="${r["progress-steps"]}"></ul>\n   <div class="${r.icon}"></div>\n   <img class="${r.image}" />\n   <h2 class="${r.title}" id="${r.title}"></h2>\n   <div class="${r["html-container"]}" id="${r["html-container"]}"></div>\n   <input class="${r.input}" id="${r.input}" />\n   <input type="file" class="${r.file}" />\n   <div class="${r.range}">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="${r.select}" id="${r.select}"></select>\n   <div class="${r.radio}"></div>\n   <label class="${r.checkbox}">\n     <input type="checkbox" id="${r.checkbox}" />\n     <span class="${r.label}"></span>\n   </label>\n   <textarea class="${r.textarea}" id="${r.textarea}"></textarea>\n   <div class="${r["validation-message"]}" id="${r["validation-message"]}"></div>\n   <div class="${r.actions}">\n     <div class="${r.loader}"></div>\n     <button type="button" class="${r.confirm}"></button>\n     <button type="button" class="${r.deny}"></button>\n     <button type="button" class="${r.cancel}"></button>\n   </div>\n   <div class="${r.footer}"></div>\n   <div class="${r["timer-progress-bar-container"]}">\n     <div class="${r["timer-progress-bar"]}"></div>\n   </div>\n </div>\n`.replace(/(^|\n)\s*/g,""),se=()=>{o.currentInstance.resetValidationMessage()},re=e=>{const t=(()=>{const e=y();return!!e&&(e.remove(),W([document.documentElement,document.body],[r["no-backdrop"],r["toast-shown"],r["has-column"]]),!0)})();if("undefined"==typeof window||"undefined"==typeof document)return void d("SweetAlert2 requires document to initialize");const n=document.createElement("div");n.className=r.container,t&&z(n,r["no-transition"]),q(n,ie),n.dataset.swal2Theme=e.theme;const o="string"==typeof(i=e.target)?document.querySelector(i):i;var i;o.appendChild(n),e.topLayer&&(n.setAttribute("popover",""),n.showPopover()),(e=>{const t=C();t.setAttribute("role",e.toast?"alert":"dialog"),t.setAttribute("aria-live",e.toast?"polite":"assertive"),e.toast||t.setAttribute("aria-modal","true")})(e),(e=>{"rtl"===window.getComputedStyle(e).direction&&z(y(),r.rtl)})(o),(()=>{const e=C(),t=K(e,r.input),n=K(e,r.file),o=e.querySelector(`.${r.range} input`),i=e.querySelector(`.${r.range} output`),s=K(e,r.select),a=e.querySelector(`.${r.checkbox} input`),l=K(e,r.textarea);t.oninput=se,n.onchange=se,s.onchange=se,a.onchange=se,l.oninput=se,o.oninput=()=>{se(),i.value=o.value},o.onchange=()=>{se(),i.value=o.value}})()},ae=(e,t)=>{e instanceof HTMLElement?t.appendChild(e):"object"==typeof e?le(e,t):e&&q(t,e)},le=(e,t)=>{e.jquery?ce(t,e):q(t,e.toString())},ce=(e,t)=>{if(e.textContent="",0 in t)for(let n=0;n in t;n++)e.appendChild(t[n].cloneNode(!0));else e.appendChild(t.cloneNode(!0))},ue=(e,t)=>{const n=O(),o=S();n&&o&&(t.showConfirmButton||t.showDenyButton||t.showCancelButton?X(n):Z(n),_(n,t,"actions"),function(e,t,n){const o=P(),i=T(),s=x();if(!o||!i||!s)return;pe(o,"confirm",n),pe(i,"deny",n),pe(s,"cancel",n),function(e,t,n,o){if(!o.buttonsStyling)return void W([e,t,n],r.styled);z([e,t,n],r.styled),o.confirmButtonColor&&e.style.setProperty("--swal2-confirm-button-background-color",o.confirmButtonColor);o.denyButtonColor&&t.style.setProperty("--swal2-deny-button-background-color",o.denyButtonColor);o.cancelButtonColor&&n.style.setProperty("--swal2-cancel-button-background-color",o.cancelButtonColor);de(e),de(t),de(n)}(o,i,s,n),n.reverseButtons&&(n.toast?(e.insertBefore(s,o),e.insertBefore(i,o)):(e.insertBefore(s,t),e.insertBefore(i,t),e.insertBefore(o,t)))}(n,o,t),q(o,t.loaderHtml||""),_(o,t,"loader"))};function de(e){const t=window.getComputedStyle(e);if(t.getPropertyValue("--swal2-action-button-focus-box-shadow"))return;const n=t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/,"rgba($1, $2, $3, 0.5)");e.style.setProperty("--swal2-action-button-focus-box-shadow",t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/,` ${n}`))}function pe(e,t,n){const o=c(t);Q(e,n[`show${o}Button`],"inline-block"),q(e,n[`${t}ButtonText`]||""),e.setAttribute("aria-label",n[`${t}ButtonAriaLabel`]||""),e.className=r[t],_(e,n,`${t}Button`)}const me=(e,t)=>{const n=y();n&&(!function(e,t){"string"==typeof t?e.style.background=t:t||z([document.documentElement,document.body],r["no-backdrop"])}(n,t.backdrop),function(e,t){if(!t)return;t in r?z(e,r[t]):(u('The "position" parameter is not valid, defaulting to "center"'),z(e,r.center))}(n,t.position),function(e,t){if(!t)return;z(e,r[`grow-${t}`])}(n,t.grow),_(n,t,"container"))};var he={innerParams:new WeakMap,domCache:new WeakMap};const ge=["input","file","range","select","radio","checkbox","textarea"],fe=e=>{if(!e.input)return;if(!Ee[e.input])return void d(`Unexpected type of input! Expected ${Object.keys(Ee).join(" | ")}, got "${e.input}"`);const t=Ce(e.input);if(!t)return;const n=Ee[e.input](t,e);X(t),e.inputAutoFocus&&setTimeout(()=>{R(n)})},be=(e,t)=>{const n=C();if(!n)return;const o=F(n,e);if(o){(e=>{for(let t=0;t<e.attributes.length;t++){const n=e.attributes[t].name;["id","type","value","style"].includes(n)||e.removeAttribute(n)}})(o);for(const e in t)o.setAttribute(e,t[e])}},ye=e=>{if(!e.input)return;const t=Ce(e.input);t&&_(t,e,"input")},ve=(e,t)=>{!e.placeholder&&t.inputPlaceholder&&(e.placeholder=t.inputPlaceholder)},we=(e,t,n)=>{if(n.inputLabel){const o=document.createElement("label"),i=r["input-label"];o.setAttribute("for",e.id),o.className=i,"object"==typeof n.customClass&&z(o,n.customClass.inputLabel),o.innerText=n.inputLabel,t.insertAdjacentElement("beforebegin",o)}},Ce=e=>{const t=C();if(t)return K(t,r[e]||r.input)},Ae=(e,t)=>{["string","number"].includes(typeof t)?e.value=`${t}`:b(t)||u(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`)},Ee={};Ee.text=Ee.email=Ee.password=Ee.number=Ee.tel=Ee.url=Ee.search=Ee.date=Ee["datetime-local"]=Ee.time=Ee.week=Ee.month=(e,t)=>(Ae(e,t.inputValue),we(e,e,t),ve(e,t),e.type=t.input,e),Ee.file=(e,t)=>(we(e,e,t),ve(e,t),e),Ee.range=(e,t)=>{const n=e.querySelector("input"),o=e.querySelector("output");return Ae(n,t.inputValue),n.type=t.input,Ae(o,t.inputValue),we(n,e,t),e},Ee.select=(e,t)=>{if(e.textContent="",t.inputPlaceholder){const n=document.createElement("option");q(n,t.inputPlaceholder),n.value="",n.disabled=!0,n.selected=!0,e.appendChild(n)}return we(e,e,t),e},Ee.radio=e=>(e.textContent="",e),Ee.checkbox=(e,t)=>{const n=F(C(),"checkbox");n.value="1",n.checked=Boolean(t.inputValue);const o=e.querySelector("span");return q(o,t.inputPlaceholder||t.inputLabel),n},Ee.textarea=(e,t)=>{Ae(e,t.inputValue),ve(e,t),we(e,e,t);return setTimeout(()=>{if("MutationObserver"in window){const n=parseInt(window.getComputedStyle(C()).width);new MutationObserver(()=>{if(!document.body.contains(e))return;const o=e.offsetWidth+(i=e,parseInt(window.getComputedStyle(i).marginLeft)+parseInt(window.getComputedStyle(i).marginRight));var i;o>n?C().style.width=`${o}px`:Y(C(),"width",t.width)}).observe(e,{attributes:!0,attributeFilter:["style"]})}}),e};const ke=(e,t)=>{const n=k();n&&(J(n),_(n,t,"htmlContainer"),t.html?(ae(t.html,n),X(n,"block")):t.text?(n.textContent=t.text,X(n,"block")):Z(n),((e,t)=>{const n=C();if(!n)return;const o=he.innerParams.get(e),i=!o||t.input!==o.input;ge.forEach(e=>{const o=K(n,r[e]);o&&(be(e,t.inputAttributes),o.className=r[e],i&&Z(o))}),t.input&&(i&&fe(t),ye(t))})(e,t))},Be=(e,t)=>{for(const[n,o]of Object.entries(a))t.icon!==n&&W(e,o);z(e,t.icon&&a[t.icon]),Pe(e,t),$e(),_(e,t,"icon")},$e=()=>{const e=C();if(!e)return;const t=window.getComputedStyle(e).getPropertyValue("background-color"),n=e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");for(let e=0;e<n.length;e++)n[e].style.backgroundColor=t},Le=(e,t)=>{if(!t.icon&&!t.iconHtml)return;let n=e.innerHTML,o="";if(t.iconHtml)o=xe(t.iconHtml);else if("success"===t.icon)o=(e=>`\n  ${e.animation?'<div class="swal2-success-circular-line-left"></div>':""}\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div>\n  ${e.animation?'<div class="swal2-success-fix"></div>':""}\n  ${e.animation?'<div class="swal2-success-circular-line-right"></div>':""}\n`)(t),n=n.replace(/ style=".*?"/g,"");else if("error"===t.icon)o='\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';else if(t.icon){o=xe({question:"?",warning:"!",info:"i"}[t.icon])}n.trim()!==o.trim()&&q(e,o)},Pe=(e,t)=>{if(t.iconColor){e.style.color=t.iconColor,e.style.borderColor=t.iconColor;for(const n of[".swal2-success-line-tip",".swal2-success-line-long",".swal2-x-mark-line-left",".swal2-x-mark-line-right"])G(e,n,"background-color",t.iconColor);G(e,".swal2-success-ring","border-color",t.iconColor)}},xe=e=>`<div class="${r["icon-content"]}">${e}</div>`;let Te=!1,Se=0,Oe=0,Me=0,je=0;const He=e=>{const t=C();if(e.target===t||A().contains(e.target)){Te=!0;const n=Ve(e);Se=n.clientX,Oe=n.clientY,Me=parseInt(t.style.insetInlineStart)||0,je=parseInt(t.style.insetBlockStart)||0,z(t,"swal2-dragging")}},Ie=e=>{const t=C();if(Te){let{clientX:n,clientY:o}=Ve(e);t.style.insetInlineStart=`${Me+(n-Se)}px`,t.style.insetBlockStart=`${je+(o-Oe)}px`}},De=()=>{const e=C();Te=!1,W(e,"swal2-dragging")},Ve=e=>{let t=0,n=0;return e.type.startsWith("mouse")?(t=e.clientX,n=e.clientY):e.type.startsWith("touch")&&(t=e.touches[0].clientX,n=e.touches[0].clientY),{clientX:t,clientY:n}},qe=(e,t)=>{const n=y(),o=C();if(n&&o){if(t.toast){Y(n,"width",t.width),o.style.width="100%";const e=S();e&&o.insertBefore(e,A())}else Y(o,"width",t.width);Y(o,"padding",t.padding),t.color&&(o.style.color=t.color),t.background&&(o.style.background=t.background),Z(L()),Ne(o,t),t.draggable&&!t.toast?(z(o,r.draggable),(e=>{e.addEventListener("mousedown",He),document.body.addEventListener("mousemove",Ie),e.addEventListener("mouseup",De),e.addEventListener("touchstart",He),document.body.addEventListener("touchmove",Ie),e.addEventListener("touchend",De)})(o)):(W(o,r.draggable),(e=>{e.removeEventListener("mousedown",He),document.body.removeEventListener("mousemove",Ie),e.removeEventListener("mouseup",De),e.removeEventListener("touchstart",He),document.body.removeEventListener("touchmove",Ie),e.removeEventListener("touchend",De)})(o))}},Ne=(e,t)=>{const n=t.showClass||{};e.className=`${r.popup} ${ee(e)?n.popup:""}`,t.toast?(z([document.documentElement,document.body],r["toast-shown"]),z(e,r.toast)):z(e,r.modal),_(e,t,"popup"),"string"==typeof t.customClass&&z(e,t.customClass),t.icon&&z(e,r[`icon-${t.icon}`])},_e=e=>{const t=document.createElement("li");return z(t,r["progress-step"]),q(t,e),t},Fe=e=>{const t=document.createElement("li");return z(t,r["progress-step-line"]),e.progressStepsDistance&&Y(t,"width",e.progressStepsDistance),t},Re=(e,t)=>{qe(0,t),me(0,t),((e,t)=>{const n=$();if(!n)return;const{progressSteps:o,currentProgressStep:i}=t;o&&0!==o.length&&void 0!==i?(X(n),n.textContent="",i>=o.length&&u("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"),o.forEach((e,s)=>{const a=_e(e);if(n.appendChild(a),s===i&&z(a,r["active-progress-step"]),s!==o.length-1){const e=Fe(t);n.appendChild(e)}})):Z(n)})(0,t),((e,t)=>{const n=he.innerParams.get(e),o=A();if(!o)return;if(n&&t.icon===n.icon)return Le(o,t),void Be(o,t);if(!t.icon&&!t.iconHtml)return void Z(o);if(t.icon&&-1===Object.keys(a).indexOf(t.icon))return d(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`),void Z(o);X(o),Le(o,t),Be(o,t),z(o,t.showClass&&t.showClass.icon),window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change",$e)})(e,t),((e,t)=>{const n=B();n&&(t.imageUrl?(X(n,""),n.setAttribute("src",t.imageUrl),n.setAttribute("alt",t.imageAlt||""),Y(n,"width",t.imageWidth),Y(n,"height",t.imageHeight),n.className=r.image,_(n,t,"image")):Z(n))})(0,t),((e,t)=>{const n=E();n&&(J(n),Q(n,t.title||t.titleText,"block"),t.title&&ae(t.title,n),t.titleText&&(n.innerText=t.titleText),_(n,t,"title"))})(0,t),((e,t)=>{const n=H();n&&(q(n,t.closeButtonHtml||""),_(n,t,"closeButton"),Q(n,t.showCloseButton),n.setAttribute("aria-label",t.closeButtonAriaLabel||""))})(0,t),ke(e,t),ue(0,t),((e,t)=>{const n=M();n&&(J(n),Q(n,t.footer,"block"),t.footer&&ae(t.footer,n),_(n,t,"footer"))})(0,t);const n=C();"function"==typeof t.didRender&&n&&t.didRender(n),o.eventEmitter.emit("didRender",n)},Ue=()=>{var e;return null===(e=P())||void 0===e?void 0:e.click()},ze=Object.freeze({cancel:"cancel",backdrop:"backdrop",close:"close",esc:"esc",timer:"timer"}),We=e=>{e.keydownTarget&&e.keydownHandlerAdded&&(e.keydownTarget.removeEventListener("keydown",e.keydownHandler,{capture:e.keydownListenerCapture}),e.keydownHandlerAdded=!1)},Ke=(e,t)=>{var n;const o=I();if(o.length)return-2===(e+=t)&&(e=o.length-1),e===o.length?e=0:-1===e&&(e=o.length-1),void o[e].focus();null===(n=C())||void 0===n||n.focus()},Ye=["ArrowRight","ArrowDown"],Xe=["ArrowLeft","ArrowUp"],Ze=(e,t,n)=>{e&&(t.isComposing||229===t.keyCode||(e.stopKeydownPropagation&&t.stopPropagation(),"Enter"===t.key?Je(t,e):"Tab"===t.key?Ge(t):[...Ye,...Xe].includes(t.key)?Qe(t.key):"Escape"===t.key&&et(t,e,n)))},Je=(e,t)=>{if(!h(t.allowEnterKey))return;const n=F(C(),t.input);if(e.target&&n&&e.target instanceof HTMLElement&&e.target.outerHTML===n.outerHTML){if(["textarea","file"].includes(t.input))return;Ue(),e.preventDefault()}},Ge=e=>{const t=e.target,n=I();let o=-1;for(let e=0;e<n.length;e++)if(t===n[e]){o=e;break}e.shiftKey?Ke(o,-1):Ke(o,1),e.stopPropagation(),e.preventDefault()},Qe=e=>{const t=O(),n=P(),o=T(),i=x();if(!(t&&n&&o&&i))return;const s=[n,o,i];if(document.activeElement instanceof HTMLElement&&!s.includes(document.activeElement))return;const r=Ye.includes(e)?"nextElementSibling":"previousElementSibling";let a=document.activeElement;if(a){for(let e=0;e<t.children.length;e++){if(a=a[r],!a)return;if(a instanceof HTMLButtonElement&&ee(a))break}a instanceof HTMLButtonElement&&a.focus()}},et=(e,t,n)=>{e.preventDefault(),h(t.allowEscapeKey)&&n(ze.esc)};var tt={swalPromiseResolve:new WeakMap,swalPromiseReject:new WeakMap};const nt=()=>{Array.from(document.body.children).forEach(e=>{e.hasAttribute("data-previous-aria-hidden")?(e.setAttribute("aria-hidden",e.getAttribute("data-previous-aria-hidden")||""),e.removeAttribute("data-previous-aria-hidden")):e.removeAttribute("aria-hidden")})},ot="undefined"!=typeof window&&!!window.GestureEvent,it=()=>{const e=y();if(!e)return;let t;e.ontouchstart=e=>{t=st(e)},e.ontouchmove=e=>{t&&(e.preventDefault(),e.stopPropagation())}},st=e=>{const t=e.target,n=y(),o=k();return!(!n||!o)&&(!rt(e)&&!at(e)&&(t===n||!(te(n)||!(t instanceof HTMLElement)||((e,t)=>{let n=e;for(;n&&n!==t;){if(te(n))return!0;n=n.parentElement}return!1})(t,o)||"INPUT"===t.tagName||"TEXTAREA"===t.tagName||te(o)&&o.contains(t))))},rt=e=>e.touches&&e.touches.length&&"stylus"===e.touches[0].touchType,at=e=>e.touches&&e.touches.length>1;let lt=null;const ct=e=>{null===lt&&(document.body.scrollHeight>window.innerHeight||"scroll"===e)&&(lt=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")),document.body.style.paddingRight=`${lt+(()=>{const e=document.createElement("div");e.className=r["scrollbar-measure"],document.body.appendChild(e);const t=e.getBoundingClientRect().width-e.clientWidth;return document.body.removeChild(e),t})()}px`)};function ut(e,t,n,s){V()?yt(e,s):(i(n).then(()=>yt(e,s)),We(o)),ot?(t.setAttribute("style","display:none !important"),t.removeAttribute("class"),t.innerHTML=""):t.remove(),D()&&(null!==lt&&(document.body.style.paddingRight=`${lt}px`,lt=null),(()=>{if(N(document.body,r.iosfix)){const e=parseInt(document.body.style.top,10);W(document.body,r.iosfix),document.body.style.top="",document.body.scrollTop=-1*e}})(),nt()),W([document.documentElement,document.body],[r.shown,r["height-auto"],r["no-backdrop"],r["toast-shown"]])}function dt(e){e=gt(e);const t=tt.swalPromiseResolve.get(this),n=pt(this);this.isAwaitingPromise?e.isDismissed||(ht(this),t(e)):n&&t(e)}const pt=e=>{const t=C();if(!t)return!1;const n=he.innerParams.get(e);if(!n||N(t,n.hideClass.popup))return!1;W(t,n.showClass.popup),z(t,n.hideClass.popup);const o=y();return W(o,n.showClass.backdrop),z(o,n.hideClass.backdrop),ft(e,t,n),!0};function mt(e){const t=tt.swalPromiseReject.get(this);ht(this),t&&t(e)}const ht=e=>{e.isAwaitingPromise&&(delete e.isAwaitingPromise,he.innerParams.get(e)||e._destroy())},gt=e=>void 0===e?{isConfirmed:!1,isDenied:!1,isDismissed:!0}:Object.assign({isConfirmed:!1,isDenied:!1,isDismissed:!1},e),ft=(e,t,n)=>{var i;const s=y(),r=ne(t);"function"==typeof n.willClose&&n.willClose(t),null===(i=o.eventEmitter)||void 0===i||i.emit("willClose",t),r?bt(e,t,s,n.returnFocus,n.didClose):ut(e,s,n.returnFocus,n.didClose)},bt=(e,t,n,i,s)=>{o.swalCloseEventFinishedCallback=ut.bind(null,e,n,i,s);const r=function(e){var n;e.target===t&&(null===(n=o.swalCloseEventFinishedCallback)||void 0===n||n.call(o),delete o.swalCloseEventFinishedCallback,t.removeEventListener("animationend",r),t.removeEventListener("transitionend",r))};t.addEventListener("animationend",r),t.addEventListener("transitionend",r)},yt=(e,t)=>{setTimeout(()=>{var n;"function"==typeof t&&t.bind(e.params)(),null===(n=o.eventEmitter)||void 0===n||n.emit("didClose"),e._destroy&&e._destroy()})},vt=e=>{let t=C();if(t||new Qn,t=C(),!t)return;const n=S();V()?Z(A()):wt(t,e),X(n),t.setAttribute("data-loading","true"),t.setAttribute("aria-busy","true"),t.focus()},wt=(e,t)=>{const n=O(),o=S();n&&o&&(!t&&ee(P())&&(t=P()),X(n),t&&(Z(t),o.setAttribute("data-button-to-replace",t.className),n.insertBefore(o,t)),z([e,n],r.loading))},Ct=e=>e.checked?1:0,At=e=>e.checked?e.value:null,Et=e=>e.files&&e.files.length?null!==e.getAttribute("multiple")?e.files:e.files[0]:null,kt=(e,t)=>{const n=C();if(!n)return;const o=e=>{"select"===t.input?function(e,t,n){const o=K(e,r.select);if(!o)return;const i=(e,t,o)=>{const i=document.createElement("option");i.value=o,q(i,t),i.selected=Lt(o,n.inputValue),e.appendChild(i)};t.forEach(e=>{const t=e[0],n=e[1];if(Array.isArray(n)){const e=document.createElement("optgroup");e.label=t,e.disabled=!1,o.appendChild(e),n.forEach(t=>i(e,t[1],t[0]))}else i(o,n,t)}),o.focus()}(n,$t(e),t):"radio"===t.input&&function(e,t,n){const o=K(e,r.radio);if(!o)return;t.forEach(e=>{const t=e[0],i=e[1],s=document.createElement("input"),a=document.createElement("label");s.type="radio",s.name=r.radio,s.value=t,Lt(t,n.inputValue)&&(s.checked=!0);const l=document.createElement("span");q(l,i),l.className=r.label,a.appendChild(s),a.appendChild(l),o.appendChild(a)});const i=o.querySelectorAll("input");i.length&&i[0].focus()}(n,$t(e),t)};g(t.inputOptions)||b(t.inputOptions)?(vt(P()),f(t.inputOptions).then(t=>{e.hideLoading(),o(t)})):"object"==typeof t.inputOptions?o(t.inputOptions):d("Unexpected type of inputOptions! Expected object, Map or Promise, got "+typeof t.inputOptions)},Bt=(e,t)=>{const n=e.getInput();n&&(Z(n),f(t.inputValue).then(o=>{n.value="number"===t.input?`${parseFloat(o)||0}`:`${o}`,X(n),n.focus(),e.hideLoading()}).catch(t=>{d(`Error in inputValue promise: ${t}`),n.value="",X(n),n.focus(),e.hideLoading()}))};const $t=e=>{const t=[];return e instanceof Map?e.forEach((e,n)=>{let o=e;"object"==typeof o&&(o=$t(o)),t.push([n,o])}):Object.keys(e).forEach(n=>{let o=e[n];"object"==typeof o&&(o=$t(o)),t.push([n,o])}),t},Lt=(e,t)=>!!t&&t.toString()===e.toString(),Pt=(e,t)=>{const n=he.innerParams.get(e);if(!n.input)return void d(`The "input" parameter is needed to be set when using returnInputValueOn${c(t)}`);const o=e.getInput(),i=((e,t)=>{const n=e.getInput();if(!n)return null;switch(t.input){case"checkbox":return Ct(n);case"radio":return At(n);case"file":return Et(n);default:return t.inputAutoTrim?n.value.trim():n.value}})(e,n);n.inputValidator?xt(e,i,t):o&&!o.checkValidity()?(e.enableButtons(),e.showValidationMessage(n.validationMessage||o.validationMessage)):"deny"===t?Tt(e,i):Mt(e,i)},xt=(e,t,n)=>{const o=he.innerParams.get(e);e.disableInput();Promise.resolve().then(()=>f(o.inputValidator(t,o.validationMessage))).then(o=>{e.enableButtons(),e.enableInput(),o?e.showValidationMessage(o):"deny"===n?Tt(e,t):Mt(e,t)})},Tt=(e,t)=>{const n=he.innerParams.get(e||void 0);if(n.showLoaderOnDeny&&vt(T()),n.preDeny){e.isAwaitingPromise=!0;Promise.resolve().then(()=>f(n.preDeny(t,n.validationMessage))).then(n=>{!1===n?(e.hideLoading(),ht(e)):e.close({isDenied:!0,value:void 0===n?t:n})}).catch(t=>Ot(e||void 0,t))}else e.close({isDenied:!0,value:t})},St=(e,t)=>{e.close({isConfirmed:!0,value:t})},Ot=(e,t)=>{e.rejectPromise(t)},Mt=(e,t)=>{const n=he.innerParams.get(e||void 0);if(n.showLoaderOnConfirm&&vt(),n.preConfirm){e.resetValidationMessage(),e.isAwaitingPromise=!0;Promise.resolve().then(()=>f(n.preConfirm(t,n.validationMessage))).then(n=>{ee(L())||!1===n?(e.hideLoading(),ht(e)):St(e,void 0===n?t:n)}).catch(t=>Ot(e||void 0,t))}else St(e,t)};function jt(){const e=he.innerParams.get(this);if(!e)return;const t=he.domCache.get(this);Z(t.loader),V()?e.icon&&X(A()):Ht(t),W([t.popup,t.actions],r.loading),t.popup.removeAttribute("aria-busy"),t.popup.removeAttribute("data-loading"),t.confirmButton.disabled=!1,t.denyButton.disabled=!1,t.cancelButton.disabled=!1}const Ht=e=>{const t=e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));t.length?X(t[0],"inline-block"):ee(P())||ee(T())||ee(x())||Z(e.actions)};function It(){const e=he.innerParams.get(this),t=he.domCache.get(this);return t?F(t.popup,e.input):null}function Dt(e,t,n){const o=he.domCache.get(e);t.forEach(e=>{o[e].disabled=n})}function Vt(e,t){const n=C();if(n&&e)if("radio"===e.type){const e=n.querySelectorAll(`[name="${r.radio}"]`);for(let n=0;n<e.length;n++)e[n].disabled=t}else e.disabled=t}function qt(){Dt(this,["confirmButton","denyButton","cancelButton"],!1)}function Nt(){Dt(this,["confirmButton","denyButton","cancelButton"],!0)}function _t(){Vt(this.getInput(),!1)}function Ft(){Vt(this.getInput(),!0)}function Rt(e){const t=he.domCache.get(this),n=he.innerParams.get(this);q(t.validationMessage,e),t.validationMessage.className=r["validation-message"],n.customClass&&n.customClass.validationMessage&&z(t.validationMessage,n.customClass.validationMessage),X(t.validationMessage);const o=this.getInput();o&&(o.setAttribute("aria-invalid","true"),o.setAttribute("aria-describedby",r["validation-message"]),R(o),z(o,r.inputerror))}function Ut(){const e=he.domCache.get(this);e.validationMessage&&Z(e.validationMessage);const t=this.getInput();t&&(t.removeAttribute("aria-invalid"),t.removeAttribute("aria-describedby"),W(t,r.inputerror))}const zt={title:"",titleText:"",text:"",html:"",footer:"",icon:void 0,iconColor:void 0,iconHtml:void 0,template:void 0,toast:!1,draggable:!1,animation:!0,theme:"light",showClass:{popup:"swal2-show",backdrop:"swal2-backdrop-show",icon:"swal2-icon-show"},hideClass:{popup:"swal2-hide",backdrop:"swal2-backdrop-hide",icon:"swal2-icon-hide"},customClass:{},target:"body",color:void 0,backdrop:!0,heightAuto:!0,allowOutsideClick:!0,allowEscapeKey:!0,allowEnterKey:!0,stopKeydownPropagation:!0,keydownListenerCapture:!1,showConfirmButton:!0,showDenyButton:!1,showCancelButton:!1,preConfirm:void 0,preDeny:void 0,confirmButtonText:"OK",confirmButtonAriaLabel:"",confirmButtonColor:void 0,denyButtonText:"No",denyButtonAriaLabel:"",denyButtonColor:void 0,cancelButtonText:"Cancel",cancelButtonAriaLabel:"",cancelButtonColor:void 0,buttonsStyling:!0,reverseButtons:!1,focusConfirm:!0,focusDeny:!1,focusCancel:!1,returnFocus:!0,showCloseButton:!1,closeButtonHtml:"&times;",closeButtonAriaLabel:"Close this dialog",loaderHtml:"",showLoaderOnConfirm:!1,showLoaderOnDeny:!1,imageUrl:void 0,imageWidth:void 0,imageHeight:void 0,imageAlt:"",timer:void 0,timerProgressBar:!1,width:void 0,padding:void 0,background:void 0,input:void 0,inputPlaceholder:"",inputLabel:"",inputValue:"",inputOptions:{},inputAutoFocus:!0,inputAutoTrim:!0,inputAttributes:{},inputValidator:void 0,returnInputValueOnDeny:!1,validationMessage:void 0,grow:!1,position:"center",progressSteps:[],currentProgressStep:void 0,progressStepsDistance:void 0,willOpen:void 0,didOpen:void 0,didRender:void 0,willClose:void 0,didClose:void 0,didDestroy:void 0,scrollbarPadding:!0,topLayer:!1},Wt=["allowEscapeKey","allowOutsideClick","background","buttonsStyling","cancelButtonAriaLabel","cancelButtonColor","cancelButtonText","closeButtonAriaLabel","closeButtonHtml","color","confirmButtonAriaLabel","confirmButtonColor","confirmButtonText","currentProgressStep","customClass","denyButtonAriaLabel","denyButtonColor","denyButtonText","didClose","didDestroy","draggable","footer","hideClass","html","icon","iconColor","iconHtml","imageAlt","imageHeight","imageUrl","imageWidth","preConfirm","preDeny","progressSteps","returnFocus","reverseButtons","showCancelButton","showCloseButton","showConfirmButton","showDenyButton","text","title","titleText","theme","willClose"],Kt={allowEnterKey:void 0},Yt=["allowOutsideClick","allowEnterKey","backdrop","draggable","focusConfirm","focusDeny","focusCancel","returnFocus","heightAuto","keydownListenerCapture"],Xt=e=>Object.prototype.hasOwnProperty.call(zt,e),Zt=e=>-1!==Wt.indexOf(e),Jt=e=>Kt[e],Gt=e=>{Xt(e)||u(`Unknown parameter "${e}"`)},Qt=e=>{Yt.includes(e)&&u(`The parameter "${e}" is incompatible with toasts`)},en=e=>{const t=Jt(e);t&&m(e,t)},tn=e=>{!1===e.backdrop&&e.allowOutsideClick&&u('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'),e.theme&&!["light","dark","auto","minimal","borderless","embed-iframe","bulma","bulma-light","bulma-dark"].includes(e.theme)&&u(`Invalid theme "${e.theme}"`);for(const t in e)Gt(t),e.toast&&Qt(t),en(t)};function nn(e){const t=y(),n=C(),o=he.innerParams.get(this);if(!n||N(n,o.hideClass.popup))return void u("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");const i=on(e),s=Object.assign({},o,i);tn(s),t.dataset.swal2Theme=s.theme,Re(this,s),he.innerParams.set(this,s),Object.defineProperties(this,{params:{value:Object.assign({},this.params,e),writable:!1,enumerable:!0}})}const on=e=>{const t={};return Object.keys(e).forEach(n=>{Zt(n)?t[n]=e[n]:u(`Invalid parameter to update: ${n}`)}),t};function sn(){const e=he.domCache.get(this),t=he.innerParams.get(this);t?(e.popup&&o.swalCloseEventFinishedCallback&&(o.swalCloseEventFinishedCallback(),delete o.swalCloseEventFinishedCallback),"function"==typeof t.didDestroy&&t.didDestroy(),o.eventEmitter.emit("didDestroy"),rn(this)):an(this)}const rn=e=>{an(e),delete e.params,delete o.keydownHandler,delete o.keydownTarget,delete o.currentInstance},an=e=>{e.isAwaitingPromise?(ln(he,e),e.isAwaitingPromise=!0):(ln(tt,e),ln(he,e),delete e.isAwaitingPromise,delete e.disableButtons,delete e.enableButtons,delete e.getInput,delete e.disableInput,delete e.enableInput,delete e.hideLoading,delete e.disableLoading,delete e.showValidationMessage,delete e.resetValidationMessage,delete e.close,delete e.closePopup,delete e.closeModal,delete e.closeToast,delete e.rejectPromise,delete e.update,delete e._destroy)},ln=(e,t)=>{for(const n in e)e[n].delete(t)};var cn=Object.freeze({__proto__:null,_destroy:sn,close:dt,closeModal:dt,closePopup:dt,closeToast:dt,disableButtons:Nt,disableInput:Ft,disableLoading:jt,enableButtons:qt,enableInput:_t,getInput:It,handleAwaitingPromise:ht,hideLoading:jt,rejectPromise:mt,resetValidationMessage:Ut,showValidationMessage:Rt,update:nn});const un=(e,t,n)=>{t.popup.onclick=()=>{e&&(dn(e)||e.timer||e.input)||n(ze.close)}},dn=e=>!!(e.showConfirmButton||e.showDenyButton||e.showCancelButton||e.showCloseButton);let pn=!1;const mn=e=>{e.popup.onmousedown=()=>{e.container.onmouseup=function(t){e.container.onmouseup=()=>{},t.target===e.container&&(pn=!0)}}},hn=e=>{e.container.onmousedown=t=>{t.target===e.container&&t.preventDefault(),e.popup.onmouseup=function(t){e.popup.onmouseup=()=>{},(t.target===e.popup||t.target instanceof HTMLElement&&e.popup.contains(t.target))&&(pn=!0)}}},gn=(e,t,n)=>{t.container.onclick=o=>{pn?pn=!1:o.target===t.container&&h(e.allowOutsideClick)&&n(ze.backdrop)}},fn=e=>e instanceof Element||(e=>"object"==typeof e&&e.jquery)(e);const bn=()=>{if(o.timeout)return(()=>{const e=j();if(!e)return;const t=parseInt(window.getComputedStyle(e).width);e.style.removeProperty("transition"),e.style.width="100%";const n=t/parseInt(window.getComputedStyle(e).width)*100;e.style.width=`${n}%`})(),o.timeout.stop()},yn=()=>{if(o.timeout){const e=o.timeout.start();return oe(e),e}};let vn=!1;const wn={};const Cn=e=>{for(let t=e.target;t&&t!==document;t=t.parentNode)for(const e in wn){const n=t.getAttribute(e);if(n)return void wn[e].fire({template:n})}};o.eventEmitter=new class{constructor(){this.events={}}_getHandlersByEventName(e){return void 0===this.events[e]&&(this.events[e]=[]),this.events[e]}on(e,t){const n=this._getHandlersByEventName(e);n.includes(t)||n.push(t)}once(e,t){const n=(...o)=>{this.removeListener(e,n),t.apply(this,o)};this.on(e,n)}emit(e,...t){this._getHandlersByEventName(e).forEach(e=>{try{e.apply(this,t)}catch(e){console.error(e)}})}removeListener(e,t){const n=this._getHandlersByEventName(e),o=n.indexOf(t);o>-1&&n.splice(o,1)}removeAllListeners(e){void 0!==this.events[e]&&(this.events[e].length=0)}reset(){this.events={}}};var An=Object.freeze({__proto__:null,argsToParams:e=>{const t={};return"object"!=typeof e[0]||fn(e[0])?["title","html","icon"].forEach((n,o)=>{const i=e[o];"string"==typeof i||fn(i)?t[n]=i:void 0!==i&&d(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof i}`)}):Object.assign(t,e[0]),t},bindClickHandler:function(e="data-swal-template"){wn[e]=this,vn||(document.body.addEventListener("click",Cn),vn=!0)},clickCancel:()=>{var e;return null===(e=x())||void 0===e?void 0:e.click()},clickConfirm:Ue,clickDeny:()=>{var e;return null===(e=T())||void 0===e?void 0:e.click()},enableLoading:vt,fire:function(...e){return new this(...e)},getActions:O,getCancelButton:x,getCloseButton:H,getConfirmButton:P,getContainer:y,getDenyButton:T,getFocusableElements:I,getFooter:M,getHtmlContainer:k,getIcon:A,getIconContent:()=>w(r["icon-content"]),getImage:B,getInputLabel:()=>w(r["input-label"]),getLoader:S,getPopup:C,getProgressSteps:$,getTimerLeft:()=>o.timeout&&o.timeout.getTimerLeft(),getTimerProgressBar:j,getTitle:E,getValidationMessage:L,increaseTimer:e=>{if(o.timeout){const t=o.timeout.increase(e);return oe(t,!0),t}},isDeprecatedParameter:Jt,isLoading:()=>{const e=C();return!!e&&e.hasAttribute("data-loading")},isTimerRunning:()=>!(!o.timeout||!o.timeout.isRunning()),isUpdatableParameter:Zt,isValidParameter:Xt,isVisible:()=>ee(C()),mixin:function(e){return class extends(this){_main(t,n){return super._main(t,Object.assign({},e,n))}}},off:(e,t)=>{e?t?o.eventEmitter.removeListener(e,t):o.eventEmitter.removeAllListeners(e):o.eventEmitter.reset()},on:(e,t)=>{o.eventEmitter.on(e,t)},once:(e,t)=>{o.eventEmitter.once(e,t)},resumeTimer:yn,showLoading:vt,stopTimer:bn,toggleTimer:()=>{const e=o.timeout;return e&&(e.running?bn():yn())}});class En{constructor(e,t){this.callback=e,this.remaining=t,this.running=!1,this.start()}start(){return this.running||(this.running=!0,this.started=new Date,this.id=setTimeout(this.callback,this.remaining)),this.remaining}stop(){return this.started&&this.running&&(this.running=!1,clearTimeout(this.id),this.remaining-=(new Date).getTime()-this.started.getTime()),this.remaining}increase(e){const t=this.running;return t&&this.stop(),this.remaining+=e,t&&this.start(),this.remaining}getTimerLeft(){return this.running&&(this.stop(),this.start()),this.remaining}isRunning(){return this.running}}const kn=["swal-title","swal-html","swal-footer"],Bn=e=>{const t={};return Array.from(e.querySelectorAll("swal-param")).forEach(e=>{Mn(e,["name","value"]);const n=e.getAttribute("name"),o=e.getAttribute("value");n&&o&&(t[n]="boolean"==typeof zt[n]?"false"!==o:"object"==typeof zt[n]?JSON.parse(o):o)}),t},$n=e=>{const t={};return Array.from(e.querySelectorAll("swal-function-param")).forEach(e=>{const n=e.getAttribute("name"),o=e.getAttribute("value");n&&o&&(t[n]=new Function(`return ${o}`)())}),t},Ln=e=>{const t={};return Array.from(e.querySelectorAll("swal-button")).forEach(e=>{Mn(e,["type","color","aria-label"]);const n=e.getAttribute("type");n&&["confirm","cancel","deny"].includes(n)&&(t[`${n}ButtonText`]=e.innerHTML,t[`show${c(n)}Button`]=!0,e.hasAttribute("color")&&(t[`${n}ButtonColor`]=e.getAttribute("color")),e.hasAttribute("aria-label")&&(t[`${n}ButtonAriaLabel`]=e.getAttribute("aria-label")))}),t},Pn=e=>{const t={},n=e.querySelector("swal-image");return n&&(Mn(n,["src","width","height","alt"]),n.hasAttribute("src")&&(t.imageUrl=n.getAttribute("src")||void 0),n.hasAttribute("width")&&(t.imageWidth=n.getAttribute("width")||void 0),n.hasAttribute("height")&&(t.imageHeight=n.getAttribute("height")||void 0),n.hasAttribute("alt")&&(t.imageAlt=n.getAttribute("alt")||void 0)),t},xn=e=>{const t={},n=e.querySelector("swal-icon");return n&&(Mn(n,["type","color"]),n.hasAttribute("type")&&(t.icon=n.getAttribute("type")),n.hasAttribute("color")&&(t.iconColor=n.getAttribute("color")),t.iconHtml=n.innerHTML),t},Tn=e=>{const t={},n=e.querySelector("swal-input");n&&(Mn(n,["type","label","placeholder","value"]),t.input=n.getAttribute("type")||"text",n.hasAttribute("label")&&(t.inputLabel=n.getAttribute("label")),n.hasAttribute("placeholder")&&(t.inputPlaceholder=n.getAttribute("placeholder")),n.hasAttribute("value")&&(t.inputValue=n.getAttribute("value")));const o=Array.from(e.querySelectorAll("swal-input-option"));return o.length&&(t.inputOptions={},o.forEach(e=>{Mn(e,["value"]);const n=e.getAttribute("value");if(!n)return;const o=e.innerHTML;t.inputOptions[n]=o})),t},Sn=(e,t)=>{const n={};for(const o in t){const i=t[o],s=e.querySelector(i);s&&(Mn(s,[]),n[i.replace(/^swal-/,"")]=s.innerHTML.trim())}return n},On=e=>{const t=kn.concat(["swal-param","swal-function-param","swal-button","swal-image","swal-icon","swal-input","swal-input-option"]);Array.from(e.children).forEach(e=>{const n=e.tagName.toLowerCase();t.includes(n)||u(`Unrecognized element <${n}>`)})},Mn=(e,t)=>{Array.from(e.attributes).forEach(n=>{-1===t.indexOf(n.name)&&u([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`,""+(t.length?`Allowed attributes are: ${t.join(", ")}`:"To set the value, use HTML within the element.")])})},jn=e=>{const t=y(),n=C();"function"==typeof e.willOpen&&e.willOpen(n),o.eventEmitter.emit("willOpen",n);const i=window.getComputedStyle(document.body).overflowY;Vn(t,n,e),setTimeout(()=>{In(t,n)},10),D()&&(Dn(t,e.scrollbarPadding,i),(()=>{const e=y();Array.from(document.body.children).forEach(t=>{t.contains(e)||(t.hasAttribute("aria-hidden")&&t.setAttribute("data-previous-aria-hidden",t.getAttribute("aria-hidden")||""),t.setAttribute("aria-hidden","true"))})})()),V()||o.previousActiveElement||(o.previousActiveElement=document.activeElement),"function"==typeof e.didOpen&&setTimeout(()=>e.didOpen(n)),o.eventEmitter.emit("didOpen",n),W(t,r["no-transition"])},Hn=e=>{const t=C();if(e.target!==t)return;const n=y();t.removeEventListener("animationend",Hn),t.removeEventListener("transitionend",Hn),n.style.overflowY="auto"},In=(e,t)=>{ne(t)?(e.style.overflowY="hidden",t.addEventListener("animationend",Hn),t.addEventListener("transitionend",Hn)):e.style.overflowY="auto"},Dn=(e,t,n)=>{(()=>{if(ot&&!N(document.body,r.iosfix)){const e=document.body.scrollTop;document.body.style.top=-1*e+"px",z(document.body,r.iosfix),it()}})(),t&&"hidden"!==n&&ct(n),setTimeout(()=>{e.scrollTop=0})},Vn=(e,t,n)=>{z(e,n.showClass.backdrop),n.animation?(t.style.setProperty("opacity","0","important"),X(t,"grid"),setTimeout(()=>{z(t,n.showClass.popup),t.style.removeProperty("opacity")},10)):X(t,"grid"),z([document.documentElement,document.body],r.shown),n.heightAuto&&n.backdrop&&!n.toast&&z([document.documentElement,document.body],r["height-auto"])};var qn=(e,t)=>/^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e)?Promise.resolve():Promise.resolve(t||"Invalid email address"),Nn=(e,t)=>/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e)?Promise.resolve():Promise.resolve(t||"Invalid URL");function _n(e){!function(e){e.inputValidator||("email"===e.input&&(e.inputValidator=qn),"url"===e.input&&(e.inputValidator=Nn))}(e),e.showLoaderOnConfirm&&!e.preConfirm&&u("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"),function(e){(!e.target||"string"==typeof e.target&&!document.querySelector(e.target)||"string"!=typeof e.target&&!e.target.appendChild)&&(u('Target parameter is not valid, defaulting to "body"'),e.target="body")}(e),"string"==typeof e.title&&(e.title=e.title.split("\n").join("<br />")),re(e)}let Fn;var Rn=new WeakMap;class Un{constructor(...t){if(n(this,Rn,void 0),"undefined"==typeof window)return;Fn=this;const o=Object.freeze(this.constructor.argsToParams(t));var i,s,r;this.params=o,this.isAwaitingPromise=!1,i=Rn,s=this,r=this._main(Fn.params),i.set(e(i,s),r)}_main(e,t={}){if(tn(Object.assign({},t,e)),o.currentInstance){const e=tt.swalPromiseResolve.get(o.currentInstance),{isAwaitingPromise:t}=o.currentInstance;o.currentInstance._destroy(),t||e({isDismissed:!0}),D()&&nt()}o.currentInstance=Fn;const n=Wn(e,t);_n(n),Object.freeze(n),o.timeout&&(o.timeout.stop(),delete o.timeout),clearTimeout(o.restoreFocusTimeout);const i=Kn(Fn);return Re(Fn,n),he.innerParams.set(Fn,n),zn(Fn,i,n)}then(e){return t(Rn,this).then(e)}finally(e){return t(Rn,this).finally(e)}}const zn=(e,t,n)=>new Promise((i,s)=>{const r=t=>{e.close({isDismissed:!0,dismiss:t})};tt.swalPromiseResolve.set(e,i),tt.swalPromiseReject.set(e,s),t.confirmButton.onclick=()=>{(e=>{const t=he.innerParams.get(e);e.disableButtons(),t.input?Pt(e,"confirm"):Mt(e,!0)})(e)},t.denyButton.onclick=()=>{(e=>{const t=he.innerParams.get(e);e.disableButtons(),t.returnInputValueOnDeny?Pt(e,"deny"):Tt(e,!1)})(e)},t.cancelButton.onclick=()=>{((e,t)=>{e.disableButtons(),t(ze.cancel)})(e,r)},t.closeButton.onclick=()=>{r(ze.close)},((e,t,n)=>{e.toast?un(e,t,n):(mn(t),hn(t),gn(e,t,n))})(n,t,r),((e,t,n)=>{We(e),t.toast||(e.keydownHandler=e=>Ze(t,e,n),e.keydownTarget=t.keydownListenerCapture?window:C(),e.keydownListenerCapture=t.keydownListenerCapture,e.keydownTarget.addEventListener("keydown",e.keydownHandler,{capture:e.keydownListenerCapture}),e.keydownHandlerAdded=!0)})(o,n,r),((e,t)=>{"select"===t.input||"radio"===t.input?kt(e,t):["text","email","number","tel","textarea"].some(e=>e===t.input)&&(g(t.inputValue)||b(t.inputValue))&&(vt(P()),Bt(e,t))})(e,n),jn(n),Yn(o,n,r),Xn(t,n),setTimeout(()=>{t.container.scrollTop=0})}),Wn=(e,t)=>{const n=(e=>{const t="string"==typeof e.template?document.querySelector(e.template):e.template;if(!t)return{};const n=t.content;return On(n),Object.assign(Bn(n),$n(n),Ln(n),Pn(n),xn(n),Tn(n),Sn(n,kn))})(e),o=Object.assign({},zt,t,n,e);return o.showClass=Object.assign({},zt.showClass,o.showClass),o.hideClass=Object.assign({},zt.hideClass,o.hideClass),!1===o.animation&&(o.showClass={backdrop:"swal2-noanimation"},o.hideClass={}),o},Kn=e=>{const t={popup:C(),container:y(),actions:O(),confirmButton:P(),denyButton:T(),cancelButton:x(),loader:S(),closeButton:H(),validationMessage:L(),progressSteps:$()};return he.domCache.set(e,t),t},Yn=(e,t,n)=>{const o=j();Z(o),t.timer&&(e.timeout=new En(()=>{n("timer"),delete e.timeout},t.timer),t.timerProgressBar&&(X(o),_(o,t,"timerProgressBar"),setTimeout(()=>{e.timeout&&e.timeout.running&&oe(t.timer)})))},Xn=(e,t)=>{if(!t.toast)return h(t.allowEnterKey)?void(Zn(e)||Jn(e,t)||Ke(-1,1)):(m("allowEnterKey"),void Gn())},Zn=e=>{const t=Array.from(e.popup.querySelectorAll("[autofocus]"));for(const e of t)if(e instanceof HTMLElement&&ee(e))return e.focus(),!0;return!1},Jn=(e,t)=>t.focusDeny&&ee(e.denyButton)?(e.denyButton.focus(),!0):t.focusCancel&&ee(e.cancelButton)?(e.cancelButton.focus(),!0):!(!t.focusConfirm||!ee(e.confirmButton))&&(e.confirmButton.focus(),!0),Gn=()=>{document.activeElement instanceof HTMLElement&&"function"==typeof document.activeElement.blur&&document.activeElement.blur()};Un.prototype.disableButtons=Nt,Un.prototype.enableButtons=qt,Un.prototype.getInput=It,Un.prototype.disableInput=Ft,Un.prototype.enableInput=_t,Un.prototype.hideLoading=jt,Un.prototype.disableLoading=jt,Un.prototype.showValidationMessage=Rt,Un.prototype.resetValidationMessage=Ut,Un.prototype.close=dt,Un.prototype.closePopup=dt,Un.prototype.closeModal=dt,Un.prototype.closeToast=dt,Un.prototype.rejectPromise=mt,Un.prototype.update=nn,Un.prototype._destroy=sn,Object.assign(Un,An),Object.keys(cn).forEach(e=>{Un[e]=function(...t){return Fn&&Fn[e]?Fn[e](...t):null}}),Un.DismissReason=ze,Un.version="11.22.4";const Qn=Un;return Qn.default=Qn,Qn}),void 0!==this&&this.Sweetalert2&&(this.swal=this.sweetAlert=this.Swal=this.SweetAlert=this.Sweetalert2);

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 52 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 52 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map

/**
 * textFit v2.3.1
 * Previously known as jQuery.textFit
 * 11/2014 by STRML (strml.github.com)
 * MIT License
 *
 * To use: textFit(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 * Version 2.0 does not use jQuery.
 */
/*global define:true, document:true, window:true, HTMLElement:true*/

(function(root, factory) {
  "use strict";

  // UMD shim
  if (typeof define === "function" && define.amd) {
    // AMD
    define([], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS
    module.exports = factory();
  } else {
    // Browser
    root.textFit = factory();
  }

}(typeof global === "object" ? global : this, function () {
  "use strict";

  var defaultSettings = {
    alignVert: false, // if true, textFit will align vertically using css tables
    alignHoriz: false, // if true, textFit will set text-align: center
    multiLine: false, // if true, textFit will not set white-space: no-wrap
    detectMultiLine: true, // disable to turn off automatic multi-line sensing
    minFontSize: 6,
    maxFontSize: 80,
    reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
    widthOnly: false, // if true, textFit will fit text to element width, regardless of text height
    alignVertWithFlexbox: false, // if true, textFit will use flexbox for vertical alignment
  };

  return function textFit(els, options) {

    if (!options) options = {};

    // Extend options.
    var settings = {};
    for(var key in defaultSettings){
      if(options.hasOwnProperty(key)){
        settings[key] = options[key];
      } else {
        settings[key] = defaultSettings[key];
      }
    }

    // Convert jQuery objects into arrays
    if (typeof els.toArray === "function") {
      els = els.toArray();
    }

    // Support passing a single el
    var elType = Object.prototype.toString.call(els);
    if (elType !== '[object Array]' && elType !== '[object NodeList]' &&
            elType !== '[object HTMLCollection]'){
      els = [els];
    }

    // Process each el we've passed.
    for(var i = 0; i < els.length; i++){
      processItem(els[i], settings);
    }
  };

  /**
   * The meat. Given an el, make the text inside it fit its parent.
   * @param  {DOMElement} el       Child el.
   * @param  {Object} settings     Options for fit.
   */
  function processItem(el, settings){
    if (!isElement(el) || (!settings.reProcess && el.getAttribute('textFitted'))) {
      return false;
    }

    // Set textFitted attribute so we know this was processed.
    if(!settings.reProcess){
      el.setAttribute('textFitted', 1);
    }

    var innerSpan, originalHeight, originalHTML, originalWidth;
    var low, mid, high;

    // Get element data.
    originalHTML = el.innerHTML;
    originalWidth = innerWidth(el);
    originalHeight = innerHeight(el);

    // Don't process if we can't find box dimensions
    if (!originalWidth || (!settings.widthOnly && !originalHeight)) {
      if(!settings.widthOnly)
        throw new Error('Set a static height and width on the target element ' + el.outerHTML +
          ' before using textFit!');
      else
        throw new Error('Set a static width on the target element ' + el.outerHTML +
          ' before using textFit!');
    }

    // Add textFitted span inside this container.
    if (originalHTML.indexOf('textFitted') === -1) {
      innerSpan = document.createElement('span');
      innerSpan.className = 'textFitted';
      // Inline block ensure it takes on the size of its contents, even if they are enclosed
      // in other tags like <p>
      innerSpan.style['display'] = 'inline-block';
      innerSpan.innerHTML = originalHTML;
      el.innerHTML = '';
      el.appendChild(innerSpan);
    } else {
      // Reprocessing.
      innerSpan = el.querySelector('span.textFitted');
      // Remove vertical align if we're reprocessing.
      if (hasClass(innerSpan, 'textFitAlignVert')){
        innerSpan.className = innerSpan.className.replace('textFitAlignVert', '');
        innerSpan.style['height'] = '';
        el.className.replace('textFitAlignVertFlex', '');
      }
    }

    // Prepare & set alignment
    if (settings.alignHoriz) {
      el.style['text-align'] = 'center';
      innerSpan.style['text-align'] = 'center';
    }

    // Check if this string is multiple lines
    // Not guaranteed to always work if you use wonky line-heights
    var multiLine = settings.multiLine;
    if (settings.detectMultiLine && !multiLine &&
        innerSpan.scrollHeight >= parseInt(window.getComputedStyle(innerSpan)['font-size'], 10) * 2){
      multiLine = true;
    }

    // If we're not treating this as a multiline string, don't let it wrap.
    if (!multiLine) {
      el.style['white-space'] = 'nowrap';
    }

    low = settings.minFontSize;
    high = settings.maxFontSize;

    // Binary search for highest best fit
    var size = low;
    while (low <= high) {
      mid = (high + low) >> 1;
      innerSpan.style.fontSize = mid + 'px';
      if(innerSpan.scrollWidth <= originalWidth && (settings.widthOnly || innerSpan.scrollHeight <= originalHeight)){
        size = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
      // await injection point
    }
    // found, updating font if differs:
    if( innerSpan.style.fontSize != size + 'px' ) innerSpan.style.fontSize = size + 'px';

    // Our height is finalized. If we are aligning vertically, set that up.
    if (settings.alignVert) {
      addStyleSheet();
      var height = innerSpan.scrollHeight;
      if (window.getComputedStyle(el)['position'] === "static"){
        el.style['position'] = 'relative';
      }
      if (!hasClass(innerSpan, "textFitAlignVert")){
        innerSpan.className = innerSpan.className + " textFitAlignVert";
      }
      innerSpan.style['height'] = height + "px";
      if (settings.alignVertWithFlexbox && !hasClass(el, "textFitAlignVertFlex")) {
        el.className = el.className + " textFitAlignVertFlex";
      }
    }
  }

  // Calculate height without padding.
  function innerHeight(el){
    var style = window.getComputedStyle(el, null);
    return el.clientHeight -
      parseInt(style.getPropertyValue('padding-top'), 10) -
      parseInt(style.getPropertyValue('padding-bottom'), 10);
  }

  // Calculate width without padding.
  function innerWidth(el){
    var style = window.getComputedStyle(el, null);
    return el.clientWidth -
      parseInt(style.getPropertyValue('padding-left'), 10) -
      parseInt(style.getPropertyValue('padding-right'), 10);
  }

  //Returns true if it is a DOM element
  function isElement(o){
    return (
      typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
      o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
    );
  }

  function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  // Better than a stylesheet dependency
  function addStyleSheet() {
    if (document.getElementById("textFitStyleSheet")) return;
    var style = [
      ".textFitAlignVert{",
        "position: absolute;",
        "top: 0; right: 0; bottom: 0; left: 0;",
        "margin: auto;",
        "display: flex;",
        "justify-content: center;",
        "flex-direction: column;",
      "}",
      ".textFitAlignVertFlex{",
        "display: flex;",
      "}",
      ".textFitAlignVertFlex .textFitAlignVert{",
        "position: static;",
      "}",].join("");

    var css = document.createElement("style");
    css.type = "text/css";
    css.id = "textFitStyleSheet";
    css.innerHTML = style;
    document.body.appendChild(css);
  }
}));

/**
 * @license MIT
 * topbar 1.0.0, 2021-01-06
 * http://buunguyen.github.io/topbar
 * Copyright (c) 2021 Buu Nguyen
 */
(function (window, document) {
  "use strict";

  // https://gist.github.com/paulirish/1579671
  (function () {
    var lastTime = 0;
    var vendors = ["ms", "moz", "webkit", "o"];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame =
        window[vendors[x] + "RequestAnimationFrame"];
      window.cancelAnimationFrame =
        window[vendors[x] + "CancelAnimationFrame"] ||
        window[vendors[x] + "CancelRequestAnimationFrame"];
    }
    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
  })();

  var canvas,
    progressTimerId,
    fadeTimerId,
    currentProgress,
    showing,
    addEvent = function (elem, type, handler) {
      if (elem.addEventListener) elem.addEventListener(type, handler, false);
      else if (elem.attachEvent) elem.attachEvent("on" + type, handler);
      else elem["on" + type] = handler;
    },
    options = {
      autoRun: true,
      barThickness: 3,
      barColors: {
        0: "rgba(26,  188, 156, .9)",
        ".25": "rgba(52,  152, 219, .9)",
        ".50": "rgba(241, 196, 15,  .9)",
        ".75": "rgba(230, 126, 34,  .9)",
        "1.0": "rgba(211, 84,  0,   .9)",
      },
      shadowBlur: 10,
      shadowColor: "rgba(0,   0,   0,   .6)",
      className: null,
    },
    repaint = function () {
      canvas.width = window.innerWidth;
      canvas.height = options.barThickness * 5; // need space for shadow

      var ctx = canvas.getContext("2d");
      ctx.shadowBlur = options.shadowBlur;
      ctx.shadowColor = options.shadowColor;

      var lineGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      for (var stop in options.barColors)
        lineGradient.addColorStop(stop, options.barColors[stop]);
      ctx.lineWidth = options.barThickness;
      ctx.beginPath();
      ctx.moveTo(0, options.barThickness / 2);
      ctx.lineTo(
        Math.ceil(currentProgress * canvas.width),
        options.barThickness / 2
      );
      ctx.strokeStyle = lineGradient;
      ctx.stroke();
    },
    createCanvas = function () {
      canvas = document.createElement("canvas");
      var style = canvas.style;
      style.position = "fixed";
      style.top = style.left = style.right = style.margin = style.padding = 0;
      style.zIndex = 100001;
      style.display = "none";
      if (options.className) canvas.classList.add(options.className);
      document.body.appendChild(canvas);
      addEvent(window, "resize", repaint);
    },
    topbar = {
      config: function (opts) {
        for (var key in opts)
          if (options.hasOwnProperty(key)) options[key] = opts[key];
      },
      show: function () {
        if (showing) return;
        showing = true;
        if (fadeTimerId !== null) window.cancelAnimationFrame(fadeTimerId);
        if (!canvas) createCanvas();
        canvas.style.opacity = 1;
        canvas.style.display = "block";
        topbar.progress(0);
        if (options.autoRun) {
          (function loop() {
            progressTimerId = window.requestAnimationFrame(loop);
            topbar.progress(
              "+" + 0.05 * Math.pow(1 - Math.sqrt(currentProgress), 2)
            );
          })();
        }
      },
      progress: function (to) {
        if (typeof to === "undefined") return currentProgress;
        if (typeof to === "string") {
          to =
            (to.indexOf("+") >= 0 || to.indexOf("-") >= 0
              ? currentProgress
              : 0) + parseFloat(to);
        }
        currentProgress = to > 1 ? 1 : to;
        repaint();
        return currentProgress;
      },
      hide: function () {
        if (!showing) return;
        showing = false;
        if (progressTimerId != null) {
          window.cancelAnimationFrame(progressTimerId);
          progressTimerId = null;
        }
        (function loop() {
          if (topbar.progress("+.1") >= 1) {
            canvas.style.opacity -= 0.05;
            if (canvas.style.opacity <= 0.05) {
              canvas.style.display = "none";
              fadeTimerId = null;
              return;
            }
          }
          fadeTimerId = window.requestAnimationFrame(loop);
        })();
      },
    };

  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = topbar;
  } else if (typeof define === "function" && define.amd) {
    define(function () {
      return topbar;
    });
  } else {
    this.topbar = topbar;
  }
}.call(this, window, document));

/**
 * vis-network
 * https://visjs.github.io/vis-network/
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 9.0.3
 * @date    2021-03-06T12:02:16.846Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
        typeof define === 'function' && define.amd ? define(['exports'], factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.vis = global.vis || {}));
}(this, (function (exports) {
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn) {
        var module = { exports: {} };
        return fn(module, module.exports), module.exports;
    }

    var check = function (it) {
        return it && it.Math == Math && it;
    }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


    var global$1 =
        /* global globalThis -- safe */
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
        function () {
            return this;
        }() || Function('return this')();

    var fails = function (exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };

    var descriptors = !fails(function () {
        return Object.defineProperty({}, 1, {
            get: function () {
                return 7;
            }
        })[1] != 7;
    });

    var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
    var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

    var NASHORN_BUG = getOwnPropertyDescriptor$5 && !nativePropertyIsEnumerable$1.call({
        1: 2
    }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

    var f$6 = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor$5(this, V);
        return !!descriptor && descriptor.enumerable;
    } : nativePropertyIsEnumerable$1;
    var objectPropertyIsEnumerable = {
        f: f$6
    };

    var createPropertyDescriptor = function (bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };

    var toString$1 = {}.toString;

    var classofRaw = function (it) {
        return toString$1.call(it).slice(8, -1);
    };

    var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

    var indexedObject = fails(function () {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
        return !Object('z').propertyIsEnumerable(0);
    }) ? function (it) {
        return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
    } : Object;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible = function (it) {
        if (it == undefined) throw TypeError("Can't call method on " + it);
        return it;
    };

    var toIndexedObject = function (it) {
        return indexedObject(requireObjectCoercible(it));
    };

    var isObject$1 = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    // https://tc39.es/ecma262/#sec-toprimitive
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string

    var toPrimitive = function (input, PREFERRED_STRING) {
        if (!isObject$1(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == 'function' && !isObject$1(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
    };

    var hasOwnProperty = {}.hasOwnProperty;

    var has$1 = function (it, key) {
        return hasOwnProperty.call(it, key);
    };

    var document$1 = global$1.document; // typeof document.createElement is 'object' in old IE

    var EXISTS = isObject$1(document$1) && isObject$1(document$1.createElement);

    var documentCreateElement = function (it) {
        return EXISTS ? document$1.createElement(it) : {};
    };

    var ie8DomDefine = !descriptors && !fails(function () {
        return Object.defineProperty(documentCreateElement('div'), 'a', {
            get: function () {
                return 7;
            }
        }).a != 7;
    });

    var nativeGetOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

    var f$5 = descriptors ? nativeGetOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (ie8DomDefine) try {
            return nativeGetOwnPropertyDescriptor$2(O, P);
        } catch (error) {
            /* empty */
        }
        if (has$1(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };
    var objectGetOwnPropertyDescriptor = {
        f: f$5
    };

    var replacement = /#|\.prototype\./;

    var isForced = function (feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
    };

    var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';
    var isForced_1 = isForced;

    var path = {};

    var aFunction$1 = function (it) {
        if (typeof it != 'function') {
            throw TypeError(String(it) + ' is not a function');
        }

        return it;
    };

    var functionBindContext = function (fn, that, length) {
        aFunction$1(fn);
        if (that === undefined) return fn;

        switch (length) {
            case 0:
                return function () {
                    return fn.call(that);
                };

            case 1:
                return function (a) {
                    return fn.call(that, a);
                };

            case 2:
                return function (a, b) {
                    return fn.call(that, a, b);
                };

            case 3:
                return function (a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }

        return function ()
            /* ...args */
        {
            return fn.apply(that, arguments);
        };
    };

    var anObject = function (it) {
        if (!isObject$1(it)) {
            throw TypeError(String(it) + ' is not an object');
        }

        return it;
    };

    var nativeDefineProperty$1 = Object.defineProperty; // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty

    var f$4 = descriptors ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (ie8DomDefine) try {
            return nativeDefineProperty$1(O, P, Attributes);
        } catch (error) {
            /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
    var objectDefineProperty = {
        f: f$4
    };

    var createNonEnumerableProperty = descriptors ? function (object, key, value) {
        return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
        object[key] = value;
        return object;
    };

    var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;

    var wrapConstructor = function (NativeConstructor) {
        var Wrapper = function (a, b, c) {
            if (this instanceof NativeConstructor) {
                switch (arguments.length) {
                    case 0:
                        return new NativeConstructor();

                    case 1:
                        return new NativeConstructor(a);

                    case 2:
                        return new NativeConstructor(a, b);
                }

                return new NativeConstructor(a, b, c);
            }

            return NativeConstructor.apply(this, arguments);
        };

        Wrapper.prototype = NativeConstructor.prototype;
        return Wrapper;
    };
    /*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/


    var _export = function (options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var PROTO = options.proto;
        var nativeSource = GLOBAL ? global$1 : STATIC ? global$1[TARGET] : (global$1[TARGET] || {}).prototype;
        var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
        var targetPrototype = target.prototype;
        var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
        var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

        for (key in source) {
            FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contains in native

            USE_NATIVE = !FORCED && nativeSource && has$1(nativeSource, key);
            targetProperty = target[key];
            if (USE_NATIVE) if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor$4(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key]; // export native or implementation

            sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
            if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue; // bind timers to global for call from export context

            if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global$1); // wrap global constructors for prevent changs in this version
            else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty); // make static versions for prototype methods
            else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty); // default case
            else resultProperty = sourceProperty; // add a flag to not completely full polyfills

            if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) {
                createNonEnumerableProperty(resultProperty, 'sham', true);
            }

            target[key] = resultProperty;

            if (PROTO) {
                VIRTUAL_PROTOTYPE = TARGET + 'Prototype';

                if (!has$1(path, VIRTUAL_PROTOTYPE)) {
                    createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
                } // export virtual prototype methods


                path[VIRTUAL_PROTOTYPE][key] = sourceProperty; // export real prototype methods

                if (options.real && targetPrototype && !targetPrototype[key]) {
                    createNonEnumerableProperty(targetPrototype, key, sourceProperty);
                }
            }
        }
    };

    var ceil = Math.ceil;
    var floor = Math.floor; // `ToInteger` abstract operation
    // https://tc39.es/ecma262/#sec-tointeger

    var toInteger = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };

    var min$2 = Math.min; // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength

    var toLength = function (argument) {
        return argument > 0 ? min$2(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var max$2 = Math.max;
    var min$1 = Math.min; // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

    var toAbsoluteIndex = function (index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max$2(integer + length, 0) : min$1(integer, length);
    };

    var createMethod$5 = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check

            if (IS_INCLUDES && el != el) while (length > index) {
                value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

                if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };

    var arrayIncludes = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod$5(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod$5(false)
    };

    var hiddenKeys$1 = {};

    var indexOf$3 = arrayIncludes.indexOf;

    var objectKeysInternal = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key); // Don't enum bug & hidden keys


        while (names.length > i) if (has$1(O, key = names[i++])) {
            ~indexOf$3(result, key) || result.push(key);
        }

        return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

    // https://tc39.es/ecma262/#sec-object.keys

    var objectKeys = Object.keys || function keys(O) {
        return objectKeysInternal(O, enumBugKeys);
    };

    var f$3 = Object.getOwnPropertySymbols;
    var objectGetOwnPropertySymbols = {
        f: f$3
    };

    // https://tc39.es/ecma262/#sec-toobject

    var toObject = function (argument) {
        return Object(requireObjectCoercible(argument));
    };

    var nativeAssign = Object.assign;
    var defineProperty$8 = Object.defineProperty; // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign

    var objectAssign = !nativeAssign || fails(function () {
        // should have correct order of operations (Edge bug)
        if (descriptors && nativeAssign({
            b: 1
        }, nativeAssign(defineProperty$8({}, 'a', {
            enumerable: true,
            get: function () {
                defineProperty$8(this, 'b', {
                    value: 3,
                    enumerable: false
                });
            }
        }), {
            b: 2
        })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

        var A = {};
        var B = {};
        /* global Symbol -- required for testing */

        var symbol = Symbol();
        var alphabet = 'abcdefghijklmnopqrst';
        A[symbol] = 7;
        alphabet.split('').forEach(function (chr) {
            B[chr] = chr;
        });
        return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
    }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars -- required for `.length`
        var T = toObject(target);
        var argumentsLength = arguments.length;
        var index = 1;
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        var propertyIsEnumerable = objectPropertyIsEnumerable.f;

        while (argumentsLength > index) {
            var S = indexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
                key = keys[j++];
                if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
            }
        }

        return T;
    } : nativeAssign;

    // https://tc39.es/ecma262/#sec-object.assign

    _export({
        target: 'Object',
        stat: true,
        forced: Object.assign !== objectAssign
    }, {
        assign: objectAssign
    });

    var assign$4 = path.Object.assign;

    var assign$3 = assign$4;

    var assign$2 = assign$3;

    var slice$6 = [].slice;
    var factories = {};

    var construct$3 = function (C, argsLength, args) {
        if (!(argsLength in factories)) {
            for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']'; // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only


            factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
        }

        return factories[argsLength](C, args);
    }; // `Function.prototype.bind` method implementation
    // https://tc39.es/ecma262/#sec-function.prototype.bind


    var functionBind = Function.bind || function bind(that
                                                      /* , ...args */
    ) {
        var fn = aFunction$1(this);
        var partArgs = slice$6.call(arguments, 1);

        var boundFunction = function bound()
            /* args... */
        {
            var args = partArgs.concat(slice$6.call(arguments));
            return this instanceof boundFunction ? construct$3(fn, args.length, args) : fn.apply(that, args);
        };

        if (isObject$1(fn.prototype)) boundFunction.prototype = fn.prototype;
        return boundFunction;
    };

    // https://tc39.es/ecma262/#sec-function.prototype.bind

    _export({
        target: 'Function',
        proto: true
    }, {
        bind: functionBind
    });

    var entryVirtual = function (CONSTRUCTOR) {
        return path[CONSTRUCTOR + 'Prototype'];
    };

    var bind$2 = entryVirtual('Function').bind;

    var FunctionPrototype = Function.prototype;

    var bind_1 = function (it) {
        var own = it.bind;
        return it === FunctionPrototype || it instanceof Function && own === FunctionPrototype.bind ? bind$2 : own;
    };

    var bind$1 = bind_1;

    var bind = bind$1;

    /**
     * Draw a circle.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The radius of the circle.
     */
    function drawCircle(ctx, x, y, r) {
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2 * Math.PI, false);
        ctx.closePath();
    }
    /**
     * Draw a square.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the width and height of the square.
     */

    function drawSquare(ctx, x, y, r) {
        ctx.beginPath();
        ctx.rect(x - r, y - r, r * 2, r * 2);
        ctx.closePath();
    }
    /**
     * Draw an equilateral triangle standing on a side.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the length of the sides.
     *
     * @remarks
     * http://en.wikipedia.org/wiki/Equilateral_triangle
     */

    function drawTriangle(ctx, x, y, r) {
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 1.15;
        y += 0.275 * r;
        var s = r * 2;
        var s2 = s / 2;
        var ir = Math.sqrt(3) / 6 * s; // radius of inner circle

        var h = Math.sqrt(s * s - s2 * s2); // height

        ctx.moveTo(x, y - (h - ir));
        ctx.lineTo(x + s2, y + ir);
        ctx.lineTo(x - s2, y + ir);
        ctx.lineTo(x, y - (h - ir));
        ctx.closePath();
    }
    /**
     * Draw an equilateral triangle standing on a vertex.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the length of the sides.
     *
     * @remarks
     * http://en.wikipedia.org/wiki/Equilateral_triangle
     */

    function drawTriangleDown(ctx, x, y, r) {
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 1.15;
        y -= 0.275 * r;
        var s = r * 2;
        var s2 = s / 2;
        var ir = Math.sqrt(3) / 6 * s; // radius of inner circle

        var h = Math.sqrt(s * s - s2 * s2); // height

        ctx.moveTo(x, y + (h - ir));
        ctx.lineTo(x + s2, y - ir);
        ctx.lineTo(x - s2, y - ir);
        ctx.lineTo(x, y + (h - ir));
        ctx.closePath();
    }
    /**
     * Draw a star.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The outer radius of the star.
     */

    function drawStar(ctx, x, y, r) {
        // http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 0.82;
        y += 0.1 * r;

        for (var n = 0; n < 10; n++) {
            var radius = n % 2 === 0 ? r * 1.3 : r * 0.5;
            ctx.lineTo(x + radius * Math.sin(n * 2 * Math.PI / 10), y - radius * Math.cos(n * 2 * Math.PI / 10));
        }

        ctx.closePath();
    }
    /**
     * Draw a diamond.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the width and height of the diamond.
     *
     * @remarks
     * http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
     */

    function drawDiamond(ctx, x, y, r) {
        ctx.beginPath();
        ctx.lineTo(x, y + r);
        ctx.lineTo(x + r, y);
        ctx.lineTo(x, y - r);
        ctx.lineTo(x - r, y);
        ctx.closePath();
    }
    /**
     * Draw a rectangle with rounded corners.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the rectangle.
     * @param h - The height of the rectangle.
     * @param r - The radius of the corners.
     *
     * @remarks
     * http://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
     */

    function drawRoundRect(ctx, x, y, w, h, r) {
        var r2d = Math.PI / 180;

        if (w - 2 * r < 0) {
            r = w / 2;
        } //ensure that the radius isn't too large for x


        if (h - 2 * r < 0) {
            r = h / 2;
        } //ensure that the radius isn't too large for y


        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.arc(x + w - r, y + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(x + w, y + h - r);
        ctx.arc(x + w - r, y + h - r, r, 0, r2d * 90, false);
        ctx.lineTo(x + r, y + h);
        ctx.arc(x + r, y + h - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(x, y + r);
        ctx.arc(x + r, y + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
    }
    /**
     * Draw an ellipse.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the ellipse.
     * @param h - The height of the ellipse.
     *
     * @remarks
     * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
     *
     * Postfix '_vis' added to discern it from standard method ellipse().
     */

    function drawEllipse(ctx, x, y, w, h) {
        var kappa = 0.5522848,
            ox = w / 2 * kappa,
            // control point offset horizontal
            oy = h / 2 * kappa,
            // control point offset vertical
            xe = x + w,
            // x-end
            ye = y + h,
            // y-end
            xm = x + w / 2,
            // x-middle
            ym = y + h / 2; // y-middle

        ctx.beginPath();
        ctx.moveTo(x, ym);
        ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        ctx.closePath();
    }
    /**
     * Draw an isometric cylinder.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the database.
     * @param h - The height of the database.
     *
     * @remarks
     * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
     */

    function drawDatabase(ctx, x, y, w, h) {
        var f = 1 / 3;
        var wEllipse = w;
        var hEllipse = h * f;
        var kappa = 0.5522848,
            ox = wEllipse / 2 * kappa,
            // control point offset horizontal
            oy = hEllipse / 2 * kappa,
            // control point offset vertical
            xe = x + wEllipse,
            // x-end
            ye = y + hEllipse,
            // y-end
            xm = x + wEllipse / 2,
            // x-middle
            ym = y + hEllipse / 2,
            // y-middle
            ymb = y + (h - hEllipse / 2),
            // y-midlle, bottom ellipse
            yeb = y + h; // y-end, bottom ellipse

        ctx.beginPath();
        ctx.moveTo(xe, ym);
        ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        ctx.lineTo(xe, ymb);
        ctx.bezierCurveTo(xe, ymb + oy, xm + ox, yeb, xm, yeb);
        ctx.bezierCurveTo(xm - ox, yeb, x, ymb + oy, x, ymb);
        ctx.lineTo(x, ym);
    }
    /**
     * Draw a dashed line.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The start position on the x axis.
     * @param y - The start position on the y axis.
     * @param x2 - The end position on the x axis.
     * @param y2 - The end position on the y axis.
     * @param pattern - List of lengths starting with line and then alternating between space and line.
     *
     * @author David Jordan
     * @remarks
     * date 2012-08-08
     * http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas
     */

    function drawDashedLine(ctx, x, y, x2, y2, pattern) {
        ctx.beginPath();
        ctx.moveTo(x, y);
        var patternLength = pattern.length;
        var dx = x2 - x;
        var dy = y2 - y;
        var slope = dy / dx;
        var distRemaining = Math.sqrt(dx * dx + dy * dy);
        var patternIndex = 0;
        var draw = true;
        var xStep = 0;
        var dashLength = +pattern[0];

        while (distRemaining >= 0.1) {
            dashLength = +pattern[patternIndex++ % patternLength];

            if (dashLength > distRemaining) {
                dashLength = distRemaining;
            }

            xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope));
            xStep = dx < 0 ? -xStep : xStep;
            x += xStep;
            y += slope * xStep;

            if (draw === true) {
                ctx.lineTo(x, y);
            } else {
                ctx.moveTo(x, y);
            }

            distRemaining -= dashLength;
            draw = !draw;
        }
    }
    /**
     * Draw a hexagon.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The radius of the hexagon.
     */

    function drawHexagon(ctx, x, y, r) {
        ctx.beginPath();
        var sides = 6;
        var a = Math.PI * 2 / sides;
        ctx.moveTo(x + r, y);

        for (var i = 1; i < sides; i++) {
            ctx.lineTo(x + r * Math.cos(a * i), y + r * Math.sin(a * i));
        }

        ctx.closePath();
    }
    var shapeMap = {
        circle: drawCircle,
        dashedLine: drawDashedLine,
        database: drawDatabase,
        diamond: drawDiamond,
        ellipse: drawEllipse,
        ellipse_vis: drawEllipse,
        hexagon: drawHexagon,
        roundRect: drawRoundRect,
        square: drawSquare,
        star: drawStar,
        triangle: drawTriangle,
        triangleDown: drawTriangleDown
    };
    /**
     * Returns either custom or native drawing function base on supplied name.
     *
     * @param name - The name of the function. Either the name of a
     * CanvasRenderingContext2D property or an export from shapes.ts without the
     * draw prefix.
     *
     * @returns The function that can be used for rendering. In case of native
     * CanvasRenderingContext2D function the API is normalized to
     * `(ctx: CanvasRenderingContext2D, ...originalArgs) => void`.
     */

    function getShape(name) {
        if (Object.prototype.hasOwnProperty.call(shapeMap, name)) {
            return shapeMap[name];
        } else {
            return function (ctx) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                CanvasRenderingContext2D.prototype[name].call(ctx, args);
            };
        }
    }

    function styleInject(css, ref) {
        if (ref === void 0) ref = {};
        var insertAt = ref.insertAt;

        if (!css || typeof document === 'undefined') {
            return;
        }

        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';

        if (insertAt === 'top') {
            if (head.firstChild) {
                head.insertBefore(style, head.firstChild);
            } else {
                head.appendChild(style);
            }
        } else {
            head.appendChild(style);
        }

        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
    }

    var css_248z$6 = ".vis-overlay {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n\n  /* Must be displayed above for example selected Timeline items */\n  z-index: 10;\n}\n\n.vis-active {\n  box-shadow: 0 0 10px #86d5f8;\n}\n";
    styleInject(css_248z$6);

    var css_248z$5 = "/* override some bootstrap styles screwing up the timelines css */\n\n.vis [class*=\"span\"] {\n  min-height: 0;\n  width: auto;\n}\n";
    styleInject(css_248z$5);

    var css_248z$4 = "div.vis-color-picker {\n  position: absolute;\n  top: 0px;\n  left: 30px;\n  margin-top: -140px;\n  margin-left: 30px;\n  width: 310px;\n  height: 444px;\n  z-index: 1;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #ffffff;\n  display: none;\n  box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px 0px;\n}\n\ndiv.vis-color-picker div.vis-arrow {\n  position: absolute;\n  top: 147px;\n  left: 5px;\n}\n\ndiv.vis-color-picker div.vis-arrow::after,\ndiv.vis-color-picker div.vis-arrow::before {\n  right: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\ndiv.vis-color-picker div.vis-arrow:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-right-color: #ffffff;\n  border-width: 30px;\n  margin-top: -30px;\n}\n\ndiv.vis-color-picker div.vis-color {\n  position: absolute;\n  width: 289px;\n  height: 289px;\n  cursor: pointer;\n}\n\ndiv.vis-color-picker div.vis-brightness {\n  position: absolute;\n  top: 313px;\n}\n\ndiv.vis-color-picker div.vis-opacity {\n  position: absolute;\n  top: 350px;\n}\n\ndiv.vis-color-picker div.vis-selector {\n  position: absolute;\n  top: 137px;\n  left: 137px;\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  border: 1px solid #ffffff;\n  background: #4c4c4c; /* Old browsers */\n  background: -moz-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #4c4c4c),\n    color-stop(12%, #595959),\n    color-stop(25%, #666666),\n    color-stop(39%, #474747),\n    color-stop(50%, #2c2c2c),\n    color-stop(51%, #000000),\n    color-stop(60%, #111111),\n    color-stop(76%, #2b2b2b),\n    color-stop(91%, #1c1c1c),\n    color-stop(100%, #131313)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* IE10+ */\n  background: linear-gradient(\n    to bottom,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4c4c4c', endColorstr='#131313',GradientType=0 ); /* IE6-9 */\n}\n\ndiv.vis-color-picker div.vis-new-color {\n  position: absolute;\n  width: 140px;\n  height: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  top: 380px;\n  left: 159px;\n  text-align: right;\n  padding-right: 2px;\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.4);\n  vertical-align: middle;\n  line-height: 20px;\n}\n\ndiv.vis-color-picker div.vis-initial-color {\n  position: absolute;\n  width: 140px;\n  height: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  top: 380px;\n  left: 10px;\n  text-align: left;\n  padding-left: 2px;\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.4);\n  vertical-align: middle;\n  line-height: 20px;\n}\n\ndiv.vis-color-picker div.vis-label {\n  position: absolute;\n  width: 300px;\n  left: 10px;\n}\n\ndiv.vis-color-picker div.vis-label.vis-brightness {\n  top: 300px;\n}\n\ndiv.vis-color-picker div.vis-label.vis-opacity {\n  top: 338px;\n}\n\ndiv.vis-color-picker div.vis-button {\n  position: absolute;\n  width: 68px;\n  height: 25px;\n  border-radius: 10px;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 25px;\n  top: 410px;\n  border: 2px solid #d9d9d9;\n  background-color: #f7f7f7;\n  cursor: pointer;\n}\n\ndiv.vis-color-picker div.vis-button.vis-cancel {\n  /*border:2px solid #ff4e33;*/\n  /*background-color: #ff7761;*/\n  left: 5px;\n}\ndiv.vis-color-picker div.vis-button.vis-load {\n  /*border:2px solid #a153e6;*/\n  /*background-color: #cb8dff;*/\n  left: 82px;\n}\ndiv.vis-color-picker div.vis-button.vis-apply {\n  /*border:2px solid #4588e6;*/\n  /*background-color: #82b6ff;*/\n  left: 159px;\n}\ndiv.vis-color-picker div.vis-button.vis-save {\n  /*border:2px solid #45e655;*/\n  /*background-color: #6dff7c;*/\n  left: 236px;\n}\n\ndiv.vis-color-picker input.vis-range {\n  width: 290px;\n  height: 20px;\n}\n\n/* TODO: is this redundant?\ndiv.vis-color-picker input.vis-range-brightness {\n  width: 289px !important;\n}\n\n\ndiv.vis-color-picker input.vis-saturation-range {\n  width: 289px !important;\n}*/\n";
    styleInject(css_248z$4);

    var css_248z$3 = "div.vis-configuration {\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\ndiv.vis-configuration-wrapper {\n  display: block;\n  width: 700px;\n}\n\ndiv.vis-configuration-wrapper::after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n\ndiv.vis-configuration.vis-config-option-container {\n  display: block;\n  width: 495px;\n  background-color: #ffffff;\n  border: 2px solid #f7f8fa;\n  border-radius: 4px;\n  margin-top: 20px;\n  left: 10px;\n  padding-left: 5px;\n}\n\ndiv.vis-configuration.vis-config-button {\n  display: block;\n  width: 495px;\n  height: 25px;\n  vertical-align: middle;\n  line-height: 25px;\n  background-color: #f7f8fa;\n  border: 2px solid #ceced0;\n  border-radius: 4px;\n  margin-top: 20px;\n  left: 10px;\n  padding-left: 5px;\n  cursor: pointer;\n  margin-bottom: 30px;\n}\n\ndiv.vis-configuration.vis-config-button.hover {\n  background-color: #4588e6;\n  border: 2px solid #214373;\n  color: #ffffff;\n}\n\ndiv.vis-configuration.vis-config-item {\n  display: block;\n  float: left;\n  width: 495px;\n  height: 25px;\n  vertical-align: middle;\n  line-height: 25px;\n}\n\ndiv.vis-configuration.vis-config-item.vis-config-s2 {\n  left: 10px;\n  background-color: #f7f8fa;\n  padding-left: 5px;\n  border-radius: 3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s3 {\n  left: 20px;\n  background-color: #e4e9f0;\n  padding-left: 5px;\n  border-radius: 3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s4 {\n  left: 30px;\n  background-color: #cfd8e6;\n  padding-left: 5px;\n  border-radius: 3px;\n}\n\ndiv.vis-configuration.vis-config-header {\n  font-size: 18px;\n  font-weight: bold;\n}\n\ndiv.vis-configuration.vis-config-label {\n  width: 120px;\n  height: 25px;\n  line-height: 25px;\n}\n\ndiv.vis-configuration.vis-config-label.vis-config-s3 {\n  width: 110px;\n}\ndiv.vis-configuration.vis-config-label.vis-config-s4 {\n  width: 100px;\n}\n\ndiv.vis-configuration.vis-config-colorBlock {\n  top: 1px;\n  width: 30px;\n  height: 19px;\n  border: 1px solid #444444;\n  border-radius: 2px;\n  padding: 0px;\n  margin: 0px;\n  cursor: pointer;\n}\n\ninput.vis-configuration.vis-config-checkbox {\n  left: -5px;\n}\n\ninput.vis-configuration.vis-config-rangeinput {\n  position: relative;\n  top: -5px;\n  width: 60px;\n  /*height:13px;*/\n  padding: 1px;\n  margin: 0;\n  pointer-events: none;\n}\n\ninput.vis-configuration.vis-config-range {\n  /*removes default webkit styles*/\n  -webkit-appearance: none;\n\n  /*fix for FF unable to apply focus style bug */\n  border: 0px solid white;\n  background-color: rgba(0, 0, 0, 0);\n\n  /*required for proper track sizing in FF*/\n  width: 300px;\n  height: 20px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-runnable-track {\n  width: 300px;\n  height: 5px;\n  background: #dedede; /* Old browsers */\n  background: -moz-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #dedede),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #dedede 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n  border: 1px solid #999999;\n  box-shadow: #aaaaaa 0px 0px 3px 0px;\n  border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border: 1px solid #14334b;\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n  background: #3876c2; /* Old browsers */\n  background: -moz-linear-gradient(top, #3876c2 0%, #385380 100%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #3876c2),\n    color-stop(100%, #385380)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #3876c2 0%,\n    #385380 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #3876c2 0%,\n    #385380 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #3876c2 0%, #385380 100%); /* IE10+ */\n  background: linear-gradient(to bottom, #3876c2 0%, #385380 100%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3876c2', endColorstr='#385380',GradientType=0 ); /* IE6-9 */\n  box-shadow: #111927 0px 0px 1px 0px;\n  margin-top: -7px;\n}\ninput.vis-configuration.vis-config-range:focus {\n  outline: none;\n}\ninput.vis-configuration.vis-config-range:focus::-webkit-slider-runnable-track {\n  background: #9d9d9d; /* Old browsers */\n  background: -moz-linear-gradient(top, #9d9d9d 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #9d9d9d),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #9d9d9d 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #9d9d9d 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #9d9d9d 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #9d9d9d 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9d9d9d', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n}\n\ninput.vis-configuration.vis-config-range::-moz-range-track {\n  width: 300px;\n  height: 10px;\n  background: #dedede; /* Old browsers */\n  background: -moz-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #dedede),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #dedede 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n  border: 1px solid #999999;\n  box-shadow: #aaaaaa 0px 0px 3px 0px;\n  border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-moz-range-thumb {\n  border: none;\n  height: 16px;\n  width: 16px;\n\n  border-radius: 50%;\n  background: #385380;\n}\n\n/*hide the outline behind the border*/\ninput.vis-configuration.vis-config-range:-moz-focusring {\n  outline: 1px solid white;\n  outline-offset: -1px;\n}\n\ninput.vis-configuration.vis-config-range::-ms-track {\n  width: 300px;\n  height: 5px;\n\n  /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */\n  background: transparent;\n\n  /*leave room for the larger thumb to overflow with a transparent border */\n  border-color: transparent;\n  border-width: 6px 0;\n\n  /*remove default tick marks*/\n  color: transparent;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-lower {\n  background: #777;\n  border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-upper {\n  background: #ddd;\n  border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-thumb {\n  border: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background: #385380;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-lower {\n  background: #888;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-upper {\n  background: #ccc;\n}\n\n.vis-configuration-popup {\n  position: absolute;\n  background: rgba(57, 76, 89, 0.85);\n  border: 2px solid #f2faff;\n  line-height: 30px;\n  height: 30px;\n  width: 150px;\n  text-align: center;\n  color: #ffffff;\n  font-size: 14px;\n  border-radius: 4px;\n  -webkit-transition: opacity 0.3s ease-in-out;\n  -moz-transition: opacity 0.3s ease-in-out;\n  transition: opacity 0.3s ease-in-out;\n}\n.vis-configuration-popup:after,\n.vis-configuration-popup:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.vis-configuration-popup:after {\n  border-color: rgba(136, 183, 213, 0);\n  border-left-color: rgba(57, 76, 89, 0.85);\n  border-width: 8px;\n  margin-top: -8px;\n}\n.vis-configuration-popup:before {\n  border-color: rgba(194, 225, 245, 0);\n  border-left-color: #f2faff;\n  border-width: 12px;\n  margin-top: -12px;\n}\n";
    styleInject(css_248z$3);

    var css_248z$2 = "div.vis-tooltip {\n  position: absolute;\n  visibility: hidden;\n  padding: 5px;\n  white-space: nowrap;\n\n  font-family: verdana;\n  font-size: 14px;\n  color: #000000;\n  background-color: #f5f4ed;\n\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n  border: 1px solid #808074;\n\n  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n\n  z-index: 5;\n}\n";
    styleInject(css_248z$2);

    var componentEmitter = createCommonjsModule(function (module) {
        /**
         * Expose `Emitter`.
         */
        {
            module.exports = Emitter;
        }
        /**
         * Initialize a new `Emitter`.
         *
         * @api public
         */


        function Emitter(obj) {
            if (obj) return mixin(obj);
        }
        /**
         * Mixin the emitter properties.
         *
         * @param {Object} obj
         * @return {Object}
         * @api private
         */

        function mixin(obj) {
            for (var key in Emitter.prototype) {
                obj[key] = Emitter.prototype[key];
            }

            return obj;
        }
        /**
         * Listen on the given `event` with `fn`.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
            this._callbacks = this._callbacks || {};
            (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
            return this;
        };
        /**
         * Adds an `event` listener that will be invoked a single
         * time then automatically removed.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.once = function (event, fn) {
            function on() {
                this.off(event, on);
                fn.apply(this, arguments);
            }

            on.fn = fn;
            this.on(event, on);
            return this;
        };
        /**
         * Remove the given callback for `event` or all
         * registered callbacks.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
            this._callbacks = this._callbacks || {}; // all

            if (0 == arguments.length) {
                this._callbacks = {};
                return this;
            } // specific event


            var callbacks = this._callbacks['$' + event];
            if (!callbacks) return this; // remove all handlers

            if (1 == arguments.length) {
                delete this._callbacks['$' + event];
                return this;
            } // remove specific handler


            var cb;

            for (var i = 0; i < callbacks.length; i++) {
                cb = callbacks[i];

                if (cb === fn || cb.fn === fn) {
                    callbacks.splice(i, 1);
                    break;
                }
            } // Remove event specific arrays for event types that no
            // one is subscribed for to avoid memory leak.


            if (callbacks.length === 0) {
                delete this._callbacks['$' + event];
            }

            return this;
        };
        /**
         * Emit `event` with the given args.
         *
         * @param {String} event
         * @param {Mixed} ...
         * @return {Emitter}
         */


        Emitter.prototype.emit = function (event) {
            this._callbacks = this._callbacks || {};
            var args = new Array(arguments.length - 1),
                callbacks = this._callbacks['$' + event];

            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }

            if (callbacks) {
                callbacks = callbacks.slice(0);

                for (var i = 0, len = callbacks.length; i < len; ++i) {
                    callbacks[i].apply(this, args);
                }
            }

            return this;
        };
        /**
         * Return array of callbacks for `event`.
         *
         * @param {String} event
         * @return {Array}
         * @api public
         */


        Emitter.prototype.listeners = function (event) {
            this._callbacks = this._callbacks || {};
            return this._callbacks['$' + event] || [];
        };
        /**
         * Check if this emitter has `event` handlers.
         *
         * @param {String} event
         * @return {Boolean}
         * @api public
         */


        Emitter.prototype.hasListeners = function (event) {
            return !!this.listeners(event).length;
        };
    });

    var createMethod$4 = function (CONVERT_TO_STRING) {
        return function ($this, pos) {
            var S = String(requireObjectCoercible($this));
            var position = toInteger(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = S.charCodeAt(position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
        };
    };

    var stringMultibyte = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod$4(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod$4(true)
    };

    var setGlobal = function (key, value) {
        try {
            createNonEnumerableProperty(global$1, key, value);
        } catch (error) {
            global$1[key] = value;
        }

        return value;
    };

    var SHARED = '__core-js_shared__';
    var store$1 = global$1[SHARED] || setGlobal(SHARED, {});
    var sharedStore = store$1;

    var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

    if (typeof sharedStore.inspectSource != 'function') {
        sharedStore.inspectSource = function (it) {
            return functionToString.call(it);
        };
    }

    var inspectSource = sharedStore.inspectSource;

    var WeakMap$1 = global$1.WeakMap;
    var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));

    var shared = createCommonjsModule(function (module) {
        (module.exports = function (key, value) {
            return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
        })('versions', []).push({
            version: '3.9.1',
            mode: 'pure' ,
            copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
        });
    });

    var id$1 = 0;
    var postfix = Math.random();

    var uid = function (key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix).toString(36);
    };

    var keys$6 = shared('keys');

    var sharedKey = function (key) {
        return keys$6[key] || (keys$6[key] = uid(key));
    };

    var WeakMap = global$1.WeakMap;
    var set$3, get$4, has;

    var enforce = function (it) {
        return has(it) ? get$4(it) : set$3(it, {});
    };

    var getterFor = function (TYPE) {
        return function (it) {
            var state;

            if (!isObject$1(it) || (state = get$4(it)).type !== TYPE) {
                throw TypeError('Incompatible receiver, ' + TYPE + ' required');
            }

            return state;
        };
    };

    if (nativeWeakMap) {
        var store = sharedStore.state || (sharedStore.state = new WeakMap());
        var wmget = store.get;
        var wmhas = store.has;
        var wmset = store.set;

        set$3 = function (it, metadata) {
            metadata.facade = it;
            wmset.call(store, it, metadata);
            return metadata;
        };

        get$4 = function (it) {
            return wmget.call(store, it) || {};
        };

        has = function (it) {
            return wmhas.call(store, it);
        };
    } else {
        var STATE = sharedKey('state');
        hiddenKeys$1[STATE] = true;

        set$3 = function (it, metadata) {
            metadata.facade = it;
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
        };

        get$4 = function (it) {
            return has$1(it, STATE) ? it[STATE] : {};
        };

        has = function (it) {
            return has$1(it, STATE);
        };
    }

    var internalState = {
        set: set$3,
        get: get$4,
        has: has,
        enforce: enforce,
        getterFor: getterFor
    };

    var correctPrototypeGetter = !fails(function () {
        function F() {
            /* empty */
        }

        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    var IE_PROTO$1 = sharedKey('IE_PROTO');
    var ObjectPrototype$1 = Object.prototype; // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof

    var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
        O = toObject(O);
        if (has$1(O, IE_PROTO$1)) return O[IE_PROTO$1];

        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
        }

        return O instanceof Object ? ObjectPrototype$1 : null;
    };

    var engineIsNode = classofRaw(global$1.process) == 'process';

    var aFunction = function (variable) {
        return typeof variable == 'function' ? variable : undefined;
    };

    var getBuiltIn = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$1[namespace]) : path[namespace] && path[namespace][method] || global$1[namespace] && global$1[namespace][method];
    };

    var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

    var process = global$1.process;
    var versions = process && process.versions;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
        match = v8.split('.');
        version = match[0] + match[1];
    } else if (engineUserAgent) {
        match = engineUserAgent.match(/Edge\/(\d+)/);

        if (!match || match[1] >= 74) {
            match = engineUserAgent.match(/Chrome\/(\d+)/);
            if (match) version = match[1];
        }
    }

    var engineV8Version = version && +version;

    var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
        /* global Symbol -- required for testing */
        return !Symbol.sham && ( // Chrome 38 Symbol has incorrect toString conversion
            // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            engineIsNode ? engineV8Version === 38 : engineV8Version > 37 && engineV8Version < 41);
    });

    var useSymbolAsUid = nativeSymbol
        /* global Symbol -- safe */
        && !Symbol.sham && typeof Symbol.iterator == 'symbol';

    var WellKnownSymbolsStore$1 = shared('wks');
    var Symbol$1 = global$1.Symbol;
    var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

    var wellKnownSymbol = function (name) {
        if (!has$1(WellKnownSymbolsStore$1, name) || !(nativeSymbol || typeof WellKnownSymbolsStore$1[name] == 'string')) {
            if (nativeSymbol && has$1(Symbol$1, name)) {
                WellKnownSymbolsStore$1[name] = Symbol$1[name];
            } else {
                WellKnownSymbolsStore$1[name] = createWellKnownSymbol('Symbol.' + name);
            }
        }

        return WellKnownSymbolsStore$1[name];
    };

    var ITERATOR$5 = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS$1 = false;

    var returnThis$2 = function () {
        return this;
    }; // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object


    var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

    if ([].keys) {
        arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;else {
            PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
        }
    }

    var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails(function () {
        var test = {}; // FF44- legacy iterators case

        return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
    });
    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

    if ((NEW_ITERATOR_PROTOTYPE) && !has$1(IteratorPrototype$2, ITERATOR$5)) {
        createNonEnumerableProperty(IteratorPrototype$2, ITERATOR$5, returnThis$2);
    }

    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype$2,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
    };

    // https://tc39.es/ecma262/#sec-object.defineproperties

    var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index = 0;
        var key;

        while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);

        return O;
    };

    var html = getBuiltIn('document', 'documentElement');

    var GT = '>';
    var LT = '<';
    var PROTOTYPE$1 = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');

    var EmptyConstructor = function () {
        /* empty */
    };

    var scriptTag = function (content) {
        return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    }; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


    var NullProtoObjectViaActiveX = function (activeXDocument) {
        activeXDocument.write(scriptTag(''));
        activeXDocument.close();
        var temp = activeXDocument.parentWindow.Object;
        activeXDocument = null; // avoid memory leak

        return temp;
    }; // Create object with fake `null` prototype: use iframe Object with cleared prototype


    var NullProtoObjectViaIFrame = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe');
        var JS = 'java' + SCRIPT + ':';
        var iframeDocument;
        iframe.style.display = 'none';
        html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag('document.F=Object'));
        iframeDocument.close();
        return iframeDocument.F;
    }; // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug


    var activeXDocument;

    var NullProtoObject = function () {
        try {
            /* global ActiveXObject -- old IE */
            activeXDocument = document.domain && new ActiveXObject('htmlfile');
        } catch (error) {
            /* ignore */
        }

        NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
        var length = enumBugKeys.length;

        while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];

        return NullProtoObject();
    };

    hiddenKeys$1[IE_PROTO] = true; // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create

    var objectCreate = Object.create || function create(O, Properties) {
        var result;

        if (O !== null) {
            EmptyConstructor[PROTOTYPE$1] = anObject(O);
            result = new EmptyConstructor();
            EmptyConstructor[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
        } else result = NullProtoObject();

        return Properties === undefined ? result : objectDefineProperties(result, Properties);
    };

    var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
    var test$2 = {};
    test$2[TO_STRING_TAG$3] = 'z';
    var toStringTagSupport = String(test$2) === '[object z]';

    var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag'); // ES3 wrong here

    var CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments;
    }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

    var tryGet = function (it, key) {
        try {
            return it[key];
        } catch (error) {
            /* empty */
        }
    }; // getting tag from ES6+ `Object.prototype.toString`


    var classof = toStringTagSupport ? classofRaw : function (it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
            : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag // builtinTag case
                : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
                    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
    };

    // https://tc39.es/ecma262/#sec-object.prototype.tostring


    var objectToString = toStringTagSupport ? {}.toString : function toString() {
        return '[object ' + classof(this) + ']';
    };

    var defineProperty$7 = objectDefineProperty.f;
    var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');

    var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
        if (it) {
            var target = STATIC ? it : it.prototype;

            if (!has$1(target, TO_STRING_TAG$1)) {
                defineProperty$7(target, TO_STRING_TAG$1, {
                    configurable: true,
                    value: TAG
                });
            }

            if (SET_METHOD && !toStringTagSupport) {
                createNonEnumerableProperty(target, 'toString', objectToString);
            }
        }
    };

    var iterators = {};

    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

    var returnThis$1 = function () {
        return this;
    };

    var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
            next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        iterators[TO_STRING_TAG] = returnThis$1;
        return IteratorConstructor;
    };

    var aPossiblePrototype = function (it) {
        if (!isObject$1(it) && it !== null) {
            throw TypeError("Can't set " + String(it) + ' as a prototype');
        }

        return it;
    };

    /* eslint-disable no-proto -- safe */
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.

    var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;

        try {
            setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
            setter.call(test, []);
            CORRECT_SETTER = test instanceof Array;
        } catch (error) {
            /* empty */
        }

        return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
            return O;
        };
    }() : undefined);

    var redefine = function (target, key, value, options) {
        if (options && options.enumerable) target[key] = value;else createNonEnumerableProperty(target, key, value);
    };

    var IteratorPrototype = iteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$4 = wellKnownSymbol('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';

    var returnThis = function () {
        return this;
    };

    var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);

        var getIterationMethod = function (KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

            switch (KIND) {
                case KEYS:
                    return function keys() {
                        return new IteratorConstructor(this, KIND);
                    };

                case VALUES:
                    return function values() {
                        return new IteratorConstructor(this, KIND);
                    };

                case ENTRIES:
                    return function entries() {
                        return new IteratorConstructor(this, KIND);
                    };
            }

            return function () {
                return new IteratorConstructor(this);
            };
        };

        var TO_STRING_TAG = NAME + ' Iterator';
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR$4] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY; // fix native

        if (anyNativeIterator) {
            CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

            if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {


                setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                iterators[TO_STRING_TAG] = returnThis;
            }
        } // fix Array#{values, @@iterator}.name in V8 / FF


        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;

            defaultIterator = function values() {
                return nativeIterator.call(this);
            };
        } // define iterator


        if ((FORCED) && IterablePrototype[ITERATOR$4] !== defaultIterator) {
            createNonEnumerableProperty(IterablePrototype, ITERATOR$4, defaultIterator);
        }

        iterators[NAME] = defaultIterator; // export additional methods

        if (DEFAULT) {
            methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) for (KEY in methods) {
                if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                    redefine(IterablePrototype, KEY, methods[KEY]);
                }
            } else _export({
                target: NAME,
                proto: true,
                forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods);
        }

        return methods;
    };

    var charAt = stringMultibyte.charAt;
    var STRING_ITERATOR = 'String Iterator';
    var setInternalState$5 = internalState.set;
    var getInternalState$2 = internalState.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-string.prototype-@@iterator

    defineIterator(String, 'String', function (iterated) {
        setInternalState$5(this, {
            type: STRING_ITERATOR,
            string: String(iterated),
            index: 0
        }); // `%StringIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
        var state = getInternalState$2(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return {
            value: undefined,
            done: true
        };
        point = charAt(string, index);
        state.index += point.length;
        return {
            value: point,
            done: false
        };
    });

    var iteratorClose = function (iterator) {
        var returnMethod = iterator['return'];

        if (returnMethod !== undefined) {
            return anObject(returnMethod.call(iterator)).value;
        }
    };

    var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
        try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
        } catch (error) {
            iteratorClose(iterator);
            throw error;
        }
    };

    var ITERATOR$3 = wellKnownSymbol('iterator');
    var ArrayPrototype$i = Array.prototype; // check on default Array iterator

    var isArrayIteratorMethod = function (it) {
        return it !== undefined && (iterators.Array === it || ArrayPrototype$i[ITERATOR$3] === it);
    };

    var createProperty = function (object, key, value) {
        var propertyKey = toPrimitive(key);
        if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
    };

    var ITERATOR$2 = wellKnownSymbol('iterator');

    var getIteratorMethod$1 = function (it) {
        if (it != undefined) return it[ITERATOR$2] || it['@@iterator'] || iterators[classof(it)];
    };

    // https://tc39.es/ecma262/#sec-array.from


    var arrayFrom = function from(arrayLike
                                  /* , mapfn = undefined, thisArg = undefined */
    ) {
        var O = toObject(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iteratorMethod = getIteratorMethod$1(O);
        var index = 0;
        var length, result, step, iterator, next, value;
        if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2); // if the target is not iterable or it's an array with the default iterator - use a simple case

        if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
            iterator = iteratorMethod.call(O);
            next = iterator.next;
            result = new C();

            for (; !(step = next.call(iterator)).done; index++) {
                value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
                createProperty(result, index, value);
            }
        } else {
            length = toLength(O.length);
            result = new C(length);

            for (; length > index; index++) {
                value = mapping ? mapfn(O[index], index) : O[index];
                createProperty(result, index, value);
            }
        }

        result.length = index;
        return result;
    };

    var ITERATOR$1 = wellKnownSymbol('iterator');
    var SAFE_CLOSING = false;

    try {
        var called = 0;
        var iteratorWithReturn = {
            next: function () {
                return {
                    done: !!called++
                };
            },
            'return': function () {
                SAFE_CLOSING = true;
            }
        };

        iteratorWithReturn[ITERATOR$1] = function () {
            return this;
        }; // eslint-disable-next-line no-throw-literal -- required for testing


        Array.from(iteratorWithReturn, function () {
            throw 2;
        });
    } catch (error) {
        /* empty */
    }

    var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        var ITERATION_SUPPORT = false;

        try {
            var object = {};

            object[ITERATOR$1] = function () {
                return {
                    next: function () {
                        return {
                            done: ITERATION_SUPPORT = true
                        };
                    }
                };
            };

            exec(object);
        } catch (error) {
            /* empty */
        }

        return ITERATION_SUPPORT;
    };

    var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
        Array.from(iterable);
    }); // `Array.from` method
    // https://tc39.es/ecma262/#sec-array.from

    _export({
        target: 'Array',
        stat: true,
        forced: INCORRECT_ITERATION
    }, {
        from: arrayFrom
    });

    var from$4 = path.Array.from;

    var from$3 = from$4;

    var from$2 = from$3;

    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState$4 = internalState.set;
    var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
    // https://tc39.es/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.es/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.es/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.es/ecma262/#sec-createarrayiterator

    defineIterator(Array, 'Array', function (iterated, kind) {
        setInternalState$4(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated),
            // target
            index: 0,
            // next index
            kind: kind // kind

        }); // `%ArrayIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
    }, function () {
        var state = getInternalState$1(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;

        if (!target || index >= target.length) {
            state.target = undefined;
            return {
                value: undefined,
                done: true
            };
        }

        if (kind == 'keys') return {
            value: index,
            done: false
        };
        if (kind == 'values') return {
            value: target[index],
            done: false
        };
        return {
            value: [index, target[index]],
            done: false
        };
    }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.es/ecma262/#sec-createmappedargumentsobject

    iterators.Arguments = iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');

    for (var COLLECTION_NAME in domIterables) {
        var Collection = global$1[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;

        if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        }

        iterators[COLLECTION_NAME] = iterators.Array;
    }

    var getIteratorMethod_1 = getIteratorMethod$1;

    var getIteratorMethod = getIteratorMethod_1;

    var getIterator$1 = function (it) {
        var iteratorMethod = getIteratorMethod$1(it);

        if (typeof iteratorMethod != 'function') {
            throw TypeError(String(it) + ' is not iterable');
        }

        return anObject(iteratorMethod.call(it));
    };

    var getIterator_1 = getIterator$1;

    var getIterator = getIterator_1;

    // https://tc39.es/ecma262/#sec-isarray

    var isArray$5 = Array.isArray || function isArray(arg) {
        return classofRaw(arg) == 'Array';
    };

    var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames

    var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return objectKeysInternal(O, hiddenKeys);
    };

    var objectGetOwnPropertyNames = {
        f: f$2
    };

    var nativeGetOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
    var toString = {}.toString;
    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    var getWindowNames = function (it) {
        try {
            return nativeGetOwnPropertyNames$2(it);
        } catch (error) {
            return windowNames.slice();
        }
    }; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


    var f$1 = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames$2(toIndexedObject(it));
    };

    var objectGetOwnPropertyNamesExternal = {
        f: f$1
    };

    var f = wellKnownSymbol;
    var wellKnownSymbolWrapped = {
        f: f
    };

    var defineProperty$6 = objectDefineProperty.f;

    var defineWellKnownSymbol = function (NAME) {
        var Symbol = path.Symbol || (path.Symbol = {});
        if (!has$1(Symbol, NAME)) defineProperty$6(Symbol, NAME, {
            value: wellKnownSymbolWrapped.f(NAME)
        });
    };

    var SPECIES$3 = wellKnownSymbol('species'); // `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate

    var arraySpeciesCreate = function (originalArray, length) {
        var C;

        if (isArray$5(originalArray)) {
            C = originalArray.constructor; // cross-realm fallback

            if (typeof C == 'function' && (C === Array || isArray$5(C.prototype))) C = undefined;else if (isObject$1(C)) {
                C = C[SPECIES$3];
                if (C === null) C = undefined;
            }
        }

        return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };

    var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation

    var createMethod$3 = function (TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var IS_FILTER_OUT = TYPE == 7;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        return function ($this, callbackfn, that, specificCreate) {
            var O = toObject($this);
            var self = indexedObject(O);
            var boundFunction = functionBindContext(callbackfn, that, 3);
            var length = toLength(self.length);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate;
            var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
            var value, result;

            for (; length > index; index++) if (NO_HOLES || index in self) {
                value = self[index];
                result = boundFunction(value, index, O);

                if (TYPE) {
                    if (IS_MAP) target[index] = result; // map
                    else if (result) switch (TYPE) {
                        case 3:
                            return true;
                        // some

                        case 5:
                            return value;
                        // find

                        case 6:
                            return index;
                        // findIndex

                        case 2:
                            push.call(target, value);
                        // filter
                    } else switch (TYPE) {
                        case 4:
                            return false;
                        // every

                        case 7:
                            push.call(target, value);
                        // filterOut
                    }
                }
            }

            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
    };

    var arrayIteration = {
        // `Array.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        forEach: createMethod$3(0),
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        map: createMethod$3(1),
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        filter: createMethod$3(2),
        // `Array.prototype.some` method
        // https://tc39.es/ecma262/#sec-array.prototype.some
        some: createMethod$3(3),
        // `Array.prototype.every` method
        // https://tc39.es/ecma262/#sec-array.prototype.every
        every: createMethod$3(4),
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        find: createMethod$3(5),
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod$3(6),
        // `Array.prototype.filterOut` method
        // https://github.com/tc39/proposal-array-filtering
        filterOut: createMethod$3(7)
    };

    var $forEach$1 = arrayIteration.forEach;
    var HIDDEN = sharedKey('hidden');
    var SYMBOL = 'Symbol';
    var PROTOTYPE = 'prototype';
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
    var setInternalState$3 = internalState.set;
    var getInternalState = internalState.getterFor(SYMBOL);
    var ObjectPrototype = Object[PROTOTYPE];
    var $Symbol = global$1.Symbol;
    var $stringify$1 = getBuiltIn('JSON', 'stringify');
    var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
    var nativeDefineProperty = objectDefineProperty.f;
    var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
    var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
    var AllSymbols = shared('symbols');
    var ObjectPrototypeSymbols = shared('op-symbols');
    var StringToSymbolRegistry = shared('string-to-symbol-registry');
    var SymbolToStringRegistry = shared('symbol-to-string-registry');
    var WellKnownSymbolsStore = shared('wks');
    var QObject = global$1.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

    var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

    var setSymbolDescriptor = descriptors && fails(function () {
        return objectCreate(nativeDefineProperty({}, 'a', {
            get: function () {
                return nativeDefineProperty(this, 'a', {
                    value: 7
                }).a;
            }
        })).a != 7;
    }) ? function (O, P, Attributes) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype, P);
        if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
        nativeDefineProperty(O, P, Attributes);

        if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
            nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
        }
    } : nativeDefineProperty;

    var wrap$1 = function (tag, description) {
        var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE]);
        setInternalState$3(symbol, {
            type: SYMBOL,
            tag: tag,
            description: description
        });
        if (!descriptors) symbol.description = description;
        return symbol;
    };

    var isSymbol = useSymbolAsUid ? function (it) {
        return typeof it == 'symbol';
    } : function (it) {
        return Object(it) instanceof $Symbol;
    };

    var $defineProperty = function defineProperty(O, P, Attributes) {
        if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
        anObject(O);
        var key = toPrimitive(P, true);
        anObject(Attributes);

        if (has$1(AllSymbols, key)) {
            if (!Attributes.enumerable) {
                if (!has$1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                O[HIDDEN][key] = true;
            } else {
                if (has$1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                Attributes = objectCreate(Attributes, {
                    enumerable: createPropertyDescriptor(0, false)
                });
            }

            return setSymbolDescriptor(O, key, Attributes);
        }

        return nativeDefineProperty(O, key, Attributes);
    };

    var $defineProperties = function defineProperties(O, Properties) {
        anObject(O);
        var properties = toIndexedObject(Properties);
        var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
        $forEach$1(keys, function (key) {
            if (!descriptors || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
        });
        return O;
    };

    var $create = function create(O, Properties) {
        return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
    };

    var $propertyIsEnumerable = function propertyIsEnumerable(V) {
        var P = toPrimitive(V, true);
        var enumerable = nativePropertyIsEnumerable.call(this, P);
        if (this === ObjectPrototype && has$1(AllSymbols, P) && !has$1(ObjectPrototypeSymbols, P)) return false;
        return enumerable || !has$1(this, P) || !has$1(AllSymbols, P) || has$1(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
    };

    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
        var it = toIndexedObject(O);
        var key = toPrimitive(P, true);
        if (it === ObjectPrototype && has$1(AllSymbols, key) && !has$1(ObjectPrototypeSymbols, key)) return;
        var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);

        if (descriptor && has$1(AllSymbols, key) && !(has$1(it, HIDDEN) && it[HIDDEN][key])) {
            descriptor.enumerable = true;
        }

        return descriptor;
    };

    var $getOwnPropertyNames = function getOwnPropertyNames(O) {
        var names = nativeGetOwnPropertyNames$1(toIndexedObject(O));
        var result = [];
        $forEach$1(names, function (key) {
            if (!has$1(AllSymbols, key) && !has$1(hiddenKeys$1, key)) result.push(key);
        });
        return result;
    };

    var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
        var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
        var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
        var result = [];
        $forEach$1(names, function (key) {
            if (has$1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has$1(ObjectPrototype, key))) {
                result.push(AllSymbols[key]);
            }
        });
        return result;
    }; // `Symbol` constructor
    // https://tc39.es/ecma262/#sec-symbol-constructor


    if (!nativeSymbol) {
        $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
            var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
            var tag = uid(description);

            var setter = function (value) {
                if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
                if (has$1(this, HIDDEN) && has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
            };

            if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                configurable: true,
                set: setter
            });
            return wrap$1(tag, description);
        };

        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return getInternalState(this).tag;
        });
        redefine($Symbol, 'withoutSetter', function (description) {
            return wrap$1(uid(description), description);
        });
        objectPropertyIsEnumerable.f = $propertyIsEnumerable;
        objectDefineProperty.f = $defineProperty;
        objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
        objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

        wellKnownSymbolWrapped.f = function (name) {
            return wrap$1(wellKnownSymbol(name), name);
        };

        if (descriptors) {
            // https://github.com/tc39/proposal-Symbol-description
            nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
                configurable: true,
                get: function description() {
                    return getInternalState(this).description;
                }
            });
        }
    }

    _export({
        global: true,
        wrap: true,
        forced: !nativeSymbol,
        sham: !nativeSymbol
    }, {
        Symbol: $Symbol
    });
    $forEach$1(objectKeys(WellKnownSymbolsStore), function (name) {
        defineWellKnownSymbol(name);
    });
    _export({
        target: SYMBOL,
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Symbol.for` method
        // https://tc39.es/ecma262/#sec-symbol.for
        'for': function (key) {
            var string = String(key);
            if (has$1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
            var symbol = $Symbol(string);
            StringToSymbolRegistry[string] = symbol;
            SymbolToStringRegistry[symbol] = string;
            return symbol;
        },
        // `Symbol.keyFor` method
        // https://tc39.es/ecma262/#sec-symbol.keyfor
        keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
            if (has$1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
        },
        useSetter: function () {
            USE_SETTER = true;
        },
        useSimple: function () {
            USE_SETTER = false;
        }
    });
    _export({
        target: 'Object',
        stat: true,
        forced: !nativeSymbol,
        sham: !descriptors
    }, {
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
    });
    _export({
        target: 'Object',
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames,
        // `Object.getOwnPropertySymbols` method
        // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
        getOwnPropertySymbols: $getOwnPropertySymbols
    }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443

    _export({
        target: 'Object',
        stat: true,
        forced: fails(function () {
            objectGetOwnPropertySymbols.f(1);
        })
    }, {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return objectGetOwnPropertySymbols.f(toObject(it));
        }
    }); // `JSON.stringify` method behavior with symbols
    // https://tc39.es/ecma262/#sec-json.stringify

    if ($stringify$1) {
        var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
            var symbol = $Symbol(); // MS Edge converts symbol values to JSON as {}

            return $stringify$1([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
                || $stringify$1({
                    a: symbol
                }) != '{}' // V8 throws on boxed symbols
                || $stringify$1(Object(symbol)) != '{}';
        });
        _export({
            target: 'JSON',
            stat: true,
            forced: FORCED_JSON_STRINGIFY
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            stringify: function stringify(it, replacer, space) {
                var args = [it];
                var index = 1;
                var $replacer;

                while (arguments.length > index) args.push(arguments[index++]);

                $replacer = replacer;
                if (!isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

                if (!isArray$5(replacer)) replacer = function (key, value) {
                    if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                    if (!isSymbol(value)) return value;
                };
                args[1] = replacer;
                return $stringify$1.apply(null, args);
            }
        });
    } // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


    if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
        createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
    } // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag


    setToStringTag($Symbol, SYMBOL);
    hiddenKeys$1[HIDDEN] = true;

    var getOwnPropertySymbols$2 = path.Object.getOwnPropertySymbols;

    var getOwnPropertySymbols$1 = getOwnPropertySymbols$2;

    var getOwnPropertySymbols = getOwnPropertySymbols$1;

    var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var FAILS_ON_PRIMITIVES$3 = fails(function () {
        nativeGetOwnPropertyDescriptor(1);
    });
    var FORCED$6 = !descriptors || FAILS_ON_PRIMITIVES$3; // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

    _export({
        target: 'Object',
        stat: true,
        forced: FORCED$6,
        sham: !descriptors
    }, {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
            return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
        }
    });

    var getOwnPropertyDescriptor_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
            return Object.getOwnPropertyDescriptor(it, key);
        };

        if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;
    });

    var getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor_1;

    var getOwnPropertyDescriptor$2 = getOwnPropertyDescriptor$3;

    var ownKeys$8 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = objectGetOwnPropertyNames.f(anObject(it));
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
    };

    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors

    _export({
        target: 'Object',
        stat: true,
        sham: !descriptors
    }, {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
            var O = toIndexedObject(object);
            var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
            var keys = ownKeys$8(O);
            var result = {};
            var index = 0;
            var key, descriptor;

            while (keys.length > index) {
                descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                if (descriptor !== undefined) createProperty(result, key, descriptor);
            }

            return result;
        }
    });

    var getOwnPropertyDescriptors$2 = path.Object.getOwnPropertyDescriptors;

    var getOwnPropertyDescriptors$1 = getOwnPropertyDescriptors$2;

    var getOwnPropertyDescriptors = getOwnPropertyDescriptors$1;

    // https://tc39.es/ecma262/#sec-object.defineproperties

    _export({
        target: 'Object',
        stat: true,
        forced: !descriptors,
        sham: !descriptors
    }, {
        defineProperties: objectDefineProperties
    });

    var defineProperties_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var defineProperties = module.exports = function defineProperties(T, D) {
            return Object.defineProperties(T, D);
        };

        if (Object.defineProperties.sham) defineProperties.sham = true;
    });

    var defineProperties$1 = defineProperties_1;

    var defineProperties = defineProperties$1;

    // https://tc39.es/ecma262/#sec-object.defineproperty

    _export({
        target: 'Object',
        stat: true,
        forced: !descriptors,
        sham: !descriptors
    }, {
        defineProperty: objectDefineProperty.f
    });

    var defineProperty_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var defineProperty = module.exports = function defineProperty(it, key, desc) {
            return Object.defineProperty(it, key, desc);
        };

        if (Object.defineProperty.sham) defineProperty.sham = true;
    });

    var defineProperty$5 = defineProperty_1;

    var defineProperty$4 = defineProperty$5;

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var defineProperty$3 = defineProperty_1;

    var defineProperty$2 = defineProperty$3;

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;

            defineProperty$2(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            defineProperty$2(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    // https://tc39.es/ecma262/#sec-array.isarray

    _export({
        target: 'Array',
        stat: true
    }, {
        isArray: isArray$5
    });

    var isArray$4 = path.Array.isArray;

    var isArray$3 = isArray$4;

    var isArray$2 = isArray$3;

    function _arrayWithHoles(arr) {
        if (isArray$2(arr)) return arr;
    }

    var SPECIES$2 = wellKnownSymbol('species');

    var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/677
        return engineV8Version >= 51 || !fails(function () {
            var array = [];
            var constructor = array.constructor = {};

            constructor[SPECIES$2] = function () {
                return {
                    foo: 1
                };
            };

            return array[METHOD_NAME](Boolean).foo !== 1;
        });
    };

    var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
    var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/679

    var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
    });
    var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

    var isConcatSpreadable = function (O) {
        if (!isObject$1(O)) return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== undefined ? !!spreadable : isArray$5(O);
    };

    var FORCED$5 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
    // https://tc39.es/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species

    _export({
        target: 'Array',
        proto: true,
        forced: FORCED$5
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        concat: function concat(arg) {
            var O = toObject(this);
            var A = arraySpeciesCreate(O, 0);
            var n = 0;
            var i, k, length, len, E;

            for (i = -1, length = arguments.length; i < length; i++) {
                E = i === -1 ? O : arguments[i];

                if (isConcatSpreadable(E)) {
                    len = toLength(E.length);
                    if (n + len > MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

                    for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
                } else {
                    if (n >= MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                    createProperty(A, n++, E);
                }
            }

            A.length = n;
            return A;
        }
    });

    // https://tc39.es/ecma262/#sec-symbol.asynciterator

    defineWellKnownSymbol('asyncIterator');

    // https://tc39.es/ecma262/#sec-symbol.hasinstance

    defineWellKnownSymbol('hasInstance');

    // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable

    defineWellKnownSymbol('isConcatSpreadable');

    // https://tc39.es/ecma262/#sec-symbol.iterator

    defineWellKnownSymbol('iterator');

    // https://tc39.es/ecma262/#sec-symbol.match

    defineWellKnownSymbol('match');

    // https://tc39.es/ecma262/#sec-symbol.matchall

    defineWellKnownSymbol('matchAll');

    // https://tc39.es/ecma262/#sec-symbol.replace

    defineWellKnownSymbol('replace');

    // https://tc39.es/ecma262/#sec-symbol.search

    defineWellKnownSymbol('search');

    // https://tc39.es/ecma262/#sec-symbol.species

    defineWellKnownSymbol('species');

    // https://tc39.es/ecma262/#sec-symbol.split

    defineWellKnownSymbol('split');

    // https://tc39.es/ecma262/#sec-symbol.toprimitive

    defineWellKnownSymbol('toPrimitive');

    // https://tc39.es/ecma262/#sec-symbol.tostringtag

    defineWellKnownSymbol('toStringTag');

    // https://tc39.es/ecma262/#sec-symbol.unscopables

    defineWellKnownSymbol('unscopables');

    // https://tc39.es/ecma262/#sec-json-@@tostringtag

    setToStringTag(global$1.JSON, 'JSON', true);

    var symbol$4 = path.Symbol;

    // https://github.com/tc39/proposal-using-statement

    defineWellKnownSymbol('asyncDispose');

    // https://github.com/tc39/proposal-using-statement

    defineWellKnownSymbol('dispose');

    // https://github.com/tc39/proposal-observable

    defineWellKnownSymbol('observable');

    // https://github.com/tc39/proposal-pattern-matching

    defineWellKnownSymbol('patternMatch');

    defineWellKnownSymbol('replaceAll');

    var symbol$3 = symbol$4;

    var symbol$2 = symbol$3;

    var ITERATOR = wellKnownSymbol('iterator');

    var isIterable$1 = function (it) {
        var O = Object(it);
        return O[ITERATOR] !== undefined || '@@iterator' in O // eslint-disable-next-line no-prototype-builtins -- safe
            || iterators.hasOwnProperty(classof(O));
    };

    var isIterable_1 = isIterable$1;

    var isIterable = isIterable_1;

    function _iterableToArrayLimit(arr, i) {
        if (typeof symbol$2 === "undefined" || !isIterable(Object(arr))) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
            for (var _i = getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }

        return _arr;
    }

    var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('slice');
    var SPECIES$1 = wellKnownSymbol('species');
    var nativeSlice = [].slice;
    var max$1 = Math.max; // `Array.prototype.slice` method
    // https://tc39.es/ecma262/#sec-array.prototype.slice
    // fallback for not array-like ES3 strings and DOM objects

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$3
    }, {
        slice: function slice(start, end) {
            var O = toIndexedObject(this);
            var length = toLength(O.length);
            var k = toAbsoluteIndex(start, length);
            var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

            var Constructor, result, n;

            if (isArray$5(O)) {
                Constructor = O.constructor; // cross-realm fallback

                if (typeof Constructor == 'function' && (Constructor === Array || isArray$5(Constructor.prototype))) {
                    Constructor = undefined;
                } else if (isObject$1(Constructor)) {
                    Constructor = Constructor[SPECIES$1];
                    if (Constructor === null) Constructor = undefined;
                }

                if (Constructor === Array || Constructor === undefined) {
                    return nativeSlice.call(O, k, fin);
                }
            }

            result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));

            for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

            result.length = n;
            return result;
        }
    });

    var slice$5 = entryVirtual('Array').slice;

    var ArrayPrototype$h = Array.prototype;

    var slice_1 = function (it) {
        var own = it.slice;
        return it === ArrayPrototype$h || it instanceof Array && own === ArrayPrototype$h.slice ? slice$5 : own;
    };

    var slice$4 = slice_1;

    var slice$3 = slice$4;

    var from$1 = from$4;

    var from = from$1;

    function _arrayLikeToArray$9(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
        }

        return arr2;
    }

    function _unsupportedIterableToArray$9(o, minLen) {
        var _context;

        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$9(o, minLen);

        var n = slice$3(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
    }

    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest();
    }

    var iterator$4 = wellKnownSymbolWrapped.f('iterator');

    var iterator$3 = iterator$4;

    var iterator$2 = iterator$3;

    function _typeof(obj) {
        "@babel/helpers - typeof";

        if (typeof symbol$2 === "function" && typeof iterator$2 === "symbol") {
            _typeof = function _typeof(obj) {
                return typeof obj;
            };
        } else {
            _typeof = function _typeof(obj) {
                return obj && typeof symbol$2 === "function" && obj.constructor === symbol$2 && obj !== symbol$2.prototype ? "symbol" : typeof obj;
            };
        }

        return _typeof(obj);
    }

    function _arrayWithoutHoles(arr) {
        if (isArray$2(arr)) return _arrayLikeToArray$9(arr);
    }

    function _iterableToArray(iter) {
        if (typeof symbol$2 !== "undefined" && isIterable(Object(iter))) return from(iter);
    }

    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableSpread();
    }

    var symbol$1 = symbol$4;

    var symbol = symbol$1;

    var concat$2 = entryVirtual('Array').concat;

    var ArrayPrototype$g = Array.prototype;

    var concat_1 = function (it) {
        var own = it.concat;
        return it === ArrayPrototype$g || it instanceof Array && own === ArrayPrototype$g.concat ? concat$2 : own;
    };

    var concat$1 = concat_1;

    var concat = concat$1;

    var slice$2 = slice_1;

    var slice$1 = slice$2;

    // https://tc39.es/ecma262/#sec-reflect.ownkeys

    _export({
        target: 'Reflect',
        stat: true
    }, {
        ownKeys: ownKeys$8
    });

    var ownKeys$7 = path.Reflect.ownKeys;

    var ownKeys$6 = ownKeys$7;

    var ownKeys$5 = ownKeys$6;

    var isArray$1 = isArray$4;

    var isArray = isArray$1;

    var $map = arrayIteration.map;
    var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$2
    }, {
        map: function map(callbackfn
                          /* , thisArg */
        ) {
            return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var map$5 = entryVirtual('Array').map;

    var ArrayPrototype$f = Array.prototype;

    var map_1 = function (it) {
        var own = it.map;
        return it === ArrayPrototype$f || it instanceof Array && own === ArrayPrototype$f.map ? map$5 : own;
    };

    var map$4 = map_1;

    var map$3 = map$4;

    var FAILS_ON_PRIMITIVES$2 = fails(function () {
        objectKeys(1);
    }); // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$2
    }, {
        keys: function keys(it) {
            return objectKeys(toObject(it));
        }
    });

    var keys$5 = path.Object.keys;

    var keys$4 = keys$5;

    var keys$3 = keys$4;

    // https://tc39.es/ecma262/#sec-date.now

    _export({
        target: 'Date',
        stat: true
    }, {
        now: function now() {
            return new Date().getTime();
        }
    });

    var now$3 = path.Date.now;

    var now$2 = now$3;

    var now$1 = now$2;

    var arrayMethodIsStrict = function (METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !!method && fails(function () {
            // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
            method.call(null, argument || function () {
                throw 1;
            }, 1);
        });
    };

    var $forEach = arrayIteration.forEach;
    var STRICT_METHOD$5 = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
    // https://tc39.es/ecma262/#sec-array.prototype.foreach

    var arrayForEach = !STRICT_METHOD$5 ? function forEach(callbackfn
                                                           /* , thisArg */
    ) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    } : [].forEach;

    // https://tc39.es/ecma262/#sec-array.prototype.foreach


    _export({
        target: 'Array',
        proto: true,
        forced: [].forEach != arrayForEach
    }, {
        forEach: arrayForEach
    });

    var forEach$4 = entryVirtual('Array').forEach;

    var forEach$3 = forEach$4;

    var ArrayPrototype$e = Array.prototype;
    var DOMIterables$3 = {
        DOMTokenList: true,
        NodeList: true
    };

    var forEach_1 = function (it) {
        var own = it.forEach;
        return it === ArrayPrototype$e || it instanceof Array && own === ArrayPrototype$e.forEach // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$3.hasOwnProperty(classof(it)) ? forEach$3 : own;
    };

    var forEach$2 = forEach_1;

    var nativeReverse = [].reverse;
    var test$1 = [1, 2]; // `Array.prototype.reverse` method
    // https://tc39.es/ecma262/#sec-array.prototype.reverse
    // fix for Safari 12.0 bug
    // https://bugs.webkit.org/show_bug.cgi?id=188794

    _export({
        target: 'Array',
        proto: true,
        forced: String(test$1) === String(test$1.reverse())
    }, {
        reverse: function reverse() {
            // eslint-disable-next-line no-self-assign -- dirty hack
            if (isArray$5(this)) this.length = this.length;
            return nativeReverse.call(this);
        }
    });

    var reverse$2 = entryVirtual('Array').reverse;

    var ArrayPrototype$d = Array.prototype;

    var reverse_1 = function (it) {
        var own = it.reverse;
        return it === ArrayPrototype$d || it instanceof Array && own === ArrayPrototype$d.reverse ? reverse$2 : own;
    };

    var reverse$1 = reverse_1;

    var reverse = reverse$1;

    var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('splice');
    var max = Math.max;
    var min = Math.min;
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded'; // `Array.prototype.splice` method
    // https://tc39.es/ecma262/#sec-array.prototype.splice
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$1
    }, {
        splice: function splice(start, deleteCount
                                /* , ...items */
        ) {
            var O = toObject(this);
            var len = toLength(O.length);
            var actualStart = toAbsoluteIndex(start, len);
            var argumentsLength = arguments.length;
            var insertCount, actualDeleteCount, A, k, from, to;

            if (argumentsLength === 0) {
                insertCount = actualDeleteCount = 0;
            } else if (argumentsLength === 1) {
                insertCount = 0;
                actualDeleteCount = len - actualStart;
            } else {
                insertCount = argumentsLength - 2;
                actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
            }

            if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
                throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
            }

            A = arraySpeciesCreate(O, actualDeleteCount);

            for (k = 0; k < actualDeleteCount; k++) {
                from = actualStart + k;
                if (from in O) createProperty(A, k, O[from]);
            }

            A.length = actualDeleteCount;

            if (insertCount < actualDeleteCount) {
                for (k = actualStart; k < len - actualDeleteCount; k++) {
                    from = k + actualDeleteCount;
                    to = k + insertCount;
                    if (from in O) O[to] = O[from];else delete O[to];
                }

                for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
            } else if (insertCount > actualDeleteCount) {
                for (k = len - actualDeleteCount; k > actualStart; k--) {
                    from = k + actualDeleteCount - 1;
                    to = k + insertCount - 1;
                    if (from in O) O[to] = O[from];else delete O[to];
                }
            }

            for (k = 0; k < insertCount; k++) {
                O[k + actualStart] = arguments[k + 2];
            }

            O.length = len - actualDeleteCount + insertCount;
            return A;
        }
    });

    var splice$2 = entryVirtual('Array').splice;

    var ArrayPrototype$c = Array.prototype;

    var splice_1 = function (it) {
        var own = it.splice;
        return it === ArrayPrototype$c || it instanceof Array && own === ArrayPrototype$c.splice ? splice$2 : own;
    };

    var splice$1 = splice_1;

    var splice = splice$1;

    var $includes = arrayIncludes.includes; // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes

    _export({
        target: 'Array',
        proto: true
    }, {
        includes: function includes(el
                                    /* , fromIndex = 0 */
        ) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
    }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    var includes$4 = entryVirtual('Array').includes;

    var MATCH$1 = wellKnownSymbol('match'); // `IsRegExp` abstract operation
    // https://tc39.es/ecma262/#sec-isregexp

    var isRegexp = function (it) {
        var isRegExp;
        return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
    };

    var notARegexp = function (it) {
        if (isRegexp(it)) {
            throw TypeError("The method doesn't accept regular expressions");
        }

        return it;
    };

    var MATCH = wellKnownSymbol('match');

    var correctIsRegexpLogic = function (METHOD_NAME) {
        var regexp = /./;

        try {
            '/./'[METHOD_NAME](regexp);
        } catch (error1) {
            try {
                regexp[MATCH] = false;
                return '/./'[METHOD_NAME](regexp);
            } catch (error2) {
                /* empty */
            }
        }

        return false;
    };

    // https://tc39.es/ecma262/#sec-string.prototype.includes


    _export({
        target: 'String',
        proto: true,
        forced: !correctIsRegexpLogic('includes')
    }, {
        includes: function includes(searchString
                                    /* , position = 0 */
        ) {
            return !!~String(requireObjectCoercible(this)).indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var includes$3 = entryVirtual('String').includes;

    var ArrayPrototype$b = Array.prototype;
    var StringPrototype = String.prototype;

    var includes$2 = function (it) {
        var own = it.includes;
        if (it === ArrayPrototype$b || it instanceof Array && own === ArrayPrototype$b.includes) return includes$4;

        if (typeof it === 'string' || it === StringPrototype || it instanceof String && own === StringPrototype.includes) {
            return includes$3;
        }

        return own;
    };

    var includes$1 = includes$2;

    var includes = includes$1;

    var FAILS_ON_PRIMITIVES$1 = fails(function () {
        objectGetPrototypeOf(1);
    }); // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$1,
        sham: !correctPrototypeGetter
    }, {
        getPrototypeOf: function getPrototypeOf(it) {
            return objectGetPrototypeOf(toObject(it));
        }
    });

    var getPrototypeOf$4 = path.Object.getPrototypeOf;

    var getPrototypeOf$3 = getPrototypeOf$4;

    var getPrototypeOf$2 = getPrototypeOf$3;

    var $filter = arrayIteration.filter;
    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT
    }, {
        filter: function filter(callbackfn
                                /* , thisArg */
        ) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var filter$2 = entryVirtual('Array').filter;

    var ArrayPrototype$a = Array.prototype;

    var filter_1 = function (it) {
        var own = it.filter;
        return it === ArrayPrototype$a || it instanceof Array && own === ArrayPrototype$a.filter ? filter$2 : own;
    };

    var filter$1 = filter_1;

    var filter = filter$1;

    var propertyIsEnumerable = objectPropertyIsEnumerable.f; // `Object.{ entries, values }` methods implementation

    var createMethod$2 = function (TO_ENTRIES) {
        return function (it) {
            var O = toIndexedObject(it);
            var keys = objectKeys(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;

            while (length > i) {
                key = keys[i++];

                if (!descriptors || propertyIsEnumerable.call(O, key)) {
                    result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
                }
            }

            return result;
        };
    };

    var objectToArray = {
        // `Object.entries` method
        // https://tc39.es/ecma262/#sec-object.entries
        entries: createMethod$2(true),
        // `Object.values` method
        // https://tc39.es/ecma262/#sec-object.values
        values: createMethod$2(false)
    };

    var $values = objectToArray.values; // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values

    _export({
        target: 'Object',
        stat: true
    }, {
        values: function values(O) {
            return $values(O);
        }
    });

    path.Object.values;

    // a string of all valid unicode whitespaces
    var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

    var whitespace = '[' + whitespaces + ']';
    var ltrim = RegExp('^' + whitespace + whitespace + '*');
    var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

    var createMethod$1 = function (TYPE) {
        return function ($this) {
            var string = String(requireObjectCoercible($this));
            if (TYPE & 1) string = string.replace(ltrim, '');
            if (TYPE & 2) string = string.replace(rtrim, '');
            return string;
        };
    };

    var stringTrim = {
        // `String.prototype.{ trimLeft, trimStart }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimstart
        start: createMethod$1(1),
        // `String.prototype.{ trimRight, trimEnd }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimend
        end: createMethod$1(2),
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        trim: createMethod$1(3)
    };

    var trim$1 = stringTrim.trim;
    var $parseInt = global$1.parseInt;
    var hex = /^[+-]?0[Xx]/;
    var FORCED$4 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22; // `parseInt` method
    // https://tc39.es/ecma262/#sec-parseint-string-radix

    var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
        var S = trim$1(String(string));
        return $parseInt(S, radix >>> 0 || (hex.test(S) ? 16 : 10));
    } : $parseInt;

    // https://tc39.es/ecma262/#sec-parseint-string-radix

    _export({
        global: true,
        forced: parseInt != numberParseInt
    }, {
        parseInt: numberParseInt
    });

    var _parseInt$2 = path.parseInt;

    var _parseInt$1 = _parseInt$2;

    var _parseInt = _parseInt$1;

    var $indexOf = arrayIncludes.indexOf;
    var nativeIndexOf = [].indexOf;
    var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
    var STRICT_METHOD$4 = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof

    _export({
        target: 'Array',
        proto: true,
        forced: NEGATIVE_ZERO || !STRICT_METHOD$4
    }, {
        indexOf: function indexOf(searchElement
                                  /* , fromIndex = 0 */
        ) {
            return NEGATIVE_ZERO // convert -0 to +0
                ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var indexOf$2 = entryVirtual('Array').indexOf;

    var ArrayPrototype$9 = Array.prototype;

    var indexOf_1 = function (it) {
        var own = it.indexOf;
        return it === ArrayPrototype$9 || it instanceof Array && own === ArrayPrototype$9.indexOf ? indexOf$2 : own;
    };

    var indexOf$1 = indexOf_1;

    var indexOf = indexOf$1;

    var non = '\u200B\u0085\u180E'; // check that a method works with the correct list
    // of whitespaces and has a correct name

    var stringTrimForced = function (METHOD_NAME) {
        return fails(function () {
            return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
        });
    };

    var $trim = stringTrim.trim; // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim

    _export({
        target: 'String',
        proto: true,
        forced: stringTrimForced('trim')
    }, {
        trim: function trim() {
            return $trim(this);
        }
    });

    entryVirtual('String').trim;

    // https://tc39.es/ecma262/#sec-object.create

    _export({
        target: 'Object',
        stat: true,
        sham: !descriptors
    }, {
        create: objectCreate
    });

    var Object$2 = path.Object;

    var create$4 = function create(P, D) {
        return Object$2.create(P, D);
    };

    var create$3 = create$4;

    var create$2 = create$3;

    var $stringify = getBuiltIn('JSON', 'stringify');
    var re = /[\uD800-\uDFFF]/g;
    var low = /^[\uD800-\uDBFF]$/;
    var hi = /^[\uDC00-\uDFFF]$/;

    var fix = function (match, offset, string) {
        var prev = string.charAt(offset - 1);
        var next = string.charAt(offset + 1);

        if (low.test(match) && !hi.test(next) || hi.test(match) && !low.test(prev)) {
            return '\\u' + match.charCodeAt(0).toString(16);
        }

        return match;
    };

    var FORCED$3 = fails(function () {
        return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
    });

    if ($stringify) {
        // `JSON.stringify` method
        // https://tc39.es/ecma262/#sec-json.stringify
        // https://github.com/tc39/proposal-well-formed-stringify
        _export({
            target: 'JSON',
            stat: true,
            forced: FORCED$3
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            stringify: function stringify(it, replacer, space) {
                var result = $stringify.apply(null, arguments);
                return typeof result == 'string' ? result.replace(re, fix) : result;
            }
        });
    }

    if (!path.JSON) path.JSON = {
        stringify: JSON.stringify
    }; // eslint-disable-next-line no-unused-vars -- required for `.length`

    var stringify$3 = function stringify(it, replacer, space) {
        return path.JSON.stringify.apply(null, arguments);
    };

    var stringify$2 = stringify$3;

    var stringify$1 = stringify$2;

    var slice = [].slice;
    var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

    var wrap = function (scheduler) {
        return function (handler, timeout
                         /* , ...arguments */
        ) {
            var boundArgs = arguments.length > 2;
            var args = boundArgs ? slice.call(arguments, 2) : undefined;
            return scheduler(boundArgs ? function () {
                // eslint-disable-next-line no-new-func -- spec requirement
                (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
            } : handler, timeout);
        };
    }; // ie9- setTimeout & setInterval additional parameters fix
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers


    _export({
        global: true,
        bind: true,
        forced: MSIE
    }, {
        // `setTimeout` method
        // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
        setTimeout: wrap(global$1.setTimeout),
        // `setInterval` method
        // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
        setInterval: wrap(global$1.setInterval)
    });

    var setTimeout$2 = path.setTimeout;

    var setTimeout$1 = setTimeout$2;

    // https://tc39.es/ecma262/#sec-array.prototype.fill


    var arrayFill = function fill(value
                                  /* , start = 0, end = @length */
    ) {
        var O = toObject(this);
        var length = toLength(O.length);
        var argumentsLength = arguments.length;
        var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
        var end = argumentsLength > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

        while (endPos > index) O[index++] = value;

        return O;
    };

    // https://tc39.es/ecma262/#sec-array.prototype.fill

    _export({
        target: 'Array',
        proto: true
    }, {
        fill: arrayFill
    }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    var fill$2 = entryVirtual('Array').fill;

    var ArrayPrototype$8 = Array.prototype;

    var fill_1 = function (it) {
        var own = it.fill;
        return it === ArrayPrototype$8 || it instanceof Array && own === ArrayPrototype$8.fill ? fill$2 : own;
    };

    var fill$1 = fill_1;

    var fill = fill$1;

    /*! Hammer.JS - v2.0.17-rc - 2019-12-16
	 * http://naver.github.io/egjs
	 *
	 * Forked By Naver egjs
	 * Copyright (c) hammerjs
	 * Licensed under the MIT license */
    function _extends() {
        _extends = Object.assign || function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }

            return target;
        };

        return _extends.apply(this, arguments);
    }

    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }

    function _assertThisInitialized$1(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
    }
    /**
     * @private
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} target
     * @param {...Object} objects_to_assign
     * @returns {Object} target
     */


    var assign;

    if (typeof Object.assign !== 'function') {
        assign = function assign(target) {
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var output = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];

                if (source !== undefined && source !== null) {
                    for (var nextKey in source) {
                        if (source.hasOwnProperty(nextKey)) {
                            output[nextKey] = source[nextKey];
                        }
                    }
                }
            }

            return output;
        };
    } else {
        assign = Object.assign;
    }

    var assign$1 = assign;
    var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
    var TEST_ELEMENT = typeof document === "undefined" ? {
        style: {}
    } : document.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round,
        abs$1 = Math.abs;
    var now = Date.now;
    /**
     * @private
     * get the prefixed property
     * @param {Object} obj
     * @param {String} property
     * @returns {String|Undefined} prefixed
     */

    function prefixed(obj, property) {
        var prefix;
        var prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;

        while (i < VENDOR_PREFIXES.length) {
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;

            if (prop in obj) {
                return prop;
            }

            i++;
        }

        return undefined;
    }
    /* eslint-disable no-new-func, no-nested-ternary */


    var win;

    if (typeof window === "undefined") {
        // window is undefined in node.js
        win = {};
    } else {
        win = window;
    }

    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) {
            return false;
        }

        var touchMap = {};
        var cssSupports = win.CSS && win.CSS.supports;
        ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            return touchMap[val] = cssSupports ? win.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }

    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented

    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = ('ontouchstart' in win);
    var SUPPORT_POINTER_EVENTS = prefixed(win, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ['x', 'y'];
    var PROPS_CLIENT_XY = ['clientX', 'clientY'];
    /**
     * @private
     * walk objects and arrays
     * @param {Object} obj
     * @param {Function} iterator
     * @param {Object} context
     */

    function each(obj, iterator, context) {
        var i;

        if (!obj) {
            return;
        }

        if (obj.forEach) {
            obj.forEach(iterator, context);
        } else if (obj.length !== undefined) {
            i = 0;

            while (i < obj.length) {
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else {
            for (i in obj) {
                obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
            }
        }
    }
    /**
     * @private
     * let a boolean value also be a function that must return a boolean
     * this first item in args will be used as the context
     * @param {Boolean|Function} val
     * @param {Array} [args]
     * @returns {Boolean}
     */


    function boolOrFn(val, args) {
        if (typeof val === TYPE_FUNCTION) {
            return val.apply(args ? args[0] || undefined : undefined, args);
        }

        return val;
    }
    /**
     * @private
     * small indexOf wrapper
     * @param {String} str
     * @param {String} find
     * @returns {Boolean} found
     */


    function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
     * @private
     * when the touchActions are collected they are not a valid value, so we need to clean things up. *
     * @param {String} actions
     * @returns {*}
     */


    function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) {
            return TOUCH_ACTION_NONE;
        }

        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning

        if (hasPanX && hasPanY) {
            return TOUCH_ACTION_NONE;
        } // pan-x OR pan-y


        if (hasPanX || hasPanY) {
            return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        } // manipulation


        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
            return TOUCH_ACTION_MANIPULATION;
        }

        return TOUCH_ACTION_AUTO;
    }
    /**
     * @private
     * Touch Action
     * sets the touchAction property or uses the js alternative
     * @param {Manager} manager
     * @param {String} value
     * @constructor
     */


    var TouchAction = /*#__PURE__*/function () {
        function TouchAction(manager, value) {
            this.manager = manager;
            this.set(value);
        }
        /**
         * @private
         * set the touchAction value on the element or enable the polyfill
         * @param {String} value
         */


        var _proto = TouchAction.prototype;

        _proto.set = function set(value) {
            // find out the touch-action by the event handlers
            if (value === TOUCH_ACTION_COMPUTE) {
                value = this.compute();
            }

            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
                this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            }

            this.actions = value.toLowerCase().trim();
        };
        /**
         * @private
         * just re-set the touchAction value
         */


        _proto.update = function update() {
            this.set(this.manager.options.touchAction);
        };
        /**
         * @private
         * compute the value for the touchAction property based on the recognizer's settings
         * @returns {String} value
         */


        _proto.compute = function compute() {
            var actions = [];
            each(this.manager.recognizers, function (recognizer) {
                if (boolOrFn(recognizer.options.enable, [recognizer])) {
                    actions = actions.concat(recognizer.getTouchAction());
                }
            });
            return cleanTouchActions(actions.join(' '));
        };
        /**
         * @private
         * this method is called on each input cycle and provides the preventing of the browser behavior
         * @param {Object} input
         */


        _proto.preventDefaults = function preventDefaults(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection; // if the touch action did prevented once this session

            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }

            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

            if (hasNone) {
                // do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;

                if (isTapPointer && isTapMovement && isTapTouchTime) {
                    return;
                }
            }

            if (hasPanX && hasPanY) {
                // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
                return;
            }

            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
                return this.preventSrc(srcEvent);
            }
        };
        /**
         * @private
         * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
         * @param {Object} srcEvent
         */


        _proto.preventSrc = function preventSrc(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        };

        return TouchAction;
    }();
    /**
     * @private
     * find if a node is in the given parent
     * @method hasParent
     * @param {HTMLElement} node
     * @param {HTMLElement} parent
     * @return {Boolean} found
     */


    function hasParent(node, parent) {
        while (node) {
            if (node === parent) {
                return true;
            }

            node = node.parentNode;
        }

        return false;
    }
    /**
     * @private
     * get the center of all the pointers
     * @param {Array} pointers
     * @return {Object} center contains `x` and `y` properties
     */


    function getCenter(pointers) {
        var pointersLength = pointers.length; // no need to loop when only one touch

        if (pointersLength === 1) {
            return {
                x: round(pointers[0].clientX),
                y: round(pointers[0].clientY)
            };
        }

        var x = 0;
        var y = 0;
        var i = 0;

        while (i < pointersLength) {
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }

        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
     * @private
     * create a simple clone from the input used for storage of firstInput and firstMultiple
     * @param {Object} input
     * @returns {Object} clonedInputData
     */


    function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;

        while (i < input.pointers.length) {
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }

        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
     * @private
     * calculate the absolute distance between two points
     * @param {Object} p1 {x, y}
     * @param {Object} p2 {x, y}
     * @param {Array} [props] containing x and y keys
     * @return {Number} distance
     */


    function getDistance(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }

        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
     * @private
     * calculate the angle between two coordinates
     * @param {Object} p1
     * @param {Object} p2
     * @param {Array} [props] containing x and y keys
     * @return {Number} angle
     */


    function getAngle(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }

        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
     * @private
     * get the direction between two points
     * @param {Number} x
     * @param {Number} y
     * @return {Number} direction
     */


    function getDirection(x, y) {
        if (x === y) {
            return DIRECTION_NONE;
        }

        if (abs$1(x) >= abs$1(y)) {
            return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        }

        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }

    function computeDeltaXY(session, input) {
        var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
        // jscs throwing error on defalut destructured values and without defaults tests fail

        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};

        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }

        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
     * @private
     * calculate the velocity between two points. unit is in px per ms.
     * @param {Number} deltaTime
     * @param {Number} x
     * @param {Number} y
     * @return {Object} velocity `x` and `y`
     */


    function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
     * @private
     * calculate the scale factor between two pointersets
     * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} scale
     */


    function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    /**
     * @private
     * calculate the rotation degrees between two pointersets
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} rotation
     */


    function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
     * @private
     * velocity is calculated every x ms
     * @param {Object} session
     * @param {Object} input
     */


    function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input;
        var deltaTime = input.timeStamp - last.timeStamp;
        var velocity;
        var velocityX;
        var velocityY;
        var direction;

        if (input.eventType !== INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs$1(v.x) > abs$1(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }

        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
     * @private
     * extend the data with some usable properties like scale, rotate, velocity etc
     * @param {Object} manager
     * @param {Object} input
     */


    function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length; // store the first input to calculate the distance and direction

        if (!session.firstInput) {
            session.firstInput = simpleCloneInputData(input);
        } // to compute scale and rotation we need to store the multiple touches


        if (pointersLength > 1 && !session.firstMultiple) {
            session.firstMultiple = simpleCloneInputData(input);
        } else if (pointersLength === 1) {
            session.firstMultiple = false;
        }

        var firstInput = session.firstInput,
            firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs$1(overallVelocity.x) > abs$1(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input); // find the correct target

        var target = manager.element;
        var srcEvent = input.srcEvent;
        var srcEventTarget;

        if (srcEvent.composedPath) {
            srcEventTarget = srcEvent.composedPath()[0];
        } else if (srcEvent.path) {
            srcEventTarget = srcEvent.path[0];
        } else {
            srcEventTarget = srcEvent.target;
        }

        if (hasParent(srcEventTarget, target)) {
            target = srcEventTarget;
        }

        input.target = target;
    }
    /**
     * @private
     * handle input events
     * @param {Manager} manager
     * @param {String} eventType
     * @param {Object} input
     */


    function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;

        if (isFirst) {
            manager.session = {};
        } // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'


        input.eventType = eventType; // compute scale, rotation etc

        computeInputData(manager, input); // emit secret event

        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
     * @private
     * split string on whitespace
     * @param {String} str
     * @returns {Array} words
     */


    function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
     * @private
     * addEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function addEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
     * @private
     * removeEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function removeEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
     * @private
     * get the window object of an element
     * @param {HTMLElement} element
     * @returns {DocumentView|Window}
     */


    function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window;
    }
    /**
     * @private
     * create new input type manager
     * @param {Manager} manager
     * @param {Function} callback
     * @returns {Input}
     * @constructor
     */


    var Input = /*#__PURE__*/function () {
        function Input(manager, callback) {
            var self = this;
            this.manager = manager;
            this.callback = callback;
            this.element = manager.element;
            this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
            // so when disabled the input events are completely bypassed.

            this.domHandler = function (ev) {
                if (boolOrFn(manager.options.enable, [manager])) {
                    self.handler(ev);
                }
            };

            this.init();
        }
        /**
         * @private
         * should handle the inputEvent data and trigger the callback
         * @virtual
         */


        var _proto = Input.prototype;

        _proto.handler = function handler() {};
        /**
         * @private
         * bind the events
         */


        _proto.init = function init() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };
        /**
         * @private
         * unbind the events
         */


        _proto.destroy = function destroy() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };

        return Input;
    }();
    /**
     * @private
     * find if a array contains the object using indexOf or a simple polyFill
     * @param {Array} src
     * @param {String} find
     * @param {String} [findByKey]
     * @return {Boolean|Number} false when not found, or the index
     */


    function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) {
            return src.indexOf(find);
        } else {
            var i = 0;

            while (i < src.length) {
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) {
                    // do not use === here, test fails
                    return i;
                }

                i++;
            }

            return -1;
        }
    }

    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    }; // in IE10 the pointer types is defined as an enum

    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816

    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive

    if (win.MSPointerEvent && !win.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
     * @private
     * Pointer events input
     * @constructor
     * @extends Input
     */


    var PointerEventInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(PointerEventInput, _Input);

        function PointerEventInput() {
            var _this;

            var proto = PointerEventInput.prototype;
            proto.evEl = POINTER_ELEMENT_EVENTS;
            proto.evWin = POINTER_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.store = _this.manager.session.pointerEvents = [];
            return _this;
        }
        /**
         * @private
         * handle mouse events
         * @param {Object} ev
         */


        var _proto = PointerEventInput.prototype;

        _proto.handler = function handler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType === INPUT_TYPE_TOUCH; // get index of the event in the store

            var storeIndex = inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down

            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                removePointer = true;
            } // it not found, so the pointer hasn't been down (so it's probably a hover)


            if (storeIndex < 0) {
                return;
            } // update the event in the store


            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [ev],
                pointerType: pointerType,
                srcEvent: ev
            });

            if (removePointer) {
                // remove from the store
                store.splice(storeIndex, 1);
            }
        };

        return PointerEventInput;
    }(Input);
    /**
     * @private
     * convert array-like objects to real arrays
     * @param {Object} obj
     * @returns {Array}
     */


    function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
     * @private
     * unique array with objects based on a key (like 'id') or just by the array's value
     * @param {Array} src [{id:1},{id:2},{id:1}]
     * @param {String} [key]
     * @param {Boolean} [sort=False]
     * @returns {Array} [{id:1},{id:2}]
     */


    function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;

        while (i < src.length) {
            var val = key ? src[i][key] : src[i];

            if (inArray(values, val) < 0) {
                results.push(src[i]);
            }

            values[i] = val;
            i++;
        }

        if (sort) {
            if (!key) {
                results = results.sort();
            } else {
                results = results.sort(function (a, b) {
                    return a[key] > b[key];
                });
            }
        }

        return results;
    }

    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * @private
     * Multi-user touch events input
     * @constructor
     * @extends Input
     */

    var TouchInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(TouchInput, _Input);

        function TouchInput() {
            var _this;

            TouchInput.prototype.evTarget = TOUCH_TARGET_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;

            return _this;
        }

        var _proto = TouchInput.prototype;

        _proto.handler = function handler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);

            if (!touches) {
                return;
            }

            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };

        return TouchInput;
    }(Input);

    function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds; // when there is only one touch, the process can be simplified

        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [allTouches, allTouches];
        }

        var i;
        var targetTouches;
        var changedTouches = toArray(ev.changedTouches);
        var changedTargetTouches = [];
        var target = this.target; // get target touches from touches

        targetTouches = allTouches.filter(function (touch) {
            return hasParent(touch.target, target);
        }); // collect touches

        if (type === INPUT_START) {
            i = 0;

            while (i < targetTouches.length) {
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        } // filter changed touches to only contain touches that exist in the collected target ids


        i = 0;

        while (i < changedTouches.length) {
            if (targetIds[changedTouches[i].identifier]) {
                changedTargetTouches.push(changedTouches[i]);
            } // cleanup removed touches


            if (type & (INPUT_END | INPUT_CANCEL)) {
                delete targetIds[changedTouches[i].identifier];
            }

            i++;
        }

        if (!changedTargetTouches.length) {
            return;
        }

        return [// merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true), changedTargetTouches];
    }

    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
     * @private
     * Mouse events input
     * @constructor
     * @extends Input
     */

    var MouseInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(MouseInput, _Input);

        function MouseInput() {
            var _this;

            var proto = MouseInput.prototype;
            proto.evEl = MOUSE_ELEMENT_EVENTS;
            proto.evWin = MOUSE_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.pressed = false; // mousedown state

            return _this;
        }
        /**
         * @private
         * handle mouse events
         * @param {Object} ev
         */


        var _proto = MouseInput.prototype;

        _proto.handler = function handler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down

            if (eventType & INPUT_START && ev.button === 0) {
                this.pressed = true;
            }

            if (eventType & INPUT_MOVE && ev.which !== 1) {
                eventType = INPUT_END;
            } // mouse must be down


            if (!this.pressed) {
                return;
            }

            if (eventType & INPUT_END) {
                this.pressed = false;
            }

            this.callback(this.manager, eventType, {
                pointers: [ev],
                changedPointers: [ev],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        };

        return MouseInput;
    }(Input);
    /**
     * @private
     * Combined touch and mouse input
     *
     * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
     * This because touch devices also emit mouse events while doing a touch.
     *
     * @constructor
     * @extends Input
     */


    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;

    function setLastTouch(eventData) {
        var _eventData$changedPoi = eventData.changedPointers,
            touch = _eventData$changedPoi[0];

        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            var lts = this.lastTouches;
            this.lastTouches.push(lastTouch);

            var removeLastTouch = function removeLastTouch() {
                var i = lts.indexOf(lastTouch);

                if (i > -1) {
                    lts.splice(i, 1);
                }
            };

            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }

    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            setLastTouch.call(this, eventData);
        }
    }

    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX;
        var y = eventData.srcEvent.clientY;

        for (var i = 0; i < this.lastTouches.length; i++) {
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x);
            var dy = Math.abs(y - t.y);

            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
                return true;
            }
        }

        return false;
    }

    var TouchMouseInput = /*#__PURE__*/function () {
        var TouchMouseInput = /*#__PURE__*/function (_Input) {
            _inheritsLoose(TouchMouseInput, _Input);

            function TouchMouseInput(_manager, callback) {
                var _this;

                _this = _Input.call(this, _manager, callback) || this;

                _this.handler = function (manager, inputEvent, inputData) {
                    var isTouch = inputData.pointerType === INPUT_TYPE_TOUCH;
                    var isMouse = inputData.pointerType === INPUT_TYPE_MOUSE;

                    if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
                        return;
                    } // when we're in a touch event, record touches to  de-dupe synthetic mouse event


                    if (isTouch) {
                        recordTouches.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputEvent, inputData);
                    } else if (isMouse && isSyntheticEvent.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputData)) {
                        return;
                    }

                    _this.callback(manager, inputEvent, inputData);
                };

                _this.touch = new TouchInput(_this.manager, _this.handler);
                _this.mouse = new MouseInput(_this.manager, _this.handler);
                _this.primaryTouch = null;
                _this.lastTouches = [];
                return _this;
            }
            /**
             * @private
             * handle mouse and touch events
             * @param {Hammer} manager
             * @param {String} inputEvent
             * @param {Object} inputData
             */


            var _proto = TouchMouseInput.prototype;
            /**
             * @private
             * remove the event listeners
             */

            _proto.destroy = function destroy() {
                this.touch.destroy();
                this.mouse.destroy();
            };

            return TouchMouseInput;
        }(Input);

        return TouchMouseInput;
    }();
    /**
     * @private
     * create new input type manager
     * called by the Manager constructor
     * @param {Hammer} manager
     * @returns {Input}
     */


    function createInputInstance(manager) {
        var Type; // let inputClass = manager.options.inputClass;

        var inputClass = manager.options.inputClass;

        if (inputClass) {
            Type = inputClass;
        } else if (SUPPORT_POINTER_EVENTS) {
            Type = PointerEventInput;
        } else if (SUPPORT_ONLY_TOUCH) {
            Type = TouchInput;
        } else if (!SUPPORT_TOUCH) {
            Type = MouseInput;
        } else {
            Type = TouchMouseInput;
        }

        return new Type(manager, inputHandler);
    }
    /**
     * @private
     * if the argument is an array, we want to execute the fn on each entry
     * if it aint an array we don't want to do a thing.
     * this is used by all the methods that accept a single and array argument.
     * @param {*|Array} arg
     * @param {String} fn
     * @param {Object} [context]
     * @returns {Boolean}
     */


    function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }

        return false;
    }

    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
     * @private
     * get a unique id
     * @returns {number} uniqueId
     */

    var _uniqueId = 1;

    function uniqueId() {
        return _uniqueId++;
    }
    /**
     * @private
     * get a recognizer by name if it is bound to a manager
     * @param {Recognizer|String} otherRecognizer
     * @param {Recognizer} recognizer
     * @returns {Recognizer}
     */


    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;

        if (manager) {
            return manager.get(otherRecognizer);
        }

        return otherRecognizer;
    }
    /**
     * @private
     * get a usable string, used as event postfix
     * @param {constant} state
     * @returns {String} state
     */


    function stateStr(state) {
        if (state & STATE_CANCELLED) {
            return 'cancel';
        } else if (state & STATE_ENDED) {
            return 'end';
        } else if (state & STATE_CHANGED) {
            return 'move';
        } else if (state & STATE_BEGAN) {
            return 'start';
        }

        return '';
    }
    /**
     * @private
     * Recognizer flow explained; *
     * All recognizers have the initial state of POSSIBLE when a input session starts.
     * The definition of a input session is from the first input until the last input, with all it's movement in it. *
     * Example session for mouse-input: mousedown -> mousemove -> mouseup
     *
     * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
     * which determines with state it should be.
     *
     * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
     * POSSIBLE to give it another change on the next cycle.
     *
     *               Possible
     *                  |
     *            +-----+---------------+
     *            |                     |
     *      +-----+-----+               |
     *      |           |               |
     *   Failed      Cancelled          |
     *                          +-------+------+
     *                          |              |
     *                      Recognized       Began
     *                                         |
     *                                      Changed
     *                                         |
     *                                  Ended/Recognized
     */

    /**
     * @private
     * Recognizer
     * Every recognizer needs to extend from this class.
     * @constructor
     * @param {Object} options
     */


    var Recognizer = /*#__PURE__*/function () {
        function Recognizer(options) {
            if (options === void 0) {
                options = {};
            }

            this.options = _extends({
                enable: true
            }, options);
            this.id = uniqueId();
            this.manager = null; // default is enable true

            this.state = STATE_POSSIBLE;
            this.simultaneous = {};
            this.requireFail = [];
        }
        /**
         * @private
         * set options
         * @param {Object} options
         * @return {Recognizer}
         */


        var _proto = Recognizer.prototype;

        _proto.set = function set(options) {
            assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state

            this.manager && this.manager.touchAction.update();
            return this;
        };
        /**
         * @private
         * recognize simultaneous with an other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.recognizeWith = function recognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
                return this;
            }

            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }

            return this;
        };
        /**
         * @private
         * drop the simultaneous link. it doesnt remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
                return this;
            }

            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        };
        /**
         * @private
         * recognizer can only run when an other is failing
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.requireFailure = function requireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
                return this;
            }

            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }

            return this;
        };
        /**
         * @private
         * drop the requireFailure link. it does not remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
                return this;
            }

            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);

            if (index > -1) {
                this.requireFail.splice(index, 1);
            }

            return this;
        };
        /**
         * @private
         * has require failures boolean
         * @returns {boolean}
         */


        _proto.hasRequireFailures = function hasRequireFailures() {
            return this.requireFail.length > 0;
        };
        /**
         * @private
         * if the recognizer can recognize simultaneous with an other recognizer
         * @param {Recognizer} otherRecognizer
         * @returns {Boolean}
         */


        _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        };
        /**
         * @private
         * You should use `tryEmit` instead of `emit` directly to check
         * that all the needed recognizers has failed before emitting.
         * @param {Object} input
         */


        _proto.emit = function emit(input) {
            var self = this;
            var state = this.state;

            function emit(event) {
                self.manager.emit(event, input);
            } // 'panstart' and 'panmove'


            if (state < STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }

            emit(self.options.event); // simple 'eventName' events

            if (input.additionalEvent) {
                // additional event(panleft, panright, pinchin, pinchout...)
                emit(input.additionalEvent);
            } // panend and pancancel


            if (state >= STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }
        };
        /**
         * @private
         * Check that all the require failure recognizers has failed,
         * if true, it emits a gesture event,
         * otherwise, setup the state to FAILED.
         * @param {Object} input
         */


        _proto.tryEmit = function tryEmit(input) {
            if (this.canEmit()) {
                return this.emit(input);
            } // it's failing anyway


            this.state = STATE_FAILED;
        };
        /**
         * @private
         * can we emit?
         * @returns {boolean}
         */


        _proto.canEmit = function canEmit() {
            var i = 0;

            while (i < this.requireFail.length) {
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                    return false;
                }

                i++;
            }

            return true;
        };
        /**
         * @private
         * update the recognizer
         * @param {Object} inputData
         */


        _proto.recognize = function recognize(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign$1({}, inputData); // is is enabled and allow recognizing?

            if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            } // reset when we've reached the end


            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
                this.state = STATE_POSSIBLE;
            }

            this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
            // so trigger an event

            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
                this.tryEmit(inputDataClone);
            }
        };
        /**
         * @private
         * return the state of the recognizer
         * the actual recognizing happens in this method
         * @virtual
         * @param {Object} inputData
         * @returns {constant} STATE
         */

        /* jshint ignore:start */


        _proto.process = function process(inputData) {};
        /* jshint ignore:end */

        /**
         * @private
         * return the preferred touch-action
         * @virtual
         * @returns {Array}
         */


        _proto.getTouchAction = function getTouchAction() {};
        /**
         * @private
         * called when the gesture isn't allowed to recognize
         * like when another is being recognized or it is disabled
         * @virtual
         */


        _proto.reset = function reset() {};

        return Recognizer;
    }();
    /**
     * @private
     * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
     * between the given interval and position. The delay option can be used to recognize multi-taps without firing
     * a single tap.
     *
     * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
     * multi-taps being recognized.
     * @constructor
     * @extends Recognizer
     */


    var TapRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(TapRecognizer, _Recognizer);

        function TapRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _Recognizer.call(this, _extends({
                event: 'tap',
                pointers: 1,
                taps: 1,
                interval: 300,
                // max time between the multi-tap taps
                time: 250,
                // max time of the pointer to be down (like finger on the screen)
                threshold: 9,
                // a minimal movement is ok, but keep it low
                posThreshold: 10
            }, options)) || this; // previous time and center,
            // used for tap counting

            _this.pTime = false;
            _this.pCenter = false;
            _this._timer = null;
            _this._input = null;
            _this.count = 0;
            return _this;
        }

        var _proto = TapRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_MANIPULATION];
        };

        _proto.process = function process(input) {
            var _this2 = this;

            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();

            if (input.eventType & INPUT_START && this.count === 0) {
                return this.failTimeout();
            } // we only allow little movement
            // and we've reached an end event, so a tap is possible


            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType !== INPUT_END) {
                    return this.failTimeout();
                }

                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;

                if (!validMultiTap || !validInterval) {
                    this.count = 1;
                } else {
                    this.count += 1;
                }

                this._input = input; // if tap count matches we have recognized it,
                // else it has began recognizing...

                var tapCount = this.count % options.taps;

                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) {
                        return STATE_RECOGNIZED;
                    } else {
                        this._timer = setTimeout(function () {
                            _this2.state = STATE_RECOGNIZED;

                            _this2.tryEmit();
                        }, options.interval);
                        return STATE_BEGAN;
                    }
                }
            }

            return STATE_FAILED;
        };

        _proto.failTimeout = function failTimeout() {
            var _this3 = this;

            this._timer = setTimeout(function () {
                _this3.state = STATE_FAILED;
            }, this.options.interval);
            return STATE_FAILED;
        };

        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };

        _proto.emit = function emit() {
            if (this.state === STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        };

        return TapRecognizer;
    }(Recognizer);
    /**
     * @private
     * This recognizer is just used as a base for the simple attribute recognizers.
     * @constructor
     * @extends Recognizer
     */


    var AttrRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(AttrRecognizer, _Recognizer);

        function AttrRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _Recognizer.call(this, _extends({
                pointers: 1
            }, options)) || this;
        }
        /**
         * @private
         * Used to check if it the recognizer receives valid input, like input.distance > 10.
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {Boolean} recognized
         */


        var _proto = AttrRecognizer.prototype;

        _proto.attrTest = function attrTest(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        };
        /**
         * @private
         * Process the input and return the state for the recognizer
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {*} State
         */


        _proto.process = function process(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED

            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
                return state | STATE_CANCELLED;
            } else if (isRecognized || isValid) {
                if (eventType & INPUT_END) {
                    return state | STATE_ENDED;
                } else if (!(state & STATE_BEGAN)) {
                    return STATE_BEGAN;
                }

                return state | STATE_CHANGED;
            }

            return STATE_FAILED;
        };

        return AttrRecognizer;
    }(Recognizer);
    /**
     * @private
     * direction cons to string
     * @param {constant} direction
     * @returns {String}
     */


    function directionStr(direction) {
        if (direction === DIRECTION_DOWN) {
            return 'down';
        } else if (direction === DIRECTION_UP) {
            return 'up';
        } else if (direction === DIRECTION_LEFT) {
            return 'left';
        } else if (direction === DIRECTION_RIGHT) {
            return 'right';
        }

        return '';
    }
    /**
     * @private
     * Pan
     * Recognized when the pointer is down and moved in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */


    var PanRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(PanRecognizer, _AttrRecognizer);

        function PanRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _AttrRecognizer.call(this, _extends({
                event: 'pan',
                threshold: 10,
                pointers: 1,
                direction: DIRECTION_ALL
            }, options)) || this;
            _this.pX = null;
            _this.pY = null;
            return _this;
        }

        var _proto = PanRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            var direction = this.options.direction;
            var actions = [];

            if (direction & DIRECTION_HORIZONTAL) {
                actions.push(TOUCH_ACTION_PAN_Y);
            }

            if (direction & DIRECTION_VERTICAL) {
                actions.push(TOUCH_ACTION_PAN_X);
            }

            return actions;
        };

        _proto.directionTest = function directionTest(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY; // lock to axis?

            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x !== this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y !== this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }

            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        };

        _proto.attrTest = function attrTest(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && ( // replace with a super call
                this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        };

        _proto.emit = function emit(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);

            if (direction) {
                input.additionalEvent = this.options.event + direction;
            }

            _AttrRecognizer.prototype.emit.call(this, input);
        };

        return PanRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Swipe
     * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */


    var SwipeRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(SwipeRecognizer, _AttrRecognizer);

        function SwipeRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'swipe',
                threshold: 10,
                velocity: 0.3,
                direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
                pointers: 1
            }, options)) || this;
        }

        var _proto = SwipeRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        };

        _proto.attrTest = function attrTest(input) {
            var direction = this.options.direction;
            var velocity;

            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
                velocity = input.overallVelocity;
            } else if (direction & DIRECTION_HORIZONTAL) {
                velocity = input.overallVelocityX;
            } else if (direction & DIRECTION_VERTICAL) {
                velocity = input.overallVelocityY;
            }

            return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && abs$1(velocity) > this.options.velocity && input.eventType & INPUT_END;
        };

        _proto.emit = function emit(input) {
            var direction = directionStr(input.offsetDirection);

            if (direction) {
                this.manager.emit(this.options.event + direction, input);
            }

            this.manager.emit(this.options.event, input);
        };

        return SwipeRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Pinch
     * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
     * @constructor
     * @extends AttrRecognizer
     */


    var PinchRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(PinchRecognizer, _AttrRecognizer);

        function PinchRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'pinch',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }

        var _proto = PinchRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_NONE];
        };

        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        };

        _proto.emit = function emit(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }

            _AttrRecognizer.prototype.emit.call(this, input);
        };

        return PinchRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Rotate
     * Recognized when two or more pointer are moving in a circular motion.
     * @constructor
     * @extends AttrRecognizer
     */


    var RotateRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(RotateRecognizer, _AttrRecognizer);

        function RotateRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'rotate',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }

        var _proto = RotateRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_NONE];
        };

        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        };

        return RotateRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Press
     * Recognized when the pointer is down for x ms without any movement.
     * @constructor
     * @extends Recognizer
     */


    var PressRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(PressRecognizer, _Recognizer);

        function PressRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _Recognizer.call(this, _extends({
                event: 'press',
                pointers: 1,
                time: 251,
                // minimal time of the pointer to be pressed
                threshold: 9
            }, options)) || this;
            _this._timer = null;
            _this._input = null;
            return _this;
        }

        var _proto = PressRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_AUTO];
        };

        _proto.process = function process(input) {
            var _this2 = this;

            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input; // we only allow little movement
            // and we've reached an end event, so a tap is possible

            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
                this.reset();
            } else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeout(function () {
                    _this2.state = STATE_RECOGNIZED;

                    _this2.tryEmit();
                }, options.time);
            } else if (input.eventType & INPUT_END) {
                return STATE_RECOGNIZED;
            }

            return STATE_FAILED;
        };

        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };

        _proto.emit = function emit(input) {
            if (this.state !== STATE_RECOGNIZED) {
                return;
            }

            if (input && input.eventType & INPUT_END) {
                this.manager.emit(this.options.event + "up", input);
            } else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        };

        return PressRecognizer;
    }(Recognizer);

    var defaults = {
        /**
         * @private
         * set if DOM events are being triggered.
         * But this is slower and unused by simple implementations, so disabled by default.
         * @type {Boolean}
         * @default false
         */
        domEvents: false,

        /**
         * @private
         * The value for the touchAction property/fallback.
         * When set to `compute` it will magically set the correct value based on the added recognizers.
         * @type {String}
         * @default compute
         */
        touchAction: TOUCH_ACTION_COMPUTE,

        /**
         * @private
         * @type {Boolean}
         * @default true
         */
        enable: true,

        /**
         * @private
         * EXPERIMENTAL FEATURE -- can be removed/changed
         * Change the parent input target element.
         * If Null, then it is being set the to main element.
         * @type {Null|EventTarget}
         * @default null
         */
        inputTarget: null,

        /**
         * @private
         * force an input class
         * @type {Null|Function}
         * @default null
         */
        inputClass: null,

        /**
         * @private
         * Some CSS properties can be used to improve the working of Hammer.
         * Add them to this method and they will be set when creating a new Manager.
         * @namespace
         */
        cssProps: {
            /**
             * @private
             * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userSelect: "none",

            /**
             * @private
             * Disable the Windows Phone grippers when pressing an element.
             * @type {String}
             * @default 'none'
             */
            touchSelect: "none",

            /**
             * @private
             * Disables the default callout shown when you touch and hold a touch target.
             * On iOS, when you touch and hold a touch target such as a link, Safari displays
             * a callout containing information about the link. This property allows you to disable that callout.
             * @type {String}
             * @default 'none'
             */
            touchCallout: "none",

            /**
             * @private
             * Specifies whether zooming is enabled. Used by IE10>
             * @type {String}
             * @default 'none'
             */
            contentZooming: "none",

            /**
             * @private
             * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userDrag: "none",

            /**
             * @private
             * Overrides the highlight color shown when the user taps a link or a JavaScript
             * clickable element in iOS. This property obeys the alpha value, if specified.
             * @type {String}
             * @default 'rgba(0,0,0,0)'
             */
            tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    /**
     * @private
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * This is separated with other defaults because of tree-shaking.
     * @type {Array}
     */

    var preset = [[RotateRecognizer, {
        enable: false
    }], [PinchRecognizer, {
        enable: false
    }, ['rotate']], [SwipeRecognizer, {
        direction: DIRECTION_HORIZONTAL
    }], [PanRecognizer, {
        direction: DIRECTION_HORIZONTAL
    }, ['swipe']], [TapRecognizer], [TapRecognizer, {
        event: 'doubletap',
        taps: 2
    }, ['tap']], [PressRecognizer]];
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
     * @private
     * add/remove the css properties as defined in manager.options.cssProps
     * @param {Manager} manager
     * @param {Boolean} add
     */

    function toggleCssProps(manager, add) {
        var element = manager.element;

        if (!element.style) {
            return;
        }

        var prop;
        each(manager.options.cssProps, function (value, name) {
            prop = prefixed(element.style, name);

            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else {
                element.style[prop] = manager.oldCssProps[prop] || "";
            }
        });

        if (!add) {
            manager.oldCssProps = {};
        }
    }
    /**
     * @private
     * trigger dom event
     * @param {String} event
     * @param {Object} data
     */


    function triggerDomEvent(event, data) {
        var gestureEvent = document.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    /**
     * @private
     * Manager
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */


    var Manager = /*#__PURE__*/function () {
        function Manager(element, options) {
            var _this = this;

            this.options = assign$1({}, defaults, options || {});
            this.options.inputTarget = this.options.inputTarget || element;
            this.handlers = {};
            this.session = {};
            this.recognizers = [];
            this.oldCssProps = {};
            this.element = element;
            this.input = createInputInstance(this);
            this.touchAction = new TouchAction(this, this.options.touchAction);
            toggleCssProps(this, true);
            each(this.options.recognizers, function (item) {
                var recognizer = _this.add(new item[0](item[1]));

                item[2] && recognizer.recognizeWith(item[2]);
                item[3] && recognizer.requireFailure(item[3]);
            }, this);
        }
        /**
         * @private
         * set options
         * @param {Object} options
         * @returns {Manager}
         */


        var _proto = Manager.prototype;

        _proto.set = function set(options) {
            assign$1(this.options, options); // Options that need a little more setup

            if (options.touchAction) {
                this.touchAction.update();
            }

            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }

            return this;
        };
        /**
         * @private
         * stop recognizing for this session.
         * This session will be discarded, when a new [input]start event is fired.
         * When forced, the recognizer cycle is stopped immediately.
         * @param {Boolean} [force]
         */


        _proto.stop = function stop(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        };
        /**
         * @private
         * run the recognizers!
         * called by the inputHandler function on every movement of the pointers (touches)
         * it walks through all the recognizers and tries to detect the gesture that is being made
         * @param {Object} inputData
         */


        _proto.recognize = function recognize(inputData) {
            var session = this.session;

            if (session.stopped) {
                return;
            } // run the touch-action polyfill


            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`

            var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
            // or when we're in a new session

            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
                session.curRecognizer = null;
                curRecognizer = null;
            }

            var i = 0;

            while (i < recognizers.length) {
                recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.

                if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer === curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) {
                    // 3
                    recognizer.recognize(inputData);
                } else {
                    recognizer.reset();
                } // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer


                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                    session.curRecognizer = recognizer;
                    curRecognizer = recognizer;
                }

                i++;
            }
        };
        /**
         * @private
         * get a recognizer by its event name.
         * @param {Recognizer|String} recognizer
         * @returns {Recognizer|Null}
         */


        _proto.get = function get(recognizer) {
            if (recognizer instanceof Recognizer) {
                return recognizer;
            }

            var recognizers = this.recognizers;

            for (var i = 0; i < recognizers.length; i++) {
                if (recognizers[i].options.event === recognizer) {
                    return recognizers[i];
                }
            }

            return null;
        };
        /**
         * @private add a recognizer to the manager
         * existing recognizers with the same event name will be removed
         * @param {Recognizer} recognizer
         * @returns {Recognizer|Manager}
         */


        _proto.add = function add(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) {
                return this;
            } // remove existing


            var existing = this.get(recognizer.options.event);

            if (existing) {
                this.remove(existing);
            }

            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        };
        /**
         * @private
         * remove a recognizer by name or instance
         * @param {Recognizer|String} recognizer
         * @returns {Manager}
         */


        _proto.remove = function remove(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) {
                return this;
            }

            var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists

            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, targetRecognizer);

                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }

            return this;
        };
        /**
         * @private
         * bind event
         * @param {String} events
         * @param {Function} handler
         * @returns {EventEmitter} this
         */


        _proto.on = function on(events, handler) {
            if (events === undefined || handler === undefined) {
                return this;
            }

            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        };
        /**
         * @private unbind event, leave emit blank to remove all handlers
         * @param {String} events
         * @param {Function} [handler]
         * @returns {EventEmitter} this
         */


        _proto.off = function off(events, handler) {
            if (events === undefined) {
                return this;
            }

            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                if (!handler) {
                    delete handlers[event];
                } else {
                    handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
                }
            });
            return this;
        };
        /**
         * @private emit event to the listeners
         * @param {String} event
         * @param {Object} data
         */


        _proto.emit = function emit(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) {
                triggerDomEvent(event, data);
            } // no handlers, so skip it all


            var handlers = this.handlers[event] && this.handlers[event].slice();

            if (!handlers || !handlers.length) {
                return;
            }

            data.type = event;

            data.preventDefault = function () {
                data.srcEvent.preventDefault();
            };

            var i = 0;

            while (i < handlers.length) {
                handlers[i](data);
                i++;
            }
        };
        /**
         * @private
         * destroy the manager and unbinds all events
         * it doesn't unbind dom events, that is the user own responsibility
         */


        _proto.destroy = function destroy() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        };

        return Manager;
    }();

    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * @private
     * Touch events input
     * @constructor
     * @extends Input
     */

    var SingleTouchInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(SingleTouchInput, _Input);

        function SingleTouchInput() {
            var _this;

            var proto = SingleTouchInput.prototype;
            proto.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
            proto.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.started = false;
            return _this;
        }

        var _proto = SingleTouchInput.prototype;

        _proto.handler = function handler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?

            if (type === INPUT_START) {
                this.started = true;
            }

            if (!this.started) {
                return;
            }

            var touches = normalizeSingleTouches.call(this, ev, type); // when done, reset the started state

            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
                this.started = false;
            }

            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };

        return SingleTouchInput;
    }(Input);

    function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);

        if (type & (INPUT_END | INPUT_CANCEL)) {
            all = uniqueArray(all.concat(changed), 'identifier', true);
        }

        return [all, changed];
    }
    /**
     * @private
     * wrap a method with a deprecation warning and stack trace
     * @param {Function} method
     * @param {String} name
     * @param {String} message
     * @returns {Function} A new function wrapping the supplied method.
     */


    function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function () {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window.console && (window.console.warn || window.console.log);

            if (log) {
                log.call(window.console, deprecationMessage, stack);
            }

            return method.apply(this, arguments);
        };
    }
    /**
     * @private
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} dest
     * @param {Object} src
     * @param {Boolean} [merge=false]
     * @returns {Object} dest
     */


    var extend = deprecate(function (dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;

        while (i < keys.length) {
            if (!merge || merge && dest[keys[i]] === undefined) {
                dest[keys[i]] = src[keys[i]];
            }

            i++;
        }

        return dest;
    }, 'extend', 'Use `assign`.');
    /**
     * @private
     * merge the values from src in the dest.
     * means that properties that exist in dest will not be overwritten by src
     * @param {Object} dest
     * @param {Object} src
     * @returns {Object} dest
     */

    var merge$1 = deprecate(function (dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
     * @private
     * simple class inheritance
     * @param {Function} child
     * @param {Function} base
     * @param {Object} [properties]
     */

    function inherit(child, base, properties) {
        var baseP = base.prototype;
        var childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;

        if (properties) {
            assign$1(childP, properties);
        }
    }
    /**
     * @private
     * simple function bind
     * @param {Function} fn
     * @param {Object} context
     * @returns {Function}
     */


    function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
     * @private
     * Simple way to create a manager with a default set of recognizers.
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */


    var Hammer$2 = /*#__PURE__*/function () {
        var Hammer =
            /**
             * @private
             * @const {string}
             */
            function Hammer(element, options) {
                if (options === void 0) {
                    options = {};
                }

                return new Manager(element, _extends({
                    recognizers: preset.concat()
                }, options));
            };

        Hammer.VERSION = "2.0.17-rc";
        Hammer.DIRECTION_ALL = DIRECTION_ALL;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.DIRECTION_LEFT = DIRECTION_LEFT;
        Hammer.DIRECTION_RIGHT = DIRECTION_RIGHT;
        Hammer.DIRECTION_UP = DIRECTION_UP;
        Hammer.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
        Hammer.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
        Hammer.DIRECTION_NONE = DIRECTION_NONE;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.INPUT_START = INPUT_START;
        Hammer.INPUT_MOVE = INPUT_MOVE;
        Hammer.INPUT_END = INPUT_END;
        Hammer.INPUT_CANCEL = INPUT_CANCEL;
        Hammer.STATE_POSSIBLE = STATE_POSSIBLE;
        Hammer.STATE_BEGAN = STATE_BEGAN;
        Hammer.STATE_CHANGED = STATE_CHANGED;
        Hammer.STATE_ENDED = STATE_ENDED;
        Hammer.STATE_RECOGNIZED = STATE_RECOGNIZED;
        Hammer.STATE_CANCELLED = STATE_CANCELLED;
        Hammer.STATE_FAILED = STATE_FAILED;
        Hammer.Manager = Manager;
        Hammer.Input = Input;
        Hammer.TouchAction = TouchAction;
        Hammer.TouchInput = TouchInput;
        Hammer.MouseInput = MouseInput;
        Hammer.PointerEventInput = PointerEventInput;
        Hammer.TouchMouseInput = TouchMouseInput;
        Hammer.SingleTouchInput = SingleTouchInput;
        Hammer.Recognizer = Recognizer;
        Hammer.AttrRecognizer = AttrRecognizer;
        Hammer.Tap = TapRecognizer;
        Hammer.Pan = PanRecognizer;
        Hammer.Swipe = SwipeRecognizer;
        Hammer.Pinch = PinchRecognizer;
        Hammer.Rotate = RotateRecognizer;
        Hammer.Press = PressRecognizer;
        Hammer.on = addEventListeners;
        Hammer.off = removeEventListeners;
        Hammer.each = each;
        Hammer.merge = merge$1;
        Hammer.extend = extend;
        Hammer.bindFn = bindFn;
        Hammer.assign = assign$1;
        Hammer.inherit = inherit;
        Hammer.bindFn = bindFn;
        Hammer.prefixed = prefixed;
        Hammer.toArray = toArray;
        Hammer.inArray = inArray;
        Hammer.uniqueArray = uniqueArray;
        Hammer.splitStr = splitStr;
        Hammer.boolOrFn = boolOrFn;
        Hammer.hasParent = hasParent;
        Hammer.addEventListeners = addEventListeners;
        Hammer.removeEventListeners = removeEventListeners;
        Hammer.defaults = assign$1({}, defaults, {
            preset: preset
        });
        return Hammer;
    }(); //  style loader but by script tag, not by the loader.

    function _createForOfIteratorHelper$8(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$8(o, minLen) { var _context21; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = slice$1(_context21 = Object.prototype.toString.call(o)).call(_context21, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

    function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Use this symbol to delete properies in deepObjectAssign.
     */

    var DELETE = symbol("DELETE");
    /**
     * Pure version of deepObjectAssign, it doesn't modify any of it's arguments.
     *
     * @param base - The base object that fullfils the whole interface T.
     * @param updates - Updates that may change or delete props.
     *
     * @returns A brand new instance with all the supplied objects deeply merged.
     */


    function pureDeepObjectAssign(base) {
        var _context;

        for (var _len = arguments.length, updates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            updates[_key - 1] = arguments[_key];
        }

        return deepObjectAssign.apply(void 0, concat(_context = [{}, base]).call(_context, updates));
    }
    /**
     * Deep version of object assign with additional deleting by the DELETE symbol.
     *
     * @param values - Objects to be deeply merged.
     *
     * @returns The first object from values.
     */


    function deepObjectAssign() {
        var merged = deepObjectAssignNonentry.apply(void 0, arguments);
        stripDelete(merged);
        return merged;
    }
    /**
     * Deep version of object assign with additional deleting by the DELETE symbol.
     *
     * @remarks
     * This doesn't strip the DELETE symbols so they may end up in the final object.
     *
     * @param values - Objects to be deeply merged.
     *
     * @returns The first object from values.
     */


    function deepObjectAssignNonentry() {
        for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        if (values.length < 2) {
            return values[0];
        } else if (values.length > 2) {
            var _context2;

            return deepObjectAssignNonentry.apply(void 0, concat(_context2 = [deepObjectAssign(values[0], values[1])]).call(_context2, _toConsumableArray(slice$1(values).call(values, 2))));
        }

        var a = values[0];
        var b = values[1];

        var _iterator = _createForOfIteratorHelper$8(ownKeys$5(b)),
            _step;

        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var prop = _step.value;
                if (!Object.prototype.propertyIsEnumerable.call(b, prop)) ;else if (b[prop] === DELETE) {
                    delete a[prop];
                } else if (a[prop] !== null && b[prop] !== null && _typeof(a[prop]) === "object" && _typeof(b[prop]) === "object" && !isArray(a[prop]) && !isArray(b[prop])) {
                    a[prop] = deepObjectAssignNonentry(a[prop], b[prop]);
                } else {
                    a[prop] = clone(b[prop]);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return a;
    }
    /**
     * Deep clone given object or array. In case of primitive simply return.
     *
     * @param a - Anything.
     *
     * @returns Deep cloned object/array or unchanged a.
     */


    function clone(a) {
        if (isArray(a)) {
            return map$3(a).call(a, function (value) {
                return clone(value);
            });
        } else if (_typeof(a) === "object" && a !== null) {
            return deepObjectAssignNonentry({}, a);
        } else {
            return a;
        }
    }
    /**
     * Strip DELETE from given object.
     *
     * @param a - Object which may contain DELETE but won't after this is executed.
     */


    function stripDelete(a) {
        for (var _i = 0, _Object$keys = keys$3(a); _i < _Object$keys.length; _i++) {
            var prop = _Object$keys[_i];

            if (a[prop] === DELETE) {
                delete a[prop];
            } else if (_typeof(a[prop]) === "object" && a[prop] !== null) {
                stripDelete(a[prop]);
            }
        }
    }
    /**
     * Seedable, fast and reasonably good (not crypto but more than okay for our
     * needs) random number generator.
     *
     * @remarks
     * Adapted from {@link https://web.archive.org/web/20110429100736/http://baagoe.com:80/en/RandomMusings/javascript}.
     * Original algorithm created by Johannes Baagøe \<baagoe\@baagoe.com\> in 2010.
     */

    /**
     * Create a seeded pseudo random generator based on Alea by Johannes Baagøe.
     *
     * @param seed - All supplied arguments will be used as a seed. In case nothing
     * is supplied the current time will be used to seed the generator.
     *
     * @returns A ready to use seeded generator.
     */


    function Alea() {
        for (var _len3 = arguments.length, seed = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            seed[_key3] = arguments[_key3];
        }

        return AleaImplementation(seed.length ? seed : [now$1()]);
    }
    /**
     * An implementation of [[Alea]] without user input validation.
     *
     * @param seed - The data that will be used to seed the generator.
     *
     * @returns A ready to use seeded generator.
     */


    function AleaImplementation(seed) {
        var _mashSeed = mashSeed(seed),
            _mashSeed2 = _slicedToArray(_mashSeed, 3),
            s0 = _mashSeed2[0],
            s1 = _mashSeed2[1],
            s2 = _mashSeed2[2];

        var c = 1;

        var random = function random() {
            var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32

            s0 = s1;
            s1 = s2;
            return s2 = t - (c = t | 0);
        };

        random.uint32 = function () {
            return random() * 0x100000000;
        }; // 2^32


        random.fract53 = function () {
            return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16;
        }; // 2^-53


        random.algorithm = "Alea";
        random.seed = seed;
        random.version = "0.9";
        return random;
    }
    /**
     * Turn arbitrary data into values [[AleaImplementation]] can use to generate
     * random numbers.
     *
     * @param seed - Arbitrary data that will be used as the seed.
     *
     * @returns Three numbers to use as initial values for [[AleaImplementation]].
     */


    function mashSeed() {
        var mash = Mash();
        var s0 = mash(" ");
        var s1 = mash(" ");
        var s2 = mash(" ");

        for (var i = 0; i < arguments.length; i++) {
            s0 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s0 < 0) {
                s0 += 1;
            }

            s1 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s1 < 0) {
                s1 += 1;
            }

            s2 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s2 < 0) {
                s2 += 1;
            }
        }

        return [s0, s1, s2];
    }
    /**
     * Create a new mash function.
     *
     * @returns A nonpure function that takes arbitrary [[Mashable]] data and turns
     * them into numbers.
     */


    function Mash() {
        var n = 0xefc8249d;
        return function (data) {
            var string = data.toString();

            for (var i = 0; i < string.length; i++) {
                n += string.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }

            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
    }
    /**
     * Setup a mock hammer.js object, for unit testing.
     *
     * Inspiration: https://github.com/uber/deck.gl/pull/658
     *
     * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
     */


    function hammerMock() {
        var noop = function noop() {};

        return {
            on: noop,
            off: noop,
            destroy: noop,
            emit: noop,
            get: function get() {
                return {
                    set: noop
                };
            }
        };
    }

    var Hammer = typeof window !== "undefined" ? window.Hammer || Hammer$2 : function () {
        // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
        return hammerMock();
    };
    /**
     * Turn an element into an clickToUse element.
     * When not active, the element has a transparent overlay. When the overlay is
     * clicked, the mode is changed to active.
     * When active, the element is displayed with a blue border around it, and
     * the interactive contents of the element can be used. When clicked outside
     * the element, the elements mode is changed to inactive.
     *
     * @param {Element} container
     * @class Activator
     */

    function Activator(container) {
        var _this = this,
            _context3;

        this._cleanupQueue = [];
        this.active = false;
        this._dom = {
            container: container,
            overlay: document.createElement("div")
        };

        this._dom.overlay.classList.add("vis-overlay");

        this._dom.container.appendChild(this._dom.overlay);

        this._cleanupQueue.push(function () {
            _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
        });

        var hammer = Hammer(this._dom.overlay);
        hammer.on("tap", bind(_context3 = this._onTapOverlay).call(_context3, this));

        this._cleanupQueue.push(function () {
            hammer.destroy(); // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
            // from memory)
        }); // block all touch events (except tap)


        var events = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];

        forEach$2(events).call(events, function (event) {
            hammer.on(event, function (event) {
                event.srcEvent.stopPropagation();
            });
        }); // attach a click event to the window, in order to deactivate when clicking outside the timeline


        if (document && document.body) {
            this._onClick = function (event) {
                if (!_hasParent(event.target, container)) {
                    _this.deactivate();
                }
            };

            document.body.addEventListener("click", this._onClick);

            this._cleanupQueue.push(function () {
                document.body.removeEventListener("click", _this._onClick);
            });
        } // prepare escape key listener for deactivating when active


        this._escListener = function (event) {
            if ("key" in event ? event.key === "Escape" : event.keyCode === 27
                /* the keyCode is for IE11 */
            ) {
                _this.deactivate();
            }
        };
    } // turn into an event emitter


    componentEmitter(Activator.prototype); // The currently active activator

    Activator.current = null;
    /**
     * Destroy the activator. Cleans up all created DOM and event listeners
     */

    Activator.prototype.destroy = function () {
        var _context4, _context5;

        this.deactivate();

        var _iterator2 = _createForOfIteratorHelper$8(reverse(_context4 = splice(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)),
            _step2;

        try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var callback = _step2.value;
                callback();
            }
        } catch (err) {
            _iterator2.e(err);
        } finally {
            _iterator2.f();
        }
    };
    /**
     * Activate the element
     * Overlay is hidden, element is decorated with a blue shadow border
     */


    Activator.prototype.activate = function () {
        // we allow only one active activator at a time
        if (Activator.current) {
            Activator.current.deactivate();
        }

        Activator.current = this;
        this.active = true;
        this._dom.overlay.style.display = "none";

        this._dom.container.classList.add("vis-active");

        this.emit("change");
        this.emit("activate"); // ugly hack: bind ESC after emitting the events, as the Network rebinds all
        // keyboard events on a 'change' event

        document.body.addEventListener("keydown", this._escListener);
    };
    /**
     * Deactivate the element
     * Overlay is displayed on top of the element
     */


    Activator.prototype.deactivate = function () {
        this.active = false;
        this._dom.overlay.style.display = "block";

        this._dom.container.classList.remove("vis-active");

        document.body.removeEventListener("keydown", this._escListener);
        this.emit("change");
        this.emit("deactivate");
    };
    /**
     * Handle a tap event: activate the container
     *
     * @param {Event}  event   The event
     * @private
     */


    Activator.prototype._onTapOverlay = function (event) {
        // activate the container
        this.activate();
        event.srcEvent.stopPropagation();
    };
    /**
     * Test whether the element has the requested parent element somewhere in
     * its chain of parent nodes.
     *
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @returns {boolean} Returns true when the parent is found somewhere in the
     *                    chain of parent nodes.
     * @private
     */


    function _hasParent(element, parent) {
        while (element) {
            if (element === parent) {
                return true;
            }

            element = element.parentNode;
        }

        return false;
    } // utility functions

    var fullHexRE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    var shortHexRE = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var rgbRE = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i;
    var rgbaRE = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
    /**
     * Remove everything in the DOM object.
     *
     * @param DOMobject - Node whose child nodes will be recursively deleted.
     */


    function recursiveDOMDelete(DOMobject) {
        if (DOMobject) {
            while (DOMobject.hasChildNodes() === true) {
                var child = DOMobject.firstChild;

                if (child) {
                    recursiveDOMDelete(child);
                    DOMobject.removeChild(child);
                }
            }
        }
    }
    /**
     * Test whether given object is a string.
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if string, false otherwise.
     */


    function isString(value) {
        return value instanceof String || typeof value === "string";
    }
    /**
     * Test whether given object is a object (not primitive or null).
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if not null object, false otherwise.
     */


    function isObject(value) {
        return _typeof(value) === "object" && value !== null;
    }
    /**
     * Copy property from b to a if property present in a.
     * If property in b explicitly set to null, delete it if `allowDeletion` set.
     *
     * Internal helper routine, should not be exported. Not added to `exports` for that reason.
     *
     * @param a - Target object.
     * @param b - Source object.
     * @param prop - Name of property to copy from b to a.
     * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
     */


    function copyOrDelete(a, b, prop, allowDeletion) {
        var doDeletion = false;

        if (allowDeletion === true) {
            doDeletion = b[prop] === null && a[prop] !== undefined;
        }

        if (doDeletion) {
            delete a[prop];
        } else {
            a[prop] = b[prop]; // Remember, this is a reference copy!
        }
    }
    /**
     * Fill an object with a possibly partially defined other object.
     *
     * Only copies values for the properties already present in a.
     * That means an object is not created on a property if only the b object has it.
     *
     * @param a - The object that will have it's properties updated.
     * @param b - The object with property updates.
     * @param allowDeletion - If true, delete properties in a that are explicitly set to null in b.
     */


    function fillIfDefined(a, b) {
        var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // NOTE: iteration of properties of a
        // NOTE: prototype properties iterated over as well
        for (var prop in a) {
            if (b[prop] !== undefined) {
                if (b[prop] === null || _typeof(b[prop]) !== "object") {
                    // Note: typeof null === 'object'
                    copyOrDelete(a, b, prop, allowDeletion);
                } else {
                    var aProp = a[prop];
                    var bProp = b[prop];

                    if (isObject(aProp) && isObject(bProp)) {
                        fillIfDefined(aProp, bProp, allowDeletion);
                    }
                }
            }
        }
    }
    /**
     * Extend object a with selected properties of object b.
     * Only properties with defined values are copied.
     *
     * @remarks
     * Previous version of this routine implied that multiple source objects could
     * be used; however, the implementation was **wrong**. Since multiple (\>1)
     * sources weren't used anywhere in the `vis.js` code, this has been removed
     *
     * @param props - Names of first-level properties to copy over.
     * @param a - Target object.
     * @param b - Source object.
     * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
     *
     * @returns Argument a.
     */


    function selectiveDeepExtend(props, a, b) {
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        // TODO: add support for Arrays to deepExtend
        if (isArray(b)) {
            throw new TypeError("Arrays are not supported by deepExtend");
        }

        for (var p = 0; p < props.length; p++) {
            var prop = props[p];

            if (Object.prototype.hasOwnProperty.call(b, prop)) {
                if (b[prop] && b[prop].constructor === Object) {
                    if (a[prop] === undefined) {
                        a[prop] = {};
                    }

                    if (a[prop].constructor === Object) {
                        deepExtend(a[prop], b[prop], false, allowDeletion);
                    } else {
                        copyOrDelete(a, b, prop, allowDeletion);
                    }
                } else if (isArray(b[prop])) {
                    throw new TypeError("Arrays are not supported by deepExtend");
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            }
        }

        return a;
    }
    /**
     * Extend object `a` with properties of object `b`, ignoring properties which
     * are explicitly specified to be excluded.
     *
     * @remarks
     * The properties of `b` are considered for copying. Properties which are
     * themselves objects are are also extended. Only properties with defined
     * values are copied.
     *
     * @param propsToExclude - Names of properties which should *not* be copied.
     * @param a - Object to extend.
     * @param b - Object to take properties from for extension.
     * @param allowDeletion - If true, delete properties in a that are explicitly
     * set to null in b.
     *
     * @returns Argument a.
     */


    function selectiveNotDeepExtend(propsToExclude, a, b) {
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        // TODO: add support for Arrays to deepExtend
        // NOTE: array properties have an else-below; apparently, there is a problem here.
        if (isArray(b)) {
            throw new TypeError("Arrays are not supported by deepExtend");
        }

        for (var prop in b) {
            if (!Object.prototype.hasOwnProperty.call(b, prop)) {
                continue;
            } // Handle local properties only


            if (includes(propsToExclude).call(propsToExclude, prop)) {
                continue;
            } // In exclusion list, skip


            if (b[prop] && b[prop].constructor === Object) {
                if (a[prop] === undefined) {
                    a[prop] = {};
                }

                if (a[prop].constructor === Object) {
                    deepExtend(a[prop], b[prop]); // NOTE: allowDeletion not propagated!
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            } else if (isArray(b[prop])) {
                a[prop] = [];

                for (var i = 0; i < b[prop].length; i++) {
                    a[prop].push(b[prop][i]);
                }
            } else {
                copyOrDelete(a, b, prop, allowDeletion);
            }
        }

        return a;
    }
    /**
     * Deep extend an object a with the properties of object b.
     *
     * @param a - Target object.
     * @param b - Source object.
     * @param protoExtend - If true, the prototype values will also be extended.
     * (That is the options objects that inherit from others will also get the
     * inherited options).
     * @param allowDeletion - If true, the values of fields that are null will be deleted.
     *
     * @returns Argument a.
     */


    function deepExtend(a, b) {
        var protoExtend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        for (var prop in b) {
            if (Object.prototype.hasOwnProperty.call(b, prop) || protoExtend === true) {
                if (_typeof(b[prop]) === "object" && b[prop] !== null && getPrototypeOf$2(b[prop]) === Object.prototype) {
                    if (a[prop] === undefined) {
                        a[prop] = deepExtend({}, b[prop], protoExtend); // NOTE: allowDeletion not propagated!
                    } else if (_typeof(a[prop]) === "object" && a[prop] !== null && getPrototypeOf$2(a[prop]) === Object.prototype) {
                        deepExtend(a[prop], b[prop], protoExtend); // NOTE: allowDeletion not propagated!
                    } else {
                        copyOrDelete(a, b, prop, allowDeletion);
                    }
                } else if (isArray(b[prop])) {
                    var _context6;

                    a[prop] = slice$1(_context6 = b[prop]).call(_context6);
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            }
        }

        return a;
    }
    /**
     * Used to extend an array and copy it. This is used to propagate paths recursively.
     *
     * @param arr - First part.
     * @param newValue - The value to be aadded into the array.
     *
     * @returns A new array with all items from arr and newValue (which is last).
     */


    function copyAndExtendArray(arr, newValue) {
        var _context7;

        return concat(_context7 = []).call(_context7, _toConsumableArray(arr), [newValue]);
    }
    /**
     * Used to extend an array and copy it. This is used to propagate paths recursively.
     *
     * @param arr - The array to be copied.
     *
     * @returns Shallow copy of arr.
     */


    function copyArray(arr) {
        return slice$1(arr).call(arr);
    }
    /**
     * Retrieve the absolute left value of a DOM element.
     *
     * @param elem - A dom element, for example a div.
     *
     * @returns The absolute left position of this element in the browser page.
     */


    function getAbsoluteLeft(elem) {
        return elem.getBoundingClientRect().left;
    }
    /**
     * Retrieve the absolute top value of a DOM element.
     *
     * @param elem - A dom element, for example a div.
     *
     * @returns The absolute top position of this element in the browser page.
     */


    function getAbsoluteTop(elem) {
        return elem.getBoundingClientRect().top;
    }
    /**
     * For each method for both arrays and objects.
     * In case of an array, the built-in Array.forEach() is applied (**No, it's not!**).
     * In case of an Object, the method loops over all properties of the object.
     *
     * @param object - An Object or Array to be iterated over.
     * @param callback - Array.forEach-like callback.
     */


    function forEach$1(object, callback) {
        if (isArray(object)) {
            // array
            var len = object.length;

            for (var i = 0; i < len; i++) {
                callback(object[i], i, object);
            }
        } else {
            // object
            for (var key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    callback(object[key], key, object);
                }
            }
        }
    }
    /**
     * Add and event listener. Works for all browsers.
     *
     * @param element - The element to bind the event listener to.
     * @param action - Same as Element.addEventListener(action, —, —).
     * @param listener - Same as Element.addEventListener(—, listener, —).
     * @param useCapture - Same as Element.addEventListener(—, —, useCapture).
     */


    function addEventListener(element, action, listener, useCapture) {
        if (element.addEventListener) {
            var _context8;

            if (useCapture === undefined) {
                useCapture = false;
            }

            if (action === "mousewheel" && includes(_context8 = navigator.userAgent).call(_context8, "Firefox")) {
                action = "DOMMouseScroll"; // For Firefox
            }

            element.addEventListener(action, listener, useCapture);
        } else {
            // @TODO: IE types? Does anyone care?
            element.attachEvent("on" + action, listener); // IE browsers
        }
    }
    /**
     * Remove an event listener from an element.
     *
     * @param element - The element to bind the event listener to.
     * @param action - Same as Element.removeEventListener(action, —, —).
     * @param listener - Same as Element.removeEventListener(—, listener, —).
     * @param useCapture - Same as Element.removeEventListener(—, —, useCapture).
     */


    function removeEventListener(element, action, listener, useCapture) {
        if (element.removeEventListener) {
            var _context9;

            // non-IE browsers
            if (useCapture === undefined) {
                useCapture = false;
            }

            if (action === "mousewheel" && includes(_context9 = navigator.userAgent).call(_context9, "Firefox")) {
                action = "DOMMouseScroll"; // For Firefox
            }

            element.removeEventListener(action, listener, useCapture);
        } else {
            // @TODO: IE types? Does anyone care?
            element.detachEvent("on" + action, listener); // IE browsers
        }
    }
    /**
     * Convert hex color string into RGB color object.
     *
     * @remarks
     * {@link http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb}
     *
     * @param hex - Hex color string (3 or 6 digits, with or without #).
     *
     * @returns RGB color object.
     */

    function hexToRGB(hex) {
        var result;

        switch (hex.length) {
            case 3:
            case 4:
                result = shortHexRE.exec(hex);
                return result ? {
                    r: _parseInt(result[1] + result[1], 16),
                    g: _parseInt(result[2] + result[2], 16),
                    b: _parseInt(result[3] + result[3], 16)
                } : null;

            case 6:
            case 7:
                result = fullHexRE.exec(hex);
                return result ? {
                    r: _parseInt(result[1], 16),
                    g: _parseInt(result[2], 16),
                    b: _parseInt(result[3], 16)
                } : null;

            default:
                return null;
        }
    }
    /**
     * This function takes string color in hex or RGB format and adds the opacity, RGBA is passed through unchanged.
     *
     * @param color - The color string (hex, RGB, RGBA).
     * @param opacity - The new opacity.
     *
     * @returns RGBA string, for example 'rgba(255, 0, 127, 0.3)'.
     */


    function overrideOpacity(color, opacity) {
        if (includes(color).call(color, "rgba")) {
            return color;
        } else if (includes(color).call(color, "rgb")) {
            var rgb = color.substr(indexOf(color).call(color, "(") + 1).replace(")", "").split(",");
            return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + opacity + ")";
        } else {
            var _rgb = hexToRGB(color);

            if (_rgb == null) {
                return color;
            } else {
                return "rgba(" + _rgb.r + "," + _rgb.g + "," + _rgb.b + "," + opacity + ")";
            }
        }
    }
    /**
     * Convert RGB \<0, 255\> into hex color string.
     *
     * @param red - Red channel.
     * @param green - Green channel.
     * @param blue - Blue channel.
     *
     * @returns Hex color string (for example: '#0acdc0').
     */


    function RGBToHex(red, green, blue) {
        var _context10;

        return "#" + slice$1(_context10 = ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16)).call(_context10, 1);
    }
    /**
     * Parse a color property into an object with border, background, and highlight colors.
     *
     * @param inputColor - Shorthand color string or input color object.
     * @param defaultColor - Full color object to fill in missing values in inputColor.
     *
     * @returns Color object.
     */


    function parseColor(inputColor, defaultColor) {
        if (isString(inputColor)) {
            var colorStr = inputColor;

            if (isValidRGB(colorStr)) {
                var _context11;

                var rgb = map$3(_context11 = colorStr.substr(4).substr(0, colorStr.length - 5).split(",")).call(_context11, function (value) {
                    return _parseInt(value);
                });

                colorStr = RGBToHex(rgb[0], rgb[1], rgb[2]);
            }

            if (isValidHex(colorStr) === true) {
                var hsv = hexToHSV(colorStr);
                var lighterColorHSV = {
                    h: hsv.h,
                    s: hsv.s * 0.8,
                    v: Math.min(1, hsv.v * 1.02)
                };
                var darkerColorHSV = {
                    h: hsv.h,
                    s: Math.min(1, hsv.s * 1.25),
                    v: hsv.v * 0.8
                };
                var darkerColorHex = HSVToHex(darkerColorHSV.h, darkerColorHSV.s, darkerColorHSV.v);
                var lighterColorHex = HSVToHex(lighterColorHSV.h, lighterColorHSV.s, lighterColorHSV.v);
                return {
                    background: colorStr,
                    border: darkerColorHex,
                    highlight: {
                        background: lighterColorHex,
                        border: darkerColorHex
                    },
                    hover: {
                        background: lighterColorHex,
                        border: darkerColorHex
                    }
                };
            } else {
                return {
                    background: colorStr,
                    border: colorStr,
                    highlight: {
                        background: colorStr,
                        border: colorStr
                    },
                    hover: {
                        background: colorStr,
                        border: colorStr
                    }
                };
            }
        } else {
            if (defaultColor) {
                var color = {
                    background: inputColor.background || defaultColor.background,
                    border: inputColor.border || defaultColor.border,
                    highlight: isString(inputColor.highlight) ? {
                        border: inputColor.highlight,
                        background: inputColor.highlight
                    } : {
                        background: inputColor.highlight && inputColor.highlight.background || defaultColor.highlight.background,
                        border: inputColor.highlight && inputColor.highlight.border || defaultColor.highlight.border
                    },
                    hover: isString(inputColor.hover) ? {
                        border: inputColor.hover,
                        background: inputColor.hover
                    } : {
                        border: inputColor.hover && inputColor.hover.border || defaultColor.hover.border,
                        background: inputColor.hover && inputColor.hover.background || defaultColor.hover.background
                    }
                };
                return color;
            } else {
                var _color = {
                    background: inputColor.background || undefined,
                    border: inputColor.border || undefined,
                    highlight: isString(inputColor.highlight) ? {
                        border: inputColor.highlight,
                        background: inputColor.highlight
                    } : {
                        background: inputColor.highlight && inputColor.highlight.background || undefined,
                        border: inputColor.highlight && inputColor.highlight.border || undefined
                    },
                    hover: isString(inputColor.hover) ? {
                        border: inputColor.hover,
                        background: inputColor.hover
                    } : {
                        border: inputColor.hover && inputColor.hover.border || undefined,
                        background: inputColor.hover && inputColor.hover.background || undefined
                    }
                };
                return _color;
            }
        }
    }
    /**
     * Convert RGB \<0, 255\> into HSV object.
     *
     * @remarks
     * {@link http://www.javascripter.net/faq/rgb2hsv.htm}
     *
     * @param red - Red channel.
     * @param green - Green channel.
     * @param blue - Blue channel.
     *
     * @returns HSV color object.
     */


    function RGBToHSV(red, green, blue) {
        red = red / 255;
        green = green / 255;
        blue = blue / 255;
        var minRGB = Math.min(red, Math.min(green, blue));
        var maxRGB = Math.max(red, Math.max(green, blue)); // Black-gray-white

        if (minRGB === maxRGB) {
            return {
                h: 0,
                s: 0,
                v: minRGB
            };
        } // Colors other than black-gray-white:


        var d = red === minRGB ? green - blue : blue === minRGB ? red - green : blue - red;
        var h = red === minRGB ? 3 : blue === minRGB ? 1 : 5;
        var hue = 60 * (h - d / (maxRGB - minRGB)) / 360;
        var saturation = (maxRGB - minRGB) / maxRGB;
        var value = maxRGB;
        return {
            h: hue,
            s: saturation,
            v: value
        };
    }
    /**
     * Convert HSV \<0, 1\> into RGB color object.
     *
     * @remarks
     * {@link https://gist.github.com/mjijackson/5311256}
     *
     * @param h - Hue.
     * @param s - Saturation.
     * @param v - Value.
     *
     * @returns RGB color object.
     */


    function HSVToRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);

        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;

            case 1:
                r = q, g = v, b = p;
                break;

            case 2:
                r = p, g = v, b = t;
                break;

            case 3:
                r = p, g = q, b = v;
                break;

            case 4:
                r = t, g = p, b = v;
                break;

            case 5:
                r = v, g = p, b = q;
                break;
        }

        return {
            r: Math.floor(r * 255),
            g: Math.floor(g * 255),
            b: Math.floor(b * 255)
        };
    }
    /**
     * Convert HSV \<0, 1\> into hex color string.
     *
     * @param h - Hue.
     * @param s - Saturation.
     * @param v - Value.
     *
     * @returns Hex color string.
     */


    function HSVToHex(h, s, v) {
        var rgb = HSVToRGB(h, s, v);
        return RGBToHex(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Convert hex color string into HSV \<0, 1\>.
     *
     * @param hex - Hex color string.
     *
     * @returns HSV color object.
     */


    function hexToHSV(hex) {
        var rgb = hexToRGB(hex);

        if (!rgb) {
            throw new TypeError("'".concat(hex, "' is not a valid color."));
        }

        return RGBToHSV(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Validate hex color string.
     *
     * @param hex - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidHex(hex) {
        var isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
        return isOk;
    }
    /**
     * Validate RGB color string.
     *
     * @param rgb - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidRGB(rgb) {
        return rgbRE.test(rgb);
    }
    /**
     * Validate RGBA color string.
     *
     * @param rgba - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidRGBA(rgba) {
        return rgbaRE.test(rgba);
    }
    /**
     * This recursively redirects the prototype of JSON objects to the referenceObject.
     * This is used for default options.
     *
     * @param referenceObject - The original object.
     *
     * @returns The Element if the referenceObject is an Element, or a new object inheriting from the referenceObject.
     */


    function bridgeObject(referenceObject) {
        if (referenceObject === null || _typeof(referenceObject) !== "object") {
            return null;
        }

        if (referenceObject instanceof Element) {
            // Avoid bridging DOM objects
            return referenceObject;
        }

        var objectTo = create$2(referenceObject);

        for (var i in referenceObject) {
            if (Object.prototype.hasOwnProperty.call(referenceObject, i)) {
                if (_typeof(referenceObject[i]) == "object") {
                    objectTo[i] = bridgeObject(referenceObject[i]);
                }
            }
        }

        return objectTo;
    }
    /**
     * This is used to set the options of subobjects in the options object.
     *
     * A requirement of these subobjects is that they have an 'enabled' element
     * which is optional for the user but mandatory for the program.
     *
     * The added value here of the merge is that option 'enabled' is set as required.
     *
     * @param mergeTarget - Either this.options or the options used for the groups.
     * @param options - Options.
     * @param option - Option key in the options argument.
     * @param globalOptions - Global options, passed in to determine value of option 'enabled'.
     */


    function mergeOptions(mergeTarget, options, option) {
        var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        // Local helpers
        var isPresent = function isPresent(obj) {
            return obj !== null && obj !== undefined;
        };

        var isObject = function isObject(obj) {
            return obj !== null && _typeof(obj) === "object";
        }; // https://stackoverflow.com/a/34491287/1223531


        var isEmpty = function isEmpty(obj) {
            for (var x in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, x)) {
                    return false;
                }
            }

            return true;
        }; // Guards


        if (!isObject(mergeTarget)) {
            throw new Error("Parameter mergeTarget must be an object");
        }

        if (!isObject(options)) {
            throw new Error("Parameter options must be an object");
        }

        if (!isPresent(option)) {
            throw new Error("Parameter option must have a value");
        }

        if (!isObject(globalOptions)) {
            throw new Error("Parameter globalOptions must be an object");
        } //
        // Actual merge routine, separated from main logic
        // Only a single level of options is merged. Deeper levels are ref'd. This may actually be an issue.
        //


        var doMerge = function doMerge(target, options, option) {
            if (!isObject(target[option])) {
                target[option] = {};
            }

            var src = options[option];
            var dst = target[option];

            for (var prop in src) {
                if (Object.prototype.hasOwnProperty.call(src, prop)) {
                    dst[prop] = src[prop];
                }
            }
        }; // Local initialization


        var srcOption = options[option];
        var globalPassed = isObject(globalOptions) && !isEmpty(globalOptions);
        var globalOption = globalPassed ? globalOptions[option] : undefined;
        var globalEnabled = globalOption ? globalOption.enabled : undefined; /////////////////////////////////////////
        // Main routine
        /////////////////////////////////////////

        if (srcOption === undefined) {
            return; // Nothing to do
        }

        if (typeof srcOption === "boolean") {
            if (!isObject(mergeTarget[option])) {
                mergeTarget[option] = {};
            }

            mergeTarget[option].enabled = srcOption;
            return;
        }

        if (srcOption === null && !isObject(mergeTarget[option])) {
            // If possible, explicit copy from globals
            if (isPresent(globalOption)) {
                mergeTarget[option] = create$2(globalOption);
            } else {
                return; // Nothing to do
            }
        }

        if (!isObject(srcOption)) {
            return;
        } //
        // Ensure that 'enabled' is properly set. It is required internally
        // Note that the value from options will always overwrite the existing value
        //


        var enabled = true; // default value

        if (srcOption.enabled !== undefined) {
            enabled = srcOption.enabled;
        } else {
            // Take from globals, if present
            if (globalEnabled !== undefined) {
                enabled = globalOption.enabled;
            }
        }

        doMerge(mergeTarget, options, option);
        mergeTarget[option].enabled = enabled;
    }
    /*
	 * Easing Functions.
	 * Only considering the t value for the range [0, 1] => [0, 1].
	 *
	 * Inspiration: from http://gizma.com/easing/
	 * https://gist.github.com/gre/1650294
	 */


    var easingFunctions = {
        /**
         * Provides no easing and no acceleration.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        linear: function linear(t) {
            return t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuad: function easeInQuad(t) {
            return t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuad: function easeOutQuad(t) {
            return t * (2 - t);
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuad: function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInCubic: function easeInCubic(t) {
            return t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutCubic: function easeOutCubic(t) {
            return --t * t * t + 1;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutCubic: function easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuart: function easeInQuart(t) {
            return t * t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuart: function easeOutQuart(t) {
            return 1 - --t * t * t * t;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuart: function easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuint: function easeInQuint(t) {
            return t * t * t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuint: function easeOutQuint(t) {
            return 1 + --t * t * t * t * t;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuint: function easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
    };
    // It works only for single property objects,
    // otherwise it combines all of the types in a union.
    // export function topMost<K1 extends string, V1> (
    //   pile: Record<K1, undefined | V1>[],
    //   accessors: K1 | [K1]
    // ): undefined | V1
    // export function topMost<K1 extends string, K2 extends string, V1, V2> (
    //   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2>>[],
    //   accessors: [K1, K2]
    // ): undefined | V1 | V2
    // export function topMost<K1 extends string, K2 extends string, K3 extends string, V1, V2, V3> (
    //   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2 | Record<K3, undefined | V3>>>[],
    //   accessors: [K1, K2, K3]
    // ): undefined | V1 | V2 | V3

    /**
     * Get the top most property value from a pile of objects.
     *
     * @param pile - Array of objects, no required format.
     * @param accessors - Array of property names.
     * For example `object['foo']['bar']` → `['foo', 'bar']`.
     *
     * @returns Value of the property with given accessors path from the first pile item where it's not undefined.
     */


    function topMost(pile, accessors) {
        var candidate;

        if (!isArray(accessors)) {
            accessors = [accessors];
        }

        var _iterator3 = _createForOfIteratorHelper$8(pile),
            _step3;

        try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var member = _step3.value;

                if (member) {
                    candidate = member[accessors[0]];

                    for (var i = 1; i < accessors.length; i++) {
                        if (candidate) {
                            candidate = candidate[accessors[i]];
                        }
                    }

                    if (typeof candidate !== "undefined") {
                        break;
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally {
            _iterator3.f();
        }

        return candidate;
    }

    var htmlColors = {
        black: "#000000",
        navy: "#000080",
        darkblue: "#00008B",
        mediumblue: "#0000CD",
        blue: "#0000FF",
        darkgreen: "#006400",
        green: "#008000",
        teal: "#008080",
        darkcyan: "#008B8B",
        deepskyblue: "#00BFFF",
        darkturquoise: "#00CED1",
        mediumspringgreen: "#00FA9A",
        lime: "#00FF00",
        springgreen: "#00FF7F",
        aqua: "#00FFFF",
        cyan: "#00FFFF",
        midnightblue: "#191970",
        dodgerblue: "#1E90FF",
        lightseagreen: "#20B2AA",
        forestgreen: "#228B22",
        seagreen: "#2E8B57",
        darkslategray: "#2F4F4F",
        limegreen: "#32CD32",
        mediumseagreen: "#3CB371",
        turquoise: "#40E0D0",
        royalblue: "#4169E1",
        steelblue: "#4682B4",
        darkslateblue: "#483D8B",
        mediumturquoise: "#48D1CC",
        indigo: "#4B0082",
        darkolivegreen: "#556B2F",
        cadetblue: "#5F9EA0",
        cornflowerblue: "#6495ED",
        mediumaquamarine: "#66CDAA",
        dimgray: "#696969",
        slateblue: "#6A5ACD",
        olivedrab: "#6B8E23",
        slategray: "#708090",
        lightslategray: "#778899",
        mediumslateblue: "#7B68EE",
        lawngreen: "#7CFC00",
        chartreuse: "#7FFF00",
        aquamarine: "#7FFFD4",
        maroon: "#800000",
        purple: "#800080",
        olive: "#808000",
        gray: "#808080",
        skyblue: "#87CEEB",
        lightskyblue: "#87CEFA",
        blueviolet: "#8A2BE2",
        darkred: "#8B0000",
        darkmagenta: "#8B008B",
        saddlebrown: "#8B4513",
        darkseagreen: "#8FBC8F",
        lightgreen: "#90EE90",
        mediumpurple: "#9370D8",
        darkviolet: "#9400D3",
        palegreen: "#98FB98",
        darkorchid: "#9932CC",
        yellowgreen: "#9ACD32",
        sienna: "#A0522D",
        brown: "#A52A2A",
        darkgray: "#A9A9A9",
        lightblue: "#ADD8E6",
        greenyellow: "#ADFF2F",
        paleturquoise: "#AFEEEE",
        lightsteelblue: "#B0C4DE",
        powderblue: "#B0E0E6",
        firebrick: "#B22222",
        darkgoldenrod: "#B8860B",
        mediumorchid: "#BA55D3",
        rosybrown: "#BC8F8F",
        darkkhaki: "#BDB76B",
        silver: "#C0C0C0",
        mediumvioletred: "#C71585",
        indianred: "#CD5C5C",
        peru: "#CD853F",
        chocolate: "#D2691E",
        tan: "#D2B48C",
        lightgrey: "#D3D3D3",
        palevioletred: "#D87093",
        thistle: "#D8BFD8",
        orchid: "#DA70D6",
        goldenrod: "#DAA520",
        crimson: "#DC143C",
        gainsboro: "#DCDCDC",
        plum: "#DDA0DD",
        burlywood: "#DEB887",
        lightcyan: "#E0FFFF",
        lavender: "#E6E6FA",
        darksalmon: "#E9967A",
        violet: "#EE82EE",
        palegoldenrod: "#EEE8AA",
        lightcoral: "#F08080",
        khaki: "#F0E68C",
        aliceblue: "#F0F8FF",
        honeydew: "#F0FFF0",
        azure: "#F0FFFF",
        sandybrown: "#F4A460",
        wheat: "#F5DEB3",
        beige: "#F5F5DC",
        whitesmoke: "#F5F5F5",
        mintcream: "#F5FFFA",
        ghostwhite: "#F8F8FF",
        salmon: "#FA8072",
        antiquewhite: "#FAEBD7",
        linen: "#FAF0E6",
        lightgoldenrodyellow: "#FAFAD2",
        oldlace: "#FDF5E6",
        red: "#FF0000",
        fuchsia: "#FF00FF",
        magenta: "#FF00FF",
        deeppink: "#FF1493",
        orangered: "#FF4500",
        tomato: "#FF6347",
        hotpink: "#FF69B4",
        coral: "#FF7F50",
        darkorange: "#FF8C00",
        lightsalmon: "#FFA07A",
        orange: "#FFA500",
        lightpink: "#FFB6C1",
        pink: "#FFC0CB",
        gold: "#FFD700",
        peachpuff: "#FFDAB9",
        navajowhite: "#FFDEAD",
        moccasin: "#FFE4B5",
        bisque: "#FFE4C4",
        mistyrose: "#FFE4E1",
        blanchedalmond: "#FFEBCD",
        papayawhip: "#FFEFD5",
        lavenderblush: "#FFF0F5",
        seashell: "#FFF5EE",
        cornsilk: "#FFF8DC",
        lemonchiffon: "#FFFACD",
        floralwhite: "#FFFAF0",
        snow: "#FFFAFA",
        yellow: "#FFFF00",
        lightyellow: "#FFFFE0",
        ivory: "#FFFFF0",
        white: "#FFFFFF"
    };
    /**
     * @param {number} [pixelRatio=1]
     */

    var ColorPicker = /*#__PURE__*/function () {
        /**
         * @param {number} [pixelRatio=1]
         */
        function ColorPicker() {
            var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            _classCallCheck(this, ColorPicker);

            this.pixelRatio = pixelRatio;
            this.generated = false;
            this.centerCoordinates = {
                x: 289 / 2,
                y: 289 / 2
            };
            this.r = 289 * 0.49;
            this.color = {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            };
            this.hueCircle = undefined;
            this.initialColor = {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            };
            this.previousColor = undefined;
            this.applied = false; // bound by

            this.updateCallback = function () {};

            this.closeCallback = function () {}; // create all DOM elements


            this._create();
        }
        /**
         * this inserts the colorPicker into a div from the DOM
         *
         * @param {Element} container
         */


        _createClass(ColorPicker, [{
            key: "insertTo",
            value: function insertTo(container) {
                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                    this.hammer = undefined;
                }

                this.container = container;
                this.container.appendChild(this.frame);

                this._bindHammer();

                this._setSize();
            }
            /**
             * the callback is executed on apply and save. Bind it to the application
             *
             * @param {Function} callback
             */

        }, {
            key: "setUpdateCallback",
            value: function setUpdateCallback(callback) {
                if (typeof callback === "function") {
                    this.updateCallback = callback;
                } else {
                    throw new Error("Function attempted to set as colorPicker update callback is not a function.");
                }
            }
            /**
             * the callback is executed on apply and save. Bind it to the application
             *
             * @param {Function} callback
             */

        }, {
            key: "setCloseCallback",
            value: function setCloseCallback(callback) {
                if (typeof callback === "function") {
                    this.closeCallback = callback;
                } else {
                    throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
                }
            }
            /**
             *
             * @param {string} color
             * @returns {string}
             * @private
             */

        }, {
            key: "_isColorString",
            value: function _isColorString(color) {
                if (typeof color === "string") {
                    return htmlColors[color];
                }
            }
            /**
             * Set the color of the colorPicker
             * Supported formats:
             * 'red'                   --> HTML color string
             * '#ffffff'               --> hex string
             * 'rgb(255,255,255)'      --> rgb string
             * 'rgba(255,255,255,1.0)' --> rgba string
             * {r:255,g:255,b:255}     --> rgb object
             * {r:255,g:255,b:255,a:1.0} --> rgba object
             *
             * @param {string | object} color
             * @param {boolean} [setInitial=true]
             */

        }, {
            key: "setColor",
            value: function setColor(color) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                if (color === "none") {
                    return;
                }

                var rgba; // if a html color shorthand is used, convert to hex

                var htmlColor = this._isColorString(color);

                if (htmlColor !== undefined) {
                    color = htmlColor;
                } // check format


                if (isString(color) === true) {
                    if (isValidRGB(color) === true) {
                        var rgbaArray = color.substr(4).substr(0, color.length - 5).split(",");
                        rgba = {
                            r: rgbaArray[0],
                            g: rgbaArray[1],
                            b: rgbaArray[2],
                            a: 1.0
                        };
                    } else if (isValidRGBA(color) === true) {
                        var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(",");

                        rgba = {
                            r: _rgbaArray[0],
                            g: _rgbaArray[1],
                            b: _rgbaArray[2],
                            a: _rgbaArray[3]
                        };
                    } else if (isValidHex(color) === true) {
                        var rgbObj = hexToRGB(color);
                        rgba = {
                            r: rgbObj.r,
                            g: rgbObj.g,
                            b: rgbObj.b,
                            a: 1.0
                        };
                    }
                } else {
                    if (color instanceof Object) {
                        if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            var alpha = color.a !== undefined ? color.a : "1.0";
                            rgba = {
                                r: color.r,
                                g: color.g,
                                b: color.b,
                                a: alpha
                            };
                        }
                    }
                } // set color


                if (rgba === undefined) {
                    throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + stringify$1(color));
                } else {
                    this._setColor(rgba, setInitial);
                }
            }
            /**
             * this shows the color picker.
             * The hue circle is constructed once and stored.
             */

        }, {
            key: "show",
            value: function show() {
                if (this.closeCallback !== undefined) {
                    this.closeCallback();
                    this.closeCallback = undefined;
                }

                this.applied = false;
                this.frame.style.display = "block";

                this._generateHueCircle();
            } // ------------------------------------------ PRIVATE ----------------------------- //

            /**
             * Hide the picker. Is called by the cancel button.
             * Optional boolean to store the previous color for easy access later on.
             *
             * @param {boolean} [storePrevious=true]
             * @private
             */

        }, {
            key: "_hide",
            value: function _hide() {
                var _this2 = this;

                var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                // store the previous color for next time;
                if (storePrevious === true) {
                    this.previousColor = assign$2({}, this.color);
                }

                if (this.applied === true) {
                    this.updateCallback(this.initialColor);
                }

                this.frame.style.display = "none"; // call the closing callback, restoring the onclick method.
                // this is in a setTimeout because it will trigger the show again before the click is done.

                setTimeout$1(function () {
                    if (_this2.closeCallback !== undefined) {
                        _this2.closeCallback();

                        _this2.closeCallback = undefined;
                    }
                }, 0);
            }
            /**
             * bound to the save button. Saves and hides.
             *
             * @private
             */

        }, {
            key: "_save",
            value: function _save() {
                this.updateCallback(this.color);
                this.applied = false;

                this._hide();
            }
            /**
             * Bound to apply button. Saves but does not close. Is undone by the cancel button.
             *
             * @private
             */

        }, {
            key: "_apply",
            value: function _apply() {
                this.applied = true;
                this.updateCallback(this.color);

                this._updatePicker(this.color);
            }
            /**
             * load the color from the previous session.
             *
             * @private
             */

        }, {
            key: "_loadLast",
            value: function _loadLast() {
                if (this.previousColor !== undefined) {
                    this.setColor(this.previousColor, false);
                } else {
                    alert("There is no last color to load...");
                }
            }
            /**
             * set the color, place the picker
             *
             * @param {object} rgba
             * @param {boolean} [setInitial=true]
             * @private
             */

        }, {
            key: "_setColor",
            value: function _setColor(rgba) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                // store the initial color
                if (setInitial === true) {
                    this.initialColor = assign$2({}, rgba);
                }

                this.color = rgba;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var angleConvert = 2 * Math.PI;
                var radius = this.r * hsv.s;
                var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
                var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);
                this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + "px";
                this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + "px";

                this._updatePicker(rgba);
            }
            /**
             * bound to opacity control
             *
             * @param {number} value
             * @private
             */

        }, {
            key: "_setOpacity",
            value: function _setOpacity(value) {
                this.color.a = value / 100;

                this._updatePicker(this.color);
            }
            /**
             * bound to brightness control
             *
             * @param {number} value
             * @private
             */

        }, {
            key: "_setBrightness",
            value: function _setBrightness(value) {
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.v = value / 100;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;

                this._updatePicker();
            }
            /**
             * update the color picker. A black circle overlays the hue circle to mimic the brightness decreasing.
             *
             * @param {object} rgba
             * @private
             */

        }, {
            key: "_updatePicker",
            value: function _updatePicker() {
                var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var ctx = this.colorPickerCanvas.getContext("2d");

                if (this.pixelRation === undefined) {
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                }

                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0); // clear the canvas

                var w = this.colorPickerCanvas.clientWidth;
                var h = this.colorPickerCanvas.clientHeight;
                ctx.clearRect(0, 0, w, h);
                ctx.putImageData(this.hueCircle, 0, 0);
                ctx.fillStyle = "rgba(0,0,0," + (1 - hsv.v) + ")";
                ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);

                fill(ctx).call(ctx);

                this.brightnessRange.value = 100 * hsv.v;
                this.opacityRange.value = 100 * rgba.a;
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
            /**
             * used by create to set the size of the canvas.
             *
             * @private
             */

        }, {
            key: "_setSize",
            value: function _setSize() {
                this.colorPickerCanvas.style.width = "100%";
                this.colorPickerCanvas.style.height = "100%";
                this.colorPickerCanvas.width = 289 * this.pixelRatio;
                this.colorPickerCanvas.height = 289 * this.pixelRatio;
            }
            /**
             * create all dom elements
             * TODO: cleanup, lots of similar dom elements
             *
             * @private
             */

        }, {
            key: "_create",
            value: function _create() {
                var _context16, _context17, _context18, _context19;

                this.frame = document.createElement("div");
                this.frame.className = "vis-color-picker";
                this.colorPickerDiv = document.createElement("div");
                this.colorPickerSelector = document.createElement("div");
                this.colorPickerSelector.className = "vis-selector";
                this.colorPickerDiv.appendChild(this.colorPickerSelector);
                this.colorPickerCanvas = document.createElement("canvas");
                this.colorPickerDiv.appendChild(this.colorPickerCanvas);

                if (!this.colorPickerCanvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.colorPickerCanvas.appendChild(noCanvas);
                } else {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                }

                this.colorPickerDiv.className = "vis-color";
                this.opacityDiv = document.createElement("div");
                this.opacityDiv.className = "vis-opacity";
                this.brightnessDiv = document.createElement("div");
                this.brightnessDiv.className = "vis-brightness";
                this.arrowDiv = document.createElement("div");
                this.arrowDiv.className = "vis-arrow";
                this.opacityRange = document.createElement("input");

                try {
                    this.opacityRange.type = "range"; // Not supported on IE9

                    this.opacityRange.min = "0";
                    this.opacityRange.max = "100";
                } catch (err) {// TODO: Add some error handling.
                }

                this.opacityRange.value = "100";
                this.opacityRange.className = "vis-range";
                this.brightnessRange = document.createElement("input");

                try {
                    this.brightnessRange.type = "range"; // Not supported on IE9

                    this.brightnessRange.min = "0";
                    this.brightnessRange.max = "100";
                } catch (err) {// TODO: Add some error handling.
                }

                this.brightnessRange.value = "100";
                this.brightnessRange.className = "vis-range";
                this.opacityDiv.appendChild(this.opacityRange);
                this.brightnessDiv.appendChild(this.brightnessRange);
                var me = this;

                this.opacityRange.onchange = function () {
                    me._setOpacity(this.value);
                };

                this.opacityRange.oninput = function () {
                    me._setOpacity(this.value);
                };

                this.brightnessRange.onchange = function () {
                    me._setBrightness(this.value);
                };

                this.brightnessRange.oninput = function () {
                    me._setBrightness(this.value);
                };

                this.brightnessLabel = document.createElement("div");
                this.brightnessLabel.className = "vis-label vis-brightness";
                this.brightnessLabel.innerText = "brightness:";
                this.opacityLabel = document.createElement("div");
                this.opacityLabel.className = "vis-label vis-opacity";
                this.opacityLabel.innerText = "opacity:";
                this.newColorDiv = document.createElement("div");
                this.newColorDiv.className = "vis-new-color";
                this.newColorDiv.innerText = "new";
                this.initialColorDiv = document.createElement("div");
                this.initialColorDiv.className = "vis-initial-color";
                this.initialColorDiv.innerText = "initial";
                this.cancelButton = document.createElement("div");
                this.cancelButton.className = "vis-button vis-cancel";
                this.cancelButton.innerText = "cancel";
                this.cancelButton.onclick = bind(_context16 = this._hide).call(_context16, this, false);
                this.applyButton = document.createElement("div");
                this.applyButton.className = "vis-button vis-apply";
                this.applyButton.innerText = "apply";
                this.applyButton.onclick = bind(_context17 = this._apply).call(_context17, this);
                this.saveButton = document.createElement("div");
                this.saveButton.className = "vis-button vis-save";
                this.saveButton.innerText = "save";
                this.saveButton.onclick = bind(_context18 = this._save).call(_context18, this);
                this.loadButton = document.createElement("div");
                this.loadButton.className = "vis-button vis-load";
                this.loadButton.innerText = "load last";
                this.loadButton.onclick = bind(_context19 = this._loadLast).call(_context19, this);
                this.frame.appendChild(this.colorPickerDiv);
                this.frame.appendChild(this.arrowDiv);
                this.frame.appendChild(this.brightnessLabel);
                this.frame.appendChild(this.brightnessDiv);
                this.frame.appendChild(this.opacityLabel);
                this.frame.appendChild(this.opacityDiv);
                this.frame.appendChild(this.newColorDiv);
                this.frame.appendChild(this.initialColorDiv);
                this.frame.appendChild(this.cancelButton);
                this.frame.appendChild(this.applyButton);
                this.frame.appendChild(this.saveButton);
                this.frame.appendChild(this.loadButton);
            }
            /**
             * bind hammer to the color picker
             *
             * @private
             */

        }, {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;

                this.drag = {};
                this.pinch = {};
                this.hammer = new Hammer(this.colorPickerCanvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                this.hammer.on("hammer.input", function (event) {
                    if (event.isFirst) {
                        _this3._moveSelector(event);
                    }
                });
                this.hammer.on("tap", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panstart", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panmove", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panend", function (event) {
                    _this3._moveSelector(event);
                });
            }
            /**
             * generate the hue circle. This is relatively heavy (200ms) and is done only once on the first time it is shown.
             *
             * @private
             */

        }, {
            key: "_generateHueCircle",
            value: function _generateHueCircle() {
                if (this.generated === false) {
                    var ctx = this.colorPickerCanvas.getContext("2d");

                    if (this.pixelRation === undefined) {
                        this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    }

                    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0); // clear the canvas

                    var w = this.colorPickerCanvas.clientWidth;
                    var h = this.colorPickerCanvas.clientHeight;
                    ctx.clearRect(0, 0, w, h); // draw hue circle

                    var x, y, hue, sat;
                    this.centerCoordinates = {
                        x: w * 0.5,
                        y: h * 0.5
                    };
                    this.r = 0.49 * w;
                    var angleConvert = 2 * Math.PI / 360;
                    var hfac = 1 / 360;
                    var sfac = 1 / this.r;
                    var rgb;

                    for (hue = 0; hue < 360; hue++) {
                        for (sat = 0; sat < this.r; sat++) {
                            x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
                            y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
                            rgb = HSVToRGB(hue * hfac, sat * sfac, 1);
                            ctx.fillStyle = "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
                            ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
                        }
                    }

                    ctx.strokeStyle = "rgba(0,0,0,1)";
                    ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                    ctx.stroke();
                    this.hueCircle = ctx.getImageData(0, 0, w, h);
                }

                this.generated = true;
            }
            /**
             * move the selector. This is called by hammer functions.
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_moveSelector",
            value: function _moveSelector(event) {
                var rect = this.colorPickerDiv.getBoundingClientRect();
                var left = event.center.x - rect.left;
                var top = event.center.y - rect.top;
                var centerY = 0.5 * this.colorPickerDiv.clientHeight;
                var centerX = 0.5 * this.colorPickerDiv.clientWidth;
                var x = left - centerX;
                var y = top - centerY;
                var angle = Math.atan2(x, y);
                var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);
                var newTop = Math.cos(angle) * radius + centerY;
                var newLeft = Math.sin(angle) * radius + centerX;
                this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + "px"; // set color

                var h = angle / (2 * Math.PI);
                h = h < 0 ? h + 1 : h;
                var s = radius / this.r;
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.h = h;
                hsv.s = s;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba; // update previews

                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        }]);

        return ColorPicker;
    }();
    /**
     * Wrap given text (last argument) in HTML elements (all preceding arguments).
     *
     * @param {...any} rest - List of tag names followed by inner text.
     *
     * @returns An element or a text node.
     */


    function wrapInTag() {
        for (var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            rest[_key5] = arguments[_key5];
        }

        if (rest.length < 1) {
            throw new TypeError("Invalid arguments.");
        } else if (rest.length === 1) {
            return document.createTextNode(rest[0]);
        } else {
            var element = document.createElement(rest[0]);
            element.appendChild(wrapInTag.apply(void 0, _toConsumableArray(slice$1(rest).call(rest, 1))));
            return element;
        }
    }
    /**
     * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
     * Boolean options are recognised as Boolean
     * Number options should be written as array: [default value, min value, max value, stepsize]
     * Colors should be written as array: ['color', '#ffffff']
     * Strings with should be written as array: [option1, option2, option3, ..]
     *
     * The options are matched with their counterparts in each of the modules and the values used in the configuration are
     */


    var Configurator = /*#__PURE__*/function () {
        /**
         * @param {object} parentModule        | the location where parentModule.setOptions() can be called
         * @param {object} defaultContainer    | the default container of the module
         * @param {object} configureOptions    | the fully configured and predefined options set found in allOptions.js
         * @param {number} pixelRatio          | canvas pixel ratio
         * @param {Function} hideOption        | custom logic to dynamically hide options
         */
        function Configurator(parentModule, defaultContainer, configureOptions) {
            var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var hideOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
                return false;
            };

            _classCallCheck(this, Configurator);

            this.parent = parentModule;
            this.changedOptions = [];
            this.container = defaultContainer;
            this.allowCreation = false;
            this.hideOption = hideOption;
            this.options = {};
            this.initialized = false;
            this.popupCounter = 0;
            this.defaultOptions = {
                enabled: false,
                filter: true,
                container: undefined,
                showButton: true
            };

            assign$2(this.options, this.defaultOptions);

            this.configureOptions = configureOptions;
            this.moduleOptions = {};
            this.domElements = [];
            this.popupDiv = {};
            this.popupLimit = 5;
            this.popupHistory = {};
            this.colorPicker = new ColorPicker(pixelRatio);
            this.wrapper = undefined;
        }
        /**
         * refresh all options.
         * Because all modules parse their options by themselves, we just use their options. We copy them here.
         *
         * @param {object} options
         */


        _createClass(Configurator, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // reset the popup history because the indices may have been changed.
                    this.popupHistory = {};

                    this._removePopup();

                    var enabled = true;

                    if (typeof options === "string") {
                        this.options.filter = options;
                    } else if (isArray(options)) {
                        this.options.filter = options.join();
                    } else if (_typeof(options) === "object") {
                        if (options == null) {
                            throw new TypeError("options cannot be null");
                        }

                        if (options.container !== undefined) {
                            this.options.container = options.container;
                        }

                        if (filter(options) !== undefined) {
                            this.options.filter = filter(options);
                        }

                        if (options.showButton !== undefined) {
                            this.options.showButton = options.showButton;
                        }

                        if (options.enabled !== undefined) {
                            enabled = options.enabled;
                        }
                    } else if (typeof options === "boolean") {
                        this.options.filter = true;
                        enabled = options;
                    } else if (typeof options === "function") {
                        this.options.filter = options;
                        enabled = true;
                    }

                    if (filter(this.options) === false) {
                        enabled = false;
                    }

                    this.options.enabled = enabled;
                }

                this._clean();
            }
            /**
             *
             * @param {object} moduleOptions
             */

        }, {
            key: "setModuleOptions",
            value: function setModuleOptions(moduleOptions) {
                this.moduleOptions = moduleOptions;

                if (this.options.enabled === true) {
                    this._clean();

                    if (this.options.container !== undefined) {
                        this.container = this.options.container;
                    }

                    this._create();
                }
            }
            /**
             * Create all DOM elements
             *
             * @private
             */

        }, {
            key: "_create",
            value: function _create() {
                this._clean();

                this.changedOptions = [];

                var filter$1 = filter(this.options);

                var counter = 0;
                var show = false;

                for (var _option in this.configureOptions) {
                    if (Object.prototype.hasOwnProperty.call(this.configureOptions, _option)) {
                        this.allowCreation = false;
                        show = false;

                        if (typeof filter$1 === "function") {
                            show = filter$1(_option, []);
                            show = show || this._handleObject(this.configureOptions[_option], [_option], true);
                        } else if (filter$1 === true || indexOf(filter$1).call(filter$1, _option) !== -1) {
                            show = true;
                        }

                        if (show !== false) {
                            this.allowCreation = true; // linebreak between categories

                            if (counter > 0) {
                                this._makeItem([]);
                            } // a header for the category


                            this._makeHeader(_option); // get the sub options


                            this._handleObject(this.configureOptions[_option], [_option]);
                        }

                        counter++;
                    }
                }

                this._makeButton();

                this._push(); //~ this.colorPicker.insertTo(this.container);

            }
            /**
             * draw all DOM elements on the screen
             *
             * @private
             */

        }, {
            key: "_push",
            value: function _push() {
                this.wrapper = document.createElement("div");
                this.wrapper.className = "vis-configuration-wrapper";
                this.container.appendChild(this.wrapper);

                for (var i = 0; i < this.domElements.length; i++) {
                    this.wrapper.appendChild(this.domElements[i]);
                }

                this._showPopupIfNeeded();
            }
            /**
             * delete all DOM elements
             *
             * @private
             */

        }, {
            key: "_clean",
            value: function _clean() {
                for (var i = 0; i < this.domElements.length; i++) {
                    this.wrapper.removeChild(this.domElements[i]);
                }

                if (this.wrapper !== undefined) {
                    this.container.removeChild(this.wrapper);
                    this.wrapper = undefined;
                }

                this.domElements = [];

                this._removePopup();
            }
            /**
             * get the value from the actualOptions if it exists
             *
             * @param {Array} path    | where to look for the actual option
             * @returns {*}
             * @private
             */

        }, {
            key: "_getValue",
            value: function _getValue(path) {
                var base = this.moduleOptions;

                for (var i = 0; i < path.length; i++) {
                    if (base[path[i]] !== undefined) {
                        base = base[path[i]];
                    } else {
                        base = undefined;
                        break;
                    }
                }

                return base;
            }
            /**
             * all option elements are wrapped in an item
             *
             * @param {Array} path    | where to look for the actual option
             * @param {Array.<Element>} domElements
             * @returns {number}
             * @private
             */

        }, {
            key: "_makeItem",
            value: function _makeItem(path) {
                if (this.allowCreation === true) {
                    var item = document.createElement("div");
                    item.className = "vis-configuration vis-config-item vis-config-s" + path.length;

                    for (var _len6 = arguments.length, domElements = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                        domElements[_key6 - 1] = arguments[_key6];
                    }

                    forEach$2(domElements).call(domElements, function (element) {
                        item.appendChild(element);
                    });

                    this.domElements.push(item);
                    return this.domElements.length;
                }

                return 0;
            }
            /**
             * header for major subjects
             *
             * @param {string} name
             * @private
             */

        }, {
            key: "_makeHeader",
            value: function _makeHeader(name) {
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-header";
                div.innerText = name;

                this._makeItem([], div);
            }
            /**
             * make a label, if it is an object label, it gets different styling.
             *
             * @param {string} name
             * @param {Array} path    | where to look for the actual option
             * @param {string} objectLabel
             * @returns {HTMLElement}
             * @private
             */

        }, {
            key: "_makeLabel",
            value: function _makeLabel(name, path) {
                var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-label vis-config-s" + path.length;

                if (objectLabel === true) {
                    while (div.firstChild) {
                        div.removeChild(div.firstChild);
                    }

                    div.appendChild(wrapInTag("i", "b", name));
                } else {
                    div.innerText = name + ":";
                }

                return div;
            }
            /**
             * make a dropdown list for multiple possible string optoins
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeDropdown",
            value: function _makeDropdown(arr, value, path) {
                var select = document.createElement("select");
                select.className = "vis-configuration vis-config-select";
                var selectedValue = 0;

                if (value !== undefined) {
                    if (indexOf(arr).call(arr, value) !== -1) {
                        selectedValue = indexOf(arr).call(arr, value);
                    }
                }

                for (var i = 0; i < arr.length; i++) {
                    var _option2 = document.createElement("option");

                    _option2.value = arr[i];

                    if (i === selectedValue) {
                        _option2.selected = "selected";
                    }

                    _option2.innerText = arr[i];
                    select.appendChild(_option2);
                }

                var me = this;

                select.onchange = function () {
                    me._update(this.value, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, select);
            }
            /**
             * make a range object for numeric options
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeRange",
            value: function _makeRange(arr, value, path) {
                var defaultValue = arr[0];
                var min = arr[1];
                var max = arr[2];
                var step = arr[3];
                var range = document.createElement("input");
                range.className = "vis-configuration vis-config-range";

                try {
                    range.type = "range"; // not supported on IE9

                    range.min = min;
                    range.max = max;
                } catch (err) {// TODO: Add some error handling.
                }

                range.step = step; // set up the popup settings in case they are needed.

                var popupString = "";
                var popupValue = 0;

                if (value !== undefined) {
                    var factor = 1.2;

                    if (value < 0 && value * factor < min) {
                        range.min = Math.ceil(value * factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    } else if (value / factor < min) {
                        range.min = Math.ceil(value / factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    }

                    if (value * factor > max && max !== 1) {
                        range.max = Math.ceil(value * factor);
                        popupValue = range.max;
                        popupString = "range increased";
                    }

                    range.value = value;
                } else {
                    range.value = defaultValue;
                }

                var input = document.createElement("input");
                input.className = "vis-configuration vis-config-rangeinput";
                input.value = range.value;
                var me = this;

                range.onchange = function () {
                    input.value = this.value;

                    me._update(Number(this.value), path);
                };

                range.oninput = function () {
                    input.value = this.value;
                };

                var label = this._makeLabel(path[path.length - 1], path);

                var itemIndex = this._makeItem(path, label, range, input); // if a popup is needed AND it has not been shown for this value, show it.


                if (popupString !== "" && this.popupHistory[itemIndex] !== popupValue) {
                    this.popupHistory[itemIndex] = popupValue;

                    this._setupPopup(popupString, itemIndex);
                }
            }
            /**
             * make a button object
             *
             * @private
             */

        }, {
            key: "_makeButton",
            value: function _makeButton() {
                var _this4 = this;

                if (this.options.showButton === true) {
                    var generateButton = document.createElement("div");
                    generateButton.className = "vis-configuration vis-config-button";
                    generateButton.innerText = "generate options";

                    generateButton.onclick = function () {
                        _this4._printOptions();
                    };

                    generateButton.onmouseover = function () {
                        generateButton.className = "vis-configuration vis-config-button hover";
                    };

                    generateButton.onmouseout = function () {
                        generateButton.className = "vis-configuration vis-config-button";
                    };

                    this.optionsContainer = document.createElement("div");
                    this.optionsContainer.className = "vis-configuration vis-config-option-container";
                    this.domElements.push(this.optionsContainer);
                    this.domElements.push(generateButton);
                }
            }
            /**
             * prepare the popup
             *
             * @param {string} string
             * @param {number} index
             * @private
             */

        }, {
            key: "_setupPopup",
            value: function _setupPopup(string, index) {
                var _this5 = this;

                if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
                    var div = document.createElement("div");
                    div.id = "vis-configuration-popup";
                    div.className = "vis-configuration-popup";
                    div.innerText = string;

                    div.onclick = function () {
                        _this5._removePopup();
                    };

                    this.popupCounter += 1;
                    this.popupDiv = {
                        html: div,
                        index: index
                    };
                }
            }
            /**
             * remove the popup from the dom
             *
             * @private
             */

        }, {
            key: "_removePopup",
            value: function _removePopup() {
                if (this.popupDiv.html !== undefined) {
                    this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
                    clearTimeout(this.popupDiv.hideTimeout);
                    clearTimeout(this.popupDiv.deleteTimeout);
                    this.popupDiv = {};
                }
            }
            /**
             * Show the popup if it is needed.
             *
             * @private
             */

        }, {
            key: "_showPopupIfNeeded",
            value: function _showPopupIfNeeded() {
                var _this6 = this;

                if (this.popupDiv.html !== undefined) {
                    var correspondingElement = this.domElements[this.popupDiv.index];
                    var rect = correspondingElement.getBoundingClientRect();
                    this.popupDiv.html.style.left = rect.left + "px";
                    this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;

                    document.body.appendChild(this.popupDiv.html);
                    this.popupDiv.hideTimeout = setTimeout$1(function () {
                        _this6.popupDiv.html.style.opacity = 0;
                    }, 1500);
                    this.popupDiv.deleteTimeout = setTimeout$1(function () {
                        _this6._removePopup();
                    }, 1800);
                }
            }
            /**
             * make a checkbox for boolean options.
             *
             * @param {number} defaultValue
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeCheckbox",
            value: function _makeCheckbox(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "vis-configuration vis-config-checkbox";
                checkbox.checked = defaultValue;

                if (value !== undefined) {
                    checkbox.checked = value;

                    if (value !== defaultValue) {
                        if (_typeof(defaultValue) === "object") {
                            if (value !== defaultValue.enabled) {
                                this.changedOptions.push({
                                    path: path,
                                    value: value
                                });
                            }
                        } else {
                            this.changedOptions.push({
                                path: path,
                                value: value
                            });
                        }
                    }
                }

                var me = this;

                checkbox.onchange = function () {
                    me._update(this.checked, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, checkbox);
            }
            /**
             * make a text input field for string options.
             *
             * @param {number} defaultValue
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeTextInput",
            value: function _makeTextInput(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "text";
                checkbox.className = "vis-configuration vis-config-text";
                checkbox.value = value;

                if (value !== defaultValue) {
                    this.changedOptions.push({
                        path: path,
                        value: value
                    });
                }

                var me = this;

                checkbox.onchange = function () {
                    me._update(this.value, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, checkbox);
            }
            /**
             * make a color field with a color picker for color fields
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeColorField",
            value: function _makeColorField(arr, value, path) {
                var _this7 = this;

                var defaultColor = arr[1];
                var div = document.createElement("div");
                value = value === undefined ? defaultColor : value;

                if (value !== "none") {
                    div.className = "vis-configuration vis-config-colorBlock";
                    div.style.backgroundColor = value;
                } else {
                    div.className = "vis-configuration vis-config-colorBlock none";
                }

                value = value === undefined ? defaultColor : value;

                div.onclick = function () {
                    _this7._showColorPicker(value, div, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, div);
            }
            /**
             * used by the color buttons to call the color picker.
             *
             * @param {number} value
             * @param {HTMLElement} div
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_showColorPicker",
            value: function _showColorPicker(value, div, path) {
                var _this8 = this;

                // clear the callback from this div
                div.onclick = function () {};

                this.colorPicker.insertTo(div);
                this.colorPicker.show();
                this.colorPicker.setColor(value);
                this.colorPicker.setUpdateCallback(function (color) {
                    var colorString = "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
                    div.style.backgroundColor = colorString;

                    _this8._update(colorString, path);
                }); // on close of the colorpicker, restore the callback.

                this.colorPicker.setCloseCallback(function () {
                    div.onclick = function () {
                        _this8._showColorPicker(value, div, path);
                    };
                });
            }
            /**
             * parse an object and draw the correct items
             *
             * @param {object} obj
             * @param {Array} [path=[]]    | where to look for the actual option
             * @param {boolean} [checkOnly=false]
             * @returns {boolean}
             * @private
             */

        }, {
            key: "_handleObject",
            value: function _handleObject(obj) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var show = false;

                var filter$1 = filter(this.options);

                var visibleInSet = false;

                for (var subObj in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, subObj)) {
                        show = true;
                        var item = obj[subObj];
                        var newPath = copyAndExtendArray(path, subObj);

                        if (typeof filter$1 === "function") {
                            show = filter$1(subObj, path); // if needed we must go deeper into the object.

                            if (show === false) {
                                if (!isArray(item) && typeof item !== "string" && typeof item !== "boolean" && item instanceof Object) {
                                    this.allowCreation = false;
                                    show = this._handleObject(item, newPath, true);
                                    this.allowCreation = checkOnly === false;
                                }
                            }
                        }

                        if (show !== false) {
                            visibleInSet = true;

                            var value = this._getValue(newPath);

                            if (isArray(item)) {
                                this._handleArray(item, value, newPath);
                            } else if (typeof item === "string") {
                                this._makeTextInput(item, value, newPath);
                            } else if (typeof item === "boolean") {
                                this._makeCheckbox(item, value, newPath);
                            } else if (item instanceof Object) {
                                // skip the options that are not enabled
                                if (!this.hideOption(path, subObj, this.moduleOptions)) {
                                    // initially collapse options with an disabled enabled option.
                                    if (item.enabled !== undefined) {
                                        var enabledPath = copyAndExtendArray(newPath, "enabled");

                                        var enabledValue = this._getValue(enabledPath);

                                        if (enabledValue === true) {
                                            var label = this._makeLabel(subObj, newPath, true);

                                            this._makeItem(newPath, label);

                                            visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                        } else {
                                            this._makeCheckbox(item, enabledValue, newPath);
                                        }
                                    } else {
                                        var _label = this._makeLabel(subObj, newPath, true);

                                        this._makeItem(newPath, _label);

                                        visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                    }
                                }
                            } else {
                                console.error("dont know how to handle", item, subObj, newPath);
                            }
                        }
                    }
                }

                return visibleInSet;
            }
            /**
             * handle the array type of option
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_handleArray",
            value: function _handleArray(arr, value, path) {
                if (typeof arr[0] === "string" && arr[0] === "color") {
                    this._makeColorField(arr, value, path);

                    if (arr[1] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                } else if (typeof arr[0] === "string") {
                    this._makeDropdown(arr, value, path);

                    if (arr[0] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                } else if (typeof arr[0] === "number") {
                    this._makeRange(arr, value, path);

                    if (arr[0] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: Number(value)
                        });
                    }
                }
            }
            /**
             * called to update the network with the new settings.
             *
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_update",
            value: function _update(value, path) {
                var options = this._constructOptions(value, path);

                if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) {
                    this.parent.body.emitter.emit("configChange", options);
                }

                this.initialized = true;
                this.parent.setOptions(options);
            }
            /**
             *
             * @param {string | boolean} value
             * @param {Array.<string>} path
             * @param {{}} optionsObj
             * @returns {{}}
             * @private
             */

        }, {
            key: "_constructOptions",
            value: function _constructOptions(value, path) {
                var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pointer = optionsObj; // when dropdown boxes can be string or boolean, we typecast it into correct types

                value = value === "true" ? true : value;
                value = value === "false" ? false : value;

                for (var i = 0; i < path.length; i++) {
                    if (path[i] !== "global") {
                        if (pointer[path[i]] === undefined) {
                            pointer[path[i]] = {};
                        }

                        if (i !== path.length - 1) {
                            pointer = pointer[path[i]];
                        } else {
                            pointer[path[i]] = value;
                        }
                    }
                }

                return optionsObj;
            }
            /**
             * @private
             */

        }, {
            key: "_printOptions",
            value: function _printOptions() {
                var options = this.getOptions();

                while (this.optionsContainer.firstChild) {
                    this.optionsContainer.removeChild(this.optionsContainer.firstChild);
                }

                this.optionsContainer.appendChild(wrapInTag("pre", "const options = " + stringify$1(options, null, 2)));
            }
            /**
             *
             * @returns {{}} options
             */

        }, {
            key: "getOptions",
            value: function getOptions() {
                var options = {};

                for (var i = 0; i < this.changedOptions.length; i++) {
                    this._constructOptions(this.changedOptions[i].value, this.changedOptions[i].path, options);
                }

                return options;
            }
        }]);

        return Configurator;
    }();
    /**
     * Popup is a class to create a popup window with some text
     */


    var Popup = /*#__PURE__*/function () {
        /**
         * @param {Element} container       The container object.
         * @param {string}  overflowMethod  How the popup should act to overflowing ('flip' or 'cap')
         */
        function Popup(container, overflowMethod) {
            _classCallCheck(this, Popup);

            this.container = container;
            this.overflowMethod = overflowMethod || "cap";
            this.x = 0;
            this.y = 0;
            this.padding = 5;
            this.hidden = false; // create the frame

            this.frame = document.createElement("div");
            this.frame.className = "vis-tooltip";
            this.container.appendChild(this.frame);
        }
        /**
         * @param {number} x   Horizontal position of the popup window
         * @param {number} y   Vertical position of the popup window
         */


        _createClass(Popup, [{
            key: "setPosition",
            value: function setPosition(x, y) {
                this.x = _parseInt(x);
                this.y = _parseInt(y);
            }
            /**
             * Set the content for the popup window. This can be HTML code or text.
             *
             * @param {string | Element} content
             */

        }, {
            key: "setText",
            value: function setText(content) {
                if (content instanceof Element) {
                    while (this.frame.firstChild) {
                        this.frame.removeChild(this.frame.firstChild);
                    }

                    this.frame.appendChild(content);
                } else {
                    // String containing literal text, element has to be used for HTML due to
                    // XSS risks associated with innerHTML (i.e. prevent XSS by accident).
                    this.frame.innerText = content;
                }
            }
            /**
             * Show the popup window
             *
             * @param {boolean} [doShow]    Show or hide the window
             */

        }, {
            key: "show",
            value: function show(doShow) {
                if (doShow === undefined) {
                    doShow = true;
                }

                if (doShow === true) {
                    var height = this.frame.clientHeight;
                    var width = this.frame.clientWidth;
                    var maxHeight = this.frame.parentNode.clientHeight;
                    var maxWidth = this.frame.parentNode.clientWidth;
                    var left = 0,
                        top = 0;

                    if (this.overflowMethod == "flip") {
                        var isLeft = false,
                            isTop = true; // Where around the position it's located

                        if (this.y - height < this.padding) {
                            isTop = false;
                        }

                        if (this.x + width > maxWidth - this.padding) {
                            isLeft = true;
                        }

                        if (isLeft) {
                            left = this.x - width;
                        } else {
                            left = this.x;
                        }

                        if (isTop) {
                            top = this.y - height;
                        } else {
                            top = this.y;
                        }
                    } else {
                        top = this.y - height;

                        if (top + height + this.padding > maxHeight) {
                            top = maxHeight - height - this.padding;
                        }

                        if (top < this.padding) {
                            top = this.padding;
                        }

                        left = this.x;

                        if (left + width + this.padding > maxWidth) {
                            left = maxWidth - width - this.padding;
                        }

                        if (left < this.padding) {
                            left = this.padding;
                        }
                    }

                    this.frame.style.left = left + "px";
                    this.frame.style.top = top + "px";
                    this.frame.style.visibility = "visible";
                    this.hidden = false;
                } else {
                    this.hide();
                }
            }
            /**
             * Hide the popup window
             */

        }, {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                this.frame.style.left = "0";
                this.frame.style.top = "0";
                this.frame.style.visibility = "hidden";
            }
            /**
             * Remove the popup window
             */

        }, {
            key: "destroy",
            value: function destroy() {
                this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
            }
        }]);

        return Popup;
    }();

    var errorFound = false;
    var allOptions$1;
    var VALIDATOR_PRINT_STYLE = "background: #FFeeee; color: #dd0000";
    /**
     *  Used to validate options.
     */

    var Validator = /*#__PURE__*/function () {
        function Validator() {
            _classCallCheck(this, Validator);
        }

        _createClass(Validator, null, [{
            key: "validate",
            value:
                /**
                 * Main function to be called
                 *
                 * @param {object} options
                 * @param {object} referenceOptions
                 * @param {object} subObject
                 * @returns {boolean}
                 * @static
                 */
                function validate(options, referenceOptions, subObject) {
                    errorFound = false;
                    allOptions$1 = referenceOptions;
                    var usedOptions = referenceOptions;

                    if (subObject !== undefined) {
                        usedOptions = referenceOptions[subObject];
                    }

                    Validator.parse(options, usedOptions, []);
                    return errorFound;
                }
            /**
             * Will traverse an object recursively and check every value
             *
             * @param {object} options
             * @param {object} referenceOptions
             * @param {Array} path    | where to look for the actual option
             * @static
             */

        }, {
            key: "parse",
            value: function parse(options, referenceOptions, path) {
                for (var _option3 in options) {
                    if (Object.prototype.hasOwnProperty.call(options, _option3)) {
                        Validator.check(_option3, options, referenceOptions, path);
                    }
                }
            }
            /**
             * Check every value. If the value is an object, call the parse function on that object.
             *
             * @param {string} option
             * @param {object} options
             * @param {object} referenceOptions
             * @param {Array} path    | where to look for the actual option
             * @static
             */

        }, {
            key: "check",
            value: function check(option, options, referenceOptions, path) {
                if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
                    Validator.getSuggestion(option, referenceOptions, path);
                    return;
                }

                var referenceOption = option;
                var is_object = true;

                if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
                    // NOTE: This only triggers if the __any__ is in the top level of the options object.
                    //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
                    // TODO: Examine if needed, remove if possible
                    // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
                    referenceOption = "__any__"; // if the any-subgroup is not a predefined object in the configurator,
                    // we do not look deeper into the object.

                    is_object = Validator.getType(options[option]) === "object";
                }

                var refOptionObj = referenceOptions[referenceOption];

                if (is_object && refOptionObj.__type__ !== undefined) {
                    refOptionObj = refOptionObj.__type__;
                }

                Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
            }
            /**
             *
             * @param {string}  option           | the option property
             * @param {object}  options          | The supplied options object
             * @param {object}  referenceOptions | The reference options containing all options and their allowed formats
             * @param {string}  referenceOption  | Usually this is the same as option, except when handling an __any__ tag.
             * @param {string}  refOptionObj     | This is the type object from the reference options
             * @param {Array}   path             | where in the object is the option
             * @static
             */

        }, {
            key: "checkFields",
            value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
                var log = function log(message) {
                    console.error("%c" + message + Validator.printLocation(path, option), VALIDATOR_PRINT_STYLE);
                };

                var optionType = Validator.getType(options[option]);
                var refOptionType = refOptionObj[optionType];

                if (refOptionType !== undefined) {
                    // if the type is correct, we check if it is supposed to be one of a few select values
                    if (Validator.getType(refOptionType) === "array" && indexOf(refOptionType).call(refOptionType, options[option]) === -1) {
                        log('Invalid option detected in "' + option + '".' + " Allowed values are:" + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
                        errorFound = true;
                    } else if (optionType === "object" && referenceOption !== "__any__") {
                        path = copyAndExtendArray(path, option);
                        Validator.parse(options[option], referenceOptions[referenceOption], path);
                    }
                } else if (refOptionObj["any"] === undefined) {
                    // type of the field is incorrect and the field cannot be any
                    log('Invalid type received for "' + option + '". Expected: ' + Validator.print(keys$3(refOptionObj)) + ". Received [" + optionType + '] "' + options[option] + '"');
                    errorFound = true;
                }
            }
            /**
             *
             * @param {object | boolean | number | string | Array.<number> | Date | Node | Moment | undefined | null} object
             * @returns {string}
             * @static
             */

        }, {
            key: "getType",
            value: function getType(object) {
                var type = _typeof(object);

                if (type === "object") {
                    if (object === null) {
                        return "null";
                    }

                    if (object instanceof Boolean) {
                        return "boolean";
                    }

                    if (object instanceof Number) {
                        return "number";
                    }

                    if (object instanceof String) {
                        return "string";
                    }

                    if (isArray(object)) {
                        return "array";
                    }

                    if (object instanceof Date) {
                        return "date";
                    }

                    if (object.nodeType !== undefined) {
                        return "dom";
                    }

                    if (object._isAMomentObject === true) {
                        return "moment";
                    }

                    return "object";
                } else if (type === "number") {
                    return "number";
                } else if (type === "boolean") {
                    return "boolean";
                } else if (type === "string") {
                    return "string";
                } else if (type === undefined) {
                    return "undefined";
                }

                return type;
            }
            /**
             * @param {string} option
             * @param {object} options
             * @param {Array.<string>} path
             * @static
             */

        }, {
            key: "getSuggestion",
            value: function getSuggestion(option, options, path) {
                var localSearch = Validator.findInOptions(option, options, path, false);
                var globalSearch = Validator.findInOptions(option, allOptions$1, [], true);
                var localSearchThreshold = 8;
                var globalSearchThreshold = 4;
                var msg;

                if (localSearch.indexMatch !== undefined) {
                    msg = " in " + Validator.printLocation(localSearch.path, option, "") + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
                } else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) {
                    msg = " in " + Validator.printLocation(localSearch.path, option, "") + "Perhaps it was misplaced? Matching option found at: " + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, "");
                } else if (localSearch.distance <= localSearchThreshold) {
                    msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
                } else {
                    msg = ". Did you mean one of these: " + Validator.print(keys$3(options)) + Validator.printLocation(path, option);
                }

                console.error('%cUnknown option detected: "' + option + '"' + msg, VALIDATOR_PRINT_STYLE);
                errorFound = true;
            }
            /**
             * traverse the options in search for a match.
             *
             * @param {string} option
             * @param {object} options
             * @param {Array} path    | where to look for the actual option
             * @param {boolean} [recursive=false]
             * @returns {{closestMatch: string, path: Array, distance: number}}
             * @static
             */

        }, {
            key: "findInOptions",
            value: function findInOptions(option, options, path) {
                var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var min = 1e9;
                var closestMatch = "";
                var closestMatchPath = [];
                var lowerCaseOption = option.toLowerCase();
                var indexMatch = undefined;

                for (var op in options) {
                    var distance = void 0;

                    if (options[op].__type__ !== undefined && recursive === true) {
                        var result = Validator.findInOptions(option, options[op], copyAndExtendArray(path, op));

                        if (min > result.distance) {
                            closestMatch = result.closestMatch;
                            closestMatchPath = result.path;
                            min = result.distance;
                            indexMatch = result.indexMatch;
                        }
                    } else {
                        var _context20;

                        if (indexOf(_context20 = op.toLowerCase()).call(_context20, lowerCaseOption) !== -1) {
                            indexMatch = op;
                        }

                        distance = Validator.levenshteinDistance(option, op);

                        if (min > distance) {
                            closestMatch = op;
                            closestMatchPath = copyArray(path);
                            min = distance;
                        }
                    }
                }

                return {
                    closestMatch: closestMatch,
                    path: closestMatchPath,
                    distance: min,
                    indexMatch: indexMatch
                };
            }
            /**
             * @param {Array.<string>} path
             * @param {object} option
             * @param {string} prefix
             * @returns {string}
             * @static
             */

        }, {
            key: "printLocation",
            value: function printLocation(path, option) {
                var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Problem value found at: \n";
                var str = "\n\n" + prefix + "options = {\n";

                for (var i = 0; i < path.length; i++) {
                    for (var j = 0; j < i + 1; j++) {
                        str += "  ";
                    }

                    str += path[i] + ": {\n";
                }

                for (var _j = 0; _j < path.length + 1; _j++) {
                    str += "  ";
                }

                str += option + "\n";

                for (var _i3 = 0; _i3 < path.length + 1; _i3++) {
                    for (var _j2 = 0; _j2 < path.length - _i3; _j2++) {
                        str += "  ";
                    }

                    str += "}\n";
                }

                return str + "\n\n";
            }
            /**
             * @param {object} options
             * @returns {string}
             * @static
             */

        }, {
            key: "print",
            value: function print(options) {
                return stringify$1(options).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
            }
            /**
             *  Compute the edit distance between the two given strings
             * http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript
             *
             * Copyright (c) 2011 Andrei Mackenzie
             *
             * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
             *
             * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
             *
             * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
             *
             * @param {string} a
             * @param {string} b
             * @returns {Array.<Array.<number>>}}
             * @static
             */

        }, {
            key: "levenshteinDistance",
            value: function levenshteinDistance(a, b) {
                if (a.length === 0) return b.length;
                if (b.length === 0) return a.length;
                var matrix = []; // increment along the first column of each row

                var i;

                for (i = 0; i <= b.length; i++) {
                    matrix[i] = [i];
                } // increment each column in the first row


                var j;

                for (j = 0; j <= a.length; j++) {
                    matrix[0][j] = j;
                } // Fill in the rest of the matrix


                for (i = 1; i <= b.length; i++) {
                    for (j = 1; j <= a.length; j++) {
                        if (b.charAt(i - 1) == a.charAt(j - 1)) {
                            matrix[i][j] = matrix[i - 1][j - 1];
                        } else {
                            matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                                Math.min(matrix[i][j - 1] + 1, // insertion
                                    matrix[i - 1][j] + 1)); // deletion
                        }
                    }
                }

                return matrix[b.length][a.length];
            }
        }]);

        return Validator;
    }();

    var Activator$1 = Activator;
    var Configurator$1 = Configurator;
    var Hammer$1 = Hammer;
    var Popup$1 = Popup;
    var VALIDATOR_PRINT_STYLE$1 = VALIDATOR_PRINT_STYLE;
    var Validator$1 = Validator;

    /* eslint-disable no-prototype-builtins */

    /* eslint-disable no-unused-vars */

    /* eslint-disable no-var */

    /**
     * Parse a text source containing data in DOT language into a JSON object.
     * The object contains two lists: one with nodes and one with edges.
     *
     * DOT language reference: http://www.graphviz.org/doc/info/lang.html
     *
     * DOT language attributes: http://graphviz.org/content/attrs
     *
     * @param {string} data     Text containing a graph in DOT-notation
     * @returns {object} graph   An object containing two parameters:
     *                          {Object[]} nodes
     *                          {Object[]} edges
     *
     * -------------------------------------------
     * TODO
     * ====
     *
     * For label handling, this is an incomplete implementation. From docs (quote #3015):
     *
     * > the escape sequences "\n", "\l" and "\r" divide the label into lines, centered,
     * > left-justified, and right-justified, respectively.
     *
     * Source: http://www.graphviz.org/content/attrs#kescString
     *
     * > As another aid for readability, dot allows double-quoted strings to span multiple physical
     * > lines using the standard C convention of a backslash immediately preceding a newline
     * > character
     * > In addition, double-quoted strings can be concatenated using a '+' operator.
     * > As HTML strings can contain newline characters, which are used solely for formatting,
     * > the language does not allow escaped newlines or concatenation operators to be used
     * > within them.
     *
     * - Currently, only '\\n' is handled
     * - Note that text explicitly says 'labels'; the dot parser currently handles escape
     *   sequences in **all** strings.
     */
    function parseDOT(data) {
        dot = data;
        return parseGraph();
    } // mapping of attributes from DOT (the keys) to vis.js (the values)

    var NODE_ATTR_MAPPING = {
        fontsize: "font.size",
        fontcolor: "font.color",
        labelfontcolor: "font.color",
        fontname: "font.face",
        color: ["color.border", "color.background"],
        fillcolor: "color.background",
        tooltip: "title",
        labeltooltip: "title"
    };

    var EDGE_ATTR_MAPPING = create$2(NODE_ATTR_MAPPING);

    EDGE_ATTR_MAPPING.color = "color.color";
    EDGE_ATTR_MAPPING.style = "dashes"; // token types enumeration

    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        IDENTIFIER: 2,
        UNKNOWN: 3
    }; // map with all delimiters

    var DELIMITERS = {
        "{": true,
        "}": true,
        "[": true,
        "]": true,
        ";": true,
        "=": true,
        ",": true,
        "->": true,
        "--": true
    };
    var dot = ""; // current dot file

    var index$1 = 0; // current index in dot file

    var c = ""; // current token character in expr

    var token = ""; // current token

    var tokenType = TOKENTYPE.NULL; // type of the token

    /**
     * Get the first character from the dot file.
     * The character is stored into the char c. If the end of the dot file is
     * reached, the function puts an empty string in c.
     */

    function first() {
        index$1 = 0;
        c = dot.charAt(0);
    }
    /**
     * Get the next character from the dot file.
     * The character is stored into the char c. If the end of the dot file is
     * reached, the function puts an empty string in c.
     */


    function next() {
        index$1++;
        c = dot.charAt(index$1);
    }
    /**
     * Preview the next character from the dot file.
     *
     * @returns {string} cNext
     */


    function nextPreview() {
        return dot.charAt(index$1 + 1);
    }
    /**
     * Test whether given character is alphabetic or numeric ( a-zA-Z_0-9.:# )
     *
     * @param {string} c
     * @returns {boolean} isAlphaNumeric
     */


    function isAlphaNumeric(c) {
        var charCode = c.charCodeAt(0);

        if (charCode < 47) {
            // #.
            return charCode === 35 || charCode === 46;
        }

        if (charCode < 59) {
            // 0-9 and :
            return charCode > 47;
        }

        if (charCode < 91) {
            // A-Z
            return charCode > 64;
        }

        if (charCode < 96) {
            // _
            return charCode === 95;
        }

        if (charCode < 123) {
            // a-z
            return charCode > 96;
        }

        return false;
    }
    /**
     * Merge all options of object b into object b
     *
     * @param {object} a
     * @param {object} b
     * @returns {object} a
     */


    function merge(a, b) {
        if (!a) {
            a = {};
        }

        if (b) {
            for (var name in b) {
                if (b.hasOwnProperty(name)) {
                    a[name] = b[name];
                }
            }
        }

        return a;
    }
    /**
     * Set a value in an object, where the provided parameter name can be a
     * path with nested parameters. For example:
     *
     *     var obj = {a: 2};
     *     setValue(obj, 'b.c', 3);     // obj = {a: 2, b: {c: 3}}
     *
     * @param {object} obj
     * @param {string} path  A parameter name or dot-separated parameter path,
     *                      like "color.highlight.border".
     * @param {*} value
     */


    function setValue(obj, path, value) {
        var keys = path.split(".");
        var o = obj;

        while (keys.length) {
            var key = keys.shift();

            if (keys.length) {
                // this isn't the end point
                if (!o[key]) {
                    o[key] = {};
                }

                o = o[key];
            } else {
                // this is the end point
                o[key] = value;
            }
        }
    }
    /**
     * Add a node to a graph object. If there is already a node with
     * the same id, their attributes will be merged.
     *
     * @param {object} graph
     * @param {object} node
     */


    function addNode(graph, node) {
        var i, len;
        var current = null; // find root graph (in case of subgraph)

        var graphs = [graph]; // list with all graphs from current graph to root graph

        var root = graph;

        while (root.parent) {
            graphs.push(root.parent);
            root = root.parent;
        } // find existing node (at root level) by its id


        if (root.nodes) {
            for (i = 0, len = root.nodes.length; i < len; i++) {
                if (node.id === root.nodes[i].id) {
                    current = root.nodes[i];
                    break;
                }
            }
        }

        if (!current) {
            // this is a new node
            current = {
                id: node.id
            };

            if (graph.node) {
                // clone default attributes
                current.attr = merge(current.attr, graph.node);
            }
        } // add node to this (sub)graph and all its parent graphs


        for (i = graphs.length - 1; i >= 0; i--) {
            var _context;

            var g = graphs[i];

            if (!g.nodes) {
                g.nodes = [];
            }

            if (indexOf(_context = g.nodes).call(_context, current) === -1) {
                g.nodes.push(current);
            }
        } // merge attributes


        if (node.attr) {
            current.attr = merge(current.attr, node.attr);
        }
    }
    /**
     * Add an edge to a graph object
     *
     * @param {object} graph
     * @param {object} edge
     */


    function addEdge(graph, edge) {
        if (!graph.edges) {
            graph.edges = [];
        }

        graph.edges.push(edge);

        if (graph.edge) {
            var attr = merge({}, graph.edge); // clone default attributes

            edge.attr = merge(attr, edge.attr); // merge attributes
        }
    }
    /**
     * Create an edge to a graph object
     *
     * @param {object} graph
     * @param {string | number | object} from
     * @param {string | number | object} to
     * @param {string} type
     * @param {object | null} attr
     * @returns {object} edge
     */


    function createEdge(graph, from, to, type, attr) {
        var edge = {
            from: from,
            to: to,
            type: type
        };

        if (graph.edge) {
            edge.attr = merge({}, graph.edge); // clone default attributes
        }

        edge.attr = merge(edge.attr || {}, attr); // merge attributes
        // Move arrows attribute from attr to edge temporally created in
        // parseAttributeList().

        if (attr != null) {
            if (attr.hasOwnProperty("arrows") && attr["arrows"] != null) {
                edge["arrows"] = {
                    to: {
                        enabled: true,
                        type: attr.arrows.type
                    }
                };
                attr["arrows"] = null;
            }
        }

        return edge;
    }
    /**
     * Get next token in the current dot file.
     * The token and token type are available as token and tokenType
     */


    function getToken() {
        tokenType = TOKENTYPE.NULL;
        token = ""; // skip over whitespaces

        while (c === " " || c === "\t" || c === "\n" || c === "\r") {
            // space, tab, enter
            next();
        }

        do {
            var isComment = false; // skip comment

            if (c === "#") {
                // find the previous non-space character
                var i = index$1 - 1;

                while (dot.charAt(i) === " " || dot.charAt(i) === "\t") {
                    i--;
                }

                if (dot.charAt(i) === "\n" || dot.charAt(i) === "") {
                    // the # is at the start of a line, this is indeed a line comment
                    while (c != "" && c != "\n") {
                        next();
                    }

                    isComment = true;
                }
            }

            if (c === "/" && nextPreview() === "/") {
                // skip line comment
                while (c != "" && c != "\n") {
                    next();
                }

                isComment = true;
            }

            if (c === "/" && nextPreview() === "*") {
                // skip block comment
                while (c != "") {
                    if (c === "*" && nextPreview() === "/") {
                        // end of block comment found. skip these last two characters
                        next();
                        next();
                        break;
                    } else {
                        next();
                    }
                }

                isComment = true;
            } // skip over whitespaces


            while (c === " " || c === "\t" || c === "\n" || c === "\r") {
                // space, tab, enter
                next();
            }
        } while (isComment); // check for end of dot file


        if (c === "") {
            // token is still empty
            tokenType = TOKENTYPE.DELIMITER;
            return;
        } // check for delimiters consisting of 2 characters


        var c2 = c + nextPreview();

        if (DELIMITERS[c2]) {
            tokenType = TOKENTYPE.DELIMITER;
            token = c2;
            next();
            next();
            return;
        } // check for delimiters consisting of 1 character


        if (DELIMITERS[c]) {
            tokenType = TOKENTYPE.DELIMITER;
            token = c;
            next();
            return;
        } // check for an identifier (number or string)
        // TODO: more precise parsing of numbers/strings (and the port separator ':')


        if (isAlphaNumeric(c) || c === "-") {
            token += c;
            next();

            while (isAlphaNumeric(c)) {
                token += c;
                next();
            }

            if (token === "false") {
                token = false; // convert to boolean
            } else if (token === "true") {
                token = true; // convert to boolean
            } else if (!isNaN(Number(token))) {
                token = Number(token); // convert to number
            }

            tokenType = TOKENTYPE.IDENTIFIER;
            return;
        } // check for a string enclosed by double quotes


        if (c === '"') {
            next();

            while (c != "" && (c != '"' || c === '"' && nextPreview() === '"')) {
                if (c === '"') {
                    // skip the escape character
                    token += c;
                    next();
                } else if (c === "\\" && nextPreview() === "n") {
                    // Honor a newline escape sequence
                    token += "\n";
                    next();
                } else {
                    token += c;
                }

                next();
            }

            if (c != '"') {
                throw newSyntaxError('End of string " expected');
            }

            next();
            tokenType = TOKENTYPE.IDENTIFIER;
            return;
        } // something unknown is found, wrong characters, a syntax error


        tokenType = TOKENTYPE.UNKNOWN;

        while (c != "") {
            token += c;
            next();
        }

        throw new SyntaxError('Syntax error in part "' + chop(token, 30) + '"');
    }
    /**
     * Parse a graph.
     *
     * @returns {object} graph
     */


    function parseGraph() {
        var graph = {};
        first();
        getToken(); // optional strict keyword

        if (token === "strict") {
            graph.strict = true;
            getToken();
        } // graph or digraph keyword


        if (token === "graph" || token === "digraph") {
            graph.type = token;
            getToken();
        } // optional graph id


        if (tokenType === TOKENTYPE.IDENTIFIER) {
            graph.id = token;
            getToken();
        } // open angle bracket


        if (token != "{") {
            throw newSyntaxError("Angle bracket { expected");
        }

        getToken(); // statements

        parseStatements(graph); // close angle bracket

        if (token != "}") {
            throw newSyntaxError("Angle bracket } expected");
        }

        getToken(); // end of file

        if (token !== "") {
            throw newSyntaxError("End of file expected");
        }

        getToken(); // remove temporary default options

        delete graph.node;
        delete graph.edge;
        delete graph.graph;
        return graph;
    }
    /**
     * Parse a list with statements.
     *
     * @param {object} graph
     */


    function parseStatements(graph) {
        while (token !== "" && token != "}") {
            parseStatement(graph);

            if (token === ";") {
                getToken();
            }
        }
    }
    /**
     * Parse a single statement. Can be a an attribute statement, node
     * statement, a series of node statements and edge statements, or a
     * parameter.
     *
     * @param {object} graph
     */


    function parseStatement(graph) {
        // parse subgraph
        var subgraph = parseSubgraph(graph);

        if (subgraph) {
            // edge statements
            parseEdge(graph, subgraph);
            return;
        } // parse an attribute statement


        var attr = parseAttributeStatement(graph);

        if (attr) {
            return;
        } // parse node


        if (tokenType != TOKENTYPE.IDENTIFIER) {
            throw newSyntaxError("Identifier expected");
        }

        var id = token; // id can be a string or a number

        getToken();

        if (token === "=") {
            // id statement
            getToken();

            if (tokenType != TOKENTYPE.IDENTIFIER) {
                throw newSyntaxError("Identifier expected");
            }

            graph[id] = token;
            getToken(); // TODO: implement comma separated list with "a_list: ID=ID [','] [a_list] "
        } else {
            parseNodeStatement(graph, id);
        }
    }
    /**
     * Parse a subgraph
     *
     * @param {object} graph    parent graph object
     * @returns {object | null} subgraph
     */


    function parseSubgraph(graph) {
        var subgraph = null; // optional subgraph keyword

        if (token === "subgraph") {
            subgraph = {};
            subgraph.type = "subgraph";
            getToken(); // optional graph id

            if (tokenType === TOKENTYPE.IDENTIFIER) {
                subgraph.id = token;
                getToken();
            }
        } // open angle bracket


        if (token === "{") {
            getToken();

            if (!subgraph) {
                subgraph = {};
            }

            subgraph.parent = graph;
            subgraph.node = graph.node;
            subgraph.edge = graph.edge;
            subgraph.graph = graph.graph; // statements

            parseStatements(subgraph); // close angle bracket

            if (token != "}") {
                throw newSyntaxError("Angle bracket } expected");
            }

            getToken(); // remove temporary default options

            delete subgraph.node;
            delete subgraph.edge;
            delete subgraph.graph;
            delete subgraph.parent; // register at the parent graph

            if (!graph.subgraphs) {
                graph.subgraphs = [];
            }

            graph.subgraphs.push(subgraph);
        }

        return subgraph;
    }
    /**
     * parse an attribute statement like "node [shape=circle fontSize=16]".
     * Available keywords are 'node', 'edge', 'graph'.
     * The previous list with default attributes will be replaced
     *
     * @param {object} graph
     * @returns {string | null} keyword Returns the name of the parsed attribute
     *                                  (node, edge, graph), or null if nothing
     *                                  is parsed.
     */


    function parseAttributeStatement(graph) {
        // attribute statements
        if (token === "node") {
            getToken(); // node attributes

            graph.node = parseAttributeList();
            return "node";
        } else if (token === "edge") {
            getToken(); // edge attributes

            graph.edge = parseAttributeList();
            return "edge";
        } else if (token === "graph") {
            getToken(); // graph attributes

            graph.graph = parseAttributeList();
            return "graph";
        }

        return null;
    }
    /**
     * parse a node statement
     *
     * @param {object} graph
     * @param {string | number} id
     */


    function parseNodeStatement(graph, id) {
        // node statement
        var node = {
            id: id
        };
        var attr = parseAttributeList();

        if (attr) {
            node.attr = attr;
        }

        addNode(graph, node); // edge statements

        parseEdge(graph, id);
    }
    /**
     * Parse an edge or a series of edges
     *
     * @param {object} graph
     * @param {string | number} from        Id of the from node
     */


    function parseEdge(graph, from) {
        while (token === "->" || token === "--") {
            var to;
            var type = token;
            getToken();
            var subgraph = parseSubgraph(graph);

            if (subgraph) {
                to = subgraph;
            } else {
                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Identifier or subgraph expected");
                }

                to = token;
                addNode(graph, {
                    id: to
                });
                getToken();
            } // parse edge attributes


            var attr = parseAttributeList(); // create edge

            var edge = createEdge(graph, from, to, type, attr);
            addEdge(graph, edge);
            from = to;
        }
    }
    /**
     * Parse a set with attributes,
     * for example [label="1.000", shape=solid]
     *
     * @returns {object | null} attr
     */


    function parseAttributeList() {
        var i;
        var attr = null; // edge styles of dot and vis

        var edgeStyles = {
            dashed: true,
            solid: false,
            dotted: [1, 5]
        };
        /**
         * Define arrow types.
         * vis currently supports types defined in 'arrowTypes'.
         * Details of arrow shapes are described in
         * http://www.graphviz.org/content/arrow-shapes
         */

        var arrowTypes = {
            dot: "circle",
            box: "box",
            crow: "crow",
            curve: "curve",
            icurve: "inv_curve",
            normal: "triangle",
            inv: "inv_triangle",
            diamond: "diamond",
            tee: "bar",
            vee: "vee"
        };
        /**
         * 'attr_list' contains attributes for checking if some of them are affected
         * later. For instance, both of 'arrowhead' and 'dir' (edge style defined
         * in DOT) make changes to 'arrows' attribute in vis.
         */

        var attr_list = new Array();
        var attr_names = new Array(); // used for checking the case.
        // parse attributes

        while (token === "[") {
            getToken();
            attr = {};

            while (token !== "" && token != "]") {
                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Attribute name expected");
                }

                var name = token;
                getToken();

                if (token != "=") {
                    throw newSyntaxError("Equal sign = expected");
                }

                getToken();

                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Attribute value expected");
                }

                var value = token; // convert from dot style to vis

                if (name === "style") {
                    value = edgeStyles[value];
                }

                var arrowType;

                if (name === "arrowhead") {
                    arrowType = arrowTypes[value];
                    name = "arrows";
                    value = {
                        to: {
                            enabled: true,
                            type: arrowType
                        }
                    };
                }

                if (name === "arrowtail") {
                    arrowType = arrowTypes[value];
                    name = "arrows";
                    value = {
                        from: {
                            enabled: true,
                            type: arrowType
                        }
                    };
                }

                attr_list.push({
                    attr: attr,
                    name: name,
                    value: value
                });
                attr_names.push(name);
                getToken();

                if (token == ",") {
                    getToken();
                }
            }

            if (token != "]") {
                throw newSyntaxError("Bracket ] expected");
            }

            getToken();
        }
        /**
         * As explained in [1], graphviz has limitations for combination of
         * arrow[head|tail] and dir. If attribute list includes 'dir',
         * following cases just be supported.
         *   1. both or none + arrowhead, arrowtail
         *   2. forward + arrowhead (arrowtail is not affedted)
         *   3. back + arrowtail (arrowhead is not affected)
         * [1] https://www.graphviz.org/doc/info/attrs.html#h:undir_note
         */


        if (includes(attr_names).call(attr_names, "dir")) {
            var idx = {}; // get index of 'arrows' and 'dir'

            idx.arrows = {};

            for (i = 0; i < attr_list.length; i++) {
                if (attr_list[i].name === "arrows") {
                    if (attr_list[i].value.to != null) {
                        idx.arrows.to = i;
                    } else if (attr_list[i].value.from != null) {
                        idx.arrows.from = i;
                    } else {
                        throw newSyntaxError("Invalid value of arrows");
                    }
                } else if (attr_list[i].name === "dir") {
                    idx.dir = i;
                }
            } // first, add default arrow shape if it is not assigned to avoid error


            var dir_type = attr_list[idx.dir].value;

            if (!includes(attr_names).call(attr_names, "arrows")) {
                if (dir_type === "both") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            to: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.to = attr_list.length - 1;
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            from: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.from = attr_list.length - 1;
                } else if (dir_type === "forward") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            to: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.to = attr_list.length - 1;
                } else if (dir_type === "back") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            from: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.from = attr_list.length - 1;
                } else if (dir_type === "none") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: ""
                    });
                    idx.arrows.to = attr_list.length - 1;
                } else {
                    throw newSyntaxError('Invalid dir type "' + dir_type + '"');
                }
            }

            var from_type;
            var to_type; // update 'arrows' attribute from 'dir'.

            if (dir_type === "both") {
                // both of shapes of 'from' and 'to' are given
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };

                    splice(attr_list).call(attr_list, idx.arrows.from, 1); // shape of 'to' is assigned and use default to 'from'

                } else if (idx.arrows.to) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "arrow";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // only shape of 'from' is assigned and use default for 'to'
                } else if (idx.arrows.from) {
                    to_type = "arrow";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }
            } else if (dir_type === "back") {
                // given both of shapes, but use only 'from'
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = "";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // given shape of 'to', but does not use it
                } else if (idx.arrows.to) {
                    to_type = "";
                    from_type = "arrow";
                    idx.arrows.from = idx.arrows.to;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // assign given 'from' shape
                } else if (idx.arrows.from) {
                    to_type = "";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }

                attr_list[idx.arrows.from] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        from: {
                            enabled: true,
                            type: attr_list[idx.arrows.from].value.from.type
                        }
                    }
                };
            } else if (dir_type === "none") {
                var idx_arrow;

                if (idx.arrows.to) {
                    idx_arrow = idx.arrows.to;
                } else {
                    idx_arrow = idx.arrows.from;
                }

                attr_list[idx_arrow] = {
                    attr: attr_list[idx_arrow].attr,
                    name: attr_list[idx_arrow].name,
                    value: ""
                };
            } else if (dir_type === "forward") {
                // given both of shapes, but use only 'to'
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // assign given 'to' shape
                } else if (idx.arrows.to) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // given shape of 'from', but does not use it
                } else if (idx.arrows.from) {
                    to_type = "arrow";
                    from_type = "";
                    idx.arrows.to = idx.arrows.from;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }

                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: attr_list[idx.arrows.to].value.to.type
                        }
                    }
                };
            } else {
                throw newSyntaxError('Invalid dir type "' + dir_type + '"');
            } // remove 'dir' attribute no need anymore


            splice(attr_list).call(attr_list, idx.dir, 1);
        } // parse 'penwidth'


        var nof_attr_list;

        if (includes(attr_names).call(attr_names, "penwidth")) {
            var tmp_attr_list = [];
            nof_attr_list = attr_list.length;

            for (i = 0; i < nof_attr_list; i++) {
                // exclude 'width' from attr_list if 'penwidth' exists
                if (attr_list[i].name !== "width") {
                    if (attr_list[i].name === "penwidth") {
                        attr_list[i].name = "width";
                    }

                    tmp_attr_list.push(attr_list[i]);
                }
            }

            attr_list = tmp_attr_list;
        }

        nof_attr_list = attr_list.length;

        for (i = 0; i < nof_attr_list; i++) {
            setValue(attr_list[i].attr, attr_list[i].name, attr_list[i].value);
        }

        return attr;
    }
    /**
     * Create a syntax error with extra information on current token and index.
     *
     * @param {string} message
     * @returns {SyntaxError} err
     */


    function newSyntaxError(message) {
        return new SyntaxError(message + ', got "' + chop(token, 30) + '" (char ' + index$1 + ")");
    }
    /**
     * Chop off text after a maximum length
     *
     * @param {string} text
     * @param {number} maxLength
     * @returns {string}
     */


    function chop(text, maxLength) {
        return text.length <= maxLength ? text : text.substr(0, 27) + "...";
    }
    /**
     * Execute a function fn for each pair of elements in two arrays
     *
     * @param {Array | *} array1
     * @param {Array | *} array2
     * @param {Function} fn
     */


    function forEach2(array1, array2, fn) {
        if (isArray(array1)) {
            forEach$2(array1).call(array1, function (elem1) {
                if (isArray(array2)) {
                    forEach$2(array2).call(array2, function (elem2) {
                        fn(elem1, elem2);
                    });
                } else {
                    fn(elem1, array2);
                }
            });
        } else {
            if (isArray(array2)) {
                forEach$2(array2).call(array2, function (elem2) {
                    fn(array1, elem2);
                });
            } else {
                fn(array1, array2);
            }
        }
    }
    /**
     * Set a nested property on an object
     * When nested objects are missing, they will be created.
     * For example setProp({}, 'font.color', 'red') will return {font: {color: 'red'}}
     *
     * @param {object} object
     * @param {string} path   A dot separated string like 'font.color'
     * @param {*} value       Value for the property
     * @returns {object} Returns the original object, allows for chaining.
     */


    function setProp(object, path, value) {
        var names = path.split(".");
        var prop = names.pop(); // traverse over the nested objects

        var obj = object;

        for (var i = 0; i < names.length; i++) {
            var name = names[i];

            if (!(name in obj)) {
                obj[name] = {};
            }

            obj = obj[name];
        } // set the property value


        obj[prop] = value;
        return object;
    }
    /**
     * Convert an object with DOT attributes to their vis.js equivalents.
     *
     * @param {object} attr     Object with DOT attributes
     * @param {object} mapping
     * @returns {object}         Returns an object with vis.js attributes
     */


    function convertAttr(attr, mapping) {
        var converted = {};

        for (var prop in attr) {
            if (attr.hasOwnProperty(prop)) {
                var visProp = mapping[prop];

                if (isArray(visProp)) {
                    forEach$2(visProp).call(visProp, function (visPropI) {
                        setProp(converted, visPropI, attr[prop]);
                    });
                } else if (typeof visProp === "string") {
                    setProp(converted, visProp, attr[prop]);
                } else {
                    setProp(converted, prop, attr[prop]);
                }
            }
        }

        return converted;
    }
    /**
     * Convert a string containing a graph in DOT language into a map containing
     * with nodes and edges in the format of graph.
     *
     * @param {string} data         Text containing a graph in DOT-notation
     * @returns {object} graphData
     */


    function DOTToGraph(data) {
        // parse the DOT file
        var dotData = parseDOT(data);
        var graphData = {
            nodes: [],
            edges: [],
            options: {}
        }; // copy the nodes

        if (dotData.nodes) {
            var _context2;

            forEach$2(_context2 = dotData.nodes).call(_context2, function (dotNode) {
                var graphNode = {
                    id: dotNode.id,
                    label: String(dotNode.label || dotNode.id)
                };
                merge(graphNode, convertAttr(dotNode.attr, NODE_ATTR_MAPPING));

                if (graphNode.image) {
                    graphNode.shape = "image";
                }

                graphData.nodes.push(graphNode);
            });
        } // copy the edges


        if (dotData.edges) {
            var _context3;

            /**
             * Convert an edge in DOT format to an edge with VisGraph format
             *
             * @param {object} dotEdge
             * @returns {object} graphEdge
             */
            var convertEdge = function convertEdge(dotEdge) {
                var graphEdge = {
                    from: dotEdge.from,
                    to: dotEdge.to
                };
                merge(graphEdge, convertAttr(dotEdge.attr, EDGE_ATTR_MAPPING)); // Add arrows attribute to default styled arrow.
                // The reason why default style is not added in parseAttributeList() is
                // because only default is cleared before here.

                if (graphEdge.arrows == null && dotEdge.type === "->") {
                    graphEdge.arrows = "to";
                }

                return graphEdge;
            };

            forEach$2(_context3 = dotData.edges).call(_context3, function (dotEdge) {
                var from, to;

                if (dotEdge.from instanceof Object) {
                    from = dotEdge.from.nodes;
                } else {
                    from = {
                        id: dotEdge.from
                    };
                }

                if (dotEdge.to instanceof Object) {
                    to = dotEdge.to.nodes;
                } else {
                    to = {
                        id: dotEdge.to
                    };
                }

                if (dotEdge.from instanceof Object && dotEdge.from.edges) {
                    var _context4;

                    forEach$2(_context4 = dotEdge.from.edges).call(_context4, function (subEdge) {
                        var graphEdge = convertEdge(subEdge);
                        graphData.edges.push(graphEdge);
                    });
                }

                forEach2(from, to, function (from, to) {
                    var subEdge = createEdge(graphData, from.id, to.id, dotEdge.type, dotEdge.attr);
                    var graphEdge = convertEdge(subEdge);
                    graphData.edges.push(graphEdge);
                });

                if (dotEdge.to instanceof Object && dotEdge.to.edges) {
                    var _context5;

                    forEach$2(_context5 = dotEdge.to.edges).call(_context5, function (subEdge) {
                        var graphEdge = convertEdge(subEdge);
                        graphData.edges.push(graphEdge);
                    });
                }
            });
        } // copy the options


        if (dotData.attr) {
            graphData.options = dotData.attr;
        }

        return graphData;
    }
    /* eslint-enable no-var */

    /* eslint-enable no-unused-vars */

    /* eslint-enable no-prototype-builtins */

    var dotparser = /*#__PURE__*/Object.freeze({
        __proto__: null,
        parseDOT: parseDOT,
        DOTToGraph: DOTToGraph
    });

    /**
     * Convert Gephi to Vis.
     *
     * @param gephiJSON - The parsed JSON data in Gephi format.
     * @param optionsObj - Additional options.
     *
     * @returns The converted data ready to be used in Vis.
     */
    function parseGephi(gephiJSON, optionsObj) {
        var _context;

        var options = {
            edges: {
                inheritColor: false
            },
            nodes: {
                fixed: false,
                parseColor: false
            }
        };

        if (optionsObj != null) {
            if (optionsObj.fixed != null) {
                options.nodes.fixed = optionsObj.fixed;
            }

            if (optionsObj.parseColor != null) {
                options.nodes.parseColor = optionsObj.parseColor;
            }

            if (optionsObj.inheritColor != null) {
                options.edges.inheritColor = optionsObj.inheritColor;
            }
        }

        var gEdges = gephiJSON.edges;

        var vEdges = map$3(gEdges).call(gEdges, function (gEdge) {
            var vEdge = {
                from: gEdge.source,
                id: gEdge.id,
                to: gEdge.target
            };

            if (gEdge.attributes != null) {
                vEdge.attributes = gEdge.attributes;
            }

            if (gEdge.label != null) {
                vEdge.label = gEdge.label;
            }

            if (gEdge.attributes != null && gEdge.attributes.title != null) {
                vEdge.title = gEdge.attributes.title;
            }

            if (gEdge.type === "Directed") {
                vEdge.arrows = "to";
            } // edge['value'] = gEdge.attributes != null ? gEdge.attributes.Weight : undefined;
            // edge['width'] = edge['value'] != null ? undefined : edgegEdge.size;


            if (gEdge.color && options.edges.inheritColor === false) {
                vEdge.color = gEdge.color;
            }

            return vEdge;
        });

        var vNodes = map$3(_context = gephiJSON.nodes).call(_context, function (gNode) {
            var vNode = {
                id: gNode.id,
                fixed: options.nodes.fixed && gNode.x != null && gNode.y != null
            };

            if (gNode.attributes != null) {
                vNode.attributes = gNode.attributes;
            }

            if (gNode.label != null) {
                vNode.label = gNode.label;
            }

            if (gNode.size != null) {
                vNode.size = gNode.size;
            }

            if (gNode.attributes != null && gNode.attributes.title != null) {
                vNode.title = gNode.attributes.title;
            }

            if (gNode.title != null) {
                vNode.title = gNode.title;
            }

            if (gNode.x != null) {
                vNode.x = gNode.x;
            }

            if (gNode.y != null) {
                vNode.y = gNode.y;
            }

            if (gNode.color != null) {
                if (options.nodes.parseColor === true) {
                    vNode.color = gNode.color;
                } else {
                    vNode.color = {
                        background: gNode.color,
                        border: gNode.color,
                        highlight: {
                            background: gNode.color,
                            border: gNode.color
                        },
                        hover: {
                            background: gNode.color,
                            border: gNode.color
                        }
                    };
                }
            }

            return vNode;
        });

        return {
            nodes: vNodes,
            edges: vEdges
        };
    }

    var gephiParser = /*#__PURE__*/Object.freeze({
        __proto__: null,
        parseGephi: parseGephi
    });

    // English
    var en = {
        addDescription: "Click in an empty space to place a new node.",
        addEdge: "Add Edge",
        addNode: "Add Node",
        back: "Back",
        close: "Close",
        createEdgeError: "Cannot link edges to a cluster.",
        del: "Delete selected",
        deleteClusterError: "Clusters cannot be deleted.",
        edgeDescription: "Click on a node and drag the edge to another node to connect them.",
        edit: "Edit",
        editClusterError: "Clusters cannot be edited.",
        editEdge: "Edit Edge",
        editEdgeDescription: "Click on the control points and drag them to a node to connect to it.",
        editNode: "Edit Node"
    }; // German

    var de = {
        addDescription: "Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.",
        addEdge: "Kante hinzuf\xFCgen",
        addNode: "Knoten hinzuf\xFCgen",
        back: "Zur\xFCck",
        close: "Schließen",
        createEdgeError: "Es ist nicht m\xF6glich, Kanten mit Clustern zu verbinden.",
        del: "L\xF6sche Auswahl",
        deleteClusterError: "Cluster k\xF6nnen nicht gel\xF6scht werden.",
        edgeDescription: "Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.",
        edit: "Editieren",
        editClusterError: "Cluster k\xF6nnen nicht editiert werden.",
        editEdge: "Kante editieren",
        editEdgeDescription: "Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.",
        editNode: "Knoten editieren"
    }; // Spanish

    var es = {
        addDescription: "Haga clic en un lugar vac\xEDo para colocar un nuevo nodo.",
        addEdge: "A\xF1adir arista",
        addNode: "A\xF1adir nodo",
        back: "Atr\xE1s",
        close: "Cerrar",
        createEdgeError: "No se puede conectar una arista a un grupo.",
        del: "Eliminar selecci\xF3n",
        deleteClusterError: "No es posible eliminar grupos.",
        edgeDescription: "Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.",
        edit: "Editar",
        editClusterError: "No es posible editar grupos.",
        editEdge: "Editar arista",
        editEdgeDescription: "Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.",
        editNode: "Editar nodo"
    }; //Italiano

    var it = {
        addDescription: "Clicca per aggiungere un nuovo nodo",
        addEdge: "Aggiungi un vertice",
        addNode: "Aggiungi un nodo",
        back: "Indietro",
        close: "Chiudere",
        createEdgeError: "Non si possono collegare vertici ad un cluster",
        del: "Cancella la selezione",
        deleteClusterError: "I cluster non possono essere cancellati",
        edgeDescription: "Clicca su un nodo e trascinalo ad un altro nodo per connetterli.",
        edit: "Modifica",
        editClusterError: "I clusters non possono essere modificati.",
        editEdge: "Modifica il vertice",
        editEdgeDescription: "Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.",
        editNode: "Modifica il nodo"
    }; // Dutch

    var nl = {
        addDescription: "Klik op een leeg gebied om een nieuwe node te maken.",
        addEdge: "Link toevoegen",
        addNode: "Node toevoegen",
        back: "Terug",
        close: "Sluiten",
        createEdgeError: "Kan geen link maken naar een cluster.",
        del: "Selectie verwijderen",
        deleteClusterError: "Clusters kunnen niet worden verwijderd.",
        edgeDescription: "Klik op een node en sleep de link naar een andere node om ze te verbinden.",
        edit: "Wijzigen",
        editClusterError: "Clusters kunnen niet worden aangepast.",
        editEdge: "Link wijzigen",
        editEdgeDescription: "Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.",
        editNode: "Node wijzigen"
    }; // Portuguese Brazil

    var pt = {
        addDescription: "Clique em um espaço em branco para adicionar um novo nó",
        addEdge: "Adicionar aresta",
        addNode: "Adicionar nó",
        back: "Voltar",
        close: "Fechar",
        createEdgeError: "Não foi possível linkar arestas a um cluster.",
        del: "Remover selecionado",
        deleteClusterError: "Clusters não puderam ser removidos.",
        edgeDescription: "Clique em um nó e arraste a aresta até outro nó para conectá-los",
        edit: "Editar",
        editClusterError: "Clusters não puderam ser editados.",
        editEdge: "Editar aresta",
        editEdgeDescription: "Clique nos pontos de controle e os arraste para um nó para conectá-los",
        editNode: "Editar nó"
    }; // Russian

    var ru = {
        addDescription: "Кликните в свободное место, чтобы добавить новый узел.",
        addEdge: "Добавить ребро",
        addNode: "Добавить узел",
        back: "Назад",
        close: "Закрывать",
        createEdgeError: "Невозможно соединить ребра в кластер.",
        del: "Удалить выбранное",
        deleteClusterError: "Кластеры не могут быть удалены",
        edgeDescription: "Кликните на узел и протяните ребро к другому узлу, чтобы соединить их.",
        edit: "Редактировать",
        editClusterError: "Кластеры недоступны для редактирования.",
        editEdge: "Редактировать ребро",
        editEdgeDescription: "Кликните на контрольные точки и перетащите их в узел, чтобы подключиться к нему.",
        editNode: "Редактировать узел"
    }; // Chinese

    var cn = {
        addDescription: "单击空白处放置新节点。",
        addEdge: "添加连接线",
        addNode: "添加节点",
        back: "返回",
        close: "關閉",
        createEdgeError: "无法将连接线连接到群集。",
        del: "删除选定",
        deleteClusterError: "无法删除群集。",
        edgeDescription: "单击某个节点并将该连接线拖动到另一个节点以连接它们。",
        edit: "编辑",
        editClusterError: "无法编辑群集。",
        editEdge: "编辑连接线",
        editEdgeDescription: "单击控制节点并将它们拖到节点上连接。",
        editNode: "编辑节点"
    }; // Ukrainian

    var uk = {
        addDescription: "Kлікніть на вільне місце, щоб додати новий вузол.",
        addEdge: "Додати край",
        addNode: "Додати вузол",
        back: "Назад",
        close: "Закрити",
        createEdgeError: "Не можливо об'єднати краї в групу.",
        del: "Видалити обране",
        deleteClusterError: "Групи не можуть бути видалені.",
        edgeDescription: "Клікніть на вузол і перетягніть край до іншого вузла, щоб їх з'єднати.",
        edit: "Редагувати",
        editClusterError: "Групи недоступні для редагування.",
        editEdge: "Редагувати край",
        editEdgeDescription: "Клікніть на контрольні точки і перетягніть їх у вузол, щоб підключитися до нього.",
        editNode: "Редагувати вузол"
    }; // French

    var fr = {
        addDescription: "Cliquez dans un endroit vide pour placer un nœud.",
        addEdge: "Ajouter un lien",
        addNode: "Ajouter un nœud",
        back: "Retour",
        close: "Fermer",
        createEdgeError: "Impossible de créer un lien vers un cluster.",
        del: "Effacer la sélection",
        deleteClusterError: "Les clusters ne peuvent pas être effacés.",
        edgeDescription: "Cliquez sur un nœud et glissez le lien vers un autre nœud pour les connecter.",
        edit: "Éditer",
        editClusterError: "Les clusters ne peuvent pas être édités.",
        editEdge: "Éditer le lien",
        editEdgeDescription: "Cliquez sur les points de contrôle et glissez-les pour connecter un nœud.",
        editNode: "Éditer le nœud"
    }; // Czech

    var cs = {
        addDescription: "Kluknutím do prázdného prostoru můžete přidat nový vrchol.",
        addEdge: "Přidat hranu",
        addNode: "Přidat vrchol",
        back: "Zpět",
        close: "Zavřít",
        createEdgeError: "Nelze připojit hranu ke shluku.",
        del: "Smazat výběr",
        deleteClusterError: "Nelze mazat shluky.",
        edgeDescription: "Přetažením z jednoho vrcholu do druhého můžete spojit tyto vrcholy novou hranou.",
        edit: "Upravit",
        editClusterError: "Nelze upravovat shluky.",
        editEdge: "Upravit hranu",
        editEdgeDescription: "Přetažením kontrolního vrcholu hrany ji můžete připojit k jinému vrcholu.",
        editNode: "Upravit vrchol"
    };

    var locales = /*#__PURE__*/Object.freeze({
        __proto__: null,
        en: en,
        de: de,
        es: es,
        it: it,
        nl: nl,
        pt: pt,
        ru: ru,
        cn: cn,
        uk: uk,
        fr: fr,
        cs: cs
    });

    /**
     * Normalizes language code into the format used internally.
     *
     * @param locales - All the available locales.
     * @param rawCode - The original code as supplied by the user.
     *
     * @returns Language code in the format language-COUNTRY or language, eventually
     * fallbacks to en.
     */
    function normalizeLanguageCode(locales, rawCode) {
        try {
            var _rawCode$split = rawCode.split(/[-_ /]/, 2),
                _rawCode$split2 = _slicedToArray(_rawCode$split, 2),
                rawLanguage = _rawCode$split2[0],
                rawCountry = _rawCode$split2[1];

            var language = rawLanguage != null ? rawLanguage.toLowerCase() : null;
            var country = rawCountry != null ? rawCountry.toUpperCase() : null;

            if (language && country) {
                var code = language + "-" + country;

                if (Object.prototype.hasOwnProperty.call(locales, code)) {
                    return code;
                } else {
                    var _context;

                    console.warn(concat(_context = "Unknown variant ".concat(country, " of language ")).call(_context, language, "."));
                }
            }

            if (language) {
                var _code = language;

                if (Object.prototype.hasOwnProperty.call(locales, _code)) {
                    return _code;
                } else {
                    console.warn("Unknown language ".concat(language));
                }
            }

            console.warn("Unknown locale ".concat(rawCode, ", falling back to English."));
            return "en";
        } catch (error) {
            console.error(error);
            console.warn("Unexpected error while normalizing locale ".concat(rawCode, ", falling back to English."));
            return "en";
        }
    }

    /**
     * Associates a canvas to a given image, containing a number of renderings
     * of the image at various sizes.
     *
     * This technique is known as 'mipmapping'.
     *
     * NOTE: Images can also be of type 'data:svg+xml`. This code also works
     *       for svg, but the mipmapping may not be necessary.
     *
     * @param {Image} image
     */
    var CachedImage = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function CachedImage() {
            _classCallCheck(this, CachedImage);

            this.NUM_ITERATIONS = 4; // Number of items in the coordinates array

            this.image = new Image();
            this.canvas = document.createElement("canvas");
        }
        /**
         * Called when the image has been successfully loaded.
         */


        _createClass(CachedImage, [{
            key: "init",
            value: function init() {
                if (this.initialized()) return;
                this.src = this.image.src; // For same interface with Image

                var w = this.image.width;
                var h = this.image.height; // Ease external access

                this.width = w;
                this.height = h;
                var h2 = Math.floor(h / 2);
                var h4 = Math.floor(h / 4);
                var h8 = Math.floor(h / 8);
                var h16 = Math.floor(h / 16);
                var w2 = Math.floor(w / 2);
                var w4 = Math.floor(w / 4);
                var w8 = Math.floor(w / 8);
                var w16 = Math.floor(w / 16); // Make canvas as small as possible

                this.canvas.width = 3 * w4;
                this.canvas.height = h2; // Coordinates and sizes of images contained in the canvas
                // Values per row:  [top x, left y, width, height]

                this.coordinates = [[0, 0, w2, h2], [w2, 0, w4, h4], [w2, h4, w8, h8], [5 * w8, h4, w16, h16]];

                this._fillMipMap();
            }
            /**
             * @returns {boolean} true if init() has been called, false otherwise.
             */

        }, {
            key: "initialized",
            value: function initialized() {
                return this.coordinates !== undefined;
            }
            /**
             * Redraw main image in various sizes to the context.
             *
             * The rationale behind this is to reduce artefacts due to interpolation
             * at differing zoom levels.
             *
             * Source: http://stackoverflow.com/q/18761404/1223531
             *
             * This methods takes the resizing out of the drawing loop, in order to
             * reduce performance overhead.
             *
             * TODO: The code assumes that a 2D context can always be gotten. This is
             *       not necessarily true! OTOH, if not true then usage of this class
             *       is senseless.
             *
             * @private
             */

        }, {
            key: "_fillMipMap",
            value: function _fillMipMap() {
                var ctx = this.canvas.getContext("2d"); // First zoom-level comes from the image

                var to = this.coordinates[0];
                ctx.drawImage(this.image, to[0], to[1], to[2], to[3]); // The rest are copy actions internal to the canvas/context

                for (var iterations = 1; iterations < this.NUM_ITERATIONS; iterations++) {
                    var from = this.coordinates[iterations - 1];
                    var _to = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], _to[0], _to[1], _to[2], _to[3]);
                }
            }
            /**
             * Draw the image, using the mipmap if necessary.
             *
             * MipMap is only used if param factor > 2; otherwise, original bitmap
             * is resized. This is also used to skip mipmap usage, e.g. by setting factor = 1
             *
             * Credits to 'Alex de Mulder' for original implementation.
             *
             * @param {CanvasRenderingContext2D} ctx  context on which to draw zoomed image
             * @param {Float} factor scale factor at which to draw
             * @param {number} left
             * @param {number} top
             * @param {number} width
             * @param {number} height
             */

        }, {
            key: "drawImageAtPosition",
            value: function drawImageAtPosition(ctx, factor, left, top, width, height) {
                if (!this.initialized()) return; //can't draw image yet not intialized

                if (factor > 2) {
                    // Determine which zoomed image to use
                    factor *= 0.5;
                    var iterations = 0;

                    while (factor > 2 && iterations < this.NUM_ITERATIONS) {
                        factor *= 0.5;
                        iterations += 1;
                    }

                    if (iterations >= this.NUM_ITERATIONS) {
                        iterations = this.NUM_ITERATIONS - 1;
                    } //console.log("iterations: " + iterations);


                    var from = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], left, top, width, height);
                } else {
                    // Draw image directly
                    ctx.drawImage(this.image, left, top, width, height);
                }
            }
        }]);

        return CachedImage;
    }();

    /**
     * This callback is a callback that accepts an Image.
     *
     * @callback ImageCallback
     * @param {Image} image
     */

    /**
     * This class loads images and keeps them stored.
     *
     * @param {ImageCallback} callback
     */

    var Images = /*#__PURE__*/function () {
        /**
         * @param {ImageCallback} callback
         */
        function Images(callback) {
            _classCallCheck(this, Images);

            this.images = {};
            this.imageBroken = {};
            this.callback = callback;
        }
        /**
         * @param {string} url                      The original Url that failed to load, if the broken image is successfully loaded it will be added to the cache using this Url as the key so that subsequent requests for this Url will return the broken image
         * @param {string} brokenUrl                Url the broken image to try and load
         * @param {Image} imageToLoadBrokenUrlOn   The image object
         */


        _createClass(Images, [{
            key: "_tryloadBrokenUrl",
            value: function _tryloadBrokenUrl(url, brokenUrl, imageToLoadBrokenUrlOn) {
                //If these parameters aren't specified then exit the function because nothing constructive can be done
                if (url === undefined || imageToLoadBrokenUrlOn === undefined) return;

                if (brokenUrl === undefined) {
                    console.warn("No broken url image defined");
                    return;
                } //Clear the old subscription to the error event and put a new in place that only handle errors in loading the brokenImageUrl


                imageToLoadBrokenUrlOn.image.onerror = function () {
                    console.error("Could not load brokenImage:", brokenUrl); // cache item will contain empty image, this should be OK for default
                }; //Set the source of the image to the brokenUrl, this is actually what kicks off the loading of the broken image


                imageToLoadBrokenUrlOn.image.src = brokenUrl;
            }
            /**
             *
             * @param {vis.Image} imageToRedrawWith
             * @private
             */

        }, {
            key: "_redrawWithImage",
            value: function _redrawWithImage(imageToRedrawWith) {
                if (this.callback) {
                    this.callback(imageToRedrawWith);
                }
            }
            /**
             * @param {string} url          Url of the image
             * @param {string} brokenUrl    Url of an image to use if the url image is not found
             * @returns {Image} img          The image object
             */

        }, {
            key: "load",
            value: function load(url, brokenUrl) {
                var _this = this;

                //Try and get the image from the cache, if successful then return the cached image
                var cachedImage = this.images[url];
                if (cachedImage) return cachedImage; //Create a new image

                var img = new CachedImage(); // Need to add to cache here, otherwise final return will spawn different copies of the same image,
                // Also, there will be multiple loads of the same image.

                this.images[url] = img; //Subscribe to the event that is raised if the image loads successfully

                img.image.onload = function () {
                    // Properly init the cached item and then request a redraw
                    _this._fixImageCoordinates(img.image);

                    img.init();

                    _this._redrawWithImage(img);
                }; //Subscribe to the event that is raised if the image fails to load


                img.image.onerror = function () {
                    console.error("Could not load image:", url); //Try and load the image specified by the brokenUrl using

                    _this._tryloadBrokenUrl(url, brokenUrl, img);
                }; //Set the source of the image to the url, this is what actually kicks off the loading of the image


                img.image.src = url; //Return the new image

                return img;
            }
            /**
             * IE11 fix -- thanks dponch!
             *
             * Local helper function
             *
             * @param {vis.Image} imageToCache
             * @private
             */

        }, {
            key: "_fixImageCoordinates",
            value: function _fixImageCoordinates(imageToCache) {
                if (imageToCache.width === 0) {
                    document.body.appendChild(imageToCache);
                    imageToCache.width = imageToCache.offsetWidth;
                    imageToCache.height = imageToCache.offsetHeight;
                    document.body.removeChild(imageToCache);
                }
            }
        }]);

        return Images;
    }();

    var freezing = !fails(function () {
        return Object.isExtensible(Object.preventExtensions({}));
    });

    var internalMetadata = createCommonjsModule(function (module) {
        var defineProperty = objectDefineProperty.f;
        var METADATA = uid('meta');
        var id = 0;

        var isExtensible = Object.isExtensible || function () {
            return true;
        };

        var setMetadata = function (it) {
            defineProperty(it, METADATA, {
                value: {
                    objectID: 'O' + ++id,
                    // object ID
                    weakData: {} // weak collections IDs

                }
            });
        };

        var fastKey = function (it, create) {
            // return a primitive with prefix
            if (!isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

            if (!has$1(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return 'F'; // not necessary to add metadata

                if (!create) return 'E'; // add missing metadata

                setMetadata(it); // return object ID
            }

            return it[METADATA].objectID;
        };

        var getWeakData = function (it, create) {
            if (!has$1(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return true; // not necessary to add metadata

                if (!create) return false; // add missing metadata

                setMetadata(it); // return the store of weak collections IDs
            }

            return it[METADATA].weakData;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function (it) {
            if (freezing && meta.REQUIRED && isExtensible(it) && !has$1(it, METADATA)) setMetadata(it);
            return it;
        };

        var meta = module.exports = {
            REQUIRED: false,
            fastKey: fastKey,
            getWeakData: getWeakData,
            onFreeze: onFreeze
        };
        hiddenKeys$1[METADATA] = true;
    });

    var Result = function (stopped, result) {
        this.stopped = stopped;
        this.result = result;
    };

    var iterate = function (iterable, unboundFunction, options) {
        var that = options && options.that;
        var AS_ENTRIES = !!(options && options.AS_ENTRIES);
        var IS_ITERATOR = !!(options && options.IS_ITERATOR);
        var INTERRUPTED = !!(options && options.INTERRUPTED);
        var fn = functionBindContext(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
        var iterator, iterFn, index, length, result, next, step;

        var stop = function (condition) {
            if (iterator) iteratorClose(iterator);
            return new Result(true, condition);
        };

        var callFn = function (value) {
            if (AS_ENTRIES) {
                anObject(value);
                return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
            }

            return INTERRUPTED ? fn(value, stop) : fn(value);
        };

        if (IS_ITERATOR) {
            iterator = iterable;
        } else {
            iterFn = getIteratorMethod$1(iterable);
            if (typeof iterFn != 'function') throw TypeError('Target is not iterable'); // optimisation for array iterators

            if (isArrayIteratorMethod(iterFn)) {
                for (index = 0, length = toLength(iterable.length); length > index; index++) {
                    result = callFn(iterable[index]);
                    if (result && result instanceof Result) return result;
                }

                return new Result(false);
            }

            iterator = iterFn.call(iterable);
        }

        next = iterator.next;

        while (!(step = next.call(iterator)).done) {
            try {
                result = callFn(step.value);
            } catch (error) {
                iteratorClose(iterator);
                throw error;
            }

            if (typeof result == 'object' && result && result instanceof Result) return result;
        }

        return new Result(false);
    };

    var anInstance = function (it, Constructor, name) {
        if (!(it instanceof Constructor)) {
            throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
        }

        return it;
    };

    var defineProperty$1 = objectDefineProperty.f;
    var forEach = arrayIteration.forEach;
    var setInternalState$2 = internalState.set;
    var internalStateGetterFor$2 = internalState.getterFor;

    var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
        var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
        var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
        var ADDER = IS_MAP ? 'set' : 'add';
        var NativeConstructor = global$1[CONSTRUCTOR_NAME];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        var exported = {};
        var Constructor;

        if (!descriptors || typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
            new NativeConstructor().entries().next();
        }))) {
            // create collection constructor
            Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
            internalMetadata.REQUIRED = true;
        } else {
            Constructor = wrapper(function (target, iterable) {
                setInternalState$2(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
                    type: CONSTRUCTOR_NAME,
                    collection: new NativeConstructor()
                });
                if (iterable != undefined) iterate(iterable, target[ADDER], {
                    that: target,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor$2(CONSTRUCTOR_NAME);
            forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
                var IS_ADDER = KEY == 'add' || KEY == 'set';

                if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
                    createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
                        var collection = getInternalState(this).collection;
                        if (!IS_ADDER && IS_WEAK && !isObject$1(a)) return KEY == 'get' ? undefined : false;
                        var result = collection[KEY](a === 0 ? 0 : a, b);
                        return IS_ADDER ? this : result;
                    });
                }
            });
            IS_WEAK || defineProperty$1(Constructor.prototype, 'size', {
                configurable: true,
                get: function () {
                    return getInternalState(this).collection.size;
                }
            });
        }

        setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
        exported[CONSTRUCTOR_NAME] = Constructor;
        _export({
            global: true,
            forced: true
        }, exported);
        if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
        return Constructor;
    };

    var redefineAll = function (target, src, options) {
        for (var key in src) {
            if (options && options.unsafe && target[key]) target[key] = src[key];else redefine(target, key, src[key], options);
        }

        return target;
    };

    var SPECIES = wellKnownSymbol('species');

    var setSpecies = function (CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
        var defineProperty = objectDefineProperty.f;

        if (descriptors && Constructor && !Constructor[SPECIES]) {
            defineProperty(Constructor, SPECIES, {
                configurable: true,
                get: function () {
                    return this;
                }
            });
        }
    };

    var defineProperty = objectDefineProperty.f;
    var fastKey = internalMetadata.fastKey;
    var setInternalState$1 = internalState.set;
    var internalStateGetterFor$1 = internalState.getterFor;
    var collectionStrong = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
                anInstance(that, C, CONSTRUCTOR_NAME);
                setInternalState$1(that, {
                    type: CONSTRUCTOR_NAME,
                    index: objectCreate(null),
                    first: undefined,
                    last: undefined,
                    size: 0
                });
                if (!descriptors) that.size = 0;
                if (iterable != undefined) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                var previous, index; // change existing entry

                if (entry) {
                    entry.value = value; // create new entry
                } else {
                    state.last = entry = {
                        index: index = fastKey(key, true),
                        key: key,
                        value: value,
                        previous: previous = state.last,
                        next: undefined,
                        removed: false
                    };
                    if (!state.first) state.first = entry;
                    if (previous) previous.next = entry;
                    if (descriptors) state.size++;else that.size++; // add to index

                    if (index !== 'F') state.index[index] = entry;
                }

                return that;
            };

            var getEntry = function (that, key) {
                var state = getInternalState(that); // fast case

                var index = fastKey(key);
                var entry;
                if (index !== 'F') return state.index[index]; // frozen object case

                for (entry = state.first; entry; entry = entry.next) {
                    if (entry.key == key) return entry;
                }
            };

            redefineAll(C.prototype, {
                // 23.1.3.1 Map.prototype.clear()
                // 23.2.3.2 Set.prototype.clear()
                clear: function clear() {
                    var that = this;
                    var state = getInternalState(that);
                    var data = state.index;
                    var entry = state.first;

                    while (entry) {
                        entry.removed = true;
                        if (entry.previous) entry.previous = entry.previous.next = undefined;
                        delete data[entry.index];
                        entry = entry.next;
                    }

                    state.first = state.last = undefined;
                    if (descriptors) state.size = 0;else that.size = 0;
                },
                // 23.1.3.3 Map.prototype.delete(key)
                // 23.2.3.4 Set.prototype.delete(value)
                'delete': function (key) {
                    var that = this;
                    var state = getInternalState(that);
                    var entry = getEntry(that, key);

                    if (entry) {
                        var next = entry.next;
                        var prev = entry.previous;
                        delete state.index[entry.index];
                        entry.removed = true;
                        if (prev) prev.next = next;
                        if (next) next.previous = prev;
                        if (state.first == entry) state.first = next;
                        if (state.last == entry) state.last = prev;
                        if (descriptors) state.size--;else that.size--;
                    }

                    return !!entry;
                },
                // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                forEach: function forEach(callbackfn
                                          /* , that = undefined */
                ) {
                    var state = getInternalState(this);
                    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                    var entry;

                    while (entry = entry ? entry.next : state.first) {
                        boundFunction(entry.value, entry.key, this); // revert to the last existing entry

                        while (entry && entry.removed) entry = entry.previous;
                    }
                },
                // 23.1.3.7 Map.prototype.has(key)
                // 23.2.3.7 Set.prototype.has(value)
                has: function has(key) {
                    return !!getEntry(this, key);
                }
            });
            redefineAll(C.prototype, IS_MAP ? {
                // 23.1.3.6 Map.prototype.get(key)
                get: function get(key) {
                    var entry = getEntry(this, key);
                    return entry && entry.value;
                },
                // 23.1.3.9 Map.prototype.set(key, value)
                set: function set(key, value) {
                    return define(this, key === 0 ? 0 : key, value);
                }
            } : {
                // 23.2.3.1 Set.prototype.add(value)
                add: function add(value) {
                    return define(this, value = value === 0 ? 0 : value, value);
                }
            });
            if (descriptors) defineProperty(C.prototype, 'size', {
                get: function () {
                    return getInternalState(this).size;
                }
            });
            return C;
        },
        setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
            var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
            var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
            var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME); // add .keys, .values, .entries, [@@iterator]
            // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11

            defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
                setInternalState$1(this, {
                    type: ITERATOR_NAME,
                    target: iterated,
                    state: getInternalCollectionState(iterated),
                    kind: kind,
                    last: undefined
                });
            }, function () {
                var state = getInternalIteratorState(this);
                var kind = state.kind;
                var entry = state.last; // revert to the last existing entry

                while (entry && entry.removed) entry = entry.previous; // get next entry


                if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                    // or finish the iteration
                    state.target = undefined;
                    return {
                        value: undefined,
                        done: true
                    };
                } // return step by kind


                if (kind == 'keys') return {
                    value: entry.key,
                    done: false
                };
                if (kind == 'values') return {
                    value: entry.value,
                    done: false
                };
                return {
                    value: [entry.key, entry.value],
                    done: false
                };
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

            setSpecies(CONSTRUCTOR_NAME);
        }
    };

    // https://tc39.es/ecma262/#sec-map-objects


    collection('Map', function (init) {
        return function Map() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong);

    var map$2 = path.Map;

    var map$1 = map$2;

    var map = map$1;

    /**
     * This class can store groups and options specific for groups.
     */
    var Groups = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function Groups() {
            _classCallCheck(this, Groups);

            this.clear();
            this._defaultIndex = 0;
            this._groupIndex = 0;
            this._defaultGroups = [{
                border: "#2B7CE9",
                background: "#97C2FC",
                highlight: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                },
                hover: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                }
            }, // 0: blue
                {
                    border: "#FFA500",
                    background: "#FFFF00",
                    highlight: {
                        border: "#FFA500",
                        background: "#FFFFA3"
                    },
                    hover: {
                        border: "#FFA500",
                        background: "#FFFFA3"
                    }
                }, // 1: yellow
                {
                    border: "#FA0A10",
                    background: "#FB7E81",
                    highlight: {
                        border: "#FA0A10",
                        background: "#FFAFB1"
                    },
                    hover: {
                        border: "#FA0A10",
                        background: "#FFAFB1"
                    }
                }, // 2: red
                {
                    border: "#41A906",
                    background: "#7BE141",
                    highlight: {
                        border: "#41A906",
                        background: "#A1EC76"
                    },
                    hover: {
                        border: "#41A906",
                        background: "#A1EC76"
                    }
                }, // 3: green
                {
                    border: "#E129F0",
                    background: "#EB7DF4",
                    highlight: {
                        border: "#E129F0",
                        background: "#F0B3F5"
                    },
                    hover: {
                        border: "#E129F0",
                        background: "#F0B3F5"
                    }
                }, // 4: magenta
                {
                    border: "#7C29F0",
                    background: "#AD85E4",
                    highlight: {
                        border: "#7C29F0",
                        background: "#D3BDF0"
                    },
                    hover: {
                        border: "#7C29F0",
                        background: "#D3BDF0"
                    }
                }, // 5: purple
                {
                    border: "#C37F00",
                    background: "#FFA807",
                    highlight: {
                        border: "#C37F00",
                        background: "#FFCA66"
                    },
                    hover: {
                        border: "#C37F00",
                        background: "#FFCA66"
                    }
                }, // 6: orange
                {
                    border: "#4220FB",
                    background: "#6E6EFD",
                    highlight: {
                        border: "#4220FB",
                        background: "#9B9BFD"
                    },
                    hover: {
                        border: "#4220FB",
                        background: "#9B9BFD"
                    }
                }, // 7: darkblue
                {
                    border: "#FD5A77",
                    background: "#FFC0CB",
                    highlight: {
                        border: "#FD5A77",
                        background: "#FFD1D9"
                    },
                    hover: {
                        border: "#FD5A77",
                        background: "#FFD1D9"
                    }
                }, // 8: pink
                {
                    border: "#4AD63A",
                    background: "#C2FABC",
                    highlight: {
                        border: "#4AD63A",
                        background: "#E6FFE3"
                    },
                    hover: {
                        border: "#4AD63A",
                        background: "#E6FFE3"
                    }
                }, // 9: mint
                {
                    border: "#990000",
                    background: "#EE0000",
                    highlight: {
                        border: "#BB0000",
                        background: "#FF3333"
                    },
                    hover: {
                        border: "#BB0000",
                        background: "#FF3333"
                    }
                }, // 10:bright red
                {
                    border: "#FF6000",
                    background: "#FF6000",
                    highlight: {
                        border: "#FF6000",
                        background: "#FF6000"
                    },
                    hover: {
                        border: "#FF6000",
                        background: "#FF6000"
                    }
                }, // 12: real orange
                {
                    border: "#97C2FC",
                    background: "#2B7CE9",
                    highlight: {
                        border: "#D2E5FF",
                        background: "#2B7CE9"
                    },
                    hover: {
                        border: "#D2E5FF",
                        background: "#2B7CE9"
                    }
                }, // 13: blue
                {
                    border: "#399605",
                    background: "#255C03",
                    highlight: {
                        border: "#399605",
                        background: "#255C03"
                    },
                    hover: {
                        border: "#399605",
                        background: "#255C03"
                    }
                }, // 14: green
                {
                    border: "#B70054",
                    background: "#FF007E",
                    highlight: {
                        border: "#B70054",
                        background: "#FF007E"
                    },
                    hover: {
                        border: "#B70054",
                        background: "#FF007E"
                    }
                }, // 15: magenta
                {
                    border: "#AD85E4",
                    background: "#7C29F0",
                    highlight: {
                        border: "#D3BDF0",
                        background: "#7C29F0"
                    },
                    hover: {
                        border: "#D3BDF0",
                        background: "#7C29F0"
                    }
                }, // 16: purple
                {
                    border: "#4557FA",
                    background: "#000EA1",
                    highlight: {
                        border: "#6E6EFD",
                        background: "#000EA1"
                    },
                    hover: {
                        border: "#6E6EFD",
                        background: "#000EA1"
                    }
                }, // 17: darkblue
                {
                    border: "#FFC0CB",
                    background: "#FD5A77",
                    highlight: {
                        border: "#FFD1D9",
                        background: "#FD5A77"
                    },
                    hover: {
                        border: "#FFD1D9",
                        background: "#FD5A77"
                    }
                }, // 18: pink
                {
                    border: "#C2FABC",
                    background: "#74D66A",
                    highlight: {
                        border: "#E6FFE3",
                        background: "#74D66A"
                    },
                    hover: {
                        border: "#E6FFE3",
                        background: "#74D66A"
                    }
                }, // 19: mint
                {
                    border: "#EE0000",
                    background: "#990000",
                    highlight: {
                        border: "#FF3333",
                        background: "#BB0000"
                    },
                    hover: {
                        border: "#FF3333",
                        background: "#BB0000"
                    }
                } // 20:bright red
            ];
            this.options = {};
            this.defaultOptions = {
                useDefaultGroups: true
            };

            assign$2(this.options, this.defaultOptions);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(Groups, [{
            key: "setOptions",
            value: function setOptions(options) {
                var optionFields = ["useDefaultGroups"];

                if (options !== undefined) {
                    for (var groupName in options) {
                        if (Object.prototype.hasOwnProperty.call(options, groupName)) {
                            if (indexOf(optionFields).call(optionFields, groupName) === -1) {
                                var group = options[groupName];
                                this.add(groupName, group);
                            }
                        }
                    }
                }
            }
            /**
             * Clear all groups
             */

        }, {
            key: "clear",
            value: function clear() {
                this._groups = new map();
                this._groupNames = [];
            }
            /**
             * Get group options of a groupname.
             * If groupname is not found, a new group may be created.
             *
             * @param {*}       groupname     Can be a number, string, Date, etc.
             * @param {boolean} [shouldCreate=true] If true, create a new group
             * @returns {object} The found or created group
             */

        }, {
            key: "get",
            value: function get(groupname) {
                var shouldCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var group = this._groups.get(groupname);

                if (group === undefined && shouldCreate) {
                    if (this.options.useDefaultGroups === false && this._groupNames.length > 0) {
                        // create new group
                        var index = this._groupIndex % this._groupNames.length;
                        ++this._groupIndex;
                        group = {};
                        group.color = this._groups.get(this._groupNames[index]);

                        this._groups.set(groupname, group);
                    } else {
                        // create new group
                        var _index = this._defaultIndex % this._defaultGroups.length;

                        this._defaultIndex++;
                        group = {};
                        group.color = this._defaultGroups[_index];

                        this._groups.set(groupname, group);
                    }
                }

                return group;
            }
            /**
             * Add custom group style.
             *
             * @param {string} groupName - The name of the group, a new group will be
             * created if a group with the same name doesn't exist, otherwise the old
             * groups style will be overwritten.
             * @param {object} style - An object containing borderColor, backgroundColor,
             * etc.
             * @returns {object} The created group object.
             */

        }, {
            key: "add",
            value: function add(groupName, style) {
                // Only push group name once to prevent duplicates which would consume more
                // RAM and also skew the distribution towards more often updated groups,
                // neither of which is desirable.
                if (!this._groups.has(groupName)) {
                    this._groupNames.push(groupName);
                }

                this._groups.set(groupName, style);

                return style;
            }
        }]);

        return Groups;
    }();

    // https://tc39.es/ecma262/#sec-number.isnan

    _export({
        target: 'Number',
        stat: true
    }, {
        isNaN: function isNaN(number) {
            // eslint-disable-next-line no-self-compare -- NaN check
            return number != number;
        }
    });

    var isNan$2 = path.Number.isNaN;

    var isNan$1 = isNan$2;

    var isNan = isNan$1;

    var globalIsFinite = global$1.isFinite; // `Number.isFinite` method
    // https://tc39.es/ecma262/#sec-number.isfinite

    var numberIsFinite = Number.isFinite || function isFinite(it) {
        return typeof it == 'number' && globalIsFinite(it);
    };

    // https://tc39.es/ecma262/#sec-number.isfinite

    _export({
        target: 'Number',
        stat: true
    }, {
        isFinite: numberIsFinite
    });

    var _isFinite$2 = path.Number.isFinite;

    var _isFinite$1 = _isFinite$2;

    var _isFinite = _isFinite$1;

    var $some = arrayIteration.some;
    var STRICT_METHOD$3 = arrayMethodIsStrict('some'); // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD$3
    }, {
        some: function some(callbackfn
                            /* , thisArg */
        ) {
            return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var some$2 = entryVirtual('Array').some;

    var ArrayPrototype$7 = Array.prototype;

    var some_1 = function (it) {
        var own = it.some;
        return it === ArrayPrototype$7 || it instanceof Array && own === ArrayPrototype$7.some ? some$2 : own;
    };

    var some$1 = some_1;

    var some = some$1;

    var nativeConstruct = getBuiltIn('Reflect', 'construct'); // `Reflect.construct` method
    // https://tc39.es/ecma262/#sec-reflect.construct
    // MS Edge supports only 2 arguments and argumentsList argument is optional
    // FF Nightly sets third argument as `new.target`, but does not create `this` from it

    var NEW_TARGET_BUG = fails(function () {
        function F() {
            /* empty */
        }

        return !(nativeConstruct(function () {
            /* empty */
        }, [], F) instanceof F);
    });
    var ARGS_BUG = !fails(function () {
        nativeConstruct(function () {
            /* empty */
        });
    });
    var FORCED$2 = NEW_TARGET_BUG || ARGS_BUG;
    _export({
        target: 'Reflect',
        stat: true,
        forced: FORCED$2,
        sham: FORCED$2
    }, {
        construct: function construct(Target, args
                                      /* , newTarget */
        ) {
            aFunction$1(Target);
            anObject(args);
            var newTarget = arguments.length < 3 ? Target : aFunction$1(arguments[2]);
            if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);

            if (Target == newTarget) {
                // w/o altered newTarget, optimization for 0-4 arguments
                switch (args.length) {
                    case 0:
                        return new Target();

                    case 1:
                        return new Target(args[0]);

                    case 2:
                        return new Target(args[0], args[1]);

                    case 3:
                        return new Target(args[0], args[1], args[2]);

                    case 4:
                        return new Target(args[0], args[1], args[2], args[3]);
                } // w/o altered newTarget, lot of arguments case


                var $args = [null];
                $args.push.apply($args, args);
                return new (functionBind.apply(Target, $args))();
            } // with altered newTarget, not support built-in constructors


            var proto = newTarget.prototype;
            var instance = objectCreate(isObject$1(proto) ? proto : Object.prototype);
            var result = Function.apply.call(Target, instance, args);
            return isObject$1(result) ? result : instance;
        }
    });

    var construct$2 = path.Reflect.construct;

    var construct$1 = construct$2;

    var construct = construct$1;

    function _assertThisInitialized(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
    }

    var create$1 = create$4;

    var create = create$1;

    // https://tc39.es/ecma262/#sec-object.setprototypeof

    _export({
        target: 'Object',
        stat: true
    }, {
        setPrototypeOf: objectSetPrototypeOf
    });

    var setPrototypeOf$2 = path.Object.setPrototypeOf;

    var setPrototypeOf$1 = setPrototypeOf$2;

    var setPrototypeOf = setPrototypeOf$1;

    function _setPrototypeOf(o, p) {
        _setPrototypeOf = setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };

        return _setPrototypeOf(o, p);
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
        }

        return _assertThisInitialized(self);
    }

    var getPrototypeOf$1 = getPrototypeOf$4;

    var getPrototypeOf = getPrototypeOf$1;

    function _getPrototypeOf(o) {
        _getPrototypeOf = setPrototypeOf ? getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var runtime_1 = createCommonjsModule(function (module) {
        var runtime = function (exports) {

            var Op = Object.prototype;
            var hasOwn = Op.hasOwnProperty;
            var undefined$1; // More compressible than void 0.

            var $Symbol = typeof Symbol === "function" ? Symbol : {};
            var iteratorSymbol = $Symbol.iterator || "@@iterator";
            var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
            var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

            function define(obj, key, value) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                return obj[key];
            }

            try {
                // IE 8 has a broken Object.defineProperty that only works on DOM objects.
                define({}, "");
            } catch (err) {
                define = function (obj, key, value) {
                    return obj[key] = value;
                };
            }

            function wrap(innerFn, outerFn, self, tryLocsList) {
                // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                var generator = Object.create(protoGenerator.prototype);
                var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
                // .throw, and .return methods.

                generator._invoke = makeInvokeMethod(innerFn, self, context);
                return generator;
            }

            exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
            // record like context.tryEntries[i].completion. This interface could
            // have been (and was previously) designed to take a closure to be
            // invoked without arguments, but in all the cases we care about we
            // already have an existing method we want to call, so there's no need
            // to create a new function object. We can even get away with assuming
            // the method takes exactly one argument, since that happens to be true
            // in every case, so we don't have to touch the arguments object. The
            // only additional allocation required is the completion record, which
            // has a stable shape and so hopefully should be cheap to allocate.

            function tryCatch(fn, obj, arg) {
                try {
                    return {
                        type: "normal",
                        arg: fn.call(obj, arg)
                    };
                } catch (err) {
                    return {
                        type: "throw",
                        arg: err
                    };
                }
            }

            var GenStateSuspendedStart = "suspendedStart";
            var GenStateSuspendedYield = "suspendedYield";
            var GenStateExecuting = "executing";
            var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
            // breaking out of the dispatch switch statement.

            var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
            // .constructor.prototype properties for functions that return Generator
            // objects. For full spec compliance, you may wish to configure your
            // minifier not to mangle the names of these two functions.

            function Generator() {}

            function GeneratorFunction() {}

            function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
            // don't natively support it.


            var IteratorPrototype = {};

            IteratorPrototype[iteratorSymbol] = function () {
                return this;
            };

            var getProto = Object.getPrototypeOf;
            var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

            if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
                // This environment has a native %IteratorPrototype%; use it instead
                // of the polyfill.
                IteratorPrototype = NativeIteratorPrototype;
            }

            var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
            GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
            GeneratorFunctionPrototype.constructor = GeneratorFunction;
            GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
            // Iterator interface in terms of a single ._invoke method.

            function defineIteratorMethods(prototype) {
                ["next", "throw", "return"].forEach(function (method) {
                    define(prototype, method, function (arg) {
                        return this._invoke(method, arg);
                    });
                });
            }

            exports.isGeneratorFunction = function (genFun) {
                var ctor = typeof genFun === "function" && genFun.constructor;
                return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
                    // do is to check its .name property.
                    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
            };

            exports.mark = function (genFun) {
                if (Object.setPrototypeOf) {
                    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                } else {
                    genFun.__proto__ = GeneratorFunctionPrototype;
                    define(genFun, toStringTagSymbol, "GeneratorFunction");
                }

                genFun.prototype = Object.create(Gp);
                return genFun;
            }; // Within the body of any async function, `await x` is transformed to
            // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
            // `hasOwn.call(value, "__await")` to determine if the yielded value is
            // meant to be awaited.


            exports.awrap = function (arg) {
                return {
                    __await: arg
                };
            };

            function AsyncIterator(generator, PromiseImpl) {
                function invoke(method, arg, resolve, reject) {
                    var record = tryCatch(generator[method], generator, arg);

                    if (record.type === "throw") {
                        reject(record.arg);
                    } else {
                        var result = record.arg;
                        var value = result.value;

                        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                            return PromiseImpl.resolve(value.__await).then(function (value) {
                                invoke("next", value, resolve, reject);
                            }, function (err) {
                                invoke("throw", err, resolve, reject);
                            });
                        }

                        return PromiseImpl.resolve(value).then(function (unwrapped) {
                            // When a yielded Promise is resolved, its final value becomes
                            // the .value of the Promise<{value,done}> result for the
                            // current iteration.
                            result.value = unwrapped;
                            resolve(result);
                        }, function (error) {
                            // If a rejected Promise was yielded, throw the rejection back
                            // into the async generator function so it can be handled there.
                            return invoke("throw", error, resolve, reject);
                        });
                    }
                }

                var previousPromise;

                function enqueue(method, arg) {
                    function callInvokeWithMethodAndArg() {
                        return new PromiseImpl(function (resolve, reject) {
                            invoke(method, arg, resolve, reject);
                        });
                    }

                    return previousPromise = // If enqueue has been called before, then we want to wait until
                        // all previous Promises have been resolved before calling invoke,
                        // so that results are always delivered in the correct order. If
                        // enqueue has not been called before, then it is important to
                        // call invoke immediately, without waiting on a callback to fire,
                        // so that the async generator function has the opportunity to do
                        // any necessary setup in a predictable way. This predictability
                        // is why the Promise constructor synchronously invokes its
                        // executor callback, and why async functions synchronously
                        // execute code before the first await. Since we implement simple
                        // async functions in terms of async generators, it is especially
                        // important to get this right, even though it requires care.
                        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                            // invocations of the iterator.
                            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                } // Define the unified helper method that is used to implement .next,
                // .throw, and .return (see defineIteratorMethods).


                this._invoke = enqueue;
            }

            defineIteratorMethods(AsyncIterator.prototype);

            AsyncIterator.prototype[asyncIteratorSymbol] = function () {
                return this;
            };

            exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
            // AsyncIterator objects; they just return a Promise for the value of
            // the final result produced by the iterator.

            exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                if (PromiseImpl === void 0) PromiseImpl = Promise;
                var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
                return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
                    : iter.next().then(function (result) {
                        return result.done ? result.value : iter.next();
                    });
            };

            function makeInvokeMethod(innerFn, self, context) {
                var state = GenStateSuspendedStart;
                return function invoke(method, arg) {
                    if (state === GenStateExecuting) {
                        throw new Error("Generator is already running");
                    }

                    if (state === GenStateCompleted) {
                        if (method === "throw") {
                            throw arg;
                        } // Be forgiving, per 25.3.3.3.3 of the spec:
                        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                        return doneResult();
                    }

                    context.method = method;
                    context.arg = arg;

                    while (true) {
                        var delegate = context.delegate;

                        if (delegate) {
                            var delegateResult = maybeInvokeDelegate(delegate, context);

                            if (delegateResult) {
                                if (delegateResult === ContinueSentinel) continue;
                                return delegateResult;
                            }
                        }

                        if (context.method === "next") {
                            // Setting context._sent for legacy support of Babel's
                            // function.sent implementation.
                            context.sent = context._sent = context.arg;
                        } else if (context.method === "throw") {
                            if (state === GenStateSuspendedStart) {
                                state = GenStateCompleted;
                                throw context.arg;
                            }

                            context.dispatchException(context.arg);
                        } else if (context.method === "return") {
                            context.abrupt("return", context.arg);
                        }

                        state = GenStateExecuting;
                        var record = tryCatch(innerFn, self, context);

                        if (record.type === "normal") {
                            // If an exception is thrown from innerFn, we leave state ===
                            // GenStateExecuting and loop back for another invocation.
                            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                            if (record.arg === ContinueSentinel) {
                                continue;
                            }

                            return {
                                value: record.arg,
                                done: context.done
                            };
                        } else if (record.type === "throw") {
                            state = GenStateCompleted; // Dispatch the exception by looping back around to the
                            // context.dispatchException(context.arg) call above.

                            context.method = "throw";
                            context.arg = record.arg;
                        }
                    }
                };
            } // Call delegate.iterator[context.method](context.arg) and handle the
            // result, either by returning a { value, done } result from the
            // delegate iterator, or by modifying context.method and context.arg,
            // setting context.delegate to null, and returning the ContinueSentinel.


            function maybeInvokeDelegate(delegate, context) {
                var method = delegate.iterator[context.method];

                if (method === undefined$1) {
                    // A .throw or .return when the delegate iterator has no .throw
                    // method always terminates the yield* loop.
                    context.delegate = null;

                    if (context.method === "throw") {
                        // Note: ["return"] must be used for ES3 parsing compatibility.
                        if (delegate.iterator["return"]) {
                            // If the delegate iterator has a return method, give it a
                            // chance to clean up.
                            context.method = "return";
                            context.arg = undefined$1;
                            maybeInvokeDelegate(delegate, context);

                            if (context.method === "throw") {
                                // If maybeInvokeDelegate(context) changed context.method from
                                // "return" to "throw", let that override the TypeError below.
                                return ContinueSentinel;
                            }
                        }

                        context.method = "throw";
                        context.arg = new TypeError("The iterator does not provide a 'throw' method");
                    }

                    return ContinueSentinel;
                }

                var record = tryCatch(method, delegate.iterator, context.arg);

                if (record.type === "throw") {
                    context.method = "throw";
                    context.arg = record.arg;
                    context.delegate = null;
                    return ContinueSentinel;
                }

                var info = record.arg;

                if (!info) {
                    context.method = "throw";
                    context.arg = new TypeError("iterator result is not an object");
                    context.delegate = null;
                    return ContinueSentinel;
                }

                if (info.done) {
                    // Assign the result of the finished delegate to the temporary
                    // variable specified by delegate.resultName (see delegateYield).
                    context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

                    context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
                    // exception, let the outer generator proceed normally. If
                    // context.method was "next", forget context.arg since it has been
                    // "consumed" by the delegate iterator. If context.method was
                    // "return", allow the original .return call to continue in the
                    // outer generator.

                    if (context.method !== "return") {
                        context.method = "next";
                        context.arg = undefined$1;
                    }
                } else {
                    // Re-yield the result returned by the delegate method.
                    return info;
                } // The delegate iterator is finished, so forget it and continue with
                // the outer generator.


                context.delegate = null;
                return ContinueSentinel;
            } // Define Generator.prototype.{next,throw,return} in terms of the
            // unified ._invoke helper method.


            defineIteratorMethods(Gp);
            define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
            // @@iterator function is called on it. Some browsers' implementations of the
            // iterator prototype chain incorrectly implement this, causing the Generator
            // object to not be returned from this call. This ensures that doesn't happen.
            // See https://github.com/facebook/regenerator/issues/274 for more details.

            Gp[iteratorSymbol] = function () {
                return this;
            };

            Gp.toString = function () {
                return "[object Generator]";
            };

            function pushTryEntry(locs) {
                var entry = {
                    tryLoc: locs[0]
                };

                if (1 in locs) {
                    entry.catchLoc = locs[1];
                }

                if (2 in locs) {
                    entry.finallyLoc = locs[2];
                    entry.afterLoc = locs[3];
                }

                this.tryEntries.push(entry);
            }

            function resetTryEntry(entry) {
                var record = entry.completion || {};
                record.type = "normal";
                delete record.arg;
                entry.completion = record;
            }

            function Context(tryLocsList) {
                // The root entry object (effectively a try statement without a catch
                // or a finally block) gives us a place to store values thrown from
                // locations where there is no enclosing try statement.
                this.tryEntries = [{
                    tryLoc: "root"
                }];
                tryLocsList.forEach(pushTryEntry, this);
                this.reset(true);
            }

            exports.keys = function (object) {
                var keys = [];

                for (var key in object) {
                    keys.push(key);
                }

                keys.reverse(); // Rather than returning an object with a next method, we keep
                // things simple and return the next function itself.

                return function next() {
                    while (keys.length) {
                        var key = keys.pop();

                        if (key in object) {
                            next.value = key;
                            next.done = false;
                            return next;
                        }
                    } // To avoid creating an additional object, we just hang the .value
                    // and .done properties off the next function object itself. This
                    // also ensures that the minifier will not anonymize the function.


                    next.done = true;
                    return next;
                };
            };

            function values(iterable) {
                if (iterable) {
                    var iteratorMethod = iterable[iteratorSymbol];

                    if (iteratorMethod) {
                        return iteratorMethod.call(iterable);
                    }

                    if (typeof iterable.next === "function") {
                        return iterable;
                    }

                    if (!isNaN(iterable.length)) {
                        var i = -1,
                            next = function next() {
                                while (++i < iterable.length) {
                                    if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                }

                                next.value = undefined$1;
                                next.done = true;
                                return next;
                            };

                        return next.next = next;
                    }
                } // Return an iterator with no values.


                return {
                    next: doneResult
                };
            }

            exports.values = values;

            function doneResult() {
                return {
                    value: undefined$1,
                    done: true
                };
            }

            Context.prototype = {
                constructor: Context,
                reset: function (skipTempReset) {
                    this.prev = 0;
                    this.next = 0; // Resetting context._sent for legacy support of Babel's
                    // function.sent implementation.

                    this.sent = this._sent = undefined$1;
                    this.done = false;
                    this.delegate = null;
                    this.method = "next";
                    this.arg = undefined$1;
                    this.tryEntries.forEach(resetTryEntry);

                    if (!skipTempReset) {
                        for (var name in this) {
                            // Not sure about the optimal order of these conditions:
                            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                                this[name] = undefined$1;
                            }
                        }
                    }
                },
                stop: function () {
                    this.done = true;
                    var rootEntry = this.tryEntries[0];
                    var rootRecord = rootEntry.completion;

                    if (rootRecord.type === "throw") {
                        throw rootRecord.arg;
                    }

                    return this.rval;
                },
                dispatchException: function (exception) {
                    if (this.done) {
                        throw exception;
                    }

                    var context = this;

                    function handle(loc, caught) {
                        record.type = "throw";
                        record.arg = exception;
                        context.next = loc;

                        if (caught) {
                            // If the dispatched exception was caught by a catch block,
                            // then let that catch block handle the exception normally.
                            context.method = "next";
                            context.arg = undefined$1;
                        }

                        return !!caught;
                    }

                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        var record = entry.completion;

                        if (entry.tryLoc === "root") {
                            // Exception thrown outside of any try block that could handle
                            // it, so set the completion value of the entire function to
                            // throw the exception.
                            return handle("end");
                        }

                        if (entry.tryLoc <= this.prev) {
                            var hasCatch = hasOwn.call(entry, "catchLoc");
                            var hasFinally = hasOwn.call(entry, "finallyLoc");

                            if (hasCatch && hasFinally) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                } else if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else if (hasCatch) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                }
                            } else if (hasFinally) {
                                if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else {
                                throw new Error("try statement without catch or finally");
                            }
                        }
                    }
                },
                abrupt: function (type, arg) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                            var finallyEntry = entry;
                            break;
                        }
                    }

                    if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                        // Ignore the finally entry if control is not jumping to a
                        // location outside the try/catch block.
                        finallyEntry = null;
                    }

                    var record = finallyEntry ? finallyEntry.completion : {};
                    record.type = type;
                    record.arg = arg;

                    if (finallyEntry) {
                        this.method = "next";
                        this.next = finallyEntry.finallyLoc;
                        return ContinueSentinel;
                    }

                    return this.complete(record);
                },
                complete: function (record, afterLoc) {
                    if (record.type === "throw") {
                        throw record.arg;
                    }

                    if (record.type === "break" || record.type === "continue") {
                        this.next = record.arg;
                    } else if (record.type === "return") {
                        this.rval = this.arg = record.arg;
                        this.method = "return";
                        this.next = "end";
                    } else if (record.type === "normal" && afterLoc) {
                        this.next = afterLoc;
                    }

                    return ContinueSentinel;
                },
                finish: function (finallyLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.finallyLoc === finallyLoc) {
                            this.complete(entry.completion, entry.afterLoc);
                            resetTryEntry(entry);
                            return ContinueSentinel;
                        }
                    }
                },
                "catch": function (tryLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.tryLoc === tryLoc) {
                            var record = entry.completion;

                            if (record.type === "throw") {
                                var thrown = record.arg;
                                resetTryEntry(entry);
                            }

                            return thrown;
                        }
                    } // The context.catch method must only be called with a location
                    // argument that corresponds to a known catch block.


                    throw new Error("illegal catch attempt");
                },
                delegateYield: function (iterable, resultName, nextLoc) {
                    this.delegate = {
                        iterator: values(iterable),
                        resultName: resultName,
                        nextLoc: nextLoc
                    };

                    if (this.method === "next") {
                        // Deliberately forget the last sent value so that we don't
                        // accidentally pass it on to the delegate.
                        this.arg = undefined$1;
                    }

                    return ContinueSentinel;
                }
            }; // Regardless of whether this script is executing as a CommonJS module
            // or not, return the runtime object so that we can declare the variable
            // regeneratorRuntime in the outer scope, which allows this module to be
            // injected easily by `bin/regenerator --include-runtime script.js`.

            return exports;
        }( // If this script is executing as a CommonJS module, use module.exports
            // as the regeneratorRuntime namespace. Otherwise create a new empty
            // object. Either way, the resulting object will be used to initialize
            // the regeneratorRuntime variable at the top of this file.
            module.exports );

        try {
            regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
            // This module should not be running in strict mode, so the above
            // assignment should always work unless something is misconfigured. Just
            // in case runtime.js accidentally runs in strict mode, we can escape
            // strict mode using a global Function call. This could conceivably fail
            // if a Content Security Policy forbids using Function, but in that case
            // the proper solution is to fix the accidental strict mode problem. If
            // you've misconfigured your bundler to force strict mode and applied a
            // CSP to forbid Function, and you're not willing to fix either of those
            // problems, please detail your unique predicament in a GitHub issue.
            Function("r", "regeneratorRuntime = r")(runtime);
        }
    });

    var regenerator = runtime_1;

    var createMethod = function (IS_RIGHT) {
        return function (that, callbackfn, argumentsLength, memo) {
            aFunction$1(callbackfn);
            var O = toObject(that);
            var self = indexedObject(O);
            var length = toLength(O.length);
            var index = IS_RIGHT ? length - 1 : 0;
            var i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) while (true) {
                if (index in self) {
                    memo = self[index];
                    index += i;
                    break;
                }

                index += i;

                if (IS_RIGHT ? index < 0 : length <= index) {
                    throw TypeError('Reduce of empty array with no initial value');
                }
            }

            for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
                memo = callbackfn(memo, self[index], index, O);
            }

            return memo;
        };
    };

    var arrayReduce = {
        // `Array.prototype.reduce` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduce
        left: createMethod(false),
        // `Array.prototype.reduceRight` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduceright
        right: createMethod(true)
    };

    var $reduce = arrayReduce.left;
    var STRICT_METHOD$2 = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

    var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD$2 || CHROME_BUG
    }, {
        reduce: function reduce(callbackfn
                                /* , initialValue */
        ) {
            return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var reduce$2 = entryVirtual('Array').reduce;

    var ArrayPrototype$6 = Array.prototype;

    var reduce_1 = function (it) {
        var own = it.reduce;
        return it === ArrayPrototype$6 || it instanceof Array && own === ArrayPrototype$6.reduce ? reduce$2 : own;
    };

    var reduce$1 = reduce_1;

    var reduce = reduce$1;

    // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray


    var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? functionBindContext(mapper, thisArg, 3) : false;
        var element;

        while (sourceIndex < sourceLen) {
            if (sourceIndex in source) {
                element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

                if (depth > 0 && isArray$5(element)) {
                    targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                } else {
                    if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
                    target[targetIndex] = element;
                }

                targetIndex++;
            }

            sourceIndex++;
        }

        return targetIndex;
    };

    var flattenIntoArray_1 = flattenIntoArray;

    // https://tc39.es/ecma262/#sec-array.prototype.flatmap


    _export({
        target: 'Array',
        proto: true
    }, {
        flatMap: function flatMap(callbackfn
                                  /* , thisArg */
        ) {
            var O = toObject(this);
            var sourceLen = toLength(O.length);
            var A;
            aFunction$1(callbackfn);
            A = arraySpeciesCreate(O, 0);
            A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            return A;
        }
    });

    var flatMap$2 = entryVirtual('Array').flatMap;

    var ArrayPrototype$5 = Array.prototype;

    var flatMap_1 = function (it) {
        var own = it.flatMap;
        return it === ArrayPrototype$5 || it instanceof Array && own === ArrayPrototype$5.flatMap ? flatMap$2 : own;
    };

    var flatMap$1 = flatMap_1;

    var flatMap = flatMap$1;

    var iterator$1 = iterator$4;

    var iterator = iterator$1;

    // https://tc39.es/ecma262/#sec-set-objects


    collection('Set', function (init) {
        return function Set() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong);

    var set$2 = path.Set;

    var set$1 = set$2;

    var set = set$1;

    var test = [];
    var nativeSort = test.sort; // IE8-

    var FAILS_ON_UNDEFINED = fails(function () {
        test.sort(undefined);
    }); // V8 bug

    var FAILS_ON_NULL = fails(function () {
        test.sort(null);
    }); // Old WebKit

    var STRICT_METHOD$1 = arrayMethodIsStrict('sort');
    var FORCED$1 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$1; // `Array.prototype.sort` method
    // https://tc39.es/ecma262/#sec-array.prototype.sort

    _export({
        target: 'Array',
        proto: true,
        forced: FORCED$1
    }, {
        sort: function sort(comparefn) {
            return comparefn === undefined ? nativeSort.call(toObject(this)) : nativeSort.call(toObject(this), aFunction$1(comparefn));
        }
    });

    var sort$2 = entryVirtual('Array').sort;

    var ArrayPrototype$4 = Array.prototype;

    var sort_1 = function (it) {
        var own = it.sort;
        return it === ArrayPrototype$4 || it instanceof Array && own === ArrayPrototype$4.sort ? sort$2 : own;
    };

    var sort$1 = sort_1;

    var sort = sort$1;

    var keys$2 = entryVirtual('Array').keys;

    var keys$1 = keys$2;

    var ArrayPrototype$3 = Array.prototype;
    var DOMIterables$2 = {
        DOMTokenList: true,
        NodeList: true
    };

    var keys_1 = function (it) {
        var own = it.keys;
        return it === ArrayPrototype$3 || it instanceof Array && own === ArrayPrototype$3.keys // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$2.hasOwnProperty(classof(it)) ? keys$1 : own;
    };

    var keys = keys_1;

    var values$2 = entryVirtual('Array').values;

    var values$1 = values$2;

    var ArrayPrototype$2 = Array.prototype;
    var DOMIterables$1 = {
        DOMTokenList: true,
        NodeList: true
    };

    var values_1 = function (it) {
        var own = it.values;
        return it === ArrayPrototype$2 || it instanceof Array && own === ArrayPrototype$2.values // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$1.hasOwnProperty(classof(it)) ? values$1 : own;
    };

    var values = values_1;

    var entries$2 = entryVirtual('Array').entries;

    var entries$1 = entries$2;

    var ArrayPrototype$1 = Array.prototype;
    var DOMIterables = {
        DOMTokenList: true,
        NodeList: true
    };

    var entries_1 = function (it) {
        var own = it.entries;
        return it === ArrayPrototype$1 || it instanceof Array && own === ArrayPrototype$1.entries // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables.hasOwnProperty(classof(it)) ? entries$1 : own;
    };

    var entries = entries_1;

    // Unique ID creation requires a high quality random # generator. In the browser we therefore
    // require the crypto API and do not support built-in fallback to lower quality random number
    // generators (like Math.random()).
    var getRandomValues;
    var rnds8 = new Uint8Array(16);
    function rng() {
        // lazy load so that environments that need to polyfill have a chance to do so
        if (!getRandomValues) {
            // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
            // find the complete implementation of crypto (msCrypto) on IE11.
            getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

            if (!getRandomValues) {
                throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
            }
        }

        return getRandomValues(rnds8);
    }

    var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

    function validate(uuid) {
        return typeof uuid === 'string' && REGEX.test(uuid);
    }

    /**
     * Convert array of 16 byte values to UUID string format of the form:
     * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
     */

    var byteToHex = [];

    for (var i = 0; i < 256; ++i) {
        byteToHex.push((i + 0x100).toString(16).substr(1));
    }

    function stringify(arr) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
        // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

        var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
        // of the following:
        // - One or more input array values don't map to a hex octet (leading to
        // "undefined" in the uuid)
        // - Invalid input values for the RFC `version` or `variant` fields

        if (!validate(uuid)) {
            throw TypeError('Stringified UUID is invalid');
        }

        return uuid;
    }

    function v4(options, buf, offset) {
        options = options || {};
        var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

        if (buf) {
            offset = offset || 0;

            for (var i = 0; i < 16; ++i) {
                buf[offset + i] = rnds[i];
            }

            return buf;
        }

        return stringify(rnds);
    }

    function ownKeys$4(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context32; forEach$2(_context32 = ownKeys$4(Object(source), true)).call(_context32, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context33; forEach$2(_context33 = ownKeys$4(Object(source))).call(_context33, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

    function _createForOfIteratorHelper$7(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$7(o, minLen) { var _context31; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = slice$1(_context31 = Object.prototype.toString.call(o)).call(_context31, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

    function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Create new data pipe.
     *
     * @param from - The source data set or data view.
     *
     * @remarks
     * Example usage:
     * ```typescript
     * interface AppItem {
     *   whoami: string;
     *   appData: unknown;
     *   visData: VisItem;
     * }
     * interface VisItem {
     *   id: number;
     *   label: string;
     *   color: string;
     *   x: number;
     *   y: number;
     * }
     *
     * const ds1 = new DataSet<AppItem, "whoami">([], { fieldId: "whoami" });
     * const ds2 = new DataSet<VisItem, "id">();
     *
     * const pipe = createNewDataPipeFrom(ds1)
     *   .filter((item): boolean => item.enabled === true)
     *   .map<VisItem, "id">((item): VisItem => item.visData)
     *   .to(ds2);
     *
     * pipe.start();
     * ```
     *
     * @returns A factory whose methods can be used to configure the pipe.
     */

    function createNewDataPipeFrom(from) {
        return new DataPipeUnderConstruction(from);
    }
    /**
     * Internal implementation of the pipe. This should be accessible only through
     * `createNewDataPipeFrom` from the outside.
     *
     * @typeParam SI - Source item type.
     * @typeParam SP - Source item type's id property name.
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     */


    var SimpleDataPipe = /*#__PURE__*/function () {
        /**
         * Create a new data pipe.
         *
         * @param _source - The data set or data view that will be observed.
         * @param _transformers - An array of transforming functions to be used to
         * filter or transform the items in the pipe.
         * @param _target - The data set or data view that will receive the items.
         */
        function SimpleDataPipe(_source, _transformers, _target) {
            var _context, _context2, _context3;

            _classCallCheck(this, SimpleDataPipe);

            this._source = _source;
            this._transformers = _transformers;
            this._target = _target;
            /**
             * Bound listeners for use with `DataInterface['on' | 'off']`.
             */

            this._listeners = {
                add: bind(_context = this._add).call(_context, this),
                remove: bind(_context2 = this._remove).call(_context2, this),
                update: bind(_context3 = this._update).call(_context3, this)
            };
        }
        /** @inheritDoc */


        _createClass(SimpleDataPipe, [{
            key: "all",
            value: function all() {
                this._target.update(this._transformItems(this._source.get()));

                return this;
            }
            /** @inheritDoc */

        }, {
            key: "start",
            value: function start() {
                this._source.on("add", this._listeners.add);

                this._source.on("remove", this._listeners.remove);

                this._source.on("update", this._listeners.update);

                return this;
            }
            /** @inheritDoc */

        }, {
            key: "stop",
            value: function stop() {
                this._source.off("add", this._listeners.add);

                this._source.off("remove", this._listeners.remove);

                this._source.off("update", this._listeners.update);

                return this;
            }
            /**
             * Apply the transformers to the items.
             *
             * @param items - The items to be transformed.
             *
             * @returns The transformed items.
             */

        }, {
            key: "_transformItems",
            value: function _transformItems(items) {
                var _context4;

                return reduce(_context4 = this._transformers).call(_context4, function (items, transform) {
                    return transform(items);
                }, items);
            }
            /**
             * Handle an add event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the ids of the added items.
             */

        }, {
            key: "_add",
            value: function _add(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.add(this._transformItems(this._source.get(payload.items)));
            }
            /**
             * Handle an update event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the ids of the updated items.
             */

        }, {
            key: "_update",
            value: function _update(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.update(this._transformItems(this._source.get(payload.items)));
            }
            /**
             * Handle a remove event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the data of the removed items.
             */

        }, {
            key: "_remove",
            value: function _remove(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.remove(this._transformItems(payload.oldData));
            }
        }]);

        return SimpleDataPipe;
    }();
    /**
     * Internal implementation of the pipe factory. This should be accessible
     * only through `createNewDataPipeFrom` from the outside.
     *
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     */


    var DataPipeUnderConstruction = /*#__PURE__*/function () {
        /**
         * Create a new data pipe factory. This is an internal constructor that
         * should never be called from outside of this file.
         *
         * @param _source - The source data set or data view for this pipe.
         */
        function DataPipeUnderConstruction(_source) {
            _classCallCheck(this, DataPipeUnderConstruction);

            this._source = _source;
            /**
             * Array transformers used to transform items within the pipe. This is typed
             * as any for the sake of simplicity.
             */

            this._transformers = [];
        }
        /**
         * Filter the items.
         *
         * @param callback - A filtering function that returns true if given item
         * should be piped and false if not.
         *
         * @returns This factory for further configuration.
         */


        _createClass(DataPipeUnderConstruction, [{
            key: "filter",
            value: function filter$1(callback) {
                this._transformers.push(function (input) {
                    return filter(input).call(input, callback);
                });

                return this;
            }
            /**
             * Map each source item to a new type.
             *
             * @param callback - A mapping function that takes a source item and returns
             * corresponding mapped item.
             *
             * @typeParam TI - Target item type.
             * @typeParam TP - Target item type's id property name.
             *
             * @returns This factory for further configuration.
             */

        }, {
            key: "map",
            value: function map(callback) {
                this._transformers.push(function (input) {
                    return map$3(input).call(input, callback);
                });

                return this;
            }
            /**
             * Map each source item to zero or more items of a new type.
             *
             * @param callback - A mapping function that takes a source item and returns
             * an array of corresponding mapped items.
             *
             * @typeParam TI - Target item type.
             * @typeParam TP - Target item type's id property name.
             *
             * @returns This factory for further configuration.
             */

        }, {
            key: "flatMap",
            value: function flatMap$1(callback) {
                this._transformers.push(function (input) {
                    return flatMap(input).call(input, callback);
                });

                return this;
            }
            /**
             * Connect this pipe to given data set.
             *
             * @param target - The data set that will receive the items from this pipe.
             *
             * @returns The pipe connected between given data sets and performing
             * configured transformation on the processed items.
             */

        }, {
            key: "to",
            value: function to(target) {
                return new SimpleDataPipe(this._source, this._transformers, target);
            }
        }]);

        return DataPipeUnderConstruction;
    }();
    /**
     * Determine whether a value can be used as an id.
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if the value is valid id, false otherwise.
     */


    function isId(value) {
        return typeof value === "string" || typeof value === "number";
    }
    /**
     * A queue.
     *
     * @typeParam T - The type of method names to be replaced by queued versions.
     */


    var Queue = /*#__PURE__*/function () {
        /**
         * Construct a new Queue.
         *
         * @param options - Queue configuration.
         */
        function Queue(options) {
            _classCallCheck(this, Queue);

            this._queue = [];
            this._timeout = null;
            this._extended = null; // options

            this.delay = null;
            this.max = Infinity;
            this.setOptions(options);
        }
        /**
         * Update the configuration of the queue.
         *
         * @param options - Queue configuration.
         */


        _createClass(Queue, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options && typeof options.delay !== "undefined") {
                    this.delay = options.delay;
                }

                if (options && typeof options.max !== "undefined") {
                    this.max = options.max;
                }

                this._flushIfNeeded();
            }
            /**
             * Extend an object with queuing functionality.
             * The object will be extended with a function flush, and the methods provided in options.replace will be replaced with queued ones.
             *
             * @param object - The object to be extended.
             * @param options - Additional options.
             *
             * @returns The created queue.
             */

        }, {
            key: "destroy",
            value:
                /**
                 * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
                 */
                function destroy() {
                    this.flush();

                    if (this._extended) {
                        var object = this._extended.object;
                        var methods = this._extended.methods;

                        for (var i = 0; i < methods.length; i++) {
                            var method = methods[i];

                            if (method.original) {
                                // @TODO: better solution?
                                object[method.name] = method.original;
                            } else {
                                // @TODO: better solution?
                                delete object[method.name];
                            }
                        }

                        this._extended = null;
                    }
                }
            /**
             * Replace a method on an object with a queued version.
             *
             * @param object - Object having the method.
             * @param method - The method name.
             */

        }, {
            key: "replace",
            value: function replace(object, method) {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias -- Function this is necessary in the function bellow, so class this has to be saved into a variable here. */
                var me = this;
                var original = object[method];

                if (!original) {
                    throw new Error("Method " + method + " undefined");
                }

                object[method] = function () {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    // add this call to the queue
                    me.queue({
                        args: args,
                        fn: original,
                        context: this
                    });
                };
            }
            /**
             * Queue a call.
             *
             * @param entry - The function or entry to be queued.
             */

        }, {
            key: "queue",
            value: function queue(entry) {
                if (typeof entry === "function") {
                    this._queue.push({
                        fn: entry
                    });
                } else {
                    this._queue.push(entry);
                }

                this._flushIfNeeded();
            }
            /**
             * Check whether the queue needs to be flushed.
             */

        }, {
            key: "_flushIfNeeded",
            value: function _flushIfNeeded() {
                var _this = this;

                // flush when the maximum is exceeded.
                if (this._queue.length > this.max) {
                    this.flush();
                } // flush after a period of inactivity when a delay is configured


                if (this._timeout != null) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }

                if (this.queue.length > 0 && typeof this.delay === "number") {
                    this._timeout = setTimeout$1(function () {
                        _this.flush();
                    }, this.delay);
                }
            }
            /**
             * Flush all queued calls
             */

        }, {
            key: "flush",
            value: function flush() {
                var _context5, _context6;

                forEach$2(_context5 = splice(_context6 = this._queue).call(_context6, 0)).call(_context5, function (entry) {
                    entry.fn.apply(entry.context || entry.fn, entry.args || []);
                });
            }
        }], [{
            key: "extend",
            value: function extend(object, options) {
                var queue = new Queue(options);

                if (object.flush !== undefined) {
                    throw new Error("Target object already has a property flush");
                }

                object.flush = function () {
                    queue.flush();
                };

                var methods = [{
                    name: "flush",
                    original: undefined
                }];

                if (options && options.replace) {
                    for (var i = 0; i < options.replace.length; i++) {
                        var name = options.replace[i];
                        methods.push({
                            name: name,
                            // @TODO: better solution?
                            original: object[name]
                        }); // @TODO: better solution?

                        queue.replace(object, name);
                    }
                }

                queue._extended = {
                    object: object,
                    methods: methods
                };
                return queue;
            }
        }]);

        return Queue;
    }();
    /**
     * [[DataSet]] code that can be reused in [[DataView]] or other similar implementations of [[DataInterface]].
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataSetPart = /*#__PURE__*/function () {
        function DataSetPart() {
            _classCallCheck(this, DataSetPart);

            this._subscribers = {
                "*": [],
                add: [],
                remove: [],
                update: []
            };
            /**
             * @deprecated Use on instead (PS: DataView.subscribe === DataView.on).
             */

            this.subscribe = DataSetPart.prototype.on;
            /**
             * @deprecated Use off instead (PS: DataView.unsubscribe === DataView.off).
             */

            this.unsubscribe = DataSetPart.prototype.off;
        }
        /**
         * Trigger an event
         *
         * @param event - Event name.
         * @param payload - Event payload.
         * @param senderId - Id of the sender.
         */


        _createClass(DataSetPart, [{
            key: "_trigger",
            value: function _trigger(event, payload, senderId) {
                var _context7, _context8;

                if (event === "*") {
                    throw new Error("Cannot trigger event *");
                }

                forEach$2(_context7 = concat(_context8 = []).call(_context8, _toConsumableArray(this._subscribers[event]), _toConsumableArray(this._subscribers["*"]))).call(_context7, function (subscriber) {
                    subscriber(event, payload, senderId != null ? senderId : null);
                });
            }
            /**
             * Subscribe to an event, add an event listener.
             *
             * @remarks Non-function callbacks are ignored.
             *
             * @param event - Event name.
             * @param callback - Callback method.
             */

        }, {
            key: "on",
            value: function on(event, callback) {
                if (typeof callback === "function") {
                    this._subscribers[event].push(callback);
                } // @TODO: Maybe throw for invalid callbacks?

            }
            /**
             * Unsubscribe from an event, remove an event listener.
             *
             * @remarks If the same callback was subscribed more than once **all** occurences will be removed.
             *
             * @param event - Event name.
             * @param callback - Callback method.
             */

        }, {
            key: "off",
            value: function off(event, callback) {
                var _context9;

                this._subscribers[event] = filter(_context9 = this._subscribers[event]).call(_context9, function (subscriber) {
                    return subscriber !== callback;
                });
            }
        }]);

        return DataSetPart;
    }();
    /**
     * Data stream
     *
     * @remarks
     * [[DataStream]] offers an always up to date stream of items from a [[DataSet]] or [[DataView]].
     * That means that the stream is evaluated at the time of iteration, conversion to another data type or when [[cache]] is called, not when the [[DataStream]] was created.
     * Multiple invocations of for example [[toItemArray]] may yield different results (if the data source like for example [[DataSet]] gets modified).
     *
     * @typeParam Item - The item type this stream is going to work with.
     */


    var DataStream = /*#__PURE__*/function () {
        /**
         * Create a new data stream.
         *
         * @param pairs - The id, item pairs.
         */
        function DataStream(pairs) {
            _classCallCheck(this, DataStream);

            this._pairs = pairs;
        }
        /**
         * Return an iterable of key, value pairs for every entry in the stream.
         */


        _createClass(DataStream, [{
            key: iterator,
            value:
            /*#__PURE__*/
                regenerator.mark(function value() {
                    var _iterator, _step, _step$value, id, item;

                    return regenerator.wrap(function value$(_context10) {
                        while (1) {
                            switch (_context10.prev = _context10.next) {
                                case 0:
                                    _iterator = _createForOfIteratorHelper$7(this._pairs);
                                    _context10.prev = 1;

                                    _iterator.s();

                                case 3:
                                    if ((_step = _iterator.n()).done) {
                                        _context10.next = 9;
                                        break;
                                    }

                                    _step$value = _slicedToArray(_step.value, 2), id = _step$value[0], item = _step$value[1];
                                    _context10.next = 7;
                                    return [id, item];

                                case 7:
                                    _context10.next = 3;
                                    break;

                                case 9:
                                    _context10.next = 14;
                                    break;

                                case 11:
                                    _context10.prev = 11;
                                    _context10.t0 = _context10["catch"](1);

                                    _iterator.e(_context10.t0);

                                case 14:
                                    _context10.prev = 14;

                                    _iterator.f();

                                    return _context10.finish(14);

                                case 17:
                                case "end":
                                    return _context10.stop();
                            }
                        }
                    }, value, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of key, value pairs for every entry in the stream.
             */

        }, {
            key: "entries",
            value:
            /*#__PURE__*/
                regenerator.mark(function entries() {
                    var _iterator2, _step2, _step2$value, id, item;

                    return regenerator.wrap(function entries$(_context11) {
                        while (1) {
                            switch (_context11.prev = _context11.next) {
                                case 0:
                                    _iterator2 = _createForOfIteratorHelper$7(this._pairs);
                                    _context11.prev = 1;

                                    _iterator2.s();

                                case 3:
                                    if ((_step2 = _iterator2.n()).done) {
                                        _context11.next = 9;
                                        break;
                                    }

                                    _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], item = _step2$value[1];
                                    _context11.next = 7;
                                    return [id, item];

                                case 7:
                                    _context11.next = 3;
                                    break;

                                case 9:
                                    _context11.next = 14;
                                    break;

                                case 11:
                                    _context11.prev = 11;
                                    _context11.t0 = _context11["catch"](1);

                                    _iterator2.e(_context11.t0);

                                case 14:
                                    _context11.prev = 14;

                                    _iterator2.f();

                                    return _context11.finish(14);

                                case 17:
                                case "end":
                                    return _context11.stop();
                            }
                        }
                    }, entries, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of keys in the stream.
             */

        }, {
            key: "keys",
            value:
            /*#__PURE__*/
                regenerator.mark(function keys() {
                    var _iterator3, _step3, _step3$value, id;

                    return regenerator.wrap(function keys$(_context12) {
                        while (1) {
                            switch (_context12.prev = _context12.next) {
                                case 0:
                                    _iterator3 = _createForOfIteratorHelper$7(this._pairs);
                                    _context12.prev = 1;

                                    _iterator3.s();

                                case 3:
                                    if ((_step3 = _iterator3.n()).done) {
                                        _context12.next = 9;
                                        break;
                                    }

                                    _step3$value = _slicedToArray(_step3.value, 1), id = _step3$value[0];
                                    _context12.next = 7;
                                    return id;

                                case 7:
                                    _context12.next = 3;
                                    break;

                                case 9:
                                    _context12.next = 14;
                                    break;

                                case 11:
                                    _context12.prev = 11;
                                    _context12.t0 = _context12["catch"](1);

                                    _iterator3.e(_context12.t0);

                                case 14:
                                    _context12.prev = 14;

                                    _iterator3.f();

                                    return _context12.finish(14);

                                case 17:
                                case "end":
                                    return _context12.stop();
                            }
                        }
                    }, keys, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of values in the stream.
             */

        }, {
            key: "values",
            value:
            /*#__PURE__*/
                regenerator.mark(function values() {
                    var _iterator4, _step4, _step4$value, item;

                    return regenerator.wrap(function values$(_context13) {
                        while (1) {
                            switch (_context13.prev = _context13.next) {
                                case 0:
                                    _iterator4 = _createForOfIteratorHelper$7(this._pairs);
                                    _context13.prev = 1;

                                    _iterator4.s();

                                case 3:
                                    if ((_step4 = _iterator4.n()).done) {
                                        _context13.next = 9;
                                        break;
                                    }

                                    _step4$value = _slicedToArray(_step4.value, 2), item = _step4$value[1];
                                    _context13.next = 7;
                                    return item;

                                case 7:
                                    _context13.next = 3;
                                    break;

                                case 9:
                                    _context13.next = 14;
                                    break;

                                case 11:
                                    _context13.prev = 11;
                                    _context13.t0 = _context13["catch"](1);

                                    _iterator4.e(_context13.t0);

                                case 14:
                                    _context13.prev = 14;

                                    _iterator4.f();

                                    return _context13.finish(14);

                                case 17:
                                case "end":
                                    return _context13.stop();
                            }
                        }
                    }, values, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an array containing all the ids in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all ids from this stream.
             */

        }, {
            key: "toIdArray",
            value: function toIdArray() {
                var _context14;

                return map$3(_context14 = _toConsumableArray(this._pairs)).call(_context14, function (pair) {
                    return pair[0];
                });
            }
            /**
             * Return an array containing all the items in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all items from this stream.
             */

        }, {
            key: "toItemArray",
            value: function toItemArray() {
                var _context15;

                return map$3(_context15 = _toConsumableArray(this._pairs)).call(_context15, function (pair) {
                    return pair[1];
                });
            }
            /**
             * Return an array containing all the entries in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all entries from this stream.
             */

        }, {
            key: "toEntryArray",
            value: function toEntryArray() {
                return _toConsumableArray(this._pairs);
            }
            /**
             * Return an object map containing all the items in this stream accessible by ids.
             *
             * @remarks
             * In case of duplicate ids (coerced to string so `7 == '7'`) the last encoutered appears in the returned object.
             *
             * @returns The object map of all id → item pairs from this stream.
             */

        }, {
            key: "toObjectMap",
            value: function toObjectMap() {
                var map = create$2(null);

                var _iterator5 = _createForOfIteratorHelper$7(this._pairs),
                    _step5;

                try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var _step5$value = _slicedToArray(_step5.value, 2),
                            id = _step5$value[0],
                            item = _step5$value[1];

                        map[id] = item;
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally {
                    _iterator5.f();
                }

                return map;
            }
            /**
             * Return a map containing all the items in this stream accessible by ids.
             *
             * @returns The map of all id → item pairs from this stream.
             */

        }, {
            key: "toMap",
            value: function toMap() {
                return new map(this._pairs);
            }
            /**
             * Return a set containing all the (unique) ids in this stream.
             *
             * @returns The set of all ids from this stream.
             */

        }, {
            key: "toIdSet",
            value: function toIdSet() {
                return new set(this.toIdArray());
            }
            /**
             * Return a set containing all the (unique) items in this stream.
             *
             * @returns The set of all items from this stream.
             */

        }, {
            key: "toItemSet",
            value: function toItemSet() {
                return new set(this.toItemArray());
            }
            /**
             * Cache the items from this stream.
             *
             * @remarks
             * This method allows for items to be fetched immediatelly and used (possibly multiple times) later.
             * It can also be used to optimize performance as [[DataStream]] would otherwise reevaluate everything upon each iteration.
             *
             * ## Example
             * ```javascript
             * const ds = new DataSet([…])
             *
             * const cachedStream = ds.stream()
             *   .filter(…)
             *   .sort(…)
             *   .map(…)
             *   .cached(…) // Data are fetched, processed and cached here.
             *
             * ds.clear()
             * chachedStream // Still has all the items.
             * ```
             *
             * @returns A new [[DataStream]] with cached items (detached from the original [[DataSet]]).
             */

        }, {
            key: "cache",
            value: function cache() {
                return new DataStream(_toConsumableArray(this._pairs));
            }
            /**
             * Get the distinct values of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @typeParam T - The type of the distinct value.
             *
             * @returns A set of all distinct properties.
             */

        }, {
            key: "distinct",
            value: function distinct(callback) {
                var set$1 = new set();

                var _iterator6 = _createForOfIteratorHelper$7(this._pairs),
                    _step6;

                try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var _step6$value = _slicedToArray(_step6.value, 2),
                            id = _step6$value[0],
                            item = _step6$value[1];

                        set$1.add(callback(item, id));
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally {
                    _iterator6.f();
                }

                return set$1;
            }
            /**
             * Filter the items of the stream.
             *
             * @param callback - The function that decides whether an item will be included.
             *
             * @returns A new data stream with the filtered items.
             */

        }, {
            key: "filter",
            value: function filter(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee() {
                    var _iterator7, _step7, _step7$value, id, item;

                    return regenerator.wrap(function _callee$(_context16) {
                        while (1) {
                            switch (_context16.prev = _context16.next) {
                                case 0:
                                    _iterator7 = _createForOfIteratorHelper$7(pairs);
                                    _context16.prev = 1;

                                    _iterator7.s();

                                case 3:
                                    if ((_step7 = _iterator7.n()).done) {
                                        _context16.next = 10;
                                        break;
                                    }

                                    _step7$value = _slicedToArray(_step7.value, 2), id = _step7$value[0], item = _step7$value[1];

                                    if (!callback(item, id)) {
                                        _context16.next = 8;
                                        break;
                                    }

                                    _context16.next = 8;
                                    return [id, item];

                                case 8:
                                    _context16.next = 3;
                                    break;

                                case 10:
                                    _context16.next = 15;
                                    break;

                                case 12:
                                    _context16.prev = 12;
                                    _context16.t0 = _context16["catch"](1);

                                    _iterator7.e(_context16.t0);

                                case 15:
                                    _context16.prev = 15;

                                    _iterator7.f();

                                    return _context16.finish(15);

                                case 18:
                                case "end":
                                    return _context16.stop();
                            }
                        }
                    }, _callee, null, [[1, 12, 15, 18]]);
                })));
            }
            /**
             * Execute a callback for each item of the stream.
             *
             * @param callback - The function that will be invoked for each item.
             */

        }, {
            key: "forEach",
            value: function forEach(callback) {
                var _iterator8 = _createForOfIteratorHelper$7(this._pairs),
                    _step8;

                try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                        var _step8$value = _slicedToArray(_step8.value, 2),
                            id = _step8$value[0],
                            item = _step8$value[1];

                        callback(item, id);
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally {
                    _iterator8.f();
                }
            }
            /**
             * Map the items into a different type.
             *
             * @param callback - The function that does the conversion.
             *
             * @typeParam Mapped - The type of the item after mapping.
             *
             * @returns A new data stream with the mapped items.
             */

        }, {
            key: "map",
            value: function map(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee2() {
                    var _iterator9, _step9, _step9$value, id, item;

                    return regenerator.wrap(function _callee2$(_context17) {
                        while (1) {
                            switch (_context17.prev = _context17.next) {
                                case 0:
                                    _iterator9 = _createForOfIteratorHelper$7(pairs);
                                    _context17.prev = 1;

                                    _iterator9.s();

                                case 3:
                                    if ((_step9 = _iterator9.n()).done) {
                                        _context17.next = 9;
                                        break;
                                    }

                                    _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], item = _step9$value[1];
                                    _context17.next = 7;
                                    return [id, callback(item, id)];

                                case 7:
                                    _context17.next = 3;
                                    break;

                                case 9:
                                    _context17.next = 14;
                                    break;

                                case 11:
                                    _context17.prev = 11;
                                    _context17.t0 = _context17["catch"](1);

                                    _iterator9.e(_context17.t0);

                                case 14:
                                    _context17.prev = 14;

                                    _iterator9.f();

                                    return _context17.finish(14);

                                case 17:
                                case "end":
                                    return _context17.stop();
                            }
                        }
                    }, _callee2, null, [[1, 11, 14, 17]]);
                })));
            }
            /**
             * Get the item with the maximum value of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @returns The item with the maximum if found otherwise null.
             */

        }, {
            key: "max",
            value: function max(callback) {
                var iter = getIterator(this._pairs);

                var curr = iter.next();

                if (curr.done) {
                    return null;
                }

                var maxItem = curr.value[1];
                var maxValue = callback(curr.value[1], curr.value[0]);

                while (!(curr = iter.next()).done) {
                    var _curr$value = _slicedToArray(curr.value, 2),
                        id = _curr$value[0],
                        item = _curr$value[1];

                    var _value = callback(item, id);

                    if (_value > maxValue) {
                        maxValue = _value;
                        maxItem = item;
                    }
                }

                return maxItem;
            }
            /**
             * Get the item with the minimum value of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @returns The item with the minimum if found otherwise null.
             */

        }, {
            key: "min",
            value: function min(callback) {
                var iter = getIterator(this._pairs);

                var curr = iter.next();

                if (curr.done) {
                    return null;
                }

                var minItem = curr.value[1];
                var minValue = callback(curr.value[1], curr.value[0]);

                while (!(curr = iter.next()).done) {
                    var _curr$value2 = _slicedToArray(curr.value, 2),
                        id = _curr$value2[0],
                        item = _curr$value2[1];

                    var _value2 = callback(item, id);

                    if (_value2 < minValue) {
                        minValue = _value2;
                        minItem = item;
                    }
                }

                return minItem;
            }
            /**
             * Reduce the items into a single value.
             *
             * @param callback - The function that does the reduction.
             * @param accumulator - The initial value of the accumulator.
             *
             * @typeParam T - The type of the accumulated value.
             *
             * @returns The reduced value.
             */

        }, {
            key: "reduce",
            value: function reduce(callback, accumulator) {
                var _iterator10 = _createForOfIteratorHelper$7(this._pairs),
                    _step10;

                try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                        var _step10$value = _slicedToArray(_step10.value, 2),
                            id = _step10$value[0],
                            item = _step10$value[1];

                        accumulator = callback(accumulator, item, id);
                    }
                } catch (err) {
                    _iterator10.e(err);
                } finally {
                    _iterator10.f();
                }

                return accumulator;
            }
            /**
             * Sort the items.
             *
             * @param callback - Item comparator.
             *
             * @returns A new stream with sorted items.
             */

        }, {
            key: "sort",
            value: function sort$1(callback) {
                var _this2 = this;

                return new DataStream(_defineProperty({}, iterator, function () {
                    var _context18;

                    return getIterator(sort(_context18 = _toConsumableArray(_this2._pairs)).call(_context18, function (_ref, _ref2) {
                        var _ref3 = _slicedToArray(_ref, 2),
                            idA = _ref3[0],
                            itemA = _ref3[1];

                        var _ref4 = _slicedToArray(_ref2, 2),
                            idB = _ref4[0],
                            itemB = _ref4[1];

                        return callback(itemA, itemB, idA, idB);
                    }));
                }));
            }
        }]);

        return DataStream;
    }();
    /**
     * Add an id to given item if it doesn't have one already.
     *
     * @remarks
     * The item will be modified.
     *
     * @param item - The item that will have an id after a call to this function.
     * @param idProp - The key of the id property.
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     *
     * @returns true
     */


    function ensureFullItem(item, idProp) {
        if (item[idProp] == null) {
            // generate an id
            item[idProp] = v4();
        }

        return item;
    }
    /**
     * # DataSet
     *
     * Vis.js comes with a flexible DataSet, which can be used to hold and
     * manipulate unstructured data and listen for changes in the data. The DataSet
     * is key/value based. Data items can be added, updated and removed from the
     * DataSet, and one can subscribe to changes in the DataSet. The data in the
     * DataSet can be filtered and ordered. Data can be normalized when appending it
     * to the DataSet as well.
     *
     * ## Example
     *
     * The following example shows how to use a DataSet.
     *
     * ```javascript
     * // create a DataSet
     * var options = {};
     * var data = new vis.DataSet(options);
     *
     * // add items
     * // note that the data items can contain different properties and data formats
     * data.add([
     *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
     *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
     *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
     *   {id: 4, text: 'item 4'}
     * ]);
     *
     * // subscribe to any change in the DataSet
     * data.on('*', function (event, properties, senderId) {
     *   console.log('event', event, properties);
     * });
     *
     * // update an existing item
     * data.update({id: 2, group: 1});
     *
     * // remove an item
     * data.remove(4);
     *
     * // get all ids
     * var ids = data.getIds();
     * console.log('ids', ids);
     *
     * // get a specific item
     * var item1 = data.get(1);
     * console.log('item1', item1);
     *
     * // retrieve a filtered subset of the data
     * var items = data.get({
     *   filter: function (item) {
     *     return item.group == 1;
     *   }
     * });
     * console.log('filtered items', items);
     * ```
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataSet = /*#__PURE__*/function (_DataSetPart) {
        _inherits(DataSet, _DataSetPart);

        var _super = _createSuper$t(DataSet);

        /**
         * Construct a new DataSet.
         *
         * @param data - Initial data or options.
         * @param options - Options (type error if data is also options).
         */
        function DataSet(data, options) {
            var _this3;

            _classCallCheck(this, DataSet);

            _this3 = _super.call(this);
            _this3._queue = null; // correctly read optional arguments

            if (data && !isArray(data)) {
                options = data;
                data = [];
            }

            _this3._options = options || {};
            _this3._data = new map(); // map with data indexed by id

            _this3.length = 0; // number of items in the DataSet

            _this3._idProp = _this3._options.fieldId || "id"; // name of the field containing id
            // add initial data when provided

            if (data && data.length) {
                _this3.add(data);
            }

            _this3.setOptions(options);

            return _this3;
        }
        /** @inheritDoc */


        _createClass(DataSet, [{
            key: "idProp",
            get: function get() {
                return this._idProp;
            }
            /**
             * Set new options.
             *
             * @param options - The new options.
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && options.queue !== undefined) {
                    if (options.queue === false) {
                        // delete queue if loaded
                        if (this._queue) {
                            this._queue.destroy();

                            this._queue = null;
                        }
                    } else {
                        // create queue and update its options
                        if (!this._queue) {
                            this._queue = Queue.extend(this, {
                                replace: ["add", "update", "remove"]
                            });
                        }

                        if (options.queue && _typeof(options.queue) === "object") {
                            this._queue.setOptions(options.queue);
                        }
                    }
                }
            }
            /**
             * Add a data item or an array with items.
             *
             * After the items are added to the DataSet, the DataSet will trigger an event `add`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet()
             *
             * // add items
             * const ids = data.add([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { text: 'item without an id' }
             * ])
             *
             * console.log(ids) // [1, 2, '<UUIDv4>']
             * ```
             *
             * @param data - Items to be added (ids will be generated if missing).
             * @param senderId - Sender id.
             *
             * @returns addedIds - Array with the ids (generated if not present) of the added items.
             *
             * @throws When an item with the same id as any of the added items already exists.
             */

        }, {
            key: "add",
            value: function add(data, senderId) {
                var _this4 = this;

                var addedIds = [];
                var id;

                if (isArray(data)) {
                    // Array
                    var idsToAdd = map$3(data).call(data, function (d) {
                        return d[_this4._idProp];
                    });

                    if (some(idsToAdd).call(idsToAdd, function (id) {
                        return _this4._data.has(id);
                    })) {
                        throw new Error("A duplicate id was found in the parameter array.");
                    }

                    for (var i = 0, len = data.length; i < len; i++) {
                        id = this._addItem(data[i]);
                        addedIds.push(id);
                    }
                } else if (data && _typeof(data) === "object") {
                    // Single item
                    id = this._addItem(data);
                    addedIds.push(id);
                } else {
                    throw new Error("Unknown dataType");
                }

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                return addedIds;
            }
            /**
             * Update existing items. When an item does not exist, it will be created.
             *
             * @remarks
             * The provided properties will be merged in the existing item. When an item does not exist, it will be created.
             *
             * After the items are updated, the DataSet will trigger an event `add` for the added items, and an event `update`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' }
             * ])
             *
             * // update items
             * const ids = data.update([
             *   { id: 2, text: 'item 2 (updated)' },
             *   { id: 4, text: 'item 4 (new)' }
             * ])
             *
             * console.log(ids) // [2, 4]
             * ```
             *
             * ## Warning for TypeScript users
             * This method may introduce partial items into the data set. Use add or updateOnly instead for better type safety.
             *
             * @param data - Items to be updated (if the id is already present) or added (if the id is missing).
             * @param senderId - Sender id.
             *
             * @returns updatedIds - The ids of the added (these may be newly generated if there was no id in the item from the data) or updated items.
             *
             * @throws When the supplied data is neither an item nor an array of items.
             */

        }, {
            key: "update",
            value: function update(data, senderId) {
                var _this5 = this;

                var addedIds = [];
                var updatedIds = [];
                var oldData = [];
                var updatedData = [];
                var idProp = this._idProp;

                var addOrUpdate = function addOrUpdate(item) {
                    var origId = item[idProp];

                    if (origId != null && _this5._data.has(origId)) {
                        var fullItem = item; // it has an id, therefore it is a fullitem

                        var oldItem = assign$2({}, _this5._data.get(origId)); // update item


                        var id = _this5._updateItem(fullItem);

                        updatedIds.push(id);
                        updatedData.push(fullItem);
                        oldData.push(oldItem);
                    } else {
                        // add new item
                        var _id = _this5._addItem(item);

                        addedIds.push(_id);
                    }
                };

                if (isArray(data)) {
                    // Array
                    for (var i = 0, len = data.length; i < len; i++) {
                        if (data[i] && _typeof(data[i]) === "object") {
                            addOrUpdate(data[i]);
                        } else {
                            console.warn("Ignoring input item, which is not an object at index " + i);
                        }
                    }
                } else if (data && _typeof(data) === "object") {
                    // Single item
                    addOrUpdate(data);
                } else {
                    throw new Error("Unknown dataType");
                }

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                if (updatedIds.length) {
                    var props = {
                        items: updatedIds,
                        oldData: oldData,
                        data: updatedData
                    }; // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});

                    this._trigger("update", props, senderId);
                }

                return concat(addedIds).call(addedIds, updatedIds);
            }
            /**
             * Update existing items. When an item does not exist, an error will be thrown.
             *
             * @remarks
             * The provided properties will be deeply merged into the existing item.
             * When an item does not exist (id not present in the data set or absent), an error will be thrown and nothing will be changed.
             *
             * After the items are updated, the DataSet will trigger an event `update`.
             * When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' },
             * ])
             *
             * // update items
             * const ids = data.update([
             *   { id: 2, text: 'item 2 (updated)' }, // works
             *   // { id: 4, text: 'item 4 (new)' }, // would throw
             *   // { text: 'item 4 (new)' }, // would also throw
             * ])
             *
             * console.log(ids) // [2]
             * ```
             *
             * @param data - Updates (the id and optionally other props) to the items in this data set.
             * @param senderId - Sender id.
             *
             * @returns updatedIds - The ids of the updated items.
             *
             * @throws When the supplied data is neither an item nor an array of items, when the ids are missing.
             */

        }, {
            key: "updateOnly",
            value: function updateOnly(data, senderId) {
                var _context19,
                    _this6 = this;

                if (!isArray(data)) {
                    data = [data];
                }

                var updateEventData = map$3(_context19 = map$3(data).call(data, function (update) {
                    var oldData = _this6._data.get(update[_this6._idProp]);

                    if (oldData == null) {
                        throw new Error("Updating non-existent items is not allowed.");
                    }

                    return {
                        oldData: oldData,
                        update: update
                    };
                })).call(_context19, function (_ref5) {
                    var oldData = _ref5.oldData,
                        update = _ref5.update;
                    var id = oldData[_this6._idProp];
                    var updatedData = pureDeepObjectAssign(oldData, update);

                    _this6._data.set(id, updatedData);

                    return {
                        id: id,
                        oldData: oldData,
                        updatedData: updatedData
                    };
                });

                if (updateEventData.length) {
                    var props = {
                        items: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.id;
                        }),
                        oldData: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.oldData;
                        }),
                        data: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.updatedData;
                        })
                    }; // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});

                    this._trigger("update", props, senderId);

                    return props.items;
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "get",
            value: function get(first, second) {
                // @TODO: Woudn't it be better to split this into multiple methods?
                // parse the arguments
                var id = undefined;
                var ids = undefined;
                var options = undefined;

                if (isId(first)) {
                    // get(id [, options])
                    id = first;
                    options = second;
                } else if (isArray(first)) {
                    // get(ids [, options])
                    ids = first;
                    options = second;
                } else {
                    // get([, options])
                    options = first;
                } // determine the return type


                var returnType = options && options.returnType === "Object" ? "Object" : "Array"; // @TODO: WTF is this? Or am I missing something?
                // var returnType
                // if (options && options.returnType) {
                //   var allowedValues = ['Array', 'Object']
                //   returnType =
                //     allowedValues.indexOf(options.returnType) == -1
                //       ? 'Array'
                //       : options.returnType
                // } else {
                //   returnType = 'Array'
                // }
                // build options

                var filter$1 = options && filter(options);

                var items = [];
                var item = undefined;
                var itemIds = undefined;
                var itemId = undefined; // convert items

                if (id != null) {
                    // return a single item
                    item = this._data.get(id);

                    if (item && filter$1 && !filter$1(item)) {
                        item = undefined;
                    }
                } else if (ids != null) {
                    // return a subset of items
                    for (var i = 0, len = ids.length; i < len; i++) {
                        item = this._data.get(ids[i]);

                        if (item != null && (!filter$1 || filter$1(item))) {
                            items.push(item);
                        }
                    }
                } else {
                    var _context20;

                    // return all items
                    itemIds = _toConsumableArray(keys(_context20 = this._data).call(_context20));

                    for (var _i = 0, _len2 = itemIds.length; _i < _len2; _i++) {
                        itemId = itemIds[_i];
                        item = this._data.get(itemId);

                        if (item != null && (!filter$1 || filter$1(item))) {
                            items.push(item);
                        }
                    }
                } // order the results


                if (options && options.order && id == undefined) {
                    this._sort(items, options.order);
                } // filter fields of the items


                if (options && options.fields) {
                    var fields = options.fields;

                    if (id != undefined && item != null) {
                        item = this._filterFields(item, fields);
                    } else {
                        for (var _i2 = 0, _len3 = items.length; _i2 < _len3; _i2++) {
                            items[_i2] = this._filterFields(items[_i2], fields);
                        }
                    }
                } // return the results


                if (returnType == "Object") {
                    var result = {};

                    for (var _i3 = 0, _len4 = items.length; _i3 < _len4; _i3++) {
                        var resultant = items[_i3]; // @TODO: Shoudn't this be this._fieldId?
                        // result[resultant.id] = resultant

                        var _id2 = resultant[this._idProp];
                        result[_id2] = resultant;
                    }

                    return result;
                } else {
                    if (id != null) {
                        var _item;

                        // a single item
                        return (_item = item) !== null && _item !== void 0 ? _item : null;
                    } else {
                        // just return our array
                        return items;
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "getIds",
            value: function getIds(options) {
                var data = this._data;

                var filter$1 = options && filter(options);

                var order = options && options.order;

                var itemIds = _toConsumableArray(keys(data).call(data));

                var ids = [];

                if (filter$1) {
                    // get filtered items
                    if (order) {
                        // create ordered list
                        var items = [];

                        for (var i = 0, len = itemIds.length; i < len; i++) {
                            var id = itemIds[i];

                            var item = this._data.get(id);

                            if (item != null && filter$1(item)) {
                                items.push(item);
                            }
                        }

                        this._sort(items, order);

                        for (var _i4 = 0, _len5 = items.length; _i4 < _len5; _i4++) {
                            ids.push(items[_i4][this._idProp]);
                        }
                    } else {
                        // create unordered list
                        for (var _i5 = 0, _len6 = itemIds.length; _i5 < _len6; _i5++) {
                            var _id3 = itemIds[_i5];

                            var _item2 = this._data.get(_id3);

                            if (_item2 != null && filter$1(_item2)) {
                                ids.push(_item2[this._idProp]);
                            }
                        }
                    }
                } else {
                    // get all items
                    if (order) {
                        // create an ordered list
                        var _items = [];

                        for (var _i6 = 0, _len7 = itemIds.length; _i6 < _len7; _i6++) {
                            var _id4 = itemIds[_i6];

                            _items.push(data.get(_id4));
                        }

                        this._sort(_items, order);

                        for (var _i7 = 0, _len8 = _items.length; _i7 < _len8; _i7++) {
                            ids.push(_items[_i7][this._idProp]);
                        }
                    } else {
                        // create unordered list
                        for (var _i8 = 0, _len9 = itemIds.length; _i8 < _len9; _i8++) {
                            var _id5 = itemIds[_i8];

                            var _item3 = data.get(_id5);

                            if (_item3 != null) {
                                ids.push(_item3[this._idProp]);
                            }
                        }
                    }
                }

                return ids;
            }
            /** @inheritDoc */

        }, {
            key: "getDataSet",
            value: function getDataSet() {
                return this;
            }
            /** @inheritDoc */

        }, {
            key: "forEach",
            value: function forEach(callback, options) {
                var filter$1 = options && filter(options);

                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data));

                if (options && options.order) {
                    // execute forEach on ordered list
                    var items = this.get(options);

                    for (var i = 0, len = items.length; i < len; i++) {
                        var item = items[i];
                        var id = item[this._idProp];
                        callback(item, id);
                    }
                } else {
                    // unordered
                    for (var _i9 = 0, _len10 = itemIds.length; _i9 < _len10; _i9++) {
                        var _id6 = itemIds[_i9];

                        var _item4 = this._data.get(_id6);

                        if (_item4 != null && (!filter$1 || filter$1(_item4))) {
                            callback(_item4, _id6);
                        }
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "map",
            value: function map(callback, options) {
                var filter$1 = options && filter(options);

                var mappedItems = [];
                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data)); // convert and filter items


                for (var i = 0, len = itemIds.length; i < len; i++) {
                    var id = itemIds[i];

                    var item = this._data.get(id);

                    if (item != null && (!filter$1 || filter$1(item))) {
                        mappedItems.push(callback(item, id));
                    }
                } // order items


                if (options && options.order) {
                    this._sort(mappedItems, options.order);
                }

                return mappedItems;
            }
            /**
             * Filter the fields of an item.
             *
             * @param item - The item whose fields should be filtered.
             * @param fields - The names of the fields that will be kept.
             *
             * @typeParam K - Field name type.
             *
             * @returns The item without any additional fields.
             */

        }, {
            key: "_filterFields",
            value: function _filterFields(item, fields) {
                var _context21;

                if (!item) {
                    // item is null
                    return item;
                }

                return reduce(_context21 = isArray(fields) ? // Use the supplied array
                    fields : // Use the keys of the supplied object
                    keys$3(fields)).call(_context21, function (filteredItem, field) {
                    filteredItem[field] = item[field];
                    return filteredItem;
                }, {});
            }
            /**
             * Sort the provided array with items.
             *
             * @param items - Items to be sorted in place.
             * @param order - A field name or custom sort function.
             *
             * @typeParam T - The type of the items in the items array.
             */

        }, {
            key: "_sort",
            value: function _sort(items, order) {
                if (typeof order === "string") {
                    // order by provided field name
                    var name = order; // field name

                    sort(items).call(items, function (a, b) {
                        // @TODO: How to treat missing properties?
                        var av = a[name];
                        var bv = b[name];
                        return av > bv ? 1 : av < bv ? -1 : 0;
                    });
                } else if (typeof order === "function") {
                    // order by sort function
                    sort(items).call(items, order);
                } else {
                    // TODO: extend order by an Object {field:string, direction:string}
                    //       where direction can be 'asc' or 'desc'
                    throw new TypeError("Order must be a function or a string");
                }
            }
            /**
             * Remove an item or multiple items by “reference” (only the id is used) or by id.
             *
             * The method ignores removal of non-existing items, and returns an array containing the ids of the items which are actually removed from the DataSet.
             *
             * After the items are removed, the DataSet will trigger an event `remove` for the removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' }
             * ])
             *
             * // remove items
             * const ids = data.remove([2, { id: 3 }, 4])
             *
             * console.log(ids) // [2, 3]
             * ```
             *
             * @param id - One or more items or ids of items to be removed.
             * @param senderId - Sender id.
             *
             * @returns The ids of the removed items.
             */

        }, {
            key: "remove",
            value: function remove(id, senderId) {
                var removedIds = [];
                var removedItems = []; // force everything to be an array for simplicity

                var ids = isArray(id) ? id : [id];

                for (var i = 0, len = ids.length; i < len; i++) {
                    var item = this._remove(ids[i]);

                    if (item) {
                        var itemId = item[this._idProp];

                        if (itemId != null) {
                            removedIds.push(itemId);
                            removedItems.push(item);
                        }
                    }
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                }

                return removedIds;
            }
            /**
             * Remove an item by its id or reference.
             *
             * @param id - Id of an item or the item itself.
             *
             * @returns The removed item if removed, null otherwise.
             */

        }, {
            key: "_remove",
            value: function _remove(id) {
                // @TODO: It origianlly returned the item although the docs say id.
                // The code expects the item, so probably an error in the docs.
                var ident; // confirm the id to use based on the args type

                if (isId(id)) {
                    ident = id;
                } else if (id && _typeof(id) === "object") {
                    ident = id[this._idProp]; // look for the identifier field using ._idProp
                } // do the removing if the item is found


                if (ident != null && this._data.has(ident)) {
                    var item = this._data.get(ident) || null;

                    this._data.delete(ident);

                    --this.length;
                    return item;
                }

                return null;
            }
            /**
             * Clear the entire data set.
             *
             * After the items are removed, the [[DataSet]] will trigger an event `remove` for all removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * @param senderId - Sender id.
             *
             * @returns removedIds - The ids of all removed items.
             */

        }, {
            key: "clear",
            value: function clear(senderId) {
                var _context22;

                var ids = _toConsumableArray(keys(_context22 = this._data).call(_context22));

                var items = [];

                for (var i = 0, len = ids.length; i < len; i++) {
                    items.push(this._data.get(ids[i]));
                }

                this._data.clear();

                this.length = 0;

                this._trigger("remove", {
                    items: ids,
                    oldData: items
                }, senderId);

                return ids;
            }
            /**
             * Find the item with maximum value of a specified field.
             *
             * @param field - Name of the property that should be searched for max value.
             *
             * @returns Item containing max value, or null if no items.
             */

        }, {
            key: "max",
            value: function max(field) {
                var _context23;

                var max = null;
                var maxField = null;

                var _iterator11 = _createForOfIteratorHelper$7(values(_context23 = this._data).call(_context23)),
                    _step11;

                try {
                    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                        var item = _step11.value;
                        var itemField = item[field];

                        if (typeof itemField === "number" && (maxField == null || itemField > maxField)) {
                            max = item;
                            maxField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator11.e(err);
                } finally {
                    _iterator11.f();
                }

                return max || null;
            }
            /**
             * Find the item with minimum value of a specified field.
             *
             * @param field - Name of the property that should be searched for min value.
             *
             * @returns Item containing min value, or null if no items.
             */

        }, {
            key: "min",
            value: function min(field) {
                var _context24;

                var min = null;
                var minField = null;

                var _iterator12 = _createForOfIteratorHelper$7(values(_context24 = this._data).call(_context24)),
                    _step12;

                try {
                    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                        var item = _step12.value;
                        var itemField = item[field];

                        if (typeof itemField === "number" && (minField == null || itemField < minField)) {
                            min = item;
                            minField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator12.e(err);
                } finally {
                    _iterator12.f();
                }

                return min || null;
            }
            /**
             * Find all distinct values of a specified field
             *
             * @param prop - The property name whose distinct values should be returned.
             *
             * @returns Unordered array containing all distinct values. Items without specified property are ignored.
             */

        }, {
            key: "distinct",
            value: function distinct(prop) {
                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data));

                var values = [];
                var count = 0;

                for (var i = 0, len = itemIds.length; i < len; i++) {
                    var id = itemIds[i];
                    var item = data.get(id);
                    var _value3 = item[prop];
                    var exists = false;

                    for (var j = 0; j < count; j++) {
                        if (values[j] == _value3) {
                            exists = true;
                            break;
                        }
                    }

                    if (!exists && _value3 !== undefined) {
                        values[count] = _value3;
                        count++;
                    }
                }

                return values;
            }
            /**
             * Add a single item. Will fail when an item with the same id already exists.
             *
             * @param item - A new item to be added.
             *
             * @returns Added item's id. An id is generated when it is not present in the item.
             */

        }, {
            key: "_addItem",
            value: function _addItem(item) {
                var fullItem = ensureFullItem(item, this._idProp);
                var id = fullItem[this._idProp]; // check whether this id is already taken

                if (this._data.has(id)) {
                    // item already exists
                    throw new Error("Cannot add item: item with id " + id + " already exists");
                }

                this._data.set(id, fullItem);

                ++this.length;
                return id;
            }
            /**
             * Update a single item: merge with existing item.
             * Will fail when the item has no id, or when there does not exist an item with the same id.
             *
             * @param update - The new item
             *
             * @returns The id of the updated item.
             */

        }, {
            key: "_updateItem",
            value: function _updateItem(update) {
                var id = update[this._idProp];

                if (id == null) {
                    throw new Error("Cannot update item: item has no id (item: " + stringify$1(update) + ")");
                }

                var item = this._data.get(id);

                if (!item) {
                    // item doesn't exist
                    throw new Error("Cannot update item: no item with id " + id + " found");
                }

                this._data.set(id, _objectSpread$4(_objectSpread$4({}, item), update));

                return id;
            }
            /** @inheritDoc */

        }, {
            key: "stream",
            value: function stream(ids) {
                if (ids) {
                    var data = this._data;
                    return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee3() {
                        var _iterator13, _step13, id, item;

                        return regenerator.wrap(function _callee3$(_context25) {
                            while (1) {
                                switch (_context25.prev = _context25.next) {
                                    case 0:
                                        _iterator13 = _createForOfIteratorHelper$7(ids);
                                        _context25.prev = 1;

                                        _iterator13.s();

                                    case 3:
                                        if ((_step13 = _iterator13.n()).done) {
                                            _context25.next = 11;
                                            break;
                                        }

                                        id = _step13.value;
                                        item = data.get(id);

                                        if (!(item != null)) {
                                            _context25.next = 9;
                                            break;
                                        }

                                        _context25.next = 9;
                                        return [id, item];

                                    case 9:
                                        _context25.next = 3;
                                        break;

                                    case 11:
                                        _context25.next = 16;
                                        break;

                                    case 13:
                                        _context25.prev = 13;
                                        _context25.t0 = _context25["catch"](1);

                                        _iterator13.e(_context25.t0);

                                    case 16:
                                        _context25.prev = 16;

                                        _iterator13.f();

                                        return _context25.finish(16);

                                    case 19:
                                    case "end":
                                        return _context25.stop();
                                }
                            }
                        }, _callee3, null, [[1, 13, 16, 19]]);
                    })));
                } else {
                    var _context26;

                    return new DataStream(_defineProperty({}, iterator, bind(_context26 = entries(this._data)).call(_context26, this._data)));
                }
            }
        }]);

        return DataSet;
    }(DataSetPart);
    /**
     * DataView
     *
     * A DataView offers a filtered and/or formatted view on a DataSet. One can subscribe to changes in a DataView, and easily get filtered or formatted data without having to specify filters and field types all the time.
     *
     * ## Example
     * ```javascript
     * // create a DataSet
     * var data = new vis.DataSet();
     * data.add([
     *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
     *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
     *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
     *   {id: 4, text: 'item 4'}
     * ]);
     *
     * // create a DataView
     * // the view will only contain items having a property group with value 1,
     * // and will only output fields id, text, and date.
     * var view = new vis.DataView(data, {
     *   filter: function (item) {
     *     return (item.group == 1);
     *   },
     *   fields: ['id', 'text', 'date']
     * });
     *
     * // subscribe to any change in the DataView
     * view.on('*', function (event, properties, senderId) {
     *   console.log('event', event, properties);
     * });
     *
     * // update an item in the data set
     * data.update({id: 2, group: 1});
     *
     * // get all ids in the view
     * var ids = view.getIds();
     * console.log('ids', ids); // will output [1, 2]
     *
     * // get all items in the view
     * var items = view.get();
     * ```
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataView = /*#__PURE__*/function (_DataSetPart2) {
        _inherits(DataView, _DataSetPart2);

        var _super2 = _createSuper$t(DataView);

        /**
         * Create a DataView.
         *
         * @param data - The instance containing data (directly or indirectly).
         * @param options - Options to configure this data view.
         */
        function DataView(data, options) {
            var _context27;

            var _this7;

            _classCallCheck(this, DataView);

            _this7 = _super2.call(this);
            /** @inheritDoc */

            _this7.length = 0;
            _this7._ids = new set(); // ids of the items currently in memory (just contains a boolean true)

            _this7._options = options || {};
            _this7._listener = bind(_context27 = _this7._onEvent).call(_context27, _assertThisInitialized(_this7));

            _this7.setData(data);

            return _this7;
        }
        /** @inheritDoc */


        _createClass(DataView, [{
            key: "idProp",
            get: function get() {
                return this.getDataSet().idProp;
            } // TODO: implement a function .config() to dynamically update things like configured filter
            // and trigger changes accordingly

            /**
             * Set a data source for the view.
             *
             * @param data - The instance containing data (directly or indirectly).
             *
             * @remarks
             * Note that when the data view is bound to a data set it won't be garbage
             * collected unless the data set is too. Use `dataView.setData(null)` or
             * `dataView.dispose()` to enable garbage collection before you lose the last
             * reference.
             */

        }, {
            key: "setData",
            value: function setData(data) {
                if (this._data) {
                    // unsubscribe from current dataset
                    if (this._data.off) {
                        this._data.off("*", this._listener);
                    } // trigger a remove of all items in memory


                    var ids = this._data.getIds({
                        filter: filter(this._options)
                    });

                    var items = this._data.get(ids);

                    this._ids.clear();

                    this.length = 0;

                    this._trigger("remove", {
                        items: ids,
                        oldData: items
                    });
                }

                if (data != null) {
                    this._data = data; // trigger an add of all added items

                    var _ids = this._data.getIds({
                        filter: filter(this._options)
                    });

                    for (var i = 0, len = _ids.length; i < len; i++) {
                        var id = _ids[i];

                        this._ids.add(id);
                    }

                    this.length = _ids.length;

                    this._trigger("add", {
                        items: _ids
                    });
                } else {
                    this._data = new DataSet();
                } // subscribe to new dataset


                if (this._data.on) {
                    this._data.on("*", this._listener);
                }
            }
            /**
             * Refresh the DataView.
             * Useful when the DataView has a filter function containing a variable parameter.
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var ids = this._data.getIds({
                    filter: filter(this._options)
                });

                var oldIds = _toConsumableArray(this._ids);

                var newIds = {};
                var addedIds = [];
                var removedIds = [];
                var removedItems = []; // check for additions

                for (var i = 0, len = ids.length; i < len; i++) {
                    var id = ids[i];
                    newIds[id] = true;

                    if (!this._ids.has(id)) {
                        addedIds.push(id);

                        this._ids.add(id);
                    }
                } // check for removals


                for (var _i10 = 0, _len11 = oldIds.length; _i10 < _len11; _i10++) {
                    var _id7 = oldIds[_i10];

                    var item = this._data.get(_id7);

                    if (item == null) {
                        // @TODO: Investigate.
                        // Doesn't happen during tests or examples.
                        // Is it really impossible or could it eventually happen?
                        // How to handle it if it does? The types guarantee non-nullable items.
                        console.error("If you see this, report it please.");
                    } else if (!newIds[_id7]) {
                        removedIds.push(_id7);
                        removedItems.push(item);

                        this._ids.delete(_id7);
                    }
                }

                this.length += addedIds.length - removedIds.length; // trigger events

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    });
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    });
                }
            }
            /** @inheritDoc */

        }, {
            key: "get",
            value: function get(first, second) {
                if (this._data == null) {
                    return null;
                } // parse the arguments


                var ids = null;
                var options;

                if (isId(first) || isArray(first)) {
                    ids = first;
                    options = second;
                } else {
                    options = first;
                } // extend the options with the default options and provided options


                var viewOptions = assign$2({}, this._options, options); // create a combined filter method when needed


                var thisFilter = filter(this._options);

                var optionsFilter = options && filter(options);

                if (thisFilter && optionsFilter) {
                    viewOptions.filter = function (item) {
                        return thisFilter(item) && optionsFilter(item);
                    };
                }

                if (ids == null) {
                    return this._data.get(viewOptions);
                } else {
                    return this._data.get(ids, viewOptions);
                }
            }
            /** @inheritDoc */

        }, {
            key: "getIds",
            value: function getIds(options) {
                if (this._data.length) {
                    var defaultFilter = filter(this._options);

                    var optionsFilter = options != null ? filter(options) : null;
                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    return this._data.getIds({
                        filter: filter$1,
                        order: options && options.order
                    });
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "forEach",
            value: function forEach(callback, options) {
                if (this._data) {
                    var _context28;

                    var defaultFilter = filter(this._options);

                    var optionsFilter = options && filter(options);

                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    forEach$2(_context28 = this._data).call(_context28, callback, {
                        filter: filter$1,
                        order: options && options.order
                    });
                }
            }
            /** @inheritDoc */

        }, {
            key: "map",
            value: function map(callback, options) {
                if (this._data) {
                    var _context29;

                    var defaultFilter = filter(this._options);

                    var optionsFilter = options && filter(options);

                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    return map$3(_context29 = this._data).call(_context29, callback, {
                        filter: filter$1,
                        order: options && options.order
                    });
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "getDataSet",
            value: function getDataSet() {
                return this._data.getDataSet();
            }
            /** @inheritDoc */

        }, {
            key: "stream",
            value: function stream(ids) {
                var _context30;

                return this._data.stream(ids || _defineProperty({}, iterator, bind(_context30 = keys(this._ids)).call(_context30, this._ids)));
            }
            /**
             * Render the instance unusable prior to garbage collection.
             *
             * @remarks
             * The intention of this method is to help discover scenarios where the data
             * view is being used when the programmer thinks it has been garbage collected
             * already. It's stricter version of `dataView.setData(null)`.
             */

        }, {
            key: "dispose",
            value: function dispose() {
                var _this$_data;

                if ((_this$_data = this._data) !== null && _this$_data !== void 0 && _this$_data.off) {
                    this._data.off("*", this._listener);
                }

                var message = "This data view has already been disposed of.";
                var replacement = {
                    get: function get() {
                        throw new Error(message);
                    },
                    set: function set() {
                        throw new Error(message);
                    },
                    configurable: false
                };

                var _iterator14 = _createForOfIteratorHelper$7(ownKeys$5(DataView.prototype)),
                    _step14;

                try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                        var key = _step14.value;

                        defineProperty$4(this, key, replacement);
                    }
                } catch (err) {
                    _iterator14.e(err);
                } finally {
                    _iterator14.f();
                }
            }
            /**
             * Event listener. Will propagate all events from the connected data set to the subscribers of the DataView, but will filter the items and only trigger when there are changes in the filtered data set.
             *
             * @param event - The name of the event.
             * @param params - Parameters of the event.
             * @param senderId - Id supplied by the sender.
             */

        }, {
            key: "_onEvent",
            value: function _onEvent(event, params, senderId) {
                if (!params || !params.items || !this._data) {
                    return;
                }

                var ids = params.items;
                var addedIds = [];
                var updatedIds = [];
                var removedIds = [];
                var oldItems = [];
                var updatedItems = [];
                var removedItems = [];

                switch (event) {
                    case "add":
                        // filter the ids of the added items
                        for (var i = 0, len = ids.length; i < len; i++) {
                            var id = ids[i];
                            var item = this.get(id);

                            if (item) {
                                this._ids.add(id);

                                addedIds.push(id);
                            }
                        }

                        break;

                    case "update":
                        // determine the event from the views viewpoint: an updated
                        // item can be added, updated, or removed from this view.
                        for (var _i11 = 0, _len12 = ids.length; _i11 < _len12; _i11++) {
                            var _id8 = ids[_i11];

                            var _item5 = this.get(_id8);

                            if (_item5) {
                                if (this._ids.has(_id8)) {
                                    updatedIds.push(_id8);
                                    updatedItems.push(params.data[_i11]);
                                    oldItems.push(params.oldData[_i11]);
                                } else {
                                    this._ids.add(_id8);

                                    addedIds.push(_id8);
                                }
                            } else {
                                if (this._ids.has(_id8)) {
                                    this._ids.delete(_id8);

                                    removedIds.push(_id8);
                                    removedItems.push(params.oldData[_i11]);
                                }
                            }
                        }

                        break;

                    case "remove":
                        // filter the ids of the removed items
                        for (var _i12 = 0, _len13 = ids.length; _i12 < _len13; _i12++) {
                            var _id9 = ids[_i12];

                            if (this._ids.has(_id9)) {
                                this._ids.delete(_id9);

                                removedIds.push(_id9);
                                removedItems.push(params.oldData[_i12]);
                            }
                        }

                        break;
                }

                this.length += addedIds.length - removedIds.length;

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                if (updatedIds.length) {
                    this._trigger("update", {
                        items: updatedIds,
                        oldData: oldItems,
                        data: updatedItems
                    }, senderId);
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                }
            }
        }]);

        return DataView;
    }(DataSetPart);
    /**
     * Check that given value is compatible with Vis Data Set interface.
     *
     * @param idProp - The expected property to contain item id.
     * @param v - The value to be tested.
     *
     * @returns True if all expected values and methods match, false otherwise.
     */


    function isDataSetLike(idProp, v) {
        return _typeof(v) === "object" && v !== null && idProp === v.idProp && typeof v.add === "function" && typeof v.clear === "function" && typeof v.distinct === "function" && typeof forEach$2(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof map$3(v) === "function" && typeof v.max === "function" && typeof v.min === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.remove === "function" && typeof v.setOptions === "function" && typeof v.stream === "function" && typeof v.update === "function" && typeof v.updateOnly === "function";
    }
    /**
     * Check that given value is compatible with Vis Data View interface.
     *
     * @param idProp - The expected property to contain item id.
     * @param v - The value to be tested.
     *
     * @returns True if all expected values and methods match, false otherwise.
     */


    function isDataViewLike(idProp, v) {
        return _typeof(v) === "object" && v !== null && idProp === v.idProp && typeof forEach$2(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof map$3(v) === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.stream === "function" && isDataSetLike(idProp, v.getDataSet());
    }

    var index = /*#__PURE__*/Object.freeze({
        __proto__: null,
        DELETE: DELETE,
        DataSet: DataSet,
        DataStream: DataStream,
        DataView: DataView,
        Queue: Queue,
        createNewDataPipeFrom: createNewDataPipeFrom,
        isDataSetLike: isDataSetLike,
        isDataViewLike: isDataViewLike
    });

    var trim = stringTrim.trim;
    var $parseFloat = global$1.parseFloat;
    var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity; // `parseFloat` method
    // https://tc39.es/ecma262/#sec-parsefloat-string

    var numberParseFloat = FORCED ? function parseFloat(string) {
        var trimmedString = trim(String(string));
        var result = $parseFloat(trimmedString);
        return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
    } : $parseFloat;

    // https://tc39.es/ecma262/#sec-parsefloat-string

    _export({
        global: true,
        forced: parseFloat != numberParseFloat
    }, {
        parseFloat: numberParseFloat
    });

    var _parseFloat$2 = path.parseFloat;

    var _parseFloat$1 = _parseFloat$2;

    var _parseFloat = _parseFloat$1;

    var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
    var FAILS_ON_PRIMITIVES = fails(function () {
        return !Object.getOwnPropertyNames(1);
    }); // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES
    }, {
        getOwnPropertyNames: nativeGetOwnPropertyNames
    });

    var Object$1 = path.Object;

    var getOwnPropertyNames$2 = function getOwnPropertyNames(it) {
        return Object$1.getOwnPropertyNames(it);
    };

    var getOwnPropertyNames$1 = getOwnPropertyNames$2;

    var getOwnPropertyNames = getOwnPropertyNames$1;

    /**
     * Helper functions for components
     */

    /**
     * Determine values to use for (sub)options of 'chosen'.
     *
     * This option is either a boolean or an object whose values should be examined further.
     * The relevant structures are:
     *
     * - chosen: <boolean value>
     * - chosen: { subOption: <boolean or function> }
     *
     * Where subOption is 'node', 'edge' or 'label'.
     *
     * The intention of this method appears to be to set a specific priority to the options;
     * Since most properties are either bridged or merged into the local options objects, there
     * is not much point in handling them separately.
     * TODO: examine if 'most' in previous sentence can be replaced with 'all'. In that case, we
     *       should be able to get rid of this method.
     *
     * @param {string}  subOption  option within object 'chosen' to consider; either 'node', 'edge' or 'label'
     * @param {object}  pile       array of options objects to consider
     *
     * @returns {boolean | Function}  value for passed subOption of 'chosen' to use
     */

    function choosify(subOption, pile) {
        // allowed values for subOption
        var allowed = ["node", "edge", "label"];
        var value = true;
        var chosen = topMost(pile, "chosen");

        if (typeof chosen === "boolean") {
            value = chosen;
        } else if (_typeof(chosen) === "object") {
            if (indexOf(allowed).call(allowed, subOption) === -1) {
                throw new Error("choosify: subOption '" + subOption + "' should be one of " + "'" + allowed.join("', '") + "'");
            }

            var chosenEdge = topMost(pile, ["chosen", subOption]);

            if (typeof chosenEdge === "boolean" || typeof chosenEdge === "function") {
                value = chosenEdge;
            }
        }

        return value;
    }
    /**
     * Check if the point falls within the given rectangle.
     *
     * @param {rect} rect
     * @param {point} point
     * @param {rotationPoint} [rotationPoint] if specified, the rotation that applies to the rectangle.
     * @returns {boolean}  true if point within rectangle, false otherwise
     */

    function pointInRect(rect, point, rotationPoint) {
        if (rect.width <= 0 || rect.height <= 0) {
            return false; // early out
        }

        if (rotationPoint !== undefined) {
            // Rotate the point the same amount as the rectangle
            var tmp = {
                x: point.x - rotationPoint.x,
                y: point.y - rotationPoint.y
            };

            if (rotationPoint.angle !== 0) {
                // In order to get the coordinates the same, you need to
                // rotate in the reverse direction
                var angle = -rotationPoint.angle;
                var tmp2 = {
                    x: Math.cos(angle) * tmp.x - Math.sin(angle) * tmp.y,
                    y: Math.sin(angle) * tmp.x + Math.cos(angle) * tmp.y
                };
                point = tmp2;
            } else {
                point = tmp;
            } // Note that if a rotation is specified, the rectangle coordinates
            // are **not* the full canvas coordinates. They are relative to the
            // rotationPoint. Hence, the point coordinates need not be translated
            // back in this case.

        }

        var right = rect.x + rect.width;
        var bottom = rect.y + rect.width;
        return rect.left < point.x && right > point.x && rect.top < point.y && bottom > point.y;
    }
    /**
     * Check if given value is acceptable as a label text.
     *
     * @param {*} text value to check; can be anything at this point
     * @returns {boolean} true if valid label value, false otherwise
     */

    function isValidLabel(text) {
        // Note that this is quite strict: types that *might* be converted to string are disallowed
        return typeof text === "string" && text !== "";
    }
    /**
     * Returns x, y of self reference circle based on provided angle
     *
     * @param {object} ctx
     * @param {number} angle
     * @param {number} radius
     * @param {VisNode} node
     *
     * @returns {object} x and y coordinates
     */

    function getSelfRefCoordinates(ctx, angle, radius, node) {
        var x = node.x;
        var y = node.y;

        if (typeof node.distanceToBorder === "function") {
            //calculating opposite and adjacent
            //distaneToBorder becomes Hypotenuse.
            //Formulas sin(a) = Opposite / Hypotenuse and cos(a) = Adjacent / Hypotenuse
            var toBorderDist = node.distanceToBorder(ctx, angle);
            var yFromNodeCenter = Math.sin(angle) * toBorderDist;
            var xFromNodeCenter = Math.cos(angle) * toBorderDist; //xFromNodeCenter is basically x and if xFromNodeCenter equals to the distance to border then it means
            //that y does not need calculation because it is equal node.height / 2 or node.y
            //same thing with yFromNodeCenter and if yFromNodeCenter equals to the distance to border then it means
            //that x is equal node.width / 2 or node.x

            if (xFromNodeCenter === toBorderDist) {
                x += toBorderDist;
                y = node.y;
            } else if (yFromNodeCenter === toBorderDist) {
                x = node.x;
                y -= toBorderDist;
            } else {
                x += xFromNodeCenter;
                y -= yFromNodeCenter;
            }
        } else if (node.shape.width > node.shape.height) {
            x = node.x + node.shape.width * 0.5;
            y = node.y - radius;
        } else {
            x = node.x + radius;
            y = node.y - node.shape.height * 0.5;
        }

        return {
            x: x,
            y: y
        };
    }

    /**
     * Callback to determine text dimensions, using the parent label settings.
     *
     * @callback MeasureText
     * @param {text} text
     * @param {text} mod
     * @returns {object} { width, values} width in pixels and font attributes
     */

    /**
     * Helper class for Label which collects results of splitting labels into lines and blocks.
     *
     * @private
     */
    var LabelAccumulator = /*#__PURE__*/function () {
        /**
         * @param {MeasureText} measureText
         */
        function LabelAccumulator(measureText) {
            _classCallCheck(this, LabelAccumulator);

            this.measureText = measureText;
            this.current = 0;
            this.width = 0;
            this.height = 0;
            this.lines = [];
        }
        /**
         * Append given text to the given line.
         *
         * @param {number}  l    index of line to add to
         * @param {string}  text string to append to line
         * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
         * @private
         */


        _createClass(LabelAccumulator, [{
            key: "_add",
            value: function _add(l, text) {
                var mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "normal";

                if (this.lines[l] === undefined) {
                    this.lines[l] = {
                        width: 0,
                        height: 0,
                        blocks: []
                    };
                } // We still need to set a block for undefined and empty texts, hence return at this point
                // This is necessary because we don't know at this point if we're at the
                // start of an empty line or not.
                // To compensate, empty blocks are removed in `finalize()`.
                //
                // Empty strings should still have a height


                var tmpText = text;
                if (text === undefined || text === "") tmpText = " "; // Determine width and get the font properties

                var result = this.measureText(tmpText, mod);

                var block = assign$2({}, values(result));

                block.text = text;
                block.width = result.width;
                block.mod = mod;

                if (text === undefined || text === "") {
                    block.width = 0;
                }

                this.lines[l].blocks.push(block); // Update the line width. We need this for determining if a string goes over max width

                this.lines[l].width += block.width;
            }
            /**
             * Returns the width in pixels of the current line.
             *
             * @returns {number}
             */

        }, {
            key: "curWidth",
            value: function curWidth() {
                var line = this.lines[this.current];
                if (line === undefined) return 0;
                return line.width;
            }
            /**
             * Add text in block to current line
             *
             * @param {string} text
             * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
             */

        }, {
            key: "append",
            value: function append(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";

                this._add(this.current, text, mod);
            }
            /**
             * Add text in block to current line and start a new line
             *
             * @param {string} text
             * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
             */

        }, {
            key: "newLine",
            value: function newLine(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";

                this._add(this.current, text, mod);

                this.current++;
            }
            /**
             * Determine and set the heights of all the lines currently contained in this instance
             *
             * Note that width has already been set.
             *
             * @private
             */

        }, {
            key: "determineLineHeights",
            value: function determineLineHeights() {
                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k]; // Looking for max height of blocks in line

                    var height = 0;

                    if (line.blocks !== undefined) {
                        // Can happen if text contains e.g. '\n '
                        for (var l = 0; l < line.blocks.length; l++) {
                            var block = line.blocks[l];

                            if (height < block.height) {
                                height = block.height;
                            }
                        }
                    }

                    line.height = height;
                }
            }
            /**
             * Determine the full size of the label text, as determined by current lines and blocks
             *
             * @private
             */

        }, {
            key: "determineLabelSize",
            value: function determineLabelSize() {
                var width = 0;
                var height = 0;

                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k];

                    if (line.width > width) {
                        width = line.width;
                    }

                    height += line.height;
                }

                this.width = width;
                this.height = height;
            }
            /**
             * Remove all empty blocks and empty lines we don't need
             *
             * This must be done after the width/height determination,
             * so that these are set properly for processing here.
             *
             * @returns {Array<Line>} Lines with empty blocks (and some empty lines) removed
             * @private
             */

        }, {
            key: "removeEmptyBlocks",
            value: function removeEmptyBlocks() {
                var tmpLines = [];

                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k]; // Note: an empty line in between text has width zero but is still relevant to layout.
                    // So we can't use width for testing empty line here

                    if (line.blocks.length === 0) continue; // Discard final empty line always

                    if (k === this.lines.length - 1) {
                        if (line.width === 0) continue;
                    }

                    var tmpLine = {};

                    assign$2(tmpLine, line);

                    tmpLine.blocks = [];
                    var firstEmptyBlock = void 0;
                    var tmpBlocks = [];

                    for (var l = 0; l < line.blocks.length; l++) {
                        var block = line.blocks[l];

                        if (block.width !== 0) {
                            tmpBlocks.push(block);
                        } else {
                            if (firstEmptyBlock === undefined) {
                                firstEmptyBlock = block;
                            }
                        }
                    } // Ensure that there is *some* text present


                    if (tmpBlocks.length === 0 && firstEmptyBlock !== undefined) {
                        tmpBlocks.push(firstEmptyBlock);
                    }

                    tmpLine.blocks = tmpBlocks;
                    tmpLines.push(tmpLine);
                }

                return tmpLines;
            }
            /**
             * Set the sizes for all lines and the whole thing.
             *
             * @returns {{width: (number|*), height: (number|*), lines: Array}}
             */

        }, {
            key: "finalize",
            value: function finalize() {
                //console.log(JSON.stringify(this.lines, null, 2));
                this.determineLineHeights();
                this.determineLabelSize();
                var tmpLines = this.removeEmptyBlocks(); // Return a simple hash object for further processing.

                return {
                    width: this.width,
                    height: this.height,
                    lines: tmpLines
                };
            }
        }]);

        return LabelAccumulator;
    }();

    var tagPattern = {
        // HTML
        "<b>": /<b>/,
        "<i>": /<i>/,
        "<code>": /<code>/,
        "</b>": /<\/b>/,
        "</i>": /<\/i>/,
        "</code>": /<\/code>/,
        // Markdown
        "*": /\*/,
        // bold
        _: /_/,
        // ital
        "`": /`/,
        // mono
        afterBold: /[^*]/,
        afterItal: /[^_]/,
        afterMono: /[^`]/
    };
    /**
     * Internal helper class for parsing the markup tags for HTML and Markdown.
     *
     * NOTE: Sequences of tabs and spaces are reduced to single space.
     *       Scan usage of `this.spacing` within method
     */

    var MarkupAccumulator = /*#__PURE__*/function () {
        /**
         * Create an instance
         *
         * @param {string} text  text to parse for markup
         */
        function MarkupAccumulator(text) {
            _classCallCheck(this, MarkupAccumulator);

            this.text = text;
            this.bold = false;
            this.ital = false;
            this.mono = false;
            this.spacing = false;
            this.position = 0;
            this.buffer = "";
            this.modStack = [];
            this.blocks = [];
        }
        /**
         * Return the mod label currently on the top of the stack
         *
         * @returns {string}  label of topmost mod
         * @private
         */


        _createClass(MarkupAccumulator, [{
            key: "mod",
            value: function mod() {
                return this.modStack.length === 0 ? "normal" : this.modStack[0];
            }
            /**
             * Return the mod label currently active
             *
             * @returns {string}  label of active mod
             * @private
             */

        }, {
            key: "modName",
            value: function modName() {
                if (this.modStack.length === 0) return "normal";else if (this.modStack[0] === "mono") return "mono";else {
                    if (this.bold && this.ital) {
                        return "boldital";
                    } else if (this.bold) {
                        return "bold";
                    } else if (this.ital) {
                        return "ital";
                    }
                }
            }
            /**
             * @private
             */

        }, {
            key: "emitBlock",
            value: function emitBlock() {
                if (this.spacing) {
                    this.add(" ");
                    this.spacing = false;
                }

                if (this.buffer.length > 0) {
                    this.blocks.push({
                        text: this.buffer,
                        mod: this.modName()
                    });
                    this.buffer = "";
                }
            }
            /**
             * Output text to buffer
             *
             * @param {string} text  text to add
             * @private
             */

        }, {
            key: "add",
            value: function add(text) {
                if (text === " ") {
                    this.spacing = true;
                }

                if (this.spacing) {
                    this.buffer += " ";
                    this.spacing = false;
                }

                if (text != " ") {
                    this.buffer += text;
                }
            }
            /**
             * Handle parsing of whitespace
             *
             * @param {string} ch  the character to check
             * @returns {boolean} true if the character was processed as whitespace, false otherwise
             */

        }, {
            key: "parseWS",
            value: function parseWS(ch) {
                if (/[ \t]/.test(ch)) {
                    if (!this.mono) {
                        this.spacing = true;
                    } else {
                        this.add(ch);
                    }

                    return true;
                }

                return false;
            }
            /**
             * @param {string} tagName  label for block type to set
             * @private
             */

        }, {
            key: "setTag",
            value: function setTag(tagName) {
                this.emitBlock();
                this[tagName] = true;
                this.modStack.unshift(tagName);
            }
            /**
             * @param {string} tagName  label for block type to unset
             * @private
             */

        }, {
            key: "unsetTag",
            value: function unsetTag(tagName) {
                this.emitBlock();
                this[tagName] = false;
                this.modStack.shift();
            }
            /**
             * @param {string} tagName label for block type we are currently processing
             * @param {string|RegExp} tag string to match in text
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "parseStartTag",
            value: function parseStartTag(tagName, tag) {
                // Note: if 'mono' passed as tagName, there is a double check here. This is OK
                if (!this.mono && !this[tagName] && this.match(tag)) {
                    this.setTag(tagName);
                    return true;
                }

                return false;
            }
            /**
             * @param {string|RegExp} tag
             * @param {number} [advance=true] if set, advance current position in text
             * @returns {boolean} true if match at given position, false otherwise
             * @private
             */

        }, {
            key: "match",
            value: function match(tag) {
                var advance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var _this$prepareRegExp = this.prepareRegExp(tag),
                    _this$prepareRegExp2 = _slicedToArray(_this$prepareRegExp, 2),
                    regExp = _this$prepareRegExp2[0],
                    length = _this$prepareRegExp2[1];

                var matched = regExp.test(this.text.substr(this.position, length));

                if (matched && advance) {
                    this.position += length - 1;
                }

                return matched;
            }
            /**
             * @param {string} tagName label for block type we are currently processing
             * @param {string|RegExp} tag string to match in text
             * @param {RegExp} [nextTag] regular expression to match for characters *following* the current tag
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "parseEndTag",
            value: function parseEndTag(tagName, tag, nextTag) {
                var checkTag = this.mod() === tagName;

                if (tagName === "mono") {
                    // special handling for 'mono'
                    checkTag = checkTag && this.mono;
                } else {
                    checkTag = checkTag && !this.mono;
                }

                if (checkTag && this.match(tag)) {
                    if (nextTag !== undefined) {
                        // Purpose of the following match is to prevent a direct unset/set of a given tag
                        // E.g. '*bold **still bold*' => '*bold still bold*'
                        if (this.position === this.text.length - 1 || this.match(nextTag, false)) {
                            this.unsetTag(tagName);
                        }
                    } else {
                        this.unsetTag(tagName);
                    }

                    return true;
                }

                return false;
            }
            /**
             * @param {string|RegExp} tag  string to match in text
             * @param {value} value  string to replace tag with, if found at current position
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "replace",
            value: function replace(tag, value) {
                if (this.match(tag)) {
                    this.add(value);
                    this.position += length - 1;
                    return true;
                }

                return false;
            }
            /**
             * Create a regular expression for the tag if it isn't already one.
             *
             * The return value is an array `[RegExp, number]`, with exactly two value, where:
             *  - RegExp is the regular expression to use
             *  - number is the lenth of the input string to match
             *
             * @param {string|RegExp} tag  string to match in text
             * @returns {Array}  regular expression to use and length of input string to match
             * @private
             */

        }, {
            key: "prepareRegExp",
            value: function prepareRegExp(tag) {
                var length;
                var regExp;

                if (tag instanceof RegExp) {
                    regExp = tag;
                    length = 1; // ASSUMPTION: regexp only tests one character
                } else {
                    // use prepared regexp if present
                    var prepared = tagPattern[tag];

                    if (prepared !== undefined) {
                        regExp = prepared;
                    } else {
                        regExp = new RegExp(tag);
                    }

                    length = tag.length;
                }

                return [regExp, length];
            }
        }]);

        return MarkupAccumulator;
    }();
    /**
     * Helper class for Label which explodes the label text into lines and blocks within lines
     *
     * @private
     */


    var LabelSplitter = /*#__PURE__*/function () {
        /**
         * @param {CanvasRenderingContext2D} ctx Canvas rendering context
         * @param {Label} parent reference to the Label instance using current instance
         * @param {boolean} selected
         * @param {boolean} hover
         */
        function LabelSplitter(ctx, parent, selected, hover) {
            var _this = this;

            _classCallCheck(this, LabelSplitter);

            this.ctx = ctx;
            this.parent = parent;
            this.selected = selected;
            this.hover = hover;
            /**
             * Callback to determine text width; passed to LabelAccumulator instance
             *
             * @param  {string} text string to determine width of
             * @param  {string} mod  font type to use for this text
             * @returns {object} { width, values} width in pixels and font attributes
             */

            var textWidth = function textWidth(text, mod) {
                if (text === undefined) return 0; // TODO: This can be done more efficiently with caching
                // This will set the ctx.font correctly, depending on selected/hover and mod - so that ctx.measureText() will be accurate.

                var values = _this.parent.getFormattingValues(ctx, selected, hover, mod);

                var width = 0;

                if (text !== "") {
                    var measure = _this.ctx.measureText(text);

                    width = measure.width;
                }

                return {
                    width: width,
                    values: values
                };
            };

            this.lines = new LabelAccumulator(textWidth);
        }
        /**
         * Split passed text of a label into lines and blocks.
         *
         * # NOTE
         *
         * The handling of spacing is option dependent:
         *
         * - if `font.multi : false`, all spaces are retained
         * - if `font.multi : true`, every sequence of spaces is compressed to a single space
         *
         * This might not be the best way to do it, but this is as it has been working till now.
         * In order not to break existing functionality, for the time being this behaviour will
         * be retained in any code changes.
         *
         * @param {string} text  text to split
         * @returns {Array<line>}
         */


        _createClass(LabelSplitter, [{
            key: "process",
            value: function process(text) {
                if (!isValidLabel(text)) {
                    return this.lines.finalize();
                }

                var font = this.parent.fontOptions; // Normalize the end-of-line's to a single representation - order important

                text = text.replace(/\r\n/g, "\n"); // Dos EOL's

                text = text.replace(/\r/g, "\n"); // Mac EOL's
                // Note that at this point, there can be no \r's in the text.
                // This is used later on splitStringIntoLines() to split multifont texts.

                var nlLines = String(text).split("\n");
                var lineCount = nlLines.length;

                if (font.multi) {
                    // Multi-font case: styling tags active
                    for (var i = 0; i < lineCount; i++) {
                        var blocks = this.splitBlocks(nlLines[i], font.multi); // Post: Sequences of tabs and spaces are reduced to single space

                        if (blocks === undefined) continue;

                        if (blocks.length === 0) {
                            this.lines.newLine("");
                            continue;
                        }

                        if (font.maxWdt > 0) {
                            // widthConstraint.maximum defined
                            //console.log('Running widthConstraint multi, max: ' + this.fontOptions.maxWdt);
                            for (var j = 0; j < blocks.length; j++) {
                                var mod = blocks[j].mod;
                                var _text = blocks[j].text;
                                this.splitStringIntoLines(_text, mod, true);
                            }
                        } else {
                            // widthConstraint.maximum NOT defined
                            for (var _j = 0; _j < blocks.length; _j++) {
                                var _mod = blocks[_j].mod;
                                var _text2 = blocks[_j].text;
                                this.lines.append(_text2, _mod);
                            }
                        }

                        this.lines.newLine();
                    }
                } else {
                    // Single-font case
                    if (font.maxWdt > 0) {
                        // widthConstraint.maximum defined
                        // console.log('Running widthConstraint normal, max: ' + this.fontOptions.maxWdt);
                        for (var _i = 0; _i < lineCount; _i++) {
                            this.splitStringIntoLines(nlLines[_i]);
                        }
                    } else {
                        // widthConstraint.maximum NOT defined
                        for (var _i2 = 0; _i2 < lineCount; _i2++) {
                            this.lines.newLine(nlLines[_i2]);
                        }
                    }
                }

                return this.lines.finalize();
            }
            /**
             * normalize the markup system
             *
             * @param {boolean|'md'|'markdown'|'html'} markupSystem
             * @returns {string}
             */

        }, {
            key: "decodeMarkupSystem",
            value: function decodeMarkupSystem(markupSystem) {
                var system = "none";

                if (markupSystem === "markdown" || markupSystem === "md") {
                    system = "markdown";
                } else if (markupSystem === true || markupSystem === "html") {
                    system = "html";
                }

                return system;
            }
            /**
             *
             * @param {string} text
             * @returns {Array}
             */

        }, {
            key: "splitHtmlBlocks",
            value: function splitHtmlBlocks(text) {
                var s = new MarkupAccumulator(text);

                var parseEntities = function parseEntities(ch) {
                    if (/&/.test(ch)) {
                        var parsed = s.replace(s.text, "&lt;", "<") || s.replace(s.text, "&amp;", "&");

                        if (!parsed) {
                            s.add("&");
                        }

                        return true;
                    }

                    return false;
                };

                while (s.position < s.text.length) {
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || /</.test(ch) && (s.parseStartTag("bold", "<b>") || s.parseStartTag("ital", "<i>") || s.parseStartTag("mono", "<code>") || s.parseEndTag("bold", "</b>") || s.parseEndTag("ital", "</i>") || s.parseEndTag("mono", "</code>")) || parseEntities(ch);

                    if (!parsed) {
                        s.add(ch);
                    }

                    s.position++;
                }

                s.emitBlock();
                return s.blocks;
            }
            /**
             *
             * @param {string} text
             * @returns {Array}
             */

        }, {
            key: "splitMarkdownBlocks",
            value: function splitMarkdownBlocks(text) {
                var _this2 = this;

                var s = new MarkupAccumulator(text);
                var beginable = true;

                var parseOverride = function parseOverride(ch) {
                    if (/\\/.test(ch)) {
                        if (s.position < _this2.text.length + 1) {
                            s.position++;
                            ch = _this2.text.charAt(s.position);

                            if (/ \t/.test(ch)) {
                                s.spacing = true;
                            } else {
                                s.add(ch);
                                beginable = false;
                            }
                        }

                        return true;
                    }

                    return false;
                };

                while (s.position < s.text.length) {
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || parseOverride(ch) || (beginable || s.spacing) && (s.parseStartTag("bold", "*") || s.parseStartTag("ital", "_") || s.parseStartTag("mono", "`")) || s.parseEndTag("bold", "*", "afterBold") || s.parseEndTag("ital", "_", "afterItal") || s.parseEndTag("mono", "`", "afterMono");

                    if (!parsed) {
                        s.add(ch);
                        beginable = false;
                    }

                    s.position++;
                }

                s.emitBlock();
                return s.blocks;
            }
            /**
             * Explodes a piece of text into single-font blocks using a given markup
             *
             * @param {string} text
             * @param {boolean|'md'|'markdown'|'html'} markupSystem
             * @returns {Array.<{text: string, mod: string}>}
             * @private
             */

        }, {
            key: "splitBlocks",
            value: function splitBlocks(text, markupSystem) {
                var system = this.decodeMarkupSystem(markupSystem);

                if (system === "none") {
                    return [{
                        text: text,
                        mod: "normal"
                    }];
                } else if (system === "markdown") {
                    return this.splitMarkdownBlocks(text);
                } else if (system === "html") {
                    return this.splitHtmlBlocks(text);
                }
            }
            /**
             * @param {string} text
             * @returns {boolean} true if text length over the current max with
             * @private
             */

        }, {
            key: "overMaxWidth",
            value: function overMaxWidth(text) {
                var width = this.ctx.measureText(text).width;
                return this.lines.curWidth() + width > this.parent.fontOptions.maxWdt;
            }
            /**
             * Determine the longest part of the sentence which still fits in the
             * current max width.
             *
             * @param {Array} words  Array of strings signifying a text lines
             * @returns {number}      index of first item in string making string go over max
             * @private
             */

        }, {
            key: "getLongestFit",
            value: function getLongestFit(words) {
                var text = "";
                var w = 0;

                while (w < words.length) {
                    var pre = text === "" ? "" : " ";
                    var newText = text + pre + words[w];
                    if (this.overMaxWidth(newText)) break;
                    text = newText;
                    w++;
                }

                return w;
            }
            /**
             * Determine the longest part of the string which still fits in the
             * current max width.
             *
             * @param {Array} words Array of strings signifying a text lines
             * @returns {number} index of first item in string making string go over max
             */

        }, {
            key: "getLongestFitWord",
            value: function getLongestFitWord(words) {
                var w = 0;

                while (w < words.length) {
                    if (this.overMaxWidth(slice$1(words).call(words, 0, w))) break;
                    w++;
                }

                return w;
            }
            /**
             * Split the passed text into lines, according to width constraint (if any).
             *
             * The method assumes that the input string is a single line, i.e. without lines break.
             *
             * This method retains spaces, if still present (case `font.multi: false`).
             * A space which falls on an internal line break, will be replaced by a newline.
             * There is no special handling of tabs; these go along with the flow.
             *
             * @param {string} str
             * @param {string} [mod='normal']
             * @param {boolean} [appendLast=false]
             * @private
             */

        }, {
            key: "splitStringIntoLines",
            value: function splitStringIntoLines(str) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
                var appendLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Set the canvas context font, based upon the current selected/hover state
                // and the provided mod, so the text measurement performed by getLongestFit
                // will be accurate - and not just use the font of whoever last used the canvas.
                this.parent.getFormattingValues(this.ctx, this.selected, this.hover, mod); // Still-present spaces are relevant, retain them

                str = str.replace(/^( +)/g, "$1\r");
                str = str.replace(/([^\r][^ ]*)( +)/g, "$1\r$2\r");
                var words = str.split("\r");

                while (words.length > 0) {
                    var w = this.getLongestFit(words);

                    if (w === 0) {
                        // Special case: the first word is already larger than the max width.
                        var word = words[0]; // Break the word to the largest part that fits the line

                        var x = this.getLongestFitWord(word);
                        this.lines.newLine(slice$1(word).call(word, 0, x), mod); // Adjust the word, so that the rest will be done next iteration

                        words[0] = slice$1(word).call(word, x);
                    } else {
                        // skip any space that is replaced by a newline
                        var newW = w;

                        if (words[w - 1] === " ") {
                            w--;
                        } else if (words[newW] === " ") {
                            newW++;
                        }

                        var text = slice$1(words).call(words, 0, w).join("");

                        if (w == words.length && appendLast) {
                            this.lines.append(text, mod);
                        } else {
                            this.lines.newLine(text, mod);
                        } // Adjust the word, so that the rest will be done next iteration


                        words = slice$1(words).call(words, newW);
                    }
                }
            }
        }]);

        return LabelSplitter;
    }();

    /**
     * List of special styles for multi-fonts
     *
     * @private
     */

    var multiFontStyle = ["bold", "ital", "boldital", "mono"];
    /**
     * A Label to be used for Nodes or Edges.
     */

    var Label = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {object} options
         * @param {boolean} [edgelabel=false]
         */
        function Label(body, options) {
            var edgelabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            _classCallCheck(this, Label);

            this.body = body;
            this.pointToSelf = false;
            this.baseSize = undefined;
            this.fontOptions = {}; // instance variable containing the *instance-local* font options

            this.setOptions(options);
            this.size = {
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                yLine: 0
            };
            this.isEdgeLabel = edgelabel;
        }
        /**
         * @param {object} options the options of the parent Node-instance
         */


        _createClass(Label, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.elementOptions = options; // Reference to the options of the parent Node-instance

                this.initFontOptions(options.font);

                if (isValidLabel(options.label)) {
                    this.labelDirty = true;
                } else {
                    // Bad label! Change the option value to prevent bad stuff happening
                    options.label = undefined;
                }

                if (options.font !== undefined && options.font !== null) {
                    // font options can be deleted at various levels
                    if (typeof options.font === "string") {
                        this.baseSize = this.fontOptions.size;
                    } else if (_typeof(options.font) === "object") {
                        var size = options.font.size;

                        if (size !== undefined) {
                            this.baseSize = size;
                        }
                    }
                }
            }
            /**
             * Init the font Options structure.
             *
             * Member fontOptions serves as an accumulator for the current font options.
             * As such, it needs to be completely separated from the node options.
             *
             * @param {object} newFontOptions the new font options to process
             * @private
             */

        }, {
            key: "initFontOptions",
            value: function initFontOptions(newFontOptions) {
                var _this = this;

                // Prepare the multi-font option objects.
                // These will be filled in propagateFonts(), if required
                forEach$1(multiFontStyle, function (style) {
                    _this.fontOptions[style] = {};
                }); // Handle shorthand option, if present

                if (Label.parseFontString(this.fontOptions, newFontOptions)) {
                    this.fontOptions.vadjust = 0;
                    return;
                } // Copy over the non-multifont options, if specified


                forEach$1(newFontOptions, function (prop, n) {
                    if (prop !== undefined && prop !== null && _typeof(prop) !== "object") {
                        _this.fontOptions[n] = prop;
                    }
                });
            }
            /**
             * If in-variable is a string, parse it as a font specifier.
             *
             * Note that following is not done here and have to be done after the call:
             * - Not all font options are set (vadjust, mod)
             *
             * @param {object} outOptions  out-parameter, object in which to store the parse results (if any)
             * @param {object} inOptions  font options to parse
             * @returns {boolean} true if font parsed as string, false otherwise
             * @static
             */

        }, {
            key: "constrain",
            value:
                /**
                 * Set the width and height constraints based on 'nearest' value
                 *
                 * @param {Array} pile array of option objects to consider
                 * @returns {object} the actual constraint values to use
                 * @private
                 */
                function constrain(pile) {
                    // NOTE: constrainWidth and  constrainHeight never set!
                    // NOTE: for edge labels, only 'maxWdt' set
                    // Node labels can set all the fields
                    var fontOptions = {
                        constrainWidth: false,
                        maxWdt: -1,
                        minWdt: -1,
                        constrainHeight: false,
                        minHgt: -1,
                        valign: "middle"
                    };
                    var widthConstraint = topMost(pile, "widthConstraint");

                    if (typeof widthConstraint === "number") {
                        fontOptions.maxWdt = Number(widthConstraint);
                        fontOptions.minWdt = Number(widthConstraint);
                    } else if (_typeof(widthConstraint) === "object") {
                        var widthConstraintMaximum = topMost(pile, ["widthConstraint", "maximum"]);

                        if (typeof widthConstraintMaximum === "number") {
                            fontOptions.maxWdt = Number(widthConstraintMaximum);
                        }

                        var widthConstraintMinimum = topMost(pile, ["widthConstraint", "minimum"]);

                        if (typeof widthConstraintMinimum === "number") {
                            fontOptions.minWdt = Number(widthConstraintMinimum);
                        }
                    }

                    var heightConstraint = topMost(pile, "heightConstraint");

                    if (typeof heightConstraint === "number") {
                        fontOptions.minHgt = Number(heightConstraint);
                    } else if (_typeof(heightConstraint) === "object") {
                        var heightConstraintMinimum = topMost(pile, ["heightConstraint", "minimum"]);

                        if (typeof heightConstraintMinimum === "number") {
                            fontOptions.minHgt = Number(heightConstraintMinimum);
                        }

                        var heightConstraintValign = topMost(pile, ["heightConstraint", "valign"]);

                        if (typeof heightConstraintValign === "string") {
                            if (heightConstraintValign === "top" || heightConstraintValign === "bottom") {
                                fontOptions.valign = heightConstraintValign;
                            }
                        }
                    }

                    return fontOptions;
                }
            /**
             * Set options and update internal state
             *
             * @param {object} options  options to set
             * @param {Array}  pile     array of option objects to consider for option 'chosen'
             */

        }, {
            key: "update",
            value: function update(options, pile) {
                this.setOptions(options, true);
                this.propagateFonts(pile);
                deepExtend(this.fontOptions, this.constrain(pile));
                this.fontOptions.chooser = choosify("label", pile);
            }
            /**
             * When margins are set in an element, adjust sizes is called to remove them
             * from the width/height constraints. This must be done prior to label sizing.
             *
             * @param {{top: number, right: number, bottom: number, left: number}} margins
             */

        }, {
            key: "adjustSizes",
            value: function adjustSizes(margins) {
                var widthBias = margins ? margins.right + margins.left : 0;

                if (this.fontOptions.constrainWidth) {
                    this.fontOptions.maxWdt -= widthBias;
                    this.fontOptions.minWdt -= widthBias;
                }

                var heightBias = margins ? margins.top + margins.bottom : 0;

                if (this.fontOptions.constrainHeight) {
                    this.fontOptions.minHgt -= heightBias;
                }
            } /////////////////////////////////////////////////////////
            // Methods for handling options piles
            // Eventually, these will be moved to a separate class
            /////////////////////////////////////////////////////////

            /**
             * Add the font members of the passed list of option objects to the pile.
             *
             * @param {Pile} dstPile  pile of option objects add to
             * @param {Pile} srcPile  pile of option objects to take font options from
             * @private
             */

        }, {
            key: "addFontOptionsToPile",
            value: function addFontOptionsToPile(dstPile, srcPile) {
                for (var i = 0; i < srcPile.length; ++i) {
                    this.addFontToPile(dstPile, srcPile[i]);
                }
            }
            /**
             * Add given font option object to the list of objects (the 'pile') to consider for determining
             * multi-font option values.
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {object} options  instance to add to pile
             * @private
             */

        }, {
            key: "addFontToPile",
            value: function addFontToPile(pile, options) {
                if (options === undefined) return;
                if (options.font === undefined || options.font === null) return;
                var item = options.font;
                pile.push(item);
            }
            /**
             * Collect all own-property values from the font pile that aren't multi-font option objectss.
             *
             * @param {Pile} pile  pile of option objects to use
             * @returns {object} object with all current own basic font properties
             * @private
             */

        }, {
            key: "getBasicOptions",
            value: function getBasicOptions(pile) {
                var ret = {}; // Scans the whole pile to get all options present

                for (var n = 0; n < pile.length; ++n) {
                    var fontOptions = pile[n]; // Convert shorthand if necessary

                    var tmpShorthand = {};

                    if (Label.parseFontString(tmpShorthand, fontOptions)) {
                        fontOptions = tmpShorthand;
                    }

                    forEach$1(fontOptions, function (opt, name) {
                        if (opt === undefined) return; // multi-font option need not be present

                        if (Object.prototype.hasOwnProperty.call(ret, name)) return; // Keep first value we encounter

                        if (indexOf(multiFontStyle).call(multiFontStyle, name) !== -1) {
                            // Skip multi-font properties but we do need the structure
                            ret[name] = {};
                        } else {
                            ret[name] = opt;
                        }
                    });
                }

                return ret;
            }
            /**
             * Return the value for given option for the given multi-font.
             *
             * All available option objects are trawled in the set order to construct the option values.
             *
             * ---------------------------------------------------------------------
             * ## Traversal of pile for multi-fonts
             *
             * The determination of multi-font option values is a special case, because any values not
             * present in the multi-font options should by definition be taken from the main font options,
             * i.e. from the current 'parent' object of the multi-font option.
             *
             * ### Search order for multi-fonts
             *
             * 'bold' used as example:
             *
             *   - search in option group 'bold' in local properties
             *   - search in main font option group in local properties
             *
             * ---------------------------------------------------------------------
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {MultiFontStyle} multiName sub path for the multi-font
             * @param {string} option  the option to search for, for the given multi-font
             * @returns {string|number} the value for the given option
             * @private
             */

        }, {
            key: "getFontOption",
            value: function getFontOption(pile, multiName, option) {
                var multiFont; // Search multi font in local properties

                for (var n = 0; n < pile.length; ++n) {
                    var fontOptions = pile[n];

                    if (Object.prototype.hasOwnProperty.call(fontOptions, multiName)) {
                        multiFont = fontOptions[multiName];
                        if (multiFont === undefined || multiFont === null) continue; // Convert shorthand if necessary
                        // TODO: inefficient to do this conversion every time; find a better way.

                        var tmpShorthand = {};

                        if (Label.parseFontString(tmpShorthand, multiFont)) {
                            multiFont = tmpShorthand;
                        }

                        if (Object.prototype.hasOwnProperty.call(multiFont, option)) {
                            return multiFont[option];
                        }
                    }
                } // Option is not mentioned in the multi font options; take it from the parent font options.
                // These have already been converted with getBasicOptions(), so use the converted values.


                if (Object.prototype.hasOwnProperty.call(this.fontOptions, option)) {
                    return this.fontOptions[option];
                } // A value **must** be found; you should never get here.


                throw new Error("Did not find value for multi-font for property: '" + option + "'");
            }
            /**
             * Return all options values for the given multi-font.
             *
             * All available option objects are trawled in the set order to construct the option values.
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {MultiFontStyle} multiName sub path for the mod-font
             * @returns {MultiFontOptions}
             * @private
             */

        }, {
            key: "getFontOptions",
            value: function getFontOptions(pile, multiName) {
                var result = {};
                var optionNames = ["color", "size", "face", "mod", "vadjust"]; // List of allowed options per multi-font

                for (var i = 0; i < optionNames.length; ++i) {
                    var mod = optionNames[i];
                    result[mod] = this.getFontOption(pile, multiName, mod);
                }

                return result;
            } /////////////////////////////////////////////////////////
            // End methods for handling options piles
            /////////////////////////////////////////////////////////

            /**
             * Collapse the font options for the multi-font to single objects, from
             * the chain of option objects passed (the 'pile').
             *
             * @param {Pile} pile  sequence of option objects to consider.
             *                     First item in list assumed to be the newly set options.
             */

        }, {
            key: "propagateFonts",
            value: function propagateFonts(pile) {
                var _this2 = this;

                var fontPile = []; // sequence of font objects to consider, order important
                // Note that this.elementOptions is not used here.

                this.addFontOptionsToPile(fontPile, pile);
                this.fontOptions = this.getBasicOptions(fontPile); // We set multifont values even if multi === false, for consistency (things break otherwise)

                var _loop = function _loop(i) {
                    var mod = multiFontStyle[i];
                    var modOptions = _this2.fontOptions[mod];

                    var tmpMultiFontOptions = _this2.getFontOptions(fontPile, mod); // Copy over found values


                    forEach$1(tmpMultiFontOptions, function (option, n) {
                        modOptions[n] = option;
                    });
                    modOptions.size = Number(modOptions.size);
                    modOptions.vadjust = Number(modOptions.vadjust);
                };

                for (var i = 0; i < multiFontStyle.length; ++i) {
                    _loop(i);
                }
            }
            /**
             * Main function. This is called from anything that wants to draw a label.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} [baseline='middle']
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover) {
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";
                // if no label, return
                if (this.elementOptions.label === undefined) return; // check if we have to render the label

                var viewFontSize = this.fontOptions.size * this.body.view.scale;
                if (this.elementOptions.label && viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) return; // This ensures that there will not be HUGE letters on screen
                // by setting an upper limit on the visible text size (regardless of zoomLevel)

                if (viewFontSize >= this.elementOptions.scaling.label.maxVisible) {
                    viewFontSize = Number(this.elementOptions.scaling.label.maxVisible) / this.body.view.scale;
                } // update the size cache if required


                this.calculateLabelSize(ctx, selected, hover, x, y, baseline);

                this._drawBackground(ctx);

                this._drawText(ctx, x, this.size.yLine, baseline, viewFontSize);
            }
            /**
             * Draws the label background
             *
             * @param {CanvasRenderingContext2D} ctx
             * @private
             */

        }, {
            key: "_drawBackground",
            value: function _drawBackground(ctx) {
                if (this.fontOptions.background !== undefined && this.fontOptions.background !== "none") {
                    ctx.fillStyle = this.fontOptions.background;
                    var size = this.getSize();
                    ctx.fillRect(size.left, size.top, size.width, size.height);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {string} [baseline='middle']
             * @param {number} viewFontSize
             * @private
             */

        }, {
            key: "_drawText",
            value: function _drawText(ctx, x, y) {
                var baseline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "middle";
                var viewFontSize = arguments.length > 4 ? arguments[4] : undefined;

                var _this$_setAlignment = this._setAlignment(ctx, x, y, baseline);

                var _this$_setAlignment2 = _slicedToArray(_this$_setAlignment, 2);

                x = _this$_setAlignment2[0];
                y = _this$_setAlignment2[1];
                ctx.textAlign = "left";
                x = x - this.size.width / 2; // Shift label 1/2-distance to the left

                if (this.fontOptions.valign && this.size.height > this.size.labelHeight) {
                    if (this.fontOptions.valign === "top") {
                        y -= (this.size.height - this.size.labelHeight) / 2;
                    }

                    if (this.fontOptions.valign === "bottom") {
                        y += (this.size.height - this.size.labelHeight) / 2;
                    }
                } // draw the text


                for (var i = 0; i < this.lineCount; i++) {
                    var line = this.lines[i];

                    if (line && line.blocks) {
                        var width = 0;

                        if (this.isEdgeLabel || this.fontOptions.align === "center") {
                            width += (this.size.width - line.width) / 2;
                        } else if (this.fontOptions.align === "right") {
                            width += this.size.width - line.width;
                        }

                        for (var j = 0; j < line.blocks.length; j++) {
                            var block = line.blocks[j];
                            ctx.font = block.font;

                            var _this$_getColor = this._getColor(block.color, viewFontSize, block.strokeColor),
                                _this$_getColor2 = _slicedToArray(_this$_getColor, 2),
                                fontColor = _this$_getColor2[0],
                                strokeColor = _this$_getColor2[1];

                            if (block.strokeWidth > 0) {
                                ctx.lineWidth = block.strokeWidth;
                                ctx.strokeStyle = strokeColor;
                                ctx.lineJoin = "round";
                            }

                            ctx.fillStyle = fontColor;

                            if (block.strokeWidth > 0) {
                                ctx.strokeText(block.text, x + width, y + block.vadjust);
                            }

                            ctx.fillText(block.text, x + width, y + block.vadjust);
                            width += block.width;
                        }

                        y += line.height;
                    }
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {string} baseline
             * @returns {Array.<number>}
             * @private
             */

        }, {
            key: "_setAlignment",
            value: function _setAlignment(ctx, x, y, baseline) {
                // check for label alignment (for edges)
                // TODO: make alignment for nodes
                if (this.isEdgeLabel && this.fontOptions.align !== "horizontal" && this.pointToSelf === false) {
                    x = 0;
                    y = 0;
                    var lineMargin = 2;

                    if (this.fontOptions.align === "top") {
                        ctx.textBaseline = "alphabetic";
                        y -= 2 * lineMargin; // distance from edge, required because we use alphabetic. Alphabetic has less difference between browsers
                    } else if (this.fontOptions.align === "bottom") {
                        ctx.textBaseline = "hanging";
                        y += 2 * lineMargin; // distance from edge, required because we use hanging. Hanging has less difference between browsers
                    } else {
                        ctx.textBaseline = "middle";
                    }
                } else {
                    ctx.textBaseline = baseline;
                }

                return [x, y];
            }
            /**
             * fade in when relative scale is between threshold and threshold - 1.
             * If the relative scale would be smaller than threshold -1 the draw function would have returned before coming here.
             *
             * @param {string} color  The font color to use
             * @param {number} viewFontSize
             * @param {string} initialStrokeColor
             * @returns {Array.<string>} An array containing the font color and stroke color
             * @private
             */

        }, {
            key: "_getColor",
            value: function _getColor(color, viewFontSize, initialStrokeColor) {
                var fontColor = color || "#000000";
                var strokeColor = initialStrokeColor || "#ffffff";

                if (viewFontSize <= this.elementOptions.scaling.label.drawThreshold) {
                    var opacity = Math.max(0, Math.min(1, 1 - (this.elementOptions.scaling.label.drawThreshold - viewFontSize)));
                    fontColor = overrideOpacity(fontColor, opacity);
                    strokeColor = overrideOpacity(strokeColor, opacity);
                }

                return [fontColor, strokeColor];
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {{width: number, height: number}}
             */

        }, {
            key: "getTextSize",
            value: function getTextSize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                this._processLabel(ctx, selected, hover);

                return {
                    width: this.size.width,
                    height: this.size.height,
                    lineCount: this.lineCount
                };
            }
            /**
             * Get the current dimensions of the label
             *
             * @returns {rect}
             */

        }, {
            key: "getSize",
            value: function getSize() {
                var lineMargin = 2;
                var x = this.size.left; // default values which might be overridden below

                var y = this.size.top - 0.5 * lineMargin; // idem

                if (this.isEdgeLabel) {
                    var x2 = -this.size.width * 0.5;

                    switch (this.fontOptions.align) {
                        case "middle":
                            x = x2;
                            y = -this.size.height * 0.5;
                            break;

                        case "top":
                            x = x2;
                            y = -(this.size.height + lineMargin);
                            break;

                        case "bottom":
                            x = x2;
                            y = lineMargin;
                            break;
                    }
                }

                var ret = {
                    left: x,
                    top: y,
                    width: this.size.width,
                    height: this.size.height
                };
                return ret;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {number} [x=0]
             * @param {number} [y=0]
             * @param {'middle'|'hanging'} [baseline='middle']
             */

        }, {
            key: "calculateLabelSize",
            value: function calculateLabelSize(ctx, selected, hover) {
                var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";

                this._processLabel(ctx, selected, hover);

                this.size.left = x - this.size.width * 0.5;
                this.size.top = y - this.size.height * 0.5;
                this.size.yLine = y + (1 - this.lineCount) * 0.5 * this.fontOptions.size;

                if (baseline === "hanging") {
                    this.size.top += 0.5 * this.fontOptions.size;
                    this.size.top += 4; // distance from node, required because we use hanging. Hanging has less difference between browsers

                    this.size.yLine += 4; // distance from node
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} mod
             * @returns {{color, size, face, mod, vadjust, strokeWidth: *, strokeColor: (*|string|allOptions.edges.font.strokeColor|{string}|allOptions.nodes.font.strokeColor|Array)}}
             */

        }, {
            key: "getFormattingValues",
            value: function getFormattingValues(ctx, selected, hover, mod) {
                var getValue = function getValue(fontOptions, mod, option) {
                    if (mod === "normal") {
                        if (option === "mod") return "";
                        return fontOptions[option];
                    }

                    if (fontOptions[mod][option] !== undefined) {
                        // Grumbl leaving out test on undefined equals false for ""
                        return fontOptions[mod][option];
                    } else {
                        // Take from parent font option
                        return fontOptions[option];
                    }
                };

                var values = {
                    color: getValue(this.fontOptions, mod, "color"),
                    size: getValue(this.fontOptions, mod, "size"),
                    face: getValue(this.fontOptions, mod, "face"),
                    mod: getValue(this.fontOptions, mod, "mod"),
                    vadjust: getValue(this.fontOptions, mod, "vadjust"),
                    strokeWidth: this.fontOptions.strokeWidth,
                    strokeColor: this.fontOptions.strokeColor
                };

                if (selected || hover) {
                    if (mod === "normal" && this.fontOptions.chooser === true && this.elementOptions.labelHighlightBold) {
                        values.mod = "bold";
                    } else {
                        if (typeof this.fontOptions.chooser === "function") {
                            this.fontOptions.chooser(values, this.elementOptions.id, selected, hover);
                        }
                    }
                }

                var fontString = "";

                if (values.mod !== undefined && values.mod !== "") {
                    // safeguard for undefined - this happened
                    fontString += values.mod + " ";
                }

                fontString += values.size + "px " + values.face;
                ctx.font = fontString.replace(/"/g, "");
                values.font = ctx.font;
                values.height = values.size;
                return values;
            }
            /**
             *
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {boolean}
             */

        }, {
            key: "differentState",
            value: function differentState(selected, hover) {
                return selected !== this.selectedState || hover !== this.hoverState;
            }
            /**
             * This explodes the passed text into lines and determines the width, height and number of lines.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} inText  the text to explode
             * @returns {{width, height, lines}|*}
             * @private
             */

        }, {
            key: "_processLabelText",
            value: function _processLabelText(ctx, selected, hover, inText) {
                var splitter = new LabelSplitter(ctx, this, selected, hover);
                return splitter.process(inText);
            }
            /**
             * This explodes the label string into lines and sets the width, height and number of lines.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_processLabel",
            value: function _processLabel(ctx, selected, hover) {
                if (this.labelDirty === false && !this.differentState(selected, hover)) return;

                var state = this._processLabelText(ctx, selected, hover, this.elementOptions.label);

                if (this.fontOptions.minWdt > 0 && state.width < this.fontOptions.minWdt) {
                    state.width = this.fontOptions.minWdt;
                }

                this.size.labelHeight = state.height;

                if (this.fontOptions.minHgt > 0 && state.height < this.fontOptions.minHgt) {
                    state.height = this.fontOptions.minHgt;
                }

                this.lines = state.lines;
                this.lineCount = state.lines.length;
                this.size.width = state.width;
                this.size.height = state.height;
                this.selectedState = selected;
                this.hoverState = hover;
                this.labelDirty = false;
            }
            /**
             * Check if this label is visible
             *
             * @returns {boolean} true if this label will be show, false otherwise
             */

        }, {
            key: "visible",
            value: function visible() {
                if (this.size.width === 0 || this.size.height === 0 || this.elementOptions.label === undefined) {
                    return false; // nothing to display
                }

                var viewFontSize = this.fontOptions.size * this.body.view.scale;

                if (viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) {
                    return false; // Too small or too far away to show
                }

                return true;
            }
        }], [{
            key: "parseFontString",
            value: function parseFontString(outOptions, inOptions) {
                if (!inOptions || typeof inOptions !== "string") return false;
                var newOptionsArray = inOptions.split(" ");
                outOptions.size = +newOptionsArray[0].replace("px", "");
                outOptions.face = newOptionsArray[1];
                outOptions.color = newOptionsArray[2];
                return true;
            }
        }]);

        return Label;
    }();

    /**
     * The Base class for all Nodes.
     */
    var NodeBase = /*#__PURE__*/function () {
        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function NodeBase(options, body, labelModule) {
            _classCallCheck(this, NodeBase);

            this.body = body;
            this.labelModule = labelModule;
            this.setOptions(options);
            this.top = undefined;
            this.left = undefined;
            this.height = undefined;
            this.width = undefined;
            this.radius = undefined;
            this.margin = undefined;
            this.refreshNeeded = true;
            this.boundingBox = {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            };
        }
        /**
         *
         * @param {object} options
         */


        _createClass(NodeBase, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             *
             * @param {Label} labelModule
             * @private
             */

        }, {
            key: "_setMargins",
            value: function _setMargins(labelModule) {
                this.margin = {};

                if (this.options.margin) {
                    if (_typeof(this.options.margin) == "object") {
                        this.margin.top = this.options.margin.top;
                        this.margin.right = this.options.margin.right;
                        this.margin.bottom = this.options.margin.bottom;
                        this.margin.left = this.options.margin.left;
                    } else {
                        this.margin.top = this.options.margin;
                        this.margin.right = this.options.margin;
                        this.margin.bottom = this.options.margin;
                        this.margin.left = this.options.margin;
                    }
                }

                labelModule.adjustSizes(this.margin);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             * @private
             */

        }, {
            key: "_distanceToBorder",
            value: function _distanceToBorder(ctx, angle) {
                var borderWidth = this.options.borderWidth;

                if (ctx) {
                    this.resize(ctx);
                }

                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "enableBorderDashes",
            value: function enableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var dashes = values.borderDashes;

                        if (dashes === true) {
                            dashes = [5, 15];
                        }

                        ctx.setLineDash(dashes);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "disableBorderDashes",
            value: function disableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([0]);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
            /**
             * Determine if the shape of a node needs to be recalculated.
             *
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {boolean}
             * @protected
             */

        }, {
            key: "needsRefresh",
            value: function needsRefresh(selected, hover) {
                if (this.refreshNeeded === true) {
                    // This is probably not the best location to reset this member.
                    // However, in the current logic, it is the most convenient one.
                    this.refreshNeeded = false;
                    return true;
                }

                return this.width === undefined || this.labelModule.differentState(selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "initContextForDraw",
            value: function initContextForDraw(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale;
                ctx.lineWidth = Math.min(this.width, borderWidth);
                ctx.strokeStyle = values.borderColor;
                ctx.fillStyle = values.color;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "performStroke",
            value: function performStroke(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale; //draw dashed border if enabled, save and restore is required for firefox not to crash on unix.

                ctx.save(); // if borders are zero width, they will be drawn with width 1 by default. This prevents that

                if (borderWidth > 0) {
                    this.enableBorderDashes(ctx, values); //draw the border

                    ctx.stroke(); //disable dashed border for other elements

                    this.disableBorderDashes(ctx, values);
                }

                ctx.restore();
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "performFill",
            value: function performFill(ctx, values) {
                ctx.save();
                ctx.fillStyle = values.color; // draw shadow if enabled

                this.enableShadow(ctx, values); // draw the background

                fill(ctx).call(ctx); // disable shadows for other elements.


                this.disableShadow(ctx, values);
                ctx.restore();
                this.performStroke(ctx, values);
            }
            /**
             *
             * @param {number} margin
             * @private
             */

        }, {
            key: "_addBoundingBoxMargin",
            value: function _addBoundingBoxMargin(margin) {
                this.boundingBox.left -= margin;
                this.boundingBox.top -= margin;
                this.boundingBox.bottom += margin;
                this.boundingBox.right += margin;
            }
            /**
             * Actual implementation of this method call.
             *
             * Doing it like this makes it easier to override
             * in the child classes.
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_updateBoundingBox",
            value: function _updateBoundingBox(x, y, ctx, selected, hover) {
                if (ctx !== undefined) {
                    this.resize(ctx, selected, hover);
                }

                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;
            }
            /**
             * Default implementation of this method call.
             * This acts as a stub which can be overridden.
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);
            }
            /**
             * Determine the dimensions to use for nodes with an internal label
             *
             * Currently, these are: Circle, Ellipse, Database, Box
             * The other nodes have external labels, and will not call this method
             *
             * If there is no label, decent default values are supplied.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} [selected]
             * @param {boolean} [hover]
             * @returns {{width:number, height:number}}
             */

        }, {
            key: "getDimensionsFromLabel",
            value: function getDimensionsFromLabel(ctx, selected, hover) {
                // NOTE: previously 'textSize' was not put in 'this' for Ellipse
                // TODO: examine the consequences.
                this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                var width = this.textSize.width;
                var height = this.textSize.height;
                var DEFAULT_SIZE = 14;

                if (width === 0) {
                    // This happens when there is no label text set
                    width = DEFAULT_SIZE; // use a decent default

                    height = DEFAULT_SIZE; // if width zero, then height also always zero
                }

                return {
                    width: width,
                    height: height
                };
            }
        }]);

        return NodeBase;
    }();

    function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Box Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Box$1 = /*#__PURE__*/function (_NodeBase) {
        _inherits(Box, _NodeBase);

        var _super = _createSuper$s(Box);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Box(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Box);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Box, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.width = dimensions.width + this.margin.right + this.margin.left;
                    this.height = dimensions.height + this.margin.top + this.margin.bottom;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                drawRoundRect(ctx, this.left, this.top, this.width, this.height, values.borderRadius);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
            /**
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);

                var borderRadius = this.options.shapeProperties.borderRadius; // only effective for box

                this._addBoundingBoxMargin(borderRadius);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) {
                    this.resize(ctx);
                }

                var borderWidth = this.options.borderWidth;
                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
        }]);

        return Box;
    }(NodeBase);

    function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * NOTE: This is a bad base class
     *
     * Child classes are:
     *
     *   Image       - uses *only* image methods
     *   Circle      - uses *only* _drawRawCircle
     *   CircleImage - uses all
     *
     * TODO: Refactor, move _drawRawCircle to different module, derive Circle from NodeBase
     *       Rename this to ImageBase
     *       Consolidate common code in Image and CircleImage to base class
     *
     * @augments NodeBase
     */

    var CircleImageBase = /*#__PURE__*/function (_NodeBase) {
        _inherits(CircleImageBase, _NodeBase);

        var _super = _createSuper$r(CircleImageBase);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function CircleImageBase(options, body, labelModule) {
            var _this;

            _classCallCheck(this, CircleImageBase);

            _this = _super.call(this, options, body, labelModule);
            _this.labelOffset = 0;
            _this.selected = false;
            return _this;
        }
        /**
         *
         * @param {object} options
         * @param {object} [imageObj]
         * @param {object} [imageObjAlt]
         */


        _createClass(CircleImageBase, [{
            key: "setOptions",
            value: function setOptions(options, imageObj, imageObjAlt) {
                this.options = options;

                if (!(imageObj === undefined && imageObjAlt === undefined)) {
                    this.setImages(imageObj, imageObjAlt);
                }
            }
            /**
             * Set the images for this node.
             *
             * The images can be updated after the initial setting of options;
             * therefore, this method needs to be reentrant.
             *
             * For correct working in error cases, it is necessary to properly set
             * field 'nodes.brokenImage' in the options.
             *
             * @param {Image} imageObj  required; main image to show for this node
             * @param {Image|undefined} imageObjAlt optional; image to show when node is selected
             */

        }, {
            key: "setImages",
            value: function setImages(imageObj, imageObjAlt) {
                if (imageObjAlt && this.selected) {
                    this.imageObj = imageObjAlt;
                    this.imageObjAlt = imageObj;
                } else {
                    this.imageObj = imageObj;
                    this.imageObjAlt = imageObjAlt;
                }
            }
            /**
             * Set selection and switch between the base and the selected image.
             *
             * Do the switch only if imageObjAlt exists.
             *
             * @param {boolean} selected value of new selected state for current node
             */

        }, {
            key: "switchImages",
            value: function switchImages(selected) {
                var selection_changed = selected && !this.selected || !selected && this.selected;
                this.selected = selected; // Remember new selection

                if (this.imageObjAlt !== undefined && selection_changed) {
                    var imageTmp = this.imageObj;
                    this.imageObj = this.imageObjAlt;
                    this.imageObjAlt = imageTmp;
                }
            }
            /**
             * Returns Image Padding from node options
             *
             * @returns {{top: number,left: number,bottom: number,right: number}} image padding inside this shape
             * @private
             */

        }, {
            key: "_getImagePadding",
            value: function _getImagePadding() {
                var imgPadding = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };

                if (this.options.imagePadding) {
                    var optImgPadding = this.options.imagePadding;

                    if (_typeof(optImgPadding) == "object") {
                        imgPadding.top = optImgPadding.top;
                        imgPadding.right = optImgPadding.right;
                        imgPadding.bottom = optImgPadding.bottom;
                        imgPadding.left = optImgPadding.left;
                    } else {
                        imgPadding.top = optImgPadding;
                        imgPadding.right = optImgPadding;
                        imgPadding.bottom = optImgPadding;
                        imgPadding.left = optImgPadding;
                    }
                }

                return imgPadding;
            }
            /**
             * Adjust the node dimensions for a loaded image.
             *
             * Pre: this.imageObj is valid
             */

        }, {
            key: "_resizeImage",
            value: function _resizeImage() {
                var width, height;

                if (this.options.shapeProperties.useImageSize === false) {
                    // Use the size property
                    var ratio_width = 1;
                    var ratio_height = 1; // Only calculate the proper ratio if both width and height not zero

                    if (this.imageObj.width && this.imageObj.height) {
                        if (this.imageObj.width > this.imageObj.height) {
                            ratio_width = this.imageObj.width / this.imageObj.height;
                        } else {
                            ratio_height = this.imageObj.height / this.imageObj.width;
                        }
                    }

                    width = this.options.size * 2 * ratio_width;
                    height = this.options.size * 2 * ratio_height;
                } else {
                    // Use the image size with image padding
                    var imgPadding = this._getImagePadding();

                    width = this.imageObj.width + imgPadding.left + imgPadding.right;
                    height = this.imageObj.height + imgPadding.top + imgPadding.bottom;
                }

                this.width = width;
                this.height = height;
                this.radius = 0.5 * this.width;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {ArrowOptions} values
             * @private
             */

        }, {
            key: "_drawRawCircle",
            value: function _drawRawCircle(ctx, x, y, values) {
                this.initContextForDraw(ctx, values);
                drawCircle(ctx, x, y, values.size);
                this.performFill(ctx, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             * @private
             */

        }, {
            key: "_drawImageAtPosition",
            value: function _drawImageAtPosition(ctx, values) {
                if (this.imageObj.width != 0) {
                    // draw the image
                    ctx.globalAlpha = values.opacity !== undefined ? values.opacity : 1; // draw shadow if enabled

                    this.enableShadow(ctx, values);
                    var factor = 1;

                    if (this.options.shapeProperties.interpolation === true) {
                        factor = this.imageObj.width / this.width / this.body.view.scale;
                    }

                    var imgPadding = this._getImagePadding();

                    var imgPosLeft = this.left + imgPadding.left;
                    var imgPosTop = this.top + imgPadding.top;
                    var imgWidth = this.width - imgPadding.left - imgPadding.right;
                    var imgHeight = this.height - imgPadding.top - imgPadding.bottom;
                    this.imageObj.drawImageAtPosition(ctx, factor, imgPosLeft, imgPosTop, imgWidth, imgHeight); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_drawImageLabel",
            value: function _drawImageLabel(ctx, x, y, selected, hover) {
                var offset = 0;

                if (this.height !== undefined) {
                    offset = this.height * 0.5;
                    var labelDimensions = this.labelModule.getTextSize(ctx, selected, hover);

                    if (labelDimensions.lineCount >= 1) {
                        offset += labelDimensions.height / 2;
                    }
                }

                var yLabel = y + offset;

                if (this.options.label) {
                    this.labelOffset = offset;
                }

                this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
            }
        }]);

        return CircleImageBase;
    }(NodeBase);

    function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Circle Node/Cluster shape.
     *
     * @augments CircleImageBase
     */

    var Circle$1 = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(Circle, _CircleImageBase);

        var _super = _createSuper$q(Circle);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Circle(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Circle);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Circle, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var diameter = Math.max(dimensions.width + this.margin.right + this.margin.left, dimensions.height + this.margin.top + this.margin.bottom);
                    this.options.size = diameter / 2; // NOTE: this size field only set here, not in Ellipse, Database, Box

                    this.width = diameter;
                    this.height = diameter;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;

                this._drawRawCircle(ctx, x, y, values);

                this.updateBoundingBox(x, y);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, y, selected, hover);
            }
            /**
             *
             * @param {number} x width
             * @param {number} y height
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.width * 0.5;
            }
        }]);

        return Circle;
    }(CircleImageBase);

    function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A CircularImage Node/Cluster shape.
     *
     * @augments CircleImageBase
     */

    var CircularImage = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(CircularImage, _CircleImageBase);

        var _super = _createSuper$p(CircularImage);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Image} imageObj
         * @param {Image} imageObjAlt
         */
        function CircularImage(options, body, labelModule, imageObj, imageObjAlt) {
            var _this;

            _classCallCheck(this, CircularImage);

            _this = _super.call(this, options, body, labelModule);

            _this.setImages(imageObj, imageObjAlt);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(CircularImage, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

                if (imageAbsent) {
                    var diameter = this.options.size * 2;
                    this.width = diameter;
                    this.height = diameter;
                    this.radius = 0.5 * this.width;
                    return;
                } // At this point, an image is present, i.e. this.imageObj is valid.


                if (this.needsRefresh(selected, hover)) {
                    this._resizeImage();
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.switchImages(selected);
                this.resize();
                var labelX = x,
                    labelY = y;

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                } // draw the background circle. IMPORTANT: the stroke in this method is used by the clip method below.


                this._drawRawCircle(ctx, labelX, labelY, values); // now we draw in the circle, we save so we can revert the clip operation after drawing.


                ctx.save(); // clip is used to use the stroke in drawRawCircle as an area that we can draw in.

                ctx.clip(); // draw the image

                this._drawImageAtPosition(ctx, values); // restore so we can again draw on the full canvas


                ctx.restore();

                this._drawImageLabel(ctx, labelX, labelY, selected, hover);

                this.updateBoundingBox(x, y);
            } // TODO: compare with Circle.updateBoundingBox(), consolidate? More stuff is happening here

            /**
             *
             * @param {number} x width
             * @param {number} y height
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.boundingBox.top = y;
                    this.boundingBox.left = x;
                    this.boundingBox.right = x + this.options.size * 2;
                    this.boundingBox.bottom = y + this.options.size * 2;
                } else {
                    this.boundingBox.top = y - this.options.size;
                    this.boundingBox.left = x - this.options.size;
                    this.boundingBox.right = x + this.options.size;
                    this.boundingBox.bottom = y + this.options.size;
                } // TODO: compare with Image.updateBoundingBox(), consolidate?


                this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.width * 0.5;
            }
        }]);

        return CircularImage;
    }(CircleImageBase);

    function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Base class for constructing Node/Cluster Shapes.
     *
     * @augments NodeBase
     */

    var ShapeBase = /*#__PURE__*/function (_NodeBase) {
        _inherits(ShapeBase, _NodeBase);

        var _super = _createSuper$o(ShapeBase);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function ShapeBase(options, body, labelModule) {
            _classCallCheck(this, ShapeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         * @param {object} [values={size: this.options.size}]
         */


        _createClass(ShapeBase, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    size: this.options.size
                };

                if (this.needsRefresh(selected, hover)) {
                    var _this$customSizeWidth, _this$customSizeHeigh;

                    this.labelModule.getTextSize(ctx, selected, hover);
                    var size = 2 * values.size;
                    this.width = (_this$customSizeWidth = this.customSizeWidth) !== null && _this$customSizeWidth !== void 0 ? _this$customSizeWidth : size;
                    this.height = (_this$customSizeHeigh = this.customSizeHeight) !== null && _this$customSizeHeigh !== void 0 ? _this$customSizeHeigh : size;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} shape
             * @param {number} sizeMultiplier - Unused! TODO: Remove next major release
             * @param {number} x
             * @param {number} y
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             * @private
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "_drawShape",
            value: function _drawShape(ctx, shape, sizeMultiplier, x, y, selected, hover, values) {
                var _this = this;

                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                getShape(shape)(ctx, x, y, values.size);
                this.performFill(ctx, values);

                if (this.options.icon !== undefined) {
                    if (this.options.icon.code !== undefined) {
                        ctx.font = (selected ? "bold " : "") + this.height / 2 + "px " + (this.options.icon.face || "FontAwesome");
                        ctx.fillStyle = this.options.icon.color || "black";
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        ctx.fillText(this.options.icon.code, x, y);
                    }
                }

                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this.options.label !== undefined) {
                            // Need to call following here in order to ensure value for
                            // `this.labelModule.size.height`.
                            _this.labelModule.calculateLabelSize(ctx, selected, hover, x, y, "hanging");

                            var yLabel = y + 0.5 * _this.height + 0.5 * _this.labelModule.size.height;

                            _this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
                        }

                        _this.updateBoundingBox(x, y);
                    }
                };
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height);
                }
            }
        }]);

        return ShapeBase;
    }(NodeBase);

    function ownKeys$3(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$2(_context = ownKeys$3(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context2; forEach$2(_context2 = ownKeys$3(Object(source))).call(_context2, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A CustomShape Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var CustomShape = /*#__PURE__*/function (_ShapeBase) {
        _inherits(CustomShape, _ShapeBase);

        var _super = _createSuper$n(CustomShape);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Function} ctxRenderer

         */
        function CustomShape(options, body, labelModule, ctxRenderer) {
            var _this;

            _classCallCheck(this, CustomShape);

            _this = _super.call(this, options, body, labelModule, ctxRenderer);
            _this.ctxRenderer = ctxRenderer;
            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on different layers.
         */


        _createClass(CustomShape, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2; // Guard right away because someone may just draw in the function itself.

                ctx.save();
                var drawLater = this.ctxRenderer({
                    ctx: ctx,
                    id: this.options.id,
                    x: x,
                    y: y,
                    state: {
                        selected: selected,
                        hover: hover
                    },
                    style: _objectSpread$3({}, values),
                    label: this.options.label
                }); // Render the node shape bellow arrows.

                if (drawLater.drawNode != null) {
                    drawLater.drawNode();
                }

                ctx.restore();

                if (drawLater.drawExternalLabel) {
                    // Guard the external label (above arrows) drawing function.
                    var drawExternalLabel = drawLater.drawExternalLabel;

                    drawLater.drawExternalLabel = function () {
                        ctx.save();
                        drawExternalLabel();
                        ctx.restore();
                    };
                }

                if (drawLater.nodeDimensions) {
                    this.customSizeWidth = drawLater.nodeDimensions.width;
                    this.customSizeHeight = drawLater.nodeDimensions.height;
                }

                return drawLater;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return CustomShape;
    }(ShapeBase);

    function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Database Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Database = /*#__PURE__*/function (_NodeBase) {
        _inherits(Database, _NodeBase);

        var _super = _createSuper$m(Database);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Database(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Database);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} selected
         * @param {boolean} hover
         */


        _createClass(Database, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var size = dimensions.width + this.margin.right + this.margin.left;
                    this.width = size;
                    this.height = size;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                drawDatabase(ctx, x - this.width / 2, y - this.height / 2, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Database;
    }(NodeBase);

    function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Diamond Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Diamond$1 = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Diamond, _ShapeBase);

        var _super = _createSuper$l(Diamond);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Diamond(options, body, labelModule) {
            _classCallCheck(this, Diamond);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Diamond, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "diamond", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Diamond;
    }(ShapeBase);

    function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Dot Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Dot = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Dot, _ShapeBase);

        var _super = _createSuper$k(Dot);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Dot(options, body, labelModule) {
            _classCallCheck(this, Dot);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Dot, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "circle", 2, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.options.size;
            }
        }]);

        return Dot;
    }(ShapeBase);

    function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Am Ellipse Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Ellipse = /*#__PURE__*/function (_NodeBase) {
        _inherits(Ellipse, _NodeBase);

        var _super = _createSuper$j(Ellipse);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Ellipse(options, body, labelModule) {
            _classCallCheck(this, Ellipse);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Ellipse, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.height = dimensions.height * 2;
                    this.width = dimensions.width + dimensions.height;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width * 0.5;
                this.top = y - this.height * 0.5;
                this.initContextForDraw(ctx, values);
                drawEllipse(ctx, this.left, this.top, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, x, y, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) {
                    this.resize(ctx);
                }

                var a = this.width * 0.5;
                var b = this.height * 0.5;
                var w = Math.sin(angle) * a;
                var h = Math.cos(angle) * b;
                return a * b / Math.sqrt(w * w + h * h);
            }
        }]);

        return Ellipse;
    }(NodeBase);

    function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * An icon replacement for the default Node shape.
     *
     * @augments NodeBase
     */

    var Icon = /*#__PURE__*/function (_NodeBase) {
        _inherits(Icon, _NodeBase);

        var _super = _createSuper$i(Icon);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Icon(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Icon);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx - Unused.
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Icon, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.iconSize = {
                        width: Number(this.options.icon.size),
                        height: Number(this.options.icon.size)
                    };
                    this.width = this.iconSize.width + this.margin.right + this.margin.left;
                    this.height = this.iconSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                var _this2 = this;

                this.resize(ctx, selected, hover);
                this.options.icon.size = this.options.icon.size || 50;
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;

                this._icon(ctx, x, y, selected, hover, values);

                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this2.options.label !== undefined) {
                            var iconTextSpacing = 5;

                            _this2.labelModule.draw(ctx, _this2.left + _this2.iconSize.width / 2 + _this2.margin.left, y + _this2.height / 2 + iconTextSpacing, selected);
                        }

                        _this2.updateBoundingBox(x, y);
                    }
                };
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.icon.size * 0.5;
                this.boundingBox.left = x - this.options.icon.size * 0.5;
                this.boundingBox.right = x + this.options.icon.size * 0.5;
                this.boundingBox.bottom = y + this.options.icon.size * 0.5;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    var iconTextSpacing = 5;
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height + iconTextSpacing);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover - Unused
             * @param {ArrowOptions} values
             */

        }, {
            key: "_icon",
            value: function _icon(ctx, x, y, selected, hover, values) {
                var iconSize = Number(this.options.icon.size);

                if (this.options.icon.code !== undefined) {
                    ctx.font = [this.options.icon.weight != null ? this.options.icon.weight : selected ? "bold" : "", // If the weight is forced (for example to make Font Awesome 5 work
                        // properly) substitute slightly bigger size for bold font face.
                        (this.options.icon.weight != null && selected ? 5 : 0) + iconSize + "px", this.options.icon.face].join(" "); // draw icon

                    ctx.fillStyle = this.options.icon.color || "black";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle"; // draw shadow if enabled

                    this.enableShadow(ctx, values);
                    ctx.fillText(this.options.icon.code, x, y); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                } else {
                    console.error("When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.");
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Icon;
    }(NodeBase);

    function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * An image-based replacement for the default Node shape.
     *
     * @augments CircleImageBase
     */

    var Image$2 = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(Image, _CircleImageBase);

        var _super = _createSuper$h(Image);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Image} imageObj
         * @param {Image} imageObjAlt
         */
        function Image(options, body, labelModule, imageObj, imageObjAlt) {
            var _this;

            _classCallCheck(this, Image);

            _this = _super.call(this, options, body, labelModule);

            _this.setImages(imageObj, imageObjAlt);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx - Unused.
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Image, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

                if (imageAbsent) {
                    var side = this.options.size * 2;
                    this.width = side;
                    this.height = side;
                    return;
                }

                if (this.needsRefresh(selected, hover)) {
                    this._resizeImage();
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                ctx.save();
                this.switchImages(selected);
                this.resize();
                var labelX = x,
                    labelY = y;

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }

                if (this.options.shapeProperties.useBorderWithImage === true) {
                    var neutralborderWidth = this.options.borderWidth;
                    var selectionLineWidth = this.options.borderWidthSelected || 2 * this.options.borderWidth;
                    var borderWidth = (selected ? selectionLineWidth : neutralborderWidth) / this.body.view.scale;
                    ctx.lineWidth = Math.min(this.width, borderWidth);
                    ctx.beginPath();
                    var strokeStyle = selected ? this.options.color.highlight.border : hover ? this.options.color.hover.border : this.options.color.border;
                    var fillStyle = selected ? this.options.color.highlight.background : hover ? this.options.color.hover.background : this.options.color.background;

                    if (values.opacity !== undefined) {
                        strokeStyle = overrideOpacity(strokeStyle, values.opacity);
                        fillStyle = overrideOpacity(fillStyle, values.opacity);
                    } // setup the line properties.


                    ctx.strokeStyle = strokeStyle; // set a fillstyle

                    ctx.fillStyle = fillStyle; // draw a rectangle to form the border around. This rectangle is filled so the opacity of a picture (in future vis releases?) can be used to tint the image

                    ctx.rect(this.left - 0.5 * ctx.lineWidth, this.top - 0.5 * ctx.lineWidth, this.width + ctx.lineWidth, this.height + ctx.lineWidth);

                    fill(ctx).call(ctx);

                    this.performStroke(ctx, values);
                    ctx.closePath();
                }

                this._drawImageAtPosition(ctx, values);

                this._drawImageLabel(ctx, labelX, labelY, selected, hover);

                this.updateBoundingBox(x, y);
                ctx.restore();
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.resize();

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }

                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Image;
    }(CircleImageBase);

    function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Square Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Square = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Square, _ShapeBase);

        var _super = _createSuper$g(Square);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Square(options, body, labelModule) {
            _classCallCheck(this, Square);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Square, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "square", 2, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Square;
    }(ShapeBase);

    function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Hexagon Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Hexagon = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Hexagon, _ShapeBase);

        var _super = _createSuper$f(Hexagon);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Hexagon(options, body, labelModule) {
            _classCallCheck(this, Hexagon);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Hexagon, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "hexagon", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Hexagon;
    }(ShapeBase);

    function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Star Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Star = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Star, _ShapeBase);

        var _super = _createSuper$e(Star);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Star(options, body, labelModule) {
            _classCallCheck(this, Star);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Star, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "star", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Star;
    }(ShapeBase);

    function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A text-based replacement for the default Node shape.
     *
     * @augments NodeBase
     */

    var Text = /*#__PURE__*/function (_NodeBase) {
        _inherits(Text, _NodeBase);

        var _super = _createSuper$d(Text);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Text(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Text);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} selected
         * @param {boolean} hover
         */


        _createClass(Text, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                    this.width = this.textSize.width + this.margin.right + this.margin.left;
                    this.height = this.textSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2; // draw shadow if enabled

                this.enableShadow(ctx, values);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover); // disable shadows for other elements.

                this.disableShadow(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Text;
    }(NodeBase);

    function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Triangle Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Triangle$1 = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Triangle, _ShapeBase);

        var _super = _createSuper$c(Triangle);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Triangle(options, body, labelModule) {
            _classCallCheck(this, Triangle);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x
         * @param {number} y
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Triangle, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangle", 3, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Triangle;
    }(ShapeBase);

    function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A downward facing Triangle Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var TriangleDown = /*#__PURE__*/function (_ShapeBase) {
        _inherits(TriangleDown, _ShapeBase);

        var _super = _createSuper$b(TriangleDown);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function TriangleDown(options, body, labelModule) {
            _classCallCheck(this, TriangleDown);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x
         * @param {number} y
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(TriangleDown, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangleDown", 3, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return TriangleDown;
    }(ShapeBase);

    function ownKeys$2(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; forEach$2(_context5 = ownKeys$2(Object(source), true)).call(_context5, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context6; forEach$2(_context6 = ownKeys$2(Object(source))).call(_context6, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }
    /**
     * A node. A node can be connected to other nodes via one or multiple edges.
     */

    var Node = /*#__PURE__*/function () {
        /**
         *
         * @param {object} options An object containing options for the node. All
         *                            options are optional, except for the id.
         *                              {number} id     Id of the node. Required
         *                              {string} label  Text label for the node
         *                              {number} x      Horizontal position of the node
         *                              {number} y      Vertical position of the node
         *                              {string} shape  Node shape
         *                              {string} image  An image url
         *                              {string} title  A title text, can be HTML
         *                              {anytype} group A group name or number
         *
         * @param {object} body               Shared state of current network instance
         * @param {Network.Images} imagelist  A list with images. Only needed when the node has an image
         * @param {Groups} grouplist          A list with groups. Needed for retrieving group options
         * @param {object} globalOptions      Current global node options; these serve as defaults for the node instance
         * @param {object} defaultOptions     Global default options for nodes; note that this is also the prototype
         *                                    for parameter `globalOptions`.
         */
        function Node(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
            _classCallCheck(this, Node);

            this.options = bridgeObject(globalOptions);
            this.globalOptions = globalOptions;
            this.defaultOptions = defaultOptions;
            this.body = body;
            this.edges = []; // all edges connected to this node
            // set defaults for the options

            this.id = undefined;
            this.imagelist = imagelist;
            this.grouplist = grouplist; // state options

            this.x = undefined;
            this.y = undefined;
            this.baseSize = this.options.size;
            this.baseFontSize = this.options.font.size;
            this.predefinedPosition = false; // used to check if initial fit should just take the range or approximate

            this.selected = false;
            this.hover = false;
            this.labelModule = new Label(this.body, this.options, false
                /* Not edge label */
            );
            this.setOptions(options);
        }
        /**
         * Attach a edge to the node
         *
         * @param {Edge} edge
         */


        _createClass(Node, [{
            key: "attachEdge",
            value: function attachEdge(edge) {
                var _context;

                if (indexOf(_context = this.edges).call(_context, edge) === -1) {
                    this.edges.push(edge);
                }
            }
            /**
             * Detach a edge from the node
             *
             * @param {Edge} edge
             */

        }, {
            key: "detachEdge",
            value: function detachEdge(edge) {
                var _context2;

                var index = indexOf(_context2 = this.edges).call(_context2, edge);

                if (index != -1) {
                    var _context3;

                    splice(_context3 = this.edges).call(_context3, index, 1);
                }
            }
            /**
             * Set or overwrite options for the node
             *
             * @param {object} options an object with options
             * @returns {null|boolean}
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                var currentShape = this.options.shape;

                if (!options) {
                    return; // Note that the return value will be 'undefined'! This is OK.
                } // Save the color for later.
                // This is necessary in order to prevent local color from being overwritten by group color.
                // TODO: To prevent such workarounds the way options are handled should be rewritten from scratch.
                // This is not the only problem with current options handling.


                if (typeof options.color !== "undefined") {
                    this._localColor = options.color;
                } // basic options


                if (options.id !== undefined) {
                    this.id = options.id;
                }

                if (this.id === undefined) {
                    throw new Error("Node must have an id");
                }

                Node.checkMass(options, this.id); // set these options locally
                // clear x and y positions

                if (options.x !== undefined) {
                    if (options.x === null) {
                        this.x = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.x = _parseInt(options.x);
                        this.predefinedPosition = true;
                    }
                }

                if (options.y !== undefined) {
                    if (options.y === null) {
                        this.y = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.y = _parseInt(options.y);
                        this.predefinedPosition = true;
                    }
                }

                if (options.size !== undefined) {
                    this.baseSize = options.size;
                }

                if (options.value !== undefined) {
                    options.value = _parseFloat(options.value);
                } // this transforms all shorthands into fully defined options


                Node.parseOptions(this.options, options, true, this.globalOptions, this.grouplist);
                var pile = [options, this.options, this.defaultOptions];
                this.chooser = choosify("node", pile);

                this._load_images();

                this.updateLabelModule(options); // Need to set local opacity after `this.updateLabelModule(options);` because `this.updateLabelModule(options);` overrites local opacity with group opacity

                if (options.opacity !== undefined && Node.checkOpacity(options.opacity)) {
                    this.options.opacity = options.opacity;
                }

                this.updateShape(currentShape);
                return options.hidden !== undefined || options.physics !== undefined;
            }
            /**
             * Load the images from the options, for the nodes that need them.
             *
             * Images are always loaded, even if they are not used in the current shape.
             * The user may switch to an image shape later on.
             *
             * @private
             */

        }, {
            key: "_load_images",
            value: function _load_images() {
                if (this.options.shape === "circularImage" || this.options.shape === "image") {
                    if (this.options.image === undefined) {
                        throw new Error("Option image must be defined for node type '" + this.options.shape + "'");
                    }
                }

                if (this.options.image === undefined) {
                    return;
                }

                if (this.imagelist === undefined) {
                    throw new Error("Internal Error: No images provided");
                }

                if (typeof this.options.image === "string") {
                    this.imageObj = this.imagelist.load(this.options.image, this.options.brokenImage, this.id);
                } else {
                    if (this.options.image.unselected === undefined) {
                        throw new Error("No unselected image provided");
                    }

                    this.imageObj = this.imagelist.load(this.options.image.unselected, this.options.brokenImage, this.id);

                    if (this.options.image.selected !== undefined) {
                        this.imageObjAlt = this.imagelist.load(this.options.image.selected, this.options.brokenImage, this.id);
                    } else {
                        this.imageObjAlt = undefined;
                    }
                }
            }
            /**
             * Check that opacity is only between 0 and 1
             *
             * @param {number} opacity
             * @returns {boolean}
             */

        }, {
            key: "getFormattingValues",
            value:
                /**
                 *
                 * @returns {{color: *, borderWidth: *, borderColor: *, size: *, borderDashes: (boolean|Array|allOptions.nodes.shapeProperties.borderDashes|{boolean, array}), borderRadius: (number|allOptions.nodes.shapeProperties.borderRadius|{number}|Array), shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *}}
                 */
                function getFormattingValues() {
                    var values = {
                        color: this.options.color.background,
                        opacity: this.options.opacity,
                        borderWidth: this.options.borderWidth,
                        borderColor: this.options.color.border,
                        size: this.options.size,
                        borderDashes: this.options.shapeProperties.borderDashes,
                        borderRadius: this.options.shapeProperties.borderRadius,
                        shadow: this.options.shadow.enabled,
                        shadowColor: this.options.shadow.color,
                        shadowSize: this.options.shadow.size,
                        shadowX: this.options.shadow.x,
                        shadowY: this.options.shadow.y
                    };

                    if (this.selected || this.hover) {
                        if (this.chooser === true) {
                            if (this.selected) {
                                if (this.options.borderWidthSelected != null) {
                                    values.borderWidth = this.options.borderWidthSelected;
                                } else {
                                    values.borderWidth *= 2;
                                }

                                values.color = this.options.color.highlight.background;
                                values.borderColor = this.options.color.highlight.border;
                                values.shadow = this.options.shadow.enabled;
                            } else if (this.hover) {
                                values.color = this.options.color.hover.background;
                                values.borderColor = this.options.color.hover.border;
                                values.shadow = this.options.shadow.enabled;
                            }
                        } else if (typeof this.chooser === "function") {
                            this.chooser(values, this.options.id, this.selected, this.hover);

                            if (values.shadow === false) {
                                if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
                                    values.shadow = true;
                                }
                            }
                        }
                    } else {
                        values.shadow = this.options.shadow.enabled;
                    }

                    if (this.options.opacity !== undefined) {
                        var opacity = this.options.opacity;
                        values.borderColor = overrideOpacity(values.borderColor, opacity);
                        values.color = overrideOpacity(values.color, opacity);
                        values.shadowColor = overrideOpacity(values.shadowColor, opacity);
                    }

                    return values;
                }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                if (this.options.label === undefined || this.options.label === null) {
                    this.options.label = "";
                }

                Node.updateGroupOptions(this.options, _objectSpread$2(_objectSpread$2({}, options), {}, {
                    color: options && options.color || this._localColor || undefined
                }), this.grouplist); //
                // Note:The prototype chain for this.options is:
                //
                // this.options ->    NodesHandler.options    -> NodesHandler.defaultOptions
                //                 (also: this.globalOptions)
                //
                // Note that the prototypes are mentioned explicitly in the pile list below;
                // WE DON'T WANT THE ORDER OF THE PROTOTYPES!!!! At least, not for font handling of labels.
                // This is a good indication that the prototype usage of options is deficient.
                //

                var currentGroup = this.grouplist.get(this.options.group, false);
                var pile = [options, // new options
                    this.options, // current node options, see comment above for prototype
                    currentGroup, // group options, if any
                    this.globalOptions, // Currently set global node options
                    this.defaultOptions // Default global node options
                ];
                this.labelModule.update(this.options, pile);

                if (this.labelModule.baseSize !== undefined) {
                    this.baseFontSize = this.labelModule.baseSize;
                }
            }
            /**
             *
             * @param {string} currentShape
             */

        }, {
            key: "updateShape",
            value: function updateShape(currentShape) {
                if (currentShape === this.options.shape && this.shape) {
                    this.shape.setOptions(this.options, this.imageObj, this.imageObjAlt);
                } else {
                    // choose draw method depending on the shape
                    switch (this.options.shape) {
                        case "box":
                            this.shape = new Box$1(this.options, this.body, this.labelModule);
                            break;

                        case "circle":
                            this.shape = new Circle$1(this.options, this.body, this.labelModule);
                            break;

                        case "circularImage":
                            this.shape = new CircularImage(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                            break;

                        case "custom":
                            this.shape = new CustomShape(this.options, this.body, this.labelModule, this.options.ctxRenderer);
                            break;

                        case "database":
                            this.shape = new Database(this.options, this.body, this.labelModule);
                            break;

                        case "diamond":
                            this.shape = new Diamond$1(this.options, this.body, this.labelModule);
                            break;

                        case "dot":
                            this.shape = new Dot(this.options, this.body, this.labelModule);
                            break;

                        case "ellipse":
                            this.shape = new Ellipse(this.options, this.body, this.labelModule);
                            break;

                        case "icon":
                            this.shape = new Icon(this.options, this.body, this.labelModule);
                            break;

                        case "image":
                            this.shape = new Image$2(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                            break;

                        case "square":
                            this.shape = new Square(this.options, this.body, this.labelModule);
                            break;

                        case "hexagon":
                            this.shape = new Hexagon(this.options, this.body, this.labelModule);
                            break;

                        case "star":
                            this.shape = new Star(this.options, this.body, this.labelModule);
                            break;

                        case "text":
                            this.shape = new Text(this.options, this.body, this.labelModule);
                            break;

                        case "triangle":
                            this.shape = new Triangle$1(this.options, this.body, this.labelModule);
                            break;

                        case "triangleDown":
                            this.shape = new TriangleDown(this.options, this.body, this.labelModule);
                            break;

                        default:
                            this.shape = new Ellipse(this.options, this.body, this.labelModule);
                            break;
                    }
                }

                this.needsRefresh();
            }
            /**
             * select this node
             */

        }, {
            key: "select",
            value: function select() {
                this.selected = true;
                this.needsRefresh();
            }
            /**
             * unselect this node
             */

        }, {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
                this.needsRefresh();
            }
            /**
             * Reset the calculated size of the node, forces it to recalculate its size
             */

        }, {
            key: "needsRefresh",
            value: function needsRefresh() {
                this.shape.refreshNeeded = true;
            }
            /**
             * get the title of this node.
             *
             * @returns {string} title    The title of the node, or undefined when no title
             *                           has been set.
             */

        }, {
            key: "getTitle",
            value: function getTitle() {
                return this.options.title;
            }
            /**
             * Calculate the distance to the border of the Node
             *
             * @param {CanvasRenderingContext2D}   ctx
             * @param {number} angle        Angle in radians
             * @returns {number} distance   Distance to the border in pixels
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this.shape.distanceToBorder(ctx, angle);
            }
            /**
             * Check if this node has a fixed x and y position
             *
             * @returns {boolean}      true if fixed, false if not
             */

        }, {
            key: "isFixed",
            value: function isFixed() {
                return this.options.fixed.x && this.options.fixed.y;
            }
            /**
             * check if this node is selecte
             *
             * @returns {boolean} selected   True if node is selected, else false
             */

        }, {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
            /**
             * Retrieve the value of the node. Can be undefined
             *
             * @returns {number} value
             */

        }, {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
            /**
             * Get the current dimensions of the label
             *
             * @returns {rect}
             */

        }, {
            key: "getLabelSize",
            value: function getLabelSize() {
                return this.labelModule.size();
            }
            /**
             * Adjust the value range of the node. The node will adjust it's size
             * based on its value.
             *
             * @param {number} min
             * @param {number} max
             * @param {number} total
             */

        }, {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var sizeDiff = this.options.scaling.max - this.options.scaling.min;

                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }

                    this.options.size = this.options.scaling.min + scale * sizeDiff;
                } else {
                    this.options.size = this.baseSize;
                    this.options.font.size = this.baseFontSize;
                }

                this.updateLabelModule();
            }
            /**
             * Draw this node in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();
                return this.shape.draw(ctx, this.x, this.y, this.selected, this.hover, values) || {};
            }
            /**
             * Update the bounding box of the shape
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(ctx) {
                this.shape.updateBoundingBox(this.x, this.y, ctx);
            }
            /**
             * Recalculate the size of this node in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "resize",
            value: function resize(ctx) {
                var values = this.getFormattingValues();
                this.shape.resize(ctx, this.selected, this.hover, values);
            }
            /**
             * Determine all visual elements of this node instance, in which the given
             * point falls within the bounding shape.
             *
             * @param {point} point
             * @returns {Array.<nodeClickItem|nodeLabelClickItem>} list with the items which are on the point
             */

        }, {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];

                if (this.labelModule.visible()) {
                    if (pointInRect(this.labelModule.getSize(), point)) {
                        ret.push({
                            nodeId: this.id,
                            labelId: 0
                        });
                    }
                }

                if (pointInRect(this.shape.boundingBox, point)) {
                    ret.push({
                        nodeId: this.id
                    });
                }

                return ret;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top, right, bottom
             * @returns {boolean}     True if location is located on node
             */

        }, {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                return this.shape.left < obj.right && this.shape.left + this.shape.width > obj.left && this.shape.top < obj.bottom && this.shape.top + this.shape.height > obj.top;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top, right, bottom
             * @returns {boolean}     True if location is located on node
             */

        }, {
            key: "isBoundingBoxOverlappingWith",
            value: function isBoundingBoxOverlappingWith(obj) {
                return this.shape.boundingBox.left < obj.right && this.shape.boundingBox.right > obj.left && this.shape.boundingBox.top < obj.bottom && this.shape.boundingBox.bottom > obj.top;
            }
            /**
             * Check valid values for mass
             *
             * The mass may not be negative or zero. If it is, reset to 1
             *
             * @param {object} options
             * @param {Node.id} id
             * @static
             */

        }], [{
            key: "checkOpacity",
            value: function checkOpacity(opacity) {
                return 0 <= opacity && opacity <= 1;
            }
            /**
             * Check that origin is 'center' or 'top-left'
             *
             * @param {string} origin
             * @returns {boolean}
             */

        }, {
            key: "checkCoordinateOrigin",
            value: function checkCoordinateOrigin(origin) {
                return origin === undefined || origin === "center" || origin === "top-left";
            }
            /**
             * Copy group option values into the node options.
             *
             * The group options override the global node options, so the copy of group options
             *  must happen *after* the global node options have been set.
             *
             * This method must also be called also if the global node options have changed and the group options did not.
             *
             * @param {object} parentOptions
             * @param {object} newOptions  new values for the options, currently only passed in for check
             * @param {object} groupList
             */

        }, {
            key: "updateGroupOptions",
            value: function updateGroupOptions(parentOptions, newOptions, groupList) {
                var _context4;

                if (groupList === undefined) return; // No groups, nothing to do

                var group = parentOptions.group; // paranoia: the selected group is already merged into node options, check.

                if (newOptions !== undefined && newOptions.group !== undefined && group !== newOptions.group) {
                    throw new Error("updateGroupOptions: group values in options don't match.");
                }

                var hasGroup = typeof group === "number" || typeof group === "string" && group != "";
                if (!hasGroup) return; // current node has no group, no need to merge

                var groupObj = groupList.get(group);

                if (groupObj.opacity !== undefined && newOptions.opacity === undefined) {
                    if (!Node.checkOpacity(groupObj.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + groupObj.opacity);
                        groupObj.opacity = undefined;
                    }
                } // Skip any new option to avoid them being overridden by the group options.


                var skipProperties = filter(_context4 = getOwnPropertyNames(newOptions)).call(_context4, function (p) {
                    return newOptions[p] != null;
                }); // Always skip merging group font options into parent; these are required to be distinct for labels


                skipProperties.push("font");
                selectiveNotDeepExtend(skipProperties, parentOptions, groupObj); // the color object needs to be completely defined.
                // Since groups can partially overwrite the colors, we parse it again, just in case.

                parentOptions.color = parseColor(parentOptions.color);
            }
            /**
             * This process all possible shorthands in the new options and makes sure that the parentOptions are fully defined.
             * Static so it can also be used by the handler.
             *
             * @param {object} parentOptions
             * @param {object} newOptions
             * @param {boolean} [allowDeletion=false]
             * @param {object} [globalOptions={}]
             * @param {object} [groupList]
             * @static
             */

        }, {
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var groupList = arguments.length > 4 ? arguments[4] : undefined;
                var fields = ["color", "fixed", "shadow"];
                selectiveNotDeepExtend(fields, parentOptions, newOptions, allowDeletion);
                Node.checkMass(newOptions);

                if (parentOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(parentOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + parentOptions.opacity);
                        parentOptions.opacity = undefined;
                    }
                }

                if (newOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(newOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + newOptions.opacity);
                        newOptions.opacity = undefined;
                    }
                }

                if (newOptions.shapeProperties && !Node.checkCoordinateOrigin(newOptions.shapeProperties.coordinateOrigin)) {
                    console.error("Invalid option for node coordinateOrigin, found: " + newOptions.shapeProperties.coordinateOrigin);
                } // merge the shadow options into the parent.


                mergeOptions(parentOptions, newOptions, "shadow", globalOptions); // individual shape newOptions

                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var parsedColor = parseColor(newOptions.color);
                    fillIfDefined(parentOptions.color, parsedColor);
                } else if (allowDeletion === true && newOptions.color === null) {
                    parentOptions.color = bridgeObject(globalOptions.color); // set the object back to the global options
                } // handle the fixed options


                if (newOptions.fixed !== undefined && newOptions.fixed !== null) {
                    if (typeof newOptions.fixed === "boolean") {
                        parentOptions.fixed.x = newOptions.fixed;
                        parentOptions.fixed.y = newOptions.fixed;
                    } else {
                        if (newOptions.fixed.x !== undefined && typeof newOptions.fixed.x === "boolean") {
                            parentOptions.fixed.x = newOptions.fixed.x;
                        }

                        if (newOptions.fixed.y !== undefined && typeof newOptions.fixed.y === "boolean") {
                            parentOptions.fixed.y = newOptions.fixed.y;
                        }
                    }
                }

                if (allowDeletion === true && newOptions.font === null) {
                    parentOptions.font = bridgeObject(globalOptions.font); // set the object back to the global options
                }

                Node.updateGroupOptions(parentOptions, newOptions, groupList); // handle the scaling options, specifically the label part

                if (newOptions.scaling !== undefined) {
                    mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
                }
            }
        }, {
            key: "checkMass",
            value: function checkMass(options, id) {
                if (options.mass !== undefined && options.mass <= 0) {
                    var strId = "";

                    if (id !== undefined) {
                        strId = " in node id: " + id;
                    }

                    console.error("%cNegative or zero mass disallowed" + strId + ", setting mass to 1.", VALIDATOR_PRINT_STYLE$1);
                    options.mass = 1;
                }
            }
        }]);

        return Node;
    }();

    function _createForOfIteratorHelper$6(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$6(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = slice$1(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

    function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Handler for Nodes
     */

    var NodesHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Images} images
         * @param {Array.<Group>} groups
         * @param {LayoutEngine} layoutEngine
         */
        function NodesHandler(body, images, groups, layoutEngine) {
            var _context,
                _this = this;

            _classCallCheck(this, NodesHandler);

            this.body = body;
            this.images = images;
            this.groups = groups;
            this.layoutEngine = layoutEngine; // create the node API in the body container

            this.body.functions.createNode = bind(_context = this.create).call(_context, this);
            this.nodesListeners = {
                add: function add(event, params) {
                    _this.add(params.items);
                },
                update: function update(event, params) {
                    _this.update(params.items, params.data, params.oldData);
                },
                remove: function remove(event, params) {
                    _this.remove(params.items);
                }
            };
            this.defaultOptions = {
                borderWidth: 1,
                borderWidthSelected: undefined,
                brokenImage: undefined,
                color: {
                    border: "#2B7CE9",
                    background: "#97C2FC",
                    highlight: {
                        border: "#2B7CE9",
                        background: "#D2E5FF"
                    },
                    hover: {
                        border: "#2B7CE9",
                        background: "#D2E5FF"
                    }
                },
                opacity: undefined,
                // number between 0 and 1
                fixed: {
                    x: false,
                    y: false
                },
                font: {
                    color: "#343434",
                    size: 14,
                    // px
                    face: "arial",
                    background: "none",
                    strokeWidth: 0,
                    // px
                    strokeColor: "#ffffff",
                    align: "center",
                    vadjust: 0,
                    multi: false,
                    bold: {
                        mod: "bold"
                    },
                    boldital: {
                        mod: "bold italic"
                    },
                    ital: {
                        mod: "italic"
                    },
                    mono: {
                        mod: "",
                        size: 15,
                        // px
                        face: "monospace",
                        vadjust: 2
                    }
                },
                group: undefined,
                hidden: false,
                icon: {
                    face: "FontAwesome",
                    //'FontAwesome',
                    code: undefined,
                    //'\uf007',
                    size: 50,
                    //50,
                    color: "#2B7CE9" //'#aa00ff'

                },
                image: undefined,
                // --> URL
                imagePadding: {
                    // only for image shape
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
                label: undefined,
                labelHighlightBold: true,
                level: undefined,
                margin: {
                    top: 5,
                    right: 5,
                    bottom: 5,
                    left: 5
                },
                mass: 1,
                physics: true,
                scaling: {
                    min: 10,
                    max: 30,
                    label: {
                        enabled: false,
                        min: 14,
                        max: 30,
                        maxVisible: 30,
                        drawThreshold: 5
                    },
                    customScalingFunction: function customScalingFunction(min, max, total, value) {
                        if (max === min) {
                            return 0.5;
                        } else {
                            var scale = 1 / (max - min);
                            return Math.max(0, (value - min) * scale);
                        }
                    }
                },
                shadow: {
                    enabled: false,
                    color: "rgba(0,0,0,0.5)",
                    size: 10,
                    x: 5,
                    y: 5
                },
                shape: "ellipse",
                shapeProperties: {
                    borderDashes: false,
                    // only for borders
                    borderRadius: 6,
                    // only for box shape
                    interpolation: true,
                    // only for image and circularImage shapes
                    useImageSize: false,
                    // only for image and circularImage shapes
                    useBorderWithImage: false,
                    // only for image shape
                    coordinateOrigin: "center" // only for image and circularImage shapes

                },
                size: 25,
                title: undefined,
                value: undefined,
                x: undefined,
                y: undefined
            }; // Protect from idiocy

            if (this.defaultOptions.mass <= 0) {
                throw "Internal error: mass in defaultOptions of NodesHandler may not be zero or negative";
            }

            this.options = bridgeObject(this.defaultOptions);
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(NodesHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _context2,
                    _context3,
                    _this2 = this;

                // refresh the nodes. Used when reverting from hierarchical layout
                this.body.emitter.on("refreshNodes", bind(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", bind(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function () {
                    forEach$1(_this2.nodesListeners, function (callback, event) {
                        if (_this2.body.data.nodes) _this2.body.data.nodes.off(event, callback);
                    });
                    delete _this2.body.functions.createNode;
                    delete _this2.nodesListeners.add;
                    delete _this2.nodesListeners.update;
                    delete _this2.nodesListeners.remove;
                    delete _this2.nodesListeners;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    Node.parseOptions(this.options, options); // Need to set opacity here because Node.parseOptions is also used for groups,
                    // if you set opacity in Node.parseOptions it overwrites group opacity.

                    if (options.opacity !== undefined) {
                        if (isNan(options.opacity) || !_isFinite(options.opacity) || options.opacity < 0 || options.opacity > 1) {
                            console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + options.opacity);
                        } else {
                            this.options.opacity = options.opacity;
                        }
                    } // update the shape in all nodes


                    if (options.shape !== undefined) {
                        for (var nodeId in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                                this.body.nodes[nodeId].updateShape();
                            }
                        }
                    } // Update the labels of nodes if any relevant options changed.


                    if (typeof options.font !== "undefined" || typeof options.widthConstraint !== "undefined" || typeof options.heightConstraint !== "undefined") {
                        for (var _i = 0, _Object$keys = keys$3(this.body.nodes); _i < _Object$keys.length; _i++) {
                            var _nodeId = _Object$keys[_i];

                            this.body.nodes[_nodeId].updateLabelModule();

                            this.body.nodes[_nodeId].needsRefresh();
                        }
                    } // update the shape size in all nodes


                    if (options.size !== undefined) {
                        for (var _nodeId2 in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) {
                                this.body.nodes[_nodeId2].needsRefresh();
                            }
                        }
                    } // update the state of the variables if needed


                    if (options.hidden !== undefined || options.physics !== undefined) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             * Set a data set with nodes for the network
             *
             * @param {Array | DataSet | DataView} nodes         The data containing the nodes.
             * @param {boolean} [doNotEmit=false] - Suppress data changed event.
             * @private
             */

        }, {
            key: "setData",
            value: function setData(nodes) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldNodesData = this.body.data.nodes;

                if (isDataViewLike("id", nodes)) {
                    this.body.data.nodes = nodes;
                } else if (isArray(nodes)) {
                    this.body.data.nodes = new DataSet();
                    this.body.data.nodes.add(nodes);
                } else if (!nodes) {
                    this.body.data.nodes = new DataSet();
                } else {
                    throw new TypeError("Array or DataSet expected");
                }

                if (oldNodesData) {
                    // unsubscribe from old dataset
                    forEach$1(this.nodesListeners, function (callback, event) {
                        oldNodesData.off(event, callback);
                    });
                } // remove drawn nodes


                this.body.nodes = {};

                if (this.body.data.nodes) {
                    // subscribe to new dataset
                    var me = this;
                    forEach$1(this.nodesListeners, function (callback, event) {
                        me.body.data.nodes.on(event, callback);
                    }); // draw all new nodes

                    var ids = this.body.data.nodes.getIds();
                    this.add(ids, true);
                }

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Add nodes
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [doNotEmit=false]
             * @private
             */

        }, {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var id;
                var newNodes = [];

                for (var i = 0; i < ids.length; i++) {
                    id = ids[i];
                    var properties = this.body.data.nodes.get(id);
                    var node = this.create(properties);
                    newNodes.push(node);
                    this.body.nodes[id] = node; // note: this may replace an existing node
                }

                this.layoutEngine.positionInitially(newNodes);

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Update existing nodes, or create them when not yet existing
             *
             * @param {number[] | string[]} ids id's of changed nodes
             * @param {Array} changedData array with changed data
             * @param {Array|undefined} oldData optional; array with previous data
             * @private
             */

        }, {
            key: "update",
            value: function update(ids, changedData, oldData) {
                var nodes = this.body.nodes;
                var dataChanged = false;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var node = nodes[id];
                    var data = changedData[i];

                    if (node !== undefined) {
                        // update node
                        if (node.setOptions(data)) {
                            dataChanged = true;
                        }
                    } else {
                        dataChanged = true; // create node

                        node = this.create(data);
                        nodes[id] = node;
                    }
                }

                if (!dataChanged && oldData !== undefined) {
                    // Check for any changes which should trigger a layout recalculation
                    // For now, this is just 'level' for hierarchical layout
                    // Assumption: old and new data arranged in same order; at time of writing, this holds.
                    dataChanged = some(changedData).call(changedData, function (newValue, index) {
                        var oldValue = oldData[index];
                        return oldValue && oldValue.level !== newValue.level;
                    });
                }

                if (dataChanged === true) {
                    this.body.emitter.emit("_dataChanged");
                } else {
                    this.body.emitter.emit("_dataUpdated");
                }
            }
            /**
             * Remove existing nodes. If nodes do not exist, the method will just ignore it.
             *
             * @param {number[] | string[]} ids
             * @private
             */

        }, {
            key: "remove",
            value: function remove(ids) {
                var nodes = this.body.nodes;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    delete nodes[id];
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * create a node
             *
             * @param {object} properties
             * @param {class} [constructorClass=Node.default]
             * @returns {*}
             */

        }, {
            key: "create",
            value: function create(properties) {
                var constructorClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Node;
                return new constructorClass(properties, this.body, this.images, this.groups, this.options, this.defaultOptions);
            }
            /**
             *
             * @param {boolean} [clearPositions=false]
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;

                var clearPositions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                forEach$1(this.body.nodes, function (node, nodeId) {
                    var data = _this3.body.data.nodes.get(nodeId);

                    if (data !== undefined) {
                        if (clearPositions === true) {
                            node.setOptions({
                                x: null,
                                y: null
                            });
                        }

                        node.setOptions({
                            fixed: false
                        });
                        node.setOptions(data);
                    }
                });
            }
            /**
             * Returns the positions of the nodes.
             *
             * @param {Array.<Node.id> | string} [ids]  --> optional, can be array of nodeIds, can be string
             * @returns {{}}
             */

        }, {
            key: "getPositions",
            value: function getPositions(ids) {
                var dataArray = {};

                if (ids !== undefined) {
                    if (isArray(ids) === true) {
                        for (var i = 0; i < ids.length; i++) {
                            if (this.body.nodes[ids[i]] !== undefined) {
                                var node = this.body.nodes[ids[i]];
                                dataArray[ids[i]] = {
                                    x: Math.round(node.x),
                                    y: Math.round(node.y)
                                };
                            }
                        }
                    } else {
                        if (this.body.nodes[ids] !== undefined) {
                            var _node = this.body.nodes[ids];
                            dataArray[ids] = {
                                x: Math.round(_node.x),
                                y: Math.round(_node.y)
                            };
                        }
                    }
                } else {
                    for (var _i2 = 0; _i2 < this.body.nodeIndices.length; _i2++) {
                        var _node2 = this.body.nodes[this.body.nodeIndices[_i2]];
                        dataArray[this.body.nodeIndices[_i2]] = {
                            x: Math.round(_node2.x),
                            y: Math.round(_node2.y)
                        };
                    }
                }

                return dataArray;
            }
            /**
             * Retrieves the x y position of a specific id.
             *
             * @param {string} id The id to retrieve.
             *
             * @throws {TypeError} If no id is included.
             * @throws {ReferenceError} If an invalid id is provided.
             *
             * @returns {{ x: number, y: number }} Returns X, Y canvas position of the node with given id.
             */

        }, {
            key: "getPosition",
            value: function getPosition(id) {
                if (id == undefined) {
                    throw new TypeError("No id was specified for getPosition method.");
                } else if (this.body.nodes[id] == undefined) {
                    throw new ReferenceError("NodeId provided for getPosition does not exist. Provided: ".concat(id));
                } else {
                    return {
                        x: Math.round(this.body.nodes[id].x),
                        y: Math.round(this.body.nodes[id].y)
                    };
                }
            }
            /**
             * Load the XY positions of the nodes into the dataset.
             */

        }, {
            key: "storePositions",
            value: function storePositions() {
                // todo: add support for clusters and hierarchical.
                var dataArray = [];
                var dataset = this.body.data.nodes.getDataSet();

                var _iterator = _createForOfIteratorHelper$6(dataset.get()),
                    _step;

                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var dsNode = _step.value;
                        var id = dsNode.id;
                        var bodyNode = this.body.nodes[id];
                        var x = Math.round(bodyNode.x);
                        var y = Math.round(bodyNode.y);

                        if (dsNode.x !== x || dsNode.y !== y) {
                            dataArray.push({
                                id: id,
                                x: x,
                                y: y
                            });
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }

                dataset.update(dataArray);
            }
            /**
             * get the bounding box of a node.
             *
             * @param {Node.id} nodeId
             * @returns {j|*}
             */

        }, {
            key: "getBoundingBox",
            value: function getBoundingBox(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) {
                    return this.body.nodes[nodeId].shape.boundingBox;
                }
            }
            /**
             * Get the Ids of nodes connected to this node.
             *
             * @param {Node.id} nodeId
             * @param {'to'|'from'|undefined} direction values 'from' and 'to' select respectively parent and child nodes only.
             *                                          Any other value returns both parent and child nodes.
             * @returns {Array}
             */

        }, {
            key: "getConnectedNodes",
            value: function getConnectedNodes(nodeId, direction) {
                var nodeList = [];

                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];
                    var nodeObj = {}; // used to quickly check if node already exists

                    for (var i = 0; i < node.edges.length; i++) {
                        var edge = node.edges[i];

                        if (direction !== "to" && edge.toId == node.id) {
                            // these are double equals since ids can be numeric or string
                            if (nodeObj[edge.fromId] === undefined) {
                                nodeList.push(edge.fromId);
                                nodeObj[edge.fromId] = true;
                            }
                        } else if (direction !== "from" && edge.fromId == node.id) {
                            // these are double equals since ids can be numeric or string
                            if (nodeObj[edge.toId] === undefined) {
                                nodeList.push(edge.toId);
                                nodeObj[edge.toId] = true;
                            }
                        }
                    }
                }

                return nodeList;
            }
            /**
             * Get the ids of the edges connected to this node.
             *
             * @param {Node.id} nodeId
             * @returns {*}
             */

        }, {
            key: "getConnectedEdges",
            value: function getConnectedEdges(nodeId) {
                var edgeList = [];

                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];

                    for (var i = 0; i < node.edges.length; i++) {
                        edgeList.push(node.edges[i].id);
                    }
                } else {
                    console.error("NodeId provided for getConnectedEdges does not exist. Provided: ", nodeId);
                }

                return edgeList;
            }
            /**
             * Move a node.
             *
             * @param {Node.id} nodeId
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "moveNode",
            value: function moveNode(nodeId, x, y) {
                var _this4 = this;

                if (this.body.nodes[nodeId] !== undefined) {
                    this.body.nodes[nodeId].x = Number(x);
                    this.body.nodes[nodeId].y = Number(y);

                    setTimeout$1(function () {
                        _this4.body.emitter.emit("startSimulation");
                    }, 0);
                } else {
                    console.error("Node id supplied to moveNode does not exist. Provided: ", nodeId);
                }
            }
        }]);

        return NodesHandler;
    }();

    // https://tc39.es/ecma262/#sec-reflect.get

    function get$3(target, propertyKey
                   /* , receiver */
    ) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var descriptor, prototype;
        if (anObject(target) === receiver) return target[propertyKey];
        if (descriptor = objectGetOwnPropertyDescriptor.f(target, propertyKey)) return has$1(descriptor, 'value') ? descriptor.value : descriptor.get === undefined ? undefined : descriptor.get.call(receiver);
        if (isObject$1(prototype = objectGetPrototypeOf(target))) return get$3(prototype, propertyKey, receiver);
    }

    _export({
        target: 'Reflect',
        stat: true
    }, {
        get: get$3
    });

    var get$2 = path.Reflect.get;

    var get$1 = get$2;

    var get = get$1;

    var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor_1;

    var getOwnPropertyDescriptor = getOwnPropertyDescriptor$1;

    function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = _getPrototypeOf(object);
            if (object === null) break;
        }

        return object;
    }

    function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && get) {
            _get = get;
        } else {
            _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;

                var desc = getOwnPropertyDescriptor(base, property);

                if (desc.get) {
                    return desc.get.call(receiver);
                }

                return desc.value;
            };
        }

        return _get(target, property, receiver || target);
    }

    var $hypot = Math.hypot;
    var abs = Math.abs;
    var sqrt = Math.sqrt; // Chrome 77 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=9546

    var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity; // `Math.hypot` method
    // https://tc39.es/ecma262/#sec-math.hypot

    _export({
        target: 'Math',
        stat: true,
        forced: BUGGY
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        hypot: function hypot(value1, value2) {
            var sum = 0;
            var i = 0;
            var aLen = arguments.length;
            var larg = 0;
            var arg, div;

            while (i < aLen) {
                arg = abs(arguments[i++]);

                if (larg < arg) {
                    div = larg / arg;
                    sum = sum * div * div + 1;
                    larg = arg;
                } else if (arg > 0) {
                    div = arg / larg;
                    sum += div * div;
                } else sum += arg;
            }

            return larg === Infinity ? Infinity : larg * sqrt(sum);
        }
    });

    var hypot$2 = path.Math.hypot;

    var hypot$1 = hypot$2;

    var hypot = hypot$1;

    function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Common methods for endpoints
     *
     * @class
     */

    var EndPoint = /*#__PURE__*/function () {
        function EndPoint() {
            _classCallCheck(this, EndPoint);
        }

        _createClass(EndPoint, null, [{
            key: "transform",
            value:
                /**
                 * Apply transformation on points for display.
                 *
                 * The following is done:
                 * - rotate by the specified angle
                 * - multiply the (normalized) coordinates by the passed length
                 * - offset by the target coordinates
                 *
                 * @param points - The point(s) to be transformed.
                 * @param arrowData - The data determining the result of the transformation.
                 */
                function transform(points, arrowData) {
                    if (!isArray(points)) {
                        points = [points];
                    }

                    var x = arrowData.point.x;
                    var y = arrowData.point.y;
                    var angle = arrowData.angle;
                    var length = arrowData.length;

                    for (var i = 0; i < points.length; ++i) {
                        var p = points[i];
                        var xt = p.x * Math.cos(angle) - p.y * Math.sin(angle);
                        var yt = p.x * Math.sin(angle) + p.y * Math.cos(angle);
                        p.x = x + length * xt;
                        p.y = y + length * yt;
                    }
                }
            /**
             * Draw a closed path using the given real coordinates.
             *
             * @param ctx - The path will be rendered into this context.
             * @param points - The points of the path.
             */

        }, {
            key: "drawPath",
            value: function drawPath(ctx, points) {
                ctx.beginPath();
                ctx.moveTo(points[0].x, points[0].y);

                for (var i = 1; i < points.length; ++i) {
                    ctx.lineTo(points[i].x, points[i].y);
                }

                ctx.closePath();
            }
        }]);

        return EndPoint;
    }();
    /**
     * Drawing methods for the arrow endpoint.
     */


    var Image$1 = /*#__PURE__*/function (_EndPoint) {
        _inherits(Image, _EndPoint);

        var _super = _createSuper$a(Image);

        function Image() {
            _classCallCheck(this, Image);

            return _super.apply(this, arguments);
        }

        _createClass(Image, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns False as there is no way to fill an image.
                 */
                function draw(ctx, arrowData) {
                    if (arrowData.image) {
                        ctx.save();
                        ctx.translate(arrowData.point.x, arrowData.point.y);
                        ctx.rotate(Math.PI / 2 + arrowData.angle);
                        var width = arrowData.imageWidth != null ? arrowData.imageWidth : arrowData.image.width;
                        var height = arrowData.imageHeight != null ? arrowData.imageHeight : arrowData.image.height;
                        arrowData.image.drawImageAtPosition(ctx, 1, // scale
                            -width / 2, // x
                            0, // y
                            width, height);
                        ctx.restore();
                    }

                    return false;
                }
        }]);

        return Image;
    }(EndPoint);
    /**
     * Drawing methods for the arrow endpoint.
     */


    var Arrow = /*#__PURE__*/function (_EndPoint2) {
        _inherits(Arrow, _EndPoint2);

        var _super2 = _createSuper$a(Arrow);

        function Arrow() {
            _classCallCheck(this, Arrow);

            return _super2.apply(this, arguments);
        }

        _createClass(Arrow, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0,
                        y: 0
                    }, {
                        x: -1,
                        y: 0.3
                    }, {
                        x: -0.9,
                        y: 0
                    }, {
                        x: -1,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Arrow;
    }(EndPoint);
    /**
     * Drawing methods for the crow endpoint.
     */


    var Crow = /*#__PURE__*/function () {
        function Crow() {
            _classCallCheck(this, Crow);
        }

        _createClass(Crow, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: -1,
                        y: 0
                    }, {
                        x: 0,
                        y: 0.3
                    }, {
                        x: -0.4,
                        y: 0
                    }, {
                        x: 0,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Crow;
    }();
    /**
     * Drawing methods for the curve endpoint.
     */


    var Curve = /*#__PURE__*/function () {
        function Curve() {
            _classCallCheck(this, Curve);
        }

        _createClass(Curve, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var point = {
                        x: -0.4,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData); // Update endpoint style for drawing transparent arc.

                    ctx.strokeStyle = ctx.fillStyle;
                    ctx.fillStyle = "rgba(0, 0, 0, 0)"; // Define curve endpoint as semicircle.

                    var pi = Math.PI;
                    var startAngle = arrowData.angle - pi / 2;
                    var endAngle = arrowData.angle + pi / 2;
                    ctx.beginPath();
                    ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                    ctx.stroke();
                    return true;
                }
        }]);

        return Curve;
    }();
    /**
     * Drawing methods for the inverted curve endpoint.
     */


    var InvertedCurve = /*#__PURE__*/function () {
        function InvertedCurve() {
            _classCallCheck(this, InvertedCurve);
        }

        _createClass(InvertedCurve, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var point = {
                        x: -0.3,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData); // Update endpoint style for drawing transparent arc.

                    ctx.strokeStyle = ctx.fillStyle;
                    ctx.fillStyle = "rgba(0, 0, 0, 0)"; // Define inverted curve endpoint as semicircle.

                    var pi = Math.PI;
                    var startAngle = arrowData.angle + pi / 2;
                    var endAngle = arrowData.angle + 3 * pi / 2;
                    ctx.beginPath();
                    ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                    ctx.stroke();
                    return true;
                }
        }]);

        return InvertedCurve;
    }();
    /**
     * Drawing methods for the trinagle endpoint.
     */


    var Triangle = /*#__PURE__*/function () {
        function Triangle() {
            _classCallCheck(this, Triangle);
        }

        _createClass(Triangle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0.02,
                        y: 0
                    }, {
                        x: -1,
                        y: 0.3
                    }, {
                        x: -1,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Triangle;
    }();
    /**
     * Drawing methods for the inverted trinagle endpoint.
     */


    var InvertedTriangle = /*#__PURE__*/function () {
        function InvertedTriangle() {
            _classCallCheck(this, InvertedTriangle);
        }

        _createClass(InvertedTriangle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0,
                        y: 0.3
                    }, {
                        x: 0,
                        y: -0.3
                    }, {
                        x: -1,
                        y: 0
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return InvertedTriangle;
    }();
    /**
     * Drawing methods for the circle endpoint.
     */


    var Circle = /*#__PURE__*/function () {
        function Circle() {
            _classCallCheck(this, Circle);
        }

        _createClass(Circle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var point = {
                        x: -0.4,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData);
                    drawCircle(ctx, point.x, point.y, arrowData.length * 0.4);
                    return true;
                }
        }]);

        return Circle;
    }();
    /**
     * Drawing methods for the bar endpoint.
     */


    var Bar = /*#__PURE__*/function () {
        function Bar() {
            _classCallCheck(this, Bar);
        }

        _createClass(Bar, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    /*
	      var points = [
	        {x:0, y:0.5},
	        {x:0, y:-0.5}
	      ];
	           EndPoint.transform(points, arrowData);
	      ctx.beginPath();
	      ctx.moveTo(points[0].x, points[0].y);
	      ctx.lineTo(points[1].x, points[1].y);
	      ctx.stroke();
	      */
                    var points = [{
                        x: 0,
                        y: 0.5
                    }, {
                        x: 0,
                        y: -0.5
                    }, {
                        x: -0.15,
                        y: -0.5
                    }, {
                        x: -0.15,
                        y: 0.5
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Bar;
    }();
    /**
     * Drawing methods for the box endpoint.
     */


    var Box = /*#__PURE__*/function () {
        function Box() {
            _classCallCheck(this, Box);
        }

        _createClass(Box, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var points = [{
                        x: 0,
                        y: 0.3
                    }, {
                        x: 0,
                        y: -0.3
                    }, {
                        x: -0.6,
                        y: -0.3
                    }, {
                        x: -0.6,
                        y: 0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Box;
    }();
    /**
     * Drawing methods for the diamond endpoint.
     */


    var Diamond = /*#__PURE__*/function () {
        function Diamond() {
            _classCallCheck(this, Diamond);
        }

        _createClass(Diamond, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var points = [{
                        x: 0,
                        y: 0
                    }, {
                        x: -0.5,
                        y: -0.3
                    }, {
                        x: -1,
                        y: 0
                    }, {
                        x: -0.5,
                        y: 0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Diamond;
    }();
    /**
     * Drawing methods for the vee endpoint.
     */


    var Vee = /*#__PURE__*/function () {
        function Vee() {
            _classCallCheck(this, Vee);
        }

        _createClass(Vee, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: -1,
                        y: 0.3
                    }, {
                        x: -0.5,
                        y: 0
                    }, {
                        x: -1,
                        y: -0.3
                    }, {
                        x: 0,
                        y: 0
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Vee;
    }();
    /**
     * Drawing methods for the endpoints.
     */


    var EndPoints = /*#__PURE__*/function () {
        function EndPoints() {
            _classCallCheck(this, EndPoints);
        }

        _createClass(EndPoints, null, [{
            key: "draw",
            value:
                /**
                 * Draw an endpoint.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True if ctx.fill() can be used to fill the arrow, false otherwise.
                 */
                function draw(ctx, arrowData) {
                    var type;

                    if (arrowData.type) {
                        type = arrowData.type.toLowerCase();
                    }

                    switch (type) {
                        case "image":
                            return Image$1.draw(ctx, arrowData);

                        case "circle":
                            return Circle.draw(ctx, arrowData);

                        case "box":
                            return Box.draw(ctx, arrowData);

                        case "crow":
                            return Crow.draw(ctx, arrowData);

                        case "curve":
                            return Curve.draw(ctx, arrowData);

                        case "diamond":
                            return Diamond.draw(ctx, arrowData);

                        case "inv_curve":
                            return InvertedCurve.draw(ctx, arrowData);

                        case "triangle":
                            return Triangle.draw(ctx, arrowData);

                        case "inv_triangle":
                            return InvertedTriangle.draw(ctx, arrowData);

                        case "bar":
                            return Bar.draw(ctx, arrowData);

                        case "vee":
                            return Vee.draw(ctx, arrowData);

                        case "arrow": // fall-through

                        default:
                            return Arrow.draw(ctx, arrowData);
                    }
                }
        }]);

        return EndPoints;
    }();

    function ownKeys$1(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; forEach$2(_context2 = ownKeys$1(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context3; forEach$2(_context3 = ownKeys$1(Object(source))).call(_context3, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }
    /**
     * The Base Class for all edges.
     */

    var EdgeBase = /*#__PURE__*/function () {
        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param _body - The body of the network.
         * @param _labelModule - Label module.
         */
        function EdgeBase(options, _body, _labelModule) {
            _classCallCheck(this, EdgeBase);

            this._body = _body;
            this._labelModule = _labelModule;
            this.color = {};
            this.colorDirty = true;
            this.hoverWidth = 1.5;
            this.selectionWidth = 2;
            this.setOptions(options);
            this.fromPoint = this.from;
            this.toPoint = this.to;
        }
        /** @inheritDoc */


        _createClass(EdgeBase, [{
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
            }
            /** @inheritDoc */

        }, {
            key: "cleanup",
            value: function cleanup() {
                return false;
            }
            /**
             * Set new edge options.
             *
             * @param options - The new edge options object.
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
                this.id = this.options.id;
            }
            /** @inheritDoc */

        }, {
            key: "drawLine",
            value: function drawLine(ctx, values, _selected, _hover) {
                var viaNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.getViaNode();
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.lineWidth = values.width;

                if (values.dashes !== false) {
                    this._drawDashedLine(ctx, values, viaNode);
                } else {
                    this._drawLine(ctx, values, viaNode);
                }
            }
            /**
             * Draw a line with given style between two nodes through supplied node(s).
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param viaNode - Additional control point(s) for the edge.
             * @param fromPoint - TODO: Seems ignored, remove?
             * @param toPoint - TODO: Seems ignored, remove?
             */

        }, {
            key: "_drawLine",
            value: function _drawLine(ctx, values, viaNode, fromPoint, toPoint) {
                if (this.from != this.to) {
                    // draw line
                    this._line(ctx, values, viaNode, fromPoint, toPoint);
                } else {
                    var _this$_getCircleData = this._getCircleData(ctx),
                        _this$_getCircleData2 = _slicedToArray(_this$_getCircleData, 3),
                        x = _this$_getCircleData2[0],
                        y = _this$_getCircleData2[1],
                        radius = _this$_getCircleData2[2];

                    this._circle(ctx, values, x, y, radius);
                }
            }
            /**
             * Draw a dashed line with given style between two nodes through supplied node(s).
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param viaNode - Additional control point(s) for the edge.
             * @param _fromPoint - Ignored (TODO: remove in the future).
             * @param _toPoint - Ignored (TODO: remove in the future).
             */

        }, {
            key: "_drawDashedLine",
            value: function _drawDashedLine(ctx, values, viaNode, _fromPoint, _toPoint) {
                ctx.lineCap = "round";
                var pattern = isArray(values.dashes) ? values.dashes : [5, 5]; // only firefox and chrome support this method, else we use the legacy one.

                if (ctx.setLineDash !== undefined) {
                    ctx.save(); // set dash settings for chrome or firefox

                    ctx.setLineDash(pattern);
                    ctx.lineDashOffset = 0; // draw the line

                    if (this.from != this.to) {
                        // draw line
                        this._line(ctx, values, viaNode);
                    } else {
                        var _this$_getCircleData3 = this._getCircleData(ctx),
                            _this$_getCircleData4 = _slicedToArray(_this$_getCircleData3, 3),
                            x = _this$_getCircleData4[0],
                            y = _this$_getCircleData4[1],
                            radius = _this$_getCircleData4[2];

                        this._circle(ctx, values, x, y, radius);
                    } // restore the dash settings.


                    ctx.setLineDash([0]);
                    ctx.lineDashOffset = 0;
                    ctx.restore();
                } else {
                    // unsupporting smooth lines
                    if (this.from != this.to) {
                        // draw line
                        drawDashedLine(ctx, this.from.x, this.from.y, this.to.x, this.to.y, pattern);
                    } else {
                        var _this$_getCircleData5 = this._getCircleData(ctx),
                            _this$_getCircleData6 = _slicedToArray(_this$_getCircleData5, 3),
                            _x = _this$_getCircleData6[0],
                            _y = _this$_getCircleData6[1],
                            _radius = _this$_getCircleData6[2];

                        this._circle(ctx, values, _x, _y, _radius);
                    } // draw shadow if enabled


                    this.enableShadow(ctx, values);
                    ctx.stroke(); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                }
            }
            /**
             * Find the intersection between the border of the node and the edge.
             *
             * @param node - The node (either from or to node of the edge).
             * @param ctx - The context that will be used for rendering.
             * @param options - Additional options.
             *
             * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
             */

        }, {
            key: "findBorderPosition",
            value: function findBorderPosition(node, ctx, options) {
                if (this.from != this.to) {
                    return this._findBorderPosition(node, ctx, options);
                } else {
                    return this._findBorderPositionCircle(node, ctx, options);
                }
            }
            /** @inheritDoc */

        }, {
            key: "findBorderPositions",
            value: function findBorderPositions(ctx) {
                if (this.from != this.to) {
                    return {
                        from: this._findBorderPosition(this.from, ctx),
                        to: this._findBorderPosition(this.to, ctx)
                    };
                } else {
                    var _context;

                    var _this$_getCircleData$ = slice$1(_context = this._getCircleData(ctx)).call(_context, 0, 2),
                        _this$_getCircleData$2 = _slicedToArray(_this$_getCircleData$, 2),
                        x = _this$_getCircleData$2[0],
                        y = _this$_getCircleData$2[1];

                    return {
                        from: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.25,
                            high: 0.6,
                            direction: -1
                        }),
                        to: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.6,
                            high: 0.8,
                            direction: 1
                        })
                    };
                }
            }
            /**
             * Compute the center point and radius of an edge connected to the same node at both ends.
             *
             * @param ctx - The context that will be used for rendering.
             *
             * @returns `[x, y, radius]`
             */

        }, {
            key: "_getCircleData",
            value: function _getCircleData(ctx) {
                var radius = this.options.selfReference.size;

                if (ctx !== undefined) {
                    if (this.from.shape.width === undefined) {
                        this.from.shape.resize(ctx);
                    }
                } // get circle coordinates


                var coordinates = getSelfRefCoordinates(ctx, this.options.selfReference.angle, radius, this.from);
                return [coordinates.x, coordinates.y, radius];
            }
            /**
             * Get a point on a circle.
             *
             * @param x - Center of the circle on the x axis.
             * @param y - Center of the circle on the y axis.
             * @param radius - Radius of the circle.
             * @param position - Value between 0 (line start) and 1 (line end).
             *
             * @returns Cartesian coordinates of requested point on the circle.
             */

        }, {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, position) {
                var angle = position * 2 * Math.PI;
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
            /**
             * Find the intersection between the border of the node and the edge.
             *
             * @remarks
             * This function uses binary search to look for the point where the circle crosses the border of the node.
             *
             * @param nearNode - The node (either from or to node of the edge).
             * @param ctx - The context that will be used for rendering.
             * @param options - Additional options.
             *
             * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
             */

        }, {
            key: "_findBorderPositionCircle",
            value: function _findBorderPositionCircle(nearNode, ctx, options) {
                var x = options.x;
                var y = options.y;
                var low = options.low;
                var high = options.high;
                var direction = options.direction;
                var maxIterations = 10;
                var radius = this.options.selfReference.size;
                var threshold = 0.05;
                var pos;
                var middle = (low + high) * 0.5;
                var endPointOffset = 0;

                if (this.options.arrowStrikethrough === true) {
                    if (direction === -1) {
                        endPointOffset = this.options.endPointOffset.from;
                    } else if (direction === 1) {
                        endPointOffset = this.options.endPointOffset.to;
                    }
                }

                var iteration = 0;

                do {
                    middle = (low + high) * 0.5;
                    pos = this._pointOnCircle(x, y, radius, middle);
                    var angle = Math.atan2(nearNode.y - pos.y, nearNode.x - pos.x);
                    var distanceToBorder = nearNode.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - nearNode.x, 2) + Math.pow(pos.y - nearNode.y, 2));
                    var difference = distanceToBorder - distanceToPoint;

                    if (Math.abs(difference) < threshold) {
                        break; // found
                    } else if (difference > 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (direction > 0) {
                            low = middle;
                        } else {
                            high = middle;
                        }
                    } else {
                        if (direction > 0) {
                            high = middle;
                        } else {
                            low = middle;
                        }
                    }

                    ++iteration;
                } while (low <= high && iteration < maxIterations);

                return _objectSpread$1(_objectSpread$1({}, pos), {}, {
                    t: middle
                });
            }
            /**
             * Get the line width of the edge. Depends on width and whether one of the connected nodes is selected.
             *
             * @param selected - Determines wheter the line is selected.
             * @param hover - Determines wheter the line is being hovered, only applies if selected is false.
             *
             * @returns The width of the line.
             */

        }, {
            key: "getLineWidth",
            value: function getLineWidth(selected, hover) {
                if (selected === true) {
                    return Math.max(this.selectionWidth, 0.3 / this._body.view.scale);
                } else if (hover === true) {
                    return Math.max(this.hoverWidth, 0.3 / this._body.view.scale);
                } else {
                    return Math.max(this.options.width, 0.3 / this._body.view.scale);
                }
            }
            /**
             * Compute the color or gradient for given edge.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param _selected - Ignored (TODO: remove in the future).
             * @param _hover - Ignored (TODO: remove in the future).
             *
             * @returns Color string if single color is inherited or gradient if two.
             */

        }, {
            key: "getColor",
            value: function getColor(ctx, values) {
                if (values.inheritsColor !== false) {
                    // when this is a loop edge, just use the 'from' method
                    if (values.inheritsColor === "both" && this.from.id !== this.to.id) {
                        var grd = ctx.createLinearGradient(this.from.x, this.from.y, this.to.x, this.to.y);
                        var fromColor = this.from.options.color.highlight.border;
                        var toColor = this.to.options.color.highlight.border;

                        if (this.from.selected === false && this.to.selected === false) {
                            fromColor = overrideOpacity(this.from.options.color.border, values.opacity);
                            toColor = overrideOpacity(this.to.options.color.border, values.opacity);
                        } else if (this.from.selected === true && this.to.selected === false) {
                            toColor = this.to.options.color.border;
                        } else if (this.from.selected === false && this.to.selected === true) {
                            fromColor = this.from.options.color.border;
                        }

                        grd.addColorStop(0, fromColor);
                        grd.addColorStop(1, toColor); // -------------------- this returns -------------------- //

                        return grd;
                    }

                    if (values.inheritsColor === "to") {
                        return overrideOpacity(this.to.options.color.border, values.opacity);
                    } else {
                        // "from"
                        return overrideOpacity(this.from.options.color.border, values.opacity);
                    }
                } else {
                    return overrideOpacity(values.color, values.opacity);
                }
            }
            /**
             * Draw a line from a node to itself, a circle.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param x - Center of the circle on the x axis.
             * @param y - Center of the circle on the y axis.
             * @param radius - Radius of the circle.
             */

        }, {
            key: "_circle",
            value: function _circle(ctx, values, x, y, radius) {
                // draw shadow if enabled
                this.enableShadow(ctx, values); //full circle

                var angleFrom = 0;
                var angleTo = Math.PI * 2;

                if (!this.options.selfReference.renderBehindTheNode) {
                    //render only parts which are not overlaping with parent node
                    //need to find x,y of from point and x,y to point
                    //calculating radians
                    var low = this.options.selfReference.angle;
                    var high = this.options.selfReference.angle + Math.PI;

                    var pointTFrom = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: -1
                    });

                    var pointTTo = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: 1
                    });

                    angleFrom = Math.atan2(pointTFrom.y - y, pointTFrom.x - x);
                    angleTo = Math.atan2(pointTTo.y - y, pointTTo.x - x);
                } // draw a circle


                ctx.beginPath();
                ctx.arc(x, y, radius, angleFrom, angleTo, false);
                ctx.stroke(); // disable shadows for other elements.

                this.disableShadow(ctx, values);
            }
            /**
             * @inheritDoc
             *
             * @remarks
             * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
             */

        }, {
            key: "getDistanceToEdge",
            value: function getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                if (this.from != this.to) {
                    return this._getDistanceToEdge(x1, y1, x2, y2, x3, y3);
                } else {
                    var _this$_getCircleData7 = this._getCircleData(undefined),
                        _this$_getCircleData8 = _slicedToArray(_this$_getCircleData7, 3),
                        x = _this$_getCircleData8[0],
                        y = _this$_getCircleData8[1],
                        radius = _this$_getCircleData8[2];

                    var dx = x - x3;
                    var dy = y - y3;
                    return Math.abs(Math.sqrt(dx * dx + dy * dy) - radius);
                }
            }
            /**
             * Calculate the distance between a point (x3, y3) and a line segment from (x1, y1) to (x2, y2).
             *
             * @param x1 - First end of the line segment on the x axis.
             * @param y1 - First end of the line segment on the y axis.
             * @param x2 - Second end of the line segment on the x axis.
             * @param y2 - Second end of the line segment on the y axis.
             * @param x3 - Position of the point on the x axis.
             * @param y3 - Position of the point on the y axis.
             *
             * @returns The distance between the line segment and the point.
             */

        }, {
            key: "_getDistanceToLine",
            value: function _getDistanceToLine(x1, y1, x2, y2, x3, y3) {
                var px = x2 - x1;
                var py = y2 - y1;
                var something = px * px + py * py;
                var u = ((x3 - x1) * px + (y3 - y1) * py) / something;

                if (u > 1) {
                    u = 1;
                } else if (u < 0) {
                    u = 0;
                }

                var x = x1 + u * px;
                var y = y1 + u * py;
                var dx = x - x3;
                var dy = y - y3; //# Note: If the actual distance does not matter,
                //# if you only want to compare what this function
                //# returns to other results of this function, you
                //# can just return the squared distance instead
                //# (i.e. remove the sqrt) to gain a little performance

                return Math.sqrt(dx * dx + dy * dy);
            }
            /** @inheritDoc */

        }, {
            key: "getArrowData",
            value: function getArrowData(ctx, position, viaNode, _selected, _hover, values) {
                // set lets
                var angle;
                var arrowPoint;
                var node1;
                var node2;
                var reversed;
                var scaleFactor;
                var type;
                var lineWidth = values.width;

                if (position === "from") {
                    node1 = this.from;
                    node2 = this.to;
                    reversed = values.fromArrowScale < 0;
                    scaleFactor = Math.abs(values.fromArrowScale);
                    type = values.fromArrowType;
                } else if (position === "to") {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.toArrowScale < 0;
                    scaleFactor = Math.abs(values.toArrowScale);
                    type = values.toArrowType;
                } else {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.middleArrowScale < 0;
                    scaleFactor = Math.abs(values.middleArrowScale);
                    type = values.middleArrowType;
                }

                var length = 15 * scaleFactor + 3 * lineWidth; // 3* lineWidth is the width of the edge.
                // if not connected to itself

                if (node1 != node2) {
                    var approximateEdgeLength = hypot(node1.x - node2.x, node1.y - node2.y);

                    var relativeLength = length / approximateEdgeLength;

                    if (position !== "middle") {
                        // draw arrow head
                        if (this.options.smooth.enabled === true) {
                            var pointT = this._findBorderPosition(node1, ctx, {
                                via: viaNode
                            });

                            var guidePos = this.getPoint(pointT.t + relativeLength * (position === "from" ? 1 : -1), viaNode);
                            angle = Math.atan2(pointT.y - guidePos.y, pointT.x - guidePos.x);
                            arrowPoint = pointT;
                        } else {
                            angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                            arrowPoint = this._findBorderPosition(node1, ctx);
                        }
                    } else {
                        // Negative half length reverses arrow direction.
                        var halfLength = (reversed ? -relativeLength : relativeLength) / 2;
                        var guidePos1 = this.getPoint(0.5 + halfLength, viaNode);
                        var guidePos2 = this.getPoint(0.5 - halfLength, viaNode);
                        angle = Math.atan2(guidePos1.y - guidePos2.y, guidePos1.x - guidePos2.x);
                        arrowPoint = this.getPoint(0.5, viaNode);
                    }
                } else {
                    // draw circle
                    var _this$_getCircleData9 = this._getCircleData(ctx),
                        _this$_getCircleData10 = _slicedToArray(_this$_getCircleData9, 3),
                        x = _this$_getCircleData10[0],
                        y = _this$_getCircleData10[1],
                        radius = _this$_getCircleData10[2];

                    if (position === "from") {
                        var low = this.options.selfReference.angle;
                        var high = this.options.selfReference.angle + Math.PI;

                        var _pointT = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: low,
                            high: high,
                            direction: -1
                        });

                        angle = _pointT.t * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                        arrowPoint = _pointT;
                    } else if (position === "to") {
                        var _low = this.options.selfReference.angle;

                        var _high = this.options.selfReference.angle + Math.PI;

                        var _pointT2 = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: _low,
                            high: _high,
                            direction: 1
                        });

                        angle = _pointT2.t * -2 * Math.PI + 1.5 * Math.PI - 1.1 * Math.PI;
                        arrowPoint = _pointT2;
                    } else {
                        var pos = this.options.selfReference.angle / (2 * Math.PI);
                        arrowPoint = this._pointOnCircle(x, y, radius, pos);
                        angle = pos * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                    }
                }

                var xi = arrowPoint.x - length * 0.9 * Math.cos(angle);
                var yi = arrowPoint.y - length * 0.9 * Math.sin(angle);
                var arrowCore = {
                    x: xi,
                    y: yi
                };
                return {
                    point: arrowPoint,
                    core: arrowCore,
                    angle: angle,
                    length: length,
                    type: type
                };
            }
            /** @inheritDoc */

        }, {
            key: "drawArrowHead",
            value: function drawArrowHead(ctx, values, _selected, _hover, arrowData) {
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.fillStyle = ctx.strokeStyle;
                ctx.lineWidth = values.width;
                var canFill = EndPoints.draw(ctx, arrowData);

                if (canFill) {
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);

                    fill(ctx).call(ctx); // disable shadows for other elements.


                    this.disableShadow(ctx, values);
                }
            }
            /**
             * Set the shadow formatting values in the context if enabled, do nothing otherwise.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the shadow.
             */

        }, {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
            /**
             * Reset the shadow formatting values in the context if enabled, do nothing otherwise.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the shadow.
             */

        }, {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
            /**
             * Render the background according to the formatting values.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the background.
             */

        }, {
            key: "drawBackground",
            value: function drawBackground(ctx, values) {
                if (values.background !== false) {
                    // save original line attrs
                    var origCtxAttr = {
                        strokeStyle: ctx.strokeStyle,
                        lineWidth: ctx.lineWidth,
                        dashes: ctx.dashes
                    };
                    ctx.strokeStyle = values.backgroundColor;
                    ctx.lineWidth = values.backgroundSize;
                    this.setStrokeDashed(ctx, values.backgroundDashes);
                    ctx.stroke(); // restore original line attrs

                    ctx.strokeStyle = origCtxAttr.strokeStyle;
                    ctx.lineWidth = origCtxAttr.lineWidth;
                    ctx.dashes = origCtxAttr.dashes;
                    this.setStrokeDashed(ctx, values.dashes);
                }
            }
            /**
             * Set the line dash pattern if supported. Logs a warning to the console if it isn't supported.
             *
             * @param ctx - The context that will be used for rendering.
             * @param dashes - The pattern [line, space, line…], true for default dashed line or false for normal line.
             */

        }, {
            key: "setStrokeDashed",
            value: function setStrokeDashed(ctx, dashes) {
                if (dashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var pattern = isArray(dashes) ? dashes : [5, 5];
                        ctx.setLineDash(pattern);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
                    }
                } else {
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
                    }
                }
            }
        }]);

        return EdgeBase;
    }();

    function ownKeys(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$2(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context2; forEach$2(_context2 = ownKeys(Object(source))).call(_context2, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * The Base Class for all Bezier edges.
     * Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var BezierEdgeBase = /*#__PURE__*/function (_EdgeBase) {
        _inherits(BezierEdgeBase, _EdgeBase);

        var _super = _createSuper$9(BezierEdgeBase);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeBase(options, body, labelModule) {
            _classCallCheck(this, BezierEdgeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         * Find the intersection between the border of the node and the edge.
         *
         * @remarks
         * This function uses binary search to look for the point where the bezier curve crosses the border of the node.
         *
         * @param nearNode - The node (either from or to node of the edge).
         * @param ctx - The context that will be used for rendering.
         * @param viaNode - Additional node(s) the edge passes through.
         *
         * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
         */


        _createClass(BezierEdgeBase, [{
            key: "_findBorderPositionBezier",
            value: function _findBorderPositionBezier(nearNode, ctx) {
                var viaNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._getViaCoordinates();
                var maxIterations = 10;
                var threshold = 0.2;
                var from = false;
                var high = 1;
                var low = 0;
                var node = this.to;
                var pos;
                var middle;
                var endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.to : 0;

                if (nearNode.id === this.from.id) {
                    node = this.from;
                    from = true;
                    endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.from : 0;
                }

                if (this.options.arrowStrikethrough === false) {
                    endPointOffset = 0;
                }

                var iteration = 0;

                do {
                    middle = (low + high) * 0.5;
                    pos = this.getPoint(middle, viaNode);
                    var angle = Math.atan2(node.y - pos.y, node.x - pos.x);
                    var distanceToBorder = node.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - node.x, 2) + Math.pow(pos.y - node.y, 2));
                    var difference = distanceToBorder - distanceToPoint;

                    if (Math.abs(difference) < threshold) {
                        break; // found
                    } else if (difference < 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (from === false) {
                            low = middle;
                        } else {
                            high = middle;
                        }
                    } else {
                        if (from === false) {
                            high = middle;
                        } else {
                            low = middle;
                        }
                    }

                    ++iteration;
                } while (low <= high && iteration < maxIterations);

                return _objectSpread(_objectSpread({}, pos), {}, {
                    t: middle
                });
            }
            /**
             * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
             *
             * @remarks
             * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
             *
             * @param x1 - First end of the line segment on the x axis.
             * @param y1 - First end of the line segment on the y axis.
             * @param x2 - Second end of the line segment on the x axis.
             * @param y2 - Second end of the line segment on the y axis.
             * @param x3 - Position of the point on the x axis.
             * @param y3 - Position of the point on the y axis.
             * @param via - The control point for the edge.
             *
             * @returns The distance between the line segment and the point.
             */

        }, {
            key: "_getDistanceToBezierEdge",
            value: function _getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var distance;
                var i, t, x, y;
                var lastX = x1;
                var lastY = y1;

                for (i = 1; i < 10; i++) {
                    t = 0.1 * i;
                    x = Math.pow(1 - t, 2) * x1 + 2 * t * (1 - t) * via.x + Math.pow(t, 2) * x2;
                    y = Math.pow(1 - t, 2) * y1 + 2 * t * (1 - t) * via.y + Math.pow(t, 2) * y2;

                    if (i > 0) {
                        distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
                        minDistance = distance < minDistance ? distance : minDistance;
                    }

                    lastX = x;
                    lastY = y;
                }

                return minDistance;
            }
            /**
             * Render a bezier curve between two nodes.
             *
             * @remarks
             * The method accepts zero, one or two control points.
             * Passing zero control points just draws a straight line.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Style options for edge drawing.
             * @param viaNode1 - First control point for curve drawing.
             * @param viaNode2 - Second control point for curve drawing.
             */

        }, {
            key: "_bezierCurve",
            value: function _bezierCurve(ctx, values, viaNode1, viaNode2) {
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);

                if (viaNode1 != null && viaNode1.x != null) {
                    if (viaNode2 != null && viaNode2.x != null) {
                        ctx.bezierCurveTo(viaNode1.x, viaNode1.y, viaNode2.x, viaNode2.y, this.toPoint.x, this.toPoint.y);
                    } else {
                        ctx.quadraticCurveTo(viaNode1.x, viaNode1.y, this.toPoint.x, this.toPoint.y);
                    }
                } else {
                    // fallback to normal straight edge
                    ctx.lineTo(this.toPoint.x, this.toPoint.y);
                } // draw a background


                this.drawBackground(ctx, values); // draw shadow if enabled

                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
        }]);

        return BezierEdgeBase;
    }(EdgeBase);

    function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Dynamic Bezier Edge. Bezier curves are used to model smooth gradual
     * curves in paths between nodes. The Dynamic piece refers to how the curve
     * reacts to physics changes.
     *
     * @augments BezierEdgeBase
     */

    var BezierEdgeDynamic = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(BezierEdgeDynamic, _BezierEdgeBase);

        var _super = _createSuper$8(BezierEdgeDynamic);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeDynamic(options, body, labelModule) {
            var _this;

            _classCallCheck(this, BezierEdgeDynamic);

            //this.via = undefined; // Here for completeness but not allowed to defined before super() is invoked.
            _this = _super.call(this, options, body, labelModule); // --> this calls the setOptions below

            _this.via = _this.via; // constructor → super → super → setOptions → setupSupportNode

            _this._boundFunction = function () {
                _this.positionBezierNode();
            };

            _this._body.emitter.on("_repositionBezierNodes", _this._boundFunction);

            return _this;
        }
        /** @inheritDoc */


        _createClass(BezierEdgeDynamic, [{
            key: "setOptions",
            value: function setOptions(options) {
                _get(_getPrototypeOf(BezierEdgeDynamic.prototype), "setOptions", this).call(this, options); // check if the physics has changed.


                var physicsChange = false;

                if (this.options.physics !== options.physics) {
                    physicsChange = true;
                } // set the options and the to and from nodes


                this.options = options;
                this.id = this.options.id;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to]; // setup the support node and connect

                this.setupSupportNode();
                this.connect(); // when we change the physics state of the edge, we reposition the support node.

                if (physicsChange === true) {
                    this.via.setOptions({
                        physics: this.options.physics
                    });
                    this.positionBezierNode();
                }
            }
            /** @inheritDoc */

        }, {
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];

                if (this.from === undefined || this.to === undefined || this.options.physics === false) {
                    this.via.setOptions({
                        physics: false
                    });
                } else {
                    // fix weird behaviour where a self referencing node has physics enabled
                    if (this.from.id === this.to.id) {
                        this.via.setOptions({
                            physics: false
                        });
                    } else {
                        this.via.setOptions({
                            physics: true
                        });
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "cleanup",
            value: function cleanup() {
                this._body.emitter.off("_repositionBezierNodes", this._boundFunction);

                if (this.via !== undefined) {
                    delete this._body.nodes[this.via.id];
                    this.via = undefined;
                    return true;
                }

                return false;
            }
            /**
             * Create and add a support node if not already present.
             *
             * @remarks
             * Bezier curves require an anchor point to calculate the smooth flow.
             * These points are nodes.
             * These nodes are invisible but are used for the force calculation.
             *
             * The changed data is not called, if needed, it is returned by the main edge constructor.
             */

        }, {
            key: "setupSupportNode",
            value: function setupSupportNode() {
                if (this.via === undefined) {
                    var nodeId = "edgeId:" + this.id;

                    var node = this._body.functions.createNode({
                        id: nodeId,
                        shape: "circle",
                        physics: true,
                        hidden: true
                    });

                    this._body.nodes[nodeId] = node;
                    this.via = node;
                    this.via.parentEdgeId = this.id;
                    this.positionBezierNode();
                }
            }
            /**
             * Position bezier node.
             */

        }, {
            key: "positionBezierNode",
            value: function positionBezierNode() {
                if (this.via !== undefined && this.from !== undefined && this.to !== undefined) {
                    this.via.x = 0.5 * (this.from.x + this.to.x);
                    this.via.y = 0.5 * (this.from.y + this.to.y);
                } else if (this.via !== undefined) {
                    this.via.x = 0;
                    this.via.y = 0;
                }
            }
            /** @inheritDoc */

        }, {
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                return this.via;
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this.via;
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.via;

                if (this.from === this.to) {
                    var _this$_getCircleData = this._getCircleData(),
                        _this$_getCircleData2 = _slicedToArray(_this$_getCircleData, 3),
                        cx = _this$_getCircleData2[0],
                        cy = _this$_getCircleData2[1],
                        cr = _this$_getCircleData2[2];

                    var a = 2 * Math.PI * (1 - position);
                    return {
                        x: cx + cr * Math.sin(a),
                        y: cy + cr - cr * (1 - Math.cos(a))
                    };
                } else {
                    return {
                        x: Math.pow(1 - position, 2) * this.fromPoint.x + 2 * position * (1 - position) * viaNode.x + Math.pow(position, 2) * this.toPoint.x,
                        y: Math.pow(1 - position, 2) * this.fromPoint.y + 2 * position * (1 - position) * viaNode.y + Math.pow(position, 2) * this.toPoint.y
                    };
                }
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx, this.via);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, this.via);
            }
        }]);

        return BezierEdgeDynamic;
    }(BezierEdgeBase);

    function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Static Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var BezierEdgeStatic = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(BezierEdgeStatic, _BezierEdgeBase);

        var _super = _createSuper$7(BezierEdgeStatic);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeStatic(options, body, labelModule) {
            _classCallCheck(this, BezierEdgeStatic);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(BezierEdgeStatic, [{
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
            /**
             * Compute the coordinates of the via node.
             *
             * @remarks
             * We do not use the to and fromPoints here to make the via nodes the same as edges without arrows.
             *
             * @returns Cartesian coordinates of the via node.
             */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                // Assumption: x/y coordinates in from/to always defined
                var factor = this.options.smooth.roundness;
                var type = this.options.smooth.type;
                var dx = Math.abs(this.from.x - this.to.x);
                var dy = Math.abs(this.from.y - this.to.y);

                if (type === "discrete" || type === "diagonalCross") {
                    var stepX;
                    var stepY;

                    if (dx <= dy) {
                        stepX = stepY = factor * dy;
                    } else {
                        stepX = stepY = factor * dx;
                    }

                    if (this.from.x > this.to.x) {
                        stepX = -stepX;
                    }

                    if (this.from.y >= this.to.y) {
                        stepY = -stepY;
                    }

                    var xVia = this.from.x + stepX;
                    var yVia = this.from.y + stepY;

                    if (type === "discrete") {
                        if (dx <= dy) {
                            xVia = dx < factor * dy ? this.from.x : xVia;
                        } else {
                            yVia = dy < factor * dx ? this.from.y : yVia;
                        }
                    }

                    return {
                        x: xVia,
                        y: yVia
                    };
                } else if (type === "straightCross") {
                    var _stepX = (1 - factor) * dx;

                    var _stepY = (1 - factor) * dy;

                    if (dx <= dy) {
                        // up - down
                        _stepX = 0;

                        if (this.from.y < this.to.y) {
                            _stepY = -_stepY;
                        }
                    } else {
                        // left - right
                        if (this.from.x < this.to.x) {
                            _stepX = -_stepX;
                        }

                        _stepY = 0;
                    }

                    return {
                        x: this.to.x + _stepX,
                        y: this.to.y + _stepY
                    };
                } else if (type === "horizontal") {
                    var _stepX2 = (1 - factor) * dx;

                    if (this.from.x < this.to.x) {
                        _stepX2 = -_stepX2;
                    }

                    return {
                        x: this.to.x + _stepX2,
                        y: this.from.y
                    };
                } else if (type === "vertical") {
                    var _stepY2 = (1 - factor) * dy;

                    if (this.from.y < this.to.y) {
                        _stepY2 = -_stepY2;
                    }

                    return {
                        x: this.from.x,
                        y: this.to.y + _stepY2
                    };
                } else if (type === "curvedCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;
                    var radius = Math.sqrt(dx * dx + dy * dy);
                    var pi = Math.PI;
                    var originalAngle = Math.atan2(dy, dx);
                    var myAngle = (originalAngle + (factor * 0.5 + 0.5) * pi) % (2 * pi);
                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * radius * Math.sin(myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * radius * Math.cos(myAngle)
                    };
                } else if (type === "curvedCCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;

                    var _radius = Math.sqrt(dx * dx + dy * dy);

                    var _pi = Math.PI;

                    var _originalAngle = Math.atan2(dy, dx);

                    var _myAngle = (_originalAngle + (-factor * 0.5 + 0.5) * _pi) % (2 * _pi);

                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * _radius * Math.sin(_myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * _radius * Math.cos(_myAngle)
                    };
                } else {
                    // continuous
                    var _stepX3;

                    var _stepY3;

                    if (dx <= dy) {
                        _stepX3 = _stepY3 = factor * dy;
                    } else {
                        _stepX3 = _stepY3 = factor * dx;
                    }

                    if (this.from.x > this.to.x) {
                        _stepX3 = -_stepX3;
                    }

                    if (this.from.y >= this.to.y) {
                        _stepY3 = -_stepY3;
                    }

                    var _xVia = this.from.x + _stepX3;

                    var _yVia = this.from.y + _stepY3;

                    if (dx <= dy) {
                        if (this.from.x <= this.to.x) {
                            _xVia = this.to.x < _xVia ? this.to.x : _xVia;
                        } else {
                            _xVia = this.to.x > _xVia ? this.to.x : _xVia;
                        }
                    } else {
                        if (this.from.y >= this.to.y) {
                            _yVia = this.to.y > _yVia ? this.to.y : _yVia;
                        } else {
                            _yVia = this.to.y < _yVia ? this.to.y : _yVia;
                        }
                    }

                    return {
                        x: _xVia,
                        y: _yVia
                    };
                }
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this._findBorderPositionBezier(nearNode, ctx, options.via);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var viaNode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates();
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates();
                var t = position;
                var x = Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * viaNode.x + Math.pow(t, 2) * this.toPoint.x;
                var y = Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * viaNode.y + Math.pow(t, 2) * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }]);

        return BezierEdgeStatic;
    }(BezierEdgeBase);

    function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Base Class for all Cubic Bezier Edges. Bezier curves are used to model
     * smooth gradual curves in paths between nodes.
     *
     * @augments BezierEdgeBase
     */

    var CubicBezierEdgeBase = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(CubicBezierEdgeBase, _BezierEdgeBase);

        var _super = _createSuper$6(CubicBezierEdgeBase);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function CubicBezierEdgeBase(options, body, labelModule) {
            _classCallCheck(this, CubicBezierEdgeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
         *
         * @remarks
         * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
         * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
         *
         * @param x1 - First end of the line segment on the x axis.
         * @param y1 - First end of the line segment on the y axis.
         * @param x2 - Second end of the line segment on the x axis.
         * @param y2 - Second end of the line segment on the y axis.
         * @param x3 - Position of the point on the x axis.
         * @param y3 - Position of the point on the y axis.
         * @param via1 - The first point this edge passes through.
         * @param via2 - The second point this edge passes through.
         *
         * @returns The distance between the line segment and the point.
         */


        _createClass(CubicBezierEdgeBase, [{
            key: "_getDistanceToBezierEdge2",
            value: function _getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var lastX = x1;
                var lastY = y1;
                var vec = [0, 0, 0, 0];

                for (var i = 1; i < 10; i++) {
                    var t = 0.1 * i;
                    vec[0] = Math.pow(1 - t, 3);
                    vec[1] = 3 * t * Math.pow(1 - t, 2);
                    vec[2] = 3 * Math.pow(t, 2) * (1 - t);
                    vec[3] = Math.pow(t, 3);
                    var x = vec[0] * x1 + vec[1] * via1.x + vec[2] * via2.x + vec[3] * x2;
                    var y = vec[0] * y1 + vec[1] * via1.y + vec[2] * via2.y + vec[3] * y2;

                    if (i > 0) {
                        var distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);

                        minDistance = distance < minDistance ? distance : minDistance;
                    }

                    lastX = x;
                    lastY = y;
                }

                return minDistance;
            }
        }]);

        return CubicBezierEdgeBase;
    }(BezierEdgeBase);

    function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Cubic Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var CubicBezierEdge = /*#__PURE__*/function (_CubicBezierEdgeBase) {
        _inherits(CubicBezierEdge, _CubicBezierEdgeBase);

        var _super = _createSuper$5(CubicBezierEdge);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function CubicBezierEdge(options, body, labelModule) {
            _classCallCheck(this, CubicBezierEdge);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(CubicBezierEdge, [{
            key: "_line",
            value: function _line(ctx, values, viaNodes) {
                // get the coordinates of the support points.
                var via1 = viaNodes[0];
                var via2 = viaNodes[1];

                this._bezierCurve(ctx, values, via1, via2);
            }
            /**
             * Compute the additional points the edge passes through.
             *
             * @returns Cartesian coordinates of the points the edge passes through.
             */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                var dx = this.from.x - this.to.x;
                var dy = this.from.y - this.to.y;
                var x1;
                var y1;
                var x2;
                var y2;
                var roundness = this.options.smooth.roundness; // horizontal if x > y or if direction is forced or if direction is horizontal

                if ((Math.abs(dx) > Math.abs(dy) || this.options.smooth.forceDirection === true || this.options.smooth.forceDirection === "horizontal") && this.options.smooth.forceDirection !== "vertical") {
                    y1 = this.from.y;
                    y2 = this.to.y;
                    x1 = this.from.x - roundness * dx;
                    x2 = this.to.x + roundness * dx;
                } else {
                    y1 = this.from.y - roundness * dy;
                    y2 = this.to.y + roundness * dy;
                    x1 = this.from.x;
                    x2 = this.to.x;
                }

                return [{
                    x: x1,
                    y: y1
                }, {
                    x: x2,
                    y: y2
                }];
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var _ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates(),
                    _ref2 = _slicedToArray(_ref, 2),
                    via1 = _ref2[0],
                    via2 = _ref2[1];

                // x3,y3 is the point
                return this._getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2);
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates(),
                    _ref4 = _slicedToArray(_ref3, 2),
                    via1 = _ref4[0],
                    via2 = _ref4[1];

                var t = position;
                var vec = [Math.pow(1 - t, 3), 3 * t * Math.pow(1 - t, 2), 3 * Math.pow(t, 2) * (1 - t), Math.pow(t, 3)];
                var x = vec[0] * this.fromPoint.x + vec[1] * via1.x + vec[2] * via2.x + vec[3] * this.toPoint.x;
                var y = vec[0] * this.fromPoint.y + vec[1] * via1.y + vec[2] * via2.y + vec[3] * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }]);

        return CubicBezierEdge;
    }(CubicBezierEdgeBase);

    function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Straight Edge.
     */

    var StraightEdge = /*#__PURE__*/function (_EdgeBase) {
        _inherits(StraightEdge, _EdgeBase);

        var _super = _createSuper$4(StraightEdge);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function StraightEdge(options, body, labelModule) {
            _classCallCheck(this, StraightEdge);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(StraightEdge, [{
            key: "_line",
            value: function _line(ctx, values) {
                // draw a straight line
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);
                ctx.lineTo(this.toPoint.x, this.toPoint.y); // draw shadow if enabled

                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return undefined;
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                return {
                    x: (1 - position) * this.fromPoint.x + position * this.toPoint.x,
                    y: (1 - position) * this.fromPoint.y + position * this.toPoint.y
                };
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var node1 = this.to;
                var node2 = this.from;

                if (nearNode.id === this.from.id) {
                    node1 = this.from;
                    node2 = this.to;
                }

                var angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var edgeSegmentLength = Math.sqrt(dx * dx + dy * dy);
                var toBorderDist = nearNode.distanceToBorder(ctx, angle);
                var toBorderPoint = (edgeSegmentLength - toBorderDist) / edgeSegmentLength;
                return {
                    x: (1 - toBorderPoint) * node2.x + toBorderPoint * node1.x,
                    y: (1 - toBorderPoint) * node2.y + toBorderPoint * node1.y,
                    t: 0
                };
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToLine(x1, y1, x2, y2, x3, y3);
            }
        }]);

        return StraightEdge;
    }(EdgeBase);

    /**
     * An edge connects two nodes and has a specific direction.
     */

    var Edge = /*#__PURE__*/function () {
        /**
         * @param {object} options        values specific to this edge, must contain at least 'from' and 'to'
         * @param {object} body           shared state from Network instance
         * @param {Network.Images} imagelist  A list with images. Only needed when the edge has image arrows.
         * @param {object} globalOptions  options from the EdgesHandler instance
         * @param {object} defaultOptions default options from the EdgeHandler instance. Value and reference are constant
         */
        function Edge(options, body, imagelist, globalOptions, defaultOptions) {
            _classCallCheck(this, Edge);

            if (body === undefined) {
                throw new Error("No body provided");
            } // Since globalOptions is constant in values as well as reference,
            // Following needs to be done only once.


            this.options = bridgeObject(globalOptions);
            this.globalOptions = globalOptions;
            this.defaultOptions = defaultOptions;
            this.body = body;
            this.imagelist = imagelist; // initialize variables

            this.id = undefined;
            this.fromId = undefined;
            this.toId = undefined;
            this.selected = false;
            this.hover = false;
            this.labelDirty = true;
            this.baseWidth = this.options.width;
            this.baseFontSize = this.options.font.size;
            this.from = undefined; // a node

            this.to = undefined; // a node

            this.edgeType = undefined;
            this.connected = false;
            this.labelModule = new Label(this.body, this.options, true
                /* It's an edge label */
            );
            this.setOptions(options);
        }
        /**
         * Set or overwrite options for the edge
         *
         * @param {object} options  an object with options
         * @returns {undefined|boolean} undefined if no options, true if layout affecting data changed, false otherwise.
         */


        _createClass(Edge, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (!options) {
                    return;
                } // Following options if changed affect the layout.


                var affectsLayout = typeof options.physics !== "undefined" && this.options.physics !== options.physics || typeof options.hidden !== "undefined" && (this.options.hidden || false) !== (options.hidden || false) || typeof options.from !== "undefined" && this.options.from !== options.from || typeof options.to !== "undefined" && this.options.to !== options.to;
                Edge.parseOptions(this.options, options, true, this.globalOptions);

                if (options.id !== undefined) {
                    this.id = options.id;
                }

                if (options.from !== undefined) {
                    this.fromId = options.from;
                }

                if (options.to !== undefined) {
                    this.toId = options.to;
                }

                if (options.title !== undefined) {
                    this.title = options.title;
                }

                if (options.value !== undefined) {
                    options.value = _parseFloat(options.value);
                }

                var pile = [options, this.options, this.defaultOptions];
                this.chooser = choosify("edge", pile); // update label Module

                this.updateLabelModule(options); // Update edge type, this if changed affects the layout.

                affectsLayout = this.updateEdgeType() || affectsLayout; // if anything has been updates, reset the selection width and the hover width

                this._setInteractionWidths(); // A node is connected when it has a from and to node that both exist in the network.body.nodes.


                this.connect();
                return affectsLayout;
            }
            /**
             *
             * @param {object} parentOptions
             * @param {object} newOptions
             * @param {boolean} [allowDeletion=false]
             * @param {object} [globalOptions={}]
             * @param {boolean} [copyFromGlobals=false]
             */

        }, {
            key: "getFormattingValues",
            value:
                /**
                 *
                 * @returns {ArrowOptions}
                 */
                function getFormattingValues() {
                    var toArrow = this.options.arrows.to === true || this.options.arrows.to.enabled === true;
                    var fromArrow = this.options.arrows.from === true || this.options.arrows.from.enabled === true;
                    var middleArrow = this.options.arrows.middle === true || this.options.arrows.middle.enabled === true;
                    var inheritsColor = this.options.color.inherit;
                    var values = {
                        toArrow: toArrow,
                        toArrowScale: this.options.arrows.to.scaleFactor,
                        toArrowType: this.options.arrows.to.type,
                        toArrowSrc: this.options.arrows.to.src,
                        toArrowImageWidth: this.options.arrows.to.imageWidth,
                        toArrowImageHeight: this.options.arrows.to.imageHeight,
                        middleArrow: middleArrow,
                        middleArrowScale: this.options.arrows.middle.scaleFactor,
                        middleArrowType: this.options.arrows.middle.type,
                        middleArrowSrc: this.options.arrows.middle.src,
                        middleArrowImageWidth: this.options.arrows.middle.imageWidth,
                        middleArrowImageHeight: this.options.arrows.middle.imageHeight,
                        fromArrow: fromArrow,
                        fromArrowScale: this.options.arrows.from.scaleFactor,
                        fromArrowType: this.options.arrows.from.type,
                        fromArrowSrc: this.options.arrows.from.src,
                        fromArrowImageWidth: this.options.arrows.from.imageWidth,
                        fromArrowImageHeight: this.options.arrows.from.imageHeight,
                        arrowStrikethrough: this.options.arrowStrikethrough,
                        color: inheritsColor ? undefined : this.options.color.color,
                        inheritsColor: inheritsColor,
                        opacity: this.options.color.opacity,
                        hidden: this.options.hidden,
                        length: this.options.length,
                        shadow: this.options.shadow.enabled,
                        shadowColor: this.options.shadow.color,
                        shadowSize: this.options.shadow.size,
                        shadowX: this.options.shadow.x,
                        shadowY: this.options.shadow.y,
                        dashes: this.options.dashes,
                        width: this.options.width,
                        background: this.options.background.enabled,
                        backgroundColor: this.options.background.color,
                        backgroundSize: this.options.background.size,
                        backgroundDashes: this.options.background.dashes
                    };

                    if (this.selected || this.hover) {
                        if (this.chooser === true) {
                            if (this.selected) {
                                var selectedWidth = this.options.selectionWidth;

                                if (typeof selectedWidth === "function") {
                                    values.width = selectedWidth(values.width);
                                } else if (typeof selectedWidth === "number") {
                                    values.width += selectedWidth;
                                }

                                values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                                values.color = this.options.color.highlight;
                                values.shadow = this.options.shadow.enabled;
                            } else if (this.hover) {
                                var hoverWidth = this.options.hoverWidth;

                                if (typeof hoverWidth === "function") {
                                    values.width = hoverWidth(values.width);
                                } else if (typeof hoverWidth === "number") {
                                    values.width += hoverWidth;
                                }

                                values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                                values.color = this.options.color.hover;
                                values.shadow = this.options.shadow.enabled;
                            }
                        } else if (typeof this.chooser === "function") {
                            this.chooser(values, this.options.id, this.selected, this.hover);

                            if (values.color !== undefined) {
                                values.inheritsColor = false;
                            }

                            if (values.shadow === false) {
                                if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
                                    values.shadow = true;
                                }
                            }
                        }
                    } else {
                        values.shadow = this.options.shadow.enabled;
                        values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                    }

                    return values;
                }
            /**
             * update the options in the label module
             *
             * @param {object} options
             */

        }, {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                var pile = [options, this.options, this.globalOptions, // Currently set global edge options
                    this.defaultOptions];
                this.labelModule.update(this.options, pile);

                if (this.labelModule.baseSize !== undefined) {
                    this.baseFontSize = this.labelModule.baseSize;
                }
            }
            /**
             * update the edge type, set the options
             *
             * @returns {boolean}
             */

        }, {
            key: "updateEdgeType",
            value: function updateEdgeType() {
                var smooth = this.options.smooth;
                var dataChanged = false;
                var changeInType = true;

                if (this.edgeType !== undefined) {
                    if (this.edgeType instanceof BezierEdgeDynamic && smooth.enabled === true && smooth.type === "dynamic" || this.edgeType instanceof CubicBezierEdge && smooth.enabled === true && smooth.type === "cubicBezier" || this.edgeType instanceof BezierEdgeStatic && smooth.enabled === true && smooth.type !== "dynamic" && smooth.type !== "cubicBezier" || this.edgeType instanceof StraightEdge && smooth.type.enabled === false) {
                        changeInType = false;
                    }

                    if (changeInType === true) {
                        dataChanged = this.cleanup();
                    }
                }

                if (changeInType === true) {
                    if (smooth.enabled === true) {
                        if (smooth.type === "dynamic") {
                            dataChanged = true;
                            this.edgeType = new BezierEdgeDynamic(this.options, this.body, this.labelModule);
                        } else if (smooth.type === "cubicBezier") {
                            this.edgeType = new CubicBezierEdge(this.options, this.body, this.labelModule);
                        } else {
                            this.edgeType = new BezierEdgeStatic(this.options, this.body, this.labelModule);
                        }
                    } else {
                        this.edgeType = new StraightEdge(this.options, this.body, this.labelModule);
                    }
                } else {
                    // if nothing changes, we just set the options.
                    this.edgeType.setOptions(this.options);
                }

                return dataChanged;
            }
            /**
             * Connect an edge to its nodes
             */

        }, {
            key: "connect",
            value: function connect() {
                this.disconnect();
                this.from = this.body.nodes[this.fromId] || undefined;
                this.to = this.body.nodes[this.toId] || undefined;
                this.connected = this.from !== undefined && this.to !== undefined;

                if (this.connected === true) {
                    this.from.attachEdge(this);
                    this.to.attachEdge(this);
                } else {
                    if (this.from) {
                        this.from.detachEdge(this);
                    }

                    if (this.to) {
                        this.to.detachEdge(this);
                    }
                }

                this.edgeType.connect();
            }
            /**
             * Disconnect an edge from its nodes
             */

        }, {
            key: "disconnect",
            value: function disconnect() {
                if (this.from) {
                    this.from.detachEdge(this);
                    this.from = undefined;
                }

                if (this.to) {
                    this.to.detachEdge(this);
                    this.to = undefined;
                }

                this.connected = false;
            }
            /**
             * get the title of this edge.
             *
             * @returns {string} title    The title of the edge, or undefined when no title
             *                           has been set.
             */

        }, {
            key: "getTitle",
            value: function getTitle() {
                return this.title;
            }
            /**
             * check if this node is selecte
             *
             * @returns {boolean} selected   True if node is selected, else false
             */

        }, {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
            /**
             * Retrieve the value of the edge. Can be undefined
             *
             * @returns {number} value
             */

        }, {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
            /**
             * Adjust the value range of the edge. The edge will adjust it's width
             * based on its value.
             *
             * @param {number} min
             * @param {number} max
             * @param {number} total
             */

        }, {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var widthDiff = this.options.scaling.max - this.options.scaling.min;

                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }

                    this.options.width = this.options.scaling.min + scale * widthDiff;
                } else {
                    this.options.width = this.baseWidth;
                    this.options.font.size = this.baseFontSize;
                }

                this._setInteractionWidths();

                this.updateLabelModule();
            }
            /**
             *
             * @private
             */

        }, {
            key: "_setInteractionWidths",
            value: function _setInteractionWidths() {
                if (typeof this.options.hoverWidth === "function") {
                    this.edgeType.hoverWidth = this.options.hoverWidth(this.options.width);
                } else {
                    this.edgeType.hoverWidth = this.options.hoverWidth + this.options.width;
                }

                if (typeof this.options.selectionWidth === "function") {
                    this.edgeType.selectionWidth = this.options.selectionWidth(this.options.width);
                } else {
                    this.edgeType.selectionWidth = this.options.selectionWidth + this.options.width;
                }
            }
            /**
             * Redraw a edge
             * Draw this edge in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();

                if (values.hidden) {
                    return;
                } // get the via node from the edge type


                var viaNode = this.edgeType.getViaNode(); // draw line and label

                this.edgeType.drawLine(ctx, values, this.selected, this.hover, viaNode);
                this.drawLabel(ctx, viaNode);
            }
            /**
             * Redraw arrows
             * Draw this arrows in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "drawArrows",
            value: function drawArrows(ctx) {
                var values = this.getFormattingValues();

                if (values.hidden) {
                    return;
                } // get the via node from the edge type


                var viaNode = this.edgeType.getViaNode();
                var arrowData = {}; // restore edge targets to defaults

                this.edgeType.fromPoint = this.edgeType.from;
                this.edgeType.toPoint = this.edgeType.to; // from and to arrows give a different end point for edges. we set them here

                if (values.fromArrow) {
                    arrowData.from = this.edgeType.getArrowData(ctx, "from", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.fromPoint = arrowData.from.core;

                    if (values.fromArrowSrc) {
                        arrowData.from.image = this.imagelist.load(values.fromArrowSrc);
                    }

                    if (values.fromArrowImageWidth) {
                        arrowData.from.imageWidth = values.fromArrowImageWidth;
                    }

                    if (values.fromArrowImageHeight) {
                        arrowData.from.imageHeight = values.fromArrowImageHeight;
                    }
                }

                if (values.toArrow) {
                    arrowData.to = this.edgeType.getArrowData(ctx, "to", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.toPoint = arrowData.to.core;

                    if (values.toArrowSrc) {
                        arrowData.to.image = this.imagelist.load(values.toArrowSrc);
                    }

                    if (values.toArrowImageWidth) {
                        arrowData.to.imageWidth = values.toArrowImageWidth;
                    }

                    if (values.toArrowImageHeight) {
                        arrowData.to.imageHeight = values.toArrowImageHeight;
                    }
                } // the middle arrow depends on the line, which can depend on the to and from arrows so we do this one lastly.


                if (values.middleArrow) {
                    arrowData.middle = this.edgeType.getArrowData(ctx, "middle", viaNode, this.selected, this.hover, values);

                    if (values.middleArrowSrc) {
                        arrowData.middle.image = this.imagelist.load(values.middleArrowSrc);
                    }

                    if (values.middleArrowImageWidth) {
                        arrowData.middle.imageWidth = values.middleArrowImageWidth;
                    }

                    if (values.middleArrowImageHeight) {
                        arrowData.middle.imageHeight = values.middleArrowImageHeight;
                    }
                }

                if (values.fromArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.from);
                }

                if (values.middleArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.middle);
                }

                if (values.toArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.to);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {Node} viaNode
             */

        }, {
            key: "drawLabel",
            value: function drawLabel(ctx, viaNode) {
                if (this.options.label !== undefined) {
                    // set style
                    var node1 = this.from;
                    var node2 = this.to;

                    if (this.labelModule.differentState(this.selected, this.hover)) {
                        this.labelModule.getTextSize(ctx, this.selected, this.hover);
                    }

                    var point;

                    if (node1.id != node2.id) {
                        this.labelModule.pointToSelf = false;
                        point = this.edgeType.getPoint(0.5, viaNode);
                        ctx.save();

                        var rotationPoint = this._getRotation(ctx);

                        if (rotationPoint.angle != 0) {
                            ctx.translate(rotationPoint.x, rotationPoint.y);
                            ctx.rotate(rotationPoint.angle);
                        } // draw the label


                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                        /*
	          // Useful debug code: draw a border around the label
	          // This should **not** be enabled in production!
	          var size = this.labelModule.getSize();; // ;; intentional so lint catches it
	          ctx.strokeStyle = "#ff0000";
	          ctx.strokeRect(size.left, size.top, size.width, size.height);
	          // End  debug code
	          */

                        ctx.restore();
                    } else {
                        // Ignore the orientations.
                        this.labelModule.pointToSelf = true; // get circle coordinates

                        var coordinates = getSelfRefCoordinates(ctx, this.options.selfReference.angle, this.options.selfReference.size, node1);
                        point = this._pointOnCircle(coordinates.x, coordinates.y, this.options.selfReference.size, this.options.selfReference.angle);
                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                    }
                }
            }
            /**
             * Determine all visual elements of this edge instance, in which the given
             * point falls within the bounding shape.
             *
             * @param {point} point
             * @returns {Array.<edgeClickItem|edgeLabelClickItem>} list with the items which are on the point
             */

        }, {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];

                if (this.labelModule.visible()) {
                    var rotationPoint = this._getRotation();

                    if (pointInRect(this.labelModule.getSize(), point, rotationPoint)) {
                        ret.push({
                            edgeId: this.id,
                            labelId: 0
                        });
                    }
                }

                var obj = {
                    left: point.x,
                    top: point.y
                };

                if (this.isOverlappingWith(obj)) {
                    ret.push({
                        edgeId: this.id
                    });
                }

                return ret;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top
             * @returns {boolean}     True if location is located on the edge
             */

        }, {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                if (this.connected) {
                    var distMax = 10;
                    var xFrom = this.from.x;
                    var yFrom = this.from.y;
                    var xTo = this.to.x;
                    var yTo = this.to.y;
                    var xObj = obj.left;
                    var yObj = obj.top;
                    var dist = this.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, xObj, yObj);
                    return dist < distMax;
                } else {
                    return false;
                }
            }
            /**
             * Determine the rotation point, if any.
             *
             * @param {CanvasRenderingContext2D} [ctx] if passed, do a recalculation of the label size
             * @returns {rotationPoint} the point to rotate around and the angle in radians to rotate
             * @private
             */

        }, {
            key: "_getRotation",
            value: function _getRotation(ctx) {
                var viaNode = this.edgeType.getViaNode();
                var point = this.edgeType.getPoint(0.5, viaNode);

                if (ctx !== undefined) {
                    this.labelModule.calculateLabelSize(ctx, this.selected, this.hover, point.x, point.y);
                }

                var ret = {
                    x: point.x,
                    y: this.labelModule.size.yLine,
                    angle: 0
                };

                if (!this.labelModule.visible()) {
                    return ret; // Don't even bother doing the atan2, there's nothing to draw
                }

                if (this.options.font.align === "horizontal") {
                    return ret; // No need to calculate angle
                }

                var dy = this.from.y - this.to.y;
                var dx = this.from.x - this.to.x;
                var angle = Math.atan2(dy, dx); // radians
                // rotate so that label is readable

                if (angle < -1 && dx < 0 || angle > 0 && dx < 0) {
                    angle += Math.PI;
                }

                ret.angle = angle;
                return ret;
            }
            /**
             * Get a point on a circle
             *
             * @param {number} x
             * @param {number} y
             * @param {number} radius
             * @param {number} angle
             * @returns {object} point
             * @private
             */

        }, {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, angle) {
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
            /**
             * Sets selected state to true
             */

        }, {
            key: "select",
            value: function select() {
                this.selected = true;
            }
            /**
             * Sets selected state to false
             */

        }, {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
            }
            /**
             * cleans all required things on delete
             *
             * @returns {*}
             */

        }, {
            key: "cleanup",
            value: function cleanup() {
                return this.edgeType.cleanup();
            }
            /**
             * Remove edge from the list and perform necessary cleanup.
             */

        }, {
            key: "remove",
            value: function remove() {
                this.cleanup();
                this.disconnect();
                delete this.body.edges[this.id];
            }
            /**
             * Check if both connecting nodes exist
             *
             * @returns {boolean}
             */

        }, {
            key: "endPointsValid",
            value: function endPointsValid() {
                return this.body.nodes[this.fromId] !== undefined && this.body.nodes[this.toId] !== undefined;
            }
        }], [{
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var copyFromGlobals = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var fields = ["endPointOffset", "arrowStrikethrough", "id", "from", "hidden", "hoverWidth", "labelHighlightBold", "length", "line", "opacity", "physics", "scaling", "selectionWidth", "selfReferenceSize", "selfReference", "to", "title", "value", "width", "font", "chosen", "widthConstraint"]; // only deep extend the items in the field array. These do not have shorthand.

                selectiveDeepExtend(fields, parentOptions, newOptions, allowDeletion); // Only use endPointOffset values (from and to) if it's valid values

                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.from !== undefined) {
                    if (_isFinite(newOptions.endPointOffset.from)) {
                        parentOptions.endPointOffset.from = newOptions.endPointOffset.from;
                    } else {
                        parentOptions.endPointOffset.from = globalOptions.endPointOffset.from !== undefined ? globalOptions.endPointOffset.from : 0;
                        console.error("endPointOffset.from is not a valid number");
                    }
                }

                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.to !== undefined) {
                    if (_isFinite(newOptions.endPointOffset.to)) {
                        parentOptions.endPointOffset.to = newOptions.endPointOffset.to;
                    } else {
                        parentOptions.endPointOffset.to = globalOptions.endPointOffset.to !== undefined ? globalOptions.endPointOffset.to : 0;
                        console.error("endPointOffset.to is not a valid number");
                    }
                } // Only copy label if it's a legal value.


                if (isValidLabel(newOptions.label)) {
                    parentOptions.label = newOptions.label;
                } else if (!isValidLabel(parentOptions.label)) {
                    parentOptions.label = undefined;
                }

                mergeOptions(parentOptions, newOptions, "smooth", globalOptions);
                mergeOptions(parentOptions, newOptions, "shadow", globalOptions);
                mergeOptions(parentOptions, newOptions, "background", globalOptions);

                if (newOptions.dashes !== undefined && newOptions.dashes !== null) {
                    parentOptions.dashes = newOptions.dashes;
                } else if (allowDeletion === true && newOptions.dashes === null) {
                    parentOptions.dashes = create$2(globalOptions.dashes); // this sets the pointer of the option back to the global option.
                } // set the scaling newOptions


                if (newOptions.scaling !== undefined && newOptions.scaling !== null) {
                    if (newOptions.scaling.min !== undefined) {
                        parentOptions.scaling.min = newOptions.scaling.min;
                    }

                    if (newOptions.scaling.max !== undefined) {
                        parentOptions.scaling.max = newOptions.scaling.max;
                    }

                    mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
                } else if (allowDeletion === true && newOptions.scaling === null) {
                    parentOptions.scaling = create$2(globalOptions.scaling); // this sets the pointer of the option back to the global option.
                } // handle multiple input cases for arrows


                if (newOptions.arrows !== undefined && newOptions.arrows !== null) {
                    if (typeof newOptions.arrows === "string") {
                        var arrows = newOptions.arrows.toLowerCase();
                        parentOptions.arrows.to.enabled = indexOf(arrows).call(arrows, "to") != -1;
                        parentOptions.arrows.middle.enabled = indexOf(arrows).call(arrows, "middle") != -1;
                        parentOptions.arrows.from.enabled = indexOf(arrows).call(arrows, "from") != -1;
                    } else if (_typeof(newOptions.arrows) === "object") {
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "to", globalOptions.arrows);
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "middle", globalOptions.arrows);
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "from", globalOptions.arrows);
                    } else {
                        throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:" + stringify$1(newOptions.arrows));
                    }
                } else if (allowDeletion === true && newOptions.arrows === null) {
                    parentOptions.arrows = create$2(globalOptions.arrows); // this sets the pointer of the option back to the global option.
                } // handle multiple input cases for color


                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var fromColor = isString(newOptions.color) ? {
                        color: newOptions.color,
                        highlight: newOptions.color,
                        hover: newOptions.color,
                        inherit: false,
                        opacity: 1
                    } : newOptions.color;
                    var toColor = parentOptions.color; // If passed, fill in values from default options - required in the case of no prototype bridging

                    if (copyFromGlobals) {
                        deepExtend(toColor, globalOptions.color, false, allowDeletion);
                    } else {
                        // Clear local properties - need to do it like this in order to retain prototype bridges
                        for (var i in toColor) {
                            if (Object.prototype.hasOwnProperty.call(toColor, i)) {
                                delete toColor[i];
                            }
                        }
                    }

                    if (isString(toColor)) {
                        toColor.color = toColor;
                        toColor.highlight = toColor;
                        toColor.hover = toColor;
                        toColor.inherit = false;

                        if (fromColor.opacity === undefined) {
                            toColor.opacity = 1.0; // set default
                        }
                    } else {
                        var colorsDefined = false;

                        if (fromColor.color !== undefined) {
                            toColor.color = fromColor.color;
                            colorsDefined = true;
                        }

                        if (fromColor.highlight !== undefined) {
                            toColor.highlight = fromColor.highlight;
                            colorsDefined = true;
                        }

                        if (fromColor.hover !== undefined) {
                            toColor.hover = fromColor.hover;
                            colorsDefined = true;
                        }

                        if (fromColor.inherit !== undefined) {
                            toColor.inherit = fromColor.inherit;
                        }

                        if (fromColor.opacity !== undefined) {
                            toColor.opacity = Math.min(1, Math.max(0, fromColor.opacity));
                        }

                        if (colorsDefined === true) {
                            toColor.inherit = false;
                        } else {
                            if (toColor.inherit === undefined) {
                                toColor.inherit = "from"; // Set default
                            }
                        }
                    }
                } else if (allowDeletion === true && newOptions.color === null) {
                    parentOptions.color = bridgeObject(globalOptions.color); // set the object back to the global options
                }

                if (allowDeletion === true && newOptions.font === null) {
                    parentOptions.font = bridgeObject(globalOptions.font); // set the object back to the global options
                }

                if (Object.prototype.hasOwnProperty.call(newOptions, "selfReferenceSize")) {
                    console.warn("The selfReferenceSize property has been deprecated. Please use selfReference property instead. The selfReference can be set like thise selfReference:{size:30, angle:Math.PI / 4}");
                    parentOptions.selfReference.size = newOptions.selfReferenceSize;
                }
            }
        }]);

        return Edge;
    }();

    /**
     * Handler for Edges
     */

    var EdgesHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Array.<Image>} images
         * @param {Array.<Group>} groups
         */
        function EdgesHandler(body, images, groups) {
            var _context,
                _this = this;

            _classCallCheck(this, EdgesHandler);

            this.body = body;
            this.images = images;
            this.groups = groups; // create the edge API in the body container

            this.body.functions.createEdge = bind(_context = this.create).call(_context, this);
            this.edgesListeners = {
                add: function add(event, params) {
                    _this.add(params.items);
                },
                update: function update(event, params) {
                    _this.update(params.items);
                },
                remove: function remove(event, params) {
                    _this.remove(params.items);
                }
            };
            this.options = {};
            this.defaultOptions = {
                arrows: {
                    to: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    },
                    // boolean / {arrowScaleFactor:1} / {enabled: false, arrowScaleFactor:1}
                    middle: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    },
                    from: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    }
                },
                endPointOffset: {
                    from: 0,
                    to: 0
                },
                arrowStrikethrough: true,
                color: {
                    color: "#848484",
                    highlight: "#848484",
                    hover: "#848484",
                    inherit: "from",
                    opacity: 1.0
                },
                dashes: false,
                font: {
                    color: "#343434",
                    size: 14,
                    // px
                    face: "arial",
                    background: "none",
                    strokeWidth: 2,
                    // px
                    strokeColor: "#ffffff",
                    align: "horizontal",
                    multi: false,
                    vadjust: 0,
                    bold: {
                        mod: "bold"
                    },
                    boldital: {
                        mod: "bold italic"
                    },
                    ital: {
                        mod: "italic"
                    },
                    mono: {
                        mod: "",
                        size: 15,
                        // px
                        face: "courier new",
                        vadjust: 2
                    }
                },
                hidden: false,
                hoverWidth: 1.5,
                label: undefined,
                labelHighlightBold: true,
                length: undefined,
                physics: true,
                scaling: {
                    min: 1,
                    max: 15,
                    label: {
                        enabled: true,
                        min: 14,
                        max: 30,
                        maxVisible: 30,
                        drawThreshold: 5
                    },
                    customScalingFunction: function customScalingFunction(min, max, total, value) {
                        if (max === min) {
                            return 0.5;
                        } else {
                            var scale = 1 / (max - min);
                            return Math.max(0, (value - min) * scale);
                        }
                    }
                },
                selectionWidth: 1.5,
                selfReference: {
                    size: 20,
                    angle: Math.PI / 4,
                    renderBehindTheNode: true
                },
                shadow: {
                    enabled: false,
                    color: "rgba(0,0,0,0.5)",
                    size: 10,
                    x: 5,
                    y: 5
                },
                background: {
                    enabled: false,
                    color: "rgba(111,111,111,1)",
                    size: 10,
                    dashes: false
                },
                smooth: {
                    enabled: true,
                    type: "dynamic",
                    forceDirection: "none",
                    roundness: 0.5
                },
                title: undefined,
                width: 1,
                value: undefined
            };
            deepExtend(this.options, this.defaultOptions);
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(EdgesHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this,
                    _context2,
                    _context3;

                // this allows external modules to force all dynamic curves to turn static.
                this.body.emitter.on("_forceDisableDynamicCurves", function (type) {
                    var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                    if (type === "dynamic") {
                        type = "continuous";
                    }

                    var dataChanged = false;

                    for (var edgeId in _this2.body.edges) {
                        if (Object.prototype.hasOwnProperty.call(_this2.body.edges, edgeId)) {
                            var edge = _this2.body.edges[edgeId];

                            var edgeData = _this2.body.data.edges.get(edgeId); // only forcibly remove the smooth curve if the data has been set of the edge has the smooth curves defined.
                            // this is because a change in the global would not affect these curves.


                            if (edgeData != null) {
                                var smoothOptions = edgeData.smooth;

                                if (smoothOptions !== undefined) {
                                    if (smoothOptions.enabled === true && smoothOptions.type === "dynamic") {
                                        if (type === undefined) {
                                            edge.setOptions({
                                                smooth: false
                                            });
                                        } else {
                                            edge.setOptions({
                                                smooth: {
                                                    type: type
                                                }
                                            });
                                        }

                                        dataChanged = true;
                                    }
                                }
                            }
                        }
                    }

                    if (emit === true && dataChanged === true) {
                        _this2.body.emitter.emit("_dataChanged");
                    }
                }); // this is called when options of EXISTING nodes or edges have changed.
                //
                // NOTE: Not true, called when options have NOT changed, for both existing as well as new nodes.
                //       See update() for logic.
                // TODO: Verify and examine the consequences of this. It might still trigger when
                //       non-option fields have changed, but then reconnecting edges is still useless.
                //       Alternatively, it might also be called when edges are removed.
                //

                this.body.emitter.on("_dataUpdated", function () {
                    _this2.reconnectEdges();
                }); // refresh the edges. Used when reverting from hierarchical layout

                this.body.emitter.on("refreshEdges", bind(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", bind(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function () {
                    forEach$1(_this2.edgesListeners, function (callback, event) {
                        if (_this2.body.data.edges) _this2.body.data.edges.off(event, callback);
                    });
                    delete _this2.body.functions.createEdge;
                    delete _this2.edgesListeners.add;
                    delete _this2.edgesListeners.update;
                    delete _this2.edgesListeners.remove;
                    delete _this2.edgesListeners;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // use the parser from the Edge class to fill in all shorthand notations
                    Edge.parseOptions(this.options, options, true, this.defaultOptions, true); // update smooth settings in all edges

                    var dataChanged = false;

                    if (options.smooth !== undefined) {
                        for (var edgeId in this.body.edges) {
                            if (Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) {
                                dataChanged = this.body.edges[edgeId].updateEdgeType() || dataChanged;
                            }
                        }
                    } // update fonts in all edges


                    if (options.font !== undefined) {
                        for (var _edgeId in this.body.edges) {
                            if (Object.prototype.hasOwnProperty.call(this.body.edges, _edgeId)) {
                                this.body.edges[_edgeId].updateLabelModule();
                            }
                        }
                    } // update the state of the variables if needed


                    if (options.hidden !== undefined || options.physics !== undefined || dataChanged === true) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             * Load edges by reading the data table
             *
             * @param {Array | DataSet | DataView} edges    The data containing the edges.
             * @param {boolean} [doNotEmit=false] - Suppress data changed event.
             * @private
             */

        }, {
            key: "setData",
            value: function setData(edges) {
                var _this3 = this;

                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldEdgesData = this.body.data.edges;

                if (isDataViewLike("id", edges)) {
                    this.body.data.edges = edges;
                } else if (isArray(edges)) {
                    this.body.data.edges = new DataSet();
                    this.body.data.edges.add(edges);
                } else if (!edges) {
                    this.body.data.edges = new DataSet();
                } else {
                    throw new TypeError("Array or DataSet expected");
                } // TODO: is this null or undefined or false?


                if (oldEdgesData) {
                    // unsubscribe from old dataset
                    forEach$1(this.edgesListeners, function (callback, event) {
                        oldEdgesData.off(event, callback);
                    });
                } // remove drawn edges


                this.body.edges = {}; // TODO: is this null or undefined or false?

                if (this.body.data.edges) {
                    // subscribe to new dataset
                    forEach$1(this.edgesListeners, function (callback, event) {
                        _this3.body.data.edges.on(event, callback);
                    }); // draw all new nodes

                    var ids = this.body.data.edges.getIds();
                    this.add(ids, true);
                }

                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Add edges
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [doNotEmit=false]
             * @private
             */

        }, {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var oldEdge = edges[id];

                    if (oldEdge) {
                        oldEdge.disconnect();
                    }

                    var data = edgesData.get(id, {
                        showInternalIds: true
                    });
                    edges[id] = this.create(data);
                }

                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Update existing edges, or create them when not yet existing
             *
             * @param {number[] | string[]} ids
             * @private
             */

        }, {
            key: "update",
            value: function update(ids) {
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;
                var dataChanged = false;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var data = edgesData.get(id);
                    var edge = edges[id];

                    if (edge !== undefined) {
                        // update edge
                        edge.disconnect();
                        dataChanged = edge.setOptions(data) || dataChanged; // if a support node is added, data can be changed.

                        edge.connect();
                    } else {
                        // create edge
                        this.body.edges[id] = this.create(data);
                        dataChanged = true;
                    }
                }

                if (dataChanged === true) {
                    this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");
                    this.body.emitter.emit("_dataChanged");
                } else {
                    this.body.emitter.emit("_dataUpdated");
                }
            }
            /**
             * Remove existing edges. Non existing ids will be ignored
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [emit=true]
             * @private
             */

        }, {
            key: "remove",
            value: function remove(ids) {
                var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (ids.length === 0) return; // early out

                var edges = this.body.edges;
                forEach$1(ids, function (id) {
                    var edge = edges[id];

                    if (edge !== undefined) {
                        edge.remove();
                    }
                });

                if (emit) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Refreshes Edge Handler
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var _this4 = this;

                forEach$1(this.body.edges, function (edge, edgeId) {
                    var data = _this4.body.data.edges.get(edgeId);

                    if (data !== undefined) {
                        edge.setOptions(data);
                    }
                });
            }
            /**
             *
             * @param {object} properties
             * @returns {Edge}
             */

        }, {
            key: "create",
            value: function create(properties) {
                return new Edge(properties, this.body, this.images, this.options, this.defaultOptions);
            }
            /**
             * Reconnect all edges
             *
             * @private
             */

        }, {
            key: "reconnectEdges",
            value: function reconnectEdges() {
                var id;
                var nodes = this.body.nodes;
                var edges = this.body.edges;

                for (id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        nodes[id].edges = [];
                    }
                }

                for (id in edges) {
                    if (Object.prototype.hasOwnProperty.call(edges, id)) {
                        var edge = edges[id];
                        edge.from = null;
                        edge.to = null;
                        edge.connect();
                    }
                }
            }
            /**
             *
             * @param {Edge.id} edgeId
             * @returns {Array}
             */

        }, {
            key: "getConnectedNodes",
            value: function getConnectedNodes(edgeId) {
                var nodeList = [];

                if (this.body.edges[edgeId] !== undefined) {
                    var edge = this.body.edges[edgeId];

                    if (edge.fromId !== undefined) {
                        nodeList.push(edge.fromId);
                    }

                    if (edge.toId !== undefined) {
                        nodeList.push(edge.toId);
                    }
                }

                return nodeList;
            }
            /**
             * There is no direct relation between the nodes and the edges DataSet,
             * so the right place to do call this is in the handler for event `_dataUpdated`.
             */

        }, {
            key: "_updateState",
            value: function _updateState() {
                this._addMissingEdges();

                this._removeInvalidEdges();
            }
            /**
             * Scan for missing nodes and remove corresponding edges, if any.
             *
             * @private
             */

        }, {
            key: "_removeInvalidEdges",
            value: function _removeInvalidEdges() {
                var _this5 = this;

                var edgesToDelete = [];
                forEach$1(this.body.edges, function (edge, id) {
                    var toNode = _this5.body.nodes[edge.toId];
                    var fromNode = _this5.body.nodes[edge.fromId]; // Skip clustering edges here, let the Clustering module handle those

                    if (toNode !== undefined && toNode.isCluster === true || fromNode !== undefined && fromNode.isCluster === true) {
                        return;
                    }

                    if (toNode === undefined || fromNode === undefined) {
                        edgesToDelete.push(id);
                    }
                });
                this.remove(edgesToDelete, false);
            }
            /**
             * add all edges from dataset that are not in the cached state
             *
             * @private
             */

        }, {
            key: "_addMissingEdges",
            value: function _addMissingEdges() {
                var edgesData = this.body.data.edges;

                if (edgesData === undefined || edgesData === null) {
                    return; // No edges DataSet yet; can happen on startup
                }

                var edges = this.body.edges;
                var addIds = [];

                forEach$2(edgesData).call(edgesData, function (edgeData, edgeId) {
                    var edge = edges[edgeId];

                    if (edge === undefined) {
                        addIds.push(edgeId);
                    }
                });

                this.add(addIds, true);
            }
        }]);

        return EdgesHandler;
    }();

    /**
     * Barnes Hut Solver
     */

    var BarnesHutSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function BarnesHutSolver(body, physicsBody, options) {
            _classCallCheck(this, BarnesHutSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.barnesHutTree;
            this.setOptions(options);
            this._rng = Alea("BARNES HUT SOLVER"); // debug: show grid
            // this.body.emitter.on("afterDrawing", (ctx) => {this._debug(ctx,'#ff0000')})
        }
        /**
         *
         * @param {object} options
         */


        _createClass(BarnesHutSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.thetaInversed = 1 / this.options.theta; // if 1 then min distance = 0.5, if 0.5 then min distance = 0.5 + 0.5*node.shape.radius

                this.overlapAvoidanceFactor = 1 - Math.max(0, Math.min(1, this.options.avoidOverlap));
            }
            /**
             * This function calculates the forces the nodes apply on each other based on a gravitational model.
             * The Barnes Hut method is used to speed up this N-body simulation.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                if (this.options.gravitationalConstant !== 0 && this.physicsBody.physicsNodeIndices.length > 0) {
                    var node;
                    var nodes = this.body.nodes;
                    var nodeIndices = this.physicsBody.physicsNodeIndices;
                    var nodeCount = nodeIndices.length; // create the tree

                    var barnesHutTree = this._formBarnesHutTree(nodes, nodeIndices); // for debugging


                    this.barnesHutTree = barnesHutTree; // place the nodes one by one recursively

                    for (var i = 0; i < nodeCount; i++) {
                        node = nodes[nodeIndices[i]];

                        if (node.options.mass > 0) {
                            // starting with root is irrelevant, it never passes the BarnesHutSolver condition
                            this._getForceContributions(barnesHutTree.root, node);
                        }
                    }
                }
            }
            /**
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_getForceContributions",
            value: function _getForceContributions(parentBranch, node) {
                this._getForceContribution(parentBranch.children.NW, node);

                this._getForceContribution(parentBranch.children.NE, node);

                this._getForceContribution(parentBranch.children.SW, node);

                this._getForceContribution(parentBranch.children.SE, node);
            }
            /**
             * This function traverses the barnesHutTree. It checks when it can approximate distant nodes with their center of mass.
             * If a region contains a single node, we check if it is not itself, then we apply the force.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_getForceContribution",
            value: function _getForceContribution(parentBranch, node) {
                // we get no force contribution from an empty region
                if (parentBranch.childrenCount > 0) {
                    // get the distance from the center of mass to the node.
                    var dx = parentBranch.centerOfMass.x - node.x;
                    var dy = parentBranch.centerOfMass.y - node.y;
                    var distance = Math.sqrt(dx * dx + dy * dy); // BarnesHutSolver condition
                    // original condition : s/d < theta = passed  ===  d/s > 1/theta = passed
                    // calcSize = 1/s --> d * 1/s > 1/theta = passed

                    if (distance * parentBranch.calcSize > this.thetaInversed) {
                        this._calculateForces(distance, dx, dy, node, parentBranch);
                    } else {
                        // Did not pass the condition, go into children if available
                        if (parentBranch.childrenCount === 4) {
                            this._getForceContributions(parentBranch, node);
                        } else {
                            // parentBranch must have only one node, if it was empty we wouldnt be here
                            if (parentBranch.children.data.id != node.id) {
                                // if it is not self
                                this._calculateForces(distance, dx, dy, node, parentBranch);
                            }
                        }
                    }
                }
            }
            /**
             * Calculate the forces based on the distance.
             *
             * @param {number} distance
             * @param {number} dx
             * @param {number} dy
             * @param {Node} node
             * @param {object} parentBranch
             * @private
             */

        }, {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1;
                    dx = distance;
                }

                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
                    distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                } // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce


                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass / Math.pow(distance, 3);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
            /**
             * This function constructs the barnesHut tree recursively. It creates the root, splits it and starts placing the nodes.
             *
             * @param {Array.<Node>} nodes
             * @param {Array.<number>} nodeIndices
             * @returns {{root: {centerOfMass: {x: number, y: number}, mass: number, range: {minX: number, maxX: number, minY: number, maxY: number}, size: number, calcSize: number, children: {data: null}, maxWidth: number, level: number, childrenCount: number}}} BarnesHutTree
             * @private
             */

        }, {
            key: "_formBarnesHutTree",
            value: function _formBarnesHutTree(nodes, nodeIndices) {
                var node;
                var nodeCount = nodeIndices.length;
                var minX = nodes[nodeIndices[0]].x;
                var minY = nodes[nodeIndices[0]].y;
                var maxX = nodes[nodeIndices[0]].x;
                var maxY = nodes[nodeIndices[0]].y; // get the range of the nodes

                for (var i = 1; i < nodeCount; i++) {
                    var _node = nodes[nodeIndices[i]];
                    var x = _node.x;
                    var y = _node.y;

                    if (_node.options.mass > 0) {
                        if (x < minX) {
                            minX = x;
                        }

                        if (x > maxX) {
                            maxX = x;
                        }

                        if (y < minY) {
                            minY = y;
                        }

                        if (y > maxY) {
                            maxY = y;
                        }
                    }
                } // make the range a square


                var sizeDiff = Math.abs(maxX - minX) - Math.abs(maxY - minY); // difference between X and Y

                if (sizeDiff > 0) {
                    minY -= 0.5 * sizeDiff;
                    maxY += 0.5 * sizeDiff;
                } // xSize > ySize
                else {
                    minX += 0.5 * sizeDiff;
                    maxX -= 0.5 * sizeDiff;
                } // xSize < ySize


                var minimumTreeSize = 1e-5;
                var rootSize = Math.max(minimumTreeSize, Math.abs(maxX - minX));
                var halfRootSize = 0.5 * rootSize;
                var centerX = 0.5 * (minX + maxX),
                    centerY = 0.5 * (minY + maxY); // construct the barnesHutTree

                var barnesHutTree = {
                    root: {
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        mass: 0,
                        range: {
                            minX: centerX - halfRootSize,
                            maxX: centerX + halfRootSize,
                            minY: centerY - halfRootSize,
                            maxY: centerY + halfRootSize
                        },
                        size: rootSize,
                        calcSize: 1 / rootSize,
                        children: {
                            data: null
                        },
                        maxWidth: 0,
                        level: 0,
                        childrenCount: 4
                    }
                };

                this._splitBranch(barnesHutTree.root); // place the nodes one by one recursively


                for (var _i = 0; _i < nodeCount; _i++) {
                    node = nodes[nodeIndices[_i]];

                    if (node.options.mass > 0) {
                        this._placeInTree(barnesHutTree.root, node);
                    }
                } // make global


                return barnesHutTree;
            }
            /**
             * this updates the mass of a branch. this is increased by adding a node.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_updateBranchMass",
            value: function _updateBranchMass(parentBranch, node) {
                var centerOfMass = parentBranch.centerOfMass;
                var totalMass = parentBranch.mass + node.options.mass;
                var totalMassInv = 1 / totalMass;
                centerOfMass.x = centerOfMass.x * parentBranch.mass + node.x * node.options.mass;
                centerOfMass.x *= totalMassInv;
                centerOfMass.y = centerOfMass.y * parentBranch.mass + node.y * node.options.mass;
                centerOfMass.y *= totalMassInv;
                parentBranch.mass = totalMass;
                var biggestSize = Math.max(Math.max(node.height, node.radius), node.width);
                parentBranch.maxWidth = parentBranch.maxWidth < biggestSize ? biggestSize : parentBranch.maxWidth;
            }
            /**
             * determine in which branch the node will be placed.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @param {boolean} skipMassUpdate
             * @private
             */

        }, {
            key: "_placeInTree",
            value: function _placeInTree(parentBranch, node, skipMassUpdate) {
                if (skipMassUpdate != true || skipMassUpdate === undefined) {
                    // update the mass of the branch.
                    this._updateBranchMass(parentBranch, node);
                }

                var range = parentBranch.children.NW.range;
                var region;

                if (range.maxX > node.x) {
                    // in NW or SW
                    if (range.maxY > node.y) {
                        region = "NW";
                    } else {
                        region = "SW";
                    }
                } else {
                    // in NE or SE
                    if (range.maxY > node.y) {
                        region = "NE";
                    } else {
                        region = "SE";
                    }
                }

                this._placeInRegion(parentBranch, node, region);
            }
            /**
             * actually place the node in a region (or branch)
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @param {'NW'| 'NE' | 'SW' | 'SE'} region
             * @private
             */

        }, {
            key: "_placeInRegion",
            value: function _placeInRegion(parentBranch, node, region) {
                var children = parentBranch.children[region];

                switch (children.childrenCount) {
                    case 0:
                        // place node here
                        children.children.data = node;
                        children.childrenCount = 1;

                        this._updateBranchMass(children, node);

                        break;

                    case 1:
                        // convert into children
                        // if there are two nodes exactly overlapping (on init, on opening of cluster etc.)
                        // we move one node a little bit and we do not put it in the tree.
                        if (children.children.data.x === node.x && children.children.data.y === node.y) {
                            node.x += this._rng();
                            node.y += this._rng();
                        } else {
                            this._splitBranch(children);

                            this._placeInTree(children, node);
                        }

                        break;

                    case 4:
                        // place in branch
                        this._placeInTree(children, node);

                        break;
                }
            }
            /**
             * this function splits a branch into 4 sub branches. If the branch contained a node, we place it in the subbranch
             * after the split is complete.
             *
             * @param {object} parentBranch
             * @private
             */

        }, {
            key: "_splitBranch",
            value: function _splitBranch(parentBranch) {
                // if the branch is shaded with a node, replace the node in the new subset.
                var containedNode = null;

                if (parentBranch.childrenCount === 1) {
                    containedNode = parentBranch.children.data;
                    parentBranch.mass = 0;
                    parentBranch.centerOfMass.x = 0;
                    parentBranch.centerOfMass.y = 0;
                }

                parentBranch.childrenCount = 4;
                parentBranch.children.data = null;

                this._insertRegion(parentBranch, "NW");

                this._insertRegion(parentBranch, "NE");

                this._insertRegion(parentBranch, "SW");

                this._insertRegion(parentBranch, "SE");

                if (containedNode != null) {
                    this._placeInTree(parentBranch, containedNode);
                }
            }
            /**
             * This function subdivides the region into four new segments.
             * Specifically, this inserts a single new segment.
             * It fills the children section of the parentBranch
             *
             * @param {object} parentBranch
             * @param {'NW'| 'NE' | 'SW' | 'SE'} region
             * @private
             */

        }, {
            key: "_insertRegion",
            value: function _insertRegion(parentBranch, region) {
                var minX, maxX, minY, maxY;
                var childSize = 0.5 * parentBranch.size;

                switch (region) {
                    case "NW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;

                    case "NE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;

                    case "SW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;

                    case "SE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;
                }

                parentBranch.children[region] = {
                    centerOfMass: {
                        x: 0,
                        y: 0
                    },
                    mass: 0,
                    range: {
                        minX: minX,
                        maxX: maxX,
                        minY: minY,
                        maxY: maxY
                    },
                    size: 0.5 * parentBranch.size,
                    calcSize: 2 * parentBranch.calcSize,
                    children: {
                        data: null
                    },
                    maxWidth: 0,
                    level: parentBranch.level + 1,
                    childrenCount: 0
                };
            } //---------------------------  DEBUGGING BELOW  ---------------------------//

            /**
             * This function is for debugging purposed, it draws the tree.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} color
             * @private
             */

        }, {
            key: "_debug",
            value: function _debug(ctx, color) {
                if (this.barnesHutTree !== undefined) {
                    ctx.lineWidth = 1;

                    this._drawBranch(this.barnesHutTree.root, ctx, color);
                }
            }
            /**
             * This function is for debugging purposes. It draws the branches recursively.
             *
             * @param {object} branch
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} color
             * @private
             */

        }, {
            key: "_drawBranch",
            value: function _drawBranch(branch, ctx, color) {
                if (color === undefined) {
                    color = "#FF0000";
                }

                if (branch.childrenCount === 4) {
                    this._drawBranch(branch.children.NW, ctx);

                    this._drawBranch(branch.children.NE, ctx);

                    this._drawBranch(branch.children.SE, ctx);

                    this._drawBranch(branch.children.SW, ctx);
                }

                ctx.strokeStyle = color;
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.minY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.minY);
                ctx.stroke();
                /*
	       if (branch.mass > 0) {
	       ctx.circle(branch.centerOfMass.x, branch.centerOfMass.y, 3*branch.mass);
	       ctx.stroke();
	       }
	       */
            }
        }]);

        return BarnesHutSolver;
    }();

    /**
     * Repulsion Solver
     */

    var RepulsionSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function RepulsionSolver(body, physicsBody, options) {
            _classCallCheck(this, RepulsionSolver);

            this._rng = Alea("REPULSION SOLVER");
            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(RepulsionSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * Calculate the forces the nodes apply on each other based on a repulsion field.
             * This field is linearly approximated.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, fx, fy, repulsingForce, node1, node2;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // repulsing forces between nodes

                var nodeDistance = this.options.nodeDistance; // approximation constants

                var a = -2 / 3 / nodeDistance;
                var b = 4 / 3; // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j

                for (var i = 0; i < nodeIndices.length - 1; i++) {
                    node1 = nodes[nodeIndices[i]];

                    for (var j = i + 1; j < nodeIndices.length; j++) {
                        node2 = nodes[nodeIndices[j]];
                        dx = node2.x - node1.x;
                        dy = node2.y - node1.y;
                        distance = Math.sqrt(dx * dx + dy * dy); // same condition as BarnesHutSolver, making sure nodes are never 100% overlapping.

                        if (distance === 0) {
                            distance = 0.1 * this._rng();
                            dx = distance;
                        }

                        if (distance < 2 * nodeDistance) {
                            if (distance < 0.5 * nodeDistance) {
                                repulsingForce = 1.0;
                            } else {
                                repulsingForce = a * distance + b; // linear approx of  1 / (1 + Math.exp((distance / nodeDistance - 1) * steepness))
                            }

                            repulsingForce = repulsingForce / distance;
                            fx = dx * repulsingForce;
                            fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }]);

        return RepulsionSolver;
    }();

    /**
     * Hierarchical Repulsion Solver
     */
    var HierarchicalRepulsionSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function HierarchicalRepulsionSolver(body, physicsBody, options) {
            _classCallCheck(this, HierarchicalRepulsionSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(HierarchicalRepulsionSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.overlapAvoidanceFactor = Math.max(0, Math.min(1, this.options.avoidOverlap || 0));
            }
            /**
             * Calculate the forces the nodes apply on each other based on a repulsion field.
             * This field is linearly approximated.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // repulsing forces between nodes

                var nodeDistance = this.options.nodeDistance; // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j

                for (var i = 0; i < nodeIndices.length - 1; i++) {
                    var node1 = nodes[nodeIndices[i]];

                    for (var j = i + 1; j < nodeIndices.length; j++) {
                        var node2 = nodes[nodeIndices[j]]; // nodes only affect nodes on their level

                        if (node1.level === node2.level) {
                            var theseNodesDistance = nodeDistance + this.overlapAvoidanceFactor * ((node1.shape.radius || 0) / 2 + (node2.shape.radius || 0) / 2);
                            var dx = node2.x - node1.x;
                            var dy = node2.y - node1.y;
                            var distance = Math.sqrt(dx * dx + dy * dy);
                            var steepness = 0.05;
                            var repulsingForce = void 0;

                            if (distance < theseNodesDistance) {
                                repulsingForce = -Math.pow(steepness * distance, 2) + Math.pow(steepness * theseNodesDistance, 2);
                            } else {
                                repulsingForce = 0;
                            } // normalize force with


                            if (distance !== 0) {
                                repulsingForce = repulsingForce / distance;
                            }

                            var fx = dx * repulsingForce;
                            var fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }]);

        return HierarchicalRepulsionSolver;
    }();

    /**
     * Spring Solver
     */
    var SpringSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function SpringSolver(body, physicsBody, options) {
            _classCallCheck(this, SpringSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(SpringSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * This function calculates the springforces on the nodes, accounting for the support nodes.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var edges = this.body.edges;
                var node1, node2, node3; // forces caused by the edges, modelled as springs

                for (var i = 0; i < edgeIndices.length; i++) {
                    edge = edges[edgeIndices[i]];

                    if (edge.connected === true && edge.toId !== edge.fromId) {
                        // only calculate forces if nodes are in the same sector
                        if (this.body.nodes[edge.toId] !== undefined && this.body.nodes[edge.fromId] !== undefined) {
                            if (edge.edgeType.via !== undefined) {
                                edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                                node1 = edge.to;
                                node2 = edge.edgeType.via;
                                node3 = edge.from;

                                this._calculateSpringForce(node1, node2, 0.5 * edgeLength);

                                this._calculateSpringForce(node2, node3, 0.5 * edgeLength);
                            } else {
                                // the * 1.5 is here so the edge looks as large as a smooth edge. It does not initially because the smooth edges use
                                // the support nodes which exert a repulsive force on the to and from nodes, making the edge appear larger.
                                edgeLength = edge.options.length === undefined ? this.options.springLength * 1.5 : edge.options.length;

                                this._calculateSpringForce(edge.from, edge.to, edgeLength);
                            }
                        }
                    }
                }
            }
            /**
             * This is the code actually performing the calculation for the function above.
             *
             * @param {Node} node1
             * @param {Node} node2
             * @param {number} edgeLength
             * @private
             */

        }, {
            key: "_calculateSpringForce",
            value: function _calculateSpringForce(node1, node2, edgeLength) {
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var distance = Math.max(Math.sqrt(dx * dx + dy * dy), 0.01); // the 1/distance is so the fx and fy can be calculated without sine or cosine.

                var springForce = this.options.springConstant * (edgeLength - distance) / distance;
                var fx = dx * springForce;
                var fy = dy * springForce; // handle the case where one node is not part of the physcis

                if (this.physicsBody.forces[node1.id] !== undefined) {
                    this.physicsBody.forces[node1.id].x += fx;
                    this.physicsBody.forces[node1.id].y += fy;
                }

                if (this.physicsBody.forces[node2.id] !== undefined) {
                    this.physicsBody.forces[node2.id].x -= fx;
                    this.physicsBody.forces[node2.id].y -= fy;
                }
            }
        }]);

        return SpringSolver;
    }();

    /**
     * Hierarchical Spring Solver
     */
    var HierarchicalSpringSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function HierarchicalSpringSolver(body, physicsBody, options) {
            _classCallCheck(this, HierarchicalSpringSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(HierarchicalSpringSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * This function calculates the springforces on the nodes, accounting for the support nodes.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var dx, dy, fx, fy, springForce, distance;
                var edges = this.body.edges;
                var factor = 0.5;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // initialize the spring force counters

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];
                    forces[nodeId].springFx = 0;
                    forces[nodeId].springFy = 0;
                } // forces caused by the edges, modelled as springs


                for (var _i = 0; _i < edgeIndices.length; _i++) {
                    edge = edges[edgeIndices[_i]];

                    if (edge.connected === true) {
                        edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                        dx = edge.from.x - edge.to.x;
                        dy = edge.from.y - edge.to.y;
                        distance = Math.sqrt(dx * dx + dy * dy);
                        distance = distance === 0 ? 0.01 : distance; // the 1/distance is so the fx and fy can be calculated without sine or cosine.

                        springForce = this.options.springConstant * (edgeLength - distance) / distance;
                        fx = dx * springForce;
                        fy = dy * springForce;

                        if (edge.to.level != edge.from.level) {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].springFx -= fx;
                                forces[edge.toId].springFy -= fy;
                            }

                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].springFx += fx;
                                forces[edge.fromId].springFy += fy;
                            }
                        } else {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].x -= factor * fx;
                                forces[edge.toId].y -= factor * fy;
                            }

                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].x += factor * fx;
                                forces[edge.fromId].y += factor * fy;
                            }
                        }
                    }
                } // normalize spring forces


                springForce = 1;
                var springFx, springFy;

                for (var _i2 = 0; _i2 < nodeIndices.length; _i2++) {
                    var _nodeId = nodeIndices[_i2];
                    springFx = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFx));
                    springFy = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFy));
                    forces[_nodeId].x += springFx;
                    forces[_nodeId].y += springFy;
                } // retain energy balance


                var totalFx = 0;
                var totalFy = 0;

                for (var _i3 = 0; _i3 < nodeIndices.length; _i3++) {
                    var _nodeId2 = nodeIndices[_i3];
                    totalFx += forces[_nodeId2].x;
                    totalFy += forces[_nodeId2].y;
                }

                var correctionFx = totalFx / nodeIndices.length;
                var correctionFy = totalFy / nodeIndices.length;

                for (var _i4 = 0; _i4 < nodeIndices.length; _i4++) {
                    var _nodeId3 = nodeIndices[_i4];
                    forces[_nodeId3].x -= correctionFx;
                    forces[_nodeId3].y -= correctionFy;
                }
            }
        }]);

        return HierarchicalSpringSolver;
    }();

    /**
     * Central Gravity Solver
     */
    var CentralGravitySolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function CentralGravitySolver(body, physicsBody, options) {
            _classCallCheck(this, CentralGravitySolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(CentralGravitySolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * Calculates forces for each node
             */

        }, {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, node;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];
                    node = nodes[nodeId];
                    dx = -node.x;
                    dy = -node.y;
                    distance = Math.sqrt(dx * dx + dy * dy);

                    this._calculateForces(distance, dx, dy, forces, node);
                }
            }
            /**
             * Calculate the forces based on the distance.
             *
             * @param {number} distance
             * @param {number} dx
             * @param {number} dy
             * @param {object<Node.id, vis.Node>} forces
             * @param {Node} node
             * @private
             */

        }, {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                var gravityForce = distance === 0 ? 0 : this.options.centralGravity / distance;
                forces[node.id].x = dx * gravityForce;
                forces[node.id].y = dy * gravityForce;
            }
        }]);

        return CentralGravitySolver;
    }();

    function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * @augments BarnesHutSolver
     */

    var ForceAtlas2BasedRepulsionSolver = /*#__PURE__*/function (_BarnesHutSolver) {
        _inherits(ForceAtlas2BasedRepulsionSolver, _BarnesHutSolver);

        var _super = _createSuper$3(ForceAtlas2BasedRepulsionSolver);

        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function ForceAtlas2BasedRepulsionSolver(body, physicsBody, options) {
            var _this;

            _classCallCheck(this, ForceAtlas2BasedRepulsionSolver);

            _this = _super.call(this, body, physicsBody, options);
            _this._rng = Alea("FORCE ATLAS 2 BASED REPULSION SOLVER");
            return _this;
        }
        /**
         * Calculate the forces based on the distance.
         *
         * @param {number} distance
         * @param {number} dx
         * @param {number} dy
         * @param {Node} node
         * @param {object} parentBranch
         * @private
         */


        _createClass(ForceAtlas2BasedRepulsionSolver, [{
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1 * this._rng();
                    dx = distance;
                }

                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
                    distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                }

                var degree = node.edges.length + 1; // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce

                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass * degree / Math.pow(distance, 2);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
        }]);

        return ForceAtlas2BasedRepulsionSolver;
    }(BarnesHutSolver);

    function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * @augments CentralGravitySolver
     */

    var ForceAtlas2BasedCentralGravitySolver = /*#__PURE__*/function (_CentralGravitySolver) {
        _inherits(ForceAtlas2BasedCentralGravitySolver, _CentralGravitySolver);

        var _super = _createSuper$2(ForceAtlas2BasedCentralGravitySolver);

        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function ForceAtlas2BasedCentralGravitySolver(body, physicsBody, options) {
            _classCallCheck(this, ForceAtlas2BasedCentralGravitySolver);

            return _super.call(this, body, physicsBody, options);
        }
        /**
         * Calculate the forces based on the distance.
         *
         * @param {number} distance
         * @param {number} dx
         * @param {number} dy
         * @param {object<Node.id, Node>} forces
         * @param {Node} node
         * @private
         */


        _createClass(ForceAtlas2BasedCentralGravitySolver, [{
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                if (distance > 0) {
                    var degree = node.edges.length + 1;
                    var gravityForce = this.options.centralGravity * degree * node.options.mass;
                    forces[node.id].x = dx * gravityForce;
                    forces[node.id].y = dy * gravityForce;
                }
            }
        }]);

        return ForceAtlas2BasedCentralGravitySolver;
    }(CentralGravitySolver);

    /**
     * The physics engine
     */

    var PhysicsEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function PhysicsEngine(body) {
            _classCallCheck(this, PhysicsEngine);

            this.body = body;
            this.physicsBody = {
                physicsNodeIndices: [],
                physicsEdgeIndices: [],
                forces: {},
                velocities: {}
            };
            this.physicsEnabled = true;
            this.simulationInterval = 1000 / 60;
            this.requiresTimeout = true;
            this.previousStates = {};
            this.referenceState = {};
            this.freezeCache = {};
            this.renderTimer = undefined; // parameters for the adaptive timestep

            this.adaptiveTimestep = false;
            this.adaptiveTimestepEnabled = false;
            this.adaptiveCounter = 0;
            this.adaptiveInterval = 3;
            this.stabilized = false;
            this.startedStabilization = false;
            this.stabilizationIterations = 0;
            this.ready = false; // will be set to true if the stabilize
            // default options

            this.options = {};
            this.defaultOptions = {
                enabled: true,
                barnesHut: {
                    theta: 0.5,
                    gravitationalConstant: -2000,
                    centralGravity: 0.3,
                    springLength: 95,
                    springConstant: 0.04,
                    damping: 0.09,
                    avoidOverlap: 0
                },
                forceAtlas2Based: {
                    theta: 0.5,
                    gravitationalConstant: -50,
                    centralGravity: 0.01,
                    springConstant: 0.08,
                    springLength: 100,
                    damping: 0.4,
                    avoidOverlap: 0
                },
                repulsion: {
                    centralGravity: 0.2,
                    springLength: 200,
                    springConstant: 0.05,
                    nodeDistance: 100,
                    damping: 0.09,
                    avoidOverlap: 0
                },
                hierarchicalRepulsion: {
                    centralGravity: 0.0,
                    springLength: 100,
                    springConstant: 0.01,
                    nodeDistance: 120,
                    damping: 0.09
                },
                maxVelocity: 50,
                minVelocity: 0.75,
                // px/s
                solver: "barnesHut",
                stabilization: {
                    enabled: true,
                    iterations: 1000,
                    // maximum number of iteration to stabilize
                    updateInterval: 50,
                    onlyDynamicEdges: false,
                    fit: true
                },
                timestep: 0.5,
                adaptiveTimestep: true,
                wind: {
                    x: 0,
                    y: 0
                }
            };

            assign$2(this.options, this.defaultOptions);

            this.timestep = 0.5;
            this.layoutFailed = false;
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(PhysicsEngine, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;

                this.body.emitter.on("initPhysics", function () {
                    _this.initPhysics();
                });
                this.body.emitter.on("_layoutFailed", function () {
                    _this.layoutFailed = true;
                });
                this.body.emitter.on("resetPhysics", function () {
                    _this.stopSimulation();

                    _this.ready = false;
                });
                this.body.emitter.on("disablePhysics", function () {
                    _this.physicsEnabled = false;

                    _this.stopSimulation();
                });
                this.body.emitter.on("restorePhysics", function () {
                    _this.setOptions(_this.options);

                    if (_this.ready === true) {
                        _this.startSimulation();
                    }
                });
                this.body.emitter.on("startSimulation", function () {
                    if (_this.ready === true) {
                        _this.startSimulation();
                    }
                });
                this.body.emitter.on("stopSimulation", function () {
                    _this.stopSimulation();
                });
                this.body.emitter.on("destroy", function () {
                    _this.stopSimulation(false);

                    _this.body.emitter.off();
                });
                this.body.emitter.on("_dataChanged", function () {
                    // Nodes and/or edges have been added or removed, update shortcut lists.
                    _this.updatePhysicsData();
                }); // debug: show forces
                // this.body.emitter.on("afterDrawing", (ctx) => {this._drawForces(ctx);});
            }
            /**
             * set the physics options
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    if (options === false) {
                        this.options.enabled = false;
                        this.physicsEnabled = false;
                        this.stopSimulation();
                    } else if (options === true) {
                        this.options.enabled = true;
                        this.physicsEnabled = true;
                        this.startSimulation();
                    } else {
                        this.physicsEnabled = true;
                        selectiveNotDeepExtend(["stabilization"], this.options, options);
                        mergeOptions(this.options, options, "stabilization");

                        if (options.enabled === undefined) {
                            this.options.enabled = true;
                        }

                        if (this.options.enabled === false) {
                            this.physicsEnabled = false;
                            this.stopSimulation();
                        }

                        var wind = this.options.wind;

                        if (wind) {
                            if (typeof wind.x !== "number" || isNan(wind.x)) {
                                wind.x = 0;
                            }

                            if (typeof wind.y !== "number" || isNan(wind.y)) {
                                wind.y = 0;
                            }
                        } // set the timestep


                        this.timestep = this.options.timestep;
                    }
                }

                this.init();
            }
            /**
             * configure the engine.
             */

        }, {
            key: "init",
            value: function init() {
                var options;

                if (this.options.solver === "forceAtlas2Based") {
                    options = this.options.forceAtlas2Based;
                    this.nodesSolver = new ForceAtlas2BasedRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new ForceAtlas2BasedCentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "repulsion") {
                    options = this.options.repulsion;
                    this.nodesSolver = new RepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "hierarchicalRepulsion") {
                    options = this.options.hierarchicalRepulsion;
                    this.nodesSolver = new HierarchicalRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new HierarchicalSpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                } else {
                    // barnesHut
                    options = this.options.barnesHut;
                    this.nodesSolver = new BarnesHutSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                }

                this.modelOptions = options;
            }
            /**
             * initialize the engine
             */

        }, {
            key: "initPhysics",
            value: function initPhysics() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    if (this.options.stabilization.enabled === true) {
                        this.stabilize();
                    } else {
                        this.stabilized = false;
                        this.ready = true;
                        this.body.emitter.emit("fit", {}, this.layoutFailed); // if the layout failed, we use the approximation for the zoom

                        this.startSimulation();
                    }
                } else {
                    this.ready = true;
                    this.body.emitter.emit("fit");
                }
            }
            /**
             * Start the simulation
             */

        }, {
            key: "startSimulation",
            value: function startSimulation() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    this.stabilized = false; // when visible, adaptivity is disabled.

                    this.adaptiveTimestep = false; // this sets the width of all nodes initially which could be required for the avoidOverlap

                    this.body.emitter.emit("_resizeNodes");

                    if (this.viewFunction === undefined) {
                        var _context;

                        this.viewFunction = bind(_context = this.simulationStep).call(_context, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                        this.body.emitter.emit("_startRendering");
                    }
                } else {
                    this.body.emitter.emit("_redraw");
                }
            }
            /**
             * Stop the simulation, force stabilization.
             *
             * @param {boolean} [emit=true]
             */

        }, {
            key: "stopSimulation",
            value: function stopSimulation() {
                var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.stabilized = true;

                if (emit === true) {
                    this._emitStabilized();
                }

                if (this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.viewFunction = undefined;

                    if (emit === true) {
                        this.body.emitter.emit("_stopRendering");
                    }
                }
            }
            /**
             * The viewFunction inserts this step into each render loop. It calls the physics tick and handles the cleanup at stabilized.
             *
             */

        }, {
            key: "simulationStep",
            value: function simulationStep() {
                // check if the physics have settled
                var startTime = now$1();

                this.physicsTick();
                var physicsTime = now$1() - startTime; // run double speed if it is a little graph

                if ((physicsTime < 0.4 * this.simulationInterval || this.runDoubleSpeed === true) && this.stabilized === false) {
                    this.physicsTick(); // this makes sure there is no jitter. The decision is taken once to run it at double speed.

                    this.runDoubleSpeed = true;
                }

                if (this.stabilized === true) {
                    this.stopSimulation();
                }
            }
            /**
             * trigger the stabilized event.
             *
             * @param {number} [amountOfIterations=this.stabilizationIterations]
             * @private
             */

        }, {
            key: "_emitStabilized",
            value: function _emitStabilized() {
                var _this2 = this;

                var amountOfIterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stabilizationIterations;

                if (this.stabilizationIterations > 1 || this.startedStabilization === true) {
                    setTimeout$1(function () {
                        _this2.body.emitter.emit("stabilized", {
                            iterations: amountOfIterations
                        });

                        _this2.startedStabilization = false;
                        _this2.stabilizationIterations = 0;
                    }, 0);
                }
            }
            /**
             * Calculate the forces for one physics iteration and move the nodes.
             *
             * @private
             */

        }, {
            key: "physicsStep",
            value: function physicsStep() {
                this.gravitySolver.solve();
                this.nodesSolver.solve();
                this.edgesSolver.solve();
                this.moveNodes();
            }
            /**
             * Make dynamic adjustments to the timestep, based on current state.
             *
             * Helper function for physicsTick().
             *
             * @private
             */

        }, {
            key: "adjustTimeStep",
            value: function adjustTimeStep() {
                var factor = 1.2; // Factor for increasing the timestep on success.
                // we compare the two steps. if it is acceptable we double the step.

                if (this._evaluateStepQuality() === true) {
                    this.timestep = factor * this.timestep;
                } else {
                    // if not, we decrease the step to a minimum of the options timestep.
                    // if the decreased timestep is smaller than the options step, we do not reset the counter
                    // we assume that the options timestep is stable enough.
                    if (this.timestep / factor < this.options.timestep) {
                        this.timestep = this.options.timestep;
                    } else {
                        // if the timestep was larger than 2 times the option one we check the adaptivity again to ensure
                        // that large instabilities do not form.
                        this.adaptiveCounter = -1; // check again next iteration

                        this.timestep = Math.max(this.options.timestep, this.timestep / factor);
                    }
                }
            }
            /**
             * A single simulation step (or 'tick') in the physics simulation
             *
             * @private
             */

        }, {
            key: "physicsTick",
            value: function physicsTick() {
                this._startStabilizing(); // this ensures that there is no start event when the network is already stable.


                if (this.stabilized === true) return; // adaptivity means the timestep adapts to the situation, only applicable for stabilization

                if (this.adaptiveTimestep === true && this.adaptiveTimestepEnabled === true) {
                    // timestep remains stable for "interval" iterations.
                    var doAdaptive = this.adaptiveCounter % this.adaptiveInterval === 0;

                    if (doAdaptive) {
                        // first the big step and revert.
                        this.timestep = 2 * this.timestep;
                        this.physicsStep();
                        this.revert(); // saves the reference state
                        // now the normal step. Since this is the last step, it is the more stable one and we will take this.

                        this.timestep = 0.5 * this.timestep; // since it's half the step, we do it twice.

                        this.physicsStep();
                        this.physicsStep();
                        this.adjustTimeStep();
                    } else {
                        this.physicsStep(); // normal step, keeping timestep constant
                    }

                    this.adaptiveCounter += 1;
                } else {
                    // case for the static timestep, we reset it to the one in options and take a normal step.
                    this.timestep = this.options.timestep;
                    this.physicsStep();
                }

                if (this.stabilized === true) this.revert();
                this.stabilizationIterations++;
            }
            /**
             * Nodes and edges can have the physics toggles on or off. A collection of indices is created here so we can skip the check all the time.
             *
             * @private
             */

        }, {
            key: "updatePhysicsData",
            value: function updatePhysicsData() {
                this.physicsBody.forces = {};
                this.physicsBody.physicsNodeIndices = [];
                this.physicsBody.physicsEdgeIndices = [];
                var nodes = this.body.nodes;
                var edges = this.body.edges; // get node indices for physics

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (nodes[nodeId].options.physics === true) {
                            this.physicsBody.physicsNodeIndices.push(nodes[nodeId].id);
                        }
                    }
                } // get edge indices for physics


                for (var edgeId in edges) {
                    if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
                        if (edges[edgeId].options.physics === true) {
                            this.physicsBody.physicsEdgeIndices.push(edges[edgeId].id);
                        }
                    }
                } // get the velocity and the forces vector


                for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
                    var _nodeId = this.physicsBody.physicsNodeIndices[i];
                    this.physicsBody.forces[_nodeId] = {
                        x: 0,
                        y: 0
                    }; // forces can be reset because they are recalculated. Velocities have to persist.

                    if (this.physicsBody.velocities[_nodeId] === undefined) {
                        this.physicsBody.velocities[_nodeId] = {
                            x: 0,
                            y: 0
                        };
                    }
                } // clean deleted nodes from the velocity vector


                for (var _nodeId2 in this.physicsBody.velocities) {
                    if (nodes[_nodeId2] === undefined) {
                        delete this.physicsBody.velocities[_nodeId2];
                    }
                }
            }
            /**
             * Revert the simulation one step. This is done so after stabilization, every new start of the simulation will also say stabilized.
             */

        }, {
            key: "revert",
            value: function revert() {
                var nodeIds = keys$3(this.previousStates);

                var nodes = this.body.nodes;
                var velocities = this.physicsBody.velocities;
                this.referenceState = {};

                for (var i = 0; i < nodeIds.length; i++) {
                    var nodeId = nodeIds[i];

                    if (nodes[nodeId] !== undefined) {
                        if (nodes[nodeId].options.physics === true) {
                            this.referenceState[nodeId] = {
                                positions: {
                                    x: nodes[nodeId].x,
                                    y: nodes[nodeId].y
                                }
                            };
                            velocities[nodeId].x = this.previousStates[nodeId].vx;
                            velocities[nodeId].y = this.previousStates[nodeId].vy;
                            nodes[nodeId].x = this.previousStates[nodeId].x;
                            nodes[nodeId].y = this.previousStates[nodeId].y;
                        }
                    } else {
                        delete this.previousStates[nodeId];
                    }
                }
            }
            /**
             * This compares the reference state to the current state
             *
             * @returns {boolean}
             * @private
             */

        }, {
            key: "_evaluateStepQuality",
            value: function _evaluateStepQuality() {
                var dx, dy, dpos;
                var nodes = this.body.nodes;
                var reference = this.referenceState;
                var posThreshold = 0.3;

                for (var nodeId in this.referenceState) {
                    if (Object.prototype.hasOwnProperty.call(this.referenceState, nodeId) && nodes[nodeId] !== undefined) {
                        dx = nodes[nodeId].x - reference[nodeId].positions.x;
                        dy = nodes[nodeId].y - reference[nodeId].positions.y;
                        dpos = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

                        if (dpos > posThreshold) {
                            return false;
                        }
                    }
                }

                return true;
            }
            /**
             * move the nodes one timestep and check if they are stabilized
             */

        }, {
            key: "moveNodes",
            value: function moveNodes() {
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var maxNodeVelocity = 0;
                var averageNodeVelocity = 0; // the velocity threshold (energy in the system) for the adaptivity toggle

                var velocityAdaptiveThreshold = 5;

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];

                    var nodeVelocity = this._performStep(nodeId); // stabilized is true if stabilized is true and velocity is smaller than vmin --> all nodes must be stabilized


                    maxNodeVelocity = Math.max(maxNodeVelocity, nodeVelocity);
                    averageNodeVelocity += nodeVelocity;
                } // evaluating the stabilized and adaptiveTimestepEnabled conditions


                this.adaptiveTimestepEnabled = averageNodeVelocity / nodeIndices.length < velocityAdaptiveThreshold;
                this.stabilized = maxNodeVelocity < this.options.minVelocity;
            }
            /**
             * Calculate new velocity for a coordinate direction
             *
             * @param {number} v  velocity for current coordinate
             * @param {number} f  regular force for current coordinate
             * @param {number} m  mass of current node
             * @returns {number} new velocity for current coordinate
             * @private
             */

        }, {
            key: "calculateComponentVelocity",
            value: function calculateComponentVelocity(v, f, m) {
                var df = this.modelOptions.damping * v; // damping force

                var a = (f - df) / m; // acceleration

                v += a * this.timestep; // Put a limit on the velocities if it is really high

                var maxV = this.options.maxVelocity || 1e9;

                if (Math.abs(v) > maxV) {
                    v = v > 0 ? maxV : -maxV;
                }

                return v;
            }
            /**
             * Perform the actual step
             *
             * @param {Node.id} nodeId
             * @returns {number} the new velocity of given node
             * @private
             */

        }, {
            key: "_performStep",
            value: function _performStep(nodeId) {
                var node = this.body.nodes[nodeId];
                var force = this.physicsBody.forces[nodeId];

                if (this.options.wind) {
                    force.x += this.options.wind.x;
                    force.y += this.options.wind.y;
                }

                var velocity = this.physicsBody.velocities[nodeId]; // store the state so we can revert

                this.previousStates[nodeId] = {
                    x: node.x,
                    y: node.y,
                    vx: velocity.x,
                    vy: velocity.y
                };

                if (node.options.fixed.x === false) {
                    velocity.x = this.calculateComponentVelocity(velocity.x, force.x, node.options.mass);
                    node.x += velocity.x * this.timestep;
                } else {
                    force.x = 0;
                    velocity.x = 0;
                }

                if (node.options.fixed.y === false) {
                    velocity.y = this.calculateComponentVelocity(velocity.y, force.y, node.options.mass);
                    node.y += velocity.y * this.timestep;
                } else {
                    force.y = 0;
                    velocity.y = 0;
                }

                var totalVelocity = Math.sqrt(Math.pow(velocity.x, 2) + Math.pow(velocity.y, 2));
                return totalVelocity;
            }
            /**
             * When initializing and stabilizing, we can freeze nodes with a predefined position.
             * This greatly speeds up stabilization because only the supportnodes for the smoothCurves have to settle.
             *
             * @private
             */

        }, {
            key: "_freezeNodes",
            value: function _freezeNodes() {
                var nodes = this.body.nodes;

                for (var id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (nodes[id].x && nodes[id].y) {
                            var fixed = nodes[id].options.fixed;
                            this.freezeCache[id] = {
                                x: fixed.x,
                                y: fixed.y
                            };
                            fixed.x = true;
                            fixed.y = true;
                        }
                    }
                }
            }
            /**
             * Unfreezes the nodes that have been frozen by _freezeDefinedNodes.
             *
             * @private
             */

        }, {
            key: "_restoreFrozenNodes",
            value: function _restoreFrozenNodes() {
                var nodes = this.body.nodes;

                for (var id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (this.freezeCache[id] !== undefined) {
                            nodes[id].options.fixed.x = this.freezeCache[id].x;
                            nodes[id].options.fixed.y = this.freezeCache[id].y;
                        }
                    }
                }

                this.freezeCache = {};
            }
            /**
             * Find a stable position for all nodes
             *
             * @param {number} [iterations=this.options.stabilization.iterations]
             */

        }, {
            key: "stabilize",
            value: function stabilize() {
                var _this3 = this;

                var iterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.stabilization.iterations;

                if (typeof iterations !== "number") {
                    iterations = this.options.stabilization.iterations;
                    console.error("The stabilize method needs a numeric amount of iterations. Switching to default: ", iterations);
                }

                if (this.physicsBody.physicsNodeIndices.length === 0) {
                    this.ready = true;
                    return;
                } // enable adaptive timesteps


                this.adaptiveTimestep = this.options.adaptiveTimestep; // this sets the width of all nodes initially which could be required for the avoidOverlap

                this.body.emitter.emit("_resizeNodes");
                this.stopSimulation(); // stop the render loop

                this.stabilized = false; // block redraw requests

                this.body.emitter.emit("_blockRedraw");
                this.targetIterations = iterations; // start the stabilization

                if (this.options.stabilization.onlyDynamicEdges === true) {
                    this._freezeNodes();
                }

                this.stabilizationIterations = 0;

                setTimeout$1(function () {
                    return _this3._stabilizationBatch();
                }, 0);
            }
            /**
             * If not already stabilizing, start it and emit a start event.
             *
             * @returns {boolean} true if stabilization started with this call
             * @private
             */

        }, {
            key: "_startStabilizing",
            value: function _startStabilizing() {
                if (this.startedStabilization === true) return false;
                this.body.emitter.emit("startStabilizing");
                this.startedStabilization = true;
                return true;
            }
            /**
             * One batch of stabilization
             *
             * @private
             */

        }, {
            key: "_stabilizationBatch",
            value: function _stabilizationBatch() {
                var _this4 = this;

                var running = function running() {
                    return _this4.stabilized === false && _this4.stabilizationIterations < _this4.targetIterations;
                };

                var sendProgress = function sendProgress() {
                    _this4.body.emitter.emit("stabilizationProgress", {
                        iterations: _this4.stabilizationIterations,
                        total: _this4.targetIterations
                    });
                };

                if (this._startStabilizing()) {
                    sendProgress(); // Ensure that there is at least one start event.
                }

                var count = 0;

                while (running() && count < this.options.stabilization.updateInterval) {
                    this.physicsTick();
                    count++;
                }

                sendProgress();

                if (running()) {
                    var _context2;

                    setTimeout$1(bind(_context2 = this._stabilizationBatch).call(_context2, this), 0);
                } else {
                    this._finalizeStabilization();
                }
            }
            /**
             * Wrap up the stabilization, fit and emit the events.
             *
             * @private
             */

        }, {
            key: "_finalizeStabilization",
            value: function _finalizeStabilization() {
                this.body.emitter.emit("_allowRedraw");

                if (this.options.stabilization.fit === true) {
                    this.body.emitter.emit("fit");
                }

                if (this.options.stabilization.onlyDynamicEdges === true) {
                    this._restoreFrozenNodes();
                }

                this.body.emitter.emit("stabilizationIterationsDone");
                this.body.emitter.emit("_requestRedraw");

                if (this.stabilized === true) {
                    this._emitStabilized();
                } else {
                    this.startSimulation();
                }

                this.ready = true;
            } //---------------------------  DEBUGGING BELOW  ---------------------------//

            /**
             * Debug function that display arrows for the forces currently active in the network.
             *
             * Use this when debugging only.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @private
             */

        }, {
            key: "_drawForces",
            value: function _drawForces(ctx) {
                for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
                    var index = this.physicsBody.physicsNodeIndices[i];
                    var node = this.body.nodes[index];
                    var force = this.physicsBody.forces[index];
                    var factor = 20;
                    var colorFactor = 0.03;
                    var forceSize = Math.sqrt(Math.pow(force.x, 2) + Math.pow(force.x, 2));
                    var size = Math.min(Math.max(5, forceSize), 15);
                    var arrowSize = 3 * size;
                    var color = HSVToHex((180 - Math.min(1, Math.max(0, colorFactor * forceSize)) * 180) / 360, 1, 1);
                    var point = {
                        x: node.x + factor * force.x,
                        y: node.y + factor * force.y
                    };
                    ctx.lineWidth = size;
                    ctx.strokeStyle = color;
                    ctx.beginPath();
                    ctx.moveTo(node.x, node.y);
                    ctx.lineTo(point.x, point.y);
                    ctx.stroke();
                    var angle = Math.atan2(force.y, force.x);
                    ctx.fillStyle = color;
                    EndPoints.draw(ctx, {
                        type: "arrow",
                        point: point,
                        angle: angle,
                        length: arrowSize
                    });

                    fill(ctx).call(ctx);
                }
            }
        }]);

        return PhysicsEngine;
    }();

    /**
     * Utility Class
     */

    var NetworkUtil = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function NetworkUtil() {
            _classCallCheck(this, NetworkUtil);
        }
        /**
         * Find the center position of the network considering the bounding boxes
         *
         * @param {Array.<Node>} allNodes
         * @param {Array.<Node>} [specificNodes=[]]
         * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
         * @static
         */


        _createClass(NetworkUtil, null, [{
            key: "getRange",
            value: function getRange(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9,
                    maxY = -1e9,
                    minX = 1e9,
                    maxX = -1e9,
                    node;

                if (specificNodes.length > 0) {
                    for (var i = 0; i < specificNodes.length; i++) {
                        node = allNodes[specificNodes[i]];

                        if (minX > node.shape.boundingBox.left) {
                            minX = node.shape.boundingBox.left;
                        }

                        if (maxX < node.shape.boundingBox.right) {
                            maxX = node.shape.boundingBox.right;
                        }

                        if (minY > node.shape.boundingBox.top) {
                            minY = node.shape.boundingBox.top;
                        } // top is negative, bottom is positive


                        if (maxY < node.shape.boundingBox.bottom) {
                            maxY = node.shape.boundingBox.bottom;
                        } // top is negative, bottom is positive

                    }
                }

                if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
                    minY = 0, maxY = 0, minX = 0, maxX = 0;
                }

                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
            /**
             * Find the center position of the network
             *
             * @param {Array.<Node>} allNodes
             * @param {Array.<Node>} [specificNodes=[]]
             * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
             * @static
             */

        }, {
            key: "getRangeCore",
            value: function getRangeCore(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9,
                    maxY = -1e9,
                    minX = 1e9,
                    maxX = -1e9,
                    node;

                if (specificNodes.length > 0) {
                    for (var i = 0; i < specificNodes.length; i++) {
                        node = allNodes[specificNodes[i]];

                        if (minX > node.x) {
                            minX = node.x;
                        }

                        if (maxX < node.x) {
                            maxX = node.x;
                        }

                        if (minY > node.y) {
                            minY = node.y;
                        } // top is negative, bottom is positive


                        if (maxY < node.y) {
                            maxY = node.y;
                        } // top is negative, bottom is positive

                    }
                }

                if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
                    minY = 0, maxY = 0, minX = 0, maxX = 0;
                }

                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
            /**
             * @param {object} range = {minX: minX, maxX: maxX, minY: minY, maxY: maxY};
             * @returns {{x: number, y: number}}
             * @static
             */

        }, {
            key: "findCenter",
            value: function findCenter(range) {
                return {
                    x: 0.5 * (range.maxX + range.minX),
                    y: 0.5 * (range.maxY + range.minY)
                };
            }
            /**
             * This returns a clone of the options or options of the edge or node to be used for construction of new edges or check functions for new nodes.
             *
             * @param {vis.Item} item
             * @param {'node'|undefined} type
             * @returns {{}}
             * @static
             */

        }, {
            key: "cloneOptions",
            value: function cloneOptions(item, type) {
                var clonedOptions = {};

                if (type === undefined || type === "node") {
                    deepExtend(clonedOptions, item.options, true);
                    clonedOptions.x = item.x;
                    clonedOptions.y = item.y;
                    clonedOptions.amountOfConnections = item.edges.length;
                } else {
                    deepExtend(clonedOptions, item.options, true);
                }

                return clonedOptions;
            }
        }]);

        return NetworkUtil;
    }();

    function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Cluster is a special Node that allows a group of Nodes positioned closely together
     * to be represented by a single Cluster Node.
     *
     * @augments Node
     */

    var Cluster = /*#__PURE__*/function (_Node) {
        _inherits(Cluster, _Node);

        var _super = _createSuper$1(Cluster);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Array.<HTMLImageElement>}imagelist
         * @param {Array} grouplist
         * @param {object} globalOptions
         * @param {object} defaultOptions     Global default options for nodes
         */
        function Cluster(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
            var _this;

            _classCallCheck(this, Cluster);

            _this = _super.call(this, options, body, imagelist, grouplist, globalOptions, defaultOptions);
            _this.isCluster = true;
            _this.containedNodes = {};
            _this.containedEdges = {};
            return _this;
        }
        /**
         * Transfer child cluster data to current and disconnect the child cluster.
         *
         * Please consult the header comment in 'Clustering.js' for the fields set here.
         *
         * @param {string|number} childClusterId  id of child cluster to open
         */


        _createClass(Cluster, [{
            key: "_openChildCluster",
            value: function _openChildCluster(childClusterId) {
                var _this2 = this;

                var childCluster = this.body.nodes[childClusterId];

                if (this.containedNodes[childClusterId] === undefined) {
                    throw new Error("node with id: " + childClusterId + " not in current cluster");
                }

                if (!childCluster.isCluster) {
                    throw new Error("node with id: " + childClusterId + " is not a cluster");
                } // Disconnect child cluster from current cluster


                delete this.containedNodes[childClusterId];
                forEach$1(childCluster.edges, function (edge) {
                    delete _this2.containedEdges[edge.id];
                }); // Transfer nodes and edges

                forEach$1(childCluster.containedNodes, function (node, nodeId) {
                    _this2.containedNodes[nodeId] = node;
                });
                childCluster.containedNodes = {};
                forEach$1(childCluster.containedEdges, function (edge, edgeId) {
                    _this2.containedEdges[edgeId] = edge;
                });
                childCluster.containedEdges = {}; // Transfer edges within cluster edges which are clustered

                forEach$1(childCluster.edges, function (clusterEdge) {
                    forEach$1(_this2.edges, function (parentClusterEdge) {
                        var _context, _context2;

                        // Assumption: a clustered edge can only be present in a single clustering edge
                        // Not tested here
                        var index = indexOf(_context = parentClusterEdge.clusteringEdgeReplacingIds).call(_context, clusterEdge.id);

                        if (index === -1) return;
                        forEach$1(clusterEdge.clusteringEdgeReplacingIds, function (srcId) {
                            parentClusterEdge.clusteringEdgeReplacingIds.push(srcId); // Maintain correct bookkeeping for transferred edge

                            _this2.body.edges[srcId].edgeReplacedById = parentClusterEdge.id;
                        }); // Remove cluster edge from parent cluster edge

                        splice(_context2 = parentClusterEdge.clusteringEdgeReplacingIds).call(_context2, index, 1);
                    });
                });
                childCluster.edges = [];
            }
        }]);

        return Cluster;
    }(Node);

    /**
     * The clustering engine
     */

    var ClusterEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function ClusterEngine(body) {
            var _this = this;

            _classCallCheck(this, ClusterEngine);

            this.body = body;
            this.clusteredNodes = {}; // key: node id, value: { clusterId: <id of cluster>, node: <node instance>}

            this.clusteredEdges = {}; // key: edge id, value: restore information for given edge

            this.options = {};
            this.defaultOptions = {};

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("_resetData", function () {
                _this.clusteredNodes = {};
                _this.clusteredEdges = {};
            });
        }
        /**
         *
         * @param {number} hubsize
         * @param {object} options
         */


        _createClass(ClusterEngine, [{
            key: "clusterByHubsize",
            value: function clusterByHubsize(hubsize, options) {
                if (hubsize === undefined) {
                    hubsize = this._getHubSize();
                } else if (_typeof(hubsize) === "object") {
                    options = this._checkOptions(hubsize);
                    hubsize = this._getHubSize();
                }

                var nodesToCluster = [];

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];

                    if (node.edges.length >= hubsize) {
                        nodesToCluster.push(node.id);
                    }
                }

                for (var _i = 0; _i < nodesToCluster.length; _i++) {
                    this.clusterByConnection(nodesToCluster[_i], options, true);
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * loop over all nodes, check if they adhere to the condition and cluster if needed.
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "cluster",
            value: function cluster() {
                var _this2 = this;

                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                if (options.joinCondition === undefined) {
                    throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");
                } // check if the options object is fine, append if needed


                options = this._checkOptions(options);
                var childNodesObj = {};
                var childEdgesObj = {}; // collect the nodes that will be in the cluster

                forEach$1(this.body.nodes, function (node, nodeId) {
                    if (node.options && options.joinCondition(node.options) === true) {
                        childNodesObj[nodeId] = node; // collect the edges that will be in the cluster

                        forEach$1(node.edges, function (edge) {
                            if (_this2.clusteredEdges[edge.id] === undefined) {
                                childEdgesObj[edge.id] = edge;
                            }
                        });
                    }
                });

                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
            /**
             * Cluster all nodes in the network that have only X edges
             *
             * @param {number} edgeCount
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterByEdgeCount",
            value: function clusterByEdgeCount(edgeCount, options) {
                var _this3 = this;

                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                options = this._checkOptions(options);
                var clusters = [];
                var usedNodes = {};
                var edge, edges, relevantEdgeCount; // collect the nodes that will be in the cluster

                var _loop = function _loop(i) {
                    var childNodesObj = {};
                    var childEdgesObj = {};
                    var nodeId = _this3.body.nodeIndices[i];
                    var node = _this3.body.nodes[nodeId]; // if this node is already used in another cluster this session, we do not have to re-evaluate it.

                    if (usedNodes[nodeId] === undefined) {
                        relevantEdgeCount = 0;
                        edges = [];

                        for (var j = 0; j < node.edges.length; j++) {
                            edge = node.edges[j];

                            if (_this3.clusteredEdges[edge.id] === undefined) {
                                if (edge.toId !== edge.fromId) {
                                    relevantEdgeCount++;
                                }

                                edges.push(edge);
                            }
                        } // this node qualifies, we collect its neighbours to start the clustering process.


                        if (relevantEdgeCount === edgeCount) {
                            var checkJoinCondition = function checkJoinCondition(node) {
                                if (options.joinCondition === undefined || options.joinCondition === null) {
                                    return true;
                                }

                                var clonedOptions = NetworkUtil.cloneOptions(node);
                                return options.joinCondition(clonedOptions);
                            };

                            var gatheringSuccessful = true;

                            for (var _j = 0; _j < edges.length; _j++) {
                                edge = edges[_j];

                                var childNodeId = _this3._getConnectedId(edge, nodeId); // add the nodes to the list by the join condition.


                                if (checkJoinCondition(node)) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[nodeId] = node;
                                    childNodesObj[childNodeId] = _this3.body.nodes[childNodeId];
                                    usedNodes[nodeId] = true;
                                } else {
                                    // this node does not qualify after all.
                                    gatheringSuccessful = false;
                                    break;
                                }
                            } // add to the cluster queue


                            if (keys$3(childNodesObj).length > 0 && keys$3(childEdgesObj).length > 0 && gatheringSuccessful === true) {
                                /**
                                 * Search for cluster data that contains any of the node id's
                                 *
                                 * @returns {boolean} true if no joinCondition, otherwise return value of joinCondition
                                 */
                                var findClusterData = function findClusterData() {
                                    for (var n = 0; n < clusters.length; ++n) {
                                        // Search for a cluster containing any of the node id's
                                        for (var m in childNodesObj) {
                                            if (clusters[n].nodes[m] !== undefined) {
                                                return clusters[n];
                                            }
                                        }
                                    }

                                    return undefined;
                                }; // If any of the found nodes is part of a cluster found in this method,
                                // add the current values to that cluster


                                var foundCluster = findClusterData();

                                if (foundCluster !== undefined) {
                                    // Add nodes to found cluster if not present
                                    for (var m in childNodesObj) {
                                        if (foundCluster.nodes[m] === undefined) {
                                            foundCluster.nodes[m] = childNodesObj[m];
                                        }
                                    } // Add edges to found cluster, if not present


                                    for (var _m in childEdgesObj) {
                                        if (foundCluster.edges[_m] === undefined) {
                                            foundCluster.edges[_m] = childEdgesObj[_m];
                                        }
                                    }
                                } else {
                                    // Create a new cluster group
                                    clusters.push({
                                        nodes: childNodesObj,
                                        edges: childEdgesObj
                                    });
                                }
                            }
                        }
                    }
                };

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    _loop(i);
                }

                for (var _i2 = 0; _i2 < clusters.length; _i2++) {
                    this._cluster(clusters[_i2].nodes, clusters[_i2].edges, options, false);
                }

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Cluster all nodes in the network that have only 1 edge
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterOutliers",
            value: function clusterOutliers(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(1, options, refreshData);
            }
            /**
             * Cluster all nodes in the network that have only 2 edge
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterBridges",
            value: function clusterBridges(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(2, options, refreshData);
            }
            /**
             * suck all connected nodes of a node into the node.
             *
             * @param {Node.id} nodeId
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterByConnection",
            value: function clusterByConnection(nodeId, options) {
                var _context;

                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                // kill conditions
                if (nodeId === undefined) {
                    throw new Error("No nodeId supplied to clusterByConnection!");
                }

                if (this.body.nodes[nodeId] === undefined) {
                    throw new Error("The nodeId given to clusterByConnection does not exist!");
                }

                var node = this.body.nodes[nodeId];
                options = this._checkOptions(options, node);

                if (options.clusterNodeProperties.x === undefined) {
                    options.clusterNodeProperties.x = node.x;
                }

                if (options.clusterNodeProperties.y === undefined) {
                    options.clusterNodeProperties.y = node.y;
                }

                if (options.clusterNodeProperties.fixed === undefined) {
                    options.clusterNodeProperties.fixed = {};
                    options.clusterNodeProperties.fixed.x = node.options.fixed.x;
                    options.clusterNodeProperties.fixed.y = node.options.fixed.y;
                }

                var childNodesObj = {};
                var childEdgesObj = {};
                var parentNodeId = node.id;
                var parentClonedOptions = NetworkUtil.cloneOptions(node);
                childNodesObj[parentNodeId] = node; // collect the nodes that will be in the cluster

                for (var i = 0; i < node.edges.length; i++) {
                    var edge = node.edges[i];

                    if (this.clusteredEdges[edge.id] === undefined) {
                        var childNodeId = this._getConnectedId(edge, parentNodeId); // if the child node is not in a cluster


                        if (this.clusteredNodes[childNodeId] === undefined) {
                            if (childNodeId !== parentNodeId) {
                                if (options.joinCondition === undefined) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                } else {
                                    // clone the options and insert some additional parameters that could be interesting.
                                    var childClonedOptions = NetworkUtil.cloneOptions(this.body.nodes[childNodeId]);

                                    if (options.joinCondition(parentClonedOptions, childClonedOptions) === true) {
                                        childEdgesObj[edge.id] = edge;
                                        childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                    }
                                }
                            } else {
                                // swallow the edge if it is self-referencing.
                                childEdgesObj[edge.id] = edge;
                            }
                        }
                    }
                }

                var childNodeIDs = map$3(_context = keys$3(childNodesObj)).call(_context, function (childNode) {
                    return childNodesObj[childNode].id;
                });

                for (var childNodeKey in childNodesObj) {
                    if (!Object.prototype.hasOwnProperty.call(childNodesObj, childNodeKey)) continue;
                    var childNode = childNodesObj[childNodeKey];

                    for (var y = 0; y < childNode.edges.length; y++) {
                        var childEdge = childNode.edges[y];

                        if (indexOf(childNodeIDs).call(childNodeIDs, this._getConnectedId(childEdge, childNode.id)) > -1) {
                            childEdgesObj[childEdge.id] = childEdge;
                        }
                    }
                }

                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
            /**
             * This function creates the edges that will be attached to the cluster
             * It looks for edges that are connected to the nodes from the "outside' of the cluster.
             *
             * @param {{Node.id: vis.Node}} childNodesObj
             * @param {{vis.Edge.id: vis.Edge}} childEdgesObj
             * @param {object} clusterNodeProperties
             * @param {object} clusterEdgeProperties
             * @private
             */

        }, {
            key: "_createClusterEdges",
            value: function _createClusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, clusterEdgeProperties) {
                var edge, childNodeId, childNode, toId, fromId, otherNodeId; // loop over all child nodes and their edges to find edges going out of the cluster
                // these edges will be replaced by clusterEdges.

                var childKeys = keys$3(childNodesObj);

                var createEdges = [];

                for (var i = 0; i < childKeys.length; i++) {
                    childNodeId = childKeys[i];
                    childNode = childNodesObj[childNodeId]; // construct new edges from the cluster to others

                    for (var j = 0; j < childNode.edges.length; j++) {
                        edge = childNode.edges[j]; // we only handle edges that are visible to the system, not the disabled ones from the clustering process.

                        if (this.clusteredEdges[edge.id] === undefined) {
                            // self-referencing edges will be added to the "hidden" list
                            if (edge.toId == edge.fromId) {
                                childEdgesObj[edge.id] = edge;
                            } else {
                                // set up the from and to.
                                if (edge.toId == childNodeId) {
                                    // this is a double equals because ints and strings can be interchanged here.
                                    toId = clusterNodeProperties.id;
                                    fromId = edge.fromId;
                                    otherNodeId = fromId;
                                } else {
                                    toId = edge.toId;
                                    fromId = clusterNodeProperties.id;
                                    otherNodeId = toId;
                                }
                            } // Only edges from the cluster outwards are being replaced.


                            if (childNodesObj[otherNodeId] === undefined) {
                                createEdges.push({
                                    edge: edge,
                                    fromId: fromId,
                                    toId: toId
                                });
                            }
                        }
                    }
                } //
                // Here we actually create the replacement edges.
                //
                // We could not do this in the loop above as the creation process
                // would add an edge to the edges array we are iterating over.
                //
                // NOTE: a clustered edge can have multiple base edges!
                //


                var newEdges = [];
                /**
                 * Find a cluster edge which matches the given created edge.
                 *
                 * @param {vis.Edge} createdEdge
                 * @returns {vis.Edge}
                 */

                var getNewEdge = function getNewEdge(createdEdge) {
                    for (var _j2 = 0; _j2 < newEdges.length; _j2++) {
                        var newEdge = newEdges[_j2]; // We replace both to and from edges with a single cluster edge

                        var matchToDirection = createdEdge.fromId === newEdge.fromId && createdEdge.toId === newEdge.toId;
                        var matchFromDirection = createdEdge.fromId === newEdge.toId && createdEdge.toId === newEdge.fromId;

                        if (matchToDirection || matchFromDirection) {
                            return newEdge;
                        }
                    }

                    return null;
                };

                for (var _j3 = 0; _j3 < createEdges.length; _j3++) {
                    var createdEdge = createEdges[_j3];
                    var _edge = createdEdge.edge;
                    var newEdge = getNewEdge(createdEdge);

                    if (newEdge === null) {
                        // Create a clustered edge for this connection
                        newEdge = this._createClusteredEdge(createdEdge.fromId, createdEdge.toId, _edge, clusterEdgeProperties);
                        newEdges.push(newEdge);
                    } else {
                        newEdge.clusteringEdgeReplacingIds.push(_edge.id);
                    } // also reference the new edge in the old edge


                    this.body.edges[_edge.id].edgeReplacedById = newEdge.id; // hide the replaced edge

                    this._backupEdgeOptions(_edge);

                    _edge.setOptions({
                        physics: false
                    });
                }
            }
            /**
             * This function checks the options that can be supplied to the different cluster functions
             * for certain fields and inserts defaults if needed
             *
             * @param {object} options
             * @returns {*}
             * @private
             */

        }, {
            key: "_checkOptions",
            value: function _checkOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (options.clusterEdgeProperties === undefined) {
                    options.clusterEdgeProperties = {};
                }

                if (options.clusterNodeProperties === undefined) {
                    options.clusterNodeProperties = {};
                }

                return options;
            }
            /**
             *
             * @param {object}    childNodesObj         | object with node objects, id as keys, same as childNodes except it also contains a source node
             * @param {object}    childEdgesObj         | object with edge objects, id as keys
             * @param {Array}     options               | object with {clusterNodeProperties, clusterEdgeProperties, processProperties}
             * @param {boolean}   refreshData | when true, do not wrap up
             * @private
             */

        }, {
            key: "_cluster",
            value: function _cluster(childNodesObj, childEdgesObj, options) {
                var refreshData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                // Remove nodes which are already clustered
                var tmpNodesToRemove = [];

                for (var nodeId in childNodesObj) {
                    if (Object.prototype.hasOwnProperty.call(childNodesObj, nodeId)) {
                        if (this.clusteredNodes[nodeId] !== undefined) {
                            tmpNodesToRemove.push(nodeId);
                        }
                    }
                }

                for (var n = 0; n < tmpNodesToRemove.length; ++n) {
                    delete childNodesObj[tmpNodesToRemove[n]];
                } // kill condition: no nodes don't bother


                if (keys$3(childNodesObj).length == 0) {
                    return;
                } // allow clusters of 1 if options allow


                if (keys$3(childNodesObj).length == 1 && options.clusterNodeProperties.allowSingleNodeCluster != true) {
                    return;
                }

                var clusterNodeProperties = deepExtend({}, options.clusterNodeProperties); // construct the clusterNodeProperties

                if (options.processProperties !== undefined) {
                    // get the childNode options
                    var childNodesOptions = [];

                    for (var _nodeId in childNodesObj) {
                        if (Object.prototype.hasOwnProperty.call(childNodesObj, _nodeId)) {
                            var clonedOptions = NetworkUtil.cloneOptions(childNodesObj[_nodeId]);
                            childNodesOptions.push(clonedOptions);
                        }
                    } // get cluster properties based on childNodes


                    var childEdgesOptions = [];

                    for (var edgeId in childEdgesObj) {
                        if (Object.prototype.hasOwnProperty.call(childEdgesObj, edgeId)) {
                            // these cluster edges will be removed on creation of the cluster.
                            if (edgeId.substr(0, 12) !== "clusterEdge:") {
                                var _clonedOptions = NetworkUtil.cloneOptions(childEdgesObj[edgeId], "edge");

                                childEdgesOptions.push(_clonedOptions);
                            }
                        }
                    }

                    clusterNodeProperties = options.processProperties(clusterNodeProperties, childNodesOptions, childEdgesOptions);

                    if (!clusterNodeProperties) {
                        throw new Error("The processProperties function does not return properties!");
                    }
                } // check if we have an unique id;


                if (clusterNodeProperties.id === undefined) {
                    clusterNodeProperties.id = "cluster:" + v4();
                }

                var clusterId = clusterNodeProperties.id;

                if (clusterNodeProperties.label === undefined) {
                    clusterNodeProperties.label = "cluster";
                } // give the clusterNode a position if it does not have one.


                var pos = undefined;

                if (clusterNodeProperties.x === undefined) {
                    pos = this._getClusterPosition(childNodesObj);
                    clusterNodeProperties.x = pos.x;
                }

                if (clusterNodeProperties.y === undefined) {
                    if (pos === undefined) {
                        pos = this._getClusterPosition(childNodesObj);
                    }

                    clusterNodeProperties.y = pos.y;
                } // force the ID to remain the same


                clusterNodeProperties.id = clusterId; // create the cluster Node
                // Note that allowSingleNodeCluster, if present, is stored in the options as well

                var clusterNode = this.body.functions.createNode(clusterNodeProperties, Cluster);
                clusterNode.containedNodes = childNodesObj;
                clusterNode.containedEdges = childEdgesObj; // cache a copy from the cluster edge properties if we have to reconnect others later on

                clusterNode.clusterEdgeProperties = options.clusterEdgeProperties; // finally put the cluster node into global

                this.body.nodes[clusterNodeProperties.id] = clusterNode;

                this._clusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, options.clusterEdgeProperties); // set ID to undefined so no duplicates arise


                clusterNodeProperties.id = undefined; // wrap up

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             *
             * @param {Edge} edge
             * @private
             */

        }, {
            key: "_backupEdgeOptions",
            value: function _backupEdgeOptions(edge) {
                if (this.clusteredEdges[edge.id] === undefined) {
                    this.clusteredEdges[edge.id] = {
                        physics: edge.options.physics
                    };
                }
            }
            /**
             *
             * @param {Edge} edge
             * @private
             */

        }, {
            key: "_restoreEdge",
            value: function _restoreEdge(edge) {
                var originalOptions = this.clusteredEdges[edge.id];

                if (originalOptions !== undefined) {
                    edge.setOptions({
                        physics: originalOptions.physics
                    });
                    delete this.clusteredEdges[edge.id];
                }
            }
            /**
             * Check if a node is a cluster.
             *
             * @param {Node.id} nodeId
             * @returns {*}
             */

        }, {
            key: "isCluster",
            value: function isCluster(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) {
                    return this.body.nodes[nodeId].isCluster === true;
                } else {
                    console.error("Node does not exist.");
                    return false;
                }
            }
            /**
             * get the position of the cluster node based on what's inside
             *
             * @param {object} childNodesObj    | object with node objects, id as keys
             * @returns {{x: number, y: number}}
             * @private
             */

        }, {
            key: "_getClusterPosition",
            value: function _getClusterPosition(childNodesObj) {
                var childKeys = keys$3(childNodesObj);

                var minX = childNodesObj[childKeys[0]].x;
                var maxX = childNodesObj[childKeys[0]].x;
                var minY = childNodesObj[childKeys[0]].y;
                var maxY = childNodesObj[childKeys[0]].y;
                var node;

                for (var i = 1; i < childKeys.length; i++) {
                    node = childNodesObj[childKeys[i]];
                    minX = node.x < minX ? node.x : minX;
                    maxX = node.x > maxX ? node.x : maxX;
                    minY = node.y < minY ? node.y : minY;
                    maxY = node.y > maxY ? node.y : maxY;
                }

                return {
                    x: 0.5 * (minX + maxX),
                    y: 0.5 * (minY + maxY)
                };
            }
            /**
             * Open a cluster by calling this function.
             *
             * @param {vis.Edge.id}  clusterNodeId | the ID of the cluster node
             * @param {object} options
             * @param {boolean} refreshData | wrap up afterwards if not true
             */

        }, {
            key: "openCluster",
            value: function openCluster(clusterNodeId, options) {
                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                // kill conditions
                if (clusterNodeId === undefined) {
                    throw new Error("No clusterNodeId supplied to openCluster.");
                }

                var clusterNode = this.body.nodes[clusterNodeId];

                if (clusterNode === undefined) {
                    throw new Error("The clusterNodeId supplied to openCluster does not exist.");
                }

                if (clusterNode.isCluster !== true || clusterNode.containedNodes === undefined || clusterNode.containedEdges === undefined) {
                    throw new Error("The node:" + clusterNodeId + " is not a valid cluster.");
                } // Check if current cluster is clustered itself


                var stack = this.findNode(clusterNodeId);
                var parentIndex = indexOf(stack).call(stack, clusterNodeId) - 1;

                if (parentIndex >= 0) {
                    // Current cluster is clustered; transfer contained nodes and edges to parent
                    var parentClusterNodeId = stack[parentIndex];
                    var parentClusterNode = this.body.nodes[parentClusterNodeId]; // clustering.clusteredNodes and clustering.clusteredEdges remain unchanged

                    parentClusterNode._openChildCluster(clusterNodeId); // All components of child cluster node have been transferred. It can die now.


                    delete this.body.nodes[clusterNodeId];

                    if (refreshData === true) {
                        this.body.emitter.emit("_dataChanged");
                    }

                    return;
                } // main body


                var containedNodes = clusterNode.containedNodes;
                var containedEdges = clusterNode.containedEdges; // allow the user to position the nodes after release.

                if (options !== undefined && options.releaseFunction !== undefined && typeof options.releaseFunction === "function") {
                    var positions = {};
                    var clusterPosition = {
                        x: clusterNode.x,
                        y: clusterNode.y
                    };

                    for (var nodeId in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) {
                            var containedNode = this.body.nodes[nodeId];
                            positions[nodeId] = {
                                x: containedNode.x,
                                y: containedNode.y
                            };
                        }
                    }

                    var newPositions = options.releaseFunction(clusterPosition, positions);

                    for (var _nodeId2 in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId2)) {
                            var _containedNode = this.body.nodes[_nodeId2];

                            if (newPositions[_nodeId2] !== undefined) {
                                _containedNode.x = newPositions[_nodeId2].x === undefined ? clusterNode.x : newPositions[_nodeId2].x;
                                _containedNode.y = newPositions[_nodeId2].y === undefined ? clusterNode.y : newPositions[_nodeId2].y;
                            }
                        }
                    }
                } else {
                    // copy the position from the cluster
                    forEach$1(containedNodes, function (containedNode) {
                        // inherit position
                        if (containedNode.options.fixed.x === false) {
                            containedNode.x = clusterNode.x;
                        }

                        if (containedNode.options.fixed.y === false) {
                            containedNode.y = clusterNode.y;
                        }
                    });
                } // release nodes


                for (var _nodeId3 in containedNodes) {
                    if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId3)) {
                        var _containedNode2 = this.body.nodes[_nodeId3]; // inherit speed

                        _containedNode2.vx = clusterNode.vx;
                        _containedNode2.vy = clusterNode.vy;

                        _containedNode2.setOptions({
                            physics: true
                        });

                        delete this.clusteredNodes[_nodeId3];
                    }
                } // copy the clusterNode edges because we cannot iterate over an object that we add or remove from.


                var edgesToBeDeleted = [];

                for (var i = 0; i < clusterNode.edges.length; i++) {
                    edgesToBeDeleted.push(clusterNode.edges[i]);
                } // actually handling the deleting.


                for (var _i3 = 0; _i3 < edgesToBeDeleted.length; _i3++) {
                    var edge = edgesToBeDeleted[_i3];

                    var otherNodeId = this._getConnectedId(edge, clusterNodeId);

                    var otherNode = this.clusteredNodes[otherNodeId];

                    for (var j = 0; j < edge.clusteringEdgeReplacingIds.length; j++) {
                        var transferId = edge.clusteringEdgeReplacingIds[j];
                        var transferEdge = this.body.edges[transferId];
                        if (transferEdge === undefined) continue; // if the other node is in another cluster, we transfer ownership of this edge to the other cluster

                        if (otherNode !== undefined) {
                            // transfer ownership:
                            var otherCluster = this.body.nodes[otherNode.clusterId];
                            otherCluster.containedEdges[transferEdge.id] = transferEdge; // delete local reference

                            delete containedEdges[transferEdge.id]; // get to and from

                            var fromId = transferEdge.fromId;
                            var toId = transferEdge.toId;

                            if (transferEdge.toId == otherNodeId) {
                                toId = otherNode.clusterId;
                            } else {
                                fromId = otherNode.clusterId;
                            } // create new cluster edge from the otherCluster


                            this._createClusteredEdge(fromId, toId, transferEdge, otherCluster.clusterEdgeProperties, {
                                hidden: false,
                                physics: true
                            });
                        } else {
                            this._restoreEdge(transferEdge);
                        }
                    }

                    edge.remove();
                } // handle the releasing of the edges


                for (var edgeId in containedEdges) {
                    if (Object.prototype.hasOwnProperty.call(containedEdges, edgeId)) {
                        this._restoreEdge(containedEdges[edgeId]);
                    }
                } // remove clusterNode


                delete this.body.nodes[clusterNodeId];

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             *
             * @param {Cluster.id} clusterId
             * @returns {Array.<Node.id>}
             */

        }, {
            key: "getNodesInCluster",
            value: function getNodesInCluster(clusterId) {
                var nodesArray = [];

                if (this.isCluster(clusterId) === true) {
                    var containedNodes = this.body.nodes[clusterId].containedNodes;

                    for (var nodeId in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) {
                            nodesArray.push(this.body.nodes[nodeId].id);
                        }
                    }
                }

                return nodesArray;
            }
            /**
             * Get the stack clusterId's that a certain node resides in. cluster A -> cluster B -> cluster C -> node
             *
             * If a node can't be found in the chain, return an empty array.
             *
             * @param {string|number} nodeId
             * @returns {Array}
             */

        }, {
            key: "findNode",
            value: function findNode(nodeId) {
                var stack = [];
                var max = 100;
                var counter = 0;
                var node;

                while (this.clusteredNodes[nodeId] !== undefined && counter < max) {
                    node = this.body.nodes[nodeId];
                    if (node === undefined) return [];
                    stack.push(node.id);
                    nodeId = this.clusteredNodes[nodeId].clusterId;
                    counter++;
                }

                node = this.body.nodes[nodeId];
                if (node === undefined) return [];
                stack.push(node.id);

                reverse(stack).call(stack);

                return stack;
            }
            /**
             * Using a clustered nodeId, update with the new options
             *
             * @param {Node.id} clusteredNodeId
             * @param {object} newOptions
             */

        }, {
            key: "updateClusteredNode",
            value: function updateClusteredNode(clusteredNodeId, newOptions) {
                if (clusteredNodeId === undefined) {
                    throw new Error("No clusteredNodeId supplied to updateClusteredNode.");
                }

                if (newOptions === undefined) {
                    throw new Error("No newOptions supplied to updateClusteredNode.");
                }

                if (this.body.nodes[clusteredNodeId] === undefined) {
                    throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");
                }

                this.body.nodes[clusteredNodeId].setOptions(newOptions);
                this.body.emitter.emit("_dataChanged");
            }
            /**
             * Using a base edgeId, update all related clustered edges with the new options
             *
             * @param {vis.Edge.id} startEdgeId
             * @param {object} newOptions
             */

        }, {
            key: "updateEdge",
            value: function updateEdge(startEdgeId, newOptions) {
                if (startEdgeId === undefined) {
                    throw new Error("No startEdgeId supplied to updateEdge.");
                }

                if (newOptions === undefined) {
                    throw new Error("No newOptions supplied to updateEdge.");
                }

                if (this.body.edges[startEdgeId] === undefined) {
                    throw new Error("The startEdgeId supplied to updateEdge does not exist.");
                }

                var allEdgeIds = this.getClusteredEdges(startEdgeId);

                for (var i = 0; i < allEdgeIds.length; i++) {
                    var edge = this.body.edges[allEdgeIds[i]];
                    edge.setOptions(newOptions);
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * Get a stack of clusterEdgeId's (+base edgeid) that a base edge is the same as. cluster edge C -> cluster edge B -> cluster edge A -> base edge(edgeId)
             *
             * @param {vis.Edge.id} edgeId
             * @returns {Array.<vis.Edge.id>}
             */

        }, {
            key: "getClusteredEdges",
            value: function getClusteredEdges(edgeId) {
                var stack = [];
                var max = 100;
                var counter = 0;

                while (edgeId !== undefined && this.body.edges[edgeId] !== undefined && counter < max) {
                    stack.push(this.body.edges[edgeId].id);
                    edgeId = this.body.edges[edgeId].edgeReplacedById;
                    counter++;
                }

                reverse(stack).call(stack);

                return stack;
            }
            /**
             * Get the base edge id of clusterEdgeId. cluster edge (clusteredEdgeId) -> cluster edge B -> cluster edge C -> base edge
             *
             * @param {vis.Edge.id} clusteredEdgeId
             * @returns {vis.Edge.id} baseEdgeId
             *
             * TODO: deprecate in 5.0.0. Method getBaseEdges() is the correct one to use.
             */

        }, {
            key: "getBaseEdge",
            value: function getBaseEdge(clusteredEdgeId) {
                // Just kludge this by returning the first base edge id found
                return this.getBaseEdges(clusteredEdgeId)[0];
            }
            /**
             * Get all regular edges for this clustered edge id.
             *
             * @param {vis.Edge.id} clusteredEdgeId
             * @returns {Array.<vis.Edge.id>} all baseEdgeId's under this clustered edge
             */

        }, {
            key: "getBaseEdges",
            value: function getBaseEdges(clusteredEdgeId) {
                var IdsToHandle = [clusteredEdgeId];
                var doneIds = [];
                var foundIds = [];
                var max = 100;
                var counter = 0;

                while (IdsToHandle.length > 0 && counter < max) {
                    var nextId = IdsToHandle.pop();
                    if (nextId === undefined) continue; // Paranoia here and onwards

                    var nextEdge = this.body.edges[nextId];
                    if (nextEdge === undefined) continue;
                    counter++;
                    var replacingIds = nextEdge.clusteringEdgeReplacingIds;

                    if (replacingIds === undefined) {
                        // nextId is a base id
                        foundIds.push(nextId);
                    } else {
                        // Another cluster edge, unravel this one as well
                        for (var i = 0; i < replacingIds.length; ++i) {
                            var replacingId = replacingIds[i]; // Don't add if already handled
                            // TODO: never triggers; find a test-case which does

                            if (indexOf(IdsToHandle).call(IdsToHandle, replacingIds) !== -1 || indexOf(doneIds).call(doneIds, replacingIds) !== -1) {
                                continue;
                            }

                            IdsToHandle.push(replacingId);
                        }
                    }

                    doneIds.push(nextId);
                }

                return foundIds;
            }
            /**
             * Get the Id the node is connected to
             *
             * @param {vis.Edge} edge
             * @param {Node.id} nodeId
             * @returns {*}
             * @private
             */

        }, {
            key: "_getConnectedId",
            value: function _getConnectedId(edge, nodeId) {
                if (edge.toId != nodeId) {
                    return edge.toId;
                } else if (edge.fromId != nodeId) {
                    return edge.fromId;
                } else {
                    return edge.fromId;
                }
            }
            /**
             * We determine how many connections denote an important hub.
             * We take the mean + 2*std as the important hub size. (Assuming a normal distribution of data, ~2.2%)
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_getHubSize",
            value: function _getHubSize() {
                var average = 0;
                var averageSquared = 0;
                var hubCounter = 0;
                var largestHub = 0;

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];

                    if (node.edges.length > largestHub) {
                        largestHub = node.edges.length;
                    }

                    average += node.edges.length;
                    averageSquared += Math.pow(node.edges.length, 2);
                    hubCounter += 1;
                }

                average = average / hubCounter;
                averageSquared = averageSquared / hubCounter;
                var variance = averageSquared - Math.pow(average, 2);
                var standardDeviation = Math.sqrt(variance);
                var hubThreshold = Math.floor(average + 2 * standardDeviation); // always have at least one to cluster

                if (hubThreshold > largestHub) {
                    hubThreshold = largestHub;
                }

                return hubThreshold;
            }
            /**
             * Create an edge for the cluster representation.
             *
             * @param {Node.id} fromId
             * @param {Node.id} toId
             * @param {vis.Edge} baseEdge
             * @param {object} clusterEdgeProperties
             * @param {object} extraOptions
             * @returns {Edge} newly created clustered edge
             * @private
             */

        }, {
            key: "_createClusteredEdge",
            value: function _createClusteredEdge(fromId, toId, baseEdge, clusterEdgeProperties, extraOptions) {
                // copy the options of the edge we will replace
                var clonedOptions = NetworkUtil.cloneOptions(baseEdge, "edge"); // make sure the properties of clusterEdges are superimposed on it

                deepExtend(clonedOptions, clusterEdgeProperties); // set up the edge

                clonedOptions.from = fromId;
                clonedOptions.to = toId;
                clonedOptions.id = "clusterEdge:" + v4(); // apply the edge specific options to it if specified

                if (extraOptions !== undefined) {
                    deepExtend(clonedOptions, extraOptions);
                }

                var newEdge = this.body.functions.createEdge(clonedOptions);
                newEdge.clusteringEdgeReplacingIds = [baseEdge.id];
                newEdge.connect(); // Register the new edge

                this.body.edges[newEdge.id] = newEdge;
                return newEdge;
            }
            /**
             * Add the passed child nodes and edges to the given cluster node.
             *
             * @param {object | Node} childNodes  hash of nodes or single node to add in cluster
             * @param {object | Edge} childEdges  hash of edges or single edge to take into account when clustering
             * @param {Node} clusterNode  cluster node to add nodes and edges to
             * @param {object} [clusterEdgeProperties]
             * @private
             */

        }, {
            key: "_clusterEdges",
            value: function _clusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties) {
                if (childEdges instanceof Edge) {
                    var edge = childEdges;
                    var obj = {};
                    obj[edge.id] = edge;
                    childEdges = obj;
                }

                if (childNodes instanceof Node) {
                    var node = childNodes;
                    var _obj = {};
                    _obj[node.id] = node;
                    childNodes = _obj;
                }

                if (clusterNode === undefined || clusterNode === null) {
                    throw new Error("_clusterEdges: parameter clusterNode required");
                }

                if (clusterEdgeProperties === undefined) {
                    // Take the required properties from the cluster node
                    clusterEdgeProperties = clusterNode.clusterEdgeProperties;
                } // create the new edges that will connect to the cluster.
                // All self-referencing edges will be added to childEdges here.


                this._createClusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties); // disable the childEdges


                for (var edgeId in childEdges) {
                    if (Object.prototype.hasOwnProperty.call(childEdges, edgeId)) {
                        if (this.body.edges[edgeId] !== undefined) {
                            var _edge2 = this.body.edges[edgeId]; // cache the options before changing

                            this._backupEdgeOptions(_edge2); // disable physics and hide the edge


                            _edge2.setOptions({
                                physics: false
                            });
                        }
                    }
                } // disable the childNodes


                for (var nodeId in childNodes) {
                    if (Object.prototype.hasOwnProperty.call(childNodes, nodeId)) {
                        this.clusteredNodes[nodeId] = {
                            clusterId: clusterNode.id,
                            node: this.body.nodes[nodeId]
                        };
                        this.body.nodes[nodeId].setOptions({
                            physics: false
                        });
                    }
                }
            }
            /**
             * Determine in which cluster given nodeId resides.
             *
             * If not in cluster, return undefined.
             *
             * NOTE: If you know a cleaner way to do this, please enlighten me (wimrijnders).
             *
             * @param {Node.id} nodeId
             * @returns {Node|undefined} Node instance for cluster, if present
             * @private
             */

        }, {
            key: "_getClusterNodeForNode",
            value: function _getClusterNodeForNode(nodeId) {
                if (nodeId === undefined) return undefined;
                var clusteredNode = this.clusteredNodes[nodeId]; // NOTE: If no cluster info found, it should actually be an error

                if (clusteredNode === undefined) return undefined;
                var clusterId = clusteredNode.clusterId;
                if (clusterId === undefined) return undefined;
                return this.body.nodes[clusterId];
            }
            /**
             * Internal helper function for conditionally removing items in array
             *
             * Done like this because Array.filter() is not fully supported by all IE's.
             *
             * @param {Array} arr
             * @param {Function} callback
             * @returns {Array}
             * @private
             */

        }, {
            key: "_filter",
            value: function _filter(arr, callback) {
                var ret = [];
                forEach$1(arr, function (item) {
                    if (callback(item)) {
                        ret.push(item);
                    }
                });
                return ret;
            }
            /**
             * Scan all edges for changes in clustering and adjust this if necessary.
             *
             * Call this (internally) after there has been a change in node or edge data.
             *
             * Pre: States of this.body.nodes and this.body.edges consistent
             * Pre: this.clusteredNodes and this.clusteredEdge consistent with containedNodes and containedEdges
             *      of cluster nodes.
             */

        }, {
            key: "_updateState",
            value: function _updateState() {
                var _this4 = this;

                var nodeId;
                var deletedNodeIds = [];
                var deletedEdgeIds = {};
                /**
                 * Utility function to iterate over clustering nodes only
                 *
                 * @param {Function} callback  function to call for each cluster node
                 */

                var eachClusterNode = function eachClusterNode(callback) {
                    forEach$1(_this4.body.nodes, function (node) {
                        if (node.isCluster === true) {
                            callback(node);
                        }
                    });
                }; //
                // Remove deleted regular nodes from clustering
                //
                // Determine the deleted nodes


                for (nodeId in this.clusteredNodes) {
                    if (!Object.prototype.hasOwnProperty.call(this.clusteredNodes, nodeId)) continue;
                    var node = this.body.nodes[nodeId];

                    if (node === undefined) {
                        deletedNodeIds.push(nodeId);
                    }
                } // Remove nodes from cluster nodes


                eachClusterNode(function (clusterNode) {
                    for (var n = 0; n < deletedNodeIds.length; n++) {
                        delete clusterNode.containedNodes[deletedNodeIds[n]];
                    }
                }); // Remove nodes from cluster list

                for (var n = 0; n < deletedNodeIds.length; n++) {
                    delete this.clusteredNodes[deletedNodeIds[n]];
                } //
                // Remove deleted edges from clustering
                //
                // Add the deleted clustered edges to the list


                forEach$1(this.clusteredEdges, function (edgeId) {
                    var edge = _this4.body.edges[edgeId];

                    if (edge === undefined || !edge.endPointsValid()) {
                        deletedEdgeIds[edgeId] = edgeId;
                    }
                }); // Cluster nodes can also contain edges which are not clustered,
                // i.e. nodes 1-2 within cluster with an edge in between.
                // So the cluster nodes also need to be scanned for invalid edges

                eachClusterNode(function (clusterNode) {
                    forEach$1(clusterNode.containedEdges, function (edge, edgeId) {
                        if (!edge.endPointsValid() && !deletedEdgeIds[edgeId]) {
                            deletedEdgeIds[edgeId] = edgeId;
                        }
                    });
                }); // Also scan for cluster edges which need to be removed in the active list.
                // Regular edges have been removed beforehand, so this only picks up the cluster edges.

                forEach$1(this.body.edges, function (edge, edgeId) {
                    // Explicitly scan the contained edges for validity
                    var isValid = true;
                    var replacedIds = edge.clusteringEdgeReplacingIds;

                    if (replacedIds !== undefined) {
                        var numValid = 0;
                        forEach$1(replacedIds, function (containedEdgeId) {
                            var containedEdge = _this4.body.edges[containedEdgeId];

                            if (containedEdge !== undefined && containedEdge.endPointsValid()) {
                                numValid += 1;
                            }
                        });
                        isValid = numValid > 0;
                    }

                    if (!edge.endPointsValid() || !isValid) {
                        deletedEdgeIds[edgeId] = edgeId;
                    }
                }); // Remove edges from cluster nodes

                eachClusterNode(function (clusterNode) {
                    forEach$1(deletedEdgeIds, function (deletedEdgeId) {
                        delete clusterNode.containedEdges[deletedEdgeId];
                        forEach$1(clusterNode.edges, function (edge, m) {
                            if (edge.id === deletedEdgeId) {
                                clusterNode.edges[m] = null; // Don't want to directly delete here, because in the loop

                                return;
                            }

                            edge.clusteringEdgeReplacingIds = _this4._filter(edge.clusteringEdgeReplacingIds, function (id) {
                                return !deletedEdgeIds[id];
                            });
                        }); // Clean up the nulls

                        clusterNode.edges = _this4._filter(clusterNode.edges, function (item) {
                            return item !== null;
                        });
                    });
                }); // Remove from cluster list

                forEach$1(deletedEdgeIds, function (edgeId) {
                    delete _this4.clusteredEdges[edgeId];
                }); // Remove cluster edges from active list (this.body.edges).
                // deletedEdgeIds still contains id of regular edges, but these should all
                // be gone when you reach here.

                forEach$1(deletedEdgeIds, function (edgeId) {
                    delete _this4.body.edges[edgeId];
                }); //
                // Check changed cluster state of edges
                //
                // Iterating over keys here, because edges may be removed in the loop

                var ids = keys$3(this.body.edges);

                forEach$1(ids, function (edgeId) {
                    var edge = _this4.body.edges[edgeId];

                    var shouldBeClustered = _this4._isClusteredNode(edge.fromId) || _this4._isClusteredNode(edge.toId);

                    if (shouldBeClustered === _this4._isClusteredEdge(edge.id)) {
                        return; // all is well
                    }

                    if (shouldBeClustered) {
                        // add edge to clustering
                        var clusterFrom = _this4._getClusterNodeForNode(edge.fromId);

                        if (clusterFrom !== undefined) {
                            _this4._clusterEdges(_this4.body.nodes[edge.fromId], edge, clusterFrom);
                        }

                        var clusterTo = _this4._getClusterNodeForNode(edge.toId);

                        if (clusterTo !== undefined) {
                            _this4._clusterEdges(_this4.body.nodes[edge.toId], edge, clusterTo);
                        } // TODO: check that it works for both edges clustered
                        //       (This might be paranoia)

                    } else {
                        delete _this4._clusterEdges[edgeId];

                        _this4._restoreEdge(edge); // This should not be happening, the state should
                        // be properly updated at this point.
                        //
                        // If it *is* reached during normal operation, then we have to implement
                        // undo clustering for this edge here.
                        // throw new Error('remove edge from clustering not implemented!')

                    }
                }); // Clusters may be nested to any level. Keep on opening until nothing to open

                var changed = false;
                var continueLoop = true;

                var _loop2 = function _loop2() {
                    var clustersToOpen = []; // Determine the id's of clusters that need opening

                    eachClusterNode(function (clusterNode) {
                        var numNodes = keys$3(clusterNode.containedNodes).length;

                        var allowSingle = clusterNode.options.allowSingleNodeCluster === true;

                        if (allowSingle && numNodes < 1 || !allowSingle && numNodes < 2) {
                            clustersToOpen.push(clusterNode.id);
                        }
                    }); // Open them

                    for (var _n = 0; _n < clustersToOpen.length; ++_n) {
                        _this4.openCluster(clustersToOpen[_n], {}, false
                            /* Don't refresh, we're in an refresh/update already */
                        );
                    }

                    continueLoop = clustersToOpen.length > 0;
                    changed = changed || continueLoop;
                };

                while (continueLoop) {
                    _loop2();
                }

                if (changed) {
                    this._updateState(); // Redo this method (recursion possible! should be safe)

                }
            }
            /**
             * Determine if node with given id is part of a cluster.
             *
             * @param {Node.id} nodeId
             * @returns {boolean} true if part of a cluster.
             */

        }, {
            key: "_isClusteredNode",
            value: function _isClusteredNode(nodeId) {
                return this.clusteredNodes[nodeId] !== undefined;
            }
            /**
             * Determine if edge with given id is not visible due to clustering.
             *
             * An edge is considered clustered if:
             * - it is directly replaced by a clustering edge
             * - any of its connecting nodes is in a cluster
             *
             * @param {vis.Edge.id} edgeId
             * @returns {boolean} true if part of a cluster.
             */

        }, {
            key: "_isClusteredEdge",
            value: function _isClusteredEdge(edgeId) {
                return this.clusteredEdges[edgeId] !== undefined;
            }
        }]);

        return ClusterEngine;
    }();

    function _createForOfIteratorHelper$5(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$5(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = slice$1(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

    function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Initializes window.requestAnimationFrame() to a usable form.
     *
     * Specifically, set up this method for the case of running on node.js with jsdom enabled.
     *
     * NOTES:
     *
     * * On node.js, when calling this directly outside of this class, `window` is not defined.
     *   This happens even if jsdom is used.
     * * For node.js + jsdom, `window` is available at the moment the constructor is called.
     *   For this reason, the called is placed within the constructor.
     * * Even then, `window.requestAnimationFrame()` is not defined, so it still needs to be added.
     * * During unit testing, it happens that the window object is reset during execution, causing
     *   a runtime error due to missing `requestAnimationFrame()`. This needs to be compensated for,
     *   see `_requestNextFrame()`.
     * * Since this is a global object, it may affect other modules besides `Network`. With normal
     *   usage, this does not cause any problems. During unit testing, errors may occur. These have
     *   been compensated for, see comment block in _requestNextFrame().
     *
     * @private
     */

    function _initRequestAnimationFrame() {
        var func;

        if (window !== undefined) {
            func = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        }

        if (func === undefined) {
            // window or method not present, setting mock requestAnimationFrame
            window.requestAnimationFrame = function (callback) {
                //console.log("Called mock requestAnimationFrame");
                callback();
            };
        } else {
            window.requestAnimationFrame = func;
        }
    }
    /**
     * The canvas renderer
     */


    var CanvasRenderer = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function CanvasRenderer(body, canvas) {
            _classCallCheck(this, CanvasRenderer);

            _initRequestAnimationFrame();

            this.body = body;
            this.canvas = canvas;
            this.redrawRequested = false;
            this.renderTimer = undefined;
            this.requiresTimeout = true;
            this.renderingActive = false;
            this.renderRequests = 0;
            this.allowRedraw = true;
            this.dragging = false;
            this.zooming = false;
            this.options = {};
            this.defaultOptions = {
                hideEdgesOnDrag: false,
                hideEdgesOnZoom: false,
                hideNodesOnDrag: false
            };

            assign$2(this.options, this.defaultOptions);

            this._determineBrowserMethod();

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(CanvasRenderer, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this,
                    _context2;

                this.body.emitter.on("dragStart", function () {
                    _this.dragging = true;
                });
                this.body.emitter.on("dragEnd", function () {
                    _this.dragging = false;
                });
                this.body.emitter.on("zoom", function () {
                    _this.zooming = true;
                    window.clearTimeout(_this.zoomTimeoutId);
                    _this.zoomTimeoutId = setTimeout$1(function () {
                        var _context;

                        _this.zooming = false;

                        bind(_context = _this._requestRedraw).call(_context, _this)();
                    }, 250);
                });
                this.body.emitter.on("_resizeNodes", function () {
                    _this._resizeNodes();
                });
                this.body.emitter.on("_redraw", function () {
                    if (_this.renderingActive === false) {
                        _this._redraw();
                    }
                });
                this.body.emitter.on("_blockRedraw", function () {
                    _this.allowRedraw = false;
                });
                this.body.emitter.on("_allowRedraw", function () {
                    _this.allowRedraw = true;
                    _this.redrawRequested = false;
                });
                this.body.emitter.on("_requestRedraw", bind(_context2 = this._requestRedraw).call(_context2, this));
                this.body.emitter.on("_startRendering", function () {
                    _this.renderRequests += 1;
                    _this.renderingActive = true;

                    _this._startRendering();
                });
                this.body.emitter.on("_stopRendering", function () {
                    _this.renderRequests -= 1;
                    _this.renderingActive = _this.renderRequests > 0;
                    _this.renderTimer = undefined;
                });
                this.body.emitter.on("destroy", function () {
                    _this.renderRequests = 0;
                    _this.allowRedraw = false;
                    _this.renderingActive = false;

                    if (_this.requiresTimeout === true) {
                        clearTimeout(_this.renderTimer);
                    } else {
                        window.cancelAnimationFrame(_this.renderTimer);
                    }

                    _this.body.emitter.off();
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = ["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag"];
                    selectiveDeepExtend(fields, this.options, options);
                }
            }
            /**
             * Prepare the drawing of the next frame.
             *
             * Calls the callback when the next frame can or will be drawn.
             *
             * @param {Function} callback
             * @param {number} delay - timeout case only, wait this number of milliseconds
             * @returns {Function | undefined}
             * @private
             */

        }, {
            key: "_requestNextFrame",
            value: function _requestNextFrame(callback, delay) {
                // During unit testing, it happens that the mock window object is reset while
                // the next frame is still pending. Then, either 'window' is not present, or
                // 'requestAnimationFrame()' is not present because it is not defined on the
                // mock window object.
                //
                // As a consequence, unrelated unit tests may appear to fail, even if the problem
                // described happens in the current unit test.
                //
                // This is not something that will happen in normal operation, but we still need
                // to take it into account.
                //
                if (typeof window === "undefined") return; // Doing `if (window === undefined)` does not work here!

                var timer;
                var myWindow = window; // Grab a reference to reduce the possibility that 'window' is reset
                // while running this method.

                if (this.requiresTimeout === true) {
                    // wait given number of milliseconds and perform the animation step function
                    timer = setTimeout$1(callback, delay);
                } else {
                    if (myWindow.requestAnimationFrame) {
                        timer = myWindow.requestAnimationFrame(callback);
                    }
                }

                return timer;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_startRendering",
            value: function _startRendering() {
                if (this.renderingActive === true) {
                    if (this.renderTimer === undefined) {
                        var _context3;

                        this.renderTimer = this._requestNextFrame(bind(_context3 = this._renderStep).call(_context3, this), this.simulationInterval);
                    }
                }
            }
            /**
             *
             * @private
             */

        }, {
            key: "_renderStep",
            value: function _renderStep() {
                if (this.renderingActive === true) {
                    // reset the renderTimer so a new scheduled animation step can be set
                    this.renderTimer = undefined;

                    if (this.requiresTimeout === true) {
                        // this schedules a new simulation step
                        this._startRendering();
                    }

                    this._redraw();

                    if (this.requiresTimeout === false) {
                        // this schedules a new simulation step
                        this._startRendering();
                    }
                }
            }
            /**
             * Redraw the network with the current data
             * chart will be resized too.
             */

        }, {
            key: "redraw",
            value: function redraw() {
                this.body.emitter.emit("setSize");

                this._redraw();
            }
            /**
             * Redraw the network with the current data
             *
             * @private
             */

        }, {
            key: "_requestRedraw",
            value: function _requestRedraw() {
                var _this2 = this;

                if (this.redrawRequested !== true && this.renderingActive === false && this.allowRedraw === true) {
                    this.redrawRequested = true;

                    this._requestNextFrame(function () {
                        _this2._redraw(false);
                    }, 0);
                }
            }
            /**
             * Redraw the network with the current data
             *
             * @param {boolean} [hidden=false] | Used to get the first estimate of the node sizes.
             *                                   Only the nodes are drawn after which they are quickly drawn over.
             * @private
             */

        }, {
            key: "_redraw",
            value: function _redraw() {
                var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                if (this.allowRedraw === true) {
                    this.body.emitter.emit("initRedraw");
                    this.redrawRequested = false;
                    var drawLater = {
                        drawExternalLabels: null
                    }; // when the container div was hidden, this fixes it back up!

                    if (this.canvas.frame.canvas.width === 0 || this.canvas.frame.canvas.height === 0) {
                        this.canvas.setSize();
                    }

                    this.canvas.setTransform();
                    var ctx = this.canvas.getContext(); // clear the canvas

                    var w = this.canvas.frame.canvas.clientWidth;
                    var h = this.canvas.frame.canvas.clientHeight;
                    ctx.clearRect(0, 0, w, h); // if the div is hidden, we stop the redraw here for performance.

                    if (this.canvas.frame.clientWidth === 0) {
                        return;
                    } // set scaling and translation


                    ctx.save();
                    ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                    ctx.scale(this.body.view.scale, this.body.view.scale);
                    ctx.beginPath();
                    this.body.emitter.emit("beforeDrawing", ctx);
                    ctx.closePath();

                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) {
                            this._drawEdges(ctx);
                        }
                    }

                    if (this.dragging === false || this.dragging === true && this.options.hideNodesOnDrag === false) {
                        var _this$_drawNodes = this._drawNodes(ctx, hidden),
                            drawExternalLabels = _this$_drawNodes.drawExternalLabels;

                        drawLater.drawExternalLabels = drawExternalLabels;
                    } // draw the arrows last so they will be at the top


                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) {
                            this._drawArrows(ctx);
                        }
                    }

                    if (drawLater.drawExternalLabels != null) {
                        drawLater.drawExternalLabels();
                    }

                    if (hidden === false) {
                        this._drawSelectionBox(ctx);
                    }

                    ctx.beginPath();
                    this.body.emitter.emit("afterDrawing", ctx);
                    ctx.closePath(); // restore original scaling and translation

                    ctx.restore();

                    if (hidden === true) {
                        ctx.clearRect(0, 0, w, h);
                    }
                }
            }
            /**
             * Redraw all nodes
             *
             * @param {CanvasRenderingContext2D}   ctx
             * @param {boolean} [alwaysShow]
             * @private
             */

        }, {
            key: "_resizeNodes",
            value: function _resizeNodes() {
                this.canvas.setTransform();
                var ctx = this.canvas.getContext();
                ctx.save();
                ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                ctx.scale(this.body.view.scale, this.body.view.scale);
                var nodes = this.body.nodes;
                var node; // resize all nodes

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        node = nodes[nodeId];
                        node.resize(ctx);
                        node.updateBoundingBox(ctx, node.selected);
                    }
                } // restore original scaling and translation


                ctx.restore();
            }
            /**
             * Redraw all nodes
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @param {boolean} [alwaysShow]
             * @private
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "_drawNodes",
            value: function _drawNodes(ctx) {
                var alwaysShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var nodes = this.body.nodes;
                var nodeIndices = this.body.nodeIndices;
                var node;
                var selected = [];
                var hovered = [];
                var margin = 20;
                var topLeft = this.canvas.DOMtoCanvas({
                    x: -margin,
                    y: -margin
                });
                var bottomRight = this.canvas.DOMtoCanvas({
                    x: this.canvas.frame.canvas.clientWidth + margin,
                    y: this.canvas.frame.canvas.clientHeight + margin
                });
                var viewableArea = {
                    top: topLeft.y,
                    left: topLeft.x,
                    bottom: bottomRight.y,
                    right: bottomRight.x
                };
                var _drawExternalLabels = []; // draw unselected nodes;

                for (var _i = 0; _i < nodeIndices.length; _i++) {
                    node = nodes[nodeIndices[_i]]; // set selected and hovered nodes aside

                    if (node.hover) {
                        hovered.push(nodeIndices[_i]);
                    } else if (node.isSelected()) {
                        selected.push(nodeIndices[_i]);
                    } else {
                        if (alwaysShow === true) {
                            var drawLater = node.draw(ctx);

                            if (drawLater.drawExternalLabel != null) {
                                _drawExternalLabels.push(drawLater.drawExternalLabel);
                            }
                        } else if (node.isBoundingBoxOverlappingWith(viewableArea) === true) {
                            var _drawLater = node.draw(ctx);

                            if (_drawLater.drawExternalLabel != null) {
                                _drawExternalLabels.push(_drawLater.drawExternalLabel);
                            }
                        } else {
                            node.updateBoundingBox(ctx, node.selected);
                        }
                    }
                }

                var i;
                var selectedLength = selected.length;
                var hoveredLength = hovered.length; // draw the selected nodes on top

                for (i = 0; i < selectedLength; i++) {
                    node = nodes[selected[i]];

                    var _drawLater2 = node.draw(ctx);

                    if (_drawLater2.drawExternalLabel != null) {
                        _drawExternalLabels.push(_drawLater2.drawExternalLabel);
                    }
                } // draw hovered nodes above everything else: fixes https://github.com/visjs/vis-network/issues/226


                for (i = 0; i < hoveredLength; i++) {
                    node = nodes[hovered[i]];

                    var _drawLater3 = node.draw(ctx);

                    if (_drawLater3.drawExternalLabel != null) {
                        _drawExternalLabels.push(_drawLater3.drawExternalLabel);
                    }
                }

                return {
                    drawExternalLabels: function drawExternalLabels() {
                        var _iterator = _createForOfIteratorHelper$5(_drawExternalLabels),
                            _step;

                        try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                var draw = _step.value;
                                draw();
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally {
                            _iterator.f();
                        }
                    }
                };
            }
            /**
             * Redraw all edges
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawEdges",
            value: function _drawEdges(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;

                for (var i = 0; i < edgeIndices.length; i++) {
                    var edge = edges[edgeIndices[i]];

                    if (edge.connected === true) {
                        edge.draw(ctx);
                    }
                }
            }
            /**
             * Redraw all arrows
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawArrows",
            value: function _drawArrows(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;

                for (var i = 0; i < edgeIndices.length; i++) {
                    var edge = edges[edgeIndices[i]];

                    if (edge.connected === true) {
                        edge.drawArrows(ctx);
                    }
                }
            }
            /**
             * Determine if the browser requires a setTimeout or a requestAnimationFrame. This was required because
             * some implementations (safari and IE9) did not support requestAnimationFrame
             *
             * @private
             */

        }, {
            key: "_determineBrowserMethod",
            value: function _determineBrowserMethod() {
                if (typeof window !== "undefined") {
                    var browserType = navigator.userAgent.toLowerCase();
                    this.requiresTimeout = false;

                    if (indexOf(browserType).call(browserType, "msie 9.0") != -1) {
                        // IE 9
                        this.requiresTimeout = true;
                    } else if (indexOf(browserType).call(browserType, "safari") != -1) {
                        // safari
                        if (indexOf(browserType).call(browserType, "chrome") <= -1) {
                            this.requiresTimeout = true;
                        }
                    }
                } else {
                    this.requiresTimeout = true;
                }
            }
            /**
             * Redraw selection box
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawSelectionBox",
            value: function _drawSelectionBox(ctx) {
                if (this.body.selectionBox.show) {
                    ctx.beginPath();
                    var width = this.body.selectionBox.position.end.x - this.body.selectionBox.position.start.x;
                    var height = this.body.selectionBox.position.end.y - this.body.selectionBox.position.start.y;
                    ctx.rect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.fillStyle = "rgba(151, 194, 252, 0.2)";
                    ctx.fillRect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.strokeStyle = "rgba(151, 194, 252, 1)";
                    ctx.stroke();
                } else {
                    ctx.closePath();
                }
            }
        }]);

        return CanvasRenderer;
    }();

    var setInterval$1 = path.setInterval;

    var setInterval = setInterval$1;

    /**
     * Register a touch event, taking place before a gesture
     *
     * @param {Hammer} hammer       A hammer instance
     * @param {Function} callback   Callback, called as callback(event)
     */
    function onTouch(hammer, callback) {
        callback.inputHandler = function (event) {
            if (event.isFirst) {
                callback(event);
            }
        };

        hammer.on("hammer.input", callback.inputHandler);
    }
    /**
     * Register a release event, taking place after a gesture
     *
     * @param {Hammer} hammer       A hammer instance
     * @param {Function} callback   Callback, called as callback(event)
     * @returns {*}
     */

    function onRelease(hammer, callback) {
        callback.inputHandler = function (event) {
            if (event.isFinal) {
                callback(event);
            }
        };

        return hammer.on("hammer.input", callback.inputHandler);
    }

    /**
     * Create the main frame for the Network.
     * This function is executed once when a Network object is created. The frame
     * contains a canvas, and this canvas contains all objects like the axis and
     * nodes.
     */

    var Canvas = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function Canvas(body) {
            _classCallCheck(this, Canvas);

            this.body = body;
            this.pixelRatio = 1;
            this.cameraState = {};
            this.initialized = false;
            this.canvasViewCenter = {};
            this._cleanupCallbacks = [];
            this.options = {};
            this.defaultOptions = {
                autoResize: true,
                height: "100%",
                width: "100%"
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(Canvas, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this,
                    _context;

                // bind the events
                this.body.emitter.once("resize", function (obj) {
                    if (obj.width !== 0) {
                        _this.body.view.translation.x = obj.width * 0.5;
                    }

                    if (obj.height !== 0) {
                        _this.body.view.translation.y = obj.height * 0.5;
                    }
                });
                this.body.emitter.on("setSize", bind(_context = this.setSize).call(_context, this));
                this.body.emitter.on("destroy", function () {
                    _this.hammerFrame.destroy();

                    _this.hammer.destroy();

                    _this._cleanUp();
                });
            }
            /**
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                var _this2 = this;

                if (options !== undefined) {
                    var fields = ["width", "height", "autoResize"];
                    selectiveDeepExtend(fields, this.options, options);
                } // Automatically adapt to changing size of the container element.


                this._cleanUp();

                if (this.options.autoResize === true) {
                    var _context2;

                    if (window.ResizeObserver) {
                        // decent browsers, immediate reactions
                        var observer = new ResizeObserver(function () {
                            var changed = _this2.setSize();

                            if (changed === true) {
                                _this2.body.emitter.emit("_requestRedraw");
                            }
                        });
                        var frame = this.frame;
                        observer.observe(frame);

                        this._cleanupCallbacks.push(function () {
                            observer.unobserve(frame);
                        });
                    } else {
                        // IE11, continous polling
                        var resizeTimer = setInterval(function () {
                            var changed = _this2.setSize();

                            if (changed === true) {
                                _this2.body.emitter.emit("_requestRedraw");
                            }
                        }, 1000);

                        this._cleanupCallbacks.push(function () {
                            clearInterval(resizeTimer);
                        });
                    } // Automatically adapt to changing size of the browser.


                    var resizeFunction = bind(_context2 = this._onResize).call(_context2, this);

                    addEventListener(window, "resize", resizeFunction);

                    this._cleanupCallbacks.push(function () {
                        removeEventListener(window, "resize", resizeFunction);
                    });
                }
            }
            /**
             * @private
             */

        }, {
            key: "_cleanUp",
            value: function _cleanUp() {
                var _context3, _context4, _context5;

                forEach$2(_context3 = reverse(_context4 = splice(_context5 = this._cleanupCallbacks).call(_context5, 0)).call(_context4)).call(_context3, function (callback) {
                    try {
                        callback();
                    } catch (error) {
                        console.error(error);
                    }
                });
            }
            /**
             * @private
             */

        }, {
            key: "_onResize",
            value: function _onResize() {
                this.setSize();
                this.body.emitter.emit("_redraw");
            }
            /**
             * Get and store the cameraState
             *
             * @param {number} [pixelRatio=this.pixelRatio]
             * @private
             */

        }, {
            key: "_getCameraState",
            value: function _getCameraState() {
                var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pixelRatio;

                if (this.initialized === true) {
                    this.cameraState.previousWidth = this.frame.canvas.width / pixelRatio;
                    this.cameraState.previousHeight = this.frame.canvas.height / pixelRatio;
                    this.cameraState.scale = this.body.view.scale;
                    this.cameraState.position = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.width / pixelRatio,
                        y: 0.5 * this.frame.canvas.height / pixelRatio
                    });
                }
            }
            /**
             * Set the cameraState
             *
             * @private
             */

        }, {
            key: "_setCameraState",
            value: function _setCameraState() {
                if (this.cameraState.scale !== undefined && this.frame.canvas.clientWidth !== 0 && this.frame.canvas.clientHeight !== 0 && this.pixelRatio !== 0 && this.cameraState.previousWidth > 0 && this.cameraState.previousHeight > 0) {
                    var widthRatio = this.frame.canvas.width / this.pixelRatio / this.cameraState.previousWidth;
                    var heightRatio = this.frame.canvas.height / this.pixelRatio / this.cameraState.previousHeight;
                    var newScale = this.cameraState.scale;

                    if (widthRatio != 1 && heightRatio != 1) {
                        newScale = this.cameraState.scale * 0.5 * (widthRatio + heightRatio);
                    } else if (widthRatio != 1) {
                        newScale = this.cameraState.scale * widthRatio;
                    } else if (heightRatio != 1) {
                        newScale = this.cameraState.scale * heightRatio;
                    }

                    this.body.view.scale = newScale; // this comes from the view module.

                    var currentViewCenter = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.clientWidth,
                        y: 0.5 * this.frame.canvas.clientHeight
                    });
                    var distanceFromCenter = {
                        // offset from view, distance view has to change by these x and y to center the node
                        x: currentViewCenter.x - this.cameraState.position.x,
                        y: currentViewCenter.y - this.cameraState.position.y
                    };
                    this.body.view.translation.x += distanceFromCenter.x * this.body.view.scale;
                    this.body.view.translation.y += distanceFromCenter.y * this.body.view.scale;
                }
            }
            /**
             *
             * @param {number|string} value
             * @returns {string}
             * @private
             */

        }, {
            key: "_prepareValue",
            value: function _prepareValue(value) {
                if (typeof value === "number") {
                    return value + "px";
                } else if (typeof value === "string") {
                    if (indexOf(value).call(value, "%") !== -1 || indexOf(value).call(value, "px") !== -1) {
                        return value;
                    } else if (indexOf(value).call(value, "%") === -1) {
                        return value + "px";
                    }
                }

                throw new Error("Could not use the value supplied for width or height:" + value);
            }
            /**
             * Create the HTML
             */

        }, {
            key: "_create",
            value: function _create() {
                // remove all elements from the container element.
                while (this.body.container.hasChildNodes()) {
                    this.body.container.removeChild(this.body.container.firstChild);
                }

                this.frame = document.createElement("div");
                this.frame.className = "vis-network";
                this.frame.style.position = "relative";
                this.frame.style.overflow = "hidden";
                this.frame.tabIndex = 0; // tab index is required for keycharm to bind keystrokes to the div instead of the window
                //////////////////////////////////////////////////////////////////

                this.frame.canvas = document.createElement("canvas");
                this.frame.canvas.style.position = "relative";
                this.frame.appendChild(this.frame.canvas);

                if (!this.frame.canvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.frame.canvas.appendChild(noCanvas);
                } else {
                    this._setPixelRatio();

                    this.setTransform();
                } // add the frame to the container element


                this.body.container.appendChild(this.frame);
                this.body.view.scale = 1;
                this.body.view.translation = {
                    x: 0.5 * this.frame.canvas.clientWidth,
                    y: 0.5 * this.frame.canvas.clientHeight
                };

                this._bindHammer();
            }
            /**
             * This function binds hammer, it can be repeated over and over due to the uniqueness check.
             *
             * @private
             */

        }, {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;

                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                }

                this.drag = {};
                this.pinch = {}; // init hammer

                this.hammer = new Hammer$1(this.frame.canvas);
                this.hammer.get("pinch").set({
                    enable: true
                }); // enable to get better response, todo: test on mobile.

                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer$1.DIRECTION_ALL
                });
                onTouch(this.hammer, function (event) {
                    _this3.body.eventListeners.onTouch(event);
                });
                this.hammer.on("tap", function (event) {
                    _this3.body.eventListeners.onTap(event);
                });
                this.hammer.on("doubletap", function (event) {
                    _this3.body.eventListeners.onDoubleTap(event);
                });
                this.hammer.on("press", function (event) {
                    _this3.body.eventListeners.onHold(event);
                });
                this.hammer.on("panstart", function (event) {
                    _this3.body.eventListeners.onDragStart(event);
                });
                this.hammer.on("panmove", function (event) {
                    _this3.body.eventListeners.onDrag(event);
                });
                this.hammer.on("panend", function (event) {
                    _this3.body.eventListeners.onDragEnd(event);
                });
                this.hammer.on("pinch", function (event) {
                    _this3.body.eventListeners.onPinch(event);
                }); // TODO: neatly cleanup these handlers when re-creating the Canvas, IF these are done with hammer, event.stopPropagation will not work?

                this.frame.canvas.addEventListener("wheel", function (event) {
                    _this3.body.eventListeners.onMouseWheel(event);
                });
                this.frame.canvas.addEventListener("mousemove", function (event) {
                    _this3.body.eventListeners.onMouseMove(event);
                });
                this.frame.canvas.addEventListener("contextmenu", function (event) {
                    _this3.body.eventListeners.onContext(event);
                });
                this.hammerFrame = new Hammer$1(this.frame);
                onRelease(this.hammerFrame, function (event) {
                    _this3.body.eventListeners.onRelease(event);
                });
            }
            /**
             * Set a new size for the network
             *
             * @param {string} width   Width in pixels or percentage (for example '800px'
             *                         or '50%')
             * @param {string} height  Height in pixels or percentage  (for example '400px'
             *                         or '30%')
             * @returns {boolean}
             */

        }, {
            key: "setSize",
            value: function setSize() {
                var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.width;
                var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.height;
                width = this._prepareValue(width);
                height = this._prepareValue(height);
                var emitEvent = false;
                var oldWidth = this.frame.canvas.width;
                var oldHeight = this.frame.canvas.height; // update the pixel ratio
                //
                // NOTE: Comment in following is rather inconsistent; this is the ONLY place in the code
                //       where it is assumed that the pixel ratio could change at runtime.
                //       The only way I can think of this happening is a rotating screen or tablet; but then
                //       there should be a mechanism for reloading the data (TODO: check if this is present).
                //
                //       If the assumption is true (i.e. pixel ratio can change at runtime), then *all* usage
                //       of pixel ratio must be overhauled for this.
                //
                //       For the time being, I will humor the assumption here, and in the rest of the code assume it is
                //       constant.

                var previousRatio = this.pixelRatio; // we cache this because the camera state storage needs the old value

                this._setPixelRatio();

                if (width != this.options.width || height != this.options.height || this.frame.style.width != width || this.frame.style.height != height) {
                    this._getCameraState(previousRatio);

                    this.frame.style.width = width;
                    this.frame.style.height = height;
                    this.frame.canvas.style.width = "100%";
                    this.frame.canvas.style.height = "100%";
                    this.frame.canvas.width = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    this.frame.canvas.height = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);
                    this.options.width = width;
                    this.options.height = height;
                    this.canvasViewCenter = {
                        x: 0.5 * this.frame.clientWidth,
                        y: 0.5 * this.frame.clientHeight
                    };
                    emitEvent = true;
                } else {
                    // this would adapt the width of the canvas to the width from 100% if and only if
                    // there is a change.
                    var newWidth = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    var newHeight = Math.round(this.frame.canvas.clientHeight * this.pixelRatio); // store the camera if there is a change in size.

                    if (this.frame.canvas.width !== newWidth || this.frame.canvas.height !== newHeight) {
                        this._getCameraState(previousRatio);
                    }

                    if (this.frame.canvas.width !== newWidth) {
                        this.frame.canvas.width = newWidth;
                        emitEvent = true;
                    }

                    if (this.frame.canvas.height !== newHeight) {
                        this.frame.canvas.height = newHeight;
                        emitEvent = true;
                    }
                }

                if (emitEvent === true) {
                    this.body.emitter.emit("resize", {
                        width: Math.round(this.frame.canvas.width / this.pixelRatio),
                        height: Math.round(this.frame.canvas.height / this.pixelRatio),
                        oldWidth: Math.round(oldWidth / this.pixelRatio),
                        oldHeight: Math.round(oldHeight / this.pixelRatio)
                    }); // restore the camera on change.

                    this._setCameraState();
                } // set initialized so the get and set camera will work from now on.


                this.initialized = true;
                return emitEvent;
            }
            /**
             *
             * @returns {CanvasRenderingContext2D}
             */

        }, {
            key: "getContext",
            value: function getContext() {
                return this.frame.canvas.getContext("2d");
            }
            /**
             * Determine the pixel ratio for various browsers.
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_determinePixelRatio",
            value: function _determinePixelRatio() {
                var ctx = this.getContext();

                if (ctx === undefined) {
                    throw new Error("Could not get canvax context");
                }

                var numerator = 1;

                if (typeof window !== "undefined") {
                    // (window !== undefined) doesn't work here!
                    // Protection during unit tests, where 'window' can be missing
                    numerator = window.devicePixelRatio || 1;
                }

                var denominator = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
                return numerator / denominator;
            }
            /**
             * Lazy determination of pixel ratio.
             *
             * @private
             */

        }, {
            key: "_setPixelRatio",
            value: function _setPixelRatio() {
                this.pixelRatio = this._determinePixelRatio();
            }
            /**
             * Set the transform in the contained context, based on its pixelRatio
             */

        }, {
            key: "setTransform",
            value: function setTransform() {
                var ctx = this.getContext();

                if (ctx === undefined) {
                    throw new Error("Could not get canvax context");
                }

                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
            }
            /**
             * Convert the X coordinate in DOM-space (coordinate point in browser relative to the container div) to
             * the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
             *
             * @param {number} x
             * @returns {number}
             * @private
             */

        }, {
            key: "_XconvertDOMtoCanvas",
            value: function _XconvertDOMtoCanvas(x) {
                return (x - this.body.view.translation.x) / this.body.view.scale;
            }
            /**
             * Convert the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
             * the X coordinate in DOM-space (coordinate point in browser relative to the container div)
             *
             * @param {number} x
             * @returns {number}
             * @private
             */

        }, {
            key: "_XconvertCanvasToDOM",
            value: function _XconvertCanvasToDOM(x) {
                return x * this.body.view.scale + this.body.view.translation.x;
            }
            /**
             * Convert the Y coordinate in DOM-space (coordinate point in browser relative to the container div) to
             * the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
             *
             * @param {number} y
             * @returns {number}
             * @private
             */

        }, {
            key: "_YconvertDOMtoCanvas",
            value: function _YconvertDOMtoCanvas(y) {
                return (y - this.body.view.translation.y) / this.body.view.scale;
            }
            /**
             * Convert the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
             * the Y coordinate in DOM-space (coordinate point in browser relative to the container div)
             *
             * @param {number} y
             * @returns {number}
             * @private
             */

        }, {
            key: "_YconvertCanvasToDOM",
            value: function _YconvertCanvasToDOM(y) {
                return y * this.body.view.scale + this.body.view.translation.y;
            }
            /**
             * @param {point} pos
             * @returns {point}
             */

        }, {
            key: "canvasToDOM",
            value: function canvasToDOM(pos) {
                return {
                    x: this._XconvertCanvasToDOM(pos.x),
                    y: this._YconvertCanvasToDOM(pos.y)
                };
            }
            /**
             *
             * @param {point} pos
             * @returns {point}
             */

        }, {
            key: "DOMtoCanvas",
            value: function DOMtoCanvas(pos) {
                return {
                    x: this._XconvertDOMtoCanvas(pos.x),
                    y: this._YconvertDOMtoCanvas(pos.y)
                };
            }
        }]);

        return Canvas;
    }();

    /**
     * Validate the fit options, replace missing optional values by defaults etc.
     *
     * @param rawOptions - The raw options.
     * @param allNodeIds - All node ids that will be used if nodes are omitted in
     * the raw options.
     *
     * @returns Options with everything filled in and validated.
     */
    function normalizeFitOptions(rawOptions, allNodeIds) {
        var options = assign$2({
            nodes: allNodeIds,
            minZoomLevel: Number.MIN_VALUE,
            maxZoomLevel: 1
        }, rawOptions !== null && rawOptions !== void 0 ? rawOptions : {});

        if (!isArray(options.nodes)) {
            throw new TypeError("Nodes has to be an array of ids.");
        }

        if (options.nodes.length === 0) {
            options.nodes = allNodeIds;
        }

        if (!(typeof options.minZoomLevel === "number" && options.minZoomLevel > 0)) {
            throw new TypeError("Min zoom level has to be a number higher than zero.");
        }

        if (!(typeof options.maxZoomLevel === "number" && options.minZoomLevel <= options.maxZoomLevel)) {
            throw new TypeError("Max zoom level has to be a number higher than min zoom level.");
        }

        return options;
    }

    /**
     * The view
     */

    var View = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function View(body, canvas) {
            var _context,
                _this = this,
                _context2;

            _classCallCheck(this, View);

            this.body = body;
            this.canvas = canvas;
            this.animationSpeed = 1 / this.renderRefreshRate;
            this.animationEasingFunction = "easeInOutQuint";
            this.easingTime = 0;
            this.sourceScale = 0;
            this.targetScale = 0;
            this.sourceTranslation = 0;
            this.targetTranslation = 0;
            this.lockedOnNodeId = undefined;
            this.lockedOnNodeOffset = undefined;
            this.touchTime = 0;
            this.viewFunction = undefined;
            this.body.emitter.on("fit", bind(_context = this.fit).call(_context, this));
            this.body.emitter.on("animationFinished", function () {
                _this.body.emitter.emit("_stopRendering");
            });
            this.body.emitter.on("unlockNode", bind(_context2 = this.releaseNode).call(_context2, this));
        }
        /**
         *
         * @param {object} [options={}]
         */


        _createClass(View, [{
            key: "setOptions",
            value: function setOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.options = options;
            }
            /**
             * This function zooms out to fit all data on screen based on amount of nodes
             *
             * @param {object} [options={{nodes=Array}}]
             * @param {boolean} [initialZoom=false]  | zoom based on fitted formula or range, true = fitted, default = false;
             */

        }, {
            key: "fit",
            value: function fit(options) {
                var initialZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                options = normalizeFitOptions(options, this.body.nodeIndices);
                var canvasWidth = this.canvas.frame.canvas.clientWidth;
                var canvasHeight = this.canvas.frame.canvas.clientHeight;
                var range;
                var zoomLevel;

                if (canvasWidth === 0 || canvasHeight === 0) {
                    // There's no point in trying to fit into zero sized canvas. This could
                    // potentially even result in invalid values being computed. For example
                    // for network without nodes and zero sized canvas the zoom level would
                    // end up being computed as 0/0 which results in NaN. In any other case
                    // this would be 0/something which is again pointless to compute.
                    zoomLevel = 1;
                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                } else if (initialZoom === true) {
                    // check if more than half of the nodes have a predefined position. If so, we use the range, not the approximation.
                    var positionDefined = 0;

                    for (var nodeId in this.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                            var node = this.body.nodes[nodeId];

                            if (node.predefinedPosition === true) {
                                positionDefined += 1;
                            }
                        }
                    }

                    if (positionDefined > 0.5 * this.body.nodeIndices.length) {
                        this.fit(options, false);
                        return;
                    }

                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var numberOfNodes = this.body.nodeIndices.length;
                    zoomLevel = 12.662 / (numberOfNodes + 7.4147) + 0.0964822; // this is obtained from fitting a dataset from 5 points with scale levels that looked good.
                    // correct for larger canvasses.

                    var factor = Math.min(canvasWidth / 600, canvasHeight / 600);
                    zoomLevel *= factor;
                } else {
                    this.body.emitter.emit("_resizeNodes");
                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var xDistance = Math.abs(range.maxX - range.minX) * 1.1;
                    var yDistance = Math.abs(range.maxY - range.minY) * 1.1;
                    var xZoomLevel = canvasWidth / xDistance;
                    var yZoomLevel = canvasHeight / yDistance;
                    zoomLevel = xZoomLevel <= yZoomLevel ? xZoomLevel : yZoomLevel;
                }

                if (zoomLevel > options.maxZoomLevel) {
                    zoomLevel = options.maxZoomLevel;
                } else if (zoomLevel < options.minZoomLevel) {
                    zoomLevel = options.minZoomLevel;
                }

                var center = NetworkUtil.findCenter(range);
                var animationOptions = {
                    position: center,
                    scale: zoomLevel,
                    animation: options.animation
                };
                this.moveTo(animationOptions);
            } // animation

            /**
             * Center a node in view.
             *
             * @param {number} nodeId
             * @param {number} [options]
             */

        }, {
            key: "focus",
            value: function focus(nodeId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (this.body.nodes[nodeId] !== undefined) {
                    var nodePosition = {
                        x: this.body.nodes[nodeId].x,
                        y: this.body.nodes[nodeId].y
                    };
                    options.position = nodePosition;
                    options.lockedOnNode = nodeId;
                    this.moveTo(options);
                } else {
                    console.error("Node: " + nodeId + " cannot be found.");
                }
            }
            /**
             *
             * @param {object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
             *                          |  options.scale    = number                 // scale to move to
             *                          |  options.position = {x:number, y:number}   // position to move to
             *                          |  options.animation = {duration:number, easingFunction:String} || Boolean   // position to move to
             */

        }, {
            key: "moveTo",
            value: function moveTo(options) {
                if (options === undefined) {
                    options = {};
                    return;
                }

                if (options.offset != null) {
                    if (options.offset.x != null) {
                        // Coerce and verify that x is valid.
                        options.offset.x = +options.offset.x;

                        if (!_isFinite(options.offset.x)) {
                            throw new TypeError('The option "offset.x" has to be a finite number.');
                        }
                    } else {
                        options.offset.x = 0;
                    }

                    if (options.offset.y != null) {
                        // Coerce and verify that y is valid.
                        options.offset.y = +options.offset.y;

                        if (!_isFinite(options.offset.y)) {
                            throw new TypeError('The option "offset.y" has to be a finite number.');
                        }
                    } else {
                        options.offset.x = 0;
                    }
                } else {
                    options.offset = {
                        x: 0,
                        y: 0
                    };
                }

                if (options.position != null) {
                    if (options.position.x != null) {
                        // Coerce and verify that x is valid.
                        options.position.x = +options.position.x;

                        if (!_isFinite(options.position.x)) {
                            throw new TypeError('The option "position.x" has to be a finite number.');
                        }
                    } else {
                        options.position.x = 0;
                    }

                    if (options.position.y != null) {
                        // Coerce and verify that y is valid.
                        options.position.y = +options.position.y;

                        if (!_isFinite(options.position.y)) {
                            throw new TypeError('The option "position.y" has to be a finite number.');
                        }
                    } else {
                        options.position.x = 0;
                    }
                } else {
                    options.position = this.getViewPosition();
                }

                if (options.scale != null) {
                    // Coerce and verify that the scale is valid.
                    options.scale = +options.scale;

                    if (!(options.scale > 0)) {
                        throw new TypeError('The option "scale" has to be a number greater than zero.');
                    }
                } else {
                    options.scale = this.body.view.scale;
                }

                if (options.animation === undefined) {
                    options.animation = {
                        duration: 0
                    };
                }

                if (options.animation === false) {
                    options.animation = {
                        duration: 0
                    };
                }

                if (options.animation === true) {
                    options.animation = {};
                }

                if (options.animation.duration === undefined) {
                    options.animation.duration = 1000;
                } // default duration


                if (options.animation.easingFunction === undefined) {
                    options.animation.easingFunction = "easeInOutQuad";
                } // default easing function


                this.animateView(options);
            }
            /**
             *
             * @param {object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
             *                          |  options.time     = number                 // animation time in milliseconds
             *                          |  options.scale    = number                 // scale to animate to
             *                          |  options.position = {x:number, y:number}   // position to animate to
             *                          |  options.easingFunction = String           // linear, easeInQuad, easeOutQuad, easeInOutQuad,
             *                                                                       // easeInCubic, easeOutCubic, easeInOutCubic,
             *                                                                       // easeInQuart, easeOutQuart, easeInOutQuart,
             *                                                                       // easeInQuint, easeOutQuint, easeInOutQuint
             */

        }, {
            key: "animateView",
            value: function animateView(options) {
                if (options === undefined) {
                    return;
                }

                this.animationEasingFunction = options.animation.easingFunction; // release if something focussed on the node

                this.releaseNode();

                if (options.locked === true) {
                    this.lockedOnNodeId = options.lockedOnNode;
                    this.lockedOnNodeOffset = options.offset;
                } // forcefully complete the old animation if it was still running


                if (this.easingTime != 0) {
                    this._transitionRedraw(true); // by setting easingtime to 1, we finish the animation.

                }

                this.sourceScale = this.body.view.scale;
                this.sourceTranslation = this.body.view.translation;
                this.targetScale = options.scale; // set the scale so the viewCenter is based on the correct zoom level. This is overridden in the transitionRedraw
                // but at least then we'll have the target transition

                this.body.view.scale = this.targetScale;
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - options.position.x,
                    y: viewCenter.y - options.position.y
                };
                this.targetTranslation = {
                    x: this.sourceTranslation.x + distanceFromCenter.x * this.targetScale + options.offset.x,
                    y: this.sourceTranslation.y + distanceFromCenter.y * this.targetScale + options.offset.y
                }; // if the time is set to 0, don't do an animation

                if (options.animation.duration === 0) {
                    if (this.lockedOnNodeId != undefined) {
                        var _context3;

                        this.viewFunction = bind(_context3 = this._lockedRedraw).call(_context3, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    } else {
                        this.body.view.scale = this.targetScale;
                        this.body.view.translation = this.targetTranslation;
                        this.body.emitter.emit("_requestRedraw");
                    }
                } else {
                    var _context4;

                    this.animationSpeed = 1 / (60 * options.animation.duration * 0.001) || 1 / 60; // 60 for 60 seconds, 0.001 for milli's

                    this.animationEasingFunction = options.animation.easingFunction;
                    this.viewFunction = bind(_context4 = this._transitionRedraw).call(_context4, this);
                    this.body.emitter.on("initRedraw", this.viewFunction);
                    this.body.emitter.emit("_startRendering");
                }
            }
            /**
             * used to animate smoothly by hijacking the redraw function.
             *
             * @private
             */

        }, {
            key: "_lockedRedraw",
            value: function _lockedRedraw() {
                var nodePosition = {
                    x: this.body.nodes[this.lockedOnNodeId].x,
                    y: this.body.nodes[this.lockedOnNodeId].y
                };
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - nodePosition.x,
                    y: viewCenter.y - nodePosition.y
                };
                var sourceTranslation = this.body.view.translation;
                var targetTranslation = {
                    x: sourceTranslation.x + distanceFromCenter.x * this.body.view.scale + this.lockedOnNodeOffset.x,
                    y: sourceTranslation.y + distanceFromCenter.y * this.body.view.scale + this.lockedOnNodeOffset.y
                };
                this.body.view.translation = targetTranslation;
            }
            /**
             * Resets state of a locked on Node
             */

        }, {
            key: "releaseNode",
            value: function releaseNode() {
                if (this.lockedOnNodeId !== undefined && this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.lockedOnNodeId = undefined;
                    this.lockedOnNodeOffset = undefined;
                }
            }
            /**
             * @param {boolean} [finished=false]
             * @private
             */

        }, {
            key: "_transitionRedraw",
            value: function _transitionRedraw() {
                var finished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this.easingTime += this.animationSpeed;
                this.easingTime = finished === true ? 1.0 : this.easingTime;
                var progress = easingFunctions[this.animationEasingFunction](this.easingTime);
                this.body.view.scale = this.sourceScale + (this.targetScale - this.sourceScale) * progress;
                this.body.view.translation = {
                    x: this.sourceTranslation.x + (this.targetTranslation.x - this.sourceTranslation.x) * progress,
                    y: this.sourceTranslation.y + (this.targetTranslation.y - this.sourceTranslation.y) * progress
                }; // cleanup

                if (this.easingTime >= 1.0) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.easingTime = 0;

                    if (this.lockedOnNodeId != undefined) {
                        var _context5;

                        this.viewFunction = bind(_context5 = this._lockedRedraw).call(_context5, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    }

                    this.body.emitter.emit("animationFinished");
                }
            }
            /**
             *
             * @returns {number}
             */

        }, {
            key: "getScale",
            value: function getScale() {
                return this.body.view.scale;
            }
            /**
             *
             * @returns {{x: number, y: number}}
             */

        }, {
            key: "getViewPosition",
            value: function getViewPosition() {
                return this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
            }
        }]);

        return View;
    }();

    var css_248z$1 = "div.vis-network div.vis-navigation div.vis-button {\n  width: 34px;\n  height: 34px;\n  -moz-border-radius: 17px;\n  border-radius: 17px;\n  position: absolute;\n  display: inline-block;\n  background-position: 2px 2px;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network div.vis-navigation div.vis-button:hover {\n  box-shadow: 0 0 3px 3px rgba(56, 207, 21, 0.3);\n}\n\ndiv.vis-network div.vis-navigation div.vis-button:active {\n  box-shadow: 0 0 1px 3px rgba(56, 207, 21, 0.95);\n}\n\ndiv.vis-network div.vis-navigation div.vis-button.vis-up {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABphJREFUeNqcV2twU9cR/nbPlVTHxpKRbNnBLyEbPyJisLEcPwgwUMKQtjNJAzNJZkgNNJOmJaZAaDKlxaXDTIBAcJtOOzSYKSkdiimhAdIMjyT4bYgBYxA2BgcUQPLrCiGDR4qt2x+yXTASFt1/957d7zt3z3d39xDCMQWUfgAz/RI/T4pSTAJpAGL8rECAXX7QFQGq9wOHOxYO1oCgjAdJj1wtB095Giv9TFuZAIWHAziATMPhTAwiHgUkYPXFJu92lMP/2MTpB1AKUCVEgNAcleUo1M+2F8TO6crSTncb1QleAOj2OTSX3Ge1p+Va42m5JrnzbnsCE8Ov+EHgpa0LPLvCJjZ/whuIlN8wAcXG+e1LUn9hm238QU84p1Ld83nsXvuO7Lq+LzKYGAT6/dn58m/HJTYf4O3EShkT8Irpzab1Uz9sGevT5+tWn+j6NB4A5hp/5NSr43xjfd5rW5tT9e3OAhCBiCua5/WsDEls/hdvYklZSwDefmrT8eXmtzuDkb5YZ33p9ndylICAVjWxf39xw/5g5Luv/9H84ZWNcwNEypZT87rXjqyJB85UYDMJYN3U7UdLJ6/6JlgqV517teRqf9uTlug8e1zEk27HgD22o98WsTBh8fWxvjm6ApdONbGvse8LM5NUPOm1Cfabuz3nACAgxX0QEFTJAnjNvLJ+Sepb14KRHnN+Ev+1XJOhZs3Qu1mbG97J2NQgsXroa1dtxrGuf8cHi1mUtPTay0lv1DMJSCRVLtoX+FgGgDQNysBAcez89l9nbbsQSji7rlXkEhjPxb/QatHOcFu0M9zz419oFSRhj/3PuaHiyqasv1Con9NGxHAYUsoCxAqImbYSgCWmFbZQwdsur7N0eC4m6tT6/jUZ750Zeb82c+OZGLWh/2p/W+Kfrmy0hIp/aVKpTSIJEqu2QgFx2iE8CwDp0RbH7Ljng/4yXr+XT3QdyhYsodS0slGr0g2OrEUK7eCrKW82SqzCVz3/yfb6vRwM4xn9rN7JkRkOQRLmfJn2LBPxQjDBqp9lD7XbX7X8pKTP160zR2bdeiX5jYeU/nLSTztNkem3XL5eXbltRUkonBxdgZ2IIUmahUxERQSCVT+rK5hzQ89xQ6P8VaaK1f5VmRvqQ4G+lba+nlnlb5brMhvlk7FBiaPzuwQEmEQhg5BOxMjWTncHc2501cQLkjDTsMCWpyuRQxFP0xXIJfp5FyVW4Zy7KajC06ItbiIGg6ZITBxDxIgbrr1jTSM0fibGIHz8O9sKK0GAibEua9spANh4aY2VmcEg+DEkiBgR/L2hYFgGtcErkQQAMVJgBxyy9hboZzv32v+Kpr7qbEECTAIMAoaJa3qPTmNiiAAgJAjk6J5xhu6HDAIgQYGLmI29PocmMcI8MNYvT1ckfzD9H/ub5br4e4Me9WfOKqtyX6Ud2cwC449PRamifDm6Auc0rTXokci+Xo1EAgBckiDuYGLjpTvntcGIA+SFcp6uUAaAI879VhWrRteYAqn/edq758brXJ1327QMhgJcZjA3EBjNrgZjOG1PkAjyTGENMjZPq5ECQ0MDE9ERBqFZrk0OJ3i4x/7vyIjBxGERt3takgVJEAp9xq3f769WiPDNvSsJdT3HDOEASPelmoBRYT3Kzt5uMtwauJEgSOCpwrk1DIJCoNUMwj9v7MweP9XSQ8/hJPp496fZTAICvLqcyv2B7nRbrgCA03JN5h8ub7A8VqpB437xHvsOy3l3cyaB4L2uqxhti1WLMcSgZQCw7+bOooO3Pk4JBZIYYXISMV5sKH59UePM10GESRGpIf/bE92HU452HywSJIGIllctrhp6YAK5+fHds0lLtJFMXNwkV6fFqA29mROefqiMJj1h6um4a5vY/92dKGaBxIhU5zJTWW2cJmEgGOmeb3c8FxAfb9mdf2RzyGGv5MvU7QwuEySwKHFp/c/M71zA/2F7b1RajnYdLAqMukMVu2YcfmDYE2MD7H+7/Xlq6cRIJqm4zXM+qd3TGjVBir43KSLlXjiELe5TsX+3/yW/ST45PaAHbKmccWh12AP93JNZywj0kSABIobpiXRHjtZ6faout2tyZMadGLXBCxBcvl6NfaAz+tKdFmObpzWl2+tIIBACYy0t/yj34M7HvsKUK+CGassvicX7alYDwwq+vykIEqPVa+Q9gdYk5+V+UE7lj3+FGbuBM/X5JUT8QwIVSSSZiTgmoFR2MfiqYFFPfjpkyrfWPopwxP47AP1pK1g9/dqeAAAAAElFTkSuQmCC');\n  bottom: 50px;\n  left: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-down {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABpdJREFUeNqcV21QlNcVfp5zX9ikoAvLEsAIIgsoHwpqWAQUNKLNaNv8iZ1JMkNG6/Qj/dDUyCSTtCHpmEkwVk3TToZRMjXj5MOG2KidjIkxQYSAQUAtX6IgIN8su8KCoOzbH4sk4q5g77/33uee555z7rnneYmZDB2MKcJKlyYbqOsZVIgGEOgSHQoy4AKbFFjqAo5dWn/rNAh9OpO852oeJHYxtrmEu4WALhMbxG2ZE9uFAlImDRLY/t/y0b3Ig+u+iWOKsAlgIZSb0OIf15kWtKo1NXh1d5xxiSPEN2wUAHrGOg11jirjWVtJyFnb6YgrzoYwocClu0DI5guPDb43Y2LLp/Iaqf9JCGSErGvIifxd7aqQn/TOJCvFvZ8Hf9haEH+m/6sFQgHBv1Sts/15WmJLkeyl6FuFwFPzny1/ZdE7Nfg/xhv1uUmH2w6kggQp+yqze7d5JbZ8Im+KpucSwI6EN7/cYtlxZarBCts3ptfrtq9odjaGKihE+sV0vRC3u8RqWmmbij149W+Wd5p2rnET6bsqsntyb6+pO3KqkE8FvLxo74lNUX9s9uTJb8/9fG2L81KoogJFYfCm3b9usNq0MXxzw1RsUkDqQICPqf/b/q8sQi3j4WdmtV47OFgNAO6r+DEUFAtFAc9YtpXmRP6hxVsI24cvhyoqnFtrK6jM7isgBa3Dl0O94TeGb255MvzXpUIFjVrhxo/dzgoARBuwFQJkBK9reCnurxfvXX8CRW3yW1G749vT2Br7ysW0oNX1pKDTPG+rm1gHRbibAHLm/7522sKnQCZqFgCUaBCqaS/bEw9vqtWoQROf3dBBiT6KTACImZ3YueqhDdOWjDbFQ4IzIl4elNUX5begU1HD6lPRmULKeghhDcpqnUmZuD3+nkgTH6gZEE9ctlZSoGmG9UIynSCsQVndMyX+IZGiBoHMjHh2SreCglClaSBiSEG8cYnD24bv7CWms/3FocO3hnw13plTggAFb196NdlPM44tC0zrSg5ItXmyEz070UEKCMRqQgkkBQ9NvL2eSJ+revoJTORSpoT6do4/7/7UShBFHQexM+HdfyUHWO8iN/uaRzX3/QjUSLlnqM72F4cCRIY5u9Zf+Y+BAv4AvzpkQ7WAIBRujA/7Vg6cia9xlId6InafVEAAGnQMUCSkb6zTMPdBy8hU3JjrphIq+CrD+Mvxeyumrr+4IH9y7o2GF5eDghuuGx4L2zbWZ9Dc0RoQRbkkFNRdP2/0BH7EtLJLKCjr+zqh2l5u8haZ847vTBW24kRFQXKAtcsT5oqz3igQENIoECkjBJUDZSGewBlBj/ammjLrdX1c/t70ero34gMte9IByLLAjPrUwKweT5jawQshdIuGMiF5XEBU2koivBl9NeEfJeYHwuxtI81zPrn2z6ip60c6DkV1jLTOCTaE2HNjd5Z4s9MwWBOhqEHp/I9cWDtUrJNoHm4KO9P7hdnTBoMYXI8Gb6gVCg63FS53jg9O5tA57tSOdHywnCAygrJrfcTgUe5U2cvNHSPtYYoKCWlrTgsIneB2AfFR+4F4b6f9ZdTzF6P8Ytud407/dy/nL7k9X9i8J9l5y+Ef6RfbnjPvWa8N5suez+KFCgqyPY95Lnd3stv2AcBZ2+mFbze+lui1xc3dXCUUlPafXNx4/aKxcajWWNp/MklRw8/mPFntbd+h1oLE847KhQQxejVg36QQqD0MPTzHv42Ux+uGasJNBnPfwllJd71kkX7RQ3WDNf7dox3BLcNNs6vt34bbbvYHJhlTGp6O+JVHb0/2HJtX1PH+aqECqG/5YN1nlXcokGvvO6vCc4x+QskotxVHB/qa+xbOWuzw8NB3nuo+Ht0z2hHsuGU3GrWAoZfi3jrxgHpw3BPpobaCH7vbqOw6mHI836vYW3Eqcq9AtioqbJy7ufQ3lhfu8sR+s9+3vL8klACsQSu7AnxMY1MxH7YXJp7oPpLulrrj+9575Ni2aeVt1teWfEWfHQLCaspseHzOU7VWU+aM5G2NoyL4i+6j8XWDNQsmGsKu/cv+nTtjQb/mm7hfENyvqEAK5v8opjPJaL26KGBpd5TfguuBvuZRgBgY6zO0jlyZXXe9JqR+8MK8ntHOMHfHIkhu2b/0yIH7/oXJ0yFlxYnPUdRbvuILgO7+y+91l6Ka6M+cnCf4fMSypXvymHf/vzBTD3CuNGUFKT8lmK5Rs5ASqKiBlAGBXFaiSuni0fkp1pJ7Ed4e/xsAqLk46EWsG1EAAAAASUVORK5CYII=');\n  bottom: 10px;\n  left: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-left {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  left: 15px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-right {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABs1JREFUeNqsl3tQlOcVxp9z3m+XygK7C4sLxkW5o4CAkYssFSkRjabjJEOSJm1IbZx2krapiZdeprW0NVVJ0pqMM0kYJQlqkoZImGioE1ItiCAgIsFwE4Es99vCslwChf36xy5EW1A0Pn9+73fO772e93kJC5EMCszFd20SbyFZNpJAAACtjWUI8KAN1CRAJTbg9LXNU+dBkG+Xkm7Zmg4OWoUdNqZXmQCZHQFsz0yOcCYGEc8mJGDnl2UTh5AO2x2DA3OxDaAsCDvQ32VF11qP9aZYz6SeFeooi17pPQEAvZNdTnWWKnWFuVhfYT7v0zza4M3EsMk2EPgnNZusby8Y7P8x/5lI/gMTYNSnNKQt/0Xtev1DfQtZlaK+M54fmDJXXhg4G8zEINBfqlLMe28L9s/lQ8Tyr5iAJ32fK/tj+OFq3IUO1O+JyGk7GgsiEPFrlQ/07bixXdwEPckHWZJ3MgG7Qw9+/mLIS/W4SyXoNvQskpyHLg1e8CNQ3NI0laoje7Tg/8CBudgGgQwSwO/DD322ze/FFnxLRWhiBzUK94GLA2f9mSTjfU+7mjqyrVe+AX8I4aGgShbA0/47Sn4ZuLcR90ih6qih0anRiVprtUEQb43bYtlXmwNZAEDAj/ACMW1M8ExpeDXyWMVCEl4yF7vntR/zLeov8JJlWfZR+Y3N92+cx/reOmu1quNrk27EWW0xvWspJcigoNNkA4C3Yk59vH7xltvu3ktDxe7PX34ilQCQfeci1j2xfn94ZrGCneY8uxcHCnW/vbr9EQD4d2ITc8AprAOAQLewroVAAaB8oMiLiRHvmVy7znNTjWCFrXKoJOSHFQ+kvnF9f+jco07s91MFdwmSkHQuYB0T8WYwIcYj0bTQdRufGlFKJMFVaCb/GvZW6aGI4yeXOwd2mr/u05zsyDY+W5X64Nm+fO85NpuJiCFJTpslIoonADEeiT2zIzIXuh+o25PQNtbsNVMOBUn2g08MiSTHN3uZjNTEDr4dnX/6H+1H/XPasmKvW+sMGfW/MXzende4K3h/ibvSYxIAItyie/K7cgCitQxCIBFjpTrKMgM+WPfrhLbxFi9iMQtlYjAJSCSBSYBAIPBNI3p86TPXj8bk56R4PVylFE626uFLQc9efiTVPDmgBIAAtzALEYNBQRITa4kYix21FwBax655CVagPLk7806Pj1qo/7MraF/FQ14/aMhszYhvGqn3KTef89rklWrSKXUTkn3mtJK9Bzf3XJA0e/PcrdgxIwSCDPmbZMQgABJkDBKzvn+yy2npIv9xAPB1Ceo2jTZ7Gc8afipIgEhAkACDwcSQQZBIIGnx5it7gg+U3wgcnbZKR1r+FnW+v2DVtDwtXCXNSKz797oAwDzZ7ySRAIBBFsTXmBh1w1+oZ4J3h+wv9lUFdbMDOrO+5IAqWIGZthuV13nC77nKRx8r7PssyibLIkoT1/h65HsfzWyu5tF6NYNB4EYJzKUETqgcLNVv0D/cDQBrNAnm9+LOfTLfNB5u2hf5z+6TMexYji+tVdrM5leMbWOtSwQx/F1C2rcuebIqwSO568a4WmuN3mEYSiUi+pRl2l1pLvYBsKArUKVwnZRYgdHpMWVG4+/WXhwoDBXE7OmkHzJ6JNemLfv51bniGqzVPoIkyLbpfK7ZMFIkE6FlrMn7Ql+BbiHg+zXGbgLjylDpyosD58KZmKM0cfWHI9//aD5o1VCZrnO83VuQQOja5PMCfwK8n3K2ChIbLVOD9KB36le3A+u/s2Q81C2yRavQmQNdVnamLnmq4nHD9jpB0rwm77jpjTW9E906Bu18fWlWCQHAox9CtGoXTwmS8IThZyXPB+29inuoE6bMsDM9ufEAMNHqJuU8ljMtAKA2B7IhzaWNiLfWjVQb3J10/SGuEZZ7Af1X7+lluZ3HkpgEQPL291M+qbzJgXQcG60ypKlVTGwsMxcFaJW6/hDXVZZvCz3RlrmRiQHwy9nRn2bM6bnas4cLfH6s1RIorsJcFDA2PToR7Z7QezfQD9qzwvI6TyTZC47ttXeiT+2c1+wBgOndoTPLt7mrmCRjvfULQ4O1xsVVchu7b9GysYUAqy3lnsdNb0aXmQuj7PYWL2etuRl6S0OfXLjiGQIdEY6K5esc2BWhjvkqXLO6x08VPKxV6iYAwuBkv5NpvNmtbrhaX2+tWdY70eVNINhtLW0/sjrv6B0/YdJlcGlR2AvE4hUlKwHQ7BU5cz8LRx0HaPY7gXb53L/67+mUfudPmP/twOWS6AQi/j6B4iWS/IlYK+yGYJDB1wWLErLRKd/omOJbAWf03wEAyO9m+/TtS3AAAAAASUVORK5CYII=');\n  bottom: 10px;\n  left: 95px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomIn {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  right: 15px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomOut {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABV5JREFUeNq0l2tQVVUYht/3W/vACMr16IFRQDiAgChpgiikMqY1WjnN9KsfGOXYTOVgkvbDUsZuXrK0qZmGUSvNspjI8TZOmo6AGBoZYly8YB6Qw80DBwQ6jJ3dj30OZZmiwvtv77XW96y91l7v9y1iMNLBuCI84tZkIXU9gwqxAILdokNBOtzgJQWWuYEDFxfcLAGh3y0k79iaD4mfjOVu4WYhoItngBiR6RkuFJAyEJBA3m/lri3Ih/uewXFFyAG4A8oAWkcm2meEzrFNH53Vkhg4xWnxCXcBQGu/3bfGeTbwjKPUcsZRElnfUxcuFLh1Nwh5vurx7s8GDbZ+L+tI/U0hkGGZX5c9/pXqOZYn2gazK8Vth0fvsRUknbx+bIJQQPCts/Mda+4KthbJFoqeKwSejX6pfO2kjytxH1pfuyqlsGH7dJAgZWvFo23L/9muboF+JxtE0/OEwMqJG46uSHinFvepTPO8lhGaX+fPHSdjCKaPy/b3v7az58h/wHFFyIHCRirgjUlbfsiJWXEFD6iUoOkdQaaQ6z9dP2YVahljF4+yXdvZ/evf4G+hQk2sEAUsti4vWxa35gKGSBMDp3T23OxxVXdXRijKovSFzrerC6ELAMT6IhcCZIyeX7c68YPzGGLlxq89PyM0q5YU2M1RuQAg0EERbiaA7Ohl1RgmPTM2p1qjBk1Mm6GDErsfswAgLiDZPmfMwrbhAqeHzm6P8Z9gV9SQdTx2lpCyAEKkhc62YZiVEjTdRgo0zXeBRnImAaSFzm7xdjjtOBGyvmZVZkNvfZjXDhU14+BToFEDKRAQpAJ0HRTjP6XHpYUKEX7RzS9bV5c+FJTmAICUgNSWQ/ZCgJwhIOJIQVLgFKcXvKHm9cyGvithFDUAFQqECho1CBUIggYapAJ1QEFBExNMYoISDU1/NIR9cvndTG/c2IBkp2fC8ZpQgknBGI/3AsDvvRfDlJhwem5zwYMs7VNlaUtbXE1h3mezj9mlGSsXrBkzkFsGKGoDmedBJLfLjxQQgAYdHRSxtPfbfceNsPYBQPTI+GZbT31YxrGIpYoKpIKigkAgFOggNBrbQBBCBaEM2L+iGGmTgnF+Uc1epqO/3VejAoAOUZSLQkFN17lAb4eVCe+VRvvHN4sH6t1feqAmMUGoPHvvhdLzTjzfKoj0sza/GLOy1Bu3vqc20Pgl5YIGkVOEZFZ0nLLMszzdDADTgjIdX6Uf3zfUx6m6u8riKRhOCcmDAqLCURo53Oe4rrsyUlGD0nlIqubdKNZJXOm9FH6y7Yh5uKBnO8vNTX2N4YoKE2fMLREQOsE8AfFN4/ak4QIfbd2XJFRQkLx85ruN7NTp2AoAZxwlCR9dWJc81NDdtoLkc86KBIJwXQ3aOpCPqwuhR2SPbCBlUc2NyogQX3N7wqgU51BAf2w9EFXUtCtLqADqS76ev6/ilgrk2q6esxHZgf5CySh3FMcG+5jbE0ZNdj4odHdDwWPGcZNNO1MPbrxtzdW4s+tI5HPBwQTTzziKY3v/7HGlhmS23g90T+OO5L1Nu7MMw3Fv/Tx1f97/FnsAYPui8/D4nBB/oZZR230uoq67auQoLaB37Iio3sEAK52nR39p+zS13HFiilHeYtOOabdC71jQzz2R+ALBbcrjWNF+cfaUwLSrk4KmtsT4T+gK9jG7AKKjv93X1lcfUNNVaantropqddnDCcIoa7lk29S92+/5CpOvQ04VJ79KUe/7iI/Hh40U6c3PyuPjhmWKN8G8Fvnw1A/zmX/vV5h/T+CXstRMUp4kOFOjZiUlWBkFQYdALitRZXRzf3RqWumdgF79NQDBOa2V/iYSHAAAAABJRU5ErkJggg==');\n  bottom: 10px;\n  right: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomExtends {\n  background-image: url('data:image/png;base64,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');\n  bottom: 50px;\n  right: 15px;\n}\n";
    styleInject(css_248z$1);

    /**
     * Created by Alex on 11/6/2014.
     */
    function keycharm(options) {
        var preventDefault = options && options.preventDefault || false;
        var container = options && options.container || window;
        var _exportFunctions = {};
        var _bound = {
            keydown: {},
            keyup: {}
        };
        var _keys = {};
        var i; // a - z

        for (i = 97; i <= 122; i++) {
            _keys[String.fromCharCode(i)] = {
                code: 65 + (i - 97),
                shift: false
            };
        } // A - Z


        for (i = 65; i <= 90; i++) {
            _keys[String.fromCharCode(i)] = {
                code: i,
                shift: true
            };
        } // 0 - 9


        for (i = 0; i <= 9; i++) {
            _keys['' + i] = {
                code: 48 + i,
                shift: false
            };
        } // F1 - F12


        for (i = 1; i <= 12; i++) {
            _keys['F' + i] = {
                code: 111 + i,
                shift: false
            };
        } // num0 - num9


        for (i = 0; i <= 9; i++) {
            _keys['num' + i] = {
                code: 96 + i,
                shift: false
            };
        } // numpad misc


        _keys['num*'] = {
            code: 106,
            shift: false
        };
        _keys['num+'] = {
            code: 107,
            shift: false
        };
        _keys['num-'] = {
            code: 109,
            shift: false
        };
        _keys['num/'] = {
            code: 111,
            shift: false
        };
        _keys['num.'] = {
            code: 110,
            shift: false
        }; // arrows

        _keys['left'] = {
            code: 37,
            shift: false
        };
        _keys['up'] = {
            code: 38,
            shift: false
        };
        _keys['right'] = {
            code: 39,
            shift: false
        };
        _keys['down'] = {
            code: 40,
            shift: false
        }; // extra keys

        _keys['space'] = {
            code: 32,
            shift: false
        };
        _keys['enter'] = {
            code: 13,
            shift: false
        };
        _keys['shift'] = {
            code: 16,
            shift: undefined
        };
        _keys['esc'] = {
            code: 27,
            shift: false
        };
        _keys['backspace'] = {
            code: 8,
            shift: false
        };
        _keys['tab'] = {
            code: 9,
            shift: false
        };
        _keys['ctrl'] = {
            code: 17,
            shift: false
        };
        _keys['alt'] = {
            code: 18,
            shift: false
        };
        _keys['delete'] = {
            code: 46,
            shift: false
        };
        _keys['pageup'] = {
            code: 33,
            shift: false
        };
        _keys['pagedown'] = {
            code: 34,
            shift: false
        }; // symbols

        _keys['='] = {
            code: 187,
            shift: false
        };
        _keys['-'] = {
            code: 189,
            shift: false
        };
        _keys[']'] = {
            code: 221,
            shift: false
        };
        _keys['['] = {
            code: 219,
            shift: false
        };

        var down = function (event) {
            handleEvent(event, 'keydown');
        };

        var up = function (event) {
            handleEvent(event, 'keyup');
        }; // handle the actualy bound key with the event


        var handleEvent = function (event, type) {
            if (_bound[type][event.keyCode] !== undefined) {
                var bound = _bound[type][event.keyCode];

                for (var i = 0; i < bound.length; i++) {
                    if (bound[i].shift === undefined) {
                        bound[i].fn(event);
                    } else if (bound[i].shift == true && event.shiftKey == true) {
                        bound[i].fn(event);
                    } else if (bound[i].shift == false && event.shiftKey == false) {
                        bound[i].fn(event);
                    }
                }

                if (preventDefault == true) {
                    event.preventDefault();
                }
            }
        }; // bind a key to a callback


        _exportFunctions.bind = function (key, callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            if (_keys[key] === undefined) {
                throw new Error("unsupported key: " + key);
            }

            if (_bound[type][_keys[key].code] === undefined) {
                _bound[type][_keys[key].code] = [];
            }

            _bound[type][_keys[key].code].push({
                fn: callback,
                shift: _keys[key].shift
            });
        }; // bind all keys to a call back (demo purposes)


        _exportFunctions.bindAll = function (callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            for (var key in _keys) {
                if (_keys.hasOwnProperty(key)) {
                    _exportFunctions.bind(key, callback, type);
                }
            }
        }; // get the key label from an event


        _exportFunctions.getKey = function (event) {
            for (var key in _keys) {
                if (_keys.hasOwnProperty(key)) {
                    if (event.shiftKey == true && _keys[key].shift == true && event.keyCode == _keys[key].code) {
                        return key;
                    } else if (event.shiftKey == false && _keys[key].shift == false && event.keyCode == _keys[key].code) {
                        return key;
                    } else if (event.keyCode == _keys[key].code && key == 'shift') {
                        return key;
                    }
                }
            }

            return "unknown key, currently not supported";
        }; // unbind either a specific callback from a key or all of them (by leaving callback undefined)


        _exportFunctions.unbind = function (key, callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            if (_keys[key] === undefined) {
                throw new Error("unsupported key: " + key);
            }

            if (callback !== undefined) {
                var newBindings = [];
                var bound = _bound[type][_keys[key].code];

                if (bound !== undefined) {
                    for (var i = 0; i < bound.length; i++) {
                        if (!(bound[i].fn == callback && bound[i].shift == _keys[key].shift)) {
                            newBindings.push(_bound[type][_keys[key].code][i]);
                        }
                    }
                }

                _bound[type][_keys[key].code] = newBindings;
            } else {
                _bound[type][_keys[key].code] = [];
            }
        }; // reset all bound variables.


        _exportFunctions.reset = function () {
            _bound = {
                keydown: {},
                keyup: {}
            };
        }; // unbind all listeners and reset all variables.


        _exportFunctions.destroy = function () {
            _bound = {
                keydown: {},
                keyup: {}
            };
            container.removeEventListener('keydown', down, true);
            container.removeEventListener('keyup', up, true);
        }; // create listeners.


        container.addEventListener('keydown', down, true);
        container.addEventListener('keyup', up, true); // return the public functions.

        return _exportFunctions;
    }

    /**
     * Navigation Handler
     */

    var NavigationHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function NavigationHandler(body, canvas) {
            var _this = this;

            _classCallCheck(this, NavigationHandler);

            this.body = body;
            this.canvas = canvas;
            this.iconsCreated = false;
            this.navigationHammers = [];
            this.boundFunctions = {};
            this.touchTime = 0;
            this.activated = false;
            this.body.emitter.on("activate", function () {
                _this.activated = true;

                _this.configureKeyboardBindings();
            });
            this.body.emitter.on("deactivate", function () {
                _this.activated = false;

                _this.configureKeyboardBindings();
            });
            this.body.emitter.on("destroy", function () {
                if (_this.keycharm !== undefined) {
                    _this.keycharm.destroy();
                }
            });
            this.options = {};
        }
        /**
         *
         * @param {object} options
         */


        _createClass(NavigationHandler, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    this.options = options;
                    this.create();
                }
            }
            /**
             * Creates or refreshes navigation and sets key bindings
             */

        }, {
            key: "create",
            value: function create() {
                if (this.options.navigationButtons === true) {
                    if (this.iconsCreated === false) {
                        this.loadNavigationElements();
                    }
                } else if (this.iconsCreated === true) {
                    this.cleanNavigation();
                }

                this.configureKeyboardBindings();
            }
            /**
             * Cleans up previous navigation items
             */

        }, {
            key: "cleanNavigation",
            value: function cleanNavigation() {
                // clean hammer bindings
                if (this.navigationHammers.length != 0) {
                    for (var i = 0; i < this.navigationHammers.length; i++) {
                        this.navigationHammers[i].destroy();
                    }

                    this.navigationHammers = [];
                } // clean up previous navigation items


                if (this.navigationDOM && this.navigationDOM["wrapper"] && this.navigationDOM["wrapper"].parentNode) {
                    this.navigationDOM["wrapper"].parentNode.removeChild(this.navigationDOM["wrapper"]);
                }

                this.iconsCreated = false;
            }
            /**
             * Creation of the navigation controls nodes. They are drawn over the rest of the nodes and are not affected by scale and translation
             * they have a triggerFunction which is called on click. If the position of the navigation controls is dependent
             * on this.frame.canvas.clientWidth or this.frame.canvas.clientHeight, we flag horizontalAlignLeft and verticalAlignTop false.
             * This means that the location will be corrected by the _relocateNavigation function on a size change of the canvas.
             *
             * @private
             */

        }, {
            key: "loadNavigationElements",
            value: function loadNavigationElements() {
                var _this2 = this;

                this.cleanNavigation();
                this.navigationDOM = {};
                var navigationDivs = ["up", "down", "left", "right", "zoomIn", "zoomOut", "zoomExtends"];
                var navigationDivActions = ["_moveUp", "_moveDown", "_moveLeft", "_moveRight", "_zoomIn", "_zoomOut", "_fit"];
                this.navigationDOM["wrapper"] = document.createElement("div");
                this.navigationDOM["wrapper"].className = "vis-navigation";
                this.canvas.frame.appendChild(this.navigationDOM["wrapper"]);

                for (var i = 0; i < navigationDivs.length; i++) {
                    this.navigationDOM[navigationDivs[i]] = document.createElement("div");
                    this.navigationDOM[navigationDivs[i]].className = "vis-button vis-" + navigationDivs[i];
                    this.navigationDOM["wrapper"].appendChild(this.navigationDOM[navigationDivs[i]]);
                    var hammer = new Hammer$1(this.navigationDOM[navigationDivs[i]]);

                    if (navigationDivActions[i] === "_fit") {
                        var _context;

                        onTouch(hammer, bind(_context = this._fit).call(_context, this));
                    } else {
                        var _context2;

                        onTouch(hammer, bind(_context2 = this.bindToRedraw).call(_context2, this, navigationDivActions[i]));
                    }

                    this.navigationHammers.push(hammer);
                } // use a hammer for the release so we do not require the one used in the rest of the network
                // the one the rest uses can be overloaded by the manipulation system.


                var hammerFrame = new Hammer$1(this.canvas.frame);
                onRelease(hammerFrame, function () {
                    _this2._stopMovement();
                });
                this.navigationHammers.push(hammerFrame);
                this.iconsCreated = true;
            }
            /**
             *
             * @param {string} action
             */

        }, {
            key: "bindToRedraw",
            value: function bindToRedraw(action) {
                if (this.boundFunctions[action] === undefined) {
                    var _context3;

                    this.boundFunctions[action] = bind(_context3 = this[action]).call(_context3, this);
                    this.body.emitter.on("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_startRendering");
                }
            }
            /**
             *
             * @param {string} action
             */

        }, {
            key: "unbindFromRedraw",
            value: function unbindFromRedraw(action) {
                if (this.boundFunctions[action] !== undefined) {
                    this.body.emitter.off("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_stopRendering");
                    delete this.boundFunctions[action];
                }
            }
            /**
             * this stops all movement induced by the navigation buttons
             *
             * @private
             */

        }, {
            key: "_fit",
            value: function _fit() {
                if (new Date().valueOf() - this.touchTime > 700) {
                    // TODO: fix ugly hack to avoid hammer's double fireing of event (because we use release?)
                    this.body.emitter.emit("fit", {
                        duration: 700
                    });
                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             * this stops all movement induced by the navigation buttons
             *
             * @private
             */

        }, {
            key: "_stopMovement",
            value: function _stopMovement() {
                for (var boundAction in this.boundFunctions) {
                    if (Object.prototype.hasOwnProperty.call(this.boundFunctions, boundAction)) {
                        this.body.emitter.off("initRedraw", this.boundFunctions[boundAction]);
                        this.body.emitter.emit("_stopRendering");
                    }
                }

                this.boundFunctions = {};
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveUp",
            value: function _moveUp() {
                this.body.view.translation.y += this.options.keyboard.speed.y;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveDown",
            value: function _moveDown() {
                this.body.view.translation.y -= this.options.keyboard.speed.y;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveLeft",
            value: function _moveLeft() {
                this.body.view.translation.x += this.options.keyboard.speed.x;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveRight",
            value: function _moveRight() {
                this.body.view.translation.x -= this.options.keyboard.speed.x;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_zoomIn",
            value: function _zoomIn() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale * (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "+",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
            /**
             *
             * @private
             */

        }, {
            key: "_zoomOut",
            value: function _zoomOut() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale / (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "-",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
            /**
             * bind all keys using keycharm.
             */

        }, {
            key: "configureKeyboardBindings",
            value: function configureKeyboardBindings() {
                var _this3 = this;

                if (this.keycharm !== undefined) {
                    this.keycharm.destroy();
                }

                if (this.options.keyboard.enabled === true) {
                    if (this.options.keyboard.bindToWindow === true) {
                        this.keycharm = keycharm({
                            container: window,
                            preventDefault: true
                        });
                    } else {
                        this.keycharm = keycharm({
                            container: this.canvas.frame,
                            preventDefault: true
                        });
                    }

                    this.keycharm.reset();

                    if (this.activated === true) {
                        var _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21, _context22, _context23, _context24, _context25, _context26, _context27;

                        bind(_context4 = this.keycharm).call(_context4, "up", function () {
                            _this3.bindToRedraw("_moveUp");
                        }, "keydown");

                        bind(_context5 = this.keycharm).call(_context5, "down", function () {
                            _this3.bindToRedraw("_moveDown");
                        }, "keydown");

                        bind(_context6 = this.keycharm).call(_context6, "left", function () {
                            _this3.bindToRedraw("_moveLeft");
                        }, "keydown");

                        bind(_context7 = this.keycharm).call(_context7, "right", function () {
                            _this3.bindToRedraw("_moveRight");
                        }, "keydown");

                        bind(_context8 = this.keycharm).call(_context8, "=", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context9 = this.keycharm).call(_context9, "num+", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context10 = this.keycharm).call(_context10, "num-", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context11 = this.keycharm).call(_context11, "-", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context12 = this.keycharm).call(_context12, "[", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context13 = this.keycharm).call(_context13, "]", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context14 = this.keycharm).call(_context14, "pageup", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context15 = this.keycharm).call(_context15, "pagedown", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context16 = this.keycharm).call(_context16, "up", function () {
                            _this3.unbindFromRedraw("_moveUp");
                        }, "keyup");

                        bind(_context17 = this.keycharm).call(_context17, "down", function () {
                            _this3.unbindFromRedraw("_moveDown");
                        }, "keyup");

                        bind(_context18 = this.keycharm).call(_context18, "left", function () {
                            _this3.unbindFromRedraw("_moveLeft");
                        }, "keyup");

                        bind(_context19 = this.keycharm).call(_context19, "right", function () {
                            _this3.unbindFromRedraw("_moveRight");
                        }, "keyup");

                        bind(_context20 = this.keycharm).call(_context20, "=", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context21 = this.keycharm).call(_context21, "num+", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context22 = this.keycharm).call(_context22, "num-", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context23 = this.keycharm).call(_context23, "-", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context24 = this.keycharm).call(_context24, "[", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context25 = this.keycharm).call(_context25, "]", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context26 = this.keycharm).call(_context26, "pageup", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context27 = this.keycharm).call(_context27, "pagedown", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                    }
                }
            }
        }]);

        return NavigationHandler;
    }();

    function _createForOfIteratorHelper$4(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$4(o, minLen) { var _context15; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = slice$1(_context15 = Object.prototype.toString.call(o)).call(_context15, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

    function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Handler for interactions
     */

    var InteractionHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         * @param {SelectionHandler} selectionHandler
         */
        function InteractionHandler(body, canvas, selectionHandler) {
            var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13;

            _classCallCheck(this, InteractionHandler);

            this.body = body;
            this.canvas = canvas;
            this.selectionHandler = selectionHandler;
            this.navigationHandler = new NavigationHandler(body, canvas); // bind the events from hammer to functions in this object

            this.body.eventListeners.onTap = bind(_context = this.onTap).call(_context, this);
            this.body.eventListeners.onTouch = bind(_context2 = this.onTouch).call(_context2, this);
            this.body.eventListeners.onDoubleTap = bind(_context3 = this.onDoubleTap).call(_context3, this);
            this.body.eventListeners.onHold = bind(_context4 = this.onHold).call(_context4, this);
            this.body.eventListeners.onDragStart = bind(_context5 = this.onDragStart).call(_context5, this);
            this.body.eventListeners.onDrag = bind(_context6 = this.onDrag).call(_context6, this);
            this.body.eventListeners.onDragEnd = bind(_context7 = this.onDragEnd).call(_context7, this);
            this.body.eventListeners.onMouseWheel = bind(_context8 = this.onMouseWheel).call(_context8, this);
            this.body.eventListeners.onPinch = bind(_context9 = this.onPinch).call(_context9, this);
            this.body.eventListeners.onMouseMove = bind(_context10 = this.onMouseMove).call(_context10, this);
            this.body.eventListeners.onRelease = bind(_context11 = this.onRelease).call(_context11, this);
            this.body.eventListeners.onContext = bind(_context12 = this.onContext).call(_context12, this);
            this.touchTime = 0;
            this.drag = {};
            this.pinch = {};
            this.popup = undefined;
            this.popupObj = undefined;
            this.popupTimer = undefined;
            this.body.functions.getPointer = bind(_context13 = this.getPointer).call(_context13, this);
            this.options = {};
            this.defaultOptions = {
                dragNodes: true,
                dragView: true,
                hover: false,
                keyboard: {
                    enabled: false,
                    speed: {
                        x: 10,
                        y: 10,
                        zoom: 0.02
                    },
                    bindToWindow: true
                },
                navigationButtons: false,
                tooltipDelay: 300,
                zoomView: true,
                zoomSpeed: 1
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(InteractionHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;

                this.body.emitter.on("destroy", function () {
                    clearTimeout(_this.popupTimer);
                    delete _this.body.functions.getPointer;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // extend all but the values in fields
                    var fields = ["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag", "keyboard", "multiselect", "selectable", "selectConnectedEdges"];
                    selectiveNotDeepExtend(fields, this.options, options); // merge the keyboard options in.

                    mergeOptions(this.options, options, "keyboard");

                    if (options.tooltip) {
                        assign$2(this.options.tooltip, options.tooltip);

                        if (options.tooltip.color) {
                            this.options.tooltip.color = parseColor(options.tooltip.color);
                        }
                    }
                }

                this.navigationHandler.setOptions(this.options);
            }
            /**
             * Get the pointer location from a touch location
             *
             * @param {{x: number, y: number}} touch
             * @returns {{x: number, y: number}} pointer
             * @private
             */

        }, {
            key: "getPointer",
            value: function getPointer(touch) {
                return {
                    x: touch.x - getAbsoluteLeft(this.canvas.frame.canvas),
                    y: touch.y - getAbsoluteTop(this.canvas.frame.canvas)
                };
            }
            /**
             * On start of a touch gesture, store the pointer
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "onTouch",
            value: function onTouch(event) {
                if (new Date().valueOf() - this.touchTime > 50) {
                    this.drag.pointer = this.getPointer(event.center);
                    this.drag.pinched = false;
                    this.pinch.scale = this.body.view.scale; // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             * handle tap/click event: select/unselect a node
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onTap",
            value: function onTap(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect && (event.changedPointers[0].ctrlKey || event.changedPointers[0].metaKey);
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
            }
            /**
             * handle doubletap event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDoubleTap",
            value: function onDoubleTap(event) {
                var pointer = this.getPointer(event.center);
                this.selectionHandler.generateClickEvent("doubleClick", event, pointer);
            }
            /**
             * handle long tap event: multi select nodes
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onHold",
            value: function onHold(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect;
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
                this.selectionHandler.generateClickEvent("hold", event, pointer);
            }
            /**
             * handle the release of the screen
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onRelease",
            value: function onRelease(event) {
                if (new Date().valueOf() - this.touchTime > 10) {
                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.generateClickEvent("release", event, pointer); // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             *
             * @param {Event} event
             */

        }, {
            key: "onContext",
            value: function onContext(event) {
                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                this.selectionHandler.generateClickEvent("oncontext", event, pointer);
            }
            /**
             * Select and deselect nodes depending current selection change.
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [add=false]
             */

        }, {
            key: "checkSelectionChanges",
            value: function checkSelectionChanges(pointer) {
                var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                if (add === true) {
                    this.selectionHandler.selectAdditionalOnPoint(pointer);
                } else {
                    this.selectionHandler.selectOnPoint(pointer);
                }
            }
            /**
             * Remove all node and edge id's from the first set that are present in the second one.
             *
             * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} firstSet
             * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} secondSet
             * @returns {{nodes: Array.<Node>, edges: Array.<vis.Edge>}}
             * @private
             */

        }, {
            key: "_determineDifference",
            value: function _determineDifference(firstSet, secondSet) {
                var arrayDiff = function arrayDiff(firstArr, secondArr) {
                    var result = [];

                    for (var i = 0; i < firstArr.length; i++) {
                        var value = firstArr[i];

                        if (indexOf(secondArr).call(secondArr, value) === -1) {
                            result.push(value);
                        }
                    }

                    return result;
                };

                return {
                    nodes: arrayDiff(firstSet.nodes, secondSet.nodes),
                    edges: arrayDiff(firstSet.edges, secondSet.edges)
                };
            }
            /**
             * This function is called by onDragStart.
             * It is separated out because we can then overload it for the datamanipulation system.
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDragStart",
            value: function onDragStart(event) {
                // if already dragging, do not start
                // this can happen on touch screens with multiple fingers
                if (this.drag.dragging) {
                    return;
                } //in case the touch event was triggered on an external div, do the initial touch now.


                if (this.drag.pointer === undefined) {
                    this.onTouch(event);
                } // note: drag.pointer is set in onTouch to get the initial touch location


                var node = this.selectionHandler.getNodeAt(this.drag.pointer);
                this.drag.dragging = true;
                this.drag.selection = [];
                this.drag.translation = assign$2({}, this.body.view.translation); // copy the object

                this.drag.nodeId = undefined;

                if (event.srcEvent.shiftKey) {
                    this.body.selectionBox.show = true;
                    var pointer = this.getPointer(event.center);
                    this.body.selectionBox.position.start = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                    this.body.selectionBox.position.end = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                }

                if (node !== undefined && this.options.dragNodes === true) {
                    this.drag.nodeId = node.id; // select the clicked node if not yet selected

                    if (node.isSelected() === false) {
                        this.selectionHandler.unselectAll();
                        this.selectionHandler.selectObject(node);
                    } // after select to contain the node


                    this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer); // create an array with the selected nodes and their original location and status

                    var _iterator = _createForOfIteratorHelper$4(this.selectionHandler.getSelectedNodes()),
                        _step;

                    try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var _node = _step.value;
                            var s = {
                                id: _node.id,
                                node: _node,
                                // store original x, y, xFixed and yFixed, make the node temporarily Fixed
                                x: _node.x,
                                y: _node.y,
                                xFixed: _node.options.fixed.x,
                                yFixed: _node.options.fixed.y
                            };
                            _node.options.fixed.x = true;
                            _node.options.fixed.y = true;
                            this.drag.selection.push(s);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                } else {
                    // fallback if no node is selected and thus the view is dragged.
                    this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer, undefined, true);
                }
            }
            /**
             * handle drag event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDrag",
            value: function onDrag(event) {
                var _this2 = this;

                if (this.drag.pinched === true) {
                    return;
                } // remove the focus on node if it is focussed on by the focusOnNode


                this.body.emitter.emit("unlockNode");
                var pointer = this.getPointer(event.center);
                var selection = this.drag.selection;

                if (selection && selection.length && this.options.dragNodes === true) {
                    this.selectionHandler.generateClickEvent("dragging", event, pointer); // calculate delta's and new location

                    var deltaX = pointer.x - this.drag.pointer.x;
                    var deltaY = pointer.y - this.drag.pointer.y; // update position of all selected nodes

                    forEach$2(selection).call(selection, function (selection) {
                        var node = selection.node; // only move the node if it was not fixed initially

                        if (selection.xFixed === false) {
                            node.x = _this2.canvas._XconvertDOMtoCanvas(_this2.canvas._XconvertCanvasToDOM(selection.x) + deltaX);
                        } // only move the node if it was not fixed initially


                        if (selection.yFixed === false) {
                            node.y = _this2.canvas._YconvertDOMtoCanvas(_this2.canvas._YconvertCanvasToDOM(selection.y) + deltaY);
                        }
                    }); // start the simulation of the physics


                    this.body.emitter.emit("startSimulation");
                } else {
                    // create selection box
                    if (event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true); // if the drag was not started properly because the click started outside the network div, start it now.

                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }

                        this.body.selectionBox.position.end = {
                            x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                            y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                        };
                        this.body.emitter.emit("_requestRedraw");
                    } // move the network


                    if (this.options.dragView === true && !event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true); // if the drag was not started properly because the click started outside the network div, start it now.

                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }

                        var diffX = pointer.x - this.drag.pointer.x;
                        var diffY = pointer.y - this.drag.pointer.y;
                        this.body.view.translation = {
                            x: this.drag.translation.x + diffX,
                            y: this.drag.translation.y + diffY
                        };
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
            /**
             * handle drag start event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDragEnd",
            value: function onDragEnd(event) {
                var _this3 = this;

                this.drag.dragging = false;

                if (this.body.selectionBox.show) {
                    var _context14;

                    this.body.selectionBox.show = false;
                    var selectionBoxPosition = this.body.selectionBox.position;
                    var selectionBoxPositionMinMax = {
                        minX: Math.min(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        minY: Math.min(selectionBoxPosition.start.y, selectionBoxPosition.end.y),
                        maxX: Math.max(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        maxY: Math.max(selectionBoxPosition.start.y, selectionBoxPosition.end.y)
                    };

                    var toBeSelectedNodes = filter(_context14 = this.body.nodeIndices).call(_context14, function (nodeId) {
                        var node = _this3.body.nodes[nodeId];
                        return node.x >= selectionBoxPositionMinMax.minX && node.x <= selectionBoxPositionMinMax.maxX && node.y >= selectionBoxPositionMinMax.minY && node.y <= selectionBoxPositionMinMax.maxY;
                    });

                    forEach$2(toBeSelectedNodes).call(toBeSelectedNodes, function (nodeId) {
                        return _this3.selectionHandler.selectObject(_this3.body.nodes[nodeId]);
                    });

                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.commitAndEmit(pointer, event);
                    this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                    this.body.emitter.emit("_requestRedraw");
                } else {
                    var selection = this.drag.selection;

                    if (selection && selection.length) {
                        forEach$2(selection).call(selection, function (s) {
                            // restore original xFixed and yFixed
                            s.node.options.fixed.x = s.xFixed;
                            s.node.options.fixed.y = s.yFixed;
                        });

                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center));
                        this.body.emitter.emit("startSimulation");
                    } else {
                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
            /**
             * Handle pinch event
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "onPinch",
            value: function onPinch(event) {
                var pointer = this.getPointer(event.center);
                this.drag.pinched = true;

                if (this.pinch["scale"] === undefined) {
                    this.pinch.scale = 1;
                } // TODO: enabled moving while pinching?


                var scale = this.pinch.scale * event.scale;
                this.zoom(scale, pointer);
            }
            /**
             * Zoom the network in or out
             *
             * @param {number} scale a number around 1, and between 0.01 and 10
             * @param {{x: number, y: number}} pointer    Position on screen
             * @private
             */

        }, {
            key: "zoom",
            value: function zoom(scale, pointer) {
                if (this.options.zoomView === true) {
                    var scaleOld = this.body.view.scale;

                    if (scale < 0.00001) {
                        scale = 0.00001;
                    }

                    if (scale > 10) {
                        scale = 10;
                    }

                    var preScaleDragPointer = undefined;

                    if (this.drag !== undefined) {
                        if (this.drag.dragging === true) {
                            preScaleDragPointer = this.canvas.DOMtoCanvas(this.drag.pointer);
                        }
                    } // + this.canvas.frame.canvas.clientHeight / 2


                    var translation = this.body.view.translation;
                    var scaleFrac = scale / scaleOld;
                    var tx = (1 - scaleFrac) * pointer.x + translation.x * scaleFrac;
                    var ty = (1 - scaleFrac) * pointer.y + translation.y * scaleFrac;
                    this.body.view.scale = scale;
                    this.body.view.translation = {
                        x: tx,
                        y: ty
                    };

                    if (preScaleDragPointer != undefined) {
                        var postScaleDragPointer = this.canvas.canvasToDOM(preScaleDragPointer);
                        this.drag.pointer.x = postScaleDragPointer.x;
                        this.drag.pointer.y = postScaleDragPointer.y;
                    }

                    this.body.emitter.emit("_requestRedraw");

                    if (scaleOld < scale) {
                        this.body.emitter.emit("zoom", {
                            direction: "+",
                            scale: this.body.view.scale,
                            pointer: pointer
                        });
                    } else {
                        this.body.emitter.emit("zoom", {
                            direction: "-",
                            scale: this.body.view.scale,
                            pointer: pointer
                        });
                    }
                }
            }
            /**
             * Event handler for mouse wheel event, used to zoom the timeline
             * See http://adomas.org/javascript-mouse-wheel/
             *     https://github.com/EightMedia/hammer.js/issues/256
             *
             * @param {MouseEvent}  event
             * @private
             */

        }, {
            key: "onMouseWheel",
            value: function onMouseWheel(event) {
                if (this.options.zoomView === true) {
                    // If delta is nonzero, handle it.
                    // Basically, delta is now positive if wheel was scrolled up,
                    // and negative, if wheel was scrolled down.
                    if (event.deltaY !== 0) {
                        // calculate the new scale
                        var scale = this.body.view.scale;
                        scale *= 1 + (event.deltaY < 0 ? 1 : -1) * (this.options.zoomSpeed * 0.1); // calculate the pointer location

                        var pointer = this.getPointer({
                            x: event.clientX,
                            y: event.clientY
                        }); // apply the new scale

                        this.zoom(scale, pointer);
                    } // Prevent default actions caused by mouse wheel.


                    event.preventDefault();
                }
            }
            /**
             * Mouse move handler for checking whether the title moves over a node with a title.
             *
             * @param  {Event} event
             * @private
             */

        }, {
            key: "onMouseMove",
            value: function onMouseMove(event) {
                var _this4 = this;

                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                var popupVisible = false; // check if the previously selected node is still selected

                if (this.popup !== undefined) {
                    if (this.popup.hidden === false) {
                        this._checkHidePopup(pointer);
                    } // if the popup was not hidden above


                    if (this.popup.hidden === false) {
                        popupVisible = true;
                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.show();
                    }
                } // if we bind the keyboard to the div, we have to highlight it to use it. This highlights it on mouse over.


                if (this.options.keyboard.bindToWindow === false && this.options.keyboard.enabled === true) {
                    this.canvas.frame.focus();
                } // start a timeout that will check if the mouse is positioned above an element


                if (popupVisible === false) {
                    if (this.popupTimer !== undefined) {
                        clearInterval(this.popupTimer); // stop any running calculationTimer

                        this.popupTimer = undefined;
                    }

                    if (!this.drag.dragging) {
                        this.popupTimer = setTimeout$1(function () {
                            return _this4._checkShowPopup(pointer);
                        }, this.options.tooltipDelay);
                    }
                } // adding hover highlights


                if (this.options.hover === true) {
                    this.selectionHandler.hoverObject(event, pointer);
                }
            }
            /**
             * Check if there is an element on the given position in the network
             * (a node or edge). If so, and if this element has a title,
             * show a popup window with its title.
             *
             * @param {{x:number, y:number}} pointer
             * @private
             */

        }, {
            key: "_checkShowPopup",
            value: function _checkShowPopup(pointer) {
                var x = this.canvas._XconvertDOMtoCanvas(pointer.x);

                var y = this.canvas._YconvertDOMtoCanvas(pointer.y);

                var pointerObj = {
                    left: x,
                    top: y,
                    right: x,
                    bottom: y
                };
                var previousPopupObjId = this.popupObj === undefined ? undefined : this.popupObj.id;
                var nodeUnderCursor = false;
                var popupType = "node"; // check if a node is under the cursor.

                if (this.popupObj === undefined) {
                    // search the nodes for overlap, select the top one in case of multiple nodes
                    var nodeIndices = this.body.nodeIndices;
                    var nodes = this.body.nodes;
                    var node;
                    var overlappingNodes = [];

                    for (var i = 0; i < nodeIndices.length; i++) {
                        node = nodes[nodeIndices[i]];

                        if (node.isOverlappingWith(pointerObj) === true) {
                            nodeUnderCursor = true;

                            if (node.getTitle() !== undefined) {
                                overlappingNodes.push(nodeIndices[i]);
                            }
                        }
                    }

                    if (overlappingNodes.length > 0) {
                        // if there are overlapping nodes, select the last one, this is the one which is drawn on top of the others
                        this.popupObj = nodes[overlappingNodes[overlappingNodes.length - 1]]; // if you hover over a node, the title of the edge is not supposed to be shown.

                        nodeUnderCursor = true;
                    }
                }

                if (this.popupObj === undefined && nodeUnderCursor === false) {
                    // search the edges for overlap
                    var edgeIndices = this.body.edgeIndices;
                    var edges = this.body.edges;
                    var edge;
                    var overlappingEdges = [];

                    for (var _i = 0; _i < edgeIndices.length; _i++) {
                        edge = edges[edgeIndices[_i]];

                        if (edge.isOverlappingWith(pointerObj) === true) {
                            if (edge.connected === true && edge.getTitle() !== undefined) {
                                overlappingEdges.push(edgeIndices[_i]);
                            }
                        }
                    }

                    if (overlappingEdges.length > 0) {
                        this.popupObj = edges[overlappingEdges[overlappingEdges.length - 1]];
                        popupType = "edge";
                    }
                }

                if (this.popupObj !== undefined) {
                    // show popup message window
                    if (this.popupObj.id !== previousPopupObjId) {
                        if (this.popup === undefined) {
                            this.popup = new Popup$1(this.canvas.frame);
                        }

                        this.popup.popupTargetType = popupType;
                        this.popup.popupTargetId = this.popupObj.id; // adjust a small offset such that the mouse cursor is located in the
                        // bottom left location of the popup, and you can easily move over the
                        // popup area

                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.setText(this.popupObj.getTitle());
                        this.popup.show();
                        this.body.emitter.emit("showPopup", this.popupObj.id);
                    }
                } else {
                    if (this.popup !== undefined) {
                        this.popup.hide();
                        this.body.emitter.emit("hidePopup");
                    }
                }
            }
            /**
             * Check if the popup must be hidden, which is the case when the mouse is no
             * longer hovering on the object
             *
             * @param {{x:number, y:number}} pointer
             * @private
             */

        }, {
            key: "_checkHidePopup",
            value: function _checkHidePopup(pointer) {
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var stillOnObj = false;

                if (this.popup.popupTargetType === "node") {
                    if (this.body.nodes[this.popup.popupTargetId] !== undefined) {
                        stillOnObj = this.body.nodes[this.popup.popupTargetId].isOverlappingWith(pointerObj); // if the mouse is still one the node, we have to check if it is not also on one that is drawn on top of it.
                        // we initially only check stillOnObj because this is much faster.

                        if (stillOnObj === true) {
                            var overNode = this.selectionHandler.getNodeAt(pointer);
                            stillOnObj = overNode === undefined ? false : overNode.id === this.popup.popupTargetId;
                        }
                    }
                } else {
                    if (this.selectionHandler.getNodeAt(pointer) === undefined) {
                        if (this.body.edges[this.popup.popupTargetId] !== undefined) {
                            stillOnObj = this.body.edges[this.popup.popupTargetId].isOverlappingWith(pointerObj);
                        }
                    }
                }

                if (stillOnObj === false) {
                    this.popupObj = undefined;
                    this.popup.hide();
                    this.body.emitter.emit("hidePopup");
                }
            }
        }]);

        return InteractionHandler;
    }();

    var getWeakData = internalMetadata.getWeakData;
    var setInternalState = internalState.set;
    var internalStateGetterFor = internalState.getterFor;
    var find = arrayIteration.find;
    var findIndex = arrayIteration.findIndex;
    var id = 0; // fallback for uncaught frozen keys

    var uncaughtFrozenStore = function (store) {
        return store.frozen || (store.frozen = new UncaughtFrozenStore());
    };

    var UncaughtFrozenStore = function () {
        this.entries = [];
    };

    var findUncaughtFrozen = function (store, key) {
        return find(store.entries, function (it) {
            return it[0] === key;
        });
    };

    UncaughtFrozenStore.prototype = {
        get: function (key) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) return entry[1];
        },
        has: function (key) {
            return !!findUncaughtFrozen(this, key);
        },
        set: function (key, value) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) entry[1] = value;else this.entries.push([key, value]);
        },
        'delete': function (key) {
            var index = findIndex(this.entries, function (it) {
                return it[0] === key;
            });
            if (~index) this.entries.splice(index, 1);
            return !!~index;
        }
    };
    var collectionWeak = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
                anInstance(that, C, CONSTRUCTOR_NAME);
                setInternalState(that, {
                    type: CONSTRUCTOR_NAME,
                    id: id++,
                    frozen: undefined
                });
                if (iterable != undefined) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
                var state = getInternalState(that);
                var data = getWeakData(anObject(key), true);
                if (data === true) uncaughtFrozenStore(state).set(key, value);else data[state.id] = value;
                return that;
            };

            redefineAll(C.prototype, {
                // 23.3.3.2 WeakMap.prototype.delete(key)
                // 23.4.3.3 WeakSet.prototype.delete(value)
                'delete': function (key) {
                    var state = getInternalState(this);
                    if (!isObject$1(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state)['delete'](key);
                    return data && has$1(data, state.id) && delete data[state.id];
                },
                // 23.3.3.4 WeakMap.prototype.has(key)
                // 23.4.3.4 WeakSet.prototype.has(value)
                has: function has(key) {
                    var state = getInternalState(this);
                    if (!isObject$1(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).has(key);
                    return data && has$1(data, state.id);
                }
            });
            redefineAll(C.prototype, IS_MAP ? {
                // 23.3.3.3 WeakMap.prototype.get(key)
                get: function get(key) {
                    var state = getInternalState(this);

                    if (isObject$1(key)) {
                        var data = getWeakData(key);
                        if (data === true) return uncaughtFrozenStore(state).get(key);
                        return data ? data[state.id] : undefined;
                    }
                },
                // 23.3.3.5 WeakMap.prototype.set(key, value)
                set: function set(key, value) {
                    return define(this, key, value);
                }
            } : {
                // 23.4.3.1 WeakSet.prototype.add(value)
                add: function add(value) {
                    return define(this, value, true);
                }
            });
            return C;
        }
    };

    createCommonjsModule(function (module) {

        var enforceIternalState = internalState.enforce;
        var IS_IE11 = !global$1.ActiveXObject && 'ActiveXObject' in global$1;
        var isExtensible = Object.isExtensible;
        var InternalWeakMap;

        var wrapper = function (init) {
            return function WeakMap() {
                return init(this, arguments.length ? arguments[0] : undefined);
            };
        }; // `WeakMap` constructor
        // https://tc39.es/ecma262/#sec-weakmap-constructor


        var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak); // IE11 WeakMap frozen keys fix
        // We can't use feature detection because it crash some old IE builds
        // https://github.com/zloirock/core-js/issues/485

        if (nativeWeakMap && IS_IE11) {
            InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
            internalMetadata.REQUIRED = true;
            var WeakMapPrototype = $WeakMap.prototype;
            var nativeDelete = WeakMapPrototype['delete'];
            var nativeHas = WeakMapPrototype.has;
            var nativeGet = WeakMapPrototype.get;
            var nativeSet = WeakMapPrototype.set;
            redefineAll(WeakMapPrototype, {
                'delete': function (key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeDelete.call(this, key) || state.frozen['delete'](key);
                    }

                    return nativeDelete.call(this, key);
                },
                has: function has(key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) || state.frozen.has(key);
                    }

                    return nativeHas.call(this, key);
                },
                get: function get(key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
                    }

                    return nativeGet.call(this, key);
                },
                set: function set(key, value) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
                    } else nativeSet.call(this, key, value);

                    return this;
                }
            });
        }
    });

    var weakMap$2 = path.WeakMap;

    var weakMap$1 = weakMap$2;

    var weakMap = weakMap$1;

    /*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }

        return privateMap.get(receiver);
    }
    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }

        privateMap.set(receiver, value);
        return value;
    }

    function _createForOfIteratorHelper$3(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$3(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = slice$1(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

    function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

    var _previousSelection, _selection, _nodes, _edges, _commitHandler;
    /**
     * @param prev
     * @param next
     */

    function diffSets(prev, next) {
        var diff = new set();

        var _iterator = _createForOfIteratorHelper$3(next),
            _step;

        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;

                if (!prev.has(item)) {
                    diff.add(item);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return diff;
    }

    var SingleTypeSelectionAccumulator = /*#__PURE__*/function () {
        function SingleTypeSelectionAccumulator() {
            _classCallCheck(this, SingleTypeSelectionAccumulator);

            _previousSelection.set(this, new set());

            _selection.set(this, new set());
        }

        _createClass(SingleTypeSelectionAccumulator, [{
            key: "size",
            get: function get() {
                return __classPrivateFieldGet(this, _selection).size;
            }
        }, {
            key: "add",
            value: function add() {
                for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
                    items[_key] = arguments[_key];
                }

                for (var _i = 0, _items = items; _i < _items.length; _i++) {
                    var item = _items[_i];

                    __classPrivateFieldGet(this, _selection).add(item);
                }
            }
        }, {
            key: "delete",
            value: function _delete() {
                for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    items[_key2] = arguments[_key2];
                }

                for (var _i2 = 0, _items2 = items; _i2 < _items2.length; _i2++) {
                    var item = _items2[_i2];

                    __classPrivateFieldGet(this, _selection).delete(item);
                }
            }
        }, {
            key: "clear",
            value: function clear() {
                __classPrivateFieldGet(this, _selection).clear();
            }
        }, {
            key: "getSelection",
            value: function getSelection() {
                return _toConsumableArray(__classPrivateFieldGet(this, _selection));
            }
        }, {
            key: "getChanges",
            value: function getChanges() {
                return {
                    added: _toConsumableArray(diffSets(__classPrivateFieldGet(this, _previousSelection), __classPrivateFieldGet(this, _selection))),
                    deleted: _toConsumableArray(diffSets(__classPrivateFieldGet(this, _selection), __classPrivateFieldGet(this, _previousSelection))),
                    previous: _toConsumableArray(new set(__classPrivateFieldGet(this, _previousSelection))),
                    current: _toConsumableArray(new set(__classPrivateFieldGet(this, _selection)))
                };
            }
        }, {
            key: "commit",
            value: function commit() {
                var changes = this.getChanges();

                __classPrivateFieldSet(this, _previousSelection, __classPrivateFieldGet(this, _selection));

                __classPrivateFieldSet(this, _selection, new set(__classPrivateFieldGet(this, _previousSelection)));

                var _iterator2 = _createForOfIteratorHelper$3(changes.added),
                    _step2;

                try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var item = _step2.value;
                        item.select();
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally {
                    _iterator2.f();
                }

                var _iterator3 = _createForOfIteratorHelper$3(changes.deleted),
                    _step3;

                try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        var _item = _step3.value;

                        _item.unselect();
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally {
                    _iterator3.f();
                }

                return changes;
            }
        }]);

        return SingleTypeSelectionAccumulator;
    }();

    _previousSelection = new weakMap(), _selection = new weakMap();
    var SelectionAccumulator = /*#__PURE__*/function () {
        function SelectionAccumulator() {
            var commitHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            _classCallCheck(this, SelectionAccumulator);

            _nodes.set(this, new SingleTypeSelectionAccumulator());

            _edges.set(this, new SingleTypeSelectionAccumulator());

            _commitHandler.set(this, void 0);

            __classPrivateFieldSet(this, _commitHandler, commitHandler);
        }

        _createClass(SelectionAccumulator, [{
            key: "sizeNodes",
            get: function get() {
                return __classPrivateFieldGet(this, _nodes).size;
            }
        }, {
            key: "sizeEdges",
            get: function get() {
                return __classPrivateFieldGet(this, _edges).size;
            }
        }, {
            key: "getNodes",
            value: function getNodes() {
                return __classPrivateFieldGet(this, _nodes).getSelection();
            }
        }, {
            key: "getEdges",
            value: function getEdges() {
                return __classPrivateFieldGet(this, _edges).getSelection();
            }
        }, {
            key: "addNodes",
            value: function addNodes() {
                var _classPrivateFieldGe;

                (_classPrivateFieldGe = __classPrivateFieldGet(this, _nodes)).add.apply(_classPrivateFieldGe, arguments);
            }
        }, {
            key: "addEdges",
            value: function addEdges() {
                var _classPrivateFieldGe2;

                (_classPrivateFieldGe2 = __classPrivateFieldGet(this, _edges)).add.apply(_classPrivateFieldGe2, arguments);
            }
        }, {
            key: "deleteNodes",
            value: function deleteNodes(node) {
                __classPrivateFieldGet(this, _nodes).delete(node);
            }
        }, {
            key: "deleteEdges",
            value: function deleteEdges(edge) {
                __classPrivateFieldGet(this, _edges).delete(edge);
            }
        }, {
            key: "clear",
            value: function clear() {
                __classPrivateFieldGet(this, _nodes).clear();

                __classPrivateFieldGet(this, _edges).clear();
            }
        }, {
            key: "commit",
            value: function commit() {
                var _classPrivateFieldGe3, _context;

                var summary = {
                    nodes: __classPrivateFieldGet(this, _nodes).commit(),
                    edges: __classPrivateFieldGet(this, _edges).commit()
                };

                for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    rest[_key3] = arguments[_key3];
                }

                (_classPrivateFieldGe3 = __classPrivateFieldGet(this, _commitHandler)).call.apply(_classPrivateFieldGe3, concat(_context = [this, summary]).call(_context, rest));

                return summary;
            }
        }]);

        return SelectionAccumulator;
    }();
    _nodes = new weakMap(), _edges = new weakMap(), _commitHandler = new weakMap();

    function _createForOfIteratorHelper$2(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$2(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = slice$1(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

    function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * The handler for selections
     */

    var SelectionHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function SelectionHandler(body, canvas) {
            var _this = this;

            _classCallCheck(this, SelectionHandler);

            this.body = body;
            this.canvas = canvas; // TODO: Consider firing an event on any change to the selection, not
            // only those caused by clicks and taps. It would be easy to implement
            // now and (at least to me) it seems like something that could be
            // quite useful.

            this._selectionAccumulator = new SelectionAccumulator();
            this.hoverObj = {
                nodes: {},
                edges: {}
            };
            this.options = {};
            this.defaultOptions = {
                multiselect: false,
                selectable: true,
                selectConnectedEdges: true,
                hoverConnectedEdges: true
            };

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("_dataChanged", function () {
                _this.updateSelection();
            });
        }
        /**
         *
         * @param {object} [options]
         */


        _createClass(SelectionHandler, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = ["multiselect", "hoverConnectedEdges", "selectable", "selectConnectedEdges"];
                    selectiveDeepExtend(fields, this.options, options);
                }
            }
            /**
             * handles the selection part of the tap;
             *
             * @param {{x: number, y: number}} pointer
             * @returns {boolean}
             */

        }, {
            key: "selectOnPoint",
            value: function selectOnPoint(pointer) {
                var selected = false;

                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer); // unselect after getting the objects in order to restore width and height.

                    this.unselectAll();

                    if (obj !== undefined) {
                        selected = this.selectObject(obj);
                    }

                    this.body.emitter.emit("_requestRedraw");
                }

                return selected;
            }
            /**
             *
             * @param {{x: number, y: number}} pointer
             * @returns {boolean}
             */

        }, {
            key: "selectAdditionalOnPoint",
            value: function selectAdditionalOnPoint(pointer) {
                var selectionChanged = false;

                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);

                    if (obj !== undefined) {
                        selectionChanged = true;

                        if (obj.isSelected() === true) {
                            this.deselectObject(obj);
                        } else {
                            this.selectObject(obj);
                        }

                        this.body.emitter.emit("_requestRedraw");
                    }
                }

                return selectionChanged;
            }
            /**
             * Create an object containing the standard fields for an event.
             *
             * @param {Event} event
             * @param {{x: number, y: number}} pointer Object with the x and y screen coordinates of the mouse
             * @returns {{}}
             * @private
             */

        }, {
            key: "_initBaseEvent",
            value: function _initBaseEvent(event, pointer) {
                var properties = {};
                properties["pointer"] = {
                    DOM: {
                        x: pointer.x,
                        y: pointer.y
                    },
                    canvas: this.canvas.DOMtoCanvas(pointer)
                };
                properties["event"] = event;
                return properties;
            }
            /**
             * Generate an event which the user can catch.
             *
             * This adds some extra data to the event with respect to cursor position and
             * selected nodes and edges.
             *
             * @param {string} eventType                          Name of event to send
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer            Object with the x and y screen coordinates of the mouse
             * @param {object | undefined} oldSelection             If present, selection state before event occured
             * @param {boolean|undefined} [emptySelection=false]  Indicate if selection data should be passed
             */

        }, {
            key: "generateClickEvent",
            value: function generateClickEvent(eventType, event, pointer, oldSelection) {
                var emptySelection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                var properties = this._initBaseEvent(event, pointer);

                if (emptySelection === true) {
                    properties.nodes = [];
                    properties.edges = [];
                } else {
                    var tmp = this.getSelection();
                    properties.nodes = tmp.nodes;
                    properties.edges = tmp.edges;
                }

                if (oldSelection !== undefined) {
                    properties["previousSelection"] = oldSelection;
                }

                if (eventType == "click") {
                    // For the time being, restrict this functionality to
                    // just the click event.
                    properties.items = this.getClickedItems(pointer);
                }

                if (event.controlEdge !== undefined) {
                    properties.controlEdge = event.controlEdge;
                }

                this.body.emitter.emit(eventType, properties);
            }
            /**
             *
             * @param {object} obj
             * @param {boolean} [highlightEdges=this.options.selectConnectedEdges]
             * @returns {boolean}
             */

        }, {
            key: "selectObject",
            value: function selectObject(obj) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.selectConnectedEdges;

                if (obj !== undefined) {
                    if (obj instanceof Node) {
                        if (highlightEdges === true) {
                            var _this$_selectionAccum;

                            (_this$_selectionAccum = this._selectionAccumulator).addEdges.apply(_this$_selectionAccum, _toConsumableArray(obj.edges));
                        }

                        this._selectionAccumulator.addNodes(obj);
                    } else {
                        this._selectionAccumulator.addEdges(obj);
                    }

                    return true;
                }

                return false;
            }
            /**
             *
             * @param {object} obj
             */

        }, {
            key: "deselectObject",
            value: function deselectObject(obj) {
                if (obj.isSelected() === true) {
                    obj.selected = false;

                    this._removeFromSelection(obj);
                }
            }
            /**
             * retrieve all nodes overlapping with given object
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @returns {number[]}   An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getAllNodesOverlappingWith",
            value: function _getAllNodesOverlappingWith(object) {
                var overlappingNodes = [];
                var nodes = this.body.nodes;

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var nodeId = this.body.nodeIndices[i];

                    if (nodes[nodeId].isOverlappingWith(object)) {
                        overlappingNodes.push(nodeId);
                    }
                }

                return overlappingNodes;
            }
            /**
             * Return a position object in canvasspace from a single point in screenspace
             *
             * @param {{x: number, y: number}} pointer
             * @returns {{left: number, top: number, right: number, bottom: number}}
             * @private
             */

        }, {
            key: "_pointerToPositionObject",
            value: function _pointerToPositionObject(pointer) {
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                return {
                    left: canvasPos.x - 1,
                    top: canvasPos.y + 1,
                    right: canvasPos.x + 1,
                    bottom: canvasPos.y - 1
                };
            }
            /**
             * Get the top node at the passed point (like a click)
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [returnNode=true]
             * @returns {Node | undefined} node
             */

        }, {
            key: "getNodeAt",
            value: function getNodeAt(pointer) {
                var returnNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                // we first check if this is an navigation controls element
                var positionObject = this._pointerToPositionObject(pointer);

                var overlappingNodes = this._getAllNodesOverlappingWith(positionObject); // if there are overlapping nodes, select the last one, this is the
                // one which is drawn on top of the others


                if (overlappingNodes.length > 0) {
                    if (returnNode === true) {
                        return this.body.nodes[overlappingNodes[overlappingNodes.length - 1]];
                    } else {
                        return overlappingNodes[overlappingNodes.length - 1];
                    }
                } else {
                    return undefined;
                }
            }
            /**
             * retrieve all edges overlapping with given object, selector is around center
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @param {number[]} overlappingEdges An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getEdgesOverlappingWith",
            value: function _getEdgesOverlappingWith(object, overlappingEdges) {
                var edges = this.body.edges;

                for (var i = 0; i < this.body.edgeIndices.length; i++) {
                    var edgeId = this.body.edgeIndices[i];

                    if (edges[edgeId].isOverlappingWith(object)) {
                        overlappingEdges.push(edgeId);
                    }
                }
            }
            /**
             * retrieve all nodes overlapping with given object
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @returns {number[]}   An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getAllEdgesOverlappingWith",
            value: function _getAllEdgesOverlappingWith(object) {
                var overlappingEdges = [];

                this._getEdgesOverlappingWith(object, overlappingEdges);

                return overlappingEdges;
            }
            /**
             * Get the edges nearest to the passed point (like a click)
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [returnEdge=true]
             * @returns {Edge | undefined} node
             */

        }, {
            key: "getEdgeAt",
            value: function getEdgeAt(pointer) {
                var returnEdge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // Iterate over edges, pick closest within 10
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                var mindist = 10;
                var overlappingEdge = null;
                var edges = this.body.edges;

                for (var i = 0; i < this.body.edgeIndices.length; i++) {
                    var edgeId = this.body.edgeIndices[i];
                    var edge = edges[edgeId];

                    if (edge.connected) {
                        var xFrom = edge.from.x;
                        var yFrom = edge.from.y;
                        var xTo = edge.to.x;
                        var yTo = edge.to.y;
                        var dist = edge.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, canvasPos.x, canvasPos.y);

                        if (dist < mindist) {
                            overlappingEdge = edgeId;
                            mindist = dist;
                        }
                    }
                }

                if (overlappingEdge !== null) {
                    if (returnEdge === true) {
                        return this.body.edges[overlappingEdge];
                    } else {
                        return overlappingEdge;
                    }
                } else {
                    return undefined;
                }
            }
            /**
             * Add object to the selection array.
             *
             * @param {object} obj
             * @private
             */

        }, {
            key: "_addToHover",
            value: function _addToHover(obj) {
                if (obj instanceof Node) {
                    this.hoverObj.nodes[obj.id] = obj;
                } else {
                    this.hoverObj.edges[obj.id] = obj;
                }
            }
            /**
             * Remove a single option from selection.
             *
             * @param {object} obj
             * @private
             */

        }, {
            key: "_removeFromSelection",
            value: function _removeFromSelection(obj) {
                if (obj instanceof Node) {
                    var _this$_selectionAccum2;

                    this._selectionAccumulator.deleteNodes(obj);

                    (_this$_selectionAccum2 = this._selectionAccumulator).deleteEdges.apply(_this$_selectionAccum2, _toConsumableArray(obj.edges));
                } else {
                    this._selectionAccumulator.deleteEdges(obj);
                }
            }
            /**
             * Unselect all nodes and edges.
             */

        }, {
            key: "unselectAll",
            value: function unselectAll() {
                this._selectionAccumulator.clear();
            }
            /**
             * return the number of selected nodes
             *
             * @returns {number}
             */

        }, {
            key: "getSelectedNodeCount",
            value: function getSelectedNodeCount() {
                return this._selectionAccumulator.sizeNodes;
            }
            /**
             * return the number of selected edges
             *
             * @returns {number}
             */

        }, {
            key: "getSelectedEdgeCount",
            value: function getSelectedEdgeCount() {
                return this._selectionAccumulator.sizeEdges;
            }
            /**
             * select the edges connected to the node that is being selected
             *
             * @param {Node} node
             * @private
             */

        }, {
            key: "_hoverConnectedEdges",
            value: function _hoverConnectedEdges(node) {
                for (var i = 0; i < node.edges.length; i++) {
                    var edge = node.edges[i];
                    edge.hover = true;

                    this._addToHover(edge);
                }
            }
            /**
             * Remove the highlight from a node or edge, in response to mouse movement
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
             * @param {Node|vis.Edge} object
             * @private
             */

        }, {
            key: "emitBlurEvent",
            value: function emitBlurEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);

                if (object.hover === true) {
                    object.hover = false;

                    if (object instanceof Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("blurNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("blurEdge", properties);
                    }
                }
            }
            /**
             * Create the highlight for a node or edge, in response to mouse movement
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
             * @param {Node|vis.Edge} object
             * @returns {boolean} hoverChanged
             * @private
             */

        }, {
            key: "emitHoverEvent",
            value: function emitHoverEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);

                var hoverChanged = false;

                if (object.hover === false) {
                    object.hover = true;

                    this._addToHover(object);

                    hoverChanged = true;

                    if (object instanceof Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("hoverNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("hoverEdge", properties);
                    }
                }

                return hoverChanged;
            }
            /**
             * Perform actions in response to a mouse movement.
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer | object with the x and y screen coordinates of the mouse
             */

        }, {
            key: "hoverObject",
            value: function hoverObject(event, pointer) {
                var object = this.getNodeAt(pointer);

                if (object === undefined) {
                    object = this.getEdgeAt(pointer);
                }

                var hoverChanged = false; // remove all node hover highlights

                for (var nodeId in this.hoverObj.nodes) {
                    if (Object.prototype.hasOwnProperty.call(this.hoverObj.nodes, nodeId)) {
                        if (object === undefined || object instanceof Node && object.id != nodeId || object instanceof Edge) {
                            this.emitBlurEvent(event, pointer, this.hoverObj.nodes[nodeId]);
                            delete this.hoverObj.nodes[nodeId];
                            hoverChanged = true;
                        }
                    }
                } // removing all edge hover highlights


                for (var edgeId in this.hoverObj.edges) {
                    if (Object.prototype.hasOwnProperty.call(this.hoverObj.edges, edgeId)) {
                        // if the hover has been changed here it means that the node has been hovered over or off
                        // we then do not use the emitBlurEvent method here.
                        if (hoverChanged === true) {
                            this.hoverObj.edges[edgeId].hover = false;
                            delete this.hoverObj.edges[edgeId];
                        } // if the blur remains the same and the object is undefined (mouse off) or another
                        // edge has been hovered, or another node has been hovered we blur the edge.
                        else if (object === undefined || object instanceof Edge && object.id != edgeId || object instanceof Node && !object.hover) {
                            this.emitBlurEvent(event, pointer, this.hoverObj.edges[edgeId]);
                            delete this.hoverObj.edges[edgeId];
                            hoverChanged = true;
                        }
                    }
                }

                if (object !== undefined) {
                    var hoveredEdgesCount = keys$3(this.hoverObj.edges).length;

                    var hoveredNodesCount = keys$3(this.hoverObj.nodes).length;

                    var newOnlyHoveredEdge = object instanceof Edge && hoveredEdgesCount === 0 && hoveredNodesCount === 0;
                    var newOnlyHoveredNode = object instanceof Node && hoveredEdgesCount === 0 && hoveredNodesCount === 0;

                    if (hoverChanged || newOnlyHoveredEdge || newOnlyHoveredNode) {
                        hoverChanged = this.emitHoverEvent(event, pointer, object);
                    }

                    if (object instanceof Node && this.options.hoverConnectedEdges === true) {
                        this._hoverConnectedEdges(object);
                    }
                }

                if (hoverChanged === true) {
                    this.body.emitter.emit("_requestRedraw");
                }
            }
            /**
             * Commit the selection changes but don't emit any events.
             */

        }, {
            key: "commitWithoutEmitting",
            value: function commitWithoutEmitting() {
                this._selectionAccumulator.commit();
            }
            /**
             * Select and deselect nodes depending current selection change.
             *
             * For changing nodes, select/deselect events are fired.
             *
             * NOTE: For a given edge, if one connecting node is deselected and with the
             * same click the other node is selected, no events for the edge will fire. It
             * was selected and it will remain selected.
             *
             * @param {{x: number, y: number}} pointer - The x and y coordinates of the
             * click, tap, dragend… that triggered this.
             * @param {UIEvent} event - The event that triggered this.
             */

        }, {
            key: "commitAndEmit",
            value: function commitAndEmit(pointer, event) {
                var selected = false;

                var selectionChanges = this._selectionAccumulator.commit();

                var previousSelection = {
                    nodes: selectionChanges.nodes.previous,
                    edges: selectionChanges.edges.previous
                };

                if (selectionChanges.edges.deleted.length > 0) {
                    this.generateClickEvent("deselectEdge", event, pointer, previousSelection);
                    selected = true;
                }

                if (selectionChanges.nodes.deleted.length > 0) {
                    this.generateClickEvent("deselectNode", event, pointer, previousSelection);
                    selected = true;
                }

                if (selectionChanges.nodes.added.length > 0) {
                    this.generateClickEvent("selectNode", event, pointer);
                    selected = true;
                }

                if (selectionChanges.edges.added.length > 0) {
                    this.generateClickEvent("selectEdge", event, pointer);
                    selected = true;
                } // fire the select event if anything has been selected or deselected


                if (selected === true) {
                    // select or unselect
                    this.generateClickEvent("select", event, pointer);
                }
            }
            /**
             * Retrieve the currently selected node and edge ids.
             *
             * @returns {{nodes: Array.<string>, edges: Array.<string>}} Arrays with the
             * ids of the selected nodes and edges.
             */

        }, {
            key: "getSelection",
            value: function getSelection() {
                return {
                    nodes: this.getSelectedNodeIds(),
                    edges: this.getSelectedEdgeIds()
                };
            }
            /**
             * Retrieve the currently selected nodes.
             *
             * @returns {Array} An array with selected nodes.
             */

        }, {
            key: "getSelectedNodes",
            value: function getSelectedNodes() {
                return this._selectionAccumulator.getNodes();
            }
            /**
             * Retrieve the currently selected edges.
             *
             * @returns {Array} An array with selected edges.
             */

        }, {
            key: "getSelectedEdges",
            value: function getSelectedEdges() {
                return this._selectionAccumulator.getEdges();
            }
            /**
             * Retrieve the currently selected node ids.
             *
             * @returns {Array} An array with the ids of the selected nodes.
             */

        }, {
            key: "getSelectedNodeIds",
            value: function getSelectedNodeIds() {
                var _context;

                return map$3(_context = this._selectionAccumulator.getNodes()).call(_context, function (node) {
                    return node.id;
                });
            }
            /**
             * Retrieve the currently selected edge ids.
             *
             * @returns {Array} An array with the ids of the selected edges.
             */

        }, {
            key: "getSelectedEdgeIds",
            value: function getSelectedEdgeIds() {
                var _context2;

                return map$3(_context2 = this._selectionAccumulator.getEdges()).call(_context2, function (edge) {
                    return edge.id;
                });
            }
            /**
             * Updates the current selection
             *
             * @param {{nodes: Array.<string>, edges: Array.<string>}} selection
             * @param {object} options                                 Options
             */

        }, {
            key: "setSelection",
            value: function setSelection(selection) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (!selection || !selection.nodes && !selection.edges) {
                    throw new TypeError("Selection must be an object with nodes and/or edges properties");
                } // first unselect any selected node, if option is true or undefined


                if (options.unselectAll || options.unselectAll === undefined) {
                    this.unselectAll();
                }

                if (selection.nodes) {
                    var _iterator = _createForOfIteratorHelper$2(selection.nodes),
                        _step;

                    try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var id = _step.value;
                            var node = this.body.nodes[id];

                            if (!node) {
                                throw new RangeError('Node with id "' + id + '" not found');
                            } // don't select edges with it


                            this.selectObject(node, options.highlightEdges);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                }

                if (selection.edges) {
                    var _iterator2 = _createForOfIteratorHelper$2(selection.edges),
                        _step2;

                    try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            var _id = _step2.value;
                            var edge = this.body.edges[_id];

                            if (!edge) {
                                throw new RangeError('Edge with id "' + _id + '" not found');
                            }

                            this.selectObject(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally {
                        _iterator2.f();
                    }
                }

                this.body.emitter.emit("_requestRedraw");

                this._selectionAccumulator.commit();
            }
            /**
             * select zero or more nodes with the option to highlight edges
             *
             * @param {number[] | string[]} selection     An array with the ids of the
             *                                            selected nodes.
             * @param {boolean} [highlightEdges]
             */

        }, {
            key: "selectNodes",
            value: function selectNodes(selection) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    nodes: selection
                }, {
                    highlightEdges: highlightEdges
                });
            }
            /**
             * select zero or more edges
             *
             * @param {number[] | string[]} selection     An array with the ids of the
             *                                            selected nodes.
             */

        }, {
            key: "selectEdges",
            value: function selectEdges(selection) {
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    edges: selection
                });
            }
            /**
             * Validate the selection: remove ids of nodes which no longer exist
             *
             * @private
             */

        }, {
            key: "updateSelection",
            value: function updateSelection() {
                for (var node in this._selectionAccumulator.getNodes()) {
                    if (!Object.prototype.hasOwnProperty.call(this.body.nodes, node.id)) {
                        this._selectionAccumulator.deleteNodes(node);
                    }
                }

                for (var edge in this._selectionAccumulator.getEdges()) {
                    if (!Object.prototype.hasOwnProperty.call(this.body.edges, edge.id)) {
                        this._selectionAccumulator.deleteEdges(edge);
                    }
                }
            }
            /**
             * Determine all the visual elements clicked which are on the given point.
             *
             * All elements are returned; this includes nodes, edges and their labels.
             * The order returned is from highest to lowest, i.e. element 0 of the return
             * value is the topmost item clicked on.
             *
             * The return value consists of an array of the following possible elements:
             *
             * - `{nodeId:number}`             - node with given id clicked on
             * - `{nodeId:number, labelId:0}`  - label of node with given id clicked on
             * - `{edgeId:number}`             - edge with given id clicked on
             * - `{edge:number, labelId:0}`    - label of edge with given id clicked on
             *
             * ## NOTES
             *
             * - Currently, there is only one label associated with a node or an edge,
             *   but this is expected to change somewhere in the future.
             * - Since there is no z-indexing yet, it is not really possible to set the nodes and
             *   edges in the correct order. For the time being, nodes come first.
             *
             * @param {point} pointer  mouse position in screen coordinates
             * @returns {Array.<nodeClickItem|nodeLabelClickItem|edgeClickItem|edgeLabelClickItem>}
             * @private
             */

        }, {
            key: "getClickedItems",
            value: function getClickedItems(pointer) {
                var point = this.canvas.DOMtoCanvas(pointer);
                var items = []; // Note reverse order; we want the topmost clicked items to be first in the array
                // Also note that selected nodes are disregarded here; these normally display on top

                var nodeIndices = this.body.nodeIndices;
                var nodes = this.body.nodes;

                for (var i = nodeIndices.length - 1; i >= 0; i--) {
                    var node = nodes[nodeIndices[i]];
                    var ret = node.getItemsOnPoint(point);
                    items.push.apply(items, ret); // Append the return value to the running list.
                }

                var edgeIndices = this.body.edgeIndices;
                var edges = this.body.edges;

                for (var _i = edgeIndices.length - 1; _i >= 0; _i--) {
                    var edge = edges[edgeIndices[_i]];

                    var _ret = edge.getItemsOnPoint(point);

                    items.push.apply(items, _ret); // Append the return value to the running list.
                }

                return items;
            }
        }]);

        return SelectionHandler;
    }();

    /****
     * The MIT License
     *
     * Copyright (c) 2015 Marco Ziccardi
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     *
     ****/
    var timsort$1 = createCommonjsModule(function (module, exports) {
        (function (global, factory) {
            {
                factory(exports);
            }
        })(commonjsGlobal, function (exports) {

            exports.__esModule = true;
            exports.sort = sort;

            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError('Cannot call a class as a function');
                }
            }

            var DEFAULT_MIN_MERGE = 32;
            var DEFAULT_MIN_GALLOPING = 7;
            var DEFAULT_TMP_STORAGE_LENGTH = 256;
            var POWERS_OF_TEN = [1e0, 1e1, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9];

            function log10(x) {
                if (x < 1e5) {
                    if (x < 1e2) {
                        return x < 1e1 ? 0 : 1;
                    }

                    if (x < 1e4) {
                        return x < 1e3 ? 2 : 3;
                    }

                    return 4;
                }

                if (x < 1e7) {
                    return x < 1e6 ? 5 : 6;
                }

                if (x < 1e9) {
                    return x < 1e8 ? 7 : 8;
                }

                return 9;
            }

            function alphabeticalCompare(a, b) {
                if (a === b) {
                    return 0;
                }

                if (~~a === a && ~~b === b) {
                    if (a === 0 || b === 0) {
                        return a < b ? -1 : 1;
                    }

                    if (a < 0 || b < 0) {
                        if (b >= 0) {
                            return -1;
                        }

                        if (a >= 0) {
                            return 1;
                        }

                        a = -a;
                        b = -b;
                    }

                    var al = log10(a);
                    var bl = log10(b);
                    var t = 0;

                    if (al < bl) {
                        a *= POWERS_OF_TEN[bl - al - 1];
                        b /= 10;
                        t = -1;
                    } else if (al > bl) {
                        b *= POWERS_OF_TEN[al - bl - 1];
                        a /= 10;
                        t = 1;
                    }

                    if (a === b) {
                        return t;
                    }

                    return a < b ? -1 : 1;
                }

                var aStr = String(a);
                var bStr = String(b);

                if (aStr === bStr) {
                    return 0;
                }

                return aStr < bStr ? -1 : 1;
            }

            function minRunLength(n) {
                var r = 0;

                while (n >= DEFAULT_MIN_MERGE) {
                    r |= n & 1;
                    n >>= 1;
                }

                return n + r;
            }

            function makeAscendingRun(array, lo, hi, compare) {
                var runHi = lo + 1;

                if (runHi === hi) {
                    return 1;
                }

                if (compare(array[runHi++], array[lo]) < 0) {
                    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
                        runHi++;
                    }

                    reverseRun(array, lo, runHi);
                } else {
                    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
                        runHi++;
                    }
                }

                return runHi - lo;
            }

            function reverseRun(array, lo, hi) {
                hi--;

                while (lo < hi) {
                    var t = array[lo];
                    array[lo++] = array[hi];
                    array[hi--] = t;
                }
            }

            function binaryInsertionSort(array, lo, hi, start, compare) {
                if (start === lo) {
                    start++;
                }

                for (; start < hi; start++) {
                    var pivot = array[start];
                    var left = lo;
                    var right = start;

                    while (left < right) {
                        var mid = left + right >>> 1;

                        if (compare(pivot, array[mid]) < 0) {
                            right = mid;
                        } else {
                            left = mid + 1;
                        }
                    }

                    var n = start - left;

                    switch (n) {
                        case 3:
                            array[left + 3] = array[left + 2];

                        case 2:
                            array[left + 2] = array[left + 1];

                        case 1:
                            array[left + 1] = array[left];
                            break;

                        default:
                            while (n > 0) {
                                array[left + n] = array[left + n - 1];
                                n--;
                            }

                    }

                    array[left] = pivot;
                }
            }

            function gallopLeft(value, array, start, length, hint, compare) {
                var lastOffset = 0;
                var maxOffset = 0;
                var offset = 1;

                if (compare(value, array[start + hint]) > 0) {
                    maxOffset = length - hint;

                    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    lastOffset += hint;
                    offset += hint;
                } else {
                    maxOffset = hint + 1;

                    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    var tmp = lastOffset;
                    lastOffset = hint - offset;
                    offset = hint - tmp;
                }

                lastOffset++;

                while (lastOffset < offset) {
                    var m = lastOffset + (offset - lastOffset >>> 1);

                    if (compare(value, array[start + m]) > 0) {
                        lastOffset = m + 1;
                    } else {
                        offset = m;
                    }
                }

                return offset;
            }

            function gallopRight(value, array, start, length, hint, compare) {
                var lastOffset = 0;
                var maxOffset = 0;
                var offset = 1;

                if (compare(value, array[start + hint]) < 0) {
                    maxOffset = hint + 1;

                    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    var tmp = lastOffset;
                    lastOffset = hint - offset;
                    offset = hint - tmp;
                } else {
                    maxOffset = length - hint;

                    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    lastOffset += hint;
                    offset += hint;
                }

                lastOffset++;

                while (lastOffset < offset) {
                    var m = lastOffset + (offset - lastOffset >>> 1);

                    if (compare(value, array[start + m]) < 0) {
                        offset = m;
                    } else {
                        lastOffset = m + 1;
                    }
                }

                return offset;
            }

            var TimSort = function () {
                function TimSort(array, compare) {
                    _classCallCheck(this, TimSort);

                    this.array = null;
                    this.compare = null;
                    this.minGallop = DEFAULT_MIN_GALLOPING;
                    this.length = 0;
                    this.tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
                    this.stackLength = 0;
                    this.runStart = null;
                    this.runLength = null;
                    this.stackSize = 0;
                    this.array = array;
                    this.compare = compare;
                    this.length = array.length;

                    if (this.length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
                        this.tmpStorageLength = this.length >>> 1;
                    }

                    this.tmp = new Array(this.tmpStorageLength);
                    this.stackLength = this.length < 120 ? 5 : this.length < 1542 ? 10 : this.length < 119151 ? 19 : 40;
                    this.runStart = new Array(this.stackLength);
                    this.runLength = new Array(this.stackLength);
                }

                TimSort.prototype.pushRun = function pushRun(runStart, runLength) {
                    this.runStart[this.stackSize] = runStart;
                    this.runLength[this.stackSize] = runLength;
                    this.stackSize += 1;
                };

                TimSort.prototype.mergeRuns = function mergeRuns() {
                    while (this.stackSize > 1) {
                        var n = this.stackSize - 2;

                        if (n >= 1 && this.runLength[n - 1] <= this.runLength[n] + this.runLength[n + 1] || n >= 2 && this.runLength[n - 2] <= this.runLength[n] + this.runLength[n - 1]) {
                            if (this.runLength[n - 1] < this.runLength[n + 1]) {
                                n--;
                            }
                        } else if (this.runLength[n] > this.runLength[n + 1]) {
                            break;
                        }

                        this.mergeAt(n);
                    }
                };

                TimSort.prototype.forceMergeRuns = function forceMergeRuns() {
                    while (this.stackSize > 1) {
                        var n = this.stackSize - 2;

                        if (n > 0 && this.runLength[n - 1] < this.runLength[n + 1]) {
                            n--;
                        }

                        this.mergeAt(n);
                    }
                };

                TimSort.prototype.mergeAt = function mergeAt(i) {
                    var compare = this.compare;
                    var array = this.array;
                    var start1 = this.runStart[i];
                    var length1 = this.runLength[i];
                    var start2 = this.runStart[i + 1];
                    var length2 = this.runLength[i + 1];
                    this.runLength[i] = length1 + length2;

                    if (i === this.stackSize - 3) {
                        this.runStart[i + 1] = this.runStart[i + 2];
                        this.runLength[i + 1] = this.runLength[i + 2];
                    }

                    this.stackSize--;
                    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
                    start1 += k;
                    length1 -= k;

                    if (length1 === 0) {
                        return;
                    }

                    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

                    if (length2 === 0) {
                        return;
                    }

                    if (length1 <= length2) {
                        this.mergeLow(start1, length1, start2, length2);
                    } else {
                        this.mergeHigh(start1, length1, start2, length2);
                    }
                };

                TimSort.prototype.mergeLow = function mergeLow(start1, length1, start2, length2) {
                    var compare = this.compare;
                    var array = this.array;
                    var tmp = this.tmp;
                    var i = 0;

                    for (i = 0; i < length1; i++) {
                        tmp[i] = array[start1 + i];
                    }

                    var cursor1 = 0;
                    var cursor2 = start2;
                    var dest = start1;
                    array[dest++] = array[cursor2++];

                    if (--length2 === 0) {
                        for (i = 0; i < length1; i++) {
                            array[dest + i] = tmp[cursor1 + i];
                        }

                        return;
                    }

                    if (length1 === 1) {
                        for (i = 0; i < length2; i++) {
                            array[dest + i] = array[cursor2 + i];
                        }

                        array[dest + length2] = tmp[cursor1];
                        return;
                    }

                    var minGallop = this.minGallop;

                    while (true) {
                        var count1 = 0;
                        var count2 = 0;
                        var exit = false;

                        do {
                            if (compare(array[cursor2], tmp[cursor1]) < 0) {
                                array[dest++] = array[cursor2++];
                                count2++;
                                count1 = 0;

                                if (--length2 === 0) {
                                    exit = true;
                                    break;
                                }
                            } else {
                                array[dest++] = tmp[cursor1++];
                                count1++;
                                count2 = 0;

                                if (--length1 === 1) {
                                    exit = true;
                                    break;
                                }
                            }
                        } while ((count1 | count2) < minGallop);

                        if (exit) {
                            break;
                        }

                        do {
                            count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

                            if (count1 !== 0) {
                                for (i = 0; i < count1; i++) {
                                    array[dest + i] = tmp[cursor1 + i];
                                }

                                dest += count1;
                                cursor1 += count1;
                                length1 -= count1;

                                if (length1 <= 1) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest++] = array[cursor2++];

                            if (--length2 === 0) {
                                exit = true;
                                break;
                            }

                            count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

                            if (count2 !== 0) {
                                for (i = 0; i < count2; i++) {
                                    array[dest + i] = array[cursor2 + i];
                                }

                                dest += count2;
                                cursor2 += count2;
                                length2 -= count2;

                                if (length2 === 0) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest++] = tmp[cursor1++];

                            if (--length1 === 1) {
                                exit = true;
                                break;
                            }

                            minGallop--;
                        } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

                        if (exit) {
                            break;
                        }

                        if (minGallop < 0) {
                            minGallop = 0;
                        }

                        minGallop += 2;
                    }

                    this.minGallop = minGallop;

                    if (minGallop < 1) {
                        this.minGallop = 1;
                    }

                    if (length1 === 1) {
                        for (i = 0; i < length2; i++) {
                            array[dest + i] = array[cursor2 + i];
                        }

                        array[dest + length2] = tmp[cursor1];
                    } else if (length1 === 0) {
                        throw new Error('mergeLow preconditions were not respected');
                    } else {
                        for (i = 0; i < length1; i++) {
                            array[dest + i] = tmp[cursor1 + i];
                        }
                    }
                };

                TimSort.prototype.mergeHigh = function mergeHigh(start1, length1, start2, length2) {
                    var compare = this.compare;
                    var array = this.array;
                    var tmp = this.tmp;
                    var i = 0;

                    for (i = 0; i < length2; i++) {
                        tmp[i] = array[start2 + i];
                    }

                    var cursor1 = start1 + length1 - 1;
                    var cursor2 = length2 - 1;
                    var dest = start2 + length2 - 1;
                    var customCursor = 0;
                    var customDest = 0;
                    array[dest--] = array[cursor1--];

                    if (--length1 === 0) {
                        customCursor = dest - (length2 - 1);

                        for (i = 0; i < length2; i++) {
                            array[customCursor + i] = tmp[i];
                        }

                        return;
                    }

                    if (length2 === 1) {
                        dest -= length1;
                        cursor1 -= length1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;

                        for (i = length1 - 1; i >= 0; i--) {
                            array[customDest + i] = array[customCursor + i];
                        }

                        array[dest] = tmp[cursor2];
                        return;
                    }

                    var minGallop = this.minGallop;

                    while (true) {
                        var count1 = 0;
                        var count2 = 0;
                        var exit = false;

                        do {
                            if (compare(tmp[cursor2], array[cursor1]) < 0) {
                                array[dest--] = array[cursor1--];
                                count1++;
                                count2 = 0;

                                if (--length1 === 0) {
                                    exit = true;
                                    break;
                                }
                            } else {
                                array[dest--] = tmp[cursor2--];
                                count2++;
                                count1 = 0;

                                if (--length2 === 1) {
                                    exit = true;
                                    break;
                                }
                            }
                        } while ((count1 | count2) < minGallop);

                        if (exit) {
                            break;
                        }

                        do {
                            count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

                            if (count1 !== 0) {
                                dest -= count1;
                                cursor1 -= count1;
                                length1 -= count1;
                                customDest = dest + 1;
                                customCursor = cursor1 + 1;

                                for (i = count1 - 1; i >= 0; i--) {
                                    array[customDest + i] = array[customCursor + i];
                                }

                                if (length1 === 0) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest--] = tmp[cursor2--];

                            if (--length2 === 1) {
                                exit = true;
                                break;
                            }

                            count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

                            if (count2 !== 0) {
                                dest -= count2;
                                cursor2 -= count2;
                                length2 -= count2;
                                customDest = dest + 1;
                                customCursor = cursor2 + 1;

                                for (i = 0; i < count2; i++) {
                                    array[customDest + i] = tmp[customCursor + i];
                                }

                                if (length2 <= 1) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest--] = array[cursor1--];

                            if (--length1 === 0) {
                                exit = true;
                                break;
                            }

                            minGallop--;
                        } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

                        if (exit) {
                            break;
                        }

                        if (minGallop < 0) {
                            minGallop = 0;
                        }

                        minGallop += 2;
                    }

                    this.minGallop = minGallop;

                    if (minGallop < 1) {
                        this.minGallop = 1;
                    }

                    if (length2 === 1) {
                        dest -= length1;
                        cursor1 -= length1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;

                        for (i = length1 - 1; i >= 0; i--) {
                            array[customDest + i] = array[customCursor + i];
                        }

                        array[dest] = tmp[cursor2];
                    } else if (length2 === 0) {
                        throw new Error('mergeHigh preconditions were not respected');
                    } else {
                        customCursor = dest - (length2 - 1);

                        for (i = 0; i < length2; i++) {
                            array[customCursor + i] = tmp[i];
                        }
                    }
                };

                return TimSort;
            }();

            function sort(array, compare, lo, hi) {
                if (!Array.isArray(array)) {
                    throw new TypeError('Can only sort arrays');
                }

                if (!compare) {
                    compare = alphabeticalCompare;
                } else if (typeof compare !== 'function') {
                    hi = lo;
                    lo = compare;
                    compare = alphabeticalCompare;
                }

                if (!lo) {
                    lo = 0;
                }

                if (!hi) {
                    hi = array.length;
                }

                var remaining = hi - lo;

                if (remaining < 2) {
                    return;
                }

                var runLength = 0;

                if (remaining < DEFAULT_MIN_MERGE) {
                    runLength = makeAscendingRun(array, lo, hi, compare);
                    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
                    return;
                }

                var ts = new TimSort(array, compare);
                var minRun = minRunLength(remaining);

                do {
                    runLength = makeAscendingRun(array, lo, hi, compare);

                    if (runLength < minRun) {
                        var force = remaining;

                        if (force > minRun) {
                            force = minRun;
                        }

                        binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
                        runLength = force;
                    }

                    ts.pushRun(lo, runLength);
                    ts.mergeRuns();
                    remaining -= runLength;
                    lo += runLength;
                } while (remaining !== 0);

                ts.forceMergeRuns();
            }
        });
    });

    var timsort = timsort$1;

    function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Interface definition for direction strategy classes.
     *
     * This class describes the interface for the Strategy
     * pattern classes used to differentiate horizontal and vertical
     * direction of hierarchical results.
     *
     * For a given direction, one coordinate will be 'fixed', meaning that it is
     * determined by level.
     * The other coordinate is 'unfixed', meaning that the nodes on a given level
     * can still move along that coordinate. So:
     *
     * - `vertical` layout: `x` unfixed, `y` fixed per level
     * - `horizontal` layout: `x` fixed per level, `y` unfixed
     *
     * The local methods are stubs and should be regarded as abstract.
     * Derived classes **must** implement all the methods themselves.
     *
     * @private
     */

    var DirectionInterface = /*#__PURE__*/function () {
        function DirectionInterface() {
            _classCallCheck(this, DirectionInterface);
        }

        _createClass(DirectionInterface, [{
            key: "abstract",
            value:
                /**
                 * @ignore
                 */
                function abstract() {
                    throw new Error("Can't instantiate abstract class!");
                }
            /**
             * This is a dummy call which is used to suppress the jsdoc errors of type:
             *
             *   "'param' is assigned a value but never used"
             *
             * @ignore
             **/

        }, {
            key: "fake_use",
            value: function fake_use() {// Do nothing special
            }
            /**
             * Type to use to translate dynamic curves to, in the case of hierarchical layout.
             * Dynamic curves do not work for these.
             *
             * The value should be perpendicular to the actual direction of the layout.
             *
             * @returns {string} Direction, either 'vertical' or 'horizontal'
             */

        }, {
            key: "curveType",
            value: function curveType() {
                return this.abstract();
            }
            /**
             * Return the value of the coordinate that is not fixed for this direction.
             *
             * @param {Node} node The node to read
             * @returns {number} Value of the unfixed coordinate
             */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                this.fake_use(node);
                return this.abstract();
            }
            /**
             * Set the value of the coordinate that is not fixed for this direction.
             *
             * @param {Node} node The node to adjust
             * @param {number} position
             * @param {number} [level] if specified, the hierarchy level that this node should be fixed to
             */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                this.fake_use(node, position, level);
                this.abstract();
            }
            /**
             * Get the width of a tree.
             *
             * A `tree` here is a subset of nodes within the network which are not connected to other nodes,
             * only among themselves. In essence, it is a sub-network.
             *
             * @param {number} index The index number of a tree
             * @returns {number} the width of a tree in the view coordinates
             */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                this.fake_use(index);
                return this.abstract();
            }
            /**
             * Sort array of nodes on the unfixed coordinates.
             *
             * **Note:** chrome has non-stable sorting implementation, which
             * has a tendency to change the order of the array items,
             * even if the custom sort function returns 0.
             *
             * For this reason, an external sort implementation is used,
             * which has the added benefit of being faster than the standard
             * platforms implementation. This has been verified on `node.js`,
             * `firefox` and `chrome` (all linux).
             *
             * @param {Array.<Node>} nodeArray array of nodes to sort
             */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                this.fake_use(nodeArray);
                this.abstract();
            }
            /**
             * Assign the fixed coordinate of the node to the given level
             *
             * @param {Node} node The node to adjust
             * @param {number} level The level to fix to
             */

        }, {
            key: "fix",
            value: function fix(node, level) {
                this.fake_use(node, level);
                this.abstract();
            }
            /**
             * Add an offset to the unfixed coordinate of the given node.
             *
             * @param {NodeId} nodeId Id of the node to adjust
             * @param {number} diff Offset to add to the unfixed coordinate
             */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.fake_use(nodeId, diff);
                this.abstract();
            }
        }]);

        return DirectionInterface;
    }();
    /**
     * Vertical Strategy
     *
     * Coordinate `y` is fixed on levels, coordinate `x` is unfixed.
     *
     * @augments DirectionInterface
     * @private
     */


    var VerticalStrategy = /*#__PURE__*/function (_DirectionInterface) {
        _inherits(VerticalStrategy, _DirectionInterface);

        var _super = _createSuper(VerticalStrategy);

        /**
         * Constructor
         *
         * @param {object} layout reference to the parent LayoutEngine instance.
         */
        function VerticalStrategy(layout) {
            var _this;

            _classCallCheck(this, VerticalStrategy);

            _this = _super.call(this);
            _this.layout = layout;
            return _this;
        }
        /** @inheritDoc */


        _createClass(VerticalStrategy, [{
            key: "curveType",
            value: function curveType() {
                return "horizontal";
            }
            /** @inheritDoc */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                return node.x;
            }
            /** @inheritDoc */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

                if (level !== undefined) {
                    this.layout.hierarchical.addToOrdering(node, level);
                }

                node.x = position;
            }
            /** @inheritDoc */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_x,
                    max: res.max_x
                };
            }
            /** @inheritDoc */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                timsort.sort(nodeArray, function (a, b) {
                    return a.x - b.x;
                });
            }
            /** @inheritDoc */

        }, {
            key: "fix",
            value: function fix(node, level) {
                node.y = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.y = true;
            }
            /** @inheritDoc */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].x += diff;
            }
        }]);

        return VerticalStrategy;
    }(DirectionInterface);
    /**
     * Horizontal Strategy
     *
     * Coordinate `x` is fixed on levels, coordinate `y` is unfixed.
     *
     * @augments DirectionInterface
     * @private
     */


    var HorizontalStrategy = /*#__PURE__*/function (_DirectionInterface2) {
        _inherits(HorizontalStrategy, _DirectionInterface2);

        var _super2 = _createSuper(HorizontalStrategy);

        /**
         * Constructor
         *
         * @param {object} layout reference to the parent LayoutEngine instance.
         */
        function HorizontalStrategy(layout) {
            var _this2;

            _classCallCheck(this, HorizontalStrategy);

            _this2 = _super2.call(this);
            _this2.layout = layout;
            return _this2;
        }
        /** @inheritDoc */


        _createClass(HorizontalStrategy, [{
            key: "curveType",
            value: function curveType() {
                return "vertical";
            }
            /** @inheritDoc */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                return node.y;
            }
            /** @inheritDoc */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

                if (level !== undefined) {
                    this.layout.hierarchical.addToOrdering(node, level);
                }

                node.y = position;
            }
            /** @inheritDoc */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_y,
                    max: res.max_y
                };
            }
            /** @inheritDoc */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                timsort.sort(nodeArray, function (a, b) {
                    return a.y - b.y;
                });
            }
            /** @inheritDoc */

        }, {
            key: "fix",
            value: function fix(node, level) {
                node.x = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.x = true;
            }
            /** @inheritDoc */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].y += diff;
            }
        }]);

        return HorizontalStrategy;
    }(DirectionInterface);

    var $every = arrayIteration.every;
    var STRICT_METHOD = arrayMethodIsStrict('every'); // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD
    }, {
        every: function every(callbackfn
                              /* , thisArg */
        ) {
            return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var every$2 = entryVirtual('Array').every;

    var ArrayPrototype = Array.prototype;

    var every_1 = function (it) {
        var own = it.every;
        return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.every ? every$2 : own;
    };

    var every$1 = every_1;

    var every = every$1;

    function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$1(o, minLen) { var _context9; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = slice$1(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

    function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

    /**
     * Try to assign levels to nodes according to their positions in the cyclic “hierarchy”.
     *
     * @param nodes - Visible nodes of the graph.
     * @param levels - If present levels will be added to it, if not a new object will be created.
     *
     * @returns Populated node levels.
     */
    function fillLevelsByDirectionCyclic(nodes, levels) {
        var edges = new set();

        forEach$2(nodes).call(nodes, function (node) {
            var _context;

            forEach$2(_context = node.edges).call(_context, function (edge) {
                if (edge.connected) {
                    edges.add(edge);
                }
            });
        });

        forEach$2(edges).call(edges, function (edge) {
            var fromId = edge.from.id;
            var toId = edge.to.id;

            if (levels[fromId] == null) {
                levels[fromId] = 0;
            }

            if (levels[toId] == null || levels[fromId] >= levels[toId]) {
                levels[toId] = levels[fromId] + 1;
            }
        });

        return levels;
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy. Leaves will be lined up at the bottom and all other nodes as close to their children as possible.
     *
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */


    function fillLevelsByDirectionLeaves(nodes) {
        return fillLevelsByDirection( // Pick only leaves (nodes without children).
            function (node) {
                var _context2, _context3;

                return every(_context2 = filter(_context3 = node.edges // Take only visible nodes into account.
                    ).call(_context3, function (edge) {
                        return nodes.has(edge.toId);
                    }) // Check that all edges lead to this node (leaf).
                ).call(_context2, function (edge) {
                    return edge.to === node;
                });
            }, // Use the lowest level.
            function (newLevel, oldLevel) {
                return oldLevel > newLevel;
            }, // Go against the direction of the edges.
            "from", nodes);
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy. Roots will be lined up at the top and all nodes as close to their parents as possible.
     *
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */

    function fillLevelsByDirectionRoots(nodes) {
        return fillLevelsByDirection( // Pick only roots (nodes without parents).
            function (node) {
                var _context4, _context5;

                return every(_context4 = filter(_context5 = node.edges // Take only visible nodes into account.
                    ).call(_context5, function (edge) {
                        return nodes.has(edge.toId);
                    }) // Check that all edges lead from this node (root).
                ).call(_context4, function (edge) {
                    return edge.from === node;
                });
            }, // Use the highest level.
            function (newLevel, oldLevel) {
                return oldLevel < newLevel;
            }, // Go in the direction of the edges.
            "to", nodes);
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy.
     *
     * @param isEntryNode - Checks and return true if the graph should be traversed from this node.
     * @param shouldLevelBeReplaced - Checks and returns true if the level of given node should be updated to the new value.
     * @param direction - Wheter the graph should be traversed in the direction of the edges `"to"` or in the other way `"from"`.
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */

    function fillLevelsByDirection(isEntryNode, shouldLevelBeReplaced, direction, nodes) {
        var _context6;

        var levels = create$2(null); // If acyclic, the graph can be walked through with (most likely way) fewer
        // steps than the number bellow. The exact value isn't too important as long
        // as it's quick to compute (doesn't impact acyclic graphs too much), is
        // higher than the number of steps actually needed (doesn't cut off before
        // acyclic graph is walked through) and prevents infinite loops (cuts off for
        // cyclic graphs).


        var limit = reduce(_context6 = _toConsumableArray(values(nodes).call(nodes))).call(_context6, function (acc, node) {
            return acc + 1 + node.edges.length;
        }, 0);

        var edgeIdProp = direction + "Id";
        var newLevelDiff = direction === "to" ? 1 : -1;

        var _iterator = _createForOfIteratorHelper$1(nodes),
            _step;

        try {
            var _loop = function _loop() {
                var _step$value = _slicedToArray(_step.value, 2),
                    entryNodeId = _step$value[0],
                    entryNode = _step$value[1];

                if ( // Skip if the node is not visible.
                    !nodes.has(entryNodeId) || // Skip if the node is not an entry node.
                    !isEntryNode(entryNode)) {
                    return "continue";
                } // Line up all the entry nodes on level 0.


                levels[entryNodeId] = 0;
                var stack = [entryNode];
                var done = 0;
                var node = void 0;

                var _loop2 = function _loop2() {
                    var _context7, _context8;

                    if (!nodes.has(entryNodeId)) {
                        // Skip if the node is not visible.
                        return "continue";
                    }

                    var newLevel = levels[node.id] + newLevelDiff;

                    forEach$2(_context7 = filter(_context8 = node.edges).call(_context8, function (edge) {
                        return (// Ignore disconnected edges.
                            edge.connected && // Ignore circular edges.
                            edge.to !== edge.from && // Ignore edges leading to the node that's currently being processed.
                            edge[direction] !== node && // Ignore edges connecting to an invisible node.
                            nodes.has(edge.toId) && // Ignore edges connecting from an invisible node.
                            nodes.has(edge.fromId)
                        );
                    })).call(_context7, function (edge) {
                        var targetNodeId = edge[edgeIdProp];
                        var oldLevel = levels[targetNodeId];

                        if (oldLevel == null || shouldLevelBeReplaced(newLevel, oldLevel)) {
                            levels[targetNodeId] = newLevel;
                            stack.push(edge[direction]);
                        }
                    });

                    if (done > limit) {
                        // This would run forever on a cyclic graph.
                        return {
                            v: {
                                v: fillLevelsByDirectionCyclic(nodes, levels)
                            }
                        };
                    } else {
                        ++done;
                    }
                };

                while (node = stack.pop()) {
                    var _ret2 = _loop2();

                    if (_ret2 === "continue") continue;
                    if (_typeof(_ret2) === "object") return _ret2.v;
                }
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _ret = _loop();

                if (_ret === "continue") continue;
                if (_typeof(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return levels;
    }

    /**
     * There's a mix-up with terms in the code. Following are the formal definitions:
     *
     *   tree   - a strict hierarchical network, i.e. every node has at most one parent
     *   forest - a collection of trees. These distinct trees are thus not connected.
     *
     * So:
     * - in a network that is not a tree, there exist nodes with multiple parents.
     * - a network consisting of unconnected sub-networks, of which at least one
     *   is not a tree, is not a forest.
     *
     * In the code, the definitions are:
     *
     *   tree   - any disconnected sub-network, strict hierarchical or not.
     *   forest - a bunch of these sub-networks
     *
     * The difference between tree and not-tree is important in the code, notably within
     * to the block-shifting algorithm. The algorithm assumes formal trees and fails
     * for not-trees, often in a spectacular manner (search for 'exploding network' in the issues).
     *
     * In order to distinguish the definitions in the following code, the adjective 'formal' is
     * used. If 'formal' is absent, you must assume the non-formal definition.
     *
     * ----------------------------------------------------------------------------------
     * NOTES
     * =====
     *
     * A hierarchical layout is a different thing from a hierarchical network.
     * The layout is a way to arrange the nodes in the view; this can be done
     * on non-hierarchical networks as well. The converse is also possible.
     */
    /**
     * Container for derived data on current network, relating to hierarchy.
     *
     * @private
     */

    var HierarchicalStatus = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function HierarchicalStatus() {
            _classCallCheck(this, HierarchicalStatus);

            this.childrenReference = {}; // child id's per node id

            this.parentReference = {}; // parent id's per node id

            this.trees = {}; // tree id per node id; i.e. to which tree does given node id belong

            this.distributionOrdering = {}; // The nodes per level, in the display order

            this.levels = {}; // hierarchy level per node id

            this.distributionIndex = {}; // The position of the node in the level sorting order, per node id.

            this.isTree = false; // True if current network is a formal tree

            this.treeIndex = -1; // Highest tree id in current network.
        }
        /**
         * Add the relation between given nodes to the current state.
         *
         * @param {Node.id} parentNodeId
         * @param {Node.id} childNodeId
         */


        _createClass(HierarchicalStatus, [{
            key: "addRelation",
            value: function addRelation(parentNodeId, childNodeId) {
                if (this.childrenReference[parentNodeId] === undefined) {
                    this.childrenReference[parentNodeId] = [];
                }

                this.childrenReference[parentNodeId].push(childNodeId);

                if (this.parentReference[childNodeId] === undefined) {
                    this.parentReference[childNodeId] = [];
                }

                this.parentReference[childNodeId].push(parentNodeId);
            }
            /**
             * Check if the current state is for a formal tree or formal forest.
             *
             * This is the case if every node has at most one parent.
             *
             * Pre: parentReference init'ed properly for current network
             */

        }, {
            key: "checkIfTree",
            value: function checkIfTree() {
                for (var i in this.parentReference) {
                    if (this.parentReference[i].length > 1) {
                        this.isTree = false;
                        return;
                    }
                }

                this.isTree = true;
            }
            /**
             * Return the number of separate trees in the current network.
             *
             * @returns {number}
             */

        }, {
            key: "numTrees",
            value: function numTrees() {
                return this.treeIndex + 1; // This assumes the indexes are assigned consecitively
            }
            /**
             * Assign a tree id to a node
             *
             * @param {Node} node
             * @param {string|number} treeId
             */

        }, {
            key: "setTreeIndex",
            value: function setTreeIndex(node, treeId) {
                if (treeId === undefined) return; // Don't bother

                if (this.trees[node.id] === undefined) {
                    this.trees[node.id] = treeId;
                    this.treeIndex = Math.max(treeId, this.treeIndex);
                }
            }
            /**
             * Ensure level for given id is defined.
             *
             * Sets level to zero for given node id if not already present
             *
             * @param {Node.id} nodeId
             */

        }, {
            key: "ensureLevel",
            value: function ensureLevel(nodeId) {
                if (this.levels[nodeId] === undefined) {
                    this.levels[nodeId] = 0;
                }
            }
            /**
             * get the maximum level of a branch.
             *
             * TODO: Never entered; find a test case to test this!
             *
             * @param {Node.id} nodeId
             * @returns {number}
             */

        }, {
            key: "getMaxLevel",
            value: function getMaxLevel(nodeId) {
                var _this = this;

                var accumulator = {};

                var _getMaxLevel = function _getMaxLevel(nodeId) {
                    if (accumulator[nodeId] !== undefined) {
                        return accumulator[nodeId];
                    }

                    var level = _this.levels[nodeId];

                    if (_this.childrenReference[nodeId]) {
                        var children = _this.childrenReference[nodeId];

                        if (children.length > 0) {
                            for (var i = 0; i < children.length; i++) {
                                level = Math.max(level, _getMaxLevel(children[i]));
                            }
                        }
                    }

                    accumulator[nodeId] = level;
                    return level;
                };

                return _getMaxLevel(nodeId);
            }
            /**
             *
             * @param {Node} nodeA
             * @param {Node} nodeB
             */

        }, {
            key: "levelDownstream",
            value: function levelDownstream(nodeA, nodeB) {
                if (this.levels[nodeB.id] === undefined) {
                    // set initial level
                    if (this.levels[nodeA.id] === undefined) {
                        this.levels[nodeA.id] = 0;
                    } // set level


                    this.levels[nodeB.id] = this.levels[nodeA.id] + 1;
                }
            }
            /**
             * Small util method to set the minimum levels of the nodes to zero.
             *
             * @param {Array.<Node>} nodes
             */

        }, {
            key: "setMinLevelToZero",
            value: function setMinLevelToZero(nodes) {
                var minLevel = 1e9; // get the minimum level

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (this.levels[nodeId] !== undefined) {
                            minLevel = Math.min(this.levels[nodeId], minLevel);
                        }
                    }
                } // subtract the minimum from the set so we have a range starting from 0


                for (var _nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, _nodeId)) {
                        if (this.levels[_nodeId] !== undefined) {
                            this.levels[_nodeId] -= minLevel;
                        }
                    }
                }
            }
            /**
             * Get the min and max xy-coordinates of a given tree
             *
             * @param {Array.<Node>} nodes
             * @param {number} index
             * @returns {{min_x: number, max_x: number, min_y: number, max_y: number}}
             */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(nodes, index) {
                var min_x = 1e9;
                var max_x = -1e9;
                var min_y = 1e9;
                var max_y = -1e9;

                for (var nodeId in this.trees) {
                    if (Object.prototype.hasOwnProperty.call(this.trees, nodeId)) {
                        if (this.trees[nodeId] === index) {
                            var node = nodes[nodeId];
                            min_x = Math.min(node.x, min_x);
                            max_x = Math.max(node.x, max_x);
                            min_y = Math.min(node.y, min_y);
                            max_y = Math.max(node.y, max_y);
                        }
                    }
                }

                return {
                    min_x: min_x,
                    max_x: max_x,
                    min_y: min_y,
                    max_y: max_y
                };
            }
            /**
             * Check if two nodes have the same parent(s)
             *
             * @param {Node} node1
             * @param {Node} node2
             * @returns {boolean} true if the two nodes have a same ancestor node, false otherwise
             */

        }, {
            key: "hasSameParent",
            value: function hasSameParent(node1, node2) {
                var parents1 = this.parentReference[node1.id];
                var parents2 = this.parentReference[node2.id];

                if (parents1 === undefined || parents2 === undefined) {
                    return false;
                }

                for (var i = 0; i < parents1.length; i++) {
                    for (var j = 0; j < parents2.length; j++) {
                        if (parents1[i] == parents2[j]) {
                            return true;
                        }
                    }
                }

                return false;
            }
            /**
             * Check if two nodes are in the same tree.
             *
             * @param {Node} node1
             * @param {Node} node2
             * @returns {boolean} true if this is so, false otherwise
             */

        }, {
            key: "inSameSubNetwork",
            value: function inSameSubNetwork(node1, node2) {
                return this.trees[node1.id] === this.trees[node2.id];
            }
            /**
             * Get a list of the distinct levels in the current network
             *
             * @returns {Array}
             */

        }, {
            key: "getLevels",
            value: function getLevels() {
                return keys$3(this.distributionOrdering);
            }
            /**
             * Add a node to the ordering per level
             *
             * @param {Node} node
             * @param {number} level
             */

        }, {
            key: "addToOrdering",
            value: function addToOrdering(node, level) {
                if (this.distributionOrdering[level] === undefined) {
                    this.distributionOrdering[level] = [];
                }

                var isPresent = false;
                var curLevel = this.distributionOrdering[level];

                for (var n in curLevel) {
                    //if (curLevel[n].id === node.id) {
                    if (curLevel[n] === node) {
                        isPresent = true;
                        break;
                    }
                }

                if (!isPresent) {
                    this.distributionOrdering[level].push(node);
                    this.distributionIndex[node.id] = this.distributionOrdering[level].length - 1;
                }
            }
        }]);

        return HierarchicalStatus;
    }();
    /**
     * The Layout Engine
     */


    var LayoutEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function LayoutEngine(body) {
            _classCallCheck(this, LayoutEngine);

            this.body = body; // Make sure there always is some RNG because the setOptions method won't
            // set it unless there's a seed for it.

            this._resetRNG(Math.random() + ":" + now$1());

            this.setPhysics = false;
            this.options = {};
            this.optionsBackup = {
                physics: {}
            };
            this.defaultOptions = {
                randomSeed: undefined,
                improvedLayout: true,
                clusterThreshold: 150,
                hierarchical: {
                    enabled: false,
                    levelSeparation: 150,
                    nodeSpacing: 100,
                    treeSpacing: 200,
                    blockShifting: true,
                    edgeMinimization: true,
                    parentCentralization: true,
                    direction: "UD",
                    // UD, DU, LR, RL
                    sortMethod: "hubsize" // hubsize, directed

                }
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(LayoutEngine, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this;

                this.body.emitter.on("_dataChanged", function () {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_dataLoaded", function () {
                    _this2.layoutNetwork();
                });
                this.body.emitter.on("_resetHierarchicalLayout", function () {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_adjustEdgesForHierarchicalLayout", function () {
                    if (_this2.options.hierarchical.enabled !== true) {
                        return;
                    } // get the type of static smooth curve in case it is required


                    var type = _this2.direction.curveType(); // force all edges into static smooth curves.


                    _this2.body.emitter.emit("_forceDisableDynamicCurves", type, false);
                });
            }
            /**
             *
             * @param {object} options
             * @param {object} allOptions
             * @returns {object}
             */

        }, {
            key: "setOptions",
            value: function setOptions(options, allOptions) {
                if (options !== undefined) {
                    var hierarchical = this.options.hierarchical;
                    var prevHierarchicalState = hierarchical.enabled;
                    selectiveDeepExtend(["randomSeed", "improvedLayout", "clusterThreshold"], this.options, options);
                    mergeOptions(this.options, options, "hierarchical");

                    if (options.randomSeed !== undefined) {
                        this._resetRNG(options.randomSeed);
                    }

                    if (hierarchical.enabled === true) {
                        if (prevHierarchicalState === true) {
                            // refresh the overridden options for nodes and edges.
                            this.body.emitter.emit("refresh", true);
                        } // make sure the level separation is the right way up


                        if (hierarchical.direction === "RL" || hierarchical.direction === "DU") {
                            if (hierarchical.levelSeparation > 0) {
                                hierarchical.levelSeparation *= -1;
                            }
                        } else {
                            if (hierarchical.levelSeparation < 0) {
                                hierarchical.levelSeparation *= -1;
                            }
                        }

                        this.setDirectionStrategy();
                        this.body.emitter.emit("_resetHierarchicalLayout"); // because the hierarchical system needs it's own physics and smooth curve settings,
                        // we adapt the other options if needed.

                        return this.adaptAllOptionsForHierarchicalLayout(allOptions);
                    } else {
                        if (prevHierarchicalState === true) {
                            // refresh the overridden options for nodes and edges.
                            this.body.emitter.emit("refresh");
                            return deepExtend(allOptions, this.optionsBackup);
                        }
                    }
                }

                return allOptions;
            }
            /**
             * Reset the random number generator with given seed.
             *
             * @param {any} seed - The seed that will be forwarded the the RNG.
             */

        }, {
            key: "_resetRNG",
            value: function _resetRNG(seed) {
                this.initialRandomSeed = seed;
                this._rng = Alea(this.initialRandomSeed);
            }
            /**
             *
             * @param {object} allOptions
             * @returns {object}
             */

        }, {
            key: "adaptAllOptionsForHierarchicalLayout",
            value: function adaptAllOptionsForHierarchicalLayout(allOptions) {
                if (this.options.hierarchical.enabled === true) {
                    var backupPhysics = this.optionsBackup.physics; // set the physics

                    if (allOptions.physics === undefined || allOptions.physics === true) {
                        allOptions.physics = {
                            enabled: backupPhysics.enabled === undefined ? true : backupPhysics.enabled,
                            solver: "hierarchicalRepulsion"
                        };
                        backupPhysics.enabled = backupPhysics.enabled === undefined ? true : backupPhysics.enabled;
                        backupPhysics.solver = backupPhysics.solver || "barnesHut";
                    } else if (_typeof(allOptions.physics) === "object") {
                        backupPhysics.enabled = allOptions.physics.enabled === undefined ? true : allOptions.physics.enabled;
                        backupPhysics.solver = allOptions.physics.solver || "barnesHut";
                        allOptions.physics.solver = "hierarchicalRepulsion";
                    } else if (allOptions.physics !== false) {
                        backupPhysics.solver = "barnesHut";
                        allOptions.physics = {
                            solver: "hierarchicalRepulsion"
                        };
                    } // get the type of static smooth curve in case it is required


                    var type = this.direction.curveType(); // disable smooth curves if nothing is defined. If smooth curves have been turned on,
                    // turn them into static smooth curves.

                    if (allOptions.edges === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges = {
                            smooth: false
                        };
                    } else if (allOptions.edges.smooth === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges.smooth = false;
                    } else {
                        if (typeof allOptions.edges.smooth === "boolean") {
                            this.optionsBackup.edges = {
                                smooth: allOptions.edges.smooth
                            };
                            allOptions.edges.smooth = {
                                enabled: allOptions.edges.smooth,
                                type: type
                            };
                        } else {
                            var smooth = allOptions.edges.smooth; // allow custom types except for dynamic

                            if (smooth.type !== undefined && smooth.type !== "dynamic") {
                                type = smooth.type;
                            } // TODO: this is options merging; see if the standard routines can be used here.


                            this.optionsBackup.edges = {
                                smooth: {
                                    enabled: smooth.enabled === undefined ? true : smooth.enabled,
                                    type: smooth.type === undefined ? "dynamic" : smooth.type,
                                    roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                                    forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                                }
                            }; // NOTE: Copying an object to self; this is basically setting defaults for undefined variables

                            allOptions.edges.smooth = {
                                enabled: smooth.enabled === undefined ? true : smooth.enabled,
                                type: type,
                                roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                                forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                            };
                        }
                    } // Force all edges into static smooth curves.
                    // Only applies to edges that do not use the global options for smooth.


                    this.body.emitter.emit("_forceDisableDynamicCurves", type);
                }

                return allOptions;
            }
            /**
             *
             * @param {Array.<Node>} nodesArray
             */

        }, {
            key: "positionInitially",
            value: function positionInitially(nodesArray) {
                if (this.options.hierarchical.enabled !== true) {
                    this._resetRNG(this.initialRandomSeed);

                    var radius = nodesArray.length + 50;

                    for (var i = 0; i < nodesArray.length; i++) {
                        var node = nodesArray[i];

                        var angle = 2 * Math.PI * this._rng();

                        if (node.x === undefined) {
                            node.x = radius * Math.cos(angle);
                        }

                        if (node.y === undefined) {
                            node.y = radius * Math.sin(angle);
                        }
                    }
                }
            }
            /**
             * Use Kamada Kawai to position nodes. This is quite a heavy algorithm so if there are a lot of nodes we
             * cluster them first to reduce the amount.
             */

        }, {
            key: "layoutNetwork",
            value: function layoutNetwork() {
                if (this.options.hierarchical.enabled !== true && this.options.improvedLayout === true) {
                    var indices = this.body.nodeIndices; // first check if we should Kamada Kawai to layout. The threshold is if less than half of the visible
                    // nodes have predefined positions we use this.

                    var positionDefined = 0;

                    for (var i = 0; i < indices.length; i++) {
                        var node = this.body.nodes[indices[i]];

                        if (node.predefinedPosition === true) {
                            positionDefined += 1;
                        }
                    } // if less than half of the nodes have a predefined position we continue


                    if (positionDefined < 0.5 * indices.length) {
                        var MAX_LEVELS = 10;
                        var level = 0;
                        var clusterThreshold = this.options.clusterThreshold; //
                        // Define the options for the hidden cluster nodes
                        // These options don't propagate outside the clustering phase.
                        //
                        // Some options are explicitly disabled, because they may be set in group or default node options.
                        // The clusters are never displayed, so most explicit settings here serve as performance optimizations.
                        //
                        // The explicit setting of 'shape' is to avoid `shape: 'image'`; images are not passed to the hidden
                        // cluster nodes, leading to an exception on creation.
                        //
                        // All settings here are performance related, except when noted otherwise.
                        //

                        var clusterOptions = {
                            clusterNodeProperties: {
                                shape: "ellipse",
                                // Bugfix: avoid type 'image', no images supplied
                                label: "",
                                // avoid label handling
                                group: "",
                                // avoid group handling
                                font: {
                                    multi: false
                                } // avoid font propagation

                            },
                            clusterEdgeProperties: {
                                label: "",
                                // avoid label handling
                                font: {
                                    multi: false
                                },
                                // avoid font propagation
                                smooth: {
                                    enabled: false // avoid drawing penalty for complex edges

                                }
                            }
                        }; // if there are a lot of nodes, we cluster before we run the algorithm.
                        // NOTE: this part fails to find clusters for large scale-free networks, which should
                        //       be easily clusterable.
                        // TODO: examine why this is so

                        if (indices.length > clusterThreshold) {
                            var startLength = indices.length;

                            while (indices.length > clusterThreshold && level <= MAX_LEVELS) {
                                //console.time("clustering")
                                level += 1;
                                var before = indices.length; // if there are many nodes we do a hubsize cluster

                                if (level % 3 === 0) {
                                    this.body.modules.clustering.clusterBridges(clusterOptions);
                                } else {
                                    this.body.modules.clustering.clusterOutliers(clusterOptions);
                                }

                                var after = indices.length;

                                if (before == after && level % 3 !== 0) {
                                    this._declusterAll();

                                    this.body.emitter.emit("_layoutFailed");
                                    console.info("This network could not be positioned by this version of the improved layout algorithm." + " Please disable improvedLayout for better performance.");
                                    return;
                                } //console.timeEnd("clustering")
                                //console.log(before,level,after);

                            } // increase the size of the edges


                            this.body.modules.kamadaKawai.setOptions({
                                springLength: Math.max(150, 2 * startLength)
                            });
                        }

                        if (level > MAX_LEVELS) {
                            console.info("The clustering didn't succeed within the amount of interations allowed," + " progressing with partial result.");
                        } // position the system for these nodes and edges


                        this.body.modules.kamadaKawai.solve(indices, this.body.edgeIndices, true); // shift to center point

                        this._shiftToCenter(); // perturb the nodes a little bit to force the physics to kick in


                        var offset = 70;

                        for (var _i = 0; _i < indices.length; _i++) {
                            // Only perturb the nodes that aren't fixed
                            var _node = this.body.nodes[indices[_i]];

                            if (_node.predefinedPosition === false) {
                                _node.x += (0.5 - this._rng()) * offset;
                                _node.y += (0.5 - this._rng()) * offset;
                            }
                        } // uncluster all clusters


                        this._declusterAll(); // reposition all bezier nodes.


                        this.body.emitter.emit("_repositionBezierNodes");
                    }
                }
            }
            /**
             * Move all the nodes towards to the center so gravitational pull wil not move the nodes away from view
             *
             * @private
             */

        }, {
            key: "_shiftToCenter",
            value: function _shiftToCenter() {
                var range = NetworkUtil.getRangeCore(this.body.nodes, this.body.nodeIndices);
                var center = NetworkUtil.findCenter(range);

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];
                    node.x -= center.x;
                    node.y -= center.y;
                }
            }
            /**
             * Expands all clusters
             *
             * @private
             */

        }, {
            key: "_declusterAll",
            value: function _declusterAll() {
                var clustersPresent = true;

                while (clustersPresent === true) {
                    clustersPresent = false;

                    for (var i = 0; i < this.body.nodeIndices.length; i++) {
                        if (this.body.nodes[this.body.nodeIndices[i]].isCluster === true) {
                            clustersPresent = true;
                            this.body.modules.clustering.openCluster(this.body.nodeIndices[i], {}, false);
                        }
                    }

                    if (clustersPresent === true) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             *
             * @returns {number|*}
             */

        }, {
            key: "getSeed",
            value: function getSeed() {
                return this.initialRandomSeed;
            }
            /**
             * This is the main function to layout the nodes in a hierarchical way.
             * It checks if the node details are supplied correctly
             *
             * @private
             */

        }, {
            key: "setupHierarchicalLayout",
            value: function setupHierarchicalLayout() {
                if (this.options.hierarchical.enabled === true && this.body.nodeIndices.length > 0) {
                    // get the size of the largest hubs and check if the user has defined a level for a node.
                    var node, nodeId;
                    var definedLevel = false;
                    var undefinedLevel = false;
                    this.lastNodeOnLevel = {};
                    this.hierarchical = new HierarchicalStatus();

                    for (nodeId in this.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                            node = this.body.nodes[nodeId];

                            if (node.options.level !== undefined) {
                                definedLevel = true;
                                this.hierarchical.levels[nodeId] = node.options.level;
                            } else {
                                undefinedLevel = true;
                            }
                        }
                    } // if the user defined some levels but not all, alert and run without hierarchical layout


                    if (undefinedLevel === true && definedLevel === true) {
                        throw new Error("To use the hierarchical layout, nodes require either no predefined levels" + " or levels have to be defined for all nodes.");
                    } else {
                        // define levels if undefined by the users. Based on hubsize.
                        if (undefinedLevel === true) {
                            var sortMethod = this.options.hierarchical.sortMethod;

                            if (sortMethod === "hubsize") {
                                this._determineLevelsByHubsize();
                            } else if (sortMethod === "directed") {
                                this._determineLevelsDirected();
                            } else if (sortMethod === "custom") {
                                this._determineLevelsCustomCallback();
                            }
                        } // fallback for cases where there are nodes but no edges


                        for (var _nodeId2 in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) {
                                this.hierarchical.ensureLevel(_nodeId2);
                            }
                        } // check the distribution of the nodes per level.


                        var distribution = this._getDistribution(); // get the parent children relations.


                        this._generateMap(); // place the nodes on the canvas.


                        this._placeNodesByHierarchy(distribution); // condense the whitespace.


                        this._condenseHierarchy(); // shift to center so gravity does not have to do much


                        this._shiftToCenter();
                    }
                }
            }
            /**
             * @private
             */

        }, {
            key: "_condenseHierarchy",
            value: function _condenseHierarchy() {
                var _this3 = this;

                // Global var in this scope to define when the movement has stopped.
                var stillShifting = false;
                var branches = {}; // first we have some methods to help shifting trees around.
                // the main method to shift the trees

                var shiftTrees = function shiftTrees() {
                    var treeSizes = getTreeSizes();
                    var shiftBy = 0;

                    for (var i = 0; i < treeSizes.length - 1; i++) {
                        var diff = treeSizes[i].max - treeSizes[i + 1].min;
                        shiftBy += diff + _this3.options.hierarchical.treeSpacing;
                        shiftTree(i + 1, shiftBy);
                    }
                }; // shift a single tree by an offset


                var shiftTree = function shiftTree(index, offset) {
                    var trees = _this3.hierarchical.trees;

                    for (var nodeId in trees) {
                        if (Object.prototype.hasOwnProperty.call(trees, nodeId)) {
                            if (trees[nodeId] === index) {
                                _this3.direction.shift(nodeId, offset);
                            }
                        }
                    }
                }; // get the width of all trees


                var getTreeSizes = function getTreeSizes() {
                    var treeWidths = [];

                    for (var i = 0; i < _this3.hierarchical.numTrees(); i++) {
                        treeWidths.push(_this3.direction.getTreeSize(i));
                    }

                    return treeWidths;
                }; // get a map of all nodes in this branch


                var getBranchNodes = function getBranchNodes(source, map) {
                    if (map[source.id]) {
                        return;
                    }

                    map[source.id] = true;

                    if (_this3.hierarchical.childrenReference[source.id]) {
                        var children = _this3.hierarchical.childrenReference[source.id];

                        if (children.length > 0) {
                            for (var i = 0; i < children.length; i++) {
                                getBranchNodes(_this3.body.nodes[children[i]], map);
                            }
                        }
                    }
                }; // get a min max width as well as the maximum movement space it has on either sides
                // we use min max terminology because width and height can interchange depending on the direction of the layout


                var getBranchBoundary = function getBranchBoundary(branchMap) {
                    var maxLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e9;
                    var minSpace = 1e9;
                    var maxSpace = 1e9;
                    var min = 1e9;
                    var max = -1e9;

                    for (var branchNode in branchMap) {
                        if (Object.prototype.hasOwnProperty.call(branchMap, branchNode)) {
                            var node = _this3.body.nodes[branchNode];
                            var level = _this3.hierarchical.levels[node.id];

                            var position = _this3.direction.getPosition(node); // get the space around the node.


                            var _this3$_getSpaceAroun = _this3._getSpaceAroundNode(node, branchMap),
                                _this3$_getSpaceAroun2 = _slicedToArray(_this3$_getSpaceAroun, 2),
                                minSpaceNode = _this3$_getSpaceAroun2[0],
                                maxSpaceNode = _this3$_getSpaceAroun2[1];

                            minSpace = Math.min(minSpaceNode, minSpace);
                            maxSpace = Math.min(maxSpaceNode, maxSpace); // the width is only relevant for the levels two nodes have in common. This is why we filter on this.

                            if (level <= maxLevel) {
                                min = Math.min(position, min);
                                max = Math.max(position, max);
                            }
                        }
                    }

                    return [min, max, minSpace, maxSpace];
                }; // check what the maximum level is these nodes have in common.


                var getCollisionLevel = function getCollisionLevel(node1, node2) {
                    var maxLevel1 = _this3.hierarchical.getMaxLevel(node1.id);

                    var maxLevel2 = _this3.hierarchical.getMaxLevel(node2.id);

                    return Math.min(maxLevel1, maxLevel2);
                };
                /**
                 * Condense elements. These can be nodes or branches depending on the callback.
                 *
                 * @param {Function} callback
                 * @param {Array.<number>} levels
                 * @param {*} centerParents
                 */


                var shiftElementsCloser = function shiftElementsCloser(callback, levels, centerParents) {
                    var hier = _this3.hierarchical;

                    for (var i = 0; i < levels.length; i++) {
                        var level = levels[i];
                        var levelNodes = hier.distributionOrdering[level];

                        if (levelNodes.length > 1) {
                            for (var j = 0; j < levelNodes.length - 1; j++) {
                                var node1 = levelNodes[j];
                                var node2 = levelNodes[j + 1]; // NOTE: logic maintained as it was; if nodes have same ancestor,
                                //       then of course they are in the same sub-network.

                                if (hier.hasSameParent(node1, node2) && hier.inSameSubNetwork(node1, node2)) {
                                    callback(node1, node2, centerParents);
                                }
                            }
                        }
                    }
                }; // callback for shifting branches


                var branchShiftCallback = function branchShiftCallback(node1, node2) {
                    var centerParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    //window.CALLBACKS.push(() => {
                    var pos1 = _this3.direction.getPosition(node1);

                    var pos2 = _this3.direction.getPosition(node2);

                    var diffAbs = Math.abs(pos2 - pos1);
                    var nodeSpacing = _this3.options.hierarchical.nodeSpacing; //console.log("NOW CHECKING:", node1.id, node2.id, diffAbs);

                    if (diffAbs > nodeSpacing) {
                        var branchNodes1 = {};
                        var branchNodes2 = {};
                        getBranchNodes(node1, branchNodes1);
                        getBranchNodes(node2, branchNodes2); // check the largest distance between the branches

                        var maxLevel = getCollisionLevel(node1, node2);
                        var branchNodeBoundary1 = getBranchBoundary(branchNodes1, maxLevel);
                        var branchNodeBoundary2 = getBranchBoundary(branchNodes2, maxLevel);
                        var max1 = branchNodeBoundary1[1];
                        var min2 = branchNodeBoundary2[0];
                        var minSpace2 = branchNodeBoundary2[2]; //console.log(node1.id, getBranchBoundary(branchNodes1, maxLevel), node2.id,
                        //            getBranchBoundary(branchNodes2, maxLevel), maxLevel);

                        var diffBranch = Math.abs(max1 - min2);

                        if (diffBranch > nodeSpacing) {
                            var offset = max1 - min2 + nodeSpacing;

                            if (offset < -minSpace2 + nodeSpacing) {
                                offset = -minSpace2 + nodeSpacing; //console.log("RESETTING OFFSET", max1 - min2 + this.options.hierarchical.nodeSpacing, -minSpace2, offset);
                            }

                            if (offset < 0) {
                                //console.log("SHIFTING", node2.id, offset);
                                _this3._shiftBlock(node2.id, offset);

                                stillShifting = true;
                                if (centerParent === true) _this3._centerParent(node2);
                            }
                        }
                    } //this.body.emitter.emit("_redraw");})

                };

                var minimizeEdgeLength = function minimizeEdgeLength(iterations, node) {
                    //window.CALLBACKS.push(() => {
                    //  console.log("ts",node.id);
                    var nodeId = node.id;
                    var allEdges = node.edges;
                    var nodeLevel = _this3.hierarchical.levels[node.id]; // gather constants

                    var C2 = _this3.options.hierarchical.levelSeparation * _this3.options.hierarchical.levelSeparation;
                    var referenceNodes = {};
                    var aboveEdges = [];

                    for (var i = 0; i < allEdges.length; i++) {
                        var edge = allEdges[i];

                        if (edge.toId != edge.fromId) {
                            var otherNode = edge.toId == nodeId ? edge.from : edge.to;
                            referenceNodes[allEdges[i].id] = otherNode;

                            if (_this3.hierarchical.levels[otherNode.id] < nodeLevel) {
                                aboveEdges.push(edge);
                            }
                        }
                    } // differentiated sum of lengths based on only moving one node over one axis


                    var getFx = function getFx(point, edges) {
                        var sum = 0;

                        for (var _i2 = 0; _i2 < edges.length; _i2++) {
                            if (referenceNodes[edges[_i2].id] !== undefined) {
                                var a = _this3.direction.getPosition(referenceNodes[edges[_i2].id]) - point;
                                sum += a / Math.sqrt(a * a + C2);
                            }
                        }

                        return sum;
                    }; // doubly differentiated sum of lengths based on only moving one node over one axis


                    var getDFx = function getDFx(point, edges) {
                        var sum = 0;

                        for (var _i3 = 0; _i3 < edges.length; _i3++) {
                            if (referenceNodes[edges[_i3].id] !== undefined) {
                                var a = _this3.direction.getPosition(referenceNodes[edges[_i3].id]) - point;
                                sum -= C2 * Math.pow(a * a + C2, -1.5);
                            }
                        }

                        return sum;
                    };

                    var getGuess = function getGuess(iterations, edges) {
                        var guess = _this3.direction.getPosition(node); // Newton's method for optimization


                        var guessMap = {};

                        for (var _i4 = 0; _i4 < iterations; _i4++) {
                            var fx = getFx(guess, edges);
                            var dfx = getDFx(guess, edges); // we limit the movement to avoid instability.

                            var limit = 40;
                            var ratio = Math.max(-limit, Math.min(limit, Math.round(fx / dfx)));
                            guess = guess - ratio; // reduce duplicates

                            if (guessMap[guess] !== undefined) {
                                break;
                            }

                            guessMap[guess] = _i4;
                        }

                        return guess;
                    };

                    var moveBranch = function moveBranch(guess) {
                        // position node if there is space
                        var nodePosition = _this3.direction.getPosition(node); // check movable area of the branch


                        if (branches[node.id] === undefined) {
                            var branchNodes = {};
                            getBranchNodes(node, branchNodes);
                            branches[node.id] = branchNodes;
                        }

                        var branchBoundary = getBranchBoundary(branches[node.id]);
                        var minSpaceBranch = branchBoundary[2];
                        var maxSpaceBranch = branchBoundary[3];
                        var diff = guess - nodePosition; // check if we are allowed to move the node:

                        var branchOffset = 0;

                        if (diff > 0) {
                            branchOffset = Math.min(diff, maxSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        } else if (diff < 0) {
                            branchOffset = -Math.min(-diff, minSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        }

                        if (branchOffset != 0) {
                            //console.log("moving branch:",branchOffset, maxSpaceBranch, minSpaceBranch)
                            _this3._shiftBlock(node.id, branchOffset); //this.body.emitter.emit("_redraw");


                            stillShifting = true;
                        }
                    };

                    var moveNode = function moveNode(guess) {
                        var nodePosition = _this3.direction.getPosition(node); // position node if there is space


                        var _this3$_getSpaceAroun3 = _this3._getSpaceAroundNode(node),
                            _this3$_getSpaceAroun4 = _slicedToArray(_this3$_getSpaceAroun3, 2),
                            minSpace = _this3$_getSpaceAroun4[0],
                            maxSpace = _this3$_getSpaceAroun4[1];

                        var diff = guess - nodePosition; // check if we are allowed to move the node:

                        var newPosition = nodePosition;

                        if (diff > 0) {
                            newPosition = Math.min(nodePosition + (maxSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        } else if (diff < 0) {
                            newPosition = Math.max(nodePosition - (minSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        }

                        if (newPosition !== nodePosition) {
                            //console.log("moving Node:",diff, minSpace, maxSpace);
                            _this3.direction.setPosition(node, newPosition); //this.body.emitter.emit("_redraw");


                            stillShifting = true;
                        }
                    };

                    var guess = getGuess(iterations, aboveEdges);
                    moveBranch(guess);
                    guess = getGuess(iterations, allEdges);
                    moveNode(guess); //})
                }; // method to remove whitespace between branches. Because we do bottom up, we can center the parents.


                var minimizeEdgeLengthBottomUp = function minimizeEdgeLengthBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < iterations; i++) {
                        stillShifting = false;

                        for (var j = 0; j < levels.length; j++) {
                            var level = levels[j];
                            var levelNodes = _this3.hierarchical.distributionOrdering[level];

                            for (var k = 0; k < levelNodes.length; k++) {
                                minimizeEdgeLength(1000, levelNodes[k]);
                            }
                        }

                        if (stillShifting !== true) {
                            //console.log("FINISHED minimizeEdgeLengthBottomUp IN " + i);
                            break;
                        }
                    }
                }; // method to remove whitespace between branches. Because we do bottom up, we can center the parents.


                var shiftBranchesCloserBottomUp = function shiftBranchesCloserBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < iterations; i++) {
                        stillShifting = false;
                        shiftElementsCloser(branchShiftCallback, levels, true);

                        if (stillShifting !== true) {
                            //console.log("FINISHED shiftBranchesCloserBottomUp IN " + (i+1));
                            break;
                        }
                    }
                }; // center all parents


                var centerAllParents = function centerAllParents() {
                    for (var nodeId in _this3.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(_this3.body.nodes, nodeId)) _this3._centerParent(_this3.body.nodes[nodeId]);
                    }
                }; // center all parents


                var centerAllParentsBottomUp = function centerAllParentsBottomUp() {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < levels.length; i++) {
                        var level = levels[i];
                        var levelNodes = _this3.hierarchical.distributionOrdering[level];

                        for (var j = 0; j < levelNodes.length; j++) {
                            _this3._centerParent(levelNodes[j]);
                        }
                    }
                }; // the actual work is done here.


                if (this.options.hierarchical.blockShifting === true) {
                    shiftBranchesCloserBottomUp(5);
                    centerAllParents();
                } // minimize edge length


                if (this.options.hierarchical.edgeMinimization === true) {
                    minimizeEdgeLengthBottomUp(20);
                }

                if (this.options.hierarchical.parentCentralization === true) {
                    centerAllParentsBottomUp();
                }

                shiftTrees();
            }
            /**
             * This gives the space around the node. IF a map is supplied, it will only check against nodes NOT in the map.
             * This is used to only get the distances to nodes outside of a branch.
             *
             * @param {Node} node
             * @param {{Node.id: vis.Node}} map
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getSpaceAroundNode",
            value: function _getSpaceAroundNode(node, map) {
                var useMap = true;

                if (map === undefined) {
                    useMap = false;
                }

                var level = this.hierarchical.levels[node.id];

                if (level !== undefined) {
                    var index = this.hierarchical.distributionIndex[node.id];
                    var position = this.direction.getPosition(node);
                    var ordering = this.hierarchical.distributionOrdering[level];
                    var minSpace = 1e9;
                    var maxSpace = 1e9;

                    if (index !== 0) {
                        var prevNode = ordering[index - 1];

                        if (useMap === true && map[prevNode.id] === undefined || useMap === false) {
                            var prevPos = this.direction.getPosition(prevNode);
                            minSpace = position - prevPos;
                        }
                    }

                    if (index != ordering.length - 1) {
                        var nextNode = ordering[index + 1];

                        if (useMap === true && map[nextNode.id] === undefined || useMap === false) {
                            var nextPos = this.direction.getPosition(nextNode);
                            maxSpace = Math.min(maxSpace, nextPos - position);
                        }
                    }

                    return [minSpace, maxSpace];
                } else {
                    return [0, 0];
                }
            }
            /**
             * We use this method to center a parent node and check if it does not cross other nodes when it does.
             *
             * @param {Node} node
             * @private
             */

        }, {
            key: "_centerParent",
            value: function _centerParent(node) {
                if (this.hierarchical.parentReference[node.id]) {
                    var parents = this.hierarchical.parentReference[node.id];

                    for (var i = 0; i < parents.length; i++) {
                        var parentId = parents[i];
                        var parentNode = this.body.nodes[parentId];
                        var children = this.hierarchical.childrenReference[parentId];

                        if (children !== undefined) {
                            // get the range of the children
                            var newPosition = this._getCenterPosition(children);

                            var position = this.direction.getPosition(parentNode);

                            var _this$_getSpaceAround = this._getSpaceAroundNode(parentNode),
                                _this$_getSpaceAround2 = _slicedToArray(_this$_getSpaceAround, 2),
                                minSpace = _this$_getSpaceAround2[0],
                                maxSpace = _this$_getSpaceAround2[1];

                            var diff = position - newPosition;

                            if (diff < 0 && Math.abs(diff) < maxSpace - this.options.hierarchical.nodeSpacing || diff > 0 && Math.abs(diff) < minSpace - this.options.hierarchical.nodeSpacing) {
                                this.direction.setPosition(parentNode, newPosition);
                            }
                        }
                    }
                }
            }
            /**
             * This function places the nodes on the canvas based on the hierarchial distribution.
             *
             * @param {object} distribution | obtained by the function this._getDistribution()
             * @private
             */

        }, {
            key: "_placeNodesByHierarchy",
            value: function _placeNodesByHierarchy(distribution) {
                this.positionedNodes = {}; // start placing all the level 0 nodes first. Then recursively position their branches.

                for (var level in distribution) {
                    if (Object.prototype.hasOwnProperty.call(distribution, level)) {
                        var _context;

                        // sort nodes in level by position:
                        var nodeArray = keys$3(distribution[level]);

                        nodeArray = this._indexArrayToNodes(nodeArray);

                        sort(_context = this.direction).call(_context, nodeArray);

                        var handledNodeCount = 0;

                        for (var i = 0; i < nodeArray.length; i++) {
                            var node = nodeArray[i];

                            if (this.positionedNodes[node.id] === undefined) {
                                var spacing = this.options.hierarchical.nodeSpacing;
                                var pos = spacing * handledNodeCount; // We get the X or Y values we need and store them in pos and previousPos.
                                // The get and set make sure we get X or Y

                                if (handledNodeCount > 0) {
                                    pos = this.direction.getPosition(nodeArray[i - 1]) + spacing;
                                }

                                this.direction.setPosition(node, pos, level);

                                this._validatePositionAndContinue(node, level, pos);

                                handledNodeCount++;
                            }
                        }
                    }
                }
            }
            /**
             * This is a recursively called function to enumerate the branches from the largest hubs and place the nodes
             * on a X position that ensures there will be no overlap.
             *
             * @param {Node.id} parentId
             * @param {number} parentLevel
             * @private
             */

        }, {
            key: "_placeBranchNodes",
            value: function _placeBranchNodes(parentId, parentLevel) {
                var _context2;

                var childRef = this.hierarchical.childrenReference[parentId]; // if this is not a parent, cancel the placing. This can happen with multiple parents to one child.

                if (childRef === undefined) {
                    return;
                } // get a list of childNodes


                var childNodes = [];

                for (var i = 0; i < childRef.length; i++) {
                    childNodes.push(this.body.nodes[childRef[i]]);
                } // use the positions to order the nodes.


                sort(_context2 = this.direction).call(_context2, childNodes); // position the childNodes


                for (var _i5 = 0; _i5 < childNodes.length; _i5++) {
                    var childNode = childNodes[_i5];
                    var childNodeLevel = this.hierarchical.levels[childNode.id]; // check if the child node is below the parent node and if it has already been positioned.

                    if (childNodeLevel > parentLevel && this.positionedNodes[childNode.id] === undefined) {
                        // get the amount of space required for this node. If parent the width is based on the amount of children.
                        var spacing = this.options.hierarchical.nodeSpacing;
                        var pos = void 0; // we get the X or Y values we need and store them in pos and previousPos.
                        // The get and set make sure we get X or Y

                        if (_i5 === 0) {
                            pos = this.direction.getPosition(this.body.nodes[parentId]);
                        } else {
                            pos = this.direction.getPosition(childNodes[_i5 - 1]) + spacing;
                        }

                        this.direction.setPosition(childNode, pos, childNodeLevel);

                        this._validatePositionAndContinue(childNode, childNodeLevel, pos);
                    } else {
                        return;
                    }
                } // center the parent nodes.


                var center = this._getCenterPosition(childNodes);

                this.direction.setPosition(this.body.nodes[parentId], center, parentLevel);
            }
            /**
             * This method checks for overlap and if required shifts the branch. It also keeps records of positioned nodes.
             * Finally it will call _placeBranchNodes to place the branch nodes.
             *
             * @param {Node} node
             * @param {number} level
             * @param {number} pos
             * @private
             */

        }, {
            key: "_validatePositionAndContinue",
            value: function _validatePositionAndContinue(node, level, pos) {
                // This method only works for formal trees and formal forests
                // Early exit if this is not the case
                if (!this.hierarchical.isTree) return; // if overlap has been detected, we shift the branch

                if (this.lastNodeOnLevel[level] !== undefined) {
                    var previousPos = this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[level]]);

                    if (pos - previousPos < this.options.hierarchical.nodeSpacing) {
                        var diff = previousPos + this.options.hierarchical.nodeSpacing - pos;

                        var sharedParent = this._findCommonParent(this.lastNodeOnLevel[level], node.id);

                        this._shiftBlock(sharedParent.withChild, diff);
                    }
                }

                this.lastNodeOnLevel[level] = node.id; // store change in position.

                this.positionedNodes[node.id] = true;

                this._placeBranchNodes(node.id, level);
            }
            /**
             * Receives an array with node indices and returns an array with the actual node references.
             * Used for sorting based on node properties.
             *
             * @param {Array.<Node.id>} idArray
             * @returns {Array.<Node>}
             */

        }, {
            key: "_indexArrayToNodes",
            value: function _indexArrayToNodes(idArray) {
                var array = [];

                for (var i = 0; i < idArray.length; i++) {
                    array.push(this.body.nodes[idArray[i]]);
                }

                return array;
            }
            /**
             * This function get the distribution of levels based on hubsize
             *
             * @returns {object}
             * @private
             */

        }, {
            key: "_getDistribution",
            value: function _getDistribution() {
                var distribution = {};
                var nodeId, node; // we fix Y because the hierarchy is vertical,
                // we fix X so we do not give a node an x position for a second time.
                // the fix of X is removed after the x value has been set.

                for (nodeId in this.body.nodes) {
                    if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                        node = this.body.nodes[nodeId];
                        var level = this.hierarchical.levels[nodeId] === undefined ? 0 : this.hierarchical.levels[nodeId];
                        this.direction.fix(node, level);

                        if (distribution[level] === undefined) {
                            distribution[level] = {};
                        }

                        distribution[level][nodeId] = node;
                    }
                }

                return distribution;
            }
            /**
             * Return the active (i.e. visible) edges for this node
             *
             * @param {Node} node
             * @returns {Array.<vis.Edge>} Array of edge instances
             * @private
             */

        }, {
            key: "_getActiveEdges",
            value: function _getActiveEdges(node) {
                var _this4 = this;

                var result = [];
                forEach$1(node.edges, function (edge) {
                    var _context3;

                    if (indexOf(_context3 = _this4.body.edgeIndices).call(_context3, edge.id) !== -1) {
                        result.push(edge);
                    }
                });
                return result;
            }
            /**
             * Get the hubsizes for all active nodes.
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_getHubSizes",
            value: function _getHubSizes() {
                var _this5 = this;

                var hubSizes = {};
                var nodeIds = this.body.nodeIndices;
                forEach$1(nodeIds, function (nodeId) {
                    var node = _this5.body.nodes[nodeId];

                    var hubSize = _this5._getActiveEdges(node).length;

                    hubSizes[hubSize] = true;
                }); // Make an array of the size sorted descending

                var result = [];
                forEach$1(hubSizes, function (size) {
                    result.push(Number(size));
                });

                sort(timsort).call(timsort, result, function (a, b) {
                    return b - a;
                });

                return result;
            }
            /**
             * this function allocates nodes in levels based on the recursive branching from the largest hubs.
             *
             * @private
             */

        }, {
            key: "_determineLevelsByHubsize",
            value: function _determineLevelsByHubsize() {
                var _this6 = this;

                var levelDownstream = function levelDownstream(nodeA, nodeB) {
                    _this6.hierarchical.levelDownstream(nodeA, nodeB);
                };

                var hubSizes = this._getHubSizes();

                var _loop = function _loop(i) {
                    var hubSize = hubSizes[i];
                    if (hubSize === 0) return "break";
                    forEach$1(_this6.body.nodeIndices, function (nodeId) {
                        var node = _this6.body.nodes[nodeId];

                        if (hubSize === _this6._getActiveEdges(node).length) {
                            _this6._crawlNetwork(levelDownstream, nodeId);
                        }
                    });
                };

                for (var i = 0; i < hubSizes.length; ++i) {
                    var _ret = _loop(i);

                    if (_ret === "break") break;
                }
            }
            /**
             * TODO: release feature
             * TODO: Determine if this feature is needed at all
             *
             * @private
             */

        }, {
            key: "_determineLevelsCustomCallback",
            value: function _determineLevelsCustomCallback() {
                var _this7 = this;

                var minLevel = 100000; // TODO: this should come from options.
                // eslint-disable-next-line no-unused-vars -- This should eventually be implemented with these parameters used.

                var customCallback = function customCallback(nodeA, nodeB, edge) {}; // TODO: perhaps move to HierarchicalStatus.
                //       But I currently don't see the point, this method is not used.


                var levelByDirection = function levelByDirection(nodeA, nodeB, edge) {
                    var levelA = _this7.hierarchical.levels[nodeA.id]; // set initial level

                    if (levelA === undefined) {
                        levelA = _this7.hierarchical.levels[nodeA.id] = minLevel;
                    }

                    var diff = customCallback(NetworkUtil.cloneOptions(nodeA, "node"), NetworkUtil.cloneOptions(nodeB, "node"), NetworkUtil.cloneOptions(edge, "edge"));
                    _this7.hierarchical.levels[nodeB.id] = levelA + diff;
                };

                this._crawlNetwork(levelByDirection);

                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
            /**
             * Allocate nodes in levels based on the direction of the edges.
             *
             * @private
             */

        }, {
            key: "_determineLevelsDirected",
            value: function _determineLevelsDirected() {
                var _context4,
                    _this8 = this;

                var nodes = reduce(_context4 = this.body.nodeIndices).call(_context4, function (acc, id) {
                    acc.set(id, _this8.body.nodes[id]);
                    return acc;
                }, new map());

                if (this.options.hierarchical.shakeTowards === "roots") {
                    this.hierarchical.levels = fillLevelsByDirectionRoots(nodes);
                } else {
                    this.hierarchical.levels = fillLevelsByDirectionLeaves(nodes);
                }

                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
            /**
             * Update the bookkeeping of parent and child.
             *
             * @private
             */

        }, {
            key: "_generateMap",
            value: function _generateMap() {
                var _this9 = this;

                var fillInRelations = function fillInRelations(parentNode, childNode) {
                    if (_this9.hierarchical.levels[childNode.id] > _this9.hierarchical.levels[parentNode.id]) {
                        _this9.hierarchical.addRelation(parentNode.id, childNode.id);
                    }
                };

                this._crawlNetwork(fillInRelations);

                this.hierarchical.checkIfTree();
            }
            /**
             * Crawl over the entire network and use a callback on each node couple that is connected to each other.
             *
             * @param {Function} [callback=function(){}]          | will receive nodeA, nodeB and the connecting edge. A and B are distinct.
             * @param {Node.id} startingNodeId
             * @private
             */

        }, {
            key: "_crawlNetwork",
            value: function _crawlNetwork() {
                var _this10 = this;

                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
                var startingNodeId = arguments.length > 1 ? arguments[1] : undefined;
                var progress = {};

                var crawler = function crawler(node, tree) {
                    if (progress[node.id] === undefined) {
                        _this10.hierarchical.setTreeIndex(node, tree);

                        progress[node.id] = true;
                        var childNode;

                        var edges = _this10._getActiveEdges(node);

                        for (var i = 0; i < edges.length; i++) {
                            var edge = edges[i];

                            if (edge.connected === true) {
                                if (edge.toId == node.id) {
                                    // Not '===' because id's can be string and numeric
                                    childNode = edge.from;
                                } else {
                                    childNode = edge.to;
                                }

                                if (node.id != childNode.id) {
                                    // Not '!==' because id's can be string and numeric
                                    callback(node, childNode, edge);
                                    crawler(childNode, tree);
                                }
                            }
                        }
                    }
                };

                if (startingNodeId === undefined) {
                    // Crawl over all nodes
                    var treeIndex = 0; // Serves to pass a unique id for the current distinct tree

                    for (var i = 0; i < this.body.nodeIndices.length; i++) {
                        var nodeId = this.body.nodeIndices[i];

                        if (progress[nodeId] === undefined) {
                            var node = this.body.nodes[nodeId];
                            crawler(node, treeIndex);
                            treeIndex += 1;
                        }
                    }
                } else {
                    // Crawl from the given starting node
                    var _node2 = this.body.nodes[startingNodeId];

                    if (_node2 === undefined) {
                        console.error("Node not found:", startingNodeId);
                        return;
                    }

                    crawler(_node2);
                }
            }
            /**
             * Shift a branch a certain distance
             *
             * @param {Node.id} parentId
             * @param {number} diff
             * @private
             */

        }, {
            key: "_shiftBlock",
            value: function _shiftBlock(parentId, diff) {
                var _this11 = this;

                var progress = {};

                var shifter = function shifter(parentId) {
                    if (progress[parentId]) {
                        return;
                    }

                    progress[parentId] = true;

                    _this11.direction.shift(parentId, diff);

                    var childRef = _this11.hierarchical.childrenReference[parentId];

                    if (childRef !== undefined) {
                        for (var i = 0; i < childRef.length; i++) {
                            shifter(childRef[i]);
                        }
                    }
                };

                shifter(parentId);
            }
            /**
             * Find a common parent between branches.
             *
             * @param {Node.id} childA
             * @param {Node.id} childB
             * @returns {{foundParent, withChild}}
             * @private
             */

        }, {
            key: "_findCommonParent",
            value: function _findCommonParent(childA, childB) {
                var _this12 = this;

                var parents = {};

                var iterateParents = function iterateParents(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];

                    if (parentRef !== undefined) {
                        for (var i = 0; i < parentRef.length; i++) {
                            var parent = parentRef[i];
                            parents[parent] = true;
                            iterateParents(parents, parent);
                        }
                    }
                };

                var findParent = function findParent(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];

                    if (parentRef !== undefined) {
                        for (var i = 0; i < parentRef.length; i++) {
                            var parent = parentRef[i];

                            if (parents[parent] !== undefined) {
                                return {
                                    foundParent: parent,
                                    withChild: child
                                };
                            }

                            var branch = findParent(parents, parent);

                            if (branch.foundParent !== null) {
                                return branch;
                            }
                        }
                    }

                    return {
                        foundParent: null,
                        withChild: child
                    };
                };

                iterateParents(parents, childA);
                return findParent(parents, childB);
            }
            /**
             * Set the strategy pattern for handling the coordinates given the current direction.
             *
             * The individual instances contain all the operations and data specific to a layout direction.
             *
             * @param {Node} node
             * @param {{x: number, y: number}} position
             * @param {number} level
             * @param {boolean} [doNotUpdate=false]
             * @private
             */

        }, {
            key: "setDirectionStrategy",
            value: function setDirectionStrategy() {
                var isVertical = this.options.hierarchical.direction === "UD" || this.options.hierarchical.direction === "DU";

                if (isVertical) {
                    this.direction = new VerticalStrategy(this);
                } else {
                    this.direction = new HorizontalStrategy(this);
                }
            }
            /**
             * Determine the center position of a branch from the passed list of child nodes
             *
             * This takes into account the positions of all the child nodes.
             *
             * @param {Array.<Node|vis.Node.id>} childNodes  Array of either child nodes or node id's
             * @returns {number}
             * @private
             */

        }, {
            key: "_getCenterPosition",
            value: function _getCenterPosition(childNodes) {
                var minPos = 1e9;
                var maxPos = -1e9;

                for (var i = 0; i < childNodes.length; i++) {
                    var childNode = void 0;

                    if (childNodes[i].id !== undefined) {
                        childNode = childNodes[i];
                    } else {
                        var childNodeId = childNodes[i];
                        childNode = this.body.nodes[childNodeId];
                    }

                    var position = this.direction.getPosition(childNode);
                    minPos = Math.min(minPos, position);
                    maxPos = Math.max(maxPos, position);
                }

                return 0.5 * (minPos + maxPos);
            }
        }]);

        return LayoutEngine;
    }();

    var css_248z = "div.vis-network div.vis-manipulation {\n  box-sizing: content-box;\n\n  border-width: 0;\n  border-bottom: 1px;\n  border-style: solid;\n  border-color: #d6d9d8;\n  background: #ffffff; /* Old browsers */\n  background: -moz-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #ffffff),\n    color-stop(48%, #fcfcfc),\n    color-stop(50%, #fafafa),\n    color-stop(100%, #fcfcfc)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* IE10+ */\n  background: linear-gradient(\n    to bottom,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fcfcfc',GradientType=0 ); /* IE6-9 */\n\n  padding-top: 4px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 28px;\n}\n\ndiv.vis-network div.vis-edit-mode,\ndiv.vis-network button.vis-edit-mode {\n  position: absolute;\n  left: 0;\n  top: 5px;\n  height: 30px;\n}\n\n/* FIXME: shouldn't the vis-close button be a child of the vis-manipulation div? */\n\ndiv.vis-network button.vis-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 30px;\n  height: 30px;\n\n  background-color: transparent;\n  background-position: 20px 3px;\n  background-repeat: no-repeat;\n  background-image: url('data:image/png;base64,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');\n  border: none;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network button.vis-close:hover {\n  opacity: 0.6;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button,\ndiv.vis-network div.vis-edit-mode button.vis-button {\n  float: left;\n  font-family: verdana;\n  font-size: 12px;\n  border: none;\n  box-sizing: content-box;\n  -moz-border-radius: 15px;\n  border-radius: 15px;\n  background-color: transparent;\n  background-position: 0px 0px;\n  background-repeat: no-repeat;\n  height: 24px;\n  margin-left: 10px;\n  cursor: pointer;\n  padding: 0px 8px 0px 8px;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button:hover {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button:active {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.5);\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-back {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation div.vis-none:hover {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0);\n  cursor: default;\n}\ndiv.vis-network div.vis-manipulation div.vis-none:active {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0);\n}\ndiv.vis-network div.vis-manipulation div.vis-none {\n  padding: 0px;\n  line-height: 23px;\n}\ndiv.vis-network div.vis-manipulation div.notification {\n  margin: 2px;\n  font-weight: bold;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-add {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-edit,\ndiv.vis-network div.vis-edit-mode button.vis-button.vis-edit {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-edit-mode button.vis-button.vis-edit.vis-edit-mode {\n  background-color: #fcfcfc;\n  border: 1px solid #cccccc;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-connect {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-delete {\n  background-image: url('data:image/png;base64,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');\n}\n/* top right bottom left */\ndiv.vis-network div.vis-manipulation div.vis-label,\ndiv.vis-network div.vis-edit-mode div.vis-label {\n  margin: 0 0 0 23px;\n  line-height: 25px;\n}\ndiv.vis-network div.vis-manipulation div.vis-separator-line {\n  float: left;\n  display: inline-block;\n  width: 1px;\n  height: 21px;\n  background-color: #bdbdbd;\n  margin: 0px 7px 0 15px; /*top right bottom left*/\n}\n\n/* TODO: is this redundant?\ndiv.network-navigation_wrapper {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n*/\n";
    styleInject(css_248z);

    function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray(o, minLen) { var _context32; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = slice$1(_context32 = Object.prototype.toString.call(o)).call(_context32, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

    function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Clears the toolbar div element of children
     *
     * @private
     */

    var ManipulationSystem = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         * @param {SelectionHandler} selectionHandler
         * @param {InteractionHandler} interactionHandler
         */
        function ManipulationSystem(body, canvas, selectionHandler, interactionHandler) {
            var _this = this,
                _context,
                _context2;

            _classCallCheck(this, ManipulationSystem);

            this.body = body;
            this.canvas = canvas;
            this.selectionHandler = selectionHandler;
            this.interactionHandler = interactionHandler;
            this.editMode = false;
            this.manipulationDiv = undefined;
            this.editModeDiv = undefined;
            this.closeDiv = undefined;
            this._domEventListenerCleanupQueue = [];
            this.temporaryUIFunctions = {};
            this.temporaryEventFunctions = [];
            this.touchTime = 0;
            this.temporaryIds = {
                nodes: [],
                edges: []
            };
            this.guiEnabled = false;
            this.inMode = false;
            this.selectedControlNode = undefined;
            this.options = {};
            this.defaultOptions = {
                enabled: false,
                initiallyActive: false,
                addNode: true,
                addEdge: true,
                editNode: undefined,
                editEdge: true,
                deleteNode: true,
                deleteEdge: true,
                controlNodeStyle: {
                    shape: "dot",
                    size: 6,
                    color: {
                        background: "#ff0000",
                        border: "#3c3c3c",
                        highlight: {
                            background: "#07f968",
                            border: "#3c3c3c"
                        }
                    },
                    borderWidth: 2,
                    borderWidthSelected: 2
                }
            };

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("destroy", function () {
                _this._clean();
            });
            this.body.emitter.on("_dataChanged", bind(_context = this._restore).call(_context, this));
            this.body.emitter.on("_resetData", bind(_context2 = this._restore).call(_context2, this));
        }
        /**
         * If something changes in the data during editing, switch back to the initial datamanipulation state and close all edit modes.
         *
         * @private
         */


        _createClass(ManipulationSystem, [{
            key: "_restore",
            value: function _restore() {
                if (this.inMode !== false) {
                    if (this.options.initiallyActive === true) {
                        this.enableEditMode();
                    } else {
                        this.disableEditMode();
                    }
                }
            }
            /**
             * Set the Options
             *
             * @param {object} options
             * @param {object} allOptions
             * @param {object} globalOptions
             */

        }, {
            key: "setOptions",
            value: function setOptions(options, allOptions, globalOptions) {
                if (allOptions !== undefined) {
                    if (allOptions.locale !== undefined) {
                        this.options.locale = allOptions.locale;
                    } else {
                        this.options.locale = globalOptions.locale;
                    }

                    if (allOptions.locales !== undefined) {
                        this.options.locales = allOptions.locales;
                    } else {
                        this.options.locales = globalOptions.locales;
                    }
                }

                if (options !== undefined) {
                    if (typeof options === "boolean") {
                        this.options.enabled = options;
                    } else {
                        this.options.enabled = true;
                        deepExtend(this.options, options);
                    }

                    if (this.options.initiallyActive === true) {
                        this.editMode = true;
                    }

                    this._setup();
                }
            }
            /**
             * Enable or disable edit-mode. Draws the DOM required and cleans up after itself.
             *
             * @private
             */

        }, {
            key: "toggleEditMode",
            value: function toggleEditMode() {
                if (this.editMode === true) {
                    this.disableEditMode();
                } else {
                    this.enableEditMode();
                }
            }
            /**
             * Enables Edit Mode
             */

        }, {
            key: "enableEditMode",
            value: function enableEditMode() {
                this.editMode = true;

                this._clean();

                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    this.editModeDiv.style.display = "none";
                    this.showManipulatorToolbar();
                }
            }
            /**
             * Disables Edit Mode
             */

        }, {
            key: "disableEditMode",
            value: function disableEditMode() {
                this.editMode = false;

                this._clean();

                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "none";
                    this.closeDiv.style.display = "none";
                    this.editModeDiv.style.display = "block";

                    this._createEditButton();
                }
            }
            /**
             * Creates the main toolbar. Removes functions bound to the select event. Binds all the buttons of the toolbar.
             *
             * @private
             */

        }, {
            key: "showManipulatorToolbar",
            value: function showManipulatorToolbar() {
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean(); // reset global variables


                this.manipulationDOM = {}; // if the gui is enabled, draw all elements.

                if (this.guiEnabled === true) {
                    var _context3, _context4;

                    // a _restore will hide these menus
                    this.editMode = true;
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    var selectedNodeCount = this.selectionHandler.getSelectedNodeCount();
                    var selectedEdgeCount = this.selectionHandler.getSelectedEdgeCount();
                    var selectedTotalCount = selectedNodeCount + selectedEdgeCount;
                    var locale = this.options.locales[this.options.locale];
                    var needSeperator = false;

                    if (this.options.addNode !== false) {
                        this._createAddNodeButton(locale);

                        needSeperator = true;
                    }

                    if (this.options.addEdge !== false) {
                        if (needSeperator === true) {
                            this._createSeperator(1);
                        } else {
                            needSeperator = true;
                        }

                        this._createAddEdgeButton(locale);
                    }

                    if (selectedNodeCount === 1 && typeof this.options.editNode === "function") {
                        if (needSeperator === true) {
                            this._createSeperator(2);
                        } else {
                            needSeperator = true;
                        }

                        this._createEditNodeButton(locale);
                    } else if (selectedEdgeCount === 1 && selectedNodeCount === 0 && this.options.editEdge !== false) {
                        if (needSeperator === true) {
                            this._createSeperator(3);
                        } else {
                            needSeperator = true;
                        }

                        this._createEditEdgeButton(locale);
                    } // remove buttons


                    if (selectedTotalCount !== 0) {
                        if (selectedNodeCount > 0 && this.options.deleteNode !== false) {
                            if (needSeperator === true) {
                                this._createSeperator(4);
                            }

                            this._createDeleteButton(locale);
                        } else if (selectedNodeCount === 0 && this.options.deleteEdge !== false) {
                            if (needSeperator === true) {
                                this._createSeperator(4);
                            }

                            this._createDeleteButton(locale);
                        }
                    } // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context3 = this.toggleEditMode).call(_context3, this)); // refresh this bar based on what has been selected


                    this._temporaryBindEvent("select", bind(_context4 = this.showManipulatorToolbar).call(_context4, this));
                } // redraw to show any possible changes


                this.body.emitter.emit("_redraw");
            }
            /**
             * Create the toolbar for adding Nodes
             */

        }, {
            key: "addNodeMode",
            value: function addNodeMode() {
                var _context6;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "addNode";

                if (this.guiEnabled === true) {
                    var _context5;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["addDescription"] || this.options.locales["en"]["addDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context5 = this.toggleEditMode).call(_context5, this));
                }

                this._temporaryBindEvent("click", bind(_context6 = this._performAddNode).call(_context6, this));
            }
            /**
             * call the bound function to handle the editing of the node. The node has to be selected.
             */

        }, {
            key: "editNode",
            value: function editNode() {
                var _this2 = this;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                var node = this.selectionHandler.getSelectedNodes()[0];

                if (node !== undefined) {
                    this.inMode = "editNode";

                    if (typeof this.options.editNode === "function") {
                        if (node.isCluster !== true) {
                            var data = deepExtend({}, node.options, false);
                            data.x = node.x;
                            data.y = node.y;

                            if (this.options.editNode.length === 2) {
                                this.options.editNode(data, function (finalizedData) {
                                    if (finalizedData !== null && finalizedData !== undefined && _this2.inMode === "editNode") {
                                        // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                        _this2.body.data.nodes.getDataSet().update(finalizedData);
                                    }

                                    _this2.showManipulatorToolbar();
                                });
                            } else {
                                throw new Error("The function for edit does not support two arguments (data, callback)");
                            }
                        } else {
                            alert(this.options.locales[this.options.locale]["editClusterError"] || this.options.locales["en"]["editClusterError"]);
                        }
                    } else {
                        throw new Error("No function has been configured to handle the editing of nodes.");
                    }
                } else {
                    this.showManipulatorToolbar();
                }
            }
            /**
             * create the toolbar to connect nodes
             */

        }, {
            key: "addEdgeMode",
            value: function addEdgeMode() {
                var _context8, _context9, _context10, _context11, _context12;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "addEdge";

                if (this.guiEnabled === true) {
                    var _context7;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["edgeDescription"] || this.options.locales["en"]["edgeDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context7 = this.toggleEditMode).call(_context7, this));
                } // temporarily overload functions


                this._temporaryBindUI("onTouch", bind(_context8 = this._handleConnect).call(_context8, this));

                this._temporaryBindUI("onDragEnd", bind(_context9 = this._finishConnect).call(_context9, this));

                this._temporaryBindUI("onDrag", bind(_context10 = this._dragControlNode).call(_context10, this));

                this._temporaryBindUI("onRelease", bind(_context11 = this._finishConnect).call(_context11, this));

                this._temporaryBindUI("onDragStart", bind(_context12 = this._dragStartEdge).call(_context12, this));

                this._temporaryBindUI("onHold", function () {});
            }
            /**
             * create the toolbar to edit edges
             */

        }, {
            key: "editEdgeMode",
            value: function editEdgeMode() {
                // when using the gui, enable edit mode if it wasn't already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "editEdge";

                if (_typeof(this.options.editEdge) === "object" && typeof this.options.editEdge.editWithoutDrag === "function") {
                    this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];

                    if (this.edgeBeingEditedId !== undefined) {
                        var edge = this.body.edges[this.edgeBeingEditedId];

                        this._performEditEdge(edge.from.id, edge.to.id);

                        return;
                    }
                }

                if (this.guiEnabled === true) {
                    var _context13;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["editEdgeDescription"] || this.options.locales["en"]["editEdgeDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context13 = this.toggleEditMode).call(_context13, this));
                }

                this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];

                if (this.edgeBeingEditedId !== undefined) {
                    var _context14, _context15, _context16, _context17;

                    var _edge = this.body.edges[this.edgeBeingEditedId]; // create control nodes

                    var controlNodeFrom = this._getNewTargetNode(_edge.from.x, _edge.from.y);

                    var controlNodeTo = this._getNewTargetNode(_edge.to.x, _edge.to.y);

                    this.temporaryIds.nodes.push(controlNodeFrom.id);
                    this.temporaryIds.nodes.push(controlNodeTo.id);
                    this.body.nodes[controlNodeFrom.id] = controlNodeFrom;
                    this.body.nodeIndices.push(controlNodeFrom.id);
                    this.body.nodes[controlNodeTo.id] = controlNodeTo;
                    this.body.nodeIndices.push(controlNodeTo.id); // temporarily overload UI functions, cleaned up automatically because of _temporaryBindUI

                    this._temporaryBindUI("onTouch", bind(_context14 = this._controlNodeTouch).call(_context14, this)); // used to get the position


                    this._temporaryBindUI("onTap", function () {}); // disabled


                    this._temporaryBindUI("onHold", function () {}); // disabled


                    this._temporaryBindUI("onDragStart", bind(_context15 = this._controlNodeDragStart).call(_context15, this)); // used to select control node


                    this._temporaryBindUI("onDrag", bind(_context16 = this._controlNodeDrag).call(_context16, this)); // used to drag control node


                    this._temporaryBindUI("onDragEnd", bind(_context17 = this._controlNodeDragEnd).call(_context17, this)); // used to connect or revert control nodes


                    this._temporaryBindUI("onMouseMove", function () {}); // disabled
                    // create function to position control nodes correctly on movement
                    // automatically cleaned up because we use the temporary bind


                    this._temporaryBindEvent("beforeDrawing", function (ctx) {
                        var positions = _edge.edgeType.findBorderPositions(ctx);

                        if (controlNodeFrom.selected === false) {
                            controlNodeFrom.x = positions.from.x;
                            controlNodeFrom.y = positions.from.y;
                        }

                        if (controlNodeTo.selected === false) {
                            controlNodeTo.x = positions.to.x;
                            controlNodeTo.y = positions.to.y;
                        }
                    });

                    this.body.emitter.emit("_redraw");
                } else {
                    this.showManipulatorToolbar();
                }
            }
            /**
             * delete everything in the selection
             */

        }, {
            key: "deleteSelected",
            value: function deleteSelected() {
                var _this3 = this;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "delete";
                var selectedNodes = this.selectionHandler.getSelectedNodeIds();
                var selectedEdges = this.selectionHandler.getSelectedEdgeIds();
                var deleteFunction = undefined;

                if (selectedNodes.length > 0) {
                    for (var i = 0; i < selectedNodes.length; i++) {
                        if (this.body.nodes[selectedNodes[i]].isCluster === true) {
                            alert(this.options.locales[this.options.locale]["deleteClusterError"] || this.options.locales["en"]["deleteClusterError"]);
                            return;
                        }
                    }

                    if (typeof this.options.deleteNode === "function") {
                        deleteFunction = this.options.deleteNode;
                    }
                } else if (selectedEdges.length > 0) {
                    if (typeof this.options.deleteEdge === "function") {
                        deleteFunction = this.options.deleteEdge;
                    }
                }

                if (typeof deleteFunction === "function") {
                    var data = {
                        nodes: selectedNodes,
                        edges: selectedEdges
                    };

                    if (deleteFunction.length === 2) {
                        deleteFunction(data, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this3.inMode === "delete") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                _this3.body.data.edges.getDataSet().remove(finalizedData.edges);

                                _this3.body.data.nodes.getDataSet().remove(finalizedData.nodes);

                                _this3.body.emitter.emit("startSimulation");

                                _this3.showManipulatorToolbar();
                            } else {
                                _this3.body.emitter.emit("startSimulation");

                                _this3.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for delete does not support two arguments (data, callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().remove(selectedEdges);
                    this.body.data.nodes.getDataSet().remove(selectedNodes);
                    this.body.emitter.emit("startSimulation");
                    this.showManipulatorToolbar();
                }
            } //********************************************** PRIVATE ***************************************//

            /**
             * draw or remove the DOM
             *
             * @private
             */

        }, {
            key: "_setup",
            value: function _setup() {
                if (this.options.enabled === true) {
                    // Enable the GUI
                    this.guiEnabled = true;

                    this._createWrappers();

                    if (this.editMode === false) {
                        this._createEditButton();
                    } else {
                        this.showManipulatorToolbar();
                    }
                } else {
                    this._removeManipulationDOM(); // disable the gui


                    this.guiEnabled = false;
                }
            }
            /**
             * create the div overlays that contain the DOM
             *
             * @private
             */

        }, {
            key: "_createWrappers",
            value: function _createWrappers() {
                // load the manipulator HTML elements. All styling done in css.
                if (this.manipulationDiv === undefined) {
                    this.manipulationDiv = document.createElement("div");
                    this.manipulationDiv.className = "vis-manipulation";

                    if (this.editMode === true) {
                        this.manipulationDiv.style.display = "block";
                    } else {
                        this.manipulationDiv.style.display = "none";
                    }

                    this.canvas.frame.appendChild(this.manipulationDiv);
                } // container for the edit button.


                if (this.editModeDiv === undefined) {
                    this.editModeDiv = document.createElement("div");
                    this.editModeDiv.className = "vis-edit-mode";

                    if (this.editMode === true) {
                        this.editModeDiv.style.display = "none";
                    } else {
                        this.editModeDiv.style.display = "block";
                    }

                    this.canvas.frame.appendChild(this.editModeDiv);
                } // container for the close div button


                if (this.closeDiv === undefined) {
                    var _this$options$locales, _this$options$locales2;

                    this.closeDiv = document.createElement("button");
                    this.closeDiv.className = "vis-close";
                    this.closeDiv.setAttribute("aria-label", (_this$options$locales = (_this$options$locales2 = this.options.locales[this.options.locale]) === null || _this$options$locales2 === void 0 ? void 0 : _this$options$locales2["close"]) !== null && _this$options$locales !== void 0 ? _this$options$locales : this.options.locales["en"]["close"]);
                    this.closeDiv.style.display = this.manipulationDiv.style.display;
                    this.canvas.frame.appendChild(this.closeDiv);
                }
            }
            /**
             * generate a new target node. Used for creating new edges and editing edges
             *
             * @param {number} x
             * @param {number} y
             * @returns {Node}
             * @private
             */

        }, {
            key: "_getNewTargetNode",
            value: function _getNewTargetNode(x, y) {
                var controlNodeStyle = deepExtend({}, this.options.controlNodeStyle);
                controlNodeStyle.id = "targetNode" + v4();
                controlNodeStyle.hidden = false;
                controlNodeStyle.physics = false;
                controlNodeStyle.x = x;
                controlNodeStyle.y = y; // we have to define the bounding box in order for the nodes to be drawn immediately

                var node = this.body.functions.createNode(controlNodeStyle);
                node.shape.boundingBox = {
                    left: x,
                    right: x,
                    top: y,
                    bottom: y
                };
                return node;
            }
            /**
             * Create the edit button
             */

        }, {
            key: "_createEditButton",
            value: function _createEditButton() {
                var _context18;

                // restore everything to it's original state (if applicable)
                this._clean(); // reset the manipulationDOM


                this.manipulationDOM = {}; // empty the editModeDiv

                recursiveDOMDelete(this.editModeDiv); // create the contents for the editMode button

                var locale = this.options.locales[this.options.locale];

                var button = this._createButton("editMode", "vis-edit vis-edit-mode", locale["edit"] || this.options.locales["en"]["edit"]);

                this.editModeDiv.appendChild(button); // bind a hammer listener to the button, calling the function toggleEditMode.

                this._bindElementEvents(button, bind(_context18 = this.toggleEditMode).call(_context18, this));
            }
            /**
             * this function cleans up after everything this module does. Temporary elements, functions and events are removed, physics restored, hammers removed.
             *
             * @private
             */

        }, {
            key: "_clean",
            value: function _clean() {
                // not in mode
                this.inMode = false; // _clean the divs

                if (this.guiEnabled === true) {
                    recursiveDOMDelete(this.editModeDiv);
                    recursiveDOMDelete(this.manipulationDiv); // removes all the bindings and overloads

                    this._cleanupDOMEventListeners();
                } // remove temporary nodes and edges


                this._cleanupTemporaryNodesAndEdges(); // restore overloaded UI functions


                this._unbindTemporaryUIs(); // remove the temporaryEventFunctions


                this._unbindTemporaryEvents(); // restore the physics if required


                this.body.emitter.emit("restorePhysics");
            }
            /**
             * Each dom element has it's own hammer. They are stored in this.manipulationHammers. This cleans them up.
             *
             * @private
             */

        }, {
            key: "_cleanupDOMEventListeners",
            value: function _cleanupDOMEventListeners() {
                var _context19;

                // _clean DOM event listener bindings
                var _iterator = _createForOfIteratorHelper(splice(_context19 = this._domEventListenerCleanupQueue).call(_context19, 0)),
                    _step;

                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var callback = _step.value;
                        callback();
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
            }
            /**
             * Remove all DOM elements created by this module.
             *
             * @private
             */

        }, {
            key: "_removeManipulationDOM",
            value: function _removeManipulationDOM() {
                // removes all the bindings and overloads
                this._clean(); // empty the manipulation divs


                recursiveDOMDelete(this.manipulationDiv);
                recursiveDOMDelete(this.editModeDiv);
                recursiveDOMDelete(this.closeDiv); // remove the manipulation divs

                if (this.manipulationDiv) {
                    this.canvas.frame.removeChild(this.manipulationDiv);
                }

                if (this.editModeDiv) {
                    this.canvas.frame.removeChild(this.editModeDiv);
                }

                if (this.closeDiv) {
                    this.canvas.frame.removeChild(this.closeDiv);
                } // set the references to undefined


                this.manipulationDiv = undefined;
                this.editModeDiv = undefined;
                this.closeDiv = undefined;
            }
            /**
             * create a seperator line. the index is to differentiate in the manipulation dom
             *
             * @param {number} [index=1]
             * @private
             */

        }, {
            key: "_createSeperator",
            value: function _createSeperator() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                this.manipulationDOM["seperatorLineDiv" + index] = document.createElement("div");
                this.manipulationDOM["seperatorLineDiv" + index].className = "vis-separator-line";
                this.manipulationDiv.appendChild(this.manipulationDOM["seperatorLineDiv" + index]);
            } // ----------------------    DOM functions for buttons    --------------------------//

            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createAddNodeButton",
            value: function _createAddNodeButton(locale) {
                var _context20;

                var button = this._createButton("addNode", "vis-add", locale["addNode"] || this.options.locales["en"]["addNode"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context20 = this.addNodeMode).call(_context20, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createAddEdgeButton",
            value: function _createAddEdgeButton(locale) {
                var _context21;

                var button = this._createButton("addEdge", "vis-connect", locale["addEdge"] || this.options.locales["en"]["addEdge"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context21 = this.addEdgeMode).call(_context21, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createEditNodeButton",
            value: function _createEditNodeButton(locale) {
                var _context22;

                var button = this._createButton("editNode", "vis-edit", locale["editNode"] || this.options.locales["en"]["editNode"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context22 = this.editNode).call(_context22, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createEditEdgeButton",
            value: function _createEditEdgeButton(locale) {
                var _context23;

                var button = this._createButton("editEdge", "vis-edit", locale["editEdge"] || this.options.locales["en"]["editEdge"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context23 = this.editEdgeMode).call(_context23, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createDeleteButton",
            value: function _createDeleteButton(locale) {
                var _context24;

                var deleteBtnClass;

                if (this.options.rtl) {
                    deleteBtnClass = "vis-delete-rtl";
                } else {
                    deleteBtnClass = "vis-delete";
                }

                var button = this._createButton("delete", deleteBtnClass, locale["del"] || this.options.locales["en"]["del"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context24 = this.deleteSelected).call(_context24, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createBackButton",
            value: function _createBackButton(locale) {
                var _context25;

                var button = this._createButton("back", "vis-back", locale["back"] || this.options.locales["en"]["back"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context25 = this.showManipulatorToolbar).call(_context25, this));
            }
            /**
             *
             * @param {number|string} id
             * @param {string} className
             * @param {label} label
             * @param {string} labelClassName
             * @returns {HTMLElement}
             * @private
             */

        }, {
            key: "_createButton",
            value: function _createButton(id, className, label) {
                var labelClassName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "vis-label";
                this.manipulationDOM[id + "Div"] = document.createElement("button");
                this.manipulationDOM[id + "Div"].className = "vis-button " + className;
                this.manipulationDOM[id + "Label"] = document.createElement("div");
                this.manipulationDOM[id + "Label"].className = labelClassName;
                this.manipulationDOM[id + "Label"].innerText = label;
                this.manipulationDOM[id + "Div"].appendChild(this.manipulationDOM[id + "Label"]);
                return this.manipulationDOM[id + "Div"];
            }
            /**
             *
             * @param {Label} label
             * @private
             */

        }, {
            key: "_createDescription",
            value: function _createDescription(label) {
                this.manipulationDOM["descriptionLabel"] = document.createElement("div");
                this.manipulationDOM["descriptionLabel"].className = "vis-none";
                this.manipulationDOM["descriptionLabel"].innerText = label;
                this.manipulationDiv.appendChild(this.manipulationDOM["descriptionLabel"]);
            } // -------------------------- End of DOM functions for buttons ------------------------------//

            /**
             * this binds an event until cleanup by the clean functions.
             *
             * @param {Event}  event   The event
             * @param {Function} newFunction
             * @private
             */

        }, {
            key: "_temporaryBindEvent",
            value: function _temporaryBindEvent(event, newFunction) {
                this.temporaryEventFunctions.push({
                    event: event,
                    boundFunction: newFunction
                });
                this.body.emitter.on(event, newFunction);
            }
            /**
             * this overrides an UI function until cleanup by the clean function
             *
             * @param {string} UIfunctionName
             * @param {Function} newFunction
             * @private
             */

        }, {
            key: "_temporaryBindUI",
            value: function _temporaryBindUI(UIfunctionName, newFunction) {
                if (this.body.eventListeners[UIfunctionName] !== undefined) {
                    this.temporaryUIFunctions[UIfunctionName] = this.body.eventListeners[UIfunctionName];
                    this.body.eventListeners[UIfunctionName] = newFunction;
                } else {
                    throw new Error("This UI function does not exist. Typo? You tried: " + UIfunctionName + " possible are: " + stringify$1(keys$3(this.body.eventListeners)));
                }
            }
            /**
             * Restore the overridden UI functions to their original state.
             *
             * @private
             */

        }, {
            key: "_unbindTemporaryUIs",
            value: function _unbindTemporaryUIs() {
                for (var functionName in this.temporaryUIFunctions) {
                    if (Object.prototype.hasOwnProperty.call(this.temporaryUIFunctions, functionName)) {
                        this.body.eventListeners[functionName] = this.temporaryUIFunctions[functionName];
                        delete this.temporaryUIFunctions[functionName];
                    }
                }

                this.temporaryUIFunctions = {};
            }
            /**
             * Unbind the events created by _temporaryBindEvent
             *
             * @private
             */

        }, {
            key: "_unbindTemporaryEvents",
            value: function _unbindTemporaryEvents() {
                for (var i = 0; i < this.temporaryEventFunctions.length; i++) {
                    var eventName = this.temporaryEventFunctions[i].event;
                    var boundFunction = this.temporaryEventFunctions[i].boundFunction;
                    this.body.emitter.off(eventName, boundFunction);
                }

                this.temporaryEventFunctions = [];
            }
            /**
             * Bind an hammer instance to a DOM element.
             *
             * @param {Element} domElement
             * @param {Function} boundFunction
             */

        }, {
            key: "_bindElementEvents",
            value: function _bindElementEvents(domElement, boundFunction) {
                // Bind touch events.
                var hammer = new Hammer$1(domElement, {});
                onTouch(hammer, boundFunction);

                this._domEventListenerCleanupQueue.push(function () {
                    hammer.destroy();
                }); // Bind keyboard events.


                var keyupListener = function keyupListener(_ref) {
                    var keyCode = _ref.keyCode,
                        key = _ref.key;

                    if (key === "Enter" || key === " " || keyCode === 13 || keyCode === 32) {
                        boundFunction();
                    }
                };

                domElement.addEventListener("keyup", keyupListener, false);

                this._domEventListenerCleanupQueue.push(function () {
                    domElement.removeEventListener("keyup", keyupListener, false);
                });
            }
            /**
             * Neatly clean up temporary edges and nodes
             *
             * @private
             */

        }, {
            key: "_cleanupTemporaryNodesAndEdges",
            value: function _cleanupTemporaryNodesAndEdges() {
                // _clean temporary edges
                for (var i = 0; i < this.temporaryIds.edges.length; i++) {
                    var _context26;

                    this.body.edges[this.temporaryIds.edges[i]].disconnect();
                    delete this.body.edges[this.temporaryIds.edges[i]];

                    var indexTempEdge = indexOf(_context26 = this.body.edgeIndices).call(_context26, this.temporaryIds.edges[i]);

                    if (indexTempEdge !== -1) {
                        var _context27;

                        splice(_context27 = this.body.edgeIndices).call(_context27, indexTempEdge, 1);
                    }
                } // _clean temporary nodes


                for (var _i = 0; _i < this.temporaryIds.nodes.length; _i++) {
                    var _context28;

                    delete this.body.nodes[this.temporaryIds.nodes[_i]];

                    var indexTempNode = indexOf(_context28 = this.body.nodeIndices).call(_context28, this.temporaryIds.nodes[_i]);

                    if (indexTempNode !== -1) {
                        var _context29;

                        splice(_context29 = this.body.nodeIndices).call(_context29, indexTempNode, 1);
                    }
                }

                this.temporaryIds = {
                    nodes: [],
                    edges: []
                };
            } // ------------------------------------------ EDIT EDGE FUNCTIONS -----------------------------------------//

            /**
             * the touch is used to get the position of the initial click
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeTouch",
            value: function _controlNodeTouch(event) {
                this.selectionHandler.unselectAll();
                this.lastTouch = this.body.functions.getPointer(event.center);
                this.lastTouch.translation = assign$2({}, this.body.view.translation); // copy the object
            }
            /**
             * the drag start is used to mark one of the control nodes as selected.
             *
             * @private
             */

        }, {
            key: "_controlNodeDragStart",
            value: function _controlNodeDragStart() {
                var pointer = this.lastTouch;

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var from = this.body.nodes[this.temporaryIds.nodes[0]];
                var to = this.body.nodes[this.temporaryIds.nodes[1]];
                var edge = this.body.edges[this.edgeBeingEditedId];
                this.selectedControlNode = undefined;
                var fromSelect = from.isOverlappingWith(pointerObj);
                var toSelect = to.isOverlappingWith(pointerObj);

                if (fromSelect === true) {
                    this.selectedControlNode = from;
                    edge.edgeType.from = from;
                } else if (toSelect === true) {
                    this.selectedControlNode = to;
                    edge.edgeType.to = to;
                } // we use the selection to find the node that is being dragged. We explicitly select it here.


                if (this.selectedControlNode !== undefined) {
                    this.selectionHandler.selectObject(this.selectedControlNode);
                }

                this.body.emitter.emit("_redraw");
            }
            /**
             * dragging the control nodes or the canvas
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeDrag",
            value: function _controlNodeDrag(event) {
                this.body.emitter.emit("disablePhysics");
                var pointer = this.body.functions.getPointer(event.center);
                var pos = this.canvas.DOMtoCanvas(pointer);

                if (this.selectedControlNode !== undefined) {
                    this.selectedControlNode.x = pos.x;
                    this.selectedControlNode.y = pos.y;
                } else {
                    this.interactionHandler.onDrag(event);
                }

                this.body.emitter.emit("_redraw");
            }
            /**
             * connecting or restoring the control nodes.
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeDragEnd",
            value: function _controlNodeDragEnd(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var edge = this.body.edges[this.edgeBeingEditedId]; // if the node that was dragged is not a control node, return

                if (this.selectedControlNode === undefined) {
                    return;
                } // we use the selection to find the node that is being dragged. We explicitly DEselect the control node here.


                this.selectionHandler.unselectAll();

                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    if (overlappingNodeIds[i] !== this.selectedControlNode.id) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                } // perform the connection


                if (node !== undefined && this.selectedControlNode !== undefined) {
                    if (node.isCluster === true) {
                        alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    } else {
                        var from = this.body.nodes[this.temporaryIds.nodes[0]];

                        if (this.selectedControlNode.id === from.id) {
                            this._performEditEdge(node.id, edge.to.id);
                        } else {
                            this._performEditEdge(edge.from.id, node.id);
                        }
                    }
                } else {
                    edge.updateEdgeType();
                    this.body.emitter.emit("restorePhysics");
                }

                this.body.emitter.emit("_redraw");
            } // ------------------------------------ END OF EDIT EDGE FUNCTIONS -----------------------------------------//
            // ------------------------------------------- ADD EDGE FUNCTIONS -----------------------------------------//

            /**
             * the function bound to the selection event. It checks if you want to connect a cluster and changes the description
             * to walk the user through the process.
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_handleConnect",
            value: function _handleConnect(event) {
                // check to avoid double fireing of this function.
                if (new Date().valueOf() - this.touchTime > 100) {
                    this.lastTouch = this.body.functions.getPointer(event.center);
                    this.lastTouch.translation = assign$2({}, this.body.view.translation); // copy the object

                    this.interactionHandler.drag.pointer = this.lastTouch; // Drag pointer is not updated when adding edges

                    this.interactionHandler.drag.translation = this.lastTouch.translation;
                    var pointer = this.lastTouch;
                    var node = this.selectionHandler.getNodeAt(pointer);

                    if (node !== undefined) {
                        if (node.isCluster === true) {
                            alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                        } else {
                            // create a node the temporary line can look at
                            var targetNode = this._getNewTargetNode(node.x, node.y);

                            this.body.nodes[targetNode.id] = targetNode;
                            this.body.nodeIndices.push(targetNode.id); // create a temporary edge

                            var connectionEdge = this.body.functions.createEdge({
                                id: "connectionEdge" + v4(),
                                from: node.id,
                                to: targetNode.id,
                                physics: false,
                                smooth: {
                                    enabled: true,
                                    type: "continuous",
                                    roundness: 0.5
                                }
                            });
                            this.body.edges[connectionEdge.id] = connectionEdge;
                            this.body.edgeIndices.push(connectionEdge.id);
                            this.temporaryIds.nodes.push(targetNode.id);
                            this.temporaryIds.edges.push(connectionEdge.id);
                        }
                    }

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_dragControlNode",
            value: function _dragControlNode(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer); // remember the edge id


                var connectFromId = undefined;

                if (this.temporaryIds.edges[0] !== undefined) {
                    connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                } // get the overlapping node but NOT the temporary node;


                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    var _context30;

                    // if the node id is NOT a temporary node, accept the node.
                    if (indexOf(_context30 = this.temporaryIds.nodes).call(_context30, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                }

                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragging", event, pointer);

                if (this.temporaryIds.nodes[0] !== undefined) {
                    var targetNode = this.body.nodes[this.temporaryIds.nodes[0]]; // there is only one temp node in the add edge mode.

                    targetNode.x = this.canvas._XconvertDOMtoCanvas(pointer.x);
                    targetNode.y = this.canvas._YconvertDOMtoCanvas(pointer.y);
                    this.body.emitter.emit("_redraw");
                } else {
                    this.interactionHandler.onDrag(event);
                }
            }
            /**
             * Connect the new edge to the target if one exists, otherwise remove temp line
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_finishConnect",
            value: function _finishConnect(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer); // remember the edge id


                var connectFromId = undefined;

                if (this.temporaryIds.edges[0] !== undefined) {
                    connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                } // get the overlapping node but NOT the temporary node;


                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    var _context31;

                    // if the node id is NOT a temporary node, accept the node.
                    if (indexOf(_context31 = this.temporaryIds.nodes).call(_context31, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                } // clean temporary nodes and edges.


                this._cleanupTemporaryNodesAndEdges(); // perform the connection


                if (node !== undefined) {
                    if (node.isCluster === true) {
                        alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    } else {
                        if (this.body.nodes[connectFromId] !== undefined && this.body.nodes[node.id] !== undefined) {
                            this._performAddEdge(connectFromId, node.id);
                        }
                    }
                }

                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragEnd", event, pointer); // No need to do _generateclickevent('dragEnd') here, the regular dragEnd event fires.

                this.body.emitter.emit("_redraw");
            }
            /**
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_dragStartEdge",
            value: function _dragStartEdge(event) {
                var pointer = this.lastTouch;
                this.selectionHandler.generateClickEvent("dragStart", event, pointer, undefined, true);
            } // --------------------------------------- END OF ADD EDGE FUNCTIONS -------------------------------------//
            // ------------------------------ Performing all the actual data manipulation ------------------------//

            /**
             * Adds a node on the specified location
             *
             * @param {object} clickData
             * @private
             */

        }, {
            key: "_performAddNode",
            value: function _performAddNode(clickData) {
                var _this4 = this;

                var defaultData = {
                    id: v4(),
                    x: clickData.pointer.canvas.x,
                    y: clickData.pointer.canvas.y,
                    label: "new"
                };

                if (typeof this.options.addNode === "function") {
                    if (this.options.addNode.length === 2) {
                        this.options.addNode(defaultData, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this4.inMode === "addNode") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                                _this4.body.data.nodes.getDataSet().add(finalizedData);
                            }

                            _this4.showManipulatorToolbar();
                        });
                    } else {
                        this.showManipulatorToolbar();
                        throw new Error("The function for add does not support two arguments (data,callback)");
                    }
                } else {
                    this.body.data.nodes.getDataSet().add(defaultData);
                    this.showManipulatorToolbar();
                }
            }
            /**
             * connect two nodes with a new edge.
             *
             * @param {Node.id} sourceNodeId
             * @param {Node.id} targetNodeId
             * @private
             */

        }, {
            key: "_performAddEdge",
            value: function _performAddEdge(sourceNodeId, targetNodeId) {
                var _this5 = this;

                var defaultData = {
                    from: sourceNodeId,
                    to: targetNodeId
                };

                if (typeof this.options.addEdge === "function") {
                    if (this.options.addEdge.length === 2) {
                        this.options.addEdge(defaultData, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this5.inMode === "addEdge") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                                _this5.body.data.edges.getDataSet().add(finalizedData);

                                _this5.selectionHandler.unselectAll();

                                _this5.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for connect does not support two arguments (data,callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().add(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
            /**
             * connect two nodes with a new edge.
             *
             * @param {Node.id} sourceNodeId
             * @param {Node.id} targetNodeId
             * @private
             */

        }, {
            key: "_performEditEdge",
            value: function _performEditEdge(sourceNodeId, targetNodeId) {
                var _this6 = this;

                var defaultData = {
                    id: this.edgeBeingEditedId,
                    from: sourceNodeId,
                    to: targetNodeId,
                    label: this.body.data.edges.get(this.edgeBeingEditedId).label
                };
                var eeFunct = this.options.editEdge;

                if (_typeof(eeFunct) === "object") {
                    eeFunct = eeFunct.editWithoutDrag;
                }

                if (typeof eeFunct === "function") {
                    if (eeFunct.length === 2) {
                        eeFunct(defaultData, function (finalizedData) {
                            if (finalizedData === null || finalizedData === undefined || _this6.inMode !== "editEdge") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                _this6.body.edges[defaultData.id].updateEdgeType();

                                _this6.body.emitter.emit("_redraw");

                                _this6.showManipulatorToolbar();
                            } else {
                                _this6.body.data.edges.getDataSet().update(finalizedData);

                                _this6.selectionHandler.unselectAll();

                                _this6.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for edit does not support two arguments (data, callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().update(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
        }]);

        return ManipulationSystem;
    }();

    /**
     * This object contains all possible options. It will check if the types are correct, if required if the option is one
     * of the allowed values.
     *
     * __any__ means that the name of the property does not matter.
     * __type__ is a required field for all objects and contains the allowed types of all objects
     */
    var string = "string";
    var bool = "boolean";
    var number = "number";
    var array = "array";
    var object = "object"; // should only be in a __type__ property

    var dom = "dom";
    var any = "any"; // List of endpoints

    var endPoints = ["arrow", "bar", "box", "circle", "crow", "curve", "diamond", "image", "inv_curve", "inv_triangle", "triangle", "vee"];
    /* eslint-disable @typescript-eslint/naming-convention -- The __*__ format is used to prevent collisions with actual option names. */

    var nodeOptions = {
        borderWidth: {
            number: number
        },
        borderWidthSelected: {
            number: number,
            undefined: "undefined"
        },
        brokenImage: {
            string: string,
            undefined: "undefined"
        },
        chosen: {
            label: {
                boolean: bool,
                function: "function"
            },
            node: {
                boolean: bool,
                function: "function"
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        color: {
            border: {
                string: string
            },
            background: {
                string: string
            },
            highlight: {
                border: {
                    string: string
                },
                background: {
                    string: string
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            hover: {
                border: {
                    string: string
                },
                background: {
                    string: string
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            __type__: {
                object: object,
                string: string
            }
        },
        opacity: {
            number: number,
            undefined: "undefined"
        },
        fixed: {
            x: {
                boolean: bool
            },
            y: {
                boolean: bool
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        font: {
            align: {
                string: string
            },
            color: {
                string: string
            },
            size: {
                number: number
            },
            face: {
                string: string
            },
            background: {
                string: string
            },
            strokeWidth: {
                number: number
            },
            strokeColor: {
                string: string
            },
            vadjust: {
                number: number
            },
            multi: {
                boolean: bool,
                string: string
            },
            bold: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            boldital: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            ital: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            mono: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            __type__: {
                object: object,
                string: string
            }
        },
        group: {
            string: string,
            number: number,
            undefined: "undefined"
        },
        heightConstraint: {
            minimum: {
                number: number
            },
            valign: {
                string: string
            },
            __type__: {
                object: object,
                boolean: bool,
                number: number
            }
        },
        hidden: {
            boolean: bool
        },
        icon: {
            face: {
                string: string
            },
            code: {
                string: string
            },
            size: {
                number: number
            },
            color: {
                string: string
            },
            weight: {
                string: string,
                number: number
            },
            __type__: {
                object: object
            }
        },
        id: {
            string: string,
            number: number
        },
        image: {
            selected: {
                string: string,
                undefined: "undefined"
            },
            unselected: {
                string: string,
                undefined: "undefined"
            },
            __type__: {
                object: object,
                string: string
            }
        },
        imagePadding: {
            top: {
                number: number
            },
            right: {
                number: number
            },
            bottom: {
                number: number
            },
            left: {
                number: number
            },
            __type__: {
                object: object,
                number: number
            }
        },
        label: {
            string: string,
            undefined: "undefined"
        },
        labelHighlightBold: {
            boolean: bool
        },
        level: {
            number: number,
            undefined: "undefined"
        },
        margin: {
            top: {
                number: number
            },
            right: {
                number: number
            },
            bottom: {
                number: number
            },
            left: {
                number: number
            },
            __type__: {
                object: object,
                number: number
            }
        },
        mass: {
            number: number
        },
        physics: {
            boolean: bool
        },
        scaling: {
            min: {
                number: number
            },
            max: {
                number: number
            },
            label: {
                enabled: {
                    boolean: bool
                },
                min: {
                    number: number
                },
                max: {
                    number: number
                },
                maxVisible: {
                    number: number
                },
                drawThreshold: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            customScalingFunction: {
                function: "function"
            },
            __type__: {
                object: object
            }
        },
        shadow: {
            enabled: {
                boolean: bool
            },
            color: {
                string: string
            },
            size: {
                number: number
            },
            x: {
                number: number
            },
            y: {
                number: number
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        shape: {
            string: ["custom", "ellipse", "circle", "database", "box", "text", "image", "circularImage", "diamond", "dot", "star", "triangle", "triangleDown", "square", "icon", "hexagon"]
        },
        ctxRenderer: {
            function: "function"
        },
        shapeProperties: {
            borderDashes: {
                boolean: bool,
                array: array
            },
            borderRadius: {
                number: number
            },
            interpolation: {
                boolean: bool
            },
            useImageSize: {
                boolean: bool
            },
            useBorderWithImage: {
                boolean: bool
            },
            coordinateOrigin: {
                string: ["center", "top-left"]
            },
            __type__: {
                object: object
            }
        },
        size: {
            number: number
        },
        title: {
            string: string,
            dom: dom,
            undefined: "undefined"
        },
        value: {
            number: number,
            undefined: "undefined"
        },
        widthConstraint: {
            minimum: {
                number: number
            },
            maximum: {
                number: number
            },
            __type__: {
                object: object,
                boolean: bool,
                number: number
            }
        },
        x: {
            number: number
        },
        y: {
            number: number
        },
        __type__: {
            object: object
        }
    };
    var allOptions = {
        configure: {
            enabled: {
                boolean: bool
            },
            filter: {
                boolean: bool,
                string: string,
                array: array,
                function: "function"
            },
            container: {
                dom: dom
            },
            showButton: {
                boolean: bool
            },
            __type__: {
                object: object,
                boolean: bool,
                string: string,
                array: array,
                function: "function"
            }
        },
        edges: {
            arrows: {
                to: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageHeight: {
                        number: number
                    },
                    imageWidth: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                middle: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageWidth: {
                        number: number
                    },
                    imageHeight: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                from: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageWidth: {
                        number: number
                    },
                    imageHeight: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                __type__: {
                    string: ["from", "to", "middle"],
                    object: object
                }
            },
            endPointOffset: {
                from: {
                    number: number
                },
                to: {
                    number: number
                },
                __type__: {
                    object: object,
                    number: number
                }
            },
            arrowStrikethrough: {
                boolean: bool
            },
            background: {
                enabled: {
                    boolean: bool
                },
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                dashes: {
                    boolean: bool,
                    array: array
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            chosen: {
                label: {
                    boolean: bool,
                    function: "function"
                },
                edge: {
                    boolean: bool,
                    function: "function"
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            color: {
                color: {
                    string: string
                },
                highlight: {
                    string: string
                },
                hover: {
                    string: string
                },
                inherit: {
                    string: ["from", "to", "both"],
                    boolean: bool
                },
                opacity: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            dashes: {
                boolean: bool,
                array: array
            },
            font: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                background: {
                    string: string
                },
                strokeWidth: {
                    number: number
                },
                strokeColor: {
                    string: string
                },
                align: {
                    string: ["horizontal", "top", "middle", "bottom"]
                },
                vadjust: {
                    number: number
                },
                multi: {
                    boolean: bool,
                    string: string
                },
                bold: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                boldital: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                ital: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                mono: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            hidden: {
                boolean: bool
            },
            hoverWidth: {
                function: "function",
                number: number
            },
            label: {
                string: string,
                undefined: "undefined"
            },
            labelHighlightBold: {
                boolean: bool
            },
            length: {
                number: number,
                undefined: "undefined"
            },
            physics: {
                boolean: bool
            },
            scaling: {
                min: {
                    number: number
                },
                max: {
                    number: number
                },
                label: {
                    enabled: {
                        boolean: bool
                    },
                    min: {
                        number: number
                    },
                    max: {
                        number: number
                    },
                    maxVisible: {
                        number: number
                    },
                    drawThreshold: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                customScalingFunction: {
                    function: "function"
                },
                __type__: {
                    object: object
                }
            },
            selectionWidth: {
                function: "function",
                number: number
            },
            selfReferenceSize: {
                number: number
            },
            selfReference: {
                size: {
                    number: number
                },
                angle: {
                    number: number
                },
                renderBehindTheNode: {
                    boolean: bool
                },
                __type__: {
                    object: object
                }
            },
            shadow: {
                enabled: {
                    boolean: bool
                },
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                x: {
                    number: number
                },
                y: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            smooth: {
                enabled: {
                    boolean: bool
                },
                type: {
                    string: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"]
                },
                roundness: {
                    number: number
                },
                forceDirection: {
                    string: ["horizontal", "vertical", "none"],
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            title: {
                string: string,
                undefined: "undefined"
            },
            width: {
                number: number
            },
            widthConstraint: {
                maximum: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool,
                    number: number
                }
            },
            value: {
                number: number,
                undefined: "undefined"
            },
            __type__: {
                object: object
            }
        },
        groups: {
            useDefaultGroups: {
                boolean: bool
            },
            __any__: nodeOptions,
            __type__: {
                object: object
            }
        },
        interaction: {
            dragNodes: {
                boolean: bool
            },
            dragView: {
                boolean: bool
            },
            hideEdgesOnDrag: {
                boolean: bool
            },
            hideEdgesOnZoom: {
                boolean: bool
            },
            hideNodesOnDrag: {
                boolean: bool
            },
            hover: {
                boolean: bool
            },
            keyboard: {
                enabled: {
                    boolean: bool
                },
                speed: {
                    x: {
                        number: number
                    },
                    y: {
                        number: number
                    },
                    zoom: {
                        number: number
                    },
                    __type__: {
                        object: object
                    }
                },
                bindToWindow: {
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            multiselect: {
                boolean: bool
            },
            navigationButtons: {
                boolean: bool
            },
            selectable: {
                boolean: bool
            },
            selectConnectedEdges: {
                boolean: bool
            },
            hoverConnectedEdges: {
                boolean: bool
            },
            tooltipDelay: {
                number: number
            },
            zoomView: {
                boolean: bool
            },
            zoomSpeed: {
                number: number
            },
            __type__: {
                object: object
            }
        },
        layout: {
            randomSeed: {
                undefined: "undefined",
                number: number,
                string: string
            },
            improvedLayout: {
                boolean: bool
            },
            clusterThreshold: {
                number: number
            },
            hierarchical: {
                enabled: {
                    boolean: bool
                },
                levelSeparation: {
                    number: number
                },
                nodeSpacing: {
                    number: number
                },
                treeSpacing: {
                    number: number
                },
                blockShifting: {
                    boolean: bool
                },
                edgeMinimization: {
                    boolean: bool
                },
                parentCentralization: {
                    boolean: bool
                },
                direction: {
                    string: ["UD", "DU", "LR", "RL"]
                },
                sortMethod: {
                    string: ["hubsize", "directed"]
                },
                shakeTowards: {
                    string: ["leaves", "roots"]
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            __type__: {
                object: object
            }
        },
        manipulation: {
            enabled: {
                boolean: bool
            },
            initiallyActive: {
                boolean: bool
            },
            addNode: {
                boolean: bool,
                function: "function"
            },
            addEdge: {
                boolean: bool,
                function: "function"
            },
            editNode: {
                function: "function"
            },
            editEdge: {
                editWithoutDrag: {
                    function: "function"
                },
                __type__: {
                    object: object,
                    boolean: bool,
                    function: "function"
                }
            },
            deleteNode: {
                boolean: bool,
                function: "function"
            },
            deleteEdge: {
                boolean: bool,
                function: "function"
            },
            controlNodeStyle: nodeOptions,
            __type__: {
                object: object,
                boolean: bool
            }
        },
        nodes: nodeOptions,
        physics: {
            enabled: {
                boolean: bool
            },
            barnesHut: {
                theta: {
                    number: number
                },
                gravitationalConstant: {
                    number: number
                },
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            forceAtlas2Based: {
                theta: {
                    number: number
                },
                gravitationalConstant: {
                    number: number
                },
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            repulsion: {
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                nodeDistance: {
                    number: number
                },
                damping: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            hierarchicalRepulsion: {
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                nodeDistance: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            maxVelocity: {
                number: number
            },
            minVelocity: {
                number: number
            },
            solver: {
                string: ["barnesHut", "repulsion", "hierarchicalRepulsion", "forceAtlas2Based"]
            },
            stabilization: {
                enabled: {
                    boolean: bool
                },
                iterations: {
                    number: number
                },
                updateInterval: {
                    number: number
                },
                onlyDynamicEdges: {
                    boolean: bool
                },
                fit: {
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            timestep: {
                number: number
            },
            adaptiveTimestep: {
                boolean: bool
            },
            wind: {
                x: {
                    number: number
                },
                y: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        //globals :
        autoResize: {
            boolean: bool
        },
        clickToUse: {
            boolean: bool
        },
        locale: {
            string: string
        },
        locales: {
            __any__: {
                any: any
            },
            __type__: {
                object: object
            }
        },
        height: {
            string: string
        },
        width: {
            string: string
        },
        __type__: {
            object: object
        }
    };
    /* eslint-enable @typescript-eslint/naming-convention */

    /**
     * This provides ranges, initial values, steps and dropdown menu choices for the
     * configuration.
     *
     * @remarks
     * Checkbox: `boolean`
     *   The value supllied will be used as the initial value.
     *
     * Text field: `string`
     *   The passed text will be used as the initial value. Any text will be
     *   accepted afterwards.
     *
     * Number range: `[number, number, number, number]`
     *   The meanings are `[initial value, min, max, step]`.
     *
     * Dropdown: `[Exclude<string, "color">, ...(string | number | boolean)[]]`
     *   Translations for people with poor understanding of TypeScript: the first
     *   value always has to be a string but never `"color"`, the rest can be any
     *   combination of strings, numbers and booleans.
     *
     * Color picker: `["color", string]`
     *   The first value says this will be a color picker not a dropdown menu. The
     *   next value is the initial color.
     */

    var configureOptions = {
        nodes: {
            borderWidth: [1, 0, 10, 1],
            borderWidthSelected: [2, 0, 10, 1],
            color: {
                border: ["color", "#2B7CE9"],
                background: ["color", "#97C2FC"],
                highlight: {
                    border: ["color", "#2B7CE9"],
                    background: ["color", "#D2E5FF"]
                },
                hover: {
                    border: ["color", "#2B7CE9"],
                    background: ["color", "#D2E5FF"]
                }
            },
            opacity: [0, 0, 1, 0.1],
            fixed: {
                x: false,
                y: false
            },
            font: {
                color: ["color", "#343434"],
                size: [14, 0, 100, 1],
                face: ["arial", "verdana", "tahoma"],
                background: ["color", "none"],
                strokeWidth: [0, 0, 50, 1],
                strokeColor: ["color", "#ffffff"]
            },
            //group: 'string',
            hidden: false,
            labelHighlightBold: true,
            //icon: {
            //  face: 'string',  //'FontAwesome',
            //  code: 'string',  //'\uf007',
            //  size: [50, 0, 200, 1],  //50,
            //  color: ['color','#2B7CE9']   //'#aa00ff'
            //},
            //image: 'string', // --> URL
            physics: true,
            scaling: {
                min: [10, 0, 200, 1],
                max: [30, 0, 200, 1],
                label: {
                    enabled: false,
                    min: [14, 0, 200, 1],
                    max: [30, 0, 200, 1],
                    maxVisible: [30, 0, 200, 1],
                    drawThreshold: [5, 0, 20, 1]
                }
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: [10, 0, 20, 1],
                x: [5, -30, 30, 1],
                y: [5, -30, 30, 1]
            },
            shape: ["ellipse", "box", "circle", "database", "diamond", "dot", "square", "star", "text", "triangle", "triangleDown", "hexagon"],
            shapeProperties: {
                borderDashes: false,
                borderRadius: [6, 0, 20, 1],
                interpolation: true,
                useImageSize: false
            },
            size: [25, 0, 200, 1]
        },
        edges: {
            arrows: {
                to: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                },
                middle: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                },
                from: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                }
            },
            endPointOffset: {
                from: [0, -10, 10, 1],
                to: [0, -10, 10, 1]
            },
            arrowStrikethrough: true,
            color: {
                color: ["color", "#848484"],
                highlight: ["color", "#848484"],
                hover: ["color", "#848484"],
                inherit: ["from", "to", "both", true, false],
                opacity: [1, 0, 1, 0.05]
            },
            dashes: false,
            font: {
                color: ["color", "#343434"],
                size: [14, 0, 100, 1],
                face: ["arial", "verdana", "tahoma"],
                background: ["color", "none"],
                strokeWidth: [2, 0, 50, 1],
                strokeColor: ["color", "#ffffff"],
                align: ["horizontal", "top", "middle", "bottom"]
            },
            hidden: false,
            hoverWidth: [1.5, 0, 5, 0.1],
            labelHighlightBold: true,
            physics: true,
            scaling: {
                min: [1, 0, 100, 1],
                max: [15, 0, 100, 1],
                label: {
                    enabled: true,
                    min: [14, 0, 200, 1],
                    max: [30, 0, 200, 1],
                    maxVisible: [30, 0, 200, 1],
                    drawThreshold: [5, 0, 20, 1]
                }
            },
            selectionWidth: [1.5, 0, 5, 0.1],
            selfReferenceSize: [20, 0, 200, 1],
            selfReference: {
                size: [20, 0, 200, 1],
                angle: [Math.PI / 2, -6 * Math.PI, 6 * Math.PI, Math.PI / 8],
                renderBehindTheNode: true
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: [10, 0, 20, 1],
                x: [5, -30, 30, 1],
                y: [5, -30, 30, 1]
            },
            smooth: {
                enabled: true,
                type: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"],
                forceDirection: ["horizontal", "vertical", "none"],
                roundness: [0.5, 0, 1, 0.05]
            },
            width: [1, 0, 30, 1]
        },
        layout: {
            //randomSeed: [0, 0, 500, 1],
            //improvedLayout: true,
            hierarchical: {
                enabled: false,
                levelSeparation: [150, 20, 500, 5],
                nodeSpacing: [100, 20, 500, 5],
                treeSpacing: [200, 20, 500, 5],
                blockShifting: true,
                edgeMinimization: true,
                parentCentralization: true,
                direction: ["UD", "DU", "LR", "RL"],
                sortMethod: ["hubsize", "directed"],
                shakeTowards: ["leaves", "roots"] // leaves, roots

            }
        },
        interaction: {
            dragNodes: true,
            dragView: true,
            hideEdgesOnDrag: false,
            hideEdgesOnZoom: false,
            hideNodesOnDrag: false,
            hover: false,
            keyboard: {
                enabled: false,
                speed: {
                    x: [10, 0, 40, 1],
                    y: [10, 0, 40, 1],
                    zoom: [0.02, 0, 0.1, 0.005]
                },
                bindToWindow: true
            },
            multiselect: false,
            navigationButtons: false,
            selectable: true,
            selectConnectedEdges: true,
            hoverConnectedEdges: true,
            tooltipDelay: [300, 0, 1000, 25],
            zoomView: true,
            zoomSpeed: [1, 0.1, 2, 0.1]
        },
        manipulation: {
            enabled: false,
            initiallyActive: false
        },
        physics: {
            enabled: true,
            barnesHut: {
                theta: [0.5, 0.1, 1, 0.05],
                gravitationalConstant: [-2000, -30000, 0, 50],
                centralGravity: [0.3, 0, 10, 0.05],
                springLength: [95, 0, 500, 5],
                springConstant: [0.04, 0, 1.2, 0.005],
                damping: [0.09, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            forceAtlas2Based: {
                theta: [0.5, 0.1, 1, 0.05],
                gravitationalConstant: [-50, -500, 0, 1],
                centralGravity: [0.01, 0, 1, 0.005],
                springLength: [95, 0, 500, 5],
                springConstant: [0.08, 0, 1.2, 0.005],
                damping: [0.4, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            repulsion: {
                centralGravity: [0.2, 0, 10, 0.05],
                springLength: [200, 0, 500, 5],
                springConstant: [0.05, 0, 1.2, 0.005],
                nodeDistance: [100, 0, 500, 5],
                damping: [0.09, 0, 1, 0.01]
            },
            hierarchicalRepulsion: {
                centralGravity: [0.2, 0, 10, 0.05],
                springLength: [100, 0, 500, 5],
                springConstant: [0.01, 0, 1.2, 0.005],
                nodeDistance: [120, 0, 500, 5],
                damping: [0.09, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            maxVelocity: [50, 0, 150, 1],
            minVelocity: [0.1, 0.01, 0.5, 0.01],
            solver: ["barnesHut", "forceAtlas2Based", "repulsion", "hierarchicalRepulsion"],
            timestep: [0.5, 0.01, 1, 0.01],
            wind: {
                x: [0, -10, 10, 0.1],
                y: [0, -10, 10, 0.1]
            } //adaptiveTimestep: true

        }
    };
    var configuratorHideOption = function configuratorHideOption(parentPath, optionName, options) {
        var _context;

        if (includes(parentPath).call(parentPath, "physics") && includes(_context = configureOptions.physics.solver).call(_context, optionName) && options.physics.solver !== optionName && optionName !== "wind") {
            return true;
        }

        return false;
    };

    var options = /*#__PURE__*/Object.freeze({
        __proto__: null,
        configuratorHideOption: configuratorHideOption,
        allOptions: allOptions,
        configureOptions: configureOptions
    });

    /**
     *  The Floyd–Warshall algorithm is an algorithm for finding shortest paths in
     *  a weighted graph with positive or negative edge weights (but with no negative
     *  cycles). - https://en.wikipedia.org/wiki/Floyd–Warshall_algorithm
     */
    var FloydWarshall = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function FloydWarshall() {
            _classCallCheck(this, FloydWarshall);
        }
        /**
         *
         * @param {object} body
         * @param {Array.<Node>} nodesArray
         * @param {Array.<Edge>} edgesArray
         * @returns {{}}
         */


        _createClass(FloydWarshall, [{
            key: "getDistances",
            value: function getDistances(body, nodesArray, edgesArray) {
                var D_matrix = {};
                var edges = body.edges; // prepare matrix with large numbers

                for (var i = 0; i < nodesArray.length; i++) {
                    var node = nodesArray[i];
                    var cell = {};
                    D_matrix[node] = cell;

                    for (var j = 0; j < nodesArray.length; j++) {
                        cell[nodesArray[j]] = i == j ? 0 : 1e9;
                    }
                } // put the weights for the edges in. This assumes unidirectionality.


                for (var _i = 0; _i < edgesArray.length; _i++) {
                    var edge = edges[edgesArray[_i]]; // edge has to be connected if it counts to the distances. If it is connected to inner clusters it will crash so we also check if it is in the D_matrix

                    if (edge.connected === true && D_matrix[edge.fromId] !== undefined && D_matrix[edge.toId] !== undefined) {
                        D_matrix[edge.fromId][edge.toId] = 1;
                        D_matrix[edge.toId][edge.fromId] = 1;
                    }
                }

                var nodeCount = nodesArray.length; // Adapted FloydWarshall based on unidirectionality to greatly reduce complexity.

                for (var k = 0; k < nodeCount; k++) {
                    var knode = nodesArray[k];
                    var kcolm = D_matrix[knode];

                    for (var _i2 = 0; _i2 < nodeCount - 1; _i2++) {
                        var inode = nodesArray[_i2];
                        var icolm = D_matrix[inode];

                        for (var _j = _i2 + 1; _j < nodeCount; _j++) {
                            var jnode = nodesArray[_j];
                            var jcolm = D_matrix[jnode];
                            var val = Math.min(icolm[jnode], icolm[knode] + kcolm[jnode]);
                            icolm[jnode] = val;
                            jcolm[inode] = val;
                        }
                    }
                }

                return D_matrix;
            }
        }]);

        return FloydWarshall;
    }();

    /**
     * KamadaKawai positions the nodes initially based on
     *
     * "AN ALGORITHM FOR DRAWING GENERAL UNDIRECTED GRAPHS"
     * -- Tomihisa KAMADA and Satoru KAWAI in 1989
     *
     * Possible optimizations in the distance calculation can be implemented.
     */

    var KamadaKawai = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {number} edgeLength
         * @param {number} edgeStrength
         */
        function KamadaKawai(body, edgeLength, edgeStrength) {
            _classCallCheck(this, KamadaKawai);

            this.body = body;
            this.springLength = edgeLength;
            this.springConstant = edgeStrength;
            this.distanceSolver = new FloydWarshall();
        }
        /**
         * Not sure if needed but can be used to update the spring length and spring constant
         *
         * @param {object} options
         */


        _createClass(KamadaKawai, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    if (options.springLength) {
                        this.springLength = options.springLength;
                    }

                    if (options.springConstant) {
                        this.springConstant = options.springConstant;
                    }
                }
            }
            /**
             * Position the system
             *
             * @param {Array.<Node>} nodesArray
             * @param {Array.<vis.Edge>} edgesArray
             * @param {boolean} [ignoreClusters=false]
             */

        }, {
            key: "solve",
            value: function solve(nodesArray, edgesArray) {
                var ignoreClusters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // get distance matrix
                var D_matrix = this.distanceSolver.getDistances(this.body, nodesArray, edgesArray); // distance matrix
                // get the L Matrix

                this._createL_matrix(D_matrix); // get the K Matrix


                this._createK_matrix(D_matrix); // initial E Matrix


                this._createE_matrix(); // calculate positions


                var threshold = 0.01;
                var innerThreshold = 1;
                var iterations = 0;
                var maxIterations = Math.max(1000, Math.min(10 * this.body.nodeIndices.length, 6000));
                var maxInnerIterations = 5;
                var maxEnergy = 1e9;
                var highE_nodeId = 0,
                    dE_dx = 0,
                    dE_dy = 0,
                    delta_m = 0,
                    subIterations = 0;

                while (maxEnergy > threshold && iterations < maxIterations) {
                    iterations += 1;

                    var _this$_getHighestEner = this._getHighestEnergyNode(ignoreClusters);

                    var _this$_getHighestEner2 = _slicedToArray(_this$_getHighestEner, 4);

                    highE_nodeId = _this$_getHighestEner2[0];
                    maxEnergy = _this$_getHighestEner2[1];
                    dE_dx = _this$_getHighestEner2[2];
                    dE_dy = _this$_getHighestEner2[3];
                    delta_m = maxEnergy;
                    subIterations = 0;

                    while (delta_m > innerThreshold && subIterations < maxInnerIterations) {
                        subIterations += 1;

                        this._moveNode(highE_nodeId, dE_dx, dE_dy);

                        var _this$_getEnergy = this._getEnergy(highE_nodeId);

                        var _this$_getEnergy2 = _slicedToArray(_this$_getEnergy, 3);

                        delta_m = _this$_getEnergy2[0];
                        dE_dx = _this$_getEnergy2[1];
                        dE_dy = _this$_getEnergy2[2];
                    }
                }
            }
            /**
             * get the node with the highest energy
             *
             * @param {boolean} ignoreClusters
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getHighestEnergyNode",
            value: function _getHighestEnergyNode(ignoreClusters) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var maxEnergy = 0;
                var maxEnergyNodeId = nodesArray[0];
                var dE_dx_max = 0,
                    dE_dy_max = 0;

                for (var nodeIdx = 0; nodeIdx < nodesArray.length; nodeIdx++) {
                    var m = nodesArray[nodeIdx]; // by not evaluating nodes with predefined positions we should only move nodes that have no positions.

                    if (nodes[m].predefinedPosition !== true || nodes[m].isCluster === true && ignoreClusters === true || nodes[m].options.fixed.x !== true || nodes[m].options.fixed.y !== true) {
                        var _this$_getEnergy3 = this._getEnergy(m),
                            _this$_getEnergy4 = _slicedToArray(_this$_getEnergy3, 3),
                            delta_m = _this$_getEnergy4[0],
                            dE_dx = _this$_getEnergy4[1],
                            dE_dy = _this$_getEnergy4[2];

                        if (maxEnergy < delta_m) {
                            maxEnergy = delta_m;
                            maxEnergyNodeId = m;
                            dE_dx_max = dE_dx;
                            dE_dy_max = dE_dy;
                        }
                    }
                }

                return [maxEnergyNodeId, maxEnergy, dE_dx_max, dE_dy_max];
            }
            /**
             * calculate the energy of a single node
             *
             * @param {Node.id} m
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getEnergy",
            value: function _getEnergy(m) {
                var _this$E_sums$m = _slicedToArray(this.E_sums[m], 2),
                    dE_dx = _this$E_sums$m[0],
                    dE_dy = _this$E_sums$m[1];

                var delta_m = Math.sqrt(Math.pow(dE_dx, 2) + Math.pow(dE_dy, 2));
                return [delta_m, dE_dx, dE_dy];
            }
            /**
             * move the node based on it's energy
             * the dx and dy are calculated from the linear system proposed by Kamada and Kawai
             *
             * @param {number} m
             * @param {number} dE_dx
             * @param {number} dE_dy
             * @private
             */

        }, {
            key: "_moveNode",
            value: function _moveNode(m, dE_dx, dE_dy) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var d2E_dx2 = 0;
                var d2E_dxdy = 0;
                var d2E_dy2 = 0;
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var km = this.K_matrix[m];
                var lm = this.L_matrix[m];

                for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
                    var i = nodesArray[iIdx];

                    if (i !== m) {
                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var kmat = km[i];
                        var lmat = lm[i];
                        var denominator = 1.0 / Math.pow(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2), 1.5);
                        d2E_dx2 += kmat * (1 - lmat * Math.pow(y_m - y_i, 2) * denominator);
                        d2E_dxdy += kmat * (lmat * (x_m - x_i) * (y_m - y_i) * denominator);
                        d2E_dy2 += kmat * (1 - lmat * Math.pow(x_m - x_i, 2) * denominator);
                    }
                } // make the variable names easier to make the solving of the linear system easier to read


                var A = d2E_dx2,
                    B = d2E_dxdy,
                    C = dE_dx,
                    D = d2E_dy2,
                    E = dE_dy; // solve the linear system for dx and dy

                var dy = (C / A + E / B) / (B / A - D / B);
                var dx = -(B * dy + C) / A; // move the node

                nodes[m].x += dx;
                nodes[m].y += dy; // Recalculate E_matrix (should be incremental)

                this._updateE_matrix(m);
            }
            /**
             * Create the L matrix: edge length times shortest path
             *
             * @param {object} D_matrix
             * @private
             */

        }, {
            key: "_createL_matrix",
            value: function _createL_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeLength = this.springLength;
                this.L_matrix = [];

                for (var i = 0; i < nodesArray.length; i++) {
                    this.L_matrix[nodesArray[i]] = {};

                    for (var j = 0; j < nodesArray.length; j++) {
                        this.L_matrix[nodesArray[i]][nodesArray[j]] = edgeLength * D_matrix[nodesArray[i]][nodesArray[j]];
                    }
                }
            }
            /**
             * Create the K matrix: spring constants times shortest path
             *
             * @param {object} D_matrix
             * @private
             */

        }, {
            key: "_createK_matrix",
            value: function _createK_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeStrength = this.springConstant;
                this.K_matrix = [];

                for (var i = 0; i < nodesArray.length; i++) {
                    this.K_matrix[nodesArray[i]] = {};

                    for (var j = 0; j < nodesArray.length; j++) {
                        this.K_matrix[nodesArray[i]][nodesArray[j]] = edgeStrength * Math.pow(D_matrix[nodesArray[i]][nodesArray[j]], -2);
                    }
                }
            }
            /**
             *  Create matrix with all energies between nodes
             *
             *  @private
             */

        }, {
            key: "_createE_matrix",
            value: function _createE_matrix() {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                this.E_matrix = {};
                this.E_sums = {};

                for (var mIdx = 0; mIdx < nodesArray.length; mIdx++) {
                    this.E_matrix[nodesArray[mIdx]] = [];
                }

                for (var _mIdx = 0; _mIdx < nodesArray.length; _mIdx++) {
                    var m = nodesArray[_mIdx];
                    var x_m = nodes[m].x;
                    var y_m = nodes[m].y;
                    var dE_dx = 0;
                    var dE_dy = 0;

                    for (var iIdx = _mIdx; iIdx < nodesArray.length; iIdx++) {
                        var i = nodesArray[iIdx];

                        if (i !== m) {
                            var x_i = nodes[i].x;
                            var y_i = nodes[i].y;
                            var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                            this.E_matrix[m][iIdx] = [this.K_matrix[m][i] * (x_m - x_i - this.L_matrix[m][i] * (x_m - x_i) * denominator), this.K_matrix[m][i] * (y_m - y_i - this.L_matrix[m][i] * (y_m - y_i) * denominator)];
                            this.E_matrix[i][_mIdx] = this.E_matrix[m][iIdx];
                            dE_dx += this.E_matrix[m][iIdx][0];
                            dE_dy += this.E_matrix[m][iIdx][1];
                        }
                    } //Store sum


                    this.E_sums[m] = [dE_dx, dE_dy];
                }
            }
            /**
             * Update method, just doing single column (rows are auto-updated) (update all sums)
             *
             * @param {number} m
             * @private
             */

        }, {
            key: "_updateE_matrix",
            value: function _updateE_matrix(m) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var colm = this.E_matrix[m];
                var kcolm = this.K_matrix[m];
                var lcolm = this.L_matrix[m];
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var dE_dx = 0;
                var dE_dy = 0;

                for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
                    var i = nodesArray[iIdx];

                    if (i !== m) {
                        //Keep old energy value for sum modification below
                        var cell = colm[iIdx];
                        var oldDx = cell[0];
                        var oldDy = cell[1]; //Calc new energy:

                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                        var dx = kcolm[i] * (x_m - x_i - lcolm[i] * (x_m - x_i) * denominator);
                        var dy = kcolm[i] * (y_m - y_i - lcolm[i] * (y_m - y_i) * denominator);
                        colm[iIdx] = [dx, dy];
                        dE_dx += dx;
                        dE_dy += dy; //add new energy to sum of each column

                        var sum = this.E_sums[i];
                        sum[0] += dx - oldDx;
                        sum[1] += dy - oldDy;
                    }
                } //Store sum at -1 index


                this.E_sums[m] = [dE_dx, dE_dy];
            }
        }]);

        return KamadaKawai;
    }();

    /**
     * Create a network visualization, displaying nodes and edges.
     *
     * @param {Element} container   The DOM element in which the Network will
     *                                  be created. Normally a div element.
     * @param {object} data         An object containing parameters
     *                              {Array} nodes
     *                              {Array} edges
     * @param {object} options      Options
     * @class Network
     */

    function Network(container, data, options) {
        var _context,
            _context2,
            _context3,
            _context4,
            _this = this;

        if (!(this instanceof Network)) {
            throw new SyntaxError("Constructor must be called with the new operator");
        } // set constant values


        this.options = {};
        this.defaultOptions = {
            locale: "en",
            locales: locales,
            clickToUse: false
        };

        assign$2(this.options, this.defaultOptions);
        /**
         * Containers for nodes and edges.
         *
         * 'edges' and 'nodes' contain the full definitions of all the network elements.
         * 'nodeIndices' and 'edgeIndices' contain the id's of the active elements.
         *
         * The distinction is important, because a defined node need not be active, i.e.
         * visible on the canvas. This happens in particular when clusters are defined, in
         * that case there will be nodes and edges not displayed.
         * The bottom line is that all code with actions related to visibility, *must* use
         * 'nodeIndices' and 'edgeIndices', not 'nodes' and 'edges' directly.
         */


        this.body = {
            container: container,
            // See comment above for following fields
            nodes: {},
            nodeIndices: [],
            edges: {},
            edgeIndices: [],
            emitter: {
                on: bind(_context = this.on).call(_context, this),
                off: bind(_context2 = this.off).call(_context2, this),
                emit: bind(_context3 = this.emit).call(_context3, this),
                once: bind(_context4 = this.once).call(_context4, this)
            },
            eventListeners: {
                onTap: function onTap() {},
                onTouch: function onTouch() {},
                onDoubleTap: function onDoubleTap() {},
                onHold: function onHold() {},
                onDragStart: function onDragStart() {},
                onDrag: function onDrag() {},
                onDragEnd: function onDragEnd() {},
                onMouseWheel: function onMouseWheel() {},
                onPinch: function onPinch() {},
                onMouseMove: function onMouseMove() {},
                onRelease: function onRelease() {},
                onContext: function onContext() {}
            },
            data: {
                nodes: null,
                // A DataSet or DataView
                edges: null // A DataSet or DataView

            },
            functions: {
                createNode: function createNode() {},
                createEdge: function createEdge() {},
                getPointer: function getPointer() {}
            },
            modules: {},
            view: {
                scale: 1,
                translation: {
                    x: 0,
                    y: 0
                }
            },
            selectionBox: {
                show: false,
                position: {
                    start: {
                        x: 0,
                        y: 0
                    },
                    end: {
                        x: 0,
                        y: 0
                    }
                }
            }
        }; // bind the event listeners

        this.bindEventListeners(); // setting up all modules

        this.images = new Images(function () {
            return _this.body.emitter.emit("_requestRedraw");
        }); // object with images

        this.groups = new Groups(); // object with groups

        this.canvas = new Canvas(this.body); // DOM handler

        this.selectionHandler = new SelectionHandler(this.body, this.canvas); // Selection handler

        this.interactionHandler = new InteractionHandler(this.body, this.canvas, this.selectionHandler); // Interaction handler handles all the hammer bindings (that are bound by canvas), key

        this.view = new View(this.body, this.canvas); // camera handler, does animations and zooms

        this.renderer = new CanvasRenderer(this.body, this.canvas); // renderer, starts renderloop, has events that modules can hook into

        this.physics = new PhysicsEngine(this.body); // physics engine, does all the simulations

        this.layoutEngine = new LayoutEngine(this.body); // layout engine for inital layout and hierarchical layout

        this.clustering = new ClusterEngine(this.body); // clustering api

        this.manipulation = new ManipulationSystem(this.body, this.canvas, this.selectionHandler, this.interactionHandler); // data manipulation system

        this.nodesHandler = new NodesHandler(this.body, this.images, this.groups, this.layoutEngine); // Handle adding, deleting and updating of nodes as well as global options

        this.edgesHandler = new EdgesHandler(this.body, this.images, this.groups); // Handle adding, deleting and updating of edges as well as global options

        this.body.modules["kamadaKawai"] = new KamadaKawai(this.body, 150, 0.05); // Layouting algorithm.

        this.body.modules["clustering"] = this.clustering; // create the DOM elements

        this.canvas._create(); // apply options


        this.setOptions(options); // load data (the disable start variable will be the same as the enabled clustering)

        this.setData(data);
    } // Extend Network with an Emitter mixin

    componentEmitter(Network.prototype);
    /**
     * Set options
     *
     * @param {object} options
     */

    Network.prototype.setOptions = function (options) {
        var _this2 = this;

        if (options === null) {
            options = undefined; // This ensures that options handling doesn't crash in the handling
        }

        if (options !== undefined) {
            var errorFound = Validator$1.validate(options, allOptions);

            if (errorFound === true) {
                console.error("%cErrors have been found in the supplied options object.", VALIDATOR_PRINT_STYLE$1);
            } // copy the global fields over


            var fields = ["locale", "locales", "clickToUse"];
            selectiveDeepExtend(fields, this.options, options); // normalize the locale or use English

            if (options.locale !== undefined) {
                options.locale = normalizeLanguageCode(options.locales || this.options.locales, options.locale);
            } // the hierarchical system can adapt the edges and the physics to it's own options because not all combinations work with the hierarichical system.


            options = this.layoutEngine.setOptions(options.layout, options);
            this.canvas.setOptions(options); // options for canvas are in globals
            // pass the options to the modules

            this.groups.setOptions(options.groups);
            this.nodesHandler.setOptions(options.nodes);
            this.edgesHandler.setOptions(options.edges);
            this.physics.setOptions(options.physics);
            this.manipulation.setOptions(options.manipulation, options, this.options); // manipulation uses the locales in the globals

            this.interactionHandler.setOptions(options.interaction);
            this.renderer.setOptions(options.interaction); // options for rendering are in interaction

            this.selectionHandler.setOptions(options.interaction); // options for selection are in interaction
            // reload the settings of the nodes to apply changes in groups that are not referenced by pointer.

            if (options.groups !== undefined) {
                this.body.emitter.emit("refreshNodes");
            } // these two do not have options at the moment, here for completeness
            //this.view.setOptions(options.view);
            //this.clustering.setOptions(options.clustering);


            if ("configure" in options) {
                if (!this.configurator) {
                    this.configurator = new Configurator$1(this, this.body.container, configureOptions, this.canvas.pixelRatio, configuratorHideOption);
                }

                this.configurator.setOptions(options.configure);
            } // if the configuration system is enabled, copy all options and put them into the config system


            if (this.configurator && this.configurator.options.enabled === true) {
                var networkOptions = {
                    nodes: {},
                    edges: {},
                    layout: {},
                    interaction: {},
                    manipulation: {},
                    physics: {},
                    global: {}
                };
                deepExtend(networkOptions.nodes, this.nodesHandler.options);
                deepExtend(networkOptions.edges, this.edgesHandler.options);
                deepExtend(networkOptions.layout, this.layoutEngine.options); // load the selectionHandler and render default options in to the interaction group

                deepExtend(networkOptions.interaction, this.selectionHandler.options);
                deepExtend(networkOptions.interaction, this.renderer.options);
                deepExtend(networkOptions.interaction, this.interactionHandler.options);
                deepExtend(networkOptions.manipulation, this.manipulation.options);
                deepExtend(networkOptions.physics, this.physics.options); // load globals into the global object

                deepExtend(networkOptions.global, this.canvas.options);
                deepExtend(networkOptions.global, this.options);
                this.configurator.setModuleOptions(networkOptions);
            } // handle network global options


            if (options.clickToUse !== undefined) {
                if (options.clickToUse === true) {
                    if (this.activator === undefined) {
                        this.activator = new Activator$1(this.canvas.frame);
                        this.activator.on("change", function () {
                            _this2.body.emitter.emit("activate");
                        });
                    }
                } else {
                    if (this.activator !== undefined) {
                        this.activator.destroy();
                        delete this.activator;
                    }

                    this.body.emitter.emit("activate");
                }
            } else {
                this.body.emitter.emit("activate");
            }

            this.canvas.setSize(); // start the physics simulation. Can be safely called multiple times.

            this.body.emitter.emit("startSimulation");
        }
    };
    /**
     * Update the visible nodes and edges list with the most recent node state.
     *
     * Visible nodes are stored in this.body.nodeIndices.
     * Visible edges are stored in this.body.edgeIndices.
     * A node or edges is visible if it is not hidden or clustered.
     *
     * @private
     */


    Network.prototype._updateVisibleIndices = function () {
        var nodes = this.body.nodes;
        var edges = this.body.edges;
        this.body.nodeIndices = [];
        this.body.edgeIndices = [];

        for (var nodeId in nodes) {
            if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                if (!this.clustering._isClusteredNode(nodeId) && nodes[nodeId].options.hidden === false) {
                    this.body.nodeIndices.push(nodes[nodeId].id);
                }
            }
        }

        for (var edgeId in edges) {
            if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
                var edge = edges[edgeId]; // It can happen that this is executed *after* a node edge has been removed,
                // but *before* the edge itself has been removed. Taking this into account.

                var fromNode = nodes[edge.fromId];
                var toNode = nodes[edge.toId];
                var edgeNodesPresent = fromNode !== undefined && toNode !== undefined;
                var isVisible = !this.clustering._isClusteredEdge(edgeId) && edge.options.hidden === false && edgeNodesPresent && fromNode.options.hidden === false && // Also hidden if any of its connecting nodes are hidden
                    toNode.options.hidden === false; // idem

                if (isVisible) {
                    this.body.edgeIndices.push(edge.id);
                }
            }
        }
    };
    /**
     * Bind all events
     */


    Network.prototype.bindEventListeners = function () {
        var _this3 = this;

        // This event will trigger a rebuilding of the cache everything.
        // Used when nodes or edges have been added or removed.
        this.body.emitter.on("_dataChanged", function () {
            _this3.edgesHandler._updateState();

            _this3.body.emitter.emit("_dataUpdated");
        }); // this is called when options of EXISTING nodes or edges have changed.

        this.body.emitter.on("_dataUpdated", function () {
            // Order important in following block
            _this3.clustering._updateState();

            _this3._updateVisibleIndices();

            _this3._updateValueRange(_this3.body.nodes);

            _this3._updateValueRange(_this3.body.edges); // start simulation (can be called safely, even if already running)


            _this3.body.emitter.emit("startSimulation");

            _this3.body.emitter.emit("_requestRedraw");
        });
    };
    /**
     * Set nodes and edges, and optionally options as well.
     *
     * @param {object} data              Object containing parameters:
     *                                   {Array | DataSet | DataView} [nodes] Array with nodes
     *                                   {Array | DataSet | DataView} [edges] Array with edges
     *                                   {String} [dot] String containing data in DOT format
     *                                   {String} [gephi] String containing data in gephi JSON format
     *                                   {Options} [options] Object with options
     */


    Network.prototype.setData = function (data) {
        // reset the physics engine.
        this.body.emitter.emit("resetPhysics");
        this.body.emitter.emit("_resetData"); // unselect all to ensure no selections from old data are carried over.

        this.selectionHandler.unselectAll();

        if (data && data.dot && (data.nodes || data.edges)) {
            throw new SyntaxError('Data must contain either parameter "dot" or ' + ' parameter pair "nodes" and "edges", but not both.');
        } // set options


        this.setOptions(data && data.options); // set all data

        if (data && data.dot) {
            console.warn("The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);"); // parse DOT file

            var dotData = DOTToGraph(data.dot);
            this.setData(dotData);
            return;
        } else if (data && data.gephi) {
            // parse DOT file
            console.warn("The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);");
            var gephiData = parseGephi(data.gephi);
            this.setData(gephiData);
            return;
        } else {
            this.nodesHandler.setData(data && data.nodes, true);
            this.edgesHandler.setData(data && data.edges, true);
        } // emit change in data


        this.body.emitter.emit("_dataChanged"); // emit data loaded

        this.body.emitter.emit("_dataLoaded"); // find a stable position or start animating to a stable position

        this.body.emitter.emit("initPhysics");
    };
    /**
     * Cleans up all bindings of the network, removing it fully from the memory IF the variable is set to null after calling this function.
     * var network = new vis.Network(..);
     * network.destroy();
     * network = null;
     */


    Network.prototype.destroy = function () {
        this.body.emitter.emit("destroy"); // clear events

        this.body.emitter.off();
        this.off(); // delete modules

        delete this.groups;
        delete this.canvas;
        delete this.selectionHandler;
        delete this.interactionHandler;
        delete this.view;
        delete this.renderer;
        delete this.physics;
        delete this.layoutEngine;
        delete this.clustering;
        delete this.manipulation;
        delete this.nodesHandler;
        delete this.edgesHandler;
        delete this.configurator;
        delete this.images;

        for (var nodeId in this.body.nodes) {
            if (!Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) continue;
            delete this.body.nodes[nodeId];
        }

        for (var edgeId in this.body.edges) {
            if (!Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) continue;
            delete this.body.edges[edgeId];
        } // remove the container and everything inside it recursively


        recursiveDOMDelete(this.body.container);
    };
    /**
     * Update the values of all object in the given array according to the current
     * value range of the objects in the array.
     *
     * @param {object} obj    An object containing a set of Edges or Nodes
     *                        The objects must have a method getValue() and
     *                        setValueRange(min, max).
     * @private
     */


    Network.prototype._updateValueRange = function (obj) {
        var id; // determine the range of the objects

        var valueMin = undefined;
        var valueMax = undefined;
        var valueTotal = 0;

        for (id in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, id)) {
                var value = obj[id].getValue();

                if (value !== undefined) {
                    valueMin = valueMin === undefined ? value : Math.min(value, valueMin);
                    valueMax = valueMax === undefined ? value : Math.max(value, valueMax);
                    valueTotal += value;
                }
            }
        } // adjust the range of all objects


        if (valueMin !== undefined && valueMax !== undefined) {
            for (id in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, id)) {
                    obj[id].setValueRange(valueMin, valueMax, valueTotal);
                }
            }
        }
    };
    /**
     * Returns true when the Network is active.
     *
     * @returns {boolean}
     */


    Network.prototype.isActive = function () {
        return !this.activator || this.activator.active;
    };

    Network.prototype.setSize = function () {
        return this.canvas.setSize.apply(this.canvas, arguments);
    };

    Network.prototype.canvasToDOM = function () {
        return this.canvas.canvasToDOM.apply(this.canvas, arguments);
    };

    Network.prototype.DOMtoCanvas = function () {
        return this.canvas.DOMtoCanvas.apply(this.canvas, arguments);
    };
    /**
     * Nodes can be in clusters. Clusters can also be in clusters. This function returns and array of
     * nodeIds showing where the node is.
     *
     * If any nodeId in the chain, especially the first passed in as a parameter, is not present in
     * the current nodes list, an empty array is returned.
     *
     * Example:
     * cluster 'A' contains cluster 'B',
     * cluster 'B' contains cluster 'C',
     * cluster 'C' contains node 'fred'.
     * `jsnetwork.clustering.findNode('fred')` will return `['A','B','C','fred']`.
     *
     * @param {string|number} nodeId
     * @returns {Array}
     */


    Network.prototype.findNode = function () {
        return this.clustering.findNode.apply(this.clustering, arguments);
    };

    Network.prototype.isCluster = function () {
        return this.clustering.isCluster.apply(this.clustering, arguments);
    };

    Network.prototype.openCluster = function () {
        return this.clustering.openCluster.apply(this.clustering, arguments);
    };

    Network.prototype.cluster = function () {
        return this.clustering.cluster.apply(this.clustering, arguments);
    };

    Network.prototype.getNodesInCluster = function () {
        return this.clustering.getNodesInCluster.apply(this.clustering, arguments);
    };

    Network.prototype.clusterByConnection = function () {
        return this.clustering.clusterByConnection.apply(this.clustering, arguments);
    };

    Network.prototype.clusterByHubsize = function () {
        return this.clustering.clusterByHubsize.apply(this.clustering, arguments);
    };

    Network.prototype.updateClusteredNode = function () {
        return this.clustering.updateClusteredNode.apply(this.clustering, arguments);
    };

    Network.prototype.getClusteredEdges = function () {
        return this.clustering.getClusteredEdges.apply(this.clustering, arguments);
    };

    Network.prototype.getBaseEdge = function () {
        return this.clustering.getBaseEdge.apply(this.clustering, arguments);
    };

    Network.prototype.getBaseEdges = function () {
        return this.clustering.getBaseEdges.apply(this.clustering, arguments);
    };

    Network.prototype.updateEdge = function () {
        return this.clustering.updateEdge.apply(this.clustering, arguments);
    };
    /**
     * This method will cluster all nodes with 1 edge with their respective connected node.
     * The options object is explained in full <a data-scroll="" data-options="{ &quot;easing&quot;: &quot;easeInCubic&quot; }" href="#optionsObject">below</a>.
     *
     * @param {object} [options]
     * @returns {undefined}
     */


    Network.prototype.clusterOutliers = function () {
        return this.clustering.clusterOutliers.apply(this.clustering, arguments);
    };

    Network.prototype.getSeed = function () {
        return this.layoutEngine.getSeed.apply(this.layoutEngine, arguments);
    };

    Network.prototype.enableEditMode = function () {
        return this.manipulation.enableEditMode.apply(this.manipulation, arguments);
    };

    Network.prototype.disableEditMode = function () {
        return this.manipulation.disableEditMode.apply(this.manipulation, arguments);
    };

    Network.prototype.addNodeMode = function () {
        return this.manipulation.addNodeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.editNode = function () {
        return this.manipulation.editNode.apply(this.manipulation, arguments);
    };

    Network.prototype.editNodeMode = function () {
        console.warn("Deprecated: Please use editNode instead of editNodeMode.");
        return this.manipulation.editNode.apply(this.manipulation, arguments);
    };

    Network.prototype.addEdgeMode = function () {
        return this.manipulation.addEdgeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.editEdgeMode = function () {
        return this.manipulation.editEdgeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.deleteSelected = function () {
        return this.manipulation.deleteSelected.apply(this.manipulation, arguments);
    };

    Network.prototype.getPositions = function () {
        return this.nodesHandler.getPositions.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getPosition = function () {
        return this.nodesHandler.getPosition.apply(this.nodesHandler, arguments);
    };

    Network.prototype.storePositions = function () {
        return this.nodesHandler.storePositions.apply(this.nodesHandler, arguments);
    };

    Network.prototype.moveNode = function () {
        return this.nodesHandler.moveNode.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getBoundingBox = function () {
        return this.nodesHandler.getBoundingBox.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getConnectedNodes = function (objectId) {
        if (this.body.nodes[objectId] !== undefined) {
            return this.nodesHandler.getConnectedNodes.apply(this.nodesHandler, arguments);
        } else {
            return this.edgesHandler.getConnectedNodes.apply(this.edgesHandler, arguments);
        }
    };

    Network.prototype.getConnectedEdges = function () {
        return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler, arguments);
    };

    Network.prototype.startSimulation = function () {
        return this.physics.startSimulation.apply(this.physics, arguments);
    };

    Network.prototype.stopSimulation = function () {
        return this.physics.stopSimulation.apply(this.physics, arguments);
    };

    Network.prototype.stabilize = function () {
        return this.physics.stabilize.apply(this.physics, arguments);
    };

    Network.prototype.getSelection = function () {
        return this.selectionHandler.getSelection.apply(this.selectionHandler, arguments);
    };

    Network.prototype.setSelection = function () {
        return this.selectionHandler.setSelection.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getSelectedNodes = function () {
        return this.selectionHandler.getSelectedNodeIds.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getSelectedEdges = function () {
        return this.selectionHandler.getSelectedEdgeIds.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getNodeAt = function () {
        var node = this.selectionHandler.getNodeAt.apply(this.selectionHandler, arguments);

        if (node !== undefined && node.id !== undefined) {
            return node.id;
        }

        return node;
    };

    Network.prototype.getEdgeAt = function () {
        var edge = this.selectionHandler.getEdgeAt.apply(this.selectionHandler, arguments);

        if (edge !== undefined && edge.id !== undefined) {
            return edge.id;
        }

        return edge;
    };

    Network.prototype.selectNodes = function () {
        return this.selectionHandler.selectNodes.apply(this.selectionHandler, arguments);
    };

    Network.prototype.selectEdges = function () {
        return this.selectionHandler.selectEdges.apply(this.selectionHandler, arguments);
    };

    Network.prototype.unselectAll = function () {
        this.selectionHandler.unselectAll.apply(this.selectionHandler, arguments);
        this.selectionHandler.commitWithoutEmitting.apply(this.selectionHandler);
        this.redraw();
    };

    Network.prototype.redraw = function () {
        return this.renderer.redraw.apply(this.renderer, arguments);
    };

    Network.prototype.getScale = function () {
        return this.view.getScale.apply(this.view, arguments);
    };

    Network.prototype.getViewPosition = function () {
        return this.view.getViewPosition.apply(this.view, arguments);
    };

    Network.prototype.fit = function () {
        return this.view.fit.apply(this.view, arguments);
    };

    Network.prototype.moveTo = function () {
        return this.view.moveTo.apply(this.view, arguments);
    };

    Network.prototype.focus = function () {
        return this.view.focus.apply(this.view, arguments);
    };

    Network.prototype.releaseNode = function () {
        return this.view.releaseNode.apply(this.view, arguments);
    };

    Network.prototype.getOptionsFromConfigurator = function () {
        var options = {};

        if (this.configurator) {
            options = this.configurator.getOptions.apply(this.configurator);
        }

        return options;
    };

    var parseDOTNetwork = DOTToGraph;
    // overflow in UMD builds. They all export vis namespace therefore reexporting
    // leads to loading vis to load vis to load vis…

    exports.DataSet = DataSet;
    exports.DataView = DataView;
    exports.Network = Network;
    exports.NetworkImages = Images;
    exports.Queue = Queue;
    exports.data = index;
    exports.networkDOTParser = dotparser;
    exports.networkGephiParser = gephiParser;
    exports.networkOptions = options;
    exports.parseDOTNetwork = parseDOTNetwork;
    exports.parseGephiNetwork = parseGephi;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=vis-network.js.map

/*!
  * Froala Pages v1.2.0 (https://github.com/froala-labs/froala-pages#readme)
  * Copyright 2017-2020
  * Licensed under Froala Pages Terms (https://www.froala.com/pages/terms)
  */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.FroalaPages = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// Helpers to make changes on the DOM.
var Helpers = function () {
  function Helpers() {
    classCallCheck(this, Helpers);
  }

  Helpers.createElement = function createElement(html) {
    var el = document.createElement('DIV');
    el.innerHTML = html;
    return el.firstChild;
  };

  Helpers.prepend = function prepend(parent, el) {
    if (!parent.firstChild) {
      parent.append(el);
    } else {
      parent.insertBefore(el, parent.firstChild);
    }
  };

  Helpers.append = function append(parent, el) {
    parent.appendChild(el);
  };

  Helpers.after = function after(node, el) {
    node.parentNode.insertBefore(el, node.nextSibling);
  };

  Helpers.before = function before(node, el) {
    node.parentNode.insertBefore(el, node);
  };

  Helpers.remove = function remove(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  };

  Helpers.offset = function offset(el) {
    var rect = el.getBoundingClientRect();

    return {
      top: rect.top,
      left: rect.left
    };
  };

  Helpers.outerHeight = function outerHeight(el) {
    var withMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var height = el.offsetHeight;

    if (withMargin) {
      var style = getComputedStyle(el);

      height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
      return height;
    }

    return height;
  };

  Helpers.outerWidth = function outerWidth(el) {
    var withMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var width = el.offsetWidth;

    if (withMargin) {
      var style = getComputedStyle(el);

      width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
      return width;
    }

    return 0;
  };

  Helpers.underscores = function underscores(text) {
    return text.toLowerCase().split(' ').join('_');
  };

  Helpers.scrollTo = function scrollTo(el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  };

  Helpers.setDownloadBtnsStatus = function setDownloadBtnsStatus(scope, disabledBtn, hide) {
    var downloadBtns = scope.pageToolbar.el.querySelectorAll('.fp-download-btn');

    downloadBtns.forEach(function (btn) {
      // enable or disable download button
      if (!btn) {
        return;
      }

      // hide download button
      btn.style.display = hide ? 'none' : 'flex';

      if (disabledBtn) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
    });
  };

  Helpers.setBackgroundButtonStatus = function setBackgroundButtonStatus(element, scope) {
    let image_button = scope.blockToolbar.el.querySelector('.fp-background_image-btn')
    // let color_button = scope.blockToolbar.el.querySelector('.fp-background_color-btn')
    let remove_button = scope.blockToolbar.el.querySelector('.fp-remove_background-btn')
    // if (element.style.backgroundImage || element.style.backgroundColor) {
    if (element.style.backgroundImage) {
      image_button.classList.add('d-none');
      // image_button.title = 'Replace Background Image';
      // color_button.classList.add('d-none');
      // color_button.title = 'Replace Background Color';
      remove_button.classList.remove('d-none');
    } else {
      image_button.classList.remove('d-none');
      // image_button.title = 'Background Image';
      // color_button.classList.remove('d-none');
      // color_button.title = 'Background Color';
      remove_button.classList.add('d-none');
    }
  };

  return Helpers;
}();

// Define our internal module class.
// The Module class is inherited by inernal classes and in the constructor of the module
// we assign the common used objects for easier access.
var Module = function Module(page) {
    classCallCheck(this, Module);

    // Set page instance.
    this.page = page;

    // Set events.
    this.events = page.events;

    // Set doc.
    this.doc = page.doc;

    // Set options.
    this.opts = page.opts;

    // Call internal init method that works like a constructor.

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    this.init.apply(this, args);
};

// A block on the page.

var Block = function (_M) {
  inherits(Block, _M);

  function Block() {
    classCallCheck(this, Block);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Block.prototype.init = function init(designBlock) {
    var _this2 = this;

    this.designBlock = designBlock;
    this.id = ++Block.ID;

    // Create element.
    this.el = Helpers.createElement(designBlock.render({
      imagesDir: this.opts.designsImagesDir
    }));
    this.el.setAttribute('data-block-type', Helpers.underscores(designBlock.blockType));
    this.el.setAttribute('data-id', this.id);

    this.events.on(this.el, 'mouseenter', function () {
      return _this2._mouseEnter();
    });
  };

  // Emit block enter event.


  Block.prototype._mouseEnter = function _mouseEnter() {
    this.events.emit('block.mouseenter', this);
  };

  return Block;
}(Module);

Block.ID = 0;

var DRAG_IMAGE_HEIGHT = 50;

// A design block is an element from the Designs Panel.

var DesignBlock = function (_M) {
  inherits(DesignBlock, _M);

  function DesignBlock() {
    classCallCheck(this, DesignBlock);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  DesignBlock.prototype.init = function init(blockType, info) {
    var _this2 = this;
    // Create design block.
    this.el = document.createElement('IMG');
    this.el.setAttribute('draggable', true);
    this.blockType = blockType;
    this.template = info.template;
    this.image = info.image;
    this.el.setAttribute('src', '' + (this.opts.designsThumbsDir || '') + this.image);

    // Bind events.
    this.events.on(this.el, 'click', function () {
      return _this2.click();
    });
    this.events.on(this.el, 'dragstart', function (e) {
      return _this2.dragstart(e);
    });
  };

  // Click on a block.


  DesignBlock.prototype.click = function click() {
    this.events.emit('designBlock.click', this);
  };

  // Start dragging a block.


  DesignBlock.prototype.dragstart = function dragstart(e) {
    // Set dragging placeholder.
    if (navigator.userAgent.search('Firefox') >= 0) {
      // Set image holder to support in FF while drag & Drop
      this.dragImage = Helpers.createElement('<span><img src="' + this.el.src + '" height="' + DRAG_IMAGE_HEIGHT + '" /></span>');
    } else {
      this.dragImage = Helpers.createElement('<img src="' + this.el.src + '" height="' + DRAG_IMAGE_HEIGHT + '" />');
    }
    this.dragImage.style.position = 'absolute';
    Helpers.append(this.page.body, this.dragImage);

    e.dataTransfer.setDragImage(this.dragImage, 0, 0);

    // Set empty string to work with Edge browser
    e.dataTransfer.setData('text/html', '');

    // Emit event of drag start.
    this.events.emit('designBlock.willDrag', this);
  };

  // Render design block.


  DesignBlock.prototype.render = function render(params) {
    return this.template.replace(/{{[a-zA-Z_]*}}/g, function (match) {
      var varName = match.replace(/{|}/g, '').trim();

      return params[varName] || '{{' + varName + '}}';
    });
  };

  return DesignBlock;
}(Module);

DesignBlock.BLOCKS = {};
DesignBlock.HEADER = 'Headers';
DesignBlock.FOOTER = 'Footers';
DesignBlock.SOCIAL = 'Social images';

// Global method to register a new design block.
DesignBlock.Register = function (type, template, image) {
  if (!DesignBlock.BLOCKS[type]) {
    DesignBlock.BLOCKS[type] = [];
  }

  DesignBlock.BLOCKS[type].push({
    template: template,
    image: image
  });
};

// Define constants for different views.
var VIEWS = {
  ADD: 1,
  FULL: 2,
  DESKTOP: 100,
  TABLET_LANDSCAPE: 1024,
  TABLET_PORTRAIT: 768,
  PHONE: 375
};

// There are 2 type of buttons - both of them work in the same manner only that have different callbacks:
//   1. on block toolbar
//   2. on page toolabr

var Button = function (_M) {
  inherits(Button, _M);

  function Button() {
    classCallCheck(this, Button);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Button.prototype.init = function init(name) {
    var _this2 = this;

    // Get button details.
    this.props = Button._[name];

    if (!this.props) {
      throw new Error('A button with the name ' + name + ' could not be found');
    }

    // Render button.
    this._render(name);

    // Bind button events.
    this.events.on(this.el, 'click', function () {
      return _this2._click();
    });
    this.events.listen('button.refresh', function () {
      return _this2._refresh();
    });

    // Bind event handler for file input field to re-open the saved template for editing.
    if (name === 'loadhtml') {
      this.events.on(this.el.querySelector('#load_template'), 'change', function (e) {
        if (e.target.files.length) {
          _this2.page.uploadTemplate(e.target.files[0]);
          e.target.value = '';
        }
      });
    }

    // Bind event handler for file input field to add background image to active section.
    if (name === 'background_image') {
      this.events.on(this.el.querySelector('#load_background_image'), 'change', function (e) {
        if (e.target.files.length) {
          _this2.page.uploadImage(e.target.files[0], _this2.page.editor.FroalaEditor.IMAGE_ACTIVE_BLOCK);
          e.target.value = '';
        }
      });
    }

    // Bind event handler for text input field to add background color to active section.
    if (name === 'background_color') {
      let element = this.el.querySelector('#load_background_color');
      this.events.listen('color.change', function (e) {
        _this2.page.activeBlock.el.style.setProperty('background-color', element.value, 'important');
        // _this2.page.activeBlock.el.style.backgroundImage = null;
        // _this2.page.activeBlock.el.style.backgroundRepeat = null;
        // _this2.page.activeBlock.el.style.backgroundSize = null;
        Helpers.setBackgroundButtonStatus(_this2.page.activeBlock.el, _this2.page);
      });
    }

    // Bind event handler for field to add settings to active section.
    if (name === 'block_setting') {
      this.events.listen('block.setting', function (values, elements) {
        elements.forEach(item => {
          let value = values[item];
          if (value) {
            if (item === 'background-size' || item === 'aspect-ratio' || item === 'background-repeat') {
              if (item === 'background-repeat') {
                _this2.page.activeBlock.el.style.setProperty('background-size', 'unset', 'important');
              }
              _this2.page.activeBlock.el.style.setProperty(item, value, 'important');
            } else {
              value = value.indexOf('px') !== -1 ? value : (value + 'px');
              _this2.page.activeBlock.el.style.setProperty(item, value, 'important');
            }
          } else {
            _this2.page.activeBlock.el.style[item] = null;
          }
        })
        _this2.page.refreshIframeSize();
      });
    }

    // Bind event handler for file input field to add background image to active section.
    if (name === 'duplicate_block') {
      this.events.on(this.el.querySelector('#duplicate_block'), 'click', function (e) {
        let currentBlock = {
          blockType: _this2.page.activeBlock.designBlock.blockType,
          el: _this2.page.activeBlock.el
        };
        _this2.page.editor.disableForBlock(currentBlock);
        _this2.page.activeBlock.el.isVisible = true;
        const designBlock = {
          blockType: _this2.page.activeBlock.designBlock.blockType,
          template: _this2.page.activeBlock.el.outerHTML,
          el: _this2.page.activeBlock.el,
          render: function render(params) {
            return this.template.replace(/{{[a-zA-Z_]*}}/g, function (match) {
              var varName = match.replace(/{|}/g, '').trim();

              return params[varName] || '{{' + varName + '}}';
            });
          }
        };
        _this2.page.insertBlock(designBlock, _this2.page.activeBlock.el);
        _this2.page.editor.enableForBlock(currentBlock);
        _this2.page.editor.enableForBlock(designBlock);
        setTimeout(() => {
          _this2.page.refreshIframeSize()
        }, 1000)
      });
    }

    // Call button callback after build.
    if (this.props.afterBuild) {
      this.props.afterBuild.apply(this);
    }
  };

  // Refresh button state.


  Button.prototype._refresh = function _refresh() {
    if (this.props.refresh) {
      this.props.refresh.apply(this);
    }
  };

  // Render button.


  Button.prototype._render = function _render(name) {
    this.el = this.doc.createElement('BUTTON');
    this.el.innerHTML = this.props.icon.template;
    this.el.classList.add('fp-btn', 'fp-' + name + '-btn', 'fr-btn-type-' + this.props.icon.type);
    this.el.setAttribute('title', this.props.title);
  };

  // Click button callback.


  Button.prototype._click = function _click() {
    this.props.callback.apply(this);
    this.events.emit('button.refresh');
  };

  return Button;
}(Module);

// Register button.


Button.Register = function (name, props) {
  if (!Button._) {
    Button._ = {};
  }

  Button._[name] = props;
};

// Define layout button.
Button.Register('layout', {
  title: 'Layout',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M0 0h24v24H0z" fill="none"/>\n                <path d="M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.setView(VIEWS.ADD);
    this.page.designsPanel.show();

    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = 'flex';
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.activeView === VIEWS.ADD);
  }
});

// Define block move up butotn.
Button.Register('moveUp', {
  title: 'Move Up',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>\n            <path d="M0 0h24v24H0z" fill="none"/>\n          </svg>'
  },
  callback: function callback() {
    var block = this.page.activeBlock;

    var prevBlock = block.el.previousSibling;
    while (prevBlock && (!prevBlock.classList || !prevBlock.classList.contains('fdb-block'))) {
      prevBlock = prevBlock.previousSibling;
    }

    window.a = prevBlock;
    window.b = block.el;

    if (prevBlock) {
      Helpers.before(prevBlock, block.el);
    }

    if (this.page.activeView === VIEWS.FULL) {
      Helpers.scrollTo(block.el);
    }

    this.page.blockToolbar.hide();
    this.page.blockToolbar.refreshPosition();
  },
  refresh: function refresh() {
    if (this.page.activeBlock) {
      this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);

      var block = this.page.activeBlock;

      var prevBlock = block.el.previousSibling;
      while (prevBlock && (!prevBlock.classList || !prevBlock.classList.contains('fdb-block'))) {
        prevBlock = prevBlock.previousSibling;
      }

      if (!prevBlock) {
        this.el.classList.add('fp-disabled');
        this.el.setAttribute('disabled', 'disabled');
      } else {
        this.el.classList.remove('fp-disabled');
        this.el.removeAttribute('disabled');
      }
    }
  }
});

// Define block remove button.
Button.Register('remove', {
  title: 'Remove',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>\n              <path d="M0 0h24v24H0z" fill="none"/>\n          </svg>'
  },
  callback: function callback() {
    if (this.page.activeBlock) {
      if (confirm('Are you sure you want to remove this design block?')) {
        var block = this.page.activeBlock;
        this.page.blockToolbar.hide();

        Helpers.remove(block.el);

        if (this.page.editor.FroalaEditor) {
          this.page.editor.FroalaEditor.INSTANCES.forEach(function (ed) {
            if (block.el.contains(ed.$oel.get(0))) {
              if (ed.popups) ed.popups.hideAll();
            }
          });
        }
        this.page.refreshBlocks();
        this.events.emit('block.removed', null);
      }
    }
  },
  afterBuild: function afterBuild() {
    this.el.classList.add('fp-remove-btn');
  }
});

// Define page edit button.
Button.Register('edit', {
  title: 'Edit',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>\n          <path d="M0 0h24v24H0z" fill="none"/>\n    </svg>'
  },
  callback: function callback() {
    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = 'none';

    this.page.setView(VIEWS.FULL);
    this.page.designsPanel.hide();

    this.page.editor.enable();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.activeView === VIEWS.FULL);
  }
});

// Defined page download button.
Button.Register('download', {
  title: 'Download',
  icon: {
    type: 'html',
    template: '\n    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>\n        <path d="M0 0h24v24H0z" fill="none"/>\n    </svg>\n    <span>Download</span>'
  },
  callback: function callback() {
    var _this3 = this;

    // Download templates only if selected
    var noBlocks = !this.page.iframeBody.querySelector('[data-block-type]');

    if (!noBlocks) {
      // Download saved HTML.
      this.page.getHTML().then(function (html) {
        // handle sharewindow
        _this3.page.sharewindow && _this3.page.sharewindow.show();

        var blob = new Blob([html], {
          type: 'text/html'
        });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'froala_design_blocks_website.html';
        a.click();
      }, function (errorMsg) {
        console.log(errorMsg);
      });
    } else {
      Helpers.setDownloadBtnsStatus(this.page, noBlocks, true);
    }
  }
});

// Define desktop mode.
Button.Register('desktop', {
  title: 'Desktop',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M0 0h24v24H0z" fill="none"/>\n                <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.DESKTOP;
    this.page.iframe.style.width = null;
    this.page.el.classList.remove('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.DESKTOP);
  },
  afterBuild: function afterBuild() {
    this.page.screenSize = VIEWS.DESKTOP;
  }
});

// Define tablet landscape mode.
Button.Register('tablet_landscape', {
  title: 'Tablet Landscape',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.TABLET_LANDSCAPE;
    this.page.iframe.style.width = VIEWS.TABLET_LANDSCAPE + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.TABLET_LANDSCAPE);
  }
});

// Define tablet portrait mode.
Button.Register('tablet_portrait', {
  title: 'Tablet Portrait',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.TABLET_PORTRAIT;
    this.page.iframe.style.width = VIEWS.TABLET_PORTRAIT + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.TABLET_PORTRAIT);
  }
});

// Define phone mode.
Button.Register('phone', {
  title: 'Phone',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"/>\n                <path d="M0 0h24v24H0z" fill="none"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.PHONE;
    this.page.iframe.style.width = VIEWS.PHONE + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.PHONE);
  }
});

// Define re-open saved template button.
Button.Register('loadhtml', {
  title: 'Load HTML',
  icon: {
    type: 'svg',
    template: '<label for="load_template"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n                <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"></path>\n              </svg></label><input type="file" id="load_template" style="display: none;" />'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
  }
});

// Custom button to add background image to active block
Button.Register('background_image', {
  title: 'Background Image',
  icon: {
    type: 'svg',
    template: '<label for="load_background_image" class="cursor-pointer px-2"><svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z"></path></svg></label><input type="file" id="load_background_image" style="display: none;" />'
  },
  callback: function callback() {
    Object.assign(this.page.editor.FroalaEditor, {
      IMAGE_ACTIVE_BLOCK: this.page.activeBlock
    });
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  },
  plugin: 'image'
})

// Custom button to add background color to active block
Button.Register('background_color', {
  title: 'Background Color',
  icon: {
    type: 'svg',
    template: '<div id="custom-color" class="color-input-toolbar toolbar-input"><div class="editor-background-color custom-color-picker" id="load_background_color"></div></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);

    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  }
})

// Custom button to duplicate active block
Button.Register('duplicate_block', {
  title: 'Duplicate Block',
  icon: {
    type: 'svg',
    template: '<div id="duplicate_block" class="cursor-pointer"><svg class="fr-svg" focusable="false" style="width: 16px; height: 16px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"></path></svg></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    if (this.page.activeBlock) {
      this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    }
  }
})

// Custom button to block setting active block
Button.Register('block_setting', {
  title: 'Block settings',
  icon: {
    type: 'svg',
    template: '<div id="block_setting_container"><div id="block_setting" class="cursor-pointer custom-block-settings"><svg class="svg-inline--fa fa-cog fa-w-16" style="width: 18px; height: 18px" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"></path></svg><span class="fr-sr-only">Block Settings</span></div></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
  }
})

// Custom button to remove background image to active block
Button.Register('remove_background', {
  title: 'Remove Background',
  icon: {
    type: 'svg',
    template: '<svg class="fr-svg" xmlns="http://www.w3.org/2000/svg" version="1.0" width="344.000000pt" height="344.000000pt" viewBox="0 0 344.000000 344.000000" preserveAspectRatio="xMidYMid meet">\n' +
      '\n' +
      '<g transform="translate(0.000000,344.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">\n' +
      '<path d="M185 2777 c-26 -14 -48 -37 -63 -67 l-22 -45 2 -1010 3 -1010 22 -35 c12 -19 37 -44 55 -55 32 -20 53 -20 954 -23 l922 -2 17 -53 c44 -137 140 -267 259 -352 122 -87 246 -125 405 -125 130 0 210 18 321 72 69 33 101 57 175 132 73 73 99 107 133 176 60 123 75 198 70 350 -4 110 -9 135 -37 210 -48 130 -142 257 -241 325 l-40 28 0 697 0 697 -22 33 c-13 18 -36 43 -51 54 l-28 21 -1397 2 -1397 3 -40 -23z m2806 -114 c12 -13 14 -132 17 -664 l2 -647 -62 20 c-35 11 -101 22 -148 25 l-85 5 -100 98 c-55 54 -110 103 -122 109 -31 16 -119 14 -151 -3 -15 -8 -130 -118 -257 -245 l-229 -231 -111 109 c-118 117 -144 131 -222 116 -33 -6 -73 -41 -283 -251 l-246 -244 -110 0 c-119 0 -134 -6 -134 -51 0 -62 -29 -59 661 -59 l629 0 0 -50 0 -50 -892 0 c-815 0 -893 1 -910 17 -17 15 -18 59 -18 995 0 656 3 986 10 999 11 19 36 19 1379 19 1261 0 1370 -1 1382 -17z m-491 -1218 c55 -56 61 -65 44 -71 -162 -53 -283 -138 -370 -260 -47 -66 -97 -168 -109 -221 l-7 -33 -151 0 -152 0 325 325 c179 179 332 325 340 325 9 0 44 -29 80 -65z m384 -181 c142 -35 293 -148 363 -274 105 -186 104 -408 -2 -585 -167 -279 -513 -371 -795 -212 -125 70 -237 217 -275 362 -19 76 -19 214 0 289 49 188 209 355 397 415 90 29 205 31 312 5z m-1212 -121 l98 -98 -92 -92 -93 -93 -215 0 -215 0 191 190 c115 115 198 190 209 190 11 0 61 -42 117 -97z"/>\n' +
      '<path d="M872 2568 c-8 -8 -12 -45 -12 -100 0 -76 2 -89 19 -98 28 -14 57 -12 75 6 12 11 16 36 16 98 0 91 -8 106 -55 106 -17 0 -36 -5 -43 -12z"/>\n' +
      '<path d="M602 2498 c-20 -20 -14 -66 19 -124 37 -64 66 -83 104 -66 42 19 42 54 -1 130 -35 61 -42 67 -74 70 -19 2 -41 -3 -48 -10z"/>\n' +
      '<path d="M1110 2448 c-47 -74 -51 -110 -15 -134 41 -27 70 -12 110 60 19 34 35 72 35 84 0 29 -26 52 -61 52 -25 0 -35 -9 -69 -62z"/>\n' +
      '<path d="M411 2301 c-45 -45 -18 -87 86 -140 50 -25 89 -16 99 23 10 40 -3 60 -62 94 -77 44 -98 48 -123 23z"/>\n' +
      '<path d="M1300 2282 c-59 -35 -65 -41 -68 -74 -3 -31 1 -40 24 -54 26 -17 28 -17 81 11 105 55 127 91 83 135 -28 28 -45 25 -120 -18z"/>\n' +
      '<path d="M805 2236 c-56 -26 -119 -90 -142 -144 -8 -20 -15 -66 -15 -104 -1 -114 61 -210 166 -253 52 -22 161 -19 216 6 173 78 215 305 81 439 -81 81 -205 103 -306 56z m190 -115 c94 -53 101 -182 15 -254 -42 -36 -90 -43 -145 -22 -111 42 -136 171 -51 254 53 51 115 59 181 22z"/>\n' +
      '<path d="M342 2034 c-26 -18 -30 -65 -6 -88 11 -12 36 -16 94 -16 88 0 110 12 110 60 0 43 -32 60 -110 60 -43 0 -73 -5 -88 -16z"/>\n' +
      '<path d="M1308 2039 c-12 -7 -18 -22 -18 -49 0 -51 17 -60 113 -60 59 0 77 4 90 18 24 26 21 68 -5 86 -26 18 -152 22 -180 5z"/>\n' +
      '<path d="M469 1802 c-68 -40 -79 -52 -79 -82 0 -30 27 -60 55 -60 21 0 125 57 143 78 29 37 0 93 -49 91 -13 0 -45 -12 -70 -27z"/>\n' +
      '<path d="M1241 1816 c-7 -8 -11 -30 -9 -48 3 -29 11 -37 70 -72 74 -42 108 -43 129 -5 20 37 3 66 -62 104 -63 37 -109 44 -128 21z"/>\n' +
      '<path d="M625 1609 c-37 -64 -44 -109 -20 -129 24 -20 67 -15 88 11 25 31 67 114 67 133 0 25 -30 46 -65 46 -31 0 -37 -5 -70 -61z"/>\n' +
      '<path d="M1079 1646 c-15 -32 -7 -60 33 -120 37 -56 64 -70 99 -52 35 17 36 58 3 114 -40 70 -53 82 -91 82 -26 0 -36 -6 -44 -24z"/>\n' +
      '<path d="M878 1609 c-15 -8 -18 -25 -18 -105 0 -92 1 -95 26 -106 21 -10 31 -9 52 3 25 14 27 20 30 99 3 77 1 87 -19 103 -24 19 -46 21 -71 6z"/>\n' +
      '<path d="M332 848 c-7 -7 -12 -26 -12 -43 0 -51 11 -55 161 -55 112 0 141 3 153 16 18 18 20 47 6 75 -10 17 -23 19 -153 19 -98 0 -147 -4 -155 -12z"/>\n' +
      '<path d="M2475 965 c-19 -18 -24 -31 -20 -48 4 -12 50 -66 103 -119 l97 -98 -99 -99 c-84 -85 -99 -105 -99 -132 0 -34 23 -59 56 -59 12 0 63 43 123 102 l104 102 104 -102 c109 -107 130 -118 166 -82 36 36 25 57 -82 166 l-102 104 102 104 c59 60 102 111 102 123 0 33 -25 56 -59 56 -27 0 -47 -15 -132 -99 l-99 -99 -97 97 c-54 53 -108 99 -120 103 -17 4 -30 -1 -48 -20z"/>\n' +
      '</g>\n' +
      '</svg>'
  },
  callback: function callback() {
    this.page.activeBlock.el.style.backgroundImage = null;
    this.page.activeBlock.el.style.backgroundRepeat = null;
    this.page.activeBlock.el.style.backgroundSize = null;
    // this.page.activeBlock.el.style.backgroundColor = null;
    // this.page.events.emit('color.remove');
    Helpers.setBackgroundButtonStatus(this.page.activeBlock.el, this.page);
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  }
})


//custom button to merge the block with bottom block
Button.Register('merge_down', {
  title: 'Merge With Down',
  icon: {
    type: 'svg',
    template: '<div id="merge_down" class="cursor-pointer"><img src="/assets/images/merge_down.png" alt=""></div>'
  },
  callback: function callback() {
    let currentBlock = this.page.activeBlock.el;
    let nextBlock = currentBlock.nextSibling;
    let isHeader = false;
    if(currentBlock.tagName === "HEADER" || nextBlock?.classList.contains('fdb-block')) {
      if (currentBlock.tagName === "HEADER") {
        nextBlock = currentBlock?.nextSibling?.nextSibling?.nextSibling;
        currentBlock.children[0].setAttribute('isHeader',true);
        isHeader = true;
      }
      let nextBlockStyle = nextBlock.style;
      let currentBlockStyle = currentBlock.style;
      let stylePropertiesArr = getPropertiesArr(nextBlockStyle);
      let stylePropertiesCurrArr =  getPropertiesArr(currentBlockStyle);
      let currentBlockChild = currentBlock.children[0];
      if (stylePropertiesCurrArr.includes('background-color') || stylePropertiesCurrArr.includes('background-image') ||  currentBlock.tagName === "HEADER") {
        if (currentBlock?.classList.contains('bg-dark') && currentBlock.tagName === "HEADER") {
          currentBlock.classList.remove('bg-dark');
          currentBlockChild.setAttribute('bg-dark',true);
        }
        wrapDivInParent(stylePropertiesCurrArr,currentBlockChild,currentBlockStyle, isHeader)
      }
      else {
          currentBlockChild.style.setProperty("padding-top", "44px", "important")
          currentBlockChild.style.setProperty("padding-bottom", "44px", "important")
      }
      currentBlock.style.setProperty("padding", "0", "important")
      let nextBlockDiv = nextBlock.children;
      let nextBlockDivs = [];
      nextBlockDivs = Object.assign(nextBlockDivs, nextBlockDiv)
      if(nextBlockDivs.length > 0) {
        nextBlockDivs.map( x => {
          if (stylePropertiesArr.includes('background-color') || stylePropertiesArr.includes('background-image')) {
            let parent = x.parentNode;
            let wrapper = document.createElement('div');
            parent.replaceChild(wrapper, x);
            wrapper.appendChild(x);
            x = wrapper;
            stylePropertiesArr.map( i => {
              i = i.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              });
              x.style[i] = nextBlockStyle[i];
              nextBlockStyle[i] = null;
            })
          }
          if(x.getAttribute('isHeader')) {
            x.style.setProperty("padding-top", "0px", "important")
            x.style.setProperty("padding-bottom", "0px", "important")
          } else {
            x.style.setProperty("padding-top", "44px", "important")
            x.style.setProperty("padding-bottom", "44px", "important")
          }
          currentBlock.appendChild(x);
        })
        currentBlock.style.setProperty("padding", "0px", "important")
      }

      if ( currentBlock.tagName === "HEADER") {
        currentBlock.nextSibling.nextSibling.nextSibling.remove();
      } else {
        currentBlock.nextElementSibling.remove();
      }
    }
  },
})


//custom button to merge the block with above block
Button.Register('merge_up', {
  title: 'Merge With Up',
  icon: {
    type: 'svg',
    template: '<div id="merge_up" class="cursor-pointer"><img src="/assets/images/merge_up.png" alt=""></div>'
  },
  callback: function callback() {
    let currentBlock = this.page.activeBlock.el;
    let previousBlock = currentBlock.previousSibling;
    let isHeader = false;
    if(previousBlock?.classList.contains('fdb-block') || currentBlock?.previousSibling?.previousSibling?.previousSibling?.tagName === "HEADER") {
      if (currentBlock?.previousSibling?.previousSibling?.previousSibling?.tagName === "HEADER") {
        previousBlock = currentBlock?.previousSibling?.previousSibling?.previousSibling;
        previousBlock.children[0].setAttribute('isHeader',true);
        isHeader = true;
      }
      let currentBlockStyle = currentBlock.style;
      let previousBlockStyle = previousBlock.style;
      let stylePropertiesArr = getPropertiesArr(currentBlockStyle);
      let stylePropertiesPrevArr = getPropertiesArr(previousBlockStyle);
      let previousBlockChild = previousBlock.children[0];
      if (stylePropertiesPrevArr.includes('background-color') || stylePropertiesPrevArr.includes('background-image') || previousBlock.tagName === "HEADER") {
        if (previousBlock?.classList.contains('bg-dark') && previousBlock.tagName === "HEADER") {
          previousBlock.classList.remove('bg-dark');
          previousBlockChild.setAttribute('bg-dark',true);
        }
        wrapDivInParent(stylePropertiesPrevArr,previousBlockChild,previousBlockStyle, isHeader)
      }
      else {
          previousBlockChild.style.setProperty("padding-top", "44px", "important")
          previousBlockChild.style.setProperty("padding-bottom", "44px", "important")
      }
      previousBlock.style.setProperty("padding", "0px", "important")
      let currentBlockDiv = currentBlock.children;
      let currentBlockDivs = [];
      currentBlockDivs = Object.assign(currentBlockDivs, currentBlockDiv)
      if(currentBlockDivs.length > 0) {
        currentBlockDivs.map(x => {
          if (stylePropertiesArr.includes('background-color') || stylePropertiesArr.includes('background-image')) {
            let parent = x.parentNode;
            let wrapper = document.createElement('div');
            parent.replaceChild(wrapper, x);
            wrapper.appendChild(x);
            x = wrapper;
            stylePropertiesArr.map( i => {
              i = i.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              });
              x.style[i] = currentBlockStyle[i];
              currentBlockStyle[i] = null;
            })
          }
          if(x.getAttribute('isHeader')) {
            x.style.setProperty("padding-top", "0px", "important")
            x.style.setProperty("padding-bottom", "0px", "important")
          } else {
            x.style.setProperty("padding-top", "44px", "important")
            x.style.setProperty("padding-bottom", "44px", "important")
          }
          previousBlock.appendChild(x);
        })
        previousBlock.style.setProperty("padding", "0px", "important")
      }
      if ( previousBlock.tagName === "HEADER") {
        previousBlock?.nextElementSibling?.nextElementSibling.remove();
      } else {
        previousBlock.nextElementSibling.remove();
      }

    }
  },
})

function wrapDivInParent(stylePropertiesArr, targetBlockChild, targetBlockStyle, isHeader = false) {
  let parent = targetBlockChild.parentNode;
  let wrapper = document.createElement('div');
  parent.replaceChild(wrapper, targetBlockChild);
  wrapper.appendChild(targetBlockChild);
  if(targetBlockChild.getAttribute('isHeader')) {
    wrapper.setAttribute('isHeader',true);
    targetBlockChild.removeAttribute('isHeader');
  }
  if(targetBlockChild.getAttribute('bg-dark')) {
    wrapper.setAttribute('bg-dark',true);
    targetBlockChild.removeAttribute('bg-dark');
  }
  targetBlockChild = wrapper;
  stylePropertiesArr.map( i => {
    i = i.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    targetBlockChild.style[i] = targetBlockStyle[i];
    targetBlockStyle[i] = null;
  })
  if(isHeader === true) {
    if(targetBlockChild.getAttribute('bg-dark')) {
      targetBlockChild.classList.add('bg-dark');
    }
    targetBlockChild.style.setProperty("padding-top", "0px", "important")
    targetBlockChild.style.setProperty("padding-bottom", "0px", "important")
  }
  if(!isHeader) {
    targetBlockChild.style.setProperty("padding-top", "44px", "important")
    targetBlockChild.style.setProperty("padding-bottom", "44px", "important")
  }
}

function getPropertiesArr (targetBlockStyle) {
  let stylePropertiesArr = [];
  let numberPattern = /\d+/g;
  for (let propName in targetBlockStyle) {
    if(propName.match(numberPattern)) {
      stylePropertiesArr.push(targetBlockStyle[propName]);
    }
  }
  return stylePropertiesArr;
}

var LEAVE_TIMEOUT = 50;

// Toolbar on a block.

var BlockToolbar = function (_M) {
  inherits(BlockToolbar, _M);

  function BlockToolbar() {
    classCallCheck(this, BlockToolbar);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  BlockToolbar.prototype.init = function init() {
    // DOM.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-block-toolbar');
    Helpers.append(this.page.body, this.el);

    // Buttons.
    this._addButtons();

    // Events.
    this._initEvents();
  };

  BlockToolbar.prototype._initEvents = function _initEvents() {
    var _this2 = this;

    this.events.listen('block.mouseenter', function (block) {
      return _this2.showForBlock(block);
    });
    this.events.on(this.page.iframeDoc, 'mouseleave', function () {
      return _this2._doLeave();
    });
    this.events.on(this.el, 'mouseenter', function () {
      return clearTimeout(_this2.leaveTimeout);
    });
    this.events.on(this.el, 'mouseleave', function () {
      return _this2._doLeave();
    });
    this.events.on(this.page.iframeDoc, 'scroll', function () {
      return _this2.refreshPosition();
    });
    this.events.on(this.page.el, 'scroll', function () {
      return _this2.refreshPosition();
    });
  };

  // Mouse goes outside of the page.


  BlockToolbar.prototype._doLeave = function _doLeave() {
    var _this3 = this;

    this.leaveTimeout = setTimeout(function () {
      return _this3.hide();
    }, LEAVE_TIMEOUT);
  };

  // Add block buttons.


  BlockToolbar.prototype._addButtons = function _addButtons() {
    var _this4 = this;

    this.opts.blockButtons.forEach(function (btnName) {
      var btn = new Button(_this4.page, btnName);

      Helpers.append(_this4.el, btn.el);
    });
  };

  // Refresh potion of the buttons on the current block.


  BlockToolbar.prototype.refreshPosition = function refreshPosition() {
    if (this.isVisible()) {
      this.showForBlock(this.page.activeBlock);
    }

    this.events.emit('button.refresh');
  };

  // Show buttons toolbar on a specific block.


  BlockToolbar.prototype.showForBlock = function showForBlock(block) {
    Helpers.setBackgroundButtonStatus(block.el, this.page);
    clearTimeout(this.leaveTimeout);
    var blockOffset = Helpers.offset(block.el);

    this.page.activeBlock = block;

    var activeEl = this.page.iframeBody.querySelector('.fp-active');
    if (activeEl) {
      activeEl.classList.remove('fp-active');
    }

    block.el.classList.add('fp-active');
    this.show(blockOffset.left, blockOffset.top);
  };

  // Show buttons toolbar at a specific position.


  BlockToolbar.prototype.show = function show(left, top) {
    this.el.classList.add('fp-visible');
    this.el.style.left = left + Helpers.offset(this.page.iframe).left + 'px';
    this.el.style.top = Math.max(0, top) / (this.page.activeView === VIEWS.ADD ? 4 : 1) + Helpers.offset(this.page.iframe).top + 'px';

    this.events.emit('button.refreshed', this.page.activeBlock)
    this.events.emit('button.refresh');
  };

  // Hide buttons toolbar.


  BlockToolbar.prototype.hide = function hide() {
    this.el.classList.remove('fp-visible');
    this.events.emit('button.hidden');
  };

  // Check if toolbar is visible.


  BlockToolbar.prototype.isVisible = function isVisible() {
    return this.el.classList.contains('fp-visible');
  };

  return BlockToolbar;
}(Module);

// Define constants for different views.
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var connError = 'DC1e1lpG4H-8A-63sgiD4D4uE1xG-7wqmE5C2D5H5G4J4B9jwA-13tiH2G4I2A4B3B8B3A4zdC-7dzfE-13E-13F5A2uwextlnE-11C4E1jzxuC4bhlaiF2joexhA-8E3I3A2sC4gaoH-9A-7H4B1kB-16yzvnfA9A30A8uC-16E6E2G2zsA1nacE-13cD4C2I2SPQC8mF-11chB2zzcnpbpliiA5A6ddbhE2mqrytfzcyI-8A3C3D3Ya1G4A3E2C2C1gmvvkipB2I3naalF-10B3tI-8zaC2dqcD-8E4A5J3C8oxF2C5C4pdtb1mB-16A2A4SobnB-21zD5A4RgyvtxB2kC-13zF-10lD4sgrqltbH-9D3cexhC-11aueD2pB-22D-17xrF-10mstrC6B1OldcpaC3eomjaC3obj1aurfzH-9H-8A11xjA2nieE1C-7xahlA6hdrbzA13B4B10mB3D3C5txdB7==';
var connSupport = 'MD5igyH3bfjxpD5A2bD2suxxfC6D6F2C1C1G1A1qnlD-11bA2G3F1A1C1D3C5D3cH-9fJ-7cqvtE6C1A-8I-8lomwwaE1F4smqC-16D6maghB-7I3qvzaseC1B3D3zD2njfldA2A32tdbcagmC2J3B5B-21wD4D6E5clB2uxtvhD5D1G1XYFB2vfG-10qF3cmjeymygi1I-7C8B4C-13B-11B-11sD3zxypA-13oqjneB1A10C7E1F1G3C1D1C1D2hdC-13F-11G-10pkD3H2wzxB-11rA4A-7ssjB4shxfG1A28A5B8xqE4A4A3yoH-7wtfB4B2JtH-8ywqA2E7NqreujjjbD5pmgI-7C8D-17E-13aawG1D2CxpwdA-9G2ytriD-16B-13tD5qvtuiuB-13A4kD-8G3B-7F-7C-21d1D-13f1gTsdxyuA-13A2C-9rsA30A9c1D2D1C4aoqA11==';
var baseUrl = 'DkpqvtD2A27A14C-22D-17zD6ibB-7sB-31uC2xrlF2H-8kuA5hB4A3qcdavA6==';
var RD = '3C10D7D5B4B2A3G3E2A2A5==';

var domain = function () {
  var i = 0;
  var domain = document.domain;
  var p = domain.split('.');
  var s = '_gd' + new Date().getTime();

  while (i < p.length - 1 && document.cookie.indexOf(s + '=' + s) == -1) {
    domain = p.slice(0 - 1 - ++i).join('.');
    document.cookie = s + '=' + s + ';domain=' + domain + ';';
  }

  document.cookie = s + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + domain + ';';

  return (domain || '').replace(/(^\.*)|(\.*$)/g, '');
}();

var Data = function (_M) {
  inherits(Data, _M);

  function Data() {
    classCallCheck(this, Data);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Data.prototype.init = function init() {
    var me = this;
    var ls = me.page.opts.key || [''];
    var pageToolbar = me.page.pageToolbar;
    var pt = me._decrypt(me._foo('ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=='));
    if (typeof ls === 'string') {
      ls = [ls];
    }

    // Assume unlicensed.
    pageToolbar.ul = true;

    // Assume not expired.
    var isExpired = false;

    // No user id.
    var usrId = 0;

    // Loop keys.
    for (var i = 0; i < ls.length; i++) {
      // Get info for keys.
      var info = me._parse(ls[i]);
      // License string.
      var st = info[2];

      // Wildcard.
      var xOem = me._decrypt(me._foo(me._decrypt('LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2==')));

      // Wildcard.
      // Domain.
      // Allowed domains by default.
      if (st === xOem || st.indexOf(domain, st.length - domain.length) >= 0 || me._isAllowedSubdomain(domain)) {
        // Check if expired.
        if (me._isExpired(info[1]) && (domain || '').length > 0 && !me._isAllowedSubdomain(domain)) {
          isExpired = true;
          usrId = info[0] || -1;
        }

        // Is OK.
        else {
            pageToolbar.ul = false;
            break;
          }
      }
    }

    // Pixel tracking.
    var img = new Image();

    // Unlicensed.
    if (pageToolbar.ul === true) {

      // Make a request over to us to track expired.
      if (isExpired) {
        img.src = me._foo(me._decrypt(pt)) + 'e=' + usrId;
      }

      // Make a request over to us to track unlicensed.
      else {
          img.src = me._foo(me._decrypt(pt)) + 'u';
        }
    }

    /*if (navigator.connection) {
      navigator.connection.addEventListener('change', function () {
        me._testConnection(me);
      });
    }*/
  };

  // test internet connection


  Data.prototype._testConnection = function _testConnection(me) {
    var api = me._decrypt(me._foo(baseUrl)) + 'keep_alive';

    !me.domain && me.makeRequest(api, 'GET');
  };

  // remove network error message from view


  Data.prototype._remove = function _remove() {
    var errMsg = document.getElementsByClassName('fp-connectin-error');

    if (errMsg.length) {
      for (var i = 0; i < errMsg.length; i++) {
        errMsg[i].remove();
      }

      // Display downloads button only if blocks are selected
      var noBlocks = !this.page.iframeBody.querySelector('[data-block-type]');

      Helpers.setDownloadBtnsStatus(this.page, noBlocks, noBlocks);
    }
  };

  // Add unlicensed message.


  Data.prototype._add = function _add(message, cls) {
    var errorMessage = this._decrypt(this._foo(message));
    var msgDiv = Helpers.createElement(errorMessage);

    cls = cls ? cls : '';

    if (msgDiv) {
      msgDiv.setAttribute('class', 'fp-license-error ' + cls);
      Helpers.prepend(this.page.body, msgDiv);
      Helpers.setDownloadBtnsStatus(this.page, true, true);
    }
  };

  Data.prototype._decrypt = function _decrypt(str) {
    if (!str) {
      return str;
    }

    var decrypted = '';
    var _bar = this._foo('charCodeAt');
    var _car = this._foo('fromCharCode');
    var key = chars.indexOf(str[0]);

    for (var i = 1; i < str.length - 2; i++) {
      var ks = this._sumDigits(++key);
      var charCode = str[_bar](i);

      // Find out how many times we added the sum of key digits.
      var t = '';

      while (/[0-9-]/.test(str[i + 1])) {
        t += str[++i];
      }
      t = parseInt(t, 10) || 0;

      charCode = this._fromRange(charCode, ks, t);
      charCode ^= key - 1 & 31;
      decrypted += String[_car](charCode);
    }

    return decrypted;
  };

  Data.prototype._isAllowedSubdomain = function _isAllowedSubdomain(st) {
    var x_froala = this._decrypt('tkC-22d1qC-13sD1wzF-7==');

    var domains = [x_froala];

    for (var i = 0; i < domains.length; i++) {

      // IE 11 polyfill
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
          if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
          }

          return this.substring(this_len - search.length, this_len) === search;
        };
      }

      if (st.endsWith(domains[i])) {
        return true;
      }
    }

    return false;
  };

  Data.prototype._parse = function _parse(key) {
    var info = (this._decrypt(key) || '').split('|');

    if (info.length === 4 && info[0] === 'V3') {
      return [info[1], info[3], info[2]];
    }

    return [null, null, ''];
  };

  Data.prototype._isExpired = function _isExpired(date) {
    // no date.
    if (date === null) {
      return true;
    }
    // date expired.
    if (new Date(date) < new Date(this._decrypt(RD))) {
      return true;
    }
    return false;
  };

  Data.prototype._sumDigits = function _sumDigits(number) {
    var str = number.toString();
    var sum = 0;

    for (var i = 0; i < str.length; i++) {
      sum += parseInt(str.charAt(i), 10);
    }

    if (sum > 10) {
      return sum % 9 + 1;
    }

    return sum;
  };

  Data.prototype._fromRange = function _fromRange(charCode, ks, i) {

    // Get how many times we should substract.
    var p = Math.abs(i);

    while (p-- > 0) {
      charCode -= ks;
    }

    // Add 123 if the index is negative.
    if (i < 0) {
      charCode += 123;
    }

    return charCode;
  };

  Data.prototype._foo = function _foo(x) {
    return x;
  };

  Data._getData = function _getData(me, resolve, reject, jsonFormat) {
    var p = me.page;
    var htmlHeader = p._getHeadHTML();
    var htmlBody = p._getBodyHTML();
    if (!me.domain) {
      Helpers.setDownloadBtnsStatus(p, true);
      p.editor.disable();

      var data = '';

      if (jsonFormat) {
        // Create a JSON structure.
        data = {
          style: p._getLinks(),
          inlineStyle: p._getInlineStyle(),
          scripts: p._getScripts(),
          blocks: p._getBlockHTML()
        };

        // data = JSON.stringify(data);
      } else {
        // Create a HTML structure.
        data = '<!DOCTYPE html>\n            <html>\n            <head>\n            ' + htmlHeader + '\n            </head>\n            <body>\n            ' + htmlBody + '\n            </body>\n            </html>\n            ';
      }

      // Init editor back.
      p.editor.enable();
      resolve(data);
      Helpers.setDownloadBtnsStatus(p, false);
    } else {
      // Destroy editor instances so that we remove editor UX.
      p.editor.disable();

      // Create a HTML structure.
      var _data = '<!DOCTYPE html>\n          <html>\n          <head>\n          ' + htmlHeader + '\n          </head>\n          <body>\n          ' + htmlBody + '\n          </body>\n          </html>\n          ';

      // Init editor back.
      p.editor.enable();

      resolve(_data);
      Helpers.setDownloadBtnsStatus(p, false);
    }
  };

  Data.prototype.makeRequest = function makeRequest(url, methodType, callBack, resolve, reject) {
    var me = this;
    var request = new XMLHttpRequest();
    var params = methodType === 'POST' ? JSON.stringify({
      key: me.opts.key
    }) : {};

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        me._remove();
        if (request.status === 200) {
          callBack && callBack(request.responseText, resolve, reject);
        } else if (request.responseText) {
          me._add(connSupport);
          reject && reject(request.responseText);
        }
      }
    };

    request.onerror = function () {
      me._add(connError, 'fp-connectin-error');
      reject && reject('Error, Please retry!');
    };

    request.open(methodType, url);
    request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    request.send(params);
  };

  return Data;
}(Module);

// CSS to be injected in the iframe.
var STYLESHEET = '\nbody, html {\n  margin: 0;\n  height: 100%\n}\nbody.no-block {\n  flex-flow: column;\n  overflow-x: hidden;\n  display: flex;\n}\nbody {\n  background: #DEDEDE;\n}\n.fp-no-block {\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-direction: column;\n  cursor: pointer;\n  color: #444;\n  display: none;\n  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;\n  text-align: center;\n  background: #FFF;\n  transition: margin 0.25s linear 0.25s;\n}\n.fp-no-block:hover {\n  background: #EFEFEF;\n}\n.fp-no-block.fp-visible {\n  display: flex;\n}\n.fp-no-sections {\n  flex: 2;\n}\n.fr-wrapper{\n  width: 100%;\n}\n.navbar .fr-view{\n  display: flex;\n  align-items: center;\n}\n.fr-popup.fr-desktop.fr-inline.fr-active{\n}\n\n\n.fr-popup.fr-desktop.fr-inline.fr-imageProButton.fr-active{\n  display:flex;\n  padding-right: 12px; \n}\n\n.fr-float-left{\n  align-items: flex-end;\n  display: flex;\n  border-top: 1px solid #ebebeb;\n  margin-top: 53px;\n  padding-bottom: 12px;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n#myModal2 .try_fro_content_footer{\n  justify-content: center;\n  padding-bottom: 20px;\n}\n#myModal2  .modal-dialog{\n  max-width: 450px;\n}\n#myModal2  .try_fro {\n  padding: 45px 22px;\n  border-bottom-right-radius: 75%;\n  border-bottom-left-radius: 75%;\n}\n#myModal2  .try_fro_content {\n  padding: 40px 22px 0px 22px;\n}\n#myModal2  .try_fro p {\n  color: #fff;\n  font-size: 25px;\n  margin: 0px;\n  text-align: center;\n}\n.fr-wrapper p{\n  margin: 0px;\n}\n.fr-box.fr-inline .fr-wrapper  .fr-element.fr-view ul{\n  display: inline-block !important;\n  list-style: none; \n}\n\n[role="application"] .fr-view ul{\n  display: flex !important;\n  list-style: none;\n}\n\n\n.fp-no-block p {\n  margin: 0;\n}\n.fp-no-sections p + p {\n  font-size: 16px;\n  margin-top: 5px;\n}\n.fdb-block {\n  box-shadow: 0;\n  margin-bottom: 0;\n  transition: margin 0.25s linear 0.25s;\n  margin-top: -5px;\n}\n.tui-image-editor-container .tui-image-editor-checkbox-wrap.fixed-width{\n  width: 187px !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li{\n  margin-top: 8px;\n}\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li:nth-child(1){\n  margin-top: -20px;\n}\n\n.fp-active {\n  box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -moz-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -webkit-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n}\n.paddremov{\n  padding:0px;\n}\n.try_fro{\n  background-color: #0092FA;\n  color: #7DFEFF;\n  padding: 35px 22px;\n  border-bottom-right-radius: 75%;\n}\n.try_fro_content{\n  padding: 25px 22px 4px 22px;\n}\n.try_fro_content p{\n  color: #000;\n}\n.try_fro_content_bottom{\n  padding: 0px 22px;\n}\n.try_fro_content_bottom p{\n  color: #000;\n  font-size: 14px;\n}\n.try_fro_content_footer ul{\n  font-size: 14px;\n  padding:0px;\n  color: #000;\n}\n.fr-toolbar .fr-btn-grp:nth-child(1){\n  display: block;\n  float: none;\n}\n.fr-toolbar .fr-btn-grp{padding-bottom: 0px;\n}\n\n\n.fr-toolbar.fr-inline{\n  z-index: 999;\n}\n.pro-btn button{\n  background-color: #0789DC;\n  border: none;\n  color: #fff;\n  padding: 7px 12px;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-top: 7px;\n  outline: none !important;\n}\n.popupp{\n  z-index: 9999999999;\n}\n.download_botton button{\n  padding: 10px 25px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 25px;\n}\n.try_fro_content_footer{\n  display: flex;\n  justify-content: space-around;\n  padding: 0px 10px;\n}\n.try_fro h1{\n  font-weight: 300;\n  color: #7DFEFF;\n  margin: 0px;\n  line-height: 47px;\n}\n.fr-custom{\n  display: block !important;\n}\n.try_fro p{\n  color: #fff;\n  font-size: 35px;\n  margin: 0px;\n}\nbody.fp-add-view [data-block-type],\nbody.fp-add-view .fp-no-block {\n  margin-bottom: 20px;\n}\nbody.fp-add-view [data-block-type] {\n  user-select: none;\n  position: relative;\n}\nbody.fp-add-view section[data-block-type] {\n  cursor: move;\n}\nbody.fp-add-view [data-block-type]:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: block;\n  z-index: 10000;\n  content: "";\n}\n.fp-drop-placeholder {\n  height: 200px;\n  width: 100%;\n  border: solid 10px  #0098f7;\n  background: #FFF;\n  margin-bottom: 20px;\n}\n.fp-dragging {\n  display: none;\n}\n.fr-popup {\n  z-index: 999 !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu{\n  position: relative;\n}\n.fp-active{\n  display: inline-block;\n  width: 100%;\n border: 1px solid #4bb7e3;\n z-index: 99;\n}\nimg.fr-dib {\n  margin: 5px auto;\n  display: block;\n  float: none;\n  vertical-align: top;\n}\nspan.fr-emoticon.fr-emoticon-img {\n  background-repeat: no-repeat !important;\n  font-size: inherit;\n  height: 1em;\n  width: 1em;\n  min-height: 20px;\n  min-width: 20px;\n  display: inline-block;\n  margin: -.1em .1em .1em;\n  line-height: 1;\n  vertical-align: middle;\n}\n@media only screen and (max-width: 767px) {\n  .navbar .fr-view {\n    display: block;\n    align-items: unset;\n}\n}\n';
STYLESHEET += '\n.fr-dropdown-content ul.fr-dropdown-list li a.fr-active {\n color: #4BB7E3!important;\n background: unset!important\n}';
/** below css is for backup
 * we have made some changes for [role="application"] .fr-view ul {} style.
 * Because it was misbehaving in editor */
// var STYLESHEET = '\nbody, html {\n  margin: 0;\n  height: 100%\n}\nbody.no-block {\n  flex-flow: column;\n  overflow-x: hidden;\n  display: flex;\n}\nbody {\n  background: #DEDEDE;\n}\n.fp-no-block {\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-direction: column;\n  cursor: pointer;\n  color: #444;\n  display: none;\n  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;\n  text-align: center;\n  background: #FFF;\n  transition: margin 0.25s linear 0.25s;\n}\n.fp-no-block:hover {\n  background: #EFEFEF;\n}\n.fp-no-block.fp-visible {\n  display: flex;\n}\n.fp-no-sections {\n  flex: 2;\n}\n.fr-wrapper{\n  width: 100%;\n}\n.navbar .fr-view{\n  display: flex;\n  align-items: center;\n}\n.fr-popup.fr-desktop.fr-inline.fr-active{\n}\n\n\n.fr-popup.fr-desktop.fr-inline.fr-imageProButton.fr-active{\n  display:flex;\n  padding-right: 12px; \n}\n\n.fr-float-left{\n  align-items: flex-end;\n  display: flex;\n  border-top: 1px solid #ebebeb;\n  margin-top: 53px;\n  padding-bottom: 12px;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n#myModal2 .try_fro_content_footer{\n  justify-content: center;\n  padding-bottom: 20px;\n}\n#myModal2  .modal-dialog{\n  max-width: 450px;\n}\n#myModal2  .try_fro {\n  padding: 45px 22px;\n  border-bottom-right-radius: 75%;\n  border-bottom-left-radius: 75%;\n}\n#myModal2  .try_fro_content {\n  padding: 40px 22px 0px 22px;\n}\n#myModal2  .try_fro p {\n  color: #fff;\n  font-size: 25px;\n  margin: 0px;\n  text-align: center;\n}\n.fr-wrapper p{\n  margin: 0px;\n}\n.fr-box.fr-inline .fr-wrapper  .fr-element.fr-view ul{\n  display: inline-block !important;\n  list-style: none; \n}\n\n[role="application"] .fr-view ul{\n  display: flex !important;\n  list-style: none;\n}\n\n\n.fp-no-block p {\n  margin: 0;\n}\n.fp-no-sections p + p {\n  font-size: 16px;\n  margin-top: 5px;\n}\n.fdb-block {\n  box-shadow: 0;\n  margin-bottom: 0;\n  transition: margin 0.25s linear 0.25s;\n  margin-top: -5px;\n}\n.tui-image-editor-container .tui-image-editor-checkbox-wrap.fixed-width{\n  width: 187px !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li{\n  margin-top: 8px;\n}\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li:nth-child(1){\n  margin-top: -20px;\n}\n\n.fp-active {\n  box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -moz-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -webkit-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n}\n.paddremov{\n  padding:0px;\n}\n.try_fro{\n  background-color: #0092FA;\n  color: #7DFEFF;\n  padding: 35px 22px;\n  border-bottom-right-radius: 75%;\n}\n.try_fro_content{\n  padding: 25px 22px 4px 22px;\n}\n.try_fro_content p{\n  color: #000;\n}\n.try_fro_content_bottom{\n  padding: 0px 22px;\n}\n.try_fro_content_bottom p{\n  color: #000;\n  font-size: 14px;\n}\n.try_fro_content_footer ul{\n  font-size: 14px;\n  padding:0px;\n  color: #000;\n}\n.fr-toolbar .fr-btn-grp:nth-child(1){\n  display: block;\n  float: none;\n}\n.fr-toolbar .fr-btn-grp{padding-bottom: 0px;\n}\n\n\n.fr-toolbar.fr-inline{\n  z-index: 999;\n}\n.pro-btn button{\n  background-color: #0789DC;\n  border: none;\n  color: #fff;\n  padding: 7px 12px;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-top: 7px;\n  outline: none !important;\n}\n.popupp{\n  z-index: 9999999999;\n}\n.download_botton button{\n  padding: 10px 25px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 25px;\n}\n.try_fro_content_footer{\n  display: flex;\n  justify-content: space-around;\n  padding: 0px 10px;\n}\n.try_fro h1{\n  font-weight: 300;\n  color: #7DFEFF;\n  margin: 0px;\n  line-height: 47px;\n}\n.fr-custom{\n  display: block !important;\n}\n.try_fro p{\n  color: #fff;\n  font-size: 35px;\n  margin: 0px;\n}\nbody.fp-add-view [data-block-type],\nbody.fp-add-view .fp-no-block {\n  margin-bottom: 20px;\n}\nbody.fp-add-view [data-block-type] {\n  user-select: none;\n  position: relative;\n}\nbody.fp-add-view section[data-block-type] {\n  cursor: move;\n}\nbody.fp-add-view [data-block-type]:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: block;\n  z-index: 10000;\n  content: "";\n}\n.fp-drop-placeholder {\n  height: 200px;\n  width: 100%;\n  border: solid 10px  #0098f7;\n  background: #FFF;\n  margin-bottom: 20px;\n}\n.fp-dragging {\n  display: none;\n}\n.fr-popup {\n  z-index: 999 !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu{\n  position: relative;\n}\n.fp-active{\n  display: inline-block;\n  width: 100%;\n border: 1px solid #4bb7e3;\n z-index: 99;\n}\nimg.fr-dib {\n  margin: 5px auto;\n  display: block;\n  float: none;\n  vertical-align: top;\n}\nspan.fr-emoticon.fr-emoticon-img {\n  background-repeat: no-repeat !important;\n  font-size: inherit;\n  height: 1em;\n  width: 1em;\n  min-height: 20px;\n  min-width: 20px;\n  display: inline-block;\n  margin: -.1em .1em .1em;\n  line-height: 1;\n  vertical-align: middle;\n}\n@media only screen and (max-width: 767px) {\n  .navbar .fr-view {\n    display: block;\n    align-items: unset;\n}\n}\n';

// DEFAULTS.
var options = {
  // Path to load design blocks thumbs.
  designsThumbsDir: 'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/screenshots/',

  // Path to load images for a design block.
  designsImagesDir: 'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/dist/imgs/',

  // Default block type to be selected.
  designsDefaultBlocks: 'Contents',

  // CSS to be injected.
  designStylesheets: [],

  // JS to be injected.
  designJavascripts: [],

  // Application default CSS.
  appStyle: STYLESHEET,

  // Buttons for a block.
  blockButtons: ['moveUp', 'remove', 'background_image', 'remove_background', 'background_color', 'duplicate_block', 'block_setting', 'merge_down', 'merge_up'],

  // licensing key for pages
  key: '',

  // display/hide download counter
  showDownloadCounter: true,

  // Page toolbar top buttons.
  pageTopButtons: [['edit']],

  // Page toolbar left buttons.
  pageLeftButtons: [['edit', 'layout', 'loadhtml'], ['desktop', 'tablet_landscape', 'tablet_portrait', 'phone']],

  // Page toolbar center buttons.
  pageCenterButtons: ['<div style="display: flex;"><span style="margin-top: 5px;">Powered by </span><a href="https://www.froala.com" style="display: inline-block; height: 20px; margin-left: 10px;" title="Froala" target="_blank"><svg style="height: 100%;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 225.8"><defs><style>.cls-1,.cls-2{fill:#0098f7;}.cls-2{stroke:#231f20;stroke-miterlimit:10;stroke-width:5px;}</style></defs><title>Froala Pages</title><path class="cls-1" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z" transform="translate(0 -61.94)"/><path class="cls-2" d="M30.4,167.64" transform="translate(0 -61.94)"/><path class="cls-1" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z" transform="translate(0 -61.94)"/></svg></a></div>'],

  // Page toolbar right buttons.
  pageRightButtons: [['download']],

  // Custom options for the editor.
  editorOptions: {
    iconsTemplate: 'font_awesome_5',
    linkList: [{
      text: 'Froala',
      href: 'https://froala.com',
      target: '_blank'
    }, {
      text: 'Google',
      href: 'https://google.com',
      target: '_blank'
    }, {
      text: 'Facebook',
      href: 'https://facebook.com'
    }]
  }
};

// Designs panel.

var Panel = function (_M) {
  inherits(Panel, _M);

  function Panel() {
    classCallCheck(this, Panel);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Panel.prototype.init = function init(title, content) {
    this.el = this.doc.createElement('DIV');
    this.el.setAttribute('class', 'fp-panel');

    this._addTitle(title);
    this._addContent(content);

    Helpers.append(this.page.container, this.el);

    this.render();
  };

  Panel.prototype._addContent = function _addContent(content) {
    var body = this.doc.createElement('DIV');
    body.setAttribute('class', 'fp-panel-body');

    if (content) {
      body.innerHTML = content;
    }

    Helpers.append(this.el, body);

    this.body = body;
  };

  Panel.prototype._addTitle = function _addTitle(title) {
    var head = this.doc.createElement('DIV');
    head.setAttribute('class', 'fp-panel-head');

    if (title) {
      var headTitle = this.doc.createElement('H2');
      headTitle.innerHTML = title;

      Helpers.append(head, headTitle);
    }

    Helpers.append(this.el, head);

    this.head = head;
  };

  Panel.prototype.show = function show() {
    this.el.classList.add('fp-visible');
  };

  Panel.prototype.hide = function hide() {
    this.el.classList.remove('fp-visible');
  };

  Panel.prototype.isVisible = function isVisible() {
    return this.el.classList.contains('fp-visible');
  };

  return Panel;
}(Module);

// Designs Panel is the zone where we can choose a design block to use.

var DesignsPanel = function (_Panel) {
  inherits(DesignsPanel, _Panel);

  function DesignsPanel() {
    classCallCheck(this, DesignsPanel);
    return possibleConstructorReturn(this, _Panel.apply(this, arguments));
  }

  DesignsPanel.prototype.render = function render() {
    this._initFilters();
    this._initPanel();

    this.loadedDesigns = {};
  };

  // Filter the current shown design blocks.


  DesignsPanel.prototype._initFilters = function _initFilters() {
    var _this2 = this;

    // Add filter.
    var filter = document.createElement('DIV');
    filter.classList.add('fp-panel-filter');

    Helpers.append(this.head, filter);

    // Render the curent selected design blocks.

    var _loop = function _loop(blockType) {
      if (Object.prototype.hasOwnProperty.call(DesignBlock.BLOCKS, blockType)) {
        var btn = _this2.doc.createElement('A');
        btn.setAttribute('data-block-type', Helpers.underscores(blockType));
        btn.innerHTML = blockType;

        Helpers.append(filter, btn);

        _this2.events.on(btn, 'click', function () {
          return _this2.setActiveBlock(blockType);
        });
      }
    };

    for (var blockType in DesignBlock.BLOCKS) {
      _loop(blockType);
    }

    // Store filter.
    this.filter = filter;
  };

  DesignsPanel.prototype._initPanel = function _initPanel() {
    // Create panel for displaying contents.
    var panel = document.createElement('DIV');
    panel.classList.add('fp-panel-panel');

    this.panel = panel;
    Helpers.append(this.body, panel);
  };

  // Refresh the filters based on the current active block type.


  DesignsPanel.prototype._refreshFilters = function _refreshFilters(blockType) {
    // Hide all panels.
    var activeBlock = this.panel.querySelector('.fp-panel-blocks-wrapper.fp-visible');
    if (activeBlock) {
      activeBlock.classList.remove('fp-visible');
      this.filter.querySelector('a.fp-active').classList.remove('fp-active');
    }

    this.filter.querySelector('a[data-block-type="' + Helpers.underscores(blockType) + '"]').classList.add('fp-active');
  };

  // Refresh designs based on the current active block type.


  DesignsPanel.prototype._refreshDesigns = function _refreshDesigns(blockType) {
    var wp = void 0;

    // Designs for the current filter weren't added yet.
    if (!this.loadedDesigns[Helpers.underscores(blockType)]) {
      wp = document.createElement('DIV');
      wp.setAttribute('data-block-type', Helpers.underscores(blockType));
      wp.classList.add('fp-panel-blocks-wrapper');

      Helpers.append(this.panel, wp);

      for (var i = 1; i <= DesignBlock.BLOCKS[blockType].length; i++) {
        var designBlock = new DesignBlock(this, blockType, DesignBlock.BLOCKS[blockType][i - 1]);
        Helpers.append(wp, designBlock.el);
      }

      this.loadedDesigns[Helpers.underscores(blockType)] = true;
    } else {
      wp = this.panel.querySelector('div.fp-panel-blocks-wrapper[data-block-type="' + Helpers.underscores(blockType) + '"]');
    }

    // Toggle classes to show the right designs.
    wp.classList.add('fp-visible');
  };

  // Set the current active block type.


  DesignsPanel.prototype.setActiveBlock = function setActiveBlock() {
    var blockType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sections';

    // Set default block type.
    if (blockType === 'Sections') {
      blockType = this.opts.designsDefaultBlocks;
    }

    // Refresh filters.
    this._refreshFilters(blockType);

    // Refresh shown designs.
    this._refreshDesigns(blockType);
  };

  return DesignsPanel;
}(Panel);

// Init editor on the current blocks.

var Editor = function (_M) {
  inherits(Editor, _M);

  function Editor() {
    classCallCheck(this, Editor);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Editor.prototype.init = function init() {}
  // Init placeholder.


  // Merge the editor configurations
  ;

  Editor.prototype._mergeEditorOpts = function _mergeEditorOpts(userOpts, pagesOpts) {
    var _loop = function _loop(config) {
      // Combine 'initialized' event handler if user has configured same.
      if (config === 'events' && userOpts[config] && userOpts[config].hasOwnProperty('initialized')) {
        var sourceMethod = pagesOpts[config].initialized,
            targetMethod = userOpts[config].initialized,
            eventsMerged = Object.assign({}, pagesOpts[config], {
          initialized: function initialized() {
            new Function(sourceMethod.apply(this)).call();
            new Function(targetMethod.apply(this)).call();
          }
        });
        // Merge the combined initialized event handler with other event handlers
        Object.assign(userOpts[config], eventsMerged);
      } else if (_typeof(userOpts[config]) === 'object') {
        if (Array.isArray(userOpts[config])) {
          userOpts[config] = [].concat(userOpts[config], pagesOpts[config]);
          // Filter the duplicated items
          userOpts[config] = userOpts[config].filter(function (item, index) {
            return userOpts[config].indexOf(item) === index;
          });
        } else {
          Object.assign(userOpts[config], pagesOpts[config]);
        }
      } else if (!userOpts.hasOwnProperty(config)) {
        userOpts[config] = pagesOpts[config];
      }
    };

    for (var config in pagesOpts) {
      _loop(config);
    }
    return userOpts;
  };

  Editor.prototype._preventTypingInLinks = function _preventTypingInLinks(editor) {
    editor.events.on('keydown', function (kde) {
      if (editor.link.get()) {
        kde.preventDefault();

        return false;
      }

      return true;
    }, true);
  };

  Editor.prototype._isTrialExpire = function _isTrialExpire() {
    return 'in-trial';
    var expiryDate = window.localStorage.getItem('FroalaTrialExpiry');
    if (!expiryDate) {
      return 'not-in-trial';
    }
    var currentDate = new Date().getTime();
    if (currentDate > expiryDate) {
      return 'expire';
    }
    return 'in-trial';
  };

  Editor.prototype._createButton = function _createButton(className) {
    var modalId = this._isTrialExpire() === 'expire' ? '#myModal2' : '#myModal';
    var btn = document.createElement('BUTTON');
    btn.innerHTML = 'Upgrade to Pro!';
    btn.setAttribute('type', 'button');
    btn.setAttribute('data-toggle', 'modal');
    btn.setAttribute('data-target', modalId);
    btn.addEventListener('touchstart', function () {
      var iframe = document.getElementById('froala-pages');
      var mobileEle = iframe.contentWindow.document.getElementsByClassName('fr-mobile');
      mobileEle[0].classList.add('fr-custom');
    });
    var proToolBars = document.createElement('DIV');
    proToolBars.setAttribute('class', 'fr-btn-grp fr-float-left pro-btn ' + className);
    proToolBars.appendChild(btn);

    return proToolBars;
  };

  Editor.prototype._addProButtonForText = function _addProButtonForText() {
    var iframe = document.getElementById('froala-pages');
    if (!iframe.contentWindow.document.getElementsByClassName('pro-btn-text').length > 0) {
      var proToolBars = this._createButton('pro-btn-text');
      var newlineElement = iframe.contentWindow.document.getElementsByClassName('fr-newline');
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-toolbar');
      toolbarsElement[0].insertBefore(proToolBars, newlineElement[0]);
      var childNodes = toolbarsElement[0].childNodes[1].getElementsByTagName('button');
      for (var i = 0; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
    }
  };

  Editor.prototype._addProButtonForImage = function _addProButtonForImage() {
    var iframe = document.getElementById('froala-pages');
    if (!iframe.contentWindow.document.getElementsByClassName('pro-btn-image').length > 0) {
      var proToolBars = this._createButton('pro-btn-image');
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-popup');
      var newlineElement = iframe.contentWindow.document.getElementsByClassName('fr-tooltip');
      toolbarsElement[0].insertBefore(proToolBars, newlineElement[0]);
      var childNodes = toolbarsElement[0].childNodes[0].getElementsByTagName('button');
      for (var i = 1; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
      toolbarsElement[0].classList.add('fr-imageProButton');
    }
  };

  Editor.prototype._downloadEditor = function _downloadEditor() {
    var currentDate = new Date();
    var experyDate = new Date(currentDate.setDate(currentDate.getDate() + 7)).getTime();
    window.localStorage.setItem('FroalaTrialExpiry', experyDate);
    var iframe = document.getElementById('froala-pages');
    var proElement = iframe.contentWindow.document.getElementsByClassName('pro-toolbar');
    for (var i = 0; i < proElement.length; i++) {
      proElement[i].classList.remove('fr-disabled', 'pro-toolbar');
    }
    window.open('https://froala.com/wysiwyg-editor/');
    window.location.reload();
  };

  Editor.prototype._addDownloadModal = function _addDownloadModal() {
    var popupElement = document.createElement('div');
    popupElement.id = 'trial_popup';
    popupElement.innerHTML = '\n      <div class="modal popupp fade" id="myModal">\n        <div class="modal-dialog modal-dialog-centered">\n          <div class="modal-content">\n            <!-- Modal Header -->\n            <!-- Modal body -->\n            <div class="modal-body paddremov">\n            <div class="try_fro">\n            <h1>Try Froala Editor</h1>\n            <p><b>For Free</b></p>\n            </div>\n            <div class="try_fro_content">\n            <p>Start your trial today and receive <b>7 days of free technical support </b> to get you started. </p>\n            </div>\n            <div class="try_fro_content_bottom">\n            <p>Here are some of the benefits you\'ll get from using froala WYSIWIG Editor:</p>\n            </div>\n            <div class="try_fro_content_footer">\n            <ul>\n            <li>7 days of free technical support</li>\n            <li>Developer Friendly</li>\n            <li>Out-of-the-box plugins</li>\n            <li>Easy to Extend</li>\n            </ul>\n            <div class="download_botton">\n            <button type="button" class="btn btn-primary"  data-dismiss="modal" onclick="downloadEditor()">\n              Download <br/> now!\n            </button>\n            </div>\n            </div>\n            </div>\n            <!-- Modal footer -->\n          </div>\n        </div>\n      </div>\n      <div class="modal popupp fade" id="myModal2">\n        <div class="modal-dialog modal-dialog-centered">\n          <div class="modal-content">\n            <!-- Modal Header -->\n            <!-- Modal body -->\n            <div class="modal-body paddremov">\n            <div class="try_fro">\n            <p><b>Your trial period has expired</b></p>\n            </div>\n            <div class="try_fro_content">\n            <p></p>\n            </div>\n            <div class="try_fro_content_bottom">\n            <p></p>\n            </div>\n            <div class="try_fro_content_footer">\n            <ul>\n            </ul>\n            <div class="download_botton">\n            <button type="button" class="btn btn-primary"  data-dismiss="modal" onclick="window.open(\'https://froala.com/wysiwyg-editor/pricing/\')">\n              Purchase  Now!\n            </button>\n            </div>\n            </div>\n            </div>\n            <!-- Modal footer -->\n          </div>\n        </div>\n      </div>\n      ';
    var iFrameEl = document.getElementById('froala-pages');
    var containerEle = iFrameEl.contentWindow.document.getElementsByClassName('container');

    // Finally, append the element to the HTML
    containerEle[0].appendChild(popupElement);
    document.getElementById('froala-pages').contentWindow.downloadEditor = this._downloadEditor;
  };

  Editor.prototype.disableForBlock = function disableForBlock(block) {
    var isHeader = block.blockType === DesignBlock.HEADER;
    var isFooter = block.blockType === DesignBlock.FOOTER;
    block.el.querySelectorAll('[class*="col"]').forEach(function (col) {
      col['data-froala.editor'] && col['data-froala.editor'].destroy();
    });


    if (isFooter) {
      block.el.querySelectorAll('footer .nav-link, footer nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    }
    if (isHeader) {
      block.el.querySelectorAll('header .nav-link, header nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    }
  }

  Editor.prototype.enableForBlock = function enableForBlock(block) {
    var me = this;
    var isHeader = block.blockType === DesignBlock.HEADER;
    var isFooter = block.blockType === DesignBlock.FOOTER;
    block.el.querySelectorAll('[class*="col"]').forEach(function (col) {
      // No link inside it.
      if (!col.querySelector('.nav-link')) {
        new me.FroalaEditor('[class*="col"]', me.opts.editorOptions);
      }
    });

    if (isHeader) {
      new me.FroalaEditor('header .nav-link, header nav a.btn, header img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkButton', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    }

    if (isFooter) {
      // Init editor on footer links.
      new me.FroalaEditor('footer .nav-link, footer nav a.btn, footer img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    }
  }

  Editor.prototype.enable = function enable(variables = [], imageAutoCropEnabled = false, imageProcessLimits = null) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;

    if (!this.FroalaEditor) return;

    this._defineLinkButtons();
    this._defineCustomFontSizeButton();
    // Add custom image setting option
    this.customImageVariableOptions(variables)
    this.cropImageOptions(variables, imageAutoCropEnabled, imageProcessLimits)
    this.imageBorderOptions();
    this.imageBackgroundColor();

    this.customVideoVariableOptions(variables)

    // Custom Paste Plugin
    this.customPastePlugin()

    // Custom Button buttons for text and background color
    this.customColorPickerButtonPlugin();

    this._defineFontButtons();

    // this._addDownloadModal();

    // scope reference used in initialized method
    var me = this;
    me._mergeEditorOpts(me.opts.editorOptions, {
      toolbarInline: true,
      pluginsEnabled: ['image', 'link', 'align', 'colors', 'emoticons', 'video', 'paragraphFormat', 'fontSize', 'fontFamily', 'table', 'lists', 'lineHeight', 'fontAwesome', 'imageTUI', 'imageVariable','videoVariable', 'customPaste', 'customButtonColorPicker','crop','fontFit', 'imgBorder', 'imgBorderColor','imgBackground'],
      toolbarButtons: ['bold', 'italic', 'textColor', 'backgroundColor', 'paragraphFormat', 'align', 'emoticons', 'insertLink', 'insertImage', 'undo', 'redo', '-', 'underline', 'subscript', 'superscript', 'fontSize', 'fontFamily', 'insertTable', 'formatOL', 'formatUL', 'lineHeight', 'insertVideo', 'fontAwesome', 'autoFontFit'],
      initOnClick: true,
      colorsHEXInput: false,
      keepFormatOnDelete: true,
      toolbarVisibleWithoutSelection: false,
      listAdvancedTypes: true,
      imageEditButtons: ['imageReplace', 'imageVariableButton','-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize','cropImage', 'imageBorder','imageBackgroundColor'], // imageTUI, imageStyle
      videoEditButtons: ['videoReplace', 'videoVariableButton', 'videoRemove', 'videoDisplay', 'videoAlign', 'videoSize', 'autoplay'],
      linkEditButtons: ['linkEdit', 'linkButton', 'linkRemove', 'bold', 'italic', 'buttonFontSize', 'fontFamily', 'textColorButton', 'backgroundColorButton', 'backgroundBorderButton', 'backgroundHoverColorButton'],
      htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'svg', 'path'],
      htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'social_images', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'fill', 'viewBox', 'xmlns', 'd', 'onmouseover', 'onmouseout', 'fix-font'],
      events: {
        initialized: function initialized() {
          // this is the editor instance.
          me._preventTypingInLinks(this);
          me._replaceImageSourceWithBase64(this);
          if (me.page.pageToolbar.ul && me._isTrialExpire() === 'not-in-trial' || me._isTrialExpire() === 'expire') {
            me._addProButtonForText();
            this.$el.on('click', 'img', function () {
              return me._addProButtonForImage();
            });
          }
        },
        'paste.before': function (e) {
          let pasteData = {};
          let types = e.clipboardData.types;
          for (let i = 0; i < types.length; i++) {
            if (types[i] !== 'text/html') {
              pasteData[types[i]] = e.clipboardData.getData(types[i]);
            } else {
              let pasteContent = e.clipboardData.getData(types[i]);
              if (this.helpers.isIOS() || this.helpers.isMac()) {
                pasteData[types[i]] = pasteContent;
              } else {
                pasteData[types[i]] = pasteContent.match(/(StartFragment-->)(.*?<!--EndFragment)/g)
                if (pasteData[types[i]] && pasteData[types[i]][0]) {
                  pasteData[types[i]] = pasteData[types[i]][0].replace('StartFragment-->', '').replace('<!--EndFragment', '');
                }
              }
            }
          }
          Object.assign(me.FroalaEditor, {
            PASTE_DATA: pasteData
          });
          return false;
        },
        'mousedown': function(mousedownEvent) {
          Object.assign(me.FroalaEditor, {
            SELECTED_TARGET: mousedownEvent.target
          });
        }
      }
    });

    // Enable editor on all blocks.
    this.page.iframeBody.querySelectorAll('[data-block-type]').forEach(function (block) {
      // Enable editor on cols.
      block.querySelectorAll('[class*="col"]').forEach(function (col) {
        // No link inside it.
        if (!col.querySelector('.nav-link')) {
          new me.FroalaEditor('[class*="col"]', me.opts.editorOptions);
        }
      });

      // Init editor on header links.
      new me.FroalaEditor('header .nav-link, header nav a.btn, header img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkButton', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));

      // Init editor on footer links.
      new me.FroalaEditor('footer .nav-link, footer nav a.btn, footer img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    });
  };

  // Disable editor.


  Editor.prototype.disable = function disable() {
    this.page.iframeBody.querySelectorAll('[data-block-type]').forEach(function (block) {
      block.querySelectorAll('[class*="col"]').forEach(function (col) {
        col['data-froala.editor'] && col['data-froala.editor'].destroy();
      });

      // disable editor on header/footer links
      block.querySelectorAll('footer .nav-link, footer nav a.btn, header .nav-link, header nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    });
  };

  // Create custom buttons for links.


  Editor.prototype._defineCustomFontSizeButton = function _defineCustomFontSizeButton() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "fontFit.popup";
    var customPlugin = "fontFit";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });

    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var width = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-width" type="text" placeholder="' + editor.language.translate('Width') + '" tabIndex="1"></div></div>';
        var height = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-height" type="text" title="height" placeholder="' + editor.language.translate('Height') + '" tabIndex="1" aria-required="true"></div></div>';
        var minFontSize = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-minFont" type="text" placeholder="' + editor.language.translate('Min Size') + '" tabIndex="1"></div></div>';
        var maxFontSize = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-maxFont" type="text" placeholder="' + editor.language.translate('Max Size') + '" tabIndex="1"></div></div></div>';
        var alignVert = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignVert fr-command fr-submit" id="fr-font-align-vert" data-cmd="alignVert" data-param1="true"><i class="fa fa-arrows-v" title="align vertical"></i><span class="pl-2">align vertical</span></div></div>';
        var alignHoriz = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignHoriz fr-command fr-submit" id="fr-font-align-horiz" data-cmd="alignHoriz" data-param1="true"><i class="fa fa-arrows-h" title="align horizontal"></i><span class="pl-2">align horizotal</span></div></div>';
        var multiLine = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line multiLine fr-command fr-submit" id="fr-font-multiline" data-cmd="multiLine" data-param1="true"><i class="fa fa-align-justify" title="multiline"></i><span class="pl-2">multiline</span></div></div>';
        var detectMultiLine = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line detectMultiLine fr-command fr-submit" id="fr-font-detect-multiline" data-cmd="detectMultiLine" data-param1="true"><i class="fa fa-indent" title="detect multiline"></i><span class="pl-2">single line</span></div></div>';
        var reProcess = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line reProcess fr-command fr-submit" id="fr-font-reprocess" data-cmd="reProcess" data-param1="true"><i class="fa fa-refresh" title="Reprocess"></i><span class="pl-2">reprocess</span></div></div>';
        var widthOnly = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line widthOnly fr-command fr-submit" id="fr-font-width-only" data-cmd="widthOnly" data-param1="true"><i class="fa fa-exchange" title="width only"></i><span class="pl-2">width only</span></div></div>';
        var alignVertWithFlexbox = '<div class="fr-my-layer fr-layer fr-active" style="width: 51%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignVertWithFlexbox fr-command fr-submit" id="fr-font-flexbox" data-cmd="alignVertWithFlexbox" data-param1="true"><i class="fa fa-th" title="align vertical with flexbox"></i><span class="pl-2">align vertical with flexbox</span></div></div>';
        var clearButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end ml-auto"><button type="button" class="fr-command fr-submit clearFontButton" data-cmd="clearFontButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end ml-auto"><button type="button" class="fr-command fr-submit autoFontFixButton" data-cmd="autoFontFixButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div></div></div>';

        var html = '<div><div class="">' +
          '<div class="d-flex align-items-center justify-content-center">'.concat(width).concat(height).concat(minFontSize).concat(maxFontSize,'<div class="d-flex flex-wrap align-items-center justify-content-between px-2" style="max-width: 500px">')
            .concat(alignVert).concat(alignHoriz).concat(multiLine).concat(detectMultiLine).concat(reProcess).concat(widthOnly).concat(alignVertWithFlexbox).concat(clearButton).concat(updateButton)

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('autoFontFixButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var element = that.FroalaEditor.SELECTED_TARGET;
            let parent = element.parentNode;
            let grandParent = parent.parentNode;
            if(element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
              let parent = element.parentNode;
              let grandParent = parent.parentNode;
              autoTextFit(grandParent, element)
            }
            else {
              let parent = element.parentNode;
              var wrapper = document.createElement('div');
              parent.replaceChild(wrapper, element);
              wrapper.appendChild(element);
              wrapper.setAttribute('data-font-fix',val);
              wrapper.setAttribute('class','auto-text-fit');
              autoTextFit(wrapper, element)
            }
            this[customPlugin].back();
          }
        });

        that.FroalaEditor.RegisterCommand('clearFontButton', {
          undo: false,
          focus: false,
          callback: function () {
            let element = that.FroalaEditor.SELECTED_TARGET;
            if(element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
              let parent = element.parentNode;
              let grandParent = parent.parentNode;
              // parent.removeAttribute('class');
              // parent.style = null;
              // grandParent.removeAttribute('class');
              // grandParent.style = null;
              grandParent.replaceWith(element);
              clearElements(element);
              element.removeAttribute('data-height');
              element.removeAttribute('data-width');
              element.removeAttribute('data-max-size');
              element.removeAttribute('data-min-size');
              element.removeAttribute('data-align-horiz');
              element.removeAttribute('data-align-vert');
              element.removeAttribute('data-multiline');
              element.removeAttribute('data-detect-multiline');
              element.removeAttribute('data-reprocess');
              element.removeAttribute('data-width-only');
              element.removeAttribute('data-flexbox');
              element.removeAttribute('data-font-fitted');
            }
          }
        });

        that.FroalaEditor.RegisterCommand('alignVert', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-align-vert');
          }
        });

        that.FroalaEditor.RegisterCommand('alignHoriz', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-align-horiz');
          }
        });

        that.FroalaEditor.RegisterCommand('multiLine', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-multiline');
          }
        });

        that.FroalaEditor.RegisterCommand('detectMultiLine', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-detect-multiline');
          }
        });

        that.FroalaEditor.RegisterCommand('reProcess', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-reprocess');
          }
        });

        that.FroalaEditor.RegisterCommand('widthOnly', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-width-only');
          }
        });

        that.FroalaEditor.RegisterCommand('alignVertWithFlexbox', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-flexbox');
          }
        });


        that.FroalaEditor.RegisterCommand('popupClose', {
          title: 'Close',
          icon: 'imageBack',
          undo: false,
          focus: false,
          callback: function () {
            this[customPlugin].back()
          }
        });

        function unSetToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
        }

        function unSetTextBox(textboxId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = "";
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.remove("fr-not-empty");
        }

        function clearElements(element) {
          unSetTextBox('fr-font-height');
          unSetTextBox('fr-font-width');
          unSetTextBox('fr-font-maxFont');
          unSetTextBox('fr-font-minFont');
          unSetToolBox('fr-font-align-vert', 'data-align-vert', element);
          unSetToolBox('fr-font-align-horiz', 'data-align-horiz', element);
          unSetToolBox('fr-font-multiline', 'data-multiline', element);
          unSetToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
          unSetToolBox('fr-font-reprocess', 'data-reprocess', element);
          unSetToolBox('fr-font-width-only', 'data-width-only', element);
          unSetToolBox('fr-font-flexbox', 'data-flexbox', element);
        }

        function setTool(elementId) {
          var iFrameEl = document.getElementById('froala-pages');
          var tool = iFrameEl.contentWindow.document.getElementById(elementId);
          if(!tool.getAttribute('data-font-active')) {
            tool.setAttribute('data-font-active',"true");
            tool.style.color = '#0074CC';
          }
          else {
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
          }
        }

        function getTool(elementId) {
          var iFrameEl = document.getElementById('froala-pages');
          return iFrameEl.contentWindow.document.getElementById(elementId).getAttribute('data-font-active');
        }

        function autoTextFit(ele, target) {
          var iFrameEl = document.getElementById('froala-pages');
          const height = iFrameEl.contentWindow.document.getElementById('fr-font-height').value;
          const width = iFrameEl.contentWindow.document.getElementById('fr-font-width').value;
          const maxSize = iFrameEl.contentWindow.document.getElementById('fr-font-maxFont').value;
          const minSize = iFrameEl.contentWindow.document.getElementById('fr-font-minFont').value;
          const alignVert = getTool('fr-font-align-vert');
          const alignHoriz = getTool('fr-font-align-horiz');
          const multiline = getTool('fr-font-multiline');
          const detectMultiline = getTool('fr-font-detect-multiline');
          const reProcess = getTool('fr-font-reprocess');
          const widthOnly = getTool('fr-font-width-only');
          const alignVertWithFlexbox = getTool('fr-font-flexbox');

          ele.style.fontSize = null;
          target.style.fontSize = null;
          if(target.tagName === "H1" || target.tagName === "H2" || target.tagName === "H3" || target.tagName === "H4" || target.tagName === "H5" || target.tagName === "H6") {
              target.style.fontSize = 'inherit';
          }
          let parent = target.parentNode;
          let grandParent = parent.parentNode;

          const fontFixObj = {};
          if(height) {
            ele.style.height = `${height}px`;
            target.setAttribute('data-height',height);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            ele.style.height = null;
            target.removeAttribute('data-height');
          }
          if(width) {
            ele.style.width = `${width}px`;
            target.setAttribute('data-width',width);
            target.setAttribute('data-font-fitted',"true");
          }
          else{
            ele.style.width = null;
            target.removeAttribute('data-width')
          }
          if(maxSize){
            fontFixObj['maxFontSize'] = Number(maxSize);
            target.setAttribute('data-max-size',maxSize);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-max-size')
          }
          if(minSize) {
            fontFixObj['minFontSize'] = Number(minSize);
            target.setAttribute('data-min-size',minSize);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-min-size')
          }
          if(alignVert) {
            fontFixObj['alignVert'] = true;
            target.setAttribute('data-align-vert',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-align-vert')
            fontFixObj['alignVert'] = false;
            if (parent) {
              if(parent.style.position) parent.style.position = null;
              if(parent.style.top) parent.style.top = null;
              if(parent.style.right) parent.style.right = null;
              if(parent.style.bottom) parent.style.bottom = null;
              if(parent.style.left) parent.style.left = null;
              if(parent.style.margin) parent.style.margin = null;
              if(parent.style.display) parent.style.display = 'inline-block';
              if(parent.style.justifyContent) parent.style.justifyContent = null;
              if(parent.style.flexDirection) parent.style.flexDirection = null;
              parent.classList.remove('textFitAlignVert');
            }
          }
          if(alignHoriz) {
            target.setAttribute('data-align-horiz',"true")
            fontFixObj['alignHoriz'] = true;
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-align-horiz')
            fontFixObj['alignHoriz'] = false;
            if (parent) {
              parent.style.textAlign = null;
            }
            if (grandParent)  {
              grandParent.style.textAlign = null;
            }
          }
          if(multiline) {
            fontFixObj['multiLine'] = true;
            target.setAttribute('data-multiline',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-multiline')
            fontFixObj['multiLine'] = false;
          }
          if(detectMultiline) {
            fontFixObj['detectMultiLine'] = false;
            target.setAttribute('data-detect-multiline',"false");
            target.setAttribute('data-font-fitted',"true");
            // ele.style.height = null;
            if(maxSize || minSize) {
              delete fontFixObj['maxFontSize'];
              delete fontFixObj['minFontSize'];
            }
          }
          else {
            target.removeAttribute('data-detect-multiline');
            fontFixObj['detectMultiLine'] = true;
            let parent = target.parentNode;
            let grandParent = parent.parentNode;
            parent.style.fontSize = null;
            grandParent.style.removeProperty('white-space');
            parent.style.whiteSpace = null;
          }
          if(reProcess) {
            fontFixObj['reProcess'] = false;
            target.setAttribute('data-reprocess',"false");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['reProcess'] = true;
            target.removeAttribute('data-reprocess')
          }
          if(widthOnly) {
            fontFixObj['widthOnly'] = true;
            target.setAttribute('data-width-only',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['widthOnly'] = false;
            target.removeAttribute('data-width-only')
          }
          if(alignVertWithFlexbox) {
            fontFixObj['alignVertWithFlexbox'] = true;
            target.setAttribute('data-flexbox',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['alignVertWithFlexbox'] = false;
            target.removeAttribute('data-flexbox')
          }
          textFit(ele,fontFixObj);
          let spanCss = window.getComputedStyle(ele.childNodes[0]);
          let spanWidth = parseInt(spanCss.width, 10);
          let spanHeight = parseInt(spanCss.height, 10);
          if(spanWidth > width || spanHeight > height) {
            if(target.getAttribute('data-max-size') || target.getAttribute('data-min-size')) {
              delete fontFixObj['maxFontSize'];
              delete fontFixObj['minFontSize'];
              textFit(ele,fontFixObj);
            }
          }
          // afterFontFix(target, fontFixObj);
          setTimeout(() => {
            let parentEle = ele.childNodes[0];
            if(target.getAttribute('data-align-vert') === "true") {
              // let grandParent = parent.parentNode;
              if (parentEle) {
                parentEle.style.position = 'absolute';
                parentEle.style.top = '0';
                parentEle.style.right = '0';
                parentEle.style.bottom = '0';
                parentEle.style.left = '0';
                parentEle.style.margin = 'auto';
                parentEle.style.display = 'flex';
                parentEle.style.justifyContent = 'center';
                parentEle.style.flexDirection = 'column';
              }
            }
            ele.style.whiteSpace = null;
          },15)
        }

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();


        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-command[data-cmd="autoFontFit"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }

    this.FroalaEditor.DefineIcon('autoFontFit', { NAME: 'text-width', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('autoFontFit', {
      title: 'Auto Font Fit',
      icon: 'autoFontFit',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'fontFit',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          var element = that.FroalaEditor.SELECTED_TARGET;
          // let style = window.getComputedStyle(element);
          let style = element.style.fontSize;
          if (style) {
            element.setAttribute('org-size',style);
          }
          clearElements(element);
          if (element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
            setTextBox('fr-font-height','data-height');
            setTextBox('fr-font-width','data-width');
            setTextBox('fr-font-maxFont','data-max-size');
            setTextBox('fr-font-minFont','data-min-size');
            setToolBox('fr-font-align-vert', 'data-align-vert', element);
            setToolBox('fr-font-align-horiz', 'data-align-horiz', element);
            setToolBox('fr-font-multiline', 'data-multiline', element);
            setToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
            setToolBox('fr-font-reprocess', 'data-reprocess', element);
            setToolBox('fr-font-width-only', 'data-width-only', element);
            setToolBox('fr-font-flexbox', 'data-flexbox', element);
          }
          else {
            clearElements(element);
          }

        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }

        function setTextBox(textboxId, valueId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = element.getAttribute(valueId);
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.add("fr-not-empty");
        }

        function unSetTextBox(textboxId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = "";
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.remove("fr-not-empty");
        }

        function setToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
          if(element.getAttribute(valueId)) {
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.setAttribute('data-font-active',"true");
            tool.style.color = '#0074CC';
          }
        }

        function unSetToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
          if(!element.getAttribute(valueId)) {
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
          }
        }

        function clearElements(element) {
          unSetTextBox('fr-font-height');
          unSetTextBox('fr-font-width');
          unSetTextBox('fr-font-maxFont');
          unSetTextBox('fr-font-minFont');
          unSetToolBox('fr-font-align-vert', 'data-align-vert', element);
          unSetToolBox('fr-font-align-horiz', 'data-align-horiz', element);
          unSetToolBox('fr-font-multiline', 'data-multiline', element);
          unSetToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
          unSetToolBox('fr-font-reprocess', 'data-reprocess', element);
          unSetToolBox('fr-font-width-only', 'data-width-only', element);
          unSetToolBox('fr-font-flexbox', 'data-flexbox', element);
        }
      },
      refresh: function refresh(ele) {

      }
    });
  };

  Editor.prototype._defineLinkButtons = function _defineLinkButtons() {
    var that = this;

    // Remove link.
    this.FroalaEditor.DefineIcon('linkDestroy', {
      NAME: 'trash'
    });
    this.FroalaEditor.RegisterCommand('linkDestroy', {
      type: 'button',
      title: 'Remove Link',
      callback: function callback() {
        var $oel = this.$oel;

        this.destroy();

        // Footer case.
        if ($oel.parents('.nav-item').length === 0) {
          $oel.remove();
        } else {
          $oel.parent().remove();
        }
      },
      refresh: function refresh($btn) {
        // Footer case.
        if (this.$oel.parent('.nav-item').length === 0) {
          $btn.get(0).classList.toggle('fr-disabled', this.$oel.siblings('.nav-link').length === 0);
        } else {
          $btn.get(0).classList.toggle('fr-disabled', this.$oel.parents('.nav-item').siblings('.nav-item').length === 0);
        }

        that.enable();
      }
    });

    // Add link.
    this.FroalaEditor.DefineIcon('linkAdd', {
      NAME: 'plus'
    });

    // Image TUI
    this.FroalaEditor.RegisterCommand('imageTUI', {
      title: 'Advanced Edit',
      undo: false,
      focus: false,
      callback: function callback(cmd, val) {

        var ele = document.getElementsByClassName('fp-block-toolbar');
        if (ele.length > 0) {
          ele[0].classList.remove('fp-visible');
        }
        this.imageTUI.launch(this, true);
      },
      plugin: 'imageTUI'
    });

    this.FroalaEditor.RegisterCommand('linkAdd', {
      type: 'button',
      title: 'Add Link',
      callback: function callback() {
        var $oel = this.$oel;

        // Footer case.
        if ($oel.parents('.nav-item').length === 0) {
          $oel.after('<a class="nav-link" href="https://www.froala.com">Link</a>');
        } else {
          $oel.parent().after('<li class="nav-item"><a class="nav-link" href="https://www.froala.com">Link</a></li>');
        }
      }
    });

    // Link button type.
    this.FroalaEditor.DefineIcon('linkButton', {
      NAME: 'star'
    });

    this.FroalaEditor.DefineIcon('insertVideo', {
      NAME: 'video-camera',
      FA5NAME: 'video',
      SVG_KEY: 'insertVideo'
    });

    this.FroalaEditor.RegisterCommand('linkButton', {
      type: 'dropdown',
      title: 'Choose Style',
      options: {
        link: 'Link',
        button: 'Button',
        outline: 'Outline'
      },
      callback: function callback(cmd, val) {
        var link = this.link.get();

        if (val === 'link') {
          link.classList.add('nav-link');
          link.classList.remove('btn', 'btn-primary', 'btn-outline-primary');
        } else if (val === 'button') {
          link.classList.remove('nav-link', 'btn-outline-primary');
          link.classList.add('btn', 'btn-primary');
        } else if (val === 'outline') {
          link.classList.remove('nav-link', 'btn-primary');
          link.classList.add('btn', 'btn-outline-primary');
        }
      }
    });
  };

  Editor.prototype.customImageVariableOptions = function customImageVariableOptions(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imageVariable.popup";
    var customPlugin = "imageVariable";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      var imageSrcOptions = {
        'none': [{name: "None", key: "", valueType: ['text', 'all']}],
      };
      if (variables) {
        imageSrcOptions = {
          'none': [{name: "None", key: "", valueType: ['text', 'all']}],
          ...variables
        }
      }
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template - icon when empty, icon + text + clear when selected
        var pickerButton = '<div class="imageSrcVariablePicker" style="display:flex;align-items:center;cursor:pointer;padding:4px 8px;" title="Select Variable">';
        pickerButton += '<span class="imageSrcVariableIcon" style="display:inline-flex;width:20px;height:20px;">' + editor.icon.create('variables') + '</span>';
        pickerButton += '<span class="imageSrcVariableLabel d-none" style="margin-left:4px;font-size:13px;white-space:nowrap;color:#333;"></span>';
        pickerButton += '<span class="imageSrcVariableClear d-none" style="cursor:pointer;color:#999;font-size:16px;margin-left:4px;line-height:1;" title="Clear">&times;</span>';
        pickerButton += '</div>';

        var checkBoxHtml = '<span style="text-align: left"><div class="fr-checkbox-line fr-autoplay-margin imageSrcVariableCheck">';
        checkBoxHtml += '<span class="fr-checkbox"><input id="imageSrcVariableCheck-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/><span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg></span></span>';
        checkBoxHtml += '<label style="line-height: 1;white-space: break-spaces;word-break: break-word;" id="imageSrcVariableCheckLabel-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command">Show the uploaded image when the selected dynamic image is not available</label></div></span>';

        var html = '<div class="fr-image-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(pickerButton).concat(checkBoxHtml, '</div>').concat('</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template checkbox command
        that.FroalaEditor.RegisterCommand('imageSrcVariableCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = this.el.querySelector("img");
            if (img.getAttribute('data-src-visibility')) {
              img.removeAttribute('data-src-visibility');
            } else {
              img.setAttribute('data-src-visibility', val);
            }
          }
        });

        // Create popup.
        var $popup = editor.popups.create(customPopupName, template);
        var popupEl = $popup[0] || $popup;

        // Attach click handler to the picker container using native DOM
        var pickerEl = popupEl.querySelector('.imageSrcVariablePicker');
        if (pickerEl) {
          pickerEl.addEventListener('click', function(e) {
            if (e.target.closest('.imageSrcVariableClear')) {
              // Clear the variable
              e.stopPropagation();
              var img = editor.el.querySelector("img");
              if (img) img.removeAttribute('data-src-variable');
              var lbl = popupEl.querySelector('.imageSrcVariableLabel');
              var clr = popupEl.querySelector('.imageSrcVariableClear');
              if (lbl) { lbl.textContent = ''; lbl.classList.add('d-none'); }
              if (clr) { clr.classList.add('d-none'); }
            } else {
              // Open the variable picker - save img reference now before toolbar closes
              if (that.onImageVariablePickerRequested) {
                that._pendingImageEditor = editor;
                that._pendingImagePopup = popupEl;
                that._pendingImageElement = editor.el.querySelector("img");
                that.onImageVariablePickerRequested();
              }
            }
          });
        }

        return $popup;
      }

      // Set default value according to attributes (using native DOM API)
      function checkElementForData(instance, popup) {
        var popupEl = popup[0] || popup;
        let img = instance.el.querySelector("img");
        if (!img) return;
        let value = img.getAttribute('data-src-visibility');
        let checkboxEl = popupEl.querySelector('.imageSrcVariableCheck input');
        if (checkboxEl) checkboxEl.checked = !!value;

        value = img.getAttribute('data-src-variable');
        let labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        let clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (!labelEl || !clearEl) return;
        if (value) {
          let newOptions = [];
          Object.keys(imageSrcOptions).forEach(group => {
            newOptions = [...newOptions, ...imageSrcOptions[group]];
          });
          let option = newOptions.find(item => item.key === value);
          if (option) {
            labelEl.textContent = option.name;
            labelEl.classList.remove('d-none');
            clearEl.classList.remove('d-none');
          }
        } else {
          labelEl.textContent = '';
          labelEl.classList.add('d-none');
          clearEl.classList.add('d-none');
        }
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.onShow(customPopupName, function() {
          checkElementForData(this, $popup);
        });

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('imageVariableButton', { NAME: 'cog', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('imageVariableButton', {
      title: 'Use Variable',
      icon: 'imageVariableButton',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      }
    });
  }

  Editor.prototype.handleImageVariableSelected = function handleImageVariableSelected(key, name) {
    var img = this._pendingImageElement;
    var popupEl = this._pendingImagePopup;
    if (!img) return;

    if (key && key.trim()) {
      img.setAttribute('data-src-variable', key);
      if (popupEl) {
        var labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        var clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (labelEl) { labelEl.textContent = name || key; labelEl.classList.remove('d-none'); }
        if (clearEl) { clearEl.classList.remove('d-none'); }
      }
    } else {
      img.removeAttribute('data-src-variable');
      if (popupEl) {
        var labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        var clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (labelEl) { labelEl.textContent = ''; labelEl.classList.add('d-none'); }
        if (clearEl) { clearEl.classList.add('d-none'); }
      }
    }

    this._pendingImageEditor = null;
    this._pendingImagePopup = null;
    this._pendingImageElement = null;
  };

  Editor.prototype.cropImageOptions = function cropImageOptions(variables, imageAutoCropEnabled = false, imageProcessLimits = null) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "crop.popup";
    var customPlugin = "crop";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var fitOptions = ['cover', 'contain', 'fill', 'inside', 'outside'];
        if (imageAutoCropEnabled) {
          fitOptions.push('auto');
        }
        
        var fitDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-fit" style="height: 46px;width: 100px;background: white;border: 1px solid #999999;border-radius: 2px"><option selected="selected" value="">select fit</option>';

        fitOptions.forEach(item => {
              fitDropDown += '<option value="'+ item +'" id="image-fit-' + item + '">' + item + '</option>';
        })

        fitDropDown += '</select>';


        var positionOptions = ['top', 'right top', 'right', 'right bottom', 'bottom', 'left bottom', 'left', 'left top', 'center'];
        var positionDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-position" style="height: 46px;width: 100px;background: white;border: 1px solid #999999;border-radius: 2px"><option selected="selected" value="">select position</option>';

        positionOptions.forEach(item => {
          positionDropDown += '<option value="'+ item +'" id="image-position-' + item + '">' + item + '</option>';
        })

        positionDropDown += '</select>';


        var medOptions = ['px', '%'];
        var medDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-med" style="height: 46px;width: 40px;background: white;border: 1px solid #999999;border-radius: 2px">';

        medOptions.forEach(item => {
          medDropDown += '<option value="'+ item +'" id="image-position-' + item + '">' + item + '</option>';
        })

        medDropDown += '</select>';


        var width = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px; padding-bottom: 0"><input id="fr-image-crop-width" type="text" placeholder="' + editor.language.translate('Width') + '" tabIndex="1"></div></div>';
        var height = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px; padding-bottom: 0"><input id="fr-image-crop-height" type="text" placeholder="' + editor.language.translate('Height') + '" tabIndex="1" aria-required="true"></div></div>';
        var position = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px; padding-bottom: 0">' + positionDropDown + '</div></div>';
        var fit = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px; padding-bottom: 0">'+fitDropDown+'</div></div>';
        var padding = '<div class="d-flex align-items-center justify-content-between w-100"><div class="d-flex align-items-center"><div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropPadding" style="width: 100px"><input id="fr-image-crop-padding" type="text" placeholder="' + editor.language.translate('Padding') + '" tabIndex="1" aria-required="true"></div></div>';
        var med = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px">'+medDropDown+'</div></div> </div>';
        var clearButton = '<div class="fr-action-buttons" style="margin-left: -50px"><button type="button" class="fr-command fr-submit clearImageButton" data-cmd="clearImageButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<button type="button" style="margin-left: -4px" class="fr-command fr-submit cropImageButton" data-cmd="cropImageButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div>';

        // Where Update says what /api/v1/image-process would refuse.
        var cropError = '<div id="fr-image-crop-error" role="alert" style="display: none; width: 100%; margin: 0 5px 10px; color: #D92D20; font-size: 13px"></div>';

        var html = '<div><div class="d-flex align-items-center flex-wrap" style="max-width: 450px">'.concat(width).concat(height).concat(position).concat(fit).concat(padding).concat(med).concat(clearButton).concat(updateButton).concat(cropError, '</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('cropImageButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = that.FroalaEditor.SELECTED_TARGET;
            var iFrameEl = document.getElementById('froala-pages');
            var cropField = function (name) {
              return iFrameEl.contentWindow.document.getElementById('fr-image-crop-' + name);
            };
            // Read before the image is touched: a value /api/v1/image-process refuses would be saved
            // as a broken image, so the popup stays open and says what it takes instead.
            var sizes = readCropSizes(img, cropField, imageProcessLimits);
            cropField('error').textContent = sizes.problem || '';
            cropField('error').style.display = sizes.problem ? '' : 'none';
            if (sizes.problem) {
              cropField(sizes.field).focus();
              return;
            }
            if(img.getAttribute('data-src-crop')) {
              clearCropImage(img);
            }
            var height = sizes.height;
            var width = sizes.width;
            var position = cropField('position').value || null;
            var fit = cropField('fit').value || null;
            // Auto is Smart Fit - the face image-process finds, otherwise contain. It reads that as
            // fit=contain&smart=true (fit=auto no longer), and the page renderer as data-src-smart.
            var smart = fit === 'auto';
            if (smart) fit = 'contain';
            var padding = sizes.padding;
            var med = cropField('med').value;

            let cropUrl = `${_this10.opts.editorOptions.cropImageUploadUrl}?`
            if(height) {
              img.setAttribute('data-src-height', height);
              cropUrl += `height=${height}&`;
            }
            if(width) {
              img.setAttribute('data-src-width', width);
              cropUrl += `width=${width}&`;
            }
            if(position) {
              img.setAttribute('data-src-position', position);
              cropUrl += `position=${position}&`;
            }
            if(fit) {
              img.setAttribute('data-src-fit', fit);
              cropUrl += `fit=${fit}&`;
            }
            if(smart) {
              img.setAttribute('data-src-smart', 'true');
              cropUrl += `smart=true&`;
            }
            if(sizes.paddingAmount !== null) {
              img.setAttribute('data-src-padding', sizes.paddingAmount);
              cropUrl += `padding=${padding}&`;
            }
            if(med) {
              img.setAttribute('data-src-padding-med', med);
            }
            if( height || width || position || fit || sizes.paddingAmount !== null) {
              img.setAttribute('data-src-crop', val);
            }
            let imageSrc = img.getAttribute('src');
            img.setAttribute('data-src-original',imageSrc);
            cropUrl += `url=${encodeURIComponent(imageSrc)}`;
            if(cropUrl) {
              img.setAttribute('src',cropUrl);
            }
            if(img.getAttribute('data-border') === "true") {
              img.style.backgroundClip = 'border-box';
              img.style.fontSize = '0';
              img.style.margin = '0';
              img.style.padding = '0';
              img.style.boxSizing = 'border-box';
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('clearImageButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = that.FroalaEditor.SELECTED_TARGET;
            clearCropImage(img)
            this.image.back();
          }
        });

        // The dialog's sizes and padding as /api/v1/image-process draws them: whole numbers within
        // the limits sent with the template (none sent: whole numbers only), or the first problem
        // and the field it is in. An empty size is the image's own, as shown.
        function readCropSizes(img, cropField, limits) {
          var maxSide = (limits && limits.maxSide) || Infinity;
          var maxPadding = (limits && limits.maxPadding) || Infinity;
          var range = function (min, max) {
            return max === Infinity ? 'of at least ' + min : 'from ' + min + ' to ' + max;
          };
          var whole = function (text) {
            var bare = text.replace(/\s*px$/i, '');
            return /^\d+$/.test(bare) ? Number(bare) : NaN;
          };
          var sizes = { padding: 0, paddingAmount: null };
          var sides = [['height', 'Height'], ['width', 'Width']];
          for (var i = 0; i < sides.length; i++) {
            var name = sides[i][0];
            var typed = cropField(name).value.trim();
            if (!typed) {
              var shown = parseInt(getComputedStyle(img)[name], 10);
              sizes[name] = shown >= 1 && shown <= maxSide ? shown : null;
            } else if (whole(typed) >= 1 && whole(typed) <= maxSide) {
              sizes[name] = whole(typed);
            } else {
              return { field: name, problem: sides[i][1] + ' must be a whole number of pixels ' + range(1, maxSide) };
            }
          }
          var paddingTyped = cropField('padding').value.trim();
          if (paddingTyped) {
            var amount = whole(paddingTyped);
            if (!(amount >= 0 && amount <= maxPadding)) {
              return { field: 'padding', problem: 'Padding must be a whole number ' + range(0, maxPadding) };
            }
            sizes.paddingAmount = amount;
            // A percentage is of the image's width, as shown.
            sizes.padding = cropField('med').value === '%'
              ? Math.round((parseInt(getComputedStyle(img).width, 10) || 0) * amount / 100)
              : amount;
            if (sizes.padding > maxPadding) {
              return { field: 'padding', problem: 'Padding of ' + amount + '% comes to ' + sizes.padding
                + ' pixels on this image, more than the ' + maxPadding + ' that can be added' };
            }
            // Contain (and Auto, which falls back to it) adds the padding around the size asked for,
            // and the result has the same limit.
            var fitValue = cropField('fit').value;
            var largest = Math.max(sizes.height || 0, sizes.width || 0);
            var room = Math.floor((maxSide - largest) / 2);
            if ((fitValue === 'contain' || fitValue === 'auto') && largest && sizes.padding > room) {
              return { field: 'padding', problem: 'Padding can be at most ' + room + ' pixels at this size: '
                + 'Contain adds it around the image, which can be at most ' + maxSide + ' pixels on a side' };
            }
          }
          return sizes;
        }

        function clearCropImage(img) {
          img.removeAttribute('data-src-crop');
          img.removeAttribute('data-src-height');
          img.removeAttribute('data-src-width');
          img.removeAttribute('data-src-position');
          img.removeAttribute('data-src-fit');
          img.removeAttribute('data-src-smart');
          img.removeAttribute('data-src-padding');
          img.removeAttribute('data-src-padding-med');
          let imageSrc = img.getAttribute('src');
          let originalUrl;
          let url = 'url'.replace(/[\[\]]/g, '\\$&');
          let regex = new RegExp('[?&]' + url + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(imageSrc);
          if (!results) return null;
          if (!results[2]) return '';
          originalUrl = decodeURIComponent(results[2].replace(/\+/g, ' '));

          if(originalUrl) {
            img.setAttribute('src',originalUrl);
          }
        }

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('cropImage', { NAME: 'crop', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('cropImage', {
      title: 'Crop',
      icon: 'cropImage',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          let img = that.FroalaEditor.SELECTED_TARGET;
          var cropError = document.getElementById('froala-pages').contentWindow.document.getElementById('fr-image-crop-error');
          if (cropError) cropError.style.display = 'none';
          if (img.getAttribute('data-src-crop')) {
            var iFrameEl = document.getElementById('froala-pages');
            if (img.getAttribute('data-src-height')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').value = img.getAttribute('data-src-height');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-width')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').value = img.getAttribute('data-src-width');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-position')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').value = img.getAttribute('data-src-position');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-fit')) {
              // Auto is stored as a smart crop (data-src-smart), and shown as Auto where offered.
              var fitSelect = iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit');
              var smartFit = img.getAttribute('data-src-smart') === 'true' && fitSelect.querySelector('option[value="auto"]');
              fitSelect.value = smartFit ? 'auto' : img.getAttribute('data-src-fit');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-padding')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').value = img.getAttribute('data-src-padding');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-padding-med')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').value = img.getAttribute('data-src-padding-med');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').classList.add("fr-not-empty");
            }
          }
          else if (!img.getAttribute('data-src-crop')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').classList.remove("fr-not-empty");;
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').classList.remove("fr-not-empty");;
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').value = "px";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').classList.remove("fr-not-empty");
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }

  Editor.prototype.imageBorderOptions = function imageBorderOptions() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imgBorder.popup";
    var customPlugin = "imgBorder";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var radius = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line pb-0" style="width: 100px"><input id="fr-border-radius" type="text" placeholder="' + editor.language.translate('Radius') + '" tabIndex="1"></div></div>';
        var size = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line pb-0" style="width: 100px"><input id="fr-border-size" type="text" placeholder="' + editor.language.translate('Size') + '" tabIndex="1" aria-required="true"></div></div>';
        var color = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line fr-action-buttons pb-0" style="width: 100px; height: auto"><button id="fr-border-color-button" type="button" style="width: 100px; height: 46px" class="fr-active fr-command fr-submit borderColor mx-auto d-block" data-cmd="borderColor" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('color') + '</button></div></div></div>';
        var circleCheckbox = '<div class="fr-my-layer fr-layer fr-active" style="margin: 10px 5px; width: 100%" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line p-0"><span class="d-flex align-items-center" style="width: 100%"><input id="borderCircleCheck" data-cmd="borderCircleCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/> <label style="line-height: 1;white-space: break-spaces;word-break: break-word; position: unset; " id="imageSrcVariableCheckLabel-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command mb-0 pl-3">Circle</label> <span></div></div></div>';
        var clearButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end"><button type="button" class="fr-command fr-submit clearBorderButton" data-cmd="clearBorderButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end"><button type="button" class="fr-command fr-submit imageBorderButton ml-3" data-cmd="imageBorderButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div></div></div>';

        var html = '<div><div class="">' +
          '<div class="d-flex align-items-center justify-content-center">'.concat(radius).concat(size).concat(color,'<div class="d-flex flex-wrap align-items-center justify-content-between px-2" style="max-width: 500px">').concat(circleCheckbox)
            .concat(clearButton).concat(updateButton)

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('imageBorderButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            var iFrameEl = document.getElementById('froala-pages');
            let radius = setValues('fr-border-radius', 'data-border-radius', img);
            let size = setValues('fr-border-size','data-border-size', img);

            if(size){
              img.style.border = `${size}px solid black`;
            }

            let imageBorderColor = iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText;
            img.style.borderColor = imageBorderColor;
            img.style.backgroundClip = 'border-box';
            img.style.fontSize = '0';
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.boxSizing = 'border-box';
            img.setAttribute('data-border', "true");
            img.setAttribute('borderColor',imageBorderColor);

            if(img.getAttribute("circle")) {
              img.style.setProperty('border-radius', '50%', 'important');
              img.setAttribute('data-border', "true");
            } else if(radius){
              img.style.setProperty('border-radius', `${radius}px`, 'important');
              img.setAttribute('data-border', "true");
            } else {
              img.style.borderRadius = null
            }

            function setValues(id, att, img) {
              var iFrameEl = document.getElementById('froala-pages');
              let value = iFrameEl.contentWindow.document.getElementById(id).value;
              if(value) {
                img.setAttribute(att, value);
                img.setAttribute('data-border', "true");
                return value;
              }
              else{
                if(img.getAttribute(att)) {
                  img.removeAttribute(att);
                }
                return false;
              }
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('borderCircleCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var iFrameEl = document.getElementById('froala-pages');
            var img = that.FroalaEditor.SELECTED_TARGET;
            if(img.getAttribute('circle')) {
              img.removeAttribute('circle');
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = false;
            } else {
              img.setAttribute('circle',val);
              img.setAttribute('data-border', "true");
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = true;
            }
          }
        });

        that.FroalaEditor.RegisterCommand('borderColor', {
          undo: false,
          focus: false,
          popup: true,
          plugin: 'imgBorderColor',
          callback: function (cmd, val) {
            Object.assign(that.FroalaEditor.POPUP_TEMPLATES, {
              ['imgBorderColor.popup']: '[_BUTTONS_][_COLOR_LAYER_]'
            });

            // Define popup buttons.
            Object.assign(that.FroalaEditor.DEFAULTS, {
              colorPopupButtons: ['colorPopupClose', '-']
            });
            var img = that.FroalaEditor.SELECTED_TARGET;

            if (!this.popups.isVisible('imgBorderColor.popup')) {
              var $popup = editor.popups.get('imgBorderColor.popup');
              if (!$popup) $popup = initPopupBorderColor();
              editor.popups.setContainer('imgBorderColor.popup', editor.$sc);
              var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="borderColor"]');
              var left = $btn.offset().left;
              var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
              editor.popups.show('imgBorderColor.popup', left, top, $btn.outerHeight());

              var iFrameEl = document.getElementById('froala-pages');
              if(img.getAttribute('data-border') === "true" && img.getAttribute('borderColor') && img.getAttribute('borderColor') !== "remove") {
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value = img.getAttribute('borderColor');
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').classList.add("fr-not-empty");
              } else {
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value = null;
              }
            }
            else {
              if (this.$el.find('.fr-marker')) {
                this.events.disableBlur();
                this.selection.restore();
              }
              this['imgBorderColor.popup'].hidePopup();
            }


            function initPopupBorderColor () {
              let template = that.FroalaEditor.POPUP_TEMPLATES['imgBorderColor.popup'];
              if (typeof template == 'function') template = template.apply(editor);

              // Popup buttons.
              let popup_buttons_border = '';

              // Create the list of buttons.
              if (editor.opts.colorPopupButtons.length > 1) {
                popup_buttons_border += '<div class="fr-buttons fr-tabs">';
                popup_buttons_border += editor.button.buildList(editor.opts.colorPopupButtons);
                popup_buttons_border += '</div>';
              }


              // Define Popup Template
              let colors = '';
              let count = 0;

              editor.opts.colorsText.forEach((color, index) => {
                if (color !== 'REMOVE') {
                  colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBorderColor" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
                } else {
                  colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBorderColor" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
                }
                count++;
                if (count === editor.opts.colorsStep) {
                  count = 0;
                  colors += '<br />'
                }
              })


              let customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-image-border" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-image-border">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="customImageBorderColor" tabindex="2" role="button">
                            OK</button></div></div>`;


              let html = `<div class="fr-color-set fr-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>').concat(customHexLayer);

              // Load popup template.
              template = {
                buttons: popup_buttons_border,
                color_layer: html,
              };


              that.FroalaEditor.RegisterCommand('applyImageBorderColor', {
                undo: false,
                focus: false,
                callback: function (cmd, val) {
                  let fontColor;
                  if (val === 'REMOVE') {
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
                    fontColor =  getFontColor('#000000');
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  } else {
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = val;
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = val;
                    fontColor =  getFontColor(val);
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  }
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });

              that.FroalaEditor.RegisterCommand('customImageBorderColor', {
                undo: false,
                focus: false,
                callback: function (cmd, val) {
                  let fontColor;
                  var iFrameEl = document.getElementById('froala-pages');
                  let customColor = iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value;
                  if(customColor) {
                    customColor = customColor.toUpperCase();
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = customColor;
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = customColor;
                    fontColor =  getFontColor(customColor);
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  }
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });

              that.FroalaEditor.RegisterCommand('colorPopupClose', {
                title: 'Close',
                icon: 'imageBack',
                undo: false,
                focus: false,
                callback: function () {
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });
              return editor.popups.create('imgBorderColor.popup', template);
            }
          }
        });

        that.FroalaEditor.RegisterCommand('clearBorderButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            img.removeAttribute('data-border-radius');
            img.removeAttribute('data-border-size');
            img.removeAttribute('borderColor');
            img.removeAttribute('data-border');
            img.style.border = null;
            img.style.borderRadius = null;
            img.style.borderColor = null;
            this.image.back();
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    function getFontColor(hexcolor) {
      hexcolor = hexcolor.replace('#', '');
      const r = parseInt(hexcolor.substr(0, 2), 16);
      const g = parseInt(hexcolor.substr(2, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000000' : '#ffffff';
    }

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('imageBorder', { NAME: 'dashcube', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('imageBorder', {
      title: 'Image Border',
      icon: 'imageBorder',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imgBorder',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          var img = that.FroalaEditor.SELECTED_TARGET;
          let imgStyle = window.getComputedStyle(img);

          let fontColor;
          if (img.getAttribute('data-border')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').value = img.getAttribute('data-border-radius');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').classList.add("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-border-size').value = img.getAttribute('data-border-size');
            iFrameEl.contentWindow.document.getElementById('fr-border-size').classList.add("fr-not-empty");
            if(img.getAttribute('circle')) {
              iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = true;
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = true;
            }
            else{
              iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = false;
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = false;
            }
            if(img.getAttribute('borderColor')) {
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = img.getAttribute('borderColor');
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = img.getAttribute('borderColor');
              fontColor =  getFontColor(img.getAttribute('borderColor'));
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            } else if (!img.getAttribute('borderColor') && imgStyle && imgStyle.getPropertyValue('border-color')) {
              let borderColor = imgStyle.getPropertyValue('border-color');
              borderColor = this.helpers.RGBToHex(borderColor)
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = borderColor;
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = borderColor;
              fontColor =  getFontColor(borderColor);
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            } else {
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
              fontColor =  getFontColor('#000000');
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            }
          }
          else if (!img.getAttribute('data-border')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-border-size').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-border-size').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = false;
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
            fontColor =  getFontColor('#000000');
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }


  Editor.prototype.imageBackgroundColor = function imageBackgroundColor(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imgBackground.popup";
    var customPlugin = "imgBackground";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_COLOR_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        let template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        let popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.colorPopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.colorPopupButtons);
          popup_buttons += '</div>';
        }


        // Define Popup Template
        let colors = '';
        let count = 0;

        editor.opts.colorsText.forEach((color, index) => {
          if (color !== 'REMOVE') {
            colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBackgroundColor" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
          } else {
            colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBackgroundColor" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
          }
          count++;
          if (count === editor.opts.colorsStep) {
            count = 0;
            colors += '<br />'
          }
        })


        let customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-image-background" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-image-background">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="customImageBackgroundColor" tabindex="2" role="button">
                            OK</button></div></div>`;


        let html = `<div class="fr-color-set fr-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>').concat(customHexLayer);

        // Load popup template.
        template = {
          buttons: popup_buttons,
          color_layer: html,
        };

        that.FroalaEditor.RegisterCommand('applyImageBackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            if (val === 'REMOVE') {
              img.style.backgroundColor = null;
              img.setAttribute('back-color',"remove");
            } else {
              img.style.backgroundColor = val;
              img.setAttribute('back-color',val);
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('customImageBackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = this.el.querySelector("img");
            var iFrameEl = document.getElementById('froala-pages');
            let customColor = iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value;
            if(customColor) {
              customColor = customColor.toUpperCase();
              img.style.backgroundColor = customColor;
              img.setAttribute('back-color',customColor);
            }
            this.image.back();
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageBackgroundColor"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('imageBackgroundColor', {
      title: 'Image Background',
      icon: "backgroundColor",
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          let img = this.el.querySelector("img");
          var iFrameEl = document.getElementById('froala-pages');
          if(img.getAttribute('back-color') && img.getAttribute('back-color') !== "remove" ) {
            iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value = img.getAttribute('back-color');
          }
          else{
            iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value = "";
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }


  Editor.prototype.customVideoVariableOptions = function customVideoVariableOptions(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "videoVariable.popup";
    var customPlugin = "videoVariable";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      var videoSrcOptions = {
        'none': [{name: "None", key: "", valueType: ['text', 'all']}],
      };
      if (variables) {
        videoSrcOptions = {
          'none': [{name: "None", key: "", valueType: ['text', 'all']}],
          ...variables
        }
      }
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var dropdownButton = '<button id="videoSrcVariable-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="videoSrcVariable" aria-controls="dropdown-menu-videoSrcVariable-'+editor.id+'" data-blur-event-set="true" aria-expanded="false" aria-haspopup="true" class="fr-command fr-btn fr-dropdown videoSrcVariable" style="display: flex;align-items: center;" data-title="Video Source">';
        dropdownButton += editor.icon.create('variables');
        dropdownButton += '<span class="d-none" style="margin-left: -5px"></span>';
        dropdownButton += '</button>';

        var dropdownHtml = '<div id="dropdown-menu-videoSrcVariable-'+editor.id+'" class="fr-dropdown-menu" role="listbox" aria-labelledby="videoSrcVariable-'+editor.id+'" aria-hidden="true">';
        dropdownHtml += '<div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">';
        dropdownHtml += '<ul class="fr-dropdown-list" role="presentation">';

        Object.keys(videoSrcOptions).forEach(groups => {
          let variableList = videoSrcOptions[groups].filter(item => (item.valueType.includes('all') || item.valueType.includes('video')) && !item.valueType.includes('ignore'));
          if (variableList.length > 0) {
            if (groups !== 'none') {
              // onclick="this.parentElement.parentElement.parentElement.style.height = `275px`;this.parentElement.parentElement.parentElement.parentElement.style.overflow = `auto`;"
              dropdownHtml += '<li>';
              dropdownHtml += '<a style="font-weight: bolder;cursor: default;text-transform: capitalize;pointer-events: none" title="'+groups+'">'+groups+'</a>';
              dropdownHtml += '</li>';
            }
            let style = groups !== "none" ? "padding: 0 30px; text-transform: capitalize;" : "text-transform: capitalize;";
            variableList.forEach(item => {
              let showName = item.name.toString().toLowerCase().trim();
              if (groups !== "none") {
                showName = showName.replace(groups.toString().toLowerCase().trim(), '');
              }
              dropdownHtml += '<li role="presentation">';
              dropdownHtml += '<a style="'+style+'" class="fr-command" tabindex="-1" role="option" data-cmd="videoSrcVariable" data-param1="'+item.key+'" title="'+item.name+'">'+showName+'</a>';
              dropdownHtml += '</li>';
            })
          }
        })

        dropdownHtml += '</ul></div></div></div>';

        var checkBoxHtml = '<span style="text-align: left"><div class="fr-checkbox-line fr-autoplay-margin videoSrcVariableCheck">';
        checkBoxHtml += '<span class="fr-checkbox"><input id="videoSrcVariableCheck-'+editor.id+'" data-cmd="videoSrcVariableCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/><span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg></span></span>';
        checkBoxHtml += '<label style="line-height: 1;white-space: break-spaces;word-break: break-word;" id="videoSrcVariableCheckLabel-'+editor.id+'" data-cmd="videoSrcVariableCheck" data-param1="true" class="fr-command">Show the uploaded video when the selected dynamic video is not available</label></div></span>';

        var html = '<div class="fr-video-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(dropdownButton).concat(dropdownHtml).concat(checkBoxHtml, '</div>').concat('</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('videoSrcVariable', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let video = this.el.querySelector("video");
            let button = this.$sc.find('.videoSrcVariable');
            let span = button[0].querySelector('span');
            if (val.trim()) {
              video.setAttribute('data-src-variable', val);
              let newOptions = [];
              Object.keys(videoSrcOptions).forEach(group => {
                newOptions = [...newOptions, ...videoSrcOptions[group]];
              });
              let option = newOptions.find(item => item.key === val);
              if (option) {
                span.innerHTML = option.name;
                span.classList.remove('d-none');
              }
            } else {
              video.removeAttribute('data-src-variable');
              span.innerHTML = '';
              span.classList.add('d-none');
            }
          }
        });

        that.FroalaEditor.RegisterCommand('popupClose', {
          title: 'Close',
          icon: 'imageBack',
          undo: false,
          focus: false,
          callback: function () {
            this[customPlugin].back();
          }
        });

        // Define custom popup template checkbox command
        that.FroalaEditor.RegisterCommand('videoSrcVariableCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let video = this.el.querySelector("video");
            if (video.getAttribute('data-src-visibility')) {
              video.removeAttribute('data-src-visibility');
            } else {
              video.setAttribute('data-src-visibility', val);
            }
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Set default value according to attributes
      function checkElementForData(instance, popup) {
        let video = instance.el.querySelector("video");
        let value = video.getAttribute('data-src-visibility');
        let checkboxVariable = popup.find('.videoSrcVariableCheck input');
        checkboxVariable[0].checked = !!value;

        value = video.getAttribute('data-src-variable');
        let button = popup.find('.videoSrcVariable');
        let span = button[0].querySelector('span');
        if (value) {
          let newOptions = [];
          Object.keys(videoSrcOptions).forEach(group => {
            newOptions = [...newOptions, ...videoSrcOptions[group]];
          });
          let option = newOptions.find(item => item.key === value);
          if (option) {
            span.innerHTML = option.name;
            span.classList.remove('d-none');
          }
        } else {
          span.innerHTML = '';
          span.classList.add('d-none');
        }
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.onShow(customPopupName, function() {
          checkElementForData(this, $popup);
        });

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="videoVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }


    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('videoVariableButton', { NAME: 'cog', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('videoVariableButton', {
      title: 'Use Variable',
      icon: 'imageVariableButton',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'videoVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      }
    });
  }




  Editor.prototype.customPastePlugin = function customPastePlugin() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPlugin = "customPaste";
    var customPopupName = "customPaste.popup";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      pastePopupButtons: ['pastePopupClose', '-']
    });

    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {

      let pasteContent = null;
      // Show the popup
      function showPopup (e) {
        pasteContent = e;
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        var targetElement = editor.position.getBoundingRect();
        editor.popups.setContainer(customPopupName, editor.$sc);
        var left = targetElement.left;
        var top = targetElement.top + targetElement.height;
        editor.popups.show(customPopupName, left, top, targetElement.height);
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Create custom popup.
      function initPopup() {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.pastePopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.pastePopupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var cleanPasteButton = '<button id="pasteCleanButton-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="pasteCleanButton" data-blur-event-set="true" class="fr-command fr-btn pasteCleanButton" style="display: flex;align-items: center;margin-right: 10px;border: 1px solid #00000038; padding: 10px;" data-title="Clean formatting">';
        cleanPasteButton += 'Clear formatting';
        cleanPasteButton += '</button>';

        var pasteKeepFormatButton = '<button id="pasteKeepButton-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="pasteKeepButton" data-blur-event-set="true" class="fr-command fr-btn pasteKeepButton" style="display: flex;align-items: center;border: 1px solid #00000038; padding: 10px;" data-title="Keep formatting">';
        pasteKeepFormatButton += 'Keep formatting';
        pasteKeepFormatButton += '</button>';

        var html = '<div class="fr-image-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(cleanPasteButton).concat(pasteKeepFormatButton).concat('</div>');

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        that.FroalaEditor.RegisterCommand('pasteCleanButton', {
          title: 'Paste Clean',
          undo: true,
          focus: false,
          callback: function(cmd) {
            let pasteData = that.FroalaEditor.PASTE_DATA;
            let content = pasteData['text/plain'];
            this.html.insert(content.replace(/<[^>]*>?/g, ''), true);
            hidePopup();
          }
        })

        that.FroalaEditor.RegisterCommand('pasteKeepButton', {
          title: 'Paste With Formatting',
          undo: true,
          focus: false,
          callback: function(cmd) {
            let pasteData = that.FroalaEditor.PASTE_DATA
            let content = ''
            if (pasteData['text/html']) {
              content = pasteData['text/html'];
              content = content.replaceAll('background-color: rgb(255, 255, 255);','');
            } else {
              content = pasteData['text/plain'];
              content = content.replaceAll('background-color: rgb(255, 255, 255);','');
            }
            this.html.insert(content, false);
            hidePopup();
          }
        })

        return editor.popups.create(customPopupName, template);
      }

      return {
        _init: function _init() {
          editor.events.on('paste.before', function(e) {
            return showPopup(e);
          })
        },
        showPopup,
        hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('pastePopupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.customPaste.back();
      }
    });
  }

  Editor.prototype.customColorPickerButtonPlugin = function customColorPickerButtonPlugin() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPlugin = "customButtonColorPicker";
    var customPopupNameText = "customButtonColorText.picker";
    var customPopupNameBackground = "customButtonColorBackground.picker";
    var customPopupNameBackgroundHover = "customButtonColorBackgroundHover.picker";
    var customPopupNameBorder = "customButtonColorBorder.picker";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupNameText]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBackground]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBackgroundHover]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBorder]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      colorPopupButtons: ['colorPopupClose', '-']
    });

    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {

      function getPopupName(type) {
        if (type === 'text') {
          return customPopupNameText;
        } else if (type === 'background') {
          return customPopupNameBackground
        } else if (type === 'backgroundHover') {
          return customPopupNameBackgroundHover
        } else if (type === 'border') {
          return customPopupNameBorder
        }
      }

      // Show the popup
      function showPopup (type) {
        var $popup = editor.popups.get(getPopupName(type));
        if (!$popup) $popup = initPopup(type);

        var targetElement = editor.position.getBoundingRect();
        editor.popups.setContainer(getPopupName(type), editor.$sc);
        var left = targetElement.left;
        var top = targetElement.top + targetElement.height;
        editor.popups.show(getPopupName(type), left, top, targetElement.height);
      }

      // Hide the custom popup.
      function hidePopup (type) {
        editor.popups.hide(getPopupName(type));
      }

      // Create custom popup.
      function initPopup(type) {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[getPopupName(type)];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.colorPopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.colorPopupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var colors = '';
        var count = 0;
        editor.opts.colorsText.forEach((color, index) => {
          if (color !== 'REMOVE') {
            colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyButton${type}Color" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
          } else {
            colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyButton${type}Color" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
          }
          count++;
          if (count === editor.opts.colorsStep) {
            count = 0;
            colors += '<br />'
          }
        })

        var customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-${type}-${editor.id}" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-${editor.id}">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="custom${type}Color" tabindex="2" role="button">
                            OK</button></div></div>`;


        var html = `<div class="fr-color-set fr-${type}-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>');

        // Load popup template.
        template = {
          buttons: popup_buttons,
          color_layer: html,
          custom_color_layer: editor.opts.colorsHEXInput ? customHexLayer : ''
        };

        that.FroalaEditor.RegisterCommand('customtextColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('text'));
            val = popup.find(`#fr-color-hex-layer-text-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.color = null;
              } else {
                element.style.setProperty('color', this.helpers.HEXtoRGB(val));
              }
              popup.find(`#fr-color-hex-layer-text-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('custombackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('background'));
            val = popup.find(`#fr-color-hex-layer-background-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.backgroundColor = null;
                // element.style.borderColor = null;
              } else {
                element.style.setProperty('background-color', this.helpers.HEXtoRGB(val));
                // element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
                element.style.backgroundImage = null;
                element.style.backgroundPosition = null;
                element.style.backgroundSize = null;
                element.style.backgroundRepeat = null;
                element.style.backgroundAttachment = null;
                element.style.backgroundOrigin = null;
                element.style.backgroundClip = null;
              }
              popup.find(`#fr-color-hex-layer-background-${editor.id}`).val('');
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('custombackgroundHoverColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('backgroundHover'));
            val = popup.find(`#fr-color-hex-layer-backgroundHover-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.removeAttribute('onmouseover');
                element.removeAttribute('onmouseout');
              } else {
                val = this.helpers.HEXtoRGB(val)
                // this.setAttribute('data-old-border-color', this.style.borderColor);this.style.setProperty('border-color', '${val}');
                let hover = `this.setAttribute('data-old-color', this.style.backgroundColor);this.style.setProperty('background-color', '${val}');`;
                element.setAttribute('onmouseover', hover);
                // let oldBorderColor = this.getAttribute('data-old-border-color');this.removeAttribute('data-old-border-color');this.style.setProperty('border-color', oldBorderColor);
                let removeHover = `let oldBackgroundColor = this.getAttribute('data-old-color');this.removeAttribute('data-old-color');;this.style.setProperty('background-color', oldBackgroundColor)`;
                element.setAttribute('onmouseout', removeHover);
              }
              popup.find(`#fr-color-hex-layer-backgroundHover-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('customborderColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('border'));
            val = popup.find(`#fr-color-hex-layer-border-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.borderColor = null;
              } else {
                element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
              }
              popup.find(`#fr-color-hex-layer-border-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtontextColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.color = null;
            } else {
              element.style.setProperty('color', this.helpers.HEXtoRGB(val));
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonbackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.backgroundColor = null;
              // element.style.borderColor = null;
            } else {
              element.style.setProperty('background-color', this.helpers.HEXtoRGB(val));
              // element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
              element.style.backgroundImage = null;
              element.style.backgroundPosition = null;
              element.style.backgroundSize = null;
              element.style.backgroundRepeat = null;
              element.style.backgroundAttachment = null;
              element.style.backgroundOrigin = null;
              element.style.backgroundClip = null;
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonbackgroundHoverColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.removeAttribute('onmouseover');
              element.removeAttribute('onmouseout');
            } else {
              val = this.helpers.HEXtoRGB(val)
              // this.setAttribute('data-old-border-color', this.style.borderColor);this.style.setProperty('border-color', '${val}');
              let hover = `this.setAttribute('data-old-color', this.style.backgroundColor);this.style.setProperty('background-color', '${val}');`;
              element.setAttribute('onmouseover', hover);
              // let oldBorderColor = this.getAttribute('data-old-border-color');this.removeAttribute('data-old-border-color');this.style.setProperty('border-color', oldBorderColor);
              let removeHover = `let oldBackgroundColor = this.getAttribute('data-old-color');this.removeAttribute('data-old-color');;this.style.setProperty('background-color', oldBackgroundColor)`;
              element.setAttribute('onmouseout', removeHover);
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonborderColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.borderColor = null;
            } else {
              element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
            }
            this.link.back();
          }
        });

        return editor.popups.create(getPopupName(type), template);
      }

      return {
        showPopup,
        hidePopup,
        getPopupName
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('colorPopupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.link.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('textColorButton', {
      title: 'Text Color',
      icon: 'textColor',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('text'))) {
          this[customPlugin].showPopup('text');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('text');
        }
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundColorButton', {
      title: 'Background Color',
      icon: 'backgroundColor',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('background'))) {
          this[customPlugin].showPopup('background');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('background');
        }
      }
    });

    this.FroalaEditor.DefineIcon('paintBrush', {
      name: 'paintBrush',
      template: 'svg',
      SVG_KEY: 'inlineStyle'
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundHoverColorButton', {
      title: 'Button Hover Color',
      icon: 'paintBrush',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('backgroundHover'))) {
          this[customPlugin].showPopup('backgroundHover');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('backgroundHover');
        }
      }
    });

    this.FroalaEditor.DefineIcon('borderIcon', {
      name: 'borderIcon',
      template: 'svg',
      SVG_KEY: 'inlineClass'
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundBorderButton', {
      title: 'Button Border Color',
      icon: 'borderIcon',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('border'))) {
          this[customPlugin].showPopup('border');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('border');
        }
      }
    });
  }

  Editor.prototype._defineFontButtons = function _defineFontButtons() {
    var that = this;
    this.FroalaEditor.RegisterCommand('buttonFontSize', {
      type: 'dropdown',
      title: 'Font Size',
      icon: 'fontSize',
      displaySelection: function (e) {
        return e.opts.fontSizeSelection
      },
      displaySelectionWidth: 30,
      defaultSelection: function (e) {
        return e.opts.fontSizeDefaultSelection
      },
      html: function () {
        for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontSize, n = 0; n < t.length; n++) {
          var r = t[n];
          e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="buttonFontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, "</a></li>")
        }
        return e += "</ul>"
      },
      callback: function (e, t) {
        let element;
        if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
          element = that.FroalaEditor.SELECTED_TARGET;
        } else {
          element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
        }
        element.style.setProperty('font-size', t, 'important');
      },
      refresh: function (e) {
        this.fontSize.refresh(e)
      },
      refreshOnShow: function (e, t) {
        this.fontSize.refreshOnShow(e, t)
      },
      plugin: "fontSize"
    });
  };

  Editor.prototype._replaceImageSourceWithBase64 = function _replaceImageSourceWithBase64(editor) {
    // let events = ['image.inserted', 'image.replaced'];
    // events.forEach(event => {
    //   editor.events.on(event, function (imageEl) {
    //     imageEl = imageEl[0];
    //
    //     var request = new XMLHttpRequest();
    //
    //     request.responseType = 'blob';
    //     request.onreadystatechange = function () {
    //       if (request.readyState === 4) {
    //         if (request.status === 200) {
    //           var reader = new FileReader();
    //
    //           reader.readAsDataURL(request.response);
    //           reader.onloadend = function () {
    //             imageEl.src = reader.result;
    //           };
    //         }
    //       }
    //     };
    //     request.open('GET', imageEl.src, true);
    //     request.send();
    //   });
    // })
  };

  return Editor;
}(Module);

// Block placeholders.

var EmptyBlock = function (_M) {
  inherits(EmptyBlock, _M);

  function EmptyBlock() {
    classCallCheck(this, EmptyBlock);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  EmptyBlock.prototype.init = function init(info) {
    var _this2 = this;

    // Set info about the block.
    this.name = info.name;
    this.template = info.template;

    var el = this.doc.createElement('DIV');
    el.classList.add('fp-no-block', 'fp-no-' + this.name.toLowerCase());
    el.setAttribute('data-fp', 'true');
    el.innerHTML = this.template;
    this.el = el;

    this.events.on(el, 'click', function () {
      return _this2.click();
    });
    this.events.on(el, 'mouseenter', function () {
      return _this2._mouseEnter();
    });
  };

  // Block on empty block.


  EmptyBlock.prototype.click = function click() {
    this.events.emit('emptyBlock.click', this);
  };

  // Mouse enter on empty block.


  EmptyBlock.prototype._mouseEnter = function _mouseEnter() {
    this.page.blockToolbar.hide();
  };

  return EmptyBlock;
}(Module);

EmptyBlock.HEADER = {
  name: 'Headers',
  template: '<p>Header</p>'
};

EmptyBlock.FOOTER = {
  name: 'Footers',
  template: '<p>Footer</p>'
};

EmptyBlock.SECTION = {
  name: 'Sections',
  template: '<h1>Blank Website</h1><p>(click to add a design block)</p>'
};

// Events.
var Events = function () {
  function Events() {
    classCallCheck(this, Events);

    // DOM events.
    this.domEvents = {};

    // Internal events.
    this.internalEvents = {};
  }

  // Set an ID for events.


  Events.prototype._id = function _id(el) {
    if (!this._ids) {
      this._ids = {};
    }

    if (this._ids[el]) {
      return this._ids[el];
    }

    this._ids[el] = Object.keys(this._ids).length + 1;

    return this._ids[el];
  };

  // Bind DOM event.


  Events.prototype.on = function on(el, events, callback) {
    var _this = this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    events.split(' ').forEach(function (event) {
      var id = _this._id(el);

      if (!_this.domEvents[id]) {
        _this.domEvents[id] = {};
      }

      if (!_this.domEvents[id][event]) {
        _this.domEvents[id][event] = [];
      }

      _this.domEvents[id][event].push({
        callback: callback,
        options: options
      });

      el.addEventListener(event, callback, options);
    });
  };

  // Turn off DOM event.


  Events.prototype.off = function off(el, events) {
    var _this2 = this;

    events.split(' ').forEach(function (event) {
      var id = _this2._id(el);

      if (_this2.domEvents[id] && _this2.domEvents[id][event]) {
        _this2.domEvents[id][event].forEach(function (info) {
          el.removeEventListener(event, info.callback, info.options);
        });
      }
    });
  };

  // Bind DOM event for a single time.


  Events.prototype.once = function once(el, events, callback) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    options.once = true;

    this.on(el, events, callback, options);
  };

  // Listen to internal event.


  Events.prototype.listen = function listen(events, callback) {
    var _this3 = this;

    events.split(' ').forEach(function (event) {
      if (!_this3.internalEvents[event]) {
        _this3.internalEvents[event] = [];
      }

      _this3.internalEvents[event].push(callback);
    });
  };

  // Emit internal event.


  Events.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.internalEvents[event]) {
      this.internalEvents[event].forEach(function (callback) {
        callback.apply(undefined, args);
      });
    }
  };

  return Events;
}();

// Popup with share options.

var SharePopup = function (_M) {
  inherits(SharePopup, _M);

  function SharePopup() {
    classCallCheck(this, SharePopup);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  SharePopup.prototype.init = function init() {
    this.shareUrl = 'https://froala.com/pages';
    this.shareText = 'Share your Froala Pages project and get your friends to build with Froala Pages for free!';
    // DOM.
    this.el = Helpers.createElement('<div class="fp-share-popup-wrap fp-hidden"><div class="fp-share-popup">\n      <div class="fp-popup-close-toolbar"><span>Share with:</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="#2196f3" width="20"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg></div>\n        <div class="fp-popup-text-row">\n          <span class="twitter-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter-square" class="svg-inline--fa fa-twitter-square fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#1da1f2" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"/></svg></span>\n          <span class="fb-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-square" class="svg-inline--fa fa-facebook-square fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#4267b2" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg></span>\n          <span class="li-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin" class="svg-inline--fa fa-linkedin fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#0077b5" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg></span>\n          <span class="mail-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="at" class="svg-inline--fa fa-at fa-w-16" role="img" viewBox="0 0 512 512" width="40"><path fill="#006fc1" d="M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"/></svg></span>\n        </div>\n      </div></div>');
    Helpers.append(this.page.selector, this.el);
    this._bindButtonEvents();
  };

  SharePopup.prototype.show = function show() {
    this.el.classList.remove('fp-hidden');
  };

  SharePopup.prototype.hide = function hide() {
    this.el.classList.add('fp-hidden');
  };

  SharePopup.prototype._shareWithTwitter = function _shareWithTwitter() {
    this._openChildWindow('http://twitter.com/share?url=' + this.shareUrl + '&text=' + this.shareText);
  };

  SharePopup.prototype._shareWithFb = function _shareWithFb() {
    this._openChildWindow('https://www.facebook.com/sharer/sharer.php?u=' + this.shareUrl + '&quote=' + this.shareText);
  };

  SharePopup.prototype._shareWithLinkedIn = function _shareWithLinkedIn() {
    this._openChildWindow('https://www.linkedin.com/shareArticle?mini=true&url=' + this.shareUrl + '&summary=' + this.shareText);
  };

  SharePopup.prototype._shareWithMail = function _shareWithMail() {
    window.open('mailto:?body=' + this.shareText + ' ' + this.shareUrl, null);
  };

  SharePopup.prototype._bindButtonEvents = function _bindButtonEvents() {
    var _this2 = this;

    var closeButton = this.el.querySelector('.fp-popup-close-toolbar svg');
    var twitterShareButton = this.el.querySelector('.twitter-share svg');
    var fbShareButton = this.el.querySelector('.fb-share svg');
    var liShareButton = this.el.querySelector('.li-share svg');
    var mailShareButton = this.el.querySelector('.mail-share svg');

    this.events.on(closeButton, 'click', function () {
      return _this2.hide();
    });
    this.events.on(twitterShareButton, 'click', function () {
      return _this2._shareWithTwitter();
    });
    this.events.on(fbShareButton, 'click', function () {
      return _this2._shareWithFb();
    });
    this.events.on(liShareButton, 'click', function () {
      return _this2._shareWithLinkedIn();
    });
    this.events.on(mailShareButton, 'click', function () {
      return _this2._shareWithMail();
    });
  };

  SharePopup.prototype._openChildWindow = function _openChildWindow(url) {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var childWindWidth = windowWidth > 600 ? 600 : windowWidth;
    var childWindHeight = windowHeight > 400 ? 400 : windowHeight;

    var top = Number(windowHeight - childWindHeight) / 2;
    var left = Number(windowWidth - childWindWidth) / 2;

    var childWind = window.open(url, '_blank', 'width=' + childWindWidth + ', height=' + childWindHeight + ', top=' + top + ', left=' + left + ', location=no, statusbar=no, toolbar=no');
  };

  return SharePopup;
}(Module);

// Toolbar that is shown at the buttom of the page.

var PageToolbar = function (_M) {
  inherits(PageToolbar, _M);

  function PageToolbar() {
    classCallCheck(this, PageToolbar);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  PageToolbar.prototype.init = function init() {
    // DOM.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-page-toolbar');
    Helpers.append(this.page.selector, this.el);

    // Buttons.
    this._addButtons(this.opts.pageLeftButtons, 'fp-lp-zone');
    this._addButtons(this.opts.pageCenterButtons, 'fp-cp-zone');
    this._addButtons(this.opts.pageRightButtons, 'fp-rp-zone');
    this.events.emit('button.refresh');
  };

  // Build buttons.


  PageToolbar.prototype._addButtons = function _addButtons(buttonsList, id) {
    var _this2 = this;

    var zone = this.doc.createElement('DIV');
    zone.classList.add('fp-btn-zone');
    if (id) {
      zone.setAttribute('id', id);
    }

    buttonsList.forEach(function (groupEl) {

      if (Array.isArray(groupEl)) {
        var group = _this2.doc.createElement('DIV');
        group.classList.add('fp-btn-group');

        groupEl.forEach(function (btnName) {
          var btn = new Button(_this2.page, btnName);

          Helpers.append(group, btn.el);
        });

        Helpers.append(zone, group);
      } else {
        zone.innerHTML += groupEl;
      }
    });

    Helpers.append(this.el, zone);
  };

  return PageToolbar;
}(Module);

// Allowed image types for background image in block
var ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg", "image/gif"];

var Page = function () {
  function Page(selectorId, options$$1) {
    classCallCheck(this, Page);


    // Set options.
    this.opts = Object.assign({}, options, options$$1);

    // Get current DOM.
    this.doc = document;
    this.body = document.body;

    // Container.
    this.container = this.doc.createElement('DIV');
    this.container.classList.add('fp-container');

    // render to selector element / body
    this.selector = this.doc.getElementById(selectorId) || this.body;
    Helpers.append(this.selector, this.container);

    // Actual editable zone.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-element');
    Helpers.append(this.container, this.el);

    // Actual editable element.
    this.editEl = this.doc.createElement('DIV');
    this.editEl.classList.add('fp-pageTop-toolbar');
    Helpers.append(this.el, this.editEl);

    // Init events.
    this.events = new Events();
    if (!!(options$$1.hasOwnProperty('eventCallbacks') && options$$1['eventCallbacks']) && options$$1.eventCallbacks) {
      Object.entries(options$$1.eventCallbacks).forEach((entry ) => {
        const [key, value] = entry;
        this.events.listen(key, value);
      });
    }

    // Init designs panel.
    this.designsPanel = new DesignsPanel(this);

    // Render UI.
    this.render();
  }

  // Here we start rendering.


  Page.prototype.render = function render() {
    this.events.emit('init.renderBefore', this);
    this._initIframe();
    this._initEmptyBlocks();
    this._initPageToolbar();
    this._initDropZone();

    this._initBlockToolbar();

    this._initEvents();

    this._initEditor();

    // Refresh current blocks.
    this.events.emit('init.renderBeforeRefresh', this);
    this.refreshBlocks();

    // Set default view as being the FULL one.
    this.setView(VIEWS.FULL);
    this.events.emit('init.renderAfter', this);
  };

  // Initialize Froala Editor.


  Page.prototype._initEditor = function _initEditor() {
    this.editor = new Editor(this);
  };

  // Initialize the block toolbar.


  Page.prototype._initBlockToolbar = function _initBlockToolbar() {
    this.blockToolbar = new BlockToolbar(this);
  };

  // Initialize the page toolbar.


  Page.prototype._initPageToolbar = function _initPageToolbar() {
    this.activeView = VIEWS.FULL;
    this.pageToolbar = new PageToolbar(this);

    if (this.selector !== this.body && !this.selector.style.height) {
      // set view height to 100% if there is no default value
      this.selector.style.height = '100%';
    }

    this.container.style.height = 'calc(100% - ' + this.pageToolbar.el.getBoundingClientRect().height + 'px)';
    this.data = new Data(this);

    // Init share window
    this.sharewindow = this.data.domain && new SharePopup(this);
  };

  // Build stylesheets for iframe.


  Page.prototype._buildStylesheets = function _buildStylesheets() {
    var cssVersion = (new Date()).getTime();
    var defaultStylesheets = [
      'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/dist/css/froala_blocks.min.css?v1=' + cssVersion, // V1 For firefox to load css
      '/assets/fonts/roboto/index.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_editor.pkgd.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_style.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/tui-image-editor.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/tui-color-picker@2.2.8/dist/tui-color-picker.min.css' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor@3.1.1/css/third_party/image_tui.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/fontawesome.min.css?v1=' + cssVersion, // V1 For firefox to load css
    ];
    var targetStylesheets = [].concat(defaultStylesheets, this.opts.designStylesheets);
    return targetStylesheets.map(function (x) {
      return '<link rel="stylesheet" href="' + x + '" />';
    }).join('');
  };

  // Build stylesheets for iframe.


  Page.prototype._buildJavascripts = function _buildJavascripts() {
    var defaultJavascripts = ['https://code.jquery.com/jquery-3.3.1.slim.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js', 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js', '/assets/js/froala_wyiwyg/froala_wyiwyg.js', 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/1.6.7/fabric.min.js', 'https://cdn.jsdelivr.net/npm/tui-code-snippet@1.4.0/dist/tui-code-snippet.min.js', 'https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/tui-image-editor.min.js', 'https://cdn.jsdelivr.net/npm/froala-editor@3.1.1/js/third_party/image_tui.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.2/js/third_party/font_awesome.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/fontawesome.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/brands.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/solid.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/v4-shims.min.js'];
    var targetJavascripts = [].concat(defaultJavascripts, this.opts.designJavascripts);
    return targetJavascripts.map(function (x) {
      return '<script src="' + x + '"></script>';
    }).join('');
  };

  // Init the iframe.


  Page.prototype._initIframe = function _initIframe(content) {
    var iframe = document.createElement('IFRAME');

    if (this.iframe) {
      this.iframe.remove();
      this.iframe = null;
      this.iframeDoc = null;
      this.iframeBody = null;
      this.iframeHead = null;
    }

    this.iframe = iframe;
    iframe.setAttribute('src', 'about:blank');

    // id is required for pages to whitelist license conditions for Editor
    iframe.setAttribute('id', 'froala-pages');

    Helpers.append(this.el, iframe);

    // Write iframe content.
    this.iframeDoc = iframe.contentWindow.document;
    this.iframeDoc.open();
    this.iframeDoc.write('<!DOCTYPE html>');
    this.writeIframeContent(content);
    this.iframeDoc.close();

    // this.startObserver();
    // Add body and head.
    this.iframeBody = this.iframeDoc.body;
    this.iframeHead = this.iframeDoc.head;
  };

  Page.prototype.startObserver = function startObserver() {
    this.destroyObserver();
    let that = this;
    let searchDelay = null;
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(() => {
        that.refreshIframeSize();
      }, 1000);
    };
    this.observer = new MutationObserver(callback);
    this.observer.observe(this.iframeDoc, config);
  }

  Page.prototype.destroyObserver = function destroyObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  Page.prototype.writeIframeContent = function writeIframeContent(data) {
    var headContent = '<meta name="viewport" content="width=device-width, initial-scale=1"></meta>\n                        ' + this._buildStylesheets() + '\n                        <style data-fp>' + this.opts.appStyle + '</style>';

    var defaultScripts = '' + this._buildJavascripts();

    if (data) {
      headContent = Array.from(data.querySelectorAll('head > meta')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ') + '\n                     ' + Array.from(data.querySelectorAll('head > link')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ') + '\n                     ' + Array.from(data.querySelectorAll('head > [data-fp]')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ');

      var scripts = Array.from(data.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
        return el.outerHTML;
      });

      // check to verify if any new scripts are added
      for (var i = 0; i < scripts.length; i++) {
        if (defaultScripts.indexOf(scripts[i]) < 0) {
          defaultScripts += scripts[i];
        }
      }
    }

    this.iframeDoc.write('<html>\n                    <head>\n                      ' + headContent + '\n                    </head>\n                    <body>\n                      ' + defaultScripts + '\n                    </body>\n                    </html>');
  };

  // Add empty block.


  Page.prototype._initEmptyBlocks = function _initEmptyBlocks() {
    if (this.emptySection) {
      Helpers.remove(this.emptySection);
      this.emptySection = null;
    }
    this.events.emit('emptyBlock.beforeAdd');
    this.emptySection = new EmptyBlock(this, EmptyBlock.SECTION);

    Helpers.append(this.iframeBody, this.emptySection.el);
    this.events.emit('emptyBlock.afterAdd', this);
  };

  // Refresh the size of the iframe.


  Page.prototype.refreshIframeSize = function refreshIframeSize() {
    this.iframe.style.height = this.iframeBody.scrollHeight + 'px';
  };

  // Refresh page blocks.


  Page.prototype.refreshBlocks = function refreshBlocks() {
    // Check if there are blocks.
    var noBlocks = !this.iframeBody.querySelector('[data-block-type]');

    // Update CSS classes to reflect new block state.
    this.emptySection.el.classList.toggle('fp-visible', noBlocks);
    this.iframeBody.classList.toggle('no-block', noBlocks);
    this.container.classList.toggle('fp-no-block', noBlocks);

    // Change iframe size.
    this.refreshIframeSize();

    // Display downloads button only if blocks are selected and has valid key

    Helpers.setDownloadBtnsStatus(this, noBlocks, noBlocks);

    if (!noBlocks) {
      this._addEditButtons(this.opts.pageTopButtons, 'fp-tp-zone');
    }
  };

  // Build buttons.


  Page.prototype._addEditButtons = function _addEditButtons(buttonsList, id) {
    var _this = this;

    var topEle = this.doc.getElementById('fp-tp-zone');

    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = this.activeView === VIEWS.FULL ? 'none' : 'flex';

    if (topEle) {
      return;
    }
    var zone = this.doc.createElement('DIV');
    zone.classList.add('fp-btn-zone');
    if (id) {
      zone.setAttribute('id', id);
    }
    buttonsList.forEach(function (groupEl) {

      if (Array.isArray(groupEl)) {
        var group = _this.doc.createElement('DIV');
        group.classList.add('fp-btn-group');

        groupEl.forEach(function (btnName) {

          var btn = new Button(_this, btnName);

          Helpers.append(group, btn.el);
        });

        Helpers.append(zone, group);
      } else {
        zone.innerHTML += groupEl;
      }
    });

    Helpers.append(this.editEl, zone);
  };

  // Refresh current view.


  Page.prototype.setView = function setView(view) {
    var _this2 = this;

    this.activeView = view;

    // Toggle CSS classes between views.
    this.body.classList.toggle('fp-add-view', this.activeView === VIEWS.ADD);
    this.body.classList.toggle('fp-full-view', this.activeView === VIEWS.FULL);

    this.iframeBody.classList.toggle('fp-add-view', this.activeView === VIEWS.ADD);
    this.iframeBody.classList.toggle('fp-full-view', this.activeView === VIEWS.FULL);

    // Toggle design blocks zone.
    this.designsPanel.setActiveBlock();
    if (this.activeView === VIEWS.ADD) {
      this.designsPanel.show();
    } else {
      this.designsPanel.hide();
    }

    // Make header and footer not draggable.
    Array.from(this.iframeBody.querySelectorAll('[data-block-type]:not(header):not(footer)')).forEach(function (el) {
      if (_this2.activeView === VIEWS.ADD) {
        el.setAttribute('draggable', 'true');
      } else {
        el.removeAttribute('draggable');
      }
    });

    // Refresh buttons.
    this.events.emit('button.refresh');
  };

  // Initialize events.


  Page.prototype._initEvents = function _initEvents() {
    var _this3 = this;

    // Click on an empty block.
    this.events.listen('emptyBlock.click', function () {
      _this3.setView(VIEWS.ADD);
    });

    // A design block was clicked.
    this.events.listen('designBlock.click', function (block) {
      return _this3.insertBlock(block);
    });
    this.events.listen('designBlock.willDrag', function (block) {
      _this3.draggingDesignBlock = block;
      _this3.dragImage = block.dragImage;

      if (_this3.dropPlaceholder) {
        _this3.dropPlaceholder.style.height = '';
      }
    });
  };

  // Drag of a block ends.


  Page.prototype._dragend = function _dragend() {
    if (this.dropPlaceholder) {
      Helpers.remove(this.dropPlaceholder);
      this.dropPlaceholder.isVisible = false;
    }

    this.body.classList.remove('fp-dragging');
  };

  // A block is dropped.


  Page.prototype._drop = function _drop(e) {
    if (navigator.userAgent.search('Firefox') >= 0) {
      e.preventDefault();
    }

    if (this.activeView === VIEWS.ADD) {
      // Sorting blocks.
      if (this.draggingBlock && this.dropPlaceholder && this.dropPlaceholder.isVisible) {
        this.draggingBlock.classList.remove('fp-dragging');
        Helpers.after(this.dropPlaceholder, this.draggingBlock);

        Helpers.remove(this.dropPlaceholder);
        Helpers.remove(this.dragImage);
      }

      // Adding block.
      if (this.draggingDesignBlock && (this.dropPlaceholder && this.dropPlaceholder.isVisible || this.container.classList.contains('fp-no-block'))) {
        this.insertBlock(this.draggingDesignBlock, this.dropPlaceholder);

        Helpers.remove(this.dropPlaceholder);
        Helpers.remove(this.dragImage);
      }

      this.dropPlaceholder.isVisible = false;
      this.draggingDesignBlock = null;
      this.draggingBlock = null;
    }

    this.body.classList.remove('fp-dragging');
  };

  // Drop placeholder.


  Page.prototype._initDropZone = function _initDropZone() {
    var _this4 = this;

    if (this.dropZone) {
      this.dropZone.remove();
      this.dropZone = null;
    }

    // create drop placeholder
    this.dropZone = this.doc.createElement('DIV');
    this.dropZone.classList.add('fp-drop-zone');
    this.dropZone.innerHTML = '<p>Drag & Drop a Design Block</p>\n                                <p>(or click one)</p>\n                                <div id="fp-drop-visual">\n                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.26 68.42">\n                                    <path d="M6.19,9.4Q4.9,7.87,3.62,6.3L5.18,5Q6.44,6.6,7.72,8.11Z"/>\n                                    <path d="M139.15,68.42q-2,0-4,0l0-2q4.09.08,8.16,0l0,2Q141.29,68.42,139.15,68.42ZM128,68.13c-2.75-.15-5.52-.35-8.22-.61l.19-2c2.68.25,5.42.45,8.14.6Zm22.65,0-.11-2c2.7-.14,5.44-.33,8.15-.58l.18,2C156.12,67.78,153.36,68,150.63,68.12ZM166,66.79l-.24-2c2.69-.32,5.41-.7,8.09-1.11l.31,2C171.48,66.09,168.73,66.47,166,66.79Zm-53.43-.08c-2.73-.36-5.47-.78-8.15-1.25l.35-2c2.64.47,5.36.88,8.06,1.24Zm68.69-2.25-.37-2c2.66-.49,5.35-1,8-1.62l.43,2C186.68,63.41,184,64,181.28,64.46Zm-83.92-.4c-2.68-.58-5.38-1.24-8-1.94l.52-1.93c2.6.69,5.27,1.34,7.93,1.92Zm-15-3.94c-2.63-.82-5.26-1.71-7.81-2.65l.69-1.88c2.53.93,5.12,1.81,7.72,2.62ZM67.87,54.84c-2.54-1.06-5.07-2.19-7.53-3.37l.86-1.8C63.63,50.83,66.13,52,68.64,53Zm-14-6.62c-2.41-1.29-4.82-2.66-7.17-4.07l1-1.71c2.32,1.4,4.71,2.75,7.08,4ZM40.62,40.27c-2.28-1.52-4.55-3.12-6.74-4.75l1.19-1.6c2.17,1.62,4.41,3.19,6.66,4.69ZM28.19,31.08c-2.11-1.73-4.22-3.54-6.25-5.38l1.34-1.48c2,1.82,4.09,3.61,6.18,5.31ZM16.69,20.75c-1.94-1.91-3.86-3.91-5.73-5.93l1.47-1.35c1.84,2,3.74,4,5.66,5.86Z"/>\n                                    <path d="M196.38,61.16l-.49-1.94q1.94-.49,3.85-1l.52,1.93Q198.33,60.67,196.38,61.16Z"/>\n                                    <polygon points="1.39 9.88 0 0 9.24 3.73 1.39 9.88"/>\n                                  </svg>\n                                </div>\n                                ';
    Helpers.append(this.container, this.dropZone);

    // Block is dragged over.
    this.events.on(this.dropZone, 'dragover dragenter', function (e) {
      e.preventDefault();

      _this4.dropZone.classList.add('fp-hover');
    });

    // Drag ends.
    this.events.on(this.dropZone, 'dragleave dragend', function () {
      _this4.dropZone.classList.remove('fp-hover');
    });

    // Block is dropped.
    this.events.on(this.dropZone, 'drop', function (e) {
      return _this4._drop(e);
    });
  };

  // Make a design block draggable.


  Page.prototype._makeBlockDraggable = function _makeBlockDraggable(block) {
    var _this5 = this;

    var el = block.el;
    var isHeader = block.designBlock.blockType === DesignBlock.HEADER;
    var isFooter = block.designBlock.blockType === DesignBlock.FOOTER;
    var isSocialImage = block.designBlock.blockType === DesignBlock.SOCIAL;

    // make it draggable
    if (!this.dropPlaceholder) {
      this.dropPlaceholder = this.doc.createElement('DIV');
      this.dropPlaceholder.classList.add('fp-drop-placeholder');

      this.events.on(this.iframeDoc, 'drop', function (e) {
        return _this5._drop(e);
      });
      this.events.on(this.doc, 'drop', function (e) {
        return _this5._drop(e);
      });

      this.events.on(this.iframeDoc, 'dragend', function (e) {
        return _this5._drop(e);
      });
      this.events.on(this.doc, 'dragend', function (e) {
        return _this5._drop(e);
      });

      this.events.on(this.iframeDoc, 'dragenter dragover', function (e) {
        return e.preventDefault();
      });
      this.events.on(this.doc, 'dragenter dragover', function (e) {
        return e.preventDefault();
      });
    }

    if (!isHeader && !isFooter && !isSocialImage) {
      el.setAttribute('draggable', 'true');
    }

    // Drag ends.
    this.events.on(el, 'dragover dragenter', function (e) {
      e.preventDefault();

      // Drag can be used only in ADD mode.
      if (_this5.activeView === VIEWS.ADD) {
        var cy = e.clientY;
        var ey = Helpers.offset(el).top;
        var eh = Helpers.outerHeight(el);

        // Decide where to place drop placeholder based on the current mouse position.
        if (isHeader && cy > ey) {
          Helpers.after(el, _this5.dropPlaceholder);
        } else if (isFooter && cy > ey) {
          Helpers.before(el, _this5.dropPlaceholder);
        }else if (isSocialImage && cy > ey) {
          Helpers.before(el, _this5.dropPlaceholder);
        } else if (cy > ey + eh / 2) {
          Helpers.after(el, _this5.dropPlaceholder);
        } else {
          Helpers.before(el, _this5.dropPlaceholder);
        }

        _this5.dropPlaceholder.isVisible = true;

        _this5.refreshIframeSize();
      }
    });

    // Drag starts.
    this.events.on(el, 'dragstart', function (e) {
      // Drag can be used only in ADD mode.
      if (_this5.activeView === VIEWS.ADD) {

        // Don't do it for footers and headers and Social images.
        if (isHeader || isFooter || isSocialImage) {
          e.preventDefault();
          e.stopPropagation();

          return false;
        }

        // Let BODY element know we're dragging.
        _this5.body.classList.add('fp-dragging');

        // Create a draggable placeholder.
        _this5.dragImage = _this5.doc.createElement('IMG');
        _this5.dragImage.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
        _this5.dragImage.style.position = 'aboslute';
        Helpers.append(_this5.body, _this5.dragImage);
        e.dataTransfer.setDragImage(_this5.dragImage, 0, 0);

        e.dataTransfer.setData('text/html', null);

        // Use a timeout so image is loaded.
        setTimeout(function () {
          Helpers.after(el, _this5.dropPlaceholder);
          _this5.dropPlaceholder.style.height = Helpers.outerHeight(el, true) + 'px';
          _this5.dropPlaceholder.isVisible = true;
          el.classList.add('fp-dragging');
        });
        _this5.draggingBlock = el;
      }

      return true;
    });
  };

  // Add a new block.


  Page.prototype.insertBlock = function insertBlock(designBlock, placeholder) {
    var _this6 = this;

    var block = new Block(this, designBlock);

    // Trigger scroll when images are loaded.
    Array.from(block.el.querySelectorAll('img')).forEach(function (img) {
      _this6.events.once(img, 'load', function () {
        return _this6.refreshIframeSize();
      });

      Helpers.scrollTo(block.el);
    });

    // Add block to the body.
    if (designBlock.blockType === DesignBlock.HEADER) {
      // Replace existing header if there is one.
      var headerEl = this.iframeBody.querySelector('header');
      if (headerEl) {
        Helpers.remove(headerEl);
      }

      Helpers.prepend(this.iframeBody, block.el);
    } else if (designBlock.blockType === DesignBlock.FOOTER) {
      // Replace existing footer if there is one.
      var footerEl = this.iframeBody.querySelector('footer');
      if (footerEl) {
        Helpers.remove(footerEl);
      }

      Helpers.append(this.iframeBody, block.el);
    }else if (designBlock.blockType === DesignBlock.SOCIAL) {
      // Replace existing social image if there is one.
      var socialEl = this.iframeBody.querySelector('header');
      if (socialEl) {
        Helpers.remove(socialEl);
      }

      Helpers.append(this.iframeBody, block.el);
    } else if (placeholder && placeholder.isVisible) {
      // Place new block after placeholder.
      Helpers.after(placeholder, block.el);
    } else {
      var _footerEl = this.iframeBody.querySelector('footer');

      // Place new block at the end.
      if (_footerEl) {
        Helpers.before(_footerEl, block.el);
      } else {
        Helpers.append(this.iframeBody, block.el);
      }
    }

    // Refresh existing blocks.
    this.refreshBlocks();

    // Make new block draggable.
    this._makeBlockDraggable(block);

    // Bind click event on the new block.
    this.events.on(block.el, 'click', function (e) {
      _this6._disableEnhancedText();
      if (e.target && e.target.tagName === 'A') {
        e.preventDefault();
        return false;
      }

      if (e.target && e.target.tagName === 'A') {
        e.preventDefault();
        return false;
      }

      return true;
    });

    // Emit block inserted event.
    this.events.emit('block.inserted', block);
  };

  //Disable Enhanced text editor if pro button available


  Page.prototype._disableEnhancedText = function _disableEnhancedText() {
    var iframe = document.getElementById('froala-pages');
    if (iframe.contentWindow.document.getElementsByClassName('pro-btn-text').length > 0) {
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-toolbar');
      var childNodes = toolbarsElement[0].childNodes[1].getElementsByTagName('button');
      for (var i = 0; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
    }
  };

  Page.prototype.setBlockPlaceholder = function setBlockPlaceholder(block) {
    this._blockPlaceholder = block;
  };

  // Get HTML for the HEAD.


  Page.prototype._getHeadHTML = function _getHeadHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('head > *')).map(function (el) {
      return el.outerHTML;
    }).join('\n  ');
  };

  // Get HTML for the BODY.


  Page.prototype._getBodyHTML = function _getBodyHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('body > [data-block-type]')).map(function (el) {
      return el.outerHTML;
    }).join('\n') + '\n      ' + Array.from(this.iframeDoc.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
      return el.outerHTML;
    }).join('\n');
  };

  // Return promise which resolves get HTML for the page.


  Page.prototype.getHTML = function getHTML() {
    var _this7 = this;

    return new Promise(function (resolve, reject) {
      Data._getData(_this7.data, resolve, reject);
    });
  };

  // Get scripts from BODY.


  Page.prototype._getScripts = function _getScripts() {
    return Array.from(this.iframeDoc.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get links from HEAD.


  Page.prototype._getLinks = function _getLinks() {
    return Array.from(this.iframeDoc.querySelectorAll('head > link')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get HTML BLOCKS from BODY.


  Page.prototype._getBlockHTML = function _getBlockHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('body > [data-block-type]')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get Inline style from HEAD.


  Page.prototype._getInlineStyle = function _getInlineStyle() {
    return Array.from(this.iframeDoc.querySelectorAll('head > [data-fp]')).map(function (el) {
      return el.outerHTML;
    });
  };

  Page.prototype._hideBlocksToolbars = function _hideBlocksToolbars() {
    this.blockToolbar.hide();
  }

  // Get the blocks as a JSON structure instead of HTML.


  Page.prototype.getJSON = function getJSON() {
    var _this8 = this;
    var deleteSizeElements = _this8.iframeDoc.getElementsByClassName('custom-fix-font');
    for (var inxD = 0; inxD < deleteSizeElements.length; inxD++) {
      if (deleteSizeElements[inxD].style?.fontSize) {
        deleteSizeElements[inxD].style.removeProperty('font-size');
        deleteSizeElements[inxD].setAttribute('fix-font', parseFloat(deleteSizeElements[inxD].offsetWidth) + 'px');
      }
    }

    return new Promise(function (resolve, reject) {
      Data._getData(_this8.data, resolve, reject, true);
    });
  };

  // Load saved HTML.


  Page.prototype.setHTML = function setHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var sections = doc.querySelectorAll('body > [data-block-type]');

    if (!sections || !sections.length) {
      alert('Selected file has no valid design blocks. Please upload a valid template.');
      return;
    }

    // Initialize iframe.
    this._initIframe(doc);

    // set view to layout mode for further edit
    this.setView(VIEWS.ADD);

    this._initEmptyBlocks();

    // remove old instances of dropPlaceholder
    if (this.dropPlaceholder) {
      this.dropPlaceholder.remove();
      this.dropPlaceholder = null;
    }

    // Render each blocks into view
    for (var i = 0; i < sections.length; i++) {
      var designBlock = {
        blockType: sections[i].getAttribute('data-block-type'),
        template: sections[i].outerHTML,
        render: DesignBlock.prototype.render
      };
      this.insertBlock(designBlock);
    }

    // hide blocktool bar button.
    this.blockToolbar.hide();

    // initialize blocktool bar.
    this.blockToolbar.init();

    // initialize dropzone.
    this._initDropZone();

    // Refresh current blocks.
    this.refreshBlocks();
  };

  // Load saved JSON.


  Page.prototype.setJSON = function setJSON(jsonData) {
    var templateContent = JSON.parse(jsonData);
    var htmlHeadContent = '';
    var htmlBodyContent = '';

    for (var key in templateContent) {
      if (key === 'blocks') {
        htmlBodyContent += templateContent[key].join('');
      } else {
        htmlHeadContent += templateContent[key].join('');
      }
    }

    if (htmlHeadContent && htmlBodyContent) {
      // Create a HTML structure.
      var data = '<!DOCTYPE html>\n              <html>\n              <head>\n              ' + htmlHeadContent + '\n              </head>\n              <body>\n              ' + htmlBodyContent + '\n              </body>\n              </html>';

      this.setHTML(data);
    } else {
      alert('Please load a valid template.');
    }
  };

  Page.prototype.uploadTemplate = function uploadTemplate(templateFile) {
    var _this9 = this;

    if (templateFile.type === "text/html") {
      var reader = new FileReader();
      reader.onloadend = function () {
        _this9.setHTML(reader.result);
      };
      reader.readAsText(templateFile);
    } else {
      alert('Only HTML files are supported. Please upload a valid HTML template.');
    }
  };

  // Custom upload Image function to set background image to active block
  Page.prototype.uploadImage = function uploadImage(imageFile, activeBlock) {
    var _this10 = this;
    var currentActiveBlock = activeBlock;
    let topBarConfig = {
      autoRun: true,
      barThickness: 3,
      shadowBlur: 10,
      shadowColor: 'rgba(0,   0,   0,   .6)'
    }

    if (ALLOWED_IMAGE_TYPES.includes(imageFile.type)) {
      window.topbar.config({
        ...topBarConfig,
        barColors: {
          '0': '#4BB7E3',
          '.25': '#4BB7E3',
          '.50': '#4BB7E3',
          '.75': '#4BB7E3',
          '1.0': '#4BB7E3'
        }
      });
      window.topbar.show();
      const xhttp = new XMLHttpRequest;
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
            window.topbar.hide();
            let response = JSON.parse(this.responseText);
            if (currentActiveBlock && currentActiveBlock.el) {
              // currentActiveBlock.el.style.backgroundColor = null;
              currentActiveBlock.el.style.setProperty('background-image', `url(${response.data.url})`, 'important');
              currentActiveBlock.el.style.setProperty('background-repeat', `no-repeat`, 'important');
              currentActiveBlock.el.style.setProperty('background-size', `cover`, 'important');
              Helpers.setBackgroundButtonStatus(currentActiveBlock.el, _this10);
            }
        } else {
          window.topbar.config({
            ...topBarConfig,
            barColors: {
              '0': '#dc3545',
              '.25': '#dc3545',
              '.50': '#dc3545',
              '.75': '#dc3545',
              '1.0': '#dc3545'
            }
          });
          window.topbar.hide();
        }
      };
      xhttp.onerror = function () {
        window.topbar.config({
          ...topBarConfig,
          barColors: {
            '0': '#dc3545',
            '.25': '#dc3545',
            '.50': '#dc3545',
            '.75': '#dc3545',
            '1.0': '#dc3545'
          }
        });
        window.topbar.hide();
      };
      xhttp.open("POST", _this10.opts.editorOptions.imageUploadURL, true);
      xhttp.setRequestHeader('Authorization', _this10.opts.editorOptions.requestHeaders['Authorization'])
      let formData = new FormData();
      formData.append("file", imageFile);
      xhttp.send(formData);
    } else {
      alert('Only JPG, PNG and JPEG files are supported. Please upload a valid JPG, PNG and JPEG template.');
    }
  };

  return Page;
}();

// Expose global classes.


Page.Events = Events;
Page.Helpers = Helpers;
Page.RegisterDesignBlock = DesignBlock.Register;
Page.Button = Button;

return Page;

})));
//# sourceMappingURL=froala_pages.js.map

/*!
  * Froala Pages v1.2.0 (https://github.com/froala-labs/froala-pages#readme)
  * Copyright 2017-2020 
  * Licensed under Froala Pages Terms (https://www.froala.com/pages/terms)
  */ !function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <p class="lead">\n          "Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast."\n        </p>\n\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/1.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-6 text-center">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n        </p>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/2.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-sm-8 col-md-6 col-lg-6 text-center">\n        <h2>\n          <strong>Right at the coast of the Semantics, a large language ocean.</strong>\n        </h2>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-outline-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/3.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-6 text-center">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n        </p>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row pt-5 pb-3">\n      <div class="col-12 text-center">\n        <p><strong>Fortune 100 companies are using our products</strong></p>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-12 text-center">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/4.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <h1>Far far away, behind the word mountains, far from</h1>\n        <p class="mt-5">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/5.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-4 text-center">\n        <p class="lead">\n          Follow us and ask more on:\n        </p>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/6.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center pb-0 pb-lg-4">\n      <div class="col-12">\n        <h1>Call to action</h1>\n      </div>\n    </div>\n    <div class="row text-center pt-4 pt-md-5">\n      <div class="col-12 col-sm-10 col-md-6 col-lg-4 m-sm-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3>First Action</h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n        <p class="mt-3"><a class="btn btn-light sl-1" href="https://www.froala.com">Button</a></p>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-4 ml-sm-auto mr-sm-auto mt-5 mt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3>Second Action</h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p class="mt-3"><a class="btn btn-light sl-1" href="https://www.froala.com">Button</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/7.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/2.svg);">\n    <div class="row justify-content-center py-5">\n      <div class="col-12 col-md-10 col-lg-8 text-center">\n        <div class="fdb-box">\n          <h1>Call to Action</h1>\n          <p class="lead">\n            Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n          </p>\n          <p class="mt-4">\n            <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/8.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-auto">\n        <h2>Use Froala Design Blocks for free in your project</h2>\n      </div>\n      <div class="col-auto mt-4 mt-sm-0">\n        <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/9.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5 bg-r" style="background-image: url({{imagesDir}}/shapes/4.svg);">\n    <div class="row justify-content-end py-5">\n      <div class="col-12 col-md-8 col-lg-6 mr-5 text-center">\n        <div class="fdb-box">\n          <h1>Call to Action</h1>\n          <p class="lead">\n            When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove\n          </p>\n          <p class="mt-4">\n            <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/10.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-auto text-center">\n        <a class="btn btn-outline-secondary" href="https://www.froala.com">Download</a>\n      </div>\n\n      <div class="col-auto mt-4 mt-sm-0">\n        <h2>Use Froala Design Blocks for free in your project</h2>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/11.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="h2">\n          Far far away, behind the word mountains, far from.\n        </p>\n      </div>\n    </div>\n\n    <div class="row align-items-center pt-2 pt-lg-5">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h2>Call to action</h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p class="mt-4"><a class="btn btn-primary" href="https://www.froala.com">Take a Tour</a></p>\n      </div>\n\n      <div class="col-8 col-md-4 m-auto m-md-0 ml-md-auto pt-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/git.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/12.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container justify-content-center align-items-center d-flex">\n    <div class="row justify-content-center text-center">\n      <div class="col-12 col-md-8">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/coffee.svg">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="mt-5"><a href="https://www.froala.com" class="btn btn-dark">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/13.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container bg-r py-5 my-5" style="background-image: url({{imagesDir}}/shapes/1.svg);">\n    <div class="row py-5">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-6 text-left">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n        </p>\n        <p class="mt-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/14.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 col-md-4 col-lg-3 m-auto m-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/smile.svg">\n      </div>\n\n      <div class="col-12 col-md-8 ml-auto pt-5 pt-md-0">\n        <h2>Call to action</h2>\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn\n          around and return to its own, safe country.</p>\n        <p class="mt-4"><a class="btn btn-secondary" href="https://www.froala.com">Take a Tour</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/15.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row justify-content-center text-center">\n      <div class="col-12 col-md-10 col-lg-8">\n        <h1>Froala Design Blocks is Open Source and free to use in your apps</h1>\n        <p class="mt-5"><a href="https://www.froala.com" class="btn btn-outline-light">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/16.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by\n          their place and supplies it with the necessary regelialia.\n        </p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center align-items-center pt-5">\n      <div class="col-8 col-sm-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/code.svg">\n      </div>\n      <div class="col-12 col-sm-6 m-auto pt-4 pt-sm-0">\n        <h2><strong>Bootstrap</strong></h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n      <div class="col-12 col-sm-3 text-center pt-4 pt-sm-0">\n        <p><a class="btn btn-outline-primary" href="https://www.froala.com">Take a Tour</a></p>\n        <p><a class="btn btn-primary" href="https://www.froala.com">Start Now</a></p>\n        <p class="h5"><em>Some foo text</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/17.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container align-items-end justify-content-center d-flex">\n    <div class="row align-items-top text-left">\n      <div class="col-12 col-md-6 col-lg-5">\n        <p class="mb-5 mt-5"><img alt="image" height="40" src="{{imagesDir}}/logo.png"></p>\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-md-6 col-lg-4 m-auto pt-5">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/sync.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/18.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-sm-6">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/sync2.svg">\n      </div>\n\n      <div class="col-12 col-lg-5 ml-auto pt-5 pt-lg-0">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-secondary">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/19.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-md-8">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.</p>\n      </div>\n      <div class="col-12 col-md-3 ml-auto text-left text-md-right">\n        <p><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n    </div>\n\n    <div class="row pt-5">\n      <div class="col-6 offset-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/rocket.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/20.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-8">\n        <h1>Froala Design Blocks is build on Boostrap Framework</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there.</p>\n        <p class="mt-5">\n          <a href="https://www.froala.com" class="btn btn-light">Call to Action</a>\n          <a href="https://www.froala.com" class="btn btn-dark ml-4">Button</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/21.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-5 text-center pb-md-5">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center pt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n\n        <h3><strong>Feature One</strong></h3>\n\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n\n        <h3><strong>Feature Two</strong></h3>\n\n        <p>Separated they live in Bookmarksgrove right at the coast</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n\n        <h3><strong>Feature Three</strong></h3>\n\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/compass.svg">\n\n        <h3><strong>Feature Four</strong></h3>\n\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/22.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-md-5">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row mt-5">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h2>Contact Us</h2>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.\n        </p>\n\n        <p class="lead">\n          It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n        </p>\n\n\n        <p class="h3 mt-5">\n          <strong>Email:</strong> <a href="https://www.froala.com">hello@website.com</a>\n        </p>\n        <p class="lead">\n          <strong>Phone:</strong> <a href="https://www.froala.com">+44 123 123 1232</a>\n        </p>\n      </div>\n\n      <div class="col-12 col-md-6 ml-auto pt-5 pt-md-0">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="First name">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Last name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/1.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <h2>We love to hear from you!</h2>\n      </div>\n    </div>\n\n    <div class="row pt-4">\n      <div class="col-12">\n        <form>\n          <div class="row">\n            <div class="col-12 col-md">\n              <input type="text" class="form-control" placeholder="Name">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <input type="text" class="form-control" placeholder="Phone (optional)">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-center">\n              <button type="submit" class="btn btn-dark">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/2.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n      </div>\n    </div>\n\n    <div class="row pt-4">\n      <div class="col-12 col-md-6">\n        <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n          width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n      </div>\n\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/3.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row py-5">\n      <div class="col py-5">\n        <div class="fdb-box fdb-touch">\n          <div class="row text-center justify-content-center">\n            <div class="col-12 col-md-9 col-lg-7">\n              <h1>Contact Us</h1>\n              <p class="lead">Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy.</p>\n            </div>\n          </div>\n\n          <div class="row justify-content-center pt-4">\n            <div class="col-12 col-md-8">\n              <form>\n                <div class="row">\n                  <div class="col-12 col-md">\n                    <input type="text" class="form-control" placeholder="Name">\n                  </div>\n                  <div class="col-12 col-md mt-4 mt-md-0">\n                    <input type="text" class="form-control" placeholder="Email">\n                  </div>\n                </div>\n\n                <div class="row mt-4">\n                  <div class="col">\n                    <input type="email" class="form-control" placeholder="Subject">\n                  </div>\n                </div>\n\n                <div class="row mt-4">\n                  <div class="col">\n                    <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n                  </div>\n                </div>\n                <div class="row mt-4">\n                  <div class="col text-center">\n                    <button type="submit" class="btn btn-primary">Submit</button>\n                  </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/4.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-3">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row text-center justify-content-center pt-5">\n      <div class="col-12 col-md-7">\n        <h1>Contact Us</h1>\n      </div>\n    </div>\n\n    <div class="row justify-content-center pt-4">\n      <div class="col-12 col-md-7">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-center">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class="row-100"></div>\n  </div>\n  <div class="bg-dark">\n    <div class="container">\n      <div class="row-50"></div>\n      <div class="row justify-content-center text-center">\n        <div class="col-12 col-md mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/phone.svg">\n          <p class="lead">+44 (112) 123 752</p>\n        </div>\n\n        <div class="col-12 col-md pt-4 pt-md-0 mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/navigation.svg">\n          <p class="lead">123 6th St.<br>Melbourne, FL 32904</p>\n        </div>\n\n        <div class="col-12 col-md pt-4 pt-md-0 mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/mail.svg">\n          <p class="lead">support@website.com</p>\n        </div>\n      </div>\n      <div class="row-50"></div>\n    </div>\n  </div>\n\n  <div class="container">\n    <div class="row-70"></div>\n    <div class="row text-center">\n      <div class="col">\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/5.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-5">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row pt-5">\n      <div class="col-12">\n        <form>\n          <div class="row">\n            <div class="col-12 col-md">\n              <label>First Name</label>\n              <input type="text" class="form-control">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <label>Last Name</label>\n              <input type="text" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Your Email</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Subject (optional but helpful)</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <label>How can we help?</label>\n              <textarea class="form-control" name="message" rows="3"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4 text-center">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/6.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block py-0">\n  <div class="container py-5" style="background-image: url({{imagesDir}}/shapes/6.svg);">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">If you’re already an active user, please <a href="https://www.froala.com">sign in</a> before contacting us.</p>\n      </div>\n    </div>\n    <div class="row-50">\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <form>\n          <div class="row">\n            <div class="col">\n              <label>Your Email Address</label>\n              <input type="text" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Subject (optional but helpful)</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>How can we help?</label>\n              <textarea class="form-control" name="message" rows="3"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-right">\n              <button type="submit" class="btn btn-dark">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class="row-100"></div>\n  </div>\n\n  <div class="container-fluid p-0">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n</section>\n',"contacts/7.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0" style="background-image: url({{imagesDir}}/shapes/8.svg)">\n  <div class="bg-gray">\n    <div class="container">\n      <div class="row-100"></div>\n      <div class="row text-left">\n        <div class="col-8">\n          <h1>Contact Us</h1>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        </div>\n      </div>\n      <div class="row-100"></div>\n    </div>\n  </div>\n  <div class="container bg-r">\n    <div class="row-100"></div>\n    <div class="row">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h2>Call or email</h2>\n        <p class="text-large">Support, Sales, and Account Management services are currently available in English</p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>Support</strong>\n        </p>\n        <p>\n          +800 3005 4300\n        </p>\n        <p>\n          <a href="https://www.froala.com">Contact Support</a>\n        </p>\n        <p>\n          Our technical support is available by phone or email from 11am to 11pm BST, Monday through Friday.\n        </p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>Sales</strong>\n        </p>\n        <p>\n          +800 3005 4300\n        </p>\n        <p>\n          <a href="https://www.froala.com">Contact Sales</a>\n        </p>\n        <p>\n          Our technical support is available by phone or email from 11am to 11pm BST, Monday through Friday.\n        </p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>General inquiries</strong>\n        </p>\n        <p>\n          <a href="https://www.froala.com">hello@website.com</a>\n        </p>\n      </div>\n\n      <div class="col-12 col-md-6 ml-auto">\n        <h2>Drop us a line</h2>\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="First name">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Last name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Company Name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Phone">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Country">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <select class="form-control" required="">\n                  <option value="">Select Department</option>\n                  <option value="1">Support</option>\n                  <option value="2">Sales</option>\n                  <option value="3">Accounting</option>\n                </select>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="5" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/8.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block bg-gray">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <p class="h2">support@website.com</p>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p><br></p>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/9.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n    <div class="row-70"></div>\n    <div class="row">\n      <div class="col-12 col-md-8 col-lg m-auto">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class="col-12 col-md-8 col-lg pt-5 m-auto pt-lg-0">\n        <iframe class="mb-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n          width="100%" height="200" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n\n        <p><strong>Showroom</strong></p>\n        <p>\n          71 Pilgrim Avenue<br>Chevy Chase, MD 20815\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/10.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/1.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in <a href="https://www.froala.com">Bookmarksgrove</a> right at the coast of the Semantics, a large language\n          ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/2.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far <a href="https://www.froala.com">World of Grammar</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/3.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col col-sm-10 col-md-8 text-left">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/4.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col col-sm-10 col-md-8 text-left">\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far <a href="https://www.froala.com">World of Grammar</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/5.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-left">\n        <h2>Far far away...</h2>\n\n        <p>Far far away, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia</a> and <a href="https://www.froala.com">Consonantia</a>, there live the blind texts. Separated they live in Bookmarksgrove right at the coast\n          of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n\n        <p>On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the <a href="https://www.froala.com">Little Blind Text</a>          should turn around and return to its own, safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her, made her drunk with Longe and Parole and dragged her into their\n          agency, where they abused her for their.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/6.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n\n        <div class="row text-left pt-4">\n          <div class="col-12 col-md-6">\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden\n              flows by their place far far away.</p>\n          </div>\n          <div class="col-12 col-md-6">\n            <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at\n              the coast.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/7.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Subtitle text about launch comes here.</p>\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2">Learn More <i class="fas fa-angle-right"></i></a>\n          <a href="https://www.froala.com" class="mx-2">Buy <i class="fas fa-angle-right"></i></a>\n        </p>\n      </div>\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-6">\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/hosting.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/8.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/developer.svg">\n      </div>\n      <div class="col-4 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/git.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/9.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row pb-3">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-life.svg">\n      </div>\n      <div class="col-3 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/designer.svg">\n      </div>\n      <div class="col-3 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-community.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/10.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-6 col-md-2">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/1.svg">\n      </div>\n      <div class="col-6 col-md-2 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/5.svg">\n      </div>\n      <div class="col-6 col-md-2 mt-4 mt-md-0 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/7.svg">\n      </div>\n      <div class="col-6 col-md-2 mt-4 mt-md-0 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/4.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/11.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-12 col-md-6 ml-md-auto mt-4 mt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/2.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/12.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <img alt="image" class="fdb-icon mb-4" src="{{imagesDir}}/icons/gift.svg">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/13.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 mb-4 mb-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/smile.svg">\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 ml-md-auto text-left">\n        <h1>Froala Blocks</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n        <p><a class="btn btn-secondary mt-4" href="https://www.froala.com">Download</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/14.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/8.svg)">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 col-lg-5">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-10 col-sm-6 m-auto col-md-4 pt-4 pt-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/chat.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/15.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <div class="row justify-content-center pb-5">\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg"></div>\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg"></div>\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg"></div>\n        </div>\n\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/16.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 m-auto col-md-4 pb-4 pb-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/chatting.svg">\n      </div>\n\n      <div class="col-12 ml-auto col-md-6 col-lg-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p><a class="btn btn-primary mt-4 mb-5 mb-md-0" href="https://www.froala.com">Download</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/17.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-12 col-lg-6 col-xl-5">\n        <h1>Design Blocks</h1>\n        <p class="lead mb-5">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n\n        <p><strong>Works in every browser:</strong></p>\n        <p class="h1 text-muted">\n          <i class="fab fa-chrome mr-3"></i>\n          <i class="fab fa-safari mr-3"></i>\n          <i class="fab fa-firefox mr-3"></i>\n          <i class="fab fa-edge"></i>\n        </p>\n      </div>\n      <div class="col-12 col-md-8 m-auto ml-lg-auto mr-lg-0 col-lg-6 pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/browsers.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/18.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-6">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Awesome Things</strong></h3>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Far from the countries Vokalia and Consonantia.</p>\n      </div>\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>More Awesomeness</strong></h3>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia and Consonantia</a>, there live the blind texts. </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/19.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/10.svg);">\n    <div class="row text-left py-5">\n      <div class="col-12 col-sm-10 m-auto ml-md-5 col-md-8 col-lg-6">\n        <div class="fdb-box">\n          <div class="row justify-content-center">\n            <div class="col-12 col-xl-8 text-center">\n              <h1>Froala Design Blocks</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n              <p class="h3 mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/20.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5 bg-r" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row text-left py-5">\n      <div class="col-12 col-md-8 col-lg-6 ml-sm-auto">\n        <div class="fdb-box fdb-touch">\n          <div class="row justify-content-center">\n            <div class="col-12 col-xl-8 text-center">\n              <h1>Froala Design Blocks</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n              <p class="h3 mt-4"><a href="https://www.froala.com" class="btn btn-primary">Register</a></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/21.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-lg-8 col-xl-6 text-center">\n        <img alt="image" width="200" src="{{imagesDir}}/logo.png">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>\n\n        <p class="h3 mt-5"><a href="https://www.froala.com" class="btn btn-primary">Download Now</a></p>\n        <p>Latest Version: 2.3.5</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/22.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 col-md-5 col-lg-4 m-auto pb-5 pb-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/iphone-hand.svg">\n      </div>\n\n      <div class="col-12 ml-md-auto col-md-7 col-lg-6 pb-5 pb-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n        <p class="mt-4">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n          <a class="btn btn-dark ml-3" href="https://www.froala.com">Register</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/23.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-7 col-lg-5 ml-md-auto">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n\n        <p class="mt-5">\n          <img alt="image" height="25" class="mr-4" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="25" class="mr-4" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="25" src="{{imagesDir}}/customers/amazon.svg">\n        </p>\n      </div>\n\n      <div class="col-10 col-sm-6 col-md-5 col-lg-4 m-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/customer-survey.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/24.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12">\n        <div class="row justify-content-center pb-5">\n          <div class="col-12 col-lg-8 text-center">\n            <h1>Froala Design Blocks is Open Source and free to use</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/25.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="col-fill-left" style="background-image: url({{imagesDir}}/people/5.jpg);">\n  </div>\n\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n        <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/26.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="col-fill-right" style="background-image: url({{imagesDir}}/people/6.jpg);">\n  </div>\n\n  <div class="container py-5">\n    <div class="row">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="mt-4 mb-5"><a class="btn btn-secondary" href="https://www.froala.com">Button</a></p>\n\n        <p>Follow us on</p>\n        <p>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/27.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block bg-dark">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Made with <i class="fas fa-heart text-danger"></i> by Froala</h1>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/28.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-8 col-md-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-1.jpg">\n      </div>\n\n      <div class="col-4 col-md-2">\n        <div class="row">\n          <div class="col-12">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-2.jpg">\n          </div>\n        </div>\n\n        <div class="row mt-4">\n          <div class="col-12">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-3.jpg">\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-6 col-lg-5 ml-auto pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/29.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-6 col-lg-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/fireworks-1.jpg">\n      </div>\n\n      <div class="col-6 col-lg-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/fireworks-2.jpg">\n      </div>\n\n      <div class="col-12 col-lg-6 pt-3">\n        <p class="lead text-left">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.</p>\n        <p class="lead text-left">Right at the coast of the Semantics, a large language ocean. A small river named Duden. <a href="https://www.froala.com">[Read More]</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/30.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left align-items-center">\n      <div class="col-12 col-md-6 col-lg-4">\n        <h2>Your Website</h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="lead"><a href="https://www.froala.com">Read More</a></p>\n      </div>\n\n      <div class="col-12 col-md-6 col-lg-4 pt-4 pt-md-0">\n        <h2>Amazing Design</h2>\n        <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Dude a rge language ocean there live the blind.</p>\n        <p class="lead"><a href="https://www.froala.com">Read More</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto m-lg-0 col-lg-4 pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/tabs.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/31.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Froala Design Blocks</h1>\n        <p class="h2"><em>Right at the coast of the Semantics, a large language ocean.</em></p>\n      </div>\n    </div>\n\n    <div class="row text-center pt-3 pt-xl-5">\n      <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6">\n        <img alt="image" height="300" src="{{imagesDir}}/draws/tenis.svg">\n        <p class="lead pt-3">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n\n      <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6 pt-5 pt-md-0">\n        <img alt="image" height="300" src="{{imagesDir}}/draws/basketball.svg">\n        <p class="lead pt-3">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/32.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container pt-5 mt-5" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-8 col-lg-6">\n        <div class="fdb-box fdb-touch rounded-bottom-0">\n          <h2><strong>Design Blocks</strong></h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics</p>\n          <p class="lead mt-4"><a href="https://www.froala.com">Read More</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/33.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block pb-0" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container">\n    <div class="row text-left justify-content-end">\n      <div class="col-12 col-md-6 col-xl-5">\n        <div class="fdb-box rounded-bottom-0">\n          <h2><strong>Design Blocks</strong></h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n\n          <p class="lead mt-4"><a class="btn btn-outline-primary" href="https://www.froala.com">Read More</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/34.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left align-items-center">\n      <div class="col-10 col-sm-6 m-auto m-lg-0 col-lg-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/opened.svg">\n      </div>\n\n      <div class="col-12 col-lg-7 offset-lg-1 pt-4 pt-lg-0">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n\n        <div class="row mt-5">\n          <div class="col-12 col-sm-6">\n            <h3><strong>Open Source</strong></h3>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n          </div>\n\n          <div class="col-12 col-sm-6 pt-3 pt-sm-0">\n            <h3><strong>Bootstrap</strong></h3>\n            <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/35.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Custom",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <br>\n        <h2>Design your own custom block</h2>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/1.jpg"),n.RegisterDesignBlock("Custom",'<section class="fdb-block">\n  <div class="col-fill-left" style="background-image: url({{imagesDir}}/people/5.jpg);">\n  </div>\n\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">Design your own custom blocks. You can add the content and create your own blocks.</p>\n\n        <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/26.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-sm-center no-gutters">\n      <div class="col-12 col-sm-8 col-md-3 m-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-md-center pt-3 pt-md-5">\n      <div class="col-12 col-sm-8 col-md-3 m-auto">\n        <h3><strong>Feature 4</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 5</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 6</strong></h3>\n        <p>The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/1.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left justify-content-sm-center">\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-md-0 pt-lg-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 4</strong></h3>\n        <p>But nothing the copy said could convince her and so it didn’t take long</p>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-sm-center pt-3 pt-lg-5">\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto">\n        <h3><strong>Feature 5</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-md-0 pt-lg-0">\n        <h3><strong>Feature 6</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 7</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 8</strong></h3>\n        <p>But nothing the copy said could convince her and so it didn’t take long</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/2.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 text-center">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-5">\n      <div class="col-12 col-md-6 col-lg-5 m-auto">\n        <h3><strong>Feature One</strong></h3>\n\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature Two</strong></h3>\n\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line.</p>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-lg-4">\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-lg-0">\n        <h3><strong>Feature Three</strong></h3>\n\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times.</p>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-lg-0">\n        <h3><strong>Feature Four</strong></h3>\n\n        <p class="lead">A small river named Duden flows by their place far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/3.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-sm-center no-gutters">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto pt-5 pt-xl-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto pt-5 pt-xl-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/4.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-lg-6 col-xl-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <div class="row pt-4 pt-xl-5">\n          <div class="col-12 col-md-5">\n            <h4><strong>Feature One</strong></h4>\n            <p>A small river named Duden flows</p>\n          </div>\n          <div class="col-12 col-md-5 m-auto pt-3 pt-md-0">\n            <h4><strong>Feature Two</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 col-lg-6 m-auto mr-lg-0 ml-lg-auto pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/scrum.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/5.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-8 col-lg-6 m-md-auto ml-lg-0 mr-lg-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/features.svg">\n      </div>\n      <div class="col-12 col-lg-6 col-xl-5 ml-sm-auto pt-5 pt-lg-0">\n        <h1>Design Blocks</h1>\n\n        <div class="row pt-4 pt-xl-5">\n          <div class="col-12 col-sm-6 col-xl-5">\n            <h4><strong>Feature One</strong></h4>\n            <p>Far far away, behind the word mountains</p>\n          </div>\n          <div class="col-12 col-sm-6 col-xl-5 m-auto pt-3 pt-sm-0">\n            <h4><strong>Feature Two</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n\n        <div class="row pt-3">\n          <div class="col-12 col-sm-6 col-xl-5">\n            <h4><strong>Feature Three</strong></h4>\n            <p>A small river named Duden flows by me</p>\n          </div>\n          <div class="col-12 col-sm-6 col-xl-5 m-auto pt-3 pt-sm-0">\n            <h4><strong>Feature Four</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/6.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-sm-6 col-lg-5 col-xl-4 m-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-5 col-xl-4 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/7.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/email.svg">\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5 pt-5">\n      <div class="col-12 col-sm-4 col-lg-3 m-md-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>Feature 1</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-4 col-lg-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n        <h3><strong>Feature 2</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-4 col-lg-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature 3</strong></h3>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/8.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-sm-4 col-xl-3 m-md-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-xl-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-xl-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/9.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature Four</strong></h3>\n        <p>Duden flows by their place far far away, behind the word mountains.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/10.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-left mt-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row text-left pt-3 pt-sm-4 pt-md-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Four</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Five</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Six</strong></h3>\n            <p>On her way she met a copy. The copy warned the Little Blind Text.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/11.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-left mt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-sm-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layout.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Four</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row text-left pt-3 pt-lg-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Five</strong></h3>\n            <p>On her way she met a copy. The copy warned the Little Blind Text.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-sm-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/package.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Six</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Eight</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/12.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-lg-right align-items-center">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h4><strong>Feature One</strong></h4>\n        <p>Far far away, behind the word mountains is hope.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/layers.svg">\n        <h4><strong>Feature Two</strong></h4>\n        <p>On her way she met a copy of the Little Blind Text.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/map.svg">\n        <h4><strong>Feature Three</strong></h4>\n        <p>Even the all-powerful has no control about the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 text-left pt-3 pt-sm-0 order-lg-12">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h4><strong>Feature Four</strong></h4>\n        <p>Duden flows by their place, behind the word mountains.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/package.svg">\n        <h4><strong>Feature Five</strong></h4>\n        <p>Separated they live in Bookmark right at the coast</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/monitor.svg">\n        <h4><strong>Feature Six</strong></h4>\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-7 col-sm-4 col-lg-4 m-auto pt-5 pt-lg-0 order-lg-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/13.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-right align-items-center">\n      <div class="col-7 col-md-4 m-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n\n      <div class="col-12 col-md-7 col-lg-5 m-auto text-left pt-5 pt-md-0">\n        <div class="row pb-lg-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts.</p>\n          </div>\n        </div>\n\n        <div class="row pt-4 pt-md-5 pb-lg-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n\n\n        <div class="row pt-4 pt-md-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/14.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-right align-items-center">\n      <div class="col-12 col-lg-6 col-xl-5 m-lg-auto text-left">\n        <h1>Features</h1>\n        <p class="h3 pb-xl-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <div class="row pt-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences.</p>\n          </div>\n        </div>\n\n        <div class="row pt-5">\n          <div class="col-9 text-right">\n            <p>When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, there live the blind texts.</p>\n          </div>\n\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n        </div>\n      </div>\n\n      <div class="col-7 col-sm-4 m-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/15.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-xl-5">\n      <div class="col-12 col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n\n    <div class="row text-right align-items-center-lg align-items-end pt-5">\n      <div class="col-7 col-sm-4 m-auto mb-md-0 mt-md-0 m-lg-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n\n      <div class="col-12 col-md-7 col-lg-6 col-xl-5 m-auto text-left pt-5 pt-md-0">\n        <h3><strong>Feature One</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences.</p>\n\n        <h3 class="mt-4 mt-xl-5"><strong>Feature Two</strong></h3>\n        <p>When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, there live the blind texts.</p>\n\n        <h3 class="mt-4 mt-xl-5"><strong>Feature Three</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/16.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n    <div class="row justify-content-center mb-5">\n      <div class="col-10">\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/17.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-center">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-12 col-sm-4">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-4 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. </p>\n      </div>\n\n      <div class="col-12 col-sm-4 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country,</p>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/product-tour.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/18.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n\n    <div class="row text-left mt-5">\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto mr-md-auto ml-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/blue.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/red.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p> It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto ml-md-auto mr-md-0 pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/yellow.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/19.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-6">\n        <h3><strong>Feature One</strong></h3>\n\n        <p>Far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with\n          the necessary regelialia. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane.</p>\n\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n      <div class="col-12 col-md-6 pt-4 pt-md-0">\n        <h3><strong>Feature Two</strong></h3>\n\n        <p> It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life. The Big Oxmox advised her not to do so, because there\n          were thousands of bad Commas, wild Question Marks and devious Semikoli. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from\n          its origin.</p>\n\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/20.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. On her way she met a copy.\n          The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text.</p>\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-sm-6 col-md-5">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-5 ml-sm-auto pt-5 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/21.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-5">\n      <div class="col-12 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5 pb-md-5">\n      <div class="col-4 col-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/designer.svg">\n      </div>\n\n      <div class="col-12 col-md-5 m-md-auto">\n        <h2><strong>Feature One</strong></h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5 pb-md-5">\n      <div class="col-4 col-md-5 m-md-auto order-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-life.svg">\n      </div>\n\n      <div class="col-12 col-md-5">\n        <h2><strong>Feature Two</strong></h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5">\n      <div class="col-4 col-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-community.svg">\n      </div>\n\n      <div class="col-12 col-md-5 m-md-auto">\n        <h2><strong>Feature Three</strong></h2>\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn\n          around.\n        </p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/22.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 col-md-10 col-lg-8 text-left">\n        <h1>Froala Design Blocks is simply ahead the word mountains</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <p class="lead"><a href="https://www.froala.com">Explore all features <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-center no-gutters pt-5">\n      <div class="col-12 col-md-10 col-lg-8">\n        <div class="row">\n          <div class="col-8 col-sm-5 col-md-2 m-auto">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n            <h4>Feature One</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-sm-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n            <h4>Feature Two</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-md-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n            <h4>Feature Three</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-md-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n            <h4>Feature Four</h4>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/23.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-top">\n      <div class="col-12 col-md-6 col-xl-4 m-auto">\n        <h2>Learn more about the Froala Design Blocks you love</h2>\n      </div>\n\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <div class="row justify-content-left">\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n            <p><a href="https://www.froala.com">One <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n            <p><a href="https://www.froala.com">Two <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n            <p><a href="https://www.froala.com">Three <i class="fas fa-angle-right"></i></a></p>\n          </div>\n        </div>\n\n        <div class="row justify-content-left mt-4 mt-xl-5">\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n            <p><a href="https://www.froala.com">Four <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n            <p><a href="https://www.froala.com">Five <i class="fas fa-angle-right"></i></a></p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/24.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>There is a feature for everyone</h1>\n        <p class="lead"><a href="https://www.froala.com">See all features <i class="fas fa-angle-right"></i></a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-10 col-sm-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/blue.svg">\n        <h3><strong>Feature One</strong></h3>\n      </div>\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/red.svg">\n        <h3><strong>Feature Two</strong></h3>\n      </div>\n\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/purple.svg">\n        <h3><strong>Feature Three</strong></h3>\n      </div>\n\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/yellow.svg">\n        <h3><strong>Feature Four</strong></h3>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/25.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center pb-xl-5">\n      <div class="col-12 col-md-7 col-xl-5">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-md-4 m-sm-auto mr-md-0 ml-md-auto pt-4 pt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/developer.svg">\n      </div>\n    </div>\n\n    <div class="row pt-5">\n      <div class="col-12 col-sm-6 col-md-3">\n        <h3><strong>Feature One</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-sm-0">\n        <h3><strong>Feature Two</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-md-0">\n        <h3><strong>Feature Three</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-md-0">\n        <h3><strong>Feature Four</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/26.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-xl-5">\n      <div class="col-8 col-sm-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/development.svg">\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-5">\n      <div class="col-12 col-md-6 col-lg-5 m-sm-auto">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-sm-auto pt-3 pt-sm-5 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove, right at the coast of the Semantics, a large language ocean.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/27.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto pt-3 pt-md-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto pt-3 pt-md-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/28.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12col-md-10 col-lg-8 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5">\n      <div class="col-12 col-sm-6 col-md-5 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>Feature one longer Text</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-5 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature two shorter</strong></h3>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5 mt-md-4 pt-5">\n      <div class="col-12 col-md-10 col-lg-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/social-media.svg">\n        <p><em>Coming this fall</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/29.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-sm-6 col-md-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>The all-powerful Pointing has no control</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n        <h3><strong>Far far away, behind the word mountains</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h3><strong>The Big Oxmox advised her not to do so</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>The copy warned the Little Blind Text</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/30.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-md-8 m-auto col-lg-4">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the countries.</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarksgrove right at the coast.</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their place and supplies.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/31.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-8 m-auto col-lg-4">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the country Vokalia, there live the blind texts.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarks right at the coast of the Semantics, a large language ocean.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their small place and supplies it with the necessary regelialia.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/32.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-4">\n        <h2>Feature One</h2>\n        <p><strong>Far far away</strong>, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia and Consonantia</a>, there live the blind texts.</p>\n      </div>\n\n      <div class="col-12 col-md-4 pt-5 pt-sm-4 pt-md-0">\n        <h2>Feature Two</h2>\n        <p> A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n\n      <div class="col-12 col-md-4 pt-5 pt-sm-4 pt-md-0">\n        <h2>Feature Three</h2>\n        <p>Even the all-powerful Pointing has no control about the <strong>blind texts</strong> it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/33.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <p>© 2018 Froala. All Rights Reserved</p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/1.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small bg-dark">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-8">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center text-md-right">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/2.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-md-8">\n        <ul class="nav justify-content-center justify-content-md-start align-items-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">\n                <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n              </a>\n          </li>\n          <li class="w-100 d-block d-sm-none"></li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-md-right">\n        © 2013-2018 Froala\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/3.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-sm-6 col-md-4 text-sm-left">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 mt-4 mt-sm-0 text-center text-sm-right text-md-center">\n        © 2013-2018 Froala\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/4.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-6 mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/5.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small bg-dark">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col">\n        <ul class="nav justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy Policy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <p class="h5 mt-5">© 2013-2018 Froala</p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/6.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-lg-2 text-lg-left">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col mt-4 mt-lg-0 text-center">\n        <ul class="nav justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy Policy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-lg-2 mt-4 mt-lg-0 text-lg-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n\n    <div class="row mt-4">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/7.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="btn btn-primary">Contact Us</a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/8.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large">\n  <div class="container">\n    <div class="row align-items-top text-center">\n      <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-sm-left">\n        <h3><strong>Group 1</strong></h3>\n        <nav class="nav flex-column">\n          <a class="nav-link active" href="https://www.froala.com">Home</a>\n          <a class="nav-link" href="https://www.froala.com">Features</a>\n          <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          <a class="nav-link" href="https://www.froala.com">Team</a>\n          <a class="nav-link" href="https://www.froala.com">Contact Us</a>\n        </nav>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-5 mt-sm-0 text-sm-left">\n        <h3><strong>Group 2</strong></h3>\n        <nav class="nav flex-column">\n          <a class="nav-link active" href="https://www.froala.com">Privacy Policy</a>\n          <a class="nav-link" href="https://www.froala.com">Terms</a>\n          <a class="nav-link" href="https://www.froala.com">FAQ</a>\n          <a class="nav-link" href="https://www.froala.com">Support</a>\n        </nav>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 text-md-left mt-5 mt-md-0">\n        <h3><strong>About Us</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n\n      <div class="col-12 col-lg-2 ml-auto text-lg-left mt-4 mt-lg-0">\n        <h3><strong>Follow Us</strong></h3>\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row mt-3">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/9.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large bg-dark">\n  <div class="container">\n    <div class="row align-items-top text-center text-md-left">\n      <div class="col-12 col-sm-6 col-md-4">\n        <h3><strong>Country A</strong></h3>\n        <p>Street Address 52<br>Contact Name</p>\n        <p>+44 827 312 5002</p>\n        <p><a href="https://www.froala.com">countrya@amazing.com</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 mt-4 mt-sm-0">\n        <h3><strong>Country B</strong></h3>\n        <p>Street Address 100<br>Contact Name</p>\n        <p>+13 827 312 5002</p>\n        <p><a href="https://www.froala.com">countryb@amazing.com</a></p>\n      </div>\n\n      <div class="col-12 col-md-4 mt-5 mt-md-0 text-md-left">\n        <h3><strong>About Us</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n    </div>\n\n    <div class="row mt-5">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/10.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center text-center">\n      <div class="col-12 col-lg-4 text-lg-left">\n        © 2018 Froala\n      </div>\n\n      <div class="col-12 col-lg-4 mt-4 mt-lg-0">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col-12 col-lg-4 text-lg-right mt-4 mt-lg-0">\n        <ul class="nav justify-content-lg-end justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/11.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h3>Company Name</h3>\n        <p>70 Bowman St.<br>South Windsor, CT 06074</p>\n        <p>USA</p>\n        <p>+13 827 312 5002</p>\n      </div>\n    </div>\n\n    <div class="row mt-4">\n      <div class="col text-center">\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/12.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-6 text-center">\n        <h1>Subscribe</h1>\n        <div class="input-group mt-4 mb-4">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n\n        <p class="h4">Find us on <a href="https://www.froala.com">Facebook</a> and <a href="https://www.froala.com">Twitter</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/1.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container">\n    <div class="fdb-box">\n      <div class="row justify-content-center align-items-center">\n        <div class="col-12 col-lg-6">\n          <h2>Join us!</h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n        </div>\n        <div class="col-12 col-lg-5 text-center">\n          <div class="input-group mt-4">\n            <input type="text" class="form-control" placeholder="Enter your email address">\n            <div class="input-group-append">\n              <button class="btn btn-primary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/2.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-lg-10 col-xl-8 text-center">\n        <div class="row">\n          <div class="col">\n            <h1>Register</h1>\n            <p class="lead">When she reached the first hills, she had a last view back on the skyline of her hometown.</p>\n          </div>\n        </div>\n        <div class="row align-items-center">\n          <div class="col-12 col-md-5 mt-4">\n            <input type="text" class="form-control" placeholder="Email">\n          </div>\n          <div class="col-12 col-md-5 mt-4">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n          <div class="col-12 col-md-2 mt-4">\n            <button class="btn btn-secondary" type="button">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/3.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/6.svg);">\n    <div class="row">\n      <div class="col-12 col-md-8 col-lg-7 col-xl-5 text-left">\n        <div class="row">\n          <div class="col">\n            <h1>Sign Up</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col mt-4">\n            <input type="text" class="form-control" placeholder="Email">\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/4.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/4.svg);">\n    <div class=" row justify-content-end">\n      <div class="col-12 col-md-8 col-lg-6 col-xl-5 text-left">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col">\n              <h1>Log In</h1>\n              <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col mt-4">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control" placeholder="Password">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-secondary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/5.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-8 col-xl-6">\n        <div class="row">\n          <div class="col text-center">\n            <h1>Register</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row align-items-center">\n          <div class="col mt-4">\n            <input type="text" class="form-control" placeholder="Company Name">\n          </div>\n        </div>\n        <div class="row align-items-center mt-4">\n          <div class="col">\n            <input type="email" class="form-control" placeholder="Email">\n          </div>\n        </div>\n        <div class="row align-items-center mt-4">\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Confirm Password">\n          </div>\n        </div>\n        <div class="row justify-content-start mt-4">\n          <div class="col">\n            <div class="form-check">\n              <label class="form-check-label">\n                  <input type="checkbox" class="form-check-input">\n                  I Read and Accept <a href="https://www.froala.com">Terms and Conditions</a>\n                </label>\n            </div>\n\n            <button class="btn btn-primary mt-4">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/6.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7 col-xl-5 text-center">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col">\n              <h1>Log In</h1>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control mb-1" placeholder="Password">\n              <p class="text-right"><a href="https://www.froala.com">Recover Password</a></p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-outline-secondary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/7.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7 col-md-5 text-center">\n        <div class="fdb-box fdb-touch">\n          <div class="row">\n            <div class="col">\n              <h1>Register</h1>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col mt-4">\n              <input type="text" class="form-control" placeholder="Name">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control mb-1" placeholder="Password">\n              <p class="text-right"><a href="https://www.froala.com">Already have an account?</a></p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-primary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/8.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block bg-gray">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12  col-md-10 col-lg-8 col-xl-6 text-center">\n        <img alt="image" height="40" src="{{imagesDir}}/icons/layers.svg">\n        <h1>Never miss an update</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n        <div class="input-group mt-4 mb-4">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n        <p class="h5"><em>*Your email address is safe with us. We never share your email address.</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/9.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">\n        <h1>Company Name</h1>\n        <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown.</p>\n        <div class="input-group mt-5 mb-5">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/10.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 col-md-6 m-md-auto ml-lg-0 col-lg-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/group-chat.svg">\n      </div>\n      <div class="col-12 col-md-10 col-lg-6 mt-4 mt-lg-0 ml-auto mr-auto ml-lg-auto text-left">\n        <div class="row">\n          <div class="col">\n            <h1>Subscribe</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <div class="input-group">\n              <input type="text" class="form-control" placeholder="Enter your email address">\n              <div class="input-group-append">\n                <button class="btn btn-primary" type="button">Submit</button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class="row">\n          <div class="col">\n            <p class="h4">* Leave your email address to be notified first.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/11.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/1.svg);">\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-9 col-lg-8">\n        <div class="fdb-box fdb-touch">\n          <div class="row justify-content-center">\n            <div class="col-12 col-lg-10">\n              <h1>Subscribe</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove.</p>\n            </div>\n          </div>\n          <div class="row justify-content-center mt-4">\n            <div class="col-12 col-lg-10">\n              <div class="input-group">\n                <input type="text" class="form-control" placeholder="Enter your email address">\n                <div class="input-group-append">\n                  <button class="btn btn-primary" type="button">Submit</button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/12.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar">\n      <div class="col">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/1.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container text-center">\n    <nav class="navbar">\n      <div class="col">\n        <a class="ml-auto mr-auto" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/2.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav0" aria-controls="navbarNav0" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav0">\n        <ul class="navbar-nav mr-auto ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/3.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav1" aria-controls="navbarNav1" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav1">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end d-none d-lg-flex ml-md-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/4.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav2" aria-controls="navbarNav2" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="col-4 col-md-2 text-right text-md-center order-lg-6">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <div class="collapse navbar-collapse col-12 col-md-5 order-lg-1" id="navbarNav2">\n        <ul class="navbar-nav col-5">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav justify-content-end col-sm-5 order-lg-12 d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/5.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav3" aria-controls="navbarNav3" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav3">\n        <ul class="navbar-nav ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/6.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav4" aria-controls="navbarNav4" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8" id="navbarNav4">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav col-2 justify-content-end d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-facebook"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-google"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/7.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-lg">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav5" aria-controls="navbarNav5" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav5">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end ml-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Docs</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/8.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-1" aria-controls="navbarNav6" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8 navbar-collapse-1">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse justify-content-end col-md-2 navbar-collapse-1">\n        <ul class="navbar-nav">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In <i class="fas fa-sign-in-alt"></i></a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/9.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-3 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-2" aria-controls="navbarNav7" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse navbar-collapse-2 justify-content-center col-md-6" id="navbarNav7">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse navbar-collapse-2">\n        <ul class="navbar-nav ml-auto justify-content-end">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Register</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/10.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar">\n      <div class="col">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/11.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container text-center">\n    <nav class="navbar">\n      <div class="col">\n        <a class="ml-auto mr-auto" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/12.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav8" aria-controls="navbarNav8" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav8">\n        <ul class="navbar-nav mr-auto ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/13.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav9" aria-controls="navbarNav9" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav9">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end d-none d-lg-flex ml-md-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/14.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav10" aria-controls="navbarNav10" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="col-4 col-sm-2 text-center order-lg-6">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <div class="collapse navbar-collapse col-12 col-md-5 order-lg-1" id="navbarNav10">\n        <ul class="navbar-nav col-5">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav justify-content-end col-sm-5 order-lg-12 d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/15.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav11" aria-controls="navbarNav11" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav11">\n        <ul class="navbar-nav ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/16.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav12" aria-controls="navbarNav12" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8" id="navbarNav12">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav col-2 justify-content-end d-none d-md-flex">\n        <li class="nav-item active">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-facebook"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-google"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/17.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-lg">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav13" aria-controls="navbarNav13" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav13">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end ml-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Docs</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/18.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-3" aria-controls="navbarNav14" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8 navbar-collapse-3" id="navbarNav14">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse justify-content-end col-md-2 navbar-collapse-3">\n        <ul class="navbar-nav">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In <i class="fas fa-sign-in-alt"></i></a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/19.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-3 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-4" aria-controls="navbarNav15" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse navbar-collapse-4 justify-content-center col-md-6" id="navbarNav15">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse navbar-collapse-4">\n        <ul class="navbar-nav ml-auto justify-content-end">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Register</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/20.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/1.svg)">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1 class="text-light">Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 rounded">\n          <h2>Hobby</h2>\n          <p class="lead"><strong>$9 / month</strong></p>\n          <p class="h3 font-weight-light">Even the all-powerful Pointing has no control about.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-outline-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 fdb-touch rounded">\n          <h2 class="text-primary">Professional</h2>\n          <p class="lead"><strong>$19 / month</strong></p>\n          <p class="h3 font-weight-light">Far far away, behind the word mountains, far from.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 rounded">\n          <h2>Business</h2>\n          <p class="lead"><strong>$49 / month</strong></p>\n          <p class="h3 font-weight-light">Wild Question Marks, but the Little Blind Text didn’t listen.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-outline-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/1.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Hobby <strong class="float-xl-right d-lg-block d-xl-inline">$99</strong></h2>\n          <p class="lead"><em>Copy Writers ambushed her, made her drunk.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Advanced <strong class="float-xl-right d-lg-block d-xl-inline">$349</strong></h2>\n          <p class="lead"><em>Separated they live in Bookmarks right.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Business <strong class="float-xl-right d-lg-block d-xl-inline">$849</strong></h2>\n          <p class="lead"><em>A small river named Duden their place.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/2.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1 class="text-white">Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center">\n        <div class="fdb-box p-4">\n          <h2>Hobby</h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia.</p>\n\n          <p class="h1 mt-5 mb-5">$99</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-dark">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box px-4 pt-5">\n          <h2>Advanced</h2>\n          <p class="lead">Separated they live in Bookmarksgrove right at the coast, a large language ocean.</p>\n\n          <p class="h1 mt-5 mb-5">$299</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-secondary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box p-4">\n          <h2>Business</h2>\n          <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost life.</p>\n\n          <p class="h1 mb-5 mt-5">$799</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-dark">Buy Now</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/3.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block py-0">\n  <div class="container pt-5 my-5" style="background-image: url({{imagesDir}}/shapes/2.svg)">\n    <div class="row text-center py-5">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row py-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Startup</h2>\n          <hr>\n          <p class="h2"><strong>$9.90</strong></p>\n          <p class="h4">Far far away, behind the word mountains, far from the countries.</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>40MB of storage</em></p>\n          <p><br></p>\n          <p><br></p>\n          <p><br></p>\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Standard</h2>\n          <hr>\n          <p class="h2"><strong>$29.90</strong></p>\n          <p class="h4">The copy warned the Blind Text, that it would have been rewritten</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>1GB of storage</em></p>\n          <p class="text-right"><em>10 hours of support</em></p>\n          <p class="text-right"><em>Custom domain</em></p>\n          <p><br></p>\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Professional</h2>\n          <hr>\n          <p class="h2"><strong>$59.90</strong></p>\n          <p class="h4"> the headline of Alphabet Village and the subline of her own road.</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>1GB of storage</em></p>\n          <p class="text-right"><em>20 hours of support</em></p>\n          <p class="text-right"><em>Custom domain</em></p>\n          <p class="text-right"><em>Analytics and SEO</em></p>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/4.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/8.svg);">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center no-gutters">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center shadow">\n        <div class="bg-white pb-5 pt-5 pl-4 pr-4 rounded-left">\n          <h2 class="font-weight-light">Basic</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$19</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-outline-dark">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 ml-auto mr-auto col-lg-4 text-center mt-4 mt-lg-0 sl-1 pt-0 pt-lg-3 pb-0 pb-lg-3 bg-white fdb-touch rounded shadow">\n        <div class="pb-5 pt-5 pl-4 pr-4">\n          <h2 class="font-weight-light">Standard</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$49</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary btn-shadow">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 ml-auto mr-auto col-lg-4 text-center mt-4 mt-lg-0 shadow">\n        <div class="bg-white pb-5 pt-5 pl-4 pr-4 rounded-right">\n          <h2 class="font-weight-light">OEM</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$99</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-outline-dark">Choose Plan</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/5.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Startup</h2>\n            <p class="h2"><strong>$9.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/layers.svg"></p>\n            <p class="h4"><strong>For small companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Standard</h2>\n            <p class="h2"><strong>$19.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/monitor.svg"></p>\n            <p class="h4"><strong>For medium companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="h2"><strong>$29.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/package.svg"></p>\n            <p class="h4"><strong>For large companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/6.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Startup</strong></h3>\n          <p class="h4">&lt; 10 employees</p>\n\n          <p class="h1 mt-5">$9.90 <span class="lead">/ month</span></p>\n          <p>Far far away, behind the word mountains, far from the countries.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Agency</strong></h3>\n          <p class="h4">10-100 employees</p>\n\n          <p class="h1 mt-5">$19.90 <span class="lead">/ month</span></p>\n          <p>And if she hasn’t been rewritten, then they are still using her.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Business</strong></h3>\n          <p class="h4">&gt;100 employees</p>\n\n          <p class="h1 mt-5">$99.90 <span class="lead">/ month</span></p>\n          <p>Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/7.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-md-8 m-auto col-lg-4 text-center">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/cloud.svg">\n        <h2><strong>Startup</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$9 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 col-lg-4 text-center m-auto pt-5 pt-lg-0">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/life-buoy.svg">\n        <h2><strong>Advanced</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$19 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 text-center pt-5 pt-lg-0">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/layers.svg">\n        <h2><strong>Business</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$29 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/8.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Startup</h2>\n          <p class="h2">$99</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-md-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Advanced</h2>\n          <p class="h2">$399</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-xl-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Business</h2>\n          <p class="h2">$999</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-xl-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Enterprise</h2>\n          <p class="h2">Call Us</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Contact</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/9.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <table class="table text-center mt-5 d-none d-lg-table">\n      <tbody>\n        <tr>\n          <th scope="row" class="border-0"></th>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Hobby</h2>\n            <p class="lead">$99</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Professional</h2>\n            <p class="lead">$399</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="lead">$899</p>\n            <p><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Enterprise</h2>\n            <p class="lead">Call us</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Contact</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>3 months</td>\n          <td>6 months</td>\n          <td>12 months</td>\n          <td>Custom</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td></td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center border-0" colspan="2">\n            <h2 class="font-weight-light">Hobby</h2>\n            <p class="h2">$99</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>3 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Professional</h2>\n            <p class="h2">$399</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>6 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="h2">$899</p>\n            <p><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>12 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Enterprise</h2>\n            <p class="h2">Call us</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Contact</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>Custom</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td>✓</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</section>\n',"pricings/10.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Teams",'<section class="fdb-block team-1">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Our Team</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries.</p>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row">\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/1.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/2.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/3.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/6.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/1.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-2">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row text-center justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/4.jpg">\n\n        <h2>Sara Doe</h2>\n        <p>Founder</p>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h2>Sara Doe</h2>\n        <p>Founder</p>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h2>Sara Doe</h2>\n\n        <p>Founder</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/2.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-3">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-center mb-5">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/3.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-4">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/5.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>A wonderful serenity has taken possession of my entire soul.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/6.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Pityful a rethoric question ran over her cheek.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>And if she hasn’t been rewritten, then they are still using her.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/2.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Wild Question Marks, but the Little Blind Text didn’t listen.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/4.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-5">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-center">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5">\n      <div class="col-sm-2  m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/9.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/5.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-6">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/9.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n      </div>\n\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/1.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>One morning, when Gregor Samsa woke from troubled dreams.</p>\n      </div>\n\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>A small river named Duden flows by their place and supplies it.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/6.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-7">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/4.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/9.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/7.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-8">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Our Amazing Team</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n      </div>\n    </div>\n\n    <div class="row-100"></div>\n\n    <div class="row justify-content-center text-left">\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/8.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/7.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row justify-content-center text-left">\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/9.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/4.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/8.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-12 col-md-10 col-lg-8">\n        <p class="lead">\n          "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."\n        </p>\n\n        <p class="lead"><strong>Person Name</strong> <em class="ml-4">Co-founder at Company</em></p>\n      </div>\n      <div class="col-8 col-sm-6 col-md-2 col-lg-3 col-xl-2 mt-4 mt-md-0 ml-auto mr-auto mr-md-0">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/1.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="fdb-box">\n      <div class="row align-items-center justify-content-center">\n        <div class="col-10 col-sm-6 col-md-4 col-lg-3 col-xl-2 m-auto">\n          <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n        </div>\n\n        <div class="col-12 col-md-8 ml-auto mr-auto mt-4 mt-md-0">\n          <p class="lead">\n            "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n          </p>\n\n          <p class="h3 mt-4 mt-lg-5"><strong>Person Name</strong></p>\n          <p><em>Co-founder at Company</em></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/2.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h3><strong>You are in good company</strong></h3>\n\n        <div class="mt-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n        </div>\n        <div class="mt-2 mt-md-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/cisco.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/apple.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ibm.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/intel.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/panasonic.svg">\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/3.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-md-6">\n        <div class="fdb-box fdb-touch">\n          <p class="h3 mb-4">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics."</p>\n\n          <p>\n            <img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/5.jpg">\n            <strong class="ml-3">Person Name</strong>\n          </p>\n        </div>\n      </div>\n\n      <div class="col-md-6 mt-4 mt-md-0">\n        <div class="fdb-box fdb-touch">\n          <p class="h3 mb-4">"A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."</p>\n\n          <p>\n            <img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/4.jpg">\n            <strong class="ml-3">Person Name</strong>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/4.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block py-5">\n  <div class="container py-5" style="background-image: url({{imagesDir}}/shapes/2.svg);">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-lg-9 col-xl-6">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col-8 col-sm-6 col-md-4 col-xl-3 ml-auto mr-auto">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/6.jpg">\n            </div>\n\n            <div class="col-md-8 mt-4 mt-md-0">\n              <p class="lead">\n                "Even the all-powerful Pointing has no control about day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n              </p>\n\n              <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n              <p><em>Co-founder at Company</em></p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-lg-9 col-xl-6 mt-4 mt-xl-0">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col-8 col-sm-6 col-md-4 col-xl-3 ml-auto mr-auto">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/8.jpg">\n            </div>\n\n            <div class="col-md-8 mt-4 mt-md-0">\n              <p class="lead">\n                "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. Separated they at the coast of the Semantics, a large language ocean."\n              </p>\n\n              <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n              <p><em>Co-founder at Company</em></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/5.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-lg-8">\n        <h2>You are in good company</h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n        <div class="mt-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/6.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block bg-dark">\n  <div class="container">\n    <div class="row justify-content-center text-center">\n      <div class="col">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/7.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row pb-xl-5 text-center justify-content-center">\n      <div class="col-md-10 col-lg-7">\n        <h1>Testimonials</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-md-8 col-lg-4 col-xl-3 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/intel.svg">\n        <p class="h3 mt-4">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n\n      <div class="col-md-8 col-lg-4 col-xl-3 pt-5 pt-lg-0 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/apple.svg">\n        <p class="h3 mt-4">"Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n\n      <div class="col-md-8 col-lg-4 col-xl-3 pt-5 pt-lg-0 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/samsung.svg">\n        <p class="h3 mt-4">"A small river named Duden flows by their place and supplies it with the necessary regelialia."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/8.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-md-10 col-lg-8 col-xl-7">\n        <h1>Testimonials</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center justify-content-center">\n      <div class="col-md-8 col-lg-4">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/1.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Even the all-powerful Pointing has no control about the blind texts it is an small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-md-8 col-lg-4 mt-4 mt-lg-0">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Far far away, behind the word mountains, far from the countries Vokalia. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-md-8 col-lg-4 mt-4 mt-lg-0">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/2.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Separated they live in Bookmarksgrove right at the coast of the Semantics, the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/9.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-md-10 col-lg-7">\n        <h1>Testimonials</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-md-10 col-lg-3 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/5.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n\n      <div class="col-md-10 col-lg-3 pt-5 pt-lg-0 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/8.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n\n      <div class="col-md-10 col-lg-3 pt-5 pt-lg-0 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"A small river named Duden flows by their place and supplies it with the necessary regelialia."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/9.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/10.jpg")});
/*!
 * froala_editor v4.0.1 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.FroalaEditor = t()
}(this, function () {
  "use strict";

  function kt(e) {
    return (kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    })(e)
  }

  Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) {
    var t = this;
    if (!document.documentElement.contains(t)) return null;
    do {
      if (t.matches(e)) return t;
      t = t.parentElement || t.parentNode
    } while (null !== t && 1 === t.nodeType);
    return null
  }), Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (e) {
    for (var t = (this.document || this.ownerDocument).querySelectorAll(e), n = t.length; 0 <= --n && t.item(n) !== this;) ;
    return -1 < n
  }), Array.isArray || (Array.isArray = function (e) {
    return "[object Array]" === Object.prototype.toString.call(e)
  }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
    value: function (e, t) {
      if (null == e) throw new TypeError("Cannot convert undefined or null to object");
      for (var n = Object(e), r = 1; r < arguments.length; r++) {
        var a = arguments[r];
        if (null != a) for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o])
      }
      return n
    }, writable: !0, configurable: !0
  }), function () {
    var i = /^\s*:scope/gi, s = /,\s*:scope/gi, l = document.createElement("div");

    function e(e, t) {
      var o = e[t];
      e[t] = function (e) {
        var t, n = !1, r = !1;
        if (!e || Array.isArray(e) || !e.match(i) && !e.match(s)) return o.call(this, e);
        this.parentNode || (l.appendChild(this), r = !0);
        var a = this.parentNode;
        return this.id || (this.id = "rootedQuerySelector_id_".concat((new Date).getTime()), n = !0), t = o.call(a, e.replace(i, "#".concat(this.id)).replace(s, ",#".concat(this.id))), n && (this.id = ""), r && l.removeChild(this), t
      }
    }

    try {
      var t = l.querySelectorAll(":scope *");
      if (!t || Array.isArray(t)) throw"error"
    } catch (n) {
      e(Element.prototype, "querySelector"), e(Element.prototype, "querySelectorAll"), e(HTMLElement.prototype, "querySelector"), e(HTMLElement.prototype, "querySelectorAll")
    }
  }(), "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function (e) {
    if ("Element" in e) {
      var t = "classList", n = "prototype", r = e.Element[n], a = Object, o = String[n].trim || function () {
        return this.replace(/^\s+|\s+$/g, "")
      }, i = Array[n].indexOf || function (e) {
        for (var t = 0, n = this.length; t < n; t++) if (t in this && this[t] === e) return t;
        return -1
      }, s = function s(e, t) {
        this.name = e, this.code = DOMException[e], this.message = t
      }, l = function l(e, t) {
        if ("" === t) throw new s("SYNTAX_ERR", "The token must not be empty.");
        if (/\s/.test(t)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
        return i.call(e, t)
      }, c = function c(e) {
        for (var t = o.call(e.getAttribute("class") || ""), n = t ? t.split(/\s+/) : [], r = 0, a = n.length; r < a; r++) this.push(n[r]);
        this._updateClassName = function () {
          e.setAttribute("class", this.toString())
        }
      }, d = c[n] = [], f = function f() {
        return new c(this)
      };
      if (s[n] = Error[n], d.item = function (e) {
        return this[e] || null
      }, d.contains = function (e) {
        return ~l(this, e + "")
      }, d.add = function () {
        for (var e, t = arguments, n = 0, r = t.length, a = !1; e = t[n] + "", ~l(this, e) || (this.push(e), a = !0), ++n < r;) ;
        a && this._updateClassName()
      }, d.remove = function () {
        var e, t, n = arguments, r = 0, a = n.length, o = !1;
        do {
          for (e = n[r] + "", t = l(this, e); ~t;) this.splice(t, 1), o = !0, t = l(this, e)
        } while (++r < a);
        o && this._updateClassName()
      }, d.toggle = function (e, t) {
        var n = this.contains(e), r = n ? !0 !== t && "remove" : !1 !== t && "add";
        return r && this[r](e), !0 === t || !1 === t ? t : !n
      }, d.replace = function (e, t) {
        var n = l(e + "");
        ~n && (this.splice(n, 1, t), this._updateClassName())
      }, d.toString = function () {
        return this.join(" ")
      }, a.defineProperty) {
        var p = {get: f, enumerable: !0, configurable: !0};
        try {
          a.defineProperty(r, t, p)
        } catch (u) {
          void 0 !== u.number && -2146823252 !== u.number || (p.enumerable = !1, a.defineProperty(r, t, p))
        }
      } else a[n].__defineGetter__ && r.__defineGetter__(t, f)
    }
  }(self), function () {
    var e = document.createElement("_");
    if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
      var t = function Yc(e) {
        var Yc = DOMTokenList.prototype[e];
        DOMTokenList.prototype[e] = function (e) {
          var t, n = arguments.length;
          for (t = 0; t < n; t++) e = arguments[t], Yc.call(this, e)
        }
      };
      t("add"), t("remove")
    }
    if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
      var n = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (e, t) {
        return 1 in arguments && !this.contains(e) == !t ? t : n.call(this, e)
      }
    }
    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function (e, t) {
      var n = this.toString().split(" "), r = n.indexOf(e + "");
      ~r && (n = n.slice(r), this.remove.apply(this, n), this.add(t), this.add.apply(this, n.slice(1)))
    }), e = null
  }());

  function xt(e, t, n) {
    if ("string" != typeof e) return new xt.Bootstrap(e, t, n);
    var r = document.querySelectorAll(e);
    t && t.iframe_document && (r = t.iframe_document.querySelectorAll(e));
    for (var a = [], o = 0; o < r.length; o++) {
      var i = r[o]["data-froala.editor"];
      i ? a.push(i) : a.push(new xt.Bootstrap(r[o], t, n))
    }
    return 1 == a.length ? a[0] : a
  }

  xt.RegisterPlugins = function (e) {
    for (var t = 0; t < e.length; t++) e[t].call(xt)
  }, Object.assign(xt, {
    DEFAULTS: {initOnClick: !1, pluginsEnabled: null},
    MODULES: {},
    PLUGINS: {},
    VERSION: "4.0.1",
    INSTANCES: [],
    OPTS_MAPPING: {},
    SHARED: {},
    ID: 0
  }), xt.MODULES.node = function (i) {
    var n = i.$;

    function s(e) {
      return e && "IFRAME" !== e.tagName ? Array.prototype.slice.call(e.childNodes || []) : []
    }

    function l(e) {
      return !!e && (e.nodeType === Node.ELEMENT_NODE && 0 <= xt.BLOCK_TAGS.indexOf(e.tagName.toLowerCase()))
    }

    function c(e) {
      var t = {}, n = e.attributes;
      if (n) for (var r = 0; r < n.length; r++) {
        var a = n[r];
        t[a.nodeName] = a.value
      }
      return t
    }

    function t(e) {
      for (var t = "", n = c(e), r = Object.keys(n).sort(), a = 0; a < r.length; a++) {
        var o = r[a], i = n[o];
        i.indexOf("'") < 0 && 0 <= i.indexOf('"') ? t += " ".concat(o, "='").concat(i, "'") : (0 <= i.indexOf('"') && 0 <= i.indexOf("'") && (i = i.replace(/"/g, "&quot;")), t += " ".concat(o, '="').concat(i, '"'))
      }
      return t
    }

    function r(e) {
      return e === i.el
    }

    return {
      isBlock: l, isEmpty: function d(e, t) {
        if (!e) return !0;
        if (e.querySelector("table")) return !1;
        var n = s(e);
        1 === n.length && l(n[0]) && (n = s(n[0]));
        for (var r = !1, a = 0; a < n.length; a++) {
          var o = n[a];
          if (!(t && i.node.hasClass(o, "fr-marker") || o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length)) {
            if ("BR" !== o.tagName && 0 < (o.textContent || "").replace(/\u200B/gi, "").replace(/\n/g, "").length) return !1;
            if (r) return !1;
            "BR" === o.tagName && (r = !0)
          }
        }
        return !(e.querySelectorAll(xt.VOID_ELEMENTS.join(",")).length - e.querySelectorAll("br").length || e.querySelector("".concat(i.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || 1 < e.querySelectorAll(xt.BLOCK_TAGS.join(",")).length || e.querySelector("".concat(i.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"), ":not(.fr-marker)")))
      }, blockParent: function a(e) {
        for (; e && e.parentNode !== i.el && (!e.parentNode || !i.node.hasClass(e.parentNode, "fr-inner"));) if (l(e = e.parentNode)) return e;
        return null
      }, deepestParent: function o(e, t, n) {
        if (void 0 === t && (t = []), void 0 === n && (n = !0), t.push(i.el), 0 <= t.indexOf(e.parentNode) || e.parentNode && i.node.hasClass(e.parentNode, "fr-inner") || e.parentNode && 0 <= xt.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName) && n) return null;
        for (; t.indexOf(e.parentNode) < 0 && e.parentNode && !i.node.hasClass(e.parentNode, "fr-inner") && (xt.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName) < 0 || !n) && (!l(e) || l(e.parentNode)) && (!l(e) || !l(e.parentNode) || !n);) e = e.parentNode;
        return e
      }, rawAttributes: c, attributes: t, clearAttributes: function f(e) {
        for (var t = e.attributes, n = t.length - 1; 0 <= n; n--) {
          var r = t[n];
          e.removeAttribute(r.nodeName)
        }
      }, openTagString: function p(e) {
        return "<".concat(e.tagName.toLowerCase()).concat(t(e), ">")
      }, closeTagString: function u(e) {
        return "</".concat(e.tagName.toLowerCase(), ">")
      }, isFirstSibling: function h(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.previousSibling; n && t && i.node.hasClass(n, "fr-marker");) n = n.previousSibling;
        return !n || n.nodeType === Node.TEXT_NODE && "" === n.textContent && h(n)
      }, isLastSibling: function g(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.nextSibling; n && t && i.node.hasClass(n, "fr-marker");) n = n.nextSibling;
        return !n || n.nodeType === Node.TEXT_NODE && "" === n.textContent && g(n)
      }, isList: function m(e) {
        return !!e && 0 <= ["UL", "OL"].indexOf(e.tagName)
      }, isLink: function v(e) {
        return !!e && e.nodeType === Node.ELEMENT_NODE && "a" === e.tagName.toLowerCase()
      }, isElement: r, contents: s, isVoid: function b(e) {
        return e && e.nodeType === Node.ELEMENT_NODE && 0 <= xt.VOID_ELEMENTS.indexOf((e.tagName || "").toLowerCase())
      }, hasFocus: function C(e) {
        return e === i.doc.activeElement && (!i.doc.hasFocus || i.doc.hasFocus()) && Boolean(r(e) || e.type || e.href || ~e.tabIndex)
      }, isEditable: function E(e) {
        return (!e.getAttribute || "false" !== e.getAttribute("contenteditable")) && ["STYLE", "SCRIPT"].indexOf(e.tagName) < 0
      }, isDeletable: function y(e) {
        return e && e.nodeType === Node.ELEMENT_NODE && e.getAttribute("class") && 0 <= (e.getAttribute("class") || "").indexOf("fr-deletable")
      }, hasClass: function L(e, t) {
        return e instanceof n && (e = e.get(0)), e && e.classList && e.classList.contains(t)
      }, filter: function _(e) {
        return i.browser.msie ? e : {acceptNode: e}
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    DOMPurify: window.DOMPurify,
    htmlAllowedTags: ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "pre", "progress", "queue", "rp", "rt", "ruby", "s", "samp", "script", "style", "section", "select", "small", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "var", "video", "wbr"],
    htmlRemoveTags: ["script", "style"],
    htmlAllowedAttrs: ["accept", "accept-charset", "accesskey", "action", "align", "allowfullscreen", "allowtransparency", "alt", "async", "autocomplete", "autofocus", "autoplay", "autosave", "background", "bgcolor", "border", "charset", "cellpadding", "cellspacing", "checked", "cite", "class", "color", "cols", "colspan", "content", "contenteditable", "contextmenu", "controls", "coords", "data", "data-.*", "datetime", "default", "defer", "dir", "dirname", "disabled", "download", "draggable", "dropzone", "enctype", "for", "form", "formaction", "frameborder", "headers", "height", "hidden", "high", "href", "hreflang", "http-equiv", "icon", "id", "ismap", "itemprop", "keytype", "kind", "label", "lang", "language", "list", "loop", "low", "max", "maxlength", "media", "method", "min", "mozallowfullscreen", "multiple", "muted", "name", "novalidate", "open", "optimum", "pattern", "ping", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "reversed", "rows", "rowspan", "sandbox", "scope", "scoped", "scrolling", "seamless", "selected", "shape", "size", "sizes", "span", "src", "srcdoc", "srclang", "srcset", "start", "step", "summary", "spellcheck", "style", "tabindex", "target", "title", "type", "translate", "usemap", "value", "valign", "webkitallowfullscreen", "width", "wrap"],
    htmlAllowedStyleProps: [".*"],
    htmlAllowComments: !0,
    htmlUntouched: !1,
    fullPage: !1
  }), xt.HTML5Map = {B: "STRONG", I: "EM", STRIKE: "S"}, xt.MODULES.clean = function (f) {
    var d, p, u, h, g = f.$;

    function a(e) {
      if (e.nodeType === Node.ELEMENT_NODE && e.getAttribute("class") && 0 <= e.getAttribute("class").indexOf("fr-marker")) return !1;
      var t, n = f.node.contents(e), r = [];
      for (t = 0; t < n.length; t++) n[t].nodeType !== Node.ELEMENT_NODE || f.node.isVoid(n[t]) ? n[t].nodeType === Node.TEXT_NODE && (n[t].textContent = n[t].textContent.replace(/\u200b/g, "")) : n[t].textContent.replace(/\u200b/g, "").length !== n[t].textContent.length && a(n[t]);
      if (e.nodeType === Node.ELEMENT_NODE && !f.node.isVoid(e) && (e.normalize(), n = f.node.contents(e), r = e.querySelectorAll(".fr-marker"), n.length - r.length == 0)) {
        for (t = 0; t < n.length; t++) if (n[t].nodeType === Node.ELEMENT_NODE && (n[t].getAttribute("class") || "").indexOf("fr-marker") < 0) return !1;
        for (t = 0; t < r.length; t++) e.parentNode.insertBefore(r[t].cloneNode(!0), e);
        return e.parentNode.removeChild(e), !1
      }
    }

    function s(e, t) {
      if (e.nodeType === Node.COMMENT_NODE) return "\x3c!--".concat(e.nodeValue, "--\x3e");
      if (e.nodeType === Node.TEXT_NODE) return t ? e.textContent.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : e.textContent.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\u00A0/g, "&nbsp;").replace(/\u0009/g, "");
      if (e.nodeType !== Node.ELEMENT_NODE) return e.outerHTML;
      if (e.nodeType === Node.ELEMENT_NODE && 0 <= ["STYLE", "SCRIPT", "NOSCRIPT"].indexOf(e.tagName)) return e.outerHTML;
      if (e.nodeType === Node.ELEMENT_NODE && "svg" === e.tagName) {
        var n = document.createElement("div"), r = e.cloneNode(!0);
        return n.appendChild(r), n.innerHTML
      }
      if ("IFRAME" === e.tagName) return e.outerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
      var a = e.childNodes;
      if (0 === a.length) return e.outerHTML;
      for (var o = "", i = 0; i < a.length; i++) "PRE" === e.tagName && (t = !0), o += s(a[i], t);
      return f.node.openTagString(e) + o + f.node.closeTagString(e)
    }

    var l = [];

    function m(e) {
      var t = e.replace(/;;/gi, ";");
      return ";" !== (t = t.replace(/^;/gi, "")).charAt(t.length) && (t += ";"), t
    }

    function c(e) {
      var t;
      for (t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
        var n = t.match(u), r = null;
        "style" === t && f.opts.htmlAllowedStyleProps.length && (r = e[t].match(h)), n && r ? e[t] = m(r.join(";")) : n && ("style" !== t || r) || delete e[t]
      }
      for (var a = "", o = Object.keys(e).sort(), i = 0; i < o.length; i++) e[t = o[i]].indexOf('"') < 0 ? a += " ".concat(t, '="').concat(e[t], '"') : a += " ".concat(t, "='").concat(e[t], "'");
      return a
    }

    function v(e, t) {
      var n, r = document.implementation.createHTMLDocument("Froala DOC").createElement("DIV");
      g(r).append(e);
      var a = "";
      if (r) {
        var o = f.node.contents(r);
        for (n = 0; n < o.length; n++) t(o[n]);
        for (o = f.node.contents(r), n = 0; n < o.length; n++) a += s(o[n])
      }
      return a
    }

    function b(e, t, n) {
      var r = e = function o(e) {
        return l = [], e = (e = (e = (e = e.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, function (e) {
          return l.push(e), "[FROALA.EDITOR.SCRIPT ".concat(l.length - 1, "]")
        })).replace(/<noscript\b[^<]*(?:(?!<\/noscript>)<[^<]*)*<\/noscript>/gi, function (e) {
          return l.push(e), "[FROALA.EDITOR.NOSCRIPT ".concat(l.length - 1, "]")
        })).replace(/<meta((?:[\w\W]*?)) http-equiv="/g, '<meta$1 data-fr-http-equiv="')).replace(/<img((?:[\w\W]*?)) src="/g, '<img$1 data-fr-src="')
      }(e), a = null;
      return f.opts.fullPage && (r = f.html.extractNode(e, "body") || (0 <= e.indexOf("<body") ? "" : e), n && (a = f.html.extractNode(e, "head") || "")), r = v(r, t), a && (a = v(a, t)), function i(e) {
        return e = (e = (e = e.replace(/\[FROALA\.EDITOR\.SCRIPT ([\d]*)\]/gi, function (e, t) {
          return 0 <= f.opts.htmlRemoveTags.indexOf("script") ? "" : l[parseInt(t, 10)]
        })).replace(/\[FROALA\.EDITOR\.NOSCRIPT ([\d]*)\]/gi, function (e, t) {
          if (0 <= f.opts.htmlRemoveTags.indexOf("noscript")) return "";
          var n = l[parseInt(t, 10)].replace(/&lt;/g, "<").replace(/&gt;/g, ">"), r = g(n);
          if (r && r.length) {
            var a = v(r.html(), E);
            r.html(a), n = r.get(0).outerHTML
          }
          return n
        })).replace(/<img((?:[\w\W]*?)) data-fr-src="/g, '<img$1 src="')
      }(function s(e, t, n) {
        if (f.opts.fullPage) {
          var r = f.html.extractDoctype(n), a = c(f.html.extractNodeAttrs(n, "html"));
          t = null === t ? f.html.extractNode(n, "head") || "<title></title>" : t;
          var o = c(f.html.extractNodeAttrs(n, "head")), i = c(f.html.extractNodeAttrs(n, "body"));
          return "".concat(r, "<html").concat(a, "><head").concat(o, ">").concat(t, "</head><body").concat(i, ">").concat(e, "</body></html>")
        }
        return e
      }(r, a, e))
    }

    function C(e) {
      var t = f.doc.createElement("DIV");
      return t.innerText = e, t.textContent
    }

    function E(e) {
      for (var t = f.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType !== Node.TEXT_NODE && E(t[n]);
      !function c(i) {
        if ("SPAN" === i.tagName && 0 <= (i.getAttribute("class") || "").indexOf("fr-marker")) return !1;
        if ("PRE" === i.tagName && function l(e) {
          var t = e.innerHTML;
          0 <= t.indexOf("\n") && (e.innerHTML = t.replace(/\n/g, "<br>"))
        }(i), i.nodeType === Node.ELEMENT_NODE && (i.getAttribute("data-fr-src") && 0 !== i.getAttribute("data-fr-src").indexOf("blob:") && i.setAttribute("data-fr-src", f.helpers.sanitizeURL(C(i.getAttribute("data-fr-src")))), i.getAttribute("href") && i.setAttribute("href", f.helpers.sanitizeURL(C(i.getAttribute("href")))), i.getAttribute("src") && i.setAttribute("src", f.helpers.sanitizeURL(C(i.getAttribute("src")))), i.getAttribute("srcdoc") && i.setAttribute("srcdoc", f.clean.html(i.getAttribute("srcdoc"))), 0 <= ["TABLE", "TBODY", "TFOOT", "TR"].indexOf(i.tagName) && (i.innerHTML = i.innerHTML.trim())), !f.opts.pasteAllowLocalImages && i.nodeType === Node.ELEMENT_NODE && "IMG" === i.tagName && i.getAttribute("data-fr-src") && 0 === i.getAttribute("data-fr-src").indexOf("file://")) return i.parentNode.removeChild(i), !1;
        if (i.nodeType === Node.ELEMENT_NODE && xt.HTML5Map[i.tagName] && "" === f.node.attributes(i)) {
          var e = xt.HTML5Map[i.tagName], t = "<".concat(e, ">").concat(i.innerHTML, "</").concat(e, ">");
          i.insertAdjacentHTML("beforebegin", t), (i = i.previousSibling).parentNode.removeChild(i.nextSibling)
        }
        if (f.opts.htmlAllowComments || i.nodeType !== Node.COMMENT_NODE) if (i.tagName && i.tagName.match(p)) "STYLE" == i.tagName && f.helpers.isMac() && function () {
          var e, n = i.innerHTML.trim(), r = [], t = /{([^}]+)}/g;
          for (n = n.replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*|<!--[\s\S]*?-->$/, ""); e = t.exec(n);) r.push(e[1]);
          for (var a = function a(t) {
            var e = n.substring(0, n.indexOf("{")).trim();
            0 == !/^[a-z_-][a-z\d_-]*$/i.test(e) && i.parentNode.querySelectorAll(e).forEach(function (e) {
              e.removeAttribute("class"), e.setAttribute("style", r[t])
            }), n = n.substring(n.indexOf("}") + 1)
          }, o = 0; -1 != n.indexOf("{"); o++) a(o)
        }(), i.parentNode.removeChild(i); else if (i.tagName && !i.tagName.match(d)) "svg" === i.tagName ? i.parentNode.removeChild(i) : f.browser.safari && "path" === i.tagName && i.parentNode && "svg" === i.parentNode.tagName || (i.outerHTML = i.innerHTML); else {
          var n = i.attributes;
          if (n) for (var r = n.length - 1; 0 <= r; r--) {
            var a = n[r], o = a.nodeName.match(u), s = null;
            "style" === a.nodeName && f.opts.htmlAllowedStyleProps.length && (s = a.value.match(h)), o && s ? a.value = m(s.join(";")) : o && ("style" !== a.nodeName || s) || i.removeAttribute(a.nodeName)
          }
        } else 0 !== i.data.indexOf("[FROALA.EDITOR") && i.parentNode.removeChild(i)
      }(e)
    }

    return {
      _init: function e() {
        f.opts.fullPage && g.merge(f.opts.htmlAllowedTags, ["head", "title", "style", "link", "base", "body", "html", "meta"])
      }, html: function y(e, t, n, r) {
        void 0 === t && (t = []), void 0 === n && (n = []), void 0 === r && (r = !1);
        var a, o = g.merge([], f.opts.htmlAllowedTags);
        for (a = 0; a < t.length; a++) 0 <= o.indexOf(t[a]) && o.splice(o.indexOf(t[a]), 1);
        var i = g.merge([], f.opts.htmlAllowedAttrs);
        for (a = 0; a < n.length; a++) 0 <= i.indexOf(n[a]) && i.splice(i.indexOf(n[a]), 1);
        return i.push("data-fr-.*"), i.push("fr-.*"), d = new RegExp("^".concat(o.join("$|^"), "$"), "gi"), u = new RegExp("^".concat(i.join("$|^"), "$"), "gi"), p = new RegExp("^".concat(f.opts.htmlRemoveTags.join("$|^"), "$"), "gi"), h = f.opts.htmlAllowedStyleProps.length ? new RegExp("((^|;|\\s)".concat(f.opts.htmlAllowedStyleProps.join(":.+?(?=;|$))|((^|;|\\s)"), ":.+?(?=(;)|$))"), "gi") : null, e = b(e, E, !0), "undefined" != typeof f.opts.DOMPurify && (e = f.opts.DOMPurify.sanitize(e)), e
      }, toHTML5: function r() {
        var e = f.el.querySelectorAll(Object.keys(xt.HTML5Map).join(","));
        if (e.length) {
          var t = !1;
          f.el.querySelector(".fr-marker") || (f.selection.save(), t = !0);
          for (var n = 0; n < e.length; n++) "" === f.node.attributes(e[n]) && g(e[n]).replaceWith("<".concat(xt.HTML5Map[e[n].tagName], ">").concat(e[n].innerHTML, "</").concat(xt.HTML5Map[e[n].tagName], ">"));
          t && f.selection.restore()
        }
      }, tables: function t() {
        !function s() {
          for (var e = f.el.querySelectorAll("tr"), t = 0; t < e.length; t++) {
            for (var n = e[t].children, r = !0, a = 0; a < n.length; a++) if ("TH" !== n[a].tagName) {
              r = !1;
              break
            }
            if (!1 !== r && 0 !== n.length) {
              for (var o = e[t]; o && "TABLE" !== o.tagName && "THEAD" !== o.tagName;) o = o.parentNode;
              var i = o;
              "THEAD" !== i.tagName && (i = f.doc.createElement("THEAD"), o.insertBefore(i, o.firstChild)), i.appendChild(e[t])
            }
          }
        }()
      }, lists: function L() {
        !function s() {
          var e, t = [];
          do {
            if (t.length) {
              var n = t[0], r = f.doc.createElement("ul");
              n.parentNode.insertBefore(r, n);
              do {
                var a = n;
                n = n.nextSibling, r.appendChild(a)
              } while (n && "LI" === n.tagName)
            }
            t = [];
            for (var o = f.el.querySelectorAll("li"), i = 0; i < o.length; i++) e = o[i], f.node.isList(e.parentNode) || t.push(o[i])
          } while (0 < t.length)
        }(), function o() {
          for (var e = f.el.querySelectorAll("ol + ol, ul + ul"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (f.node.isList(n.previousSibling) && f.node.openTagString(n) === f.node.openTagString(n.previousSibling)) {
              for (var r = f.node.contents(n), a = 0; a < r.length; a++) n.previousSibling.appendChild(r[a]);
              n.parentNode.removeChild(n)
            }
          }
        }(), function i() {
          for (var e = f.el.querySelectorAll("ul, ol"), t = 0; t < e.length; t++) for (var n = f.node.contents(e[t]), r = null, a = n.length - 1; 0 <= a; a--) !n[a].tagName && f.opts.htmlUntouched || "LI" === n[a].tagName || "UL" == n[a].tagName || "OL" == n[a].tagName ? r = null : (r || (r = g(f.doc.createElement("LI"))).insertBefore(n[a]), r.prepend(n[a]))
        }(), function l() {
          var e, t, n;
          do {
            t = !1;
            var r = f.el.querySelectorAll("li:empty");
            for (e = 0; e < r.length; e++) r[e].parentNode.removeChild(r[e]);
            var a = f.el.querySelectorAll("ul, ol");
            for (e = 0; e < a.length; e++) (n = a[e]).querySelector("LI") || (t = !0, n.parentNode.removeChild(n))
          } while (!0 === t)
        }(), function a() {
          for (var e = f.el.querySelectorAll("ul > ul, ol > ol, ul > ol, ol > ul"), t = 0; t < e.length; t++) {
            var n = e[t], r = n.previousSibling;
            r && ("LI" === r.tagName ? r.appendChild(n) : g(n).wrap("<li></li>"))
          }
        }(), function c() {
          for (var e = f.el.querySelectorAll("li > ul, li > ol"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (n.nextSibling) for (var r = n.nextSibling; 0 < r.childNodes.length;) n.append(r.childNodes[0])
          }
        }(), function d() {
          for (var e = f.el.querySelectorAll("li > ul, li > ol"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (f.node.isFirstSibling(n) && "none" != n.parentNode.style.listStyleType) g(n).before("<br/>"); else if (n.previousSibling && "BR" === n.previousSibling.tagName) {
              for (var r = n.previousSibling.previousSibling; r && f.node.hasClass(r, "fr-marker");) r = r.previousSibling;
              r && "BR" !== r.tagName && g(n.previousSibling).remove()
            }
          }
        }(), function n() {
          for (var e = f.el.querySelectorAll("li:empty"), t = 0; t < e.length; t++) g(e[t]).remove()
        }()
      }, invisibleSpaces: function n(e) {
        return e.replace(/\u200b/g, "").length === e.length ? e : f.clean.exec(e, a)
      }, exec: b
    }
  }, xt.XS = 0, xt.SM = 1, xt.MD = 2, xt.LG = 3;
  xt.LinkRegExCommon = "[".concat("a-z\\u0080-\\u009f\\u00a1-\\uffff0-9-_\\.", "]{1,}"), xt.LinkRegExEnd = "((:[0-9]{1,5})|)(((\\/|\\?|#)[a-z\\u00a1-\\uffff0-9@?\\|!^=%&amp;\\/~+#-\\'*-_{}]*)|())", xt.LinkRegExTLD = "((".concat(xt.LinkRegExCommon, ")(\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))"), xt.LinkRegExHTTP = "((ftp|http|https):\\/\\/".concat(xt.LinkRegExCommon, ")"), xt.LinkRegExAuth = "((ftp|http|https):\\/\\/[\\u0021-\\uffff]{1,}@".concat(xt.LinkRegExCommon, ")"), xt.LinkRegExWWW = "(www\\.".concat(xt.LinkRegExCommon, "\\.[a-z0-9-]{2,24})"), xt.LinkRegEx = "(".concat(xt.LinkRegExTLD, "|").concat(xt.LinkRegExHTTP, "|").concat(xt.LinkRegExWWW, "|").concat(xt.LinkRegExAuth, ")").concat(xt.LinkRegExEnd), xt.LinkProtocols = ["mailto", "tel", "sms", "notes", "data"], xt.MAIL_REGEX = /.+@.+\..+/i, xt.MODULES.helpers = function (o) {
    var i, s = o.$;

    function e() {
      var e = {}, t = function o() {
        var e, t = -1;
        return "Microsoft Internet Explorer" === navigator.appName ? (e = navigator.userAgent, null !== new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})").exec(e) && (t = parseFloat(RegExp.$1))) : "Netscape" === navigator.appName && (e = navigator.userAgent, null !== new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})").exec(e) && (t = parseFloat(RegExp.$1))), t
      }();
      if (0 < t) e.msie = !0; else {
        var n = navigator.userAgent.toLowerCase(),
          r = /(edge)[ /]([\w.]+)/.exec(n) || /(chrome)[ /]([\w.]+)/.exec(n) || /(webkit)[ /]([\w.]+)/.exec(n) || /(opera)(?:.*version|)[ /]([\w.]+)/.exec(n) || /(msie) ([\w.]+)/.exec(n) || n.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(n) || [],
          a = r[1] || "";
        r[2];
        r[1] && (e[a] = !0), e.chrome ? e.webkit = !0 : e.webkit && (e.safari = !0)
      }
      return e.msie && (e.version = t), e
    }

    function t() {
      return /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !a()
    }

    function n() {
      return /(Android)/g.test(navigator.userAgent) && !a()
    }

    function r() {
      return /(Blackberry)/g.test(navigator.userAgent)
    }

    function a() {
      return /(Windows Phone)/gi.test(navigator.userAgent)
    }

    var l = null;
    return {
      _init: function c() {
        o.browser = e()
      }, isIOS: t, isMac: function d() {
        return null === l && (l = 0 <= navigator.platform.toUpperCase().indexOf("MAC")), l
      }, isAndroid: n, isBlackberry: r, isWindowsPhone: a, isMobile: function f() {
        return n() || t() || r()
      }, isEmail: function p(e) {
        return !/^(https?:|ftps?:|)\/\//i.test(e) && xt.MAIL_REGEX.test(e)
      }, requestAnimationFrame: function u() {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (e) {
          window.setTimeout(e, 1e3 / 60)
        }
      }, getPX: function h(e) {
        return parseInt(e, 10) || 0
      }, screenSize: function g(e) {
        try {
          var t = 0;
          if ((t = e ? o.$box.width() : o.$sc.width()) < 768) return xt.XS;
          if (768 <= t && t < 992) return xt.SM;
          if (992 <= t && t < 1200) return xt.MD;
          if (1200 <= t) return xt.LG
        } catch (n) {
          return xt.LG
        }
      }, isTouch: function m() {
        return "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch
      }, sanitizeURL: function v(e) {
        return /^(https?:|ftps?:|)\/\//i.test(e) ? e : /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e) ? e : new RegExp("^(".concat(xt.LinkProtocols.join("|"), "):"), "i").test(e) ? e : e = encodeURIComponent(e).replace(/%23/g, "#").replace(/%2F/g, "/").replace(/%25/g, "%").replace(/mailto%3A/gi, "mailto:").replace(/file%3A/gi, "file:").replace(/sms%3A/gi, "sms:").replace(/tel%3A/gi, "tel:").replace(/notes%3A/gi, "notes:").replace(/data%3Aimage/gi, "data:image").replace(/blob%3A/gi, "blob:").replace(/%3A(\d)/gi, ":$1").replace(/webkit-fake-url%3A/gi, "webkit-fake-url:").replace(/%3F/g, "?").replace(/%3D/g, "=").replace(/%26/g, "&").replace(/&amp;/g, "&").replace(/%2C/g, ",").replace(/%3B/g, ";").replace(/%2B/g, "+").replace(/%40/g, "@").replace(/%5B/g, "[").replace(/%5D/g, "]").replace(/%7B/g, "{").replace(/%7D/g, "}")
      }, isArray: function b(e) {
        return e && !Object.prototype.propertyIsEnumerable.call(e, "length") && "object" === kt(e) && "number" == typeof e.length
      }, RGBToHex: function C(e) {
        function t(e) {
          return "0".concat(parseInt(e, 10).toString(16)).slice(-2)
        }

        try {
          return e && "transparent" !== e ? /^#[0-9A-F]{6}$/i.test(e) ? e : (e = e.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/), "#".concat(t(e[1])).concat(t(e[2])).concat(t(e[3])).toUpperCase()) : ""
        } catch (n) {
          return null
        }
      }, HEXtoRGB: function E(e) {
        e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, n, r) {
          return t + t + n + n + r + r
        });
        var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
        return t ? "rgb(".concat(parseInt(t[1], 16), ", ").concat(parseInt(t[2], 16), ", ").concat(parseInt(t[3], 16), ")") : ""
      }, isURL: function y(e) {
        return !!/^(https?:|ftps?:|)\/\//i.test(e) && (e = String(e).replace(/</g, "%3C").replace(/>/g, "%3E").replace(/"/g, "%22").replace(/ /g, "%20"), new RegExp("^".concat(xt.LinkRegExHTTP).concat(xt.LinkRegExEnd, "$"), "gi").test(e))
      }, getAlignment: function L(e) {
        e.css || (e = s(e));
        var t = (e.css("text-align") || "").replace(/-(.*)-/g, "");
        if (["left", "right", "justify", "center"].indexOf(t) < 0) {
          if (!i) {
            var n = s('<div dir="'.concat("rtl" === o.opts.direction ? "rtl" : "auto", '" style="text-align: ').concat(o.$el.css("text-align"), '; position: fixed; left: -3000px;"><span id="s1">.</span><span id="s2">.</span></div>'));
            s("body").first().append(n);
            var r = n.find("#s1").get(0).getBoundingClientRect().left,
              a = n.find("#s2").get(0).getBoundingClientRect().left;
            n.remove(), i = r < a ? "left" : "right"
          }
          t = i
        }
        return t
      }, scrollTop: function _() {
        return o.o_win.pageYOffset ? o.o_win.pageYOffset : o.o_doc.documentElement && o.o_doc.documentElement.scrollTop ? o.o_doc.documentElement.scrollTop : o.o_doc.body.scrollTop ? o.o_doc.body.scrollTop : 0
      }, scrollLeft: function w() {
        return o.o_win.pageXOffset ? o.o_win.pageXOffset : o.o_doc.documentElement && o.o_doc.documentElement.scrollLeft ? o.o_doc.documentElement.scrollLeft : o.o_doc.body.scrollLeft ? o.o_doc.body.scrollLeft : 0
      }, isInViewPort: function A(e) {
        var t = e.getBoundingClientRect();
        return 0 <= (t = {
          top: Math.round(t.top),
          bottom: Math.round(t.bottom)
        }).top && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) || t.top <= 0 && t.bottom >= (window.innerHeight || document.documentElement.clientHeight)
      }
    }
  }, xt.MODULES.events = function (l) {
    var e, o = l.$, i = {};

    function s(e, t, n) {
      m(e, t, n)
    }

    function c(e) {
      if (void 0 === e && (e = !0), !l.$wp) return !1;
      if (l.helpers.isIOS() && l.$win.get(0).focus(), l.core.hasFocus()) return !1;
      if (l.selection.isCollapsed() && !l.selection.get().anchorNode) {
        var t = l.$el.find(l.html.blockTagsQuery()).get(0);
        t && (o(t).prepend(xt.MARKERS), l.selection.restore())
      }
      if (!l.core.hasFocus() && e) {
        var n = l.$win.scrollTop();
        if (l.browser.msie && l.$box && l.$box.css("position", "fixed"), l.browser.msie && l.$wp && l.$wp.css("overflow", "visible"), l.browser.msie && l.$sc && l.$sc.css("position", "fixed"), l.browser.msie || (p(), l.el.focus(), l.events.trigger("focus"), f()), l.browser.msie && l.$sc && l.$sc.css("position", ""), l.browser.msie && l.$box && l.$box.css("position", ""), l.browser.msie && l.$wp && l.$wp.css("overflow", "auto"), n !== l.$win.scrollTop() && l.$win.scrollTop(n), !l.selection.info(l.el).atStart) return !1
      }
      if (!l.core.hasFocus() || 0 < l.$el.find(".fr-marker").length) return !1;
      if (l.selection.info(l.el).atStart && l.selection.isCollapsed() && null !== l.html.defaultTag()) {
        var r = l.markers.insert();
        if (r && !l.node.blockParent(r)) {
          o(r).remove();
          var a = l.$el.find(l.html.blockTagsQuery()).get(0);
          a && (o(a).prepend(xt.MARKERS), l.selection.restore())
        } else r && o(r).remove()
      }
    }

    var d = !1;

    function f() {
      e = !0
    }

    function p() {
      e = !1
    }

    function u() {
      return e
    }

    function h(e, t, n) {
      var r, a = e.split(" ");
      if (1 < a.length) {
        for (var o = 0; o < a.length; o++) h(a[o], t, n);
        return !0
      }
      void 0 === n && (n = !1), r = 0 !== e.indexOf("shared.") ? (i[e] = i[e] || [], i[e]) : (l.shared._events[e] = l.shared._events[e] || [], l.shared._events[e]), n ? r.unshift(t) : r.push(t)
    }

    var g = [];

    function m(e, t, n, r, a) {
      "function" == typeof n && (a = r, r = n, n = !1);
      var o = a ? l.shared.$_events : g, i = a ? l.sid : l.id,
        s = "".concat(t.trim().split(" ").join(".ed".concat(i, " ")), ".ed").concat(i);
      n ? e.on(s, n, r) : e.on(s, r), o.push([e, s])
    }

    function t(e) {
      for (var t = 0; t < e.length; t++) e[t][0].off(e[t][1])
    }

    function v(e, t, n) {
      if (!l.edit.isDisabled() || n) {
        var r, a;
        if (0 !== e.indexOf("shared.")) r = i[e]; else {
          if (0 < l.shared.count) return !1;
          r = l.shared._events[e]
        }
        if (r) for (var o = 0; o < r.length; o++) if (!1 === (a = r[o].apply(l, t))) return !1;
        return (!l.opts.events || !l.opts.events[e] || !1 !== (a = l.opts.events[e].apply(l, t))) && a
      }
    }

    function b() {
      for (var e in i) Object.prototype.hasOwnProperty.call(i, e) && delete i[e]
    }

    function C() {
      for (var e in l.shared._events) Object.prototype.hasOwnProperty.call(l.shared._events, e) && delete l.shared._events[e]
    }

    return {
      _init: function E() {
        l.shared.$_events = l.shared.$_events || [], l.shared._events = {}, function e() {
          l.helpers.isMobile() ? (l._mousedown = "touchstart", l._mouseup = "touchend", l._move = "touchmove", l._mousemove = "touchmove") : (l._mousedown = "mousedown", l._mouseup = "mouseup", l._move = "", l._mousemove = "mousemove")
        }(), function t() {
          s(l.$el, "click mouseup mousemove mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart", function (e) {
            v(e.type, [e])
          }), h("mousedown", function () {
            for (var e = 0; e < xt.INSTANCES.length; e++) xt.INSTANCES[e] !== l && xt.INSTANCES[e].popups && xt.INSTANCES[e].popups.areVisible() && xt.INSTANCES[e].$el.find(".fr-marker").remove()
          })
        }(), function n() {
          s(l.$win, l._mousedown, function (e) {
            v("window.mousedown", [e]), f()
          }), s(l.$win, l._mouseup, function (e) {
            v("window.mouseup", [e])
          }), s(l.$win, "beforeinput cut copy keydown keyup touchmove touchend", function (e) {
            v("window.".concat(e.type), [e])
          })
        }(), function r() {
          s(l.$doc, "dragend drop", function (e) {
            v("document.".concat(e.type), [e])
          })
        }(), function a() {
          s(l.$el, "beforeinput keydown keypress keyup input", function (e) {
            v(e.type, [e])
          })
        }(), function o() {
          s(l.$el, "focus", function (e) {
            u() && (c(!1), !1 === d && (v(e.type, [e]), l.helpers.isMobile() && p()))
          }), s(l.$el, "blur", function (e) {
            u() && !0 === d && (v(e.type, [e]), l.helpers.isMobile() && l.opts.toolbarContainer && (l.shared.selected_editor = l.id), f())
          }), m(l.$el, "mousedown", '[contenteditable="true"]', function () {
            p(), l.$el.blur()
          }), h("focus", function () {
            d = !0
          }), h("blur", function () {
            d = !1
          })
        }(), f(), function i() {
          s(l.$el, "cut copy paste beforepaste", function (e) {
            v(e.type, [e])
          })
        }(), h("destroy", b), h("shared.destroy", C)
      }, on: h, trigger: v, bindClick: function r(e, t, n) {
        m(e, l._mousedown, t, function (e) {
          l.edit.isDisabled() || function n(e) {
            var t = o(e.currentTarget);
            return l.edit.isDisabled() || l.node.hasClass(t.get(0), "fr-disabled") ? (e.preventDefault(), !1) : "mousedown" === e.type && 1 !== e.which || (l.helpers.isMobile() || e.preventDefault(), (l.helpers.isAndroid() || l.helpers.isWindowsPhone()) && 0 === t.parents(".fr-dropdown-menu").length && (e.preventDefault(), e.stopPropagation()), t.addClass("fr-selected"), void l.events.trigger("commands.mousedown", [t]))
          }(e)
        }, !0), m(e, "".concat(l._mouseup, " ").concat(l._move), t, function (e) {
          l.edit.isDisabled() || function a(e, t) {
            var n = o(e.currentTarget);
            if (l.edit.isDisabled() || l.node.hasClass(n.get(0), "fr-disabled")) return e.preventDefault(), !1;
            if ("mouseup" === e.type && 1 !== e.which) return !0;
            if (l.button.getButtons(".fr-selected", !0).get(0) == n.get(0) && !l.node.hasClass(n.get(0), "fr-selected")) return !0;
            if ("touchmove" !== e.type) {
              if (e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault(), !l.node.hasClass(n.get(0), "fr-selected")) return l.button.getButtons(".fr-selected", !0).removeClass("fr-selected"), !1;
              if (l.button.getButtons(".fr-selected", !0).removeClass("fr-selected"), n.data("dragging") || n.attr("disabled")) return n.removeData("dragging"), !1;
              var r = n.data("timeout");
              r && (clearTimeout(r), n.removeData("timeout")), t.apply(l, [e])
            } else n.data("timeout") || n.data("timeout", setTimeout(function () {
              n.data("dragging", !0)
            }, 100))
          }(e, n)
        }, !0), m(e, "mousedown click mouseup", t, function (e) {
          l.edit.isDisabled() || e.stopPropagation()
        }, !0), h("window.mouseup", function () {
          l.edit.isDisabled() || (e.find(t).removeClass("fr-selected"), f())
        }), m(e, "mouseover", t, function () {
          o(this).hasClass("fr-options") && o(this).prev(".fr-btn").addClass("fr-btn-hover"), o(this).next(".fr-btn").hasClass("fr-options") && o(this).next(".fr-btn").addClass("fr-btn-hover")
        }), m(e, "mouseout", t, function () {
          o(this).hasClass("fr-options") && o(this).prev(".fr-btn").removeClass("fr-btn-hover"), o(this).next(".fr-btn").hasClass("fr-options") && o(this).next(".fr-btn").removeClass("fr-btn-hover")
        })
      }, disableBlur: p, enableBlur: f, blurActive: u, focus: c, chainTrigger: function y(e, t, n) {
        if (!l.edit.isDisabled() || n) {
          var r, a;
          if (0 !== e.indexOf("shared.")) r = i[e]; else {
            if (0 < l.shared.count) return !1;
            r = l.shared._events[e]
          }
          if (r) for (var o = 0; o < r.length; o++) void 0 !== (a = r[o].apply(l, [t])) && (t = a);
          return l.opts.events && l.opts.events[e] && void 0 !== (a = l.opts.events[e].apply(l, [t])) && (t = a), t
        }
      }, $on: m, $off: function n() {
        t(g), g = [], 0 === l.shared.count && (t(l.shared.$_events), l.shared.$_events = [])
      }
    }
  }, Object.assign(xt.DEFAULTS, {indentMargin: 20}), xt.COMMANDS = {
    bold: {
      title: "Bold", toggle: !0, refresh: function (e) {
        var t = this.format.is("strong");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    italic: {
      title: "Italic", toggle: !0, refresh: function (e) {
        var t = this.format.is("em");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    underline: {
      title: "Underline", toggle: !0, refresh: function (e) {
        var t = this.format.is("u");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    strikeThrough: {
      title: "Strikethrough", toggle: !0, refresh: function (e) {
        var t = this.format.is("s");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    subscript: {
      title: "Subscript", toggle: !0, refresh: function (e) {
        var t = this.format.is("sub");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    superscript: {
      title: "Superscript", toggle: !0, refresh: function (e) {
        var t = this.format.is("sup");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    outdent: {title: "Decrease Indent"},
    indent: {title: "Increase Indent"},
    undo: {title: "Undo", undo: !1, forcedRefresh: !0, disabled: !0},
    redo: {title: "Redo", undo: !1, forcedRefresh: !0, disabled: !0},
    insertHR: {title: "Insert Horizontal Line"},
    clearFormatting: {title: "Clear Formatting"},
    selectAll: {title: "Select All", undo: !1},
    moreText: {title: "More Text", undo: !1},
    moreParagraph: {title: "More Paragraph", undo: !1},
    moreRich: {title: "More Rich", undo: !1},
    moreMisc: {title: "More Misc", undo: !1}
  }, xt.RegisterCommand = function (e, t) {
    xt.COMMANDS[e] = t
  }, xt.MODULES.commands = function (i) {
    var s = i.$;

    function l(e) {
      return i.html.defaultTag() && (e = "<".concat(i.html.defaultTag(), ">").concat(e, "</").concat(i.html.defaultTag(), ">")), e
    }

    var o = {
      bold: function () {
        e("bold", "strong")
      }, subscript: function () {
        i.format.is("sup") && i.format.remove("sup"), e("subscript", "sub")
      }, superscript: function () {
        i.format.is("sub") && i.format.remove("sub"), e("superscript", "sup")
      }, italic: function () {
        e("italic", "em")
      }, strikeThrough: function () {
        e("strikeThrough", "s")
      }, underline: function () {
        e("underline", "u")
      }, undo: function () {
        i.undo.run()
      }, redo: function () {
        i.undo.redo()
      }, indent: function () {
        r(1)
      }, outdent: function () {
        r(-1)
      }, show: function () {
        i.opts.toolbarInline && i.toolbar.showInline(null, !0)
      }, insertHR: function () {
        i.selection.remove();
        var e = "";
        i.core.isEmpty() && (e = l(e = "<br>"));
        var t = '<hr id="fr-just" class="fr-just">'.concat(e);
        i.opts.trackChangesEnabled && (t = i.track_changes.wrapInTracking(s(t), "hrWrapper").get(0).outerHTML);
        i.html.insert(t);
        var n, r = i.$el.find("hr#fr-just").length ? i.$el.find("hr#fr-just") : i.$el.find(".fr-just");
        r.removeAttr("id"), r.removeAttr("class");
        var a = i.opts.trackChangesEnabled && "SPAN" === r[0].parentNode.tagName && "P" === r[0].parentNode.parentNode.tagName;
        if (0 === r.next().length) {
          var o = i.html.defaultTag();
          o && !a ? r.after(s(i.doc.createElement(o)).append("<br>").get(0)) : a ? r[0].parentNode.after(s(i.doc.createElement(o)).append("<br>").get(0)) : r.after("<br>")
        }
        r.prev().is("hr") ? n = i.selection.setAfter(r.get(0), !1) : r.next().is("hr") ? n = i.selection.setBefore(r.get(0), !1) : a || i.selection.setAfter(r.get(0), !1) ? i.selection.setAfter(r[0].parentNode, !1) : i.selection.setBefore(r.get(0), !1), n || void 0 === n || (e = l(e = "".concat(xt.MARKERS, "<br>")), r.after(e)), i.selection.restore()
      }, clearFormatting: function () {
        i.format.remove()
      }, selectAll: function () {
        i.doc.execCommand("selectAll", !1, !1)
      }, moreText: function (e) {
        t(e)
      }, moreParagraph: function (e) {
        t(e)
      }, moreRich: function (e) {
        t(e)
      }, moreMisc: function (e) {
        t(e)
      }, moreTrackChanges: function () {
        t("trackChanges")
      }
    };

    function t(e) {
      var t = i.$tb.find("[data-cmd=".concat(e, "]")), n = i.$tb.find("[data-cmd=html]");
      i.opts.trackChangesEnabled ? n && n.addClass("fr-disabled") : n && n.removeClass("fr-disabled"), function r(n) {
        i.helpers.isMobile() && i.opts.toolbarInline && i.events.disableBlur();
        var e = i.$tb.find('.fr-more-toolbar[data-name="'.concat(n.attr("data-group-name"), '"]'));
        "trackChanges" === n.data("cmd") && (e = i.$tb.find('.fr-more-toolbar[data-name="trackChanges-'.concat(i.id, '"]')));
        if (i.$tb.find(".fr-open").not(n).not('[data-cmd="trackChanges"]').removeClass("fr-open"), n.toggleClass("fr-open"), i.$tb.find(".fr-more-toolbar").removeClass("fr-overflow-visible"), i.$tb.find(".fr-expanded").not(e).length) {
          var t = i.$tb.find(".fr-expanded").not(e);
          t.each(function (e, t) {
            0 != s(t).data("name").indexOf("trackChanges-") && 0 != s(t).data("name").indexOf("moreRich-") ? s(t).toggleClass("fr-expanded") : n.parents('[data-name^="moreRich-"]').length || 0 == s(t).data("name").indexOf("trackChanges-") || s(t).find('[id^="trackChanges-"]').length && i.opts.trackChangesEnabled || s(t).toggleClass("fr-expanded")
          }), e.toggleClass("fr-expanded")
        } else e.toggleClass("fr-expanded"), i.$box.toggleClass("fr-toolbar-open"), i.$tb.toggleClass("fr-toolbar-open")
      }(t), i.toolbar.setMoreToolbarsHeight()
    }

    function n(e, t) {
      if (!(i.markdown && i.markdown.isEnabled() && ("bold" === e || "italic" === e || "underline" === e) || i.opts.trackChangesEnabled && "markdown" === e) && !1 !== i.events.trigger("commands.before", s.merge([e], t || []))) {
        var n = xt.COMMANDS[e] && xt.COMMANDS[e].callback || o[e], r = !0, a = !1;
        xt.COMMANDS[e] && ("undefined" != typeof xt.COMMANDS[e].focus && (r = xt.COMMANDS[e].focus), "undefined" != typeof xt.COMMANDS[e].accessibilityFocus && (a = xt.COMMANDS[e].accessibilityFocus)), (!i.core.hasFocus() && r && !i.popups.areVisible() || !i.core.hasFocus() && a && i.accessibility.hasFocus()) && i.events.focus(!0), xt.COMMANDS[e] && !1 !== xt.COMMANDS[e].undo && (i.$el.find(".fr-marker").length && (i.events.disableBlur(), i.selection.restore()), i.undo.saveStep()), n && n.apply(i, s.merge([e], t || [])), i.events.trigger("commands.after", s.merge([e], t || [])), xt.COMMANDS[e] && !1 !== xt.COMMANDS[e].undo && i.undo.saveStep()
      }
    }

    function e(e, t) {
      i.format.toggle(t)
    }

    function r(e) {
      i.selection.save(), i.html.wrap(!0, !0, !0, !0), i.selection.restore();
      for (var t = i.selection.blocks(), n = 0; n < t.length; n++) if ("LI" !== t[n].tagName || "LI" !== t[n].parentNode.tagName) {
        var r = s(t[n]);
        "LI" != t[n].tagName && "LI" == t[n].parentNode.tagName && (r = s(t[n].parentNode));
        var a = "rtl" === i.opts.direction || "rtl" === r.css("direction") ? "margin-right" : "margin-left",
          o = i.helpers.getPX(r.css(a));
        if (r.width() < 2 * i.opts.indentMargin && 0 < e) continue;
        "UL" != t[n].parentNode.tagName && "OL" != t[n].parentNode.tagName && "LI" != t[n].parentNode.tagName && r.css(a, Math.max(o + e * i.opts.indentMargin, 0) || ""), r.removeClass("fr-temp-div")
      }
      i.selection.save(), i.html.unwrap(), i.selection.restore()
    }

    function a(e) {
      return function () {
        n(e)
      }
    }

    var c = {};
    for (var d in o) Object.prototype.hasOwnProperty.call(o, d) && (c[d] = a(d));
    return Object.assign(c, {
      exec: n, _init: function f() {
        i.events.on("keydown", function (e) {
          var t = i.selection.element();
          if (t && "HR" === t.tagName && !i.keys.isArrow(e.which)) return e.preventDefault(), !1
        }), i.events.on("keyup", function (e) {
          var t = i.selection.element();
          if (t && "HR" === t.tagName) if (e.which === xt.KEYCODE.ARROW_LEFT || e.which === xt.KEYCODE.ARROW_UP) {
            if (t.previousSibling) return i.node.isBlock(t.previousSibling) ? i.selection.setAtEnd(t.previousSibling) : s(t).before(xt.MARKERS), i.selection.restore(), !1
          } else if ((e.which === xt.KEYCODE.ARROW_RIGHT || e.which === xt.KEYCODE.ARROW_DOWN) && t.nextSibling) return i.node.isBlock(t.nextSibling) ? i.selection.setAtStart(t.nextSibling) : s(t).after(xt.MARKERS), i.selection.restore(), !1
        }), i.events.on("mousedown", function (e) {
          if (e.target && "HR" === e.target.tagName) return e.preventDefault(), e.stopPropagation(), !1
        }), i.events.on("mouseup", function () {
          var e = i.selection.element();
          e === i.selection.endElement() && e && "HR" === e.tagName && (e.nextSibling && (i.node.isBlock(e.nextSibling) ? i.selection.setAtStart(e.nextSibling) : s(e).after(xt.MARKERS)), i.selection.restore())
        })
      }
    })
  }, xt.MODULES.cursorLists = function (g) {
    var m = g.$;

    function v(e) {
      for (var t = e; "LI" !== t.tagName;) t = t.parentNode;
      return t
    }

    function b(e) {
      for (var t = e; !g.node.isList(t);) t = t.parentNode;
      return t
    }

    return {
      _startEnter: function C(e) {
        var t, n = v(e), r = n.nextSibling, a = n.previousSibling, o = g.html.defaultTag();
        if (g.node.isEmpty(n, !0) && r) {
          for (var i = "", s = "", l = e.parentNode; !g.node.isList(l) && l.parentNode && ("LI" !== l.parentNode.tagName || l.parentNode === n);) i = g.node.openTagString(l) + i, s += g.node.closeTagString(l), l = l.parentNode;
          i = g.node.openTagString(l) + i, s += g.node.closeTagString(l);
          var c = "";
          for (c = l.parentNode && "LI" === l.parentNode.tagName ? "".concat(s, "<li>").concat(xt.MARKERS, "<br>").concat(i) : o ? "".concat(s, "<").concat(o, ">").concat(xt.MARKERS, "<br></").concat(o, ">").concat(i) : "".concat(s + xt.MARKERS, "<br>").concat(i); ["UL", "OL"].indexOf(l.tagName) < 0 || l.parentNode && "LI" === l.parentNode.tagName;) l = l.parentNode;
          m(n).replaceWith('<span id="fr-break"></span>');
          var d = g.node.openTagString(l) + m(l).html() + g.node.closeTagString(l);
          d = d.replace(/<span id="fr-break"><\/span>/g, c), m(l).replaceWith(d), g.$el.find("li:empty").remove()
        } else if (a && r || !g.node.isEmpty(n, !0)) {
          for (var f = "<br>", p = e.parentNode; p && "LI" !== p.tagName;) f = g.node.openTagString(p) + f + g.node.closeTagString(p), p = p.parentNode;
          m(n).before("<li>".concat(f, "</li>")), m(e).remove()
        } else if (a) {
          t = b(n);
          for (var u = "".concat(xt.MARKERS, "<br>"), h = e.parentNode; h && "LI" !== h.tagName;) u = g.node.openTagString(h) + u + g.node.closeTagString(h), h = h.parentNode;
          t.parentNode && "LI" === t.parentNode.tagName ? m(t.parentNode).after("<li>".concat(u, "</li>")) : o ? m(t).after("<".concat(o, ">").concat(u, "</").concat(o, ">")) : m(t).after(u), m(n).remove()
        } else (t = b(n)).parentNode && "LI" === t.parentNode.tagName ? r ? m(t.parentNode).before("".concat(g.node.openTagString(n) + xt.MARKERS, "<br></li>")) : m(t.parentNode).after("".concat(g.node.openTagString(n) + xt.MARKERS, "<br></li>")) : o ? m(t).before("<".concat(o, ">").concat(xt.MARKERS, "<br></").concat(o, ">")) : m(t).before("".concat(xt.MARKERS, "<br>")), m(n).remove()
      }, _middleEnter: function c(e) {
        for (var t = v(e), n = "", r = e, a = "", o = "", i = !1; r !== t;) {
          var s = "A" === (r = r.parentNode).tagName && g.cursor.isAtEnd(e, r) ? "fr-to-remove" : "";
          i || r == t || g.node.isBlock(r) || (i = !0, a += xt.INVISIBLE_SPACE), a = g.node.openTagString(m(r).clone().addClass(s).get(0)) + a, g.opts.trackChangesEnabled ? o += g.node.closeTagString(r) : o = g.node.closeTagString(r) + o
        }
        n = o + n + a + xt.MARKERS + (g.opts.keepFormatOnDelete ? xt.INVISIBLE_SPACE : ""), m(e).replaceWith('<span id="fr-break"></span>');
        var l = g.node.openTagString(t) + m(t).html() + g.node.closeTagString(t);
        l = l.replace(/<span id="fr-break"><\/span>/g, n), m(t).replaceWith(l)
      }, _endEnter: function l(e) {
        for (var t = v(e), n = xt.MARKERS, r = "", a = e, o = !1; a !== t;) if (!(a = a.parentNode).classList.contains("fr-img-space-wrap") && !a.classList.contains("fr-img-space-wrap2")) {
          var i = "A" === a.tagName && g.cursor.isAtEnd(e, a) ? "fr-to-remove" : "";
          o || a === t || g.node.isBlock(a) || (o = !0, r += xt.INVISIBLE_SPACE), r = g.node.openTagString(m(a).clone().addClass(i).get(0)) + r, n += g.node.closeTagString(a)
        }
        var s = r + n;
        m(e).remove(), m(t).after(s)
      }, _backspace: function d(e) {
        var t = v(e), n = t.previousSibling;
        if (n) {
          n = m(n).find(g.html.blockTagsQuery()).get(-1) || n, m(e).replaceWith(xt.MARKERS);
          var r = g.node.contents(n);
          r.length && "BR" === r[r.length - 1].tagName && m(r[r.length - 1]).remove(), m(t).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === t && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
          });
          for (var a, o = g.node.contents(t)[0]; o && !g.node.isList(o);) a = o.nextSibling, m(n).append(o), o = a;
          for (n = t.previousSibling; o;) a = o.nextSibling, m(n).append(o), o = a;
          1 < (r = g.node.contents(n)).length && "BR" === r[r.length - 1].tagName && m(r[r.length - 1]).remove(), m(t).remove()
        } else {
          var i = b(t);
          if (m(e).replaceWith(xt.MARKERS), i.parentNode && "LI" === i.parentNode.tagName) {
            var s = i.previousSibling;
            g.node.isBlock(s) ? (m(t).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
              this.parentNode === t && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
            }), m(s).append(m(t).html())) : m(i).before(m(t).html())
          } else {
            var l = g.html.defaultTag();
            l && 0 === m(t).find(g.html.blockTagsQuery()).length ? m(i).before("<".concat(l, ">").concat(m(t).html(), "</").concat(l, ">")) : m(i).before(m(t).html())
          }
          m(t).remove(), g.html.wrap(), 0 === m(i).find("li").length && m(i).remove()
        }
      }, _del: function f(e) {
        var t, n = v(e), r = n.nextSibling;
        if (r) {
          (t = g.node.contents(r)).length && "BR" === t[0].tagName && m(t[0]).remove(), m(r).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === r && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
          });
          for (var a, o = e, i = g.node.contents(r)[0]; i && !g.node.isList(i);) a = i.nextSibling, m(o).after(i), o = i, i = a;
          for (; i;) a = i.nextSibling, m(n).append(i), i = a;
          m(e).replaceWith(xt.MARKERS), m(r).remove()
        } else {
          for (var s = n; !s.nextSibling && s !== g.el;) s = s.parentNode;
          if (s === g.el) return !1;
          if (s = s.nextSibling, g.node.isBlock(s)) xt.NO_DELETE_TAGS.indexOf(s.tagName) < 0 && (m(e).replaceWith(xt.MARKERS), (t = g.node.contents(n)).length && "BR" === t[t.length - 1].tagName && m(t[t.length - 1]).remove(), m(n).append(m(s).html()), m(s).remove()); else {
            for ((t = g.node.contents(n)).length && "BR" === t[t.length - 1].tagName && m(t[t.length - 1]).remove(), m(e).replaceWith(xt.MARKERS); s && !g.node.isBlock(s) && "BR" !== s.tagName;) m(n).append(m(s)), s = s.nextSibling;
            m(s).remove()
          }
        }
      }
    }
  }, xt.NO_DELETE_TAGS = ["TH", "TD", "TR", "TABLE", "FORM"], xt.SIMPLE_ENTER_TAGS = ["TH", "TD", "LI", "DL", "DT", "FORM"], xt.MODULES.cursor = function (h) {
    var g = h.$;

    function d(e) {
      return !!e && (!!h.node.isBlock(e) || (e.nextSibling && e.nextSibling.nodeType === Node.TEXT_NODE && 0 === e.nextSibling.textContent.replace(/\u200b/g, "").length ? d(e.nextSibling) : !(e.nextSibling && (!e.previousSibling || "BR" !== e.nextSibling.tagName || e.nextSibling.nextSibling)) && d(e.parentNode)))
    }

    function f(e) {
      return !!e && (!!h.node.isBlock(e) || (e.previousSibling && e.previousSibling.nodeType === Node.TEXT_NODE && 0 === e.previousSibling.textContent.replace(/\u200b/g, "").length ? f(e.previousSibling) : !e.previousSibling && (!(e.previousSibling || !h.node.hasClass(e.parentNode, "fr-inner")) || f(e.parentNode))))
    }

    function u(e, t) {
      return !!e && (e !== h.$wp.get(0) && (e.previousSibling && e.previousSibling.nodeType === Node.TEXT_NODE && 0 === e.previousSibling.textContent.replace(/\u200b/g, "").length ? u(e.previousSibling, t) : !e.previousSibling && (e.parentNode === t || u(e.parentNode, t))))
    }

    function m(e, t) {
      return !!e && (e !== h.$wp.get(0) && (e.nextSibling && e.nextSibling.nodeType === Node.TEXT_NODE && 0 === e.nextSibling.textContent.replace(/\u200b/g, "").length ? m(e.nextSibling, t) : !(e.nextSibling && (!e.previousSibling || "BR" !== e.nextSibling.tagName || e.nextSibling.nextSibling)) && (e.parentNode === t || m(e.parentNode, t))))
    }

    function p(e) {
      return 0 < g(e).parentsUntil(h.$el, "LI").length && 0 === g(e).parentsUntil("LI", "TABLE").length
    }

    function v(e, t) {
      var n = new RegExp("".concat(t ? "^" : "", "(([\\uD83C-\\uDBFF\\uDC00-\\uDFFF]+\\u200D)*[\\uD83C-\\uDBFF\\uDC00-\\uDFFF]{2})").concat(t ? "" : "$"), "i"),
        r = e.match(n);
      return r ? r[0].length : 1
    }

    function b(e) {
      for (var t, n = e; !n.previousSibling;) if (n = n.parentNode, h.node.isElement(n)) return !1;
      n = n.previousSibling;
      var r = h.opts.htmlAllowedEmptyTags, a = n.tagName && n.tagName.toLowerCase();
      if ((!h.node.isBlock(n) || n.lastChild && a && 0 <= r.indexOf(a)) && h.node.isEditable(n)) {
        for (t = h.node.contents(n); n.nodeType !== Node.TEXT_NODE && !h.node.isDeletable(n) && t.length && h.node.isEditable(n);) n = t[t.length - 1], t = h.node.contents(n);
        if (n.nodeType === Node.TEXT_NODE) {
          var o = n.textContent, i = o.length;
          if (o.length && "\n" === o[o.length - 1]) return n.textContent = o.substring(0, i - 2), 0 === n.textContent.length && n.parentNode.removeChild(n), b(e);
          if (h.opts.tabSpaces && o.length >= h.opts.tabSpaces) 0 === o.substr(o.length - h.opts.tabSpaces, o.length - 1).replace(/ /g, "").replace(new RegExp(xt.UNICODE_NBSP, "g"), "").length && (i = o.length - h.opts.tabSpaces + 1);
          n.textContent = o.substring(0, i - v(o)), h.opts.trackChangesEnabled && 0 === n.textContent.length && g(n.parentElement).data("tracking") && 0 === g(n.parentElement).find("[data-tracking-deleted=true]").length && (g(e).insertBefore(n.parentElement), g(n.parentElement).remove(), n = g(e)[0].previousSibling), h.opts.htmlUntouched && !e.nextSibling && n.textContent.length && " " === n.textContent[n.textContent.length - 1] && (n.textContent = n.textContent.substring(0, n.textContent.length - 1) + xt.UNICODE_NBSP);
          var s = o.length !== n.textContent.length;
          if (0 === n.textContent.length && n.previousSibling && "BR" === n.previousSibling.tagName && n.previousSibling.remove(), 0 === n.textContent.length) if (s && h.opts.keepFormatOnDelete) g(n).after(xt.INVISIBLE_SPACE + xt.MARKERS); else if (0 !== o.length && h.node.isBlock(n.parentNode)) g(n).after(xt.MARKERS); else if ((2 != n.parentNode.childNodes.length || n.parentNode != e.parentNode) && 1 != n.parentNode.childNodes.length || h.node.isBlock(n.parentNode) || h.node.isElement(n.parentNode) || !h.node.isDeletable(n.parentNode)) {
            for (var l, c = n; !h.node.isElement(n.parentNode) && h.node.isEmpty(n.parentNode) && xt.NO_DELETE_TAGS.indexOf(n.parentNode.tagName) < 0;) if ("A" === (n = n.parentNode).tagName) {
              var d = n.childNodes[0];
              for (g(n).before(d), l = !0; 0 < d.childNodes.length;) d = d.childNodes[0];
              n.parentNode.removeChild(n), n = d;
              break
            }
            l || (n = c), g(n).after(xt.MARKERS), h.node.isElement(n.parentNode) && !e.nextSibling && n.previousSibling && "BR" === n.previousSibling.tagName && g(e).after("<br>");
            var f = n.parentNode;
            n.parentNode.removeChild(n), h.node.isEmpty(f) && g(f).html(xt.INVISIBLE_SPACE + xt.MARKERS)
          } else g(n.parentNode).after(xt.MARKERS), g(n.parentNode).remove(); else g(n).after(xt.MARKERS)
        } else h.node.isDeletable(n) ? (g(n).after(xt.MARKERS), g(n).remove()) : e.nextSibling && "BR" === e.nextSibling.tagName && h.node.isVoid(n) && "BR" !== n.tagName ? (g(e.nextSibling).remove(), g(e).replaceWith(xt.MARKERS)) : !1 !== h.events.trigger("node.remove", [g(n)]) && (g(n).after(xt.MARKERS), g(n).remove())
      } else if (xt.NO_DELETE_TAGS.indexOf(n.tagName) < 0 && (h.node.isEditable(n) || h.node.isDeletable(n))) if (h.node.isDeletable(n)) g(e).replaceWith(xt.MARKERS), g(n).remove(); else if (h.node.isEmpty(n) && !h.node.isList(n)) g(n).remove(), g(e).replaceWith(xt.MARKERS); else {
        for (h.node.isList(n) && (n = g(n).find("li").last().get(0)), (t = h.node.contents(n)) && "BR" === t[t.length - 1].tagName && g(t[t.length - 1]).remove(), t = h.node.contents(n); t && h.node.isBlock(t[t.length - 1]);) n = t[t.length - 1], t = h.node.contents(n);
        g(n).append(xt.MARKERS);
        for (var p = e; !p.previousSibling;) p = p.parentNode;
        for (; p && "BR" !== p.tagName && !h.node.isBlock(p);) {
          var u = p;
          p = p.nextSibling, g(n).append(u)
        }
        p && "BR" === p.tagName && g(p).remove(), g(e).remove()
      } else e.nextSibling && "BR" === e.nextSibling.tagName && g(e.nextSibling).remove();
      return !0
    }

    function o(e) {
      var t = 0 < g(e).parentsUntil(h.$el, "BLOCKQUOTE").length, n = h.node.deepestParent(e, [], !t);
      if (n && "BLOCKQUOTE" === n.tagName) {
        var r = h.node.deepestParent(e, [g(e).parentsUntil(h.$el, "BLOCKQUOTE").get(0)]);
        r && r.nextSibling && (n = r)
      }
      if (null !== n) {
        var a, o = n.nextSibling;
        if (h.node.isBlock(n) && (h.node.isEditable(n) || h.node.isDeletable(n)) && o && xt.NO_DELETE_TAGS.indexOf(o.tagName) < 0) if (h.node.isDeletable(o)) g(o).remove(), g(e).replaceWith(xt.MARKERS); else if (h.node.isBlock(o) && h.node.isEditable(o)) if (h.node.isList(o)) if (h.node.isEmpty(n, !0)) g(n).remove(), g(o).find("li").first().prepend(xt.MARKERS); else {
          var i = g(o).find("li").first();
          "BLOCKQUOTE" === n.tagName && (a = h.node.contents(n)).length && h.node.isBlock(a[a.length - 1]) && (n = a[a.length - 1]), 0 === i.find("ul, ol").length && (g(e).replaceWith(xt.MARKERS), i.find(h.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === i.get(0) && g(this).replaceWith(g(this).html() + (h.node.isEmpty(this) ? "" : "<br>"))
          }), g(n).append(h.node.contents(i.get(0))), i.remove(), 0 === g(o).find("li").length && g(o).remove())
        } else {
          if ((a = h.node.contents(o)).length && "BR" === a[0].tagName && g(a[0]).remove(), "BLOCKQUOTE" !== o.tagName && "BLOCKQUOTE" === n.tagName) for (a = h.node.contents(n); a.length && h.node.isBlock(a[a.length - 1]);) n = a[a.length - 1], a = h.node.contents(n); else if ("BLOCKQUOTE" === o.tagName && "BLOCKQUOTE" !== n.tagName) for (a = h.node.contents(o); a.length && h.node.isBlock(a[0]);) o = a[0], a = h.node.contents(o);
          g(e).replaceWith(xt.MARKERS), g(n).append(o.innerHTML), g(o).remove()
        } else {
          for (g(e).replaceWith(xt.MARKERS); o && "BR" !== o.tagName && !h.node.isBlock(o) && h.node.isEditable(o);) {
            var s = o;
            o = o.nextSibling, g(n).append(s)
          }
          o && "BR" === o.tagName && h.node.isEditable(o) && g(o).remove()
        }
      }
    }

    function n(e) {
      for (var t, n = e; !n.nextSibling;) if (n = n.parentNode, h.node.isElement(n)) return !1;
      if ("BR" === (n = n.nextSibling).tagName && h.node.isEditable(n)) if (n.nextSibling) {
        if (h.node.isBlock(n.nextSibling) && h.node.isEditable(n.nextSibling)) {
          if (!(xt.NO_DELETE_TAGS.indexOf(n.nextSibling.tagName) < 0)) return void g(n).remove();
          n = n.nextSibling, g(n.previousSibling).remove()
        }
      } else if (d(n)) {
        if (p(e)) h.cursorLists._del(e); else h.node.deepestParent(n) && ((!h.node.isEmpty(h.node.blockParent(n)) || (h.node.blockParent(n).nextSibling && xt.NO_DELETE_TAGS.indexOf(h.node.blockParent(n).nextSibling.tagName)) < 0) && g(n).remove(), o(e));
        return
      }
      if (!h.node.isBlock(n) && h.node.isEditable(n)) {
        for (t = h.node.contents(n); n.nodeType !== Node.TEXT_NODE && t.length && !h.node.isDeletable(n) && h.node.isEditable(n);) n = t[0], t = h.node.contents(n);
        n.nodeType === Node.TEXT_NODE ? (g(n).before(xt.MARKERS), n.textContent.length && (n.textContent = n.textContent.substring(v(n.textContent, !0), n.textContent.length))) : h.node.isDeletable(n) ? (g(n).before(xt.MARKERS), g(n).remove()) : !1 !== h.events.trigger("node.remove", [g(n)]) && (g(n).before(xt.MARKERS), g(n).remove()), g(e).remove()
      } else if (xt.NO_DELETE_TAGS.indexOf(n.tagName) < 0 && (h.node.isEditable(n) || h.node.isDeletable(n))) if (h.node.isDeletable(n)) g(e).replaceWith(xt.MARKERS), g(n).remove(); else if (h.node.isList(n)) e.previousSibling ? (g(n).find("li").first().prepend(e), h.cursorLists._backspace(e)) : (g(n).find("li").first().prepend(xt.MARKERS), g(e).remove()); else if ((t = h.node.contents(n)) && "BR" === t[0].tagName && g(t[0]).remove(), t && "BLOCKQUOTE" === n.tagName) {
        var r = t[0];
        for (g(e).before(xt.MARKERS); r && "BR" !== r.tagName;) {
          var a = r;
          r = r.nextSibling, g(e).before(a)
        }
        r && "BR" === r.tagName && g(r).remove()
      } else g(e).after(g(n).html()).after(xt.MARKERS), g(n).remove()
    }

    function i() {
      for (var e = h.el.querySelectorAll("blockquote:empty"), t = 0; t < e.length; t++) e[t].parentNode.removeChild(e[t])
    }

    function C(e, t, n) {
      var r, a = h.node.deepestParent(e, [], !n);
      if (a && "BLOCKQUOTE" === a.tagName) return m(e, a) ? (r = h.html.defaultTag(), t ? g(e).replaceWith("<br>" + xt.MARKERS) : r ? g(a).after("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(a).after("".concat(xt.MARKERS, "<br>")), g(e).remove()) : E(e, t, n), !1;
      if (null === a) (r = h.html.defaultTag()) && h.node.isElement(e.parentNode) ? g(e).replaceWith("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : !e.previousSibling || g(e.previousSibling).is("br") || e.nextSibling ? g(e).replaceWith("<br>".concat(xt.MARKERS)) : g(e).replaceWith("<br>".concat(xt.MARKERS, "<br>")); else {
        var o = e, i = "";
        "PRE" != a.tagName || e.nextSibling || (t = !0), h.node.isBlock(a) && !t || (i = "<br/>");
        var s, l = "", c = "", d = "", f = "";
        (r = h.html.defaultTag()) && h.node.isBlock(a) && (d = "<".concat(r, ">"), f = "</".concat(r, ">"), a.tagName === r.toUpperCase() && (d = h.node.openTagString(g(a).clone().removeAttr("id").get(0))));
        do {
          if (o = o.parentNode, !t || o !== a || t && !h.node.isBlock(a)) if (l += h.node.closeTagString(o), o === a && h.node.isBlock(a)) c = d + c; else {
            var p = ("A" === o.tagName || h.node.hasClass(o, "fa")) && m(e, o) ? "fr-to-remove" : "";
            c = "isPasted" === o.getAttribute("id") ? h.node.openTagString(g(o).clone().attr("style", "").addClass(p).get(0)) + c : h.node.openTagString(g(o).clone().addClass(p).get(0)) + c
          }
        } while (o !== a);
        i = l + i + c + (e.parentNode === a && h.node.isBlock(a) ? "" : xt.INVISIBLE_SPACE) + xt.MARKERS, h.node.isBlock(a) && !g(a).find("*").last().is("br") && g(a).append("<br/>"), g(e).after('<span id="fr-break"></span>'), g(e).remove(), a.nextSibling && !h.node.isBlock(a.nextSibling) || h.node.isBlock(a) || g(a).after("<br>"), s = (s = !t && h.node.isBlock(a) ? h.node.openTagString(a) + g(a).html() + f : h.node.openTagString(a) + g(a).html() + h.node.closeTagString(a)).replace(/<span id="fr-break"><\/span>/g, i), g(a).replaceWith(s)
      }
    }

    function E(e, t, n) {
      var r = h.node.deepestParent(e, [], !n);
      if (null === r) h.html.defaultTag() && e.parentNode === h.el ? g(e).replaceWith("<".concat(h.html.defaultTag(), ">").concat(xt.MARKERS, "<br></").concat(h.html.defaultTag(), ">")) : (e.nextSibling && !h.node.isBlock(e.nextSibling) || g(e).after("<br>"), g(e).replaceWith("<br>".concat(xt.MARKERS))); else if (e.previousSibling && "IMG" == e.previousSibling.tagName || e.nextSibling && "IMG" == e.nextSibling.tagName) g(e).replaceWith("<" + h.html.defaultTag() + ">" + xt.MARKERS + "<br></" + h.html.defaultTag() + ">"); else {
        var a = e, o = "";
        "PRE" === r.tagName && (t = !0), h.node.isBlock(r) && !t || (o = "<br>");
        var i = "", s = "";
        do {
          var l = a;
          if (a = a.parentNode, "BLOCKQUOTE" === r.tagName && h.node.isEmpty(l) && !h.node.hasClass(l, "fr-marker") && g(l).contains(e) && g(l).after(e), "BLOCKQUOTE" !== r.tagName || !m(e, a) && !u(e, a)) if (!t || a !== r || t && !h.node.isBlock(r)) {
            i += h.node.closeTagString(a);
            var c = "A" == a.tagName && m(e, a) || h.node.hasClass(a, "fa") ? "fr-to-remove" : "";
            s = h.node.openTagString(g(a).clone().addClass(c).removeAttr("id").get(0)) + s, a === r && "DIV" === r.tagName && (i = "<br>", s = "")
          } else "BLOCKQUOTE" == r.tagName && t && (s = i = "")
        } while (a !== r);
        var d = r === e.parentNode && h.node.isBlock(r) || e.nextSibling;
        if ("BLOCKQUOTE" === r.tagName) if (e.previousSibling && h.node.isBlock(e.previousSibling) && e.nextSibling && "BR" === e.nextSibling.tagName && (g(e.nextSibling).after(e), e.nextSibling && "BR" === e.nextSibling.tagName && g(e.nextSibling).remove()), t) o = i + o + xt.MARKERS + s; else {
          var f = h.html.defaultTag();
          o = "".concat(i + o + (f ? "<".concat(f, ">") : "") + xt.MARKERS, "<br>").concat(f ? "</".concat(f, ">") : "").concat(s)
        } else o = i + o + s + (d ? "" : xt.INVISIBLE_SPACE) + xt.MARKERS;
        g(e).replaceWith('<span id="fr-break"></span>');
        var p = h.node.openTagString(r) + g(r).html() + h.node.closeTagString(r);
        p = p.replace(/<span id="fr-break"><\/span>/g, o), g(r).replaceWith(p)
      }
    }

    return {
      enter: function y(e) {
        var t = h.markers.insert();
        if (!t) return !0;
        for (var n = t.parentNode; n && !h.node.isElement(n);) {
          if ("false" === n.getAttribute("contenteditable")) return g(t).replaceWith(xt.MARKERS), h.selection.restore(), !1;
          if ("true" === n.getAttribute("contenteditable")) break;
          n = n.parentNode
        }
        h.el.normalize();
        var r = !1;
        0 < g(t).parentsUntil(h.$el, "BLOCKQUOTE").length && (r = !0), g(t).parentsUntil(h.$el, "TD, TH").length && (r = !1), d(t) ? !p(t) || e || r ? C(t, e, r) : h.cursorLists._endEnter(t) : f(t) ? !p(t) || e || r ? function l(e, t, n) {
          var r, a = h.node.deepestParent(e, [], !n);
          if (a && "TABLE" === a.tagName) return g(a).find("td, th").first().prepend(e), l(e, t, n);
          if (a && "BLOCKQUOTE" === a.tagName) if (u(e, a)) {
            if (!t) return (r = h.html.defaultTag()) ? g(a).before("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(a).before("".concat(xt.MARKERS, "<br>")), g(e).remove(), !1
          } else m(e, a) ? C(e, t, !0) : E(e, t, !0);
          if (null === a) (r = h.html.defaultTag()) && h.node.isElement(e.parentNode) ? g(e).replaceWith("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(e).replaceWith("<br>".concat(xt.MARKERS)); else {
            if (r = h.html.defaultTag(), h.node.isBlock(a)) if ("PRE" === a.tagName && (t = !0), t) g(e).remove(), g(a).prepend("<br>".concat(xt.MARKERS)); else if (e.nextSibling && "IMG" == e.nextSibling.tagName || e.nextSibling && e.nextSibling.nextElementSibling && "IMG" == e.nextSibling.nextElementSibling) g(e).replaceWith("<" + h.html.defaultTag() + ">" + xt.MARKERS + "<br></" + h.html.defaultTag() + ">"); else {
              if (h.node.isEmpty(a, !0)) return C(e, t, n);
              if (h.opts.keepFormatOnDelete || "DIV" === a.tagName || "div" === h.html.defaultTag()) if (!h.opts.keepFormatOnDelete && "DIV" === a.tagName || "div" === h.html.defaultTag()) g(a).before("<" + h.html.defaultTag() + "><br></" + h.html.defaultTag() + ">"); else {
                for (var o = e, i = xt.INVISIBLE_SPACE; o !== a && !h.node.isElement(o);) o = o.parentNode, i = h.node.openTagString(o) + i + h.node.closeTagString(o);
                g(a).before(i)
              } else g(a).before("".concat(h.node.openTagString(g(a).clone().removeAttr("id").get(0)), "<br>").concat(h.node.closeTagString(a)))
            } else g(a).before("<br>");
            g(e).remove()
          }
        }(t, e, r) : h.cursorLists._startEnter(t) : !p(t) || e || r ? E(t, e, r) : h.cursorLists._middleEnter(t), function c() {
          h.$el.find(".fr-to-remove").each(function () {
            for (var e = h.node.contents(this), t = 0; t < e.length; t++) e[t].nodeType === Node.TEXT_NODE && (e[t].textContent = e[t].textContent.replace(/\u200B/g, ""));
            g(this).replaceWith(this.innerHTML)
          })
        }(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists(), h.spaces.normalizeAroundCursor()), h.selection.restore();
        var a = h.o_win.innerHeight;
        if (h.$oel[0].offsetHeight > a) {
          var o = h.helpers.scrollTop(), i = h.selection.blocks();
          if (i && 0 < i.length && i[0].offsetTop) {
            var s = i[0].offsetTop;
            a - 100 < s - o ? h.o_win.scroll(0, s - a + 120) : s - o < 0 && h.o_win.scroll(0, s - 20)
          }
        }
      }, backspace: function s() {
        var e = !1, t = h.markers.insert();
        if (!t) return !0;
        for (var n = t.parentNode; n && !h.node.isElement(n);) {
          if ("false" === n.getAttribute("contenteditable")) return g(t).replaceWith(xt.MARKERS), h.selection.restore(), !1;
          if (n.innerText.length && "true" === n.getAttribute("contenteditable")) break;
          n = n.parentNode
        }
        h.el.normalize();
        var r = t.previousSibling;
        if (r) {
          var a = r.textContent;
          a && a.length && 8203 === a.charCodeAt(a.length - 1) && 1 !== a.length && (r.textContent = r.textContent.substr(0, a.length - v(a)))
        }
        return d(t) ? p(t) && u(t, g(t).parents("li").first().get(0)) ? h.cursorLists._backspace(t) : e = b(t) : f(t) ? p(t) && u(t, g(t).parents("li").first().get(0)) ? h.cursorLists._backspace(t) : function c(e) {
          for (var t = 0 < g(e).parentsUntil(h.$el, "BLOCKQUOTE").length, n = h.node.deepestParent(e, [], !t), r = n; n && !n.previousSibling && "BLOCKQUOTE" !== n.tagName && n.parentElement !== h.el && !h.node.hasClass(n.parentElement, "fr-inner") && xt.SIMPLE_ENTER_TAGS.indexOf(n.parentElement.tagName) < 0;) n = n.parentElement;
          if (n && "BLOCKQUOTE" === n.tagName) {
            var a = h.node.deepestParent(e, [g(e).parentsUntil(h.$el, "BLOCKQUOTE").get(0)]);
            a && a.previousSibling && (r = n = a)
          }
          if (null !== n) {
            var o, i = n.previousSibling;
            if (h.node.isBlock(n) && h.node.isEditable(n)) if (i && xt.NO_DELETE_TAGS.indexOf(i.tagName) < 0) {
              if (h.node.isDeletable(i)) g(i).remove(), g(e).replaceWith(xt.MARKERS); else if (h.node.isEditable(i)) if (h.node.isBlock(i)) if (h.node.isEmpty(i) && !h.node.isList(i)) g(i).remove(), g(e).after(h.opts.keepFormatOnDelete ? xt.INVISIBLE_SPACE : ""); else {
                if (h.node.isList(i) && (i = g(i).find("li").last().get(0)), (o = h.node.contents(i)).length && "BR" === o[o.length - 1].tagName && g(o[o.length - 1]).remove(), "BLOCKQUOTE" === i.tagName && "BLOCKQUOTE" !== n.tagName) for (o = h.node.contents(i); o.length && h.node.isBlock(o[o.length - 1]);) i = o[o.length - 1], o = h.node.contents(i); else if ("BLOCKQUOTE" !== i.tagName && "BLOCKQUOTE" === r.tagName) for (o = h.node.contents(r); o.length && h.node.isBlock(o[0]);) r = o[0], o = h.node.contents(r);
                if (h.node.isEmpty(n)) g(e).remove(), h.selection.setAtEnd(i, !0); else {
                  g(e).replaceWith(xt.MARKERS);
                  var s = i.childNodes;
                  h.node.isBlock(s[s.length - 1]) ? g(s[s.length - 1]).append(r.innerHTML) : g(i).append(r.innerHTML)
                }
                g(r).remove(), h.node.isEmpty(n) && g(n).remove()
              } else g(e).replaceWith(xt.MARKERS), "BLOCKQUOTE" === n.tagName && i.nodeType === Node.ELEMENT_NODE ? g(i).remove() : (g(i).after(h.node.isEmpty(n) ? "" : g(n).html()), g(n).remove(), "BR" === i.tagName && g(i).remove())
            } else if (!i) if (n && "BLOCKQUOTE" === n.tagName && 0 === g(n).text().replace(/\u200B/g, "").length) g(n).remove(); else {
              var l = n.nextSibling;
              h.node.isEmpty(n) && n.parentNode && h.node.isEditable(n.parentNode) && !l && n.parentNode != h.el && g(n.parentNode).remove()
            }
          }
        }(t) : e = b(t), g(t).remove(), i(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists(), h.spaces.normalizeAroundCursor()), h.selection.restore(), e
      }, del: function r() {
        var e = h.markers.insert();
        if (!e) return !1;
        if (h.el.normalize(), d(e)) if (p(e)) if (0 === g(e).parents("li").first().find("ul, ol").length) h.cursorLists._del(e); else {
          var t = g(e).parents("li").first().find("ul, ol").first().find("li").first();
          (t = t.find(h.html.blockTagsQuery()).get(-1) || t).prepend(e), h.cursorLists._backspace(e)
        } else o(e); else f(e), n(e);
        g(e).remove(), i(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists()), h.spaces.normalizeAroundCursor(), h.selection.restore()
      }, isAtEnd: m, isAtStart: u
    }
  }, xt.MODULES.data = function (f) {
    function p(e) {
      return e
    }

    function c(e) {
      for (var t = e.toString(), n = 0, r = 0; r < t.length; r++) n += parseInt(t.charAt(r), 10);
      return 10 < n ? n % 9 + 1 : n
    }

    function d(e, t, n) {
      for (var r = Math.abs(n); 0 < r--;) e -= t;
      return n < 0 && (e += 123), e
    }

    function u(e) {
      return e && "block" !== e.css("display") ? (e.remove(), !0) : e && 0 === f.helpers.getPX(e.css("height")) ? (e.remove(), !0) : !(!e || "absolute" !== e.css("position") && "fixed" !== e.css("position") || (e.remove(), 0))
    }

    function h(e) {
      return e && 0 === f.$box.find(e).length
    }

    function g() {
      if (10 < e && (f[p(T("0ppecjvc=="))](), setTimeout(function () {
        E.FE = null
      }, 10)), !f.$box) return !1;
      f.$wp.prepend(T(p(T(w)))), b = f.$wp.find("> div").first(), C = b.find("> a"), "rtl" === f.opts.direction && b.css("left", "auto").css("right", 0).attr("direction", "rtl"), e++
    }

    function m(e) {
      for (var t = [T("9qqG-7amjlwq=="), T("KA3B3C2A6D1D5H5H1A3=="), T("3B9B3B5F3C4G3E3=="), T("QzbzvxyB2yA-9m=="), T("ji1kacwmgG5bc=="), T("nmA-13aogi1A3c1jd=="), T("BA9ggq=="), T("emznbjbH3fij=="), T("tkC-22d1qC-13sD1wzF-7=="), T("tA3jjf=="), T("1D1brkm==")], n = 0; n < t.length; n++) if (String.prototype.endsWith || (String.prototype.endsWith = function (e, t) {
        return (void 0 === t || t > this.length) && (t = this.length), this.substring(t - e.length, t) === e
      }), e.endsWith(t[n])) return !0;
      return !1
    }

    function v() {
      var e = T(p(n)), t = T(p("tzgatD-13eD1dtdrvmF3c1nrC-7saQcdav==")).split(".");
      try {
        return window.parent.document.querySelector(e) && window[t[1]][t[2]]
      } catch (e) {
        return !1
      }
    }

    var b, C, E = f.$,
      y = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2FC1A3NB2IF1HE1TH4WB8eB-11zVG2F3I3yYB5ZG4CB2DA15CC5AD3F1A1KG1oLA10B1A6wQF1H3vgale2C4F4XA2qc2A5D5B3pepmriKB3OE1HD1fUC10pjD-11E-11TB4YJ3bC-16zE-11yc1B2CE2BC3jhjKC1pdA-21OA6C1D5B-8vF4QA11pD6sqf1C3lldA-16BD4A2H3qoEA7bB-16rmNH5H1F1vSB7RE2A3TH4YC5A5b1A4d1B3whepyAC3AA2zknC3mbgf1SC4WH4PD8TC5ZB2C3H3jb2A5ZA2EF2aoFC5qqHC4B1H1zeGA7UA5RF4TA29TA6ZC4d1C3hyWA10A3rBB2E3decorationRD3QC10UD3E6E6ZD2F3F3fme2E5uxxrEC9C3E4fB-11azhHB1LD7D6VF4VVTPC6b1C4TYG3qzDD6B3B3AH4I2H2kxbHE1JD1yihfd1QD6WB1D4mhrc1B5rvFG3A14A7cDA2OC1AA1JB5zC-16KA6WB4C-8wvlTB5A5lkZB2C2C7zynBD2D2bI-7C-21d1HE2cubyvPC8A6VB3aroxxZE4C4F4e1I2BE1WjdifH1H4A14NA1GB1YG-10tWA3A14A9sVA2C5XH2A29b2A6gsleGG2jaED2D-13fhE1OA8NjwytyTD4e1sc1D-16ZC3B5C-9e1C2FB6EFF5B2C2JH4E1C2tdLE5A3UG4G-7b2D3B4fA-9oh1G3kqvB4AG3ibnjcAC6D2B1cDA9KC2QA6bRC4VA30RB8hYB2A4A-8h1A21A2B2==",
      L = "7D4YH4fkhHB3pqDC3H2E1fkMD1IB1NF1D3QD9wB5rxqlh1A8c2B4ZA3FD2AA6FB5EB3jJG4D2J-7aC-21GB6PC5RE4TC11QD6XC4XE3XH3mlvnqjbaOA2OC2BE6A1fmI-7ujwbc1G5f1F3e1C11mXF4owBG3E1yD1E4F1D2D-8B-8C-7yC-22HD1MF5UE4cWA3D8D6a1B2C3H3a3I3sZA4B3A2akfwEB3xHD5D1F1wIC11pA-16xdxtVI2C9A6YC4a1A2F3B2GA6B4C3lsjyJB1eMA1D-11MF5PE4ja1D3D7byrf1C3e1C7D-16lwqAF3H2A1B-21wNE1MA1OG1HB2A-16tSE5UD4RB3icRA4F-10wtwzBB3E1C3CC2DA8LA2LA1EB1kdH-8uVB7decorg1J2B7B6qjrqGI2J1C6ijehIB1hkemC-13hqkrH4H-7QD6XF5XF3HLNAC3CB2aD2CD2KB10B4ycg1A-8KA4H4B11jVB5TC4yqpB-21pd1E4pedzGB6MD5B3ncB-7MA4LD2JB6PD5uH-8TB9C7YD5XD2E3I3jmiDB3zeimhLD8E2F2JC1H-9ivkPC5lG-10SB1D3H3A-21rc1A3d1E3fsdqwfGA2KA1OrC-22LA6D1B4afUB16SC7AitC-8qYA11fsxcajGA15avjNE2A-9h1hDB16B9tPC1C5F5UC1G3B8d2A5d1D4RnHJ3C3JB5D3ucMG1yzD-17hafjC-8VD3yWC6e1YD2H3ZE2C8C5oBA3H3D2vFA4WzJC4C2i1A-65fNB8afWA1H4A26mvkC-13ZB3E3h1A21BC4eFB2GD2AA5ghqND2A2B2==",
      n = "MekC-11nB-8tIzpD7pewxvzC6mD-16xerg1==", _ = "lC4B3A3B2B5A1C2E4G1A2==",
      w = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2EE1MA2ND1KD1IE4cA-21pSD2D5ve1G3h1A8b1E5ZC3CD2FA16mC5OC5E1hpnG1NA10B1D7hkUD4I-7b2C3C5nXD2E3F3whidEC2EH3GI2mJE2E2bxci1WA10VC7pllSG2F3A7xd1A4ZC3DB2aaeGA2DE4H2E1j1ywD-13FD1A3VE4WA3D8C6wuc1A2hf1B5B7vnrrjA1B9ic1mpbD1oMB1iSB7rWC4RI4G-7upB6jd1A2F3H2EA4FD3kDF4A2moc1anJD1TD4VI4b2C7oeQF4c1E3XC7ZA3C3G3uDB2wGB6D1JC4D1JD4C1hTE6QC5pH4pD3C-22D7c1A3textAA4gdlB2mpozkmhNC1mrxA3yWA5edhg1I2H3B7ozgmvAI3I2B5GD1LD2RSNH1KA1XA5SB4PA3sA9tlmC-9tnf1G3nd1coBH4I2I2JC3C-16LE6A1tnUA3vbwQB1G3f1A20a3A8a1C6pxAB2eniuE1F3kH2lnjB2hB-16XA5PF1G4zwtYA5B-11mzTG2B9pHB3BE2hGH3B3B2cMD5C1F1wzPA8E7VG5H5vD3H-7C8tyvsVF2I1G2A5fE3bg1mgajoyxMA4fhuzSD8aQB2B4g1A20ukb1A4B3F3GG2CujjanIC1ObiB11SD1C5pWC1D4YB8YE5FE-11jXE2F-7jB4CC2G-10uLH4E1C2tA-13yjUH5d1H1A7sWD5E4hmjF-7pykafoGA16hDD4joyD-8OA33B3C2tC7cRE4SA31a1B8d1e2A4F4g1A2A22CC5zwlAC2C1A12==",
      A = function () {
        for (var e = 0, t = document.domain, n = t.split("."), r = "_gd".concat((new Date).getTime()); e < n.length - 1 && -1 === document.cookie.indexOf("".concat(r, "=").concat(r));) t = n.slice(-1 - ++e).join("."), document.cookie = "".concat(r, "=").concat(r, ";domain=").concat(t, ";");
        return document.cookie = "".concat(r, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=").concat(t, ";"), (t || "").replace(/(^\.*)|(\.*$)/g, "")
      }(), T = p(function S(e) {
        if (!e) return e;
        for (var t = "", n = p("charCodeAt"), r = p("fromCharCode"), a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".indexOf(e[0]), o = 1; o < e.length - 2; o++) {
          for (var i = c(++a), s = e[n](o), l = ""; /[0-9-]/.test(e[o + 1]);) l += e[++o];
          s = d(s, i, l = parseInt(l, 10) || 0), s ^= a - 1 & 31, t += String[r](s)
        }
        return t
      }), e = 0;
    return {
      _init: function k() {
        var e = f.opts.key || [""],
          t = T(p("ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=="));
        "string" == typeof e && (e = [e]);
        for (var n, r, a, o = !(f.ul = !0), i = 0, s = 0; s < e.length; s++) {
          var l = (r = e[s], 4 === (a = (T(r) || "").split("|")).length && "V3" === a[0] ? [a[1], a[3], a[2]] : [null, null, ""]),
            c = l[2];
          if (c === T(p(T("LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2=="))) || 0 <= c.indexOf(A, c.length - A.length) || m(A) || v()) {
            if (null !== (n = l[1]) && !(0 == n.indexOf("TRIAL") ? (n = new Date(n.replace(/TRIAL/, "")), new Date(n) < new Date && (y = L, 1)) : new Date(n) < new Date(T(_))) || !(0 < (A || "").length) || m(A) || v()) {
              f.ul = !1;
              break
            }
            o = !0, w = y, i = l[0] || -1
          }
        }
        var d = new Image;
        !0 === f.ul && (g(), d.src = o ? "".concat(p(T(t)), "e=").concat(i) : "".concat(p(T(t)), "u")), !0 === f.ul && (f.events.on("contentChanged", function () {
          (function e() {
            return u(b) || u(C) || h(b) || h(C)
          })() && g()
        }), f.events.on("html.get", function (e) {
          return e + T("qD2H-9G3ioD-17qA1tE1B-8qI3A4hA-13C-11E2C1njfldD1E6pg1C-8sC3hfbkcD2G3stC-22gqgB3G2B-7vtoA4nweeD1A31A15B9uC-16A1F5dkykdc1B8dE-11bA3F2D3A9gd1E7F2tlI-8H-7vtxB2A5B2C3B2F2B5A6ldbyC4iqC-22D-17E-13mA3D2dywiB3oxlvfC1H4C2TjqbzlnI3ntB4E3qA2zaqsC6D3pmnkoE3C6D5wvuE3bwifdhB6hch1E4xibD-17dmrC1rG-7pntnF6nB-8F1D2A11C8plrkmF2F3MC-16bocqA2WwA-21ayeA1C4d1isC-22rD-13D6DfjpjtC2E6hB2G2G4A-7D2==")
        })), f.events.on("html.set", function () {
          var e = f.el.querySelector('[data-f-id="pbf"]');
          e && E(e).remove()
        }), f.events.on("destroy", function () {
          b && b.length && b.remove()
        }, !0)
      }
    }
  }, xt.MODULES.edit = function (t) {
    function e() {
      if (t.browser.mozilla) try {
        t.doc.execCommand("enableObjectResizing", !1, "false"), t.doc.execCommand("enableInlineTableEditing", !1, "false")
      } catch (e) {
      }
      if (t.browser.msie) try {
        t.doc.body.addEventListener("mscontrolselect", function (e) {
          return e.srcElement.focus(), !1
        })
      } catch (e) {
      }
    }

    var n = !1;

    function r() {
      return n
    }

    return {
      _init: function a() {
        t.events.on("focus", function () {
          r() ? t.edit.off() : t.edit.on()
        })
      }, on: function o() {
        t.$wp ? (t.$el.attr("contenteditable", !0), t.$el.removeClass("fr-disabled").attr("aria-disabled", !1), e()) : t.$el.is("a") && t.$el.attr("contenteditable", !0), t.events.trigger("edit.on", [], !0), n = !1
      }, off: function i() {
        t.events.disableBlur(), t.$wp ? (t.$el.attr("contenteditable", !1), t.$el.addClass("fr-disabled").attr("aria-disabled", !0)) : t.$el.is("a") && t.$el.attr("contenteditable", !1), t.events.trigger("edit.off"), t.events.enableBlur(), n = !0
      }, disableDesign: e, isDisabled: r
    }
  }, xt.MODULES.format = function (T) {
    var S = T.$;

    function m(e, t) {
      var n = "<".concat(e);
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n += " ".concat(r, '="').concat(t[r], '"'));
      return n += ">"
    }

    function k(e, t) {
      var n = e;
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n += "id" === r ? "#".concat(t[r]) : "class" === r ? ".".concat(t[r]) : "[".concat(r, '="').concat(t[r], '"]'));
      return n
    }

    function x(e, t) {
      return !(!e || e.nodeType !== Node.ELEMENT_NODE) && (e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector).call(e, t)
    }

    function v(e, t, n) {
      var r, a, o, i = {strong: {prop: "font-weight", val: "bold"}, em: {prop: "font-style", val: "italic"}};
      if (e) {
        if (T.node.isBlock(e) && e.hasAttribute("contenteditable") && "false" === e.getAttribute("contenteditable") || e.parentNode && e.parentNode.hasAttribute("contenteditable") && "false" === e.parentNode.getAttribute("contenteditable")) {
          if (e.nextSibling && S(e.nextSibling).hasClass("fr-marker")) return;
          if (e.nextSibling) return void v(e.nextSibling, t, n);
          if (e.parentNode) return void v(e.parentNode, t, n)
        }
        for (; e.nodeType === Node.COMMENT_NODE;) e = e.nextSibling;
        if (e) {
          if (T.node.isBlock(e) && "HR" !== e.tagName) return T.node.hasClass(e.firstChild, "fr-marker") ? v(e.firstChild.nextSibling, t, n) : v(e.firstChild, t, n), !1;
          var s = S(T.doc.createElement(t));
          s.attr(n), s.insertBefore(e), (r = b(e)) && (0 <= ["strong", "em"].indexOf(t) || "span" === t && n.hasOwnProperty("style")) && (o = "span" === t ? (a = (i = n.style.replace(/;$/, "").split(":"))[0].trim(), i[1].trim()) : (a = i[t].prop, i[t].val), "background-color" !== a && (S(r).css(a, o), function g(e, t) {
            var n, r = e.childNodes;
            for (n = 0; n < r.length; n++) 0 <= ["UL", "OL", "LI"].indexOf(r[n].tagName) && "" === r[n].style[t] && S(r[n]).css(t, "initial")
          }(r, a)));
          for (var l = e; l && !S(l).hasClass("fr-marker") && 0 === S(l).find(".fr-marker").length && "UL" !== l.tagName && "OL" !== l.tagName;) {
            var c = l;
            if ("SPAN" === l.tagName && S(l).hasClass("fr-tracking-deleted")) l = l.nextSibling; else {
              if (T.node.isBlock(l) && "HR" !== e.tagName) return v(l.firstChild, t, n), !1;
              if ("SPAN" === l.tagName) return v(l.firstChild, t, n), !1;
              if (l.tagName && l.hasAttribute("contenteditable") && "false" === l.getAttribute("contenteditable")) return void v(l.nextSibling, t, n);
              l = l.nextSibling, s.append(c)
            }
          }
          if (l) {
            if (S(l).find(".fr-marker").length || "UL" === l.tagName || "OL" === l.tagName) v(l.firstChild, t, n); else if (T.browser.mozilla && T.node.hasClass(l, "fr-marker")) {
              var d, f = T.selection.blocks(), p = f.length;
              for (d = 0; d < p; d++) f[d] != l.parentNode && f[d].childNodes.length && f[d].childNodes[0] != l.parentNode && (l = f[d].childNodes[1] || f[d].childNodes[0], (s = S(m(t, n)).insertBefore(l)).append(l))
            }
          } else {
            for (var u = s.get(0).parentNode; u && !u.nextSibling && !T.node.isElement(u);) u = u.parentNode;
            if (u) {
              var h = u.nextSibling;
              h && (T.node.isBlock(h) ? "HR" === h.tagName ? v(h.nextSibling, t, n) : v(h.firstChild, t, n) : v(h, t, n))
            }
          }
          s.is(":empty") && s.remove()
        }
      }
    }

    function n(e, t) {
      var n;
      if (void 0 === t && (t = {}), t.style && delete t.style, T.selection.isCollapsed()) {
        T.markers.insert(), T.$el.find(".fr-marker").replaceWith(m(e, t) + xt.INVISIBLE_SPACE + xt.MARKERS + function i(e) {
          return "</".concat(e, ">")
        }(e)), T.selection.restore()
      } else {
        var r;
        T.selection.save(), v(T.$el.find('.fr-marker[data-type="true"]').length && T.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling, e, t);
        do {
          for (r = T.$el.find("".concat(k(e, t), " > ").concat(k(e, t))), n = 0; n < r.length; n++) r[n].outerHTML = r[n].innerHTML
        } while (r.length);
        T.el.normalize();
        var a = T.el.querySelectorAll(".fr-marker");
        for (n = 0; n < a.length; n++) {
          var o = S(a[n]);
          !0 === o.data("type") ? x(o.get(0).nextSibling, k(e, t)) && o.next().prepend(o) : x(o.get(0).previousSibling, k(e, t)) && o.prev().append(o)
        }
        T.selection.restore()
      }
    }

    function R(e, t, n, r) {
      if (!r) {
        var a = !1;
        if (!0 === e.data("type")) for (; T.node.isFirstSibling(e.get(0)) && !e.parent().is(T.$el) && !e.parent().is("ol") && !e.parent().is("ul");) e.parent().before(e), a = !0; else if (!1 === e.data("type")) for (; T.node.isLastSibling(e.get(0)) && !e.parent().is(T.$el) && !e.parent().is("ol") && !e.parent().is("ul");) e.parent().after(e), a = !0;
        if (a) return !0
      }
      if (e.parents(t).length || void 0 === t) {
        var o, i = "", s = "", l = e.parent();
        if (l.is(T.$el) || T.node.isBlock(l.get(0))) return !1;
        for (; !(T.node.isBlock(l.parent().get(0)) || void 0 !== t && x(l.get(0), k(t, n)));) i += T.node.closeTagString(l.get(0)), s = T.node.openTagString(l.get(0)) + s, l = l.parent();
        var c = e.get(0).outerHTML;
        return e.replaceWith('<span id="mark"></span>'), o = l.html().replace(/<span id="mark"><\/span>/, i + T.node.closeTagString(l.get(0)) + s + c + i + T.node.openTagString(l.get(0)) + s), l.replaceWith(T.node.openTagString(l.get(0)) + o + T.node.closeTagString(l.get(0))), !0
      }
      return !1
    }

    function r(e, t) {
      void 0 === t && (t = {}), t.style && delete t.style;
      var n = T.selection.isCollapsed();
      T.selection.save();
      for (var r = !0; r;) {
        r = !1;
        for (var a = T.$el.find(".fr-marker"), o = 0; o < a.length; o++) {
          var i = S(a[o]), s = null;
          if (i.attr("data-cloned") || n || (s = i.clone().removeClass("fr-marker").addClass("fr-clone"), i.data("type") && "true" === i.data("type").toString() ? i.attr("data-cloned", !0).after(s) : i.attr("data-cloned", !0).before(s)), R(i, e, t, n)) {
            r = !0;
            break
          }
        }
      }
      !function w(e, t, n, r) {
        for (var a, o = {
          strong: {prop: "font-weight", val: "bold"},
          em: {prop: "font-style", val: "italic"}
        }, i = T.node.contents(e.get(0)), s = 0; s < i.length; s++) {
          var l = i[s];
          if (l.innerHTML && 8203 == l.innerHTML.charCodeAt() && l.tagName.toLocaleLowerCase() == n && l.childNodes.length < 2 && (l.outerHTML = l.innerHTML), T.node.hasClass(l, "fr-marker")) t = (t + 1) % 2; else if (t) if (0 < S(l).find(".fr-marker").length) t = w(S(l), t, n, r); else {
            (a = "LI" === l.tagName ? l : S(l).parentsUntil(T.$el, "li").get(0)) && (void 0 === n || 0 <= ["strong", "em"].indexOf(n)) && (n ? S(a).css(o[n].prop, "") : a.style = "");
            for (var c = S(l).find(n || "*:not(br)"), d = c.length - 1; 0 <= d; d--) {
              var f = c[d];
              (a = "LI" === f.tagName ? f : S(f).parentsUntil(T.$el, "li").get(0)) && (!n || 0 <= ["strong", "em"].indexOf(n)) && (n ? S(a).css(o[n].prop, "") : a.style = ""), T.node.isBlock(f) || T.node.isVoid(f) || void 0 !== n && !x(f, k(n, r)) ? T.node.isBlock(f) && void 0 === n && "TABLE" !== l.tagName && T.node.clearAttributes(f) : T.node.hasClass(f, "fr-clone") || T.node.hasClass(f, "fr-tracking-deleted") || S(f).data("tracking") || (f.outerHTML = f.innerHTML)
            }
            void 0 === n && l.nodeType === Node.ELEMENT_NODE && !T.node.isVoid(l) || x(l, k(n, r)) ? T.node.isBlock(l) || (T.node.hasClass(l, "fr-clone") || T.opts.trackChangesEnabled ? !T.node.hasClass(l, "fr-clone") && T.opts.trackChangesEnabled && l.parentNode && (l.outerHTML = l.innerHTML) : l.outerHTML = l.innerHTML) : void 0 === n && l.nodeType === Node.ELEMENT_NODE && T.node.isBlock(l) && "TABLE" !== l.tagName && T.node.clearAttributes(l)
          } else 0 < S(l).find(".fr-marker").length && (t = w(S(l), t, n, r))
        }
        return t
      }(T.$el, 0, e, t), n || (T.$el.find(".fr-marker").remove(), T.$el.find(".fr-clone").removeClass("fr-clone").addClass("fr-marker")), n && T.$el.find(".fr-marker").before(xt.INVISIBLE_SPACE).after(xt.INVISIBLE_SPACE), T.html.cleanEmptyTags(), T.el.normalize();
      var l = T.$el.find(".fr-marker")[0], c = T.$el.find(".fr-marker")[1];
      !l.parentNode || "P" !== l.parentNode.tagName && "DIV" !== l.parentNode.tagName || l.parentNode.firstChild !== l || l.parentNode.lastChild !== c || l.parentNode.removeAttribute("style"), T.selection.restore();
      var d = T.win.getSelection() && T.win.getSelection().anchorNode;
      if (d) {
        var f = T.node.blockParent(d), p = !!d.textContent.replace(/\u200B/g, "").length,
          u = T.win.getSelection().getRangeAt(0), h = u.startOffset, g = u.endOffset;
        T.selection.text().replace(/\u200B/g, "").length || function A(e, t) {
          if (e && t) {
            if (e.isSameNode(t) ? e.textContent = e.textContent.replace(/\u200B(?=.*\u200B)/g, "") : e.nodeType === Node.TEXT_NODE && (e.textContent = e.textContent.replace(/\u200B/g, "")), !e.childNodes.length) return !1;
            Array.isArray(e.childNodes) && e.childNodes.forEach(function (e) {
              A(e, t)
            })
          }
        }(f, d);
        var m = T.win.getSelection().getRangeAt(0);
        if (d.nodeType === Node.TEXT_NODE) {
          if (!p || !T.selection.text().length && h === g) {
            var v = d.textContent.search(/\u200B/g) + 1;
            if (T.browser.msie) {
              var b = T.doc.createRange();
              T.selection.get().removeAllRanges(), b.setStart(d, v), b.setEnd(d, v), T.selection.get().addRange(b)
            } else m.setStart(d, v), m.setEnd(d, v)
          }
        } else {
          var C, E, y = 0, L = S(d).contents();
          if (T.browser.msie) {
            for (; E = L[y];) E.nodeType === Node.TEXT_NODE && 0 <= E.textContent.search(/\u200B/g) && (C = E), y++;
            C = S(C)
          } else C = L.filter(function (e) {
            return e.nodeType === Node.TEXT_NODE && 0 <= e.textContent.search(/\u200B/g)
          });
          if (C.length && !T.opts.trackChangesEnabled) {
            var _ = C.text().search(/\u200B/g) + 1;
            m.setStart(C.get(0), _), m.setEnd(C.get(0), _)
          }
        }
      }
    }

    function t(e, t) {
      var n, r, a, o, i, s, l, c = null;
      if (T.selection.isCollapsed()) {
        T.markers.insert();
        var d = (r = T.$el.find(".fr-marker")).parent();
        if (T.node.openTagString(d.get(0)) === '<span style="'.concat(e, ": ").concat(d.css(e), ';">')) {
          if (T.node.isEmpty(d.get(0))) c = S(T.doc.createElement("span")).attr("style", "".concat(e, ": ").concat(t, ";")).html("".concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS)), d.replaceWith(c); else {
            var f = {};
            f["style*"] = "".concat(e, ":"), R(r, "span", f, !0), r = T.$el.find(".fr-marker"), t ? (c = S(T.doc.createElement("span")).attr("style", "".concat(e, ": ").concat(t, ";")).html("".concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS)), r.replaceWith(c)) : r.replaceWith(xt.INVISIBLE_SPACE + xt.MARKERS)
          }
          T.html.cleanEmptyTags()
        } else T.node.isEmpty(d.get(0)) && d.is("span") ? (r.replaceWith(xt.MARKERS), d.css(e, t)) : (c = S('<span style="'.concat(e, ": ").concat(t, ';">').concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS, "</span>")), r.replaceWith(c));
        c && C(c, e, t)
      } else {
        if (T.selection.save(), null === t || "color" === e && 0 < T.$el.find(".fr-marker").parents("u, a").length) {
          var p = T.$el.find(".fr-marker");
          for (n = 0; n < p.length; n++) if (!0 === (r = S(p[n])).data("type") || "true" === r.data("type")) for (; T.node.isFirstSibling(r.get(0)) && !r.parent().is(T.$el) && !T.node.isElement(r.parent().get(0)) && !T.node.isBlock(r.parent().get(0));) r.parent().before(r); else for (; T.node.isLastSibling(r.get(0)) && !r.parent().is(T.$el) && !T.node.isElement(r.parent().get(0)) && !T.node.isBlock(r.parent().get(0));) r.parent().after(r)
        }
        for (var u = T.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling; u.firstChild;) u = u.firstChild;
        var h = {"class": "fr-unprocessed"};
        for (t && (h.style = "".concat(e, ": ").concat(t, ";")), v(u, "span", h), T.$el.find(".fr-marker + .fr-unprocessed").each(function () {
          S(this).prepend(S(this).prev())
        }), T.$el.find(".fr-unprocessed + .fr-marker").each(function () {
          S(this).prev().append(S(this))
        }), (t || "").match(/\dem$/) && T.$el.find("span.fr-unprocessed").removeClass("fr-unprocessed"); 0 < T.$el.find("span.fr-unprocessed").length;) {
          if (a = b(c = T.$el.find("span.fr-unprocessed").first().removeClass("fr-unprocessed")), c.parent().get(0).normalize(), c.parent().is("span") && 1 === c.parent().get(0).childNodes.length) {
            c.parent().css(e, t);
            var g = c;
            c = c.parent(), g.replaceWith(g.html())
          }
          for (o = c.find("span"), a && "background-color" !== e && (a.normalize(), o = S(a).find("span:not(.fr-unprocessed)")), n = o.length - 1; 0 <= n; n--) i = o[n], s = e, l = void 0, (l = S(i)).css(s, ""), "" === l.attr("style") && l.replaceWith(l.html());
          C(c, e, t)
        }
      }
      !function m() {
        var e;
        for (; 0 < T.$el.find(".fr-split:empty").length;) T.$el.find(".fr-split:empty").remove();
        T.$el.find(".fr-split").removeClass("fr-split"), T.$el.find('[style=""]').removeAttr("style"), T.$el.find('[class=""]').removeAttr("class"), T.html.cleanEmptyTags();
        for (var t = T.$el.find("span"), n = t.length - 1; 0 <= n; n--) {
          var r = t[n];
          r.attributes && 0 !== r.attributes.length || S(r).replaceWith(r.innerHTML)
        }
        T.el.normalize();
        var a = T.$el.find("span[style] + span[style]");
        for (e = 0; e < a.length; e++) {
          var o = S(a[e]), i = S(a[e]).prev();
          o.get(0).previousSibling === i.get(0) && T.node.openTagString(o.get(0)) === T.node.openTagString(i.get(0)) && (o.prepend(i.html()), i.remove())
        }
        T.$el.find("span[style] span[style]").each(function () {
          if (0 <= S(this).attr("style").indexOf("font-size")) {
            var e = S(this).parents("span[style]");
            e.attr("style") && 0 <= e.attr("style").indexOf("background-color") && (S(this).attr("style", "".concat(S(this).attr("style"), ";").concat(e.attr("style"))), R(S(this), "span[style]", {}, !1))
          }
        }), T.el.normalize(), T.selection.restore()
      }()
    }

    function b(e) {
      var t, n, r, a, o, i;
      if (t = "LI" === e.tagName ? e : S(e).parentsUntil(T.$el, "li").get(0)) {
        if ((i = T.selection.info(t)).atStart && i.atEnd) return t;
        if (i.atStart && !i.atEnd && (n = S(t).find(".fr-marker[data-type=false]").get(0), r = S(n).parentsUntil(T.$el, "li").get(0), a = S(n).parent().get(0), (o = n.nextSibling) && 0 <= ["UL", "OL"].indexOf(o.tagName) || !r.isSameNode(t) || !o && ("LI" === a.tagName || !a.nextSibling || 0 <= ["UL", "OL"].indexOf(a.nextSibling.tagName) || T.node.isVoid(a.nextSibling)))) return t
      }
    }

    function C(e, t, n) {
      var r, a, o, i = e.parentsUntil(T.$el, "span[style]"), s = [];
      for (r = i.length - 1; 0 <= r; r--) a = i[r], o = t, 0 === S(a).attr("style").indexOf("".concat(o, ":")) || 0 <= S(a).attr("style").indexOf(";".concat(o, ":")) || 0 <= S(a).attr("style").indexOf("; ".concat(o, ":")) || s.push(i[r]);
      if ((i = i.not(s)).length) {
        for (var l = "", c = "", d = "", f = "", p = e.get(0); p = p.parentNode, S(p).addClass("fr-split"), l += T.node.closeTagString(p), c = T.node.openTagString(S(p).clone().addClass("fr-split").get(0)) + c, i.get(0) !== p && (d += T.node.closeTagString(p), f = T.node.openTagString(S(p).clone().addClass("fr-split").get(0)) + f), i.get(0) !== p;) ;
        var u = "".concat(l + T.node.openTagString(S(i.get(0)).clone().css(t, n || "").get(0)) + f + e.css(t, "").get(0).outerHTML + d, "</span>").concat(c);
        e.replaceWith('<span id="fr-break"></span>');
        var h = i.get(0).outerHTML;
        S(i.get(0)).replaceWith(h.replace(/<span id="fr-break"><\/span>/g, function () {
          return u
        }))
      }
    }

    function a(e, t) {
      void 0 === t && (t = {}), t.style && delete t.style;
      var n = T.selection.ranges(0), r = n.startContainer;
      if (r.nodeType === Node.ELEMENT_NODE && 0 < r.childNodes.length && r.childNodes[n.startOffset] && (r = r.childNodes[n.startOffset]), !n.collapsed && r.nodeType === Node.TEXT_NODE && n.startOffset === (r.textContent || "").length) {
        for (; !T.node.isBlock(r.parentNode) && !r.nextSibling;) r = r.parentNode;
        r.nextSibling && (r = r.nextSibling)
      }
      for (var a = r; a && a.nodeType === Node.ELEMENT_NODE && !x(a, k(e, t));) a = a.firstChild;
      if (a && a.nodeType === Node.ELEMENT_NODE && x(a, k(e, t))) return !0;
      var o = r;
      for (o && o.nodeType !== Node.ELEMENT_NODE && (o = o.parentNode); o && o.nodeType === Node.ELEMENT_NODE && o !== T.el && !x(o, k(e, t));) o = o.parentNode;
      return !(!o || o.nodeType !== Node.ELEMENT_NODE || o === T.el || !x(o, k(e, t)))
    }

    return {
      is: a, toggle: function o(e, t) {
        a(e, t) ? r(e, t) : n(e, t)
      }, apply: n, remove: r, applyStyle: t, removeStyle: function i(e) {
        t(e, null)
      }
    }
  }, xt.MODULES.spaces = function (c) {
    function r(e, t) {
      var n = e.previousSibling, r = e.nextSibling, a = e.textContent, o = e.parentNode,
        i = [xt.ENTER_P, xt.ENTER_DIV, xt.ENTER_BR];
      if (!c.html.isPreformatted(o)) {
        t && (a = a.replace(/[\f\n\r\t\v ]{2,}/g, " "), r && "BR" !== r.tagName && !c.node.isBlock(r) || !(c.node.isBlock(o) || c.node.isLink(o) && !o.nextSibling || c.node.isElement(o)) || (a = a.replace(/[\f\n\r\t\v ]{1,}$/g, "")), n && "BR" !== n.tagName && !c.node.isBlock(n) || !(c.node.isBlock(o) || c.node.isLink(o) && !o.previousSibling || c.node.isElement(o)) || (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), (c.node.isBlock(r) || c.node.isBlock(n)) && (!n || n && "A" !== n.tagName) && (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), " " === a && (n && c.node.isVoid(n) || r && c.node.isVoid(r)) && !(n && r && c.node.isVoid(n) || r && n && c.node.isVoid(r)) && (a = "")), (!n && c.node.isBlock(r) || !r && c.node.isBlock(n)) && c.node.isBlock(o) && o !== c.el && (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), t || (a = a.replace(new RegExp(xt.UNICODE_NBSP, "g"), " "));
        for (var s = "", l = 0; l < a.length; l++) 32 != a.charCodeAt(l) || 0 !== l && 32 != s.charCodeAt(l - 1) || !((c.opts.enter === xt.ENTER_BR || c.opts.enter === xt.ENTER_DIV) && (n && "BR" === n.tagName || r && "BR" === r.tagName) || n && r && n.tagName === r.tagName) && (n && r && c.node.isVoid(n) || n && r && c.node.isVoid(r)) ? s += a[l] : s += xt.UNICODE_NBSP;
        (!r || r && c.node.isBlock(r) || r && r.nodeType === Node.ELEMENT_NODE && c.win.getComputedStyle(r) && "block" === c.win.getComputedStyle(r).display) && (!c.node.isVoid(n) || n && -1 !== ["P", "DIV", "BR"].indexOf(n.tagName) && -1 !== i.indexOf(c.opts.enter)) && (s = s.replace(/ $/, xt.UNICODE_NBSP)), !n || c.node.isVoid(n) || c.node.isBlock(n) || 1 !== (s = s.replace(/^\u00A0([^ $])/, " $1")).length || 160 !== s.charCodeAt(0) || !r || c.node.isVoid(r) || c.node.isBlock(r) || c.node.hasClass(n, "fr-marker") && c.node.hasClass(r, "fr-marker") || (s = " "), t || (s = s.replace(/([^ \u00A0])\u00A0([^ \u00A0])/g, "$1 $2")), e.textContent !== s && (e.textContent = s)
      }
    }

    function l(e, t) {
      if (void 0 !== e && e || (e = c.el), void 0 === t && (t = !1), !e.getAttribute || "false" !== e.getAttribute("contenteditable")) if (e.nodeType === Node.TEXT_NODE) r(e, t); else if (e.nodeType === Node.ELEMENT_NODE) for (var n = c.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, c.node.filter(function (e) {
        for (var t = e.parentNode; t && t !== c.el;) {
          if ("STYLE" === t.tagName || "IFRAME" === t.tagName) return !1;
          if ("PRE" === t.tagName) return !1;
          t = t.parentNode
        }
        return null !== e.textContent.match(/([ \u00A0\f\n\r\t\v]{2,})|(^[ \u00A0\f\n\r\t\v]{1,})|([ \u00A0\f\n\r\t\v]{1,}$)/g) && !c.node.hasClass(e.parentNode, "fr-marker")
      }), !1); n.nextNode();) r(n.currentNode, t)
    }

    return {
      normalize: l, normalizeAroundCursor: function d() {
        for (var e = [], t = c.el.querySelectorAll(".fr-marker"), n = 0; n < t.length; n++) {
          for (var r = null, a = c.node.blockParent(t[n]), o = (r = a || t[n]).nextSibling, i = r.previousSibling; o && "BR" === o.tagName;) o = o.nextSibling;
          for (; i && "BR" === i.tagName;) i = i.previousSibling;
          r && e.indexOf(r) < 0 && e.push(r), i && e.indexOf(i) < 0 && e.push(i), o && e.indexOf(o) < 0 && e.push(o)
        }
        for (var s = 0; s < e.length; s++) l(e[s])
      }
    }
  }, xt.START_MARKER = '<span class="fr-marker" data-id="0" data-type="true" style="display: none; line-height: 0;">'.concat(xt.INVISIBLE_SPACE = "&#8203;", "</span>"), xt.END_MARKER = '<span class="fr-marker" data-id="0" data-type="false" style="display: none; line-height: 0;">'.concat(xt.INVISIBLE_SPACE, "</span>"), xt.MARKERS = xt.START_MARKER + xt.END_MARKER, xt.MODULES.markers = function (d) {
    var f = d.$;

    function l() {
      if (!d.$wp) return null;
      try {
        var e = d.selection.ranges(0), t = e.commonAncestorContainer;
        if (t !== d.el && !d.$el.contains(t)) return null;
        var n = e.cloneRange(), r = e.cloneRange();
        n.collapse(!0);
        var a = f(d.doc.createElement("SPAN")).addClass("fr-marker").attr("style", "display: none; line-height: 0;").html(xt.INVISIBLE_SPACE).get(0);
        if (n.insertNode(a), a = d.$el.find("span.fr-marker").get(0)) {
          for (var o = a.nextSibling; o && o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length;) f(o).remove(), o = d.$el.find("span.fr-marker").get(0).nextSibling;
          return d.selection.clear(), d.selection.get().addRange(r), a
        }
        return null
      } catch (i) {
      }
    }

    function c() {
      d.$el.find(".fr-marker").remove()
    }

    return {
      place: function p(e, t, n) {
        var r, a, o;
        try {
          var i = e.cloneRange();
          if (i.collapse(t), i.insertNode(function l(e, t) {
            var n = f(d.doc.createElement("SPAN"));
            return n.addClass("fr-marker").attr("data-id", t).attr("data-type", e).attr("style", "display: ".concat(d.browser.safari ? "none" : "inline-block", "; line-height: 0;")).html(xt.INVISIBLE_SPACE), n.get(0)
          }(t, n)), !0 === t) for (o = (r = d.$el.find('span.fr-marker[data-type="true"][data-id="'.concat(n, '"]')).get(0)).nextSibling; o && o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length;) f(o).remove(), o = r.nextSibling;
          if (!0 === t && !e.collapsed) {
            for (; !d.node.isElement(r.parentNode) && !o;) -1 < /\bfa\b/g.test(r.parentNode.className) && "I" === r.parentNode.tagName ? f(r.parentNode).before(r) : f(r.parentNode).after(r), o = r.nextSibling;
            if (o && o.nodeType === Node.ELEMENT_NODE && d.node.isBlock(o) && "HR" !== o.tagName) {
              for (a = [o]; o = a[0], (a = d.node.contents(o))[0] && d.node.isBlock(a[0]);) ;
              f(o).prepend(f(r))
            }
          }
          if (!1 === t && !e.collapsed) {
            if ((o = (r = d.$el.find('span.fr-marker[data-type="false"][data-id="'.concat(n, '"]')).get(0)).previousSibling) && o.nodeType === Node.ELEMENT_NODE && d.node.isBlock(o) && "HR" !== o.tagName) {
              for (a = [o]; o = a[a.length - 1], (a = d.node.contents(o))[a.length - 1] && d.node.isBlock(a[a.length - 1]);) ;
              f(o).append(f(r))
            }
            (r.parentNode && 0 <= ["TD", "TH"].indexOf(r.parentNode.tagName) || !r.previousSibling && d.node.isBlock(r.parentElement)) && (r.parentNode.previousSibling && !r.previousSibling ? f(r.parentNode.previousSibling).append(r) : 0 <= ["TD", "TH"].indexOf(r.parentNode.tagName) && r.parentNode.firstChild === r && (r.parentNode.previousSibling ? f(r.parentNode.previousSibling).append(r) : r.parentNode.parentNode && r.parentNode.parentNode.previousSibling && f(r.parentNode.parentNode.previousSibling).append(r)))
          }
          var s = d.$el.find('span.fr-marker[data-type="'.concat(t, '"][data-id="').concat(n, '"]')).get(0);
          return s && (s.style.display = "none"), s
        } catch (c) {
          return null
        }
      }, insert: l, split: function i() {
        d.selection.isCollapsed() || d.selection.remove();
        var e = d.$el.find(".fr-marker").get(0);
        if (e || (e = l()), !e) return null;
        var t = d.node.deepestParent(e);
        if (t || (t = d.node.blockParent(e)) && "LI" !== t.tagName && (t = null), t) if (d.node.isBlock(t) && d.node.isEmpty(t)) "LI" !== t.tagName || t.parentNode.firstElementChild !== t || d.node.isEmpty(t.parentNode) ? f(t).replaceWith('<span class="fr-marker"></span>') : f(t).append('<span class="fr-marker"></span>'); else if (d.cursor.isAtStart(e, t)) f(t).before('<span class="fr-marker"></span>'), f(e).remove(); else if (d.cursor.isAtEnd(e, t)) f(t).after('<span class="fr-marker"></span>'), f(e).remove(); else {
          for (var n = e, r = "", a = ""; n = n.parentNode, r += d.node.closeTagString(n), a = d.node.openTagString(n) + a, n !== t;) ;
          f(e).replaceWith('<span id="fr-break"></span>');
          var o = d.node.openTagString(t) + f(t).html() + d.node.closeTagString(t);
          o = o.replace(/<span id="fr-break"><\/span>/g, "".concat(r, '<span class="fr-marker"></span>').concat(a)), f(t).replaceWith(o)
        }
        return d.$el.find(".fr-marker").get(0)
      }, insertAtPoint: function u(e) {
        var t, n = e.clientX, r = e.clientY;
        c();
        var a = null;
        if ("undefined" != typeof d.doc.caretPositionFromPoint ? (t = d.doc.caretPositionFromPoint(n, r), (a = d.doc.createRange()).setStart(t.offsetNode, t.offset), a.setEnd(t.offsetNode, t.offset)) : "undefined" != typeof d.doc.caretRangeFromPoint && (t = d.doc.caretRangeFromPoint(n, r), (a = d.doc.createRange()).setStart(t.startContainer, t.startOffset), a.setEnd(t.startContainer, t.startOffset)), null !== a && "undefined" != typeof d.win.getSelection) {
          var o = d.win.getSelection();
          o.removeAllRanges(), o.addRange(a)
        } else if ("undefined" != typeof d.doc.body.createTextRange) try {
          (a = d.doc.body.createTextRange()).moveToPoint(n, r);
          var i = a.duplicate();
          i.moveToPoint(n, r), a.setEndPoint("EndToEnd", i), a.select()
        } catch (s) {
          return !1
        }
        l()
      }, remove: c
    }
  }, xt.MODULES.selection = function (y) {
    var L = y.$;

    function s() {
      var e = "";
      return y.win.getSelection ? e = y.win.getSelection() : y.doc.getSelection ? e = y.doc.getSelection() : y.doc.selection && (e = y.doc.selection.createRange().text), e.toString()
    }

    function E() {
      return y.win.getSelection ? y.win.getSelection() : y.doc.getSelection ? y.doc.getSelection() : y.doc.selection.createRange()
    }

    function f(e) {
      var t = E(), n = [];
      if (t && t.getRangeAt && t.rangeCount) {
        n = [];
        for (var r = 0; r < t.rangeCount; r++) n.push(t.getRangeAt(r))
      } else n = y.doc.createRange ? [y.doc.createRange()] : [];
      return void 0 !== e ? n[e] : n
    }

    function _() {
      var e = E();
      try {
        e.removeAllRanges ? e.removeAllRanges() : e.empty ? e.empty() : e.clear && e.clear()
      } catch (t) {
      }
    }

    function p(e, t) {
      var n = e;
      return n.nodeType === Node.ELEMENT_NODE && 0 < n.childNodes.length && n.childNodes[t] && (n = n.childNodes[t]), n.nodeType === Node.TEXT_NODE && (n = n.parentNode), n
    }

    function w() {
      if (y.$wp) {
        y.markers.remove();
        var e, t, n = f(), r = [];
        for (t = 0; t < n.length; t++) if (n[t].startContainer !== y.doc || y.browser.msie) {
          var a = (e = n[t]).collapsed, o = y.markers.place(e, !0, t), i = y.markers.place(e, !1, t);
          if (void 0 !== o && o || !a || (L(".fr-marker").remove(), y.selection.setAtEnd(y.el)), y.el.normalize(), y.browser.safari && !a) try {
            (e = y.doc.createRange()).setStartAfter(o), e.setEndBefore(i), r.push(e)
          } catch (s) {
          }
        }
        if (y.browser.safari && r.length) for (y.selection.clear(), t = 0; t < r.length; t++) y.selection.get().addRange(r[t])
      }
    }

    function A() {
      var e, t = y.el.querySelectorAll('.fr-marker[data-type="true"]');
      if (!y.$wp) return y.markers.remove(), !1;
      if (0 === t.length) return !1;
      if (y.browser.msie || y.browser.edge) for (e = 0; e < t.length; e++) t[e].style.display = "inline-block";
      y.core.hasFocus() || y.browser.msie || y.browser.webkit || y.$el.focus(), _();
      var n = E();
      for (e = 0; e < t.length; e++) {
        var r = L(t[e]).data("id"), a = t[e], o = y.doc.createRange(),
          i = y.$el.find('.fr-marker[data-type="false"][data-id="'.concat(r, '"]'));
        (y.browser.msie || y.browser.edge) && i.css("display", "inline-block");
        var s = null;
        if (0 < i.length) {
          i = i[0];
          try {
            for (var l = !1, c = a.nextSibling, d = null; c && c.nodeType === Node.TEXT_NODE && 0 === c.textContent.length;) c = (d = c).nextSibling, L(d).remove();
            for (var f = i.nextSibling; f && f.nodeType === Node.TEXT_NODE && 0 === f.textContent.length;) f = (d = f).nextSibling, L(d).remove();
            if (a.nextSibling === i || i.nextSibling === a) {
              for (var p = a.nextSibling === i ? a : i, u = p === a ? i : a, h = p.previousSibling; h && h.nodeType === Node.TEXT_NODE && 0 === h.length;) h = (d = h).previousSibling, L(d).remove();
              if (h && h.nodeType === Node.TEXT_NODE) for (; h && h.previousSibling && h.previousSibling.nodeType === Node.TEXT_NODE;) h.previousSibling.textContent += h.textContent, h = h.previousSibling, L(h.nextSibling).remove();
              for (var g = u.nextSibling; g && g.nodeType === Node.TEXT_NODE && 0 === g.length;) g = (d = g).nextSibling, L(d).remove();
              if (g && g.nodeType === Node.TEXT_NODE) for (; g && g.nextSibling && g.nextSibling.nodeType === Node.TEXT_NODE;) g.nextSibling.textContent = g.textContent + g.nextSibling.textContent, g = g.nextSibling, L(g.previousSibling).remove();
              if (h && (y.node.isVoid(h) || y.node.isBlock(h)) && (h = null), g && (y.node.isVoid(g) || y.node.isBlock(g)) && (g = null), h && g && h.nodeType === Node.TEXT_NODE && g.nodeType === Node.TEXT_NODE) {
                L(a).remove(), L(i).remove();
                var m = h.textContent.length;
                h.textContent += g.textContent, L(g).remove(), y.spaces.normalize(h), o.setStart(h, m), o.setEnd(h, m), l = !0
              } else !h && g && g.nodeType === Node.TEXT_NODE ? (L(a).remove(), L(i).remove(), y.opts.htmlUntouched || y.spaces.normalize(g), s = L(y.doc.createTextNode("\u200b")).get(0), L(g).before(s), o.setStart(g, 0), o.setEnd(g, 0), l = !0) : !g && h && h.nodeType === Node.TEXT_NODE && (L(a).remove(), L(i).remove(), y.opts.htmlUntouched || y.spaces.normalize(h), s = L(y.doc.createTextNode("\u200b")).get(0), L(h).after(s), o.setStart(h, h.textContent.length), o.setEnd(h, h.textContent.length), l = !0)
            }
            if (!l) {
              var v = void 0, b = void 0;
              b = (y.browser.chrome || y.browser.edge) && a.nextSibling === i ? (v = T(i, o, !0) || o.setStartAfter(i), T(a, o, !1) || o.setEndBefore(a)) : (a.previousSibling === i && (i = (a = i).nextSibling), i.nextSibling && "BR" === i.nextSibling.tagName || !i.nextSibling && y.node.isBlock(a.previousSibling) || a.previousSibling && "BR" === a.previousSibling.tagName || (a.style.display = "inline", i.style.display = "inline", s = L(y.doc.createTextNode("\u200b")).get(0)), v = T(a, o, !0) || L(a).before(s) && o.setStartBefore(a), T(i, o, !1) || L(i).after(s) && o.setEndAfter(i)), "function" == typeof v && v(), "function" == typeof b && b()
            }
          } catch (C) {
          }
        }
        s && L(s).remove();
        try {
          n.addRange(o)
        } catch (C) {
        }
      }
      y.markers.remove()
    }

    function T(e, t, n) {
      var r, a = e.previousSibling, o = e.nextSibling;
      return a && o && a.nodeType === Node.TEXT_NODE && o.nodeType === Node.TEXT_NODE ? (r = a.textContent.length, n ? (o.textContent = a.textContent + o.textContent, L(a).remove(), L(e).remove(), y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setStart(o, r)
      }) : (a.textContent += o.textContent, L(o).remove(), L(e).remove(), y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setEnd(a, r)
      })) : a && !o && a.nodeType === Node.TEXT_NODE ? (r = a.textContent.length, n ? (y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setStart(a, r)
      }) : (y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setEnd(a, r)
      })) : !(!o || a || o.nodeType !== Node.TEXT_NODE) && (n ? (y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setStart(o, 0)
      }) : (y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setEnd(o, 0)
      }))
    }

    function S() {
      for (var e = f(), t = 0; t < e.length; t++) if (!e[t].collapsed) return !1;
      return !0
    }

    function a(e) {
      var t, n, r = !1, a = !1;
      if (y.win.getSelection) {
        var o = y.win.getSelection();
        o.rangeCount && ((n = (t = o.getRangeAt(0)).cloneRange()).selectNodeContents(e), n.setEnd(t.startContainer, t.startOffset), r = i(n), n.selectNodeContents(e), n.setStart(t.endContainer, t.endOffset), a = i(n))
      } else y.doc.selection && "Control" !== y.doc.selection.type && ((n = (t = y.doc.selection.createRange()).duplicate()).moveToElementText(e), n.setEndPoint("EndToStart", t), r = i(n), n.moveToElementText(e), n.setEndPoint("StartToEnd", t), a = i(n));
      return {atStart: r, atEnd: a}
    }

    function i(e) {
      return "" === e.toString().replace(/[\u200B-\u200D\uFEFF]/g, "")
    }

    function k(e, t) {
      void 0 === t && (t = !0);
      var n = L(e).html();
      n && n.replace(/\u200b/g, "").length !== n.length && L(e).html(n.replace(/\u200b/g, ""));
      for (var r = y.node.contents(e), a = 0; a < r.length; a++) r[a].nodeType !== Node.ELEMENT_NODE ? L(r[a]).remove() : (k(r[a], 0 === a), 0 === a && (t = !1));
      if (e.nodeType === Node.TEXT_NODE) {
        var o = L(document.createElement("span")).attr("data-first", "true").attr("data-text", "true");
        L(e)[0].replaceWith(o[0])
      } else t && L(e).attr("data-first", !0)
    }

    function x() {
      return 0 === L(this).find("fr-inner").length
    }

    function u() {
      try {
        if (!y.$wp) return !1;
        for (var e = f(0).commonAncestorContainer; e && !y.node.isElement(e);) e = e.parentNode;
        return !!y.node.isElement(e)
      } catch (t) {
        return !1
      }
    }

    function r(e, t) {
      if (!e || 0 < e.getElementsByClassName("fr-marker").length) return !1;
      for (var n = e.firstChild; n && (y.node.isBlock(n) || t && !y.node.isVoid(n) && n.nodeType === Node.ELEMENT_NODE);) n = (e = n).firstChild;
      e.innerHTML = xt.MARKERS + e.innerHTML
    }

    function o(e, t) {
      if (!e || 0 < e.getElementsByClassName("fr-marker").length) return !1;
      for (var n = e.lastChild; n && (y.node.isBlock(n) || t && !y.node.isVoid(n) && n.nodeType === Node.ELEMENT_NODE);) n = (e = n).lastChild;
      var r = y.doc.createElement("SPAN");
      for (r.setAttribute("id", "fr-sel-markers"), r.innerHTML = xt.MARKERS; e.parentNode && y.opts.htmlAllowedEmptyTags && 0 <= y.opts.htmlAllowedEmptyTags.indexOf(e.tagName.toLowerCase());) e = e.parentNode;
      e.appendChild(r);
      var a = e.querySelector("#fr-sel-markers");
      a.outerHTML = a.innerHTML
    }

    return {
      text: s, get: E, ranges: f, clear: _, element: function l() {
        var e = E();
        try {
          if (e.rangeCount) {
            var t, n = f(0), r = n.startContainer;
            if (y.node.isElement(r) && 0 === n.startOffset && r.childNodes.length) for (; r.childNodes.length && r.childNodes[0].nodeType === Node.ELEMENT_NODE;) r = r.childNodes[0];
            if (r.nodeType === Node.TEXT_NODE && n.startOffset === (r.textContent || "").length && r.nextSibling && (r = r.nextSibling), r.nodeType === Node.ELEMENT_NODE) {
              var a = !1;
              if (0 < r.childNodes.length && r.childNodes[n.startOffset]) {
                for (t = r.childNodes[n.startOffset]; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) t = t.nextSibling;
                if (t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0), !a && 1 < r.childNodes.length && 0 < n.startOffset && r.childNodes[n.startOffset - 1]) {
                  for (t = r.childNodes[n.startOffset - 1]; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) t = t.nextSibling;
                  t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0)
                }
              } else !n.collapsed && r.nextSibling && r.nextSibling.nodeType === Node.ELEMENT_NODE && (t = r.nextSibling) && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0);
              !a && 0 < r.childNodes.length && L(r.childNodes[0]).text().replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && ["BR", "IMG", "HR"].indexOf(r.childNodes[0].tagName) < 0 && (r = r.childNodes[0])
            }
            for (; r.nodeType !== Node.ELEMENT_NODE && r.parentNode;) r = r.parentNode;
            for (var o = r; o && "HTML" !== o.tagName;) {
              if (o === y.el) return r;
              o = L(o).parent()[0]
            }
          }
        } catch (i) {
        }
        return y.el
      }, endElement: function c() {
        var e = E();
        try {
          if (e.rangeCount) {
            var t, n = f(0), r = n.endContainer;
            if (r.nodeType === Node.ELEMENT_NODE) {
              var a = !1;
              0 < r.childNodes.length && r.childNodes[n.endOffset] && L(r.childNodes[n.endOffset]).text() === s() ? (r = r.childNodes[n.endOffset], a = !0) : !n.collapsed && r.previousSibling && r.previousSibling.nodeType === Node.ELEMENT_NODE ? (t = r.previousSibling) && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0) : !n.collapsed && 0 < r.childNodes.length && r.childNodes[n.endOffset] && (t = r.childNodes[n.endOffset].previousSibling).nodeType === Node.ELEMENT_NODE && t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0), !a && 0 < r.childNodes.length && L(r.childNodes[r.childNodes.length - 1]).text() === s() && ["BR", "IMG", "HR"].indexOf(r.childNodes[r.childNodes.length - 1].tagName) < 0 && (r = r.childNodes[r.childNodes.length - 1])
            }
            for (r.nodeType === Node.TEXT_NODE && 0 === n.endOffset && r.previousSibling && r.previousSibling.nodeType === Node.ELEMENT_NODE && (r = r.previousSibling); r.nodeType !== Node.ELEMENT_NODE && r.parentNode;) r = r.parentNode;
            for (var o = r; o && "HTML" !== o.tagName;) {
              if (o === y.el) return r;
              o = L(o).parent()[0]
            }
          }
        } catch (i) {
        }
        return y.el
      }, save: w, restore: A, isCollapsed: S, isFull: function d() {
        if (S()) return !1;
        y.selection.save();
        var e, t = y.el.querySelectorAll("td, th, img, br");
        for (e = 0; e < t.length; e++) (t[e].nextSibling || "IMG" === t[e].tagName) && (t[e].innerHTML = '<span class="fr-mk" style="display: none;">&nbsp;</span>'.concat(t[e].innerHTML));
        var n = !1, r = a(y.el);
        for (r.atStart && r.atEnd && (n = !0), t = y.el.querySelectorAll(".fr-mk"), e = 0; e < t.length; e++) t[e].parentNode.removeChild(t[e]);
        return y.selection.restore(), n
      }, inEditor: u, remove: function R() {
        if (S()) return !0;
        var e;

        function t(e) {
          for (var t = e.previousSibling; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) {
            var n = t;
            t = t.previousSibling, L(n).remove()
          }
          return t
        }

        function n(e) {
          for (var t = e.nextSibling; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) {
            var n = t;
            t = t.nextSibling, L(n).remove()
          }
          return t
        }

        w();
        var r = y.$el.find('.fr-marker[data-type="true"]');
        for (e = 0; e < r.length; e++) for (var a = r[e]; !(t(a) || y.node.isBlock(a.parentNode) || y.$el.is(a.parentNode) || y.node.hasClass(a.parentNode, "fr-inner"));) L(a.parentNode).before(a);
        var o = y.$el.find('.fr-marker[data-type="false"]');
        for (e = 0; e < o.length; e++) {
          for (var i = o[e]; !(n(i) || y.node.isBlock(i.parentNode) || y.$el.is(i.parentNode) || y.node.hasClass(i.parentNode, "fr-inner"));) L(i.parentNode).after(i);
          i.parentNode && y.node.isBlock(i.parentNode) && y.node.isEmpty(i.parentNode) && !y.$el.is(i.parentNode) && !y.node.hasClass(i.parentNode, "fr-inner") && y.opts.keepFormatOnDelete && L(i.parentNode).after(i)
        }
        if (function C() {
          for (var e = y.$el.find(".fr-marker"), t = 0; t < e.length; t++) if (L(e[t]).parentsUntil('.fr-element, [contenteditable="true"]', '[contenteditable="false"]').length) return !1;
          return !0
        }()) {
          !function E(e, t) {
            var n = y.node.contents(e.get(0));
            0 <= ["TD", "TH"].indexOf(e.get(0).tagName) && 1 === e.find(".fr-marker").length && (y.node.hasClass(n[0], "fr-marker") || "BR" == n[0].tagName && y.node.hasClass(n[0].nextElementSibling, "fr-marker")) && e.attr("data-del-cell", !0);
            for (var r = 0; r < n.length; r++) {
              var a = n[r];
              y.node.hasClass(a, "fr-marker") ? t = (t + 1) % 2 : t ? 0 < L(a).find(".fr-marker").length ? t = E(L(a), t) : ["TD", "TH"].indexOf(a.tagName) < 0 && !y.node.hasClass(a, "fr-inner") ? !y.opts.keepFormatOnDelete || 0 < y.$el.find("[data-first]").length || y.node.isVoid(a) ? L(a).remove() : k(a) : y.node.hasClass(a, "fr-inner") ? 0 === L(a).find(".fr-inner").length ? L(a).html("<br>") : L(a).find(".fr-inner").filter(x).html("<br>") : (L(a).empty(), L(a).attr("data-del-cell", !0)) : 0 < L(a).find(".fr-marker").length && (t = E(L(a), t))
            }
            return t
          }(y.$el, 0);
          var s = y.$el.find('[data-first="true"]');
          if (s.length) y.$el.find(".fr-marker").remove(), s.append(xt.INVISIBLE_SPACE + xt.MARKERS).removeAttr("data-first"), s.attr("data-text") && s.replaceWith(s.html()); else for (y.$el.find("table").filter(function () {
            return 0 < L(this).find("[data-del-cell]").length && L(this).find("[data-del-cell]").length === L(this).find("td, th").length
          }).remove(), y.$el.find("[data-del-cell]").removeAttr("data-del-cell"), r = y.$el.find('.fr-marker[data-type="true"]'), e = 0; e < r.length; e++) {
            var l = r[e], c = l.nextSibling,
              d = y.$el.find('.fr-marker[data-type="false"][data-id="'.concat(L(l).data("id"), '"]')).get(0);
            if (d) {
              if (l && (!c || c !== d)) {
                var f = y.node.blockParent(l), p = y.node.blockParent(d), u = !1, h = !1;
                if (f && 0 <= ["UL", "OL"].indexOf(f.tagName) && (u = !(f = null)), p && 0 <= ["UL", "OL"].indexOf(p.tagName) && (h = !(p = null)), L(l).after(d), f !== p) if (null !== f || u) if (null !== p || h || 0 !== L(f).parentsUntil(y.$el, "table").length) f && p && 0 === L(f).parentsUntil(y.$el, "table").length && 0 === L(p).parentsUntil(y.$el, "table").length && !L(f).contains(p) && !L(p).contains(f) && (L(f).append(L(p).html()), L(p).remove()); else {
                  for (c = f; !c.nextSibling && c.parentNode !== y.el;) c = c.parentNode;
                  for (c = c.nextSibling; c && "BR" !== c.tagName;) {
                    var g = c.nextSibling;
                    L(f).append(c), c = g
                  }
                  c && "BR" === c.tagName && L(c).remove()
                } else {
                  var m = y.node.deepestParent(l);
                  m ? (L(m).after(L(p).html()), L(p).remove()) : 0 === L(p).parentsUntil(y.$el, "table").length && (L(l).next().after(L(p).html()), L(p).remove())
                }
              }
            } else d = L(l).clone().attr("data-type", !1), L(l).after(d)
          }
        }
        y.$el.find("li:empty").remove(), y.opts.keepFormatOnDelete || y.html.fillEmptyBlocks(), y.html.cleanEmptyTags(!0), y.opts.htmlUntouched || (y.clean.lists(), y.$el.find("li:empty").append("<br>"), y.spaces.normalize());
        var v = y.$el.find(".fr-marker").last().get(0), b = y.$el.find(".fr-marker").first().get(0);
        void 0 !== v && void 0 !== b && !v.nextSibling && b.previousSibling && "BR" === b.previousSibling.tagName && y.node.isElement(v.parentNode) && y.node.isElement(b.parentNode) && y.$el.append("<br>"), A()
      }, blocks: function h(e) {
        var t, n, r = [], a = E();
        if (u() && a.rangeCount) {
          var o = f();
          for (t = 0; t < o.length; t++) {
            var i = o[t], s = p(i.startContainer, i.startOffset), l = p(i.endContainer, i.endOffset);
            (y.node.isBlock(s) || y.node.hasClass(s, "fr-inner")) && r.indexOf(s) < 0 && r.push(s), (n = y.node.blockParent(s)) && r.indexOf(n) < 0 && r.push(n);
            for (var c = [], d = s; d !== l && d !== y.el;) c.indexOf(d) < 0 && d.children && d.children.length ? (c.push(d), d = d.children[0]) : d.nextSibling ? d = d.nextSibling : d.parentNode && (d = d.parentNode, c.push(d)), y.node.isBlock(d) && c.indexOf(d) < 0 && r.indexOf(d) < 0 && (d !== l || 0 < i.endOffset) && r.push(d);
            y.node.isBlock(l) && r.indexOf(l) < 0 && 0 < i.endOffset && r.push(l), (n = y.node.blockParent(l)) && r.indexOf(n) < 0 && r.push(n)
          }
        }
        for (t = r.length - 1; 0 < t; t--) if (L(r[t]).find(r).length) {
          if (e && L(r[t]).find("ul, ol").length) continue;
          r.splice(t, 1)
        }
        return r
      }, info: a, setAtEnd: o, setAtStart: r, setBefore: function g(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.previousSibling; n && n.nodeType === Node.TEXT_NODE && 0 === n.textContent.length;) n = n.previousSibling;
        return n ? (y.node.isBlock(n) ? o(n) : "BR" === n.tagName ? L(n).before(xt.MARKERS) : L(n).after(xt.MARKERS), !0) : !!t && (y.node.isBlock(e) ? r(e) : L(e).before(xt.MARKERS), !0)
      }, setAfter: function m(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.nextSibling; n && n.nodeType === Node.TEXT_NODE && 0 === n.textContent.length;) n = n.nextSibling;
        return n ? (y.node.isBlock(n) ? r(n) : L(n).before(xt.MARKERS), !0) : !!t && (y.node.isBlock(e) ? o(e) : L(e).after(xt.MARKERS), !0)
      }, rangeElement: p
    }
  }, Object.assign(xt.DEFAULTS, {language: null}), xt.LANGUAGE = {}, xt.MODULES.language = function (e) {
    var t;
    return {
      _init: function n() {
        xt.LANGUAGE && (t = xt.LANGUAGE[e.opts.language]), t && t.direction && (e.opts.direction = t.direction)
      }, translate: function r(e) {
        return t && t.translation[e] && t.translation[e].length ? t.translation[e] : e
      }
    }
  }, Object.assign(xt.DEFAULTS, {placeholderText: "Type something"}), xt.MODULES.placeholder = function (f) {
    var p = f.$;

    function e() {
      f.$placeholder || function d() {
        f.$placeholder = p(f.doc.createElement("SPAN")).addClass("fr-placeholder"), f.$wp.append(f.$placeholder)
      }();
      var e = f.opts.iframe ? f.$iframe.prev().outerHeight(!0) : f.$el.prev().outerHeight(!0), t = 0, n = 0, r = 0,
        a = 0, o = 0, i = 0, s = f.node.contents(f.el), l = p(f.selection.element()).css("text-align");
      if (s.length && s[0].nodeType === Node.ELEMENT_NODE) {
        var c = p(s[0]);
        (0 < f.$wp.prev().length || 0 < f.$el.prev().length) && f.ready && (t = f.helpers.getPX(c.css("margin-top")), a = f.helpers.getPX(c.css("padding-top")), n = f.helpers.getPX(c.css("margin-left")), r = f.helpers.getPX(c.css("margin-right")), o = f.helpers.getPX(c.css("padding-left")), i = f.helpers.getPX(c.css("padding-right"))), f.$placeholder.css("font-size", c.css("font-size")), f.$placeholder.css("line-height", c.css("line-height"))
      } else f.$placeholder.css("font-size", f.$el.css("font-size")), f.$placeholder.css("line-height", f.$el.css("line-height"));
      f.$wp.addClass("show-placeholder"), f.$placeholder.css({
        marginTop: Math.max(f.helpers.getPX(f.$el.css("margin-top")), t) + (e || 0),
        paddingTop: Math.max(f.helpers.getPX(f.$el.css("padding-top")), a),
        paddingLeft: Math.max(f.helpers.getPX(f.$el.css("padding-left")), o),
        marginLeft: Math.max(f.helpers.getPX(f.$el.css("margin-left")), n),
        paddingRight: Math.max(f.helpers.getPX(f.$el.css("padding-right")), i),
        marginRight: Math.max(f.helpers.getPX(f.$el.css("margin-right")), r),
        textAlign: l
      }).text(f.language.translate(f.opts.placeholderText || f.$oel.attr("placeholder") || "")), f.$placeholder.html(f.$placeholder.text().replace(/\n/g, "<br>"))
    }

    function t() {
      f.$wp.removeClass("show-placeholder")
    }

    function n() {
      if (!f.$wp) return !1;
      f.core.isEmpty() ? e() : t()
    }

    return {
      _init: function r() {
        if (!f.$wp) return !1;
        f.events.on("init input keydown keyup contentChanged initialized", n)
      }, show: e, hide: t, refresh: n, isVisible: function a() {
        return !f.$wp || f.node.hasClass(f.$wp.get(0), "show-placeholder")
      }
    }
  }, xt.UNICODE_NBSP = String.fromCharCode(160), xt.VOID_ELEMENTS = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"], xt.BLOCK_TAGS = ["address", "article", "aside", "audio", "blockquote", "canvas", "details", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "li", "main", "nav", "noscript", "ol", "output", "p", "pre", "section", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul", "video"], Object.assign(xt.DEFAULTS, {
    htmlAllowedEmptyTags: ["textarea", "a", "iframe", "object", "video", "style", "script", ".fa", ".fr-emoticon", ".fr-inner", "path", "line", "hr"],
    htmlDoNotWrapTags: ["script", "style"],
    htmlSimpleAmpersand: !1,
    htmlIgnoreCSSProperties: [],
    htmlExecuteScripts: !0
  }), xt.MODULES.html = function (x) {
    var h = x.$;

    function d() {
      return x.opts.enter === xt.ENTER_P ? "p" : x.opts.enter === xt.ENTER_DIV ? "div" : x.opts.enter === xt.ENTER_BR ? "p" : void 0
    }

    function s(e, t) {
      return !(!e || e === x.el) && (t ? -1 != ["PRE", "SCRIPT", "STYLE"].indexOf(e.tagName) || s(e.parentNode, t) : -1 !== ["PRE", "SCRIPT", "STYLE"].indexOf(e.tagName))
    }

    function o(e) {
      var t, n = [], r = [];
      if (e) {
        var a = x.el.querySelectorAll(".fr-marker");
        for (t = 0; t < a.length; t++) {
          var o = x.node.blockParent(a[t]) || a[t];
          if (o) {
            var i = o.nextSibling, s = o.previousSibling;
            o && r.indexOf(o) < 0 && x.node.isBlock(o) && r.push(o), s && x.node.isBlock(s) && r.indexOf(s) < 0 && r.push(s), i && x.node.isBlock(i) && r.indexOf(i) < 0 && r.push(i)
          }
        }
      } else r = x.el.querySelectorAll(p());
      var l = p();
      for (l += ",".concat(xt.VOID_ELEMENTS.join(",")), l += ", .fr-inner", l += ",".concat(x.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)"), t = r.length - 1; 0 <= t; t--) if (!(r[t].textContent && 0 < r[t].textContent.replace(/\u200B|\n/g, "").length || 0 < r[t].querySelectorAll(l).length)) {
        for (var c = x.node.contents(r[t]), d = !1, f = 0; f < c.length; f++) if (c[f].nodeType !== Node.COMMENT_NODE && c[f].textContent && 0 < c[f].textContent.replace(/\u200B|\n/g, "").length) {
          d = !0;
          break
        }
        d || n.push(r[t])
      }
      return n
    }

    function p() {
      return xt.BLOCK_TAGS.join(", ")
    }

    function e(e) {
      var t, n, r = h.merge([], xt.VOID_ELEMENTS);
      r = h.merge(r, x.opts.htmlAllowedEmptyTags), r = void 0 === e ? h.merge(r, xt.BLOCK_TAGS) : h.merge(r, xt.NO_DELETE_TAGS), t = x.el.querySelectorAll("*:empty:not(".concat(r.join("):not("), "):not(.fr-marker):not(template)"));
      do {
        n = !1;
        for (var a = 0; a < t.length; a++) 0 !== t[a].attributes.length && void 0 === t[a].getAttribute("href") || (t[a].parentNode.removeChild(t[a]), n = !0);
        t = x.el.querySelectorAll("*:empty:not(".concat(r.join("):not("), "):not(.fr-marker):not(template)"))
      } while (t.length && n)
    }

    function i(e, t) {
      var n = d();
      if (t && (n = "div"), n) {
        for (var r = x.doc.createDocumentFragment(), a = null, o = !1, i = e.firstChild, s = !1; i;) {
          var l = i.nextSibling;
          if (i.nodeType === Node.ELEMENT_NODE && (x.node.isBlock(i) || 0 <= x.opts.htmlDoNotWrapTags.indexOf(i.tagName.toLowerCase()) && !x.node.hasClass(i, "fr-marker"))) a = null, r.appendChild(i.cloneNode(!0)); else if (i.nodeType !== Node.ELEMENT_NODE && i.nodeType !== Node.TEXT_NODE) a = null, r.appendChild(i.cloneNode(!0)); else if ("BR" === i.tagName) null === a ? (a = x.doc.createElement(n), s = !0, t && (a.setAttribute("class", "fr-temp-div"), a.setAttribute("data-empty", !0)), a.appendChild(i.cloneNode(!0)), r.appendChild(a)) : !1 === o && (a.appendChild(x.doc.createElement("br")), t && (a.setAttribute("class", "fr-temp-div"), a.setAttribute("data-empty", !0))), a = null; else {
            var c = i.textContent;
            i.nodeType !== Node.TEXT_NODE || 0 < c.replace(/\n/g, "").replace(/(^ *)|( *$)/g, "").length || c.replace(/(^ *)|( *$)/g, "").length && c.indexOf("\n") < 0 ? (null === a && (a = x.doc.createElement(n), s = !0, t && a.setAttribute("class", "fr-temp-div"), r.appendChild(a), o = !1), a.appendChild(i.cloneNode(!0)), o || x.node.hasClass(i, "fr-marker") || i.nodeType === Node.TEXT_NODE && 0 === c.replace(/ /g, "").length || (o = !0)) : s = !0
          }
          i = l
        }
        s && (e.innerHTML = "", e.appendChild(r))
      }
    }

    function l(e, t) {
      for (var n = e.length - 1; 0 <= n; n--) i(e[n], t)
    }

    function t(e, t, n, r, a) {
      if (!x.$wp) return !1;
      void 0 === e && (e = !1), void 0 === t && (t = !1), void 0 === n && (n = !1), void 0 === r && (r = !1), void 0 === a && (a = !1);
      var o = x.$wp.scrollTop();
      i(x.el, e), r && l(x.el.querySelectorAll(".fr-inner"), e), t && l(x.el.querySelectorAll("td, th"), e), n && l(x.el.querySelectorAll("blockquote"), e), a && l(x.el.querySelectorAll("li"), e), o !== x.$wp.scrollTop() && x.$wp.scrollTop(o)
    }

    function n(e) {
      if (void 0 === e && (e = x.el), e && 0 <= ["SCRIPT", "STYLE", "PRE"].indexOf(e.tagName)) return !1;
      for (var t = x.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, x.node.filter(function (e) {
        return null !== e.textContent.match(/([ \n]{2,})|(^[ \n]{1,})|([ \n]{1,}$)/g)
      }), !1); t.nextNode();) {
        var n = t.currentNode;
        if (!s(n.parentNode, !0)) {
          var r = x.node.isBlock(n.parentNode) || x.node.isElement(n.parentNode),
            a = n.textContent.replace(/(?!^)( ){2,}(?!$)/g, " ").replace(/\n/g, " ").replace(/^[ ]{2,}/g, " ").replace(/[ ]{2,}$/g, " ");
          if (r) {
            var o = n.previousSibling, i = n.nextSibling;
            o && i && " " === a ? a = x.node.isBlock(o) && x.node.isBlock(i) ? "" : " " : (o || (a = a.replace(/^ */, "")), i || (a = a.replace(/ *$/, "")))
          }
          n.textContent = a
        }
      }
    }

    function r(e, t, n) {
      var r = new RegExp(t, "gi").exec(e);
      return r ? r[n] : null
    }

    function R(e) {
      var t = e.doctype, n = "<!DOCTYPE html>";
      return t && (n = "<!DOCTYPE ".concat(t.name).concat(t.publicId ? ' PUBLIC "'.concat(t.publicId, '"') : "").concat(!t.publicId && t.systemId ? " SYSTEM" : "").concat(t.systemId ? ' "'.concat(t.systemId, '"') : "", ">")), n
    }

    function c(e) {
      var t = e.parentNode;
      if (t && (x.node.isBlock(t) || x.node.isElement(t)) && ["TD", "TH"].indexOf(t.tagName) < 0) {
        for (var n = e.previousSibling, r = e.nextSibling; n && (n.nodeType === Node.TEXT_NODE && 0 === n.textContent.replace(/\n|\r/g, "").length || x.node.hasClass(n, "fr-tmp"));) n = n.previousSibling;
        if (r) return !1;
        n && t && "BR" !== n.tagName && !x.node.isBlock(n) && !r && 0 < t.textContent.replace(/\u200B/g, "").length && 0 < n.textContent.length && !x.node.hasClass(n, "fr-marker") && (x.el === t && !r && x.opts.enter === xt.ENTER_BR && x.browser.msie || e.parentNode.removeChild(e))
      } else !t || x.node.isBlock(t) || x.node.isElement(t) || e.previousSibling || e.nextSibling || !x.node.isDeletable(e.parentNode) || c(e.parentNode)
    }

    function g() {
      x.opts.htmlUntouched || (e(), t(), n(), x.spaces.normalize(null, !0), x.html.fillEmptyBlocks(), x.clean.lists(), x.clean.tables(), x.clean.toHTML5(), x.html.cleanBRs()), x.selection.restore(), a(), x.placeholder.refresh()
    }

    function a() {
      x.node.isEmpty(x.el) && (null !== d() ? x.el.querySelector(p()) || x.el.querySelector("".concat(x.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || (x.core.hasFocus() ? (x.$el.html("<".concat(d(), ">").concat(xt.MARKERS, "<br/></").concat(d(), ">")), x.selection.restore()) : x.$el.html("<".concat(d(), "><br/></").concat(d(), ">"))) : x.el.querySelector("*:not(.fr-marker):not(br)") || (x.core.hasFocus() ? (x.$el.html("".concat(xt.MARKERS, "<br/>")), x.selection.restore()) : x.$el.html("<br/>")))
    }

    function m(e, t) {
      return r(e, "<".concat(t, "[^>]*?>([\\w\\W]*)</").concat(t, ">"), 1)
    }

    function v(e, t) {
      var n = h("<div ".concat(r(e, "<".concat(t, "([^>]*?)>"), 1) || "", ">"));
      return x.node.rawAttributes(n.get(0))
    }

    function b(e) {
      return (r(e, "<!DOCTYPE([^>]*?)>", 0) || "<!DOCTYPE html>").replace(/\n/g, " ").replace(/ {2,}/g, " ")
    }

    function C(e, t) {
      x.opts.htmlExecuteScripts ? e.html(t) : e.get(0).innerHTML = t
    }

    function M(e) {
      var t;
      (t = /:not\(([^)]*)\)/g).test(e) && (e = e.replace(t, "     $1 "));
      var n = 100 * (e.match(/(#[^\s+>~.[:]+)/g) || []).length + 10 * (e.match(/(\[[^]]+\])/g) || []).length + 10 * (e.match(/(\.[^\s+>~.[:]+)/g) || []).length + 10 * (e.match(/(:[\w-]+\([^)]*\))/gi) || []).length + 10 * (e.match(/(:[^\s+>~.[:]+)/g) || []).length + (e.match(/(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi) || []).length;
      return n += ((e = (e = e.replace(/[*\s+>~]/g, " ")).replace(/[#.]/g, " ")).match(/([^\s+>~.[:]+)/g) || []).length
    }

    function O(e) {
      if (x.events.trigger("html.processGet", [e]), e && e.getAttribute && "" === e.getAttribute("class") && e.removeAttribute("class"), e && e.getAttribute && "" === e.getAttribute("style") && e.removeAttribute("style"), e && e.nodeType === Node.ELEMENT_NODE) {
        var t, n = e.querySelectorAll('[class=""],[style=""]');
        for (t = 0; t < n.length; t++) {
          var r = n[t];
          "" === r.getAttribute("class") && r.removeAttribute("class"), "" === r.getAttribute("style") && r.removeAttribute("style")
        }
        if ("BR" === e.tagName) c(e); else {
          var a = e.querySelectorAll("br");
          for (t = 0; t < a.length; t++) c(a[t])
        }
      }
    }

    function N(e, t) {
      return e[3] - t[3]
    }

    function I() {
      for (var e = x.el.querySelectorAll("input, textarea"), t = 0; t < e.length; t++) "checkbox" !== e[t].type && "radio" !== e[t].type || (e[t].checked ? e[t].setAttribute("checked", e[t].checked) : x.$(e[t]).removeAttr("checked")), e[t].getAttribute("value") && e[t].setAttribute("value", e[t].value)
    }

    function f(e) {
      var t = x.doc.createElement("div");
      return t.innerHTML = e, null !== t.querySelector(p())
    }

    function u(e) {
      var t = null;
      if (void 0 === e && (t = x.selection.element()), x.opts.keepFormatOnDelete) return !1;
      var n, r, a = t ? (t.textContent.match(/\u200B/g) || []).length - t.querySelectorAll(".fr-marker").length : 0;
      if ((x.el.textContent.match(/\u200B/g) || []).length - x.el.querySelectorAll(".fr-marker").length === a) return !1;
      do {
        r = !1, n = x.el.querySelectorAll("*:not(.fr-marker)");
        for (var o = 0; o < n.length; o++) {
          var i = n[o];
          if (t !== i) {
            var s = i.textContent;
            0 === i.children.length && 1 === s.length && 8203 === s.charCodeAt(0) && "TD" !== i.tagName && (h(i).remove(), r = !0)
          }
        }
      } while (r)
    }

    function E() {
      u(), x.placeholder && setTimeout(x.placeholder.refresh, 0)
    }

    return {
      defaultTag: d, isPreformatted: s, emptyBlocks: o, emptyBlockTagsQuery: function y() {
        return "".concat(xt.BLOCK_TAGS.join(":empty, "), ":empty")
      }, blockTagsQuery: p, fillEmptyBlocks: function L(e) {
        var t = o(e);
        x.node.isEmpty(x.el) && x.opts.enter === xt.ENTER_BR && t.push(x.el);
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          "false" === r.getAttribute("contenteditable") || r.querySelector("".concat(x.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || x.node.isVoid(r) || "TABLE" !== r.tagName && "TBODY" !== r.tagName && "TR" !== r.tagName && "UL" !== r.tagName && "OL" !== r.tagName && r.appendChild(x.doc.createElement("br"))
        }
        if (x.browser.msie && x.opts.enter === xt.ENTER_BR) {
          var a = x.node.contents(x.el);
          a.length && a[a.length - 1].nodeType === Node.TEXT_NODE && x.$el.append("<br>")
        }
      }, cleanEmptyTags: e, cleanWhiteTags: u, cleanBlankSpaces: n, blocks: function _() {
        return x.$el.get(0).querySelectorAll(p())
      }, getDoctype: R, set: function w(e) {
        var t = x.clean.html((e || "").trim(), [], [], x.opts.fullPage), n = new RegExp("%3A//", "g"),
          r = t.replace(n, "://");
        if (x.opts.fullPage) {
          var a = m(r, "body") || (0 <= r.indexOf("<body") ? "" : r), o = v(r, "body"),
            i = m(r, "head") || "<title></title>", s = v(r, "head"), l = h("<div>");
          l.append(i).contents().each(function () {
            (this.nodeType === Node.COMMENT_NODE || 0 <= ["BASE", "LINK", "META", "NOSCRIPT", "SCRIPT", "STYLE", "TEMPLATE", "TITLE"].indexOf(this.tagName)) && this.parentNode.removeChild(this)
          });
          var c = l.html().trim();
          i = h("<div>").append(i).contents().map(function () {
            return this.nodeType === Node.COMMENT_NODE ? "\x3c!--".concat(this.nodeValue, "--\x3e") : 0 <= ["BASE", "LINK", "META", "NOSCRIPT", "SCRIPT", "STYLE", "TEMPLATE", "TITLE"].indexOf(this.tagName) ? this.outerHTML : ""
          }).toArray().join("");
          var d = b(r), f = v(r, "html");
          C(x.$el, "".concat(c, "\n").concat(a)), x.node.clearAttributes(x.el), x.$el.attr(o), x.$el.addClass("fr-view"), x.$el.attr("spellcheck", x.opts.spellcheck), x.$el.attr("dir", x.opts.direction), C(x.$head, i), x.node.clearAttributes(x.$head.get(0)), x.$head.attr(s), x.node.clearAttributes(x.$html.get(0)), x.$html.attr(f), x.iframe_document.doctype.parentNode.replaceChild(function u(e, t) {
            var n = e.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?"?([^"]*)"? ?"?([^"]*)"?>/i);
            return n ? t.implementation.createDocumentType(n[1], n[3], n[4]) : t.implementation.createDocumentType("html")
          }(d, x.iframe_document), x.iframe_document.doctype)
        } else C(x.$el, r);
        var p = x.edit.isDisabled();
        x.edit.on(), x.core.injectStyle(x.opts.iframeDefaultStyle + x.opts.iframeStyle), g(), x.opts.useClasses || (x.$el.find("[fr-original-class]").each(function () {
          this.setAttribute("class", this.getAttribute("fr-original-class")), this.removeAttribute("fr-original-class")
        }), x.$el.find("[fr-original-style]").each(function () {
          this.setAttribute("style", this.getAttribute("fr-original-style")), this.removeAttribute("fr-original-style")
        })), p && x.edit.off(), x.events.trigger("html.set"), x.events.trigger("charCounter.update")
      }, syncInputs: I, get: function D(e, t) {
        if (!x.$wp) return x.$oel.clone().removeClass("fr-view").removeAttr("contenteditable").get(0).outerHTML;
        var n = "";
        x.events.trigger("html.beforeGet");
        var r, a, o = [], i = {}, s = [];
        if (I(), !x.opts.useClasses && !t) {
          var l = new RegExp("^".concat(x.opts.htmlIgnoreCSSProperties.join("$|^"), "$"), "gi");
          for (r = 0; r < x.doc.styleSheets.length; r++) {
            var c = void 0, d = 0;
            try {
              c = x.doc.styleSheets[r].cssRules, x.doc.styleSheets[r].ownerNode && "STYLE" === x.doc.styleSheets[r].ownerNode.nodeType && (d = 1)
            } catch (k) {
            }
            if (c) for (var f = 0, p = c.length; f < p; f++) if (c[f].selectorText && 0 < c[f].style.cssText.length) {
              var u = c[f].selectorText.replace(/body |\.fr-view /g, "").replace(/::/g, ":"), h = void 0;
              try {
                h = x.el.querySelectorAll(u)
              } catch (k) {
                h = []
              }
              for (a = 0; a < h.length; a++) {
                !h[a].getAttribute("fr-original-style") && h[a].getAttribute("style") ? (h[a].setAttribute("fr-original-style", h[a].getAttribute("style")), o.push(h[a])) : h[a].getAttribute("fr-original-style") || (h[a].setAttribute("fr-original-style", ""), o.push(h[a])), i[h[a]] || (i[h[a]] = {});
                for (var g = 1e3 * d + M(c[f].selectorText), m = c[f].style.cssText.split(";"), v = 0; v < m.length; v++) {
                  var b = m[v].trim().split(":")[0];
                  if (b && !b.match(l) && (i[h[a]][b] || (i[h[a]][b] = 0) <= (h[a].getAttribute("fr-original-style") || "").indexOf("".concat(b, ":")) && (i[h[a]][b] = 1e4), g >= i[h[a]][b] && (i[h[a]][b] = g, m[v].trim().length))) {
                    var C = m[v].trim().split(":");
                    C.splice(0, 1), s.push([h[a], b.trim(), C.join(":").trim(), g])
                  }
                }
              }
            }
          }
          for (s.sort(N), r = 0; r < s.length; r++) {
            var E = s[r];
            E[0].style[E[1]] = E[2]
          }
          for (r = 0; r < o.length; r++) if (o[r].getAttribute("class") && (o[r].setAttribute("fr-original-class", o[r].getAttribute("class")), o[r].removeAttribute("class")), 0 < (o[r].getAttribute("fr-original-style") || "").trim().length) {
            var y = o[r].getAttribute("fr-original-style").split(";");
            for (a = 0; a < y.length; a++) if (0 < y[a].indexOf(":")) {
              var L = y[a].split(":"), _ = L[0];
              L.splice(0, 1), o[r].style[_.trim()] = L.join(":").trim()
            }
          }
        }
        if (x.node.isEmpty(x.el)) x.opts.fullPage && (n = R(x.iframe_document), n += "<html".concat(x.node.attributes(x.$html.get(0)), ">").concat(x.$html.find("head").get(0).outerHTML, "<body></body></html>")); else if (void 0 === e && (e = !1), x.opts.fullPage) {
          n = R(x.iframe_document), x.$el.removeClass("fr-view");
          var w = x.opts.heightMin, A = x.opts.height, T = x.opts.heightMax;
          x.opts.heightMin = null, x.opts.height = null, x.opts.heightMax = null, x.size.refresh(), n += "<html".concat(x.node.attributes(x.$html.get(0)), ">").concat(x.$html.html(), "</html>"), x.opts.heightMin = w, x.opts.height = A, x.opts.heightMax = T, x.size.refresh(), x.$el.addClass("fr-view")
        } else n = x.$el.html();
        if (!x.opts.useClasses && !t) for (r = 0; r < o.length; r++) o[r].getAttribute("fr-original-class") && (o[r].setAttribute("class", o[r].getAttribute("fr-original-class")), o[r].removeAttribute("fr-original-class")), null !== o[r].getAttribute("fr-original-style") && void 0 !== o[r].getAttribute("fr-original-style") ? (0 !== o[r].getAttribute("fr-original-style").length ? o[r].setAttribute("style", o[r].getAttribute("fr-original-style")) : o[r].removeAttribute("style"), o[r].removeAttribute("fr-original-style")) : o[r].removeAttribute("style");
        x.opts.fullPage && (n = (n = (n = (n = (n = (n = (n = (n = n.replace(/<style data-fr-style="true">(?:[\w\W]*?)<\/style>/g, "")).replace(/<link([^>]*)data-fr-style="true"([^>]*)>/g, "")).replace(/<style(?:[\w\W]*?)class="firebugResetStyles"(?:[\w\W]*?)>(?:[\w\W]*?)<\/style>/g, "")).replace(/<body((?:[\w\W]*?)) spellcheck="true"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$2>$3</body>")).replace(/<body((?:[\w\W]*?)) contenteditable="(true|false)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?)) dir="([\w]*)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?))class="([\w\W]*?)(fr-rtl|fr-ltr)([\w\W]*?)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1class="$2$4"$5>$6</body>')).replace(/<body((?:[\w\W]*?)) class=""((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$2>$3</body>")), x.opts.htmlSimpleAmpersand && (n = n.replace(/&amp;/gi, "&")), x.events.trigger("html.afterGet"), e || (n = n.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, "")), n = x.clean.invisibleSpaces(n), n = x.clean.exec(n, O);
        var S = x.events.chainTrigger("html.get", n);
        return "string" == typeof S && (n = S), n = (n = n.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (e) {
          return e.replace(/<br>/g, "\n")
        })).replace(/<meta((?:[\w\W]*?)) data-fr-http-equiv="/g, '<meta$1 http-equiv="')
      }, getSelected: function A() {
        function e(e, t) {
          for (; t && (t.nodeType === Node.TEXT_NODE || !x.node.isBlock(t)) && !x.node.isElement(t) && !x.node.hasClass(t, "fr-inner");) t && t.nodeType !== Node.TEXT_NODE && h(e).wrapInner(x.node.openTagString(t) + x.node.closeTagString(t)), t = t.parentNode;
          t && e.innerHTML === t.innerHTML ? e.innerHTML = t.outerHTML : -1 != t.innerText.indexOf(e.innerHTML) && (e.innerHTML = x.node.openTagString(t) + t.innerHTML + x.node.closeTagString(t))
        }

        var t, n, r = "";
        if ("undefined" != typeof x.win.getSelection) {
          x.browser.mozilla && (x.selection.save(), 1 < x.$el.find('.fr-marker[data-type="false"]').length && (x.$el.find('.fr-marker[data-type="false"][data-id="0"]').remove(), x.$el.find('.fr-marker[data-type="false"]:last').attr("data-id", "0"), x.$el.find(".fr-marker").not('[data-id="0"]').remove()), x.selection.restore());
          for (var a = x.selection.ranges(), o = 0; o < a.length; o++) {
            var i = document.createElement("div");
            i.appendChild(a[o].cloneContents()), e(i, (n = t = void 0, n = null, x.win.getSelection ? (t = x.win.getSelection()) && t.rangeCount && (n = t.getRangeAt(0).commonAncestorContainer).nodeType !== Node.ELEMENT_NODE && (n = n.parentNode) : (t = x.doc.selection) && "Control" !== t.type && (n = t.createRange().parentElement()), null !== n && (0 <= h(n).parents().toArray().indexOf(x.el) || n === x.el) ? n : null)), 0 < h(i).find(".fr-element").length && (i = x.el), r += i.innerHTML
          }
        } else "undefined" != typeof x.doc.selection && "Text" === x.doc.selection.type && (r = x.doc.selection.createRange().htmlText);
        return r
      }, insert: function T(e, t, n) {
        var r;
        if (x.selection.isCollapsed() || x.selection.remove(), r = t ? e : x.clean.html(e), 0 === e.indexOf('<i class="fa ') && (r = "<span>&nbsp;".concat(r, "</span>")), e.indexOf('class="fr-marker"') < 0 && (r = function i(e) {
          var t = x.doc.createElement("div");
          return t.innerHTML = e, x.selection.setAtEnd(t, !0), t.innerHTML
        }(r)), x.node.isEmpty(x.el) && !x.opts.keepFormatOnDelete && f(r)) x.opts.trackChangesEnabled ? x.track_changes.pasteInEmptyEdior(r) : x.el.innerHTML = r; else {
          var a = x.markers.insert();
          if (a) if (x.opts.trackChangesEnabled) x.track_changes.pasteInEdior(r); else {
            x.node.isLastSibling(a) && h(a).parent().hasClass("fr-deletable") && h(a).insertAfter(h(a).parent());
            var o = x.node.blockParent(a);
            if ((f(r) || n) && (x.node.deepestParent(a) || o && "LI" === o.tagName)) {
              if (o && "LI" === o.tagName && (r = function s(e) {
                if (!x.html.defaultTag()) return e;
                var t = x.doc.createElement("div");
                t.innerHTML = e;
                for (var n = t.querySelectorAll(":scope > ".concat(x.html.defaultTag())), r = n.length - 1; 0 <= r; r--) {
                  var a = n[r];
                  x.node.isBlock(a.previousSibling) || (a.previousSibling && !x.node.isEmpty(a) && h("<br>").insertAfter(a.previousSibling), a.outerHTML = a.innerHTML)
                }
                return t.innerHTML
              }(r)), !(a = x.markers.split())) return !1;
              a.outerHTML = r
            } else a.outerHTML = r
          } else x.el.innerHTML += r
        }
        g(), x.keys.positionCaret(), x.events.trigger("html.inserted")
      }, wrap: t, unwrap: function S() {
        x.$el.find("div.fr-temp-div").each(function () {
          this.previousSibling && this.previousSibling.nodeType === Node.TEXT_NODE && h(this).before("<br>"), h(this).attr("data-empty") || !this.nextSibling || x.node.isBlock(this.nextSibling) && !h(this.nextSibling).hasClass("fr-temp-div") ? h(this).replaceWith(h(this).html()) : h(this).replaceWith("".concat(h(this).html(), "<br>"))
        }), x.$el.find(".fr-temp-div").removeClass("fr-temp-div").filter(function () {
          return "" === h(this).attr("class")
        }).removeAttr("class")
      }, escapeEntities: function k(e) {
        return e.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/"/gi, "&quot;").replace(/'/gi, "&#39;")
      }, checkIfEmpty: a, extractNode: m, extractNodeAttrs: v, extractDoctype: b, cleanBRs: function B() {
        for (var e = x.el.getElementsByTagName("br"), t = 0; t < e.length; t++) c(e[t])
      }, _init: function H() {
        x.events.$on(x.$el, "mousemove", "span.fr-word-select", function (e) {
          var t = window.getSelection();
          t = window.getSelection();
          var n = document.createRange();
          n.selectNodeContents(e.target), t.removeAllRanges(), t.addRange(n)
        }), x.$wp && (x.events.on("mouseup", E), x.events.on("keydown", E), x.events.on("contentChanged", a))
      }, _setHtml: C
    }
  }, xt.ENTER_P = 0, xt.ENTER_DIV = 1, xt.ENTER_BR = 2, xt.KEYCODE = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    FF_SEMICOLON: 59,
    FF_EQUALS: 61,
    QUESTION_MARK: 63,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    FF_HYPHEN: 173,
    SEMICOLON: 186,
    DASH: 189,
    EQUALS: 187,
    COMMA: 188,
    HYPHEN: 189,
    PERIOD: 190,
    SLASH: 191,
    APOSTROPHE: 192,
    TILDE: 192,
    SINGLE_QUOTE: 222,
    OPEN_SQUARE_BRACKET: 219,
    BACKSLASH: 220,
    CLOSE_SQUARE_BRACKET: 221,
    IME: 229
  }, Object.assign(xt.DEFAULTS, {enter: xt.ENTER_P, multiLine: !0, tabSpaces: 0}), xt.MODULES.keys = function (d) {
    var f, n, r, a = d.$, p = !1;

    function u(e) {
      if (d.selection.isCollapsed()) if (["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && d.cursor.backspace(), d.helpers.isIOS()) {
        var t = d.selection.ranges(0);
        t.deleteContents(), t.insertNode(document.createTextNode("\u200b")), d.selection.get().modify("move", "forward", "character")
      } else ["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && e.preventDefault(), e.stopPropagation(); else e.preventDefault(), e.stopPropagation(), d.selection.remove();
      d.placeholder.refresh()
    }

    function h(e) {
      ["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && e.preventDefault(), e.stopPropagation(), "" !== d.selection.text() || d.selection.element().hasAttribute("contenteditable") && "false" === d.selection.element().getAttribute("contenteditable") || !d.selection.isCollapsed() && "IMG" == d.selection.element().tagName ? d.selection.remove() : d.cursor.del(), d.placeholder.refresh()
    }

    function e() {
      if (d.browser.mozilla && d.selection.isCollapsed() && !p) {
        var e = d.selection.ranges(0), t = e.startContainer, n = e.startOffset;
        t && t.nodeType === Node.TEXT_NODE && n <= t.textContent.length && 0 < n && 32 === t.textContent.charCodeAt(n - 1) && (d.selection.save(), d.spaces.normalize(), d.selection.restore())
      }
    }

    function t() {
      d.selection.isFull() && setTimeout(function () {
        var e = d.html.defaultTag();
        e ? d.$el.html("<".concat(e, ">").concat(xt.MARKERS, "<br/></").concat(e, ">")) : d.$el.html("".concat(xt.MARKERS, "<br/>")), d.selection.restore(), d.placeholder.refresh(), d.button.bulkRefresh(), d.undo.saveStep()
      }, 0)
    }

    function o() {
      p = !1
    }

    function i() {
      p = !1
    }

    function g() {
      var e = d.html.defaultTag();
      e ? d.$el.html("<".concat(e, ">").concat(xt.MARKERS, "<br/></").concat(e, ">")) : d.$el.html("".concat(xt.MARKERS, "<br/>")), d.selection.restore()
    }

    function m(e, t) {
      if (e.parentElement && (-1 < e.innerHTML.indexOf("<span") || -1 < e.parentElement.innerHTML.indexOf("<span") || -1 < e.parentElement.parentElement.innerHTML.indexOf("<span")) && (e.classList.contains("fr-img-space-wrap") || e.parentElement.classList.contains("fr-img-space-wrap") || e.parentElement.parentElement.classList.contains("fr-img-space-wrap"))) {
        if (a(e.parentElement).is("p")) {
          var n = e.parentElement.innerHTML;
          return (n = n.replace(/<br>/g, "")).length < 1 ? e.parentElement.insertAdjacentHTML("afterbegin", "&nbsp;") : "&nbsp;" != n && " " != n && "Backspace" == t.key ? u(t) : "&nbsp;" != n && " " != n && "Delete" == t.key && h(t), !0
        }
        if (a(e).is("p")) {
          var r = e.innerHTML.replace(/<br>/g, "");
          return r.length < 1 ? e.insertAdjacentHTML("afterbegin", "&nbsp;") : "&nbsp;" != r && " " != r && "Backspace" == t.key ? u(t) : "&nbsp;" != r && " " != r && "Delete" == t.key && h(t), !0
        }
      }
      return !1
    }

    function s(e) {
      var t = d.selection.element();
      if (t && 0 <= ["INPUT", "TEXTAREA"].indexOf(t.tagName)) return !0;
      if (e && b(e.which)) return !0;
      d.events.disableBlur();
      var n = e.which;
      if (16 === n) return !0;
      if ((f = n) === xt.KEYCODE.IME) return p = !0;
      if (p = !1, v(e)) return !0;
      var r = C(n) && !v(e) && !e.altKey, a = n === xt.KEYCODE.BACKSPACE || n === xt.KEYCODE.DELETE;
      if ((d.selection.isFull() && !d.opts.keepFormatOnDelete && !d.placeholder.isVisible() || a && d.placeholder.isVisible() && d.opts.keepFormatOnDelete) && (r || a) && (g(), !C(n))) return e.preventDefault(), !0;
      if (n === xt.KEYCODE.ENTER) !d.helpers.isIOS() && e.shiftKey || t.classList.contains("fr-inner") || t.parentElement.classList.contains("fr-inner") ? function o(e) {
        e.preventDefault(), e.stopPropagation(), d.opts.multiLine && (d.selection.isCollapsed() || d.selection.remove(), d.cursor.enter(!0))
      }(e) : function i(e) {
        d.opts.multiLine ? (d.helpers.isIOS() || (e.preventDefault(), e.stopPropagation()), d.selection.isCollapsed() || d.selection.remove(), d.cursor.enter()) : (e.preventDefault(), e.stopPropagation())
      }(e); else if (n === xt.KEYCODE.BACKSPACE && (e.metaKey || e.ctrlKey)) !function s() {
        setTimeout(function () {
          d.events.disableBlur(), d.events.focus()
        }, 0)
      }(); else if (n !== xt.KEYCODE.BACKSPACE || v(e) || e.altKey) if (n !== xt.KEYCODE.DELETE || v(e) || e.altKey || e.shiftKey) n === xt.KEYCODE.SPACE ? function l(e) {
        var t = d.selection.element();
        if (!d.helpers.isMobile() && t && "A" === t.tagName) {
          e.preventDefault(), e.stopPropagation(), d.selection.isCollapsed() || d.selection.remove();
          var n = d.markers.insert();
          if (n) {
            var r = n.previousSibling;
            !n.nextSibling && n.parentNode && "A" === n.parentNode.tagName ? (n.parentNode.insertAdjacentHTML("afterend", "&nbsp;".concat(xt.MARKERS)), n.parentNode.removeChild(n)) : (r && r.nodeType === Node.TEXT_NODE && 1 === r.textContent.length && 160 === r.textContent.charCodeAt(0) ? r.textContent += " " : n.insertAdjacentHTML("beforebegin", "&nbsp;"), n.outerHTML = xt.MARKERS), d.selection.restore()
          }
        }
      }(e) : n === xt.KEYCODE.TAB ? function c(e) {
        if (0 < d.opts.tabSpaces) if (d.selection.isCollapsed()) {
          d.undo.saveStep(), e.preventDefault(), e.stopPropagation();
          for (var t = "", n = 0; n < d.opts.tabSpaces; n++) t += "&nbsp;";
          d.html.insert(t), d.placeholder.refresh(), d.undo.saveStep()
        } else e.preventDefault(), e.stopPropagation(), e.shiftKey ? d.commands.outdent() : d.commands.indent()
      }(e) : v(e) || !C(e.which) || d.selection.isCollapsed() || e.ctrlKey || e.altKey || d.selection.remove(); else {
        if (m(t, e)) return e.preventDefault(), void e.stopPropagation();
        d.placeholder.isVisible() ? (d.opts.keepFormatOnDelete || g(), e.preventDefault(), e.stopPropagation()) : h(e)
      } else {
        if (m(t, e)) return e.preventDefault(), void e.stopPropagation();
        d.placeholder.isVisible() ? (d.opts.keepFormatOnDelete || g(), e.preventDefault(), e.stopPropagation()) : u(e)
      }
      d.events.enableBlur()
    }

    function l() {
      if (!d.$wp) return !0;
      var e;
      d.opts.height || d.opts.heightMax ? (e = d.position.getBoundingRect().top, (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top), e > d.$wp.offset().top - d.helpers.scrollTop() + d.$wp.height() - 20 && d.$wp.scrollTop(e + d.$wp.scrollTop() - (d.$wp.height() + d.$wp.offset().top) + d.helpers.scrollTop() + 20)) : (e = d.position.getBoundingRect().top, d.opts.toolbarBottom && (e += d.opts.toolbarStickyOffset), (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top, e -= d.helpers.scrollTop()), (e += d.opts.toolbarStickyOffset) > d.o_win.innerHeight - 20 && a(d.o_win).scrollTop(e + d.helpers.scrollTop() - d.o_win.innerHeight + 20), e = d.position.getBoundingRect().top, d.opts.toolbarBottom || (e -= d.opts.toolbarStickyOffset), (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top, e -= d.helpers.scrollTop()), e < 100 && a(d.o_win).scrollTop(e + d.helpers.scrollTop() - 100))
    }

    function c(e) {
      var t = d.selection.element();
      if (t && 0 <= ["INPUT", "TEXTAREA"].indexOf(t.tagName)) return !0;
      if (e && 0 === e.which && f && (e.which = f), d.helpers.isAndroid() && d.browser.mozilla) return !0;
      if (p) return !1;
      if (e && d.helpers.isIOS() && e.which === xt.KEYCODE.ENTER && d.doc.execCommand("undo"), !d.selection.isCollapsed()) return !0;
      if (e && (e.which === xt.KEYCODE.META || e.which === xt.KEYCODE.CTRL)) return !0;
      if (e && b(e.which)) return !0;
      if (e && !d.helpers.isIOS() && (e.which === xt.KEYCODE.ENTER || e.which === xt.KEYCODE.BACKSPACE || 37 <= e.which && e.which <= 40 && !d.browser.msie)) try {
        l()
      } catch (r) {
      }
      var n = d.selection.element();
      (function a(e) {
        if (!e) return !1;
        var t = e.innerHTML;
        return !!((t = t.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, "")) && /\u200B/.test(t) && 0 < t.replace(/\u200B/gi, "").length)
      })(n) && !d.node.hasClass(n, "fr-marker") && "IFRAME" !== n.tagName && function o(e) {
        return !d.helpers.isIOS() || 0 === ((e.textContent || "").match(/[\u3041-\u3096\u30A0-\u30FF\u4E00-\u9FFF\u3130-\u318F\uAC00-\uD7AF]/gi) || []).length
      }(n) && (d.selection.save(), function i(e) {
        for (var t = d.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, d.node.filter(function (e) {
          return /\u200B/gi.test(e.textContent)
        }), !1); t.nextNode();) {
          var n = t.currentNode;
          n.textContent = n.textContent.replace(/\u200B/gi, "")
        }
      }(n), d.selection.restore())
    }

    function v(e) {
      if (-1 !== navigator.userAgent.indexOf("Mac OS X")) {
        if (e.metaKey && !e.altKey) return !0
      } else if (e.ctrlKey && !e.altKey) return !0;
      return !1
    }

    function b(e) {
      if (e >= xt.KEYCODE.ARROW_LEFT && e <= xt.KEYCODE.ARROW_DOWN) return !0
    }

    function C(e) {
      if (e >= xt.KEYCODE.ZERO && e <= xt.KEYCODE.NINE) return !0;
      if (e >= xt.KEYCODE.NUM_ZERO && e <= xt.KEYCODE.NUM_MULTIPLY) return !0;
      if (e >= xt.KEYCODE.A && e <= xt.KEYCODE.Z) return !0;
      if (d.browser.webkit && 0 === e) return !0;
      switch (e) {
        case xt.KEYCODE.SPACE:
        case xt.KEYCODE.QUESTION_MARK:
        case xt.KEYCODE.NUM_PLUS:
        case xt.KEYCODE.NUM_MINUS:
        case xt.KEYCODE.NUM_PERIOD:
        case xt.KEYCODE.NUM_DIVISION:
        case xt.KEYCODE.SEMICOLON:
        case xt.KEYCODE.FF_SEMICOLON:
        case xt.KEYCODE.DASH:
        case xt.KEYCODE.EQUALS:
        case xt.KEYCODE.FF_EQUALS:
        case xt.KEYCODE.COMMA:
        case xt.KEYCODE.PERIOD:
        case xt.KEYCODE.SLASH:
        case xt.KEYCODE.APOSTROPHE:
        case xt.KEYCODE.SINGLE_QUOTE:
        case xt.KEYCODE.OPEN_SQUARE_BRACKET:
        case xt.KEYCODE.BACKSLASH:
        case xt.KEYCODE.CLOSE_SQUARE_BRACKET:
          return !0;
        default:
          return !1
      }
    }

    function E(e) {
      var t = e.which;
      if (v(e) || 37 <= t && t <= 40 || !C(t) && t !== xt.KEYCODE.DELETE && t !== xt.KEYCODE.BACKSPACE && t !== xt.KEYCODE.ENTER && t !== xt.KEYCODE.IME) return !0;
      n || (r = d.snapshot.get(), d.undo.canDo() || d.undo.saveStep()), clearTimeout(n), n = setTimeout(function () {
        n = null, d.undo.saveStep()
      }, Math.max(250, d.opts.typingTimer))
    }

    function y(e) {
      var t = e.which;
      if (v(e) || 37 <= t && t <= 40) return !0;
      r && n ? (d.undo.saveStep(r), r = null) : void 0 !== t && 0 !== t || r || n || d.undo.saveStep()
    }

    function L(e) {
      if (e && "BR" === e.tagName) return !1;
      try {
        return 0 === (e.textContent || "").length && e.querySelector && !e.querySelector(":scope > br") || e.childNodes && 1 === e.childNodes.length && e.childNodes[0].getAttribute && ("false" === e.childNodes[0].getAttribute("contenteditable") || d.node.hasClass(e.childNodes[0], "fr-img-caption"))
      } catch (t) {
        return !1
      }
    }

    function _(e) {
      var t = d.el.childNodes, n = d.html.defaultTag(), r = d.node.blockParent(d.selection.blocks()[0]);
      return r && "TR" == r.tagName && r.getAttribute("contenteditable") == undefined && (r = r.closest("table")), !d.node.isEditable(e.target) || r && "false" === r.getAttribute("contenteditable") ? d.toolbar.disable() : d.toolbar.enable(), !(!e.target || e.target === d.el) || (0 === t.length || void (t[0].offsetHeight + t[0].offsetTop <= e.offsetY ? L(t[t.length - 1]) && (n ? d.$el.append("<".concat(n, ">").concat(xt.MARKERS, "<br></").concat(n, ">")) : d.$el.append("".concat(xt.MARKERS, "<br>")), d.selection.restore(), l()) : e.offsetY <= 10 && L(t[0]) && (n ? d.$el.prepend("<".concat(n, ">").concat(xt.MARKERS, "<br></").concat(n, ">")) : d.$el.prepend("".concat(xt.MARKERS, "<br>")), d.selection.restore(), l())))
    }

    function w() {
      n && clearTimeout(n)
    }

    return {
      _init: function A() {
        d.events.on("keydown", E), d.events.on("input", e), d.events.on("mousedown", i), d.events.on("keyup input", y), d.events.on("keypress", o), d.events.on("keydown", s), d.events.on("keyup", c), d.events.on("destroy", w), d.events.on("html.inserted", c), d.events.on("cut", t), d.opts.multiLine && d.events.on("click", _)
      }, ctrlKey: v, isCharacter: C, isArrow: b, forceUndo: function T() {
        n && (clearTimeout(n), d.undo.saveStep(), r = null)
      }, isIME: function S() {
        return p
      }, isBrowserAction: function k(e) {
        var t = e.which;
        return v(e) || t === xt.KEYCODE.F5
      }, positionCaret: l
    }
  }, Object.assign(xt.DEFAULTS, {
    pastePlain: !1,
    pasteDeniedTags: ["colgroup", "col", "meta"],
    pasteDeniedAttrs: ["class", "id"],
    pasteAllowedStyleProps: [".*"],
    pasteAllowLocalImages: !1
  }), xt.MODULES.paste = function (S) {
    var i, s, k, o, x, R = S.$;

    function n(e, t) {
      try {
        S.win.localStorage.setItem("fr-copied-html", e), S.win.localStorage.setItem("fr-copied-text", t)
      } catch (n) {
      }
    }

    function e(e) {
      var t = S.html.getSelected();
      n(t, R(S.doc.createElement("div")).html(t).text()), "cut" === e.type && (S.undo.saveStep(), setTimeout(function () {
        S.selection.save(), S.html.wrap(), S.selection.restore(), S.events.focus(), S.undo.saveStep()
      }, 0))
    }

    var l = !1;

    function t(e) {
      if ("INPUT" === e.target.nodeName && "text" === e.target.type) return !0;
      if (S.edit.isDisabled()) return !1;
      if (c(e.target)) return !1;
      if (l) return !1;
      if ((e.originalEvent && (e = e.originalEvent), e && e.clipboardData && e.clipboardData.getData) && ((e.clipboardData || window.clipboardData).getData("text/html") || "").match('content="Microsoft OneNote')) return !1;
      if (!1 === S.events.trigger("paste.before", [e])) return e.preventDefault(), !1;
      if (e && e.clipboardData && e.clipboardData.getData) {
        var t = "", n = e.clipboardData.types;
        if (S.helpers.isArray(n)) for (var r = 0; r < n.length; r++) t += "".concat(n[r], ";"); else t = n;
        if (i = "", /text\/rtf/.test(t) && (s = e.clipboardData.getData("text/rtf")), /text\/html/.test(t) && !S.browser.safari ? i = e.clipboardData.getData("text/html") : /text\/rtf/.test(t) && S.browser.safari ? i = s : /public.rtf/.test(t) && S.browser.safari && (i = e.clipboardData.getData("text/rtf")), k = e.clipboardData.getData("text"), "" !== i) return d(), e.preventDefault && (e.stopPropagation(), e.preventDefault()), !1;
        i = null
      }
      return function a() {
        S.selection.save(), S.events.disableBlur(), i = null, o ? (o.html(""), S.browser.edge && S.opts.iframe && S.$el.append(o)) : (o = R('<div contenteditable="true" style="position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>'), S.browser.webkit || S.browser.mozilla ? (o.css("top", S.$sc.scrollTop()), S.$el.after(o)) : S.browser.edge && S.opts.iframe ? S.$el.append(o) : S.$box.after(o), S.events.on("destroy", function () {
          o.remove()
        }));
        var e;
        S.helpers.isIOS() && S.$sc && (e = S.$sc.scrollTop());
        S.opts.iframe && S.$el.attr("contenteditable", "false");
        o.focus(), S.helpers.isIOS() && S.$sc && S.$sc.scrollTop(e);
        S.win.setTimeout(d, 1)
      }(), !1
    }

    function c(e) {
      return e && "false" === e.contentEditable
    }

    function r(e) {
      if (e.originalEvent && (e = e.originalEvent), c(e.target)) return !1;
      if (e && e.dataTransfer && e.dataTransfer.getData) {
        var t = "", n = e.dataTransfer.types;
        if (S.helpers.isArray(n)) for (var r = 0; r < n.length; r++) t += "".concat(n[r], ";"); else t = n;
        if (i = "", /text\/rtf/.test(t) && (s = e.dataTransfer.getData("text/rtf")), /text\/html/.test(t) ? i = e.dataTransfer.getData("text/html") : /text\/rtf/.test(t) && S.browser.safari ? i = s : /text\/plain/.test(t) && !this.browser.mozilla && (i = S.html.escapeEntities(e.dataTransfer.getData("text/plain")).replace(/\n/g, "<br>")), "" !== i) {
          S.keys.forceUndo(), x = S.snapshot.get(), S.selection.save(), S.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-helper");
          var a = S.markers.insertAtPoint(e);
          if (S.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-placeholder"), S.$el.find(".fr-marker-helper").addClass("fr-marker").removeClass("fr-marker-helper"), S.selection.restore(), S.selection.remove(), S.$el.find(".fr-marker-placeholder").addClass("fr-marker").removeClass("fr-marker-placeholder"), !1 !== a) {
            var o = S.el.querySelector(".fr-marker");
            return R(o).replaceWith(xt.MARKERS), S.selection.restore(), d(), e.preventDefault && (e.stopPropagation(), e.preventDefault()), !1
          }
        } else i = null
      }
    }

    function d() {
      S.opts.iframe && S.$el.attr("contenteditable", "true"), S.browser.edge && S.opts.iframe && S.$box.after(o), x || (S.keys.forceUndo(), x = S.snapshot.get()), i || (i = o.get(0).innerHTML, k = o.text(), S.selection.restore(), S.events.enableBlur());
      var e = i.match(/(class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi),
        t = S.events.chainTrigger("paste.beforeCleanup", i);
      t && "string" == typeof t && (i = t), (!e || e && !1 !== S.events.trigger("paste.wordPaste", [i])) && a(i, e)
    }

    function M(e) {
      for (var t = "", n = 0; n++ < e;) t += "&nbsp;";
      return t
    }

    function a(e, t, n) {
      var r, a = null, o = null;
      if (0 <= e.toLowerCase().indexOf("<body")) {
        var i = "";
        0 <= e.indexOf("<style") && (i = e.replace(/[.\s\S\w\W<>]*(<style[^>]*>[\s]*[.\s\S\w\W<>]*[\s]*<\/style>)[.\s\S\w\W<>]*/gi, "$1")), e = (e = (e = i + e.replace(/[.\s\S\w\W<>]*<body[^>]*>[\s]*([.\s\S\w\W<>]*)[\s]*<\/body>[.\s\S\w\W<>]*/gi, "$1")).replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (e) {
          return e.replace(/\n/g, "<br />")
        })).replace(/ \n/g, " ").replace(/\n /g, " ").replace(/([^>])\n([^<])/g, "$1 $2")
      }
      var s = !1;
      0 <= e.indexOf('id="docs-internal-guid') && (e = e.replace(/^[\w\W\s\S]* id="docs-internal-guid[^>]*>([\w\W\s\S]*)<\/b>[\w\W\s\S]*$/g, "$1"), s = !0), 0 <= e.indexOf('content="Sheets"') && (e = e.replace(/width:0px;/g, ""));
      var l = !1;
      if (!t) if ((l = function L() {
        var e = null;
        try {
          e = S.win.localStorage.getItem("fr-copied-text")
        } catch (t) {
        }
        return !(!e || !k || k.replace(/\u00A0/gi, " ").replace(/\r|\n/gi, "") !== e.replace(/\u00A0/gi, " ").replace(/\r|\n/gi, "") && k.replace(/\s/g, "") !== e.replace(/\s/g, ""))
      }()) && (e = S.win.localStorage.getItem("fr-copied-html")), l) e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs); else {
        var c = S.opts.htmlAllowedStyleProps;
        S.opts.htmlAllowedStyleProps = S.opts.pasteAllowedStyleProps, S.opts.htmlAllowComments = !1, e = (e = (e = e.replace(/<span class="Apple-tab-span">\s*<\/span>/g, M(S.opts.tabSpaces || 4))).replace(/<span class="Apple-tab-span" style="white-space:pre">(\t*)<\/span>/g, function (e, t) {
          return M(t.length * (S.opts.tabSpaces || 4))
        })).replace(/\t/g, M(S.opts.tabSpaces || 4)), e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs), S.opts.htmlAllowedStyleProps = c, S.opts.htmlAllowComments = !0, e = (e = (e = O(e)).replace(/\r/g, "")).replace(/^ */g, "").replace(/ *$/g, "")
      }
      !t || S.wordPaste && n || (0 === (e = e.replace(/^\n*/g, "").replace(/^ /g, "")).indexOf("<colgroup>") && (e = "<table>".concat(e, "</table>")), e = O(e = function _(e) {
        var t;
        e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/<p(.*?)class="?'?MsoListParagraph"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ul><li>$3</li></ul>")).replace(/<p(.*?)class="?'?NumberedText"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ol><li>$3</li></ol>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ul><li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ol><li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListBullet"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li></ul>")).replace(/<p(.*?)class="?'?NumberedTextCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li></ol>")).replace(/<span([^<]*?)style="?'?mso-list:Ignore"?'?([\s\S]*?)>([\s\S]*?)<span/gi, "<span><span")).replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi, "")).replace(/<!\[if !supportLists\]>([\s\S]*?)<!\[endif\]>/gi, "")).replace(/(\n|\r| class=(")?Mso[a-zA-Z0-9]+(")?)/gi, " ")).replace(/<!--[\s\S]*?-->/gi, "")).replace(/<(\/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>/gi, "");
        var n, r = ["style", "script", "applet", "embed", "noframes", "noscript"];
        for (t = 0; t < r.length; t++) {
          var a = new RegExp("<".concat(r[t], ".*?").concat(r[t], "(.*?)>"), "gi");
          e = e.replace(a, "")
        }
        for (e = (e = (e = e.replace(/&nbsp;/gi, " ")).replace(/<td([^>]*)><\/td>/g, "<td$1><br></td>")).replace(/<th([^>]*)><\/th>/g, "<th$1><br></th>"); (e = (n = e).replace(/<[^/>][^>]*><\/[^>]+>/gi, "")) !== n;) ;
        e = (e = e.replace(/<lilevel([^1])([^>]*)>/gi, '<li data-indent="true"$2>')).replace(/<lilevel1([^>]*)>/gi, "<li$1>"), e = (e = (e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs)).replace(/<a>(.[^<]+)<\/a>/gi, "$1")).replace(/<br> */g, "<br>");
        var o = S.o_doc.createElement("div");
        o.innerHTML = e;
        var i = o.querySelectorAll("li[data-indent]");
        for (t = 0; t < i.length; t++) {
          var s = i[t], l = s.previousElementSibling;
          if (l && "LI" === l.tagName) {
            var c = l.querySelector(":scope > ul, :scope > ol");
            c || (c = document.createElement("ul"), l.appendChild(c)), c.appendChild(s)
          } else s.removeAttribute("data-indent")
        }
        return S.html.cleanBlankSpaces(o), e = o.innerHTML
      }(e))), S.opts.pastePlain && (e = function w(e) {
        var t, n = null, r = S.doc.createElement("div");
        r.innerHTML = e;
        var a = r.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote");
        for (t = 0; t < a.length; t++) (n = a[t]).outerHTML = "<".concat(S.html.defaultTag() || "DIV", ">").concat(n.innerText, "</").concat(S.html.defaultTag() || "DIV", ">");
        for (t = (a = r.querySelectorAll("*:not(".concat("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img".split(",").join("):not("), ")"))).length - 1; 0 <= t; t--) (n = a[t]).outerHTML = n.innerHTML;
        return function o(e) {
          for (var t = S.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType !== Node.TEXT_NODE && t[n].nodeType !== Node.ELEMENT_NODE ? t[n].parentNode.removeChild(t[n]) : o(t[n])
        }(r), r.innerHTML
      }(e));
      var d = S.events.chainTrigger("paste.afterCleanup", e);
      if ("string" == typeof d && (e = d), "" !== e) {
        var f = S.o_doc.createElement("div");
        0 <= (f.innerHTML = e).indexOf("<body>") ? (S.html.cleanBlankSpaces(f), S.spaces.normalize(f, !0)) : S.spaces.normalize(f);
        var p = f.getElementsByTagName("span");
        for (r = p.length - 1; 0 <= r; r--) {
          var u = p[r];
          0 === u.attributes.length && (u.outerHTML = u.innerHTML)
        }
        if (!0 === S.opts.linkAlwaysBlank) {
          var h = f.getElementsByTagName("a");
          for (r = h.length - 1; 0 <= r; r--) {
            var g = h[r];
            g.getAttribute("target") || g.setAttribute("target", "_blank")
          }
        }
        var m = S.selection.element(), v = !1;
        if (m && R(m).parentsUntil(S.el, "ul, ol").length && (v = !0), v) {
          var b = f.children;
          1 === b.length && 0 <= ["OL", "UL"].indexOf(b[0].tagName) && (b[0].outerHTML = b[0].innerHTML)
        }
        if (!s) {
          var C = f.getElementsByTagName("br");
          for (r = C.length - 1; 0 <= r; r--) {
            var E = C[r];
            S.node.isBlock(E.previousSibling) && E.parentNode.removeChild(E)
          }
        }
        if (S.opts.enter === xt.ENTER_BR) for (r = (a = f.querySelectorAll("p, div")).length - 1; 0 <= r; r--) 0 === (o = a[r]).attributes.length && (o.outerHTML = o.innerHTML + (o.nextSibling && !S.node.isEmpty(o) ? "<br>" : "")); else if (S.opts.enter === xt.ENTER_DIV) for (r = (a = f.getElementsByTagName("p")).length - 1; 0 <= r; r--) 0 === (o = a[r]).attributes.length && (o.outerHTML = "<div>".concat(o.innerHTML, "</div>")); else S.opts.enter === xt.ENTER_P && 1 === f.childNodes.length && "P" === f.childNodes[0].tagName && 0 === f.childNodes[0].attributes.length && (f.childNodes[0].outerHTML = f.childNodes[0].innerHTML);
        if (f.children && 0 < f.children.length) if (S.opts.trackChangesEnabled) for (var y = 0; y < f.children.length; y++) f.children[y].setAttribute("id", "isPasted"); else f.children[0].setAttribute("id", "isPasted");
        e = f.innerHTML, l && (e = function A(e) {
          var t, n = S.o_doc.createElement("div");
          n.innerHTML = e;
          var r = n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(xt.VOID_ELEMENTS.join("):not("), "):not(").concat(S.opts.htmlAllowedEmptyTags.join("):not("), ")"));
          for (; r.length;) {
            for (t = 0; t < r.length; t++) r[t].parentNode.removeChild(r[t]);
            r = n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(xt.VOID_ELEMENTS.join("):not("), "):not(").concat(S.opts.htmlAllowedEmptyTags.join("):not("), ")"))
          }
          return n.innerHTML
        }(e)), S.html.insert(e, !0)
      }
      !function T() {
        S.events.trigger("paste.after")
      }(), S.undo.saveStep(x), x = null, S.undo.saveStep()
    }

    function f(e) {
      for (var t = e.length - 1; 0 <= t; t--) e[t].attributes && e[t].attributes.length && e.splice(t, 1);
      return e
    }

    function O(e) {
      var t, n = S.o_doc.createElement("div");
      n.innerHTML = e;
      for (var r = f(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])"))); r.length;) {
        var a = r[r.length - 1];
        if (S.html.defaultTag() && "div" !== S.html.defaultTag()) a.querySelector(S.html.blockTagsQuery()) ? a.outerHTML = a.innerHTML : a.outerHTML = "<".concat(S.html.defaultTag(), ">").concat(a.innerHTML, "</").concat(S.html.defaultTag(), ">"); else {
          var o = a.querySelectorAll("*");
          !o.length || "BR" !== o[o.length - 1].tagName && 0 === a.innerText.length ? a.outerHTML = a.innerHTML + (a.nextSibling ? "<br>" : "") : !o.length || "BR" !== o[o.length - 1].tagName || o[o.length - 1].nextSibling ? a.outerHTML = a.innerHTML + (a.nextSibling ? "<br>" : "") : a.outerHTML = a.innerHTML
        }
        r = f(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])")))
      }
      for (r = f(Array.prototype.slice.call(n.querySelectorAll("div:not([style])"))); r.length;) {
        for (t = 0; t < r.length; t++) {
          var i = r[t], s = i.innerHTML.replace(/\u0009/gi, "").trim();
          i.outerHTML = s
        }
        r = f(Array.prototype.slice.call(n.querySelectorAll("div:not([style])")))
      }
      return n.innerHTML
    }

    function p() {
      S.el.removeEventListener("copy", e), S.el.removeEventListener("cut", e), S.el.removeEventListener("paste", t)
    }

    return {
      _init: function u() {
        S.el.addEventListener("copy", e), S.el.addEventListener("cut", e), S.el.addEventListener("paste", t, {capture: !0}), S.events.on("drop", r), S.browser.msie && S.browser.version < 11 && (S.events.on("mouseup", function (e) {
          2 === e.button && (setTimeout(function () {
            l = !1
          }, 50), l = !0)
        }, !0), S.events.on("beforepaste", t)), S.events.on("destroy", p)
      }, cleanEmptyTagsAndDivs: O, getRtfClipboard: function h() {
        return s
      }, saveCopiedText: n, clean: a
    }
  }, Object.assign(xt.DEFAULTS, {
    shortcutsEnabled: [],
    shortcutsHint: !0
  }), xt.SHORTCUTS_MAP = {}, xt.RegisterShortcut = function (e, t, n, r, a, o) {
    xt.SHORTCUTS_MAP[(a ? "^" : "") + (o ? "@" : "") + e] = {
      cmd: t,
      val: n,
      letter: r,
      shift: a,
      option: o
    }, xt.DEFAULTS.shortcutsEnabled.push(t)
  }, xt.RegisterShortcut(xt.KEYCODE.E, "show", null, "E", !1, !1), xt.RegisterShortcut(xt.KEYCODE.B, "bold", null, "B", !1, !1), xt.RegisterShortcut(xt.KEYCODE.I, "italic", null, "I", !1, !1), xt.RegisterShortcut(xt.KEYCODE.U, "underline", null, "U", !1, !1), xt.RegisterShortcut(xt.KEYCODE.S, "strikeThrough", null, "S", !1, !1), xt.RegisterShortcut(xt.KEYCODE.CLOSE_SQUARE_BRACKET, "indent", null, "]", !1, !1), xt.RegisterShortcut(xt.KEYCODE.OPEN_SQUARE_BRACKET, "outdent", null, "[", !1, !1), xt.RegisterShortcut(xt.KEYCODE.Z, "undo", null, "Z", !1, !1), xt.RegisterShortcut(xt.KEYCODE.Z, "redo", null, "Z", !0, !1), xt.RegisterShortcut(xt.KEYCODE.Y, "redo", null, "Y", !1, !1), xt.MODULES.shortcuts = function (s) {
    var r = null;
    var l = !1;

    function e(e) {
      if (!s.core.hasFocus()) return !0;
      var t = e.which, n = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey;
      if ("keyup" === e.type && l && t !== xt.KEYCODE.META) return l = !1;
      "keydown" === e.type && (l = !1);
      var r = (e.shiftKey ? "^" : "") + (e.altKey ? "@" : "") + t, a = s.node.blockParent(s.selection.blocks()[0]);
      if (a && "TR" == a.tagName && a.getAttribute("contenteditable") == undefined && (a = a.closest("table")), n && xt.SHORTCUTS_MAP[r] && (!a || "false" !== a.getAttribute("contenteditable"))) {
        var o = xt.SHORTCUTS_MAP[r].cmd;
        if (o && 0 <= s.opts.shortcutsEnabled.indexOf(o)) {
          var i = xt.SHORTCUTS_MAP[r].val;
          if (!1 === s.events.trigger("shortcut", [e, o, i])) return !(l = !0);
          if (o && (s.commands[o] || xt.COMMANDS[o] && xt.COMMANDS[o].callback)) return e.preventDefault(), e.stopPropagation(), "keydown" === e.type && ((s.commands[o] || xt.COMMANDS[o].callback)(), l = !0), !1
        }
      }
    }

    return {
      _init: function t() {
        s.events.on("keydown", e, !0), s.events.on("keyup", e, !0)
      }, get: function a(e) {
        if (!s.opts.shortcutsHint) return null;
        if (!r) for (var t in r = {}, xt.SHORTCUTS_MAP) Object.prototype.hasOwnProperty.call(xt.SHORTCUTS_MAP, t) && 0 <= s.opts.shortcutsEnabled.indexOf(xt.SHORTCUTS_MAP[t].cmd) && (r["".concat(xt.SHORTCUTS_MAP[t].cmd, ".").concat(xt.SHORTCUTS_MAP[t].val || "")] = {
          shift: xt.SHORTCUTS_MAP[t].shift,
          option: xt.SHORTCUTS_MAP[t].option,
          letter: xt.SHORTCUTS_MAP[t].letter
        });
        var n = r[e];
        return n ? (s.helpers.isMac() ? String.fromCharCode(8984) : "".concat(s.language.translate("Ctrl"), "+")) + (n.shift ? s.helpers.isMac() ? String.fromCharCode(8679) : "".concat(s.language.translate("Shift"), "+") : "") + (n.option ? s.helpers.isMac() ? String.fromCharCode(8997) : "".concat(s.language.translate("Alt"), "+") : "") + n.letter : null
      }
    }
  }, xt.MODULES.snapshot = function (l) {
    function n(e) {
      for (var t = e.parentNode.childNodes, n = 0, r = null, a = 0; a < t.length; a++) {
        if (r) {
          var o = t[a].nodeType === Node.TEXT_NODE && "" === t[a].textContent,
            i = r.nodeType === Node.TEXT_NODE && t[a].nodeType === Node.TEXT_NODE,
            s = r.nodeType === Node.TEXT_NODE && "" === r.textContent;
          o || i || s || n++
        }
        if (t[a] === e) return n;
        r = t[a]
      }
    }

    function a(e) {
      var t = [];
      if (!e.parentNode) return [];
      for (; !l.node.isElement(e);) t.push(n(e)), e = e.parentNode;
      return t.reverse()
    }

    function o(e, t) {
      for (; e && e.nodeType === Node.TEXT_NODE;) {
        var n = e.previousSibling;
        n && n.nodeType === Node.TEXT_NODE && (t += n.textContent.length), e = n
      }
      return t
    }

    function c(e) {
      for (var t = l.el, n = 0; n < e.length; n++) t = t.childNodes[e[n]];
      return t
    }

    function r(e, t) {
      try {
        var n = c(t.scLoc), r = t.scOffset, a = c(t.ecLoc), o = t.ecOffset, i = l.doc.createRange();
        i.setStart(n, r), i.setEnd(a, o), e.addRange(i)
      } catch (s) {
      }
    }

    return {
      get: function i() {
        var e, t = {};
        if (l.events.trigger("snapshot.before"), t.html = (l.$wp ? l.$el.html() : l.$oel.get(0).outerHTML).replace(/ style=""/g, ""), t.ranges = [], l.$wp && l.selection.inEditor() && l.core.hasFocus()) for (var n = l.selection.ranges(), r = 0; r < n.length; r++) t.ranges.push({
          scLoc: a((e = n[r]).startContainer),
          scOffset: o(e.startContainer, e.startOffset),
          ecLoc: a(e.endContainer),
          ecOffset: o(e.endContainer, e.endOffset)
        });
        return l.events.trigger("snapshot.after", [t]), t
      }, restore: function s(e) {
        l.$el.html() !== e.html && (l.opts.htmlExecuteScripts ? l.$el.html(e.html) : l.el.innerHTML = e.html);
        var t = l.selection.get();
        l.selection.clear(), l.events.focus(!0);
        for (var n = 0; n < e.ranges.length; n++) r(t, e.ranges[n])
      }, equal: function d(e, t) {
        return e.html === t.html && (!l.core.hasFocus() || JSON.stringify(e.ranges) === JSON.stringify(t.ranges))
      }
    }
  }, xt.MODULES.undo = function (n) {
    function e(e) {
      var t = e.which;
      n.keys.ctrlKey(e) && (t === xt.KEYCODE.Z && e.shiftKey && e.preventDefault(), t === xt.KEYCODE.Z && e.preventDefault())
    }

    var t = null;

    function r() {
      if (n.undo_stack && !n.undoing) for (; n.undo_stack.length > n.undo_index;) n.undo_stack.pop()
    }

    function a() {
      n.undo_index = 0, n.undo_stack = []
    }

    function o() {
      n.undo_stack = []
    }

    return {
      _init: function i() {
        a(), n.events.on("initialized", function () {
          t = (n.$wp ? n.$el.html() : n.$oel.get(0).outerHTML).replace(/ style=""/g, "")
        }), n.events.on("blur", function () {
          n.el.querySelector(".fr-dragging") || n.undo.saveStep()
        }), n.events.on("keydown", e), n.events.on("destroy", o)
      }, run: function s() {
        if (1 < n.undo_index) {
          n.undoing = !0;
          var e = n.undo_stack[--n.undo_index - 1];
          clearTimeout(n._content_changed_timer), n.snapshot.restore(e), t = e.html, n.popups.hideAll(), n.toolbar.enable(), n.events.trigger("contentChanged"), n.events.trigger("commands.undo"), n.undoing = !1
        }
      }, redo: function l() {
        if (n.undo_index < n.undo_stack.length) {
          n.undoing = !0;
          var e = n.undo_stack[n.undo_index++];
          clearTimeout(n._content_changed_timer), n.snapshot.restore(e), t = e.html, n.popups.hideAll(), n.toolbar.enable(), n.events.trigger("contentChanged"), n.events.trigger("commands.redo"), n.undoing = !1
        }
      }, canDo: function c() {
        return !(0 === n.undo_stack.length || n.undo_index <= 1)
      }, canRedo: function d() {
        return n.undo_index !== n.undo_stack.length
      }, dropRedo: r, reset: a, saveStep: function f(e) {
        if (n.undo_stack && !n.undoing && !n.el.querySelector(".fr-marker")) if (void 0 === e) {
          if ((e = n.snapshot.get()) && e.html && n.undo_stack[n.undo_stack.length - 1] && e.html === n.undo_stack[n.undo_stack.length - 1].html) return;
          n.undo_stack[n.undo_index - 1] && n.snapshot.equal(n.undo_stack[n.undo_index - 1], e) || (r(), n.undo_stack.push(e), n.undo_index++, function a(e, t) {
            var n = t.split("fr-selected-cell").join("");
            n = n.split(' class=""').join("");
            e = e || '';
            var r = e.split("fr-selected-cell").join("");
            return n === (r = r.split(' class=""').join(""))
          }(t, e.html) || (n.events.trigger("contentChanged"), t = e.html))
        } else r(), 0 < n.undo_index ? n.undo_stack[n.undo_index - 1] = e : (n.undo_stack.push(e), n.undo_index++)
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    height: null,
    heightMax: null,
    heightMin: null,
    width: null
  }), xt.MODULES.size = function (e) {
    function t() {
      n(), e.opts.height && e.$el.css("minHeight", e.opts.height - e.helpers.getPX(e.$el.css("padding-top")) - e.helpers.getPX(e.$el.css("padding-bottom"))), e.$iframe.height(e.$el.outerHeight(!0))
    }

    function n() {
      e.opts.heightMin ? e.$el.css("minHeight", e.opts.heightMin) : e.$el.css("minHeight", ""), e.opts.heightMax ? (e.$wp.css("maxHeight", e.opts.heightMax), e.$wp.css("overflow", "auto")) : (e.$wp.css("maxHeight", ""), e.$wp.css("overflow", "")), e.opts.height ? (e.$wp.css("height", e.opts.height), e.$wp.css("overflow", "auto"), e.$el.css("minHeight", e.opts.height - e.helpers.getPX(e.$el.css("padding-top")) - e.helpers.getPX(e.$el.css("padding-bottom")))) : (e.$wp.css("height", ""), e.opts.heightMin || e.$el.css("minHeight", ""), e.opts.heightMax || e.$wp.css("overflow", "")), e.opts.width && e.$box.width(e.opts.width)
    }

    return {
      _init: function r() {
        if (!e.$wp) return !1;
        n(), e.$iframe && 0 == e.opts.fullPage && (e.events.on("keyup keydown", function () {
          setTimeout(t, 0)
        }, !0), e.events.on("commands.after html.set init initialized paste.after", t))
      }, syncIframe: t, refresh: n
    }
  }, Object.assign(xt.DEFAULTS, {
    documentReady: !1,
    editorClass: null,
    typingTimer: 500,
    iframe: !1,
    requestWithCORS: !0,
    requestWithCredentials: !1,
    requestHeaders: {},
    useClasses: !0,
    spellcheck: !0,
    iframeDefaultStyle: 'html{margin:0px;height:auto;}body{height:auto;padding:20px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:"";display:block;clear:both;}body::-moz-selection{background:#b5d6fd;color:#000;}body::selection{background:#b5d6fd;color:#000;}',
    iframeStyle: "",
    iframeStyleFiles: [],
    direction: "auto",
    zIndex: 1,
    tabIndex: null,
    disableRightClick: !1,
    scrollableContainer: "body",
    keepFormatOnDelete: !1,
    theme: null
  }), xt.MODULES.core = function (i) {
    var r = i.$;

    function n() {
      if (i.$box.addClass("fr-box".concat(i.opts.editorClass ? " ".concat(i.opts.editorClass) : "")), i.$box.attr("role", "application"), i.$wp.addClass("fr-wrapper"), i.opts.documentReady && i.$box.addClass("fr-document"), function a() {
        i.opts.iframe || i.$el.addClass("fr-element fr-view")
      }(), i.opts.iframe) {
        i.$iframe.addClass("fr-iframe"), i.$el.addClass("fr-view");
        for (var e = 0; e < i.o_doc.styleSheets.length; e++) {
          var t = void 0;
          try {
            t = i.o_doc.styleSheets[e].cssRules
          } catch (o) {
          }
          if (t) for (var n = 0, r = t.length; n < r; n++) !t[n].selectorText || 0 !== t[n].selectorText.indexOf(".fr-view") && 0 !== t[n].selectorText.indexOf(".fr-element") || 0 < t[n].style.cssText.length && (0 === t[n].selectorText.indexOf(".fr-view") ? i.opts.iframeStyle += "".concat(t[n].selectorText.replace(/\.fr-view/g, "body"), "{").concat(t[n].style.cssText, "}") : i.opts.iframeStyle += "".concat(t[n].selectorText.replace(/\.fr-element/g, "body"), "{").concat(t[n].style.cssText, "}"))
        }
      }
      "auto" !== i.opts.direction && i.$box.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(i.opts.direction)), i.$el.attr("dir", i.opts.direction), i.$wp.attr("dir", i.opts.direction), 1 < i.opts.zIndex && i.$box.css("z-index", i.opts.zIndex), i.opts.theme && i.$box.addClass("".concat(i.opts.theme, "-theme")), i.opts.tabIndex = i.opts.tabIndex || i.$oel.attr("tabIndex"), i.opts.tabIndex && i.$el.attr("tabIndex", i.opts.tabIndex)
    }

    return {
      _init: function a() {
        if (xt.INSTANCES.push(i), function e() {
          i.drag_support = {
            filereader: "undefined" != typeof FileReader,
            formdata: Boolean(i.win.FormData),
            progress: "upload" in new XMLHttpRequest
          }
        }(), i.$wp) {
          n(), i.html.set(i._original_html), i.$el.attr("spellcheck", i.opts.spellcheck), i.helpers.isMobile() && (i.$el.attr("autocomplete", i.opts.spellcheck ? "on" : "off"), i.$el.attr("autocorrect", i.opts.spellcheck ? "on" : "off"), i.$el.attr("autocapitalize", i.opts.spellcheck ? "on" : "off")), i.opts.disableRightClick && i.events.$on(i.$el, "contextmenu", function (e) {
            if (2 === e.button) return e.preventDefault(), e.stopPropagation(), !1
          });
          try {
            i.doc.execCommand("styleWithCSS", !1, !1)
          } catch (t) {
          }
        }
        "TEXTAREA" === i.$oel.get(0).tagName && (i.events.on("contentChanged", function () {
          i.$oel.val(i.html.get())
        }), i.events.on("form.submit", function () {
          i.$oel.val(i.html.get())
        }), i.events.on("form.reset", function () {
          i.html.set(i._original_html)
        }), i.$oel.val(i.html.get())), i.helpers.isIOS() && i.events.$on(i.$doc, "selectionchange", function () {
          i.$doc.get(0).hasFocus() || i.$win.get(0).focus()
        }), i.events.trigger("init"), i.opts.autofocus && !i.opts.initOnClick && i.$wp && i.events.on("initialized", function () {
          i.events.focus(!0)
        })
      }, destroy: function t(e) {
        "TEXTAREA" === i.$oel.get(0).tagName && i.$oel.val(e), i.$box && i.$box.removeAttr("role"), i.$wp && ("TEXTAREA" === i.$oel.get(0).tagName ? (i.$el.html(""), i.$wp.html(""), i.$box.replaceWith(i.$oel), i.$oel.show()) : (i.$wp.replaceWith(e), i.$el.html(""), i.$box.removeClass("fr-view fr-ltr fr-box ".concat(i.opts.editorClass || "")), i.opts.theme && i.$box.addClass("".concat(i.opts.theme, "-theme")))), this.$wp = null, this.$el = null, this.el = null, this.$box = null
      }, isEmpty: function e() {
        return i.node.isEmpty(i.el)
      }, getXHR: function o(e, t) {
        var n = new XMLHttpRequest;
        for (var r in n.open(t, e, !0), i.opts.requestWithCredentials && (n.withCredentials = !0), i.opts.requestHeaders) Object.prototype.hasOwnProperty.call(i.opts.requestHeaders, r) && n.setRequestHeader(r, i.opts.requestHeaders[r]);
        return n
      }, injectStyle: function s(e) {
        if (i.opts.iframe) {
          i.$head.find("style[data-fr-style], link[data-fr-style]").remove(), i.$head.append('<style data-fr-style="true">'.concat(e, "</style>"));
          for (var t = 0; t < i.opts.iframeStyleFiles.length; t++) {
            var n = r('<link data-fr-style="true" rel="stylesheet" href="'.concat(i.opts.iframeStyleFiles[t], '">'));
            n.get(0).addEventListener("load", i.size.syncIframe), i.$head.append(n)
          }
        }
      }, hasFocus: function l() {
        return i.browser.mozilla && i.helpers.isMobile() ? i.selection.inEditor() : i.node.hasFocus(i.el) || 0 < i.$el.find("*:focus").length
      }, sameInstance: function c(e) {
        if (!e) return !1;
        var t = e.data("instance");
        return !!t && t.id === i.id
      }
    }
  }, xt.POPUP_TEMPLATES = {"text.edit": "[_EDIT_]"}, xt.RegisterTemplate = function (e, t) {
    xt.POPUP_TEMPLATES[e] = t
  }, xt.MODULES.popups = function (u) {
    var r, d = u.$;
    u.shared.popups || (u.shared.popups = {});
    var h, g = u.shared.popups;

    function m(e, t) {
      t.isVisible() || (t = u.$sc), t.is(g[e].data("container")) || (g[e].data("container", t), t.append(g[e]))
    }

    function a(e) {
      var t;
      e.find(".fr-upload-progress").addClass("fr-height-set"), e.find(".fr-upload-progress").removeClass("fr-height-auto"), u.popups.get("filesManager.insert").removeClass("fr-height-auto"), e.find(".fr-files-upload-layer").hasClass("fr-active") && (t = 1), e.find(".fr-files-by-url-layer").hasClass("fr-active") && (t = 2), e.find(".fr-files-embed-layer").hasClass("fr-active") && (t = 3), e.find(".fr-upload-progress-layer").get(0).clientHeight + 10 < e.find(".fr-upload-progress").get(0).clientHeight && e.find(".fr-upload-progress").addClass("fr-height-auto"), 400 < e[0].clientHeight && (e[0].childNodes[4].style.height = "".concat(e[0].clientHeight - (e[0].childNodes[0].clientHeight + e[0].childNodes[t].clientHeight) - 80, "px"))
    }

    var o = 2e3;

    function i() {
      d(this).toggleClass("fr-not-empty", !0)
    }

    function s() {
      var e = d(this);
      e.toggleClass("fr-not-empty", "" !== e.val())
    }

    function v(e) {
      return g[e] && u.node.hasClass(g[e], "fr-active") && u.core.sameInstance(g[e]) || !1
    }

    function b(e) {
      for (var t in g) if (Object.prototype.hasOwnProperty.call(g, t) && v(t) && (void 0 === e || g[t].data("instance") === e)) return g[t];
      return !1
    }

    function n(e) {
      var t = null;
      if (t = "string" != typeof e ? e : g[e], "filesManager.insert" === e && u.filesManager !== undefined && u.filesManager.isChildWindowOpen()) return !1;
      if (t && u.node.hasClass(t, "fr-active") && (t.removeClass("fr-active fr-above"), u.events.trigger("popups.hide.".concat(e)), u.$tb && (1 < u.opts.zIndex ? u.$tb.css("zIndex", u.opts.zIndex + 1) : u.$tb.css("zIndex", "")), u.events.disableBlur(), t.find("input, textarea, button").each(function () {
        this === this.ownerDocument.activeElement && this.blur()
      }), t.find("input, textarea").attr("disabled", "disabled"), h)) for (var n = 0; n < h.length; n++) d(h[n]).removeClass("fr-btn-active-popup")
    }

    function C(e) {
      for (var t in void 0 === e && (e = []), g) Object.prototype.hasOwnProperty.call(g, t) && e.indexOf(t) < 0 && n(t)
    }

    function t() {
      u.shared.exit_flag = !0
    }

    function E() {
      u.shared.exit_flag = !1
    }

    function l() {
      return u.shared.exit_flag
    }

    function c(e, t) {
      var n, r = function c(e, t) {
        var n = xt.POPUP_TEMPLATES[e];
        if (!n) return null;
        for (var r in "function" == typeof n && (n = n.apply(u)), t) Object.prototype.hasOwnProperty.call(t, r) && (n = n.replace("[_".concat(r.toUpperCase(), "_]"), t[r]));
        return n
      }(e, t), a = d(u.doc.createElement("DIV"));
      if (!r) return "filesManager.insert" === e ? a.addClass("fr-popup fr-files-manager fr-empty") : a.addClass("fr-popup fr-empty"), (n = d("body").first()).append(a), a.data("container", n), g[e] = a;
      "filesManager.insert" === e ? a.addClass("fr-popup fr-files-manager".concat(u.helpers.isMobile() ? " fr-mobile" : " fr-desktop").concat(u.opts.toolbarInline ? " fr-inline" : "")) : a.addClass("fr-popup".concat(u.helpers.isMobile() ? " fr-mobile" : " fr-desktop").concat(u.opts.toolbarInline ? " fr-inline" : "")), a.html(r), u.opts.theme && a.addClass("".concat(u.opts.theme, "-theme")), 1 < u.opts.zIndex && (!u.opts.editInPopup && u.$tb ? u.$tb.css("z-index", u.opts.zIndex + 2) : a.css("z-index", u.opts.zIndex + 2)), "auto" !== u.opts.direction && a.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(u.opts.direction)), a.find("input, textarea").attr("dir", u.opts.direction).attr("disabled", "disabled"), (n = d("body").first()).append(a), a.data("container", n);
      var o = (g[e] = a).find(".fr-color-hex-layer");
      if (0 < o.length) {
        var i = u.helpers.getPX(a.find(".fr-color-set > span").css("width")), s = u.helpers.getPX(o.css("paddingLeft")),
          l = u.helpers.getPX(o.css("paddingRight"));
        o.css("width", i * u.opts.colorsStep + s + l)
      }
      return u.button.bindCommands(a, !1), a
    }

    function y(r) {
      var a = g[r];
      return {
        _windowResize: function () {
          var e = a.data("instance") || u;
          !e.helpers.isMobile() && a.isVisible() && (e.events.disableBlur(), e.popups.hide(r), e.events.enableBlur())
        }, _inputFocus: function (e) {
          var t = a.data("instance") || u, n = d(e.currentTarget);
          if (n.is("input:file") && n.closest(".fr-layer").addClass("fr-input-focus"), e.preventDefault(), e.stopPropagation(), setTimeout(function () {
            t.events.enableBlur()
          }, 100), t.helpers.isMobile()) {
            var r = d(t.o_win).scrollTop();
            setTimeout(function () {
              d(t.o_win).scrollTop(r)
            }, 0)
          }
        }, _inputBlur: function (e) {
          var t = a.data("instance") || u, n = d(e.currentTarget);
          n.is("input:file") && n.closest(".fr-layer").removeClass("fr-input-focus"), document.activeElement !== this && d(this).isVisible() && (t.events.blurActive() && t.events.trigger("blur"), t.events.enableBlur())
        }, _editorKeydown: function (e) {
          var t = a.data("instance") || u;
          t.keys.ctrlKey(e) || e.which === xt.KEYCODE.ALT || e.which === xt.KEYCODE.ESC || (v(r) && a.findVisible(".fr-back").length ? t.button.exec(a.findVisible(".fr-back").first()) : e.which !== xt.KEYCODE.ALT && t.popups.hide(r))
        }, _preventFocus: function (e) {
          var t = a.data("instance") || u,
            n = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null;
          "mouseup" === e.type || d(n).is(":focus") || t.events.disableBlur(), "mouseup" !== e.type || d(n).hasClass("fr-command") || 0 < d(n).parents(".fr-command").length || d(n).hasClass("fr-dropdown-content") || u.button.hideActiveDropdowns(a), (u.browser.safari || u.browser.mozilla) && "mousedown" === e.type && d(n).is("input[type=file]") && t.events.disableBlur();
          var r = "input, textarea, button, select, label, .fr-command";
          if (n && !d(n).is(r) && 0 === d(n).parents(r).length) return e.stopPropagation(), !1;
          n && d(n).is(r) && e.stopPropagation(), E()
        }, _editorMouseup: function () {
          a.isVisible() && l() && 0 < a.findVisible("input:focus, textarea:focus, button:focus, select:focus").length && u.events.disableBlur()
        }, _windowMouseup: function (e) {
          if (!u.core.sameInstance(a)) return !0;
          var t = a.data("instance") || u;
          a.isVisible() && l() && (e.stopPropagation(), t.markers.remove(), t.popups.hide(r), E())
        }, _windowKeydown: function (e) {
          if (!u.core.sameInstance(a)) return !0;
          var t = a.data("instance") || u, n = e.which;
          if (xt.KEYCODE.ESC === n) {
            if (t.popups.isVisible(r) && t.opts.toolbarInline) return e.stopPropagation(), t.popups.isVisible(r) && (a.findVisible(".fr-back").length ? (t.button.exec(a.findVisible(".fr-back").first()), t.accessibility.focusPopupButton(a)) : a.findVisible(".fr-dismiss").length ? t.button.exec(a.findVisible(".fr-dismiss").first()) : (t.popups.hide(r), t.toolbar.showInline(null, !0), t.accessibility.focusPopupButton(a))), !1;
            if (t.popups.isVisible(r)) return a.findVisible(".fr-back").length ? (t.button.exec(a.findVisible(".fr-back").first), t.accessibility.focusPopupButton(a)) : a.findVisible(".fr-dismiss").length ? t.button.exec(a.findVisible(".fr-dismiss").first()) : (t.popups.hide(r), t.accessibility.focusPopupButton(a)), !1
          }
        }, _repositionPopup: function () {
          if (!u.opts.height && !u.opts.heightMax || u.opts.toolbarInline) return !0;
          if (u.$wp && v(r) && a.parent().get(0) === u.$sc.get(0)) {
            var e = a.offset().top - u.$wp.offset().top, t = u.$wp.outerHeight();
            u.node.hasClass(a.get(0), "fr-above") && (e += a.outerHeight());
            var n = u.image.getEl();
            n && n.offset().top > t || t < e || e < 0 ? a.addClass("fr-hidden") : a.removeClass("fr-hidden")
          }
        }
      }
    }

    function f(e, t) {
      u.events.on("mouseup", e._editorMouseup, !0), u.$wp && u.events.on("keydown", e._editorKeydown), u.events.on("focus", function () {
        g[t].removeClass("focused")
      }), u.events.on("blur", function () {
        b() && u.markers.remove(), u.helpers.isMobile() ? g[t].hasClass("focused") ? (C(), g[t].removeClass("focused")) : g[t].addClass("focused") : g[t].find("iframe").length || C()
      }), u.$wp && !u.helpers.isMobile() && u.events.$on(u.$wp, "scroll.popup".concat(t), e._repositionPopup), u.events.on("window.mouseup", e._windowMouseup, !0), u.events.on("window.keydown", e._windowKeydown, !0), g[t].data("inst".concat(u.id), !0), u.events.on("destroy", function () {
        u.core.sameInstance(g[t]) && (d("body").first().append(g[t]), g[t].removeClass("fr-active"))
      }, !0)
    }

    function p() {
      var e = d(this).prev().children().first();
      e.attr("checked", !e.attr("checked"))
    }

    function e() {
      for (var e in g) if (Object.prototype.hasOwnProperty.call(g, e)) {
        var t = g[e];
        t && (t.html("").removeData().remove(), g[e] = null)
      }
      g = []
    }

    return u.shared.exit_flag = !1, {
      _init: function L() {
        r = window.innerHeight, u.events.on("shared.destroy", e, !0), u.events.on("window.mousedown", t), u.events.on("window.touchmove", E), u.events.$on(d(u.o_win), "scroll", E), u.events.on("mousedown", function (e) {
          b() && (e.stopPropagation(), u.$el.find(".fr-marker").remove(), t(), u.events.disableBlur())
        })
      }, create: function _(e, t) {
        var n = c(e, t), r = y(e);
        f(r, e), u.events.$on(n, "mousedown mouseup touchstart touchend touch", "*", r._preventFocus, !0), u.events.$on(n, "focus", "input, textarea, button, select", r._inputFocus, !0), u.events.$on(n, "blur", "input, textarea, button, select", r._inputBlur, !0);
        var a = n.find("input, textarea");
        return function o(e) {
          for (var t = 0; t < e.length; t++) {
            var n = e[t], r = d(n);
            0 === r.next().length && r.attr("placeholder") && (r.after('<label for="'.concat(r.attr("id"), '">').concat(r.attr("placeholder"), "</label>")), r.attr("placeholder", ""))
          }
        }(a), u.events.$on(a, "focus", i), u.events.$on(a, "blur change", s), u.events.$on(n, "click", ".fr-checkbox + label", p), u.accessibility.registerPopup(e), u.helpers.isIOS() && u.events.$on(n, "touchend", "label", function () {
          d("#".concat(d(this).attr("for"))).prop("checked", function (e, t) {
            return !t
          })
        }, !0), u.events.$on(d(u.o_win), "resize", r._windowResize, !0), "filesManager.insert" === e && g["filesManager.insert"].css("zIndex", 2147483641), n
      }, get: function w(e) {
        var t = g[e];
        return t && !t.data("inst".concat(u.id)) && f(y(e), e), t
      }, show: function A(e, t, n, r, a) {
        if (v(e) || (b() && 0 < u.$el.find(".fr-marker").length ? (u.events.disableBlur(), u.selection.restore()) : b() || (u.events.disableBlur(), u.events.focus(), u.events.enableBlur())), C([e]), !g[e]) return !1;
        var o = u.button.getButtons(".fr-dropdown.fr-active");
        o.removeClass("fr-active").attr("aria-expanded", !1).parents(".fr-toolbar").css("zIndex", "").find("> .fr-dropdown-wrapper").css("height", ""), o.next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), g[e].data("instance", u), u.$tb && u.$tb.data("instance", u);
        var i = v(e);
        g[e].addClass("fr-active").removeClass("fr-hidden").find("input, textarea").removeAttr("disabled");
        var s = g[e].data("container");
        if (function p(e, t) {
          t.isVisible() || (t = u.$sc), t.contains([g[e].get(0)]) || t.append(g[e])
        }(e, s), u.opts.toolbarInline && s && u.$tb && s.get(0) === u.$tb.get(0) && (m(e, u.$sc), n = u.$tb.offset().top - u.helpers.getPX(u.$tb.css("margin-top")), t = u.$tb.offset().left + u.$tb.outerWidth() / 2, u.node.hasClass(u.$tb.get(0), "fr-above") && n && (n += u.$tb.outerHeight()), r = 0), s = g[e].data("container"), u.opts.iframe && !r && !i) {
          var l = u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-top")),
            c = u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-left"));
          t && (t -= u.$iframe.offset().left + c), n && (n -= u.$iframe.offset().top + l)
        }
        s.is(u.$tb) ? u.$tb.css("zIndex", (u.opts.zIndex || 1) + 4) : g[e].css("zIndex", (u.opts.zIndex || 1) + 3), u.opts.toolbarBottom && s && u.$tb && s.get(0) === u.$tb.get(0) && (g[e].addClass("fr-above"), n && (n -= g[e].outerHeight())), a && (t -= g[e].width() / 2), t + g[e].outerWidth() > u.$sc.offset().left + u.$sc.width() && (t -= t + g[e].outerWidth() - u.$sc.offset().left - u.$sc.width()), t < u.$sc.offset().left && "rtl" === u.opts.direction && (t = u.$sc.offset().left), g[e].removeClass("fr-active"), u.position.at(t, n, g[e], r || 0);
        var d = u.node.blockParent(u.selection.blocks()[0]);
        if (d && "false" === d.getAttribute("contenteditable")) g[e].removeClass("fr-active"); else {
          var f = u.selection.element().parentElement.getAttribute("contenteditable");
          f && "false" === f ? g[e].removeClass("fr-active") : g[e].addClass("fr-active")
        }
        i || u.accessibility.focusPopup(g[e]), u.opts.toolbarInline && u.toolbar.hide(), u.$tb && (h = u.$tb.find(".fr-btn-active-popup")), u.events.trigger("popups.show.".concat(e)), y(e)._repositionPopup(), E()
      }, hide: n, onHide: function T(e, t) {
        u.events.on("popups.hide.".concat(e), t)
      }, hideAll: C, setContainer: m, refresh: function S(e) {
        g[e].data("instance", u), u.events.trigger("popups.refresh.".concat(e));
        for (var t = g[e].find(".fr-command"), n = 0; n < t.length; n++) {
          var r = d(t[n]);
          0 === r.parents(".fr-dropdown-menu").length && u.button.refresh(r)
        }
      }, onRefresh: function k(e, t) {
        u.events.on("popups.refresh.".concat(e), t)
      }, onShow: function x(e, t) {
        u.events.on("popups.show.".concat(e), t)
      }, isVisible: v, setFileListHeight: a, areVisible: b, setPopupDimensions: function R(e, t) {
        t && e.find(".fr-upload-progress-layer").get(0).clientHeight < o && (e.find(".fr-upload-progress").addClass("fr-height-auto"), u.popups.get("filesManager.insert").addClass("fr-height-auto"), e.find(".fr-upload-progress").removeClass("fr-height-set"), o = 2e3), e.get(0).clientHeight > window.innerHeight / 2 && (window.innerWidth < 500 ? e.get(0).clientHeight > .6 * r && a(e) : 400 < e.get(0).clientHeight && a(e), o = e.find(".fr-upload-progress-layer").get(0).clientHeight);
        var n = window.innerWidth;
        switch (!0) {
          case n <= 320:
            e.width(200);
            break;
          case n <= 420:
            e.width(250);
            break;
          case n <= 520:
            e.width(300);
            break;
          case n <= 720:
            e.width(400);
            break;
          case 720 < n:
            e.width(530)
        }
      }
    }
  }, xt.MODULES.accessibility = function (f) {
    var p = f.$, o = !0;

    function l(t) {
      for (var e = f.$el.find('[contenteditable="true"]'), n = !1, r = 0; e.get(r);) p(e.get(r)).is(":focus") && (n = !0), r++;
      t && t.length && !n && (t.data("blur-event-set") || t.parents(".fr-popup").length || (f.events.$on(t, "blur", function () {
        var e = t.parents(".fr-toolbar, .fr-popup").data("instance") || f;
        e.events.blurActive() && !f.core.hasFocus() && e.events.trigger("blur"), setTimeout(function () {
          e.events.enableBlur()
        }, 100)
      }, !0), t.data("blur-event-set", !0)), (t.parents(".fr-toolbar, .fr-popup").data("instance") || f).events.disableBlur(), t.get(0).focus(), f.shared.$f_el = t)
    }

    function u(e, t) {
      var n = t ? "last" : "first", r = s(g(e))[n]();
      if (r.length) return l(r), !0
    }

    function i(e) {
      return e.is("input, textarea, select") && t(), f.events.disableBlur(), e.get(0).focus(), !0
    }

    function h(e, t) {
      var n = e.find("input, textarea, button, select").filter(function () {
        return p(this).isVisible()
      }).not(":disabled");
      if ((n = t ? n.last() : n.first()).length) return i(n);
      if (f.shared.with_kb) {
        var r = e.findVisible(".fr-active-item").first();
        if (r.length) return i(r);
        var a = e.findVisible("[tabIndex]").first();
        if (a.length) return i(a)
      }
    }

    function t() {
      0 === f.$el.find(".fr-marker").length && f.core.hasFocus() && f.selection.save()
    }

    function c() {
      var e = f.popups.areVisible();
      if (e) {
        var t = e.find(".fr-buttons");
        return t.find("button:focus, .fr-group span:focus").length ? !u(e.data("instance").$tb) : !u(t)
      }
      return !u(f.$tb)
    }

    function d() {
      var e = null;
      return f.shared.$f_el.is(".fr-dropdown.fr-active") ? e = f.shared.$f_el : f.shared.$f_el.closest(".fr-dropdown-menu").prev().is(".fr-dropdown.fr-active") && (e = f.shared.$f_el.closest(".fr-dropdown-menu").prev()), e
    }

    function s(e) {
      for (var t = -1, n = 0; n < e.length; n++) p(e[n]).hasClass("fr-open") && (t = n);
      var r = e.index(f.$tb.find(".fr-more-toolbar.fr-expanded > button.fr-command").first());
      if (0 < r && -1 !== t) {
        var a = e.slice(r, e.length), o = (e = e.slice(0, r)).slice(0, t + 1), i = e.slice(t + 1, e.length);
        e = o;
        for (var s = 0; s < a.length; s++) e.push(a[s]);
        for (var l = 0; l < i.length; l++) e.push(i[l])
      }
      return e
    }

    function g(e) {
      return e.findVisible("button:not(.fr-disabled), .fr-group span.fr-command").filter(function (e) {
        var t = p(e).parents(".fr-more-toolbar");
        return 0 === t.length || 0 < t.length && t.hasClass("fr-expanded")
      })
    }

    function n(e, t, n) {
      if (f.shared.$f_el) {
        var r = d();
        r && (f.button.click(r), f.shared.$f_el = r);
        var a = s(g(e)), o = a.index(f.shared.$f_el);
        if (0 === o && !n || o === a.length - 1 && n) {
          var i;
          if (t) {
            if (e.parent().is(".fr-popup")) i = !h(e.parent().children().not(".fr-buttons"), !n);
            !1 === i && (f.shared.$f_el = null)
          }
          t && !1 === i || u(e, !n)
        } else l(p(a.get(o + (n ? 1 : -1))));
        return !1
      }
    }

    function m(e, t) {
      return n(e, t, !0)
    }

    function v(e, t) {
      return n(e, t)
    }

    function b(e) {
      if (f.shared.$f_el) {
        var t;
        if (f.shared.$f_el.is(".fr-dropdown.fr-active")) return l(t = e ? f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").last()), !1;
        if (f.shared.$f_el.is("a.fr-command")) return (t = e ? f.shared.$f_el.closest("li").nextAllVisible().first().find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.closest("li").prevAllVisible().first().find(".fr-command:not(.fr-disabled)").first()).length || (t = e ? f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").last()), l(t), !1
      }
    }

    function C() {
      if (f.shared.$f_el) {
        if (f.shared.$f_el.hasClass("fr-dropdown")) f.button.click(f.shared.$f_el); else if (f.shared.$f_el.is("button.fr-back")) {
          f.opts.toolbarInline && (f.events.disableBlur(), f.events.focus());
          var e = f.popups.areVisible(f);
          e && (f.shared.with_kb = !1), f.button.click(f.shared.$f_el), y(e)
        } else {
          if (f.events.disableBlur(), f.button.click(f.shared.$f_el), f.shared.$f_el.attr("data-group-name")) {
            var t = f.$tb.find('.fr-more-toolbar[data-name="'.concat(f.shared.$f_el.attr("data-group-name"), '"]')),
              n = f.shared.$f_el;
            t.hasClass("fr-expanded") && (n = t.findVisible("button:not(.fr-disabled)").first()), n && l(n)
          } else if (f.shared.$f_el.attr("data-popup")) {
            var r = f.popups.areVisible(f);
            r && r.data("popup-button", f.shared.$f_el)
          } else if (f.shared.$f_el.attr("data-modal")) {
            var a = f.modals.areVisible(f);
            a && a.data("modal-button", f.shared.$f_el)
          }
          f.shared.$f_el = null
        }
        return !1
      }
    }

    function E() {
      f.shared.$f_el && (f.events.disableBlur(), f.shared.$f_el.blur(), f.shared.$f_el = null), !1 !== f.events.trigger("toolbar.focusEditor") && (f.events.disableBlur(), f.$el.get(0).focus(), f.events.focus())
    }

    function a(r) {
      r && r.length && (f.events.$on(r, "keydown", function (e) {
        if (!p(e.target).is("a.fr-command, button.fr-command, .fr-group span.fr-command")) return !0;
        var t = r.parents(".fr-popup").data("instance") || r.data("instance") || f;
        f.shared.with_kb = !0;
        var n = t.accessibility.exec(e, r);
        return f.shared.with_kb = !1, n
      }, !0), f.events.$on(r, "mouseenter", "[tabIndex]", function (e) {
        var t = r.parents(".fr-popup").data("instance") || r.data("instance") || f;
        if (!o) return e.stopPropagation(), void e.preventDefault();
        var n = p(e.currentTarget);
        t.shared.$f_el && t.shared.$f_el.not(n) && t.accessibility.focusEditor()
      }, !0), f.$tb && f.events.$on(f.$tb, "transitionend", ".fr-more-toolbar", function () {
        f.shared.$f_el = p(document.activeElement)
      }))
    }

    function y(e) {
      var t = e.data("popup-button");
      t && setTimeout(function () {
        l(t), e.data("popup-button", null)
      }, 0)
    }

    function L(e) {
      var t = f.popups.areVisible(e);
      t && t.data("popup-button", null)
    }

    function e(e) {
      var t = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey;
      if (e.which !== xt.KEYCODE.F10 || t || e.shiftKey || !e.altKey) return !0;
      f.shared.with_kb = !0;
      var n = f.popups.areVisible(f), r = !1;
      return n && (r = h(n.children().not(".fr-buttons"))), r || c(), f.shared.with_kb = !1, e.preventDefault(), e.stopPropagation(), !1
    }

    return {
      _init: function r() {
        f.$wp ? f.events.on("keydown", e, !0) : f.events.$on(f.$win, "keydown", e, !0), f.events.on("mousedown", function (e) {
          L(f), f.shared.$f_el && f.el.isSameNode(f.shared.$f_el[0]) && (f.accessibility.restoreSelection(), e.stopPropagation(), f.events.disableBlur(), f.shared.$f_el = null)
        }, !0), f.events.on("blur", function () {
          f.shared.$f_el = null, L(f)
        }, !0)
      }, registerPopup: function _(e) {
        var t = f.popups.get(e), n = function r(c) {
          var d = f.popups.get(c);
          return {
            _tiKeydown: function (e) {
              var t = d.data("instance") || f;
              if (!1 === t.events.trigger("popup.tab", [e])) return !1;
              var n = e.which, r = d.find(":focus").first();
              if (xt.KEYCODE.TAB === n) {
                e.preventDefault();
                var a = d.children().not(".fr-buttons"),
                  o = a.findVisible("input, textarea, button, select").not(".fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled").toArray(),
                  i = o.indexOf(this) + (e.shiftKey ? -1 : 1);
                if (0 <= i && i < o.length) return t.events.disableBlur(), p(o[i]).focus(), e.stopPropagation(), !1;
                var s = d.find(".fr-buttons");
                if (s.length && u(s, Boolean(e.shiftKey))) return e.stopPropagation(), !1;
                if (h(a)) return e.stopPropagation(), !1
              } else {
                if (xt.KEYCODE.ENTER !== n || !e.target || "TEXTAREA" === e.target.tagName) return xt.KEYCODE.ESC === n ? (e.preventDefault(), e.stopPropagation(), t.accessibility.restoreSelection(), t.popups.isVisible(c) && d.findVisible(".fr-back").length ? (t.opts.toolbarInline && (t.events.disableBlur(), t.events.focus()), t.button.exec(d.findVisible(".fr-back").first()), y(d)) : t.popups.isVisible(c) && d.findVisible(".fr-dismiss").length ? t.button.exec(d.findVisible(".fr-dismiss").first()) : (t.popups.hide(c), t.opts.toolbarInline && t.toolbar.showInline(null, !0), y(d)), !1) : xt.KEYCODE.SPACE === n && (r.is(".fr-submit") || r.is(".fr-dismiss")) ? (e.preventDefault(), e.stopPropagation(), t.events.disableBlur(), t.button.exec(r), !0) : t.keys.isBrowserAction(e) ? void e.stopPropagation() : r.is("input[type=text], textarea") ? void e.stopPropagation() : xt.KEYCODE.SPACE === n && (r.is(".fr-link-attr") || r.is("input[type=file]")) ? void e.stopPropagation() : (e.stopPropagation(), e.preventDefault(), !1);
                var l = null;
                0 < d.findVisible(".fr-submit").length ? l = d.findVisible(".fr-submit").first() : d.findVisible(".fr-dismiss").length && (l = d.findVisible(".fr-dismiss").first()), l && (e.preventDefault(), e.stopPropagation(), t.events.disableBlur(), t.button.exec(l))
              }
            }, _tiMouseenter: function () {
              var e = d.data("instance") || f;
              L(e)
            }
          }
        }(e);
        a(t.find(".fr-buttons")), f.events.$on(t, "mouseenter", "tabIndex", n._tiMouseenter, !0), f.events.$on(t.children().not(".fr-buttons"), "keydown", "[tabIndex]", n._tiKeydown, !0), f.popups.onHide(e, function () {
          (t.data("instance") || f).accessibility.restoreSelection()
        }), f.popups.onShow(e, function () {
          o = !1, setTimeout(function () {
            o = !0
          }, 0)
        })
      }, registerToolbar: a, focusToolbarElement: l, focusToolbar: u, focusContent: h, focusPopup: function w(r) {
        var a = r.children().not(".fr-buttons");
        a.data("mouseenter-event-set") || (f.events.$on(a, "mouseenter", "[tabIndex]", function (e) {
          var t = r.data("instance") || f;
          if (!o) return e.stopPropagation(), void e.preventDefault();
          var n = a.find(":focus").first();
          n.length && !n.is("input, button, textarea, select") && (t.events.disableBlur(), n.blur(), t.events.disableBlur(), t.events.focus())
        }), a.data("mouseenter-event-set", !0)), !h(a) && f.shared.with_kb && u(r.find(".fr-buttons"))
      }, focusModal: function A(e) {
        f.core.hasFocus() || (f.events.disableBlur(), f.events.focus()), f.accessibility.saveSelection(), f.events.disableBlur(), f.el.blur(), f.selection.clear(), f.events.disableBlur(), f.shared.with_kb ? e.find(".fr-command[tabIndex], [tabIndex]").first().focus() : e.find("[tabIndex]").first().focus()
      }, focusEditor: E, focusPopupButton: y, focusModalButton: function T(e) {
        var t = e.data("modal-button");
        t && setTimeout(function () {
          l(t), e.data("modal-button", null)
        }, 0)
      }, hasFocus: function S() {
        return null !== f.shared.$f_el
      }, exec: function k(e, t) {
        var n = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, r = e.which, a = !1;
        return r !== xt.KEYCODE.TAB || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_RIGHT || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.TAB || n || !e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_LEFT || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_UP || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_DOWN || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ENTER && r !== xt.KEYCODE.SPACE || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ESC || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.F10 || n || e.shiftKey || !e.altKey || (a = c()) : a = function o(e) {
          if (f.shared.$f_el) {
            var t = d();
            return t ? (f.button.click(t), l(t)) : e.parent().findVisible(".fr-back").length ? (f.shared.with_kb = !1, f.opts.toolbarInline && (f.events.disableBlur(), f.events.focus()), f.button.exec(e.parent().findVisible(".fr-back")).first(), y(e.parent())) : f.shared.$f_el.is("button, .fr-group span") && (e.parent().is(".fr-popup") ? (f.accessibility.restoreSelection(), f.shared.$f_el = null, !1 !== f.events.trigger("toolbar.esc") && (f.popups.hide(e.parent()), f.opts.toolbarInline && f.toolbar.showInline(null, !0), y(e.parent()))) : E()), !1
          }
        }(t) : a = C() : a = function i() {
          return f.shared.$f_el && f.shared.$f_el.is(".fr-dropdown:not(.fr-active)") ? C() : b(!0)
        }() : a = function s() {
          return b()
        }() : a = v(t) : a = v(t, !0) : a = m(t) : a = m(t, !0), f.shared.$f_el || void 0 !== a || (a = !0), !a && f.keys.isBrowserAction(e) && (a = !0), !!a || (e.preventDefault(), e.stopPropagation(), !1)
      }, saveSelection: t, restoreSelection: function x() {
        f.$el.find(".fr-marker").length && (f.events.disableBlur(), f.selection.restore(), f.events.enableBlur())
      }
    }
  }, Object.assign(xt.DEFAULTS, {tooltips: !0}), xt.MODULES.tooltip = function (s) {
    var l = s.$;

    function r() {
      s.helpers.isMobile() || s.$tooltip && s.$tooltip.removeClass("fr-visible").css("left", "-3000px").css("position", "fixed")
    }

    function a(e, t) {
      if (!s.helpers.isMobile()) {
        var n = e.attr("id") && e.attr("id").split("-")[0], r = e.attr("title");
        if ("trackChanges" === n) r = s.opts.trackChangesEnabled ? "Disable Track Changes" : "Enable Track Changes"; else if ("showChanges" === n) r = s.opts.showChangesEnabled ? "Hide Changes" : "Show Changes"; else if (("applyAll" === n || "removeAll" === n || "applyLast" === n || "removeLast" === n) && 0 === s.track_changes.getPendingChanges().length) return;
        if (e.data("title", r), e.data("title")) {
          s.$tooltip || function i() {
            s.opts.tooltips && !s.helpers.isMobile() && (s.shared.$tooltip ? s.$tooltip = s.shared.$tooltip : (s.shared.$tooltip = l(s.doc.createElement("DIV")).addClass("fr-tooltip"), s.$tooltip = s.shared.$tooltip, s.opts.theme && s.$tooltip.addClass("".concat(s.opts.theme, "-theme")), l(s.o_doc).find("body").first().append(s.$tooltip)), s.events.on("shared.destroy", function () {
              s.$tooltip.html("").removeData().remove(), s.$tooltip = null
            }, !0))
          }(), e.removeAttr("title"), s.$tooltip.text(s.language.translate(e.data("title"))), s.$tooltip.addClass("fr-visible");
          var a = e.offset().left + (e.outerWidth() - s.$tooltip.outerWidth()) / 2;
          a < 0 && (a = 0), a + s.$tooltip.outerWidth() > l(s.o_win).width() && (a = l(s.o_win).width() - s.$tooltip.outerWidth()), void 0 === t && (t = s.opts.toolbarBottom), e.offset().top - l(window).scrollTop() + e.outerHeight() + 10 >= l(window).height() && (t = !0);
          var o = t ? e.offset().top - s.$tooltip.height() : e.offset().top + e.outerHeight();
          s.$tooltip.css("position", ""), s.$tooltip.css("left", a), s.$tooltip.css("top", Math.ceil(o)), "static" !== l(s.o_doc).find("body").first().css("position") ? (s.$tooltip.css("margin-left", -l(s.o_doc).find("body").first().offset().left), s.$tooltip.css("margin-top", -l(s.o_doc).find("body").first().offset().top)) : (s.$tooltip.css("margin-left", ""), s.$tooltip.css("margin-top", ""))
        }
      }
    }

    return {
      hide: r, to: a, bind: function o(e, t, n) {
        s.opts.tooltips && !s.helpers.isMobile() && (s.events.$on(e, "mouseover", t, function (e) {
          s.node.hasClass(e.currentTarget, "fr-disabled") || s.edit.isDisabled() || a(l(e.currentTarget), n)
        }, !0), s.events.$on(e, "mouseout ".concat(s._mousedown, " ").concat(s._mouseup), t, function () {
          r()
        }, !0))
      }
    }
  }, xt.TOOLBAR_VISIBLE_BUTTONS = 3, xt.MODULES.button = function (g) {
    var h = g.$, i = [];
    (g.opts.toolbarInline || g.opts.toolbarContainer) && (g.shared.buttons || (g.shared.buttons = []), i = g.shared.buttons);
    var s = [];

    function l(e, t, n) {
      for (var r = h(), a = 0; a < e.length; a++) {
        var o = h(e[a]);
        if (o.is(t) && (r = r.add(o)), n && o.is(".fr-dropdown")) {
          var i = o.next().find(t);
          r = r.add(i)
        }
      }
      return r
    }

    function m(e, t) {
      var n, r = h();
      if (!e) return r;
      for (n in r = (r = r.add(l(i, e, t))).add(l(s, e, t)), g.shared.popups) if (Object.prototype.hasOwnProperty.call(g.shared.popups, n)) {
        var a = g.shared.popups[n].children().find(e);
        r = r.add(a)
      }
      for (n in g.shared.modals) if (Object.prototype.hasOwnProperty.call(g.shared.modals, n)) {
        var o = g.shared.modals[n].$modal.find(e);
        r = r.add(o)
      }
      return r
    }

    function a(e) {
      var t = e.next(), n = g.node.hasClass(e.get(0), "fr-active"), r = m(".fr-dropdown.fr-active").not(e),
        a = e.parents(".fr-toolbar, .fr-popup").data("instance") || g;
      a.helpers.isIOS() && !a.el.querySelector(".fr-marker") && (a.selection.save(), a.selection.clear(), a.selection.restore()), t.parents(".fr-more-toolbar").addClass("fr-overflow-visible");
      var o = 0, i = 0, s = t.find("> .fr-dropdown-wrapper");
      if (!n) {
        var l = e.data("cmd");
        t.find(".fr-command").removeClass("fr-active").attr("aria-selected", !1), xt.COMMANDS[l] && xt.COMMANDS[l].refreshOnShow && xt.COMMANDS[l].refreshOnShow.apply(a, [e, t]), t.css("left", e.offset().left - e.parents(".fr-btn-wrap, .fr-toolbar, .fr-buttons").offset().left - ("rtl" === g.opts.direction ? t.width() - e.outerWidth() : 0)), t.addClass("test-height"), o = t.outerHeight(), i = g.helpers.getPX(s.css("max-height")), t.removeClass("test-height"), t.css("top", "").css("bottom", "");
        var c = e.outerHeight() / 10;
        if (!g.opts.toolbarBottom && t.offset().top + e.outerHeight() + o < h(g.o_doc).height()) t.css("top", e.position().top + e.outerHeight() - c); else {
          var d = 0, f = e.parents(".fr-more-toolbar");
          0 < f.length && (d = f.first().height()), t.css("bottom", e.parents(".fr-popup, .fr-toolbar").first().height() - d - e.position().top)
        }
      }
      (e.addClass("fr-blink").toggleClass("fr-active"), e.hasClass("fr-options")) && e.prev().toggleClass("fr-expanded");
      e.hasClass("fr-active") ? (t.attr("aria-hidden", !1), e.attr("aria-expanded", !0), function u(e, t, n) {
        n <= t && (e.parent().css("overflow", "auto"), e.parent().css("overflow-x", "hidden")), e.css("height", Math.min(t, n))
      }(s, o, i)) : (t.attr("aria-hidden", !0).css("overflow", ""), e.attr("aria-expanded", !1), s.css("height", "")), setTimeout(function () {
        e.removeClass("fr-blink")
      }, 300), t.css("margin-left", ""), t.offset().left + t.outerWidth() > g.$sc.offset().left + g.$sc.width() && t.css("margin-left", -(t.offset().left + t.outerWidth() - g.$sc.offset().left - g.$sc.width())), t.offset().left < g.$sc.offset().left && "rtl" === g.opts.direction && t.css("margin-left", g.$sc.offset().left), r.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), r.prev(".fr-expanded").removeClass("fr-expanded"), r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", ""), 0 !== e.parents(".fr-popup").length || g.opts.toolbarInline || (g.node.hasClass(e.get(0), "fr-active") ? g.$tb.css("zIndex", (g.opts.zIndex || 1) + 4) : g.$tb.css("zIndex", ""));
      var p = t.find("a.fr-command.fr-active").first();
      g.helpers.isMobile() || (p.length ? (g.accessibility.focusToolbarElement(p), s.scrollTop(Math.abs(p.parents(".fr-dropdown-content").offset().top - p.offset().top) - p.offset().top)) : (g.accessibility.focusToolbarElement(e), s.scrollTop(0)))
    }

    function o(e) {
      e.addClass("fr-blink"), setTimeout(function () {
        e.removeClass("fr-blink")
      }, 500);
      for (var t = e.data("cmd"), n = []; void 0 !== e.data("param".concat(n.length + 1));) n.push(e.data("param".concat(n.length + 1)));
      var r = m(".fr-dropdown.fr-active");
      r.length && (r.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), r.prev(".fr-expanded").removeClass("fr-expanded"), r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", "")), e.parents(".fr-popup, .fr-toolbar").data("instance").commands.exec(t, n)
    }

    function t(e) {
      var t = e.parents(".fr-popup, .fr-toolbar").data("instance");
      if (0 === e.parents(".fr-popup").length && e.data("popup") && !e.hasClass("fr-btn-active-popup") && e.addClass("fr-btn-active-popup"), 0 !== e.parents(".fr-popup").length || e.data("popup") || t.popups.hideAll(), t.popups.areVisible() && !t.popups.areVisible(t)) {
        for (var n = 0; n < xt.INSTANCES.length; n++) xt.INSTANCES[n] !== t && xt.INSTANCES[n].popups && xt.INSTANCES[n].popups.areVisible() && xt.INSTANCES[n].$el.find(".fr-marker").remove();
        t.popups.hideAll()
      }
      g.node.hasClass(e.get(0), "fr-dropdown") ? a(e) : (!function r(e) {
        o(e)
      }(e), xt.COMMANDS[e.data("cmd")] && !1 !== xt.COMMANDS[e.data("cmd")].refreshAfterCallback && t.button.bulkRefresh())
    }

    function c(e) {
      t(h(e.currentTarget))
    }

    function d(e) {
      var t = e.find(".fr-dropdown.fr-active");
      t.length && (t.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), t.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", ""), t.prev().removeClass("fr-expanded"))
    }

    function f(e) {
      e.preventDefault(), e.stopPropagation()
    }

    function p(e) {
      if (e.stopPropagation(), !g.helpers.isMobile()) return !1
    }

    function v(e) {
      var t = 1 < arguments.length && arguments[1] !== undefined ? arguments[1] : {},
        n = 2 < arguments.length ? arguments[2] : undefined;
      if (g.helpers.isMobile() && !1 === t.showOnMobile) return "";
      var r = t.displaySelection;
      "function" == typeof r && (r = r(g));
      var a = "";
      if ("options" !== t.type) if (r) {
        var o = "function" == typeof t.defaultSelection ? t.defaultSelection(g) : t.defaultSelection;
        a = '<span style="width:'.concat(t.displaySelectionWidth || 100, 'px">').concat(g.language.translate(o || t.title), "</span>")
      } else a = g.icon.create(t.icon || e), a += '<span class="fr-sr-only">'.concat(g.language.translate(t.title) || "", "</span>");
      var i = t.popup ? ' data-popup="true"' : "", s = t.modal ? ' data-modal="true"' : "",
        l = g.shortcuts.get("".concat(e, "."));
      l = l ? " (".concat(l, ")") : "";
      var c = "".concat(e, "-").concat(g.id), d = "dropdown-menu-".concat(c),
        f = '<button id="'.concat(c, '"').concat(t.more_btn ? ' data-group-name="'.concat(c, '" ') : "", 'type="button" tabIndex="-1" role="button"').concat(t.toggle ? ' aria-pressed="false"' : "").concat("dropdown" === t.type || "options" === t.type ? ' aria-controls="'.concat(d, '" aria-expanded="false" aria-haspopup="true"') : "").concat(t.disabled ? ' aria-disabled="true"' : "", ' title="').concat(g.language.translate(t.title) || "").concat(l, '" class="fr-command fr-btn').concat("dropdown" === t.type || "options" == t.type ? " fr-dropdown" : "").concat("options" == t.type ? " fr-options" : "").concat("more" == t.type ? " fr-more" : "").concat(t.displaySelection ? " fr-selection" : "").concat(t.back ? " fr-back" : "").concat(t.disabled ? " fr-disabled" : "").concat(n ? "" : " fr-hidden", '" data-cmd="').concat(e, '"').concat(i).concat(s, ">").concat(a, "</button>");
      if ("dropdown" === t.type || "options" === t.type) {
        var p = '<div id="'.concat(d, '" class="fr-dropdown-menu" role="listbox" aria-labelledby="').concat(c, '" aria-hidden="true"><div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">');
        p += function u(e, t) {
          var n = "";
          if (t.html) "function" == typeof t.html ? n += t.html.call(g) : n += t.html; else {
            var r = t.options;
            for (var a in "function" == typeof r && (r = r()), n += '<ul class="fr-dropdown-list" role="presentation">', r) if (Object.prototype.hasOwnProperty.call(r, a)) {
              var o = g.shortcuts.get("".concat(e, ".").concat(a));
              o = o ? '<span class="fr-shortcut">'.concat(o, "</span>") : "", n += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="'.concat("options" === t.type ? e.replace(/Options/g, "") : e, '" data-param1="').concat(a, '" title="').concat(r[a], '">').concat(g.language.translate(r[a]), "</a></li>")
            }
            n += "</ul>"
          }
          return n
        }(e, t), f += p += "</div></div></div>"
      }
      return t.hasOptions && t.hasOptions.apply(g) && (f = '<div class="fr-btn-wrap">'.concat(f, " ").concat(v(e + "Options", Object.assign({}, t, {
        type: "options",
        hasOptions: !1
      }), n), "  </div>")), f
    }

    function e(a) {
      var o = g.$tb && g.$tb.data("instance") || g;
      if (!1 === g.events.trigger("buttons.refresh")) return !0;
      setTimeout(function () {
        for (var e = o.selection.inEditor() && o.core.hasFocus(), t = 0; t < a.length; t++) {
          var n = h(a[t]), r = n.data("cmd");
          0 === n.parents(".fr-popup").length ? e || xt.COMMANDS[r] && xt.COMMANDS[r].forcedRefresh ? o.button.refresh(n) : g.node.hasClass(n.get(0), "fr-dropdown") || (n.removeClass("fr-active"), n.attr("aria-pressed") && n.attr("aria-pressed", !1)) : n.parents(".fr-popup").isVisible() && o.button.refresh(n)
        }
      }, 0)
    }

    function n() {
      e(i), e(s)
    }

    function r() {
      i = [], s = []
    }

    g.shared.popup_buttons || (g.shared.popup_buttons = []), s = g.shared.popup_buttons;
    var u = null;

    function b() {
      clearTimeout(u), u = setTimeout(n, 50)
    }

    return {
      _init: function C() {
        g.opts.toolbarInline ? g.events.on("toolbar.show", n) : (g.events.on("mouseup", b), g.events.on("keyup", b), g.events.on("blur", b), g.events.on("focus", b), g.events.on("contentChanged", b), g.helpers.isMobile() && g.events.$on(g.$doc, "selectionchange", n)), g.events.on("shared.destroy", r)
      }, build: v, buildList: function E(e, t) {
        for (var n = "", r = 0; r < e.length; r++) {
          var a = e[r], o = xt.COMMANDS[a];
          o && "undefined" != typeof o.plugin && g.opts.pluginsEnabled.indexOf(o.plugin) < 0 || (o ? n += v(a, o, void 0 === t || 0 <= t.indexOf(a)) : "|" === a ? n += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>' : "-" === a && (n += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>'))
        }
        return n
      }, buildGroup: function y(e) {
        var t = "", n = "";
        for (var r in e) {
          var a = e[r];
          if (a.buttons) {
            for (var o = "", i = "", s = 0, l = "left", c = xt.TOOLBAR_VISIBLE_BUTTONS, d = 0; d < a.buttons.length; d++) {
              var f = a.buttons[d], p = xt.COMMANDS[f];
              p || ("|" == f ? o += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>' : "-" == f && (o += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>')), !p || p && "undefined" != typeof p.plugin && g.opts.pluginsEnabled.indexOf(p.plugin) < 0 || (e[r].align !== undefined && (l = e[r].align), e[r].buttonsVisible !== undefined && (c = e[r].buttonsVisible), e.showMoreButtons && c <= s ? i += v(f, p, !0) : o += v(f, p, !0), s++)
            }
            if (e.showMoreButtons && c < s) {
              var u = r, h = xt.COMMANDS[u];
              h.more_btn = !0, o += v(u, h, !0)
            }
            "trackChanges" !== r && (t += '<div class="fr-btn-grp fr-float-'.concat(l, '">').concat(o, "</div>")), e.showMoreButtons && 0 < i.length && (n += '<div class="fr-more-toolbar" data-name="'.concat(r + "-" + g.id, '">').concat(i, "</div>"))
          }
        }
        return g.opts.toolbarBottom ? g.helpers.isMobile() ? '<div class="fr-bottom-extended">'.concat(n, "</div><div>").concat(t, "</div>") : "".concat(n, '<div class="fr-newline"></div>').concat(t) : "".concat(t, '<div class="fr-newline"></div>').concat(n)
      }, bindCommands: function L(t, e) {
        g.events.bindClick(t, ".fr-command:not(.fr-disabled)", c), g.events.$on(t, "".concat(g._mousedown, " ").concat(g._mouseup, " ").concat(g._move), ".fr-dropdown-menu", f, !0), g.events.$on(t, "".concat(g._mousedown, " ").concat(g._mouseup, " ").concat(g._move), ".fr-dropdown-menu .fr-dropdown-wrapper", p, !0);
        var n = t.get(0).ownerDocument, r = "defaultView" in n ? n.defaultView : n.parentWindow;

        function a(e) {
          (!e || e.type === g._mouseup && e.target !== h("html").get(0) || "keydown" === e.type && (g.keys.isCharacter(e.which) && !g.keys.ctrlKey(e) || e.which === xt.KEYCODE.ESC)) && d(t)
        }

        g.events.$on(h(r), "".concat(g._mouseup, " resize keydown"), a, !0), g.opts.iframe && g.events.$on(g.$win, g._mouseup, a, !0), g.node.hasClass(t.get(0), "fr-popup") ? h.merge(s, t.find(".fr-btn").toArray()) : h.merge(i, t.find(".fr-btn").toArray()), g.tooltip.bind(t, ".fr-btn, .fr-title", e)
      }, refresh: function _(e) {
        var t, n = e.parents(".fr-popup, .fr-toolbar").data("instance") || g, r = e.data("cmd");
        g.node.hasClass(e.get(0), "fr-dropdown") ? t = e.next() : (e.removeClass("fr-active"), e.attr("aria-pressed") && e.attr("aria-pressed", !1)), xt.COMMANDS[r] && xt.COMMANDS[r].refresh ? xt.COMMANDS[r].refresh.apply(n, [e, t]) : g.refresh[r] && n.refresh[r](e, t)
      }, bulkRefresh: n, exec: o, click: t, hideActiveDropdowns: d, addButtons: function w(e) {
        for (var t = 0; t < e.length; t++) i.push(e[t])
      }, getButtons: m, getPosition: function A(e) {
        var t = e.offset().left, n = g.opts.toolbarBottom ? 10 : e.outerHeight() - 10;
        return {left: t, top: e.offset().top + n}
      }
    }
  }, xt.ICON_TEMPLATES = {
    font_awesome: '<i class="fa fa-[NAME]" aria-hidden="true"></i>',
    font_awesome_5: '<i class="fas fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5r: '<i class="far fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5l: '<i class="fal fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5b: '<i class="fab fa-[FA5NAME]" aria-hidden="true"></i>',
    text: '<span style="text-align: center;">[NAME]</span>',
    image: "<img src=[SRC] alt=[ALT] />",
    svg: '<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="[PATH]"/></svg>',
    empty: " "
  }, xt.ICONS = {
    bold: {NAME: "bold", SVG_KEY: "bold"},
    italic: {NAME: "italic", SVG_KEY: "italic"},
    underline: {NAME: "underline", SVG_KEY: "underline"},
    strikeThrough: {NAME: "strikethrough", SVG_KEY: "strikeThrough"},
    subscript: {NAME: "subscript", SVG_KEY: "subscript"},
    superscript: {NAME: "superscript", SVG_KEY: "superscript"},
    cancel: {NAME: "cancel", SVG_KEY: "cancel"},
    color: {NAME: "tint", SVG_KEY: "textColor"},
    outdent: {NAME: "outdent", SVG_KEY: "outdent"},
    indent: {NAME: "indent", SVG_KEY: "indent"},
    undo: {NAME: "rotate-left", FA5NAME: "undo", SVG_KEY: "undo"},
    redo: {NAME: "rotate-right", FA5NAME: "redo", SVG_KEY: "redo"},
    insert: {NAME: "insert", SVG_KEY: "insert"},
    insertAll: {NAME: "insertAll", SVG_KEY: "insertAll"},
    insertHR: {NAME: "minus", SVG_KEY: "horizontalLine"},
    clearFormatting: {NAME: "eraser", SVG_KEY: "clearFormatting"},
    selectAll: {NAME: "mouse-pointer", SVG_KEY: "selectAll"},
    minimize: {NAME: "minimize", SVG_KEY: "minimize"},
    moreText: {NAME: "ellipsis-v", SVG_KEY: "textMore"},
    moreParagraph: {NAME: "ellipsis-v", SVG_KEY: "paragraphMore"},
    moreRich: {NAME: "ellipsis-v", SVG_KEY: "insertMore"},
    moreMisc: {NAME: "ellipsis-v", SVG_KEY: "more"}
  }, xt.DefineIconTemplate = function (e, t) {
    xt.ICON_TEMPLATES[e] = t
  }, xt.DefineIcon = function (e, t) {
    xt.ICONS[e] = t
  }, Object.assign(xt.DEFAULTS, {iconsTemplate: "svg"}), xt.MODULES.icon = function (a) {
    return {
      create: function o(n) {
        var e = null, r = xt.ICONS[n];
        if (void 0 !== r) {
          var t = r.template || xt.ICON_DEFAULT_TEMPLATE || a.opts.iconsTemplate;
          t && t.apply && (t = t.apply(a)), r.FA5NAME || (r.FA5NAME = r.NAME), "svg" !== t || r.PATH || (r.PATH = xt.SVG[r.SVG_KEY] || ""), t && (t = xt.ICON_TEMPLATES[t]) && (e = t.replace(/\[([a-zA-Z0-9]*)\]/g, function (e, t) {
            return "NAME" === t ? r[t] || n : r[t]
          }))
        }
        return e || n
      }, getTemplate: function r(e) {
        var t = xt.ICONS[e], n = a.opts.iconsTemplate;
        return void 0 !== t ? n = t.template || xt.ICON_DEFAULT_TEMPLATE || a.opts.iconsTemplate : n
      }, getFileIcon: function n(e) {
        var t = xt.FILEICONS[e];
        return void 0 !== t ? t : e
      }
    }
  }, xt.SVG = {
    add: "M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z",
    advancedImageEditor: "M3,17v2h6v-2H3z M3,5v2h10V5H3z M13,21v-2h8v-2h-8v-2h-2v6H13z M7,9v2H3v2h4v2h2V9H7z M21,13v-2H11v2H21z M15,9h2V7h4V5h-4  V3h-2V9z",
    alignCenter: "M9,18h6v-2H9V18z M6,11v2h12v-2H6z M3,6v2h18V6H3z",
    alignJustify: "M3,18h18v-2H3V18z M3,11v2h18v-2H3z M3,6v2h18V6H3z",
    alignLeft: "M3,18h6v-2H3V18z M3,11v2h12v-2H3z M3,6v2h18V6H3z",
    alignRight: "M15,18h6v-2h-6V18z M9,11v2h12v-2H9z M3,6v2h18V6H3z",
    anchors: "M16,4h-4H8C6.9,4,6,4.9,6,6v4v10l6-2.6l6,2.6V10V6C18,4.9,17.1,4,16,4z M16,17l-4-1.8L8,17v-7V6h4h4v4V17z",
    autoplay: "M 7.570312 0.292969 C 7.542969 0.292969 7.515625 0.292969 7.488281 0.296875 C 7.203125 0.324219 6.984375 0.539062 6.980469 0.792969 L 6.925781 3.535156 C 2.796875 3.808594 -0.0078125 6.425781 -0.0859375 10.09375 C -0.121094 11.96875 0.710938 13.6875 2.265625 14.921875 C 3.769531 16.117188 5.839844 16.796875 8.097656 16.828125 C 8.140625 16.828125 12.835938 16.898438 13.035156 16.886719 C 15.171875 16.796875 17.136719 16.128906 18.558594 15.003906 C 20.066406 13.816406 20.882812 12.226562 20.917969 10.40625 C 20.960938 8.410156 20.023438 6.605469 18.289062 5.335938 C 18.214844 5.277344 18.128906 5.230469 18.035156 5.203125 C 17.636719 5.074219 17.222656 5.199219 17 5.476562 L 15.546875 7.308594 C 15.304688 7.609375 15.363281 8.007812 15.664062 8.265625 C 16.351562 8.851562 16.707031 9.625 16.6875 10.5 C 16.652344 12.25 15.070312 13.390625 12.757812 13.535156 C 12.59375 13.539062 8.527344 13.472656 8.164062 13.464844 C 5.703125 13.429688 4.101562 12.191406 4.140625 10.3125 C 4.175781 8.570312 5.132812 7.46875 6.847656 7.199219 L 6.796875 9.738281 C 6.792969 9.992188 7 10.214844 7.285156 10.253906 C 7.3125 10.257812 7.339844 10.257812 7.367188 10.257812 C 7.503906 10.261719 7.632812 10.222656 7.738281 10.148438 L 14.039062 5.785156 C 14.171875 5.691406 14.253906 5.558594 14.253906 5.410156 C 14.257812 5.261719 14.1875 5.125 14.058594 5.027344 L 7.941406 0.414062 C 7.835938 0.335938 7.707031 0.292969 7.570312 0.292969 ",
    back: "M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z",
    backgroundColor: "M9.91752,12.24082l7.74791-5.39017,1.17942,1.29591-6.094,7.20747L9.91752,12.24082M7.58741,12.652l4.53533,4.98327a.93412.93412,0,0,0,1.39531-.0909L20.96943,8.7314A.90827.90827,0,0,0,20.99075,7.533l-2.513-2.76116a.90827.90827,0,0,0-1.19509-.09132L7.809,11.27135A.93412.93412,0,0,0,7.58741,12.652ZM2.7939,18.52772,8.41126,19.5l1.47913-1.34617-3.02889-3.328Z",
    blockquote: "M10.31788,5l.93817,1.3226A12.88271,12.88271,0,0,0,8.1653,9.40125a5.54242,5.54242,0,0,0-.998,3.07866v.33733q.36089-.04773.66067-.084a4.75723,4.75723,0,0,1,.56519-.03691,2.87044,2.87044,0,0,1,2.11693.8427,2.8416,2.8416,0,0,1,.8427,2.09274,3.37183,3.37183,0,0,1-.8898,2.453A3.143,3.143,0,0,1,8.10547,19,3.40532,3.40532,0,0,1,5.375,17.7245,4.91156,4.91156,0,0,1,4.30442,14.453,9.3672,9.3672,0,0,1,5.82051,9.32933,14.75716,14.75716,0,0,1,10.31788,5Zm8.39243,0,.9369,1.3226a12.88289,12.88289,0,0,0-3.09075,3.07865,5.54241,5.54241,0,0,0-.998,3.07866v.33733q.33606-.04773.63775-.084a4.91773,4.91773,0,0,1,.58938-.03691,2.8043,2.8043,0,0,1,2.1042.83,2.89952,2.89952,0,0,1,.80578,2.10547,3.42336,3.42336,0,0,1-.86561,2.453A3.06291,3.06291,0,0,1,16.49664,19,3.47924,3.47924,0,0,1,13.742,17.7245,4.846,4.846,0,0,1,12.64721,14.453,9.25867,9.25867,0,0,1,14.17476,9.3898,15.26076,15.26076,0,0,1,18.71031,5Z",
    bold: "M15.25,11.8h0A3.68,3.68,0,0,0,17,9a3.93,3.93,0,0,0-3.86-4H6.65V19h7a3.74,3.74,0,0,0,3.7-3.78V15.1A3.64,3.64,0,0,0,15.25,11.8ZM8.65,7h4.2a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61,2.23,2.23,0,0,1-.63.09H8.65Zm4.6,10H8.65V13h4.6a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61A2.23,2.23,0,0,1,13.25,17Z",
    cancel: "M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",
    cellBackground: "M16.6,12.4L7.6,3.5L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4  l5.5-5.5C17.2,14,17.2,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2  C21,17.2,19,15,19,15z",
    cellBorderColor: "M22,22H2v2h20V22z",
    cellOptions: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M9.5,6.5h5V9h-5V6.5z M8,17.5H4  c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z   M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4  c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0V9z",
    cellStyle: "M20,19.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L12.3,17h3.8l1.7-3.5l1.4,3.5H23L20,19.9z M20,5H4C2.9,5,2,5.9,2,7v10  c0,1.1,0.9,2,2,2h7.5l-0.6-0.6L10,17.5H9.5V15h5.4l1.1-2.3v-2.2h4.5v3H20l0.6,1.5H22V7C22,5.9,21.1,5,20,5z M3.5,7  c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0.1,0h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M4,17.5c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0-0.1v-2H8v2.5H4  z M14.5,9h-5V6.5h5V9z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1V9z",
    clearFormatting: "M11.48,10.09l-1.2-1.21L8.8,7.41,6.43,5,5.37,6.1,8.25,9,4.66,19h2l1.43-4h5.14l1.43,4h2l-.89-2.51L18.27,19l1.07-1.06L14.59,13.2ZM8.8,13l.92-2.56L12.27,13Zm.56-7.15L9.66,5h2l1.75,4.9Z",
    close: "M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",
    codeView: "M9.4,16.6,4.8,12,9.4,7.4,8,6,2,12l6,6Zm5.2,0L19.2,12,14.6,7.4,16,6l6,6-6,6Z",
    cogs: "M18.877 12.907a6.459 6.459 0 0 0 0 -1.814l1.952 -1.526a0.468 0.468 0 0 0 0.111 -0.593l-1.851 -3.2a0.461 0.461 0 0 0 -0.407 -0.231 0.421 0.421 0 0 0 -0.157 0.028l-2.3 0.925a6.755 6.755 0 0 0 -1.563 -0.907l-0.352 -2.452a0.451 0.451 0 0 0 -0.453 -0.388h-3.7a0.451 0.451 0 0 0 -0.454 0.388L9.347 5.588A7.077 7.077 0 0 0 7.783 6.5l-2.3 -0.925a0.508 0.508 0 0 0 -0.166 -0.028 0.457 0.457 0 0 0 -0.4 0.231l-1.851 3.2a0.457 0.457 0 0 0 0.111 0.593l1.952 1.526A7.348 7.348 0 0 0 5.063 12a7.348 7.348 0 0 0 0.064 0.907L3.175 14.433a0.468 0.468 0 0 0 -0.111 0.593l1.851 3.2a0.461 0.461 0 0 0 0.407 0.231 0.421 0.421 0 0 0 0.157 -0.028l2.3 -0.925a6.74 6.74 0 0 0 1.564 0.907L9.7 20.864a0.451 0.451 0 0 0 0.454 0.388h3.7a0.451 0.451 0 0 0 0.453 -0.388l0.352 -2.452a7.093 7.093 0 0 0 1.563 -0.907l2.3 0.925a0.513 0.513 0 0 0 0.167 0.028 0.457 0.457 0 0 0 0.4 -0.231l1.851 -3.2a0.468 0.468 0 0 0 -0.111 -0.593Zm-0.09 2.029l-0.854 1.476 -2.117 -0.852 -0.673 0.508a5.426 5.426 0 0 1 -1.164 0.679l-0.795 0.323 -0.33 2.269h-1.7l-0.32 -2.269 -0.793 -0.322a5.3 5.3 0 0 1 -1.147 -0.662L8.2 15.56l-2.133 0.86 -0.854 -1.475 1.806 -1.411 -0.1 -0.847c-0.028 -0.292 -0.046 -0.5 -0.046 -0.687s0.018 -0.4 0.045 -0.672l0.106 -0.854L5.217 9.064l0.854 -1.475 2.117 0.851 0.673 -0.508a5.426 5.426 0 0 1 1.164 -0.679l0.8 -0.323 0.331 -2.269h1.7l0.321 2.269 0.792 0.322a5.3 5.3 0 0 1 1.148 0.661l0.684 0.526 2.133 -0.859 0.853 1.473 -1.8 1.421 0.1 0.847a5 5 0 0 1 0.046 0.679c0 0.193 -0.018 0.4 -0.045 0.672l-0.106 0.853ZM12 14.544A2.544 2.544 0 1 1 14.546 12 2.552 2.552 0 0 1 12 14.544Z",
    columns: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z M20.5,17  c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0  V9z",
    edit: "M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z",
    exitFullscreen: "M5,16H8v3h2V14H5ZM8,8H5v2h5V5H8Zm6,11h2V16h3V14H14ZM16,8V5H14v5h5V8Z",
    fileInsert: "M 8.09375 12.75 L 5.90625 12.75 C 5.542969 12.75 5.25 12.394531 5.25 11.953125 L 5.25 6.375 L 2.851562 6.375 C 2.367188 6.375 2.121094 5.660156 2.464844 5.242188 L 6.625 0.1875 C 6.832031 -0.0585938 7.167969 -0.0585938 7.371094 0.1875 L 11.535156 5.242188 C 11.878906 5.660156 11.632812 6.375 11.148438 6.375 L 8.75 6.375 L 8.75 11.953125 C 8.75 12.394531 8.457031 12.75 8.09375 12.75 Z M 14 12.484375 L 14 16.203125 C 14 16.644531 13.707031 17 13.34375 17 L 0.65625 17 C 0.292969 17 0 16.644531 0 16.203125 L 0 12.484375 C 0 12.042969 0.292969 11.6875 0.65625 11.6875 L 4.375 11.6875 L 4.375 11.953125 C 4.375 12.980469 5.0625 13.8125 5.90625 13.8125 L 8.09375 13.8125 C 8.9375 13.8125 9.625 12.980469 9.625 11.953125 L 9.625 11.6875 L 13.34375 11.6875 C 13.707031 11.6875 14 12.042969 14 12.484375 Z M 10.609375 15.40625 C 10.609375 15.039062 10.363281 14.742188 10.0625 14.742188 C 9.761719 14.742188 9.515625 15.039062 9.515625 15.40625 C 9.515625 15.773438 9.761719 16.070312 10.0625 16.070312 C 10.363281 16.070312 10.609375 15.773438 10.609375 15.40625 Z M 12.359375 15.40625 C 12.359375 15.039062 12.113281 14.742188 11.8125 14.742188 C 11.511719 14.742188 11.265625 15.039062 11.265625 15.40625 C 11.265625 15.773438 11.511719 16.070312 11.8125 16.070312 C 12.113281 16.070312 12.359375 15.773438 12.359375 15.40625 Z M 12.359375 15.40625 ",
    fileManager: "M 0 5.625 L 20.996094 5.625 L 21 15.75 C 21 16.371094 20.410156 16.875 19.6875 16.875 L 1.3125 16.875 C 0.585938 16.875 0 16.371094 0 15.75 Z M 0 5.625 M 21 4.5 L 0 4.5 L 0 2.25 C 0 1.628906 0.585938 1.125 1.3125 1.125 L 6.921875 1.125 C 7.480469 1.125 8.015625 1.316406 8.40625 1.652344 L 9.800781 2.847656 C 10.195312 3.183594 10.730469 3.375 11.289062 3.375 L 19.6875 3.375 C 20.414062 3.375 21 3.878906 21 4.5 Z M 21 4.5",
    markdown: "M5.55006 17.75V7.35L8.96006 16.89H10.7101L14.2301 7.37V14.0729C14.3951 14.1551 14.5499 14.265 14.6875 14.4026L14.7001 14.4151V11.64C14.7001 10.8583 15.2127 10.1963 15.9201 9.97171V5H13.6801L10.0401 14.86L6.51006 5H4.00006V17.75H5.55006ZM17.2001 11.64C17.2001 11.2258 16.8643 10.89 16.4501 10.89C16.0359 10.89 15.7001 11.2258 15.7001 11.64V16.8294L13.9804 15.1097C13.6875 14.8168 13.2126 14.8168 12.9197 15.1097C12.6269 15.4026 12.6269 15.8775 12.9197 16.1703L15.9197 19.1703C16.2126 19.4632 16.6875 19.4632 16.9804 19.1703L19.9804 16.1703C20.2733 15.8775 20.2733 15.4026 19.9804 15.1097C19.6875 14.8168 19.2126 14.8168 18.9197 15.1097L17.2001 16.8294V11.64Z",
    fontAwesome: "M18.99018,13.98212V7.52679c-.08038-1.21875-1.33929-.683-1.33929-.683-2.933,1.39282-4.36274.61938-5.85938.15625a6.23272,6.23272,0,0,0-2.79376-.20062l-.00946.004A1.98777,1.98777,0,0,0,7.62189,5.106a.984.984,0,0,0-.17517-.05432c-.02447-.0055-.04882-.01032-.0736-.0149A.9565.9565,0,0,0,7.1908,5H6.82539a.9565.9565,0,0,0-.18232.0368c-.02472.00458-.04907.0094-.07348.01484a.985.985,0,0,0-.17523.05438,1.98585,1.98585,0,0,0-.573,3.49585v9.394A1.004,1.004,0,0,0,6.82539,19H7.1908a1.00406,1.00406,0,0,0,1.00409-1.00409V15.52234c3.64221-1.09827,5.19709.64282,7.09888.57587a5.57291,5.57291,0,0,0,3.25446-1.05805A1.2458,1.2458,0,0,0,18.99018,13.98212Z",
    fontFamily: "M16,19h2L13,5H11L6,19H8l1.43-4h5.14Zm-5.86-6L12,7.8,13.86,13Z",
    fontSize: "M20.75,19h1.5l-3-10h-1.5l-3,10h1.5L17,16.5h3Zm-3.3-4,1.05-3.5L19.55,15Zm-5.7,4h2l-5-14h-2l-5,14h2l1.43-4h5.14ZM5.89,13,7.75,7.8,9.61,13Z",
    fullscreen: "M7,14H5v5h5V17H7ZM5,10H7V7h3V5H5Zm12,7H14v2h5V14H17ZM14,5V7h3v3h2V5Z",
    help: "M11,17h2v2h-2V17z M12,5C9.8,5,8,6.8,8,9h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.7-3,5v1h2v-1c0-2.2,3-2.5,3-5  C16,6.8,14.2,5,12,5z",
    horizontalLine: "M5,12h14 M19,11H5v2h14V11z",
    imageAltText: "M19,7h-6v12h-2V7H5V5h6h2h6V7z",
    imageCaption: "M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z M22,22H2v2h20V22z",
    imageClass: "M9.5,13.4l-2.9-2.9h3.8L12.2,7l1.4,3.5h3.8l-3,2.9l0.9,3.6L12,15.1L8.8,17L9.5,13.4z M22,6v12c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,6H4v12h16V8.8V6z",
    imageDisplay: "M3,5h18v2H3V5z M13,9h8v2h-8V9z M13,13h8v2h-8V13z M3,17h18v2H3V17z M3,9h8v6H3V9z",
    imageManager: "M20,6h-7l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h6.2l2,2H20V18z   M18,16l-3.8-5H14l-2.9,3.8L9,12.1L6,16H18z M10,9.5C10,8.7,9.3,8,8.5,8S7,8.7,7,9.5S7.7,11,8.5,11S10,10.3,10,9.5z",
    imageSize: "M16.9,4c-0.3,0-0.5,0.2-0.8,0.3L3.3,13c-0.9,0.6-1.1,1.9-0.5,2.8l2.2,3.3c0.4,0.7,1.2,1,2,0.8c0.3,0,0.5-0.2,0.8-0.3  L20.7,11c0.9-0.6,1.1-1.9,0.5-2.8l-2.2-3.3C18.5,4.2,17.7,3.9,16.9,4L16.9,4z M16.9,9.9L18.1,9l-2-2.9L17,5.6c0.1,0,0.1-0.1,0.2-0.1  c0.2,0,0.4,0,0.5,0.2L19.9,9c0.2,0.2,0.1,0.5-0.1,0.7L7,18.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.4,0-0.5-0.2L4.1,15  c-0.2-0.2-0.1-0.5,0.1-0.7L5,13.7l2,2.9l1.2-0.8l-2-2.9L7.5,12l1.1,1.7l1.2-0.8l-1.1-1.7l1.2-0.8l2,2.9l1.2-0.8l-2-2.9l1.2-0.8  l1.1,1.7l1.2-0.8l-1.1-1.7L14.9,7L16.9,9.9z",
    indent: "M3,9v6l3-3L3,9z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",
    inlineClass: "M9.9,13.313A1.2,1.2,0,0,1,9.968,13H6.277l1.86-5.2,1.841,5.148A1.291,1.291,0,0,1,11.212,12h.426l-2.5-7h-2l-5,14h2l1.43-4H9.9Zm2.651,6.727a2.884,2.884,0,0,1-.655-2.018v-2.71A1.309,1.309,0,0,1,13.208,14h3.113a3.039,3.039,0,0,1,2,1.092s1.728,1.818,2.964,2.928a1.383,1.383,0,0,1,.318,1.931,1.44,1.44,0,0,1-.19.215l-3.347,3.31a1.309,1.309,0,0,1-1.832.258h0a1.282,1.282,0,0,1-.258-.257l-1.71-1.728Zm2.48-3.96a.773.773,0,1,0,.008,0Z",
    inlineStyle: "M11.88,15h.7l.7-1.7-3-8.3h-2l-5,14h2l1.4-4Zm-4.4-2,1.9-5.2,1.9,5.2ZM15.4,21.545l3.246,1.949-.909-3.637L20.72,17H16.954l-1.429-3.506L13.837,17H10.071l2.857,2.857-.779,3.637Z",
    insert: "M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10",
    insertEmbed: "M20.73889,15.45929a3.4768,3.4768,0,0,0-5.45965-.28662L9.5661,12.50861a3.49811,3.49811,0,0,0-.00873-1.01331l5.72174-2.66809a3.55783,3.55783,0,1,0-.84527-1.81262L8.70966,9.6839a3.50851,3.50851,0,1,0,.0111,4.63727l5.7132,2.66412a3.49763,3.49763,0,1,0,6.30493-1.526ZM18.00745,5.01056A1.49993,1.49993,0,1,1,16.39551,6.3894,1.49994,1.49994,0,0,1,18.00745,5.01056ZM5.99237,13.49536a1.49989,1.49989,0,1,1,1.61194-1.37878A1.49982,1.49982,0,0,1,5.99237,13.49536Zm11.78211,5.494a1.49993,1.49993,0,1,1,1.61193-1.37885A1.49987,1.49987,0,0,1,17.77448,18.98932Z",
    insertFile: "M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z",
    insertImage: "M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z",
    insertLink: "M11,17H7A5,5,0,0,1,7,7h4V9H7a3,3,0,0,0,0,6h4ZM17,7H13V9h4a3,3,0,0,1,0,6H13v2h4A5,5,0,0,0,17,7Zm-1,4H8v2h8Z",
    insertMore: "M16.5,13h-6v6h-2V13h-6V11h6V5h2v6h6Zm5,4.5A1.5,1.5,0,1,1,20,16,1.5,1.5,0,0,1,21.5,17.5Zm0-4A1.5,1.5,0,1,1,20,12,1.5,1.5,0,0,1,21.5,13.5Zm0-4A1.5,1.5,0,1,1,20,8,1.5,1.5,0,0,1,21.5,9.5Z",
    insertTable: "M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M9.5,13.5v-3  h5v3H9.5z M14.5,15v2.5h-5V15H14.5z M9.5,9V6.5h5V9H9.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M3.5,17  v-2H8v2.5H4C3.7,17.5,3.5,17.3,3.5,17z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M16,9V6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16z",
    insertVideo: "M15,8v8H5V8H15m2,2.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l2.29,2.29A1,1,0,0,0,21,15.08V8.91a1,1,0,0,0-1.71-.71Z",
    upload: "M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",
    uploadFiles: "M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",
    italic: "M11.76,9h2l-2.2,10h-2Zm1.68-4a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    search: "M15.5 14h-0.79l-0.28 -0.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09 -0.59 4.23 -1.57l0.27 0.28v0.79l5 4.99L20.49 19l-4.99 -5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    lineHeight: "M6.25,7h2.5L5.25,3.5,1.75,7h2.5V17H1.75l3.5,3.5L8.75,17H6.25Zm4-2V7h12V5Zm0,14h12V17h-12Zm0-6h12V11h-12Z",
    linkStyles: "M19,17.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L11.3,15h3.8l1.7-3.5l1.4,3.5H22L19,17.9z M20,12c0,0.3-0.1,0.7-0.2,1h2.1  c0.1-0.3,0.1-0.6,0.1-1c0-2.8-2.2-5-5-5h-4v2h4C18.7,9,20,10.3,20,12z M14.8,11H8v2h3.3h2.5L14.8,11z M9.9,16.4L8.5,15H7  c-1.7,0-3-1.3-3-3s1.3-3,3-3h4V7H7c-2.8,0-5,2.2-5,5s2.2,5,5,5h3.5L9.9,16.4z",
    mention: "M12.4,5c-4.1,0-7.5,3.4-7.5,7.5S8.3,20,12.4,20h3.8v-1.5h-3.8c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6v1.1  c0,0.6-0.5,1.2-1.1,1.2s-1.1-0.6-1.1-1.2v-1.1c0-2.1-1.7-3.8-3.8-3.8s-3.7,1.7-3.7,3.8s1.7,3.8,3.8,3.8c1,0,2-0.4,2.7-1.1  c0.5,0.7,1.3,1.1,2.2,1.1c1.5,0,2.6-1.2,2.6-2.7v-1.1C19.9,8.4,16.6,5,12.4,5z M12.4,14.7c-1.2,0-2.3-1-2.3-2.2s1-2.3,2.3-2.3  s2.3,1,2.3,2.3S13.6,14.7,12.4,14.7z",
    minimize: "M5,12h14 M19,11H5v2h14V11z",
    more: "M13.5,17c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,16.2,13.5,17z M13.5,12c0,0.8-0.7,1.5-1.5,1.5 s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,11.2,13.5,12z M13.5,7c0,0.8-0.7,1.5-1.5,1.5S10.5,7.8,10.5,7s0.7-1.5,1.5-1.5 S13.5,6.2,13.5,7z",
    openLink: "M17,17H7V7h3V5H7C6,5,5,6,5,7v10c0,1,1,2,2,2h10c1,0,2-1,2-2v-3h-2V17z M14,5v2h1.6l-5.8,5.8l1.4,1.4L17,8.4V10h2V5H14z",
    orderedList: "M2.5,16h2v.5h-1v1h1V18h-2v1h3V15h-3Zm1-7h1V5h-2V6h1Zm-1,2H4.3L2.5,13.1V14h3V13H3.7l1.8-2.1V10h-3Zm5-5V8h14V6Zm0,12h14V16H7.5Zm0-5h14V11H7.5Z",
    outdent: "M3,12l3,3V9L3,12z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",
    pageBreaker: "M3,9v6l3-3L3,9z M21,9H8V4h2v3h9V4h2V9z M21,20h-2v-3h-9v3H8v-5h13V20z M11,13H8v-2h3V13z M16,13h-3v-2h3V13z M21,13h-3v-2  h3V13z",
    paragraphFormat: "M10.15,5A4.11,4.11,0,0,0,6.08,8.18,4,4,0,0,0,10,13v6h2V7h2V19h2V7h2V5ZM8,9a2,2,0,0,1,2-2v4A2,2,0,0,1,8,9Z",
    paragraphMore: "M7.682,5a4.11,4.11,0,0,0-4.07,3.18,4,4,0,0,0,3.11,4.725h0l.027.005a3.766,3.766,0,0,0,.82.09v6h2V7h2V19h2V7h2V5ZM5.532,9a2,2,0,0,1,2-2v4A2,2,0,0,1,5.532,9Zm14.94,8.491a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,17.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,13.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,9.491Z",
    paragraphStyle: "M4,9c0-1.1,0.9-2,2-2v4C4.9,11,4,10.1,4,9z M16.7,20.5l3.2,1.9L19,18.8l3-2.9h-3.7l-1.4-3.5L15.3,16h-3.8l2.9,2.9l-0.9,3.6  L16.7,20.5z M10,17.4V19h1.6L10,17.4z M6.1,5c-1.9,0-3.6,1.3-4,3.2c-0.5,2.1,0.8,4.2,2.9,4.7c0,0,0,0,0,0h0.2C5.5,13,5.8,13,6,13v6  h2V7h2v7h2V7h2V5H6.1z",
    pdfExport: "M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z M16.3,13.5  c-0.2-0.6-1.1-0.8-2.6-0.8c-0.1,0-0.1,0-0.2,0c-0.3-0.3-0.8-0.9-1-1.2c-0.2-0.2-0.3-0.3-0.4-0.6c0.2-0.7,0.2-1,0.3-1.5  c0.1-0.9,0-1.6-0.2-1.8c-0.4-0.2-0.7-0.2-0.9-0.2c-0.1,0-0.3,0.2-0.7,0.7c-0.2,0.7-0.1,1.8,0.6,2.8c-0.2,0.8-0.7,1.6-1,2.4  c-0.8,0.2-1.5,0.7-1.9,1.1c-0.7,0.7-0.9,1.1-0.7,1.6c0,0.3,0.2,0.6,0.7,0.6c0.3-0.1,0.3-0.2,0.7-0.3c0.6-0.3,1.2-1.7,1.7-2.4  c0.8-0.2,1.7-0.3,2-0.3c0.1,0,0.3,0,0.6,0c0.8,0.8,1.2,1.1,1.8,1.2c0.1,0,0.2,0,0.3,0c0.3,0,0.8-0.1,1-0.6  C16.4,14.1,16.4,13.9,16.3,13.5z M8.3,15.7c-0.1,0.1-0.2,0.1-0.2,0.1c0-0.1,0-0.3,0.6-0.8c0.2-0.2,0.6-0.3,0.9-0.7  C9,15,8.6,15.5,8.3,15.7z M11.3,9c0-0.1,0.1-0.2,0.1-0.2S11.6,9,11.5,10c0,0.1,0,0.3-0.1,0.7C11.3,10.1,11,9.5,11.3,9z M10.9,13.1  c0.2-0.6,0.6-1,0.7-1.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.3,0.7,0.7,0.9C12.2,12.8,11.6,13,10.9,13.1z M15.2,14.1  c-0.1,0-0.1,0-0.2,0c-0.2,0-0.7-0.2-1-0.7c1.1,0,1.6,0.2,1.6,0.6C15.5,14.1,15.4,14.1,15.2,14.1z",
    print: "M16.1,17c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1C16.5,18,16.1,17.6,16.1,17z M22,15v4c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h1V5c0-1.1,0.9-2,2-2h7.4L19,7.6V13h1C21.1,13,22,13.9,22,15z M7,13h10V9h-4V5H7V13z M20,15H4  v4h16V15z",
    redo: "M13.6,9.4c1.7,0.3,3.2,0.9,4.6,2L21,8.5v7h-7l2.7-2.7C13,10.1,7.9,11,5.3,14.7c-0.2,0.3-0.4,0.5-0.5,0.8L3,14.6  C5.1,10.8,9.3,8.7,13.6,9.4z",
    removeTable: "M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",
    insertAll: "M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 ",
    remove: "M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",
    replaceImage: "M16,5v3H4v2h12v3l4-4L16,5z M8,19v-3h12v-2H8v-3l-4,4L8,19z",
    row: "M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M16,6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16V6.5z M9.5,6.5h5V9h-5V6.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.5  v-2H8V17.5z M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z",
    selectAll: "M5,7h2V5C5.9,5,5,5.9,5,7z M5,11h2V9H5V11z M9,19h2v-2H9V19z M5,11h2V9H5V11z M15,5h-2v2h2V5z M17,5v2h2C19,5.9,18.1,5,17,5  z M7,19v-2H5C5,18.1,5.9,19,7,19z M5,15h2v-2H5V15z M11,5H9v2h2V5z M13,19h2v-2h-2V19z M17,11h2V9h-2V11z M17,19c1.1,0,2-0.9,2-2h-2  V19z M17,11h2V9h-2V11z M17,15h2v-2h-2V15z M13,19h2v-2h-2V19z M13,7h2V5h-2V7z M9,15h6V9H9V15z M11,11h2v2h-2V11z",
    smile: "M11.991,3A9,9,0,1,0,21,12,8.99557,8.99557,0,0,0,11.991,3ZM12,19a7,7,0,1,1,7-7A6.99808,6.99808,0,0,1,12,19Zm3.105-5.2h1.503a4.94542,4.94542,0,0,1-9.216,0H8.895a3.57808,3.57808,0,0,0,6.21,0ZM7.5,9.75A1.35,1.35,0,1,1,8.85,11.1,1.35,1.35,0,0,1,7.5,9.75Zm6.3,0a1.35,1.35,0,1,1,1.35,1.35A1.35,1.35,0,0,1,13.8,9.75Z",
    spellcheck: "M19.1,13.6l-5.6,5.6l-2.7-2.7l-1.4,1.4l4.1,4.1l7-7L19.1,13.6z M10.8,13.7l2.7,2.7l0.8-0.8L10.5,5h-2l-5,14h2l1.4-4h2.6  L10.8,13.7z M9.5,7.8l1.9,5.2H7.6L9.5,7.8z",
    star: "M12.1,7.7l1,2.5l0.4,0.9h1h2.4l-2.1,2l-0.6,0.6l0.2,0.9l0.6,2.3l-2.2-1.3L12,15.2l-0.8,0.5L9,17l0.5-2.5l0.1-0.8L9,13.1  l-2-2h2.5h0.9l0.4-0.8L12.1,7.7 M12.2,4L9.5,9.6H3.4L8,14.2L6.9,20l5.1-3.1l5.3,3.1l-1.5-5.8l4.8-4.6h-6.1L12.2,4L12.2,4z",
    strikeThrough: "M3,12.20294H21v1.5H16.63422a3.59782,3.59782,0,0,1,.34942,1.5929,3.252,3.252,0,0,1-1.31427,2.6997A5.55082,5.55082,0,0,1,12.20251,19a6.4421,6.4421,0,0,1-2.62335-.539,4.46335,4.46335,0,0,1-1.89264-1.48816,3.668,3.668,0,0,1-.67016-2.15546V14.704h.28723v-.0011h.34149v.0011H9.02v.11334a2.18275,2.18275,0,0,0,.85413,1.83069,3.69,3.69,0,0,0,2.32836.67926,3.38778,3.38778,0,0,0,2.07666-.5462,1.73346,1.73346,0,0,0,.7013-1.46655,1.69749,1.69749,0,0,0-.647-1.43439,3.00525,3.00525,0,0,0-.27491-.17725H3ZM16.34473,7.05981A4.18163,4.18163,0,0,0,14.6236,5.5462,5.627,5.627,0,0,0,12.11072,5,5.16083,5.16083,0,0,0,8.74719,6.06213,3.36315,3.36315,0,0,0,7.44006,8.76855a3.22923,3.22923,0,0,0,.3216,1.42786h2.59668c-.08338-.05365-.18537-.10577-.25269-.16064a1.60652,1.60652,0,0,1-.65283-1.30036,1.79843,1.79843,0,0,1,.68842-1.5108,3.12971,3.12971,0,0,1,1.96948-.55243,3.04779,3.04779,0,0,1,2.106.6687,2.35066,2.35066,0,0,1,.736,1.83258v.11341h2.00317V9.17346A3.90013,3.90013,0,0,0,16.34473,7.05981Z",
    subscript: "M10.4,12l3.6,3.6L12.6,17L9,13.4L5.4,17L4,15.6L7.6,12L4,8.4L5.4,7L9,10.6L12.6,7L14,8.4L10.4,12z M18.31234,19.674  l1.06812-1.1465c0.196-0.20141,0.37093-0.40739,0.5368-0.6088c0.15975-0.19418,0.30419-0.40046,0.432-0.617  c0.11969-0.20017,0.21776-0.41249,0.29255-0.6334c0.07103-0.21492,0.10703-0.43986,0.10662-0.66621  c0.00297-0.28137-0.04904-0.56062-0.1531-0.82206c-0.09855-0.24575-0.25264-0.46534-0.45022-0.6416  c-0.20984-0.18355-0.45523-0.32191-0.72089-0.40646c-0.63808-0.19005-1.3198-0.17443-1.94851,0.04465  c-0.28703,0.10845-0.54746,0.2772-0.76372,0.49487c-0.20881,0.20858-0.37069,0.45932-0.47483,0.73548  c-0.10002,0.26648-0.15276,0.54838-0.15585,0.833l-0.00364,0.237H17.617l0.00638-0.22692  c0.00158-0.12667,0.01966-0.25258,0.05377-0.37458c0.03337-0.10708,0.08655-0.20693,0.15679-0.29437  c0.07105-0.08037,0.15959-0.14335,0.25882-0.1841c0.22459-0.08899,0.47371-0.09417,0.7018-0.01458  c0.0822,0.03608,0.15559,0.08957,0.21509,0.15679c0.06076,0.07174,0.10745,0.15429,0.13761,0.24333  c0.03567,0.10824,0.05412,0.22141,0.05469,0.33538c-0.00111,0.08959-0.0118,0.17881-0.0319,0.26612  c-0.02913,0.10428-0.07076,0.20465-0.124,0.29893c-0.07733,0.13621-0.1654,0.26603-0.26338,0.38823  c-0.13438,0.17465-0.27767,0.34226-0.42929,0.50217l-2.15634,2.35315V21H21v-1.326H18.31234z",
    superscript: "M10.4,12,14,15.6,12.6,17,9,13.4,5.4,17,4,15.6,7.6,12,4,8.4,5.4,7,9,10.6,12.6,7,14,8.4Zm8.91234-3.326,1.06812-1.1465c.196-.20141.37093-.40739.5368-.6088a4.85745,4.85745,0,0,0,.432-.617,3.29,3.29,0,0,0,.29255-.6334,2.11079,2.11079,0,0,0,.10662-.66621,2.16127,2.16127,0,0,0-.1531-.82206,1.7154,1.7154,0,0,0-.45022-.6416,2.03,2.03,0,0,0-.72089-.40646,3.17085,3.17085,0,0,0-1.94851.04465,2.14555,2.14555,0,0,0-.76372.49487,2.07379,2.07379,0,0,0-.47483.73548,2.446,2.446,0,0,0-.15585.833l-.00364.237H18.617L18.62338,5.25a1.45865,1.45865,0,0,1,.05377-.37458.89552.89552,0,0,1,.15679-.29437.70083.70083,0,0,1,.25882-.1841,1.00569,1.00569,0,0,1,.7018-.01458.62014.62014,0,0,1,.21509.15679.74752.74752,0,0,1,.13761.24333,1.08893,1.08893,0,0,1,.05469.33538,1.25556,1.25556,0,0,1-.0319.26612,1.34227,1.34227,0,0,1-.124.29893,2.94367,2.94367,0,0,1-.26338.38823,6.41629,6.41629,0,0,1-.42929.50217L17.19709,8.92642V10H22V8.674Z",
    symbols: "M15.77493,16.98885a8.21343,8.21343,0,0,0,1.96753-2.57651,7.34824,7.34824,0,0,0,.6034-3.07618A6.09092,6.09092,0,0,0,11.99515,5a6.13347,6.13347,0,0,0-4.585,1.79187,6.417,6.417,0,0,0-1.756,4.69207,6.93955,6.93955,0,0,0,.622,2.97415,8.06587,8.06587,0,0,0,1.949,2.53076H5.41452V19h5.54114v-.04331h-.00147V16.84107a5.82825,5.82825,0,0,1-2.2052-2.2352A6.40513,6.40513,0,0,1,7.97672,11.447,4.68548,4.68548,0,0,1,9.07785,8.19191a3.73232,3.73232,0,0,1,2.9173-1.22462,3.76839,3.76839,0,0,1,2.91241,1.21489,4.482,4.482,0,0,1,1.11572,3.154,6.71141,6.71141,0,0,1-.75384,3.24732,5.83562,5.83562,0,0,1-2.22357,2.25759v2.11562H13.0444V19h5.54108V16.98885Z",
    tags: "M8.9749 7.47489a1.5 1.5 0 1 1 -1.5 1.5A1.5 1.5 0 0 1 8.9749 7.47489Zm3.78866 -3.12713L16.5362 8.12041l0.33565 0.33564 2.77038 2.77038a2.01988 2.01988 0 0 1 0.59 1.42 1.95518 1.95518 0 0 1 -0.5854 1.40455l0.00044 0.00043 -5.59583 5.59583 -0.00043 -0.00044a1.95518 1.95518 0 0 1 -1.40455 0.5854 1.98762 1.98762 0 0 1 -1.41 -0.58L8.45605 16.87185l-0.33564 -0.33565L4.35777 12.77357a1.99576 1.99576 0 0 1 -0.59 -1.42V9.36358l0 -3.59582a2.00579 2.00579 0 0 1 2 -2l3.59582 0h1.98995A1.98762 1.98762 0 0 1 12.76356 4.34776ZM15.46186 9.866l-0.33564 -0.33564L11.36359 5.76776H5.76776v5.59583L9.866 15.46186l2.7794 2.7794 5.5878 -5.60385 -0.001 -0.001Z",
    tableHeader: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  l0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M14.5,17.5h-5V15h5V17.5z M14.5,13.5h-5v-3h5V13.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5l0,0  H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9h-4.4H16h-1.5h-5H8H7.9H3.5V7c0-0.3,0.2-0.5,0.4-0.5l0,0h4l0,0h8.2l0,0H20  c0.3,0,0.5,0.2,0.5,0.4l0,0V9z",
    tableStyle: "M20.0171,19.89752l.9,3.6-3.2-1.9-3.3,1.9.8-3.6-2.9-2.9h3.8l1.7-3.5,1.4,3.5h3.8ZM20,5H4A2.00591,2.00591,0,0,0,2,7V17a2.00591,2.00591,0,0,0,2,2h7.49115l-.58826-.58826L9.99115,17.5H9.5V14.9975h5.36511L16,12.66089V10.5h4.5v3h-.52783l.599,1.4975H22V7A2.00591,2.00591,0,0,0,20,5ZM3.5,7A.4724.4724,0,0,1,4,6.5H8V9H3.5Zm0,3.5H8v3H3.5Zm.5,7a.4724.4724,0,0,1-.5-.5V15H8v2.5Zm10.5-4h-5v-3h5Zm0-4.5h-5V6.5h5Zm6,0H16V6.5h4a.4724.4724,0,0,1,.5.5Z",
    textColor: "M15.2,13.494s-3.6,3.9-3.6,6.3a3.65,3.65,0,0,0,7.3.1v-.1C18.9,17.394,15.2,13.494,15.2,13.494Zm-1.47-1.357.669-.724L12.1,5h-2l-5,14h2l1.43-4h2.943A24.426,24.426,0,0,1,13.726,12.137ZM11.1,7.8l1.86,5.2H9.244Z",
    textMore: "M13.55,19h2l-5-14h-2l-5,14h2l1.4-4h5.1Zm-5.9-6,1.9-5.2,1.9,5.2Zm12.8,4.5a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,17.5Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,13.5Zm0-4A1.5,1.5,0,1,1,18.95,8,1.5,1.5,0,0,1,20.45,9.5Z",
    underline: "M19,20v2H5V20Zm-3-6.785a4,4,0,0,1-5.74,3.4A3.75,3.75,0,0,1,8,13.085V5.005H6v8.21a6,6,0,0,0,8,5.44,5.851,5.851,0,0,0,4-5.65v-8H16ZM16,5v0h2V5ZM8,5H6v0H8Z",
    undo: "M10.4,9.4c-1.7,0.3-3.2,0.9-4.6,2L3,8.5v7h7l-2.7-2.7c3.7-2.6,8.8-1.8,11.5,1.9c0.2,0.3,0.4,0.5,0.5,0.8l1.8-0.9  C18.9,10.8,14.7,8.7,10.4,9.4z",
    unlink: "M14.4,11l1.6,1.6V11H14.4z M17,7h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1c0,1.3-0.8,2.4-1.9,2.8l1.4,1.4C21,15.4,22,13.8,22,12  C22,9.2,19.8,7,17,7z M2,4.3l3.1,3.1C3.3,8.1,2,9.9,2,12c0,2.8,2.2,5,5,5h4v-1.9H7c-1.7,0-3.1-1.4-3.1-3.1c0-1.6,1.2-2.9,2.8-3.1  L8.7,11H8v2h2.7l2.3,2.3V17h1.7l4,4l1.4-1.4L3.4,2.9L2,4.3z",
    unorderedList: "M4,10.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,10.5,4,10.5z M4,5.5C3.2,5.5,2.5,6.2,2.5,7  S3.2,8.5,4,8.5S5.5,7.8,5.5,7S4.8,5.5,4,5.5z M4,15.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,15.5,4,15.5z   M7.5,6v2h14V6H7.5z M7.5,18h14v-2h-14V18z M7.5,13h14v-2h-14V13z",
    verticalAlignBottom: "M16,13h-3V3h-2v10H8l4,4L16,13z M3,19v2h18v-2H3z",
    verticalAlignMiddle: "M3,11v2h18v-2H3z M8,18h3v3h2v-3h3l-4-4L8,18z M16,6h-3V3h-2v3H8l4,4L16,6z",
    verticalAlignTop: "M8,11h3v10h2V11h3l-4-4L8,11z M21,5V3H3v2H21z",
    trackChanges: "M17.2 20H12.4599L13.9938 19.2076L14.0305 19.1886L14.0616 19.1612C14.1036 19.1242 14.1373 19.0786 14.1603 19.0275C14.1806 18.9825 14.1923 18.9342 14.1948 18.885H14.2H14.3384L14.4364 18.7874L14.7049 18.52H15.45C15.5747 18.52 15.6942 18.4705 15.7823 18.3823C15.8705 18.2942 15.92 18.1746 15.92 18.05C15.92 17.9253 15.8705 17.8058 15.7823 17.7176C15.7351 17.6704 15.6789 17.6343 15.6177 17.6109L17.33 15.9056V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H11.2508C11.2396 19.9629 11.2337 19.9242 11.2337 19.885C11.2337 19.8133 11.2533 19.7431 11.29 19.6819L11.2739 19.6734L11.8838 18.52H5C4.87535 18.52 4.7558 18.4705 4.66766 18.3823C4.57952 18.2942 4.53 18.1746 4.53 18.05C4.53 17.9253 4.57952 17.8058 4.66766 17.7176C4.7558 17.6295 4.87535 17.58 5 17.58H12.3809L12.3925 17.5582L12.4187 17.5284C12.4558 17.4864 12.5014 17.4527 12.5525 17.4297C12.5836 17.4156 12.6163 17.4057 12.6498 17.4001C12.6522 17.3065 12.6877 17.2166 12.7503 17.1467L13 17.37C12.9902 17.381 12.9847 17.3952 12.9847 17.41C12.9847 17.4247 12.9902 17.439 13 17.45L14.13 18.55H14.2L19.09 13.68V13.6L17.99 12.5C17.979 12.4902 17.9647 12.4847 17.95 12.4847C17.9352 12.4847 17.921 12.4902 17.91 12.5L13 17.37L12.7641 17.1322L15.1759 14.74H5C4.87535 14.74 4.7558 14.6905 4.66766 14.6023C4.57952 14.5142 4.53 14.3946 4.53 14.27C4.53 14.1453 4.57952 14.0258 4.66766 13.9376C4.7558 13.8495 4.87535 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9376C15.8169 13.9722 15.8454 14.0115 15.8675 14.0541L17.33 12.6034V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM11.7889 20H11.8785C11.8902 19.9746 11.898 19.9475 11.9015 19.9197L11.8661 19.9866L11.8117 19.9578L13.84 18.91C13.8464 18.9044 13.8515 18.8974 13.855 18.8897C13.8585 18.8819 13.8603 18.8735 13.8603 18.865C13.8603 18.8565 13.8585 18.8481 13.855 18.8403C13.8515 18.8325 13.8464 18.8256 13.84 18.82L12.76 17.75C12.7544 17.7436 12.7474 17.7385 12.7397 17.735C12.7319 17.7315 12.7235 17.7297 12.715 17.7297C12.7065 17.7297 12.6981 17.7315 12.6903 17.735C12.6825 17.7385 12.6756 17.7436 12.67 17.75L11.57 19.83L11.5023 19.7942L11.58 19.85C11.5727 19.8602 11.5687 19.8724 11.5687 19.885C11.5687 19.8975 11.5727 19.9098 11.58 19.92L11.67 20H11.73L11.7642 19.9823L11.7889 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60183 10.9735 6.54621C10.9534 6.49058 10.9224 6.43948 10.8825 6.39582C10.8425 6.35216 10.7944 6.31681 10.7408 6.29179C10.6871 6.26677 10.6291 6.25257 10.57 6.25H5C4.88239 6.25773 4.77251 6.3113 4.69397 6.39918C4.61543 6.48707 4.57451 6.60226 4.58 6.72C4.57451 6.83774 4.61543 6.95293 4.69397 7.04082C4.77251 7.12871 4.88239 7.18227 5 7.19H10.6C10.714 7.1774 10.8189 7.12173 10.8933 7.03438C10.9676 6.94702 11.0058 6.83457 11 6.72ZM11.1 8.14001H5C4.87535 8.14001 4.7558 8.18953 4.66766 8.27767C4.57952 8.36582 4.53 8.48536 4.53 8.61001C4.53 8.73467 4.57952 8.85421 4.66766 8.94236C4.7558 9.0305 4.87535 9.08001 5 9.08001H11.1C11.2247 9.08001 11.3442 9.0305 11.4323 8.94236C11.5205 8.85421 11.57 8.73467 11.57 8.61001C11.57 8.48536 11.5205 8.36582 11.4323 8.27767C11.3442 8.18953 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8536C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1464C15.7098 10.0527 15.5826 10 15.45 10H5C4.86739 10 4.74021 10.0527 4.64645 10.1464C4.55268 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3337 11.9673 11.2202 11.9152 11.1 11.91H5C4.94089 11.9126 4.88286 11.9268 4.82924 11.9518C4.77562 11.9768 4.72746 12.0122 4.68752 12.0558C4.64758 12.0995 4.61664 12.1506 4.59648 12.2062C4.57631 12.2618 4.56731 12.3209 4.57 12.38C4.56451 12.5004 4.60649 12.6181 4.6869 12.7079C4.76731 12.7976 4.87974 12.8523 5 12.86ZM11.1 16.63H5C4.87535 16.63 4.7558 16.5805 4.66766 16.4923C4.57952 16.4042 4.53 16.2846 4.53 16.16C4.53 16.0353 4.57952 15.9158 4.66766 15.8276C4.7558 15.7395 4.87535 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4323 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4323 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.8503 11.592C18.7991 11.6175 18.7545 11.6544 18.72 11.7L18.26 12.14C18.2501 12.151 18.2447 12.1652 18.2447 12.18C18.2447 12.1947 18.2501 12.209 18.26 12.22L19.37 13.32C19.381 13.3298 19.3952 13.3353 19.41 13.3353C19.4247 13.3353 19.439 13.3298 19.45 13.32L19.86 12.91C19.9057 12.867 19.9421 12.8151 19.967 12.7575C19.9919 12.6998 20.0047 12.6377 20.0047 12.575C20.0047 12.5122 19.9919 12.4501 19.967 12.3925C19.9421 12.3349 19.9057 12.283 19.86 12.24L19.31 11.7C19.2755 11.6544 19.2309 11.6175 19.1797 11.592C19.1285 11.5666 19.0721 11.5533 19.015 11.5533C18.9578 11.5533 18.9014 11.5666 18.8503 11.592Z",
    showTrackChanges: "M17.2421 13.6048C17.2631 13.6136 17.2841 13.6226 17.305 13.6317V9.29505H13.2626C13.1897 9.30481 13.1159 9.30481 13.043 9.29505C12.7532 9.21632 12.4953 9.04872 12.3056 8.81577C12.1158 8.58283 12.0037 8.29625 11.985 7.99627V4H4.12976C4.09534 4 4.06234 4.01368 4.038 4.03804C4.01367 4.0624 4 4.09543 4 4.12988V19.8552C4 19.8896 4.01367 19.9227 4.038 19.947C4.06234 19.9714 4.09534 19.9851 4.12976 19.9851H13.4875C13.0501 19.8216 12.6281 19.6155 12.2277 19.3686C11.8529 19.1551 11.4911 18.9196 11.1442 18.6632C11.0697 18.6152 10.9982 18.5628 10.9302 18.5065H4.99812C4.87371 18.5065 4.75438 18.457 4.66641 18.3689C4.57843 18.2809 4.529 18.1614 4.529 18.0369C4.529 17.9124 4.57843 17.7929 4.66641 17.7049C4.75438 17.6168 4.87371 17.5673 4.99812 17.5673H10.4396C10.4472 17.4488 10.4756 17.3324 10.5235 17.2235C10.5939 17.017 10.6761 16.8149 10.7694 16.6182H4.99812C4.87371 16.6182 4.75438 16.5687 4.66641 16.4807C4.57843 16.3926 4.529 16.2732 4.529 16.1487C4.529 16.0241 4.57843 15.9047 4.66641 15.8166C4.75438 15.7286 4.87371 15.6791 4.99812 15.6791H11.0867C11.1576 15.6791 11.2268 15.6952 11.2895 15.7253C11.5204 15.361 11.7938 15.027 12.1033 14.73H4.99812C4.87371 14.73 4.75438 14.6805 4.66641 14.5924C4.57843 14.5044 4.529 14.385 4.529 14.2604C4.529 14.1359 4.57843 14.0164 4.66641 13.9284C4.75438 13.8403 4.87371 13.7909 4.99812 13.7909H13.4434C13.9833 13.525 14.5656 13.3516 15.166 13.2795L15.1923 13.2763H15.2189H15.4925C16.0923 13.2609 16.6886 13.3728 17.2421 13.6048ZM13.0829 4.64939L16.5764 8.14613C16.5975 8.16843 16.6118 8.19636 16.6174 8.22657C16.6231 8.25677 16.62 8.28798 16.6084 8.31645C16.5968 8.34492 16.5773 8.36944 16.5521 8.38707C16.527 8.40471 16.4973 8.41471 16.4666 8.41587H13.043L12.8134 8.18609V4.75929C12.8146 4.72857 12.8246 4.69884 12.8422 4.67366C12.8598 4.64849 12.8843 4.62893 12.9128 4.61733C12.9412 4.60573 12.9724 4.60259 13.0026 4.60827C13.0328 4.61396 13.0607 4.62824 13.0829 4.64939ZM10.9869 6.71746C10.9896 6.65841 10.9806 6.59941 10.9604 6.54383C10.9403 6.48825 10.9094 6.4372 10.8696 6.39358C10.8297 6.34997 10.7816 6.31465 10.7281 6.28965C10.6746 6.26466 10.6167 6.25047 10.5577 6.2479H4.99813C4.88074 6.25562 4.77106 6.30914 4.69267 6.39694C4.61428 6.48475 4.57343 6.59983 4.57891 6.71746C4.57343 6.83509 4.61428 6.95017 4.69267 7.03798C4.77106 7.12579 4.88074 7.1793 4.99813 7.18702H10.5876C10.7014 7.17444 10.8061 7.11882 10.8803 7.03154C10.9545 6.94427 10.9927 6.83192 10.9869 6.71746ZM11.0867 8.13614H4.99812C4.87371 8.13614 4.75438 8.18561 4.66641 8.27367C4.57843 8.36173 4.529 8.48116 4.529 8.6057C4.529 8.73023 4.57843 8.84967 4.66641 8.93773C4.75438 9.02579 4.87371 9.07526 4.99812 9.07526H11.0867C11.2111 9.07526 11.3304 9.02579 11.4184 8.93773C11.5064 8.84967 11.5558 8.73023 11.5558 8.6057C11.5558 8.48116 11.5064 8.36173 11.4184 8.27367C11.3304 8.18561 11.2111 8.13614 11.0867 8.13614ZM4.99812 10.9935H15.4285C15.5609 10.9935 15.6878 10.9408 15.7814 10.8472C15.875 10.7535 15.9276 10.6264 15.9276 10.4939C15.9276 10.3614 15.875 10.2344 15.7814 10.1407C15.6878 10.047 15.5609 9.9944 15.4285 9.9944H4.99812C4.86576 9.9944 4.73883 10.047 4.64523 10.1407C4.55164 10.2344 4.49906 10.3614 4.49906 10.4939C4.49906 10.6264 4.55164 10.7535 4.64523 10.8472C4.73883 10.9408 4.86576 10.9935 4.99812 10.9935ZM4.99812 12.8517H11.0867C11.2076 12.844 11.3208 12.7898 11.4027 12.7004C11.4845 12.611 11.5287 12.4934 11.5259 12.3722C11.5286 12.252 11.4841 12.1355 11.402 12.0477C11.3199 11.9599 11.2067 11.9078 11.0867 11.9026H4.99812C4.93912 11.9052 4.8812 11.9194 4.82769 11.9444C4.77417 11.9694 4.7261 12.0047 4.68623 12.0483C4.64637 12.0919 4.61549 12.143 4.59536 12.1985C4.57523 12.2541 4.56625 12.3131 4.56893 12.3722C4.56345 12.4925 4.60535 12.6101 4.68561 12.6998C4.76587 12.7894 4.87809 12.844 4.99812 12.8517ZM19.97 17.4974C19.5787 16.5636 19.0431 15.6971 18.383 14.9298C18.0152 14.5351 17.5679 14.2233 17.0706 14.0148C16.5732 13.8064 16.0373 13.7062 15.4984 13.7209H15.2189C14.4787 13.8098 13.7684 14.0666 13.1423 14.4717C12.5162 14.8769 11.9906 15.4196 11.6057 16.0587C11.3211 16.4677 11.0959 16.9151 10.937 17.3875C10.9006 17.464 10.8817 17.5476 10.8817 17.6323C10.8817 17.717 10.9006 17.8006 10.937 17.877C11.0642 18.0428 11.2196 18.1849 11.3961 18.2967C11.7346 18.5476 12.0879 18.7778 12.4541 18.986C13.4096 19.5767 14.497 19.92 15.6182 19.9851C16.4392 20.0504 17.2632 19.9005 18.0088 19.5501C18.7544 19.1998 19.3959 18.661 19.8702 17.9869C19.9311 17.923 19.9729 17.8432 19.9905 17.7566C20.0082 17.67 20.0011 17.5801 19.97 17.4974ZM15.9775 19.1758C14.3849 19.068 12.8507 18.5331 11.5358 17.6273C11.5788 17.5678 11.6255 17.5111 11.6756 17.4574C12.3061 16.569 13.1295 15.8359 14.0832 15.3126C13.8003 15.7406 13.6785 16.2566 13.7417 16.7681C13.7676 17.0339 13.8465 17.2918 13.9737 17.5265C14.1009 17.7613 14.2739 17.9681 14.4823 18.1348C14.6907 18.3016 14.9304 18.4248 15.1872 18.4972C15.4441 18.5696 15.7128 18.5897 15.9775 18.5564C16.305 18.4971 16.6137 18.3609 16.8785 18.159C17.1432 17.9572 17.3564 17.6954 17.5005 17.3951C17.6446 17.0949 17.7156 16.7647 17.7077 16.4317C17.6997 16.0987 17.613 15.7723 17.4547 15.4793C17.2614 15.3391 17.0533 15.2235 16.8351 15.1339C17.0715 15.226 17.2966 15.3485 17.5046 15.4993C18.0049 15.8976 18.4424 16.3691 18.8022 16.898L18.8927 17.0137L18.8927 17.0137C19.0823 17.2564 19.2729 17.5004 19.4709 17.7072C18.5404 18.6311 17.288 19.1576 15.9775 19.1758ZM16.3168 15.769C16.2085 15.8106 16.1171 15.8873 16.0574 15.9869C15.9977 16.0865 15.9731 16.2032 15.9875 16.3185C15.9949 16.3856 16.0156 16.4505 16.0483 16.5096C16.081 16.5686 16.1251 16.6206 16.178 16.6624C16.2309 16.7042 16.2916 16.7351 16.3566 16.7532C16.4216 16.7714 16.4895 16.7764 16.5564 16.7681H16.6063C16.5618 16.9495 16.4637 17.1132 16.3248 17.238C16.186 17.3627 16.0127 17.4427 15.8278 17.4674H15.6481C15.4335 17.4396 15.2337 17.3427 15.0789 17.1913C14.924 17.04 14.8226 16.8423 14.7897 16.6282C14.7628 16.3782 14.8311 16.1271 14.981 15.9253C15.1305 15.7238 15.3504 15.5861 15.5968 15.5395C15.3446 15.5862 15.12 15.7284 14.9697 15.9364C14.8191 16.1448 14.7547 16.4034 14.7897 16.6582C14.8226 16.8723 14.924 17.0699 15.0789 17.2213C15.2337 17.3727 15.4335 17.4696 15.6481 17.4974H15.8377C16.0209 17.4708 16.1919 17.39 16.3289 17.2654C16.4658 17.1408 16.5625 16.978 16.6063 16.7981C16.7293 16.7633 16.8359 16.686 16.9072 16.5799C16.9785 16.4737 17.0098 16.3457 16.9956 16.2186C16.9882 16.1515 16.9675 16.0865 16.9348 16.0275C16.9021 15.9685 16.858 15.9165 16.805 15.8747C16.7521 15.8329 16.6914 15.802 16.6264 15.7838C16.5615 15.7657 16.4936 15.7607 16.4266 15.769H16.3168Z",
    acceptAllChanges: "M9.36499 16.7348C9.38499 16.7547 9.41212 16.7659 9.44041 16.7659H10.9881C10.9028 16.6008 10.9289 16.3933 11.0663 16.2541L11.7266 15.585H10.1444C10.0549 15.5701 9.97363 15.5238 9.91498 15.4547C9.85639 15.3856 9.82422 15.298 9.82422 15.2074C9.82422 15.1169 9.85639 15.0292 9.91498 14.9601C9.97363 14.891 10.0549 14.8448 10.1444 14.8298H12.4879C12.5584 14.785 12.6407 14.7607 12.7257 14.7607C12.8106 14.7607 12.893 14.785 12.9635 14.8298H16.5295L18.3303 13.0091C18.4135 12.925 18.5271 12.8776 18.6456 12.8777C18.7642 12.8777 18.8777 12.9252 18.9609 13.0094L20 14.0621V8.25532H16.8001C16.7301 8.27288 16.6568 8.27288 16.5868 8.25532C16.3485 8.1935 16.1367 8.0565 15.9829 7.86478C15.8292 7.67306 15.7416 7.43688 15.7335 7.19149V4H9.44041C9.41293 4.0024 9.38718 4.01437 9.36767 4.03383C9.34816 4.05329 9.33615 4.07897 9.33375 4.10638V16.6596C9.33375 16.6878 9.34499 16.7148 9.36499 16.7348ZM10.0744 17.2979H11.4803L12.259 18.0957H5.06727C5.01734 18.0957 4.96838 18.1057 4.9232 18.1246C4.8788 18.1431 4.83798 18.1702 4.80335 18.2048C4.7333 18.2746 4.69398 18.3693 4.69398 18.468C4.69398 18.5668 4.7333 18.6615 4.80335 18.7313C4.87333 18.8011 4.96832 18.8404 5.06727 18.8404H12.9857L13.7947 19.6693L14.0836 19.9574H4.10733C4.09291 19.9591 4.07829 19.9576 4.06457 19.9528C4.05085 19.9481 4.03838 19.9403 4.02812 19.9301C4.01785 19.9198 4.01004 19.9074 4.00529 19.8937C4.00054 19.88 3.99896 19.8654 4.00067 19.8511V7.29787C4.00067 7.26966 4.01191 7.2426 4.03191 7.22265C4.05192 7.2027 4.07905 7.19149 4.10733 7.19149H8.70447V9.05319H5.06727C4.97294 9.05867 4.88453 9.10069 4.8208 9.17019C4.757 9.23973 4.72302 9.33135 4.72594 9.42553C4.72289 9.52082 4.75654 9.61364 4.82002 9.6849C4.88356 9.75613 4.97203 9.80038 5.06727 9.8085H8.70447V10.5638H5.06727C5.01968 10.5652 4.97274 10.5759 4.92932 10.5954C4.88583 10.6148 4.84664 10.6426 4.8139 10.6772C4.78122 10.7118 4.7557 10.7525 4.73877 10.7969C4.72184 10.8413 4.7139 10.8887 4.71527 10.9361C4.7139 10.9837 4.72184 11.031 4.73877 11.0754C4.74424 11.0897 4.75055 11.1037 4.75778 11.1171C4.76162 11.1243 4.76566 11.1313 4.76995 11.1382C4.78265 11.1585 4.79736 11.1776 4.8139 11.1951C4.84664 11.2297 4.88583 11.2575 4.92932 11.2769C4.95491 11.2884 4.98173 11.2968 5.0092 11.3021C5.02834 11.3058 5.04774 11.3079 5.06727 11.3085H8.70447V12.0638H5.06734C4.97782 12.0789 4.89651 12.1251 4.83792 12.1942C4.77926 12.2633 4.7471 12.351 4.7471 12.4415C4.7471 12.5321 4.77926 12.6197 4.83792 12.6888C4.89651 12.758 4.97782 12.8041 5.06734 12.8192H8.70447V13.5745H5.06734C4.97782 13.5895 4.89651 13.6357 4.83792 13.7048C4.81383 13.7332 4.79424 13.7647 4.77946 13.7983C4.7583 13.8465 4.7471 13.8988 4.7471 13.9522C4.7471 14.0427 4.77926 14.1303 4.83792 14.1994C4.89651 14.2686 4.97782 14.3147 5.06734 14.3298H8.70447V15.0744H5.06727C4.97776 15.0895 4.89651 15.1357 4.83785 15.2048C4.77926 15.2739 4.7471 15.3616 4.7471 15.4521C4.7471 15.5043 4.75778 15.5556 4.77809 15.6029C4.793 15.6376 4.81305 15.6701 4.83785 15.6994C4.89651 15.7685 4.97776 15.8147 5.06727 15.8298H8.70447V16.5851H5.06727C4.97776 16.6001 4.89651 16.6463 4.83785 16.7154C4.79489 16.7661 4.76618 16.8267 4.75387 16.8912C4.74938 16.9146 4.7471 16.9386 4.7471 16.9628C4.7471 17.0533 4.77926 17.1409 4.83785 17.21C4.89651 17.2792 4.97776 17.3253 5.06727 17.3404H9.95241C9.99552 17.3331 10.0367 17.3187 10.0744 17.2979ZM20 15.3204L18.5709 16.7659H19.8933C19.9216 16.7659 19.9487 16.7547 19.9687 16.7348C19.9887 16.7148 20 16.6878 20 16.6596V15.3204ZM14.7526 16.6264L13.7248 15.585H15.7825L14.7526 16.6264ZM14.9498 6.08721C14.9465 6.06854 14.9416 6.05023 14.9353 6.03244C14.9202 5.98939 14.897 5.94929 14.8665 5.91442C14.8145 5.85488 14.7444 5.81394 14.6669 5.79787H10.1337C10.0348 5.79787 9.93978 5.83709 9.8698 5.90693C9.79975 5.97676 9.76043 6.07146 9.76043 6.17022C9.76043 6.19463 9.76283 6.21879 9.76752 6.24239C9.77462 6.2782 9.78692 6.31268 9.80398 6.34479C9.82123 6.37716 9.8433 6.40709 9.8698 6.43348C9.93978 6.50332 10.0348 6.54257 10.1337 6.54257H14.6669C14.6811 6.54023 14.6951 6.53702 14.7088 6.53299C14.7206 6.52955 14.7322 6.52549 14.7436 6.52082C14.7624 6.51309 14.7806 6.50371 14.7979 6.4928C14.8378 6.46764 14.8722 6.43468 14.8991 6.39599C14.9259 6.35729 14.9447 6.31359 14.9543 6.26749C14.9554 6.26232 14.9563 6.25716 14.9571 6.25197C14.9579 6.24739 14.9586 6.24281 14.9591 6.23824C14.9612 6.22129 14.962 6.20424 14.9616 6.18723C14.961 6.16727 14.9588 6.14733 14.9549 6.12766C14.9539 6.11406 14.9523 6.10055 14.9498 6.08721ZM15.0189 7.29788H10.1445C10.0549 7.31291 9.97363 7.35911 9.91504 7.42823C9.85639 7.49738 9.82422 7.585 9.82422 7.67555C9.82422 7.76609 9.85639 7.85369 9.91504 7.92284C9.97363 7.99196 10.0549 8.03815 10.1445 8.05319H15.0189C15.0321 8.05241 15.0451 8.05095 15.058 8.04877C15.0745 8.04601 15.0906 8.04212 15.1064 8.03718C15.1669 8.01822 15.2219 7.98361 15.2654 7.93618C15.3291 7.86664 15.3632 7.77502 15.3602 7.68084C15.3606 7.67392 15.3608 7.66701 15.3608 7.66009C15.3609 7.65087 15.3606 7.64165 15.3599 7.63247C15.3592 7.62263 15.358 7.61279 15.3565 7.60302C15.3532 7.58188 15.3479 7.56104 15.3409 7.54072C15.3254 7.49575 15.301 7.45426 15.2693 7.41868C15.2492 7.39621 15.2265 7.37638 15.2017 7.35959C15.1872 7.34979 15.172 7.34102 15.1562 7.33339C15.1132 7.31265 15.0665 7.3006 15.0189 7.29788ZM10.1445 9.56381H18.496C18.5856 9.54877 18.6669 9.50258 18.7255 9.43346C18.7841 9.3643 18.8163 9.27671 18.8163 9.18617C18.8163 9.09562 18.7841 9.008 18.7255 8.93884C18.6669 8.86973 18.5856 8.82353 18.496 8.8085H10.1445C10.0549 8.82353 9.97363 8.86973 9.91504 8.93884C9.85639 9.008 9.82422 9.09562 9.82422 9.18617C9.82422 9.24412 9.83738 9.30087 9.86224 9.35236C9.87624 9.38132 9.89395 9.40859 9.91504 9.43346C9.97363 9.50258 10.0549 9.54877 10.1445 9.56381ZM10.1445 11.0638H15.0189C15.1084 11.0488 15.1897 11.0026 15.2483 10.9335C15.2854 10.8898 15.3118 10.8387 15.3263 10.7842C15.3347 10.7525 15.3391 10.7195 15.3391 10.6861C15.3391 10.5956 15.3069 10.508 15.2483 10.4389C15.1897 10.3697 15.1084 10.3235 15.0189 10.3085H10.1445C10.0549 10.3235 9.97363 10.3697 9.91504 10.4389C9.85639 10.508 9.82422 10.5956 9.82422 10.6861C9.82422 10.7424 9.83666 10.7976 9.8601 10.8478C9.87442 10.8785 9.89284 10.9073 9.91504 10.9335C9.97363 11.0026 10.0549 11.0488 10.1445 11.0638ZM18.496 12.5745H10.1444C10.0549 12.5594 9.97363 12.5132 9.91498 12.4441C9.85639 12.3749 9.82422 12.2873 9.82422 12.1968C9.82422 12.1062 9.85639 12.0186 9.91498 11.9495C9.97363 11.8803 10.0549 11.8342 10.1444 11.8191H18.496C18.5856 11.8342 18.6669 11.8803 18.7255 11.9495C18.7841 12.0186 18.8163 12.1062 18.8163 12.1968C18.8163 12.2873 18.7841 12.3749 18.7255 12.4441C18.6971 12.4776 18.6633 12.5058 18.6259 12.5276C18.5861 12.5507 18.5421 12.5667 18.496 12.5745ZM15.0189 14.0744H10.1444C10.0968 14.0731 10.0499 14.0624 10.0064 14.0429C9.96296 14.0234 9.92376 13.9956 9.89102 13.961C9.85834 13.9265 9.83282 13.8857 9.81589 13.8413C9.79897 13.7969 9.79102 13.7496 9.79239 13.7021C9.79102 13.6546 9.79897 13.6073 9.81589 13.5628C9.83282 13.5184 9.85834 13.4778 9.89102 13.4432C9.92376 13.4086 9.96296 13.3808 10.0064 13.3613C10.0499 13.3419 10.0968 13.3311 10.1444 13.3297H15.0189C15.0661 13.3311 15.1125 13.3419 15.1554 13.3615C15.1983 13.381 15.2368 13.4091 15.2686 13.4438C15.3005 13.4785 15.325 13.5193 15.3407 13.5637C15.3564 13.608 15.363 13.6551 15.3602 13.7021C15.3631 13.7963 15.3291 13.8879 15.2653 13.9574C15.2016 14.027 15.1132 14.0689 15.0189 14.0744ZM16.6188 4.52128L19.4133 7.30852C19.4293 7.32624 19.4401 7.34808 19.4443 7.37157C19.4485 7.39506 19.446 7.41925 19.4371 7.4414C19.4282 7.46356 19.4133 7.48278 19.394 7.4969C19.3747 7.51102 19.3518 7.51947 19.328 7.52128H16.5868L16.4054 7.34043V4.60639C16.4073 4.5826 16.4157 4.55979 16.4299 4.54056C16.444 4.52133 16.4633 4.50644 16.4855 4.49757C16.5077 4.48871 16.532 4.48624 16.5556 4.49043C16.5791 4.49462 16.601 4.50531 16.6188 4.52128ZM18.6454 13.3192L20 14.6915L14.7522 20L14.7416 19.9894L14.1123 19.3617L13.3976 18.6277L11.3817 16.5638L12.7257 15.2021L14.7522 17.2553L18.6454 13.3192Z",
    rejectAllChanges: "M9.54637 16.5847H8.96997V15.8295H12.786C12.8024 15.8265 12.8186 15.8223 12.8343 15.817C12.8535 15.8105 12.8719 15.8023 12.8897 15.7926C12.9315 15.7697 12.969 15.738 12.9997 15.6991C13.0268 15.6649 13.0478 15.6261 13.0621 15.5847H13.571V16.7656H9.79386C9.78396 16.7479 9.77269 16.731 9.76011 16.7151C9.70552 16.6459 9.62976 16.5998 9.54637 16.5847ZM13.4717 12.9573V13.3295H9.72523C9.6809 13.3309 9.63716 13.3416 9.59671 13.361C9.57578 13.3711 9.55595 13.3834 9.53745 13.3977C9.5201 13.411 9.50391 13.4262 9.48917 13.4429C9.45872 13.4775 9.43494 13.5182 9.41917 13.5626C9.41778 13.5664 9.41644 13.5703 9.41523 13.5742H8.96997V12.8189H12.786C12.8694 12.8039 12.9452 12.7577 12.9997 12.6886C13.0078 12.6784 13.0153 12.6677 13.0223 12.6568L13.029 12.6458L13.033 12.6389L13.0397 12.6266C13.0452 12.6157 13.0503 12.6046 13.055 12.5931C13.0576 12.5869 13.0599 12.5806 13.0621 12.5742H13.6872C13.6453 12.5965 13.607 12.6269 13.5746 12.6644C13.5059 12.7439 13.469 12.849 13.4717 12.9573ZM9.82598 14.0742H13.4758C13.4809 14.0932 13.4904 14.1108 13.5037 14.1251C13.5242 14.147 13.552 14.1593 13.581 14.1593H13.6008L13.571 14.1912V14.8295H9.72523C9.64183 14.8445 9.56614 14.8907 9.51149 14.9598C9.4845 14.994 9.46351 15.0328 9.4492 15.0741H8.96997V14.3295H9.54637C9.62976 14.3145 9.70552 14.2683 9.76011 14.1992C9.78947 14.162 9.81166 14.1195 9.82598 14.0742ZM18.9075 8.2552V12.5317H17.7846V12.323C17.7978 12.2827 17.8047 12.2399 17.8047 12.1965C17.8047 12.106 17.7747 12.0184 17.7201 11.9493C17.6655 11.8801 17.5897 11.834 17.5063 11.8189H9.72523C9.64183 11.834 9.56614 11.8801 9.51149 11.9493C9.48444 11.9835 9.46351 12.0222 9.4492 12.0636H8.96997V11.3083H9.54637C9.63425 11.3028 9.71662 11.2608 9.776 11.1913C9.80687 11.1551 9.83029 11.113 9.84527 11.0676L9.84654 11.0637H14.2667C14.3501 11.0486 14.4258 11.0024 14.4805 10.9333C14.5231 10.8794 14.5507 10.8142 14.5607 10.7452C14.5636 10.7258 14.565 10.706 14.565 10.686C14.565 10.6658 14.5635 10.6458 14.5606 10.626C14.5572 10.6026 14.5516 10.5796 14.5442 10.5573C14.5299 10.5144 14.5084 10.4741 14.4805 10.4387C14.4258 10.3696 14.3501 10.3234 14.2667 10.3083H9.72529C9.6832 10.3159 9.64299 10.3314 9.60653 10.3538C9.57081 10.3759 9.5386 10.4045 9.51155 10.4387C9.49639 10.4579 9.4831 10.4785 9.47182 10.5002C9.46133 10.5205 9.45259 10.5417 9.44568 10.5636H8.96997V9.80838H9.16873C9.25656 9.80286 9.33899 9.76085 9.39837 9.69131C9.45775 9.62177 9.48947 9.53022 9.48674 9.43601C9.48711 9.42951 9.48735 9.42302 9.48741 9.41653C9.48741 9.41049 9.48729 9.40445 9.48705 9.39848C9.49457 9.41055 9.50269 9.42218 9.51155 9.43334C9.56614 9.50249 9.64189 9.54866 9.72529 9.56372H17.5063C17.5897 9.54866 17.6655 9.50249 17.7201 9.43334C17.7747 9.36419 17.8047 9.2766 17.8047 9.18603C17.8047 9.09552 17.7747 9.00786 17.7201 8.93878C17.6655 8.86963 17.5897 8.82346 17.5063 8.8084H9.72529C9.64189 8.82346 9.56614 8.86963 9.51155 8.93878C9.4569 9.00786 9.42694 9.09552 9.42694 9.18603L9.427 9.19707L9.42754 9.20875C9.41972 9.19661 9.41123 9.18499 9.40201 9.17389C9.38478 9.15311 9.36537 9.1346 9.34427 9.11863C9.33735 9.11344 9.33026 9.1085 9.32298 9.10383C9.31855 9.10097 9.31406 9.09824 9.30951 9.09565L9.30424 9.09266L9.29659 9.08857C9.28792 9.08402 9.27906 9.07993 9.27009 9.07623C9.2616 9.07279 9.25298 9.06974 9.24431 9.06701C9.21974 9.05935 9.19439 9.05461 9.16873 9.05305H8.96997V4.10638C8.97221 4.07897 8.9834 4.05328 9.00157 4.03383C9.01975 4.01437 9.04374 4.0024 9.06935 4H14.9325V7.1914C14.9401 7.43679 15.0216 7.67296 15.1649 7.86468C15.3082 8.0564 15.5055 8.19338 15.7275 8.2552C15.7927 8.27277 15.861 8.27277 15.9262 8.2552H18.9075ZM13.571 17.2975V19.4251L13.5722 19.4615C13.5835 19.6376 13.6323 19.8068 13.7133 19.957H4.10061C4.08718 19.9587 4.07355 19.9571 4.06077 19.9524C4.04799 19.9477 4.03637 19.9399 4.02681 19.9296C4.01724 19.9194 4.00997 19.907 4.00554 19.8933C4.00111 19.8796 3.99964 19.865 4.00124 19.8506V7.29778C4.00124 7.26957 4.01171 7.24251 4.03034 7.22256C4.04898 7.20261 4.07426 7.1914 4.10061 7.1914H8.38368V9.05305H4.99497C4.90708 9.05857 4.82471 9.10052 4.76533 9.17006C4.70589 9.2396 4.67423 9.33121 4.67696 9.42536C4.67411 9.52067 4.70547 9.61346 4.76461 9.68475C4.8238 9.75598 4.90623 9.80026 4.99497 9.80838H8.38368V10.5636H4.99497C4.96682 10.5645 4.93898 10.5692 4.91199 10.5774C4.89647 10.5821 4.88124 10.588 4.86644 10.5952C4.8494 10.6034 4.83308 10.613 4.81762 10.6241C4.79627 10.6393 4.77655 10.657 4.7589 10.6771C4.72846 10.7116 4.70468 10.7523 4.68891 10.7967C4.67314 10.8411 4.66574 10.8885 4.66701 10.9359C4.66641 10.9597 4.66792 10.9834 4.67156 11.0067C4.6752 11.03 4.68102 11.053 4.68891 11.0752C4.70468 11.1196 4.72846 11.1603 4.7589 11.1949C4.7731 11.211 4.78862 11.2256 4.80524 11.2386C4.81452 11.2459 4.82417 11.2527 4.83417 11.259C4.84461 11.2655 4.85534 11.2714 4.86644 11.2767C4.9069 11.2962 4.95063 11.3069 4.99497 11.3083H8.38368V12.0636H4.99503C4.91163 12.0787 4.83587 12.1249 4.78128 12.194C4.7526 12.2303 4.7307 12.2717 4.71639 12.3159C4.70347 12.3559 4.69667 12.3983 4.69667 12.4413C4.69667 12.5318 4.72664 12.6194 4.78128 12.6886C4.809 12.7237 4.84218 12.7529 4.87906 12.7751C4.89416 12.7842 4.90993 12.7921 4.92619 12.7988C4.94833 12.8079 4.97137 12.8147 4.99503 12.8189H8.38368V13.5742H4.99503C4.95275 13.5819 4.91242 13.5975 4.87584 13.62C4.8403 13.642 4.80822 13.6705 4.78128 13.7046C4.72664 13.7737 4.69667 13.8613 4.69667 13.9519C4.69667 14.0424 4.72664 14.13 4.78128 14.1992C4.83587 14.2683 4.91163 14.3145 4.99503 14.3295H8.38368V15.0741H4.99497C4.94644 15.0829 4.90047 15.1022 4.85977 15.1304C4.83878 15.145 4.81919 15.162 4.80136 15.1811C4.79439 15.1885 4.78765 15.1964 4.78122 15.2045C4.77188 15.2163 4.76327 15.2287 4.75539 15.2416C4.74441 15.2594 4.73495 15.2781 4.727 15.2975C4.71924 15.3163 4.71293 15.3358 4.70808 15.3558C4.70407 15.3723 4.7011 15.389 4.69922 15.4061C4.69752 15.4212 4.69667 15.4364 4.69667 15.4518C4.69667 15.5423 4.72664 15.6299 4.78122 15.6991C4.83587 15.7682 4.91157 15.8144 4.99497 15.8295H8.38368V16.5847H4.99497C4.91157 16.5998 4.83587 16.6459 4.78122 16.7151C4.72664 16.7842 4.69667 16.8718 4.69667 16.9624C4.69667 17.0529 4.72664 17.1405 4.78122 17.2097C4.83587 17.2788 4.91157 17.325 4.99497 17.34H9.54637C9.58655 17.3328 9.62496 17.3183 9.66008 17.2975H13.571ZM15.7573 4.52124L18.3609 7.30839C18.3758 7.32612 18.3858 7.34796 18.3897 7.37145C18.3937 7.39493 18.3914 7.41913 18.3831 7.44128C18.3748 7.46343 18.3609 7.48266 18.3429 7.49678C18.325 7.51089 18.3036 7.51934 18.2814 7.52115H15.7275L15.5585 7.34031V4.60634C15.5602 4.58255 15.5681 4.55975 15.5813 4.54051C15.5945 4.52128 15.6125 4.50639 15.6332 4.49753C15.6539 4.48867 15.6765 4.48619 15.6984 4.49038C15.7203 4.49457 15.7407 4.50526 15.7573 4.52124ZM14.1248 5.91437C14.1732 5.97391 14.2021 6.04884 14.2071 6.1276C14.2157 6.17377 14.2155 6.22129 14.2065 6.26739C14.2045 6.27778 14.2021 6.28804 14.1992 6.29817L14.1944 6.31388C14.1847 6.34291 14.1715 6.3705 14.1551 6.39595C14.13 6.43465 14.098 6.46757 14.0608 6.49276C14.0354 6.5099 14.008 6.52328 13.9794 6.53244C13.9661 6.53672 13.9525 6.5401 13.9387 6.5425H9.71529C9.62309 6.5425 9.5346 6.50328 9.4694 6.43342C9.40413 6.36362 9.3675 6.26889 9.3675 6.17013C9.3675 6.07144 9.40413 5.97671 9.4694 5.90691C9.5346 5.83704 9.62309 5.79783 9.71529 5.79783H13.9387C13.9718 5.80516 14.0034 5.81769 14.0326 5.83484C14.0672 5.85522 14.0984 5.88204 14.1248 5.91437ZM14.2667 7.29776H9.72529C9.69606 7.30302 9.66773 7.31211 9.64092 7.3247C9.62612 7.33171 9.61175 7.33977 9.59798 7.34879C9.56565 7.36996 9.53642 7.39664 9.51155 7.42813C9.4569 7.49722 9.42694 7.58487 9.42694 7.67538C9.42694 7.70155 9.42942 7.72752 9.43434 7.75285C9.44635 7.81505 9.47273 7.87355 9.51155 7.9227C9.55292 7.9751 9.60647 8.01432 9.66628 8.03678C9.67762 8.04107 9.6892 8.04477 9.70097 8.04775C9.70898 8.04983 9.71711 8.05158 9.72529 8.05308H14.2667C14.3546 8.04756 14.437 8.00555 14.4964 7.93601C14.5558 7.86647 14.5875 7.77492 14.5847 7.68071C14.5874 7.63318 14.5813 7.58559 14.5667 7.54059C14.5522 7.4956 14.5296 7.45417 14.5 7.41859C14.4704 7.38301 14.4346 7.35398 14.3946 7.33327C14.3546 7.31256 14.3111 7.30048 14.2667 7.29776ZM4.99497 18.84H12.786C12.8783 18.84 12.9667 18.8008 13.032 18.731C13.0972 18.6611 13.1338 18.5664 13.1338 18.4677C13.1338 18.3689 13.0972 18.2742 13.032 18.2044C12.9667 18.1346 12.8783 18.0954 12.786 18.0954H4.99497C4.90277 18.0954 4.81428 18.1346 4.74908 18.2044C4.68381 18.2742 4.64718 18.3689 4.64718 18.4677C4.64718 18.5664 4.68381 18.6611 4.74908 18.731C4.81428 18.8008 4.90277 18.84 4.99497 18.84ZM17.5858 12.7444H19.5733H19.623C19.7249 12.7499 19.821 12.7971 19.8913 12.8764C19.9616 12.9556 20.0007 13.0607 20.0006 13.17V13.8295C20.0007 13.8458 19.9976 13.862 19.9914 13.8769C19.9853 13.8918 19.9764 13.9052 19.9652 13.9163C19.9539 13.9273 19.9407 13.9357 19.9262 13.9409C19.9118 13.9461 19.8965 13.948 19.8814 13.9465H13.7797C13.7507 13.9465 13.7229 13.9342 13.7024 13.9123C13.6819 13.8903 13.6704 13.8606 13.6704 13.8295V13.17C13.6677 13.0617 13.7046 12.9566 13.7733 12.8771C13.842 12.7976 13.9371 12.75 14.0381 12.7444H16.0256V12.5104C16.0352 12.439 16.0687 12.3737 16.1199 12.3268C16.1711 12.2798 16.2365 12.2544 16.3039 12.2551H17.2976C17.3667 12.2517 17.4345 12.276 17.4878 12.3232C17.541 12.3704 17.576 12.4371 17.5858 12.5104V12.7444ZM14.0679 19.4251V14.1912H19.5037V19.4251C19.4935 19.585 19.4256 19.7344 19.3143 19.8416C19.203 19.9488 19.0571 20.0055 18.9075 19.9996H14.6642C14.5146 20.0055 14.3687 19.9488 14.2574 19.8416C14.1461 19.7344 14.0781 19.585 14.0679 19.4251ZM15.5983 15.1593H15.2505C15.0969 15.1593 14.9723 15.2926 14.9723 15.4572V18.7336C14.9723 18.8981 15.0969 19.0315 15.2505 19.0315H15.5983C15.752 19.0315 15.8766 18.8981 15.8766 18.7336V15.4572C15.8766 15.2926 15.752 15.1593 15.5983 15.1593ZM16.9598 15.1593H16.612C16.4583 15.1593 16.3337 15.2926 16.3337 15.4572V18.7336C16.3337 18.8981 16.4583 19.0315 16.612 19.0315H16.9598C17.1135 19.0315 17.238 18.8981 17.238 18.7336V15.4572C17.238 15.2926 17.1135 15.1593 16.9598 15.1593ZM17.9635 15.1593H18.3113C18.465 15.1593 18.5895 15.2926 18.5895 15.4572V18.7336C18.5895 18.8981 18.465 19.0315 18.3113 19.0315H17.9635C17.8098 19.0315 17.6852 18.8981 17.6852 18.7336V15.4572C17.6852 15.2926 17.8098 15.1593 17.9635 15.1593Z",
    acceptSingleChange: "M17.2 20H15.6628L17.33 18.3091V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H14.4978L14.1823 19.6791L13.5135 18.9904L13.5123 18.9891L13.0529 18.52H5C4.87537 18.52 4.75586 18.4705 4.66766 18.3823C4.57953 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 17.9253 4.57953 17.8058 4.66766 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H12.1323L11.6235 17.0604L11.6231 16.48L12.8831 15.19L13.4765 15.1896L15.0807 16.8276L17.33 14.5413V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5208 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9534 6.49057 10.9224 6.43948 10.8825 6.39581C10.8425 6.35217 10.7944 6.3168 10.7408 6.29178C10.6871 6.26678 10.6292 6.25256 10.57 6.25H5C4.88239 6.25772 4.77252 6.31131 4.69397 6.39917C4.61542 6.48706 4.57452 6.60226 4.58002 6.72C4.57452 6.83774 4.61542 6.95294 4.69397 7.04083C4.77252 7.12869 4.88239 7.18228 5 7.19H10.6C10.7141 7.1774 10.8189 7.12173 10.8933 7.03436C10.9677 6.94702 11.0058 6.83456 11 6.72ZM11.1 8.14001H5C4.87537 8.14001 4.75586 8.18954 4.66766 8.27768C4.57953 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57953 8.85422 4.66766 8.94235C4.71558 8.99023 4.77277 9.02673 4.83496 9.05008C4.86932 9.06296 4.90521 9.07184 4.94189 9.07642C4.96106 9.0788 4.98047 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.5205 8.85422 11.57 8.73468 11.57 8.61002C11.57 8.48535 11.5205 8.36581 11.4324 8.27768C11.3442 8.18954 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8035 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8035 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86737 10 4.74023 10.0527 4.64642 10.1465C4.55267 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55267 10.7598 4.64642 10.8535C4.74023 10.9473 4.86737 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.416 12.0552C11.3337 11.9673 11.2203 11.9152 11.1 11.91H5C4.94086 11.9126 4.88287 11.9268 4.82922 11.9518C4.77563 11.9768 4.72748 12.0122 4.6875 12.0558C4.65833 12.0878 4.63391 12.1237 4.61505 12.1624C4.60809 12.1767 4.60193 12.1913 4.5965 12.2062C4.58264 12.2443 4.5741 12.2841 4.57092 12.3243C4.56946 12.3428 4.56915 12.3614 4.57001 12.38C4.56451 12.5004 4.60651 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM15.45 14.74H5C4.87537 14.74 4.75586 14.6905 4.66766 14.6023C4.57953 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57953 14.0258 4.66766 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9377C15.8705 14.0258 15.92 14.1453 15.92 14.27C15.92 14.3947 15.8705 14.5142 15.7823 14.6023C15.6942 14.6905 15.5747 14.74 15.45 14.74ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66766 16.4923C4.57953 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57953 15.9158 4.66766 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.73 13.71L20 15.01L15.08 20L15.07 19.99L14.48 19.39L13.81 18.7L11.92 16.77L13.18 15.48L15.08 17.42L18.73 13.71Z",
    rejectSingleChange: "M17.0495 11.5C17.1461 11.5 17.241 11.5173 17.33 11.5501V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20H13.2305C13.1075 19.8287 13.0338 19.6249 13.0205 19.4112L13.0195 19.3956V18.52H5C4.87537 18.52 4.75586 18.4705 4.66772 18.3823C4.57959 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 18.0119 4.53467 17.9742 4.54358 17.9378C4.56396 17.8552 4.60657 17.7788 4.66772 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H13.0195V14.74H5C4.87537 14.74 4.75586 14.6905 4.66772 14.6023C4.57959 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57959 14.0258 4.66772 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H12.8393C12.6229 13.6377 12.4998 13.3897 12.4998 13.1032C12.4997 12.8414 12.6008 12.5847 12.7513 12.3911C12.9 12.1998 13.1561 12 13.4994 12L15.2519 12C15.2928 11.8972 15.3589 11.7915 15.4649 11.6992C15.6135 11.5698 15.8041 11.499 16.0011 11.5H17.0495ZM13.1 4.65L16.6 8.15C16.6211 8.17232 16.6354 8.20028 16.6411 8.23051C16.6468 8.26075 16.6437 8.29199 16.6321 8.32048C16.6204 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8311 4.72925 12.8411 4.6995 12.8588 4.67429C12.8764 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9892 4.60315 13.0194 4.60884C13.0497 4.61453 13.0776 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9716 6.5408 10.9695 6.53543 10.9673 6.53012C10.9626 6.51852 10.9575 6.50717 10.9518 6.49603C10.9406 6.47391 10.9275 6.45273 10.9127 6.43274C10.9033 6.41992 10.8932 6.40759 10.8824 6.39581C10.8425 6.35217 10.7943 6.3168 10.7407 6.29178C10.6871 6.26678 10.629 6.25256 10.5699 6.25H5C4.88232 6.25772 4.77246 6.31131 4.69397 6.39917C4.61536 6.48706 4.57446 6.60226 4.57996 6.72C4.57715 6.7811 4.58679 6.84152 4.60767 6.8978C4.61523 6.91803 4.62415 6.93771 4.63452 6.9567C4.65088 6.98669 4.67078 7.01495 4.69397 7.04083C4.77246 7.12869 4.88232 7.18228 5 7.19H10.6C10.714 7.1774 10.8188 7.12173 10.8932 7.03436C10.922 7.00049 10.9454 6.96283 10.9629 6.92273C10.9725 6.9006 10.9805 6.87775 10.9865 6.8544C10.9933 6.82791 10.9977 6.80075 10.9995 6.77325C11.0001 6.76453 11.0004 6.75574 11.0005 6.74695C11.0006 6.73798 11.0005 6.729 11 6.72ZM11.1 8.14001H5C4.97534 8.14001 4.95081 8.14194 4.92676 8.14575C4.89587 8.15063 4.8656 8.15857 4.83643 8.1694C4.77368 8.19272 4.71606 8.2294 4.66772 8.27768C4.57959 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57959 8.85422 4.66772 8.94235C4.75586 9.03049 4.87537 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.4617 8.91306 11.4867 8.88028 11.5071 8.845C11.5349 8.79691 11.554 8.74414 11.5634 8.68915C11.5677 8.66318 11.5701 8.63672 11.5701 8.61002C11.5701 8.48535 11.5205 8.36581 11.4324 8.27768C11.3929 8.23831 11.3474 8.20663 11.2979 8.18365C11.2365 8.15518 11.1689 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86743 10 4.74023 10.0527 4.64648 10.1465C4.55273 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55273 10.7598 4.64648 10.8535C4.74023 10.9473 4.86743 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4987 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3336 11.9673 11.2202 11.9152 11.1 11.91H5C4.94092 11.9126 4.88281 11.9268 4.82922 11.9518C4.77563 11.9768 4.72742 12.0122 4.6875 12.0558C4.64758 12.0995 4.6167 12.1506 4.59644 12.2062C4.58899 12.2266 4.58313 12.2475 4.57874 12.2687C4.57129 12.3052 4.56824 12.3426 4.56995 12.38C4.56445 12.5004 4.60645 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66772 16.4923C4.57959 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57959 15.9158 4.66772 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.5701 16.0353 11.5701 16.16C11.5701 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM19.59 12.53H17.36V12.3C17.3574 12.2195 17.3236 12.1432 17.2657 12.0872C17.2078 12.0313 17.1305 12 17.05 12H16C15.9242 11.9994 15.8509 12.0265 15.7938 12.0762C15.7367 12.126 15.6997 12.1949 15.69 12.27V12.5H13.44C13.3768 12.4994 13.3142 12.5125 13.2565 12.5382C13.1988 12.564 13.1473 12.6019 13.1055 12.6493C13.0638 12.6968 13.0327 12.7526 13.0145 12.8132C12.9963 12.8737 12.9913 12.9374 13 13V13.67C13 13.6871 13.0033 13.704 13.0099 13.7198C13.0164 13.7355 13.026 13.7499 13.038 13.7619C13.0501 13.774 13.0644 13.7836 13.0802 13.7901C13.096 13.7966 13.1129 13.8 13.13 13.8H19.84C19.8611 13.8054 19.8834 13.8054 19.9045 13.8C19.9257 13.7946 19.9452 13.7839 19.9611 13.7689C19.9771 13.754 19.989 13.7352 19.9958 13.7144C20.0026 13.6937 20.004 13.6715 20 13.65V13C20.0028 12.8866 19.9617 12.7765 19.8853 12.6927C19.809 12.6088 19.7031 12.5577 19.59 12.55V12.53ZM13.52 14V19.38C13.5303 19.5454 13.6054 19.7 13.7289 19.8105C13.8525 19.9209 14.0145 19.9782 14.18 19.97H18.84C19.0055 19.9782 19.1676 19.9209 19.2911 19.8105C19.4146 19.7 19.4897 19.5454 19.5 19.38V14H13.52ZM15.52 18.67C15.52 18.7522 15.4874 18.8311 15.4292 18.8892C15.3711 18.9473 15.2922 18.98 15.21 18.98H14.83C14.7478 18.98 14.669 18.9473 14.6108 18.8892C14.5527 18.8311 14.52 18.7522 14.52 18.67V15.33C14.52 15.2893 14.528 15.249 14.5436 15.2114C14.5592 15.1738 14.582 15.1396 14.6108 15.1108C14.6396 15.082 14.6738 15.0592 14.7114 15.0436C14.749 15.028 14.7893 15.02 14.83 15.02H15.21C15.2507 15.02 15.291 15.028 15.3287 15.0436C15.3663 15.0592 15.4004 15.082 15.4292 15.1108C15.458 15.1396 15.4808 15.1738 15.4964 15.2114C15.512 15.249 15.52 15.2893 15.52 15.33V18.67ZM17.01 18.67C17.01 18.7522 16.9774 18.8311 16.9192 18.8892C16.8611 18.9473 16.7822 18.98 16.7 18.98H16.32C16.2798 18.98 16.2399 18.9719 16.2029 18.9562C16.1658 18.9405 16.1323 18.9176 16.1043 18.8886C16.0763 18.8597 16.0544 18.8254 16.0399 18.7879C16.0254 18.7503 16.0187 18.7102 16.02 18.67V15.33C16.0187 15.2898 16.0254 15.2497 16.0399 15.2121C16.0544 15.1746 16.0763 15.1403 16.1043 15.1114C16.1323 15.0824 16.1658 15.0595 16.2029 15.0438C16.2399 15.0281 16.2798 15.02 16.32 15.02H16.7C16.7407 15.02 16.781 15.028 16.8187 15.0436C16.8563 15.0592 16.8904 15.082 16.9192 15.1108C16.948 15.1396 16.9708 15.1738 16.9864 15.2114C17.002 15.249 17.01 15.2893 17.01 15.33V18.67ZM18.51 18.67C18.51 18.7107 18.502 18.751 18.4864 18.7886C18.4708 18.8262 18.448 18.8604 18.4192 18.8892C18.3904 18.918 18.3563 18.9408 18.3187 18.9564C18.281 18.972 18.2407 18.98 18.2 18.98H17.82C17.7378 18.98 17.659 18.9473 17.6008 18.8892C17.5427 18.8311 17.51 18.7522 17.51 18.67V15.33C17.51 15.2893 17.518 15.249 17.5336 15.2114C17.5492 15.1738 17.572 15.1396 17.6008 15.1108C17.6296 15.082 17.6638 15.0592 17.7014 15.0436C17.739 15.028 17.7793 15.02 17.82 15.02H18.2C18.2407 15.02 18.281 15.028 18.3187 15.0436C18.3563 15.0592 18.3904 15.082 18.4192 15.1108C18.448 15.1396 18.4708 15.1738 18.4864 15.2114C18.502 15.249 18.51 15.2893 18.51 15.33V18.67Z"
  }, xt.FILEICONS = {
    docIcon: {
      extension: ".doc",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.617188 46.875 C 13.234375 46.875 16.160156 43.929688 16.160156 40.292969 C 16.160156 36.695312 13.234375 33.75 9.617188 33.75 L 7.402344 33.75 C 6.820312 33.75 6.371094 34.199219 6.371094 34.78125 L 6.371094 45.84375 C 6.371094 46.335938 6.714844 46.757812 7.191406 46.855469 L 7.402344 46.875 Z M 9.617188 44.792969 L 8.453125 44.792969 L 8.453125 35.832031 L 9.617188 35.832031 C 12.089844 35.832031 14.078125 37.835938 14.078125 40.292969 C 14.078125 42.789062 12.089844 44.773438 9.617188 44.792969 Z M 24.816406 46.875 C 26.539062 46.875 28.191406 46.085938 29.296875 44.867188 C 30.460938 43.648438 31.191406 41.980469 31.191406 40.125 C 31.191406 38.269531 30.460938 36.617188 29.296875 35.382812 C 28.191406 34.144531 26.539062 33.375 24.816406 33.375 C 23.015625 33.375 21.367188 34.144531 20.222656 35.382812 C 19.058594 36.617188 18.367188 38.269531 18.367188 40.125 C 18.367188 41.980469 19.058594 43.648438 20.222656 44.867188 C 21.367188 46.085938 23.015625 46.875 24.816406 46.875 Z M 24.816406 44.738281 C 23.617188 44.738281 22.566406 44.230469 21.777344 43.386719 C 20.992188 42.582031 20.503906 41.398438 20.503906 40.125 C 20.503906 38.851562 20.992188 37.667969 21.777344 36.84375 C 22.566406 36 23.617188 35.511719 24.816406 35.511719 C 25.941406 35.511719 26.992188 36 27.777344 36.84375 C 28.546875 37.667969 29.054688 38.851562 29.054688 40.125 C 29.054688 41.398438 28.546875 42.582031 27.777344 43.386719 C 26.992188 44.230469 25.941406 44.738281 24.816406 44.738281 Z M 39.996094 46.875 C 41.648438 46.875 43.148438 46.332031 44.328125 45.414062 C 44.777344 45.054688 44.851562 44.382812 44.515625 43.914062 C 44.140625 43.460938 43.445312 43.386719 43.015625 43.707031 C 42.171875 44.382812 41.160156 44.738281 39.996094 44.738281 C 38.703125 44.738281 37.503906 44.210938 36.621094 43.386719 C 35.777344 42.5625 35.253906 41.398438 35.253906 40.125 C 35.253906 38.851562 35.777344 37.726562 36.621094 36.863281 C 37.503906 36.039062 38.703125 35.511719 39.996094 35.511719 C 41.160156 35.511719 42.191406 35.867188 43.015625 36.542969 C 43.445312 36.882812 44.140625 36.804688 44.515625 36.335938 C 44.851562 35.867188 44.777344 35.210938 44.328125 34.835938 C 43.148438 33.917969 41.648438 33.375 39.996094 33.375 C 36.246094 33.394531 33.132812 36.414062 33.117188 40.125 C 33.132812 43.855469 36.246094 46.875 39.996094 46.875 Z M 39.996094 46.875 "/>\n      </g>'
    },
    gifIcon: {
      extension: ".gif",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.394531 46.875 C 18.988281 46.875 20.46875 46.332031 21.648438 45.414062 C 21.835938 45.28125 21.949219 45.132812 22.003906 44.960938 L 22.003906 44.945312 C 22.023438 44.90625 22.023438 44.886719 22.042969 44.851562 C 22.0625 44.738281 22.097656 44.664062 22.097656 44.53125 L 22.097656 40.386719 C 22.097656 39.789062 21.613281 39.335938 21.011719 39.335938 L 17.28125 39.335938 C 16.699219 39.335938 16.210938 39.789062 16.210938 40.386719 C 16.210938 40.96875 16.699219 41.457031 17.28125 41.457031 L 19.960938 41.457031 L 19.960938 44.023438 C 19.210938 44.457031 18.332031 44.738281 17.394531 44.738281 C 16.042969 44.738281 14.863281 44.230469 14.019531 43.367188 C 13.136719 42.523438 12.613281 41.382812 12.613281 40.144531 C 12.613281 38.867188 13.136719 37.726562 14.019531 36.882812 C 14.863281 36.019531 16.042969 35.511719 17.394531 35.511719 C 18.519531 35.511719 19.550781 35.90625 20.355469 36.523438 C 20.824219 36.898438 21.519531 36.804688 21.875 36.355469 C 22.230469 35.886719 22.15625 35.195312 21.667969 34.835938 C 20.503906 33.917969 18.988281 33.375 17.394531 33.375 C 13.585938 33.375 10.472656 36.375 10.472656 40.144531 C 10.472656 43.894531 13.585938 46.875 17.394531 46.875 Z M 26.945312 46.875 C 27.507812 46.875 27.996094 46.425781 27.996094 45.84375 L 27.996094 34.78125 C 27.996094 34.199219 27.507812 33.75 26.945312 33.75 C 26.363281 33.75 25.914062 34.199219 25.914062 34.78125 L 25.914062 45.84375 C 25.914062 46.425781 26.363281 46.875 26.945312 46.875 Z M 33.066406 46.875 C 33.648438 46.875 34.117188 46.40625 34.117188 45.84375 L 34.117188 41.34375 L 38.488281 41.34375 C 39.050781 41.34375 39.519531 40.875 39.519531 40.292969 C 39.519531 39.75 39.050781 39.261719 38.488281 39.261719 L 34.117188 39.261719 L 34.117188 35.832031 L 39.199219 35.832031 C 39.742188 35.832031 40.230469 35.363281 40.230469 34.78125 C 40.230469 34.21875 39.742188 33.75 39.199219 33.75 L 33.066406 33.75 C 32.488281 33.75 32.035156 34.21875 32.035156 34.78125 L 32.035156 45.84375 C 32.035156 46.40625 32.488281 46.875 33.066406 46.875 Z M 33.066406 46.875 "/>\n      </g>'
    },
    jpegIcon: {
      extension: ".jpeg",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9 43.75 C 11.140625 43.75 12.890625 42.015625 12.890625 39.875 L 12.890625 33.671875 C 12.890625 33.1875 12.5 32.8125 12.03125 32.8125 C 11.546875 32.8125 11.15625 33.1875 11.15625 33.671875 L 11.15625 39.875 C 11.15625 41.046875 10.1875 42.015625 9 42.015625 C 8.046875 42.015625 7.234375 41.390625 6.953125 40.53125 C 6.8125 40.078125 6.328125 39.828125 5.859375 39.984375 C 5.421875 40.109375 5.15625 40.59375 5.3125 41.0625 C 5.8125 42.625 7.28125 43.75 9 43.75 Z M 15.640625 43.75 C 16.125 43.75 16.515625 43.359375 16.515625 42.890625 L 16.515625 39.5 L 18.4375 39.5 C 20.296875 39.5 21.796875 38 21.796875 36.171875 C 21.796875 34.3125 20.296875 32.8125 18.4375 32.8125 L 15.640625 32.8125 C 15.171875 32.8125 14.78125 33.1875 14.78125 33.671875 L 14.78125 42.890625 C 14.78125 43.359375 15.171875 43.75 15.640625 43.75 Z M 18.4375 37.765625 L 16.515625 37.765625 L 16.515625 34.546875 L 18.4375 34.546875 C 19.34375 34.546875 20.046875 35.265625 20.0625 36.171875 C 20.046875 37.046875 19.34375 37.765625 18.4375 37.765625 Z M 29.234375 43.75 C 29.6875 43.75 30.09375 43.359375 30.09375 42.890625 C 30.09375 42.40625 29.6875 42.015625 29.234375 42.015625 L 25 42.015625 L 25 39.140625 L 28.640625 39.140625 C 29.109375 39.140625 29.5 38.75 29.5 38.265625 C 29.5 37.8125 29.109375 37.40625 28.640625 37.40625 L 25 37.40625 L 25 34.546875 L 29.234375 34.546875 C 29.6875 34.546875 30.09375 34.15625 30.09375 33.671875 C 30.09375 33.1875 29.6875 32.8125 29.234375 32.8125 L 24.125 32.8125 C 23.640625 32.8125 23.265625 33.1875 23.265625 33.671875 L 23.265625 42.890625 C 23.265625 43.359375 23.640625 43.75 24.125 43.75 C 24.125 43.75 24.140625 43.734375 24.140625 43.734375 C 24.140625 43.734375 24.140625 43.75 24.171875 43.75 Z M 37.1875 43.75 C 38.515625 43.75 39.75 43.296875 40.734375 42.53125 C 40.890625 42.421875 40.984375 42.296875 41.03125 42.15625 L 41.03125 42.140625 C 41.046875 42.109375 41.046875 42.09375 41.0625 42.0625 C 41.078125 41.96875 41.109375 41.90625 41.109375 41.796875 L 41.109375 38.34375 C 41.109375 37.914062 40.8125 37.578125 40.410156 37.492188 L 40.203125 37.46875 L 37.09375 37.46875 C 36.609375 37.46875 36.203125 37.84375 36.203125 38.34375 C 36.203125 38.828125 36.609375 39.234375 37.09375 39.234375 L 39.328125 39.234375 L 39.328125 41.375 C 38.703125 41.734375 37.96875 41.96875 37.1875 41.96875 C 36.0625 41.96875 35.078125 41.546875 34.375 40.828125 C 33.640625 40.125 33.203125 39.171875 33.203125 38.140625 C 33.203125 37.078125 33.640625 36.125 34.375 35.421875 C 35.078125 34.703125 36.0625 34.28125 37.1875 34.28125 C 38.125 34.28125 38.984375 34.609375 39.65625 35.125 C 40.046875 35.4375 40.625 35.359375 40.921875 34.984375 C 41.21875 34.59375 41.15625 34.015625 40.75 33.71875 C 39.78125 32.953125 38.515625 32.5 37.1875 32.5 C 34.015625 32.5 31.421875 35 31.421875 38.140625 C 31.421875 41.265625 34.015625 43.75 37.1875 43.75 Z M 37.1875 43.75 "/>\n      </g>'
    },
    logIcon: {
      extension: ".log",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.542969 46.875 C 14.085938 46.875 14.574219 46.40625 14.574219 45.84375 C 14.574219 45.261719 14.085938 44.792969 13.542969 44.792969 L 8.460938 44.792969 L 8.460938 34.78125 C 8.460938 34.21875 7.992188 33.75 7.410156 33.75 C 6.828125 33.75 6.378906 34.21875 6.378906 34.78125 L 6.378906 45.84375 C 6.378906 46.40625 6.828125 46.875 7.410156 46.875 Z M 21.742188 46.875 C 23.46875 46.875 25.117188 46.085938 26.222656 44.867188 C 27.386719 43.648438 28.117188 41.980469 28.117188 40.125 C 28.117188 38.269531 27.386719 36.617188 26.222656 35.382812 C 25.117188 34.144531 23.46875 33.375 21.742188 33.375 C 19.941406 33.375 18.292969 34.144531 17.148438 35.382812 C 15.984375 36.617188 15.292969 38.269531 15.292969 40.125 C 15.292969 41.980469 15.984375 43.648438 17.148438 44.867188 C 18.292969 46.085938 19.941406 46.875 21.742188 46.875 Z M 21.742188 44.738281 C 20.542969 44.738281 19.492188 44.230469 18.703125 43.386719 C 17.917969 42.582031 17.429688 41.398438 17.429688 40.125 C 17.429688 38.851562 17.917969 37.667969 18.703125 36.84375 C 19.492188 36 20.542969 35.511719 21.742188 35.511719 C 22.867188 35.511719 23.917969 36 24.703125 36.84375 C 25.472656 37.667969 25.980469 38.851562 25.980469 40.125 C 25.980469 41.398438 25.472656 42.582031 24.703125 43.386719 C 23.917969 44.230469 22.867188 44.738281 21.742188 44.738281 Z M 37.300781 46.875 C 38.894531 46.875 40.375 46.332031 41.558594 45.414062 C 41.746094 45.28125 41.855469 45.132812 41.914062 44.960938 L 41.914062 44.945312 L 41.949219 44.851562 C 41.96875 44.738281 42.007812 44.664062 42.007812 44.53125 L 42.007812 40.386719 C 42.007812 39.789062 41.519531 39.335938 40.917969 39.335938 L 37.1875 39.335938 C 36.605469 39.335938 36.121094 39.789062 36.121094 40.386719 C 36.121094 40.96875 36.605469 41.457031 37.1875 41.457031 L 39.871094 41.457031 L 39.871094 44.023438 C 39.121094 44.457031 38.238281 44.738281 37.300781 44.738281 C 35.949219 44.738281 34.769531 44.230469 33.925781 43.367188 C 33.042969 42.523438 32.519531 41.382812 32.519531 40.144531 C 32.519531 38.867188 33.042969 37.726562 33.925781 36.882812 C 34.769531 36.019531 35.949219 35.511719 37.300781 35.511719 C 38.425781 35.511719 39.457031 35.90625 40.261719 36.523438 C 40.730469 36.898438 41.425781 36.804688 41.78125 36.355469 C 42.136719 35.886719 42.0625 35.195312 41.574219 34.835938 C 40.414062 33.917969 38.894531 33.375 37.300781 33.375 C 33.496094 33.375 30.382812 36.375 30.382812 40.144531 C 30.382812 43.894531 33.496094 46.875 37.300781 46.875 Z M 37.300781 46.875 "/>\n      </g>'
    },
    movIcon: {
      extension: ".mov",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 15.472656 46.875 C 16.035156 46.875 16.523438 46.40625 16.523438 45.84375 L 16.523438 34.78125 C 16.523438 34.289062 16.152344 33.882812 15.679688 33.777344 L 15.472656 33.75 L 15.453125 33.75 C 15.117188 33.75 14.816406 33.898438 14.609375 34.179688 L 10.878906 39.355469 L 7.148438 34.179688 C 6.960938 33.898438 6.625 33.75 6.324219 33.75 L 6.265625 33.75 C 5.703125 33.75 5.234375 34.21875 5.234375 34.78125 L 5.234375 45.84375 C 5.234375 46.40625 5.703125 46.875 6.265625 46.875 C 6.847656 46.875 7.316406 46.40625 7.316406 45.84375 L 7.316406 37.949219 L 10 41.699219 C 10.203125 41.980469 10.523438 42.132812 10.859375 42.132812 L 10.898438 42.132812 C 11.234375 42.132812 11.535156 41.980469 11.742188 41.699219 L 14.441406 37.949219 L 14.441406 45.84375 C 14.441406 46.40625 14.890625 46.875 15.472656 46.875 Z M 25.460938 46.875 C 27.1875 46.875 28.835938 46.085938 29.941406 44.867188 C 31.105469 43.648438 31.835938 41.980469 31.835938 40.125 C 31.835938 38.269531 31.105469 36.617188 29.941406 35.382812 C 28.835938 34.144531 27.1875 33.375 25.460938 33.375 C 23.660156 33.375 22.011719 34.144531 20.867188 35.382812 C 19.703125 36.617188 19.011719 38.269531 19.011719 40.125 C 19.011719 41.980469 19.703125 43.648438 20.867188 44.867188 C 22.011719 46.085938 23.660156 46.875 25.460938 46.875 Z M 25.460938 44.738281 C 24.261719 44.738281 23.210938 44.230469 22.421875 43.386719 C 21.636719 42.582031 21.148438 41.398438 21.148438 40.125 C 21.148438 38.851562 21.636719 37.667969 22.421875 36.84375 C 23.210938 36 24.261719 35.511719 25.460938 35.511719 C 26.585938 35.511719 27.636719 36 28.421875 36.84375 C 29.191406 37.667969 29.699219 38.851562 29.699219 40.125 C 29.699219 41.398438 29.191406 42.582031 28.421875 43.386719 C 27.636719 44.230469 26.585938 44.738281 25.460938 44.738281 Z M 38.683594 46.855469 L 38.71875 46.855469 C 38.777344 46.835938 38.8125 46.820312 38.871094 46.820312 C 38.886719 46.800781 38.886719 46.800781 38.90625 46.800781 C 38.964844 46.78125 39.019531 46.726562 39.058594 46.707031 L 39.09375 46.6875 L 39.207031 46.59375 C 39.226562 46.574219 39.226562 46.574219 39.246094 46.539062 L 39.339844 46.425781 C 39.355469 46.425781 39.355469 46.425781 39.355469 46.40625 C 39.394531 46.367188 39.414062 46.292969 39.433594 46.257812 L 44.0625 35.304688 C 44.269531 34.800781 44.027344 34.179688 43.5 33.976562 C 42.996094 33.75 42.375 33.992188 42.152344 34.519531 L 38.496094 43.199219 L 34.839844 34.519531 C 34.613281 33.992188 34.011719 33.75 33.507812 33.976562 C 32.964844 34.179688 32.71875 34.800781 32.945312 35.304688 L 37.539062 46.257812 C 37.574219 46.292969 37.613281 46.367188 37.632812 46.40625 C 37.632812 46.425781 37.652344 46.425781 37.652344 46.425781 C 37.667969 46.460938 37.707031 46.5 37.746094 46.539062 C 37.746094 46.574219 37.761719 46.574219 37.761719 46.59375 C 37.820312 46.632812 37.855469 46.648438 37.894531 46.6875 L 37.914062 46.6875 C 37.96875 46.726562 38.042969 46.78125 38.082031 46.800781 L 38.101562 46.800781 C 38.101562 46.800781 38.121094 46.800781 38.121094 46.820312 C 38.15625 46.820312 38.230469 46.835938 38.269531 46.855469 L 38.308594 46.855469 L 38.402344 46.871094 L 38.496094 46.875 C 38.550781 46.875 38.605469 46.875 38.683594 46.855469 Z M 38.683594 46.855469 "/>\n      </g>'
    },
    ogvIcon: {
      extension: ".ogv",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 11.511719 46.875 C 13.238281 46.875 14.886719 46.085938 15.996094 44.867188 C 17.15625 43.648438 17.886719 41.980469 17.886719 40.125 C 17.886719 38.269531 17.15625 36.617188 15.996094 35.382812 C 14.886719 34.144531 13.238281 33.375 11.511719 33.375 C 9.714844 33.375 8.0625 34.144531 6.917969 35.382812 C 5.757812 36.617188 5.0625 38.269531 5.0625 40.125 C 5.0625 41.980469 5.757812 43.648438 6.917969 44.867188 C 8.0625 46.085938 9.714844 46.875 11.511719 46.875 Z M 11.511719 44.738281 C 10.3125 44.738281 9.261719 44.230469 8.476562 43.386719 C 7.6875 42.582031 7.199219 41.398438 7.199219 40.125 C 7.199219 38.851562 7.6875 37.667969 8.476562 36.84375 C 9.261719 36 10.3125 35.511719 11.511719 35.511719 C 12.636719 35.511719 13.6875 36 14.476562 36.84375 C 15.246094 37.667969 15.75 38.851562 15.75 40.125 C 15.75 41.398438 15.246094 42.582031 14.476562 43.386719 C 13.6875 44.230469 12.636719 44.738281 11.511719 44.738281 Z M 27.25 46.875 C 28.84375 46.875 30.324219 46.332031 31.507812 45.414062 C 31.695312 45.28125 31.804688 45.132812 31.863281 44.960938 L 31.863281 44.945312 C 31.882812 44.90625 31.882812 44.886719 31.898438 44.851562 C 31.917969 44.738281 31.957031 44.664062 31.957031 44.53125 L 31.957031 40.386719 C 31.957031 39.789062 31.46875 39.335938 30.867188 39.335938 L 27.136719 39.335938 C 26.554688 39.335938 26.070312 39.789062 26.070312 40.386719 C 26.070312 40.96875 26.554688 41.457031 27.136719 41.457031 L 29.820312 41.457031 L 29.820312 44.023438 C 29.070312 44.457031 28.1875 44.738281 27.25 44.738281 C 25.898438 44.738281 24.71875 44.230469 23.875 43.367188 C 22.992188 42.523438 22.46875 41.382812 22.46875 40.144531 C 22.46875 38.867188 22.992188 37.726562 23.875 36.882812 C 24.71875 36.019531 25.898438 35.511719 27.25 35.511719 C 28.375 35.511719 29.40625 35.90625 30.210938 36.523438 C 30.679688 36.898438 31.375 36.804688 31.730469 36.355469 C 32.085938 35.886719 32.011719 35.195312 31.523438 34.835938 C 30.363281 33.917969 28.84375 33.375 27.25 33.375 C 23.445312 33.375 20.332031 36.375 20.332031 40.144531 C 20.332031 43.894531 23.445312 46.875 27.25 46.875 Z M 40.191406 46.855469 L 40.230469 46.855469 C 40.285156 46.835938 40.324219 46.820312 40.378906 46.820312 C 40.398438 46.800781 40.398438 46.800781 40.417969 46.800781 C 40.472656 46.78125 40.53125 46.726562 40.566406 46.707031 C 40.605469 46.6875 40.605469 46.6875 40.605469 46.6875 L 40.71875 46.59375 C 40.738281 46.574219 40.738281 46.574219 40.753906 46.539062 L 40.847656 46.425781 C 40.867188 46.425781 40.867188 46.425781 40.867188 46.40625 C 40.90625 46.367188 40.925781 46.292969 40.941406 46.257812 L 45.574219 35.304688 C 45.78125 34.800781 45.535156 34.179688 45.011719 33.976562 C 44.503906 33.75 43.886719 33.992188 43.660156 34.519531 L 40.003906 43.199219 L 36.347656 34.519531 C 36.125 33.992188 35.523438 33.75 35.019531 33.976562 C 34.472656 34.179688 34.230469 34.800781 34.457031 35.304688 L 39.050781 46.257812 C 39.085938 46.292969 39.125 46.367188 39.144531 46.40625 C 39.144531 46.425781 39.160156 46.425781 39.160156 46.425781 C 39.179688 46.460938 39.21875 46.5 39.253906 46.539062 C 39.253906 46.574219 39.273438 46.574219 39.273438 46.59375 C 39.332031 46.632812 39.367188 46.648438 39.40625 46.6875 L 39.425781 46.6875 C 39.480469 46.726562 39.554688 46.78125 39.59375 46.800781 L 39.613281 46.800781 C 39.613281 46.800781 39.628906 46.800781 39.628906 46.820312 C 39.667969 46.820312 39.742188 46.835938 39.78125 46.855469 L 39.816406 46.855469 L 39.910156 46.871094 L 40.003906 46.875 C 40.0625 46.875 40.117188 46.875 40.191406 46.855469 Z M 40.191406 46.855469 "/>\n      </g>'
    },
    pngIcon: {
      extension: ".png",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.523438 46.875 C 8.105469 46.875 8.574219 46.40625 8.574219 45.84375 L 8.574219 41.773438 L 10.878906 41.773438 C 13.109375 41.773438 14.910156 39.976562 14.910156 37.78125 C 14.910156 35.550781 13.109375 33.75 10.878906 33.75 L 7.523438 33.75 C 6.960938 33.75 6.492188 34.199219 6.492188 34.78125 L 6.492188 45.84375 C 6.492188 46.40625 6.960938 46.875 7.523438 46.875 Z M 10.878906 39.695312 L 8.574219 39.695312 L 8.574219 35.832031 L 10.878906 35.832031 C 11.964844 35.832031 12.808594 36.695312 12.828125 37.78125 C 12.808594 38.832031 11.964844 39.695312 10.878906 39.695312 Z M 26.75 46.875 C 27.3125 46.875 27.78125 46.40625 27.78125 45.84375 L 27.78125 34.949219 C 27.78125 34.40625 27.3125 33.9375 26.75 33.9375 C 26.1875 33.9375 25.738281 34.40625 25.738281 34.949219 L 25.738281 42.675781 L 19.679688 34.292969 C 19.363281 33.84375 18.722656 33.75 18.253906 34.070312 C 17.972656 34.273438 17.824219 34.613281 17.84375 34.929688 L 17.84375 45.84375 C 17.84375 46.40625 18.292969 46.875 18.875 46.875 C 19.417969 46.875 19.886719 46.40625 19.886719 45.84375 L 19.886719 38.0625 L 25.886719 46.386719 C 25.90625 46.425781 25.941406 46.460938 25.980469 46.5 C 26.167969 46.726562 26.449219 46.875 26.75 46.875 Z M 38.082031 46.875 C 39.675781 46.875 41.15625 46.332031 42.339844 45.414062 C 42.527344 45.28125 42.636719 45.132812 42.695312 44.960938 L 42.695312 44.945312 C 42.714844 44.90625 42.714844 44.886719 42.730469 44.851562 C 42.75 44.738281 42.789062 44.664062 42.789062 44.53125 L 42.789062 40.386719 C 42.789062 39.789062 42.300781 39.335938 41.699219 39.335938 L 37.96875 39.335938 C 37.386719 39.335938 36.902344 39.789062 36.902344 40.386719 C 36.902344 40.96875 37.386719 41.457031 37.96875 41.457031 L 40.652344 41.457031 L 40.652344 44.023438 C 39.902344 44.457031 39.019531 44.738281 38.082031 44.738281 C 36.730469 44.738281 35.550781 44.230469 34.707031 43.367188 C 33.824219 42.523438 33.300781 41.382812 33.300781 40.144531 C 33.300781 38.867188 33.824219 37.726562 34.707031 36.882812 C 35.550781 36.019531 36.730469 35.511719 38.082031 35.511719 C 39.207031 35.511719 40.238281 35.90625 41.042969 36.523438 C 41.511719 36.898438 42.207031 36.804688 42.5625 36.355469 C 42.917969 35.886719 42.84375 35.195312 42.355469 34.835938 C 41.195312 33.917969 39.675781 33.375 38.082031 33.375 C 34.277344 33.375 31.164062 36.375 31.164062 40.144531 C 31.164062 43.894531 34.277344 46.875 38.082031 46.875 Z M 38.082031 46.875 "/>\n      </g>'
    },
    txtIcon: {
      extension: ".txt",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 12.847656 46.875 C 13.429688 46.875 13.878906 46.425781 13.878906 45.84375 L 13.878906 35.832031 L 16.859375 35.832031 C 17.421875 35.832031 17.890625 35.34375 17.890625 34.78125 C 17.890625 34.199219 17.421875 33.75 16.859375 33.75 L 8.855469 33.75 C 8.273438 33.75 7.824219 34.199219 7.824219 34.78125 C 7.824219 35.34375 8.273438 35.832031 8.855469 35.832031 L 11.816406 35.832031 L 11.816406 45.84375 C 11.816406 46.425781 12.285156 46.875 12.847656 46.875 Z M 29.019531 46.875 C 29.222656 46.875 29.429688 46.800781 29.617188 46.667969 C 30.085938 46.351562 30.160156 45.695312 29.84375 45.242188 L 26.28125 40.367188 L 29.84375 35.53125 C 30.160156 35.0625 30.085938 34.425781 29.617188 34.105469 C 29.148438 33.75 28.53125 33.84375 28.175781 34.332031 L 25.023438 38.644531 L 21.855469 34.332031 C 21.535156 33.84375 20.878906 33.75 20.429688 34.105469 C 19.960938 34.425781 19.867188 35.0625 20.1875 35.53125 L 23.75 40.367188 L 20.1875 45.242188 C 19.867188 45.695312 19.960938 46.351562 20.429688 46.667969 C 20.597656 46.800781 20.804688 46.875 21.03125 46.875 C 21.347656 46.875 21.648438 46.707031 21.855469 46.445312 L 25.023438 42.113281 L 28.175781 46.445312 C 28.378906 46.707031 28.679688 46.875 29.019531 46.875 Z M 37.464844 46.875 C 38.042969 46.875 38.496094 46.425781 38.496094 45.84375 L 38.496094 35.832031 L 41.476562 35.832031 C 42.039062 35.832031 42.507812 35.34375 42.507812 34.78125 C 42.507812 34.199219 42.039062 33.75 41.476562 33.75 L 33.46875 33.75 C 32.886719 33.75 32.4375 34.199219 32.4375 34.78125 C 32.4375 35.34375 32.886719 35.832031 33.46875 35.832031 L 36.433594 35.832031 L 36.433594 45.84375 C 36.433594 46.425781 36.902344 46.875 37.464844 46.875 Z M 37.464844 46.875 "/>\n      </g>'
    },
    webmIcon: {
      extension: ".webm",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.195312 43.734375 L 7.242188 43.734375 C 7.273438 43.71875 7.304688 43.703125 7.367188 43.703125 C 7.367188 43.6875 7.382812 43.6875 7.382812 43.6875 L 7.398438 43.6875 C 7.429688 43.671875 7.476562 43.625 7.523438 43.59375 L 7.554688 43.59375 C 7.585938 43.5625 7.617188 43.53125 7.648438 43.515625 C 7.648438 43.5 7.664062 43.5 7.664062 43.46875 L 7.757812 43.375 C 7.757812 43.375 7.757812 43.359375 7.773438 43.359375 C 7.789062 43.328125 7.820312 43.265625 7.835938 43.21875 L 9.882812 38.375 L 11.929688 43.21875 C 11.945312 43.265625 11.960938 43.328125 11.992188 43.359375 C 11.992188 43.359375 11.992188 43.375 12.023438 43.375 L 12.085938 43.46875 C 12.101562 43.5 12.101562 43.5 12.117188 43.515625 C 12.148438 43.53125 12.179688 43.5625 12.226562 43.59375 L 12.242188 43.59375 C 12.273438 43.625 12.320312 43.671875 12.382812 43.6875 C 12.398438 43.6875 12.398438 43.6875 12.414062 43.703125 C 12.445312 43.703125 12.476562 43.71875 12.523438 43.734375 L 12.570312 43.734375 L 12.640625 43.746094 L 12.710938 43.75 C 12.773438 43.75 12.820312 43.75 12.867188 43.734375 L 12.898438 43.734375 C 12.945312 43.71875 12.992188 43.703125 13.023438 43.703125 C 13.023438 43.6875 13.039062 43.6875 13.039062 43.6875 L 13.054688 43.6875 C 13.117188 43.671875 13.148438 43.625 13.195312 43.59375 L 13.210938 43.59375 C 13.242188 43.5625 13.289062 43.53125 13.320312 43.515625 C 13.320312 43.5 13.335938 43.5 13.335938 43.46875 C 13.367188 43.4375 13.398438 43.40625 13.414062 43.375 C 13.414062 43.375 13.429688 43.359375 13.429688 43.359375 C 13.460938 43.328125 13.492188 43.265625 13.507812 43.21875 L 17.335938 34.109375 C 17.523438 33.6875 17.320312 33.171875 16.898438 33 C 16.445312 32.8125 15.945312 33.015625 15.757812 33.453125 L 12.710938 40.6875 L 10.695312 35.890625 C 10.539062 35.546875 10.210938 35.359375 9.882812 35.359375 C 9.539062 35.359375 9.210938 35.546875 9.070312 35.890625 L 7.054688 40.6875 L 3.992188 33.453125 C 3.820312 33.015625 3.304688 32.8125 2.882812 33 C 2.429688 33.171875 2.242188 33.6875 2.414062 34.109375 L 6.257812 43.21875 C 6.289062 43.265625 6.304688 43.328125 6.335938 43.359375 L 6.335938 43.375 C 6.367188 43.40625 6.382812 43.4375 6.414062 43.46875 C 6.429688 43.5 6.429688 43.5 6.445312 43.515625 C 6.492188 43.53125 6.507812 43.5625 6.554688 43.59375 L 6.570312 43.59375 C 6.601562 43.625 6.664062 43.671875 6.710938 43.6875 C 6.726562 43.6875 6.726562 43.6875 6.742188 43.703125 C 6.773438 43.703125 6.804688 43.71875 6.851562 43.734375 L 6.898438 43.734375 L 6.976562 43.746094 L 7.054688 43.75 C 7.101562 43.75 7.148438 43.75 7.195312 43.734375 Z M 25.179688 43.75 C 25.632812 43.75 26.039062 43.359375 26.039062 42.890625 C 26.039062 42.40625 25.632812 42.015625 25.179688 42.015625 L 20.945312 42.015625 L 20.945312 39.140625 L 24.585938 39.140625 C 25.054688 39.140625 25.445312 38.75 25.445312 38.265625 C 25.445312 37.8125 25.054688 37.40625 24.585938 37.40625 L 20.945312 37.40625 L 20.945312 34.546875 L 25.179688 34.546875 C 25.632812 34.546875 26.039062 34.15625 26.039062 33.671875 C 26.039062 33.1875 25.632812 32.8125 25.179688 32.8125 L 20.070312 32.8125 C 19.585938 32.8125 19.210938 33.1875 19.210938 33.671875 L 19.210938 42.890625 C 19.210938 43.359375 19.585938 43.75 20.070312 43.75 C 20.070312 43.75 20.085938 43.734375 20.085938 43.734375 C 20.085938 43.734375 20.085938 43.75 20.117188 43.75 Z M 31.539062 43.75 C 33.382812 43.75 34.882812 42.25 34.882812 40.390625 C 34.882812 39.203125 34.242188 38.15625 33.304688 37.5625 C 33.679688 37.0625 33.898438 36.453125 33.898438 35.78125 C 33.898438 34.140625 32.570312 32.8125 30.929688 32.8125 L 28.710938 32.8125 C 28.242188 32.8125 27.851562 33.1875 27.851562 33.671875 L 27.851562 42.890625 C 27.851562 43.359375 28.242188 43.75 28.710938 43.75 L 28.757812 43.734375 C 28.757812 43.734375 28.757812 43.75 28.773438 43.75 Z M 30.929688 37.046875 L 29.585938 37.046875 L 29.585938 34.546875 L 30.929688 34.546875 C 31.617188 34.546875 32.164062 35.09375 32.164062 35.78125 C 32.164062 36.46875 31.617188 37.046875 30.929688 37.046875 Z M 31.539062 42.015625 L 29.585938 42.015625 L 29.585938 38.78125 L 31.539062 38.78125 C 32.429688 38.796875 33.148438 39.5 33.148438 40.390625 C 33.148438 41.296875 32.429688 42 31.539062 42.015625 Z M 45.664062 43.75 C 46.132812 43.75 46.539062 43.359375 46.539062 42.890625 L 46.539062 33.671875 C 46.539062 33.269531 46.242188 32.9375 45.859375 32.839844 L 45.664062 32.8125 L 45.648438 32.8125 C 45.367188 32.8125 45.117188 32.9375 44.945312 33.171875 L 41.835938 37.484375 L 38.726562 33.171875 C 38.570312 32.9375 38.289062 32.8125 38.039062 32.8125 L 37.992188 32.8125 C 37.523438 32.8125 37.132812 33.203125 37.132812 33.671875 L 37.132812 42.890625 C 37.132812 43.359375 37.523438 43.75 37.992188 43.75 C 38.476562 43.75 38.867188 43.359375 38.867188 42.890625 L 38.867188 36.3125 L 41.101562 39.4375 C 41.273438 39.671875 41.539062 39.796875 41.820312 39.796875 L 41.851562 39.796875 C 42.132812 39.796875 42.382812 39.671875 42.554688 39.4375 L 44.804688 36.3125 L 44.804688 42.890625 C 44.804688 43.359375 45.179688 43.75 45.664062 43.75 Z M 45.664062 43.75 "/>\n      </g>'
    },
    webpIcon: {
      extension: ".webp",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.234375 43.734375 L 9.28125 43.734375 C 9.3125 43.71875 9.34375 43.703125 9.40625 43.703125 L 9.414062 43.6875 C 9.421875 43.6875 9.421875 43.6875 9.4375 43.6875 C 9.46875 43.671875 9.515625 43.625 9.5625 43.59375 L 9.59375 43.59375 C 9.625 43.5625 9.65625 43.53125 9.6875 43.515625 C 9.6875 43.5 9.703125 43.5 9.703125 43.46875 L 9.796875 43.375 C 9.796875 43.375 9.796875 43.359375 9.8125 43.359375 C 9.828125 43.328125 9.859375 43.265625 9.875 43.21875 L 11.921875 38.375 L 13.96875 43.21875 C 13.984375 43.265625 14 43.328125 14.03125 43.359375 C 14.03125 43.359375 14.03125 43.375 14.0625 43.375 L 14.125 43.46875 C 14.140625 43.5 14.140625 43.5 14.15625 43.515625 L 14.203125 43.546875 L 14.265625 43.59375 C 14.265625 43.59375 14.265625 43.59375 14.28125 43.59375 C 14.3125 43.625 14.359375 43.671875 14.421875 43.6875 C 14.4375 43.6875 14.4375 43.6875 14.453125 43.703125 C 14.484375 43.703125 14.515625 43.71875 14.5625 43.734375 L 14.609375 43.734375 L 14.679688 43.746094 L 14.75 43.75 C 14.8125 43.75 14.859375 43.75 14.90625 43.734375 L 14.9375 43.734375 C 14.984375 43.71875 15.03125 43.703125 15.0625 43.703125 C 15.0625 43.6875 15.078125 43.6875 15.078125 43.6875 L 15.09375 43.6875 C 15.15625 43.671875 15.1875 43.625 15.234375 43.59375 L 15.25 43.59375 C 15.28125 43.5625 15.328125 43.53125 15.359375 43.515625 C 15.359375 43.5 15.375 43.5 15.375 43.46875 C 15.40625 43.4375 15.4375 43.40625 15.453125 43.375 L 15.46875 43.359375 C 15.5 43.328125 15.53125 43.265625 15.546875 43.21875 L 19.375 34.109375 C 19.5625 33.6875 19.359375 33.171875 18.9375 33 C 18.484375 32.8125 17.984375 33.015625 17.796875 33.453125 L 14.75 40.6875 L 12.734375 35.890625 C 12.578125 35.546875 12.25 35.359375 11.921875 35.359375 C 11.578125 35.359375 11.25 35.546875 11.109375 35.890625 L 9.09375 40.6875 L 6.03125 33.453125 C 5.859375 33.015625 5.34375 32.8125 4.921875 33 C 4.46875 33.171875 4.28125 33.6875 4.453125 34.109375 L 8.296875 43.21875 C 8.328125 43.265625 8.34375 43.328125 8.375 43.359375 L 8.375 43.375 C 8.40625 43.40625 8.421875 43.4375 8.453125 43.46875 C 8.46875 43.5 8.46875 43.5 8.484375 43.515625 L 8.539062 43.546875 L 8.59375 43.59375 C 8.59375 43.59375 8.59375 43.59375 8.609375 43.59375 C 8.640625 43.625 8.703125 43.671875 8.75 43.6875 C 8.765625 43.6875 8.765625 43.6875 8.78125 43.703125 C 8.8125 43.703125 8.84375 43.71875 8.890625 43.734375 L 8.9375 43.734375 L 9.015625 43.746094 L 9.09375 43.75 C 9.140625 43.75 9.1875 43.75 9.234375 43.734375 Z M 27.21875 43.75 C 27.671875 43.75 28.078125 43.359375 28.078125 42.890625 C 28.078125 42.40625 27.671875 42.015625 27.21875 42.015625 L 22.984375 42.015625 L 22.984375 39.140625 L 26.625 39.140625 C 27.09375 39.140625 27.484375 38.75 27.484375 38.265625 C 27.484375 37.8125 27.09375 37.40625 26.625 37.40625 L 22.984375 37.40625 L 22.984375 34.546875 L 27.21875 34.546875 C 27.671875 34.546875 28.078125 34.15625 28.078125 33.671875 C 28.078125 33.1875 27.671875 32.8125 27.21875 32.8125 L 22.109375 32.8125 C 21.625 32.8125 21.25 33.1875 21.25 33.671875 L 21.25 42.890625 C 21.25 43.359375 21.625 43.75 22.109375 43.75 L 22.125 43.734375 C 22.125 43.734375 22.125 43.75 22.15625 43.75 Z M 33.578125 43.75 C 35.421875 43.75 36.921875 42.25 36.921875 40.390625 C 36.921875 39.203125 36.28125 38.15625 35.34375 37.5625 C 35.71875 37.0625 35.9375 36.453125 35.9375 35.78125 C 35.9375 34.140625 34.609375 32.8125 32.96875 32.8125 L 30.75 32.8125 C 30.28125 32.8125 29.890625 33.1875 29.890625 33.671875 L 29.890625 42.890625 C 29.890625 43.359375 30.28125 43.75 30.75 43.75 C 30.765625 43.75 30.765625 43.734375 30.796875 43.734375 C 30.796875 43.734375 30.796875 43.75 30.8125 43.75 Z M 32.96875 37.046875 L 31.625 37.046875 L 31.625 34.546875 L 32.96875 34.546875 C 33.65625 34.546875 34.203125 35.09375 34.203125 35.78125 C 34.203125 36.46875 33.65625 37.046875 32.96875 37.046875 Z M 33.578125 42.015625 L 31.625 42.015625 L 31.625 38.78125 L 33.578125 38.78125 C 34.46875 38.796875 35.1875 39.5 35.1875 40.390625 C 35.1875 41.296875 34.46875 42 33.578125 42.015625 Z M 40.03125 43.75 C 40.515625 43.75 40.90625 43.359375 40.90625 42.890625 L 40.90625 39.5 L 42.828125 39.5 C 44.6875 39.5 46.1875 38 46.1875 36.171875 C 46.1875 34.3125 44.6875 32.8125 42.828125 32.8125 L 40.03125 32.8125 C 39.5625 32.8125 39.171875 33.1875 39.171875 33.671875 L 39.171875 42.890625 C 39.171875 43.359375 39.5625 43.75 40.03125 43.75 Z M 42.828125 37.765625 L 40.90625 37.765625 L 40.90625 34.546875 L 42.828125 34.546875 C 43.734375 34.546875 44.4375 35.265625 44.453125 36.171875 C 44.4375 37.046875 43.734375 37.765625 42.828125 37.765625 Z M 42.828125 37.765625 "/>\n      </g>'
    },
    wmvIcon: {
      extension: ".wmv",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.484375 43.734375 L 8.53125 43.734375 C 8.5625 43.71875 8.59375 43.703125 8.65625 43.703125 L 8.664062 43.6875 C 8.671875 43.6875 8.671875 43.6875 8.6875 43.6875 C 8.71875 43.671875 8.765625 43.625 8.8125 43.59375 L 8.84375 43.59375 C 8.875 43.5625 8.90625 43.53125 8.9375 43.515625 C 8.9375 43.5 8.953125 43.5 8.953125 43.46875 L 9.046875 43.375 C 9.046875 43.375 9.046875 43.359375 9.0625 43.359375 C 9.078125 43.328125 9.109375 43.265625 9.125 43.21875 L 11.171875 38.375 L 13.21875 43.21875 C 13.234375 43.265625 13.25 43.328125 13.28125 43.359375 C 13.28125 43.359375 13.28125 43.375 13.3125 43.375 L 13.375 43.46875 C 13.390625 43.5 13.390625 43.5 13.40625 43.515625 L 13.453125 43.546875 L 13.515625 43.59375 C 13.515625 43.59375 13.515625 43.59375 13.53125 43.59375 C 13.5625 43.625 13.609375 43.671875 13.671875 43.6875 C 13.6875 43.6875 13.6875 43.6875 13.703125 43.703125 C 13.734375 43.703125 13.765625 43.71875 13.8125 43.734375 L 13.859375 43.734375 L 13.929688 43.746094 L 14 43.75 C 14.0625 43.75 14.109375 43.75 14.15625 43.734375 L 14.1875 43.734375 C 14.234375 43.71875 14.28125 43.703125 14.3125 43.703125 C 14.3125 43.6875 14.328125 43.6875 14.328125 43.6875 L 14.34375 43.6875 C 14.40625 43.671875 14.4375 43.625 14.484375 43.59375 L 14.5 43.59375 C 14.53125 43.5625 14.578125 43.53125 14.609375 43.515625 C 14.609375 43.5 14.625 43.5 14.625 43.46875 C 14.65625 43.4375 14.6875 43.40625 14.703125 43.375 L 14.71875 43.359375 C 14.75 43.328125 14.78125 43.265625 14.796875 43.21875 L 18.625 34.109375 C 18.8125 33.6875 18.609375 33.171875 18.1875 33 C 17.734375 32.8125 17.234375 33.015625 17.046875 33.453125 L 14 40.6875 L 11.984375 35.890625 C 11.828125 35.546875 11.5 35.359375 11.171875 35.359375 C 10.828125 35.359375 10.5 35.546875 10.359375 35.890625 L 8.34375 40.6875 L 5.28125 33.453125 C 5.109375 33.015625 4.59375 32.8125 4.171875 33 C 3.71875 33.171875 3.53125 33.6875 3.703125 34.109375 L 7.546875 43.21875 C 7.578125 43.265625 7.59375 43.328125 7.625 43.359375 L 7.625 43.375 C 7.65625 43.40625 7.671875 43.4375 7.703125 43.46875 C 7.71875 43.5 7.71875 43.5 7.734375 43.515625 L 7.789062 43.546875 L 7.84375 43.59375 C 7.84375 43.59375 7.84375 43.59375 7.859375 43.59375 C 7.890625 43.625 7.953125 43.671875 8 43.6875 C 8.015625 43.6875 8.015625 43.6875 8.03125 43.703125 C 8.0625 43.703125 8.09375 43.71875 8.140625 43.734375 L 8.1875 43.734375 L 8.265625 43.746094 L 8.34375 43.75 C 8.390625 43.75 8.4375 43.75 8.484375 43.734375 Z M 29.03125 43.75 C 29.5 43.75 29.90625 43.359375 29.90625 42.890625 L 29.90625 33.671875 C 29.90625 33.269531 29.609375 32.9375 29.226562 32.839844 L 29.03125 32.8125 L 29.015625 32.8125 C 28.734375 32.8125 28.484375 32.9375 28.3125 33.171875 L 25.203125 37.484375 L 22.09375 33.171875 C 21.9375 32.9375 21.65625 32.8125 21.40625 32.8125 L 21.359375 32.8125 C 20.890625 32.8125 20.5 33.203125 20.5 33.671875 L 20.5 42.890625 C 20.5 43.359375 20.890625 43.75 21.359375 43.75 C 21.84375 43.75 22.234375 43.359375 22.234375 42.890625 L 22.234375 36.3125 L 24.46875 39.4375 C 24.640625 39.671875 24.90625 39.796875 25.1875 39.796875 L 25.21875 39.796875 C 25.5 39.796875 25.75 39.671875 25.921875 39.4375 L 28.171875 36.3125 L 28.171875 42.890625 C 28.171875 43.359375 28.546875 43.75 29.03125 43.75 Z M 37.015625 43.734375 L 37.0625 43.734375 C 37.09375 43.71875 37.125 43.703125 37.1875 43.703125 L 37.195312 43.6875 C 37.203125 43.6875 37.203125 43.6875 37.21875 43.6875 C 37.25 43.671875 37.296875 43.625 37.34375 43.59375 L 37.375 43.59375 C 37.40625 43.5625 37.4375 43.53125 37.46875 43.515625 C 37.46875 43.5 37.484375 43.5 37.484375 43.46875 L 37.578125 43.375 C 37.578125 43.375 37.578125 43.359375 37.59375 43.359375 C 37.609375 43.328125 37.640625 43.265625 37.65625 43.21875 L 39.703125 38.375 L 41.75 43.21875 C 41.765625 43.265625 41.78125 43.328125 41.8125 43.359375 C 41.8125 43.359375 41.8125 43.375 41.84375 43.375 L 41.90625 43.46875 C 41.921875 43.5 41.921875 43.5 41.9375 43.515625 L 41.984375 43.546875 L 42.046875 43.59375 C 42.046875 43.59375 42.046875 43.59375 42.0625 43.59375 C 42.09375 43.625 42.140625 43.671875 42.203125 43.6875 C 42.21875 43.6875 42.21875 43.6875 42.234375 43.703125 C 42.265625 43.703125 42.296875 43.71875 42.34375 43.734375 L 42.390625 43.734375 L 42.460938 43.746094 L 42.53125 43.75 C 42.59375 43.75 42.640625 43.75 42.6875 43.734375 L 42.71875 43.734375 C 42.765625 43.71875 42.8125 43.703125 42.84375 43.703125 C 42.84375 43.6875 42.859375 43.6875 42.859375 43.6875 L 42.875 43.6875 C 42.9375 43.671875 42.96875 43.625 43.015625 43.59375 L 43.03125 43.59375 C 43.0625 43.5625 43.109375 43.53125 43.140625 43.515625 C 43.140625 43.5 43.15625 43.5 43.15625 43.46875 C 43.1875 43.4375 43.21875 43.40625 43.234375 43.375 L 43.25 43.359375 C 43.28125 43.328125 43.3125 43.265625 43.328125 43.21875 L 47.15625 34.109375 C 47.34375 33.6875 47.140625 33.171875 46.71875 33 C 46.265625 32.8125 45.765625 33.015625 45.578125 33.453125 L 42.53125 40.6875 L 40.515625 35.890625 C 40.359375 35.546875 40.03125 35.359375 39.703125 35.359375 C 39.359375 35.359375 39.03125 35.546875 38.890625 35.890625 L 36.875 40.6875 L 33.8125 33.453125 C 33.640625 33.015625 33.125 32.8125 32.703125 33 C 32.25 33.171875 32.0625 33.6875 32.234375 34.109375 L 36.078125 43.21875 C 36.109375 43.265625 36.125 43.328125 36.15625 43.359375 L 36.15625 43.375 C 36.1875 43.40625 36.203125 43.4375 36.234375 43.46875 C 36.25 43.5 36.25 43.5 36.265625 43.515625 L 36.320312 43.546875 L 36.375 43.59375 C 36.375 43.59375 36.375 43.59375 36.390625 43.59375 C 36.421875 43.625 36.484375 43.671875 36.53125 43.6875 C 36.546875 43.6875 36.546875 43.6875 36.5625 43.703125 C 36.59375 43.703125 36.625 43.71875 36.671875 43.734375 L 36.71875 43.734375 L 36.796875 43.746094 L 36.875 43.75 C 36.921875 43.75 36.96875 43.75 37.015625 43.734375 Z M 37.015625 43.734375 "/>\n      </g>'
    },
    xlsIcon: {
      extension: ".xls",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.21875 46.875 C 17.425781 46.875 17.632812 46.800781 17.820312 46.667969 C 18.289062 46.351562 18.363281 45.695312 18.042969 45.242188 L 14.480469 40.367188 L 18.042969 35.53125 C 18.363281 35.0625 18.289062 34.425781 17.820312 34.105469 C 17.351562 33.75 16.730469 33.84375 16.375 34.332031 L 13.226562 38.644531 L 10.054688 34.332031 C 9.738281 33.84375 9.082031 33.75 8.632812 34.105469 C 8.164062 34.425781 8.070312 35.0625 8.386719 35.53125 L 11.949219 40.367188 L 8.386719 45.242188 C 8.070312 45.695312 8.164062 46.351562 8.632812 46.667969 C 8.800781 46.800781 9.007812 46.875 9.230469 46.875 C 9.550781 46.875 9.851562 46.707031 10.054688 46.445312 L 13.226562 42.113281 L 16.375 46.445312 C 16.582031 46.707031 16.882812 46.875 17.21875 46.875 Z M 29.351562 46.875 C 29.894531 46.875 30.382812 46.40625 30.382812 45.84375 C 30.382812 45.261719 29.894531 44.792969 29.351562 44.792969 L 24.269531 44.792969 L 24.269531 34.78125 C 24.269531 34.21875 23.800781 33.75 23.21875 33.75 C 22.636719 33.75 22.1875 34.21875 22.1875 34.78125 L 22.1875 45.84375 C 22.1875 46.335938 22.53125 46.757812 23.007812 46.855469 L 23.222656 46.875 Z M 37.28125 46.855469 C 38.613281 46.855469 39.832031 46.460938 40.75 45.789062 C 41.6875 45.113281 42.363281 44.082031 42.363281 42.882812 C 42.363281 42.300781 42.195312 41.738281 41.914062 41.289062 C 41.480469 40.59375 40.804688 40.105469 40.039062 39.730469 C 39.289062 39.375 38.40625 39.132812 37.449219 38.945312 L 37.414062 38.945312 C 36.398438 38.757812 35.554688 38.457031 35.070312 38.117188 C 34.824219 37.949219 34.65625 37.78125 34.5625 37.632812 C 34.46875 37.480469 34.429688 37.332031 34.429688 37.105469 C 34.429688 36.710938 34.636719 36.300781 35.144531 35.925781 C 35.648438 35.550781 36.398438 35.289062 37.242188 35.289062 C 38.386719 35.289062 39.304688 35.851562 40.261719 36.488281 C 40.710938 36.789062 41.3125 36.65625 41.59375 36.207031 C 41.894531 35.773438 41.761719 35.175781 41.332031 34.875 C 40.375 34.257812 39.042969 33.375 37.242188 33.375 C 36.023438 33.375 34.882812 33.730469 34 34.367188 C 33.136719 35.007812 32.5 35.980469 32.5 37.105469 C 32.5 37.667969 32.648438 38.195312 32.929688 38.644531 C 33.34375 39.300781 33.960938 39.769531 34.675781 40.105469 C 35.386719 40.445312 36.210938 40.667969 37.09375 40.835938 L 37.132812 40.835938 C 38.238281 41.042969 39.15625 41.363281 39.699219 41.71875 C 39.980469 41.90625 40.148438 42.09375 40.261719 42.28125 C 40.375 42.46875 40.429688 42.636719 40.429688 42.882812 C 40.429688 43.351562 40.1875 43.820312 39.625 44.230469 C 39.0625 44.644531 38.21875 44.925781 37.28125 44.925781 C 35.949219 44.945312 34.523438 44.15625 33.699219 43.480469 C 33.289062 43.144531 32.667969 43.199219 32.332031 43.613281 C 32.011719 44.023438 32.070312 44.644531 32.480469 44.980469 C 33.550781 45.824219 35.257812 46.835938 37.28125 46.855469 Z M 37.28125 46.855469 "/>\n      </g>'
    },
    xlsxIcon: {
      extension: ".xlsx",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.070312 43.75 C 13.242188 43.75 13.414062 43.6875 13.570312 43.578125 C 13.960938 43.3125 14.023438 42.765625 13.757812 42.390625 L 10.789062 38.328125 L 13.757812 34.296875 C 14.023438 33.90625 13.960938 33.375 13.570312 33.109375 C 13.179688 32.8125 12.664062 32.890625 12.367188 33.296875 L 9.742188 36.890625 L 7.101562 33.296875 C 6.835938 32.890625 6.289062 32.8125 5.914062 33.109375 C 5.523438 33.375 5.445312 33.90625 5.710938 34.296875 L 8.679688 38.328125 L 5.710938 42.390625 C 5.445312 42.765625 5.523438 43.3125 5.914062 43.578125 C 6.054688 43.6875 6.226562 43.75 6.414062 43.75 C 6.679688 43.75 6.929688 43.609375 7.101562 43.390625 L 9.742188 39.78125 L 12.367188 43.390625 C 12.539062 43.609375 12.789062 43.75 13.070312 43.75 Z M 23.179688 43.75 C 23.632812 43.75 24.039062 43.359375 24.039062 42.890625 C 24.039062 42.40625 23.632812 42.015625 23.179688 42.015625 L 18.945312 42.015625 L 18.945312 33.671875 C 18.945312 33.203125 18.554688 32.8125 18.070312 32.8125 C 17.585938 32.8125 17.210938 33.203125 17.210938 33.671875 L 17.210938 42.890625 C 17.210938 43.359375 17.585938 43.75 18.070312 43.75 Z M 29.789062 43.734375 C 30.898438 43.734375 31.914062 43.40625 32.679688 42.84375 C 33.460938 42.28125 34.023438 41.421875 34.023438 40.421875 C 34.023438 39.9375 33.882812 39.46875 33.648438 39.09375 C 33.289062 38.515625 32.726562 38.109375 32.085938 37.796875 C 31.460938 37.5 30.726562 37.296875 29.929688 37.140625 L 29.898438 37.140625 C 29.054688 36.984375 28.351562 36.734375 27.945312 36.453125 C 27.742188 36.3125 27.601562 36.171875 27.523438 36.046875 C 27.445312 35.921875 27.414062 35.796875 27.414062 35.609375 C 27.414062 35.28125 27.585938 34.9375 28.007812 34.625 C 28.429688 34.3125 29.054688 34.09375 29.757812 34.09375 C 30.710938 34.09375 31.476562 34.5625 32.273438 35.09375 C 32.648438 35.34375 33.148438 35.234375 33.382812 34.859375 C 33.632812 34.5 33.523438 34 33.164062 33.75 C 32.367188 33.234375 31.257812 32.5 29.757812 32.5 C 28.742188 32.5 27.789062 32.796875 27.054688 33.328125 C 26.335938 33.859375 25.804688 34.671875 25.804688 35.609375 C 25.804688 36.078125 25.929688 36.515625 26.164062 36.890625 C 26.507812 37.4375 27.023438 37.828125 27.617188 38.109375 C 28.210938 38.390625 28.898438 38.578125 29.632812 38.71875 L 29.664062 38.71875 C 30.585938 38.890625 31.351562 39.15625 31.804688 39.453125 C 32.039062 39.609375 32.179688 39.765625 32.273438 39.921875 C 32.367188 40.078125 32.414062 40.21875 32.414062 40.421875 C 32.414062 40.8125 32.210938 41.203125 31.742188 41.546875 C 31.273438 41.890625 30.570312 42.125 29.789062 42.125 C 28.679688 42.140625 27.492188 41.484375 26.804688 40.921875 C 26.460938 40.640625 25.945312 40.6875 25.664062 41.03125 C 25.398438 41.375 25.445312 41.890625 25.789062 42.171875 C 26.679688 42.875 28.101562 43.71875 29.789062 43.734375 Z M 43.179688 43.75 C 43.351562 43.75 43.523438 43.6875 43.679688 43.578125 C 44.070312 43.3125 44.132812 42.765625 43.867188 42.390625 L 40.898438 38.328125 L 43.867188 34.296875 C 44.132812 33.90625 44.070312 33.375 43.679688 33.109375 C 43.289062 32.8125 42.773438 32.890625 42.476562 33.296875 L 39.851562 36.890625 L 37.210938 33.296875 C 36.945312 32.890625 36.398438 32.8125 36.023438 33.109375 C 35.632812 33.375 35.554688 33.90625 35.820312 34.296875 L 38.789062 38.328125 L 35.820312 42.390625 C 35.554688 42.765625 35.632812 43.3125 36.023438 43.578125 C 36.164062 43.6875 36.335938 43.75 36.523438 43.75 C 36.789062 43.75 37.039062 43.609375 37.210938 43.390625 L 39.851562 39.78125 L 42.476562 43.390625 C 42.648438 43.609375 42.898438 43.75 43.179688 43.75 Z M 43.179688 43.75 "/>\n      </g>'
    },
    zipIcon: {
      extension: ".zip",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.175781 46.875 C 20.855469 46.875 21.402344 46.351562 21.402344 45.671875 C 21.402344 44.992188 20.855469 44.445312 20.175781 44.445312 L 13.132812 44.445312 L 21.183594 33.488281 L 21.183594 33.445312 C 21.203125 33.421875 21.226562 33.378906 21.25 33.335938 C 21.269531 33.3125 21.269531 33.289062 21.292969 33.269531 C 21.3125 33.203125 21.3125 33.179688 21.335938 33.136719 C 21.335938 33.09375 21.378906 33.070312 21.378906 33.007812 C 21.378906 32.984375 21.378906 32.960938 21.402344 32.917969 L 21.402344 32.679688 C 21.402344 32.632812 21.402344 32.613281 21.378906 32.546875 C 21.378906 32.503906 21.378906 32.480469 21.335938 32.4375 C 21.335938 32.414062 21.3125 32.371094 21.3125 32.304688 C 21.292969 32.285156 21.269531 32.242188 21.269531 32.21875 C 21.25 32.195312 21.226562 32.152344 21.203125 32.109375 C 21.183594 32.066406 21.160156 32.042969 21.117188 32.023438 C 21.09375 32 21.074219 31.957031 21.050781 31.933594 C 21.03125 31.914062 21.007812 31.867188 20.964844 31.847656 C 20.941406 31.824219 20.941406 31.804688 20.898438 31.78125 L 20.875 31.78125 C 20.832031 31.757812 20.8125 31.738281 20.765625 31.714844 C 20.746094 31.695312 20.722656 31.648438 20.65625 31.648438 L 20.570312 31.605469 L 20.4375 31.585938 C 20.417969 31.585938 20.375 31.5625 20.351562 31.5625 L 10.75 31.5625 C 10.070312 31.5625 9.546875 32.085938 9.546875 32.765625 C 9.546875 33.421875 10.070312 33.992188 10.75 33.992188 L 17.8125 33.992188 L 9.785156 44.972656 L 9.765625 44.972656 C 9.742188 45.015625 9.71875 45.058594 9.699219 45.082031 C 9.699219 45.101562 9.675781 45.148438 9.632812 45.167969 C 9.632812 45.210938 9.609375 45.257812 9.609375 45.277344 C 9.589844 45.320312 9.589844 45.367188 9.566406 45.386719 L 9.566406 45.496094 C 9.546875 45.539062 9.546875 45.585938 9.546875 45.648438 L 9.546875 45.738281 C 9.546875 45.78125 9.566406 45.824219 9.566406 45.890625 C 9.566406 45.933594 9.589844 45.957031 9.589844 45.976562 L 9.632812 46.109375 C 9.632812 46.152344 9.675781 46.175781 9.699219 46.21875 C 9.699219 46.242188 9.71875 46.261719 9.742188 46.328125 C 9.765625 46.351562 9.785156 46.394531 9.808594 46.414062 C 9.828125 46.4375 9.851562 46.460938 9.894531 46.480469 L 9.9375 46.542969 L 9.984375 46.589844 C 10.003906 46.613281 10.027344 46.632812 10.046875 46.632812 L 10.046875 46.65625 C 10.070312 46.679688 10.09375 46.679688 10.136719 46.699219 C 10.179688 46.722656 10.222656 46.742188 10.246094 46.742188 C 10.265625 46.789062 10.289062 46.789062 10.3125 46.808594 C 10.375 46.808594 10.421875 46.832031 10.464844 46.832031 C 10.484375 46.851562 10.507812 46.851562 10.53125 46.851562 L 10.648438 46.871094 Z M 26.214844 46.875 C 26.871094 46.875 27.4375 46.351562 27.4375 45.671875 L 27.4375 32.765625 C 27.4375 32.085938 26.871094 31.5625 26.214844 31.5625 C 25.535156 31.5625 25.011719 32.085938 25.011719 32.765625 L 25.011719 45.671875 C 25.011719 46.351562 25.535156 46.875 26.214844 46.875 Z M 32.734375 46.875 C 33.410156 46.875 33.957031 46.328125 33.957031 45.671875 L 33.957031 40.925781 L 36.648438 40.925781 C 39.25 40.925781 41.351562 38.824219 41.351562 36.265625 C 41.351562 33.664062 39.25 31.5625 36.648438 31.5625 L 32.734375 31.5625 C 32.078125 31.5625 31.53125 32.085938 31.53125 32.765625 L 31.53125 45.671875 C 31.53125 46.328125 32.078125 46.875 32.734375 46.875 Z M 36.648438 38.496094 L 33.957031 38.496094 L 33.957031 33.992188 L 36.648438 33.992188 C 37.917969 33.992188 38.902344 34.996094 38.921875 36.265625 C 38.902344 37.492188 37.917969 38.496094 36.648438 38.496094 Z M 36.648438 38.496094 "/>\n      </g>'
    },
    docxIcon: {
      extension: ".docx",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.789062 43.75 C 9.589844 43.75 10.988281 43.269531 11.984375 42.304688 C 12.980469 41.339844 13.476562 39.984375 13.476562 38.234375 C 13.476562 36.496094 12.980469 35.144531 11.984375 34.179688 C 10.988281 33.214844 9.589844 32.734375 7.789062 32.734375 L 4.695312 32.734375 C 4.394531 32.734375 4.15625 32.816406 3.984375 32.984375 C 3.8125 33.152344 3.726562 33.386719 3.726562 33.6875 L 3.726562 42.796875 C 3.726562 43.097656 3.8125 43.332031 3.984375 43.5 C 4.15625 43.667969 4.394531 43.75 4.695312 43.75 Z M 7.664062 42.109375 L 5.742188 42.109375 L 5.742188 34.375 L 7.664062 34.375 C 10.195312 34.375 11.460938 35.660156 11.460938 38.234375 C 11.460938 40.816406 10.195312 42.109375 7.664062 42.109375 Z M 20.414062 43.890625 C 21.476562 43.890625 22.402344 43.660156 23.1875 43.203125 C 23.972656 42.746094 24.582031 42.089844 25.007812 41.234375 C 25.433594 40.378906 25.648438 39.378906 25.648438 38.234375 C 25.648438 37.089844 25.4375 36.089844 25.015625 35.242188 C 24.59375 34.394531 23.988281 33.738281 23.203125 33.28125 C 22.417969 32.824219 21.488281 32.59375 20.414062 32.59375 C 19.339844 32.59375 18.410156 32.824219 17.617188 33.28125 C 16.824219 33.738281 16.21875 34.394531 15.796875 35.242188 C 15.375 36.089844 15.164062 37.089844 15.164062 38.234375 C 15.164062 39.378906 15.378906 40.378906 15.804688 41.234375 C 16.230469 42.089844 16.839844 42.746094 17.625 43.203125 C 18.410156 43.660156 19.339844 43.890625 20.414062 43.890625 Z M 20.414062 42.28125 C 19.394531 42.28125 18.597656 41.933594 18.03125 41.234375 C 17.464844 40.535156 17.179688 39.535156 17.179688 38.234375 C 17.179688 36.933594 17.464844 35.933594 18.03125 35.242188 C 18.597656 34.550781 19.394531 34.203125 20.414062 34.203125 C 21.425781 34.203125 22.214844 34.550781 22.78125 35.242188 C 23.347656 35.933594 23.632812 36.933594 23.632812 38.234375 C 23.632812 39.535156 23.347656 40.535156 22.78125 41.234375 C 22.214844 41.933594 21.425781 42.28125 20.414062 42.28125 Z M 32.601562 43.890625 C 33.289062 43.890625 33.933594 43.789062 34.539062 43.585938 C 35.144531 43.382812 35.679688 43.089844 36.148438 42.703125 C 36.285156 42.597656 36.378906 42.488281 36.429688 42.367188 C 36.480469 42.246094 36.507812 42.109375 36.507812 41.953125 C 36.507812 41.722656 36.445312 41.53125 36.320312 41.375 C 36.195312 41.21875 36.042969 41.140625 35.867188 41.140625 C 35.753906 41.140625 35.644531 41.160156 35.539062 41.203125 C 35.433594 41.246094 35.332031 41.296875 35.226562 41.359375 C 34.746094 41.683594 34.316406 41.910156 33.9375 42.046875 C 33.558594 42.183594 33.144531 42.25 32.695312 42.25 C 31.613281 42.25 30.792969 41.910156 30.234375 41.234375 C 29.675781 40.558594 29.398438 39.558594 29.398438 38.234375 C 29.398438 36.921875 29.675781 35.925781 30.234375 35.25 C 30.792969 34.574219 31.613281 34.234375 32.695312 34.234375 C 33.164062 34.234375 33.589844 34.300781 33.976562 34.429688 C 34.363281 34.558594 34.777344 34.792969 35.226562 35.125 C 35.445312 35.269531 35.660156 35.34375 35.867188 35.34375 C 36.042969 35.34375 36.195312 35.265625 36.320312 35.109375 C 36.445312 34.953125 36.507812 34.761719 36.507812 34.53125 C 36.507812 34.363281 36.480469 34.222656 36.429688 34.109375 C 36.378906 33.996094 36.285156 33.886719 36.148438 33.78125 C 35.679688 33.394531 35.144531 33.101562 34.539062 32.898438 C 33.933594 32.695312 33.289062 32.59375 32.601562 32.59375 C 31.539062 32.59375 30.609375 32.824219 29.8125 33.28125 C 29.015625 33.738281 28.402344 34.394531 27.976562 35.242188 C 27.550781 36.089844 27.335938 37.089844 27.335938 38.234375 C 27.335938 39.378906 27.550781 40.378906 27.976562 41.234375 C 28.402344 42.089844 29.015625 42.746094 29.8125 43.203125 C 30.609375 43.660156 31.539062 43.890625 32.601562 43.890625 Z M 46.132812 43.84375 C 46.382812 43.84375 46.605469 43.75 46.796875 43.5625 C 46.988281 43.375 47.085938 43.15625 47.085938 42.90625 C 47.085938 42.707031 47.003906 42.511719 46.835938 42.3125 L 43.445312 38.15625 L 46.710938 34.171875 C 46.867188 34.003906 46.945312 33.808594 46.945312 33.578125 C 46.945312 33.328125 46.847656 33.113281 46.65625 32.929688 C 46.464844 32.746094 46.242188 32.65625 45.992188 32.65625 C 45.730469 32.65625 45.507812 32.769531 45.320312 33 L 42.273438 36.765625 L 39.226562 33 C 39.027344 32.769531 38.800781 32.65625 38.539062 32.65625 C 38.289062 32.65625 38.070312 32.746094 37.882812 32.929688 C 37.695312 33.113281 37.601562 33.328125 37.601562 33.578125 C 37.601562 33.808594 37.679688 34.003906 37.835938 34.171875 L 41.101562 38.15625 L 37.695312 42.3125 C 37.539062 42.5 37.460938 42.699219 37.460938 42.90625 C 37.460938 43.15625 37.558594 43.371094 37.75 43.554688 C 37.941406 43.738281 38.164062 43.828125 38.414062 43.828125 C 38.675781 43.828125 38.898438 43.71875 39.085938 43.5 L 42.273438 39.5625 L 45.445312 43.5 C 45.644531 43.730469 45.871094 43.84375 46.132812 43.84375 Z M 46.132812 43.84375 "/>\n      </g>'
    },
    jpgIcon: {
      extension: ".jpg",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.789062 47.007812 L 9.488281 46.960938 C 12.214844 46.757812 13.578125 45.277344 13.578125 42.523438 L 13.578125 32.742188 C 13.578125 32.320312 13.453125 31.980469 13.195312 31.726562 C 12.941406 31.472656 12.59375 31.34375 12.15625 31.34375 C 11.734375 31.34375 11.394531 31.472656 11.140625 31.726562 C 10.886719 31.980469 10.757812 32.320312 10.757812 32.742188 L 10.757812 42.523438 C 10.757812 43.238281 10.605469 43.769531 10.296875 44.117188 C 9.992188 44.46875 9.539062 44.660156 8.941406 44.6875 L 8.242188 44.730469 C 7.847656 44.761719 7.558594 44.867188 7.378906 45.046875 C 7.195312 45.230469 7.105469 45.496094 7.105469 45.847656 C 7.105469 46.664062 7.667969 47.050781 8.789062 47.007812 Z M 18.304688 47.007812 C 18.742188 47.007812 19.089844 46.878906 19.34375 46.625 C 19.597656 46.367188 19.726562 46.023438 19.726562 45.585938 L 19.726562 40.882812 L 23.640625 40.882812 C 25.289062 40.882812 26.574219 40.464844 27.492188 39.632812 C 28.410156 38.804688 28.871094 37.644531 28.871094 36.15625 C 28.871094 34.667969 28.410156 33.511719 27.492188 32.6875 C 26.574219 31.863281 25.289062 31.453125 23.640625 31.453125 L 18.261719 31.453125 C 17.839844 31.453125 17.507812 31.570312 17.265625 31.804688 C 17.023438 32.035156 16.90625 32.363281 16.90625 32.789062 L 16.90625 45.585938 C 16.90625 46.023438 17.03125 46.367188 17.289062 46.625 C 17.542969 46.878906 17.882812 47.007812 18.304688 47.007812 Z M 23.292969 38.714844 L 19.726562 38.714844 L 19.726562 33.640625 L 23.292969 33.640625 C 25.230469 33.640625 26.203125 34.488281 26.203125 36.179688 C 26.203125 37.871094 25.230469 38.714844 23.292969 38.714844 Z M 38.605469 47.070312 C 39.320312 47.070312 40.0625 47.011719 40.835938 46.898438 C 41.609375 46.78125 42.285156 46.621094 42.871094 46.414062 C 43.410156 46.242188 43.765625 46.015625 43.941406 45.738281 C 44.117188 45.460938 44.203125 44.988281 44.203125 44.316406 L 44.203125 39.613281 C 44.203125 39.292969 44.101562 39.03125 43.898438 38.835938 C 43.695312 38.640625 43.425781 38.539062 43.089844 38.539062 L 39.21875 38.539062 C 38.867188 38.539062 38.59375 38.628906 38.398438 38.804688 C 38.199219 38.976562 38.101562 39.226562 38.101562 39.546875 C 38.101562 39.867188 38.199219 40.117188 38.398438 40.289062 C 38.59375 40.464844 38.867188 40.554688 39.21875 40.554688 L 41.6875 40.554688 L 41.6875 44.425781 C 40.699219 44.703125 39.707031 44.839844 38.714844 44.839844 C 35.390625 44.839844 33.726562 42.945312 33.726562 39.152344 C 33.726562 37.300781 34.132812 35.90625 34.941406 34.964844 C 35.75 34.023438 36.949219 33.554688 38.539062 33.554688 C 39.238281 33.554688 39.867188 33.644531 40.421875 33.828125 C 40.972656 34.007812 41.574219 34.324219 42.214844 34.777344 C 42.390625 34.894531 42.542969 34.980469 42.671875 35.03125 C 42.804688 35.082031 42.949219 35.105469 43.109375 35.105469 C 43.359375 35.105469 43.570312 34.996094 43.746094 34.777344 C 43.921875 34.558594 44.007812 34.289062 44.007812 33.96875 C 44.007812 33.75 43.96875 33.558594 43.886719 33.398438 C 43.808594 33.238281 43.679688 33.078125 43.503906 32.917969 C 42.191406 31.808594 40.507812 31.257812 38.453125 31.257812 C 36.90625 31.257812 35.5625 31.574219 34.425781 32.207031 C 33.289062 32.84375 32.410156 33.753906 31.789062 34.941406 C 31.171875 36.128906 30.859375 37.535156 30.859375 39.152344 C 30.859375 40.800781 31.171875 42.21875 31.789062 43.40625 C 32.410156 44.597656 33.304688 45.503906 34.46875 46.132812 C 35.636719 46.757812 37.015625 47.070312 38.605469 47.070312 Z M 38.605469 47.070312 "/>\n      </g>'
    },
    mp3Icon: {
      extension: ".mp3",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 43.828125 43.710938 C 43.605469 44.28125 43.273438 44.804688 42.84375 45.265625 C 42.40625 45.730469 41.867188 46.113281 41.242188 46.398438 C 40.597656 46.699219 39.851562 46.855469 39.027344 46.855469 C 38.328125 46.855469 37.703125 46.757812 37.160156 46.570312 C 36.609375 46.378906 36.160156 46.136719 35.769531 45.839844 C 35.386719 45.550781 35.050781 45.210938 34.796875 44.832031 C 34.570312 44.507812 34.394531 44.195312 34.265625 43.890625 C 34.140625 43.59375 34.054688 43.335938 33.996094 43.101562 C 33.792969 42.261719 34.304688 41.417969 35.140625 41.210938 C 35.980469 41.007812 36.828125 41.519531 37.03125 42.355469 C 37.039062 42.390625 37.066406 42.488281 37.144531 42.671875 C 37.191406 42.777344 37.265625 42.914062 37.371094 43.0625 C 37.4375 43.160156 37.53125 43.257812 37.65625 43.351562 C 37.792969 43.453125 37.972656 43.542969 38.195312 43.625 C 38.332031 43.667969 38.59375 43.730469 39.027344 43.730469 C 39.390625 43.730469 39.695312 43.675781 39.925781 43.566406 C 40.1875 43.445312 40.398438 43.300781 40.558594 43.132812 C 40.71875 42.957031 40.839844 42.773438 40.914062 42.578125 C 40.996094 42.371094 41.03125 42.195312 41.03125 42.023438 C 41.03125 41.789062 41 41.585938 40.921875 41.398438 C 40.871094 41.257812 40.785156 41.148438 40.660156 41.039062 C 40.515625 40.910156 40.296875 40.792969 40.011719 40.699219 C 39.6875 40.59375 39.253906 40.539062 38.738281 40.535156 C 37.882812 40.527344 37.1875 39.832031 37.1875 38.972656 L 37.1875 38.832031 C 37.1875 37.984375 37.859375 37.292969 38.699219 37.265625 C 39.070312 37.257812 39.398438 37.195312 39.679688 37.101562 C 39.921875 37.011719 40.121094 36.902344 40.273438 36.773438 C 40.40625 36.652344 40.507812 36.519531 40.582031 36.359375 C 40.652344 36.210938 40.6875 36.027344 40.6875 35.8125 C 40.6875 35.523438 40.644531 35.289062 40.574219 35.125 C 40.5 34.96875 40.414062 34.847656 40.304688 34.757812 C 40.1875 34.660156 40.042969 34.582031 39.867188 34.53125 C 39.402344 34.386719 38.878906 34.398438 38.480469 34.542969 C 38.289062 34.617188 38.121094 34.714844 37.976562 34.84375 C 37.820312 34.984375 37.695312 35.148438 37.59375 35.339844 C 37.484375 35.550781 37.40625 35.773438 37.367188 36.039062 C 37.230469 36.890625 36.429688 37.472656 35.574219 37.335938 C 34.722656 37.195312 34.140625 36.398438 34.28125 35.542969 C 34.378906 34.9375 34.5625 34.378906 34.835938 33.871094 C 35.109375 33.355469 35.464844 32.898438 35.890625 32.519531 C 36.320312 32.132812 36.824219 31.828125 37.382812 31.617188 C 38.433594 31.226562 39.667969 31.199219 40.78125 31.539062 C 41.351562 31.714844 41.863281 31.992188 42.308594 32.355469 C 42.777344 32.753906 43.148438 33.242188 43.414062 33.824219 C 43.679688 34.402344 43.8125 35.070312 43.8125 35.8125 C 43.8125 36.476562 43.679688 37.097656 43.421875 37.660156 C 43.25 38.046875 43.023438 38.394531 42.746094 38.707031 C 43.242188 39.148438 43.609375 39.671875 43.835938 40.261719 C 44.046875 40.804688 44.15625 41.398438 44.15625 42.023438 C 44.15625 42.578125 44.046875 43.148438 43.828125 43.710938 Z M 31.445312 38.492188 C 31.148438 39.140625 30.734375 39.703125 30.199219 40.164062 C 29.6875 40.605469 29.078125 40.957031 28.390625 41.199219 C 27.71875 41.4375 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.859375 24.296875 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.859375 21.875 45 L 21.875 32.8125 C 21.875 31.945312 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.667969 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.03125 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.28125 L 14.015625 43.140625 C 14.007812 43.164062 13.996094 43.191406 13.984375 43.214844 C 13.71875 43.777344 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.9375 44.117188 11.375 43.777344 11.109375 43.214844 L 11.082031 43.160156 L 9.339844 39.101562 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.1875 L 12.527344 39.09375 L 15.59375 32.207031 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.167969 31.261719 C 18.03125 31.261719 18.730469 31.960938 18.730469 32.824219 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.136719 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.136719 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 28.257812 34.902344 C 27.835938 34.550781 27.140625 34.375 26.191406 34.375 L 25 34.375 L 25 38.4375 L 26.191406 38.4375 C 26.621094 38.4375 27.007812 38.375 27.34375 38.253906 C 27.667969 38.140625 27.929688 37.992188 28.148438 37.804688 C 28.34375 37.632812 28.492188 37.4375 28.601562 37.195312 C 28.710938 36.964844 28.757812 36.703125 28.757812 36.40625 C 28.757812 35.324219 28.382812 35.003906 28.257812 34.902344 "/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 11.34125 13.57875 C 11.345 13.5925 11.3525 13.62375 11.36375 13.67375 C 11.3775 13.7225 11.3975 13.78125 11.42625 13.85 C 11.45375 13.9175 11.49375 13.9875 11.54625 14.0625 C 11.5975 14.13875 11.66625 14.20875 11.75 14.27125 C 11.83375 14.33625 11.9375 14.38875 12.0575 14.43125 C 12.1775 14.4725 12.32 14.49375 12.4875 14.49375 C 12.67875 14.49375 12.845 14.46125 12.9875 14.39375 C 13.13 14.32875 13.24875 14.245 13.34375 14.1425 C 13.43875 14.0425 13.51125 13.93 13.55875 13.8075 C 13.6075 13.6825 13.63125 13.56375 13.63125 13.4475 C 13.63125 13.31125 13.6075 13.1825 13.5625 13.065 C 13.515 12.9475 13.4425 12.845 13.3425 12.7575 C 13.2425 12.67 13.115 12.6 12.96 12.55 C 12.805 12.49875 12.6175 12.4725 12.4 12.4725 L 12.4 12.42625 C 12.57 12.42 12.72375 12.3925 12.8625 12.34375 C 13.0025 12.29625 13.11875 12.2275 13.21625 12.14375 C 13.31375 12.05875 13.3875 11.96 13.44125 11.845 C 13.4925 11.7275 13.52 11.60125 13.52 11.46 C 13.52 11.29375 13.4925 11.1525 13.43875 11.0325 C 13.38375 10.91375 13.31125 10.81625 13.21875 10.74 C 13.1275 10.66375 13.0225 10.6075 12.90375 10.5725 C 12.78625 10.535 12.66375 10.5175 12.5375 10.5175 C 12.395 10.5175 12.26125 10.54 12.14 10.58625 C 12.0175 10.6325 11.91 10.69625 11.81875 10.77875 C 11.72625 10.8625 11.64875 10.96 11.5875 11.07375 C 11.5275 11.18875 11.48625 11.315 11.4625 11.45375 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.475 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'
    },
    mp4Icon: {
      extension: ".mp4",
      path: '<g id="surface6" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 36.898438 40.625 L 40.625 35.480469 L 40.625 40.625 Z M 28.761719 36.40625 C 28.761719 36.703125 28.707031 36.964844 28.605469 37.195312 C 28.496094 37.433594 28.347656 37.632812 28.148438 37.804688 C 27.929688 37.992188 27.667969 38.144531 27.34375 38.257812 C 27.003906 38.375 26.621094 38.4375 26.191406 38.4375 L 25 38.4375 L 25 34.375 L 26.191406 34.375 C 27.140625 34.375 27.835938 34.554688 28.253906 34.902344 C 28.378906 35.007812 28.761719 35.324219 28.761719 36.40625 Z M 44.6875 43.75 L 43.75 43.75 L 43.75 45.3125 C 43.75 46.175781 43.050781 46.875 42.1875 46.875 C 41.324219 46.875 40.625 46.175781 40.625 45.3125 L 40.625 43.75 L 34.066406 43.75 C 33.199219 43.75 32.503906 43.050781 32.503906 42.1875 L 32.503906 41.875 C 32.503906 41.546875 32.605469 41.226562 32.800781 40.957031 L 39.363281 31.898438 C 39.660156 31.492188 40.128906 31.25 40.628906 31.25 L 42.1875 31.25 C 43.050781 31.25 43.75 31.949219 43.75 32.8125 L 43.75 40.625 L 44.6875 40.625 C 45.550781 40.625 46.25 41.324219 46.25 42.1875 C 46.25 43.050781 45.550781 43.75 44.6875 43.75 Z M 31.445312 38.492188 C 31.148438 39.140625 30.730469 39.703125 30.195312 40.167969 C 29.6875 40.605469 29.082031 40.957031 28.390625 41.203125 C 27.71875 41.441406 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.863281 24.300781 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.863281 21.875 45 L 21.875 32.8125 C 21.875 31.949219 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.671875 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.027344 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.6875 L 14.035156 43.105469 C 14.019531 43.144531 14.003906 43.179688 13.984375 43.214844 C 13.71875 43.78125 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.941406 44.117188 11.378906 43.78125 11.113281 43.214844 C 11.097656 43.183594 11.078125 43.152344 11.066406 43.125 L 9.339844 39.484375 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.191406 L 9.355469 32.226562 L 12.523438 38.90625 L 15.578125 32.242188 C 15.585938 32.226562 15.597656 32.210938 15.605469 32.191406 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.164062 31.261719 C 18.027344 31.261719 18.726562 31.960938 18.726562 32.824219 L 18.726562 45.210938 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface6" mask="url(#mask0)"/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 14.3 13.5 L 10.90125 13.5 L 10.90125 13.4 L 13.00125 10.5 L 13.5 10.5 L 13.5 14.5 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.47625 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'
    },
    oggIcon: {
      extension: ".ogg",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.976562 47.070312 C 10.464844 47.070312 11.757812 46.75 12.859375 46.109375 C 13.960938 45.46875 14.808594 44.550781 15.40625 43.351562 C 16.003906 42.15625 16.304688 40.757812 16.304688 39.152344 C 16.304688 37.550781 16.007812 36.152344 15.417969 34.964844 C 14.828125 33.777344 13.980469 32.859375 12.882812 32.21875 C 11.78125 31.578125 10.480469 31.257812 8.976562 31.257812 C 7.472656 31.257812 6.167969 31.578125 5.0625 32.21875 C 3.953125 32.859375 3.101562 33.777344 2.511719 34.964844 C 1.921875 36.152344 1.625 37.550781 1.625 39.152344 C 1.625 40.757812 1.925781 42.15625 2.523438 43.351562 C 3.121094 44.550781 3.972656 45.46875 5.070312 46.109375 C 6.171875 46.75 7.472656 47.070312 8.976562 47.070312 Z M 8.976562 44.820312 C 7.546875 44.820312 6.433594 44.332031 5.640625 43.351562 C 4.847656 42.375 4.449219 40.976562 4.449219 39.152344 C 4.449219 37.332031 4.847656 35.933594 5.640625 34.964844 C 6.433594 33.996094 7.546875 33.507812 8.976562 33.507812 C 10.390625 33.507812 11.496094 33.996094 12.289062 34.964844 C 13.085938 35.933594 13.484375 37.332031 13.484375 39.152344 C 13.484375 40.976562 13.085938 42.375 12.289062 43.351562 C 11.496094 44.332031 10.390625 44.820312 8.976562 44.820312 Z M 26.410156 47.070312 C 27.125 47.070312 27.871094 47.011719 28.640625 46.898438 C 29.414062 46.78125 30.09375 46.621094 30.675781 46.414062 C 31.214844 46.242188 31.574219 46.015625 31.75 45.738281 C 31.921875 45.460938 32.011719 44.988281 32.011719 44.316406 L 32.011719 39.613281 C 32.011719 39.292969 31.910156 39.03125 31.703125 38.835938 C 31.5 38.640625 31.230469 38.539062 30.894531 38.539062 L 27.023438 38.539062 C 26.671875 38.539062 26.398438 38.628906 26.203125 38.804688 C 26.007812 38.976562 25.90625 39.226562 25.90625 39.546875 C 25.90625 39.867188 26.007812 40.117188 26.203125 40.289062 C 26.398438 40.464844 26.671875 40.554688 27.023438 40.554688 L 29.496094 40.554688 L 29.496094 44.425781 C 28.503906 44.703125 27.511719 44.839844 26.519531 44.839844 C 23.195312 44.839844 21.53125 42.945312 21.53125 39.152344 C 21.53125 37.300781 21.9375 35.90625 22.746094 34.964844 C 23.554688 34.023438 24.753906 33.554688 26.34375 33.554688 C 27.046875 33.554688 27.671875 33.644531 28.226562 33.828125 C 28.78125 34.007812 29.378906 34.324219 30.019531 34.777344 C 30.195312 34.894531 30.347656 34.980469 30.480469 35.03125 C 30.609375 35.082031 30.757812 35.105469 30.917969 35.105469 C 31.164062 35.105469 31.375 34.996094 31.550781 34.777344 C 31.726562 34.558594 31.8125 34.289062 31.8125 33.96875 C 31.8125 33.75 31.773438 33.558594 31.695312 33.398438 C 31.613281 33.238281 31.484375 33.078125 31.3125 32.917969 C 30 31.808594 28.3125 31.257812 26.257812 31.257812 C 24.710938 31.257812 23.371094 31.574219 22.234375 32.207031 C 21.09375 32.84375 20.214844 33.753906 19.597656 34.941406 C 18.976562 36.128906 18.667969 37.535156 18.667969 39.152344 C 18.667969 40.800781 18.976562 42.21875 19.597656 43.40625 C 20.214844 44.597656 21.109375 45.503906 22.277344 46.132812 C 23.441406 46.757812 24.820312 47.070312 26.410156 47.070312 Z M 42.445312 47.070312 C 43.160156 47.070312 43.902344 47.011719 44.675781 46.898438 C 45.449219 46.78125 46.128906 46.621094 46.710938 46.414062 C 47.25 46.242188 47.609375 46.015625 47.78125 45.738281 C 47.957031 45.460938 48.046875 44.988281 48.046875 44.316406 L 48.046875 39.613281 C 48.046875 39.292969 47.941406 39.03125 47.738281 38.835938 C 47.535156 38.640625 47.265625 38.539062 46.929688 38.539062 L 43.058594 38.539062 C 42.707031 38.539062 42.433594 38.628906 42.238281 38.804688 C 42.039062 38.976562 41.941406 39.226562 41.941406 39.546875 C 41.941406 39.867188 42.039062 40.117188 42.238281 40.289062 C 42.433594 40.464844 42.707031 40.554688 43.058594 40.554688 L 45.53125 40.554688 L 45.53125 44.425781 C 44.539062 44.703125 43.546875 44.839844 42.554688 44.839844 C 39.230469 44.839844 37.566406 42.945312 37.566406 39.152344 C 37.566406 37.300781 37.972656 35.90625 38.78125 34.964844 C 39.589844 34.023438 40.789062 33.554688 42.378906 33.554688 C 43.078125 33.554688 43.707031 33.644531 44.261719 33.828125 C 44.816406 34.007812 45.414062 34.324219 46.054688 34.777344 C 46.230469 34.894531 46.382812 34.980469 46.515625 35.03125 C 46.644531 35.082031 46.792969 35.105469 46.953125 35.105469 C 47.199219 35.105469 47.410156 34.996094 47.585938 34.777344 C 47.761719 34.558594 47.847656 34.289062 47.847656 33.96875 C 47.847656 33.75 47.808594 33.558594 47.726562 33.398438 C 47.648438 33.238281 47.519531 33.078125 47.34375 32.917969 C 46.03125 31.808594 44.347656 31.257812 42.292969 31.257812 C 40.746094 31.257812 39.40625 31.574219 38.265625 32.207031 C 37.128906 32.84375 36.25 33.753906 35.632812 34.941406 C 35.011719 36.128906 34.703125 37.535156 34.703125 39.152344 C 34.703125 40.800781 35.011719 42.21875 35.632812 43.40625 C 36.25 44.597656 37.144531 45.503906 38.3125 46.132812 C 39.476562 46.757812 40.855469 47.070312 42.445312 47.070312 Z M 42.445312 47.070312 "/>\n      </g>'
    },
    pdfIcon: {
      extension: ".pdf",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.59375 25 L 39.4375 25 C 41.476562 25.003906 43.484375 25.472656 45.3125 26.375 L 45.3125 15.375 C 45.347656 14.191406 44.867188 13.054688 44 12.25 L 34.625 2.875 C 33.875 2.003906 32.773438 1.523438 31.625 1.5625 L 6.625 1.5625 C 5.589844 1.5625 4.75 2.402344 4.75 3.4375 L 4.75 26.375 C 6.566406 25.480469 8.566406 25.007812 10.59375 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.71875 L 42.15625 12.5 L 34.53125 12.5 C 34.480469 12.511719 34.425781 12.511719 34.375 12.5 Z M 6.25 25.71875 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.300781 13.980469 32.316406 15.253906 33.75 15.625 C 33.957031 15.675781 34.167969 15.675781 34.375 15.625 L 43.75 15.625 L 43.75 25.71875 C 44.859375 26.09375 45.910156 26.621094 46.875 27.28125 L 46.875 15.375 C 46.964844 13.722656 46.3125 12.117188 45.09375 11 L 35.71875 1.625 C 34.648438 0.523438 33.160156 -0.0664062 31.625 0 L 6.625 0 C 5.703125 -0.015625 4.8125 0.339844 4.152344 0.984375 C 3.496094 1.632812 3.125 2.515625 3.125 3.4375 L 3.125 27.28125 C 4.09375 26.625 5.144531 26.101562 6.25 25.71875 Z M 6.25 25.71875 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.625 28.125 C 6.335938 28.117188 4.136719 29.023438 2.515625 30.640625 C 0.898438 32.261719 -0.0078125 34.460938 0 36.75 L 0 41.375 C 0 46.136719 3.863281 50 8.625 50 L 41.375 50 C 46.132812 49.984375 49.984375 46.132812 50 41.375 L 50 36.75 C 50 31.988281 46.136719 28.125 41.375 28.125 Z M 8.625 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 14.40625 41.78125 L 12.09375 41.78125 L 12.09375 45.84375 C 12.003906 46.351562 11.5625 46.726562 11.046875 46.726562 C 10.53125 46.726562 10.089844 46.351562 10 45.84375 L 10 34.78125 C 10 34.210938 10.460938 33.75 11.03125 33.75 L 14.40625 33.75 C 15.925781 33.617188 17.390625 34.351562 18.191406 35.648438 C 18.992188 36.945312 18.992188 38.585938 18.191406 39.882812 C 17.390625 41.179688 15.925781 41.914062 14.40625 41.78125 Z M 12.09375 39.6875 L 14.40625 39.6875 C 15.152344 39.78125 15.882812 39.4375 16.289062 38.804688 C 16.691406 38.171875 16.691406 37.359375 16.289062 36.726562 C 15.882812 36.09375 15.152344 35.75 14.40625 35.84375 L 12.09375 35.84375 Z M 12.09375 39.6875 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.3125 45.84375 L 20.3125 34.78125 C 20.3125 34.210938 20.773438 33.75 21.34375 33.75 L 23.5625 33.75 C 27.1875 33.75 30.125 36.6875 30.125 40.3125 C 30.125 43.9375 27.1875 46.875 23.5625 46.875 L 21.34375 46.875 C 20.773438 46.875 20.3125 46.414062 20.3125 45.84375 Z M 22.40625 44.78125 L 23.5625 44.78125 C 26.03125 44.78125 28.03125 42.78125 28.03125 40.3125 C 28.03125 37.84375 26.03125 35.84375 23.5625 35.84375 L 22.40625 35.84375 Z M 22.40625 44.78125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 33.1875 45.84375 L 33.1875 34.78125 C 33.183594 34.476562 33.3125 34.1875 33.542969 33.992188 C 33.769531 33.792969 34.074219 33.703125 34.375 33.75 L 40.625 33.75 C 41.132812 33.839844 41.507812 34.28125 41.507812 34.796875 C 41.507812 35.3125 41.132812 35.753906 40.625 35.84375 L 35.25 35.84375 L 35.25 39.28125 L 39.625 39.28125 C 40.195312 39.28125 40.65625 39.742188 40.65625 40.3125 C 40.65625 40.882812 40.195312 41.34375 39.625 41.34375 L 35.25 41.34375 L 35.25 45.84375 C 35.257812 46.359375 34.882812 46.796875 34.375 46.875 C 34.074219 46.921875 33.769531 46.832031 33.542969 46.632812 C 33.3125 46.4375 33.183594 46.148438 33.1875 45.84375 Z M 33.1875 45.84375 "/>\n      </g>'
    },
    defaultIcon: {
      extension: ".default",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 3.117188 44.777344 C 1.394531 44.777344 0 43.386719 0 41.671875 L 0 3.484375 C 0 1.769531 1.394531 0.378906 3.117188 0.378906 L 25.792969 0.378906 C 27.164062 0.304688 28.5 0.808594 29.480469 1.765625 L 37.980469 10.230469 C 39.144531 11.242188 39.769531 12.730469 39.683594 14.265625 L 39.683594 41.671875 C 39.683594 43.386719 38.289062 44.777344 36.5625 44.777344 Z M 25.511719 3.203125 L 3.117188 3.203125 C 2.960938 3.203125 2.832031 3.328125 2.832031 3.484375 L 2.832031 41.671875 C 2.832031 41.828125 2.960938 41.957031 3.117188 41.957031 L 36.5625 41.957031 C 36.679688 41.949219 36.785156 41.867188 36.820312 41.757812 L 36.820312 14.492188 L 28.34375 14.492188 C 28.160156 14.539062 27.964844 14.539062 27.777344 14.492188 C 26.480469 14.15625 25.554688 13.007812 25.511719 11.671875 Z M 28.34375 4.640625 L 28.34375 11.671875 C 28.390625 11.683594 28.441406 11.683594 28.488281 11.671875 L 35.402344 11.671875 Z M 28.34375 4.640625 "/>\n      </g>'
    }
  }, xt.MODULES.modals = function (l) {
    var i = l.$;
    l.shared.modals || (l.shared.modals = {});
    var a, c = l.shared.modals;

    function e() {
      for (var e in c) if (Object.prototype.hasOwnProperty.call(c, e)) {
        var t = c[e];
        t && t.$modal && t.$modal.removeData().remove()
      }
      a && a.removeData().remove(), c = {}
    }

    function s(e, t) {
      if (c[e]) {
        var n = c[e].$modal, r = n.data("instance") || l;
        r.events.enableBlur(), n.hide(), a.hide(), i(r.o_doc).find("body").first().removeClass("fr-prevent-scroll fr-mobile"), n.removeClass("fr-active"), t || (r.accessibility.restoreSelection(), r.events.trigger("modals.hide"))
      }
    }

    function n(e) {
      var t;
      if ("string" == typeof e) {
        if (!c[e]) return;
        t = c[e].$modal
      } else t = e;
      return t && l.node.hasClass(t, "fr-active") && l.core.sameInstance(t) || !1
    }

    return {
      _init: function t() {
        l.events.on("shared.destroy", e, !0)
      }, get: function r(e) {
        return c[e]
      }, create: function d(n, e, t) {
        if (e = '<div class="fr-modal-head-line">'.concat(e, "</div>"), l.shared.$overlay || (l.shared.$overlay = i(l.doc.createElement("DIV")).addClass("fr-overlay"), i("body").first().append(l.shared.$overlay)), a = l.shared.$overlay, l.opts.theme && a.addClass("".concat(l.opts.theme, "-theme")), !c[n]) {
          var r = function o(e, t) {
            var n = '<div tabIndex="-1" class="fr-modal'.concat(l.opts.theme ? " ".concat(l.opts.theme, "-theme") : "", '"><div class="fr-modal-wrapper">'),
              r = '<button title="'.concat(l.language.translate("Cancel"), '" class="fr-command fr-btn fr-modal-close"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24"><path d="').concat(xt.SVG.close, '"/></svg></button>');
            n += '<div class="fr-modal-head">'.concat(e).concat(r, "</div>"), n += '<div tabIndex="-1" class="fr-modal-body">'.concat(t, "</div>"), n += "</div></div>";
            var a = i(l.doc.createElement("DIV"));
            return a.html(n), a.find("> .fr-modal")
          }(e, t);
          c[n] = {
            $modal: r,
            $head: r.find(".fr-modal-head"),
            $body: r.find(".fr-modal-body")
          }, l.helpers.isMobile() || r.addClass("fr-desktop"), i("body").first().append(r), l.events.$on(r, "click", ".fr-modal-close", function () {
            s(n)
          }, !0), c[n].$body.css("margin-top", c[n].$head.outerHeight()), l.events.$on(r, "keydown", function (e) {
            var t = e.which;
            return t === xt.KEYCODE.ESC ? (s(n), l.accessibility.focusModalButton(r), !1) : !(!i(e.currentTarget).is("input[type=text], textarea") && t !== xt.KEYCODE.ARROW_UP && t !== xt.KEYCODE.ARROW_DOWN && !l.keys.isBrowserAction(e) && (e.preventDefault(), e.stopPropagation(), 1))
          }, !0), s(n, !0)
        }
        return c[n]
      }, show: function o(e) {
        if (c[e]) {
          var t = c[e].$modal;
          t.data("instance", l), t.show(), a.show(), i(l.o_doc).find("body").first().addClass("fr-prevent-scroll"), l.helpers.isMobile() && i(l.o_doc).find("body").first().addClass("fr-mobile"), t.addClass("fr-active"), l.accessibility.focusModal(t)
        }
      }, hide: s, resize: function f(e) {
        if (c[e]) {
          var t = c[e], n = t.$modal, r = t.$body, a = l.o_win.innerHeight, o = n.find(".fr-modal-wrapper"),
            i = a - o.outerHeight(!0) + (o.height() - (r.outerHeight(!0) - r.height())), s = "auto";
          i < r.get(0).scrollHeight && (s = i), r.height(s)
        }
      }, isVisible: n, areVisible: function p(e) {
        for (var t in c) if (Object.prototype.hasOwnProperty.call(c, t) && n(t) && (void 0 === e || c[t].$modal.data("instance") === e)) return c[t].$modal;
        return !1
      }
    }
  }, xt.MODULES.position = function (E) {
    var y = E.$;

    function a() {
      var e = E.selection.ranges(0).getBoundingClientRect();
      if (0 === e.top && 0 === e.left && 0 === e.width || 0 === e.height) {
        var t = !1;
        0 === E.$el.find(".fr-marker").length && (E.selection.save(), t = !0);
        var n = E.$el.find(".fr-marker").first();
        n.css("display", "inline"), n.css("line-height", "");
        var r = n.offset(), a = n.outerHeight();
        n.css("display", "none"), n.css("line-height", 0), (e = {}).left = r && r.left, e.width = 0, e.height = a, e.top = r && r.top - (E.helpers.isMobile() && !E.helpers.isIOS() || E.opts.iframe ? 0 : E.helpers.scrollTop()), e.right = 1, e.bottom = 1, e.ok = !0, t && E.selection.restore()
      }
      return e
    }

    function o(e, t, n, r) {
      var a = n.data("container");
      if (!a || "BODY" === a.get(0).tagName && "static" === a.css("position") || (e && (e -= a.offset().left), t && (t -= a.offset().top), "BODY" !== a.get(0).tagName ? (e && (e += a.get(0).scrollLeft), t && (t += a.get(0).scrollTop)) : "absolute" === a.css("position") && (e && (e += a.position().left), t && (t += a.position().top))), E.opts.iframe && a && E.$tb && a.get(0) !== E.$tb.get(0)) {
        var o = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-top")),
          i = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-left"));
        e && (e += E.$iframe.offset().left + i), t && (t += E.$iframe.offset().top + o)
      }
      var s = function l(e, t) {
        var n = e.outerWidth(!0);
        return t + n > E.$sc.get(0).clientWidth - 10 && (t = E.$sc.get(0).clientWidth - n - 10), t < 0 && (t = 10), t
      }(n, e);
      e && n.css("left", s), t && n.css("top", function c(e, t, n) {
        var r = e.outerHeight(!0);
        if (!E.helpers.isMobile() && E.$tb && e.parent().get(0) !== E.$tb.get(0)) {
          var a = e.parent().offset().top, o = t - r - (n || 0);
          e.parent().get(0) === E.$sc.get(0) && (a -= e.parent().position().top);
          var i = E.$sc.get(0).clientHeight;
          a + t + r > E.$sc.offset().top + i && 0 < e.parent().offset().top + o && 0 < o ? o > E.$wp.scrollTop() && (t = o, e.addClass("fr-above")) : e.removeClass("fr-above")
        }
        return t
      }(n, t, r))
    }

    function i(e) {
      var n = y(e), t = n.is(".fr-sticky-on"), r = n.data("sticky-top"), a = n.data("sticky-scheduled");
      if (void 0 === r) {
        n.data("sticky-top", 0);
        var o = y('<div class="fr-sticky-dummy" style="height: '.concat(n.outerHeight(), 'px;"></div>'));
        E.$box.prepend(o)
      } else E.$box.find(".fr-sticky-dummy").css("height", n.outerHeight());
      if (E.core.hasFocus() || 0 < E.$tb.findVisible("input:focus").length) {
        var i = E.helpers.scrollTop(),
          s = Math.min(Math.max(i - E.$tb.parent().offset().top, 0), E.$tb.parent().outerHeight() - n.outerHeight());
        if (s !== r && s !== a && (clearTimeout(n.data("sticky-timeout")), n.data("sticky-scheduled", s), n.outerHeight() < i - E.$tb.parent().offset().top && n.addClass("fr-opacity-0"), n.data("sticky-timeout", setTimeout(function () {
          var e = E.helpers.scrollTop(),
            t = Math.min(Math.max(e - E.$tb.parent().offset().top, 0), E.$tb.parent().outerHeight() - n.outerHeight());
          0 < t && "BODY" === E.$tb.parent().get(0).tagName && (t += E.$tb.parent().position().top), t !== r && (n.css("top", Math.max(t, 0)), n.data("sticky-top", t), n.data("sticky-scheduled", t)), n.removeClass("fr-opacity-0")
        }, 100))), !t) {
          var l = E.$tb.parent(), c = l.get(0).offsetWidth - l.get(0).clientWidth;
          n.css("top", "0"), n.width(l.width() - c), n.addClass("fr-sticky-on"), E.$box.addClass("fr-sticky-box")
        }
      } else clearTimeout(y(e).css("sticky-timeout")), n.css("top", "0"), n.css("position", ""), n.css("width", ""), n.data("sticky-top", 0), n.removeClass("fr-sticky-on"), E.$box.removeClass("fr-sticky-box")
    }

    function t(e) {
      if (e.offsetWidth) {
        var t = y(e), n = t.outerHeight(), r = t.data("sticky-position"),
          a = y("body" === E.opts.scrollableContainer ? E.o_win : E.opts.scrollableContainer).outerHeight(), o = 0,
          i = 0;
        "body" !== E.opts.scrollableContainer && (o = E.$sc.offset().top, i = y(E.o_win).outerHeight() - o - a);
        var s = "body" === E.opts.scrollableContainer ? E.helpers.scrollTop() : o, l = t.is(".fr-sticky-on");
        t.data("sticky-parent") || t.data("sticky-parent", t.parent());
        var c = t.data("sticky-parent"), d = c.offset().top, f = c.outerHeight();
        if (t.data("sticky-offset") ? E.$box.find(".fr-sticky-dummy").css("height", "".concat(n, "px")) : (t.data("sticky-offset", !0), t.after('<div class="fr-sticky-dummy" style="height: '.concat(n, 'px;"></div>'))), !r) {
          var p = "auto" !== t.css("top") || "auto" !== t.css("bottom");
          p || t.css("position", "fixed"), r = {
            top: E.node.hasClass(t.get(0), "fr-top"),
            bottom: E.node.hasClass(t.get(0), "fr-bottom")
          }, p || t.css("position", ""), t.data("sticky-position", r), t.data("top", E.node.hasClass(t.get(0), "fr-top") ? t.css("top") : "auto"), t.data("bottom", E.node.hasClass(t.get(0), "fr-bottom") ? t.css("bottom") : "auto")
        }
        var u = E.helpers.getPX(t.data("top")), h = E.helpers.getPX(t.data("bottom")), g = r.top && function b() {
            return d < s + u && s + u <= d + f - n
          }() && (E.helpers.isInViewPort(E.$sc.get(0)) || "body" === E.opts.scrollableContainer),
          m = r.bottom && function C() {
            return d + n < s + a - h && s + a - h < d + f
          }();
        if (g || m) {
          var v = c.get(0).offsetWidth - c.get(0).clientWidth;
          t.css("width", "".concat(c.get(0).getBoundingClientRect().width - v, "px")), l || (t.addClass("fr-sticky-on"), t.removeClass("fr-sticky-off"), t.css("top") && ("auto" !== t.data("top") ? t.css("top", E.helpers.getPX(t.data("top")) + o) : t.data("top", "auto")), t.css("bottom") && ("auto" !== t.data("bottom") ? t.css("bottom", E.helpers.getPX(t.data("bottom")) + i) : t.css("bottom", "auto")))
        } else E.node.hasClass(t.get(0), "fr-sticky-off") || (t.css("width", ""), t.removeClass("fr-sticky-on"), t.addClass("fr-sticky-off"), t.css("top") && "auto" !== t.data("top") && r.top && t.css("top", 0), t.css("bottom") && "auto" !== t.data("bottom") && r.bottom && t.css("bottom", 0))
      }
    }

    function s() {
      if (E.helpers.requestAnimationFrame()(s), !1 !== E.events.trigger("position.refresh")) for (var e = 0; e < E._stickyElements.length; e++) if (E.opts.toolbarBottom) {
        var t = E.$tb.parent(), n = t.get(0).offsetWidth - t.get(0).clientWidth, r = y(E._stickyElements[e]);
        r.width(t.width() - n), r.addClass("fr-sticky-on"), E.$box.addClass("fr-sticky-box")
      } else i(E._stickyElements[e])
    }

    function n() {
      if (E._stickyElements) for (var e = 0; e < E._stickyElements.length; e++) t(E._stickyElements[e])
    }

    return {
      _init: function r() {
        !function e() {
          E._stickyElements = [], E.helpers.isIOS() ? (s(), E.events.$on(y(E.o_win), "scroll", function () {
            if (E.core.hasFocus()) for (var e = 0; e < E._stickyElements.length; e++) {
              var t = y(E._stickyElements[e]), n = t.parent(), r = E.helpers.scrollTop();
              t.outerHeight() < r - n.offset().top && (E.opts.toolbarBottom && E.helpers.isIOS() || (t.addClass("fr-opacity-0"), t.data("sticky-top", -1), t.data("sticky-scheduled", -1)))
            }
          }, !0)) : ("body" !== E.opts.scrollableContainer && E.events.$on(y(E.opts.scrollableContainer), "scroll", n, !0), E.events.$on(y(E.o_win), "scroll", n, !0), E.events.$on(y(E.o_win), "resize", n, !0), E.events.on("initialized", n), E.events.on("focus", n), E.events.$on(y(E.o_win), "resize", "textarea", n, !0)), E.events.on("destroy", function () {
            E._stickyElements = []
          })
        }()
      }, forSelection: function l(e) {
        var t = a();
        e.css({top: 0, left: 0});
        var n = t.top + t.height, r = t.left + t.width / 2 - e.get(0).offsetWidth / 2 + E.helpers.scrollLeft();
        E.opts.iframe || (n += E.helpers.scrollTop()), o(r, n, e, t.height)
      }, addSticky: function c(e) {
        e.addClass("fr-sticky"), E.helpers.isIOS() && !E.opts.toolbarBottom && e.addClass("fr-sticky-ios"), e.removeClass("fr-sticky"), E._stickyElements.push(e.get(0))
      }, refresh: n, at: o, getBoundingRect: a
    }
  }, xt.MODULES.refresh = function (l) {
    var c = l.$;

    function o(e, t) {
      e.toggleClass("fr-disabled", t).attr("aria-disabled", t)
    }

    function e(e) {
      var t = l.$tb.find('.fr-more-toolbar[data-name="'.concat(e.attr("data-group-name"), '"]')), n = function s(e, t) {
        var n = 0, r = t.find("> .fr-command, > .fr-btn-wrap");
        r.each(function (e, t) {
          n += c(t).outerWidth()
        });
        var a, o = l.helpers.getPX(c(r[0]).css("margin-left")), i = l.helpers.getPX(c(r[0]).css("margin-right"));
        a = "rtl" === l.opts.direction ? l.$tb.outerWidth() - e.offset().left + l.$tb.offset().left - (n + e.outerWidth() + r.length * (o + i)) / 2 : e.offset().left - l.$tb.offset().left - (n - e.outerWidth() + r.length * (o + i)) / 2;
        a + n + r.length * (o + i) > l.$tb.outerWidth() && (a -= (n + r.length * (o + i) - e.outerWidth()) / 2);
        a < 0 && (a = 0);
        return a
      }(e, t);
      "rtl" === l.opts.direction ? t.css("padding-right", n) : t.css("padding-left", n)
    }

    return {
      undo: function t(e) {
        o(e, !l.undo.canDo())
      }, redo: function n(e) {
        o(e, !l.undo.canRedo())
      }, outdent: function i(e) {
        if (l.node.hasClass(e.get(0), "fr-no-refresh")) return !1;
        if (c("button#markdown-".concat(l.id, ".fr-active")).length) return !1;
        for (var t = l.selection.blocks(), n = 0; n < t.length; n++) {
          var r = "rtl" === l.opts.direction || "rtl" === c(t[n]).css("direction") ? "margin-right" : "margin-left",
            a = t[0].parentElement;
          if ("P" != a.parentNode.tagName && "DIV" != a.parentNode.tagName && "UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return o(e, !0), !0;
          if (t[0].previousSibling && "none" == a.parentNode.style.listStyleType) return o(e, !0), !0;
          if ("LI" === t[n].tagName || "LI" === t[n].parentNode.tagName) return o(e, !1), !0;
          if (0 < l.helpers.getPX(c(t[n]).css(r))) return o(e, !1), !0
        }
        o(e, !0)
      }, indent: function a(e) {
        if (l.node.hasClass(e.get(0), "fr-no-refresh")) return !1;
        if (c("button#markdown-".concat(l.id, ".fr-active")).length) return !1;
        for (var t = l.selection.blocks(), n = 0; n < t.length; n++) {
          for (var r = t[n].previousSibling; r && r.nodeType === Node.TEXT_NODE && 0 === r.textContent.length;) r = r.previousSibling;
          if ("LI" !== t[n].tagName || r) return o(e, !1), !0;
          o(e, !0)
        }
      }, moreText: e, moreParagraph: e, moreMisc: e, moreRich: e
    }
  }, Object.assign(xt.DEFAULTS, {
    attribution: !0,
    toolbarBottom: !1,
    toolbarButtons: null,
    toolbarButtonsXS: null,
    toolbarButtonsSM: null,
    toolbarButtonsMD: null,
    toolbarContainer: null,
    toolbarInline: !1,
    toolbarSticky: !0,
    toolbarStickyOffset: 0,
    toolbarVisibleWithoutSelection: !1
  }), xt.TOOLBAR_BUTTONS = {
    moreText: {buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "inlineClass", "inlineStyle", "clearFormatting"]},
    moreParagraph: {buttons: ["alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "paragraphFormat", "paragraphStyle", "lineHeight", "outdent", "indent", "quote"]},
    moreRich: {
      buttons: ["trackChanges", "markdown", "insertLink", "insertFiles", "insertImage", "insertVideo", "insertTable", "emoticons", "fontAwesome", "specialCharacters", "embedly", "insertFile", "insertHR"],
      buttonsVisible: 4
    },
    moreMisc: {
      buttons: ["undo", "redo", "fullscreen", "print", "getPDF", "spellChecker", "selectAll", "html", "help"],
      align: "right",
      buttonsVisible: 2
    },
    trackChanges: {buttons: ["showChanges", "applyAll", "removeAll", "applyLast", "removeLast"], buttonsVisible: 0}
  }, xt.TOOLBAR_BUTTONS_MD = null, (xt.TOOLBAR_BUTTONS_SM = {}).moreText = Object.assign({}, xt.TOOLBAR_BUTTONS.moreText, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreParagraph = Object.assign({}, xt.TOOLBAR_BUTTONS.moreParagraph, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreRich = Object.assign({}, xt.TOOLBAR_BUTTONS.moreRich, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreMisc = Object.assign({}, xt.TOOLBAR_BUTTONS.moreMisc, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.trackChanges = Object.assign({}, xt.TOOLBAR_BUTTONS.trackChanges, {buttonsVisible: 0}), (xt.TOOLBAR_BUTTONS_XS = {}).moreText = Object.assign({}, xt.TOOLBAR_BUTTONS.moreText, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreParagraph = Object.assign({}, xt.TOOLBAR_BUTTONS.moreParagraph, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreRich = Object.assign({}, xt.TOOLBAR_BUTTONS.moreRich, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreMisc = Object.assign({}, xt.TOOLBAR_BUTTONS.moreMisc, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_XS.trackChanges = Object.assign({}, xt.TOOLBAR_BUTTONS.trackChanges, {buttonsVisible: 0}), xt.POWERED_BY = '<a id="fr-logo" href="https://froala.com/wysiwyg-editor" target="_blank" title="Froala WYSIWYG HTML Editor"><span>Powered by</span><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 355.33"><defs><style>.fr-logo{fill:#b1b2b7;}</style></defs><title>Froala</title><path class="fr-logo" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z"/><path class="fr-logo" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z"/><path class="fr-logo" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z"/><path class="fr-logo" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z"/><path class="fr-logo" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z"/><path class="fr-logo" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z"/><path class="fr-logo" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z"/></svg></a>', xt.MODULES.toolbar = function (y) {
    var L, _ = y.$, t = [];

    function e(e) {
      var n = {};
      if (Array.isArray(e)) {
        if (!Array.isArray(e[0])) {
          for (var t = [], r = [], a = 0; a < e.length; a++) "|" === e[a] || "-" === e[a] ? (0 < r.length && t.push(r), r = []) : r.push(e[a]);
          0 < r.length && t.push(r), e = t
        }
        e.forEach(function (e, t) {
          n["group".concat(t + 1)] = {buttons: e}
        }), n.showMoreButtons = !1
      } else "object" !== kt(e) || Array.isArray(e) || ((n = e).showMoreButtons = !0);
      return n
    }

    function w() {
      var e = y.helpers.screenSize();
      return t[L = e]
    }

    function A() {
      for (var e = y.$tb.find(".fr-more-toolbar"), t = 0; t < e.length; t++) {
        var c = _(e[t]);
        c.hasClass("fr-expanded") ? function () {
          var n = y.helpers.getPX(c.css("padding-left")), e = c.find("> .fr-command, > .fr-btn-wrap"), t = _(e[0]),
            r = y.helpers.getPX(t.css("margin-left")), a = y.helpers.getPX(t.css("margin-right")),
            o = y.helpers.getPX(t.css("margin-top")), i = y.helpers.getPX(t.css("margin-bottom"));
          if (e.each(function (e, t) {
            n += _(t).outerWidth() + r + a
          }), y.$tb.outerWidth() < n) {
            var s = Math.floor(n / y.$tb.outerWidth());
            n += s * (n / c[0].childElementCount), s = Math.ceil(n / y.$tb.outerWidth());
            var l = (y.helpers.getPX(t.css("height")) + o + i) * s;
            c.css("height", l)
          }
        }() : c.css("height", "")
      }
      !y.helpers.isMobile() && y.opts.toolbarBottom ? y.$tb.find(".fr-toolbar .fr-more-toolbar").removeClass("position-relative") : y.$tb.find(".fr-toolbar .fr-more-toolbar").addClass("position-relative")
    }

    function r() {
      if (0 == _("[data-name='trackChanges-".concat(y.id, "']")).length) {
        _(".fr-toolbar").append(_('<div class="fr-more-toolbar"></div>').data("name", "trackChanges-".concat(y.id)));
        for (var e = 0, t = ["showChanges", "applyAll", "removeAll", "applyLast", "removeLast"]; e < t.length; e++) {
          var n = t[e], r = xt.COMMANDS[n];
          if (r) {
            r.more_btn = !0;
            var a = _(y.button.build(n, r, !0));
            y.button.addButtons(a), _("[data-name='trackChanges-".concat(y.id, "']")).append(a)
          }
        }
      }
      if (L !== y.helpers.screenSize()) {
        var o = w(), i = _(), s = _();
        for (var l in y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").addClass("fr-hidden"), function E() {
          for (var t = y.$tb.find(".fr-btn-grp, .fr-more-toolbar"), r = function r(e) {
            var n = _(t[e]);
            n.children().each(function (e, t) {
              n.before(t)
            }), n.remove()
          }, e = 0; e < t.length; e++) r(e)
        }(), o) {
          var c = o[l];
          if (c.buttons) {
            var d = void 0, f = 0, p = 3, u = void 0;
            "trackChanges" !== l && (u = _('<div class="fr-btn-grp fr-float-'.concat(o[l].align ? o[l].align : "left", '"></div>'))), o.showMoreButtons && (d = _('<div class="fr-more-toolbar"></div>').data("name", "".concat(l, "-").concat(y.id)), "trackChanges" !== l && "moreRich" !== l || !y.opts.trackChangesEnabled || d.addClass("fr-expanded"));
            for (var h = 0; h < c.buttons.length; h++) {
              c.buttonsVisible !== undefined && (p = c.buttonsVisible);
              var g = y.$tb.find('> .fr-command[data-cmd="' + c.buttons[h] + '"], > div.fr-btn-wrap > .fr-command[data-cmd="' + c.buttons[h] + '"]'),
                m = null;
              y.node.hasClass(g.next().get(0), "fr-dropdown-menu") && (m = g.next()), y.node.hasClass(g.next().get(0), "fr-options") && (g.removeClass("fr-hidden"), g.next().removeClass("fr-hidden"), g = g.parent()), g.removeClass("fr-hidden"), o.showMoreButtons && p <= f ? (d.append(g), m && d.append(m)) : (u.append(g), m && u.append(m)), f++
            }
            if (o.showMoreButtons && p < f) {
              var v = y.$tb.find('.fr-command[data-cmd="'.concat(l, '"]'));
              if (0 < v.length) v.removeClass("fr-hidden fr-open"); else {
                var b = l, C = xt.COMMANDS[b];
                C.more_btn = !0, v = _(y.button.build(b, C, !0)), y.button.addButtons(v)
              }
              u && u.append(v)
            }
            u && i.push(u), o.showMoreButtons && s.push(d)
          }
        }
        y.opts.toolbarBottom ? (y.$tb.append(s), y.$tb.find(".fr-newline").remove(), y.$tb.append('<div class="fr-newline"></div>'), y.$tb.append(i)) : (y.$tb.append(i), y.$tb.find(".fr-newline").remove(), y.$tb.append('<div class="fr-newline"></div>'), y.$tb.append(s)), y.$tb.removeClass("fr-toolbar-open"), y.$box.removeClass("fr-toolbar-open"), y.events.trigger("codeView.toggle")
      }
      A()
    }

    function n(e, t) {
      setTimeout(function () {
        if ((!e || e.which != xt.KEYCODE.ESC) && y.selection.inEditor() && y.core.hasFocus() && !y.popups.areVisible() && "false" != _(y.selection.blocks()[0]).closest("table").attr("contenteditable") && (y.opts.toolbarVisibleWithoutSelection || !y.selection.isCollapsed() && !y.keys.isIME() || t)) {
          if (y.$tb.data("instance", y), !1 === y.events.trigger("toolbar.show", [e])) return;
          y.$tb.show(), y.opts.toolbarContainer || y.position.forSelection(y.$tb), 1 < y.opts.zIndex ? y.$tb.css("z-index", y.opts.zIndex + 1) : y.$tb.css("z-index", null)
        }
      }, 0)
    }

    function a(e) {
      return (!e || "blur" !== e.type || document.activeElement !== y.el) && (!(!e || "keydown" !== e.type || !y.keys.ctrlKey(e)) || (!!y.button.getButtons(".fr-dropdown.fr-active").next().find(y.o_doc.activeElement).length || (y.helpers.isMobile() && y.opts.toolbarInline && (y.$tb.find(".fr-expanded").toggleClass("fr-expanded"), y.$tb.find(".fr-open").removeClass("fr-open"), y.$tb.removeClass("fr-toolbar-open"), A()), void (!1 !== y.events.trigger("toolbar.hide") && y.$tb.hide()))))
    }

    t[xt.XS] = e(y.opts.toolbarButtonsXS || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_XS || xt.TOOLBAR_BUTTONS || []), t[xt.SM] = e(y.opts.toolbarButtonsSM || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_SM || xt.TOOLBAR_BUTTONS || []), t[xt.MD] = e(y.opts.toolbarButtonsMD || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_MD || xt.TOOLBAR_BUTTONS || []), t[xt.LG] = e(y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS || []);
    var o = null;

    function i(e) {
      clearTimeout(o), e && e.which === xt.KEYCODE.ESC || (o = setTimeout(n, y.opts.typingTimer))
    }

    function s() {
      y.events.on("window.mousedown", a), y.events.on("keydown", a), y.events.on("blur", a), y.events.$on(y.$tb, "transitionend", ".fr-more-toolbar", function () {
        y.position.forSelection(y.$tb)
      }), y.helpers.isMobile() || y.events.on("window.mouseup", n), y.helpers.isMobile() ? y.helpers.isIOS() || (y.events.on("window.touchend", n), y.browser.mozilla && setInterval(n, 200)) : y.events.on("window.keyup", i), y.events.on("keydown", function (e) {
        e && e.which === xt.KEYCODE.ESC && y.events.trigger("toolbar.esc")
      }), y.events.on("keydown", function (e) {
        if (e.which === xt.KEYCODE.ALT) return e.stopPropagation(), !1
      }, !0), y.events.$on(y.$wp, "scroll.toolbar", n), y.events.on("commands.after", n), y.helpers.isMobile() && (y.events.$on(y.$doc, "selectionchange", i), y.events.$on(y.$doc, "orientationchange", n))
    }

    function l() {
      y.$tb.html("").removeData().remove(), y.$tb = null, y.$second_tb && (y.$second_tb.html("").removeData().remove(), y.$second_tb = null)
    }

    function c() {
      y.$box.removeClass("fr-top fr-bottom fr-inline fr-basic"), y.$box.find(".fr-sticky-dummy").remove()
    }

    function d() {
      y.opts.theme && y.$tb.addClass("".concat(y.opts.theme, "-theme")), 1 < y.opts.zIndex && y.$tb.css("z-index", y.opts.zIndex + 1), "auto" !== y.opts.direction && y.$tb.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(y.opts.direction)), y.helpers.isMobile() ? y.$tb.addClass("fr-mobile") : y.$tb.addClass("fr-desktop"), y.opts.toolbarContainer ? (y.opts.toolbarInline && (s(), a()), y.opts.toolbarBottom ? y.$tb.addClass("fr-bottom") : y.$tb.addClass("fr-top")) : function e() {
        y.opts.toolbarInline ? (y.$sc.append(y.$tb), y.$tb.data("container", y.$sc), y.$tb.addClass("fr-inline"), s(), y.opts.toolbarBottom = !1) : (y.opts.toolbarBottom ? (y.$box.append(y.$tb), y.$tb.addClass("fr-bottom"), y.$box.addClass("fr-bottom")) : (y.opts.toolbarBottom = !1, y.$box.prepend(y.$tb), y.$tb.addClass("fr-top"), y.$box.addClass("fr-top")), y.$tb.addClass("fr-basic"), y.opts.toolbarSticky && (y.opts.toolbarStickyOffset && (y.opts.toolbarBottom ? y.$tb.css("bottom", y.opts.toolbarStickyOffset) : y.$tb.css("top", y.opts.toolbarStickyOffset)), y.position.addSticky(y.$tb)))
      }(), function t() {
        var e = y.button.buildGroup(w());
        y.$tb.append(e), A(), y.button.bindCommands(y.$tb)
      }(), function n() {
        y.events.$on(_(y.o_win), "resize", r), y.events.$on(_(y.o_win), "orientationchange", r), y.opts.toolbarButtons && -1 < y.opts.toolbarButtons.indexOf("trackChanges") && r()
      }(), y.accessibility.registerToolbar(y.$tb), y.events.$on(y.$tb, "".concat(y._mousedown, " ").concat(y._mouseup), function (e) {
        var t = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null;
        if (t && "INPUT" !== t.tagName && !y.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1
      }, !0), y.events.$on(y.$tb, "transitionend", ".fr-more-toolbar", function () {
        y.$box.hasClass("fr-fullscreen") && (y.opts.height = y.o_win.innerHeight - (y.opts.toolbarInline ? 0 : y.$tb.outerHeight() + (y.$second_tb ? y.$second_tb.outerHeight() : 0)), y.size.refresh())
      })
    }

    var f = !1;
    return {
      _init: function p() {
        if (y.$sc = _(y.opts.scrollableContainer).first(), !y.$wp) return !1;
        y.opts.toolbarInline || y.opts.toolbarBottom || (y.$second_tb = _(y.doc.createElement("div")).attr("class", "fr-second-toolbar"), y.$box.append(y.$second_tb), (!1 !== y.ul || y.opts.attribution) && y.$second_tb.prepend(xt.POWERED_BY)), y.opts.toolbarContainer ? (y.shared.$tb ? (y.$tb = y.shared.$tb, y.opts.toolbarInline && s()) : (y.shared.$tb = _(y.doc.createElement("DIV")), y.shared.$tb.addClass("fr-toolbar"), y.$tb = y.shared.$tb, _(y.opts.toolbarContainer).append(y.$tb), d(), y.$tb.data("instance", y)), y.helpers.isMobile() && y.events.$on(y.$tb, "click", function () {
          y.popups.areVisible().length || y.id !== y.shared.selected_editor || y.$el.focus()
        }), y.opts.toolbarInline ? y.$box.addClass("fr-inline") : y.$box.addClass("fr-basic"), y.events.on("focus", function () {
          y.$tb.data("instance", y)
        }, !0), y.opts.toolbarInline = !1) : y.opts.toolbarInline ? (y.$box.addClass("fr-inline"), y.shared.$tb ? (y.$tb = y.shared.$tb, s()) : (y.shared.$tb = _(y.doc.createElement("DIV")), y.shared.$tb.addClass("fr-toolbar"), y.$tb = y.shared.$tb, d())) : (y.$box.addClass("fr-basic"), y.$tb = _(y.doc.createElement("DIV")), y.$tb.addClass("fr-toolbar"), d(), y.$tb.data("instance", y)), y.events.on("destroy", c, !0), y.events.on(y.opts.toolbarInline || y.opts.toolbarContainer ? "shared.destroy" : "destroy", l, !0), y.events.on("edit.on", function () {
          y.$tb.removeClass("fr-disabled").removeAttr("aria-disabled")
        }), y.events.on("edit.off", function () {
          y.$tb.addClass("fr-disabled").attr("aria-disabled", !0)
        }), function e() {
          y.events.on("shortcut", function (e, t, n) {
            var r;
            if (t && !n ? r = y.$tb.find('.fr-command[data-cmd="'.concat(t, '"]')) : t && n && (r = y.$tb.find('.fr-command[data-cmd="'.concat(t, '"][data-param1="').concat(n, '"]'))), r.length && (e.preventDefault(), e.stopPropagation(), r.parents(".fr-toolbar").data("instance", y), "keydown" === e.type)) return y.button.exec(r), !1
          })
        }()
      }, hide: a, show: function u() {
        if (!1 === y.events.trigger("toolbar.show")) return !1;
        y.$tb.show()
      }, showInline: n, disable: function h() {
        !f && y.$tb && (y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").addClass("fr-disabled fr-no-refresh").attr("aria-disabled", !0), f = !0)
      }, enable: function g() {
        f && y.$tb && (y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").removeClass("fr-disabled fr-no-refresh").attr("aria-disabled", !1), f = !1), y.button.bulkRefresh()
      }, setMoreToolbarsHeight: A
    }
  };
  var c = ["scroll", "wheel", "touchmove", "touchstart", "touchend"], d = ["webkit", "moz", "ms", "o"],
    f = ["transitionend"], a = document.createElement("div").style, o = ["Webkit", "Moz", "ms", "O", "css", "style"],
    s = {visibility: "hidden", display: "block"}, r = ["focus", "blur", "click"], i = {}, l = function l(e, t) {
      return {
        altKey: e.altKey,
        bubbles: e.bubbles,
        cancelable: e.cancelable,
        changedTouches: e.changedTouches,
        ctrlKey: e.ctrlKey,
        detail: e.detail,
        eventPhase: e.eventPhase,
        metaKey: e.metaKey,
        pageX: e.pageX,
        pageY: e.pageY,
        shiftKey: e.shiftKey,
        view: e.view,
        "char": e["char"],
        key: e.key,
        keyCode: e.keyCode,
        button: e.button,
        buttons: e.buttons,
        clientX: e.clientX,
        clientY: e.clientY,
        offsetX: e.offsetX,
        offsetY: e.offsetY,
        pointerId: e.pointerId,
        pointerType: e.pointerType,
        screenX: e.screenX,
        screenY: e.screenY,
        targetTouches: e.targetTouches,
        toElement: e.toElement,
        touches: e.touches,
        type: e.type,
        which: e.which,
        target: e.target,
        currentTarget: t,
        originalEvent: e,
        stopPropagation: function () {
          e.stopPropagation()
        },
        stopImmediatePropagation: function () {
          e.stopImmediatePropagation()
        },
        preventDefault: function () {
          -1 === c.indexOf(e.type) && e.preventDefault()
        }
      }
    }, p = function p(e) {
      return e.ownerDocument && e.ownerDocument.body.contains(e) || "#document" === e.nodeName || "HTML" === e.nodeName || e === window
    }, u = function u(n, r) {
      return function (e) {
        var t = e.target;
        if (r) for (r = g(r); t && t !== this;) Element.prototype.matches.call(t, g(r)) && n.call(t, l(e, t)), t = t.parentNode; else p(t) && n.call(t, l(e, t))
      }
    }, h = function h(e, t) {
      return new b(e, t)
    }, g = function g(e) {
      return e && "string" == typeof e ? e.replace(/^\s*>/g, ":scope >").replace(/,\s*>/g, ", :scope >") : e
    }, m = function m(e) {
      return "function" == typeof e && "number" != typeof e.nodeType
    }, v = h;
  h.fn = h.prototype = {
    constructor: h, length: 0, contains: function (e) {
      if (!e) return !1;
      if (Array.isArray(e)) {
        for (var t = 0; t < e.length; t++) if (this.contains(e[t]) && this != e[t]) return !0;
        return !1
      }
      for (var n = 0; n < this.length; n++) for (var r = e; r;) {
        if (r == this[n] || r[0] && r[0].isEqualNode(this[n])) return !0;
        r = r.parentNode
      }
      return !1
    }, findVisible: function (e) {
      for (var t = this.find(e), n = t.length - 1; 0 <= n; n--) v(t[n]).isVisible() || t.splice(n, 1);
      return t
    }, formatParams: function (t) {
      var e = "".concat(Object.keys(t).map(function (e) {
        return "".concat(e, "=").concat(encodeURIComponent(t[e]))
      }).join("&"));
      return e || ""
    }, ajax: function (t) {
      var n = new XMLHttpRequest, e = this.formatParams(t.data);
      for (var r in "GET" === t.method.toUpperCase() && (t.url = e ? t.url + "?" + e : t.url), n.open(t.method, t.url, !0), t.withCredentials && (n.withCredentials = !0), t.crossDomain && n.setRequestHeader("Access-Control-Allow-Origin", "*"), t.headers) Object.prototype.hasOwnProperty.call(t.headers, r) && n.setRequestHeader(r, t.headers[r]);
      Object.prototype.hasOwnProperty.call(t.headers, "Content-Type") || ("json" === t.dataType ? n.setRequestHeader("Content-Type", "application/json") : n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8")), n.onload = function () {
        if (200 == n.status) {
          var e = n.responseText;
          "json" === t.dataType && (e = JSON.parse(e)), t.done(e, n.status, n)
        } else t.fail(n)
      }, n.send(e)
    }, prevAll: function () {
      var e = v();
      if (!this[0]) return e;
      for (var t = this[0]; t && t.previousSibling;) t = t.previousSibling, e.push(t);
      return e
    }, index: function (e) {
      return e ? "string" == typeof e ? [].indexOf.call(v(e), this[0]) : [].indexOf.call(this, e.length ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
    }, isVisible: function () {
      return !!this[0] && !!(this[0].offsetWidth || this[0].offsetHeight || this[0].getClientRects().length)
    }, toArray: function () {
      return [].slice.call(this)
    }, get: function (e) {
      return null == e ? [].slice.call(this) : e < 0 ? this[e + this.length] : this[e]
    }, pushStack: function (e) {
      var t = h.merge(this.constructor(), e);
      return t.prevObject = this, t
    }, wrapAll: function (e) {
      var t;
      return this[0] && (m(e) && (e = e.call(this[0])), t = h(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        for (var e = this; e.firstElementChild;) e = e.firstElementChild;
        return e
      }).append(this)), this
    }, wrapInner: function (e) {
      if ("string" == typeof e) {
        for (var t = e.split(" "), n = 0; n < t.length && 0 === t[n].trim().length;) n++;
        if (n < t.length && (v(e).length && t[n].trim() === v(e)[0].tagName && (e = document.createElement(t[n].trim())), n++), "string" != typeof e) for (var r = v(e); n < t.length; n++) {
          t[n] = t[n].trim();
          var a = t[n].split("=");
          r.attr(a[0], a[1].replace('"', ""))
        }
      }
      for (; this[0].firstChild && this[0].firstChild !== e && "string" != typeof e;) e.appendChild(this[0].firstChild)
    }, wrap: function (t) {
      var n = m(t);
      return this.each(function (e) {
        v(this).wrapAll(n ? t.call(this, e) : t)
      })
    }, unwrap: function () {
      return this.parent().each(function () {
        this.nodeName && this.nodeName.toLowerCase() === name.toLowerCase() || h(this).replaceWith(this.childNodes)
      })
    }, grep: function (e, t, n) {
      for (var r = [], a = 0, o = e.length, i = !n; a < o; a++) !t(e[a], a) !== i && r.push(e[a]);
      return r
    }, map: function (n) {
      return this.pushStack(h.map(this, function (e, t) {
        return n.call(e, t, e)
      }))
    }, slice: function () {
      return this.pushStack([].slice.apply(this, arguments))
    }, each: function (e) {
      if (this.length) for (var t = 0; t < this.length && !1 !== e.call(this[t], t, this[t]); t++) ;
      return this
    }, first: function () {
      return this.eq(0)
    }, last: function () {
      return this.eq(-1)
    }, eq: function (e) {
      var t = this.length, n = +e + (e < 0 ? t : 0);
      return this.pushStack(0 <= n && n < t ? [this[n]] : [])
    }, empty: function () {
      for (var e = 0; e < this.length; e++) this[e].innerHTML = ""
    }, contents: function () {
      for (var e = v(), t = 0; t < this.length; t++) for (var n = this[t].childNodes, r = 0; r < n.length; r++) e.push(n[r]);
      return e
    }, attr: function (e, t) {
      if ("object" === kt(e)) {
        for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && null !== e[n] && this.attr(n, e[n]);
        return this
      }
      if (void 0 === t) return 0 === this.length || !this[0].getAttribute && "checked" !== e ? undefined : "checked" === e ? this[0].checked : "tagName" === e ? this[0].tagName : this[0].getAttribute(e);
      if ("checked" === e) for (var r = 0; r < this.length; r++) this[r].checked = t; else if ("tagName" === e) for (var a = 0; a < this.length; a++) this[a].tagName = t; else for (var o = 0; o < this.length; o++) this[o].setAttribute(e, t);
      return this
    }, removeAttr: function (e) {
      for (var t = 0; t < this.length; t++) this[t].removeAttribute && this[t].removeAttribute(e);
      return this
    }, hide: function () {
      return this.css("display", "none"), this
    }, show: function () {
      return this.css("display", "block"), this
    }, focus: function () {
      return this.length && this[0].focus(), this
    }, blur: function () {
      return this.length && this[0].blur(), this
    }, data: function (e, t) {
      if (void 0 !== t) {
        for (var n = 0; n < this.length; n++) "object" !== kt(this[n]["data-" + e] = t) && "function" != typeof t && this[n].setAttribute && this[n].setAttribute("data-" + e, t);
        return this
      }
      if (void 0 !== t) return this.attr("data-" + e, t);
      if (0 === this.length) return undefined;
      for (var r = 0; r < this.length; r++) {
        var a = this[r]["data-" + e];
        if (null == a && this[r].getAttribute && (a = this[r].getAttribute("data-" + e)), void 0 !== a && null != a) return a
      }
      return undefined
    }, removeData: function (e) {
      for (var t = 0; t < this.length; t++) this[t].removeAttribute && this[t].removeAttribute("data-" + e), this[t]["data-" + e] = null;
      return this
    }, getCorrectStyleName: function (e) {
      if (!i[e]) {
        var t;
        e in a && (t = e);
        for (var n = e[0].toUpperCase() + e.slice(1), r = o.length; r--;) (e = o[r] + n) in a && (t = e);
        i[e] = t
      }
      return i[e]
    }, css: function (e, t) {
      if (void 0 !== t) {
        if (0 === this.length) return this;
        ("string" != typeof t || "" === t.trim() || isNaN(t)) && "number" != typeof t || !/(margin)|(padding)|(height)|(width)|(top)|(left)|(right)|(bottom)/gi.test(e) || /(line-height)/gi.test(e) || (t += "px");
        for (var n = 0; n < this.length; n++) e = v(this).getCorrectStyleName(e), this[n].style[e] = t;
        return this
      }
      if ("string" == typeof e) {
        if (0 === this.length) return undefined;
        var r = this[0].ownerDocument || document, a = r.defaultView || r.parentWindow;
        return e = v(this).getCorrectStyleName(e), a.getComputedStyle(this[0])[e]
      }
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && this.css(o, e[o]);
      return this
    }, toggleClass: function (e, t) {
      if (1 < e.split(" ").length) {
        for (var n = e.split(" "), r = 0; r < n.length; r++) this.toggleClass(n[r], t);
        return this
      }
      for (var a = 0; a < this.length; a++) void 0 === t ? this[a].classList.contains(e) ? this[a].classList.remove(e) : this[a].classList.add(e) : t ? this[a].classList.contains(e) || this[a].classList.add(e) : this[a].classList.contains(e) && this[a].classList.remove(e);
      return this
    }, addClass: function (e) {
      if (0 === e.length) return this;
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) this.addClass(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) this[r].classList.add(e);
      return this
    }, removeClass: function (e) {
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) t[n] = t[n].trim(), t[n].length && this.removeClass(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) e.length && this[r].classList.remove(e);
      return this
    }, getClass: function (e) {
      return e.getAttribute && e.getAttribute("class") || ""
    }, stripAndCollapse: function (e) {
      return (e.match(/[^\x20\t\r\n\f]+/g) || []).join(" ")
    }, hasClass: function (e) {
      var t, n, r = 0;
      for (t = " " + e + " "; n = this[r++];) if (1 === n.nodeType && -1 < (" " + v(this).stripAndCollapse(v(this).getClass(n)) + " ").indexOf(t)) return !0;
      return !1
    }, scrollTop: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0] === document ? document.documentElement.scrollTop : this[0].scrollTop;
      for (var t = 0; t < this.length; t++) this[t] === document ? window.scrollTo(document.documentElement.scrollLeft, e) : this[t].scrollTop = e
    }, scrollLeft: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0] === document ? document.documentElement.scrollLeft : this[0].scrollLeft;
      for (var t = 0; t < this.length; t++) this[t] === document ? window.scrollTo(e, document.documentElement.scrollTop) : this[t].scrollLeft = e
    }, on: function (e, t, n) {
      if (1 < e.split(" ").length) {
        for (var r = e.split(" "), a = 0; a < r.length; a++) if (-1 !== f.indexOf(e)) for (var o = 0; o < d.length; o++) this.on(d[o] + e[0].toUpperCase() + e.slice(1), t, n); else this.on(r[a], t, n);
        return this
      }
      n = "function" == typeof t ? u(t, null) : u(n, t);
      for (var i = 0; i < this.length; i++) {
        var s = v(this[i]);
        s.data("events") || s.data("events", []), s.data("events").push([e, n]);
        var l = e.split(".");
        l = l[0], 0 <= c.indexOf(l) ? s.get(0).addEventListener(l, n, {passive: !0}) : s.get(0).addEventListener(l, n)
      }
    }, off: function (e) {
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) this.off(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) {
        var a = v(this[r]);
        if (a.data("events")) {
          var o = e.split(".");
          o = o[0];
          for (var i = a.data("events") || [], s = i.length - 1; 0 <= s; s--) {
            var l = i[s];
            l[0] == e && (a.get(0).removeEventListener(o, l[1]), i.splice(s, 1))
          }
        }
      }
    }, trigger: function (e) {
      for (var t = 0; t < this.length; t++) {
        var n = void 0;
        "function" == typeof Event ? n = 0 <= e.search(/^mouse/g) ? new MouseEvent(e, {
          view: window,
          cancelable: !0,
          bubbles: !0
        }) : new Event(e) : 0 <= e.search(/^mouse/g) ? (n = document.createEvent("MouseEvents")).initMouseEvent(e, !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null) : (n = document.createEvent("Event")).initEvent(e, !0, !0), 0 <= r.indexOf(e) && "function" == typeof this[t][e] ? this[t][e]() : this[t].dispatchEvent(n)
      }
    }, triggerHandler: function () {
    }, val: function (e) {
      if (void 0 === e) return this[0].value;
      for (var t = 0; t < this.length; t++) this[t].value = e;
      return this
    }, siblings: function () {
      return v(this[0]).parent().children().not(this)
    }, find: function (e) {
      var t = v();
      if ("string" != typeof e) {
        for (var n = 0; n < e.length; n++) for (var r = 0; r < this.length; r++) if (this[r] !== e[n] && v(this[r]).contains(e[n])) {
          t.push(e[n]);
          break
        }
        return t
      }
      var a = function a(e) {
        return "object" === ("undefined" == typeof HTMLElement ? "undefined" : kt(HTMLElement)) ? e instanceof HTMLElement : e && "object" === kt(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
      };
      e = g(e);
      for (var o = 0; o < this.length; o++) if (this[o].querySelectorAll) {
        var i = [];
        if (e && "string" == typeof e) try {
          i = this[o].querySelectorAll(e)
        } catch (l) {
          i = this[o].children
        } else a(e) && (i = [e]);
        for (var s = 0; s < i.length; s++) t.push(i[s])
      }
      return t
    }, children: function () {
      for (var e = v(), t = 0; t < this.length; t++) for (var n = this[t].children, r = 0; r < n.length; r++) e.push(n[r]);
      return e
    }, not: function (e) {
      if ("string" == typeof e) for (var t = this.length - 1; 0 <= t; t--) Element.prototype.matches.call(this[t], e) && this.splice(t, 1); else if (e instanceof h) {
        for (var n = this.length - 1; 0 <= n; n--) for (var r = 0; r < e.length; r++) if (this[n] === e[r]) {
          this.splice(n, 1);
          break
        }
      } else for (var a = this.length - 1; 0 <= a; a--) this[a] === e[0] && this.splice(a, 1);
      return this
    }, add: function (e) {
      for (var t = 0; t < e.length; t++) this.push(e[t]);
      return this
    }, closest: function (e) {
      for (var t = 0; t < this.length; t++) {
        var n = Element.prototype.closest.call(this[t], e);
        if (n) return v(n)
      }
      return v()
    }, html: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0].innerHTML;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        this[t].innerHTML = e;
        for (var n = this[t].children, r = this[t].ownerDocument || document, a = 0; a < n.length; a++) if ("SCRIPT" === n[a].tagName) {
          var o = r.createElement("script");
          o.innerHTML = n[a].innerHTML, n[a].hasAttribute("async") && o.setAttribute("async", ""), o.src = n[a].src, n[a].hasAttribute("defer") && o.setAttribute("defer", ""), r.head.appendChild(o).parentNode.removeChild(o)
        }
      } else {
        this[0].innerHTML = "", this.append(e[0]);
        var i = this[0].ownerDocument || document;
        if ("SCRIPT" === e[0].tagName) {
          var s = i.createElement("script");
          s.innerHTML = e[0].innerHTML, i.head.appendChild(s).parentNode.removeChild(s)
        }
      }
      return this
    }, text: function (e) {
      if (!e) return this.length ? this[0].textContent : "";
      for (var t = 0; t < this.length; t++) this[t].textContent = e
    }, after: function e(t) {
      if (t) if ("string" == typeof t) for (var n = 0; n < this.length; n++) {
        var e = this[n];
        if (e.nodeType != Node.ELEMENT_NODE) {
          var r = e.ownerDocument.createElement("SPAN");
          v(e).after(r), v(r).after(t).remove()
        } else e.insertAdjacentHTML("afterend", t)
      } else {
        var a = this[0];
        if (a.nextSibling) if (t instanceof h) for (var o = 0; o < t.length; o++) a.nextSibling.parentNode.insertBefore(t[o], a.nextSibling); else a.nextSibling.parentNode.insertBefore(t, a.nextSibling); else v(a.parentNode).append(t)
      }
      return this
    }, clone: function (e) {
      for (var t = v(), n = 0; n < this.length; n++) t.push(this[n].cloneNode(e));
      return t
    }, replaceWith: function (e) {
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) this[t].parentNode && (this[t].outerHTML = e); else if (e.length) for (var n = 0; n < this.length; n++) this.replaceWith(e[n]); else this.after(e).remove()
    }, insertBefore: function (e) {
      return v(e).before(this[0]), this
    }, before: function e(t) {
      if (t instanceof h) {
        for (var n = 0; n < t.length; n++) this.before(t[n]);
        return this
      }
      if (t) if ("string" == typeof t) for (var r = 0; r < this.length; r++) {
        var e = this[r];
        if (e.nodeType != Node.ELEMENT_NODE) {
          var a = e.ownerDocument.createElement("SPAN");
          v(e).before(a), v(a).before(t).remove()
        } else e.parentNode && e.insertAdjacentHTML("beforebegin", t)
      } else {
        var o = this[0];
        if (o.parentNode) if (t instanceof h) for (var i = 0; i < t.length; i++) o.parentNode.insertBefore(t[i], o); else o.parentNode.insertBefore(t, o)
      }
      return this
    }, append: function (e) {
      if (0 == this.length) return this;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        var n = this[t], r = n.ownerDocument.createElement("SPAN");
        v(n).append(r), v(r).after(e).remove()
      } else if (e instanceof h || Array.isArray(e)) for (var a = 0; a < e.length; a++) this.append(e[a]); else "function" != typeof e && this[0].appendChild(e);
      return this
    }, prepend: function (e) {
      if (0 == this.length) return this;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        var n = this[t], r = n.ownerDocument.createElement("SPAN");
        v(n).prepend(r), v(r).before(e).remove()
      } else if (e instanceof h) for (var a = 0; a < e.length; a++) this.prepend(e[a]); else {
        var o = this[0];
        o.firstChild ? o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e) : v(o).append(e)
      }
      return this
    }, remove: function () {
      for (var e = 0; e < this.length; e++) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      return this
    }, prev: function () {
      return this.length && this[0].previousElementSibling ? v(this[0].previousElementSibling) : v()
    }, next: function () {
      return this.length && this[0].nextElementSibling ? v(this[0].nextElementSibling) : v()
    }, nextAllVisible: function () {
      return this.next()
    }, prevAllVisible: function () {
      return this.prev()
    }, outerHeight: function (e) {
      if (0 === this.length) return undefined;
      var t = this[0];
      if (t === t.window) return t.innerHeight;
      var n = {}, r = this.isVisible();
      if (!r) for (var a in s) n[a] = t.style[a], t.style[a] = s[a];
      var o = t.offsetHeight;
      if (e && (o += parseInt(v(t).css("marginTop")) + parseInt(v(t).css("marginBottom"))), !r) for (var i in s) t.style[i] = n[i];
      return o
    }, outerWidth: function (e) {
      if (0 === this.length) return undefined;
      var t = this[0];
      if (t === t.window) return t.outerWidth;
      var n = {}, r = this.isVisible();
      if (!r) for (var a in s) n[a] = t.style[a], t.style[a] = s[a];
      var o = t.offsetWidth;
      if (e && (o += parseInt(v(t).css("marginLeft")) + parseInt(v(t).css("marginRight"))), !r) for (var i in s) t.style[i] = n[i];
      return o
    }, width: function (e) {
      if (e === undefined) {
        if (this[0] instanceof HTMLDocument) return this[0].body.offsetWidth;
        if (this[0]) return this[0].offsetWidth
      } else this[0].style.width = e + "px"
    }, height: function (e) {
      var t = this[0];
      if (e === undefined) {
        if (t instanceof HTMLDocument) {
          var n = t.documentElement;
          return Math.max(t.body.scrollHeight, n.scrollHeight, t.body.offsetHeight, n.offsetHeight, n.clientHeight)
        }
        return t.offsetHeight
      }
      t.style.height = e + "px"
    }, is: function (e) {
      return 0 !== this.length && ("string" == typeof e && this[0].matches ? this[0].matches(e) : e instanceof h ? this[0] == e[0] : this[0] == e)
    }, parent: function () {
      return 0 === this.length ? v() : v(this[0].parentNode)
    }, _matches: function (e, t) {
      var n = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
      return e && !t ? n : n.call(e, t)
    }, parents: function (e) {
      for (var t = v(), n = 0; n < this.length; n++) for (var r = this[n].parentNode; r && r != document && this._matches(r);) e ? this._matches(r, e) && t.push(r) : t.push(r), r = r.parentNode;
      return t
    }, parentsUntil: function (e, t) {
      var n = v();
      e instanceof h && 0 < e.length && (e = e[0]);
      for (var r = 0; r < this.length; r++) for (var a = this[r].parentNode; a && a != document && a != e && this[r] != e && ("string" != typeof e || !Element.prototype.matches.call(a, e));) t ? Element.prototype.matches.call(a, t) && n.push(a) : n.push(a), a = a.parentNode;
      return n
    }, insertAfter: function (e) {
      var t = e.parent()[0];
      t && t.insertBefore(this[0], e[0].nextElementSibling)
    }, filter: function (e) {
      var t = v();
      if ("function" == typeof e) for (var n = 0; n < this.length; n++) e.call(this[n], this[n]) && t.push(this[n]); else if ("string" == typeof e) for (var r = 0; r < this.length; r++) this[r].matches(e) && t.push(this[r]);
      return t
    }, offset: function () {
      if (0 === this.length) return undefined;
      var e = this[0].getBoundingClientRect(), t = this[0].ownerDocument.defaultView;
      return {top: e.top + t.pageYOffset, left: e.left + t.pageXOffset}
    }, position: function () {
      return {left: this[0].offsetLeft, top: this[0].offsetTop}
    }, push: [].push, splice: [].splice
  }, h.extend = function (e) {
    e = e || {};
    for (var t = 1; t < arguments.length; t++) if (arguments[t]) for (var n in arguments[t]) Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
    return e
  }, h.merge = function (e, t) {
    for (var n = +t.length, r = 0, a = e.length; r < n; r++) e[a++] = t[r];
    return e.length = a, e
  }, h.map = function (e, t, n) {
    var r, a, o = 0, i = [];
    if (Array.isArray(e)) for (r = e.length; o < r; o++) null != (a = t(e[o], o, n)) && i.push(a); else for (o in e) null != (a = t(e[o], o, n)) && i.push(a);
    return [].concat.apply([], i)
  };
  var b = function b(e, t) {
    if (!e) return this;
    if ("string" == typeof e && "<" === e[0]) {
      var n = document.createElement("DIV");
      return n.innerHTML = e, v(n.firstElementChild)
    }
    if (t = t instanceof h ? t[0] : t, "string" != typeof e) return e instanceof h ? e : (this[0] = e, this.length = 1, this);
    e = g(e);
    for (var r = (t || document).querySelectorAll(e), a = 0; a < r.length; a++) this[a] = r[a];
    return this.length = r.length, this
  };
  b.prototype = h.prototype;
  var C = xt;

  function E() {
    this.doc = this.$el.get(0).ownerDocument, this.win = "defaultView" in this.doc ? this.doc.defaultView : this.doc.parentWindow, this.$doc = h(this.doc), this.$win = h(this.win), this.opts.pluginsEnabled || (this.opts.pluginsEnabled = Object.keys(C.PLUGINS)), this.opts.initOnClick ? (this.load(C.MODULES), this.$el.on("touchstart.init", function () {
      h(this).data("touched", !0)
    }), this.$el.on("touchmove.init", function () {
      h(this).removeData("touched")
    }), this.$el.on("mousedown.init touchend.init dragenter.init focus.init", function r(e) {
      if ("touchend" === e.type && !this.$el.data("touched")) return !0;
      if (1 === e.which || !e.which) {
        this.$el.off("mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init"), this.load(C.MODULES), this.load(C.PLUGINS);
        var t = e.originalEvent && e.originalEvent.originalTarget;
        if (t && "IMG" === t.tagName && h(t).trigger("mousedown"), "undefined" == typeof this.ul && this.destroy(), "touchend" === e.type && this.image && e.originalEvent && e.originalEvent.target && h(e.originalEvent.target).is("img")) {
          var n = this;
          setTimeout(function () {
            n.image.edit(h(e.originalEvent.target))
          }, 100)
        }
        this.ready = !0, this.events.trigger("initialized")
      }
    }.bind(this)), this.events.trigger("initializationDelayed")) : (this.load(C.MODULES), this.load(C.PLUGINS), h(this.o_win).scrollTop(this.c_scroll), "undefined" == typeof this.ul && this.destroy(), this.ready = !0, this.events.trigger("initialized"))
  }

  if (C.Bootstrap = function (e, t, n) {
    this.id = ++C.ID, this.$ = h;
    var r = {};
    "function" == typeof t && (n = t, t = {}), n && (t.events || (t.events = {}), t.events.initialized = n), t && t.documentReady && (r.toolbarButtons = [["fullscreen", "undo", "redo", "getPDF", "print"], ["bold", "italic", "underline", "textColor", "backgroundColor", "clearFormatting"], ["alignLeft", "alignCenter", "alignRight", "alignJustify"], ["formatOL", "formatUL", "indent", "outdent"], ["paragraphFormat"], ["fontFamily"], ["fontSize"], ["insertLink", "insertImage", "quote"]], r.paragraphFormatSelection = !0, r.fontFamilySelection = !0, r.fontSizeSelection = !0, r.placeholderText = "", r.quickInsertEnabled = !1, r.charCounterCount = !1), this.opts = Object.assign({}, Object.assign({}, C.DEFAULTS, r, "object" === kt(t) && t));
    var a = JSON.stringify(this.opts);
    C.OPTS_MAPPING[a] = C.OPTS_MAPPING[a] || this.id, this.sid = C.OPTS_MAPPING[a], C.SHARED[this.sid] = C.SHARED[this.sid] || {}, this.shared = C.SHARED[this.sid], this.shared.count = (this.shared.count || 0) + 1, this.$oel = h(e), this.$oel.data("froala.editor", this), this.o_doc = e.ownerDocument, this.o_win = "defaultView" in this.o_doc ? this.o_doc.defaultView : this.o_doc.parentWindow, this.c_scroll = h(this.o_win).scrollTop(), this._init()
  }, C.Bootstrap.prototype._init = function () {
    var e = this.$oel.get(0).tagName;
    this.$oel.closest("label").length;
    var t = function () {
      "TEXTAREA" !== e && (this._original_html = this._original_html || this.$oel.html()), this.$box = this.$box || this.$oel, this.opts.fullPage && (this.opts.iframe = !0), this.opts.iframe ? (this.$iframe = h('<iframe src="about:blank" frameBorder="0">'), this.$wp = h("<div></div>"), this.$box.html(this.$wp), this.$wp.append(this.$iframe), this.$iframe.get(0).contentWindow.document.open(), this.$iframe.get(0).contentWindow.document.write("<!DOCTYPE html>"), this.$iframe.get(0).contentWindow.document.write("<html><head></head><body></body></html>"), this.$iframe.get(0).contentWindow.document.close(), this.iframe_document = this.$iframe.get(0).contentWindow.document, this.$el = h(this.iframe_document.querySelector("body")), this.el = this.$el.get(0), this.$head = h(this.iframe_document.querySelector("head")), this.$html = h(this.iframe_document.querySelector("html"))) : (this.$el = h(this.o_doc.createElement("DIV")), this.el = this.$el.get(0), this.$wp = h(this.o_doc.createElement("DIV")).append(this.$el), this.$box.html(this.$wp)), setTimeout(E.bind(this), 0)
    }.bind(this), n = function () {
      this.$box = h("<div>"), this.$oel.before(this.$box).hide(), this._original_html = this.$oel.val();
      var e = this;
      this.$oel.parents("form").on("submit.".concat(this.id), function () {
        e.events.trigger("form.submit")
      }), this.$oel.parents("form").on("reset.".concat(this.id), function () {
        e.events.trigger("form.reset")
      }), t()
    }.bind(this), r = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.$el.attr("contenteditable", !0).css("outline", "none").css("display", "inline-block"), this.opts.multiLine = !1, this.opts.toolbarInline = !1, setTimeout(E.bind(this), 0)
    }.bind(this), a = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.opts.toolbarInline = !1, setTimeout(E.bind(this), 0)
    }.bind(this), o = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.opts.toolbarInline = !1, this.$oel.on("click.popup", function (e) {
        e.preventDefault()
      }), setTimeout(E.bind(this), 0)
    }.bind(this);
    this.opts.editInPopup ? o() : "TEXTAREA" === e ? n() : "A" === e ? r() : "IMG" === e ? a() : "BUTTON" === e || "INPUT" === e ? (this.opts.editInPopup = !0, this.opts.toolbarInline = !1, o()) : t()
  }, C.Bootstrap.prototype.load = function (e) {
    for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
      if (this[t]) continue;
      if (C.PLUGINS[t] && this.opts.pluginsEnabled.indexOf(t) < 0) continue;
      if (this[t] = new e[t](this), this[t]._init && (this[t]._init(), this.opts.initOnClick && "core" === t)) return !1
    }
  }, C.Bootstrap.prototype.destroy = function () {
    this.destrying = !0, this.shared.count--, this.events && this.events.$off();
    var e = this.html && this.html.get();
    if (this.opts.iframe && (this.events.disableBlur(), this.win.focus(), this.events.enableBlur()), this.events && (this.events.trigger("destroy", [], !0), this.events.trigger("shared.destroy", [], !0)), 0 === this.shared.count) {
      for (var t in this.shared) Object.prototype.hasOwnProperty.call(this.shared, t) && (this.shared[t] = null, C.SHARED[this.sid][t] = null);
      delete C.SHARED[this.sid]
    }
    this.$oel.parents("form").off(".".concat(this.id)), this.$oel.off("click.popup"), this.$oel.removeData("froala.editor"), this.$oel.off("froalaEditor"), this.core && this.core.destroy(e), C.INSTANCES.splice(C.INSTANCES.indexOf(this), 1)
  }, xt.PLUGINS.align = function (a) {
    var o = a.$;
    return {
      apply: function i(e) {
        var t = a.selection.element();
        if (o(t).parents(".fr-img-caption").length) o(t).css("text-align", e); else {
          a.selection.save(), a.html.wrap(!0, !0, !0, !0), a.selection.restore();
          for (var n = a.selection.blocks(), r = 0; r < n.length; r++) o(n[r]).css("text-align", e).removeClass("fr-temp-div"), "" === o(n[r]).attr("class") && o(n[r]).removeAttr("class"), "" === o(n[r]).attr("style") && o(n[r]).removeAttr("style");
          a.selection.save(), a.html.unwrap(), a.selection.restore()
        }
      }, refresh: function r(e) {
        var t = a.selection.blocks();
        if (t.length) {
          var n = a.helpers.getAlignment(o(t[0]));
          e.find("> *").first().replaceWith(a.icon.create("align-".concat(n)))
        }
      }, refreshOnShow: function s(e, t) {
        var n = a.selection.blocks();
        if (n.length) {
          var r = a.helpers.getAlignment(o(n[0]));
          t.find('a.fr-command[data-param1="'.concat(r, '"]')).addClass("fr-active").attr("aria-selected", !0)
        }
      }, refreshForToolbar: function l(e) {
        var t = a.selection.blocks();
        if (t.length) {
          var n = a.helpers.getAlignment(o(t[0]));
          n = n.charAt(0).toUpperCase() + n.slice(1), "align".concat(n) === e.attr("data-cmd") && e.addClass("fr-active")
        }
      }
    }
  }, xt.DefineIcon("align", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), xt.DefineIcon("align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), xt.DefineIcon("align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }), xt.DefineIcon("align-center", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }), xt.DefineIcon("align-justify", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }), xt.RegisterCommand("align", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "Align Center", right: "Align Right", justify: "Align Justify"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.align.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="align"data-param1="\n        '.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("align-".concat(n)), '<span class="fr-sr-only">\n        ').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.align.apply(t)
    },
    refresh: function (e) {
      this.align.refresh(e)
    },
    refreshOnShow: function (e, t) {
      this.align.refreshOnShow(e, t)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignLeft", {
    type: "button", icon: "align-left", title: "Align Left", callback: function () {
      this.align.apply("left")
    }, refresh: function (e) {
      this.align.refreshForToolbar(e)
    }, plugin: "align"
  }), xt.RegisterCommand("alignRight", {
    type: "button",
    icon: "align-right",
    title: "Align Right",
    callback: function () {
      this.align.apply("right")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignCenter", {
    type: "button",
    icon: "align-center",
    title: "Align Center",
    callback: function () {
      this.align.apply("center")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignJustify", {
    type: "button",
    icon: "align-justify",
    title: "Align Justify",
    callback: function () {
      this.align.apply("justify")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), Object.assign(xt.DEFAULTS, {charCounterMax: -1, charCounterCount: !0}), xt.PLUGINS.charCounter = function (n) {
    var r, t = n.$, a = function a() {
      return (n.el.textContent || "").replace(/\u200B/g, "").length
    };

    function e(e) {
      if (n.opts.charCounterMax < 0) return !0;
      if (a() < n.opts.charCounterMax) return !0;
      var t = e.which;
      return !(!n.keys.ctrlKey(e) && n.keys.isCharacter(t) || t === xt.KEYCODE.IME) || (e.preventDefault(), e.stopPropagation(), n.events.trigger("charCounter.exceeded"), !1)
    }

    function o(e) {
      return n.opts.charCounterMax < 0 ? e : t("<div>").html(e).text().length + a() <= n.opts.charCounterMax ? e : (n.events.trigger("charCounter.exceeded"), "")
    }

    function i() {
      if (n.opts.charCounterCount) {
        var e = a() + (0 < n.opts.charCounterMax ? "/" + n.opts.charCounterMax : "");
        r.text("".concat(n.language.translate("Characters"), " : ").concat(e)), n.opts.toolbarBottom && r.css("margin-bottom", n.$tb.outerHeight(!0));
        var t = n.$wp.get(0).offsetWidth - n.$wp.get(0).clientWidth;
        0 <= t && ("rtl" == n.opts.direction ? r.css("margin-left", t) : r.css("margin-right", t))
      }
    }

    return {
      _init: function s() {
        return !!n.$wp && !!n.opts.charCounterCount && ((r = t(document.createElement("span")).attr("class", "fr-counter")).css("bottom", n.$wp.css("border-bottom-width")), n.$second_tb ? n.$second_tb.append(r) : n.$wp.append(r), n.events.on("keydown", e, !0), n.events.on("paste.afterCleanup", o), n.events.on("keyup contentChanged input", function () {
          n.events.trigger("charCounter.update")
        }), n.events.on("charCounter.update", i), n.events.trigger("charCounter.update"), void n.events.on("destroy", function () {
          t(n.o_win).off("resize.char".concat(n.id)), r.removeData().remove(), r = null
        }))
      }, count: a
    }
  }, xt.PLUGINS.codeBeautifier = function () {
    var e, t, n, r, j = {};

    function x(r, e) {
      var t = {"@page": !0, "@font-face": !0, "@keyframes": !0, "@media": !0, "@supports": !0, "@document": !0},
        n = {"@media": !0, "@supports": !0, "@document": !0};
      e = e || {}, r = (r = r || "").replace(/\r\n|[\r\u2028\u2029]/g, "\n");
      var a = e.indent_size || 4, o = e.indent_char || " ",
        i = e.selector_separator_newline === undefined || e.selector_separator_newline,
        s = e.end_with_newline !== undefined && e.end_with_newline,
        l = e.newline_between_rules === undefined || e.newline_between_rules, c = e.eol ? e.eol : "\n";
      "string" == typeof a && (a = parseInt(a, 10)), e.indent_with_tabs && (o = "\t", a = 1), c = c.replace(/\\r/, "\r").replace(/\\n/, "\n");
      var d, f = /^\s+$/, p = -1, u = 0;

      function h() {
        return (d = r.charAt(++p)) || ""
      }

      function g(e) {
        var t, n = p;
        return e && v(), t = r.charAt(p + 1) || "", p = n - 1, h(), t
      }

      function m(e) {
        for (var t = p; h();) if ("\\" === d) h(); else {
          if (-1 !== e.indexOf(d)) break;
          if ("\n" === d) break
        }
        return r.substring(t, p + 1)
      }

      function v() {
        for (var e = ""; f.test(g());) h(), e += d;
        return e
      }

      function b() {
        var e = "";
        for (d && f.test(d) && (e = d); f.test(h());) e += d;
        return e
      }

      function C(e) {
        var t = p;
        for (e = "/" === g(), h(); h();) {
          if (!e && "*" === d && "/" === g()) {
            h();
            break
          }
          if (e && "\n" === d) return r.substring(t, p)
        }
        return r.substring(t, p) + d
      }

      function E(e) {
        return r.substring(p - e.length, p).toLowerCase() === e
      }

      function y() {
        for (var e = 0, t = p + 1; t < r.length; t++) {
          var n = r.charAt(t);
          if ("{" === n) return !0;
          if ("(" === n) e += 1; else if (")" === n) {
            if (0 === e) return !1;
            e -= 1
          } else if (" " === n || "}" === n) return !1
        }
        return !1
      }

      var L = r.match(/^[\t ]*/)[0], _ = new Array(a + 1).join(o), w = 0, A = 0;
      for (var T, S, k, x = {
        "{": function (e) {
          x.singleSpace(), R.push(e), x.newLine()
        }, "}": function (e) {
          x.newLine(), R.push(e), x.newLine()
        }, _lastCharWhitespace: function () {
          return f.test(R[R.length - 1])
        }, newLine: function (e) {
          R.length && (e || "\n" === R[R.length - 1] || x.trim(), R.push("\n"), L && R.push(L))
        }, singleSpace: function () {
          R.length && !x._lastCharWhitespace() && R.push(" ")
        }, preserveSingleSpace: function () {
          T && x.singleSpace()
        }, trim: function () {
          for (; x._lastCharWhitespace();) R.pop()
        }
      }, R = [], M = !1, O = !1, N = !1, I = "", D = ""; ;) {
        var B = b();
        T = "" !== B;
        var H = -1 !== B.indexOf("\n");
        if (D = I, !(I = d)) break;
        if ("/" === d && "*" === g()) {
          var $ = 0 === w;
          (H || $) && x.newLine(), R.push(C()), x.newLine(), $ && x.newLine(!0)
        } else if ("/" === d && "/" === g()) H || "{" === D || x.trim(), x.singleSpace(), R.push(C()), x.newLine(); else if ("@" === d) {
          x.preserveSingleSpace(), R.push(d);
          var F = (void 0, S = p, k = m(": , {}()[]/='\""), p = S - 1, h(), k);
          F.match(/[ :]$/) && (h(), F = m(": ").replace(/\s$/, ""), R.push(F), x.singleSpace()), (F = F.replace(/\s$/, "")) in t && (A += 1, F in n && (N = !0))
        } else "#" === d && "{" === g() ? (x.preserveSingleSpace(), R.push(m("}"))) : "{" === d ? "}" === g(!0) ? (v(), h(), x.singleSpace(), R.push("{}"), x.newLine(), l && 0 === w && x.newLine(!0)) : (w++, L += _, x["{"](d), M = N ? (N = !1, A < w) : A <= w) : "}" === d ? (w--, L = L.slice(0, -a), x["}"](d), O = M = !1, A && A--, l && 0 === w && x.newLine(!0)) : ":" === d ? (v(), !M && !N || E("&") || y() ? ":" === g() ? (h(), R.push("::")) : R.push(":") : (O = !0, R.push(":"), x.singleSpace())) : '"' === d || "'" === d ? (x.preserveSingleSpace(), R.push(m(d))) : " " === d ? (O = !1, R.push(d), x.newLine()) : "(" === d ? E("url") ? (R.push(d), v(), h() && (")" !== d && '"' !== d && "'" !== d ? R.push(m(")")) : p--)) : (u++, x.preserveSingleSpace(), R.push(d), v()) : ")" === d ? (R.push(d), u--) : "," === d ? (R.push(d), v(), i && !O && u < 1 ? x.newLine() : x.singleSpace()) : ("]" === d || ("[" === d ? x.preserveSingleSpace() : "=" === d ? (v(), d = "=") : x.preserveSingleSpace()), R.push(d))
      }
      var P = "";
      return L && (P += L), P += R.join("").replace(/[\r\n\t ]+$/, ""), s && (P += "\n"), "\n" != c && (P = P.replace(/[\n]/g, c)), P
    }

    function q(e, t) {
      for (var n = 0; n < t.length; n += 1) if (t[n] === e) return !0;
      return !1
    }

    function Z(e) {
      return e.replace(/^\s+|\s+$/g, "")
    }

    function R(e, t) {
      return new a(e, t).beautify()
    }

    e = j, t = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc", n = new RegExp("[".concat(t, "]")), r = new RegExp("[".concat(t, " ").concat("\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f", "]")), e.newline = /[\n\r\u2028\u2029]/, e.lineBreak = new RegExp("\r\n|".concat(e.newline.source)), e.allLineBreaks = new RegExp(e.lineBreak.source, "g"), e.isIdentifierStart = function (e) {
      return e < 65 ? 36 === e || 64 === e : e < 91 || (e < 97 ? 95 === e : e < 123 || 170 <= e && n.test(String.fromCharCode(e)))
    }, e.isIdentifierChar = function (e) {
      return e < 48 ? 36 === e : e < 58 || !(e < 65) && (e < 91 || (e < 97 ? 95 === e : e < 123 || 170 <= e && r.test(String.fromCharCode(e))))
    };
    var X = {
      BlockStatement: "BlockStatement",
      Statement: "Statement",
      ObjectLiteral: "ObjectLiteral",
      ArrayLiteral: "ArrayLiteral",
      ForInitializer: "ForInitializer",
      Conditional: "Conditional",
      Expression: "Expression"
    };

    function a(r, e) {
      var c, a, o, d, i, s, l, f, p, t, n, u, h, g = [], m = "";

      function v(e, t) {
        var n = 0;
        return e && (n = e.indentation_level, !c.just_added_newline() && e.line_indent_level > n && (n = e.line_indent_level)), {
          mode: t,
          parent: e,
          last_text: e ? e.last_text : "",
          last_word: e ? e.last_word : "",
          declaration_statement: !1,
          declaration_assignment: !1,
          multiline_frame: !1,
          if_block: !1,
          else_block: !1,
          do_block: !1,
          do_while: !1,
          in_case_statement: !1,
          in_case: !1,
          case_body: !1,
          indentation_level: n,
          line_indent_level: e ? e.line_indent_level : n,
          start_line_index: c.get_line_number(),
          ternary_depth: 0
        }
      }

      for (u = {
        TK_START_EXPR: function I() {
          R();
          var e = X.Expression;
          if ("[" === d.text) {
            if ("TK_WORD" === i || ")" === f.last_text) return "TK_RESERVED" === i && q(f.last_text, o.line_starters) && (c.space_before_token = !0), A(e), _(), w(), void (h.space_in_paren && (c.space_before_token = !0));
            e = X.ArrayLiteral, T(f.mode) && ("[" !== f.last_text && ("," !== f.last_text || "]" !== s && "}" !== s) || h.keep_array_indentation || y())
          } else "TK_RESERVED" === i && "for" === f.last_text ? e = X.ForInitializer : "TK_RESERVED" === i && q(f.last_text, ["if", "while"]) && (e = X.Conditional);
          " " === f.last_text || "TK_START_BLOCK" === i ? y() : "TK_END_EXPR" === i || "TK_START_EXPR" === i || "TK_END_BLOCK" === i || "." === f.last_text ? E(d.wanted_newline) : "TK_RESERVED" === i && "(" === d.text || "TK_WORD" === i || "TK_OPERATOR" === i ? "TK_RESERVED" === i && ("function" === f.last_word || "typeof" === f.last_word) || "*" === f.last_text && "function" === s ? h.space_after_anon_function && (c.space_before_token = !0) : "TK_RESERVED" !== i || !q(f.last_text, o.line_starters) && "catch" !== f.last_text || h.space_before_conditional && (c.space_before_token = !0) : c.space_before_token = !0;
          "(" === d.text && "TK_RESERVED" === i && "await" === f.last_word && (c.space_before_token = !0);
          "(" === d.text && ("TK_EQUALS" !== i && "TK_OPERATOR" !== i || x() || E());
          A(e), _(), h.space_in_paren && (c.space_before_token = !0);
          w()
        }, TK_END_EXPR: function D() {
          for (; f.mode === X.Statement;) k();
          f.multiline_frame && E("]" === d.text && T(f.mode) && !h.keep_array_indentation);
          h.space_in_paren && ("TK_START_EXPR" !== i || h.space_in_empty_paren ? c.space_before_token = !0 : (c.trim(), c.space_before_token = !1));
          "]" === d.text && h.keep_array_indentation ? (_(), k()) : (k(), _());
          c.remove_redundant_indentation(p), f.do_while && p.mode === X.Conditional && (p.mode = X.Expression, f.do_block = !1, f.do_while = !1)
        }, TK_START_BLOCK: function B() {
          var e = O(1), t = O(2);
          t && (":" === t.text && q(e.type, ["TK_STRING", "TK_WORD", "TK_RESERVED"]) || q(e.text, ["get", "set"]) && q(t.type, ["TK_WORD", "TK_RESERVED"])) ? q(s, ["class", "interface"]) ? A(X.BlockStatement) : A(X.ObjectLiteral) : A(X.BlockStatement);
          var n = !e.comments_before.length && "}" === e.text && "function" === f.last_word && "TK_END_EXPR" === i;
          "expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? "TK_OPERATOR" !== i && (n || "TK_EQUALS" === i || "TK_RESERVED" === i && M(f.last_text) && "else" !== f.last_text) ? c.space_before_token = !0 : y(!1, !0) : "TK_OPERATOR" !== i && "TK_START_EXPR" !== i ? "TK_START_BLOCK" === i ? y() : c.space_before_token = !0 : T(p.mode) && "," === f.last_text && ("}" === s ? c.space_before_token = !0 : y());
          _(), w()
        }, TK_END_BLOCK: function H() {
          for (; f.mode === X.Statement;) k();
          var e = "TK_START_BLOCK" === i;
          "expand" === h.brace_style ? e || y() : e || (T(f.mode) && h.keep_array_indentation ? (h.keep_array_indentation = !1, y(), h.keep_array_indentation = !0) : y());
          k(), _()
        }, TK_WORD: N, TK_RESERVED: N, TK_SEMICOLON: function $() {
          R() && (c.space_before_token = !1);
          for (; f.mode === X.Statement && !f.if_block && !f.do_block;) k();
          _()
        }, TK_STRING: function F() {
          R() ? c.space_before_token = !0 : "TK_RESERVED" === i || "TK_WORD" === i ? c.space_before_token = !0 : "TK_COMMA" === i || "TK_START_EXPR" === i || "TK_EQUALS" === i || "TK_OPERATOR" === i ? x() || E() : y();
          _()
        }, TK_EQUALS: function P() {
          R();
          f.declaration_statement && (f.declaration_assignment = !0);
          c.space_before_token = !0, _(), c.space_before_token = !0
        }, TK_OPERATOR: function U() {
          R();
          if ("TK_RESERVED" === i && M(f.last_text)) return c.space_before_token = !0, void _();
          if ("*" === d.text && "TK_DOT" === i) return void _();
          if (":" === d.text && f.in_case) return f.case_body = !0, w(), _(), y(), void (f.in_case = !1);
          if ("::" === d.text) return void _();
          "TK_OPERATOR" === i && E();
          var e = !0, t = !0;
          q(d.text, ["--", "++", "!", "~"]) || q(d.text, ["-", "+"]) && (q(i, ["TK_START_BLOCK", "TK_START_EXPR", "TK_EQUALS", "TK_OPERATOR"]) || q(f.last_text, o.line_starters) || "," === f.last_text) ? (t = e = !1, !d.wanted_newline || "--" !== d.text && "++" !== d.text || y(!1, !0), " " === f.last_text && S(f.mode) && (e = !0), "TK_RESERVED" === i ? e = !0 : "TK_END_EXPR" === i ? e = !("]" === f.last_text && ("--" === d.text || "++" === d.text)) : "TK_OPERATOR" === i && (e = q(d.text, ["--", "-", "++", "+"]) && q(f.last_text, ["--", "-", "++", "+"]), q(d.text, ["+", "-"]) && q(f.last_text, ["--", "++"]) && (t = !0)), f.mode !== X.BlockStatement && f.mode !== X.Statement || "{" !== f.last_text && " " !== f.last_text || y()) : ":" === d.text ? 0 === f.ternary_depth ? e = !1 : f.ternary_depth -= 1 : "?" === d.text ? f.ternary_depth += 1 : "*" === d.text && "TK_RESERVED" === i && "function" === f.last_text && (t = e = !1);
          c.space_before_token = c.space_before_token || e, _(), c.space_before_token = t
        }, TK_COMMA: function z() {
          if (f.declaration_statement) return S(f.parent.mode) && (f.declaration_assignment = !1), _(), void (f.declaration_assignment ? y(f.declaration_assignment = !1, !0) : (c.space_before_token = !0, h.comma_first && E()));
          _(), f.mode === X.ObjectLiteral || f.mode === X.Statement && f.parent.mode === X.ObjectLiteral ? (f.mode === X.Statement && k(), y()) : (c.space_before_token = !0, h.comma_first && E())
        }, TK_BLOCK_COMMENT: function K() {
          if (c.raw) return c.add_raw_token(d), void (d.directives && "end" === d.directives.preserve && (h.test_output_raw || (c.raw = !1)));
          if (d.directives) return y(!1, !0), _(), "start" === d.directives.preserve && (c.raw = !0), void y(!1, !0);
          if (!j.newline.test(d.text) && !d.wanted_newline) return c.space_before_token = !0, _(), void (c.space_before_token = !0);
          var e, t = function i(e) {
            var t;
            e = e.replace(/\x0d/g, "");
            var n = [];
            t = e.indexOf("\n");
            for (; -1 !== t;) n.push(e.substring(0, t)), e = e.substring(t + 1), t = e.indexOf("\n");
            e.length && n.push(e);
            return n
          }(d.text), n = !1, r = !1, a = d.whitespace_before, o = a.length;
          y(!1, !0), 1 < t.length && (!function s(e, t) {
            for (var n = 0; n < e.length; n++) {
              var r = Z(e[n]);
              if (r.charAt(0) !== t) return !1
            }
            return !0
          }(t.slice(1), "*") ? function l(e, t) {
            for (var n, r = 0, a = e.length; r < a; r++) if ((n = e[r]) && 0 !== n.indexOf(t)) return !1;
            return !0
          }(t.slice(1), a) && (r = !0) : n = !0);
          for (_(t[0]), e = 1; e < t.length; e++) y(!1, !0), n ? _(" ".concat(t[e].replace(/^\s+/g, ""))) : r && t[e].length > o ? _(t[e].substring(o)) : c.add_token(t[e]);
          y(!1, !0)
        }, TK_COMMENT: function V() {
          d.wanted_newline ? y(!1, !0) : c.trim(!0);
          c.space_before_token = !0, _(), y(!1, !0)
        }, TK_DOT: function W() {
          R();
          "TK_RESERVED" === i && M(f.last_text) ? c.space_before_token = !0 : E(")" === f.last_text && h.break_chained_methods);
          _()
        }, TK_UNKNOWN: function G() {
          _(), "\n" === d.text[d.text.length - 1] && y()
        }, TK_EOF: function Y() {
          for (; f.mode === X.Statement;) k()
        }
      }, h = {}, (e = e || {}).braces_on_own_line !== undefined && (h.brace_style = e.braces_on_own_line ? "expand" : "collapse"), h.brace_style = e.brace_style ? e.brace_style : h.brace_style ? h.brace_style : "collapse", "expand-strict" === h.brace_style && (h.brace_style = "expand"), h.indent_size = e.indent_size ? parseInt(e.indent_size, 10) : 4, h.indent_char = e.indent_char ? e.indent_char : " ", h.eol = e.eol ? e.eol : "\n", h.preserve_newlines = e.preserve_newlines === undefined || e.preserve_newlines, h.break_chained_methods = e.break_chained_methods !== undefined && e.break_chained_methods, h.max_preserve_newlines = e.max_preserve_newlines === undefined ? 0 : parseInt(e.max_preserve_newlines, 10), h.space_in_paren = e.space_in_paren !== undefined && e.space_in_paren, h.space_in_empty_paren = e.space_in_empty_paren !== undefined && e.space_in_empty_paren, h.jslint_happy = e.jslint_happy !== undefined && e.jslint_happy, h.space_after_anon_function = e.space_after_anon_function !== undefined && e.space_after_anon_function, h.keep_array_indentation = e.keep_array_indentation !== undefined && e.keep_array_indentation, h.space_before_conditional = e.space_before_conditional === undefined || e.space_before_conditional, h.unescape_strings = e.unescape_strings !== undefined && e.unescape_strings, h.wrap_line_length = e.wrap_line_length === undefined ? 0 : parseInt(e.wrap_line_length, 10), h.e4x = e.e4x !== undefined && e.e4x, h.end_with_newline = e.end_with_newline !== undefined && e.end_with_newline, h.comma_first = e.comma_first !== undefined && e.comma_first, h.test_output_raw = e.test_output_raw !== undefined && e.test_output_raw, h.jslint_happy && (h.space_after_anon_function = !0), e.indent_with_tabs && (h.indent_char = "\t", h.indent_size = 1), h.eol = h.eol.replace(/\\r/, "\r").replace(/\\n/, "\n"), l = ""; 0 < h.indent_size;) l += h.indent_char, h.indent_size -= 1;
      var b = 0;
      if (r && r.length) {
        for (; " " === r.charAt(b) || "\t" === r.charAt(b);) m += r.charAt(b), b += 1;
        r = r.substring(b)
      }

      function C(e) {
        var t = e.newlines;
        if (h.keep_array_indentation && T(f.mode)) for (var n = 0; n < t; n += 1) y(0 < n); else if (h.max_preserve_newlines && t > h.max_preserve_newlines && (t = h.max_preserve_newlines), h.preserve_newlines && 1 < e.newlines) {
          y();
          for (var r = 1; r < t; r += 1) y(!0)
        }
        u[(d = e).type]()
      }

      function E(e) {
        if (e = e !== undefined && e, !c.just_added_newline()) if (h.preserve_newlines && d.wanted_newline || e) y(!1, !0); else if (h.wrap_line_length) {
          c.current_line.get_character_count() + d.text.length + (c.space_before_token ? 1 : 0) >= h.wrap_line_length && y(!1, !0)
        }
      }

      function y(e, t) {
        if (!t && " " !== f.last_text && "," !== f.last_text && "=" !== f.last_text && "TK_OPERATOR" !== i) for (; f.mode === X.Statement && !f.if_block && !f.do_block;) k();
        c.add_new_line(e) && (f.multiline_frame = !0)
      }

      function L() {
        c.just_added_newline() && (h.keep_array_indentation && T(f.mode) && d.wanted_newline ? (c.current_line.push(d.whitespace_before), c.space_before_token = !1) : c.set_indent(f.indentation_level) && (f.line_indent_level = f.indentation_level))
      }

      function _(e) {
        c.raw ? c.add_raw_token(d) : (h.comma_first && "TK_COMMA" === i && c.just_added_newline() && "," === c.previous_line.last() && (c.previous_line.pop(), L(), c.add_token(","), c.space_before_token = !0), e = e || d.text, L(), c.add_token(e))
      }

      function w() {
        f.indentation_level += 1
      }

      function A(e) {
        p = f ? (t.push(f), f) : v(null, e), f = v(p, e)
      }

      function T(e) {
        return e === X.ArrayLiteral
      }

      function S(e) {
        return q(e, [X.Expression, X.ForInitializer, X.Conditional])
      }

      function k() {
        0 < t.length && (p = f, f = t.pop(), p.mode === X.Statement && c.remove_redundant_indentation(p))
      }

      function x() {
        return f.parent.mode === X.ObjectLiteral && f.mode === X.Statement && (":" === f.last_text && 0 === f.ternary_depth || "TK_RESERVED" === i && q(f.last_text, ["get", "set"]))
      }

      function R() {
        return !!("TK_RESERVED" === i && q(f.last_text, ["const", "let", "const"]) && "TK_WORD" === d.type || "TK_RESERVED" === i && "do" === f.last_text || "TK_RESERVED" === i && "return" === f.last_text && !d.wanted_newline || "TK_RESERVED" === i && "else" === f.last_text && ("TK_RESERVED" !== d.type || "if" !== d.text) || "TK_END_EXPR" === i && (p.mode === X.ForInitializer || p.mode === X.Conditional) || "TK_WORD" === i && f.mode === X.BlockStatement && !f.in_case && "--" !== d.text && "++" !== d.text && "function" !== s && "TK_WORD" !== d.type && "TK_RESERVED" !== d.type || f.mode === X.ObjectLiteral && (":" === f.last_text && 0 === f.ternary_depth || "TK_RESERVED" === i && q(f.last_text, ["get", "set"]))) && (A(X.Statement), w(), "TK_RESERVED" === i && q(f.last_text, ["const", "let", "const"]) && "TK_WORD" === d.type && (f.declaration_statement = !0), x() || E("TK_RESERVED" === d.type && q(d.text, ["do", "for", "if", "while"])), !0)
      }

      function M(e) {
        return q(e, ["case", "return", "do", "if", "throw", "else"])
      }

      function O(e) {
        var t = a + (e || 0);
        return t < 0 || t >= g.length ? null : g[t]
      }

      function N() {
        ("TK_RESERVED" === d.type && f.mode !== X.ObjectLiteral && q(d.text, ["set", "get"]) && (d.type = "TK_WORD"), "TK_RESERVED" === d.type && f.mode === X.ObjectLiteral) && (":" === O(1).text && (d.type = "TK_WORD"));
        if (R() || !d.wanted_newline || S(f.mode) || "TK_OPERATOR" === i && "--" !== f.last_text && "++" !== f.last_text || "TK_EQUALS" === i || !h.preserve_newlines && "TK_RESERVED" === i && q(f.last_text, ["const", "let", "const", "set", "get"]) || y(), f.do_block && !f.do_while) {
          if ("TK_RESERVED" === d.type && "while" === d.text) return c.space_before_token = !0, _(), c.space_before_token = !0, void (f.do_while = !0);
          y(), f.do_block = !1
        }
        if (f.if_block) if (f.else_block || "TK_RESERVED" !== d.type || "else" !== d.text) {
          for (; f.mode === X.Statement;) k();
          f.if_block = !1, f.else_block = !1
        } else f.else_block = !0;
        if ("TK_RESERVED" === d.type && ("case" === d.text || "default" === d.text && f.in_case_statement)) return y(), (f.case_body || h.jslint_happy) && (!function e() {
          0 < f.indentation_level && (!f.parent || f.indentation_level > f.parent.indentation_level) && (f.indentation_level -= 1)
        }(), f.case_body = !1), _(), f.in_case = !0, void (f.in_case_statement = !0);
        if ("TK_RESERVED" === d.type && "function" === d.text && ((q(f.last_text, ["}", " "]) || c.just_added_newline() && !q(f.last_text, ["[", "{", ":", "=", ","])) && (c.just_added_blankline() || d.comments_before.length || (y(), y(!0))), "TK_RESERVED" === i || "TK_WORD" === i ? "TK_RESERVED" === i && q(f.last_text, ["get", "set", "new", "return", "export", "async"]) ? c.space_before_token = !0 : "TK_RESERVED" === i && "default" === f.last_text && "export" === s ? c.space_before_token = !0 : y() : "TK_OPERATOR" === i || "=" === f.last_text ? c.space_before_token = !0 : (f.multiline_frame || !S(f.mode) && !T(f.mode)) && y()), "TK_COMMA" !== i && "TK_START_EXPR" !== i && "TK_EQUALS" !== i && "TK_OPERATOR" !== i || x() || E(), "TK_RESERVED" === d.type && q(d.text, ["function", "get", "set"])) return _(), void (f.last_word = d.text);
        (n = "NONE", "TK_END_BLOCK" === i ? "TK_RESERVED" === d.type && q(d.text, ["else", "catch", "finally"]) ? "expand" === h.brace_style || "end-expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? n = "NEWLINE" : (n = "SPACE", c.space_before_token = !0) : n = "NEWLINE" : "TK_SEMICOLON" === i && f.mode === X.BlockStatement ? n = "NEWLINE" : "TK_SEMICOLON" === i && S(f.mode) ? n = "SPACE" : "TK_STRING" === i ? n = "NEWLINE" : "TK_RESERVED" === i || "TK_WORD" === i || "*" === f.last_text && "function" === s ? n = "SPACE" : "TK_START_BLOCK" === i ? n = "NEWLINE" : "TK_END_EXPR" === i && (c.space_before_token = !0, n = "NEWLINE"), "TK_RESERVED" === d.type && q(d.text, o.line_starters) && ")" !== f.last_text && (n = "else" === f.last_text || "export" === f.last_text ? "SPACE" : "NEWLINE"), "TK_RESERVED" === d.type && q(d.text, ["else", "catch", "finally"])) ? "TK_END_BLOCK" !== i || "expand" === h.brace_style || "end-expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? y() : (c.trim(!0), "}" !== c.current_line.last() && y(), c.space_before_token = !0) : "NEWLINE" === n ? "TK_RESERVED" === i && M(f.last_text) ? c.space_before_token = !0 : "TK_END_EXPR" !== i ? "TK_START_EXPR" === i && "TK_RESERVED" === d.type && q(d.text, ["const", "let", "const"]) || ":" === f.last_text || ("TK_RESERVED" === d.type && "if" === d.text && "else" === f.last_text ? c.space_before_token = !0 : y()) : "TK_RESERVED" === d.type && q(d.text, o.line_starters) && ")" !== f.last_text && y() : f.multiline_frame && T(f.mode) && "," === f.last_text && "}" === s ? y() : "SPACE" === n && (c.space_before_token = !0);
        _(), f.last_word = d.text, "TK_RESERVED" === d.type && "do" === d.text && (f.do_block = !0), "TK_RESERVED" === d.type && "if" === d.text && (f.if_block = !0)
      }

      i = "TK_START_BLOCK", s = "", (c = new Q(l, m)).raw = h.test_output_raw, t = [], A(X.BlockStatement), this.beautify = function () {
        var e, t;
        for (o = new ee(r, h, l), g = o.tokenize(), a = 0; e = O();) {
          for (var n = 0; n < e.comments_before.length; n++) C(e.comments_before[n]);
          C(e), s = f.last_text, i = e.type, f.last_text = e.text, a += 1
        }
        return t = c.get_code(), h.end_with_newline && (t += "\n"), "\n" != h.eol && (t = t.replace(/[\n]/g, h.eol)), t
      }
    }

    function o(t) {
      var n = 0, r = -1, a = [], o = !0;
      this.set_indent = function (e) {
        n = t.baseIndentLength + e * t.indent_length, r = e
      }, this.get_character_count = function () {
        return n
      }, this.is_empty = function () {
        return o
      }, this.last = function () {
        return this._empty ? null : a[a.length - 1]
      }, this.push = function (e) {
        a.push(e), n += e.length, o = !1
      }, this.pop = function () {
        var e = null;
        return o || (e = a.pop(), n -= e.length, o = 0 === a.length), e
      }, this.remove_indent = function () {
        0 < r && (r -= 1, n -= t.indent_length)
      }, this.trim = function () {
        for (; " " === this.last();) a.pop(), n -= 1;
        o = 0 === a.length
      }, this.toString = function () {
        var e = "";
        return this._empty || (0 <= r && (e = t.indent_cache[r]), e += a.join("")), e
      }
    }

    function Q(t, n) {
      n = n || "", this.indent_cache = [n], this.baseIndentLength = n.length, this.indent_length = t.length, this.raw = !1;
      var r = [];
      this.baseIndentString = n, this.indent_string = t, this.previous_line = null, this.current_line = null, this.space_before_token = !1, this.add_outputline = function () {
        this.previous_line = this.current_line, this.current_line = new o(this), r.push(this.current_line)
      }, this.add_outputline(), this.get_line_number = function () {
        return r.length
      }, this.add_new_line = function (e) {
        return (1 !== this.get_line_number() || !this.just_added_newline()) && (!(!e && this.just_added_newline()) && (this.raw || this.add_outputline(), !0))
      }, this.get_code = function () {
        return r.join("\n").replace(/[\r\n\t ]+$/, "")
      }, this.set_indent = function (e) {
        if (1 < r.length) {
          for (; e >= this.indent_cache.length;) this.indent_cache.push(this.indent_cache[this.indent_cache.length - 1] + this.indent_string);
          return this.current_line.set_indent(e), !0
        }
        return this.current_line.set_indent(0), !1
      }, this.add_raw_token = function (e) {
        for (var t = 0; t < e.newlines; t++) this.add_outputline();
        this.current_line.push(e.whitespace_before), this.current_line.push(e.text), this.space_before_token = !1
      }, this.add_token = function (e) {
        this.add_space_before_token(), this.current_line.push(e)
      }, this.add_space_before_token = function () {
        this.space_before_token && !this.just_added_newline() && this.current_line.push(" "), this.space_before_token = !1
      }, this.remove_redundant_indentation = function (e) {
        if (!e.multiline_frame && e.mode !== X.ForInitializer && e.mode !== X.Conditional) for (var t = e.start_line_index, n = r.length; t < n;) r[t].remove_indent(), t++
      }, this.trim = function (e) {
        for (e = e !== undefined && e, this.current_line.trim(t, n); e && 1 < r.length && this.current_line.is_empty();) r.pop(), this.current_line = r[r.length - 1], this.current_line.trim();
        this.previous_line = 1 < r.length ? r[r.length - 2] : null
      }, this.just_added_newline = function () {
        return this.current_line.is_empty()
      }, this.just_added_blankline = function () {
        return !!this.just_added_newline() && (1 === r.length || r[r.length - 2].is_empty())
      }
    }

    var J = function J(e, t, n, r, a, o) {
      this.type = e, this.text = t, this.comments_before = [], this.newlines = n || 0, this.wanted_newline = 0 < n, this.whitespace_before = r || "", this.parent = null, this.directives = null
    };

    function ee(k, x, e) {
      var R = "\n\r\t ".split(""), M = /[0-9]/, O = /[01234567]/, N = /[0123456789abcdefABCDEF]/,
        I = "+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>".split(" ");
      this.line_starters = "continue,try,throw,return,const,let,const,if,switch,case,default,for,while,break,function,import,export".split(",");
      var D, B, H, $, F, P,
        U = this.line_starters.concat(["do", "in", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await"]),
        z = /([\s\S]*?)((?:\*\/)|$)/g, K = /([^\n\r\u2028\u2029]*)/g, V = /\/\* beautify( \w+[:]\w+)+ \*\//g,
        W = / (\w+)[:](\w+)/g, G = /([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g,
        Y = /((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;

      function i() {
        var e, t, n = [];
        if (D = 0, B = "", P <= F) return ["", "TK_EOF"];
        t = $.length ? $[$.length - 1] : new J("TK_START_BLOCK", "{");
        var r = k.charAt(F);
        for (F += 1; q(r, R);) {
          if (j.newline.test(r) ? "\n" === r && "\r" === k.charAt(F - 2) || (D += 1, n = []) : n.push(r), P <= F) return ["", "TK_EOF"];
          r = k.charAt(F), F += 1
        }
        if (n.length && (B = n.join("")), M.test(r)) {
          var a = !0, o = !0, i = M;
          for ("0" === r && F < P && /[Xxo]/.test(k.charAt(F)) ? (o = a = !1, r += k.charAt(F), F += 1, i = /[o]/.test(k.charAt(F)) ? O : N) : (r = "", F -= 1); F < P && i.test(k.charAt(F));) r += k.charAt(F), F += 1, a && F < P && "." === k.charAt(F) && (r += k.charAt(F), F += 1, a = !1), o && F < P && /[Ee]/.test(k.charAt(F)) && (r += k.charAt(F), (F += 1) < P && /[+-]/.test(k.charAt(F)) && (r += k.charAt(F), F += 1), a = o = !1);
          return [r, "TK_WORD"]
        }
        if (j.isIdentifierStart(k.charCodeAt(F - 1))) {
          if (F < P) for (; j.isIdentifierChar(k.charCodeAt(F)) && (r += k.charAt(F), (F += 1) !== P);) ;
          return "TK_DOT" === t.type || "TK_RESERVED" === t.type && q(t.text, ["set", "get"]) || !q(r, U) ? [r, "TK_WORD"] : "in" === r ? [r, "TK_OPERATOR"] : [r, "TK_RESERVED"]
        }
        if ("(" === r || "[" === r) return [r, "TK_START_EXPR"];
        if (")" === r || "]" === r) return [r, "TK_END_EXPR"];
        if ("{" === r) return [r, "TK_START_BLOCK"];
        if ("}" === r) return [r, "TK_END_BLOCK"];
        if (" " === r) return [r, "TK_SEMICOLON"];
        if ("/" === r) {
          var s = "";
          if ("*" === k.charAt(F)) {
            F += 1, z.lastIndex = F;
            var l = z.exec(k);
            s = "/*".concat(l[0]), F += l[0].length;
            var c = function T(e) {
              if (!e.match(V)) return null;
              var t = {};
              W.lastIndex = 0;
              for (var n = W.exec(e); n;) t[n[1]] = n[2], n = W.exec(e);
              return t
            }(s);
            return c && "start" === c.ignore && (G.lastIndex = F, s += (l = G.exec(k))[0], F += l[0].length), [s = s.replace(j.lineBreak, "\n"), "TK_BLOCK_COMMENT", c]
          }
          if ("/" === k.charAt(F)) {
            F += 1, K.lastIndex = F;
            var d = K.exec(k);
            return s = "//".concat(d[0]), F += d[0].length, [s, "TK_COMMENT"]
          }
        }
        if ("`" === r || "'" === r || '"' === r || ("/" === r || x.e4x && "<" === r && k.slice(F - 1).match(/^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/)) && ("TK_RESERVED" === t.type && q(t.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || "TK_END_EXPR" === t.type && ")" === t.text && t.parent && "TK_RESERVED" === t.parent.type && q(t.parent.text, ["if", "while", "for"]) || q(t.type, ["TK_COMMENT", "TK_START_EXPR", "TK_START_BLOCK", "TK_END_BLOCK", "TK_OPERATOR", "TK_EQUALS", "TK_EOF", "TK_SEMICOLON", "TK_COMMA"]))) {
          var f = r, p = !1, u = !1;
          if (e = r, "/" === f) for (var h = !1; F < P && (p || h || k.charAt(F) !== f) && !j.newline.test(k.charAt(F));) e += k.charAt(F), p ? p = !1 : (p = "\\" === k.charAt(F), "[" === k.charAt(F) ? h = !0 : "]" === k.charAt(F) && (h = !1)), F += 1; else if (x.e4x && "<" === f) {
            var g = /<(\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/g,
              m = k.slice(F - 1), v = g.exec(m);
            if (v && 0 === v.index) {
              for (var b = v[2], C = 0; v;) {
                var E = !!v[1], y = v[2], L = !!v[v.length - 1] || "![CDATA[" === y.slice(0, 8);
                if (y !== b || L || (E ? --C : ++C), C <= 0) break;
                v = g.exec(m)
              }
              var _ = v ? v.index + v[0].length : m.length;
              return m = m.slice(0, _), F += _ - 1, [m = m.replace(j.lineBreak, "\n"), "TK_STRING"]
            }
          } else for (; F < P && (p || k.charAt(F) !== f && ("`" === f || !j.newline.test(k.charAt(F))));) (p || "`" === f) && j.newline.test(k.charAt(F)) ? ("\r" === k.charAt(F) && "\n" === k.charAt(F + 1) && (F += 1), e += "\n") : e += k.charAt(F), p = p ? ("x" !== k.charAt(F) && "u" !== k.charAt(F) || (u = !0), !1) : "\\" === k.charAt(F), F += 1;
          if (u && x.unescape_strings && (e = function S(e) {
            var t, n = !1, r = "", a = 0, o = "", i = 0;
            for (; n || a < e.length;) if (t = e.charAt(a), a++, n) {
              if (n = !1, "x" === t) o = e.substr(a, 2), a += 2; else {
                if ("u" !== t) {
                  r += "\\".concat(t);
                  continue
                }
                o = e.substr(a, 4), a += 4
              }
              if (!o.match(/^[0123456789abcdefABCDEF]+$/)) return e;
              if (0 <= (i = parseInt(o, 16)) && i < 32) {
                r += "x" === t ? "\\x".concat(o) : "\\u".concat(o);
                continue
              }
              if (34 === i || 39 === i || 92 === i) r += "\\".concat(String.fromCharCode(i)); else {
                if ("x" === t && 126 < i && i <= 255) return e;
                r += String.fromCharCode(i)
              }
            } else "\\" === t ? n = !0 : r += t;
            return r
          }(e)), F < P && k.charAt(F) === f && (e += f, F += 1, "/" === f)) for (; F < P && j.isIdentifierStart(k.charCodeAt(F));) e += k.charAt(F), F += 1;
          return [e, "TK_STRING"]
        }
        if ("#" === r) {
          if (0 === $.length && "!" === k.charAt(F)) {
            for (e = r; F < P && "\n" !== r;) e += r = k.charAt(F), F += 1;
            return ["".concat(Z(e), "\n"), "TK_UNKNOWN"]
          }
          var w = "#";
          if (F < P && M.test(k.charAt(F))) {
            for (; w += r = k.charAt(F), (F += 1) < P && "#" !== r && "=" !== r;) ;
            return "#" === r || ("[" === k.charAt(F) && "]" === k.charAt(F + 1) ? (w += "[]", F += 2) : "{" === k.charAt(F) && "}" === k.charAt(F + 1) && (w += "{}", F += 2)), [w, "TK_WORD"]
          }
        }
        if ("<" === r && ("?" === k.charAt(F) || "%" === k.charAt(F))) {
          Y.lastIndex = F - 1;
          var A = Y.exec(k);
          if (A) return r = A[0], F += r.length - 1, [r = r.replace(j.lineBreak, "\n"), "TK_STRING"]
        }
        if ("<" === r && "\x3c!--" === k.substring(F - 1, F + 3)) {
          for (F += 3, r = "\x3c!--"; !j.newline.test(k.charAt(F)) && F < P;) r += k.charAt(F), F++;
          return H = !0, [r, "TK_COMMENT"]
        }
        if ("-" === r && H && "--\x3e" === k.substring(F - 1, F + 2)) return H = !1, F += 2, ["--\x3e", "TK_COMMENT"];
        if ("." === r) return [r, "TK_DOT"];
        if (q(r, I)) {
          for (; F < P && q(r + k.charAt(F), I) && (r += k.charAt(F), !(P <= (F += 1)));) ;
          return "," === r ? [r, "TK_COMMA"] : "=" === r ? [r, "TK_EQUALS"] : [r, "TK_OPERATOR"]
        }
        return [r, "TK_UNKNOWN"]
      }

      this.tokenize = function () {
        var e, t, n;
        P = k.length, F = 0, H = !1, $ = [];
        for (var r = null, a = [], o = []; !t || "TK_EOF" !== t.type;) {
          for (n = i(), e = new J(n[1], n[0], D, B); "TK_COMMENT" === e.type || "TK_BLOCK_COMMENT" === e.type || "TK_UNKNOWN" === e.type;) "TK_BLOCK_COMMENT" === e.type && (e.directives = n[2]), o.push(e), n = i(), e = new J(n[1], n[0], D, B);
          o.length && (e.comments_before = o, o = []), "TK_START_BLOCK" === e.type || "TK_START_EXPR" === e.type ? (e.parent = t, a.push(r), r = e) : ("TK_END_BLOCK" === e.type || "TK_END_EXPR" === e.type) && r && ("]" === e.text && "[" === r.text || ")" === e.text && "(" === r.text || "}" === e.text && "{" === r.text) && (e.parent = r.parent, r = a.pop()), $.push(e), t = e
        }
        return $
      }
    }

    return {
      run: function M(e, t) {
        function i(e) {
          return e.replace(/\s+$/g, "")
        }

        var n, r, a, m, o, s, v, l, c, b, C, E, d, f;
        for ((t = t || {}).wrap_line_length !== undefined && 0 !== parseInt(t.wrap_line_length, 10) || t.max_char === undefined || 0 === parseInt(t.max_char, 10) || (t.wrap_line_length = t.max_char), r = t.indent_inner_html !== undefined && t.indent_inner_html, a = t.indent_size === undefined ? 4 : parseInt(t.indent_size, 10), m = t.indent_char === undefined ? " " : t.indent_char, s = t.brace_style === undefined ? "collapse" : t.brace_style, o = 0 === parseInt(t.wrap_line_length, 10) ? 32786 : parseInt(t.wrap_line_length || 250, 10), v = t.unformatted || ["a", "span", "img", "bdo", "em", "strong", "dfn", "code", "samp", "kbd", "const", "cite", "abbr", "acronym", "q", "sub", "sup", "tt", "i", "b", "big", "small", "u", "s", "strike", "font", "ins", "del", "address", "pre"], l = t.preserve_newlines === undefined || t.preserve_newlines, c = l ? isNaN(parseInt(t.max_preserve_newlines, 10)) ? 32786 : parseInt(t.max_preserve_newlines, 10) : 0, b = t.indent_handlebars !== undefined && t.indent_handlebars, C = t.wrap_attributes === undefined ? "auto" : t.wrap_attributes, E = t.wrap_attributes_indent_size === undefined ? a : parseInt(t.wrap_attributes_indent_size, 10) || a, d = t.end_with_newline !== undefined && t.end_with_newline, f = Array.isArray(t.extra_liners) ? t.extra_liners.concat() : "string" == typeof t.extra_liners ? t.extra_liners.split(",") : "head,body,/html".split(","), t.indent_with_tabs && (m = "\t", a = 1), (n = new function k() {
          return this.pos = 0, this.token = "", this.current_mode = "CONTENT", this.tags = {
            parent: "parent1",
            parentcount: 1,
            parent1: ""
          }, this.tag_type = "", this.token_text = this.last_token = this.last_text = this.token_type = "", this.newlines = 0, this.indent_content = r, this.Utils = {
            whitespace: "\n\r\t ".split(""),
            single_token: "br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed".split(","),
            extra_liners: f,
            in_array: function (e, t) {
              for (var n = 0; n < t.length; n++) if (e === t[n]) return !0;
              return !1
            }
          }, this.is_whitespace = function (e) {
            for (; 0 < e.length; e++) if (!this.Utils.in_array(e.charAt(0), this.Utils.whitespace)) return !1;
            return !0
          }, this.traverse_whitespace = function () {
            var e = "";
            if (e = this.input.charAt(this.pos), this.Utils.in_array(e, this.Utils.whitespace)) {
              for (this.newlines = 0; this.Utils.in_array(e, this.Utils.whitespace);) l && "\n" === e && this.newlines <= c && (this.newlines += 1), this.pos++, e = this.input.charAt(this.pos);
              return !0
            }
            return !1
          }, this.space_or_wrap = function (e) {
            this.line_char_count >= this.wrap_line_length ? (this.print_newline(!1, e), this.print_indentation(e)) : (this.line_char_count++, e.push(" "))
          }, this.get_content = function () {
            for (var e = "", t = []; "<" != this.input.charAt(this.pos);) {
              if (this.pos >= this.input.length) return t.length ? t.join("") : ["", "TK_EOF"];
              if (this.traverse_whitespace()) this.space_or_wrap(t); else {
                if (b) {
                  var n = this.input.substr(this.pos, 3);
                  if ("{{#" === n || "{{/" === n) break;
                  if ("{{!" === n) return [this.get_tag(), "TK_TAG_HANDLEBARS_COMMENT"];
                  if ("{{" === this.input.substr(this.pos, 2) && "{{else}}" === this.get_tag(!0)) break
                }
                e = this.input.charAt(this.pos), this.pos++, this.line_char_count++, t.push(e)
              }
            }
            return t.length ? t.join("") : ""
          }, this.get_contents_to = function (e) {
            if (this.pos === this.input.length) return ["", "TK_EOF"];
            var t = "", n = new RegExp("</".concat(e, "\\s*>"), "igm");
            n.lastIndex = this.pos;
            var r = n.exec(this.input), a = r ? r.index : this.input.length;
            return this.pos < a && (t = this.input.substring(this.pos, a), this.pos = a), t
          }, this.record_tag = function (e) {
            this.tags["".concat(e, "count")] ? this.tags["".concat(e, "count")]++ : this.tags["".concat(e, "count")] = 1, this.tags[e + this.tags["".concat(e, "count")]] = this.indent_level, this.tags[e + this.tags["".concat(e, "count")] + "parent"] = this.tags.parent, this.tags.parent = e + this.tags["".concat(e, "count")]
          }, this.retrieve_tag = function (e) {
            if (this.tags["".concat(e, "count")]) {
              for (var t = this.tags.parent; t && e + this.tags["".concat(e, "count")] !== t;) t = this.tags["".concat(t, "parent")];
              t && (this.indent_level = this.tags[e + this.tags["".concat(e, "count")]], this.tags.parent = this.tags[t + "parent"]), delete this.tags[e + this.tags["".concat(e, "count")] + "parent"], delete this.tags[e + this.tags["".concat(e, "count")]], 1 === this.tags["".concat(e, "count")] ? delete this.tags["".concat(e, "count")] : this.tags["".concat(e, "count")]--
            }
          }, this.indent_to_tag = function (e) {
            if (this.tags["".concat(e, "count")]) {
              for (var t = this.tags.parent; t && e + this.tags["".concat(e, "count")] !== t;) t = this.tags["".concat(t, "parent")];
              t && (this.indent_level = this.tags[e + this.tags["".concat(e, "count")]])
            }
          }, this.get_tag = function (e) {
            var t, n, r = "", a = [], o = "", i = !1, s = !0, l = this.pos, c = this.line_char_count;
            e = e !== undefined && e;
            do {
              if (this.pos >= this.input.length) return e && (this.pos = l, this.line_char_count = c), a.length ? a.join("") : ["", "TK_EOF"];
              if (r = this.input.charAt(this.pos), this.pos++, this.Utils.in_array(r, this.Utils.whitespace)) i = !0; else {
                if ("'" !== r && '"' !== r || (r += this.get_unformatted(r), i = !0), "=" === r && (i = !1), a.length && "=" != a[a.length - 1] && ">" != r && i) {
                  if (this.space_or_wrap(a), i = !1, !s && "force" === C && "/" != r) {
                    this.print_newline(!0, a), this.print_indentation(a);
                    for (var d = 0; d < E; d++) a.push(m)
                  }
                  for (var f = 0; f < a.length; f++) if (" " === a[f]) {
                    s = !1;
                    break
                  }
                }
                if (b && "<" === n && r + this.input.charAt(this.pos) === "{{" && (r += this.get_unformatted("}}"), a.length && " " != a[a.length - 1] && "<" != a[a.length - 1] && (r = " ".concat(r)), i = !0), "<" !== r || n || (t = this.pos - 1, n = "<"), b && !n && 2 <= a.length && "{" === a[a.length - 1] && "{" === a[a.length - 2] && (t = "#" === r || "/" === r || "!" === r ? this.pos - 3 : this.pos - 2, n = "{"), this.line_char_count++, a.push(r), a[1] && ("!" === a[1] || "?" === a[1] || "%" === a[1])) {
                  a = [this.get_comment(t)];
                  break
                }
                if (b && a[1] && "{" === a[1] && a[2] && "!" === a[2]) {
                  a = [this.get_comment(t)];
                  break
                }
                if (b && "{" === n && 2 < a.length && "}" === a[a.length - 2] && "}" === a[a.length - 1]) break
              }
            } while (">" != r);
            var p, u, h = a.join("");
            p = -1 != h.indexOf(" ") ? h.indexOf(" ") : "{" === h[0] ? h.indexOf("}") : h.indexOf(">"), u = "<" !== h[0] && b ? "#" === h[2] ? 3 : 2 : 1;
            var g = h.substring(u, p).toLowerCase();
            return "/" === h.charAt(h.length - 2) || this.Utils.in_array(g, this.Utils.single_token) ? e || (this.tag_type = "SINGLE") : b && "{" === h[0] && "else" === g ? e || (this.indent_to_tag("if"), this.tag_type = "HANDLEBARS_ELSE", this.indent_content = !0, this.traverse_whitespace()) : this.is_unformatted(g, v) ? (o = this.get_unformatted("</".concat(g, ">"), h), a.push(o), this.pos, this.tag_type = "SINGLE") : "script" === g && (-1 === h.search("type") || -1 < h.search("type") && -1 < h.search(/\b(text|application)\/(x-)?(javascript|ecmascript|jscript|livescript)/)) ? e || (this.record_tag(g), this.tag_type = "SCRIPT") : "style" === g && (-1 === h.search("type") || -1 < h.search("type") && -1 < h.search("text/css")) ? e || (this.record_tag(g), this.tag_type = "STYLE") : "!" === g.charAt(0) ? e || (this.tag_type = "SINGLE", this.traverse_whitespace()) : e || ("/" === g.charAt(0) ? (this.retrieve_tag(g.substring(1)), this.tag_type = "END") : (this.record_tag(g), "html" != g.toLowerCase() && (this.indent_content = !0), this.tag_type = "START"), this.traverse_whitespace() && this.space_or_wrap(a), this.Utils.in_array(g, this.Utils.extra_liners) && (this.print_newline(!1, this.output), this.output.length && "\n" != this.output[this.output.length - 2] && this.print_newline(!0, this.output))), e && (this.pos = l, this.line_char_count = c), a.join("")
          }, this.get_comment = function (e) {
            var t = "", n = ">", r = !1;
            this.pos = e;
            var a = this.input.charAt(this.pos);
            for (this.pos++; this.pos <= this.input.length && ((t += a)[t.length - 1] !== n[n.length - 1] || -1 == t.indexOf(n));) !r && t.length < 10 && (0 === t.indexOf("<![if") ? (n = "<![endif]>", r = !0) : 0 === t.indexOf("<![cdata[") ? (n = "]]>", r = !0) : 0 === t.indexOf("<![") ? (n = "]>", r = !0) : 0 === t.indexOf("\x3c!--") ? (n = "--\x3e", r = !0) : 0 === t.indexOf("{{!") ? (n = "}}", r = !0) : 0 === t.indexOf("<?") ? (n = "?>", r = !0) : 0 === t.indexOf("<%") && (n = "%>", r = !0)), a = this.input.charAt(this.pos), this.pos++;
            return t
          }, this.get_unformatted = function (e, t) {
            if (t && -1 != t.toLowerCase().indexOf(e)) return "";
            var n = "", r = "", a = 0, o = !0;
            do {
              if (this.pos >= this.input.length) return r;
              if (n = this.input.charAt(this.pos), this.pos++, this.Utils.in_array(n, this.Utils.whitespace)) {
                if (!o) {
                  this.line_char_count--;
                  continue
                }
                if ("\n" === n || "\r" === n) {
                  r += "\n", this.line_char_count = 0;
                  continue
                }
              }
              r += n, this.line_char_count++, o = !0, b && "{" === n && r.length && "{" === r[r.length - 2] && (a = (r += this.get_unformatted("}}")).length)
            } while (-1 === r.toLowerCase().indexOf(e, a));
            return r
          }, this.get_token = function () {
            var e;
            if ("TK_TAG_SCRIPT" !== this.last_token && "TK_TAG_STYLE" !== this.last_token) return "CONTENT" === this.current_mode ? "string" != typeof (e = this.get_content()) ? e : [e, "TK_CONTENT"] : "TAG" === this.current_mode ? "string" != typeof (e = this.get_tag()) ? e : [e, "TK_TAG_".concat(this.tag_type)] : void 0;
            var t = this.last_token.substr(7);
            return "string" != typeof (e = this.get_contents_to(t)) ? e : [e, "TK_".concat(t)]
          }, this.get_full_indent = function (e) {
            return (e = this.indent_level + e || 0) < 1 ? "" : new Array(e + 1).join(this.indent_string)
          }, this.is_unformatted = function (e, t) {
            if (!this.Utils.in_array(e, t)) return !1;
            if ("a" != e.toLowerCase() || !this.Utils.in_array("a", t)) return !0;
            var n = (this.get_tag(!0) || "").match(/^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/);
            return !(n && !this.Utils.in_array(n, t))
          }, this.printer = function (e, t, n, r, a) {
            this.input = e || "", this.output = [], this.indent_character = t, this.indent_string = "", this.indent_size = n, this.brace_style = a, this.indent_level = 0, this.wrap_line_length = r;
            for (var o = this.line_char_count = 0; o < this.indent_size; o++) this.indent_string += this.indent_character;
            this.print_newline = function (e, t) {
              this.line_char_count = 0, t && t.length && (e || "\n" != t[t.length - 1]) && ("\n" != t[t.length - 1] && (t[t.length - 1] = i(t[t.length - 1])), t.push("\n"))
            }, this.print_indentation = function (e) {
              for (var t = 0; t < this.indent_level; t++) e.push(this.indent_string), this.line_char_count += this.indent_string.length
            }, this.print_token = function (e) {
              this.is_whitespace(e) && !this.output.length || ((e || "" !== e) && this.output.length && "\n" === this.output[this.output.length - 1] && (this.print_indentation(this.output), e = function t(e) {
                return e.replace(/^\s+/g, "")
              }(e)), this.print_token_raw(e))
            }, this.print_token_raw = function (e) {
              0 < this.newlines && (e = i(e)), e && "" !== e && (1 < e.length && "\n" === e[e.length - 1] ? (this.output.push(e.slice(0, -1)), this.print_newline(!1, this.output)) : this.output.push(e));
              for (var t = 0; t < this.newlines; t++) this.print_newline(0 < t, this.output);
              this.newlines = 0
            }, this.indent = function () {
              this.indent_level++
            }, this.unindent = function () {
              0 < this.indent_level && this.indent_level--
            }
          }, this
        }).printer(e, m, a, o, s); ;) {
          var p = n.get_token();
          if (n.token_text = p[0], n.token_type = p[1], "TK_EOF" === n.token_type) break;
          switch (n.token_type) {
            case"TK_TAG_START":
              n.print_newline(!1, n.output), n.print_token(n.token_text), n.indent_content && (n.indent(), n.indent_content = !1), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_STYLE":
            case"TK_TAG_SCRIPT":
              n.print_newline(!1, n.output), n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_END":
              if ("TK_CONTENT" === n.last_token && "" === n.last_text) {
                var u = n.token_text.match(/\w+/)[0], h = null;
                n.output.length && (h = n.output[n.output.length - 1].match(/(?:<|{{#)\/?\s*(\w+)/)), (null === h || h[1] != u && !n.Utils.in_array(h[1], v)) && n.print_newline(!1, n.output)
              }
              n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_SINGLE":
              var g = n.token_text.match(/^\s*<([a-z-]+)/i);
              g && n.Utils.in_array(g[1], v) || n.print_newline(!1, n.output), n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_HANDLEBARS_ELSE":
              n.print_token(n.token_text), n.indent_content && (n.indent(), n.indent_content = !1), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_HANDLEBARS_COMMENT":
            case"TK_CONTENT":
              n.print_token(n.token_text), n.current_mode = "TAG";
              break;
            case"TK_STYLE":
            case"TK_SCRIPT":
              if ("" !== n.token_text) {
                n.print_newline(!1, n.output);
                var y = n.token_text, L = void 0, _ = 1;
                "TK_SCRIPT" === n.token_type ? L = R : "TK_STYLE" === n.token_type && (L = x), "keep" === t.indent_scripts ? _ = 0 : "separate" === t.indent_scripts && (_ = -n.indent_level);
                var w = n.get_full_indent(_);
                if (L) y = L(y.replace(/^\s*/, w), t); else {
                  var A = y.match(/^\s*/)[0].match(/[^\n\r]*$/)[0].split(n.indent_string).length - 1,
                    T = n.get_full_indent(_ - A);
                  y = y.replace(/^\s*/, w).replace(/\r\n|\r|\n/g, "\n" + T).replace(/\s+$/, "")
                }
                y && (n.print_token_raw(y), n.print_newline(!0, n.output))
              }
              n.current_mode = "TAG";
              break;
            default:
              "" !== n.token_text && n.print_token(n.token_text)
          }
          n.last_token = n.token_type, n.last_text = n.token_text
        }
        var S = n.output.join("").replace(/[\r\n\t ]+$/, "");
        return d && (S += "\n"), S
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    codeMirror: window.CodeMirror,
    codeMirrorOptions: {
      lineNumbers: !0,
      tabMode: "indent",
      indentWithTabs: !0,
      lineWrapping: !0,
      mode: "text/html",
      tabSize: 2
    },
    codeBeautifierOptions: {
      end_with_newline: !0,
      indent_inner_html: !0,
      extra_liners: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "pre", "ul", "ol", "table", "dl"],
      brace_style: "expand",
      indent_char: "\t",
      indent_size: 1,
      wrap_line_length: 0
    },
    codeViewKeepActiveButtons: ["fullscreen"]
  }), xt.PLUGINS.codeView = function (c) {
    var d, f, p = c.$, u = function u() {
      return c.$box.hasClass("fr-code-view")
    };

    function h() {
      return f ? f.getValue() : d.val()
    }

    function g() {
      u() && (f && f.setSize(null, c.opts.height ? c.opts.height : "auto"), c.opts.heightMin || c.opts.height ? (c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height", c.opts.heightMin || c.opts.height), d.css("height", c.opts.height)) : c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height", ""))
    }

    var m, v = !1;

    function b() {
      u() && c.events.trigger("blur")
    }

    function C() {
      u() && v && c.events.trigger("focus")
    }

    function r(e) {
      d || (!function l() {
        d = p('<textarea class="fr-code" tabIndex="-1">'), c.$wp.append(d), d.attr("dir", c.opts.direction), c.$box.hasClass("fr-basic") || (m = p('<a data-cmd="html" title="Code View" class="fr-command fr-btn html-switch'.concat(c.helpers.isMobile() ? "" : " fr-desktop", '" role="button" tabIndex="-1"><i class="fa fa-code"></i></button>')), c.$box.append(m), c.events.bindClick(c.$box, "a.html-switch", function () {
          c.events.trigger("commands.before", ["html"]), E(!1), c.events.trigger("commands.after", ["html"])
        }));
        var e = function e() {
          return !u()
        };
        c.events.on("buttons.refresh", e), c.events.on("copy", e, !0), c.events.on("cut", e, !0), c.events.on("paste", e, !0), c.events.on("destroy", y, !0), c.events.on("html.set", function () {
          u() && E(!0)
        }), c.events.on("codeView.update", g), c.events.on("codeView.toggle", function () {
          c.$box.hasClass("fr-code-view") && E()
        }), c.events.on("form.submit", function () {
          u() && (c.html.set(h()), c.events.trigger("contentChanged", [], !0))
        }, !0)
      }(), !f && c.opts.codeMirror ? ((f = c.opts.codeMirror.fromTextArea(d.get(0), c.opts.codeMirrorOptions)).on("blur", b), f.on("focus", C)) : (c.events.$on(d, "keydown keyup change input", function () {
        c.opts.height ? this.removeAttribute("rows") : (this.rows = 1, 0 === this.value.length ? this.style.height = "auto" : this.style.height = "".concat(this.scrollHeight, "px"))
      }), c.events.$on(d, "blur", b), c.events.$on(d, "focus", C))), c.undo.saveStep(), c.html.cleanEmptyTags(), c.html.cleanWhiteTags(!0), c.core.hasFocus() && (c.core.isEmpty() || (c.selection.save(), c.$el.find('.fr-marker[data-type="true"]').first().replaceWith('<span class="fr-tmp fr-sm">F</span>'), c.$el.find('.fr-marker[data-type="false"]').last().replaceWith('<span class="fr-tmp fr-em">F</span>')));
      var t = c.html.get(!1, !0);
      c.$el.find("span.fr-tmp").remove(), c.$box.toggleClass("fr-code-view", !0);
      var n, r, a = !1;
      if (c.core.hasFocus() && (a = !0, c.events.disableBlur(), c.$el.blur()), t = (t = t.replace(/<span class="fr-tmp fr-sm">F<\/span>/, "FROALA-SM")).replace(/<span class="fr-tmp fr-em">F<\/span>/, "FROALA-EM"), c.codeBeautifier && !t.includes("fr-embedly") && (t = c.codeBeautifier.run(t, c.opts.codeBeautifierOptions)), f) {
        n = t.indexOf("FROALA-SM"), (r = t.indexOf("FROALA-EM")) < n ? n = r : r -= 9;
        var o = (t = t.replace(/FROALA-SM/g, "").replace(/FROALA-EM/g, "")).substring(0, n).length - t.substring(0, n).replace(/\n/g, "").length,
          i = t.substring(0, r).length - t.substring(0, r).replace(/\n/g, "").length;
        n = t.substring(0, n).length - t.substring(0, t.substring(0, n).lastIndexOf("\n") + 1).length, r = t.substring(0, r).length - t.substring(0, t.substring(0, r).lastIndexOf("\n") + 1).length, f.setSize(null, c.opts.height ? c.opts.height : "auto"), c.opts.heightMin && c.$box.find(".CodeMirror-scroll").css("min-height", c.opts.heightMin), f.setValue(t), v = !a, f.focus(), v = !0, f.setSelection({
          line: o,
          ch: n
        }, {line: i, ch: r}), f.refresh(), f.clearHistory()
      } else {
        n = t.indexOf("FROALA-SM"), r = t.indexOf("FROALA-EM") - 9, c.opts.heightMin && d.css("min-height", c.opts.heightMin), c.opts.height && d.css("height", c.opts.height), c.opts.heightMax && d.css("max-height", c.opts.height || c.opts.heightMax), d.val(t.replace(/FROALA-SM/g, "").replace(/FROALA-EM/g, "")).trigger("change");
        var s = p(c.o_doc).scrollTop();
        v = !a, d.focus(), v = !0, d.get(0).setSelectionRange(n, r), p(c.o_doc).scrollTop(s)
      }
      c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).filter(function () {
        return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd")) < 0
      }).addClass("fr-disabled").attr("aria-disabled", !0), e.addClass("fr-active").attr("aria-pressed", !0), !c.helpers.isMobile() && c.opts.toolbarInline && c.toolbar.hide()
    }

    function E(e) {
      void 0 === e && (e = !u());
      var t = c.$tb.find('.fr-command[data-cmd="html"]');
      e ? (c.popups.hideAll(), r(t)) : (c.$box.toggleClass("fr-code-view", !1), function n(e) {
        var t = h();
        c.html.set(t), c.$el.blur(), c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled", !1), e.removeClass("fr-active").attr("aria-pressed", !1), c.selection.setAtStart(c.el), c.selection.restore(), c.placeholder.refresh(), c.undo.saveStep()
      }(t), c.events.trigger("codeView.update"))
    }

    function y() {
      u() && E(!1), f && f.toTextArea(), d.val("").removeData().remove(), d = null, m && (m.remove(), m = null)
    }

    return {
      _init: function e() {
        if (c.events.on("focus", function () {
          c.opts.toolbarContainer && function t() {
            var e = c.$tb.find('.fr-command[data-cmd="html"]');
            u() ? (c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).filter(function () {
              return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd")) < 0
            }).addClass("fr-disabled").attr("aria-disabled", !1), e.addClass("fr-active").attr("aria-pressed", !1)) : (c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled", !1), e.removeClass("fr-active").attr("aria-pressed", !1))
          }()
        }), !c.$wp) return !1
      }, toggle: E, isActive: u, get: h
    }
  }, xt.RegisterCommand("html", {
    title: "Code View",
    undo: !1,
    focus: !1,
    forcedRefresh: !0,
    toggle: !0,
    callback: function () {
      this.codeView.toggle()
    },
    plugin: "codeView"
  }), xt.DefineIcon("html", {
    NAME: "code",
    SVG_KEY: "codeView"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "textColor.picker": "[_BUTTONS_][_TEXT_COLORS_][_CUSTOM_COLOR_]",
    "backgroundColor.picker": "[_BUTTONS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]"
  }), Object.assign(xt.DEFAULTS, {
    colorsText: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    colorsBackground: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    colorsStep: 7,
    colorsHEXInput: !0,
    colorsButtons: ["colorsBack", "|", "-"]
  }), xt.PLUGINS.colors = function (m) {
    var v = m.$,
      s = '<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer- \n  '.concat(m.id, '"><div class="fr-input-line"><input maxlength="7" id="[ID]"\n  type="text" placeholder="').concat(m.language.translate("HEX Color"), '" \n  tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button \n  type="button" class="fr-command fr-submit" data-cmd="[COMMAND]" tabIndex="2" role="button">\n  ').concat(m.language.translate("OK"), "</button></div></div>");

    function l(e) {
      for (var t = "text" === e ? m.opts.colorsText : m.opts.colorsBackground, n = '<div class="fr-color-set fr-'.concat(e, '-color fr-selected-set">'), r = 0; r < t.length; r++) 0 !== r && r % m.opts.colorsStep == 0 && (n += "<br>"), "REMOVE" !== t[r] ? n += '<span class="fr-command fr-select-color" style="background:'.concat(t[r], ';" \n        tabIndex="-1" aria-selected="false" role="button" data-cmd="apply').concat(e, 'Color" \n        data-param1="').concat(t[r], '"><span class="fr-sr-only"> ').concat(m.language.translate("Color")).concat(t[r], " \n        &nbsp;&nbsp;&nbsp;</span></span>") : n += '<span class="fr-command fr-select-color" data-cmd="apply'.concat(e, 'Color"\n         tabIndex="-1" role="button" data-param1="REMOVE" \n         title="').concat(m.language.translate("Clear Formatting"), '">').concat(m.icon.create("remove"), ' \n        <span class="fr-sr-only"> ').concat(m.language.translate("Clear Formatting"), " </span></span>");
      return "".concat(n, "</div>")
    }

    function c(e) {
      var t, n = m.popups.get("".concat(e, "Color.picker")), r = v(m.selection.element());
      t = "background" === e ? "background-color" : "color";
      var a = n.find(".fr-".concat(e, "-color .fr-select-color"));
      for (a.find(".fr-selected-color").remove(), a.removeClass("fr-active-item"), a.not('[data-param1="REMOVE"]').attr("aria-selected", !1); r.get(0) !== m.el;) {
        if ("transparent" !== r.css(t) && "rgba(0, 0, 0, 0)" !== r.css(t)) {
          var o = n.find(".fr-".concat(e, '-color .fr-select-color[data-param1="').concat(m.helpers.RGBToHex(r.css(t)), '"]'));
          o.append('<span class="fr-selected-color" aria-hidden="true">\uf00c</span>'), o.addClass("fr-active-item").attr("aria-selected", !0);
          break
        }
        r = r.parent()
      }
      !function i(e) {
        var t = m.popups.get("".concat(e, "Color.picker")),
          n = t.find(".fr-".concat(e, "-color .fr-active-item")).attr("data-param1"),
          r = t.find(".fr-color-hex-layer input");
        n || (n = "");
        r.length && v(r.val(n).input).trigger("change")
      }(e)
    }

    function r(e) {
      "REMOVE" !== e ? m.format.applyStyle("background-color", m.helpers.HEXtoRGB(e)) : m.format.removeStyle("background-color"), m.popups.hide("backgroundColor.picker")
    }

    function a(e) {
      "REMOVE" !== e ? m.format.applyStyle("color", m.helpers.HEXtoRGB(e)) : m.format.removeStyle("color"), m.popups.hide("textColor.picker")
    }

    return {
      showColorsPopup: function d(e) {
        var t = m.$tb.find('.fr-command[data-cmd="'.concat(e, '"]')), n = m.popups.get("".concat(e, ".picker"));
        if (n || (n = function i(e) {
          var t = "";
          m.opts.toolbarInline && 0 < m.opts.colorsButtons.length && (t += '<div class="fr-buttons fr-colors-buttons fr-tabs">\n        '.concat(m.button.buildList(m.opts.colorsButtons), "\n        </div>"));
          var n, r = "";
          n = "textColor" === e ? (m.opts.colorsHEXInput && (r = s.replace(/\[ID\]/g, "fr-color-hex-layer-text-".concat(m.id)).replace(/\[COMMAND\]/g, "customTextColor")), {
            buttons: t,
            text_colors: l("text"),
            custom_color: r
          }) : (m.opts.colorsHEXInput && (r = s.replace(/\[ID\]/g, "fr-color-hex-layer-background-".concat(m.id)).replace(/\[COMMAND\]/g, "customBackgroundColor")), {
            buttons: t,
            background_colors: l("background"),
            custom_color: r
          });
          var a = m.popups.create("".concat(e, ".picker"), n);
          return function o(h, g) {
            m.events.on("popup.tab", function (e) {
              var t = v(e.currentTarget);
              if (!m.popups.isVisible(g) || !t.is("span")) return !0;
              var n = e.which, r = !0;
              if (xt.KEYCODE.TAB === n) {
                var a = h.find(".fr-buttons");
                r = !m.accessibility.focusToolbar(a, !!e.shiftKey)
              } else if (xt.KEYCODE.ARROW_UP === n || xt.KEYCODE.ARROW_DOWN === n || xt.KEYCODE.ARROW_LEFT === n || xt.KEYCODE.ARROW_RIGHT === n) {
                if (t.is("span.fr-select-color")) {
                  var o = t.parent().find("span.fr-select-color"), i = o.index(t), s = m.opts.colorsStep,
                    l = Math.floor(o.length / s), c = i % s, d = Math.floor(i / s), f = d * s + c, p = l * s;
                  xt.KEYCODE.ARROW_UP === n ? f = ((f - s) % p + p) % p : xt.KEYCODE.ARROW_DOWN === n ? f = (f + s) % p : xt.KEYCODE.ARROW_LEFT === n ? f = ((f - 1) % p + p) % p : xt.KEYCODE.ARROW_RIGHT === n && (f = (f + 1) % p);
                  var u = v(o.get(f));
                  m.events.disableBlur(), u.focus(), r = !1
                }
              } else xt.KEYCODE.ENTER === n && (m.button.exec(t), r = !1);
              return !1 === r && (e.preventDefault(), e.stopPropagation()), r
            }, !0)
          }(a, "".concat(e, ".picker")), a
        }(e)), !n.hasClass("fr-active")) if (m.popups.setContainer("".concat(e, ".picker"), m.$tb), c("textColor" === e ? "text" : "background"), t.isVisible()) {
          var r = m.button.getPosition(t), a = r.left, o = r.top;
          m.popups.show("".concat(e, ".picker"), a, o, t.outerHeight())
        } else m.position.forSelection(n), m.popups.show("".concat(e, ".picker"))
      }, background: r, customColor: function o(e) {
        var t = m.popups.get("".concat(e, "Color.picker")).find(".fr-color-hex-layer input");
        if (t.length) {
          var n = t.val();
          "background" === e ? r(n) : a(n)
        }
      }, text: a, back: function e() {
        m.popups.hide("textColor.picker"), m.popups.hide("backgroundColor.picker"), m.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("textColor", {
    NAME: "tint",
    SVG_KEY: "textColor"
  }), xt.RegisterCommand("textColor", {
    title: "Text Color",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("textColor.picker") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("textColor.picker")) : this.colors.showColorsPopup("textColor")
    }
  }), xt.RegisterCommand("applytextColor", {
    undo: !0, callback: function (e, t) {
      this.colors.text(t)
    }
  }), xt.RegisterCommand("customTextColor", {
    title: "OK", undo: !0, callback: function () {
      this.colors.customColor("text")
    }
  }), xt.DefineIcon("backgroundColor", {
    NAME: "paint-brush",
    SVG_KEY: "backgroundColor"
  }), xt.RegisterCommand("backgroundColor", {
    title: "Background Color",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("backgroundColor.picker") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("backgroundColor.picker")) : this.colors.showColorsPopup("backgroundColor")
    }
  }), xt.RegisterCommand("applybackgroundColor", {
    undo: !0, callback: function (e, t) {
      this.colors.background(t)
    }
  }), xt.RegisterCommand("customBackgroundColor", {
    title: "OK", undo: !0, callback: function () {
      this.colors.customColor("background")
    }
  }), xt.DefineIcon("colorsBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("colorsBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.colors.back()
    }
  }), xt.DefineIcon("remove", {
    NAME: "eraser",
    SVG_KEY: "remove"
  }), Object.assign(xt.DEFAULTS, {dragInline: !0}), xt.PLUGINS.draggable = function (d) {
    var f = d.$;

    function e(e) {
      return !(!e.originalEvent || !e.originalEvent.target || e.originalEvent.target.nodeType !== Node.TEXT_NODE) || (e.target && "A" === e.target.tagName && 1 === e.target.childNodes.length && "IMG" === e.target.childNodes[0].tagName && (e.target = e.target.childNodes[0]), f(e.target).hasClass("fr-draggable") ? (d.undo.canDo() || d.undo.saveStep(), d.opts.dragInline ? d.$el.attr("contenteditable", !0) : d.$el.attr("contenteditable", !1), d.opts.toolbarInline && d.toolbar.hide(), f(e.target).addClass("fr-dragging"), d.browser.msie || d.browser.edge || d.selection.clear(), void e.originalEvent.dataTransfer.setData("text", "Froala")) : (e.preventDefault(), !1))
    }

    var p, u = function u(e) {
      return !(e && ("HTML" === e.tagName || "BODY" === e.tagName || d.node.isElement(e)))
    };

    function h(e, t, n) {
      if (d.opts.iframe) {
        var r = d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-top")),
          a = d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-left"));
        e += d.$iframe.offset().top + r, t += d.$iframe.offset().left + a
      }
      p.offset().top !== e && p.css("top", e), p.offset().left !== t && p.css("left", t), p.width() !== n && p.css("width", n)
    }

    function t(e) {
      e.originalEvent.dataTransfer.dropEffect = "move", d.opts.dragInline ? (!function n() {
        for (var e = null, t = 0; t < xt.INSTANCES.length; t++) if ((e = xt.INSTANCES[t].$el.find(".fr-dragging")).length) return e.get(0)
      }() || d.browser.msie || d.browser.edge) && e.preventDefault() : (e.preventDefault(), function c(e) {
        var t = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset);
        if (!u(t)) {
          for (var n = 0, r = t; !u(r) && r === t && 0 < e.originalEvent.pageY - d.win.pageYOffset - n;) n++, r = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset - n);
          (!u(r) || p && 0 === d.$el.find(r).length && r !== p.get(0)) && (r = null);
          for (var a = 0, o = t; !u(o) && o === t && e.originalEvent.pageY - d.win.pageYOffset + a < f(d.doc).height();) a++, o = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset + a);
          (!u(o) || p && 0 === d.$el.find(o).length && o !== p.get(0)) && (o = null), t = null === o && r ? r : o && null === r ? o : o && r ? n < a ? r : o : null
        }
        if (f(t).hasClass("fr-drag-helper")) return !1;
        if (t && !d.node.isBlock(t) && (t = d.node.blockParent(t)), t && 0 <= ["TD", "TH", "TR", "THEAD", "TBODY"].indexOf(t.tagName) && (t = f(t).parents("table").get(0)), t && 0 <= ["LI"].indexOf(t.tagName) && (t = f(t).parents("UL, OL").get(0)), t && !f(t).hasClass("fr-drag-helper")) {
          var i;
          p || (xt.$draggable_helper || (xt.$draggable_helper = f(document.createElement("div")).attr("class", "fr-drag-helper")), p = xt.$draggable_helper, d.events.on("shared.destroy", function () {
            p.html("").removeData().remove(), p = null
          }, !0)), i = e.originalEvent.pageY < f(t).offset().top + f(t).outerHeight() / 2;
          var s = f(t), l = 0;
          i || 0 !== s.next().length ? (i || (s = s.next()), "before" === p.data("fr-position") && s.is(p.data("fr-tag")) || (0 < s.prev().length && (l = parseFloat(s.prev().css("margin-bottom")) || 0), l = Math.max(l, parseFloat(s.css("margin-top")) || 0), h(s.offset().top - l / 2 - d.$box.offset().top, s.offset().left - d.win.pageXOffset - d.$box.offset().left, s.width()), p.data("fr-position", "before"))) : "after" === p.data("fr-position") && s.is(p.data("fr-tag")) || (l = parseFloat(s.css("margin-bottom")) || 0, h(s.offset().top + f(t).height() + l / 2 - d.$box.offset().top, s.offset().left - d.win.pageXOffset - d.$box.offset().left, s.width()), p.data("fr-position", "after")), p.data("fr-tag", s), p.addClass("fr-visible"), d.$box.append(p)
        } else p && 0 < d.$box.find(p).length && p.removeClass("fr-visible")
      }(e))
    }

    function n(e) {
      e.originalEvent.dataTransfer.dropEffect = "move", d.opts.dragInline || e.preventDefault()
    }

    function r(e) {
      d.$el.attr("contenteditable", !0);
      var t = d.$el.find(".fr-dragging");
      p && p.hasClass("fr-visible") && d.$box.find(p).length ? a(e) : t.length && (e.preventDefault(), e.stopPropagation()), p && d.$box.find(p).length && p.removeClass("fr-visible"), t.removeClass("fr-dragging")
    }

    function a(e) {
      var t, n;
      d.$el.attr("contenteditable", !0);
      for (var r = 0; r < xt.INSTANCES.length; r++) if ((t = xt.INSTANCES[r].$el.find(".fr-dragging")).length) {
        n = xt.INSTANCES[r];
        break
      }
      if (t.length) {
        if (e.preventDefault(), e.stopPropagation(), p && p.hasClass("fr-visible") && d.$box.find(p).length) p.data("fr-tag")[p.data("fr-position")]('<span class="fr-marker"></span>'), p.removeClass("fr-visible"); else if (!1 === d.markers.insertAtPoint(e.originalEvent)) return !1;
        if (t.removeClass("fr-dragging"), !1 === (t = d.events.chainTrigger("element.beforeDrop", t))) return !1;
        var a = t;
        if (t.parent().is("A") && 1 === t.parent().get(0).childNodes.length && (a = t.parent()), d.core.isEmpty()) d.events.focus(); else d.$el.find(".fr-marker").replaceWith(xt.MARKERS), d.selection.restore();
        if (n === d || d.undo.canDo() || d.undo.saveStep(), d.core.isEmpty()) d.$el.html(a); else {
          var o = d.markers.insert();
          0 === a.find(o).length ? f(o).replaceWith(a) : 0 === t.find(o).length && f(o).replaceWith(t), t.after(xt.MARKERS), d.selection.restore()
        }
        return d.popups.hideAll(), d.selection.save(), d.$el.find(d.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").not(d.opts.htmlAllowedEmptyTags.join(",")).remove(), d.html.wrap(), d.html.fillEmptyBlocks(), d.selection.restore(), d.undo.saveStep(), d.opts.iframe && d.size.syncIframe(), n !== d && (n.popups.hideAll(), n.$el.find(n.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").remove(), n.html.wrap(), n.html.fillEmptyBlocks(), n.undo.saveStep(), n.events.trigger("element.dropped"), n.opts.iframe && n.size.syncIframe()), d.events.trigger("element.dropped", [a]), !1
      }
      p && p.removeClass("fr-visible"), d.undo.canDo() || d.undo.saveStep(), setTimeout(function () {
        d.undo.saveStep()
      }, 0)
    }

    function o(e) {
      if (e && "DIV" === e.tagName && d.node.hasClass(e, "fr-drag-helper")) e.parentNode.removeChild(e); else if (e && e.nodeType === Node.ELEMENT_NODE) for (var t = e.querySelectorAll("div.fr-drag-helper"), n = 0; n < t.length; n++) t[n].parentNode.removeChild(t[n])
    }

    return {
      _init: function i() {
        d.opts.enter === xt.ENTER_BR && (d.opts.dragInline = !0), d.events.on("dragstart", e, !0), d.events.on("dragover", t, !0), d.events.on("dragenter", n, !0), d.events.on("document.dragend", r, !0), d.events.on("document.drop", r, !0), d.events.on("drop", a, !0), d.events.on("html.processGet", o)
      }
    }
  }, Object.assign(xt.DEFAULTS, {editInPopup: !1}), xt.MODULES.editInPopup = function (r) {
    function e() {
      r.events.$on(r.$el, r._mouseup, function () {
        setTimeout(function () {
          !function n() {
            var e, t = r.popups.get("text.edit");
            e = "INPUT" === r.el.tagName ? r.$el.attr("placeholder") : r.$el.text(), t.find("input").val(e).trigger("change"), r.popups.setContainer("text.edit", r.$sc), r.popups.show("text.edit", r.$el.offset().left + r.$el.outerWidth() / 2, r.$el.offset().top + r.$el.outerHeight(), r.$el.outerHeight())
          }()
        }, 10)
      })
    }

    return {
      _init: function n() {
        r.opts.editInPopup && (!function t() {
          var e = {edit: '<div id="fr-text-edit-'.concat(r.id, '" class="fr-layer fr-text-edit-layer"><div class="fr-input-line"><input type="text" placeholder="').concat(r.language.translate("Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="updateText" tabIndex="2">').concat(r.language.translate("Update"), "</button></div></div>")};
          r.popups.create("text.edit", e)
        }(), e())
      }, update: function t() {
        var e = r.popups.get("text.edit").find("input").val();
        0 === e.length && (e = r.opts.placeholderText), "INPUT" === r.el.tagName ? r.$el.attr("placeholder", e) : r.$el.text(e), r.events.trigger("contentChanged"), r.popups.hide("text.edit")
      }
    }
  }, xt.RegisterCommand("updateText", {
    focus: !1, undo: !1, callback: function () {
      this.editInPopup.update()
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {emoticons: "[_BUTTONS_][_CUSTOM_LAYER_]"}), Object.assign(xt.DEFAULTS, {
    emoticonsSet: [{
      id: "people",
      name: "Smileys & People",
      code: "1f600",
      emoticons: [{code: "1f600", desc: "Grinning face"}, {
        code: "1f601",
        desc: "Grinning Face with Smiling Eyes"
      }, {code: "1f602", desc: "Face with Tears of Joy"}, {
        code: "1f603",
        desc: "Smiling Face with Open Mouth"
      }, {code: "1f604", desc: "Smiling Face with Open Mouth and Smiling Eyes"}, {
        code: "1f605",
        desc: "Smiling Face with Open Mouth and Cold Sweat"
      }, {code: "1f606", desc: "Smiling Face with Open Mouth and Tightly-Closed Eyes"}, {
        code: "1f609",
        desc: "Winking Face"
      }, {code: "1f60a", desc: "Smiling Face with Smiling Eyes"}, {
        code: "1f608",
        desc: "Face Savouring Delicious Food"
      }, {code: "1f60e", desc: "Smiling Face with Sunglasses"}, {
        code: "1f60d",
        desc: "Smiling Face with Heart-Shaped Eyes"
      }, {code: "1f618", desc: "Face Throwing a Kiss"}, {code: "1f617", desc: "Kissing Face"}, {
        code: "1f619",
        desc: "Kissing Face with Smiling Eyes"
      }, {code: "1f61a", desc: "Kissing Face with Closed Eyes"}, {
        code: "263a",
        desc: "White Smiling Face"
      }, {code: "1f642", desc: "Slightly Smiling Face"}, {code: "1f610", desc: "Neutral Face"}, {
        code: "1f611",
        desc: "Expressionless Face"
      }, {code: "1f636", desc: "Face Without Mouth"}, {code: "1f60f", desc: "Smirking Face"}, {
        code: "1f623",
        desc: "Persevering Face"
      }, {code: "1f625", desc: "Disappointed but Relieved Face"}, {
        code: "1f62e",
        desc: "Face with Open Mouth"
      }, {code: "1f62f", desc: "Hushed Face"}, {code: "1f62a", desc: "Sleepy Face"}, {
        code: "1f62b",
        desc: "Tired Face"
      }, {code: "1f634", desc: "Sleeping Face"}, {code: "1f60c", desc: "Relieved Face"}, {
        code: "1f61b",
        desc: "Face with Stuck-out Tongue"
      }, {code: "1f61c", desc: "Face with Stuck-out Tongue and Winking Eye"}, {
        code: "1f61d",
        desc: "Face with Stuck-out Tongue and Tightly-Closed Eyes"
      }, {code: "1f612", desc: "Unamused Face"}, {code: "1f613", desc: "Face with Cold Sweat"}, {
        code: "1f613",
        desc: "Face with Cold Sweat"
      }, {code: "1f614", desc: "Pensive Face"}, {code: "1f615", desc: "Confused Face"}, {
        code: "1f632",
        desc: "Astonished  Face"
      }, {code: "1f616", desc: "Confounded Face"}, {code: "1f61e", desc: "Disappointed Face"}, {
        code: "1f61f",
        desc: "Worried Face"
      }, {code: "1f624", desc: "Face with Look of Triumph"}, {code: "1f622", desc: "Crying Face"}, {
        code: "1f62d",
        desc: "Loudly Crying Face"
      }, {code: "1f626", desc: "Frowning Face with Open Mouth"}, {
        code: "1f627",
        desc: "Anguished Face"
      }, {code: "1f628", desc: "Fearful Face"}, {code: "1f629", desc: "Weary Face"}, {
        code: "1f62c",
        desc: "Grimacing Face"
      }, {code: "1f630", desc: "Face with Open Mouth and Cold Sweat"}, {
        code: "1f631",
        desc: "Face Screaming in Fear"
      }, {code: "1f633", desc: "Flushed Face"}, {code: "1f635", desc: "Dizzy Face"}, {
        code: "1f621",
        desc: "Pouting Face"
      }, {code: "1f620", desc: "Angry Face"}, {code: "1f637", desc: "Face with Medical Mask"}, {
        code: "1f607",
        desc: "Smiling Face with Halo"
      }, {code: "1f608", desc: "Smiling Face with Horns"}, {code: "1f47f", desc: "Imp"}, {
        code: "1f479",
        desc: "Japanese Ogre"
      }, {code: "1f47a", desc: "Japanese Goblin"}, {code: "1f480", desc: "Skull"}, {
        code: "1f47b",
        desc: "Ghost"
      }, {code: "1f47d", desc: "Extraterrestrial Alien"}, {code: "1f47e", desc: "Alien Monster"}, {
        code: "1f4a9",
        desc: "Pile of Poo"
      }, {code: "1f63a", desc: "Smiling Cat Face with Open Mouth"}, {
        code: "1f638",
        desc: "Grinning Cat Face with Smiling Eyes"
      }, {code: "1f639", desc: "Cat Face with Tears of Joy"}, {
        code: "1f63b",
        desc: "Smiling Cat Face with Heart-Shaped Eyes"
      }, {code: "1f63c", desc: "Cat Face with Wry Smile"}, {
        code: "1f63d",
        desc: "Kissing Cat Face with Closed Eyes"
      }, {code: "1f640", desc: "Weary Cat Face"}, {code: "1f63f", desc: "Crying Cat Face"}, {
        code: "1f63e",
        desc: "Pouting Cat Face"
      }, {code: "1f648", desc: "See-No-Evil Monkey"}, {code: "1f649", desc: "Hear-No-Evil Monkey"}, {
        code: "1f64a",
        desc: "Speak-No-Evil Monkey"
      }, {code: "1f476", desc: "Baby"}, {code: "1f466", desc: "Boy"}, {code: "1f467", desc: "Girl"}, {
        code: "1f468",
        desc: "Man"
      }, {code: "1f469", desc: "Woman"}, {code: "1f474", desc: "Older Man"}, {
        code: "1f475",
        desc: "Older Woman"
      }, {code: "1f46e", desc: "Police Officer"}, {code: "1f482", desc: " Guardsman"}, {
        code: "1f477",
        desc: " Construction Worker"
      }, {code: "1f478", desc: "Princess"}, {code: "1f473", desc: "Man with Turban"}, {
        code: "1f472",
        desc: "Man with Gua Pi Mao"
      }, {code: "1f471", desc: "Person with Blond Hair"}, {code: "1f470", desc: "Bride with Veil"}, {
        code: "1f47c",
        desc: "Baby Angel"
      }, {code: "1f385", desc: "Father Christmas"}, {code: "1f64e", desc: "Person with Pouting Face"}, {
        code: "1f645",
        desc: "Face with No Good Gesture"
      }, {code: "1f646", desc: "Face with Ok Gesture"}, {
        code: "1f481",
        desc: "Information Desk Person"
      }, {code: "1f64b", desc: "Happy Person Raising One Hand"}, {
        code: "1f647",
        desc: "Person Bowing Deeply"
      }, {code: "1f486", desc: "Face Massage"}, {code: "1f487", desc: "Haircut"}, {
        code: "1f6b6",
        desc: "Pedestrian"
      }, {code: "1f3c3", desc: "Runner"}, {code: "1f483", desc: "Dancer"}, {
        code: "1f46f",
        desc: "Woman with Bunny Ears"
      }, {code: "1f6c0", desc: "Bath"}, {code: "1f464", desc: "Bust in Silhouette"}, {
        code: "1f465",
        desc: "Busts in Silhouette"
      }, {code: "1f3c7", desc: "Horse Racing"}, {code: "1f3c2", desc: " Snowboarder"}, {
        code: "1f3c4",
        desc: " Surfer"
      }, {code: "1f6a3", desc: " Rowboat"}, {code: "1f3ca", desc: " Swimmer"}, {
        code: "1f6b4",
        desc: " Bicyclist"
      }, {code: "1f6b5", desc: "Mountain Bicyclist"}, {
        code: "1f46b",
        desc: " Man and Woman Holding Hands"
      }, {code: "1f46c", desc: "Two Men Holding Hands"}, {
        code: "1f46d",
        desc: "Two Women Holding Hands"
      }, {code: "1f48f", desc: "Kiss"}, {
        code: "1f468-2764-1f48b-1f468",
        uCode: "\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68",
        desc: "Man Kiss Man"
      }, {
        code: "1f469-2764-1f48b-1f469",
        uCode: "\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",
        desc: "Woman Kiss Woman"
      }, {code: "1f491", desc: "Couple with Heart"}, {
        code: "1f468-2764-1f468",
        uCode: "\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68",
        desc: "Man Heart Man"
      }, {
        code: "1f469-2764-1f469",
        uCode: "\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",
        desc: "Woman Heart Woman"
      }, {code: "1f46a", desc: "Family"}, {code: "1f468", desc: "Man Woman Boy"}, {
        code: "1f468-1f469-1f467",
        desc: "Man Woman Girl"
      }, {code: "1f468-1f469-1f467-1f466", desc: "Man Woman Girl Boy"}, {
        code: "1f468-1f469-1f466-1f466",
        desc: "Man Woman Boy Boy"
      }, {code: "1f468-1f469-1f467-1f467", desc: "Man Woman Girl Girl"}, {
        code: "1f468-1f468-1f466",
        desc: "Man Man Boy"
      }, {code: "1f468-1f468-1f467", desc: "Man Man Girl"}, {
        code: "1f468-1f468-1f467-1f466",
        desc: "Man Man Girl Boy"
      }, {code: "1f468-1f468-1f466-1f466", desc: "Man Man Boy Boy"}, {
        code: "1f469-1f469-1f466",
        desc: "Woman Woman Boy"
      }, {code: "1f469-1f469-1f467", desc: "Woman Woman Girl"}, {
        code: "1f469-1f469-1f467-1f466",
        desc: "Woman Woman Girl Boy"
      }, {code: "1f469-1f469-1f467-1f467", desc: "Woman Woman Girl Girl"}, {
        code: "1f4aa",
        desc: "Flexed Biceps"
      }, {code: "1f448", desc: "White Left Pointing Backhand Index"}, {
        code: "1f449",
        desc: "White Right Pointing Backhand Index"
      }, {code: "1f446", desc: "White Up Pointing Backhand Index"}, {
        code: "1f447",
        desc: "White Down Pointing Backhand Index"
      }, {code: "270c", desc: "Victory Hand"}, {code: "270b", desc: "Raised Hand"}, {
        code: "1f44c",
        desc: "Ok Hand Sign"
      }, {code: "1f44d", desc: "Thumbs Up Sign"}, {code: "1f44e", desc: "Thumbs Down Sign"}, {
        code: "270a",
        desc: "Raised Fist"
      }, {code: "1f44a", desc: "Fisted Hand Sign"}, {code: "1f44b", desc: "Waving Hand Sign"}, {
        code: "1f44f",
        desc: "Clapping Hands Sign"
      }, {code: "1f450", desc: "Open  Hands Sign"}, {
        code: "1f64c",
        desc: "Person Raising Both Hands in Celebration"
      }, {code: "1f64f", desc: "Person with Folded Hands"}, {code: "1f485", desc: "Nail Polish"}, {
        code: "1f442",
        desc: "Ear"
      }, {code: "1f443", desc: "Nose"}, {code: "1f463", desc: "Footprints"}, {
        code: "1f440",
        desc: "Eyes"
      }, {code: "1f445", desc: "Tongue"}, {code: "1f444", desc: "Mouth"}, {
        code: "1f48b",
        desc: "Kiss Mark"
      }, {code: "1f498", desc: "Heart with Arrow"}, {code: "2764", desc: "Heavy Black Heart"}, {
        code: "1f493",
        desc: "Heavy Black Heart"
      }, {code: "1f494", desc: "Broken Heart"}, {code: "1f495", desc: "Two Hearts"}, {
        code: "1f496",
        desc: "Sparkling Hearts"
      }, {code: "1f497", desc: "Growing Hearts"}, {code: "1f499", desc: "Blue Heart"}, {
        code: "1f49a",
        desc: "Green Heart"
      }, {code: "1f49b", desc: "Yellow Heart"}, {code: "1f49c", desc: "Purple Heart"}, {
        code: "1f49d",
        desc: "Heart with Ribbon"
      }, {code: "1f49e", desc: "Revolving Hearts"}, {code: "1f49f", desc: "Heart Decoration"}, {
        code: "1f48c",
        desc: "Love Letter"
      }, {code: "1f4a4", desc: "Sleeping Symbol"}, {code: "1f4a2", desc: "Anger Symbol"}, {
        code: "1f4a3",
        desc: "Bomb"
      }, {code: "1f4a5", desc: "Collision Symbol"}, {code: "1f4a6", desc: "Splashing Sweat Symbol"}, {
        code: "1f4a8",
        desc: "Dash Symbol"
      }, {code: "1f4ab", desc: "Dizzy Symbol"}, {code: "1f4ab", desc: "Dizzy Symbol"}, {
        code: "1f4ac",
        desc: "Speech Balloon"
      }, {code: "1f4ad", desc: "Thought Balloon"}, {code: "1f453", desc: "Eyeglasses"}, {
        code: "1f454",
        desc: "Necktie"
      }, {code: "1f455", desc: "T-Shirt"}, {code: "1f456", desc: "Jeans"}, {
        code: "1f457",
        desc: "Dress"
      }, {code: "1f458", desc: "Kimono"}, {code: "1f459", desc: "Bikini"}, {
        code: "1f45a",
        desc: "Womans Clothes"
      }, {code: "1f45b", desc: "Purse"}, {code: "1f45c", desc: "Handbag"}, {
        code: "1f45d",
        desc: "Pouch"
      }, {code: "1f392", desc: "School Satchel"}, {code: "1f45e", desc: "Mans Shoe"}, {
        code: "1f45f",
        desc: "Athletic Shoe"
      }, {code: "1f460", desc: "High-Heeled Shoe"}, {code: "1f461", desc: "Womans Sandal"}, {
        code: "1f462",
        desc: "Womans Boots"
      }, {code: "1f451", desc: "Crown"}, {code: "1f452", desc: "Womans Hat"}, {
        code: "1f462",
        desc: "Top Hat"
      }, {code: "1f393", desc: "Graduation Cap"}, {code: "1f484", desc: "Lipstick"}, {
        code: "1f48d",
        desc: "Ring"
      }, {code: "1f48e", desc: "Gem Stone"}]
    }, {
      id: "nature",
      name: "Animals & Nature",
      code: "1F435",
      emoticons: [{code: "1F435", desc: "Monkey Face"}, {code: "1F412", desc: "Monkey"}, {
        code: "1F436",
        desc: "Dog Face"
      }, {code: "1F415", desc: "Dog"}, {code: "1F429", desc: "Poodle"}, {
        code: "1F43A",
        desc: "Wolf Face"
      }, {code: "1F431", desc: "Cat Face"}, {code: "1F408", desc: "Cat"}, {
        code: "1F42F",
        desc: "Tiger Face"
      }, {code: "1F405", desc: "Tiger"}, {code: "1F406", desc: "Leopard"}, {
        code: "1F434",
        desc: "Horse Face"
      }, {code: "1F40E", desc: "Horse"}, {code: "1F42E", desc: "Cow Face"}, {code: "1F402", desc: "Ox"}, {
        code: "1F403",
        desc: "Water Buffalo"
      }, {code: "1F404", desc: "Cow"}, {code: "1F437", desc: "Pig Face"}, {code: "1F416", desc: "Pig"}, {
        code: "1F417",
        desc: "Boar"
      }, {code: "1F43D", desc: "Pig Nose"}, {code: "1F40F", desc: "Ram"}, {
        code: "1F411",
        desc: "Sheep"
      }, {code: "1F410", desc: "Goat"}, {code: "1F42A", desc: "Dromedary Camel"}, {
        code: "1F42B",
        desc: "Bactrian Camel"
      }, {code: "1F418", desc: "Elephant"}, {code: "1F42D", desc: "Mouse Face"}, {
        code: "1F401",
        desc: "Mouse"
      }, {code: "1F400", desc: "Rat"}, {code: "1F439", desc: "Hamster Face"}, {
        code: "1F430",
        desc: "Rabbit Face"
      }, {code: "1F407", desc: "Rabbit"}, {code: "1F43B", desc: "Bear Face"}, {
        code: "1F428",
        desc: "Koala"
      }, {code: "1F43C", desc: "Panda Face"}, {code: "1F43E", desc: "Paw Prints"}, {
        code: "1F414",
        desc: "Chicken"
      }, {code: "1F413", desc: "Rooster"}, {code: "1F423", desc: "Hatching Chick"}, {
        code: "1F424",
        desc: "Baby Chick"
      }, {code: "1F425", desc: "Front-Facing Baby Chick"}, {code: "1F426", desc: "Bird"}, {
        code: "1F427",
        desc: "Penguin"
      }, {code: "1F438", desc: "Frog Face"}, {code: "1F40A", desc: "Crocodile"}, {
        code: "1F422",
        desc: "Turtle"
      }, {code: "1F40D", desc: "Snake"}, {code: "1F432", desc: "Dragon Face"}, {
        code: "1F409",
        desc: "Dragon"
      }, {code: "1F433", desc: "Spouting Whale"}, {code: "1F40B", desc: "Whale"}, {
        code: "1F42C",
        desc: "Dolphin"
      }, {code: "1F41F", desc: "Fish"}, {code: "1F420", desc: "Tropical Fish"}, {
        code: "1F421",
        desc: "Blowfish"
      }, {code: "1F419", desc: "Octopus"}, {code: "1F41A", desc: "Spiral Shell"}, {
        code: "1F40C",
        desc: "Snail"
      }, {code: "1F41B", desc: "Bug"}, {code: "1F41C", desc: "Ant"}, {code: "1F41D", desc: "Honeybee"}, {
        code: "1F41E",
        desc: "Lady Beetle"
      }, {code: "1F490", desc: "Bouquet"}, {code: "1F338", desc: "Cherry Blossom"}, {
        code: "1F4AE",
        desc: "White Flower"
      }, {code: "1F339", desc: "Rose"}, {code: "1F33A", desc: "Hibiscus"}, {
        code: "1F33B",
        desc: "Sunflower"
      }, {code: "1F33C", desc: "Blossom"}, {code: "1F337", desc: "Tulip"}, {
        code: "1F331",
        desc: "Seedling"
      }, {code: "1F332", desc: "Evergreen Tree"}, {code: "1F333", desc: "Deciduous Tree"}, {
        code: "1F334",
        desc: "Palm Tree"
      }, {code: "1F335", desc: "Cactus"}, {code: "1F33E", desc: "Ear of Rice"}, {
        code: "1F33F",
        desc: "Herb"
      }, {code: "2618", desc: "Four Leaf Clover"}, {code: "1F341", desc: "Maple Leaf"}, {
        code: "1F342",
        desc: "Fallen Leaf"
      }, {code: "1F343", desc: "Leaf Fluttering in Wind"}]
    }, {
      id: "foods",
      name: "Food & Drink",
      code: "1F347",
      emoticons: [{code: "1F347", desc: "Grapes"}, {code: "1F348", desc: "Melon"}, {
        code: "1F349",
        desc: "Watermelon"
      }, {code: "1F34A", desc: "Tangerine"}, {code: "1F34B", desc: "Lemon"}, {
        code: "1F34C",
        desc: "Banana"
      }, {code: "1F34D", desc: "Pineapple"}, {code: "1F34E", desc: "Red Apple"}, {
        code: "1F34F",
        desc: "Green Apple"
      }, {code: "1F350", desc: "Pear"}, {code: "1F351", desc: "Peach"}, {
        code: "1F352",
        desc: "Cherries"
      }, {code: "1F353", desc: "Strawberry"}, {code: "1F345", desc: "Tomato"}, {
        code: "1F346",
        desc: "Aubergine"
      }, {code: "1F33D", desc: "Ear of Maize"}, {code: "1F344", desc: "Mushroom"}, {
        code: "1F330",
        desc: "Chestnut"
      }, {code: "1F35E", desc: "Bread"}, {code: "1F356", desc: "Meat on Bone"}, {
        code: "1F357",
        desc: "Poultry Leg"
      }, {code: "1F354", desc: "Hamburger"}, {code: "1F35F", desc: "French Fries"}, {
        code: "1F355",
        desc: "Slice of Pizza"
      }, {code: "1F373", desc: "Cooking"}, {code: "1F372", desc: "Pot of Food"}, {
        code: "1F371",
        desc: "Bento Box"
      }, {code: "1F358", desc: "Rice Cracker"}, {code: "1F359", desc: "Rice Ball"}, {
        code: "1F35A",
        desc: "Cooked Rice"
      }, {code: "1F35B", desc: "Curry and Rice"}, {code: "1F35C", desc: "Steaming Bowl"}, {
        code: "1F35D",
        desc: "Spaghetti"
      }, {code: "1F360", desc: "Roasted Sweet Potato"}, {code: "1F362", desc: "Oden"}, {
        code: "1F363",
        desc: "Sushi"
      }, {code: "1F364", desc: "Fried Shrimp"}, {code: "1F365", desc: "Fish Cake with Swirl Design"}, {
        code: "1F361",
        desc: "Dango"
      }, {code: "1F366", desc: "Soft Ice Cream"}, {code: "1F367", desc: "Shaved Ice"}, {
        code: "1F368",
        desc: "Ice Cream"
      }, {code: "1F369", desc: "Doughnut"}, {code: "1F36A", desc: "Cookie"}, {
        code: "1F382",
        desc: "Birthday Cake"
      }, {code: "1F370", desc: "Shortcake"}, {code: "1F36B", desc: "Chocolate Bar"}, {
        code: "1F36C",
        desc: "Candy"
      }, {code: "1F36D", desc: "Lollipop"}, {code: "1F36E", desc: "Custard"}, {
        code: "1F36F",
        desc: "Honey Pot"
      }, {code: "1F37C", desc: "Baby Bottle"}, {code: "2615", desc: "Hot Beverage"}, {
        code: "1F375",
        desc: "Teacup Without Handle"
      }, {code: "1F376", desc: "Sake Bottle and Cup"}, {code: "1F377", desc: "Wine Glass"}, {
        code: "1F378",
        desc: "Cocktail Glass"
      }, {code: "1F379", desc: "Tropical Drink"}, {code: "1F37A", desc: "Beer Mug"}, {
        code: "1F37B",
        desc: "Clinking Beer Mugs"
      }, {code: "1F374", desc: "Fork and Knife"}, {code: "1F52A", desc: "Hocho"}]
    }, {
      id: "activity",
      name: "Activities",
      code: "1f383",
      emoticons: [{code: "1f383", desc: " Jack-O-Lantern"}, {code: "1f384", desc: "Christmas Tree"}, {
        code: "1f386",
        desc: " Fireworks"
      }, {code: "1f387", desc: "Firework Sparkler"}, {code: "2728", desc: " Sparkles"}, {
        code: "1f388",
        desc: "Balloon"
      }, {code: "1f389", desc: "Party Popper"}, {code: "1f38a", desc: "Confetti Ball"}, {
        code: "1f38b",
        desc: "Tanabata Tree"
      }, {code: "1f38d", desc: "Pine Decoration"}, {code: "1f38e", desc: "Japanese Dolls"}, {
        code: "1f38f",
        desc: "Carp Streamer"
      }, {code: "1f390", desc: "Wind Chime"}, {code: "1f391", desc: "Moon Viewing Ceremony"}, {
        code: "1f380",
        desc: "Ribbon"
      }, {code: "1f381", desc: "Wrapped Present"}, {code: "1f3ab", desc: "Ticket"}, {
        code: "1f3c6",
        desc: "Trophy"
      }, {code: "1f388", desc: "Balloon"}, {code: "26bd", desc: "Soccer Ball"}, {
        code: "26be",
        desc: "Baseball"
      }, {code: "1f3c0", desc: "Basketball and Hoop"}, {code: "1f3c8", desc: "American Football"}, {
        code: "1f3c9",
        desc: "Rugby Football"
      }, {code: "1f3be", desc: "Tennis Racquet and Ball"}, {code: "1f3b1", desc: "Billiards"}, {
        code: "1f3b3",
        desc: "Bowling"
      }, {code: "1f3af", desc: "Direct Hit"}, {code: "26f3", desc: "Flag in Hole"}, {
        code: "1f3a3",
        desc: "Fishing Pole and Fish"
      }, {code: "1f3bd", desc: "Running Shirt with Sash"}, {code: "1f3bf", desc: "Ski and Ski Boot"}, {
        code: "1f3ae",
        desc: "Video Game"
      }, {code: "1f3b2", desc: "Game Die"}, {code: "2660", desc: "Black Spade Suit"}, {
        code: "2665",
        desc: "Black Heart SuiT"
      }, {code: "2666", desc: "Black Diamond Suit"}, {code: "2663", desc: "Black Club Suit"}, {
        code: "1f0cf",
        desc: "Playing Card Black Joker"
      }, {code: "1f004", desc: "Mahjong Tile Red Dragon"}, {code: "1f3b4", desc: "Flower Playing Cards"}]
    }, {
      id: "places",
      name: "Travel & Places",
      code: "1f30d",
      emoticons: [{code: "1f30d", desc: "Earth Globe Europe-Africa"}, {
        code: "1f30e",
        desc: "Earth Globe Americas"
      }, {code: "1f30f", desc: "Earth Globe Asia-Australia"}, {
        code: "1f310",
        desc: "Globe with Meridians"
      }, {code: "1f5fe", desc: "Silhouette of Japan"}, {code: "1f30b", desc: "Volcano"}, {
        code: "1f5fb",
        desc: "Mount Fuji"
      }, {code: "1f3e0", desc: "House Building"}, {code: "1f3e1", desc: "House with Garden"}, {
        code: "1f3e2",
        desc: "Office Building"
      }, {code: "1f3e3", desc: "Japanese Post Office"}, {code: "1f3e4", desc: "European Post Office"}, {
        code: "1f3e5",
        desc: "Hospital"
      }, {code: "1f3e6", desc: "Bank"}, {code: "1f3e8", desc: "Hotel"}, {
        code: "1f3e9",
        desc: "Love Hotel"
      }, {code: "1f3ea", desc: "Convenience Store"}, {code: "1f3eb", desc: "School"}, {
        code: "1f3ec",
        desc: "Department Store"
      }, {code: "1f3ed", desc: "Factory"}, {code: "1f3ef", desc: "Japanese Castle"}, {
        code: "1f3f0",
        desc: "European Castle"
      }, {code: "1f492", desc: "Wedding"}, {code: "1f5fc", desc: "Tokyo Tower"}, {
        code: "1f5fd",
        desc: "Statue of Liberty"
      }, {code: "26ea", desc: "Church"}, {code: "26f2", desc: "Fountain"}, {code: "26fa", desc: "Tent"}, {
        code: "1f301",
        desc: "Foggy"
      }, {code: "1f303", desc: "Night with Stars"}, {code: "1f304", desc: "Sunrise over Mountains"}, {
        code: "1f305",
        desc: "Sunrise"
      }, {code: "1f306", desc: "Cityscape at Dusk"}, {code: "1f307", desc: "Sunset over Buildings"}, {
        code: "1f309",
        desc: "Bridge at Night"
      }, {code: "2668", desc: "Hot Springs"}, {code: "1f30c", desc: "Milky Way"}, {
        code: "1f3a0",
        desc: "Carousel Horse"
      }, {code: "1f3a1", desc: "Ferris Wheel"}, {code: "1f3a2", desc: "Roller Coaster"}, {
        code: "1f488",
        desc: "Barber Pole"
      }, {code: "1f3aa", desc: "Circus Tent"}, {code: "1f3ad", desc: "Performing Arts"}, {
        code: "1f3a8",
        desc: "Artist Palette"
      }, {code: "1f3b0", desc: "Slot Machine"}, {code: "1f682", desc: "Steam Locomotive"}, {
        code: "1f683",
        desc: "Railway Car"
      }, {code: "1f684", desc: "High-Speed Train"}, {
        code: "1f685",
        desc: "High-Speed Train with Bullet Nose"
      }, {code: "1f686", desc: "Train"}, {code: "1f687", desc: "Metro"}, {
        code: "1f688",
        desc: "Light Rail"
      }, {code: "1f689", desc: "Station"}, {code: "1f68a", desc: "Tram"}, {
        code: "1f69d",
        desc: "Monorail"
      }, {code: "1f69e", desc: "Mountain Railway"}, {code: "1f68b", desc: "Tram Car"}, {
        code: "1f68c",
        desc: "Bus"
      }, {code: "1f68d", desc: "Oncoming Bus"}, {code: "1f68e", desc: "Trolleybus"}, {
        code: "1f690",
        desc: "Minibus"
      }, {code: "1f691", desc: "Ambulance"}, {code: "1f692", desc: "Fire Engine"}, {
        code: "1f693",
        desc: "Police Car"
      }, {code: "1f694", desc: "Oncoming Police Car"}, {code: "1f695", desc: "Taxi"}, {
        code: "1f695",
        desc: "Oncoming Taxi"
      }, {code: "1f697", desc: "Automobile"}, {code: "1f698", desc: "Oncoming Automobile"}, {
        code: "1f699",
        desc: "Recreational Vehicle"
      }, {code: "1f69a", desc: "Delivery Truck"}, {code: "1f69b", desc: "Articulated Lorry"}, {
        code: "1f69c",
        desc: "Tractor"
      }, {code: "1f6b2", desc: "Bicycle"}, {code: "1f68f", desc: "Bus Stop"}, {
        code: "26fd",
        desc: "Fuel Pump"
      }, {code: "1f6a8", desc: "Police Cars Revolving Light"}, {
        code: "1f6a5",
        desc: "Horizontal Traffic Light"
      }, {code: "1f6a6", desc: "Vertical Traffic Light"}, {code: "1f6a7", desc: "Construction Sign"}, {
        code: "2693",
        desc: "Anchor"
      }, {code: "26f5", desc: "Sailboat"}, {code: "1f6a4", desc: "Speedboat"}, {
        code: "1f6a2",
        desc: "Ship"
      }, {code: "2708", desc: "Airplane"}, {code: "1f4ba", desc: "Seat"}, {
        code: "1f681",
        desc: "Helicopter"
      }, {code: "1f69f", desc: "Suspension Railway"}, {code: "1f6a0", desc: "Mountain Cableway"}, {
        code: "1f6a1",
        desc: "Aerial Tramway"
      }, {code: "1f680", desc: "Rocket"}, {code: "1f6aa", desc: "Door"}, {
        code: "1f6bd",
        desc: "Toilet"
      }, {code: "1f6bf", desc: "Shower"}, {code: "1f6c1", desc: "Bathtub"}, {
        code: "231b",
        desc: "Hourglass"
      }, {code: "23f3", desc: "Hourglass with Flowing Sand"}, {code: "231a", desc: "Watch"}, {
        code: "23f0",
        desc: "Alarm Clock"
      }, {code: "1f55b", desc: "Clock Face Twelve Oclock"}, {
        code: "1f567",
        desc: "Clock Face Twelve-Thirty"
      }, {code: "1f550", desc: "Clock Face One Oclock"}, {code: "1f55c", desc: "Clock Face One-thirty"}, {
        code: "1f551",
        desc: "Clock Face Two Oclock"
      }, {code: "1f55d", desc: "Clock Face Two-thirty"}, {
        code: "1f552",
        desc: "Clock Face Three Oclock"
      }, {code: "1f55e", desc: "Clock Face Three-thirty"}, {
        code: "1f553",
        desc: "Clock Face Four Oclock"
      }, {code: "1f55f", desc: "Clock Face Four-thirty"}, {
        code: "1f554",
        desc: "Clock Face Five Oclock"
      }, {code: "1f560", desc: "Clock Face Five-thirty"}, {
        code: "1f555",
        desc: "Clock Face Six Oclock"
      }, {code: "1f561", desc: "Clock Face Six-thirty"}, {
        code: "1f556",
        desc: "Clock Face Seven Oclock"
      }, {code: "1f562", desc: "Clock Face Seven-thirty"}, {
        code: "1f557",
        desc: "Clock Face Eight Oclock"
      }, {code: "1f563", desc: "Clock Face Eight-thirty"}, {
        code: "1f558",
        desc: "Clock Face Nine Oclock"
      }, {code: "1f564", desc: "Clock Face Nine-thirty"}, {
        code: "1f559",
        desc: "Clock Face Ten Oclock"
      }, {code: "1f565", desc: "Clock Face Ten-thirty"}, {
        code: "1f55a",
        desc: "Clock Face Eleven Oclock"
      }, {code: "1f566", desc: "Clock Face Eleven-thirty"}, {code: "1f311", desc: "New Moon Symbol"}, {
        code: "1f312",
        desc: "Waxing Crescent Moon Symbol"
      }, {code: "1f313", desc: "First Quarter Moon Symbol"}, {
        code: "1f314",
        desc: "Waxing Gibbous Moon Symbol"
      }, {code: "1f315", desc: "Full Moon Symbol"}, {code: "1f316", desc: "Waning Gibbous Moon Symbol"}, {
        code: "1f317",
        desc: "Last Quarter Moon Symbol"
      }, {code: "1f318", desc: "Waning Crescent Moon Symbol"}, {code: "1f319", desc: "Crescent Moon"}, {
        code: "1f31a",
        desc: "New Moon with Face"
      }, {code: "1f31b", desc: "First Quarter Moon with Face"}, {
        code: "1f31c",
        desc: "Last Quarter Moon with Face"
      }, {code: "2600", desc: "Black Sun with Rays"}, {code: "1f31d", desc: "Full Moon with Face"}, {
        code: "1f31e",
        desc: "Sun with Face"
      }, {code: "2b50", desc: "White Medium Star"}, {code: "1f31f", desc: "Glowing Star"}, {
        code: "1f320",
        desc: "Shooting Star"
      }, {code: "2601", desc: "Cloud"}, {code: "26c5", desc: "Sun Behind Cloud"}, {
        code: "1f300",
        desc: "Cyclone"
      }, {code: "1f308", desc: "Rainbow"}, {code: "1f302", desc: "Closed Umbrella"}, {
        code: "2614",
        desc: "Umbrella with Rain Drops"
      }, {code: "26a1", desc: "High Voltage Sign"}, {code: "2744", desc: "Snowflake"}, {
        code: "2603",
        desc: "Snowman Without Snow"
      }, {code: "1f525", desc: "Fire"}, {code: "1f4a7", desc: "Droplet"}, {code: "1F30A", desc: "Water Wave"}]
    }, {
      id: "objects",
      name: "Objects",
      code: "1F507",
      emoticons: [{code: "1F507", desc: "Speaker with Cancellation Stroke"}, {
        code: "1F508",
        desc: "Speaker"
      }, {code: "1F509", desc: "Speaker with One Sound Wave"}, {
        code: "1F50A",
        desc: "Speaker with Three Sound Wave"
      }, {code: "1F4E2", desc: "Public Address Loudspeaker"}, {
        code: "1F4E3",
        desc: "Cheering Megaphone"
      }, {code: "1F4EF", desc: "Postal Horn"}, {code: "1F514", desc: "Bell"}, {
        code: "1F515",
        desc: "Bell with Cancellation Stroke"
      }, {code: "1F3BC", desc: "Musical Score"}, {code: "1F3B5", desc: "Musical Note"}, {
        code: "1F3B6",
        desc: "Multiple Musical Notes"
      }, {code: "1F3A4", desc: "Microphone"}, {code: "1F3A7", desc: "Headphone"}, {
        code: "1F4FB",
        desc: "Radio"
      }, {code: "1F3B7", desc: "Saxophone"}, {code: "1F3B8", desc: "Guitar"}, {
        code: "1F3B9",
        desc: "Musical Keyboard"
      }, {code: "1F3BA", desc: "Trumpet"}, {code: "1F3BB", desc: "Violin"}, {
        code: "1F4F1",
        desc: "Mobile Phone"
      }, {code: "1F4F2", desc: "Mobile Phone with Rightwards Arrow at Left"}, {
        code: "260E",
        desc: "Black Telephone"
      }, {code: "1F4DE", desc: "Telephone Receiver"}, {code: "1F4DF", desc: "Pager"}, {
        code: "1F4E0",
        desc: "Fax Machine"
      }, {code: "1F50B", desc: "Battery"}, {code: "1F50C", desc: "Electric Plug"}, {
        code: "1F4BB",
        desc: "Personal Computer"
      }, {code: "1F4BD", desc: "Minidisc"}, {code: "1F4BE", desc: "Floppy Disk"}, {
        code: "1F4BF",
        desc: "Optical Disk"
      }, {code: "1F4C0", desc: "Dvd"}, {code: "1F3A5", desc: "Movie Camera"}, {
        code: "1F3AC",
        desc: "Clapper Board"
      }, {code: "1F4FA", desc: "Television"}, {code: "1F4F7", desc: "Camera"}, {
        code: "1F4F9",
        desc: "Video Camera"
      }, {code: "1F4FC", desc: "Videocassette"}, {
        code: "1F50D",
        desc: "Left-Pointing Magnifying Glass"
      }, {code: "1F50E", desc: "Right-Pointing Magnifying Glass"}, {code: "1F52C", desc: "Microscope"}, {
        code: "1F52D",
        desc: "Telelscope"
      }, {code: "1F4E1", desc: "Satellite Antenna"}, {code: "1F4A1", desc: "Electric Light Bulb"}, {
        code: "1F526",
        desc: "Electric Torch"
      }, {code: "1F3EE", desc: "Izakaya Lantern"}, {
        code: "1F4D4",
        desc: "Notebook with Decorative Cover"
      }, {code: "1F4D5", desc: "Closed Book"}, {code: "1F4D6", desc: "Open Book"}, {
        code: "1F4D7",
        desc: "Green Book"
      }, {code: "1F4D8", desc: "Blue Book"}, {code: "1F4D9", desc: "Orange Book"}, {
        code: "1F4DA",
        desc: "Books"
      }, {code: "1F4D3", desc: "Notebook"}, {code: "1F4D2", desc: "Ledger"}, {
        code: "1F4C3",
        desc: "Curl"
      }, {code: "1F4DC", desc: "Scroll"}, {code: "1F4C4", desc: "Page Facing Up"}, {
        code: "1F4F0",
        desc: "Newspaper"
      }, {code: "1F4D1", desc: "Bookmark Tabs"}, {code: "1F516", desc: "Bookmark"}, {
        code: "1F4B0",
        desc: "Money Bag"
      }, {code: "1F4B4", desc: "Banknote with Yen Sign"}, {
        code: "1F4B5",
        desc: "Banknote with Dollar Sign"
      }, {code: "1F4B6", desc: "Banknote with Euro Sign"}, {
        code: "1F4B7",
        desc: "Banknote with Pound Sign"
      }, {code: "1F4B8", desc: "Money with Wings"}, {code: "1F4B3", desc: "Credit Card"}, {
        code: "1F4B9",
        desc: "Chart with Upwards Trend and Yen Sign"
      }, {code: "1F4B1", desc: "Currency Exchange"}, {code: "1F4B2", desc: "Heavy Dollar Sign"}, {
        code: "2709",
        desc: "Envelope"
      }, {code: "1F4E7", desc: "E-Mail Symbol"}, {code: "1F4E8", desc: "Incoming Envelope"}, {
        code: "1F4E9",
        desc: "Envelope with Downwards Arrow Above"
      }, {code: "1F4E4", desc: "Outbox Tray"}, {code: "1F4E5", desc: "Inbox Tray"}, {
        code: "1F4E6",
        desc: "Package"
      }, {code: "1F4BE", desc: "Closed Mailbox with Raised Flag"}, {
        code: "1F4EA",
        desc: "Closed Mailbox with Lowered Flag"
      }, {code: "1F4EC", desc: "Open Mailbox with Raised Flag"}, {
        code: "1F4ED",
        desc: "Open Mailbox with Lowered Flag"
      }, {code: "1F5F3", desc: "Postbox"}, {code: "270F", desc: "Pencil"}, {
        code: "2712",
        desc: "Black Nib"
      }, {code: "1F4DD", desc: "Memo"}, {code: "1F4BC", desc: "Briefcase"}, {
        code: "1F4C1",
        desc: "File Folder"
      }, {code: "1F4C2", desc: "Open File Folder"}, {code: "1F4C5", desc: "Calender"}, {
        code: "1F4C6",
        desc: "Tear-off Calender"
      }, {code: "1F4C7", desc: "Card Index"}, {code: "1F4C8", desc: "Chart with Upwards Trend"}, {
        code: "1F4C9",
        desc: "Chart with Downwards Trend"
      }, {code: "1F4CA", desc: "Bar Chart"}, {code: "1F4CB", desc: "Clipboard"}, {
        code: "1F4CC",
        desc: "Pushpin"
      }, {code: "1F4CD", desc: "Round Pushpin"}, {code: "1F4CE", desc: "Paperclip"}, {
        code: "1F4CF",
        desc: "Straight Ruler"
      }, {code: "1F4D0", desc: "Triangular Ruler"}, {code: "2702", desc: "Black Scissors"}, {
        code: "1F512",
        desc: "Lock"
      }, {code: "1F513", desc: "Open Lock"}, {code: "1F50F", desc: "Lock with Ink Pen"}, {
        code: "1F510",
        desc: "Closed Lock with Key"
      }, {code: "1F511", desc: "Key"}, {code: "1F528", desc: "Hammer"}, {code: "1F52B", desc: "Pistol"}, {
        code: "1F527",
        desc: "Wrench"
      }, {code: "1F529", desc: "Nut and Bolt"}, {code: "1F517", desc: "Link Symbol"}, {
        code: "1F489",
        desc: "Syringe"
      }, {code: "1F48A", desc: "Pill"}, {code: "1F6AC", desc: "Smoking Symbol"}, {
        code: "1F5FF",
        desc: "Moyai"
      }, {code: "1F52E", desc: "Crystal Ball"}]
    }, {
      id: "symbols",
      name: "Symbols",
      code: "1F3E7",
      emoticons: [{code: "1F3E7", desc: "Automated Teller Machine"}, {
        code: "1F6AE",
        desc: "Put Litter in Its Place Symbol"
      }, {code: "1F6B0", desc: "Potable Water Symbol"}, {code: "267F", desc: "Wheelchair Symbol"}, {
        code: "1F6B9",
        desc: "Mens Symbol"
      }, {code: "1F6BA", desc: "Womens Symbol"}, {code: "1F6BB", desc: "Restroom"}, {
        code: "1F6BC",
        desc: "Baby Symbol"
      }, {code: "1F6BE", desc: "Water Closet"}, {code: "1F6C2", desc: "Passport Control"}, {
        code: "1F6C3",
        desc: "Customs"
      }, {code: "1F6C4", desc: "Baggage Claim"}, {code: "1F6C5", desc: "Left Luggage"}, {
        code: "26A0",
        desc: "Warning Sign"
      }, {code: "1F6B8", desc: "Children Crossing"}, {code: "26D4", desc: "No Entry"}, {
        code: "1F6AB",
        desc: "No Entry Sign"
      }, {code: "1F6B3", desc: "No Bicycles"}, {code: "1F6AD", desc: "No Smoking Symbol"}, {
        code: "1F6AF",
        desc: "Do Not Litter Symbol"
      }, {code: "1F6B1", desc: "Non-Potable Water Symbol"}, {code: "1F6B7", desc: "No Pedestrians"}, {
        code: "1F4F5",
        desc: "No Mobile Phones"
      }, {code: "1F51E", desc: "No One Under Eighteen Symbol"}, {
        code: "2B06",
        desc: "Upwards Black Arrow"
      }, {code: "2197", desc: "North East Arrow"}, {code: "27A1", desc: "Black Rightwards Arrow"}, {
        code: "2198",
        desc: "South East Arrow"
      }, {code: "2B07", desc: "Downwards Black Arrow"}, {code: "2199", desc: "South West Arrow"}, {
        code: "2B05",
        desc: "Leftwards Black Arrow"
      }, {code: "2196", desc: "North West Arrow"}, {code: "2195", desc: "Up Down Arrow"}, {
        code: "2194",
        desc: "Left Right Arrow"
      }, {code: "21A9", desc: "Leftwards Arrow with Hook"}, {
        code: "21AA",
        desc: "Rightwards Arrow with Hook"
      }, {code: "2934", desc: "Arrow Pointing Rightwards Then Curving Upwards"}, {
        code: "2935",
        desc: "Arrow Pointing Rightwards Then Curving Downwards"
      }, {code: "1F503", desc: "Clockwise Downwards and Upwards Open Circle Arrows"}, {
        code: "1F504",
        desc: "Anticlockwise Downwards and Upwards Open Circle Arrows"
      }, {code: "1F519", desc: "Back with Leftwards Arrow Above"}, {
        code: "1F51A",
        desc: "End with Leftwards Arrow Above"
      }, {code: "1F51B", desc: "On with Exclamation Mark with Left Right Arrow Above"}, {
        code: "1F51C",
        desc: "Soon with Rightwards Arrow Above"
      }, {code: "1F51D", desc: "Top with Upwards Arrow Above"}, {
        code: "1F52F",
        desc: "Six Pointed Star with Middle Dot"
      }, {code: "2648", desc: "Aries"}, {code: "2649", desc: "Taurus"}, {code: "264A", desc: "Gemini"}, {
        code: "264B",
        desc: "Cancer"
      }, {code: "264C", desc: "Leo"}, {code: "264D", desc: "Virgo"}, {code: "264E", desc: "Libra"}, {
        code: "264F",
        desc: "Scorpius"
      }, {code: "2650", desc: "Sagittarius"}, {code: "2651", desc: "Capricorn"}, {
        code: "2652",
        desc: "Aquarius"
      }, {code: "2653", desc: "Pisces"}, {code: "26CE", desc: "Ophiuchus"}, {
        code: "1F500",
        desc: "Twisted Rightwards Arrows"
      }, {code: "1F501", desc: "Clockwise Rightwards and Leftwards Open Circle Arrows"}, {
        code: "1F502",
        desc: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay"
      }, {code: "25B6", desc: "Black Right-Pointing Triangle"}, {
        code: "23E9",
        desc: "Black Right-Pointing Double Triangle"
      }, {code: "25C0", desc: "Black Left-Pointing Triangle"}, {
        code: "23EA",
        desc: "Black Left-Pointing Double Triangle"
      }, {code: "1F53C", desc: "Up-Pointing Small Red Triangle"}, {
        code: "23EB",
        desc: "Black Up-Pointing Double Triangle"
      }, {code: "1F53D", desc: "Down-Pointing Small Red Triangle"}, {
        code: "23EC",
        desc: "Black Down-Pointing Double Triangle"
      }, {code: "1F3A6", desc: "Cinema"}, {code: "1F505", desc: "Low Brightness Symbol"}, {
        code: "1F506",
        desc: "High Brightness Symbol"
      }, {code: "1F4F6", desc: "Antenna with Bars"}, {code: "1F4F3", desc: "Vibration Mode"}, {
        code: "1F4F4",
        desc: "Mobile Phone off"
      }, {code: "267B", desc: "Black Universal Recycling Symbol"}, {
        code: "1F531",
        desc: "Trident Emblem"
      }, {code: "1F4DB", desc: "Name Badge"}, {code: "1F530", desc: "Japanese Symbol for Beginner"}, {
        code: "2B55",
        desc: "Heavy Large Circle"
      }, {code: "2705", desc: "White Heavy Check Mark"}, {code: "2611", desc: "Ballot Box with Check"}, {
        code: "2714",
        desc: "Heavy Check Mark"
      }, {code: "2716", desc: "Heavy Multiplication X"}, {code: "274C", desc: "Cross Mark"}, {
        code: "274E",
        desc: "Negative Squared Cross Mark"
      }, {code: "2795", desc: "Heavy Plus Sign"}, {code: "2796", desc: "Heavy Minus Sign"}, {
        code: "2797",
        desc: "Heavy Division Sign"
      }, {code: "27B0", desc: "Curly Loop"}, {code: "27BF", desc: "Double Curly Loop"}, {
        code: "303D",
        desc: "Part Alternation Mark"
      }, {code: "2733", desc: "Eight Spoked Asterisk"}, {code: "2734", desc: "Eight Pointed Black Star"}, {
        code: "2747",
        desc: "Sparkle"
      }, {code: "203C", desc: "Double Exclamation Mark"}, {
        code: "2049",
        desc: "Exclamation Question Mark"
      }, {code: "2753", desc: "Black Question Mark Ornament"}, {
        code: "2754",
        desc: "White Question Mark Ornament"
      }, {code: "2755", desc: "White Exclamation Mark Ornament"}, {
        code: "2757",
        desc: "Heavy Exclamation Mark Symbol"
      }, {code: "3030", desc: "Wavy Dash"}, {code: "2122", desc: "Trade Mark Sign"}, {
        code: "1F51F",
        desc: "Keycap Ten"
      }, {code: "1F4AF", desc: "Hundred Points Symbol"}, {
        code: "1F520",
        desc: "Input Symbol for Latin Capital Letters"
      }, {code: "1F521", desc: "Input Symbol for Latin Small Letters"}, {
        code: "1F522",
        desc: "Input Symbol for Numbers"
      }, {code: "1F523", desc: "Input Symbol for Symbols"}, {
        code: "1F524",
        desc: "Input Symbol for Latin Letters"
      }, {code: "1F170", desc: "Negative Squared Latin Capital Letter a"}, {
        code: "1F18E",
        desc: "Negative Squared Ab"
      }, {code: "1F171", desc: "Negative Squared Latin Capital Letter B"}, {
        code: "1F191",
        desc: "Squared Cl"
      }, {code: "1F192", desc: "Squared Cool"}, {code: "1F193", desc: "Squared Free"}, {
        code: "2139",
        desc: "Information Source"
      }, {code: "1F194", desc: "Squared Id"}, {code: "24C2", desc: "Circled Latin Capital Letter M"}, {
        code: "1F195",
        desc: "Squared New"
      }, {code: "1F196", desc: "Squared Ng"}, {
        code: "1F17E",
        desc: "Negative Squared Latin Capital Letter O"
      }, {code: "1F197", desc: "Squared Ok"}, {
        code: "1F17F",
        desc: "Negative Squared Latin Capital Letter P"
      }, {code: "1F198", desc: "Squared Sos"}, {
        code: "1F199",
        desc: "Squared Up with Exclamation Mark"
      }, {code: "1F19A", desc: "Squared Vs"}, {code: "1F201", desc: "Squared Katakana Koko"}, {
        code: "1F202",
        desc: "Squared Katakana Sa"
      }, {code: "1F237", desc: "Squared Cjk Unified Ideograph-6708"}, {
        code: "1F236",
        desc: "Squared Cjk Unified Ideograph-6709"
      }, {code: "1F22F", desc: "Squared Cjk Unified Ideograph-6307"}, {
        code: "1F250",
        desc: "Circled Ideograph Advantage"
      }, {code: "1F239", desc: "Squared Cjk Unified Ideograph-5272"}, {
        code: "1F21A",
        desc: "Squared Cjk Unified Ideograph-7121"
      }, {code: "1F232", desc: "Squared Cjk Unified Ideograph-7981"}, {
        code: "1F251",
        desc: "Circled Ideograph Accept"
      }, {code: "1F238", desc: "Squared Cjk Unified Ideograph-7533"}, {
        code: "1F234",
        desc: "Squared Cjk Unified Ideograph-5408"
      }, {code: "1F233", desc: "Squared Cjk Unified Ideograph-7a7a"}, {
        code: "3297",
        desc: "Circled Ideograph Congratulation"
      }, {code: "3299", desc: "Circled Ideograph Secret"}, {
        code: "1F23A",
        desc: "Squared Cjk Unified Ideograph-55b6"
      }, {code: "1F235", desc: "Squared Cjk Unified Ideograph-6e80"}, {
        code: "25AA",
        desc: "Black Small Square"
      }, {code: "25AB", desc: "White Small Square"}, {code: "25FB", desc: "White Medium Square"}, {
        code: "25FC",
        desc: "Black Medium Square"
      }, {code: "25FD", desc: "White Medium Small Square"}, {
        code: "25FE",
        desc: "Black Medium Small Square"
      }, {code: "2B1B", desc: "Black Large Square"}, {code: "2B1C", desc: "White Large Square"}, {
        code: "1F536",
        desc: "Large Orange Diamond"
      }, {code: "1F537", desc: "Large Blue Diamond"}, {code: "1F538", desc: "Small Orange Diamond"}, {
        code: "1F539",
        desc: "Small Blue Diamond"
      }, {code: "1F53A", desc: "Up-Pointing Red Triangle"}, {
        code: "1F53B",
        desc: "Down-Pointing Red Triangle"
      }, {code: "1F4A0", desc: "Diamond Shape with a Dot Inside"}, {
        code: "1F518",
        desc: "Radio Button"
      }, {code: "1F532", desc: "Black Square Button"}, {code: "1F533", desc: "White Square Button"}, {
        code: "26AA",
        desc: "Medium White Circle"
      }, {code: "26AB", desc: "Medium Black Circle"}, {code: "1F534", desc: "Large Red Circle"}, {
        code: "1F535",
        desc: "Large Blue Circle"
      }]
    }, {
      id: "flags",
      name: "Flags",
      code: "1F3C1",
      emoticons: [{code: "1f3c1", desc: "Chequered Flag"}, {code: "1f1e8-1f1f3", desc: "China Flag"}, {
        code: "1f38c",
        desc: "Crossed Flags"
      }, {code: "1f1e9-1f1ea", desc: "Germany Flag"}, {code: "1f1ea-1f1f8", desc: "Spain Flag"}, {
        code: "1f1e6-1f1e8",
        desc: "Ascension Island Flag"
      }, {code: "1f1e6-1f1e9", desc: "Andorra Flag"}, {
        code: "1f1e6-1f1ea",
        desc: "United Arab Emirates Flag"
      }, {code: "1f1e6-1f1eb", desc: "Afghanistan Flag"}, {
        code: "1f1e6-1f1ec",
        desc: "Antigua & Barbuda Flag"
      }, {code: "1f1e6-1f1ee", desc: "Anguilla Flag"}, {
        code: "1f1e6-1f1f1",
        desc: "Albania Flag"
      }, {code: "1f1e6-1f1f2", desc: "Armenia Flag"}, {code: "1f1e6-1f1f4", desc: "Angola Flag"}, {
        code: "1f1e6-1f1f6",
        desc: "Antarctica Flag"
      }, {code: "1f1e6-1f1f7", desc: "Argentina Flag"}, {
        code: "1f1e6-1f1f8",
        desc: "American Samoa Flag"
      }, {code: "1f1e6-1f1f9", desc: "Austria Flag"}, {
        code: "1f1e6-1f1fa",
        desc: "Australia Flag"
      }, {code: "1f1e6-1f1fc", desc: "Aruba Flag"}, {
        code: "1f1e6-1f1fd",
        desc: "\xc5land Islands Flag"
      }, {code: "1f1e6-1f1ff", desc: "Azerbaijan Flag"}, {
        code: "1f1e7-1f1e7",
        desc: "Barbados Flag"
      }, {code: "1f1e7-1f1e9", desc: "Bangladesh Flag"}, {
        code: "1f1e7-1f1ea",
        desc: "Belgium Flag"
      }, {code: "1f1e7-1f1eb", desc: "Burkina Faso Flag"}, {
        code: "1f1e7-1f1ec",
        desc: "Bulgaria Flag"
      }, {code: "1f1e7-1f1ed", desc: "Bahrain Flag"}, {code: "1f1e7-1f1ee", desc: "Burundi Flag"}, {
        code: "1f1e7-1f1ef",
        desc: "Benin Flag"
      }, {code: "1f1e7-1f1f1", desc: "St. Barth\xe9lemy Flag"}, {
        code: "1f1e7-1f1f2",
        desc: "Bermuda Flag"
      }, {code: "1f1e7-1f1f4", desc: "Bolivia Flag"}, {
        code: "1f1e7-1f1f6",
        desc: "Caribbean Netherlands Flag"
      }, {code: "1f1e7-1f1f7", desc: "Brazil Flag"}, {code: "1f1e7-1f1f8", desc: "Bahamas Flag"}, {
        code: "1f1e7-1f1f9",
        desc: "Bhutan Flag"
      }, {code: "1f1e7-1f1fb", desc: "Bouvet Island Flag"}, {
        code: "1f1e7-1f1fc",
        desc: "Botswana Flag"
      }, {code: "1f1e7-1f1fe", desc: "Belarus Flag"}, {code: "1f1e7-1f1ff", desc: "Belize Flag"}, {
        code: "1f1e8-1f1e6",
        desc: "Canada Flag"
      }, {code: "1f1e8-1f1e8", desc: "Cocos (keeling) Islands Flag"}, {
        code: "1f1e8-1f1e9",
        desc: "Congo - Kinshasa Flag"
      }, {code: "1f1e8-1f1eb", desc: "Central African Republic Flag"}, {
        code: "1f1e8-1f1ec",
        desc: "Congo - Brazzaville Flag"
      }, {code: "1f1e8-1f1ed", desc: "Switzerland Flag"}, {
        code: "1f1e8-1f1ee",
        desc: "C\xf4te D\u2019ivoire Flag"
      }, {code: "1f1e8-1f1f0", desc: "Cook Islands Flag"}, {
        code: "1f1e8-1f1f1",
        desc: "Chile Flag"
      }, {code: "1f1e8-1f1f2", desc: "Cameroon Flag"}, {
        code: "1f1e8-1f1f4",
        desc: "Colombia Flag"
      }, {code: "1f1e8-1f1f7", desc: "Costa Rica Flag"}, {code: "1f1e8-1f1fa", desc: "Cuba Flag"}, {
        code: "1f1e8-1f1fb",
        desc: "Cape Verde Flag"
      }, {code: "1f1e8-1f1fc", desc: "Cura\xe7ao Flag"}, {
        code: "1f1e8-1f1fd",
        desc: "Christmas Island Flag"
      }, {code: "1f1e8-1f1fe", desc: "Cyprus Flag"}, {code: "1f1e8-1f1ff", desc: 'Czechia Flag"'}, {
        code: "1f1e9-1f1ec",
        desc: "Diego Garcia Flag"
      }, {code: "1f1e9-1f1ef", desc: "Djibouti Flag"}, {
        code: "1f1e9-1f1f0",
        desc: "Denmark Flag"
      }, {code: "1f1e9-1f1f2", desc: "Dominica Flag"}, {
        code: "1f1e9-1f1f4",
        desc: "Dominican Republic Flag"
      }, {code: "1f1e9-1f1ff", desc: "Algeria Flag"}, {
        code: "1f1ea-1f1e6",
        desc: "Ceuta & Melilla Flag"
      }, {code: "1f1ea-1f1e8", desc: "Ecuador Flag"}, {code: "1f1ea-1f1ea", desc: "Estonia Flag"}, {
        code: "1f1ea-1f1ec",
        desc: "Egypt Flag"
      }, {code: "1f1ea-1f1ed", desc: "Western Sahara Flag"}, {
        code: "1f1ea-1f1f7",
        desc: "Eritrea Flag"
      }, {code: "1f1ea-1f1f9", desc: "Ethiopia Flag"}, {
        code: "1f1ea-1f1fa",
        desc: "European Union Flag"
      }, {code: "1f1eb-1f1ee", desc: "Finland Flag"}, {code: "1f1eb-1f1ef", desc: "Fiji Flag"}, {
        code: "1f1eb-1f1f0",
        desc: "Falkland Islands Flag"
      }, {code: "1f1eb-1f1f2", desc: "Micronesia Flag"}, {
        code: "1f1eb-1f1f4",
        desc: "Faroe Islands Flag"
      }, {code: "1f1ec-1f1e6", desc: "Gabon Flag"}, {code: "1f1ec-1f1e9", desc: "Grenada Flag"}, {
        code: "1f1ec-1f1ea",
        desc: "Georgia Flag"
      }, {code: "1f1ec-1f1eb", desc: "French Guiana Flag"}, {
        code: "1f1ec-1f1ec",
        desc: "Guernsey Flag"
      }, {code: "1f1ec-1f1ed", desc: "Ghana Flag"}, {code: "1f1ec-1f1ee", desc: "Gibraltar Flag"}, {
        code: "1f1ec-1f1f1",
        desc: "Greenland Flag"
      }, {code: "1f1ec-1f1f2", desc: "Gambia Flag"}, {code: "1f1ec-1f1f3", desc: "Guinea Flag"}, {
        code: "1f1ec-1f1f5",
        desc: "Guadeloupe Flag"
      }, {code: "1f1ec-1f1f6", desc: "Equatorial Guinea Flag"}, {
        code: "1f1ec-1f1f7",
        desc: "Greece Flag"
      }, {code: "1f1ec-1f1f8", desc: "South Georgia & South Sandwich Islands Flag"}, {
        code: "1f1ec-1f1f9",
        desc: "Guatemala Flag"
      }, {code: "1f1ec-1f1fa", desc: "Guam Flag"}, {
        code: "1f1ec-1f1fc",
        desc: "Guinea-Bissau Flag"
      }, {code: "1f1ec-1f1fe", desc: "Guyana Flag"}, {
        code: "1f1ed-1f1f0",
        desc: "Hong Kong Sar China Flag"
      }, {code: "1f1ed-1f1f2", desc: "Heard & Mcdonald Islands Flag"}, {
        code: "1f1ed-1f1f3",
        desc: "Honduras Flag"
      }, {code: "1f1ed-1f1f7", desc: "Croatia Flag"}, {code: "1f1ed-1f1f9", desc: "Haiti Flag"}, {
        code: "1f1ed-1f1fa",
        desc: "Hungary Flag"
      }, {code: "1f1ee-1f1e8", desc: "Canary Islands Flag"}, {
        code: "1f1ee-1f1e9",
        desc: "Indonesia Flag"
      }, {code: "1f1ee-1f1ea", desc: "Ireland Flag"}, {code: "1f1ee-1f1f1", desc: "Israel Flag"}, {
        code: "1f1ee-1f1f2",
        desc: "Isle of Man Flag"
      }, {code: "1f1ee-1f1f3", desc: "India Flag"}, {
        code: "1f1ee-1f1f4",
        desc: "British Indian Ocean Territory Flag"
      }, {code: "1f1ee-1f1f6", desc: "Iraq Flag"}, {code: "1f1ee-1f1f7", desc: "Iran Flag"}, {
        code: "1f1ee-1f1f8",
        desc: "Iceland Flag"
      }, {code: "1f1ef-1f1ea", desc: "Jersey Flag"}, {code: "1f1ef-1f1f2", desc: "Jamaica Flag"}, {
        code: "1f1ef-1f1f4",
        desc: "Jordan Flag"
      }, {code: "1f1f0-1f1ea", desc: "Kenya Flag"}, {
        code: "1f1f0-1f1ec",
        desc: "Kyrgyzstan Flag"
      }, {code: "1f1f0-1f1ed", desc: "Cambodia Flag"}, {
        code: "1f1f0-1f1ee",
        desc: "Kiribati Flag"
      }, {code: "1f1f0-1f1f2", desc: "Comoros Flag"}, {
        code: "1f1f0-1f1f3",
        desc: "St. Kitts & Nevis Flag"
      }, {code: "1f1f0-1f1f5", desc: "North Korea Flag"}, {
        code: "1f1f0-1f1fc",
        desc: "Kuwait Flag"
      }, {code: "1f1f0-1f1fe", desc: "Cayman Islands Flag"}, {
        code: "1f1f0-1f1ff",
        desc: "Kazakhstan Flag"
      }, {code: "1f1f1-1f1e6", desc: "Laos Flag"}, {code: "1f1f1-1f1e7", desc: "Lebanon Flag"}, {
        code: "1f1f1-1f1e8",
        desc: "St. Lucia Flag"
      }, {code: "1f1f1-1f1ee", desc: "Liechtenstein Flag"}, {
        code: "1f1f1-1f1f0",
        desc: "Sri Lanka Flag"
      }, {code: "1f1f1-1f1f7", desc: "Liberia Flag"}, {code: "1f1f1-1f1f8", desc: "Lesotho Flag"}, {
        code: "1f1f1-1f1f9",
        desc: "Lithuania Flag"
      }, {code: "1f1f1-1f1fa", desc: "Luxembourg Flag"}, {
        code: "1f1f1-1f1fb",
        desc: "Latvia Flag"
      }, {code: "1f1f1-1f1fe", desc: "Libya Flag"}, {code: "1f1f2-1f1e6", desc: "Morocco Flag"}, {
        code: "1f1f2-1f1e8",
        desc: "Monaco Flag"
      }, {code: "1f1f2-1f1e9", desc: "Moldova Flag"}, {
        code: "1f1f2-1f1ea",
        desc: "Montenegro Flag"
      }, {code: "1f1f2-1f1eb", desc: "St. Martin Flag"}, {
        code: "1f1f2-1f1ec",
        desc: "Madagascar Flag"
      }, {code: "1f1f2-1f1ed", desc: "Marshall Islands Flag"}, {
        code: "1f1f2-1f1f0",
        desc: "Macedonia Flag"
      }, {code: "1f1f2-1f1f1", desc: "Mali Flag"}, {
        code: "1f1f2-1f1f2",
        desc: "Myanmar (burma) Flag"
      }, {code: "1f1f2-1f1f3", desc: "Mongolia Flag"}, {
        code: "1f1f2-1f1f4",
        desc: "Macau Sar China Flag"
      }, {code: "1f1f2-1f1f5", desc: "Northern Mariana Islands Flag"}, {
        code: "1f1f2-1f1f6",
        desc: "Martinique Flag"
      }, {code: "1f1f2-1f1f7", desc: "Mauritania Flag"}, {
        code: "1f1f2-1f1f8",
        desc: "Montserrat Flag"
      }, {code: "1f1f2-1f1f9", desc: "Malta Flag"}, {code: "1f1f2-1f1fa", desc: "Mauritius Flag"}, {
        code: "1f1f2-1f1fb",
        desc: "Maldives Flag"
      }, {code: "1f1f2-1f1fc", desc: "Malawi Flag"}, {code: "1f1f2-1f1fd", desc: "Mexico Flag"}, {
        code: "1f1f2-1f1fe",
        desc: "Malaysia Flag"
      }, {code: "1f1f2-1f1ff", desc: "Mozambique Flag"}, {
        code: "1f1f3-1f1e6",
        desc: "Namibia Flag"
      }, {code: "1f1f3-1f1e8", desc: "New Caledonia Flag"}, {
        code: "1f1f3-1f1ea",
        desc: "Niger Flag"
      }, {code: "1f1f3-1f1eb", desc: "Norfolk Island Flag"}, {
        code: "1f1f3-1f1ec",
        desc: "Nigeria Flag"
      }, {code: "1f1f3-1f1ee", desc: "Nicaragua Flag"}, {
        code: "1f1f3-1f1f1",
        desc: "Netherlands Flag"
      }, {code: "1f1f3-1f1f4", desc: "Norway Flag"}, {code: "1f1f3-1f1f5", desc: "Nepal Flag"}, {
        code: "1f1f3-1f1f7",
        desc: "Nauru Flag"
      }, {code: "1f1f3-1f1fa", desc: "Niue Flag"}, {
        code: "1f1f3-1f1ff",
        desc: "New Zealand Flag"
      }, {code: "1f1f4-1f1f2", desc: "Oman Flag"}, {code: "1f1f8-1f1ff", desc: "Swaziland Flag"}, {
        code: "1f1f5-1f1e6",
        desc: "Panama Flag"
      }, {code: "1f1f5-1f1ea", desc: "Peru Flag"}, {
        code: "1f1f5-1f1eb",
        desc: "French Polynesia Flag"
      }, {code: "1f1f5-1f1ec", desc: "Papua New Guinea Flag"}, {
        code: "1f1f5-1f1ed",
        desc: "Philippines Flag"
      }, {code: "1f1f5-1f1f0", desc: "Pakistan Flag"}, {code: "1f1f5-1f1f1", desc: "Poland Flag"}, {
        code: "1f1f5-1f1f2",
        desc: "St. Pierre & Miquelon  Flag"
      }, {code: "1f1f5-1f1f3", desc: "Pitcairn Islands Flag"}, {
        code: "1f1f5-1f1f7",
        desc: "Puerto Rico Flag"
      }, {code: "1f1f5-1f1f8", desc: "Palestinian Territories Flag"}, {
        code: "1f1f5-1f1f9",
        desc: "Portugal Flag"
      }, {code: "1f1f5-1f1fc", desc: "Palau Flag"}, {code: "1f1f5-1f1fe", desc: "Paraguay Flag"}, {
        code: "1f1f6-1f1e6",
        desc: "Qatar Flag"
      }, {code: "1f1f7-1f1ea", desc: "R\xe9union Flag"}, {
        code: "1f1f7-1f1f4",
        desc: "Romania Flag"
      }, {code: "1f1f7-1f1f8", desc: "Serbia Flag"}, {code: "1f1f7-1f1fc", desc: "Rwanda Flag"}, {
        code: "1f1f8-1f1e6",
        desc: "Saudi Arabia Flag"
      }, {code: "1f1f8-1f1e7", desc: "Solomon Islands Flag"}, {
        code: "1f1f8-1f1e8",
        desc: "Seychelles Flag"
      }, {code: "1f1f8-1f1e9", desc: "Sudan Flag"}, {code: "1f1f8-1f1ea", desc: "Sweden Flag"}, {
        code: "1f1f8-1f1ec",
        desc: "Singapore Flag"
      }, {code: "1f1f8-1f1ee", desc: "Slovenia Flag"}, {
        code: "1f1f8-1f1ed",
        desc: "St. Helena  Flag"
      }, {code: "1f1f8-1f1ef", desc: "Svalbard & Jan Mayen  Flag"}, {
        code: "1f1f8-1f1f1",
        desc: "Sierra Leone Flag"
      }, {code: "1f1f8-1f1f2", desc: "San Marino Flag"}, {
        code: "1f1f8-1f1f3",
        desc: "Senegal Flag"
      }, {code: "1f1f8-1f1f4", desc: "Somalia Flag"}, {
        code: "1f1f8-1f1f7",
        desc: "Suriname Flag"
      }, {code: "1f1f8-1f1f8", desc: "South Sudan  Flag"}, {
        code: "1f1f8-1f1f9",
        desc: "S\xe3o Tom\xe9 & Pr\xedncipe Flag"
      }, {code: "1f1f8-1f1fb", desc: "El Salvador Flag"}, {
        code: "1f1f8-1f1fd",
        desc: "Sint Maarten Flag"
      }, {code: "1f1f8-1f1fe", desc: "Syria Flag"}, {
        code: "1f1f9-1f1e6",
        desc: "Tristan Da Cunha Flag"
      }, {code: "1f1f9-1f1e8", desc: "Turks & Caicos Islands  Flag"}, {
        code: "1f1f9-1f1eb",
        desc: "French Southern Territories Flag"
      }, {code: "1f1f9-1f1ec", desc: "Togo Flag"}, {code: "1f1f9-1f1ed", desc: "Thailand Flag"}, {
        code: "1f1f9-1f1ef",
        desc: "Tajikistan Flag"
      }, {code: "1f1f9-1f1f0", desc: "Tokelau Flag"}, {
        code: "1f1f9-1f1f1",
        desc: "Timor-Leste Flag"
      }, {code: "1f1f9-1f1f2", desc: "Turkmenistan Flag"}, {
        code: "1f1f9-1f1f3",
        desc: "Tunisia Flag"
      }, {code: "1f1f9-1f1f4", desc: "Tonga Flag"}, {code: "1f1f9-1f1f7", desc: "Turkey Flag"}, {
        code: "1f1f9-1f1f9",
        desc: "Trinidad & Tobago Flag"
      }, {code: "1f1f9-1f1fb", desc: "Tuvalu Flag"}, {code: "1f1f9-1f1fc", desc: "Taiwan Flag"}, {
        code: "1f1f9-1f1ff",
        desc: "Tanzania Flag"
      }, {code: "1f1fa-1f1e6", desc: "Ukraine City  Flag"}, {
        code: "1f1fa-1f1ec",
        desc: "Uganda Flag"
      }, {code: "1f1fa-1f1f2", desc: "U.s. Outlying Islands  Flag"}, {
        code: "1f1fa-1f1fe",
        desc: "Uruguay  Flag"
      }, {code: "1f1fa-1f1ff", desc: "Uzbekistan Flag"}, {
        code: "1f1fb-1f1e6",
        desc: "Vatican City  Flag"
      }, {code: "1f1fb-1f1e8", desc: "St. Vincent & Grenadines Flag"}, {
        code: "1f1fb-1f1ea",
        desc: "Venezuela Flag"
      }, {code: "1f1fb-1f1ec", desc: "British Virgin Islands Flag"}, {
        code: "1f1fb-1f1ee",
        desc: "U.s. Virgin Islands Flag"
      }, {code: "1f1fb-1f1f3", desc: "Vietnam Flag"}, {code: "1f1fc-1f1f8", desc: "Samoa Flag"}, {
        code: "1f1fb-1f1fa",
        desc: "Vanuatu Flag"
      }, {code: "1f1fc-1f1eb", desc: '"Wallis & Futuna Flag'}, {
        code: "1f1fd-1f1f0",
        desc: "Kosovo Flag"
      }, {code: "1f1fe-1f1ea", desc: "Yemen Flag"}, {code: "1f1fe-1f1f9", desc: "Mayotte Flag"}, {
        code: "1f1ff-1f1e6",
        desc: "South Africa Flag"
      }, {code: "1f1ff-1f1f2", desc: "Zambia Flag"}, {code: "1f1ff-1f1fc", desc: "Zimbabwe Flag"}, {
        code: "1f1eb-1f1f7",
        desc: "France Flag"
      }, {code: "1f1ec-1f1e7", desc: "United Kingdom  Flag"}, {
        code: "1f1ee-1f1f9",
        desc: "Italy Flag"
      }, {code: "1f1ef-1f1f5", desc: "Japan Flag"}, {
        code: "1f1f0-1f1f7",
        desc: "South Korea Flag"
      }, {code: "1f1f7-1f1fa", desc: "Russia Flag"}, {
        code: "1F6A9",
        desc: "Triangular Flag on Post"
      }, {code: "1f1fa-1f1f8", desc: "United States Flag"}]
    }], emoticonsButtons: ["emoticonsBack", "|"], emoticonsUseImage: !0
  }), xt.PLUGINS.emoticons = function (m) {
    var v = m.$, a = m.opts.emoticonsSet, o = a && a[0], i = "";

    function s() {
      if (!m.selection.isCollapsed()) return !1;
      var e = m.selection.element(), t = m.selection.endElement();
      if (e && m.node.hasClass(e, "fr-emoticon")) return e;
      if (t && m.node.hasClass(t, "fr-emoticon")) return t;
      var n = m.selection.ranges(0), r = n.startContainer;
      if (r.nodeType == Node.ELEMENT_NODE && 0 < r.childNodes.length && 0 < n.startOffset) {
        var a = r.childNodes[n.startOffset - 1];
        if (m.node.hasClass(a, "fr-emoticon")) return a
      }
      return !1
    }

    function l() {
      return "".concat(function r(e, t) {
        return '<div class="fr-buttons fr-tabs fr-tabs-scroll">\n                        '.concat(function n(e, r) {
          var a = "";
          return e.forEach(function (e) {
            var t = {image: e.code.toLowerCase()}, n = {
              elementClass: e.id === r.id ? "fr-active fr-active-tab" : "",
              emoticonsUnicodeClass: m.opts.emoticonsUseImage ? "" : "fr-tabs-unicode",
              title: m.language.translate(e.name),
              dataCmd: "setEmoticonCategory",
              dataParam1: e.id,
              image: m.opts.emoticonsUseImage ? '<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(t.image, '.svg"/>') : "&#x".concat(t.image, ";")
            };
            a += '<button class="fr-command fr-btn '.concat(n.elementClass, " ").concat(n.emoticonsUnicodeClass, '" \n      title="').concat(n.title, '" data-cmd="').concat(n.dataCmd, '" data-param1="').concat(n.dataParam1, '">\n       ').concat(n.image, " </button>")
          }), a
        }(e, t), "\n                        </div>")
      }(a, o), "\n                      ").concat(function n(e) {
        return '\n        <div class="fr-icon-container fr-emoticon-container">\n            '.concat(function t(e) {
          var a = "";
          return e.emoticons.forEach(function (e) {
            var t = e.code.split("-").reduce(function (e, t) {
              return e ? "".concat(e, "&zwj;&#x").concat(t.toLowerCase(), ";") : "&#x".concat(t.toLowerCase(), ";")
            }, ""), n = {image: e.code.toLowerCase(), compiledCode: e.uCode ? e.uCode : t}, r = {
              dataParam1: e.code.toLowerCase(),
              dataParam2: n.compiledCode,
              title: m.language.translate(e.desc),
              image: m.opts.emoticonsUseImage ? '<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(n.image, '.svg"/>') : "".concat(n.compiledCode),
              desc: m.language.translate(e.desc)
            };
            a += '<span class="fr-command fr-emoticon fr-icon" role="button" \n      data-cmd="insertEmoticon" data-param1="'.concat(r.dataParam1, '" \n      data-param2="').concat(r.dataParam2, '"  title="').concat(r.title, '" >\n      ').concat(r.image, '<span class="fr-sr-only">').concat(r.desc, "&nbsp;&nbsp;&nbsp;</span></span>")
          }), a
        }(e), "\n        </div>\n        ")
      }(o), "\n                      ").concat(function e() {
        return m.opts.emoticonsUseImage ? '<p style="font-size: 12px; text-align: center; padding: 0 5px;">Emoji free by <a class="fr-link" tabIndex="-1" href="http://emojione.com/" target="_blank" rel="nofollow noopener noreferrer" role="link" aria-label="Open Emoji One website.">Emoji One</a></p>' : ""
      }())
    }

    return {
      _init: function e() {
        var n = function n() {
          for (var e = m.el.querySelectorAll(".fr-emoticon:not(.fr-deletable)"), t = 0; t < e.length; t++) e[t].className += " fr-deletable"
        };
        n(), m.events.on("html.set", n), m.events.on("keydown", function (e) {
          if (m.keys.isCharacter(e.which) && m.selection.inEditor()) {
            var t = m.selection.ranges(0), n = s();
            m.node.hasClass(n, "fr-emoticon-img") && n && (0 === t.startOffset && m.selection.element() === n ? v(n).before(xt.MARKERS + xt.INVISIBLE_SPACE) : v(n).after(xt.INVISIBLE_SPACE + xt.MARKERS), m.selection.restore())
          }
        }), m.events.on("keyup", function (e) {
          for (var t = m.el.querySelectorAll(".fr-emoticon"), n = 0; n < t.length; n++) "undefined" != typeof t[n].textContent && 0 === t[n].textContent.replace(/\u200B/gi, "").length && v(t[n]).remove();
          if (!(e.which >= xt.KEYCODE.ARROW_LEFT && e.which <= xt.KEYCODE.ARROW_DOWN)) {
            var r = s();
            m.node.hasClass(r, "fr-emoticon-img") && (v(r).append(xt.MARKERS), m.selection.restore())
          }
        })
      }, insert: function c(e, t) {
        var n = s(), r = m.selection.ranges(0);
        n ? (0 === r.startOffset && m.selection.element() === n ? v(n).before(xt.MARKERS + xt.INVISIBLE_SPACE) : 0 < r.startOffset && m.selection.element() === n && r.commonAncestorContainer.parentNode.classList.contains("fr-emoticon") && v(n).after(xt.INVISIBLE_SPACE + xt.MARKERS), m.selection.restore(), m.html.insert('<span class="fr-emoticon fr-deletable'.concat(t ? " fr-emoticon-img" : "", '"').concat(t ? ' style="background: url('.concat(t, ');"') : "", ">").concat(t ? "&nbsp;" : e, "</span>&nbsp;").concat(xt.MARKERS), !0)) : m.html.insert('<span class="fr-emoticon fr-deletable'.concat(t ? " fr-emoticon-img" : "", '"').concat(t ? ' style="background: url('.concat(t, ');"') : "", ">").concat(t ? "&nbsp;" : e, "</span>&nbsp;"), !0)
      }, setEmoticonCategory: function n(t) {
        o = a.filter(function (e) {
          return e.id === t
        })[0], function e() {
          m.popups.get("emoticons").html(i + l())
        }()
      }, showEmoticonsPopup: function d() {
        var e = m.popups.get("emoticons");
        if (e || (e = function o() {
          m.opts.toolbarInline && 0 < m.opts.emoticonsButtons.length && (i = '<div class="fr-buttons fr-emoticons-buttons fr-tabs">'.concat(m.button.buildList(m.opts.emoticonsButtons), "</div>"));
          var e = {buttons: i, custom_layer: l()}, t = m.popups.create("emoticons", e);
          return function n(g) {
            m.events.on("popup.tab", function (e) {
              var t = v(e.currentTarget);
              if (!m.popups.isVisible("emoticons") || !t.is("span, a")) return !0;
              var n, r, a, o = e.which;
              if (xt.KEYCODE.TAB == o) {
                if (t.is("span.fr-emoticon") && e.shiftKey || t.is("a") && !e.shiftKey) {
                  var i = g.find(".fr-buttons");
                  n = !m.accessibility.focusToolbar(i, !!e.shiftKey)
                }
                if (!1 !== n) {
                  var s = g.find("span.fr-emoticon:focus").first().concat(g.findVisible(" div.fr-tabs").first().concat(g.find("a")));
                  t.is("span.fr-emoticon") && (s = s.not("span.fr-emoticon:not(:focus)")), r = s.index(t), r = e.shiftKey ? ((r - 1) % s.length + s.length) % s.length : (r + 1) % s.length, a = s.get(r), m.events.disableBlur(), a.focus(), n = !1
                }
              } else if (xt.KEYCODE.ARROW_UP == o || xt.KEYCODE.ARROW_DOWN == o || xt.KEYCODE.ARROW_LEFT == o || xt.KEYCODE.ARROW_RIGHT == o) {
                if (t.is("span.fr-emoticon")) {
                  var l = t.parent().find("span.fr-emoticon");
                  r = l.index(t);
                  var c = m.opts.emoticonsStep, d = Math.floor(l.length / c), f = r % c, p = Math.floor(r / c),
                    u = p * c + f, h = d * c;
                  xt.KEYCODE.ARROW_UP == o ? u = ((u - c) % h + h) % h : xt.KEYCODE.ARROW_DOWN == o ? u = (u + c) % h : xt.KEYCODE.ARROW_LEFT == o ? u = ((u - 1) % h + h) % h : xt.KEYCODE.ARROW_RIGHT == o && (u = (u + 1) % h), a = v(l.get(u)), m.events.disableBlur(), a.focus(), n = !1
                }
              } else xt.KEYCODE.ENTER == o && (t.is("a") ? t[0].click() : m.button.exec(t), n = !1);
              return !1 === n && (e.preventDefault(), e.stopPropagation()), n
            }, !0)
          }(t), t
        }()), !e.hasClass("fr-active")) {
          m.popups.refresh("emoticons"), m.popups.setContainer("emoticons", m.$tb);
          var t = m.$tb.find('.fr-command[data-cmd="emoticons"]'), n = m.button.getPosition(t), r = n.left, a = n.top;
          m.popups.show("emoticons", r, a, t.outerHeight())
        }
      }, back: function t() {
        m.popups.hide("emoticons"), m.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("emoticons", {
    NAME: "smile-o",
    FA5NAME: "smile",
    SVG_KEY: "smile"
  }), xt.RegisterCommand("emoticons", {
    title: "Emoticons",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("emoticons") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("emoticons")) : this.emoticons.showEmoticonsPopup()
    },
    plugin: "emoticons"
  }), xt.RegisterCommand("insertEmoticon", {
    callback: function (e, t, n) {
      this.emoticons.insert(n, this.opts.emoticonsUseImage ? "https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/".concat(t, ".svg") : null), this.popups.hide("emoticons")
    }
  }), xt.RegisterCommand("setEmoticonCategory", {
    undo: !1, focus: !1, callback: function (e, t) {
      this.emoticons.setEmoticonCategory(t)
    }
  }), xt.DefineIcon("emoticonsBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("emoticonsBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.emoticons.back()
    }
  }), Object.assign(xt.DEFAULTS, {entities: "&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Aacute;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Eacute;&Ecirc;&Euml;&Igrave;&Iacute;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Oacute;&Ocirc;&Otilde;&Ouml;&times;&Oslash;&Ugrave;&Uacute;&Ucirc;&Uuml;&Yacute;&THORN;&szlig;&agrave;&aacute;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&eacute;&ecirc;&euml;&igrave;&iacute;&icirc;&iuml;&eth;&ntilde;&ograve;&oacute;&ocirc;&otilde;&ouml;&divide;&oslash;&ugrave;&uacute;&ucirc;&uuml;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;"}), xt.PLUGINS.entities = function (a) {
    var o, i, s = a.$;

    function r(e) {
      var t = e.textContent;
      if (t.match(o)) {
        for (var n = "", r = 0; r < t.length; r++) i[t[r]] ? n += i[t[r]] : n += t[r];
        e.textContent = n
      }
    }

    function l(e) {
      if (e && 0 <= ["STYLE", "SCRIPT", "svg", "IFRAME"].indexOf(e.tagName)) return !0;
      for (var t = a.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType === Node.TEXT_NODE ? r(t[n]) : l(t[n]);
      return e.nodeType === Node.TEXT_NODE && r(e), !1
    }

    var c = function c(e) {
      return 0 === e.length ? "" : a.clean.exec(e, l).replace(/\&amp;/g, "&")
    };
    return {
      _init: function d() {
        a.opts.htmlSimpleAmpersand || (a.opts.entities = "".concat(a.opts.entities, "&amp;"));
        var e = s(document.createElement("div")).html(a.opts.entities).text(), t = a.opts.entities.split(";");
        i = {}, o = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charAt(n);
          i[r] = "".concat(t[n], ";"), o += "\\".concat(r + (n < e.length - 1 ? "|" : ""))
        }
        o = new RegExp("(".concat(o, ")"), "g"), a.events.on("html.get", c, !0)
      }
    }
  }, Object.assign(xt.POPUP_TEMPLATES, {"file.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_PROGRESS_BAR_]"}), Object.assign(xt.DEFAULTS, {
    fileUpload: !0,
    fileUploadURL: null,
    fileUploadParam: "file",
    fileUploadParams: {},
    fileUploadToS3: !1,
    fileUploadToAzure: !1,
    fileUploadMethod: "POST",
    fileMaxSize: 10485760,
    fileAllowedTypes: ["*"],
    fileInsertButtons: ["fileBack", "|"],
    fileUseSelectedText: !1
  }), xt.PLUGINS.file = function (E) {
    var r, p = E.$, y = "https://i.froala.com/upload", u = 2, h = 3, g = 4, L = 5, _ = 6, n = {};

    function w() {
      var e = E.popups.get("file.insert");
      e || (e = l()), e.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), e.find(".fr-file-progress-bar-layer").addClass("fr-active"), e.find(".fr-buttons").hide(), a(E.language.translate("Uploading"), 0)
    }

    function o(e) {
      var t = E.popups.get("file.insert");
      t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-file-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e && (E.events.focus(), E.popups.hide("file.insert")))
    }

    function a(e, t) {
      var n = E.popups.get("file.insert");
      if (n) {
        var r = n.find(".fr-file-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function m(e, t, n) {
      E.edit.on(), E.events.focus(!0), E.selection.restore(), E.opts.fileUseSelectedText && E.selection.text().length && (t = E.selection.text()), E.html.insert('<a href="'.concat(e, '" target="_blank" id="fr-inserted-file" class="fr-file">').concat(t, "</a>"));
      var r = E.$el.find("#fr-inserted-file");
      r.removeAttr("id"), E.popups.hide("file.insert"), E.undo.saveStep(), d(), E.events.trigger("file.inserted", [r, n])
    }

    function A(e, t, n) {
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (E.opts.fileUploadToS3 || E.opts.fileUploadToAzure) if (201 === r) {
          var s;
          if (E.opts.fileUploadToAzure) {
            if (!1 === E.events.trigger("file.uploadedToAzure", [this.responseURL, n, a], !0)) return E.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = p(e).find("Location").text(), n = p(e).find("Key").text();
              return !1 === E.events.trigger("file.uploadedToS3", [t, n, e], !0) ? (E.edit.on(), !1) : t
            } catch (r) {
              return k(g, e), !1
            }
          }(o);
          s && m(s, e, a || o)
        } else k(g, a || o); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === E.events.trigger("file.uploaded", [e], !0)) return E.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (k(u, e), !1)
            } catch (n) {
              return k(g, e), !1
            }
          }(i);
          l && m(l.link, e, a || i)
        } else k(h, a || i)
      } catch (f) {
        k(g, a || i)
      }
    }

    function T() {
      k(g, this.response || this.responseText || this.responseXML)
    }

    function S(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        a(E.language.translate("Uploading"), t)
      }
    }

    function k(e, t) {
      E.edit.on(), function r(e) {
        w();
        var t = E.popups.get("file.insert").find(".fr-file-progress-bar-layer");
        t.addClass("fr-error");
        var n = t.find("h3");
        n.text(e), E.events.disableBlur(), n.focus()
      }(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("file.error", [{
        code: e,
        message: n[e]
      }, t])
    }

    function x() {
      E.edit.on(), o(!0)
    }

    function i(e) {
      if (void 0 !== e && 0 < e.length) {
        if (!1 === E.events.trigger("file.beforeUpload", [e])) return !1;
        var t, n = e[0];
        if (!(null !== E.opts.fileUploadURL && E.opts.fileUploadURL !== y || E.opts.fileUploadToS3 || E.opts.fileUploadToAzure)) return function C(a) {
          var o = new FileReader;
          o.onload = function () {
            for (var e = o.result, t = atob(o.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
            e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: a.type})), E.file.insert(e, a.name, null)
          }, w(), o.readAsDataURL(a)
        }(n), !1;
        if (n.size > E.opts.fileMaxSize) return k(L), !1;
        if (E.opts.fileAllowedTypes.indexOf("*") < 0 && E.opts.fileAllowedTypes.indexOf(n.type.replace(/file\//g, "")) < 0) return k(_), !1;
        if (E.drag_support.formdata && (t = E.drag_support.formdata ? new FormData : null), t) {
          var r;
          if (!1 !== E.opts.fileUploadToS3) for (r in t.append("key", E.opts.fileUploadToS3.keyStart + (new Date).getTime() + "-" + (n.name || "untitled")), t.append("success_action_status", "201"), t.append("X-Requested-With", "xhr"), t.append("Content-Type", n.type), E.opts.fileUploadToS3.params) E.opts.fileUploadToS3.params.hasOwnProperty(r) && t.append(r, E.opts.fileUploadToS3.params[r]);
          for (r in E.opts.fileUploadParams) E.opts.fileUploadParams.hasOwnProperty(r) && t.append(r, E.opts.fileUploadParams[r]);
          t.append(E.opts.fileUploadParam, n);
          var a, o, i = E.opts.fileUploadURL;
          E.opts.fileUploadToS3 && (i = E.opts.fileUploadToS3.uploadURL ? E.opts.fileUploadToS3.uploadURL : "https://".concat(E.opts.fileUploadToS3.region, ".amazonaws.com/").concat(E.opts.fileUploadToS3.bucket));
          var s = E.opts.fileUploadMethod;
          E.opts.fileUploadToAzure && (i = E.opts.fileUploadToAzure.uploadURL ? "".concat(E.opts.fileUploadToAzure.uploadURL, "/").concat(n.name) : encodeURI("https://".concat(E.opts.fileUploadToAzure.account, ".blob.core.windows.net/").concat(E.opts.fileUploadToAzure.container, "/").concat(n.name)), a = i, E.opts.fileUploadToAzure.SASToken && (i += E.opts.fileUploadToAzure.SASToken), s = "PUT");
          var l = E.core.getXHR(i, s);
          if (E.opts.fileUploadToAzure) {
            var c = (new Date).toUTCString();
            if (!E.opts.fileUploadToAzure.SASToken && E.opts.fileUploadToAzure.accessKey) {
              var d = E.opts.fileUploadToAzure.account, f = E.opts.fileUploadToAzure.container;
              if (E.opts.fileUploadToAzure.uploadURL) {
                var p = E.opts.fileUploadToAzure.uploadURL.split("/");
                f = p.pop(), d = p.pop().split(".")[0]
              }
              var u = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(c, "\nx-ms-version:2019-07-07"),
                h = encodeURI("/" + d + "/" + f + "/" + n.name),
                g = s + "\n\n\n" + n.size + "\n\n" + n.type + "\n\n\n\n\n\n\n" + u + "\n" + h,
                m = E.cryptoJSPlugin.cryptoJS.HmacSHA256(g, E.cryptoJSPlugin.cryptoJS.enc.Base64.parse(E.opts.fileUploadToAzure.accessKey)).toString(E.cryptoJSPlugin.cryptoJS.enc.Base64),
                v = "SharedKey " + d + ":" + m;
              o = m, l.setRequestHeader("Authorization", v)
            }
            for (r in l.setRequestHeader("x-ms-version", "2019-07-07"), l.setRequestHeader("x-ms-date", c), l.setRequestHeader("Content-Type", n.type), l.setRequestHeader("x-ms-blob-type", "BlockBlob"), E.opts.fileUploadParams) E.opts.fileUploadParams.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.fileUploadParams[r]);
            for (r in E.opts.fileUploadToAzure.params) E.opts.fileUploadToAzure.params.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.fileUploadToAzure.params[r])
          }
          l.onload = function () {
            A.call(l, n.name, a, o)
          }, l.onerror = T, l.upload.onprogress = S, l.onabort = x, w();
          var b = E.popups.get("file.insert");
          b && (b.off("abortUpload"), b.on("abortUpload", function () {
            4 !== l.readyState && l.abort()
          })), l.send(E.opts.fileUploadToAzure ? n : t)
        }
      }
    }

    function s() {
      o()
    }

    function l(e) {
      if (e) return E.popups.onHide("file.insert", s), !0;
      var t;
      E.opts.fileUpload || E.opts.fileInsertButtons.splice(E.opts.fileInsertButtons.indexOf("fileUpload"), 1), t = '<div class="fr-buttons fr-tabs">'.concat(E.button.buildList(E.opts.fileInsertButtons), "</div>");
      var n = "";
      E.opts.fileUpload && (n = '<div class="fr-file-upload-layer fr-layer fr-active" id="fr-file-upload-layer-'.concat(E.id, '"><strong>').concat(E.language.translate("Drop file"), "</strong><br>(").concat(E.language.translate("or click"), ')<div class="fr-form"><input type="file" name="').concat(E.opts.fileUploadParam, '" accept="').concat(0 <= E.opts.fileAllowedTypes.indexOf("*") ? "/" : "").concat(E.opts.fileAllowedTypes.join(", ").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-file-upload-layer-').concat(E.id, '" role="button"></div></div>'));
      var r = {
        buttons: t,
        upload_layer: n,
        progress_bar: '<div class="fr-file-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="fileDismissError" tabIndex="2" role="button">OK</button></div></div>'
      }, a = E.popups.create("file.insert", r);
      return function o(n) {
        E.events.$on(n, "dragover dragenter", ".fr-file-upload-layer", function () {
          return p(this).addClass("fr-drop"), !1
        }, !0), E.events.$on(n, "dragleave dragend", ".fr-file-upload-layer", function () {
          return p(this).removeClass("fr-drop"), !1
        }, !0), E.events.$on(n, "drop", ".fr-file-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), p(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          t && t.files && (n.data("instance") || E).file.upload(t.files)
        }, !0), E.helpers.isIOS() && E.events.$on(n, "touchstart", '.fr-file-upload-layer input[type="file"]', function () {
          p(this).trigger("click")
        }), E.events.$on(n, "change", '.fr-file-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = n.data("instance") || E;
            e.events.disableBlur(), n.find("input:focus").blur(), e.events.enableBlur(), e.file.upload(this.files)
          }
          p(this).val("")
        }, !0)
      }(a), a
    }

    function t(e) {
      E.node.hasClass(e, "fr-file")
    }

    function c(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && "undefined" != typeof n.type) {
          if (n.type.indexOf("image") < 0) {
            if (!E.opts.fileUpload) return e.preventDefault(), e.stopPropagation(), !1;
            E.markers.remove(), E.markers.insertAtPoint(e.originalEvent), E.$el.find(".fr-marker").replaceWith(xt.MARKERS), E.popups.hideAll();
            var r = E.popups.get("file.insert");
            return r || (r = l()), E.popups.setContainer("file.insert", E.$sc), E.popups.show("file.insert", e.originalEvent.pageX, e.originalEvent.pageY), w(), i(t.files), e.preventDefault(), e.stopPropagation(), !1
          }
        } else n.type.indexOf("image") < 0 && (e.preventDefault(), e.stopPropagation())
      }
    }

    function d() {
      var e, t = Array.prototype.slice.call(E.el.querySelectorAll("a.fr-file")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("href"));
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("href")) < 0 && E.events.trigger("file.unlink", [r[e]]);
      r = t
    }

    return n[1] = "File cannot be loaded from the passed link.", n[u] = "No link in upload response.", n[h] = "Error during file upload.", n[g] = "Parsing response failed.", n[L] = "File is too large.", n[_] = "File file type is invalid.", n[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", {
      _init: function f() {
        !function e() {
          E.events.on("drop", c), E.events.$on(E.$win, "keydown", function (e) {
            var t = e.which, n = E.popups.get("file.insert");
            n && t === xt.KEYCODE.ESC && n.trigger("abortUpload")
          }), E.events.on("destroy", function () {
            var e = E.popups.get("file.insert");
            e && e.trigger("abortUpload")
          })
        }(), E.events.on("link.beforeRemove", t), E.$wp && (d(), E.events.on("contentChanged", d)), l(!0)
      }, showInsertPopup: function v() {
        var e = E.$tb.find('.fr-command[data-cmd="insertFile"]'), t = E.popups.get("file.insert");
        if (t || (t = l()), o(), !t.hasClass("fr-active")) if (E.popups.refresh("file.insert"), E.popups.setContainer("file.insert", E.$tb), e.isVisible) {
          var n = E.button.getPosition(e), r = n.left, a = n.top;
          E.popups.show("file.insert", r, a, e.outerHeight())
        } else E.position.forSelection(t), E.popups.show("file.insert")
      }, upload: i, insert: m, back: function e() {
        E.events.disableBlur(), E.selection.restore(), E.events.enableBlur(), E.popups.hide("file.insert"), E.toolbar.showInline()
      }, hideProgressBar: o
    }
  }, xt.DefineIcon("insertFile", {
    NAME: "file-o",
    FA5NAME: "file",
    SVG_KEY: "insertFile"
  }), xt.RegisterCommand("insertFile", {
    title: "Upload File",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("file.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("file.insert")) : this.file.showInsertPopup()
    },
    plugin: "file"
  }), xt.DefineIcon("fileBack", {NAME: "arrow-left", SVG_KEY: "back"}), xt.RegisterCommand("fileBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.file.back()
    },
    refresh: function (e) {
      this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }), xt.RegisterCommand("fileDismissError", {
    title: "OK", callback: function () {
      this.file.hideProgressBar(!0)
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "filesManager.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_PROGRESS_LAYER_][_PROGRESS_BAR_]",
    "image.edit": "[_BUTTONS_]",
    "image.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "image.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    filesInsertButtons: ["imageBack", "|", "filesUpload", "filesByURL", "filesEmbed"],
    filesInsertButtons2: ["deleteAll", "insertAll", "cancel", "minimize"],
    imageEditButtons: ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"],
    imageAltButtons: ["imageBack", "|"],
    imageSizeButtons: ["imageBack", "|"],
    imageUpload: !0,
    filesManagerUploadURL: null,
    imageCORSProxy: "https://cors-anywhere.froala.com",
    imageUploadRemoteUrls: !0,
    filesManagerUploadParam: "file",
    filesManagerUploadParams: {},
    googleOptions: {},
    filesManagerUploadToS3: !1,
    filesManagerUploadToAzure: !1,
    filesManagerUploadMethod: "POST",
    filesManagerMaxSize: 10485760,
    filesManagerAllowedTypes: ["*"],
    imageResize: !0,
    imageResizeWithPercent: !1,
    imageRoundPercent: !1,
    imageDefaultWidth: 300,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageSplitHTML: !1,
    imageStyles: {"fr-rounded": "Rounded", "fr-bordered": "Bordered", "fr-shadow": "Shadow"},
    imageMove: !0,
    imageMultipleStyles: !0,
    imageTextNear: !0,
    imagePaste: !0,
    imagePasteProcess: !1,
    imageMinWidth: 16,
    imageOutputSize: !1,
    imageDefaultMargin: 5,
    imageAddNewLine: !1
  }), xt.VIDEO_PROVIDERS = [{
    test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
    url_text: "https://www.youtube.com/embed/$1?$2",
    html: '<iframe width="640" height="360" src="{url}&wmode=opaque" frameborder="0" allowfullscreen></iframe>',
    provider: "youtube"
  }, {
    test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
    url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,
    url_text: "https://player.vimeo.com/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vimeo"
  }, {
    test_regex: /^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,
    url_text: "https://www.dailymotion.com/embed/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "dailymotion"
  }, {
    test_regex: /^.+(screen.yahoo.com)\/[^_&]+/,
    url_regex: "",
    url_text: "",
    html: '<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "yahoo"
  }, {
    test_regex: /^.+(rutube.ru)\/[^_&]+/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,
    url_text: "https://rutube.ru/play/embed/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "rutube"
  }, {
    test_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
    url_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,
    url_text: "https://play.vidyard.com/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vidyard"
  }], xt.VIDEO_EMBED_REGEX = /^\W*((<iframe(.|\n)*>(\s|\n)*<\/iframe>)|(<embed(.|\n)*>))\W*$/i, xt.IMAGE_EMBED_REGEX = /^\W*((<img(.|\n)*>(\s|\n)*))\W*$/i, xt.PLUGINS.filesManager = function (A) {
    var y, i, T, l, c, d, s, f, S = A.$, L = "https://i.froala.com/upload", p = !1, t = !1, k = new Map, x = new Map,
      _ = new Map, w = new Map, R = new Map, M = new Map, o = 0, a = [], u = -1, O = [], h = 0,
      g = ["file", "image", "imageTUI", "video"], N = 1, m = 2, I = 3, D = 4, B = 5, H = 6, $ = 10,
      F = ["video/avi", "video/mpeg", "video/x-ms-wmv"], v = {};

    function b() {
      var e = A.popups.get("filesManager.insert"), t = e.find(".fr-files-by-url-layer input");
      t.val(""), e.find(".fr-files-embed-layer textarea").val("").trigger("change"), t.trigger("change")
    }

    function C(e) {
      var t;
      A.hasOwnProperty("imageTUI") || (s = "fr-disabled"), M.forEach(function (e, t) {
        Z(t)
      }), E() ? (t = A.popups.get("filesManager.insert")) || (t = Ue()) : (t = A.popups.get("filesManager.insert")) || (t = function i() {
        var e = '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.fileInsertButtons), "</div>"),
          t = "<div style= 'padding:10px'>\n    <div class = 'fr-message'><h3 style ='font-size: 16px; margin: 10px 10px;font-weight: normal;'>".concat(A.language.translate(function a() {
            var e = "", t = function n() {
              var t = [];
              return g.forEach(function (e) {
                A.opts.pluginsEnabled.indexOf(e) < 0 && t.push(e.charAt(0).toUpperCase() + e.slice(1))
              }), t
            }();
            e = t.join(", "), 1 < t.length ? e += " plugin are" : e += " plugin is";
            return e
          }() + " not enabled. Do you want to enable?"), "</h3></div>\n    <div style='text-align:right;'>\n      <button class='fr-trim-button fr-plugins-enable'>").concat(A.language.translate("Enable"), "</button>               \n      <button class='fr-trim-button fr-plugins-cancel'>").concat(A.language.translate("Cancel"), "</button>\n    </div>"),
          n = {
            buttons: e,
            upload_layer: t,
            by_url_layer: "",
            embed_layer: "",
            upload_progress_layer: "",
            progress_bar: ""
          }, r = A.popups.create("filesManager.insert", n);
        return Ie(r), r
      }());
      var n = A.$tb.find('.fr-command[data-cmd="insertFiles"]');
      if (J(), e || !t.hasClass("fr-active")) if (e || X(), A.popups.refresh("filesManager.insert"), A.popups.setContainer("filesManager.insert", A.$tb), n.isVisible()) {
        var r = A.button.getPosition(n, k.size), a = r.left, o = r.top;
        A.popups.show("filesManager.insert", a, o, n.outerHeight())
      } else A.position.forSelection(t), A.popups.show("filesManager.insert");
      A.popups.setPopupDimensions(t), E() && A.popups.setFileListHeight(t), t.find(".fr-upload-progress") && 0 == k.size && t.find(".fr-upload-progress").addClass("fr-none")
    }

    function E() {
      var t = !0;
      return g.forEach(function (e) {
        A.opts.pluginsEnabled.indexOf(e) < 0 && (t = !1)
      }), t
    }

    function P() {
      J()
    }

    function U() {
      if (l || function i() {
        var e;
        A.shared.$image_resizer ? (l = A.shared.$image_resizer, d = A.shared.$img_overlay, A.events.on("destroy", function () {
          S("body").first().append(l.removeClass("fr-active"))
        }, !0)) : (A.shared.$image_resizer = S(document.createElement("div")).attr("class", "fr-image-resizer"), l = A.shared.$image_resizer, A.events.$on(l, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), A.opts.imageResize && (l.append(z("nw") + z("ne") + z("sw") + z("se")), A.shared.$img_overlay = S(document.createElement("div")).attr("class", "fr-image-overlay"), d = A.shared.$img_overlay, e = l.get(0).ownerDocument, S(e).find("body").first().append(d)));
        A.events.on("shared.destroy", function () {
          l.html("").removeData().remove(), l = null, A.opts.imageResize && (d.remove(), d = null)
        }, !0), A.helpers.isMobile() || A.events.$on(S(A.o_win), "resize", function () {
          y && !y.hasClass("fr-uploading") ? rt(!0) : y && (U(), replace(), Q(!1))
        });
        if (A.opts.imageResize) {
          e = l.get(0).ownerDocument, A.events.$on(l, A._mousedown, ".fr-handler", V), A.events.$on(S(e), A._mousemove, W), A.events.$on(S(e.defaultView || e.parentWindow), A._mouseup, G), A.events.$on(d, "mouseleave", G);
          var r = 1, a = null, o = 0;
          A.events.on("keydown", function (e) {
            if (y) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || A.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = qe.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || A.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey ? r = qe.call(this, e, 2, -1, r) : A.keys.ctrlKey(e) || n != xt.KEYCODE.ENTER || (y.before("<br>"), _e(y)), a = n, o = e.timeStamp
            }
          }, !0), A.events.on("keyup", function () {
            r = 1
          })
        }
      }(), !y) return !1;
      var e = A.$wp || A.$sc;
      e.append(l), l.data("instance", A);
      var t = e.scrollTop() - ("static" != e.css("position") ? e.offset().top : 0),
        n = e.scrollLeft() - ("static" != e.css("position") ? e.offset().left : 0);
      n -= A.helpers.getPX(e.css("border-left-width")), t -= A.helpers.getPX(e.css("border-top-width")), A.$el.is("img") && A.$sc.is("body") && (n = t = 0);
      var r = ct();
      dt() && (r = r.find(".fr-img-wrap"));
      var a = 0, o = 0;
      A.opts.iframe && (a = A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")), o = A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"))), l.css("top", (A.opts.iframe ? r.offset().top + a : r.offset().top + t) - 1).css("left", (A.opts.iframe ? r.offset().left + o : r.offset().left + n) - 1).css("width", r.get(0).getBoundingClientRect().width).css("height", r.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function z(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function K(e) {
      dt() ? y.parents(".fr-img-caption").css("width", e) : y.css("width", e)
    }

    function V(e) {
      if (!A.core.sameInstance(l)) return !0;
      if (e.preventDefault(), e.stopPropagation(), A.$el.find("img.fr-error").left) return !1;
      A.undo.canDo() || A.undo.saveStep();
      var t = e.pageX || e.originalEvent.touches[0].pageX;
      if ("mousedown" == e.type) {
        var n = A.$oel.get(0).ownerDocument, r = n.defaultView || n.parentWindow, a = !1;
        try {
          a = r.location != r.parent.location && !(r.$ && r.$.FE)
        } catch (s) {
        }
        a && r.frameElement && (t += A.helpers.getPX(S(r.frameElement).offset().left) + r.frameElement.clientLeft)
      }
      (c = S(this)).data("start-x", t), c.data("start-width", y.width()), c.data("start-height", y.height());
      var o = y.width();
      if (A.opts.imageResizeWithPercent) {
        var i = y.parentsUntil(A.$el, A.html.blockTagsQuery()).get(0) || A.el;
        o = (o / S(i).outerWidth() * 100).toFixed(2) + "%"
      }
      K(o), d.show(), A.popups.hideAll(), it()
    }

    function W(e) {
      if (!A.core.sameInstance(l)) return !0;
      var t;
      if (c && y) {
        if (e.preventDefault(), A.$el.find("img.fr-error").left) return !1;
        var n = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);
        if (!n) return !1;
        var r = n - c.data("start-x"), a = c.data("start-width");
        if ((c.hasClass("fr-hnw") || c.hasClass("fr-hsw")) && (r = 0 - r), A.opts.imageResizeWithPercent) {
          var o = y.parentsUntil(A.$el, A.html.blockTagsQuery()).get(0) || A.el;
          a = ((a + r) / S(o).outerWidth() * 100).toFixed(2), A.opts.imageRoundPercent && (a = Math.round(a)), K("".concat(a, "%")), (t = dt() ? (A.helpers.getPX(y.parents(".fr-img-caption").css("width")) / S(o).outerWidth() * 100).toFixed(2) : (A.helpers.getPX(y.css("width")) / S(o).outerWidth() * 100).toFixed(2)) === a || A.opts.imageRoundPercent || K("".concat(t, "%")), y.css("height", "").removeAttr("height")
        } else a + r >= A.opts.imageMinWidth && (K(a + r), t = dt() ? A.helpers.getPX(y.parents(".fr-img-caption").css("width")) : A.helpers.getPX(y.css("width"))), t !== a + r && K(t), ((y.attr("style") || "").match(/(^height:)|(; *height:)/) || y.attr("height")) && (y.css("height", c.data("start-height") * y.width() / c.data("start-width")), y.removeAttr("height"));
        U(), A.events.trigger("image.resize", [lt()])
      }
    }

    function G(e) {
      if (!A.core.sameInstance(l)) return !0;
      if (c && y) {
        if (e && e.stopPropagation(), A.$el.find("img.fr-error").left) return !1;
        c = null, d.hide(), U(), A.undo.saveStep(), A.events.trigger("image.resizeEnd", [lt()])
      } else l.removeClass("fr-active")
    }

    function Y() {
      M.forEach(function (e, t) {
        var n = A.popups.get("filesManager.insert");
        n.find(".fr-checkbox-file-" + t).get(0).disabled = !0, document.getElementById("fr-file-autoplay-button-" + t) && (document.getElementById("fr-file-autoplay-button-" + t).disabled = !0, document.getElementById("fr-file-autoplay-button-" + t).parentElement.classList.add("fr-checkbox-disabled"), document.getElementById("fr-file-autoplay-button-" + t).parentElement.classList.remove("fr-files-checkbox")), n.find(".fr-checkbox-" + t).get(0).classList.remove("fr-files-checkbox"), n.find(".fr-checkbox-" + t).get(0).classList.add("fr-checkbox-disabled")
      })
    }

    function j(e, t, n, r) {
      A.edit.on(), y && y.addClass("fr-error"), v[e] ? (e != I && e != m && e != D || Ee(100, r, !0), M.set(r, v[e]), Y(), function a() {
        M.forEach(function (e, t) {
          A.popups.get("filesManager.insert"), document.getElementById("fr-file-edit-button-".concat(t)) && (document.getElementById("fr-file-edit-button-".concat(t)).classList.add("fr-disabled"), document.getElementById("fr-file-view-button-".concat(t)).classList.add("fr-disabled"), document.getElementById("fr-file-insert-button-".concat(t)).classList.add("fr-disabled"))
        })
      }(), ne(A.language.translate(v[e]), r)) : ne(A.language.translate("Something went wrong. Please try again."), r), !y && n && Ze(n), A.events.trigger("filesManager.error", [{
        code: e,
        message: v[e]
      }, t, n])
    }

    function q() {
      var e = A.popups.get("filesManager.insert"), t = e.find('.fr-command[data-cmd="insertAll"]'),
        n = e.find('.fr-command[data-cmd="deleteAll"]'), r = !0;
      R.forEach(function a(e, t, n) {
        R.get(t) && (r = !1)
      }), r ? t.addClass("fr-disabled") : t.removeClass("fr-disabled"), r ? n.addClass("fr-disabled") : n.removeClass("fr-disabled")
    }

    function Z(e) {
      x.get(e) && x.get(e).link && A.events.trigger("filesManager.removed", [x.get(e).link]);
      var t = A.popups.get("filesManager.insert");
      t.find(".fr-file-" + e).get(0) !== undefined && (t.find(".fr-file-" + e).get(0).outerHTML = ""), x["delete"](e), k["delete"](e), R["delete"](e), q(), 0 == k.size && (h = 0), M["delete"](e), A.popups.setPopupDimensions(t, !0), A.opts.toolbarBottom ? C(!0) : A.popups.setPopupDimensions(t), t.find(".fr-upload-progress") && 0 == k.size && t.find(".fr-upload-progress").addClass("fr-none")
    }

    function X() {
      for (var e = A.popups.get("filesManager.insert"), t = e.find(".fr-insert-checkbox"), n = 0; n < t.length; n++) t.get(n).children.target.checked = !1, e.find(".fr-file-" + t.get(n).id.split("-").pop()).get(0).classList.add("fr-unchecked");
      if (T) document.getElementById("fr-file-autoplay-button-".concat(T)) && (document.getElementById("fr-file-autoplay-button-".concat(T)).checked = !1), O = O.filter(function (e) {
        return e != T
      }); else {
        for (var r = e.find(".fr-file-autoplay-button"), a = 0; a < r.length; a++) r.get(a).checked = !1;
        O = []
      }
      R = new Map, q()
    }

    function Q(e) {
      var t = A.popups.get("filesManager.insert");
      if (t || (t = Ue()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-files-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), y) {
        var n = ct();
        A.popups.setContainer("filesManager.insert", A.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        A.popups.show("filesManager.insert", r, a, n.outerHeight())
      }
      void 0 === e && ee(A.language.translate("Uploading"), 0)
    }

    function J(e) {
      var t = A.popups.get("filesManager.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-files-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || A.$el.find("img.fr-error").length)) {
        if (A.events.focus(), A.$el.find("img.fr-error").length && (A.$el.find("img.fr-error").remove(), A.undo.saveStep(), A.undo.run(), A.undo.dropRedo()), !A.$wp && y) {
          var n = y;
          rt(!0), A.selection.setAfter(n.get(0)), A.selection.restore()
        }
        A.popups.hide("filesManager.insert")
      }
    }

    function ee(e, t) {
      var n = A.popups.get("filesManager.insert");
      if (n) {
        var r = n.find(".fr-files-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function te(e) {
      Q();
      var t = A.popups.get("filesManager.insert").find(".fr-files-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), A.events.disableBlur(), n.focus()
    }

    function ne(e, t) {
      var n = A.popups.get("filesManager.insert"), r = n.find(".fr-upload-progress-layer"),
        a = n.find(".fr-file-".concat(t));
      r.addClass("fr-error"), a.find("h5").text(e)
    }

    v[N] = "File cannot be loaded from the passed link.", v[m] = "No link in upload response.", v[I] = "Error during file upload.", v[D] = "Parsing response failed.", v[B] = "File is too large.", v[H] = "File type is invalid.", v[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", v[8] = "File is corrupted.", v[9] = "Error during file loading.", v[$] = "File upload cancelled";
    var n, re, ae, oe, ie, se, r, le, ce, de, fe = "";

    function pe(e) {
      fe = e, n = document.getElementsByClassName(e), Array.prototype.map.call(n, function (e) {
        !function r(e) {
          if (e.addEventListener("dragover", function (e) {
            e.preventDefault(), e.stopPropagation(), re = e.pageX, ae = e.pageY;
            var t = document.getElementById("filesList");
            ae + 20 > t.getBoundingClientRect().bottom && ue(t, 0, 10), ae - 20 < t.getBoundingClientRect().top && ue(t, 0, -10)
          }, !1), A.helpers.isMobile()) {
            var t = e.getElementsByClassName("dot");
            t[0].addEventListener("touchmove", function (e) {
              e.preventDefault(), e.stopPropagation();
              for (var t = e.target; t && !t.classList.contains(fe);) t = t.parentElement;
              for (var n = document.elementFromPoint(e.targetTouches[0].clientX, e.targetTouches[0].clientY); n && !n.classList.contains(fe);) n = n.parentElement;
              var r = document.getElementsByClassName("fr-hovered-over-file");
              Array.prototype.forEach.call(r, function (e) {
                e.classList.remove("fr-hovered-over-file")
              }), n && !t.classList.contains("fr-unchecked") && n.classList.add("fr-hovered-over-file");
              var a = document.getElementById("filesList");
              e.targetTouches[0].clientY + 5 > a.getBoundingClientRect().bottom && ue(a, 0, 5), e.targetTouches[0].clientY - 5 < a.getBoundingClientRect().top && ue(a, 0, -5)
            }, !1)
          }
          if (e.ondrag = he, e.ondragend = ge, A.helpers.isMobile()) {
            var n = e.getElementsByClassName("dot");
            n[0].addEventListener("touchmove", he, !1), n[0].addEventListener("touchend", ge, !1)
          }
        }(e)
      })
    }

    function ue(e, t, n) {
      e.scrollLeft += t, e.scrollTop += n
    }

    function he(e) {
      for (A.helpers.isMobile() && (ie = event.touches[0].clientX, se = event.touches[0].clientY), oe = e.target; !oe.classList.contains(fe);) oe = oe.parentElement;
      oe.classList.contains(fe) && !oe.classList.contains("fr-unchecked") ? A.helpers.isMobile() && oe.classList.add("drag-sort-active") : oe = undefined
    }

    function ge(e) {
      var t;
      if (oe !== undefined) {
        var n, r;
        if (A.helpers.isMobile()) for (n = ie, r = se, t = event.target; !t.classList.contains(fe);) t = t.parentElement; else n = event.clientX, r = event.clientY;
        A.helpers.isMobile() || !A.browser.safari && !A.browser.mozilla || (n = re, r = ae);
        for (var a = document.elementFromPoint(n, r); a && !a.classList.contains(fe);) a = a.parentElement;
        a && !a.classList.contains(fe) ? a = undefined : a && oe !== a && function s(e, t) {
          var n, r, a = e.parentNode, o = t.parentNode;
          if (!a || !o || a.isEqualNode(t) || o.isEqualNode(e)) return;
          for (var i = 0; i < a.children.length; i++) a.children[i].isEqualNode(e) && (n = i);
          for (var i = 0; i < o.children.length; i++) o.children[i].isEqualNode(t) && (r = i);
          a.isEqualNode(o) && n < r && r++;
          a.insertBefore(t, a.children[n]), o.insertBefore(e, o.children[r])
        }(oe, a), A.helpers.isMobile() && (t.classList.remove("fr-hovered-over-file"), a.classList.remove("fr-hovered-over-file"))
      }
    }

    function me(e) {
      var r = A.popups.get("filesManager.insert");
      r.find(".fr-upload-progress-layer").hasClass("fr-active") || r.find(".fr-upload-progress-layer").addClass("fr-active"), r.find(".fr-upload-progress").removeClass("fr-none");
      var t = k.get(e), n = function i(e) {
          var t, n = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
          try {
            t = e.toLocaleDateString(A.opts.language ? A.opts.language : undefined, n)
          } catch (r) {
            t = e.toLocaleDateString(undefined, n)
          }
          return t + ""
        }(new Date), a = R.get(e) ? "" : "fr-unchecked ",
        o = "\n        <div id='fr-file-".concat(e, "' class='fr-file-list-item fr-file-").concat(e, " ").concat(a, "' draggable = \"").concat(!a, '" >\n        <div class=\'fr-file-item-left\' >\n\n    \n            <div class="fr-file-item-insert-checkbox fr-files-checkbox-line">\n            ').concat(A.helpers.isMobile() ? "<div id='fr-pick-".concat(e, "}' class='dot'>\n            </div>") : "", '\n            <div id="checkbox-key-').concat(e, '" class="fr-files-checkbox fr-insert-checkbox  fr-checkbox-').concat(e, '">\n            <input name="target" class="fr-insert-attr fr-checkbox-file-').concat(e, ' fr-file-insert-check" data-cmd="fileInsertCheckbox"\n             data-checked="_blank" type="checkbox" id="fr-link-target-').concat(A.id, '" tabIndex="0" />\n            <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '\n            </span>\n        </div>\n                <label id="fr-label-target-').concat(A.id, "\"></label>\n            </div>\n    \n            <div class='fr-file-item-icon fr-file-item-icon-").concat(e, "' >\n                <img src='https://secure.webtoolhub.com/static/resources/icons/set112/f2afb6f7.png' alt='Image preview' class='thumbnail-padding' height='36px' width='36px' />\n            </div>\n\n            <div class='fr-file-item-description' >\n                <div class='fr-file-name fr-files-manager-tooltip'>\n                   ").concat(function s(e, t, n) {
          null == t && (t = 100);
          null == n && (n = "...");
          return e.length > t ? e.substring(0, t - n.length) + n : e
        }(t.name, 20), '\n                      <span class="').concat(20 < t.name.length ? "tooltiptext" : "fr-none", '">').concat(t.name, "\n                      </span>\n                 </div>\n                 <div class='fr-file-details'>\n                 <div class='fr-file-date'>").concat(n, "\n                 </div>\n \n                 <div class='fr-file-size'>\n                     ").concat(function l(e) {
          if (0 == e) return "0 Bytes";
          var t = Math.floor(Math.log(e) / Math.log(1024));
          return " | " + 1 * (e / Math.pow(1024, t)).toFixed(2) + " " + ["Bytes", "KB", "MB", "GB", "TB"][t]
        }(t.size), "\n                 </div>\n                 </div>\n\n                  <div class='fr-file-error'>\n                    <h5 class='fr-file-error-h5'></h5>\n                 </div>\n             </div>\n    \n        </div>\n\n        <div class='fr-file-item-right fr-file-item-right-").concat(e, "'>") + Ce(e) + "</div>\n    </div>";
      r.find(".fr-upload-progress-layer")[0].innerHTML = o + r.find(".fr-upload-progress-layer")[0].innerHTML, k.forEach(function c(e, t, n) {
        R.get(t) && r.find("input.fr-insert-attr.fr-checkbox-file-".concat(t))[0].setAttribute("checked", null)
      }), O.forEach(function (e) {
        document.getElementById("fr-file-autoplay-button-" + e).checked = !0
      }), be(e, t), J(), A.opts.toolbarBottom ? C(!0) : A.popups.setPopupDimensions(r), pe("fr-file-list-item")
    }

    function ve(e) {
      switch (e) {
        case"application/msword":
          return A.icon.getFileIcon("docIcon");
        case"application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          return A.icon.getFileIcon("docxIcon");
        case"image/gif":
          return A.icon.getFileIcon("gifIcon");
        case"image/jpeg":
          return A.icon.getFileIcon("jpegIcon");
        case"type/text":
          return A.icon.getFileIcon("logIcon");
        case"video/quicktime":
          return A.icon.getFileIcon("movIcon");
        case"audio/mp3":
        case"audio/mpeg":
          return A.icon.getFileIcon("mp3Icon");
        case"video/mp4":
          return A.icon.getFileIcon("mp4Icon");
        case"audio/ogg":
          return A.icon.getFileIcon("oggIcon");
        case"video/ogg":
          return A.icon.getFileIcon("ogvIcon");
        case"application/pdf":
          return A.icon.getFileIcon("pdfIcon");
        case"image/png":
          return A.icon.getFileIcon("pngIcon");
        case"text/plain":
          return A.icon.getFileIcon("txtIcon");
        case"video/webm":
          return A.icon.getFileIcon("webmIcon");
        case"image/webp":
          return A.icon.getFileIcon("webpIcon");
        case"video/x-ms-wmv":
          return A.icon.getFileIcon("wmvIcon");
        case"application/vnd.ms-excel":
          return A.icon.getFileIcon("xlsIcon");
        case"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return A.icon.getFileIcon("xlsxIcon");
        case"application/x-zip-compressed":
        case"application/zip":
          return A.icon.getFileIcon("zipIcon");
        default:
          return A.icon.getFileIcon("defaultIcon")
      }
    }

    function be(r, a, e) {
      var o = A.popups.get("filesManager.insert"), t = o.find(".fr-file-item-icon-" + r).get(0);
      if (Be(ke(a)) && "image/gif" != ke(a) && "image/webp" != ke(a)) {
        "a" != t.children[0].localName && (t.innerHTML = "<a target='_blank' href=''>" + t.innerHTML + "</a>");
        o.find(".fr-file-item-icon-" + r).get(0).children[0].children[0];
        var i = new FileReader;
        if (null != e && e) {
          var n = k.get(r);
          a.name = n.name, k.set(r, a)
        }
        if (i.onloadend = function () {
          o.find(".fr-file-item-icon-" + r).get(0).children[0].children[0].src = i.result;
          for (var e = atob(i.result.split(",")[1]), t = [], n = 0; n < e.length; n++) t.push(e.charCodeAt(n));
          o.find(".fr-file-item-icon-" + r).get(0).children[0].href = window.URL.createObjectURL(new Blob([new Uint8Array(t)], {type: ke(a)})), o.find(".fr-file-item-icon-" + r).get(0).classList.add("file-item-thumbnail-hover")
        }, a) i.readAsDataURL(a); else {
          var s = ve(ke(a));
          t.innerHTML = '<svg height="40px" width="40px" viewBox="0 0 55 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        '.concat(s.path, "\n        </svg>")
        }
      } else {
        var l = ve(ke(a));
        t.innerHTML = '<svg height="40px" width="40px" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      '.concat(l.path, "\n      </svg>")
      }
    }

    function Ce(e) {
      var t = "";
      if ($e(ke(k.get(e)))) {
        var n = "fr-files-checkbox", r = "";
        Pe(ke(k.get(e))) || (n = "fr-checkbox-disabled", r = "disabled");
        t = '\n      <div class="fr-files-checkbox-line align-autoplay">\n      <div id="checkbox-key-'.concat(e, '" class="').concat(n, " fr-autoplay-checkbox  fr-checkbox-").concat(e, '">  \n                   \n      <input type="checkbox" id="fr-file-autoplay-button-').concat(e, '" class="fr-file-button-').concat(e, ' fr-file-autoplay-button" data-title="Edit" data-param1="').concat(e, '" role="button" ').concat(r, "/>\n\n      <span>").concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', " </span>\n      </div>      \n      <label  class='fr-autoplay-checkbox-label'>Autoplay </label>\n      </div>")
      }
      var a = "application/msword", o = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        i = "";
      return !Fe(ke(k.get(e))) && Pe(ke(k.get(e))) || (s = "fr-disabled"), $e(ke(k.get(e))) && (s = "fr-disabled"), He(ke(k.get(e))) && (s = "fr-disabled", ke(k.get(e)) != a && ke(k.get(e)) != o || A.opts.googleOptions && !A.helpers.isMobile() && A.opts.googleOptions.API_KEY && A.opts.googleOptions.CLIENT_ID && (s = ""), "text/plain" != ke(k.get(e)) && ke(k.get(e)) != a && "application/pdf" != ke(k.get(e)) && ke(k.get(e)) != o && "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" != ke(k.get(e)) && "application/vnd.ms-excel" != ke(k.get(e)) && "type/text" != ke(k.get(e)) || (i = "")), "video/url" === ke(k.get(e)) && (s = "fr-disabled"), t += '<div class=\'fr-file-item-action-buttons\' >\n                <button type="button" id="fr-file-insert-button-'.concat(e, '" class=" fr-doc-edit-').concat(e, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-button-").concat(e, " fr-file-insert-button-").concat(e, ' fr-file-insert-button" data-cmd="imageInsertByUpload" data-title="Insert" data-param1="').concat(e, '" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-5 0 28 28" xlmns = "http://w3.org/200/svg"><path d = \'M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 \'></path></svg>\n                </button>\n\n                <button type="button" id="fr-file-edit-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " ").concat(s, " fr-img-icon fr-btn fr-command fr-submit \n                fr-file-action-icons fr-file-edit-button-").concat(e, " fr-file-button-").concat(e, ' fr-file-edit-button" data-cmd="editImage" data-title="Edit" data-param1="').concat(e, '" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "0 4 25 25" xlmns = "http://w3.org/200/svg"><path d = \'M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z\'></path></svg>\n                </button>\n                \n                <span class="fr-file-view-').concat(e, '"><button type="button" id="fr-file-view-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " ").concat(i, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-view-button-").concat(e, ' fr-file-view-button" data-cmd="viewImage" data-title="View" data-param1="').concat(e, '" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "15 19 21 21" xlmns = "http://w3.org/200/svg"> <path style="fill:none;stroke-width:0.9077;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(0%,0%,0%);stroke-opacity:1;stroke-miterlimit:10;" d="M 19.086094 16.541466 C 16.185625 16.541466 14.318281 19.447115 14.318281 19.447115 L 14.318281 19.555288 C 14.318281 19.555288 16.176719 22.475962 19.077187 22.475962 C 21.977656 22.475962 23.847969 19.576322 23.847969 19.576322 L 23.847969 19.465144 C 23.847969 19.465144 21.989531 16.541466 19.086094 16.541466 Z M 19.07125 21.024639 C 18.248906 21.024639 17.583906 20.357572 17.583906 19.53726 C 17.583906 18.716947 18.248906 18.04988 19.07125 18.04988 C 19.890625 18.04988 20.555625 18.716947 20.555625 19.53726 C 20.555625 20.357572 19.890625 21.024639 19.07125 21.024639 Z M 19.07125 21.024639 " transform="matrix(1.315789,0,0,1.3,0,0)"/></svg></button></span>\n\n                <button type="button" id="fr-file-delete-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons\n                fr-file-button-").concat(e, ' fr-file-delete-button" data-cmd="deleteImage" data-title="Delete" data-param1="').concat(e, '" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n                </button>\n                 \n            </div>\n            <div id="user_area-').concat(e, "\" style=\"display: none;\">\n            \n              <div id=\"file_container\"></div>\n\n              <div style='display:block;text-align: center; margin-left:50%; id='edit-file-loader' class='fr-file-loader'></div>\n\n          </div> \n            ")
    }

    function Ee(e, t, n) {
      var r = A.popups.get("filesManager.insert");
      if (!n && e <= 100) {
        r.find(".fr-checkbox-file-" + t).get(0).disabled = !0, r.find(".fr-checkbox-" + t).get(0).classList.remove("fr-files-checkbox"), r.find(".fr-checkbox-" + t).get(0).classList.add("fr-checkbox-disabled");
        var a = r.find(".fr-file-progress-circle-" + t), o = r.find(".fr-file-upload-percent-" + t);
        return 50 < e ? a.get(0).setAttribute("class", "fr-file-progress-circle-" + t + " progress-circle p" + Math.floor(e) + " over50") : a.get(0).setAttribute("class", "fr-file-progress-circle-" + t + " progress-circle p" + Math.floor(e)), o.get(0).innerHTML = Math.floor(e) + "%", void ye(t, e, n)
      }
      n && (r.find(".fr-checkbox-file-" + t).get(0).disabled = !1, r.find(".fr-checkbox-" + t).get(0).classList.remove("fr-checkbox-disabled"), r.find(".fr-checkbox-" + t).get(0).classList.add("fr-files-checkbox"), r.find(".fr-file-item-right-" + t).get(0).innerHTML = Ce(t), ye(t, 100, n))
    }

    function ye(e, t, n) {
      var r = A.popups.get("filesManager.insert");
      r.find(".fr-progress-bar").removeClass("fr-none").addClass("fr-display-block"), r.find(".fr-upload-progress").hasClass("fr-height-set") && A.popups.setFileListHeight(r);
      var a = 0;
      w.set(e, t), w.forEach(function (e, t) {
        a += e
      }), a /= w.size, 100 == t && n && o++, r.find('.fr-command[data-cmd="filesUpload"]').addClass("fr-disabled"), r.find('.fr-command[data-cmd="filesByURL"]').addClass("fr-disabled"), r.find('.fr-command[data-cmd="filesEmbed"]').addClass("fr-disabled"), r.find(".fr-progress-bar").get(0).style.width = a + "%", o == w.size && (r.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"), w = new Map, o = 0, r.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"), r.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"), r.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"))
    }

    function Le(n, r) {
      J(), A.popups.get("filesManager.insert").find(".fr-upload-progress-layer").addClass("fr-active"), n.forEach(function (e, t) {
        Be(ke(e)) && A.opts.imageUploadRemoteUrls && A.opts.imageCORSProxy && A.opts.imageUpload ? Ne(e, n, y, r[t]) : x.set(r[t], e)
      })
    }

    function _e(e) {
      e && e.get && function n(e) {
        if ("false" == S(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
        if (e && "touchend" == e.type && de) return !0;
        if (e && A.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
        for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != A && xt.INSTANCES[t].events.trigger("image.hideResizer");
        A.toolbar.disable(), e && (e.stopPropagation(), e.preventDefault());
        A.helpers.isMobile() && (A.events.disableBlur(), A.$el.blur(), A.events.enableBlur());
        A.opts.iframe && A.size.syncIframe();
        y = S(this), U(), A.browser.msie ? (A.popups.areVisible() && A.events.disableBlur(), A.win.getSelection && (A.win.getSelection().removeAllRanges(), A.win.getSelection().addRange(A.doc.createRange()))) : A.selection.clear();
        A.helpers.isIOS() && (A.events.disableBlur(), A.$el.blur());
        A.button.bulkRefresh(), A.events.trigger("video.hideResizer")
      }.call(e.get(0))
    }

    function we() {
      var e = S(this);
      e.removeClass("fr-uploading"), e.next().is("br") && e.next().remove(), (0 == a.length || 0 < a.length && a.length == u) && (f = e), "VIDEO" == e.get(0).tagName || "AUDIO" == e.get(0).tagName ? A.selection.setAfter(e.parent()) : A.selection.setAfter(e), A.undo.saveStep(), A.events.trigger("filesManager.loaded", [e]), Te(a)
    }

    function Ae() {
      var e, t = Array.prototype.slice.call(A.el.querySelectorAll("video, .fr-video > *")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("src")), S(t[e]).toggleClass("fr-draggable", A.opts.videoMove), "" === t[e].getAttribute("class") && t[e].removeAttribute("class"), "" === t[e].getAttribute("style") && t[e].removeAttribute("style");
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("src")) < 0 && A.events.trigger("video.removed", [S(r[e])]);
      r = t
    }

    function Te(e) {
      if (null != e) {
        if (0 == e.length) return void (null != f && ("VIDEO" == f.get(0).tagName ? A.video._editVideo(f.parent()) : "IMG" == f.get(0).tagName ? A.image.edit(f) : f.trigger("click"), A.toolbar.disable()));
        xe(e.shift(), e)
      }
    }

    function Se(e) {
      var t = !1;
      if ($e(ke(x.get(e)))) A.trimVideoPlugin.trimVideo(k.get(e), e, k), t = !0; else if (Be(ke(x.get(e)))) {
        var n = x.get(e).link, r = A.o_doc.createElement("img");
        r.src = n, y = r, i = e, A.imageTUI.launch(A, !1, e), t = !0
      } else if (He(ke(x.get(e)))) {
        var a = {
          apiKey: A.opts.googleOptions.API_KEY,
          clientId: A.opts.googleOptions.CLIENT_ID,
          authorizeButton: "authorize_button-".concat(e),
          signoutButton: "signout_button",
          userArea: "user_area-".concat(e),
          fileInput: "file_input",
          fileIndex: e,
          file: k.get(e),
          fileContainer: "file_container",
          loadingText: "File is being uploaded...",
          events: {
            onInvalidFile: function (e) {
            }, onError: function (e) {
            }
          }
        };
        ce = function d(p) {
          var o, e = ["https://www.googleapis.com/discovery/v1/apis/drive/v2/rest"],
            u = "id,title,mimeType,userPermission,editable,copyable,shared,fileSize",
            h = "-------314159265358979323846", g = "\r\n--" + h + "\r\n", m = "\r\n--" + h + "--",
            t = (document.getElementById(p.authorizeButton), document.getElementById(p.userArea));
          p.events || (p.events = {});

          function n() {
            gapi.client.init({
              apiKey: p.apiKey,
              clientId: p.clientId,
              discoveryDocs: e,
              scope: "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.appdata"
            }).then(function () {
              gapi.auth2.getAuthInstance().isSignedIn.listen(r), r(gapi.auth2.getAuthInstance().isSignedIn.get()), function t(e) {
                !gapi.auth2.getAuthInstance().isSignedIn.get() || gapi.auth.getToken() !== undefined && gapi.auth.getToken().access_token === undefined ? Promise.resolve(gapi.auth2.getAuthInstance().signIn()).then(function () {
                  i()
                }) : i()
              }()
            }, function (e) {
              p.events.onError(e)
            })
          }

          function r(e) {
            e && (t.style.display = "block")
          }

          function a(e) {
            var t = gapi.auth.getToken().access_token, n = o,
              r = "https://docs.google.com/feeds/download/documents/export/Export?id=" + n + "&format=docx&access_token=" + t,
              a = new XMLHttpRequest;
            a.open("get", r), a.responseType = "arraybuffer", a.onload = function () {
              var e = new Blob([new Uint8Array(this.response)], {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"}),
                t = k.get(p.fileIndex);
              e.name = t.name, e.lastModified = t.lastModified, e.lastModifiedDate = t.lastModifiedDate, k.set(p.fileIndex, e), A.filesManager.upload(e, x, y, p.fileIndex), l()
            }, a.send()
          }

          function i(e) {
            !function r(e) {
              for (var t = document.getElementsByClassName("fr-doc-edit-".concat(e)), n = 0; n < t.length; n++) t[n].setAttribute("disabled", !0), t[n].classList.add("fr-disabled")
            }(p.fileIndex);
            var t = p.file;
            t ? function n(c, d) {
              var f = new FileReader;
              f.readAsArrayBuffer(c), f.onload = function (e) {
                for (var t = {
                  title: c.name,
                  mimeType: "application/vnd.google-apps.document"
                }, n = "", r = new Uint8Array(f.result), a = r.byteLength, o = 0; o < a; o++) n += String.fromCharCode(r[o]);
                var i = btoa(n),
                  s = g + "Content-Type: application/json; charset=UTF-8\r\n\r\n" + JSON.stringify(t) + g + "Content-Type: application/octet-stream\r\nContent-Transfer-Encoding: base64\r\n\r\n" + i + m,
                  l = gapi.client.request({
                    path: "/upload/drive/v2/files",
                    method: "POST",
                    params: {uploadType: "multipart", fields: u},
                    headers: {"Content-Type": 'multipart/related; boundary="' + h + '"', "Content-Length": s.Length},
                    body: s
                  });
                d || (d = function (e) {
                }), l.execute(function (e, t) {
                  e.error ? p.events.onError(e.error) : d(e)
                })
              }
            }(t, s) : p.events.onInvalidFile("File is not selected")
          }

          function s(e) {
            o = e.id;
            var t = "https://docs.google.com/document/d/" + e.id + "/edit", n = A.o_doc.body,
              r = A.o_doc.createElement("div");
            r.setAttribute("id", "editDocContainer"), r.style.cssText = "position: fixed; top: 0;left: 0;padding: 0;width: 100%;height: 100%;background: rgba(255,255,255,1);z-index: 9998;display:block", r.innerHTML = '<div style="margin-top:25px; text-align:center"><label>Sign Out : </label><input type="checkbox" id ="markSignOut" role="button"/>  <button id="signout_button"  class="fr-trim-button" >Save </button> <button id="cancel_file_edit" class="fr-trim-button">Cancel</button></div>  <iframe title="Edit your file" frameBorder="0" width="100%" height="700px" src="' + t + '"></iframe>', n.appendChild(r), document.getElementById("signout_button").onclick = a, document.getElementById("cancel_file_edit").onclick = l
          }

          function l() {
            document.getElementById("markSignOut").checked && gapi.auth2.getAuthInstance().signOut().then(function () {
              gapi.auth.getToken() && (gapi.auth.getToken().access_token = undefined)
            });
            var e = document.getElementById("editDocContainer");
            e.parentNode.removeChild(e), document.getElementById("user_area-".concat(p.fileIndex)) && (document.getElementById("user_area-".concat(p.fileIndex)).style.display = "none"), function r(e) {
              for (var t = document.getElementsByClassName("fr-doc-edit-".concat(e)), n = 0; n < t.length; n++) t[n].removeAttribute("disabled"), t[n].classList.remove("fr-disabled")
            }(p.fileIndex)
          }

          p.events.onInvalidFile = p.events.onInvalidFile || function (e) {
          }, p.events.onError = p.events.onError || function (e) {
          };
          var c = {};
          return c.handleClientLoad = function () {
            gapi.load("client:auth2", n)
          }, c
        }(a), function o(e, t) {
          var r = function r(e, t) {
            var n = document.createElement("script");
            n.src = e, n.onload = function () {
              this.onload = function () {
              }, ce.handleClientLoad()
            }, n.onreadystatechange = function () {
              "complete" === this.readyState && this.onload()
            }, (document.getElementsByTagName("head")[0] || document.body).appendChild(n)
          };
          !function n() {
            0 != e.length ? r(e.shift(), n) : t && t()
          }()
        }(["https://apis.google.com/js/api.js"], function () {
        })
      }
      t && (p = !0)
    }

    function ke(e) {
      if ("" != e.type) return e.type;
      var n, r = /(?:\.([^.]+))?$/.exec(e.name)[1];
      return [[".doc", "application/msword"], [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"], [".gif", "image/gif"], [".jpeg", "image/jpeg"], [".jpg", "image/jpeg"], [".txt", "text/plain"], [".log", "type/text"], [".mov", "video/quicktime"], [".mp3", "audio/mpeg"], [".mp4", "video/mp4"], [".ogg", "audio/ogg"], [".ogv", "video/ogg"], [".pdf", "application/pdf"], [".png", "image/png"], [".webm", "video/webm"], [".webp", "image/webp"], [".wmv", "video/x-ms-wmv"], [".xls", "application/vnd.ms-excel"], [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"], [".zip", "application/x-zip-compressed"]].forEach(function (e, t) {
        e[0] == ".".concat(r) && (n = e[1])
      }), n
    }

    function xe(s, e) {
      if (He(ke(x.get(s))) || !Pe(ke(x.get(s)))) {
        var t = x.get(s).link, n = x.get(s).text;
        !n && k.get(s) && k.get(s).name && (n = k.get(s).name);
        var r = x.get(s).response;
        if (A.edit.on(), A.events.focus(!0), A.selection.restore(), A.opts.fileUseSelectedText && A.selection.text().length && (n = A.selection.text()), t.endsWith(".pdf") || t.endsWith(".txt")) Re('<iframe src="'.concat(t, '" title="').concat(n, '" width="\u201d100%\u201d" height="\u201d100%\u201d" class="fr-file"></iframe>'), !0); else A.html.insert('<a href="'.concat(t, '" target="_blank" id="fr-inserted-file" class="fr-file">').concat(n, "</a>"));
        var a = A.$el.find("#fr-inserted-file");
        a.removeAttr("id"), A.undo.saveStep(), function L() {
          var e, t = Array.prototype.slice.call(A.el.querySelectorAll("a.fr-file")), n = [];
          for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("href"));
          if (le) for (e = 0; e < le.length; e++) n.indexOf(le[e].getAttribute("href")) < 0 && A.events.trigger("file.unlink", [le[e]]);
          le = t
        }(), A.selection.clear(), A.selection.setAfter(a), A.events.trigger("file.inserted", [a, r]), Te(e)
      }
      if (Be(ke(x.get(s))) && Pe(ke(x.get(s)))) {
        var i = x.get(s).link, o = x.get(s).sanitize, l = x.get(s).data, c = x.get(s).$existing_img,
          d = x.get(s).response;
        c && "string" == typeof c && (c = A.$(c)), A.edit.off(), ee(A.language.translate("Loading image")), o && (i = A.helpers.sanitizeURL(i));
        var f = new Image;
        f.onload = function () {
          var e, t;
          if (c) {
            A.undo.canDo() || c.hasClass("fr-uploading") || A.undo.saveStep();
            var n = c.data("fr-old-src");
            c.data("fr-image-pasted") && (n = null), A.$wp ? ((e = c.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"), n && c.attr("src", n), c.replaceWith(e)) : e = c;
            for (var r = e.get(0).attributes, a = 0; a < r.length; a++) {
              var o = r[a];
              0 === o.nodeName.indexOf("data-") && e.removeAttr(o.nodeName)
            }
            if (void 0 !== l) for (t in l) l.hasOwnProperty(t) && "link" != t && e.attr("data-".concat(t), l[t]);
            e.on("load", we), e.attr("src", i), A.edit.on(), A.undo.saveStep(), A.events.disableBlur(), A.$el.blur(), A.events.trigger(n ? "image.replaced" : "image.inserted", [e, d])
          } else e = function s(e, t, n) {
            var r, a = S(document.createElement("img")).attr("src", e);
            if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (" data-".concat(r, '="').concat(t[r], '"'), a.attr("data-".concat(r), t[r]));
            var o = A.opts.imageDefaultWidth;
            o && "auto" != o && (o = A.opts.imageResizeWithPercent ? "100%" : "".concat(o, "px"));
            a.attr("style", o ? "width: ".concat(o, ";") : ""), st(a, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), a.on("load", n), a.on("error", n), A.edit.on(), A.events.focus(!0), A.selection.restore(), A.undo.saveStep(), A.opts.imageSplitHTML ? A.markers.split() : A.markers.insert();
            A.html.wrap();
            var i = A.$el.find(".fr-marker");
            i.length ? (i.parent().is("hr") && i.parent().after(i), A.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a)) : A.$el.append(a);
            return a
          }(i, l, we), A.undo.saveStep(), A.events.disableBlur(), A.$el.blur(), A.events.trigger("image.inserted", [e, d])
        }, f.onerror = function () {
          j(N, null, null, s), Te(e)
        }, f.src = i
      }
      if (($e(ke(x.get(s))) || Fe(ke(x.get(s)))) && Pe(ke(x.get(s)))) if (T = s, "video/url" == ke(x.get(s))) {
        var p = !1;
        if (document.getElementById("fr-file-autoplay-button-" + s) !== undefined && (p = document.getElementById("fr-file-autoplay-button-" + s).checked), p && x.get(s) !== undefined && -1 < x.get(s).video.indexOf("iframe") && x.get(s).video.indexOf("autoplay=1") < 0) {
          var u = x.get(s).video.substring(x.get(s).video.indexOf("src") + 3), h = "&";
          (u = (u = u.substring(u.indexOf('"') + 1)).substring(0, u.indexOf('"'))).indexOf("?") < 0 && (h = "?"), x.get(s).video = x.get(s).video.replace(u, u += h + "autoplay=1")
        } else !p && x.get(s).video.indexOf(!1) && (-1 < x.get(s).video.indexOf("&autoplay=1") && (x.get(s).video = x.get(s).video.replace("&autoplay=1", "")), -1 < x.get(s).video.indexOf("?autoplay=1") && (x.get(s).video = x.get(s).video.replace("?autoplay=1", "")));
        A.events.focus(!0), A.selection.restore(), A.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(x.get(s).video, "</span>"), !1, A.opts.videoSplitHTML), A.popups.hide("filesManager.insert");
        var g = A.$el.find(".fr-jiv");
        g.removeClass("fr-jiv"), g.toggleClass("fr-rv", A.opts.videoResponsive), function _(e, t, n) {
          !A.opts.htmlUntouched && A.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
            display: "block",
            clear: "both"
          }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
        }(g, A.opts.videoDefaultDisplay, A.opts.videoDefaultAlign), g.toggleClass("fr-draggable", A.opts.videoMove), A.events.trigger("video.inserted", [g]), we.call(g)
      } else {
        var m = x.get(s).link, v = x.get(s).sanitize, b = x.get(s).data, C = x.get(s).$existing_img,
          E = x.get(s).response;
        A.edit.off(), v && (m = A.helpers.sanitizeURL(m)), function w() {
          var e, t;
          if (C) {
            A.undo.canDo() || C.find("video").hasClass("fr-uploading") || A.undo.saveStep();
            var n = C.find("video").data("fr-old-src"), r = C.data("fr-replaced");
            C.data("fr-replaced", !1), A.$wp ? ((e = C.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"), e.find("video").off("canplay"), n && C.find("video").attr("src", n), C.replaceWith(e)) : e = C;
            for (var a = e.find("video").get(0).attributes, o = 0; o < a.length; o++) {
              var i = a[o];
              0 === i.nodeName.indexOf("data-") && e.find("video").removeAttr(i.nodeName)
            }
            if (void 0 !== b) for (t in b) b.hasOwnProperty(t) && "link" != t && e.find("video").attr("data-".concat(t), b[t]);
            e.find("video").on("canplay", we), e.find("video").attr("src", m), A.edit.on(), Ae(), A.undo.saveStep(), A.$el.blur(), A.events.trigger(r ? "video.replaced" : "video.inserted", [e, E])
          } else e = function u(e, t, n, r, a) {
            var o, i = "";
            if (t && void 0 !== t) for (o in t) t.hasOwnProperty(o) && "link" != o && (i += " data-".concat(o, '="').concat(t[o], '"'));
            var s, l = A.opts.videoDefaultWidth;
            l && "auto" != l && (l = "".concat(l, "px"));
            if (Fe(r)) s = S(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + A.opts.videoDefaultDisplay[0] + ("center" != A.opts.videoDefaultAlign ? " fr-fv" + A.opts.videoDefaultAlign[0] : "")).html('<audio src="' + e + '" ' + i + " controls>" + A.language.translate("Your browser does not support HTML5 video.") + "</audio>"); else {
              var c = "", d = document.getElementById("fr-file-autoplay-button-" + a).checked;
              d && (c = "autoplay"), s = S(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + A.opts.videoDefaultDisplay[0] + ("center" != A.opts.videoDefaultAlign ? " fr-fv" + A.opts.videoDefaultAlign[0] : "")).html('<video src="' + e + '" ' + i + (l ? ' style="width: ' + l + ';" ' : "") + c + "  controls>" + A.language.translate("Your browser does not support HTML5 video.") + "</video>")
            }
            s.toggleClass("fr-draggable", A.opts.videoMove), A.edit.on(), A.events.focus(!0), A.selection.restore(), A.undo.saveStep(), A.opts.videoSplitHTML ? A.markers.split() : A.markers.insert();
            A.html.wrap();
            var f = A.$el.find(".fr-marker");
            A.node.isLastSibling(f) && f.parent().hasClass("fr-deletable") && f.insertAfter(f.parent());
            f.replaceWith(s);
            var p = "";
            p = Fe(r) ? "audio" : "video", s.find(p).get(0).readyState > s.find(p).get(0).HAVE_FUTURE_DATA || A.helpers.isIOS() ? n.call(s.find(p).get(0)) : (s.find(p).on("canplaythrough load", n), s.find(p).on("error", n));
            return s
          }(m, b, we, ke(x.get(s)), s), Ae(), A.undo.saveStep(), A.events.trigger("video.inserted", [e, E])
        }()
      }
      A.popups.hide("filesManager.insert"), R["delete"](s);
      var y = A.popups.get("filesManager.insert");
      y.find("input.fr-insert-attr.fr-checkbox-file-".concat(s))[0].checked = !1, y.find(".fr-file-" + s).get(0).classList.add("fr-unchecked"), q(), document.getElementById("fr-file-autoplay-button-" + s) && (document.getElementById("fr-file-autoplay-button-" + s).checked = !1), O = O.filter(function (e) {
        return e != s
      })
    }

    function Re(e, t) {
      var n, r;
      xt.VIDEO_EMBED_REGEX.test(e) ? (n = "video", r = A.opts.videoSplitHTML) : xt.IMAGE_EMBED_REGEX.test(e) && (n = "image", r = A.opts.imageSplitHTML), A.events.focus(!0), A.selection.restore();
      var a = !1;
      y && (Ze(), a = !0), A.html.insert('<span id="fr-inserted-file" contenteditable="true" draggable="true" class="fr-'.concat(n, ' fr-jiv fr-deletable">').concat(e, "</span>"), !1, r), A.popups.hide("filesManager.insert");
      var o = A.$el.find(".fr-jiv");
      o.removeClass("fr-jiv"), "video" == n && (o.toggleClass("fr-rv", A.opts.videoResponsive), function i(e, t, n) {
        !A.opts.htmlUntouched && A.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
          display: "block",
          clear: "both"
        }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
      }(o, A.opts.videoDefaultDisplay, A.opts.videoDefaultAlign), o.toggleClass("fr-draggable", A.opts.videoMove), A.events.trigger(a ? "video.replaced" : "video.inserted", [o])), "image" == n && (st(o, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), o.find("img").removeClass("fr-dii"), o.find("img").addClass("fr-dib"), o.toggleClass("fr-draggable", A.opts.imageMove), A.events.trigger(a ? "image.replaced" : "image.inserted", [o])), t && (f = o, A.selection.clear(), A.toolbar.disable(), A.video._editVideo(f))
    }

    function Me(e, t) {
      try {
        if (!1 === A.events.trigger("filesManager.uploaded", [e], !0)) return A.edit.on(), !1;
        var n = JSON.parse(e);
        return n.link ? n : (j(m, e, null, t), !1)
      } catch (r) {
        return j(D, e, null, t), !1
      }
    }

    function Oe(e, t) {
      try {
        var n = S(e).find("Location").text(), r = S(e).find("Key").text();
        return !1 === A.events.trigger("filesManager.uploadedToS3", [n, r, e], !0) ? (A.edit.on(), !1) : n
      } catch (a) {
        return j(D, e, null, t), !1
      }
    }

    function Ne(e, t, n, r) {
      if (-1 < F.indexOf(ke(e)) || !ke(e)) return j(H, null, null, r), !1;
      if (!1 === A.events.trigger("filesManager.beforeUpload", [t])) return !1;
      if (!(null !== A.opts.filesManagerUploadURL && A.opts.filesManagerUploadURL != L || A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure)) return function C(s, l, c) {
        var d = new FileReader;
        d.onload = function () {
          var e = d.result;
          if (d.result.indexOf("svg+xml") < 0) {
            for (var t = atob(d.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
            if (e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: ke(l)})), Be(ke(l))) {
              var a = {link: e, sanitize: !1, data: null, $existing_img: c, response: null, type: ke(l)};
              x.set(s, a)
            }
            if (He(ke(l))) {
              var o = {link: e, text: l.name, response: null, type: ke(l)};
              x.set(s, o)
            }
            if ($e(ke(l)) || Fe(ke(l))) {
              var i = {link: e, sanitize: !1, data: null, $existing_img: c, type: ke(l)};
              x.set(s, i)
            }
          }
        }, d.readAsDataURL(l)
      }(r, e), !1;
      if (Be(ke(e)) && (e.name || (e.name = (new Date).getTime() + "." + (ke(e) || "image/jpeg").replace(/image\//g, ""))), e.size > A.opts.filesManagerMaxSize) return j(B, null, null, r), !1;
      if (A.opts.filesManagerAllowedTypes.indexOf("*") < 0 && A.opts.filesManagerAllowedTypes.indexOf(ke(e)) < 0) return j(H, null, null, r), !1;
      var a;
      if (function E(e) {
        isNaN(e) || (A.popups.get("filesManager.insert").find(".fr-file-item-right-" + e).get(0).innerHTML = '<div class=\'fr-file-item-action-buttons\' >\n    <button type="button" id="fr-file-cancel-upload-button-'.concat(e, '" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e, ' fr-file-cancel-upload-button" data-cmd="cancelUpload" data-title="Cancel" data-param1="').concat(e, '" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z\'></path></svg>\n    </button>\n\n    <button type="button" id="fr-upload-delete-button-').concat(e, '" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e, ' fr-upload-delete-button" data-cmd="deleteUpload" data-title="Delete" data-param1="').concat(e, '" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n    </button>\n\n    <div class=\'progress-circle p0 fr-file-progress-circle-').concat(e, "'>\n                  <span class='fr-file-upload-percent-").concat(e, " fr-file-upload-percent'>0%</span>\n                  <div class='left-half-clipper'>\n                    <div class='first50-bar'></div>\n                    <div class='value-bar'></div>\n                  </div>\n                </div>\n            </div>"), w.set(e, 0))
      }(r), A.drag_support.formdata && (a = A.drag_support.formdata ? new FormData : null), a) {
        var o;
        if (!1 !== A.opts.filesManagerUploadToS3) for (o in a.append("key", A.opts.filesManagerUploadToS3.keyStart + (new Date).getTime() + "-" + (e.name || "untitled")), a.append("success_action_status", "201"), a.append("X-Requested-With", "xhr"), a.append("Content-Type", ke(e)), A.opts.filesManagerUploadToS3.params) A.opts.filesManagerUploadToS3.params.hasOwnProperty(o) && a.append(o, A.opts.filesManagerUploadToS3.params[o]);
        for (o in A.opts.filesManagerUploadParams) A.opts.filesManagerUploadParams.hasOwnProperty(o) && a.append(o, A.opts.filesManagerUploadParams[o]);
        a.append(A.opts.filesManagerUploadParam, e, e.name);
        var i, s, l = A.opts.filesManagerUploadURL;
        A.opts.filesManagerUploadToS3 && (l = A.opts.filesManagerUploadToS3.uploadURL ? A.opts.filesManagerUploadToS3.uploadURL : "https://".concat(A.opts.filesManagerUploadToS3.region, ".amazonaws.com/").concat(A.opts.filesManagerUploadToS3.bucket)), A.opts.filesManagerUploadToAzure && (l = A.opts.filesManagerUploadToAzure.uploadURL ? "".concat(A.opts.filesManagerUploadToAzure.uploadURL, "/").concat(e.name) : encodeURI("https://".concat(A.opts.filesManagerUploadToAzure.account, ".blob.core.windows.net/").concat(A.opts.filesManagerUploadToAzure.container, "/").concat(e.name)), i = l, A.opts.filesManagerUploadToAzure.SASToken && (l += A.opts.filesManagerUploadToAzure.SASToken), A.opts.filesManagerUploadMethod = "PUT");
        var c = A.core.getXHR(l, A.opts.filesManagerUploadMethod);
        if (A.opts.filesManagerUploadToAzure) {
          var d = (new Date).toUTCString();
          if (!A.opts.filesManagerUploadToAzure.SASToken && A.opts.filesManagerUploadToAzure.accessKey) {
            var f = A.opts.filesManagerUploadToAzure.account, p = A.opts.filesManagerUploadToAzure.container;
            if (A.opts.filesManagerUploadToAzure.uploadURL) {
              var u = A.opts.filesManagerUploadToAzure.uploadURL.split("/");
              p = u.pop(), f = u.pop().split(".")[0]
            }
            var h = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(d, "\nx-ms-version:2019-07-07"),
              g = encodeURI("/" + f + "/" + p + "/" + e.name),
              m = A.opts.filesManagerUploadMethod + "\n\n\n" + e.size + "\n\n" + ke(e) + "\n\n\n\n\n\n\n" + h + "\n" + g,
              v = A.cryptoJSPlugin.cryptoJS.HmacSHA256(m, A.cryptoJSPlugin.cryptoJS.enc.Base64.parse(A.opts.filesManagerUploadToAzure.accessKey)).toString(A.cryptoJSPlugin.cryptoJS.enc.Base64),
              b = "SharedKey " + f + ":" + v;
            s = v, c.setRequestHeader("Authorization", b)
          }
          for (o in c.setRequestHeader("x-ms-version", "2019-07-07"), c.setRequestHeader("x-ms-date", d), c.setRequestHeader("Content-Type", ke(e)), c.setRequestHeader("x-ms-blob-type", "BlockBlob"), A.opts.filesManagerUploadParams) A.opts.filesManagerUploadParams.hasOwnProperty(o) && c.setRequestHeader(o, A.opts.filesManagerUploadParams[o]);
          for (o in A.opts.filesManagerUploadToAzure.params) A.opts.filesManagerUploadToAzure.params.hasOwnProperty(o) && c.setRequestHeader(o, A.opts.filesManagerUploadToAzure.params[o])
        }
        c.onload = function () {
          He(ke(e)) ? function h(e, t, n, r, a) {
            var o = this.status, i = this.response, s = this.responseXML, l = this.responseText;
            try {
              if (A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure) if (201 === o) {
                var c;
                if (A.opts.filesManagerUploadToAzure) {
                  if (!1 === A.events.trigger("filesManager.uploadedToAzure", [this.responseURL, a, i], !0)) return A.edit.on(), !1;
                  c = r
                } else c = Oe(s, t);
                if (c) {
                  var d = {link: c, text: e, response: i, type: n};
                  x.set(t, d)
                }
              } else j(D, i || s, null, t); else if (200 <= o && o < 300) {
                var f = Me(l, t);
                if (f) {
                  var p = {link: f.link, text: e, response: i, type: n};
                  x.set(t, p)
                }
              } else j(I, i || l, null, t)
            } catch (u) {
              j(D, i || l, null, t)
            }
          }.call(c, e.name, r, ke(e), i, s) : function g(e, t, n, r, a) {
            var o = this.status, i = this.response, s = this.responseXML, l = this.responseText;
            try {
              if (A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure) if (201 == o) {
                var c;
                if (A.opts.filesManagerUploadToAzure) {
                  if (!1 === A.events.trigger("filesManager.uploadedToAzure", [this.responseURL, a, i], !0)) return A.edit.on(), !1;
                  c = r
                } else c = Oe(s, t);
                if (c) {
                  var d = {link: c, sanitize: !1, data: [], $existing_img: e, response: i || s, type: n};
                  x.set(t, d)
                }
              } else j(D, i || s, e, t); else if (200 <= o && o < 300) {
                var f = Me(l, t);
                if (f) {
                  var p = {link: f.link, sanitize: !1, data: f, $existing_img: e, response: i || s, type: n};
                  x.set(t, p)
                }
              } else j(I, i || l, e, t)
            } catch (u) {
              j(D, i || l, e, t)
            }
          }.call(c, y, r, ke(e), i, s), M.has(r) || Ee(100, r, !0)
        }, c.onerror = function () {
          j(D, this.response || this.responseText || this.responseXML, null, r)
        }, c.upload.onprogress = function (e) {
          !function n(e, t) {
            e.lengthComputable && Ee(e.loaded / e.total * 100 | 0, t, !1)
          }(e, r)
        }, c.onabort = function (e) {
          !function n(e, t) {
            j($, t, y, e)
          }(r, e)
        }, c.send(A.opts.filesManagerUploadToAzure ? e : a), _.set(r, c)
      }
    }

    function Ie(l) {
      A.events.$on(l, "click", ".fr-upload-progress-layer", function (e) {
        if (A.helpers.isMobile()) return e.stopPropagation(), !1
      }, !0), A.events.$on(l, "dragover dragenter", ".fr-upload-progress-layer", function (e) {
        e.preventDefault();
        for (var t = 0; t < e.originalEvent.dataTransfer.types.length; t++) "Files" == e.originalEvent.dataTransfer.types[t] && (e.originalEvent.dataTransfer.dropEffect = "none");
        return !1
      }, !0), A.events.$on(l, "dragleave dragend", ".fr-upload-progress-layer", function (e) {
        return e.preventDefault(), !1
      }, !0), A.events.$on(l, "dragover dragenter", ".fr-files-upload-layer", function (e) {
        return S(this).addClass("fr-drop"), (A.browser.msie || A.browser.edge) && e.preventDefault(), !1
      }, !0), A.events.$on(l, "dragleave dragend", ".fr-files-upload-layer", function (e) {
        return S(this).removeClass("fr-drop"), (A.browser.msie || A.browser.edge) && e.preventDefault(), !1
      }, !0), A.events.$on(l, "click", ".fr-insert-checkbox", function (e) {
        if (this.classList.contains("fr-checkbox-disabled")) return this.children.target.disabled = !0, void (this.children.target.checked = !1);
        var t = parseInt(this.id.split("-").pop());
        R.set(t, this.children.target.checked);
        for (var n = l.find('.fr-command[data-cmd="insertAll"]'), r = l.find('.fr-command[data-cmd="deleteAll"]'), a = l.find('input.fr-file-insert-check[type="checkbox"]'), o = a.length, i = !0, s = 0; s < o; s++) 1 == a[s].checked && (i = !1);
        if (i ? n.addClass("fr-disabled") : n.removeClass("fr-disabled"), i ? r.addClass("fr-disabled") : r.removeClass("fr-disabled"), this.children.target.checked) l.find(".fr-file-" + this.id.split("-").pop()).get(0).setAttribute("draggable", "true"), l.find(".fr-file-" + this.id.split("-").pop()).get(0).classList.remove("fr-unchecked"); else {
          this.id.split("-").pop();
          l.find(".fr-file-" + this.id.split("-").pop()).get(0).setAttribute("draggable", "false"), l.find(".fr-file-" + this.id.split("-").pop()).get(0).classList.add("fr-unchecked")
        }
      }), A.events.$on(l, "click", ".fr-file-insert-button", function (e) {
        this.classList.contains("fr-disabled") || xe(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-autoplay-button", function (e) {
        if (this.parentNode.classList.contains("fr-checkbox-disabled")) return this.disabled = !0, void (this.checked = !1);
        De(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-edit-button", function (e) {
        var t = parseInt(this.id.split("-").pop());
        l.find(".fr-file-edit-button-".concat(t)).hasClass("fr-disabled") || Se(t)
      }), A.events.$on(l, "click", ".fr-file-view-button", function (e) {
        var t = parseInt(this.id.split("-").pop());
        l.find(".fr-file-view-button-".concat(t)).hasClass("fr-disabled") || function v(e) {
          if (!Pe(ke(x.get(e)))) {
            var t = x.get(e).link, n = x.get(e).link;
            if (k.get(e) && k.get(e).name ? n = k.get(e).name : x.get(e).text && (n = x.get(e).text), 0 === t.indexOf("blob:") && A.browser.msie && window.navigator && window.navigator.msSaveBlob) window.navigator.msSaveBlob(k.get(e), n); else {
              var r = document.createElement("a");
              r.href = t, r.download = n, r.click()
            }
            return !1
          }
          var a = A.popups.get("filesManager.insert");
          if (0 < a.find(".fr-file-view-image-" + e).length) a.find(".fr-file-view-image-" + e)[0].remove(); else {
            for (var o = a.find(".fr-file-view"), i = 0; i < o.length; i++) o.get(i).remove();
            var s = a.find(".fr-file-view-" + e);
            if (Be(ke(x.get(e)))) {
              var l = '<div class="fr-file-view-modal">\n              <div class="fr-file-view-modal-content">\n              <div class="fr-file-view-close">&times;</div> \n                <img src="' + x.get(e).link + "\" class ='fr-file-view-image'/>\n                </div>\n              </div>";
              s[0].innerHTML = l + s[0].innerHTML
            } else if ($e(ke(x.get(e)))) {
              var c;
              if (x.get(e).hasOwnProperty("video")) {
                var d = x.get(e).video.substring(x.get(e).video.indexOf("src") + 3),
                  f = d.substring(d.indexOf('"') + 1);
                f = f.substring(0, f.indexOf('"')), c = '<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div class="fr-file-view-close">&times;</div> \n          <iframe width="640" height="360" src="'.concat(f + "&autoplay=1", '" frameborder="0" class = "fr-file-view-image"></iframe>\n        </div>\n      </div>')
              } else c = '<div class="fr-file-view-modal">\n          <div class="fr-file-view-modal-content ">\n            <div class="fr-file-view-close">&times;</div> \n            <video controls src="' + x.get(e).link + "\"  class ='fr-file-view-image' autoplay></video>\n          </div>\n        </div>";
              s[0].innerHTML = c + s[0].innerHTML
            } else if (Fe(ke(x.get(e)))) {
              var p = '<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div  class="fr-file-view-close">&times;</div> \n          <audio controls="controls"  class =\'fr-file-view-image\' autoplay>\n\n          <source src="'.concat(x.get(e).link, '" type="').concat(ke(x.get(e)), '" />\n\n            Your browser does not support the audio element.\n          </audio>\n        </div>\n      </div>');
              s[0].innerHTML = p + s[0].innerHTML
            } else if (He(ke(x.get(e)))) {
              var u = x.get(e).link, h = x.get(e).text;
              if (u.endsWith(".pdf") || u.endsWith(".txt")) {
                var g = '<div class="fr-file-view-modal">\t\n              <div class="fr-file-view-modal-content " >\t\n              <div class="fr-file-view-close">&times;</div> \t\n              <iframe src="'.concat(u, "\" style='background-color: white;' height='50%' width='50%' title=\"").concat(h, '" class="fr-file fr-file-view-image"></iframe>\t\n            </div>\t\n            </div>');
                s[0].innerHTML = g + s[0].innerHTML
              } else if (0 === u.indexOf("blob:") && A.browser.msie && window.navigator && window.navigator.msSaveBlob) window.navigator.msSaveBlob(k.get(e), h); else {
                var m = document.createElement("a");
                m.href = u, m.download = h, m.click()
              }
            }
          }
        }(t)
      }), A.events.$on(l, "click", ".fr-file-delete-button", function (e) {
        Z(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-cancel-upload-button", function (e) {
        !function n(e) {
          var t = A.popups.get("filesManager.insert");
          t.find(".fr-file-item-right-" + e).get(0).innerHTML = Ce(e), _.get(e).abort(), ye(e, 100, !0), t.find(".fr-checkbox-file-" + e).get(0).disabled = !0
        }(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-upload-delete-button", function (e) {
        !function t(e) {
          0 != _.get(e).readyState && (_.get(e).abort(), ye(e, 100, !0), _["delete"](e)), Z(e)
        }(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-view-close", function (e) {
        l.find(".fr-file-view-modal").get(0).outerHTML = ""
      }), A.events.$on(l, "click", ".fr-plugins-enable", function (e) {
        !function t() {
          g.forEach(function (e) {
            A.opts.pluginsEnabled.indexOf(e) < 0 && A.opts.pluginsEnabled.push(e)
          })
        }(), function n(e) {
          for (var t in e) if (!A[t]) {
            if (xt.PLUGINS[t] && A.opts.pluginsEnabled.indexOf(t) < 0) continue;
            A[t] = new e[t](A), A[t]._init && A[t]._init()
          }
        }(xt.PLUGINS), A.popups.get("filesManager.insert").get(0).outerHTML = "", Ue(), C(!0)
      }), A.events.$on(l, "click", ".fr-plugins-cancel", function (e) {
        A.popups.hide("filesManager.insert")
      }), A.events.$on(l, "drop", ".fr-upload-progress", function (e) {
        e.preventDefault(), e.stopPropagation()
      }), A.events.$on(l, "drop", ".fr-files-upload-layer", function (e) {
        e.preventDefault(), e.stopPropagation(), S(this).removeClass("fr-drop");
        var t = e.originalEvent.dataTransfer;
        if (t && t.files) {
          var n = l.data("instance") || A;
          n.events.disableBlur();
          for (var r = [], a = 0; a < t.files.length; a++) {
            var o = h;
            k.set(o, t.files[a]), me(o), R.set(o, !1), r.push(o), h++
          }
          for (var i = 0; i < r.length; i++) n.filesManager.upload(k.get(r[i]), t.files, y, r[i]);
          n.events.enableBlur()
        }
      }, !0), A.helpers.isIOS() && A.events.$on(l, "touchstart", '.fr-files-upload-layer input[type="file"]', function () {
        S(this).trigger("click")
      }, !0), A.events.$on(l, "change", '.fr-files-upload-layer input[type="file"]', function () {
        if (this.files) {
          var e = l.data("instance") || A;
          e.events.disableBlur(), l.find("input:focus").blur(), e.events.enableBlur();
          var t = [];
          if ("undefined" != typeof this.files && 0 < this.files.length) {
            for (var n = 0; n < this.files.length; n++) {
              var r = h;
              k.set(r, this.files[n]), me(r), R.set(r, !1), ++h, t.push(r)
            }
            for (var a = 0; a < t.length; a++) e.filesManager.upload(k.get(t[a]), this.files, y, t[a])
          }
        }
        S(this).val("")
      }, !0)
    }

    function De(t) {
      document.getElementById("fr-file-autoplay-button-" + t).checked ? O.push(t) : O = O.filter(function (e) {
        return e != t
      })
    }

    function Be(e) {
      return e && "image" === e.split("/")[0]
    }

    function He(e) {
      return e && "image" != e.split("/")[0] && e && "video" != e.split("/")[0] && e && "audio" != e.split("/")[0]
    }

    function $e(e) {
      return e && "video" === e.split("/")[0]
    }

    function Fe(e) {
      return e && "audio" === e.split("/")[0]
    }

    function Pe(e) {
      if ("audio/ogg" == e || "video/ogg" == e || "image/webp" == e || "video/webm" == e) {
        if (A.browser.msie || A.browser.edge || A.browser.safari) return !1;
        if (A.helpers.isMobile()) {
          if ("audio/ogg" == e || "video/ogg" == e) return !1;
          if (!A.helpers.isAndroid() && !A.browser.chrome) return !1
        }
      }
      return !0
    }

    function Ue(e) {
      if (e) return A.popups.onRefresh("filesManager.insert", b), A.popups.onHide("filesManager.insert", P), !0;
      var t, n, r = "";
      A.opts.imageUpload || -1 === A.opts.filesInsertButtons.indexOf("filesUpload") || A.opts.imageInsertButtons.splice(A.opts.filesInsertButtons.indexOf("filesUpload"), 1);
      var a = A.button.buildList(A.opts.filesInsertButtons), o = A.button.buildList(A.opts.filesInsertButtons2);
      "" !== a && (r = '<div class="fr-buttons fr-tabs">'.concat(a, '<span class="fr-align-right">').concat(o, "</span></div>"));
      var i = A.opts.filesInsertButtons.indexOf("filesUpload"), s = A.opts.filesInsertButtons.indexOf("filesByURL"),
        l = A.opts.filesInsertButtons.indexOf("filesEmbed"), c = "";
      0 <= i && (t = " fr-active", 0 <= s && s < i && (t = ""), c = '<div class="fr-files-upload-layer'.concat(t, ' fr-layer " id="fr-files-upload-layer-').concat(A.id, '"><div style="display:flex"><div class="fr-upload-section"><div class = \'fr-blue-decorator\'><div class = \'fr-cloud-icon\'><svg class = "fr-svg" focusable="false" width="26px" height="26px" viewBox = "0 0 24 24" xlmns = "http://w3.org/200/svg"><path d = \'M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z\'></path></svg></div>Drag & Drop One or More Files<br><div class="decorated"><span> OR </span></div> Click Browse Files </div> </div><div class="fr-form"><input type="file" accept="').concat(A.opts.filesManagerAllowedTypes.join(",").toLowerCase(), '" tabIndex="-1" aria - labelledby="fr-files-upload-layer-').concat(A.id, '"role="button" multiple></div> </div></div>'));
      var d = "";
      0 <= l && (t = " fr-active", (i < l && 0 <= i || s < l && 0 <= s) && (t = ""), d = '<div class="fr-files-embed-layer fr-layer'.concat(t, '" id="fr-files-embed-layer-').concat(A.id, '"><div class="fr-input-line padding-top-15"><textarea data-gramm_editor="false" style=\'height:60px\' id="fr-files-embed-layer-text').concat(A.id, '" type="text" placeholder="').concat(A.language.translate("Embedded Code"), '" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="insertEmbed" tabIndex="2" role="button">').concat(A.language.translate("Insert"), "</button></div></div>"));
      var f = "";
      0 <= s && (t = " fr-active", 0 <= i && i < s && (t = ""), f = '<div class="fr-files-by-url-layer'.concat(t, ' fr-layer" id="fr-files-by-url-layer-').concat(A.id, '"><div class="fr-input-line fr-by-url-padding"><input id="fr-files-by-url-layer-text-').concat(A.id, '" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="filesInsertByURL" tabIndex="2" role="button">').concat(A.language.translate("Add"), "</button></div></div>"));
      var p = {
        buttons: r,
        upload_layer: c,
        by_url_layer: f,
        embed_layer: d,
        upload_progress_layer: "<div class = ' fr-margin-16 fr-upload-progress' id=\"fr-upload-progress-layer-".concat(A.id, "\" ><div  class='fr-progress-bar-style'><div class='fr-progress-bar fr-none'></div></div><div id='filesList' class = 'fr-upload-progress-layer fr-layer'></div></div>"),
        progress_bar: '<div class="fr-files-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="filesDismissError" tabIndex="2" role="button">OK</button></div></div>'
      };
      return 1 <= A.opts.imageInsertButtons.length && (n = A.popups.create("filesManager.insert", p)), A.$wp && A.events.$on(A.$wp, "scroll", function () {
        y && A.popups.isVisible("filesManager.insert") && replace()
      }), Ie(n), A.popups.setPopupDimensions(n), n
    }

    function ze(e) {
      var t = e.split("/").pop();
      if (t.split(".").length < 2) {
        var n = new Date;
        return t + "-" + n.getDate() + "/" + (n.getMonth() + 1) + "/" + n.getFullYear()
      }
      return t
    }

    function Ke() {
      y && A.popups.get("image.alt").find("input").val(y.attr("alt") || "").trigger("change")
    }

    function Ve() {
      var e = A.popups.get("image.alt");
      e || (e = We()), J(), A.popups.refresh("image.alt"), A.popups.setContainer("image.alt", A.$sc);
      var t = ct();
      dt() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      A.popups.show("image.alt", n, r, t.outerHeight(), !0)
    }

    function We(e) {
      if (e) return A.popups.onRefresh("image.alt", Ke), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageAltButtons), "</div>"),
        alt_layer: '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(A.id, '"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(A.id, '" type="text" placeholder="').concat(A.language.translate("Alternative Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(A.language.translate("Update"), "</button></div></div>")
      }, n = A.popups.create("image.alt", t);
      return A.$wp && A.events.$on(A.$wp, "scroll.image-alt", function () {
        y && A.popups.isVisible("image.alt") && Ve()
      }), n
    }

    function Ge() {
      var e = A.popups.get("image.size");
      if (y) if (dt()) {
        var t = y.parent();
        t.get(0).style.width || (t = y.parent().parent()), e.find('input[name="width"]').val(t.get(0).style.width).trigger("change"), e.find('input[name="height"]').val(t.get(0).style.height).trigger("change")
      } else e.find('input[name="width"]').val(y.get(0).style.width).trigger("change"), e.find('input[name="height"]').val(y.get(0).style.height).trigger("change")
    }

    function Ye() {
      var e = A.popups.get("image.size");
      e || (e = je()), J(), A.popups.refresh("image.size"), A.popups.setContainer("image.size", A.$sc);
      var t = ct();
      dt() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      A.popups.show("image.size", n, r, t.outerHeight(), !0)
    }

    function je(e) {
      if (e) return A.popups.onRefresh("image.size", Ge), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageSizeButtons), "</div>"),
        size_layer: '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(A.id, '"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(A.id, '" type="text" name="width" placeholder="').concat(A.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(A.id, '" type="text" name="height" placeholder="').concat(A.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(A.language.translate("Update"), "</button></div></div>")
      }, n = A.popups.create("image.size", t);
      return A.$wp && A.events.$on(A.$wp, "scroll.image-size", function () {
        y && A.popups.isVisible("image.size") && Ye()
      }), n
    }

    function qe(e, t, n, r) {
      return e.pageX = t, V.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), W.call(this, e), G.call(this, e), ++r
    }

    function Ze(e) {
      (e = e || ct()) && !1 !== A.events.trigger("image.beforeRemove", [e]) && (A.popups.hideAll(), rt(!0), A.undo.canDo() || A.undo.saveStep(), e.get(0) == A.el ? e.removeAttr("src") : (e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? (A.selection.setBefore(e.get(0).parentNode) || A.selection.setAfter(e.get(0).parentNode) || e.parent().after(xt.MARKERS), S(e.get(0).parentNode).remove()) : (A.selection.setBefore(e.get(0)) || A.selection.setAfter(e.get(0)) || e.after(xt.MARKERS), e.remove()), A.html.fillEmptyBlocks(), A.selection.restore()), A.undo.saveStep())
    }

    function Xe(e) {
      var t = e.which;
      if (y && (t == xt.KEYCODE.BACKSPACE || t == xt.KEYCODE.DELETE)) return e.preventDefault(), e.stopPropagation(), Ze(), !1;
      if (y && t == xt.KEYCODE.ESC) {
        var n = y;
        return rt(!0), A.selection.setAfter(n.get(0)), A.selection.restore(), e.preventDefault(), !1
      }
      if (!y || t != xt.KEYCODE.ARROW_LEFT && t != xt.KEYCODE.ARROW_RIGHT) return y && t === xt.KEYCODE.TAB ? (e.preventDefault(), e.stopPropagation(), rt(!0), !1) : y && t != xt.KEYCODE.F10 && !A.keys.isBrowserAction(e) ? (e.preventDefault(), e.stopPropagation(), !1) : void 0;
      var r = y.get(0);
      return rt(!0), t == xt.KEYCODE.ARROW_LEFT ? A.selection.setBefore(r) : A.selection.setAfter(r), A.selection.restore(), e.preventDefault(), !1
    }

    function Qe(e) {
      if (e && "IMG" == e.tagName) {
        if (A.node.hasClass(e, "fr-uploading") || A.node.hasClass(e, "fr-error") ? e.parentNode.removeChild(e) : A.node.hasClass(e, "fr-draggable") && e.classList.remove("fr-draggable"), e.parentNode && e.parentNode.parentNode && A.node.hasClass(e.parentNode.parentNode, "fr-img-caption")) {
          var t = e.parentNode.parentNode;
          t.removeAttribute("contenteditable"), t.removeAttribute("draggable"), t.classList.remove("fr-draggable");
          var n = e.nextSibling;
          n && n.removeAttribute("contenteditable")
        }
      } else if (e && e.nodeType == Node.ELEMENT_NODE) for (var r = e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"), a = 0; a < r.length; a++) Qe(r[a])
    }

    function Je(e) {
      var t = e.target.result, n = A.opts.imageDefaultWidth;
      n && "auto" != n && (n += A.opts.imageResizeWithPercent ? "%" : "px"), A.undo.saveStep(), A.html.insert('<img data-fr-image-pasted="true" src="'.concat(t, '"').concat(n ? ' style="width: '.concat(n, ';"') : "", ">"));
      var r = A.$el.find('img[data-fr-image-pasted="true"]');
      r && st(r, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), A.events.trigger("paste.after")
    }

    function et(e, t) {
      var n = new FileReader;
      n.onload = function r(e) {
        var t = A.opts.imageDefaultWidth;
        t && "auto" != t && (t += A.opts.imageResizeWithPercent ? "%" : "px"), A.html.insert('<img data-fr-image-pasted="true" src="'.concat(e, '"').concat(t ? ' style="width: '.concat(t, ';"') : "", ">"));
        var n = A.$el.find('img[data-fr-image-pasted="true"]');
        n && st(n, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), A.events.trigger("paste.after")
      }(t), n.readAsDataURL(e, t)
    }

    function tt(e) {
      if (e && e.clipboardData && e.clipboardData.items) {
        var t = (e.clipboardData || window.clipboardData).getData("text/html") || "",
          n = (new DOMParser).parseFromString(t, "text/html").querySelector("img");
        if (n) {
          if (!n) return !1;
          var r = n.src, a = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) a = e.clipboardData.items[0].getAsFile(); else for (var o = 0; o < e.clipboardData.items.length && !(a = e.clipboardData.items[o].getAsFile()); o++) ;
          if (a) return et(a, r), !1
        } else {
          var i = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) i = e.clipboardData.items[0].getAsFile(); else for (var s = 0; s < e.clipboardData.items.length && !(i = e.clipboardData.items[s].getAsFile()); s++) ;
          if (i) return function l(e) {
            var t = new FileReader;
            t.onload = Je, t.readAsDataURL(e)
          }(i), !1
        }
      }
    }

    function nt(e) {
      return e = e.replace(/<img /gi, '<img data-fr-image-pasted="true" ')
    }

    function rt(e) {
      y && (function t() {
        return at
      }() || !0 === e) && (A.toolbar.enable(), l && l.removeClass("fr-active"), A.popups.hide("image.edit"), y = null, it(), c = null, d && d.hide())
    }

    var at = !1;

    function ot() {
      at = !0
    }

    function it() {
      at = !1
    }

    function st(e, t, n) {
      !A.opts.htmlUntouched && A.opts.useClasses ? (S(e[e.length - 1]).removeClass("fr-fil fr-fir fr-dib fr-dii"), n && S(e[e.length - 1]).addClass("fr-fi".concat(n[0])), t && S(e[e.length - 1]).addClass("fr-di".concat(t[0]))) : "inline" == t ? (e.css({
        display: "inline-block",
        verticalAlign: "bottom",
        margin: A.opts.imageDefaultMargin
      }), "center" == n ? e.css({
        "float": "none",
        marginBottom: "",
        marginTop: "",
        maxWidth: "calc(100% - ".concat(2 * A.opts.imageDefaultMargin, "px)"),
        textAlign: "center"
      }) : "left" == n ? e.css({
        "float": "left",
        marginLeft: 0,
        maxWidth: "calc(100% - ".concat(A.opts.imageDefaultMargin, "px)"),
        textAlign: "left"
      }) : e.css({
        "float": "right",
        marginRight: 0,
        maxWidth: "calc(100% - ".concat(A.opts.imageDefaultMargin, "px)"),
        textAlign: "right"
      })) : "block" == t && (e.css({
        display: "block",
        "float": "none",
        verticalAlign: "top",
        margin: "".concat(A.opts.imageDefaultMargin, "px auto"),
        textAlign: "center"
      }), "left" == n ? e.css({marginLeft: 0, textAlign: "left"}) : "right" == n && e.css({
        marginRight: 0,
        textAlign: "right"
      }))
    }

    function lt() {
      return y
    }

    function ct() {
      return dt() ? y.parents(".fr-img-caption").first() : y
    }

    function dt() {
      return !!y && 0 < y.parents(".fr-img-caption").length
    }

    return {
      _init: function ft() {
        var r;
        (function e() {
          A.events.$on(A.$el, A._mousedown, "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            A.helpers.isMobile() || A.selection.clear(), t = !0, A.popups.areVisible() && A.events.disableBlur(), A.browser.msie && (A.events.disableBlur(), A.$el.attr("contenteditable", !1)), A.draggable || "touchstart" == e.type || e.preventDefault(), e.stopPropagation()
          }), A.events.$on(A.$el, A._mousedown, ".fr-img-caption .fr-inner", function (e) {
            A.core.hasFocus() || A.events.focus(), e.stopPropagation()
          }), A.events.$on(A.$el, "paste", ".fr-img-caption .fr-inner", function (e) {
            !0 === A.opts.toolbarInline && (A.toolbar.hide(), e.stopPropagation())
          }), A.events.$on(A.$el, A._mouseup, "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            t && (t = !1, e.stopPropagation(), A.browser.msie && (A.$el.attr("contenteditable", !0), A.events.enableBlur()))
          }), A.events.on("keyup", function (e) {
            if (e.shiftKey && "" === A.selection.text().replace(/\n/g, "") && A.keys.isArrow(e.which)) {
              var t = A.selection.element(), n = A.selection.endElement();
              t && "IMG" == t.tagName ? _e(S(t)) : n && "IMG" == n.tagName && _e(S(n))
            }
          }, !0), A.events.on("window.mousedown", ot), A.events.on("window.touchmove", it), A.events.on("mouseup window.mouseup", function () {
            if (y) return rt(), !1;
            it()
          }), A.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && rt()
          }), A.events.on("image.resizeEnd", function () {
            A.opts.iframe && A.size.syncIframe()
          }), A.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
            rt(!(t = !1))
          }), A.events.on("modals.hide", function () {
            y && A.selection.clear()
          }), A.events.on("image.resizeEnd", function () {
            A.win.getSelection && _e(y)
          }), A.opts.imageAddNewLine && A.events.on("image.inserted", function (e) {
            var t = e.get(0);
            for (t.nextSibling && "BR" === t.nextSibling.tagName && (t = t.nextSibling); t && !A.node.isElement(t);) t = A.node.isLastSibling(t) ? t.parentNode : null;
            A.node.isElement(t) && (A.opts.enter === xt.ENTER_BR ? e.after("<br>") : S(A.node.blockParent(e.get(0))).after("<".concat(A.html.defaultTag(), "><br></").concat(A.html.defaultTag(), ">")))
          })
        })(), "IMG" == A.el.tagName && A.$el.addClass("fr-view"), A.helpers.isMobile() && (A.events.$on(A.$el, "touchstart", "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function () {
          de = !1
        }), A.events.$on(A.$el, "touchmove", function () {
          de = !0
        })), A.$wp ? (A.events.on("window.keydown keydown", Xe, !0), A.events.on("keyup", function (e) {
          if (y && e.which == xt.KEYCODE.ENTER) return !1
        }, !0), A.events.$on(A.$el, "keydown", function () {
          var e = A.selection.element();
          (e.nodeType === Node.TEXT_NODE || "BR" == e.tagName && A.node.isLastSibling(e)) && (e = e.parentNode), A.node.hasClass(e, "fr-inner") || (A.node.hasClass(e, "fr-img-caption") || (e = S(e).parents(".fr-img-caption").get(0)), A.node.hasClass(e, "fr-img-caption") && (A.opts.trackChangesEnabled || S(e).after(xt.INVISIBLE_SPACE + xt.MARKERS), A.selection.restore()))
        })) : A.events.$on(A.$win, "keydown", Xe), A.events.on("toolbar.esc", function () {
          if (y) {
            if (A.$wp) A.events.disableBlur(), A.events.focus(); else {
              var e = y;
              rt(!0), A.selection.setAfter(e.get(0)), A.selection.restore()
            }
            return !1
          }
        }, !0), A.events.on("toolbar.focusEditor", function () {
          if (y) return !1
        }, !0), A.events.on("window.cut window.copy", function (e) {
          if (y && A.popups.isVisible("image.edit") && !A.popups.get("image.edit").find(":focus").length) {
            var t = ct();
            dt() ? (t.before(xt.START_MARKER), t.after(xt.END_MARKER), A.selection.restore(), A.paste.saveCopiedText(t.get(0).outerHTML, t.text())) : A.paste.saveCopiedText(y.get(0).outerHTML, y.attr("alt")), "copy" == e.type ? setTimeout(function () {
              _e(y)
            }) : (rt(!0), A.undo.saveStep(), setTimeout(function () {
              A.undo.saveStep()
            }, 0))
          }
        }, !0), A.browser.msie && A.events.on("keydown", function (e) {
          if (!A.selection.isCollapsed() || !y) return !0;
          var t = e.which;
          t == xt.KEYCODE.C && A.keys.ctrlKey(e) ? A.events.trigger("window.copy") : t == xt.KEYCODE.X && A.keys.ctrlKey(e) && A.events.trigger("window.cut")
        }), A.events.$on(S(A.o_win), "keydown", function (e) {
          var t = e.which;
          if (y && t == xt.KEYCODE.BACKSPACE) return e.preventDefault(), !1
        }), A.events.$on(A.$win, "keydown", function (e) {
          var t = e.which;
          y && y.hasClass("fr-uploading") && t == xt.KEYCODE.ESC && y.trigger("abortUpload")
        }), A.events.on("destroy", function () {
          y && y.hasClass("fr-uploading") && y.trigger("abortUpload")
        }), A.events.on("paste.before", tt), A.events.on("paste.beforeCleanup", nt), A.events.on("html.processGet", Qe), A.opts.imageOutputSize && A.events.on("html.beforeGet", function () {
          r = A.el.querySelectorAll("img");
          for (var e = 0; e < r.length; e++) {
            var t = r[e].style.width || S(r[e]).width(), n = r[e].style.height || S(r[e]).height();
            t && r[e].setAttribute("width", "".concat(t).replace(/px/, "")), n && r[e].setAttribute("height", "".concat(n).replace(/px/, ""))
          }
        }), A.opts.iframe && A.events.on("image.loaded", A.size.syncIframe), A.events.$on(S(A.o_win), "orientationchange.image", function () {
          setTimeout(function () {
            y && _e(y)
          }, 100)
        }), function a(e) {
          if (e) return A.$wp && A.events.$on(A.$wp, "scroll.image-edit", function () {
            y && A.popups.isVisible("image.edit") && A.events.disableBlur()
          }), !0;
          var t = "";
          if (0 < A.opts.imageEditButtons.length) {
            var n = {buttons: t += '<div class="fr-buttons"> \n        '.concat(A.button.buildList(A.opts.imageEditButtons), "\n        </div>")};
            return A.popups.create("image.edit", n)
          }
          return !1
        }(!0), Ue(!0), je(!0), We(!0), A.events.on("node.remove", function (e) {
          if ("IMG" == e.get(0).tagName) return Ze(e), !1
        }), A.events.on("popups.hide.filesManager.insert", function (e) {
          A.filesManager.minimizePopup(T)
        })
      },
      showInsertPopup: C,
      showLayer: function pt(e) {
        var t, n, r = A.popups.get("filesManager.insert");
        if (y || A.opts.toolbarInline) {
          if (y) {
            var a = ct();
            dt() && (a = a.find(".fr-img-wrap")), n = a.offset().top + a.outerHeight(), t = a.offset().left
          }
        } else {
          var o = A.$tb.find('.fr-command[data-cmd="insertFiles"]');
          t = o.offset().left, n = o.offset().top + (A.opts.toolbarBottom ? 10 : o.outerHeight() - 10)
        }
        !y && A.opts.toolbarInline && (n = r.offset().top - A.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), r.find(".fr-upload-progress-layer").addClass("fr-active"), A.popups.show("filesManager.insert", t, n, y ? y.outerHeight() : 0), A.accessibility.focusPopup(r)
      },
      refreshUploadButton: function ut(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      refreshByURLButton: function ht(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      upload: Ne,
      insertByURL: function gt() {
        for (var e, t = A.popups.get("filesManager.insert").find(".fr-files-by-url-layer input"), n = t.val().trim().split(/[ ,]+/), r = [], a = 0, o = 0; o < n.length; o++) e = n[o], new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").test(e) && (r[a] = n[o], a++);
        if (0 != r.length) {
          if (0 < t.val().trim().length && 0 < r.length) {
            var s = [], l = [], c = h, d = r.length;
            r.forEach(function (e, n) {
              if (0 == e.trim().length) h == c + --d && Le(s, l); else {
                J(), Q(), ee(A.language.translate("Loading file(s)"));
                var r = e.trim(), t = function i(e) {
                  if (void 0 === e) return e;
                  var t = null;
                  if (/^http/.test(e) || (e = "https://".concat(e)), A.helpers.isURL(e)) for (var n = 0; n < xt.VIDEO_PROVIDERS.length; n++) {
                    var r = xt.VIDEO_PROVIDERS[n];
                    if (r.test_regex.test(e) && new RegExp(A.opts.videoAllowedProviders.join("|")).test(r.provider)) {
                      t = e.replace(r.url_regex, r.url_text), t = r.html.replace(/\{url\}/, t);
                      break
                    }
                  }
                  return t
                }(r);
                if (t) {
                  var a = {link: r, name: r, type: "video/url", size: 2, video: t};
                  k.set(c + n, a), me(c + n), J(), Q(), ee(A.language.translate("Loading file(s)")), x.set(c + n, a), ++h == c + d && Le(s, l)
                } else {
                  var o = new XMLHttpRequest;
                  o.onload = function () {
                    if (200 == this.status) {
                      var e = new Blob([this.response], {type: this.response.type || ""});
                      e.name = ze(r), e.link = r, Be(this.response.type) ? (e.sanitize = !0, e.existing_image = y) : He(this.response.type) && (e.text = ze(r)), s.push(e), l.push(c + n), k.set(c + n, e), me(c + n), (-1 < F.indexOf(ke(e)) || !ke(e)) && j(H, null, null, c + n)
                    } else {
                      var t = new Blob([this.response], {type: this.response.type || " "});
                      t.name = ze(r), t.link = r, k.set(c + n, t), me(c + n), j(N, this.response, y, c + n)
                    }
                    J(), Q(), ee(A.language.translate("Loading file(s)")), ++h == c + d && Le(s, l)
                  }, o.onerror = function () {
                    var e = {link: r, name: ze(r), size: 0, type: ""};
                    j(9, this.response, y, c + n);
                    var t = h;
                    k.set(t, e), me(t), J(), Q(), ee(A.language.translate("Loading file(s)")), ++h == c + d && Le(s, l)
                  }, o.open("GET", "".concat(A.opts.imageCORSProxy, "/").concat(r), !0), o.responseType = "blob", o.send()
                }
              }
            }), t.val(""), t.blur()
          }
        } else te(A.language.translate("Url entered is invalid. Please try again."))
      },
      insertAllFiles: function mt() {
        a = [];
        var e = A.popups.get("filesManager.insert");
        u = -1, f = null, e.find(".fr-insert-checkbox").toArray().forEach(function r(e, t, n) {
          e.children.target.checked && (a.push(parseInt(e.id.split("-").pop())), Be(x.get(parseInt(e.id.split("-").pop())).type) && -1 == u && (u = t))
        }), Te(a), q()
      },
      deleteAllFiles: function e() {
        A.popups.get("filesManager.insert").find(".fr-insert-checkbox").toArray().forEach(function a(e, t, n) {
          if (e.children.target.checked) {
            var r = parseInt(e.id.split("-").pop());
            _.has(r) && _["delete"](r), Z(r)
          }
        }), q()
      },
      get: lt,
      getEl: ct,
      insert: xe,
      showProgressBar: Q,
      remove: Ze,
      hideProgressBar: J,
      applyStyle: function vt(e, t, n) {
        if (void 0 === t && (t = A.opts.imageStyles), void 0 === n && (n = A.opts.imageMultipleStyles), !y) return !1;
        var r = ct();
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), r.removeClass(a.join(" "))
        }
        "object" == kt(t[e]) ? (r.removeAttr("style"), r.css(t[e].style)) : r.toggleClass(e), _e(y)
      },
      showAltPopup: Ve,
      showSizePopup: Ye,
      setAlt: function bt(e) {
        if (y) {
          var t = A.popups.get("image.alt");
          y.attr("alt", e || t.find("input").val() || ""), t.find("input:focus").blur(), _e(y)
        }
      },
      setSize: function Ct(e, t) {
        if (y) {
          var n = A.popups.get("image.size");
          e = e || n.find('input[name="width"]').val() || "", t = t || n.find('input[name="height"]').val() || "";
          var r = /^[\d]+((px)|%)*$/g;
          y.removeAttr("width").removeAttr("height"), e.match(r) ? y.css("width", e) : y.css("width", ""), t.match(r) ? y.css("height", t) : y.css("height", ""), dt() && (y.parents(".fr-img-caption").removeAttr("width").removeAttr("height"), e.match(r) ? y.parents(".fr-img-caption").css("width", e) : y.parents(".fr-img-caption").css("width", ""), t.match(r) ? y.parents(".fr-img-caption").css("height", t) : y.parents(".fr-img-caption").css("height", "")), n && n.find("input:focus").blur(), _e(y)
        }
      },
      toggleCaption: function Et() {
        var e;
        if (y && !dt()) {
          (e = y).parent().is("a") && (e = y.parent());
          var t, n,
            r = y.parents("ul") && 0 < y.parents("ul").length ? y.parents("ul") : y.parents("ol") && 0 < y.parents("ol").length ? y.parents("ol") : [];
          if (0 < r.length) {
            var a = r.find("li").length, o = y.parents("li"), i = document.createElement("li");
            a - 1 === o.index() && (r.append(i), i.innerHTML = "&nbsp;")
          }
          e.attr("style") && (n = -1 < (t = e.attr("style").split(":")).indexOf("width") ? t[t.indexOf("width") + 1].replace(";", "") : "");
          var s = A.opts.imageResizeWithPercent ? (-1 < n.indexOf("px") ? null : n) || "100%" : y.width() + "px";
          e.wrap('<div class="fr-img-space-wrap"><span ' + (A.browser.mozilla ? "" : 'contenteditable="false"') + 'class="fr-img-caption ' + y.attr("class") + '" style="' + (A.opts.useClasses ? "" : e.attr("style")) + '" draggable="false"></span><p class="fr-img-space-wrap2">&nbsp;</p></div>'), e.wrap('<span class="fr-img-wrap"></span>'), y.after('<span class="fr-inner"'.concat(A.browser.mozilla ? "" : ' contenteditable="true"', ">").concat(xt.START_MARKER).concat(A.language.translate("Image Caption")).concat(xt.END_MARKER, "</span>")), y.removeAttr("class").removeAttr("style").removeAttr("width"), y.parents(".fr-img-caption").css("width", s), rt(!0), A.selection.restore()
        } else e = ct(), y.insertAfter(e), y.attr("class", e.attr("class").replace("fr-img-caption", "")).attr("style", e.attr("style")), e.remove(), _e(y)
      },
      refreshEmbedButton: function yt(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-embed-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      insertEmbed: function Lt(e) {
        void 0 === e && (e = A.popups.get("filesManager.insert").find(".fr-files-embed-layer textarea").val() || ""), 0 === e.length || !xt.VIDEO_EMBED_REGEX.test(e) && !xt.IMAGE_EMBED_REGEX.test(e) ? (te(A.language.translate("Something went wrong. Please try again.")), xt.VIDEO_EMBED_REGEX.test(e) && A.events.trigger("video.codeError", [e])) : Re(e)
      },
      hasCaption: dt,
      exitEdit: rt,
      edit: _e,
      cancelFileInsert: function _t() {
        this.file_manager_dialog_open = !1, _.forEach(function (e, t) {
          4 != e.readyState && (e.abort(), Z(t))
        });
        var e = A.popups.get("filesManager.insert");
        e.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"), e.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"), e.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"), e.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"), o = 0, _ = new Map, w = new Map, X(), A.popups.hide("filesManager.insert")
      },
      minimizePopup: function wt(e) {
        this.file_manager_dialog_open = !1, A.popups.hide("filesManager.insert"), X()
      },
      editImage: Se,
      saveImage: function At(e) {
        var t = x.get(i);
        t.link = window.URL.createObjectURL(new Blob(e, {type: "image/png"})), x.set(i, t)
      },
      _showErrorMessage: te,
      _showFileErrorMessage: ne,
      getFileThumbnail: be,
      deleteFile: Z,
      checkAutoplay: De,
      checkInsertAllState: q,
      _disableInsertCheckbox: Y,
      _getFileType: ke,
      isChildWindowOpen: function Tt() {
        return p
      },
      setChildWindowState: function St(e) {
        e !== undefined && (p = e)
      },
      resetAllFilesCheckbox: X
    }
  }, xt.DefineIcon("insertFiles", {
    NAME: "image",
    SVG_KEY: "fileManager"
  }), xt.RegisterShortcut(xt.KEYCODE.P, "insertFiles", null, "P"), xt.RegisterCommand("insertFiles", {
    title: "Insert Files",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("filesManager.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("filesManager.insert")) : this.filesManager.showInsertPopup()
    },
    plugin: "filesManager"
  }), xt.DefineIcon("cloudIcon", {
    NAME: "cloudIcon",
    SVG_KEY: "uploadFiles"
  }), xt.DefineIcon("filesUpload", {
    NAME: "uploadFiles",
    SVG_KEY: "uploadFiles"
  }), xt.RegisterCommand("filesUpload", {
    title: "Upload Files", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-upload")
    }, refresh: function (e) {
      this.filesManager.refreshUploadButton(e)
    }
  }), xt.DefineIcon("filesByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterCommand("filesByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-by-url")
    }, refresh: function (e) {
      this.filesManager.refreshByURLButton(e)
    }
  }), xt.DefineIcon("filesEmbed", {
    NAME: "code",
    SVG_KEY: "codeView"
  }), xt.RegisterCommand("filesEmbed", {
    title: "Embedded Code", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-embed")
    }, refresh: function (e) {
      this.filesManager.refreshEmbedButton(e)
    }
  }), xt.DefineIcon("insertAll", {
    NAME: "insertAll",
    SVG_KEY: "fileInsert"
  }), xt.RegisterCommand("insertAll", {
    title: "Insert",
    undo: !1,
    focus: !1,
    toggle: !0,
    disabled: !0,
    callback: function () {
      this.filesManager.insertAllFiles()
    }
  }), xt.DefineIcon("deleteAll", {NAME: "remove", SVG_KEY: "remove"}), xt.RegisterCommand("deleteAll", {
    title: "Delete",
    undo: !1,
    focus: !1,
    toggle: !0,
    disabled: !0,
    callback: function () {
      this.filesManager.deleteAllFiles()
    }
  }), xt.DefineIcon("cancel", {NAME: "cancel", SVG_KEY: "cancel"}), xt.RegisterCommand("cancel", {
    title: "Cancel",
    undo: !1,
    focus: !1,
    toggle: !0,
    callback: function () {
      this.filesManager.cancelFileInsert()
    },
    refresh: function (e) {
    }
  }), xt.DefineIcon("minimize", {
    NAME: "minimize",
    SVG_KEY: "minimize"
  }), xt.RegisterCommand("minimize", {
    title: "Minimize", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.minimizePopup("image.insert", !0)
    }, refresh: function (e) {
      this.filesManager.refreshEmbedButton(e)
    }
  }), xt.RegisterCommand("filesInsertByURL", {
    title: "Insert Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.filesManager.insertByURL()
    },
    refresh: function (e) {
      e.text(this.language.translate("Add"))
    }
  }), xt.RegisterCommand("imageInsertByUpload", {
    title: "Insert",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function (e, t) {
    },
    refresh: function (e) {
    }
  }), xt.RegisterCommand("viewImage", {
    title: "View Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function (e, t) {
    },
    refresh: function (e) {
    }
  }), xt.RegisterCommand("insertEmbed", {
    undo: !0, focus: !0, callback: function () {
      this.filesManager.insertEmbed(), this.popups.get("filesManager.insert").find("textarea")[0].value = "", this.popups.get("filesManager.insert").find("textarea").removeClass("fr-not-empty")
    }
  }), xt.RegisterCommand("filesDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.filesManager.hideProgressBar(!0)
    }
  }), xt.PLUGINS.cryptoJSPlugin = function (e) {
    var t, d, n, r, a, o, i, f, s, l, c, p, u, h, g, v, m, b, C, E, y, L, _, w, A, T, S, k, x, R, M, O, N, I, D, B, H,
      $, F, P, U, z, K, V, W, G, Y, j, q, Z, X, Q, J, ee, te, ne, re, ae, oe, ie, se, le, ce, de, fe, pe, ue, he, ge,
      me, ve = ve || function (d, e) {
        var t;
        if ("undefined" != typeof window && window.crypto && (t = window.crypto), !t && "undefined" != typeof window && window.msCrypto && (t = window.msCrypto), !t && "undefined" != typeof global && global.crypto && (t = global.crypto), !t && "function" == typeof require) try {
          t = require("crypto")
        } catch (g) {
        }
        var r = function r() {
          if (t) {
            if ("function" == typeof t.getRandomValues) try {
              return t.getRandomValues(new Uint32Array(1))[0]
            } catch (g) {
            }
            if ("function" == typeof t.randomBytes) try {
              return t.randomBytes(4).readInt32LE()
            } catch (g) {
            }
          }
          throw new Error("Native crypto module could not be used to get secure random number.")
        }, n = Object.create || function () {
          function n() {
          }

          return function (e) {
            var t;
            return n.prototype = e, t = new n, n.prototype = null, t
          }
        }(), a = {}, o = a.lib = {}, i = o.Base = {
          extend: function (e) {
            var t = n(this);
            return e && t.mixIn(e), t.hasOwnProperty("init") && this.init !== t.init || (t.init = function () {
              t.$super.init.apply(this, arguments)
            }), (t.init.prototype = t).$super = this, t
          }, create: function () {
            var e = this.extend();
            return e.init.apply(e, arguments), e
          }, init: function () {
          }, mixIn: function (e) {
            for (var t in e) e.hasOwnProperty(t) && (this[t] = e[t]);
            e.hasOwnProperty("toString") && (this.toString = e.toString)
          }, clone: function () {
            return this.init.prototype.extend(this)
          }
        }, f = o.WordArray = i.extend({
          init: function (e, t) {
            e = this.words = e || [], this.sigBytes = null != t ? t : 4 * e.length
          }, toString: function (e) {
            return (e || l).stringify(this)
          }, concat: function (e) {
            var t = this.words, n = e.words, r = this.sigBytes, a = e.sigBytes;
            if (this.clamp(), r % 4) for (var o = 0; o < a; o++) {
              var i = n[o >>> 2] >>> 24 - o % 4 * 8 & 255;
              t[r + o >>> 2] |= i << 24 - (r + o) % 4 * 8
            } else for (o = 0; o < a; o += 4) t[r + o >>> 2] = n[o >>> 2];
            return this.sigBytes += a, this
          }, clamp: function () {
            var e = this.words, t = this.sigBytes;
            e[t >>> 2] &= 4294967295 << 32 - t % 4 * 8, e.length = d.ceil(t / 4)
          }, clone: function e() {
            var e = i.clone.call(this);
            return e.words = this.words.slice(0), e
          }, random: function (e) {
            for (var t = [], n = 0; n < e; n += 4) t.push(r());
            return new f.init(t, e)
          }
        }), s = a.enc = {}, l = s.Hex = {
          stringify: function (e) {
            for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a++) {
              var o = t[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16))
            }
            return r.join("")
          }, parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r += 2) n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
            return new f.init(n, t / 2)
          }
        }, c = s.Latin1 = {
          stringify: function (e) {
            for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a++) {
              var o = t[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              r.push(String.fromCharCode(o))
            }
            return r.join("")
          }, parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
            return new f.init(n, t)
          }
        }, p = s.Utf8 = {
          stringify: function (e) {
            try {
              return decodeURIComponent(escape(c.stringify(e)))
            } catch (t) {
              throw new Error("Malformed UTF-8 data")
            }
          }, parse: function (e) {
            return c.parse(unescape(encodeURIComponent(e)))
          }
        }, u = o.BufferedBlockAlgorithm = i.extend({
          reset: function () {
            this._data = new f.init, this._nDataBytes = 0
          }, _append: function (e) {
            "string" == typeof e && (e = p.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes
          }, _process: function (e) {
            var t, n = this._data, r = n.words, a = n.sigBytes, o = this.blockSize, i = a / (4 * o),
              s = (i = e ? d.ceil(i) : d.max((0 | i) - this._minBufferSize, 0)) * o, l = d.min(4 * s, a);
            if (s) {
              for (var c = 0; c < s; c += o) this._doProcessBlock(r, c);
              t = r.splice(0, s), n.sigBytes -= l
            }
            return new f.init(t, l)
          }, clone: function e() {
            var e = i.clone.call(this);
            return e._data = this._data.clone(), e
          }, _minBufferSize: 0
        }), h = (o.Hasher = u.extend({
          cfg: i.extend(), init: function (e) {
            this.cfg = this.cfg.extend(e), this.reset()
          }, reset: function () {
            u.reset.call(this), this._doReset()
          }, update: function (e) {
            return this._append(e), this._process(), this
          }, finalize: function (e) {
            return e && this._append(e), this._doFinalize()
          }, blockSize: 16, _createHelper: function (n) {
            return function (e, t) {
              return new n.init(t).finalize(e)
            }
          }, _createHmacHelper: function (n) {
            return function (e, t) {
              return new h.HMAC.init(n, t).finalize(e)
            }
          }
        }), a.algo = {});
        return a
      }(Math);
    return d = (t = ve).lib.WordArray, t.enc.Base64 = {
      stringify: function (e) {
        var t = e.words, n = e.sigBytes, r = this._map;
        e.clamp();
        for (var a = [], o = 0; o < n; o += 3) for (var i = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, s = 0; s < 4 && o + .75 * s < n; s++) a.push(r.charAt(i >>> 6 * (3 - s) & 63));
        var l = r.charAt(64);
        if (l) for (; a.length % 4;) a.push(l);
        return a.join("")
      }, parse: function (e) {
        var t = e.length, n = this._map, r = this._reverseMap;
        if (!r) {
          r = this._reverseMap = [];
          for (var a = 0; a < n.length; a++) r[n.charCodeAt(a)] = a
        }
        var o = n.charAt(64);
        if (o) {
          var i = e.indexOf(o);
          -1 !== i && (t = i)
        }
        return function c(e, t, n) {
          for (var r = [], a = 0, o = 0; o < t; o++) if (o % 4) {
            var i = n[e.charCodeAt(o - 1)] << o % 4 * 2, s = n[e.charCodeAt(o)] >>> 6 - o % 4 * 2, l = i | s;
            r[a >>> 2] |= l << 24 - a % 4 * 8, a++
          }
          return d.create(r, a)
        }(e, t, r)
      }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, function (d) {
      var e = ve, t = e.lib, n = t.WordArray, r = t.Hasher, a = e.algo, T = [];
      !function () {
        for (var e = 0; e < 64; e++) T[e] = 4294967296 * d.abs(d.sin(e + 1)) | 0
      }();
      var o = a.MD5 = r.extend({
        _doReset: function () {
          this._hash = new n.init([1732584193, 4023233417, 2562383102, 271733878])
        }, _doProcessBlock: function (e, t) {
          for (var n = 0; n < 16; n++) {
            var r = t + n, a = e[r];
            e[r] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8)
          }
          var o = this._hash.words, i = e[t + 0], s = e[t + 1], l = e[t + 2], c = e[t + 3], d = e[t + 4], f = e[t + 5],
            p = e[t + 6], u = e[t + 7], h = e[t + 8], g = e[t + 9], m = e[t + 10], v = e[t + 11], b = e[t + 12],
            C = e[t + 13], E = e[t + 14], y = e[t + 15], L = o[0], _ = o[1], w = o[2], A = o[3];
          _ = R(_ = R(_ = R(_ = R(_ = x(_ = x(_ = x(_ = x(_ = k(_ = k(_ = k(_ = k(_ = S(_ = S(_ = S(_ = S(_, w = S(w, A = S(A, L = S(L, _, w, A, i, 7, T[0]), _, w, s, 12, T[1]), L, _, l, 17, T[2]), A, L, c, 22, T[3]), w = S(w, A = S(A, L = S(L, _, w, A, d, 7, T[4]), _, w, f, 12, T[5]), L, _, p, 17, T[6]), A, L, u, 22, T[7]), w = S(w, A = S(A, L = S(L, _, w, A, h, 7, T[8]), _, w, g, 12, T[9]), L, _, m, 17, T[10]), A, L, v, 22, T[11]), w = S(w, A = S(A, L = S(L, _, w, A, b, 7, T[12]), _, w, C, 12, T[13]), L, _, E, 17, T[14]), A, L, y, 22, T[15]), w = k(w, A = k(A, L = k(L, _, w, A, s, 5, T[16]), _, w, p, 9, T[17]), L, _, v, 14, T[18]), A, L, i, 20, T[19]), w = k(w, A = k(A, L = k(L, _, w, A, f, 5, T[20]), _, w, m, 9, T[21]), L, _, y, 14, T[22]), A, L, d, 20, T[23]), w = k(w, A = k(A, L = k(L, _, w, A, g, 5, T[24]), _, w, E, 9, T[25]), L, _, c, 14, T[26]), A, L, h, 20, T[27]), w = k(w, A = k(A, L = k(L, _, w, A, C, 5, T[28]), _, w, l, 9, T[29]), L, _, u, 14, T[30]), A, L, b, 20, T[31]), w = x(w, A = x(A, L = x(L, _, w, A, f, 4, T[32]), _, w, h, 11, T[33]), L, _, v, 16, T[34]), A, L, E, 23, T[35]), w = x(w, A = x(A, L = x(L, _, w, A, s, 4, T[36]), _, w, d, 11, T[37]), L, _, u, 16, T[38]), A, L, m, 23, T[39]), w = x(w, A = x(A, L = x(L, _, w, A, C, 4, T[40]), _, w, i, 11, T[41]), L, _, c, 16, T[42]), A, L, p, 23, T[43]), w = x(w, A = x(A, L = x(L, _, w, A, g, 4, T[44]), _, w, b, 11, T[45]), L, _, y, 16, T[46]), A, L, l, 23, T[47]), w = R(w, A = R(A, L = R(L, _, w, A, i, 6, T[48]), _, w, u, 10, T[49]), L, _, E, 15, T[50]), A, L, f, 21, T[51]), w = R(w, A = R(A, L = R(L, _, w, A, b, 6, T[52]), _, w, c, 10, T[53]), L, _, m, 15, T[54]), A, L, s, 21, T[55]), w = R(w, A = R(A, L = R(L, _, w, A, h, 6, T[56]), _, w, y, 10, T[57]), L, _, p, 15, T[58]), A, L, C, 21, T[59]), w = R(w, A = R(A, L = R(L, _, w, A, d, 6, T[60]), _, w, v, 10, T[61]), L, _, l, 15, T[62]), A, L, g, 21, T[63]), o[0] = o[0] + L | 0, o[1] = o[1] + _ | 0, o[2] = o[2] + w | 0, o[3] = o[3] + A | 0
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          t[r >>> 5] |= 128 << 24 - r % 32;
          var a = d.floor(n / 4294967296), o = n;
          t[15 + (r + 64 >>> 9 << 4)] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8), t[14 + (r + 64 >>> 9 << 4)] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), e.sigBytes = 4 * (t.length + 1), this._process();
          for (var i = this._hash, s = i.words, l = 0; l < 4; l++) {
            var c = s[l];
            s[l] = 16711935 & (c << 8 | c >>> 24) | 4278255360 & (c << 24 | c >>> 8)
          }
          return i
        }, clone: function e() {
          var e = r.clone.call(this);
          return e._hash = this._hash.clone(), e
        }
      });

      function S(e, t, n, r, a, o, i) {
        var s = e + (t & n | ~t & r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function k(e, t, n, r, a, o, i) {
        var s = e + (t & r | n & ~r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function x(e, t, n, r, a, o, i) {
        var s = e + (t ^ n ^ r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function R(e, t, n, r, a, o, i) {
        var s = e + (n ^ (t | ~r)) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      e.MD5 = r._createHelper(o), e.HmacMD5 = r._createHmacHelper(o)
    }(Math), r = (n = ve).lib, a = r.WordArray, o = r.Hasher, i = n.algo, f = [], s = i.SHA1 = o.extend({
      _doReset: function () {
        this._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520])
      }, _doProcessBlock: function (e, t) {
        for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = 0; l < 80; l++) {
          if (l < 16) f[l] = 0 | e[t + l]; else {
            var c = f[l - 3] ^ f[l - 8] ^ f[l - 14] ^ f[l - 16];
            f[l] = c << 1 | c >>> 31
          }
          var d = (r << 5 | r >>> 27) + s + f[l];
          d += l < 20 ? 1518500249 + (a & o | ~a & i) : l < 40 ? 1859775393 + (a ^ o ^ i) : l < 60 ? (a & o | a & i | o & i) - 1894007588 : (a ^ o ^ i) - 899497514, s = i, i = o, o = a << 30 | a >>> 2, a = r, r = d
        }
        n[0] = n[0] + r | 0, n[1] = n[1] + a | 0, n[2] = n[2] + o | 0, n[3] = n[3] + i | 0, n[4] = n[4] + s | 0
      }, _doFinalize: function () {
        var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
        return t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = Math.floor(n / 4294967296), t[15 + (r + 64 >>> 9 << 4)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash
      }, clone: function e() {
        var e = o.clone.call(this);
        return e._hash = this._hash.clone(), e
      }
    }), n.SHA1 = o._createHelper(s), n.HmacSHA1 = o._createHmacHelper(s), function (a) {
      var e = ve, t = e.lib, n = t.WordArray, r = t.Hasher, o = e.algo, i = [], C = [];
      !function () {
        function e(e) {
          for (var t = a.sqrt(e), n = 2; n <= t; n++) if (!(e % n)) return !1;
          return !0
        }

        function t(e) {
          return 4294967296 * (e - (0 | e)) | 0
        }

        for (var n = 2, r = 0; r < 64;) e(n) && (r < 8 && (i[r] = t(a.pow(n, .5))), C[r] = t(a.pow(n, 1 / 3)), r++), n++
      }();
      var E = [], s = o.SHA256 = r.extend({
        _doReset: function () {
          this._hash = new n.init(i.slice(0))
        }, _doProcessBlock: function (e, t) {
          for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = n[5], c = n[6], d = n[7], f = 0; f < 64; f++) {
            if (f < 16) E[f] = 0 | e[t + f]; else {
              var p = E[f - 15], u = (p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3, h = E[f - 2],
                g = (h << 15 | h >>> 17) ^ (h << 13 | h >>> 19) ^ h >>> 10;
              E[f] = u + E[f - 7] + g + E[f - 16]
            }
            var m = r & a ^ r & o ^ a & o, v = (r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22),
              b = d + ((s << 26 | s >>> 6) ^ (s << 21 | s >>> 11) ^ (s << 7 | s >>> 25)) + (s & l ^ ~s & c) + C[f] + E[f];
            d = c, c = l, l = s, s = i + b | 0, i = o, o = a, a = r, r = b + (v + m) | 0
          }
          n[0] = n[0] + r | 0, n[1] = n[1] + a | 0, n[2] = n[2] + o | 0, n[3] = n[3] + i | 0, n[4] = n[4] + s | 0, n[5] = n[5] + l | 0, n[6] = n[6] + c | 0, n[7] = n[7] + d | 0
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          return t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = a.floor(n / 4294967296), t[15 + (r + 64 >>> 9 << 4)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash
        }, clone: function e() {
          var e = r.clone.call(this);
          return e._hash = this._hash.clone(), e
        }
      });
      e.SHA256 = r._createHelper(s), e.HmacSHA256 = r._createHmacHelper(s)
    }(Math), function () {
      var e = ve, a = e.lib.WordArray, t = e.enc;
      t.Utf16 = t.Utf16BE = {
        stringify: function (e) {
          for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a += 2) {
            var o = t[a >>> 2] >>> 16 - a % 4 * 8 & 65535;
            r.push(String.fromCharCode(o))
          }
          return r.join("")
        }, parse: function (e) {
          for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 1] |= e.charCodeAt(r) << 16 - r % 2 * 16;
          return a.create(n, 2 * t)
        }
      };

      function i(e) {
        return e << 8 & 4278255360 | e >>> 8 & 16711935
      }

      t.Utf16LE = {
        stringify: function (e) {
          for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a += 2) {
            var o = i(t[a >>> 2] >>> 16 - a % 4 * 8 & 65535);
            r.push(String.fromCharCode(o))
          }
          return r.join("")
        }, parse: function (e) {
          for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 1] |= i(e.charCodeAt(r) << 16 - r % 2 * 16);
          return a.create(n, 2 * t)
        }
      }
    }(), function () {
      if ("function" == typeof ArrayBuffer) {
        var e = ve.lib.WordArray, a = e.init;
        (e.init = function (e) {
          if (e instanceof ArrayBuffer && (e = new Uint8Array(e)), (e instanceof Int8Array || "undefined" != typeof Uint8ClampedArray && e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) && (e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength)), e instanceof Uint8Array) {
            for (var t = e.byteLength, n = [], r = 0; r < t; r++) n[r >>> 2] |= e[r] << 24 - r % 4 * 8;
            a.call(this, n, t)
          } else a.apply(this, arguments)
        }).prototype = e
      }
    }(), function (e) {
      var t = ve, n = t.lib, r = n.WordArray, a = n.Hasher, o = t.algo,
        _ = r.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]),
        w = r.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]),
        A = r.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]),
        T = r.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]),
        S = r.create([0, 1518500249, 1859775393, 2400959708, 2840853838]),
        k = r.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), i = o.RIPEMD160 = a.extend({
          _doReset: function () {
            this._hash = r.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520])
          }, _doProcessBlock: function (e, t) {
            for (var n = 0; n < 16; n++) {
              var r = t + n, a = e[r];
              e[r] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8)
            }
            var o, i, s, l, c, d, f, p, u, h, g, m = this._hash.words, v = S.words, b = k.words, C = _.words, E = w.words,
              y = A.words, L = T.words;
            d = o = m[0], f = i = m[1], p = s = m[2], u = l = m[3], h = c = m[4];
            for (n = 0; n < 80; n += 1) g = o + e[t + C[n]] | 0, g += n < 16 ? x(i, s, l) + v[0] : n < 32 ? R(i, s, l) + v[1] : n < 48 ? M(i, s, l) + v[2] : n < 64 ? O(i, s, l) + v[3] : N(i, s, l) + v[4], g = (g = I(g |= 0, y[n])) + c | 0, o = c, c = l, l = I(s, 10), s = i, i = g, g = d + e[t + E[n]] | 0, g += n < 16 ? N(f, p, u) + b[0] : n < 32 ? O(f, p, u) + b[1] : n < 48 ? M(f, p, u) + b[2] : n < 64 ? R(f, p, u) + b[3] : x(f, p, u) + b[4], g = (g = I(g |= 0, L[n])) + h | 0, d = h, h = u, u = I(p, 10), p = f, f = g;
            g = m[1] + s + u | 0, m[1] = m[2] + l + h | 0, m[2] = m[3] + c + d | 0, m[3] = m[4] + o + f | 0, m[4] = m[0] + i + p | 0, m[0] = g
          }, _doFinalize: function () {
            var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
            t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = 16711935 & (n << 8 | n >>> 24) | 4278255360 & (n << 24 | n >>> 8), e.sigBytes = 4 * (t.length + 1), this._process();
            for (var a = this._hash, o = a.words, i = 0; i < 5; i++) {
              var s = o[i];
              o[i] = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8)
            }
            return a
          }, clone: function e() {
            var e = a.clone.call(this);
            return e._hash = this._hash.clone(), e
          }
        });

      function x(e, t, n) {
        return e ^ t ^ n
      }

      function R(e, t, n) {
        return e & t | ~e & n
      }

      function M(e, t, n) {
        return (e | ~t) ^ n
      }

      function O(e, t, n) {
        return e & n | t & ~n
      }

      function N(e, t, n) {
        return e ^ (t | ~n)
      }

      function I(e, t) {
        return e << t | e >>> 32 - t
      }

      t.RIPEMD160 = a._createHelper(i), t.HmacRIPEMD160 = a._createHmacHelper(i)
    }(Math), c = (l = ve).lib.Base, p = l.enc.Utf8, l.algo.HMAC = c.extend({
      init: function (e, t) {
        e = this._hasher = new e.init, "string" == typeof t && (t = p.parse(t));
        var n = e.blockSize, r = 4 * n;
        t.sigBytes > r && (t = e.finalize(t)), t.clamp();
        for (var a = this._oKey = t.clone(), o = this._iKey = t.clone(), i = a.words, s = o.words, l = 0; l < n; l++) i[l] ^= 1549556828, s[l] ^= 909522486;
        a.sigBytes = o.sigBytes = r, this.reset()
      }, reset: function () {
        var e = this._hasher;
        e.reset(), e.update(this._iKey)
      }, update: function (e) {
        return this._hasher.update(e), this
      }, finalize: function (e) {
        var t = this._hasher, n = t.finalize(e);
        return t.reset(), t.finalize(this._oKey.clone().concat(n))
      }
    }), h = (u = ve).lib, g = h.Base, v = h.WordArray, m = u.algo, b = m.SHA1, C = m.HMAC, E = m.PBKDF2 = g.extend({
      cfg: g.extend({
        keySize: 4,
        hasher: b,
        iterations: 1
      }), init: function (e) {
        this.cfg = this.cfg.extend(e)
      }, compute: function (e, t) {
        for (var n = this.cfg, r = C.create(n.hasher, e), a = v.create(), o = v.create([1]), i = a.words, s = o.words, l = n.keySize, c = n.iterations; i.length < l;) {
          var d = r.update(t).finalize(o);
          r.reset();
          for (var f = d.words, p = f.length, u = d, h = 1; h < c; h++) {
            u = r.finalize(u), r.reset();
            for (var g = u.words, m = 0; m < p; m++) f[m] ^= g[m]
          }
          a.concat(d), s[0]++
        }
        return a.sigBytes = 4 * l, a
      }
    }), u.PBKDF2 = function (e, t, n) {
      return E.create(n).compute(e, t)
    }, L = (y = ve).lib, _ = L.Base, w = L.WordArray, A = y.algo, T = A.MD5, S = A.EvpKDF = _.extend({
      cfg: _.extend({
        keySize: 4,
        hasher: T,
        iterations: 1
      }), init: function (e) {
        this.cfg = this.cfg.extend(e)
      }, compute: function (e, t) {
        for (var n, r = this.cfg, a = r.hasher.create(), o = w.create(), i = o.words, s = r.keySize, l = r.iterations; i.length < s;) {
          n && a.update(n), n = a.update(e).finalize(t), a.reset();
          for (var c = 1; c < l; c++) n = a.finalize(n), a.reset();
          o.concat(n)
        }
        return o.sigBytes = 4 * s, o
      }
    }), y.EvpKDF = function (e, t, n) {
      return S.create(n).compute(e, t)
    }, x = (k = ve).lib.WordArray, R = k.algo, M = R.SHA256, O = R.SHA224 = M.extend({
      _doReset: function () {
        this._hash = new x.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428])
      }, _doFinalize: function () {
        var e = M._doFinalize.call(this);
        return e.sigBytes -= 4, e
      }
    }), k.SHA224 = M._createHelper(O), k.HmacSHA224 = M._createHmacHelper(O), I = (N = ve).lib, D = I.Base, B = I.WordArray, (H = N.x64 = {}).Word = D.extend({
      init: function (e, t) {
        this.high = e, this.low = t
      }
    }), H.WordArray = D.extend({
      init: function (e, t) {
        e = this.words = e || [], this.sigBytes = null != t ? t : 8 * e.length
      }, toX32: function () {
        for (var e = this.words, t = e.length, n = [], r = 0; r < t; r++) {
          var a = e[r];
          n.push(a.high), n.push(a.low)
        }
        return B.create(n, this.sigBytes)
      }, clone: function e() {
        for (var e = D.clone.call(this), t = e.words = this.words.slice(0), n = t.length, r = 0; r < n; r++) t[r] = t[r].clone();
        return e
      }
    }), function (p) {
      var e = ve, t = e.lib, u = t.WordArray, r = t.Hasher, d = e.x64.Word, n = e.algo, x = [], R = [], M = [];
      !function () {
        for (var e = 1, t = 0, n = 0; n < 24; n++) {
          x[e + 5 * t] = (n + 1) * (n + 2) / 2 % 64;
          var r = (2 * e + 3 * t) % 5;
          e = t % 5, t = r
        }
        for (e = 0; e < 5; e++) for (t = 0; t < 5; t++) R[e + 5 * t] = t + (2 * e + 3 * t) % 5 * 5;
        for (var a = 1, o = 0; o < 24; o++) {
          for (var i = 0, s = 0, l = 0; l < 7; l++) {
            if (1 & a) {
              var c = (1 << l) - 1;
              c < 32 ? s ^= 1 << c : i ^= 1 << c - 32
            }
            128 & a ? a = a << 1 ^ 113 : a <<= 1
          }
          M[o] = d.create(i, s)
        }
      }();
      var O = [];
      !function () {
        for (var e = 0; e < 25; e++) O[e] = d.create()
      }();
      var a = n.SHA3 = r.extend({
        cfg: r.cfg.extend({outputLength: 512}), _doReset: function () {
          for (var e = this._state = [], t = 0; t < 25; t++) e[t] = new d.init;
          this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32
        }, _doProcessBlock: function (e, t) {
          for (var n = this._state, r = this.blockSize / 2, a = 0; a < r; a++) {
            var o = e[t + 2 * a], i = e[t + 2 * a + 1];
            o = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), i = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8), (w = n[a]).high ^= i, w.low ^= o
          }
          for (var s = 0; s < 24; s++) {
            for (var l = 0; l < 5; l++) {
              for (var c = 0, d = 0, f = 0; f < 5; f++) {
                c ^= (w = n[l + 5 * f]).high, d ^= w.low
              }
              var p = O[l];
              p.high = c, p.low = d
            }
            for (l = 0; l < 5; l++) {
              var u = O[(l + 4) % 5], h = O[(l + 1) % 5], g = h.high, m = h.low;
              for (c = u.high ^ (g << 1 | m >>> 31), d = u.low ^ (m << 1 | g >>> 31), f = 0; f < 5; f++) {
                (w = n[l + 5 * f]).high ^= c, w.low ^= d
              }
            }
            for (var v = 1; v < 25; v++) {
              var b = (w = n[v]).high, C = w.low, E = x[v];
              d = E < 32 ? (c = b << E | C >>> 32 - E, C << E | b >>> 32 - E) : (c = C << E - 32 | b >>> 64 - E, b << E - 32 | C >>> 64 - E);
              var y = O[R[v]];
              y.high = c, y.low = d
            }
            var L = O[0], _ = n[0];
            L.high = _.high, L.low = _.low;
            for (l = 0; l < 5; l++) for (f = 0; f < 5; f++) {
              var w = n[v = l + 5 * f], A = O[v], T = O[(l + 1) % 5 + 5 * f], S = O[(l + 2) % 5 + 5 * f];
              w.high = A.high ^ ~T.high & S.high, w.low = A.low ^ ~T.low & S.low
            }
            w = n[0];
            var k = M[s];
            w.high ^= k.high, w.low ^= k.low
          }
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = (this._nDataBytes, 8 * e.sigBytes), r = 32 * this.blockSize;
          t[n >>> 5] |= 1 << 24 - n % 32, t[(p.ceil((n + 1) / r) * r >>> 5) - 1] |= 128, e.sigBytes = 4 * t.length, this._process();
          for (var a = this._state, o = this.cfg.outputLength / 8, i = o / 8, s = [], l = 0; l < i; l++) {
            var c = a[l], d = c.high, f = c.low;
            d = 16711935 & (d << 8 | d >>> 24) | 4278255360 & (d << 24 | d >>> 8), f = 16711935 & (f << 8 | f >>> 24) | 4278255360 & (f << 24 | f >>> 8), s.push(f), s.push(d)
          }
          return new u.init(s, o)
        }, clone: function e() {
          for (var e = r.clone.call(this), t = e._state = this._state.slice(0), n = 0; n < 25; n++) t[n] = t[n].clone();
          return e
        }
      });
      e.SHA3 = r._createHelper(a), e.HmacSHA3 = r._createHmacHelper(a)
    }(Math), function () {
      var e = ve, t = e.lib.Hasher, n = e.x64, r = n.Word, a = n.WordArray, o = e.algo;

      function i() {
        return r.create.apply(r, arguments)
      }

      var _e = [i(1116352408, 3609767458), i(1899447441, 602891725), i(3049323471, 3964484399), i(3921009573, 2173295548), i(961987163, 4081628472), i(1508970993, 3053834265), i(2453635748, 2937671579), i(2870763221, 3664609560), i(3624381080, 2734883394), i(310598401, 1164996542), i(607225278, 1323610764), i(1426881987, 3590304994), i(1925078388, 4068182383), i(2162078206, 991336113), i(2614888103, 633803317), i(3248222580, 3479774868), i(3835390401, 2666613458), i(4022224774, 944711139), i(264347078, 2341262773), i(604807628, 2007800933), i(770255983, 1495990901), i(1249150122, 1856431235), i(1555081692, 3175218132), i(1996064986, 2198950837), i(2554220882, 3999719339), i(2821834349, 766784016), i(2952996808, 2566594879), i(3210313671, 3203337956), i(3336571891, 1034457026), i(3584528711, 2466948901), i(113926993, 3758326383), i(338241895, 168717936), i(666307205, 1188179964), i(773529912, 1546045734), i(1294757372, 1522805485), i(1396182291, 2643833823), i(1695183700, 2343527390), i(1986661051, 1014477480), i(2177026350, 1206759142), i(2456956037, 344077627), i(2730485921, 1290863460), i(2820302411, 3158454273), i(3259730800, 3505952657), i(3345764771, 106217008), i(3516065817, 3606008344), i(3600352804, 1432725776), i(4094571909, 1467031594), i(275423344, 851169720), i(430227734, 3100823752), i(506948616, 1363258195), i(659060556, 3750685593), i(883997877, 3785050280), i(958139571, 3318307427), i(1322822218, 3812723403), i(1537002063, 2003034995), i(1747873779, 3602036899), i(1955562222, 1575990012), i(2024104815, 1125592928), i(2227730452, 2716904306), i(2361852424, 442776044), i(2428436474, 593698344), i(2756734187, 3733110249), i(3204031479, 2999351573), i(3329325298, 3815920427), i(3391569614, 3928383900), i(3515267271, 566280711), i(3940187606, 3454069534), i(4118630271, 4000239992), i(116418474, 1914138554), i(174292421, 2731055270), i(289380356, 3203993006), i(460393269, 320620315), i(685471733, 587496836), i(852142971, 1086792851), i(1017036298, 365543100), i(1126000580, 2618297676), i(1288033470, 3409855158), i(1501505948, 4234509866), i(1607167915, 987167468), i(1816402316, 1246189591)],
        we = [];
      !function () {
        for (var e = 0; e < 80; e++) we[e] = i()
      }();
      var s = o.SHA512 = t.extend({
        _doReset: function () {
          this._hash = new a.init([new r.init(1779033703, 4089235720), new r.init(3144134277, 2227873595), new r.init(1013904242, 4271175723), new r.init(2773480762, 1595750129), new r.init(1359893119, 2917565137), new r.init(2600822924, 725511199), new r.init(528734635, 4215389547), new r.init(1541459225, 327033209)])
        }, _doProcessBlock: function (e, t) {
          for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = n[5], c = n[6], d = n[7], f = r.high, p = r.low, u = a.high, h = a.low, g = o.high, m = o.low, v = i.high, b = i.low, C = s.high, E = s.low, y = l.high, L = l.low, _ = c.high, w = c.low, A = d.high, T = d.low, S = f, k = p, x = u, R = h, M = g, O = m, N = v, I = b, D = C, B = E, H = y, $ = L, F = _, P = w, U = A, z = T, K = 0; K < 80; K++) {
            var V, W, G = we[K];
            if (K < 16) W = G.high = 0 | e[t + 2 * K], V = G.low = 0 | e[t + 2 * K + 1]; else {
              var Y = we[K - 15], j = Y.high, q = Y.low, Z = (j >>> 1 | q << 31) ^ (j >>> 8 | q << 24) ^ j >>> 7,
                X = (q >>> 1 | j << 31) ^ (q >>> 8 | j << 24) ^ (q >>> 7 | j << 25), Q = we[K - 2], J = Q.high,
                ee = Q.low, te = (J >>> 19 | ee << 13) ^ (J << 3 | ee >>> 29) ^ J >>> 6,
                ne = (ee >>> 19 | J << 13) ^ (ee << 3 | J >>> 29) ^ (ee >>> 6 | J << 26), re = we[K - 7], ae = re.high,
                oe = re.low, ie = we[K - 16], se = ie.high, le = ie.low;
              W = (W = (W = Z + ae + ((V = X + oe) >>> 0 < X >>> 0 ? 1 : 0)) + te + ((V += ne) >>> 0 < ne >>> 0 ? 1 : 0)) + se + ((V += le) >>> 0 < le >>> 0 ? 1 : 0), G.high = W, G.low = V
            }
            var ce, de = D & H ^ ~D & F, fe = B & $ ^ ~B & P, pe = S & x ^ S & M ^ x & M, ue = k & R ^ k & O ^ R & O,
              he = (S >>> 28 | k << 4) ^ (S << 30 | k >>> 2) ^ (S << 25 | k >>> 7),
              ge = (k >>> 28 | S << 4) ^ (k << 30 | S >>> 2) ^ (k << 25 | S >>> 7),
              me = (D >>> 14 | B << 18) ^ (D >>> 18 | B << 14) ^ (D << 23 | B >>> 9),
              ve = (B >>> 14 | D << 18) ^ (B >>> 18 | D << 14) ^ (B << 23 | D >>> 9), be = _e[K], Ce = be.high,
              Ee = be.low, ye = U + me + ((ce = z + ve) >>> 0 < z >>> 0 ? 1 : 0), Le = ge + ue;
            U = F, z = P, F = H, P = $, H = D, $ = B, D = N + (ye = (ye = (ye = ye + de + ((ce = ce + fe) >>> 0 < fe >>> 0 ? 1 : 0)) + Ce + ((ce = ce + Ee) >>> 0 < Ee >>> 0 ? 1 : 0)) + W + ((ce = ce + V) >>> 0 < V >>> 0 ? 1 : 0)) + ((B = I + ce | 0) >>> 0 < I >>> 0 ? 1 : 0) | 0, N = M, I = O, M = x, O = R, x = S, R = k, S = ye + (he + pe + (Le >>> 0 < ge >>> 0 ? 1 : 0)) + ((k = ce + Le | 0) >>> 0 < ce >>> 0 ? 1 : 0) | 0
          }
          p = r.low = p + k, r.high = f + S + (p >>> 0 < k >>> 0 ? 1 : 0), h = a.low = h + R, a.high = u + x + (h >>> 0 < R >>> 0 ? 1 : 0), m = o.low = m + O, o.high = g + M + (m >>> 0 < O >>> 0 ? 1 : 0), b = i.low = b + I, i.high = v + N + (b >>> 0 < I >>> 0 ? 1 : 0), E = s.low = E + B, s.high = C + D + (E >>> 0 < B >>> 0 ? 1 : 0), L = l.low = L + $, l.high = y + H + (L >>> 0 < $ >>> 0 ? 1 : 0), w = c.low = w + P, c.high = _ + F + (w >>> 0 < P >>> 0 ? 1 : 0), T = d.low = T + z, d.high = A + U + (T >>> 0 < z >>> 0 ? 1 : 0)
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          return t[r >>> 5] |= 128 << 24 - r % 32, t[30 + (r + 128 >>> 10 << 5)] = Math.floor(n / 4294967296), t[31 + (r + 128 >>> 10 << 5)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash.toX32()
        }, clone: function e() {
          var e = t.clone.call(this);
          return e._hash = this._hash.clone(), e
        }, blockSize: 32
      });
      e.SHA512 = t._createHelper(s), e.HmacSHA512 = t._createHmacHelper(s)
    }(), F = ($ = ve).x64, P = F.Word, U = F.WordArray, z = $.algo, K = z.SHA512, V = z.SHA384 = K.extend({
      _doReset: function () {
        this._hash = new U.init([new P.init(3418070365, 3238371032), new P.init(1654270250, 914150663), new P.init(2438529370, 812702999), new P.init(355462360, 4144912697), new P.init(1731405415, 4290775857), new P.init(2394180231, 1750603025), new P.init(3675008525, 1694076839), new P.init(1203062813, 3204075428)])
      }, _doFinalize: function () {
        var e = K._doFinalize.call(this);
        return e.sigBytes -= 16, e
      }
    }), $.SHA384 = K._createHelper(V), $.HmacSHA384 = K._createHmacHelper(V), ve.lib.Cipher || (G = (W = ve).lib, Y = G.Base, j = G.WordArray, q = G.BufferedBlockAlgorithm, (Z = W.enc).Utf8, X = Z.Base64, Q = W.algo.EvpKDF, J = G.Cipher = q.extend({
      cfg: Y.extend(),
      createEncryptor: function (e, t) {
        return this.create(this._ENC_XFORM_MODE, e, t)
      },
      createDecryptor: function (e, t) {
        return this.create(this._DEC_XFORM_MODE, e, t)
      },
      init: function (e, t, n) {
        this.cfg = this.cfg.extend(n), this._xformMode = e, this._key = t, this.reset()
      },
      reset: function () {
        q.reset.call(this), this._doReset()
      },
      process: function (e) {
        return this._append(e), this._process()
      },
      finalize: function (e) {
        return e && this._append(e), this._doFinalize()
      },
      keySize: 4,
      ivSize: 4,
      _ENC_XFORM_MODE: 1,
      _DEC_XFORM_MODE: 2,
      _createHelper: function () {
        function a(e) {
          return "string" == typeof e ? le : ie
        }

        return function (r) {
          return {
            encrypt: function (e, t, n) {
              return a(t).encrypt(r, e, t, n)
            }, decrypt: function (e, t, n) {
              return a(t).decrypt(r, e, t, n)
            }
          }
        }
      }()
    }), G.StreamCipher = J.extend({
      _doFinalize: function () {
        return this._process(!0)
      }, blockSize: 1
    }), ee = W.mode = {}, te = G.BlockCipherMode = Y.extend({
      createEncryptor: function (e, t) {
        return this.Encryptor.create(e, t)
      }, createDecryptor: function (e, t) {
        return this.Decryptor.create(e, t)
      }, init: function (e, t) {
        this._cipher = e, this._iv = t
      }
    }), ne = ee.CBC = function () {
      var e = te.extend();

      function o(e, t, n) {
        var r, a = this._iv;
        a ? (r = a, this._iv = void 0) : r = this._prevBlock;
        for (var o = 0; o < n; o++) e[t + o] ^= r[o]
      }

      return e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize;
          o.call(this, e, t, r), n.encryptBlock(e, t), this._prevBlock = e.slice(t, t + r)
        }
      }), e.Decryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = e.slice(t, t + r);
          n.decryptBlock(e, t), o.call(this, e, t, r), this._prevBlock = a
        }
      }), e
    }(), re = (W.pad = {}).Pkcs7 = {
      pad: function (e, t) {
        for (var n = 4 * t, r = n - e.sigBytes % n, a = r << 24 | r << 16 | r << 8 | r, o = [], i = 0; i < r; i += 4) o.push(a);
        var s = j.create(o, r);
        e.concat(s)
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, G.BlockCipher = J.extend({
      cfg: J.cfg.extend({mode: ne, padding: re}), reset: function () {
        var e;
        J.reset.call(this);
        var t = this.cfg, n = t.iv, r = t.mode;
        this._xformMode == this._ENC_XFORM_MODE ? e = r.createEncryptor : (e = r.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == e ? this._mode.init(this, n && n.words) : (this._mode = e.call(r, this, n && n.words), this._mode.__creator = e)
      }, _doProcessBlock: function (e, t) {
        this._mode.processBlock(e, t)
      }, _doFinalize: function () {
        var e, t = this.cfg.padding;
        return this._xformMode == this._ENC_XFORM_MODE ? (t.pad(this._data, this.blockSize), e = this._process(!0)) : (e = this._process(!0), t.unpad(e)), e
      }, blockSize: 4
    }), ae = G.CipherParams = Y.extend({
      init: function (e) {
        this.mixIn(e)
      }, toString: function (e) {
        return (e || this.formatter).stringify(this)
      }
    }), oe = (W.format = {}).OpenSSL = {
      stringify: function (e) {
        var t = e.ciphertext, n = e.salt;
        return (n ? j.create([1398893684, 1701076831]).concat(n).concat(t) : t).toString(X)
      }, parse: function (e) {
        var t, n = X.parse(e), r = n.words;
        return 1398893684 == r[0] && 1701076831 == r[1] && (t = j.create(r.slice(2, 4)), r.splice(0, 4), n.sigBytes -= 16), ae.create({
          ciphertext: n,
          salt: t
        })
      }
    }, ie = G.SerializableCipher = Y.extend({
      cfg: Y.extend({format: oe}), encrypt: function (e, t, n, r) {
        r = this.cfg.extend(r);
        var a = e.createEncryptor(n, r), o = a.finalize(t), i = a.cfg;
        return ae.create({
          ciphertext: o,
          key: n,
          iv: i.iv,
          algorithm: e,
          mode: i.mode,
          padding: i.padding,
          blockSize: e.blockSize,
          formatter: r.format
        })
      }, decrypt: function (e, t, n, r) {
        return r = this.cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext)
      }, _parse: function (e, t) {
        return "string" == typeof e ? t.parse(e, this) : e
      }
    }), se = (W.kdf = {}).OpenSSL = {
      execute: function (e, t, n, r) {
        r || (r = j.random(8));
        var a = Q.create({keySize: t + n}).compute(e, r), o = j.create(a.words.slice(t), 4 * n);
        return a.sigBytes = 4 * t, ae.create({key: a, iv: o, salt: r})
      }
    }, le = G.PasswordBasedCipher = ie.extend({
      cfg: ie.cfg.extend({kdf: se}), encrypt: function (e, t, n, r) {
        var a = (r = this.cfg.extend(r)).kdf.execute(n, e.keySize, e.ivSize);
        r.iv = a.iv;
        var o = ie.encrypt.call(this, e, t, a.key, r);
        return o.mixIn(a), o
      }, decrypt: function (e, t, n, r) {
        r = this.cfg.extend(r), t = this._parse(t, r.format);
        var a = r.kdf.execute(n, e.keySize, e.ivSize, t.salt);
        return r.iv = a.iv, ie.decrypt.call(this, e, t, a.key, r)
      }
    })), ve.mode.CFB = function () {
      var e = ve.lib.BlockCipherMode.extend();

      function o(e, t, n, r) {
        var a, o = this._iv;
        o ? (a = o.slice(0), this._iv = undefined) : a = this._prevBlock, r.encryptBlock(a, 0);
        for (var i = 0; i < n; i++) e[t + i] ^= a[i]
      }

      return e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize;
          o.call(this, e, t, r, n), this._prevBlock = e.slice(t, t + r)
        }
      }), e.Decryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = e.slice(t, t + r);
          o.call(this, e, t, r, n), this._prevBlock = a
        }
      }), e
    }(), ve.mode.ECB = ((ce = ve.lib.BlockCipherMode.extend()).Encryptor = ce.extend({
      processBlock: function (e, t) {
        this._cipher.encryptBlock(e, t)
      }
    }), ce.Decryptor = ce.extend({
      processBlock: function (e, t) {
        this._cipher.decryptBlock(e, t)
      }
    }), ce), ve.pad.AnsiX923 = {
      pad: function (e, t) {
        var n = e.sigBytes, r = 4 * t, a = r - n % r, o = n + a - 1;
        e.clamp(), e.words[o >>> 2] |= a << 24 - o % 4 * 8, e.sigBytes += a
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, ve.pad.Iso10126 = {
      pad: function (e, t) {
        var n = 4 * t, r = n - e.sigBytes % n;
        e.concat(ve.lib.WordArray.random(r - 1)).concat(ve.lib.WordArray.create([r << 24], 1))
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, ve.pad.Iso97971 = {
      pad: function (e, t) {
        e.concat(ve.lib.WordArray.create([2147483648], 1)), ve.pad.ZeroPadding.pad(e, t)
      }, unpad: function (e) {
        ve.pad.ZeroPadding.unpad(e), e.sigBytes--
      }
    }, ve.mode.OFB = (de = ve.lib.BlockCipherMode.extend(), fe = de.Encryptor = de.extend({
      processBlock: function (e, t) {
        var n = this._cipher, r = n.blockSize, a = this._iv, o = this._keystream;
        a && (o = this._keystream = a.slice(0), this._iv = undefined), n.encryptBlock(o, 0);
        for (var i = 0; i < r; i++) e[t + i] ^= o[i]
      }
    }), de.Decryptor = fe, de), ve.pad.NoPadding = {
      pad: function () {
      }, unpad: function () {
      }
    }, ue = (pe = ve).lib.CipherParams, he = pe.enc.Hex, pe.format.Hex = {
      stringify: function (e) {
        return e.ciphertext.toString(he)
      }, parse: function (e) {
        var t = he.parse(e);
        return ue.create({ciphertext: t})
      }
    }, function () {
      var e = ve, t = e.lib.BlockCipher, n = e.algo, c = [], d = [], f = [], p = [], u = [], h = [], g = [], m = [],
        v = [], b = [];
      !function () {
        for (var e = [], t = 0; t < 256; t++) e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
        var n = 0, r = 0;
        for (t = 0; t < 256; t++) {
          var a = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4;
          a = a >>> 8 ^ 255 & a ^ 99, c[n] = a;
          var o = e[d[a] = n], i = e[o], s = e[i], l = 257 * e[a] ^ 16843008 * a;
          f[n] = l << 24 | l >>> 8, p[n] = l << 16 | l >>> 16, u[n] = l << 8 | l >>> 24, h[n] = l;
          l = 16843009 * s ^ 65537 * i ^ 257 * o ^ 16843008 * n;
          g[a] = l << 24 | l >>> 8, m[a] = l << 16 | l >>> 16, v[a] = l << 8 | l >>> 24, b[a] = l, n ? (n = o ^ e[e[e[s ^ o]]], r ^= e[e[r]]) : n = r = 1
        }
      }();
      var C = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], r = n.AES = t.extend({
        _doReset: function () {
          if (!this._nRounds || this._keyPriorReset !== this._key) {
            for (var e = this._keyPriorReset = this._key, t = e.words, n = e.sigBytes / 4, r = 4 * ((this._nRounds = n + 6) + 1), a = this._keySchedule = [], o = 0; o < r; o++) o < n ? a[o] = t[o] : (l = a[o - 1], o % n ? 6 < n && o % n == 4 && (l = c[l >>> 24] << 24 | c[l >>> 16 & 255] << 16 | c[l >>> 8 & 255] << 8 | c[255 & l]) : (l = c[(l = l << 8 | l >>> 24) >>> 24] << 24 | c[l >>> 16 & 255] << 16 | c[l >>> 8 & 255] << 8 | c[255 & l], l ^= C[o / n | 0] << 24), a[o] = a[o - n] ^ l);
            for (var i = this._invKeySchedule = [], s = 0; s < r; s++) {
              o = r - s;
              if (s % 4) var l = a[o]; else l = a[o - 4];
              i[s] = s < 4 || o <= 4 ? l : g[c[l >>> 24]] ^ m[c[l >>> 16 & 255]] ^ v[c[l >>> 8 & 255]] ^ b[c[255 & l]]
            }
          }
        }, encryptBlock: function (e, t) {
          this._doCryptBlock(e, t, this._keySchedule, f, p, u, h, c)
        }, decryptBlock: function (e, t) {
          var n = e[t + 1];
          e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, this._invKeySchedule, g, m, v, b, d);
          n = e[t + 1];
          e[t + 1] = e[t + 3], e[t + 3] = n
        }, _doCryptBlock: function (e, t, n, r, a, o, i, s) {
          for (var l = this._nRounds, c = e[t] ^ n[0], d = e[t + 1] ^ n[1], f = e[t + 2] ^ n[2], p = e[t + 3] ^ n[3], u = 4, h = 1; h < l; h++) {
            var g = r[c >>> 24] ^ a[d >>> 16 & 255] ^ o[f >>> 8 & 255] ^ i[255 & p] ^ n[u++],
              m = r[d >>> 24] ^ a[f >>> 16 & 255] ^ o[p >>> 8 & 255] ^ i[255 & c] ^ n[u++],
              v = r[f >>> 24] ^ a[p >>> 16 & 255] ^ o[c >>> 8 & 255] ^ i[255 & d] ^ n[u++],
              b = r[p >>> 24] ^ a[c >>> 16 & 255] ^ o[d >>> 8 & 255] ^ i[255 & f] ^ n[u++];
            c = g, d = m, f = v, p = b
          }
          g = (s[c >>> 24] << 24 | s[d >>> 16 & 255] << 16 | s[f >>> 8 & 255] << 8 | s[255 & p]) ^ n[u++], m = (s[d >>> 24] << 24 | s[f >>> 16 & 255] << 16 | s[p >>> 8 & 255] << 8 | s[255 & c]) ^ n[u++], v = (s[f >>> 24] << 24 | s[p >>> 16 & 255] << 16 | s[c >>> 8 & 255] << 8 | s[255 & d]) ^ n[u++], b = (s[p >>> 24] << 24 | s[c >>> 16 & 255] << 16 | s[d >>> 8 & 255] << 8 | s[255 & f]) ^ n[u++];
          e[t] = g, e[t + 1] = m, e[t + 2] = v, e[t + 3] = b
        }, keySize: 8
      });
      e.AES = t._createHelper(r)
    }(), function () {
      var e = ve, t = e.lib, a = t.WordArray, n = t.BlockCipher, r = e.algo,
        c = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4],
        d = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32],
        f = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], p = [{
          0: 8421888,
          268435456: 32768,
          536870912: 8421378,
          805306368: 2,
          1073741824: 512,
          1342177280: 8421890,
          1610612736: 8389122,
          1879048192: 8388608,
          2147483648: 514,
          2415919104: 8389120,
          2684354560: 33280,
          2952790016: 8421376,
          3221225472: 32770,
          3489660928: 8388610,
          3758096384: 0,
          4026531840: 33282,
          134217728: 0,
          402653184: 8421890,
          671088640: 33282,
          939524096: 32768,
          1207959552: 8421888,
          1476395008: 512,
          1744830464: 8421378,
          2013265920: 2,
          2281701376: 8389120,
          2550136832: 33280,
          2818572288: 8421376,
          3087007744: 8389122,
          3355443200: 8388610,
          3623878656: 32770,
          3892314112: 514,
          4160749568: 8388608,
          1: 32768,
          268435457: 2,
          536870913: 8421888,
          805306369: 8388608,
          1073741825: 8421378,
          1342177281: 33280,
          1610612737: 512,
          1879048193: 8389122,
          2147483649: 8421890,
          2415919105: 8421376,
          2684354561: 8388610,
          2952790017: 33282,
          3221225473: 514,
          3489660929: 8389120,
          3758096385: 32770,
          4026531841: 0,
          134217729: 8421890,
          402653185: 8421376,
          671088641: 8388608,
          939524097: 512,
          1207959553: 32768,
          1476395009: 8388610,
          1744830465: 2,
          2013265921: 33282,
          2281701377: 32770,
          2550136833: 8389122,
          2818572289: 514,
          3087007745: 8421888,
          3355443201: 8389120,
          3623878657: 0,
          3892314113: 33280,
          4160749569: 8421378
        }, {
          0: 1074282512,
          16777216: 16384,
          33554432: 524288,
          50331648: 1074266128,
          67108864: 1073741840,
          83886080: 1074282496,
          100663296: 1073758208,
          117440512: 16,
          134217728: 540672,
          150994944: 1073758224,
          167772160: 1073741824,
          184549376: 540688,
          201326592: 524304,
          218103808: 0,
          234881024: 16400,
          251658240: 1074266112,
          8388608: 1073758208,
          25165824: 540688,
          41943040: 16,
          58720256: 1073758224,
          75497472: 1074282512,
          92274688: 1073741824,
          109051904: 524288,
          125829120: 1074266128,
          142606336: 524304,
          159383552: 0,
          176160768: 16384,
          192937984: 1074266112,
          209715200: 1073741840,
          226492416: 540672,
          243269632: 1074282496,
          260046848: 16400,
          268435456: 0,
          285212672: 1074266128,
          301989888: 1073758224,
          318767104: 1074282496,
          335544320: 1074266112,
          352321536: 16,
          369098752: 540688,
          385875968: 16384,
          402653184: 16400,
          419430400: 524288,
          436207616: 524304,
          452984832: 1073741840,
          469762048: 540672,
          486539264: 1073758208,
          503316480: 1073741824,
          520093696: 1074282512,
          276824064: 540688,
          293601280: 524288,
          310378496: 1074266112,
          327155712: 16384,
          343932928: 1073758208,
          360710144: 1074282512,
          377487360: 16,
          394264576: 1073741824,
          411041792: 1074282496,
          427819008: 1073741840,
          444596224: 1073758224,
          461373440: 524304,
          478150656: 0,
          494927872: 16400,
          511705088: 1074266128,
          528482304: 540672
        }, {
          0: 260,
          1048576: 0,
          2097152: 67109120,
          3145728: 65796,
          4194304: 65540,
          5242880: 67108868,
          6291456: 67174660,
          7340032: 67174400,
          8388608: 67108864,
          9437184: 67174656,
          10485760: 65792,
          11534336: 67174404,
          12582912: 67109124,
          13631488: 65536,
          14680064: 4,
          15728640: 256,
          524288: 67174656,
          1572864: 67174404,
          2621440: 0,
          3670016: 67109120,
          4718592: 67108868,
          5767168: 65536,
          6815744: 65540,
          7864320: 260,
          8912896: 4,
          9961472: 256,
          11010048: 67174400,
          12058624: 65796,
          13107200: 65792,
          14155776: 67109124,
          15204352: 67174660,
          16252928: 67108864,
          16777216: 67174656,
          17825792: 65540,
          18874368: 65536,
          19922944: 67109120,
          20971520: 256,
          22020096: 67174660,
          23068672: 67108868,
          24117248: 0,
          25165824: 67109124,
          26214400: 67108864,
          27262976: 4,
          28311552: 65792,
          29360128: 67174400,
          30408704: 260,
          31457280: 65796,
          32505856: 67174404,
          17301504: 67108864,
          18350080: 260,
          19398656: 67174656,
          20447232: 0,
          21495808: 65540,
          22544384: 67109120,
          23592960: 256,
          24641536: 67174404,
          25690112: 65536,
          26738688: 67174660,
          27787264: 65796,
          28835840: 67108868,
          29884416: 67109124,
          30932992: 67174400,
          31981568: 4,
          33030144: 65792
        }, {
          0: 2151682048,
          65536: 2147487808,
          131072: 4198464,
          196608: 2151677952,
          262144: 0,
          327680: 4198400,
          393216: 2147483712,
          458752: 4194368,
          524288: 2147483648,
          589824: 4194304,
          655360: 64,
          720896: 2147487744,
          786432: 2151678016,
          851968: 4160,
          917504: 4096,
          983040: 2151682112,
          32768: 2147487808,
          98304: 64,
          163840: 2151678016,
          229376: 2147487744,
          294912: 4198400,
          360448: 2151682112,
          425984: 0,
          491520: 2151677952,
          557056: 4096,
          622592: 2151682048,
          688128: 4194304,
          753664: 4160,
          819200: 2147483648,
          884736: 4194368,
          950272: 4198464,
          1015808: 2147483712,
          1048576: 4194368,
          1114112: 4198400,
          1179648: 2147483712,
          1245184: 0,
          1310720: 4160,
          1376256: 2151678016,
          1441792: 2151682048,
          1507328: 2147487808,
          1572864: 2151682112,
          1638400: 2147483648,
          1703936: 2151677952,
          1769472: 4198464,
          1835008: 2147487744,
          1900544: 4194304,
          1966080: 64,
          2031616: 4096,
          1081344: 2151677952,
          1146880: 2151682112,
          1212416: 0,
          1277952: 4198400,
          1343488: 4194368,
          1409024: 2147483648,
          1474560: 2147487808,
          1540096: 64,
          1605632: 2147483712,
          1671168: 4096,
          1736704: 2147487744,
          1802240: 2151678016,
          1867776: 4160,
          1933312: 2151682048,
          1998848: 4194304,
          2064384: 4198464
        }, {
          0: 128,
          4096: 17039360,
          8192: 262144,
          12288: 536870912,
          16384: 537133184,
          20480: 16777344,
          24576: 553648256,
          28672: 262272,
          32768: 16777216,
          36864: 537133056,
          40960: 536871040,
          45056: 553910400,
          49152: 553910272,
          53248: 0,
          57344: 17039488,
          61440: 553648128,
          2048: 17039488,
          6144: 553648256,
          10240: 128,
          14336: 17039360,
          18432: 262144,
          22528: 537133184,
          26624: 553910272,
          30720: 536870912,
          34816: 537133056,
          38912: 0,
          43008: 553910400,
          47104: 16777344,
          51200: 536871040,
          55296: 553648128,
          59392: 16777216,
          63488: 262272,
          65536: 262144,
          69632: 128,
          73728: 536870912,
          77824: 553648256,
          81920: 16777344,
          86016: 553910272,
          90112: 537133184,
          94208: 16777216,
          98304: 553910400,
          102400: 553648128,
          106496: 17039360,
          110592: 537133056,
          114688: 262272,
          118784: 536871040,
          122880: 0,
          126976: 17039488,
          67584: 553648256,
          71680: 16777216,
          75776: 17039360,
          79872: 537133184,
          83968: 536870912,
          88064: 17039488,
          92160: 128,
          96256: 553910272,
          100352: 262272,
          104448: 553910400,
          108544: 0,
          112640: 553648128,
          116736: 16777344,
          120832: 262144,
          124928: 537133056,
          129024: 536871040
        }, {
          0: 268435464,
          256: 8192,
          512: 270532608,
          768: 270540808,
          1024: 268443648,
          1280: 2097152,
          1536: 2097160,
          1792: 268435456,
          2048: 0,
          2304: 268443656,
          2560: 2105344,
          2816: 8,
          3072: 270532616,
          3328: 2105352,
          3584: 8200,
          3840: 270540800,
          128: 270532608,
          384: 270540808,
          640: 8,
          896: 2097152,
          1152: 2105352,
          1408: 268435464,
          1664: 268443648,
          1920: 8200,
          2176: 2097160,
          2432: 8192,
          2688: 268443656,
          2944: 270532616,
          3200: 0,
          3456: 270540800,
          3712: 2105344,
          3968: 268435456,
          4096: 268443648,
          4352: 270532616,
          4608: 270540808,
          4864: 8200,
          5120: 2097152,
          5376: 268435456,
          5632: 268435464,
          5888: 2105344,
          6144: 2105352,
          6400: 0,
          6656: 8,
          6912: 270532608,
          7168: 8192,
          7424: 268443656,
          7680: 270540800,
          7936: 2097160,
          4224: 8,
          4480: 2105344,
          4736: 2097152,
          4992: 268435464,
          5248: 268443648,
          5504: 8200,
          5760: 270540808,
          6016: 270532608,
          6272: 270540800,
          6528: 270532616,
          6784: 8192,
          7040: 2105352,
          7296: 2097160,
          7552: 0,
          7808: 268435456,
          8064: 268443656
        }, {
          0: 1048576,
          16: 33555457,
          32: 1024,
          48: 1049601,
          64: 34604033,
          80: 0,
          96: 1,
          112: 34603009,
          128: 33555456,
          144: 1048577,
          160: 33554433,
          176: 34604032,
          192: 34603008,
          208: 1025,
          224: 1049600,
          240: 33554432,
          8: 34603009,
          24: 0,
          40: 33555457,
          56: 34604032,
          72: 1048576,
          88: 33554433,
          104: 33554432,
          120: 1025,
          136: 1049601,
          152: 33555456,
          168: 34603008,
          184: 1048577,
          200: 1024,
          216: 34604033,
          232: 1,
          248: 1049600,
          256: 33554432,
          272: 1048576,
          288: 33555457,
          304: 34603009,
          320: 1048577,
          336: 33555456,
          352: 34604032,
          368: 1049601,
          384: 1025,
          400: 34604033,
          416: 1049600,
          432: 1,
          448: 0,
          464: 34603008,
          480: 33554433,
          496: 1024,
          264: 1049600,
          280: 33555457,
          296: 34603009,
          312: 1,
          328: 33554432,
          344: 1048576,
          360: 1025,
          376: 34604032,
          392: 33554433,
          408: 34603008,
          424: 0,
          440: 34604033,
          456: 1049601,
          472: 1024,
          488: 33555456,
          504: 1048577
        }, {
          0: 134219808,
          1: 131072,
          2: 134217728,
          3: 32,
          4: 131104,
          5: 134350880,
          6: 134350848,
          7: 2048,
          8: 134348800,
          9: 134219776,
          10: 133120,
          11: 134348832,
          12: 2080,
          13: 0,
          14: 134217760,
          15: 133152,
          2147483648: 2048,
          2147483649: 134350880,
          2147483650: 134219808,
          2147483651: 134217728,
          2147483652: 134348800,
          2147483653: 133120,
          2147483654: 133152,
          2147483655: 32,
          2147483656: 134217760,
          2147483657: 2080,
          2147483658: 131104,
          2147483659: 134350848,
          2147483660: 0,
          2147483661: 134348832,
          2147483662: 134219776,
          2147483663: 131072,
          16: 133152,
          17: 134350848,
          18: 32,
          19: 2048,
          20: 134219776,
          21: 134217760,
          22: 134348832,
          23: 131072,
          24: 0,
          25: 131104,
          26: 134348800,
          27: 134219808,
          28: 134350880,
          29: 133120,
          30: 2080,
          31: 134217728,
          2147483664: 131072,
          2147483665: 2048,
          2147483666: 134348832,
          2147483667: 133152,
          2147483668: 32,
          2147483669: 134348800,
          2147483670: 134217728,
          2147483671: 134219808,
          2147483672: 134350880,
          2147483673: 134217760,
          2147483674: 134219776,
          2147483675: 0,
          2147483676: 133120,
          2147483677: 2080,
          2147483678: 131104,
          2147483679: 134350848
        }], u = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], o = r.DES = n.extend({
          _doReset: function () {
            for (var e = this._key.words, t = [], n = 0; n < 56; n++) {
              var r = c[n] - 1;
              t[n] = e[r >>> 5] >>> 31 - r % 32 & 1
            }
            for (var a = this._subKeys = [], o = 0; o < 16; o++) {
              var i = a[o] = [], s = f[o];
              for (n = 0; n < 24; n++) i[n / 6 | 0] |= t[(d[n] - 1 + s) % 28] << 31 - n % 6, i[4 + (n / 6 | 0)] |= t[28 + (d[n + 24] - 1 + s) % 28] << 31 - n % 6;
              i[0] = i[0] << 1 | i[0] >>> 31;
              for (n = 1; n < 7; n++) i[n] = i[n] >>> 4 * (n - 1) + 3;
              i[7] = i[7] << 5 | i[7] >>> 27
            }
            var l = this._invSubKeys = [];
            for (n = 0; n < 16; n++) l[n] = a[15 - n]
          }, encryptBlock: function (e, t) {
            this._doCryptBlock(e, t, this._subKeys)
          }, decryptBlock: function (e, t) {
            this._doCryptBlock(e, t, this._invSubKeys)
          }, _doCryptBlock: function (e, t, n) {
            this._lBlock = e[t], this._rBlock = e[t + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), g.call(this, 2, 858993459), g.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var r = 0; r < 16; r++) {
              for (var a = n[r], o = this._lBlock, i = this._rBlock, s = 0, l = 0; l < 8; l++) s |= p[l][((i ^ a[l]) & u[l]) >>> 0];
              this._lBlock = i, this._rBlock = o ^ s
            }
            var c = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = c, h.call(this, 1, 1431655765), g.call(this, 8, 16711935), g.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), e[t] = this._lBlock, e[t + 1] = this._rBlock
          }, keySize: 2, ivSize: 2, blockSize: 2
        });

      function h(e, t) {
        var n = (this._lBlock >>> e ^ this._rBlock) & t;
        this._rBlock ^= n, this._lBlock ^= n << e
      }

      function g(e, t) {
        var n = (this._rBlock >>> e ^ this._lBlock) & t;
        this._lBlock ^= n, this._rBlock ^= n << e
      }

      e.DES = n._createHelper(o);
      var i = r.TripleDES = n.extend({
        _doReset: function () {
          var e = this._key.words;
          if (2 !== e.length && 4 !== e.length && e.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
          var t = e.slice(0, 2), n = e.length < 4 ? e.slice(0, 2) : e.slice(2, 4),
            r = e.length < 6 ? e.slice(0, 2) : e.slice(4, 6);
          this._des1 = o.createEncryptor(a.create(t)), this._des2 = o.createEncryptor(a.create(n)), this._des3 = o.createEncryptor(a.create(r))
        }, encryptBlock: function (e, t) {
          this._des1.encryptBlock(e, t), this._des2.decryptBlock(e, t), this._des3.encryptBlock(e, t)
        }, decryptBlock: function (e, t) {
          this._des3.decryptBlock(e, t), this._des2.encryptBlock(e, t), this._des1.decryptBlock(e, t)
        }, keySize: 6, ivSize: 2, blockSize: 2
      });
      e.TripleDES = n._createHelper(i)
    }(), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, r = n.RC4 = t.extend({
        _doReset: function () {
          for (var e = this._key, t = e.words, n = e.sigBytes, r = this._S = [], a = 0; a < 256; a++) r[a] = a;
          a = 0;
          for (var o = 0; a < 256; a++) {
            var i = a % n, s = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            o = (o + r[a] + s) % 256;
            var l = r[a];
            r[a] = r[o], r[o] = l
          }
          this._i = this._j = 0
        }, _doProcessBlock: function (e, t) {
          e[t] ^= a.call(this)
        }, keySize: 8, ivSize: 0
      });

      function a() {
        for (var e = this._S, t = this._i, n = this._j, r = 0, a = 0; a < 4; a++) {
          n = (n + e[t = (t + 1) % 256]) % 256;
          var o = e[t];
          e[t] = e[n], e[n] = o, r |= e[(e[t] + e[n]) % 256] << 24 - 8 * a
        }
        return this._i = t, this._j = n, r
      }

      e.RC4 = t._createHelper(r);
      var o = n.RC4Drop = r.extend({
        cfg: r.cfg.extend({drop: 192}), _doReset: function () {
          r._doReset.call(this);
          for (var e = this.cfg.drop; 0 < e; e--) a.call(this)
        }
      });
      e.RC4Drop = t._createHelper(o)
    }(), ve.mode.CTRGladman = function () {
      var e = ve.lib.BlockCipherMode.extend();

      function c(e) {
        if (255 == (e >> 24 & 255)) {
          var t = e >> 16 & 255, n = e >> 8 & 255, r = 255 & e;
          255 === t ? (t = 0, 255 === n ? (n = 0, 255 === r ? r = 0 : ++r) : ++n) : ++t, e = 0, e += t << 16, e += n << 8, e += r
        } else e += 1 << 24;
        return e
      }

      var t = e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = this._iv, o = this._counter;
          a && (o = this._counter = a.slice(0), this._iv = undefined), function l(e) {
            return 0 === (e[0] = c(e[0])) && (e[1] = c(e[1])), e
          }(o);
          var i = o.slice(0);
          n.encryptBlock(i, 0);
          for (var s = 0; s < r; s++) e[t + s] ^= i[s]
        }
      });
      return e.Decryptor = t, e
    }(), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, a = [], l = [], c = [], r = n.Rabbit = t.extend({
        _doReset: function () {
          for (var e = this._key.words, t = this.cfg.iv, n = 0; n < 4; n++) e[n] = 16711935 & (e[n] << 8 | e[n] >>> 24) | 4278255360 & (e[n] << 24 | e[n] >>> 8);
          var r = this._X = [e[0], e[3] << 16 | e[2] >>> 16, e[1], e[0] << 16 | e[3] >>> 16, e[2], e[1] << 16 | e[0] >>> 16, e[3], e[2] << 16 | e[1] >>> 16],
            a = this._C = [e[2] << 16 | e[2] >>> 16, 4294901760 & e[0] | 65535 & e[1], e[3] << 16 | e[3] >>> 16, 4294901760 & e[1] | 65535 & e[2], e[0] << 16 | e[0] >>> 16, 4294901760 & e[2] | 65535 & e[3], e[1] << 16 | e[1] >>> 16, 4294901760 & e[3] | 65535 & e[0]];
          for (n = this._b = 0; n < 4; n++) p.call(this);
          for (n = 0; n < 8; n++) a[n] ^= r[n + 4 & 7];
          if (t) {
            var o = t.words, i = o[0], s = o[1], l = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8),
              c = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8), d = l >>> 16 | 4294901760 & c,
              f = c << 16 | 65535 & l;
            a[0] ^= l, a[1] ^= d, a[2] ^= c, a[3] ^= f, a[4] ^= l, a[5] ^= d, a[6] ^= c, a[7] ^= f;
            for (n = 0; n < 4; n++) p.call(this)
          }
        }, _doProcessBlock: function (e, t) {
          var n = this._X;
          p.call(this), a[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, a[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, a[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, a[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
          for (var r = 0; r < 4; r++) a[r] = 16711935 & (a[r] << 8 | a[r] >>> 24) | 4278255360 & (a[r] << 24 | a[r] >>> 8), e[t + r] ^= a[r]
        }, blockSize: 4, ivSize: 2
      });

      function p() {
        for (var e = this._X, t = this._C, n = 0; n < 8; n++) l[n] = t[n];
        t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + (t[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, t[2] = t[2] + 886263092 + (t[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, t[3] = t[3] + 1295307597 + (t[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, t[4] = t[4] + 3545052371 + (t[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, t[5] = t[5] + 886263092 + (t[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, t[6] = t[6] + 1295307597 + (t[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, t[7] = t[7] + 3545052371 + (t[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = t[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
        for (n = 0; n < 8; n++) {
          var r = e[n] + t[n], a = 65535 & r, o = r >>> 16, i = ((a * a >>> 17) + a * o >>> 15) + o * o,
            s = ((4294901760 & r) * r | 0) + ((65535 & r) * r | 0);
          c[n] = i ^ s
        }
        e[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, e[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, e[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, e[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, e[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, e[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, e[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, e[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0
      }

      e.Rabbit = t._createHelper(r)
    }(), ve.mode.CTR = (ge = ve.lib.BlockCipherMode.extend(), me = ge.Encryptor = ge.extend({
      processBlock: function (e, t) {
        var n = this._cipher, r = n.blockSize, a = this._iv, o = this._counter;
        a && (o = this._counter = a.slice(0), this._iv = undefined);
        var i = o.slice(0);
        n.encryptBlock(i, 0), o[r - 1] = o[r - 1] + 1 | 0;
        for (var s = 0; s < r; s++) e[t + s] ^= i[s]
      }
    }), ge.Decryptor = me, ge), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, a = [], l = [], c = [], r = n.RabbitLegacy = t.extend({
        _doReset: function () {
          for (var e = this._key.words, t = this.cfg.iv, n = this._X = [e[0], e[3] << 16 | e[2] >>> 16, e[1], e[0] << 16 | e[3] >>> 16, e[2], e[1] << 16 | e[0] >>> 16, e[3], e[2] << 16 | e[1] >>> 16], r = this._C = [e[2] << 16 | e[2] >>> 16, 4294901760 & e[0] | 65535 & e[1], e[3] << 16 | e[3] >>> 16, 4294901760 & e[1] | 65535 & e[2], e[0] << 16 | e[0] >>> 16, 4294901760 & e[2] | 65535 & e[3], e[1] << 16 | e[1] >>> 16, 4294901760 & e[3] | 65535 & e[0]], a = this._b = 0; a < 4; a++) p.call(this);
          for (a = 0; a < 8; a++) r[a] ^= n[a + 4 & 7];
          if (t) {
            var o = t.words, i = o[0], s = o[1], l = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8),
              c = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8), d = l >>> 16 | 4294901760 & c,
              f = c << 16 | 65535 & l;
            r[0] ^= l, r[1] ^= d, r[2] ^= c, r[3] ^= f, r[4] ^= l, r[5] ^= d, r[6] ^= c, r[7] ^= f;
            for (a = 0; a < 4; a++) p.call(this)
          }
        }, _doProcessBlock: function (e, t) {
          var n = this._X;
          p.call(this), a[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, a[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, a[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, a[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
          for (var r = 0; r < 4; r++) a[r] = 16711935 & (a[r] << 8 | a[r] >>> 24) | 4278255360 & (a[r] << 24 | a[r] >>> 8), e[t + r] ^= a[r]
        }, blockSize: 4, ivSize: 2
      });

      function p() {
        for (var e = this._X, t = this._C, n = 0; n < 8; n++) l[n] = t[n];
        t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + (t[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, t[2] = t[2] + 886263092 + (t[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, t[3] = t[3] + 1295307597 + (t[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, t[4] = t[4] + 3545052371 + (t[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, t[5] = t[5] + 886263092 + (t[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, t[6] = t[6] + 1295307597 + (t[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, t[7] = t[7] + 3545052371 + (t[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = t[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
        for (n = 0; n < 8; n++) {
          var r = e[n] + t[n], a = 65535 & r, o = r >>> 16, i = ((a * a >>> 17) + a * o >>> 15) + o * o,
            s = ((4294901760 & r) * r | 0) + ((65535 & r) * r | 0);
          c[n] = i ^ s
        }
        e[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, e[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, e[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, e[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, e[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, e[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, e[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, e[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0
      }

      e.RabbitLegacy = t._createHelper(r)
    }(), ve.pad.ZeroPadding = {
      pad: function (e, t) {
        var n = 4 * t;
        e.clamp(), e.sigBytes += n - (e.sigBytes % n || n)
      }, unpad: function (e) {
        var t = e.words, n = e.sigBytes - 1;
        for (n = e.sigBytes - 1; 0 <= n; n--) if (t[n >>> 2] >>> 24 - n % 4 * 8 & 255) {
          e.sigBytes = n + 1;
          break
        }
      }
    }, {
      init: function be() {
      }, cryptoJS: ve
    }
  }, Object.assign(xt.DEFAULTS, {
    fontFamily: {
      "Arial,Helvetica,sans-serif": "Arial",
      "Georgia,serif": "Georgia",
      "Impact,Charcoal,sans-serif": "Impact",
      "Tahoma,Geneva,sans-serif": "Tahoma",
      "Times New Roman,Times,serif,-webkit-standard": "Times New Roman",
      "Verdana,Geneva,sans-serif": "Verdana"
    }, fontFamilySelection: !1, fontFamilyDefaultSelection: "Font Family"
  }), xt.PLUGINS.fontFamily = function (a) {
    var o = a.$;

    function i(e) {
      var t = e.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi, "").replace(/"|'| /g, "").split(",");
      return o(this).grep(t, function (e) {
        return 0 < e.length
      })
    }

    function s(e, t) {
      for (var n = 0; n < e.length; n++) for (var r = 0; r < t.length; r++) if (e[n].toLowerCase() === t[r].toLowerCase()) return [n, r];
      return null
    }

    function n() {
      var e = i(o(a.selection.element()).css("font-family")), t = [];
      for (var n in a.opts.fontFamily) if (a.opts.fontFamily.hasOwnProperty(n)) {
        var r = s(e, i(n));
        r && t.push([n, r])
      }
      return 0 === t.length ? null : (t.sort(function (e, t) {
        var n = e[1][0] - t[1][0];
        return 0 === n ? e[1][1] - t[1][1] : n
      }), t[0][0])
    }

    return {
      apply: function t(e) {
        a.format.applyStyle("font-family", e)
      }, refreshOnShow: function r(e, t) {
        t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", !1), t.find('.fr-command[data-param1="'.concat(n(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function l(e) {
        if (a.opts.fontFamilySelection) {
          var t = o(a.selection.element()).css("font-family").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi, "").replace(/"|'|/g, "").split(",");
          e.find("> span").text(a.opts.fontFamily[n()] || t[0] || a.language.translate(a.opts.fontFamilyDefaultSelection))
        }
      }
    }
  }, xt.RegisterCommand("fontFamily", {
    type: "dropdown", displaySelection: function (e) {
      return e.opts.fontFamilySelection
    }, defaultSelection: function (e) {
      return e.opts.fontFamilyDefaultSelection
    }, displaySelectionWidth: 120, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontFamily;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(n, '" \n        style="font-family: ').concat(n, '" title="').concat(t[n], '">').concat(t[n], "</a></li>"));
      return e += "</ul>"
    }, title: "Font Family", callback: function (e, t) {
      this.fontFamily.apply(t)
    }, refresh: function (e) {
      this.fontFamily.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.fontFamily.refreshOnShow(e, t)
    }, plugin: "fontFamily"
  }), xt.DefineIcon("fontFamily", {
    NAME: "font",
    SVG_KEY: "fontFamily"
  }), Object.assign(xt.DEFAULTS, {
    fontSize: ["8", "9", "10", "11", "12", "14", "18", "24", "30", "36", "48", "60", "72", "96"],
    fontSizeSelection: !1,
    fontSizeDefaultSelection: "12",
    fontSizeUnit: "px"
  }), xt.PLUGINS.fontSize = function (r) {
    var a = r.$;
    return {
      apply: function t(e) {
        r.format.applyStyle("font-size", e)
      }, refreshOnShow: function o(e, t) {
        var n = a(r.selection.element()).css("font-size");
        "pt" === r.opts.fontSizeUnit && (n = "".concat(Math.round(72 * parseFloat(n, 10) / 96), "pt")), t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", !1), t.find('.fr-command[data-param1="'.concat(n, '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function n(e) {
        if (r.opts.fontSizeSelection) {
          var t = r.helpers.getPX(a(r.selection.element()).css("font-size"));
          "pt" === r.opts.fontSizeUnit && (t = "".concat(Math.round(72 * parseFloat(t, 10) / 96), "pt")), e.find("> span").text(t)
        }
      }
    }
  }, xt.RegisterCommand("fontSize", {
    type: "dropdown", title: "Font Size", displaySelection: function (e) {
      return e.opts.fontSizeSelection
    }, displaySelectionWidth: 30, defaultSelection: function (e) {
      return e.opts.fontSizeDefaultSelection
    }, html: function () {
      for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontSize, n = 0; n < t.length; n++) {
        var r = t[n];
        e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, "</a></li>")
      }
      return e += "</ul>"
    }, callback: function (e, t) {
      this.fontSize.apply(t)
    }, refresh: function (e) {
      this.fontSize.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.fontSize.refreshOnShow(e, t)
    }, plugin: "fontSize"
  }), xt.DefineIcon("fontSize", {
    NAME: "text-height",
    SVG_KEY: "fontSize"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "forms.edit": "[_BUTTONS_]",
    "forms.update": "[_BUTTONS_][_TEXT_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    formEditButtons: ["inputStyle", "inputEdit"],
    formStyles: {"fr-rounded": "Rounded", "fr-large": "Large"},
    formMultipleStyles: !0,
    formUpdateButtons: ["inputBack", "|"]
  }), xt.PLUGINS.forms = function (i) {
    var s, l = i.$;

    function t(e) {
      i.selection.clear(), l(this).data("mousedown", !0)
    }

    function n(e) {
      l(this).data("mousedown") && (e.stopPropagation(), l(this).removeData("mousedown"), d(s = this)), e.preventDefault()
    }

    function r() {
      i.$el.find("input, textarea, button").removeData("mousedown")
    }

    function a() {
      l(this).removeData("mousedown")
    }

    function c() {
      return s || null
    }

    function d(e) {
      if (-1 == ["checkbox", "radio"].indexOf(e.type)) {
        var t = i.popups.get("forms.edit");
        t || (t = function o() {
          var e = "";
          0 < i.opts.formEditButtons.length && (e = '<div class="fr-buttons">'.concat(i.button.buildList(i.opts.formEditButtons), "</div>"));
          var t = {buttons: e}, n = i.popups.create("forms.edit", t);
          return i.$wp && i.events.$on(i.$wp, "scroll.link-edit", function () {
            c() && i.popups.isVisible("forms.edit") && d(c())
          }), n
        }());
        var n = l(s = e);
        i.popups.refresh("forms.edit"), i.popups.setContainer("forms.edit", i.$sc);
        var r = n.offset().left + n.outerWidth() / 2, a = n.offset().top + n.outerHeight();
        i.popups.show("forms.edit", r, a, n.outerHeight())
      }
    }

    function o() {
      var e = i.popups.get("forms.update"), t = c();
      if (t) {
        var n = l(t);
        n.is("button") ? e.find('input[type="text"][name="text"]').val(n.text()) : n.is("input[type=button]") || n.is("input[type=submit]") || n.is("input[type=reset]") ? e.find('input[type="text"][name="text"]').val(n.val()) : e.find('input[type="text"][name="text"]').val(n.attr("placeholder"))
      }
      e.find('input[type="text"][name="text"]').trigger("change")
    }

    function f() {
      s = null
    }

    function p(e) {
      if (e) return i.popups.onRefresh("forms.update", o), i.popups.onHide("forms.update", f), !0;
      var t = "";
      1 <= i.opts.formUpdateButtons.length && (t = '<div class="fr-buttons">'.concat(i.button.buildList(i.opts.formUpdateButtons), "</div>"));
      var n = 0, r = {
        buttons: t,
        text_layer: '<div class="fr-forms-text-layer fr-layer fr-active"> \n    <div class="fr-input-line"><input name="text" type="text" placeholder="Text" tabIndex=" '.concat(++n, ' "></div>\n    <div class="fr-action-buttons"><button class="fr-command fr-submit" data-cmd="updateInput" href="#" tabIndex="').concat(2, '" type="button">').concat(i.language.translate("Update"), "</button></div></div>")
      };
      return i.popups.create("forms.update", r)
    }

    return {
      _init: function u() {
        !function e() {
          i.events.$on(i.$el, i._mousedown, "input, textarea, button", t), i.events.$on(i.$el, i._mouseup, "input, textarea, button", n), i.events.$on(i.$el, "touchmove", "input, textarea, button", a), i.events.$on(i.$el, i._mouseup, r), i.events.$on(i.$win, i._mouseup, r), p(!0)
        }(), i.events.$on(i.$el, "submit", "form", function (e) {
          return e.preventDefault(), !1
        })
      }, updateInput: function h() {
        var e = i.popups.get("forms.update"), t = c();
        if (t) {
          var n = l(t), r = e.find('input[type="text"][name="text"]').val() || "";
          n.is("button") ? r.length ? n.text(r) : n.text("\u200b") : -1 != ["button", "submit", "reset"].indexOf(t.type) ? n.attr("value", r) : n.attr("placeholder", r), i.popups.hide("forms.update"), d(t)
        }
      }, getInput: c, applyStyle: function g(e, t, n) {
        void 0 === t && (t = i.opts.formStyles), void 0 === n && (n = i.opts.formMultipleStyles);
        var r = c();
        if (!r) return !1;
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), l(r).removeClass(a.join(" "))
        }
        l(r).toggleClass(e)
      }, showUpdatePopup: function m() {
        var e = c();
        if (e) {
          var t = l(e), n = i.popups.get("forms.update");
          n || (n = p()), i.popups.isVisible("forms.update") || i.popups.refresh("forms.update"), i.popups.setContainer("forms.update", i.$sc);
          var r = t.offset().left + t.outerWidth() / 2, a = t.offset().top + t.outerHeight();
          i.popups.show("forms.update", r, a, t.outerHeight())
        }
      }, showEditPopup: d, back: function v() {
        i.events.disableBlur(), i.selection.restore(), i.events.enableBlur();
        var e = c();
        e && i.$wp && ("BUTTON" === e.tagName && i.selection.restore(), d(e))
      }
    }
  },xt.RegisterCommand("updateInput", {
    undo: !1, focus: !1, title: "Update", callback: function () {
      this.forms.updateInput()
    }
  }),xt.DefineIcon("inputStyle", {
    NAME: "magic",
    SVG_KEY: "inlineStyle"
  }),xt.RegisterCommand("inputStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list">', t = this.opts.formStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li><a class="fr-command" tabIndex="-1" data-cmd="inputStyle" data-param1="'.concat(n, '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      var n = this.forms.getInput();
      n && (this.forms.applyStyle(t), this.forms.showEditPopup(n))
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.forms.getInput();
      if (r) {
        var a = n(r);
        t.find(".fr-command").each(function () {
          var e = n(this).data("param1");
          n(this).toggleClass("fr-active", a.hasClass(e))
        })
      }
    }
  }),xt.DefineIcon("inputEdit", {NAME: "edit", SVG_KEY: "edit"}),xt.RegisterCommand("inputEdit", {
    title: "Edit Button",
    undo: !1,
    refreshAfterCallback: !1,
    callback: function () {
      this.forms.showUpdatePopup()
    }
  }),xt.DefineIcon("inputBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("inputBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.forms.back()
    }
  }),xt.RegisterCommand("updateInput", {
    undo: !1, focus: !1, title: "Update", callback: function () {
      this.forms.updateInput()
    }
  }),xt.PLUGINS.fullscreen = function (a) {
    var t, n, r, o, i = a.$, s = function s() {
      return a.$box.hasClass("fr-fullscreen")
    };

    function l() {
      if (a.helpers.isIOS() && a.core.hasFocus()) return a.$el.blur(), setTimeout(d, 250), !1;
      t = a.helpers.scrollTop(), a.$box.toggleClass("fr-fullscreen"), i("body").first().toggleClass("fr-fullscreen"), a.helpers.isMobile() && (a.opts.toolbarBottom ? a.$tb[0].removeAttribute("style") : (a.$tb.data("parent", a.$tb.parent()), a.$box.prepend(a.$tb), a.$tb.data("sticky-dummy") && a.$tb.after(a.$tb.data("sticky-dummy")))), n = a.opts.height, r = a.opts.heightMax, o = a.opts.z_index, a.opts.height = a.o_win.innerHeight - (a.opts.toolbarInline ? 0 : a.$tb.outerHeight() + (a.$second_tb ? a.$second_tb.outerHeight() : 0)), a.opts.zIndex = 2147483641, a.opts.heightMax = null, a.size.refresh(), a.opts.toolbarInline && a.toolbar.showInline();
      for (var e = a.$box.parent(); !e.first().is("body");) e.addClass("fr-fullscreen-wrapper"), e = e.parent();
      a.opts.toolbarContainer && a.$box.prepend(a.$tb), a.events.trigger("charCounter.update"), a.events.trigger("codeView.update"), a.$win.trigger("scroll")
    }

    function c() {
      if (a.helpers.isIOS() && a.core.hasFocus()) return a.$el.blur(), setTimeout(d, 250), !1;
      a.$box.toggleClass("fr-fullscreen"), i("body").first().toggleClass("fr-fullscreen"), a.$tb.data("parent") && a.$tb.data("parent").prepend(a.$tb), a.$tb.data("sticky-dummy") && a.$tb.after(a.$tb.data("sticky-dummy")), a.opts.height = n, a.opts.heightMax = r, a.opts.zIndex = o, a.size.refresh(), i(a.o_win).scrollTop(t), a.opts.toolbarInline && a.toolbar.showInline(), a.events.trigger("charCounter.update"), a.opts.toolbarSticky && a.opts.toolbarStickyOffset && (a.opts.toolbarBottom ? a.$tb.css("bottom", a.opts.toolbarStickyOffset).data("bottom", a.opts.toolbarStickyOffset) : a.$tb.css("top", a.opts.toolbarStickyOffset).data("top", a.opts.toolbarStickyOffset));
      for (var e = a.$box.parent(); !e.first().is("body");) e.removeClass("fr-fullscreen-wrapper"), e = e.parent();
      a.opts.toolbarContainer && i(a.opts.toolbarContainer).append(a.$tb), i(a.o_win).trigger("scroll"), a.events.trigger("codeView.update")
    }

    function d() {
      s() ? c() : l(), f(a.$tb.find('.fr-command[data-cmd="fullscreen"]'));
      var e = a.$tb.find('.fr-command[data-cmd="moreText"]'), t = a.$tb.find('.fr-command[data-cmd="moreParagraph"]'),
        n = a.$tb.find('.fr-command[data-cmd="moreRich"]'), r = a.$tb.find('.fr-command[data-cmd="moreMisc"]');
      e.length && a.refresh.moreText(e), t.length && a.refresh.moreParagraph(t), n.length && a.refresh.moreRich(n), r.length && a.refresh.moreMisc(r)
    }

    function f(e) {
      var t = s();
      e.toggleClass("fr-active", t).attr("aria-pressed", t), e.find("> *").not(".fr-sr-only").replaceWith(t ? a.icon.create("fullscreenCompress") : a.icon.create("fullscreen"))
    }

    return {
      _init: function e() {
        if (!a.$wp) return !1;
        a.events.$on(i(a.o_win), "resize", function () {
          s() && (c(), l())
        }), a.events.on("toolbar.hide", function () {
          if (s() && a.helpers.isMobile()) return !1
        }), a.events.on("position.refresh", function () {
          if (a.helpers.isIOS()) return !s()
        }), a.events.on("destroy", function () {
          s() && c()
        }, !0)
      }, toggle: d, refresh: f, isActive: s
    }
  },xt.RegisterCommand("fullscreen", {
    title: "Fullscreen",
    undo: !1,
    focus: !1,
    accessibilityFocus: !0,
    forcedRefresh: !0,
    toggle: !0,
    callback: function () {
      this.fullscreen.toggle()
    },
    refresh: function (e) {
      this.fullscreen.refresh(e)
    },
    plugin: "fullscreen"
  }),xt.DefineIcon("fullscreen", {
    NAME: "expand",
    SVG_KEY: "fullscreen"
  }),xt.DefineIcon("fullscreenCompress", {NAME: "compress", SVG_KEY: "exitFullscreen"}),Object.assign(xt.DEFAULTS, {
    helpSets: [{title: "Inline Editor", commands: [{val: "OSkeyE", desc: "Show the editor"}]}, {
      title: "Common actions",
      commands: [{val: "OSkeyC", desc: "Copy"}, {val: "OSkeyX", desc: "Cut"}, {
        val: "OSkeyV",
        desc: "Paste"
      }, {val: "OSkeyZ", desc: "Undo"}, {val: "OSkeyShift+Z", desc: "Redo"}, {
        val: "OSkeyK",
        desc: "Insert Link"
      }, {val: "OSkeyP", desc: "Insert Image"}]
    }, {
      title: "Basic Formatting",
      commands: [{val: "OSkeyA", desc: "Select All"}, {val: "OSkeyB", desc: "Bold"}, {
        val: "OSkeyI",
        desc: "Italic"
      }, {val: "OSkeyU", desc: "Underline"}, {val: "OSkeyS", desc: "Strikethrough"}, {
        val: "OSkey]",
        desc: "Increase Indent"
      }, {val: "OSkey[", desc: "Decrease Indent"}]
    }, {
      title: "Quote",
      commands: [{val: "OSkey'", desc: "Increase quote level"}, {val: "OSkeyShift+'", desc: "Decrease quote level"}]
    }, {
      title: "Image / Video",
      commands: [{val: "OSkey+", desc: "Resize larger"}, {val: "OSkey-", desc: "Resize smaller"}]
    }, {
      title: "Table",
      commands: [{val: "Alt+Space", desc: "Select table cell"}, {
        val: "Shift+Left/Right arrow",
        desc: "Extend selection one cell"
      }, {val: "Shift+Up/Down arrow", desc: "Extend selection one row"}]
    }, {
      title: "Navigation",
      commands: [{val: "OSkey/", desc: "Shortcuts"}, {val: "Alt+F10", desc: "Focus popup / toolbar"}, {
        val: "Esc",
        desc: "Return focus to previous position"
      }]
    }]
  }),xt.PLUGINS.help = function (s) {
    var r, a = s.$, o = "help";
    return {
      _init: function e() {
      }, show: function l() {
        if (!r) {
          var e = "<h4>".concat(s.language.translate("Shortcuts"), "</h4>"), t = function i() {
            for (var e = '<div class="fr-help-modal">', t = 0; t < s.opts.helpSets.length; t++) {
              var n = s.opts.helpSets[t], r = "<table>";
              r += "<thead><tr><th>".concat(s.language.translate(n.title), "</th></tr></thead>"), r += "<tbody>";
              for (var a = 0; a < n.commands.length; a++) {
                var o = n.commands[a];
                r += "<tr>", r += "<td>".concat(s.language.translate(o.desc), "</td>"), r += "<td>".concat(o.val.replace("OSkey", s.helpers.isMac() ? "&#8984;" : "Ctrl+"), "</td>"), r += "</tr>"
              }
              e += r += "</tbody></table>"
            }
            return e += "</div>"
          }(), n = s.modals.create(o, e, t);
          r = n.$modal, s.events.$on(a(s.o_win), "resize", function () {
            s.modals.resize(o)
          })
        }
        s.modals.show(o), s.modals.resize(o)
      }, hide: function t() {
        s.modals.hide(o)
      }
    }
  },xt.DefineIcon("help", {
    NAME: "question",
    SVG_KEY: "help"
  }),xt.RegisterShortcut(xt.KEYCODE.SLASH, "help", null, "/"),xt.RegisterCommand("help", {
    title: "Help",
    icon: "help",
    undo: !1,
    focus: !1,
    modal: !0,
    callback: function () {
      this.help.show()
    },
    plugin: "help",
    showOnMobile: !1
  }),Object.assign(xt.POPUP_TEMPLATES, {
    "image.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]",
    "image.edit": "[_BUTTONS_]",
    "image.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "image.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }),Object.assign(xt.DEFAULTS, {
    imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
    imageEditButtons: ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"],
    imageAltButtons: ["imageBack", "|"],
    imageSizeButtons: ["imageBack", "|"],
    imageUpload: !0,
    imageUploadURL: null,
    imageCORSProxy: "https://cors-anywhere.froala.com",
    imageUploadRemoteUrls: !0,
    imageUploadParam: "file",
    imageUploadParams: {},
    imageUploadToS3: !1,
    imageUploadToAzure: !1,
    imageUploadMethod: "POST",
    imageMaxSize: 10485760,
    imageAllowedTypes: ["jpeg", "jpg", "png", "gif", "webp"],
    imageResize: !0,
    imageResizeWithPercent: !1,
    imageRoundPercent: !1,
    imageDefaultWidth: 300,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageSplitHTML: !1,
    imageStyles: {"fr-rounded": "Rounded", "fr-bordered": "Bordered", "fr-shadow": "Shadow"},
    imageMove: !0,
    imageMultipleStyles: !0,
    imageTextNear: !0,
    imagePaste: !0,
    imagePasteProcess: !1,
    imageMinWidth: 16,
    imageOutputSize: !1,
    imageDefaultMargin: 5,
    imageAddNewLine: !1
  }),xt.PLUGINS.image = function (L) {
    var _, l, c, d, s, n, w = L.$, A = "https://i.froala.com/upload", t = !1, r = 1, p = 2, u = 3, h = 4, T = 5, S = 6,
      a = {};

    function f() {
      var e = L.popups.get("image.insert").find(".fr-image-by-url-layer input");
      e.val(""), _ && e.val(_.attr("src")), e.trigger("change")
    }

    function o() {
      var e = L.popups.get("image.edit");
      if (e || (e = M()), e) {
        var t = ye();
        Le() && (t = t.find(".fr-img-wrap")), L.popups.setContainer("image.edit", L.$sc), L.popups.refresh("image.edit");
        var n = t.offset().left + t.outerWidth() / 2, r = (function a(e) {
          for (var t = 0; e;) {
            if ("BODY" == e.tagName) {
              var n = e.scrollTop || document.documentElement.scrollTop;
              t += e.offsetTop - n + e.clientTop
            } else t += e.offsetTop - e.scrollTop + e.clientTop;
            e = e.offsetParent
          }
          return {y: t}
        }(_[0]).y + t.outerHeight()) / 5;
        t.offset().top < 0 || !L.opts.height || L.helpers.isMobile() || L.opts.iframe ? r = t.offset().top + t.outerHeight() : Le() && L.opts.height && (r = t.offset().top + t.outerHeight() / 4), _.hasClass("fr-uploading") ? O() : L.popups.show("image.edit", n, r, t.outerHeight(), !0)
      }
    }

    function g() {
      N()
    }

    function i(e) {
      0 < e.parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first());
      var t = e.hasClass("fr-dib") ? "block" : e.hasClass("fr-dii") ? "inline" : null,
        n = e.hasClass("fr-fil") ? "left" : e.hasClass("fr-fir") ? "right" : me(e);
      ge(e, t, n), e.removeClass("fr-dib fr-dii fr-fir fr-fil")
    }

    function m() {
      for (var e, t = "IMG" == L.el.tagName ? [L.el] : L.el.querySelectorAll("img"), n = 0; n < t.length; n++) {
        var r = w(t[n]);
        !L.opts.htmlUntouched && L.opts.useClasses ? ((L.opts.imageDefaultAlign || L.opts.imageDefaultDisplay) && (0 < (e = r).parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first()), e.hasClass("fr-dii") || e.hasClass("fr-dib") || (e.addClass("fr-fi".concat(me(e)[0])), e.addClass("fr-di".concat(ve(e)[0])), e.css("margin", ""), e.css("float", ""), e.css("display", ""), e.css("z-index", ""), e.css("position", ""), e.css("overflow", ""), e.css("vertical-align", ""))), L.opts.imageTextNear || (0 < r.parents(".fr-img-caption").length ? r.parents(".fr-img-caption").first().removeClass("fr-dii").addClass("fr-dib") : r.removeClass("fr-dii").addClass("fr-dib"))) : L.opts.htmlUntouched || L.opts.useClasses || (L.opts.imageDefaultAlign || L.opts.imageDefaultDisplay) && i(r), L.opts.iframe && r.on("load", L.size.syncIframe)
      }
    }

    function v(e) {
      void 0 === e && (e = !0);
      var t, n = Array.prototype.slice.call(L.el.querySelectorAll("img")), r = [];
      for (t = 0; t < n.length; t++) if (r.push(n[t].getAttribute("src")), w(n[t]).toggleClass("fr-draggable", L.opts.imageMove), "" === n[t].getAttribute("class") && n[t].removeAttribute("class"), "" === n[t].getAttribute("style") && n[t].removeAttribute("style"), n[t].parentNode && n[t].parentNode.parentNode && L.node.hasClass(n[t].parentNode.parentNode, "fr-img-caption")) {
        var a = n[t].parentNode.parentNode;
        L.browser.mozilla || a.setAttribute("contenteditable", !1), a.setAttribute("draggable", !1), a.classList.add("fr-draggable");
        var o = n[t].nextSibling;
        o && !L.browser.mozilla && o.setAttribute("contenteditable", !0)
      }
      if (s) for (t = 0; t < s.length; t++) r.indexOf(s[t].getAttribute("src")) < 0 && L.events.trigger("image.removed", [w(s[t])]);
      if (s && e) {
        var i = [];
        for (t = 0; t < s.length; t++) i.push(s[t].getAttribute("src"));
        for (t = 0; t < n.length; t++) i.indexOf(n[t].getAttribute("src")) < 0 && L.events.trigger("image.loaded", [w(n[t])])
      }
      s = n
    }

    function k() {
      if (l || function i() {
        var e;
        L.shared.$image_resizer ? (l = L.shared.$image_resizer, d = L.shared.$img_overlay, L.events.on("destroy", function () {
          w("body").first().append(l.removeClass("fr-active"))
        }, !0)) : (L.shared.$image_resizer = w(document.createElement("div")).attr("class", "fr-image-resizer"), l = L.shared.$image_resizer, L.events.$on(l, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), L.opts.imageResize && (l.append(b("nw") + b("ne") + b("sw") + b("se")), L.shared.$img_overlay = w(document.createElement("div")).attr("class", "fr-image-overlay"), d = L.shared.$img_overlay, e = l.get(0).ownerDocument, w(e).find("body").first().append(d)));
        L.events.on("shared.destroy", function () {
          l.html("").removeData().remove(), l = null, L.opts.imageResize && (d.remove(), d = null)
        }, !0), L.helpers.isMobile() || L.events.$on(w(L.o_win), "resize", function () {
          _ && !_.hasClass("fr-uploading") ? fe(!0) : _ && (k(), be(), O(!1))
        });
        if (L.opts.imageResize) {
          e = l.get(0).ownerDocument, L.events.$on(l, L._mousedown, ".fr-handler", E), L.events.$on(w(e), L._mousemove, y), L.events.$on(w(e.defaultView || e.parentWindow), L._mouseup, x), L.events.$on(d, "mouseleave", x);
          var r = 1, a = null, o = 0;
          L.events.on("keydown", function (e) {
            if (_) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || L.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = ee.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || L.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey ? r = ee.call(this, e, 2, -1, r) : L.keys.ctrlKey(e) || n != xt.KEYCODE.ENTER || (_.before("<br>"), B(_)), a = n, o = e.timeStamp
            }
          }, !0), L.events.on("keyup", function () {
            r = 1
          })
        }
      }(), !_) return !1;
      var e = L.$wp || L.$sc;
      e.append(l), l.data("instance", L);
      var t = e.scrollTop() - ("static" != e.css("position") ? e.offset().top : 0),
        n = e.scrollLeft() - ("static" != e.css("position") ? e.offset().left : 0);
      n -= L.helpers.getPX(e.css("border-left-width")), t -= L.helpers.getPX(e.css("border-top-width")), L.$el.is("img") && L.$sc.is("body") && (n = t = 0);
      var r = ye();
      Le() && (r = r.find(".fr-img-wrap"));
      var a = 0, o = 0;
      L.opts.iframe && (a = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")), o = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"))), l.css("top", (L.opts.iframe ? r.offset().top + a : r.offset().top + t) - 1).css("left", (L.opts.iframe ? r.offset().left + o : r.offset().left + n) - 1).css("width", r.get(0).getBoundingClientRect().width).css("height", r.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function b(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function C(e) {
      Le() ? _.parents(".fr-img-caption").css("width", e) : _.css("width", e)
    }

    function E(e) {
      if (!L.core.sameInstance(l)) return !0;
      if (e.preventDefault(), e.stopPropagation(), L.$el.find("img.fr-error").left) return !1;
      L.undo.canDo() || L.undo.saveStep();
      var t = e.pageX || e.originalEvent.touches[0].pageX;
      if ("mousedown" == e.type) {
        var n = L.$oel.get(0).ownerDocument, r = n.defaultView || n.parentWindow, a = !1;
        try {
          a = r.location != r.parent.location && !(r.$ && r.$.FE)
        } catch (s) {
        }
        a && r.frameElement && (t += L.helpers.getPX(w(r.frameElement).offset().left) + r.frameElement.clientLeft)
      }
      (c = w(this)).data("start-x", t), c.data("start-width", _.width()), c.data("start-height", _.height());
      var o = _.width();
      if (L.opts.imageResizeWithPercent) {
        var i = _.parentsUntil(L.$el, L.html.blockTagsQuery()).get(0) || L.el;
        o = (o / w(i).outerWidth() * 100).toFixed(2) + "%"
      }
      C(o), d.show(), L.popups.hideAll(), he()
    }

    function y(e) {
      if (!L.core.sameInstance(l)) return !0;
      var t;
      if (c && _) {
        if (e.preventDefault(), L.$el.find("img.fr-error").left) return !1;
        var n = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);
        if (!n) return !1;
        var r = n - c.data("start-x"), a = c.data("start-width");
        if ((c.hasClass("fr-hnw") || c.hasClass("fr-hsw")) && (r = 0 - r), L.opts.imageResizeWithPercent) {
          var o = _.parentsUntil(L.$el, L.html.blockTagsQuery()).get(0) || L.el;
          a = ((a + r) / w(o).outerWidth() * 100).toFixed(2), L.opts.imageRoundPercent && (a = Math.round(a)), C("".concat(a, "%")), (t = Le() ? (L.helpers.getPX(_.parents(".fr-img-caption").css("width")) / w(o).outerWidth() * 100).toFixed(2) : (L.helpers.getPX(_.css("width")) / w(o).outerWidth() * 100).toFixed(2)) === a || L.opts.imageRoundPercent || C("".concat(t, "%")), _.css("height", "").removeAttr("height")
        } else a + r >= L.opts.imageMinWidth && (C(a + r), t = Le() ? L.helpers.getPX(_.parents(".fr-img-caption").css("width")) : L.helpers.getPX(_.css("width"))), t !== a + r && C(t), ((_.attr("style") || "").match(/(^height:)|(; *height:)/) || _.attr("height")) && (_.css("height", c.data("start-height") * _.width() / c.data("start-width")), _.removeAttr("height"));
        k(), L.events.trigger("image.resize", [Ee()])
      }
    }

    function x(e) {
      if (!L.core.sameInstance(l)) return !0;
      if (c && _) {
        if (e && e.stopPropagation(), L.$el.find("img.fr-error").left) return !1;
        c = null, d.hide(), k(), o(), L.undo.saveStep(), L.events.trigger("image.resizeEnd", [Ee()])
      } else l.removeClass("fr-active")
    }

    function R(e, t, n) {
      L.edit.on(), _ && _.addClass("fr-error"), a[e] ? D(L.language.translate(a[e])) : D(L.language.translate("Something went wrong. Please try again.")), !_ && n && te(n), L.events.trigger("image.error", [{
        code: e,
        message: a[e]
      }, t, n])
    }

    function M(e) {
      if (e) return L.$wp && L.events.$on(L.$wp, "scroll.image-edit", function () {
        _ && L.popups.isVisible("image.edit") && (L.events.disableBlur(), o())
      }), !0;
      var t = "";
      if (0 < L.opts.imageEditButtons.length) {
        var n = {buttons: t += '<div class="fr-buttons">\n        '.concat(L.button.buildList(L.opts.imageEditButtons), "\n        </div>")};
        return L.popups.create("image.edit", n)
      }
      return !1
    }

    function O(e) {
      var t = L.popups.get("image.insert");
      if (t || (t = Y()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), _) {
        var n = ye();
        L.popups.setContainer("image.insert", L.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        L.popups.show("image.insert", r, a, n.outerHeight())
      }
      void 0 === e && I(L.language.translate("Uploading"), 0)
    }

    function N(e) {
      var t = L.popups.get("image.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || L.$el.find("img.fr-error").length)) {
        if (L.events.focus(), L.$el.find("img.fr-error").length && (L.$el.find("img.fr-error").remove(), L.undo.saveStep(), L.undo.run(), L.undo.dropRedo()), !L.$wp && _) {
          var n = _;
          fe(!0), L.selection.setAfter(n.get(0)), L.selection.restore()
        }
        L.popups.hide("image.insert")
      }
    }

    function I(e, t) {
      var n = L.popups.get("image.insert");
      if (n) {
        var r = n.find(".fr-image-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function D(e) {
      O();
      var t = L.popups.get("image.insert").find(".fr-image-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), L.events.disableBlur(), n.focus()
    }

    function B(e) {
      de.call(e.get(0))
    }

    function H() {
      var e = w(this);
      L.popups.hide("image.insert"), e.removeClass("fr-uploading"), e.next().is("br") && e.next().remove(), B(e), L.events.trigger("image.loaded", [e])
    }

    function $(i, e, s, l, c) {
      l && "string" == typeof l && (l = L.$(l)), L.edit.off(), I(L.language.translate("Loading image")), e && (i = L.helpers.sanitizeURL(i));
      var t = new Image;
      t.onload = function () {
        var e, t;
        if (l) {
          L.undo.canDo() || l.hasClass("fr-uploading") || L.undo.saveStep();
          var n = l.data("fr-old-src");
          l.data("fr-image-pasted") && (n = null), L.$wp ? ((e = l.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"), n && l.attr("src", n), !L.opts.trackChangesEnabled || l[0].parentNode && "SPAN" === l[0].parentNode.tagName && l[0].parentNode.hasAttribute("data-tracking") || L.track_changes.replaceSpecialItem(l), l.replaceWith(e)) : e = l;
          for (var r = e.get(0).attributes, a = 0; a < r.length; a++) {
            var o = r[a];
            0 === o.nodeName.indexOf("data-") ? e.removeAttr(o.nodeName) : s && s.hasOwnProperty(o.nodeName) && e.removeAttr(o.nodeName)
          }
          if (void 0 !== s) for (t in s) s.hasOwnProperty(t) && "link" != t && e.attr("".concat(t), s[t]);
          e.on("load", H), e.attr("src", i), L.edit.on(), v(!1), L.undo.saveStep(), L.events.disableBlur(), L.$el.blur(), L.events.trigger(n ? "image.replaced" : "image.inserted", [e, c])
        } else (e = z(i, s, H)) && (v(!1), L.undo.saveStep(), L.events.disableBlur(), L.$el.blur(), L.events.trigger("image.inserted", [e, c]))
      }, t.onerror = function () {
        R(r)
      }, O(L.language.translate("Loading image")), t.src = i
    }

    function F(e, t, n) {
      I(L.language.translate("Loading image"));
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (L.opts.imageUploadToS3 || L.opts.imageUploadToAzure) if (201 == r) {
          var s;
          if (L.opts.imageUploadToAzure) {
            if (!1 === L.events.trigger("image.uploadedToAzure", [this.responseURL, n, a], !0)) return L.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = w(e).find("Location").text(), n = w(e).find("Key").text();
              return !1 === L.events.trigger("image.uploadedToS3", [t, n, e], !0) ? (L.edit.on(), !1) : t
            } catch (r) {
              return R(h, e), !1
            }
          }(o);
          s && $(s, !1, [], e, a || o)
        } else R(h, a || o, e); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === L.events.trigger("image.uploaded", [e], !0)) return L.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (R(p, e), !1)
            } catch (n) {
              return R(h, e), !1
            }
          }(i);
          l && $(l.link, !1, l, e, a || i)
        } else R(u, a || i, e)
      } catch (f) {
        R(h, a || i, e)
      }
    }

    function P() {
      R(h, this.response || this.responseText || this.responseXML)
    }

    function U(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        I(L.language.translate("Uploading"), t)
      }
    }

    function z(e, t, n) {
      var r, a = w(document.createElement("img")).attr("src", e);
      if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (" data-".concat(r, '="').concat(t[r], '"'), a.attr("".concat(r), t[r]));
      var o = L.opts.imageDefaultWidth;
      o && "auto" != o && (o = L.opts.imageResizeWithPercent ? "100%" : "".concat(o, "px")), a.attr("style", o ? "width: ".concat(o, ";") : ""), ge(a, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), a.on("load", n), a.on("error", n), L.edit.on(), L.events.focus(!0), L.selection.restore(), L.undo.saveStep(), L.opts.imageSplitHTML ? L.markers.split() : L.markers.insert(), L.html.wrap();
      var i = L.$el.find(".fr-marker");
      if (i.length) i.parent().is("hr") && i.parent().after(i), L.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a); else {
        if (L.opts.trackChangesEnabled) return N(!0), !1;
        L.$el.append(a)
      }
      return L.selection.clear(), a
    }

    function K() {
      L.edit.on(), N(!0)
    }

    function V(e, t) {
      if (void 0 !== e && 0 < e.length) {
        if (e && "image/svg+xml" == e[0].type) {
          var n = new FileReader;
          n.onload = function (e) {
            var t = e.target.result;
            L.image.insert(t, null, null, L.image.get())
          }, n.readAsDataURL(e[0])
        }
        if (!1 === L.events.trigger("image.beforeUpload", [e, t])) return !1;
        var r, a = e[0];
        if (!(null !== L.opts.imageUploadURL && L.opts.imageUploadURL != A || L.opts.imageUploadToS3 || L.opts.imageUploadToAzure)) return function E(a, o) {
          var i = new FileReader;
          i.onload = function () {
            var e = i.result;
            if (i.result.indexOf("svg+xml") < 0) {
              for (var t = atob(i.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
              e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: a.type})), o && o.data("fr-old-src", o.attr("src")), L.image.insert(e, !1, null, o)
            }
          }, O(), i.readAsDataURL(a)
        }(a, t || _), !1;
        if (a.name || (a.name = (new Date).getTime() + "." + (a.type || "image/jpeg").replace(/image\//g, "")), a.size > L.opts.imageMaxSize) return R(T), !1;
        if (L.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g, "")) < 0) return R(S), !1;
        if (L.drag_support.formdata && (r = L.drag_support.formdata ? new FormData : null), r) {
          var o;
          if (!1 !== L.opts.imageUploadToS3) for (o in r.append("key", L.opts.imageUploadToS3.keyStart + (new Date).getTime() + "-" + (a.name || "untitled")), r.append("success_action_status", "201"), r.append("X-Requested-With", "xhr"), r.append("Content-Type", a.type), L.opts.imageUploadToS3.params) L.opts.imageUploadToS3.params.hasOwnProperty(o) && r.append(o, L.opts.imageUploadToS3.params[o]);
          for (o in L.opts.imageUploadParams) L.opts.imageUploadParams.hasOwnProperty(o) && r.append(o, L.opts.imageUploadParams[o]);
          r.append(L.opts.imageUploadParam, a, a.name);
          var i, s, l = L.opts.imageUploadURL, c = L.opts.imageUploadMethod;
          L.opts.imageUploadToS3 && (l = L.opts.imageUploadToS3.uploadURL ? L.opts.imageUploadToS3.uploadURL : "https://".concat(L.opts.imageUploadToS3.region, ".amazonaws.com/").concat(L.opts.imageUploadToS3.bucket)), L.opts.imageUploadToAzure && (i = l = L.opts.imageUploadToAzure.uploadURL ? "".concat(L.opts.imageUploadToAzure.uploadURL, "/").concat(a.name) : encodeURI("https://".concat(L.opts.imageUploadToAzure.account, ".blob.core.windows.net/").concat(L.opts.imageUploadToAzure.container, "/").concat(a.name)), L.opts.imageUploadToAzure.SASToken && (l += L.opts.imageUploadToAzure.SASToken), c = "PUT");
          var d = L.core.getXHR(l, c);
          if (L.opts.imageUploadToAzure) {
            var f = (new Date).toUTCString();
            if (!L.opts.imageUploadToAzure.SASToken && L.opts.imageUploadToAzure.accessKey) {
              var p = L.opts.imageUploadToAzure.account, u = L.opts.imageUploadToAzure.container;
              if (L.opts.imageUploadToAzure.uploadURL) {
                var h = L.opts.imageUploadToAzure.uploadURL.split("/");
                u = h.pop(), p = h.pop().split(".")[0]
              }
              var g = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(f, "\nx-ms-version:2019-07-07"),
                m = encodeURI("/" + p + "/" + u + "/" + a.name),
                v = c + "\n\n\n" + a.size + "\n\n" + a.type + "\n\n\n\n\n\n\n" + g + "\n" + m,
                b = L.cryptoJSPlugin.cryptoJS.HmacSHA256(v, L.cryptoJSPlugin.cryptoJS.enc.Base64.parse(L.opts.imageUploadToAzure.accessKey)).toString(L.cryptoJSPlugin.cryptoJS.enc.Base64),
                C = "SharedKey " + p + ":" + b;
              s = b, d.setRequestHeader("Authorization", C)
            }
            for (o in d.setRequestHeader("x-ms-version", "2019-07-07"), d.setRequestHeader("x-ms-date", f), d.setRequestHeader("Content-Type", a.type), d.setRequestHeader("x-ms-blob-type", "BlockBlob"), L.opts.imageUploadParams) L.opts.imageUploadParams.hasOwnProperty(o) && d.setRequestHeader(o, L.opts.imageUploadParams[o]);
            for (o in L.opts.imageUploadToAzure.params) L.opts.imageUploadToAzure.params.hasOwnProperty(o) && d.setRequestHeader(o, L.opts.imageUploadToAzure.params[o])
          }
          !function y(t, n, r, a, o, i) {
            function s() {
              var e = w(this);
              e.off("load"), e.addClass("fr-uploading"), e.next().is("br") && e.next().remove(), L.placeholder.refresh(), B(e), k(), O(), L.edit.off(), t.onload = function () {
                F.call(t, e, o, i)
              }, t.onerror = P, t.upload.onprogress = U, t.onabort = K, w(e.off("abortUpload")).on("abortUpload", function () {
                4 != t.readyState && (t.abort(), a ? (a.attr("src", a.data("fr-old-src")), a.removeClass("fr-uploading")) : e.remove(), fe(!0))
              }), t.send(L.opts.imageUploadToAzure ? r : n)
            }

            var l = new FileReader;
            l.onload = function () {
              var e = l.result;
              if (l.result.indexOf("svg+xml") < 0) {
                for (var t = atob(l.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
                e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: "image/jpeg"}))
              }
              a ? (a.on("load", s), a.on("error", function () {
                s(), w(this).off("error")
              }), L.edit.on(), L.undo.saveStep(), a.data("fr-old-src", a.attr("src")), a.attr("src", e)) : z(e, null, s)
            }, l.readAsDataURL(r)
          }(d, r, a, t || _, i, s)
        }
      }
    }

    function W(e) {
      if (e.is("img") && 0 < e.parents(".fr-img-caption").length) return e.parents(".fr-img-caption")
    }

    function G(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && n.type && -1 !== n.type.indexOf("image") && 0 <= L.opts.imageAllowedTypes.indexOf(n.type.replace(/image\//g, ""))) {
          if (!L.opts.imageUpload) return e.preventDefault(), e.stopPropagation(), !1;
          L.markers.remove(), L.markers.insertAtPoint(e.originalEvent), L.$el.find(".fr-marker").replaceWith(xt.MARKERS), 0 === L.$el.find(".fr-marker").length && L.selection.setAtEnd(L.el), L.popups.hideAll();
          var r = L.popups.get("image.insert");
          r || (r = Y()), L.popups.setContainer("image.insert", L.$sc);
          var a = e.originalEvent.pageX, o = e.originalEvent.pageY;
          if (L.opts.iframe) {
            var i = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
              s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
            o += L.$iframe.offset().top + i, a += L.$iframe.offset().left + s
          }
          return L.popups.show("image.insert", a, o), O(), 0 <= L.opts.imageAllowedTypes.indexOf(n.type.replace(/image\//g, "")) ? (fe(!0), V(t.files)) : R(S), e.preventDefault(), e.stopPropagation(), !1
        }
      }
    }

    function Y(e) {
      if (e) return L.popups.onRefresh("image.insert", f), L.popups.onHide("image.insert", g), !0;
      var t, n, r = "";
      L.opts.imageUpload || -1 === L.opts.imageInsertButtons.indexOf("imageUpload") || L.opts.imageInsertButtons.splice(L.opts.imageInsertButtons.indexOf("imageUpload"), 1);
      var a = L.button.buildList(L.opts.imageInsertButtons);
      "" !== a && (r = '<div class="fr-buttons fr-tabs">'.concat(a, "</div>"));
      var o = L.opts.imageInsertButtons.indexOf("imageUpload"), i = L.opts.imageInsertButtons.indexOf("imageByURL"),
        s = "";
      0 <= o && (t = " fr-active", 0 <= i && i < o && (t = ""), s = '<div class="fr-image-upload-layer'.concat(t, ' fr-layer" id="fr-image-upload-layer-').concat(L.id, '"><strong>').concat(L.language.translate("Drop image"), "</strong><br>(").concat(L.language.translate("or click"), ')<div class="fr-form"><input type="file" accept="image/').concat(L.opts.imageAllowedTypes.join(", image/").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-image-upload-layer-').concat(L.id, '" role="button"></div></div>'));
      var l = "";
      0 <= i && (t = " fr-active", 0 <= o && o < i && (t = ""), l = '<div class="fr-image-by-url-layer'.concat(t, ' fr-layer" id="fr-image-by-url-layer-').concat(L.id, '"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-').concat(L.id, '" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">').concat(L.language.translate("Insert"), "</button></div></div>"));
      var c = {
        buttons: r,
        upload_layer: s,
        by_url_layer: l,
        progress_bar: '<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>'
      };
      return 1 <= L.opts.imageInsertButtons.length && (n = L.popups.create("image.insert", c)), L.$wp && L.events.$on(L.$wp, "scroll", function () {
        _ && L.popups.isVisible("image.insert") && be()
      }), function d(r) {
        L.events.$on(r, "dragover dragenter", ".fr-image-upload-layer", function (e) {
          return w(this).addClass("fr-drop"), (L.browser.msie || L.browser.edge) && e.preventDefault(), !1
        }, !0), L.events.$on(r, "dragleave dragend", ".fr-image-upload-layer", function (e) {
          return w(this).removeClass("fr-drop"), (L.browser.msie || L.browser.edge) && e.preventDefault(), !1
        }, !0), L.events.$on(r, "drop", ".fr-image-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), w(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          if (t && t.files) {
            var n = r.data("instance") || L;
            n.events.disableBlur(), n.image.upload(t.files), n.events.enableBlur()
          }
        }, !0), L.helpers.isIOS() && L.events.$on(r, "touchstart", '.fr-image-upload-layer input[type="file"]', function () {
          w(this).trigger("click")
        }, !0), L.events.$on(r, "change", '.fr-image-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = r.data("instance") || L;
            e.events.disableBlur(), r.find("input:focus").blur(), e.events.enableBlur(), e.image.upload(this.files, _)
          }
          w(this).val("")
        }, !0)
      }(n), n
    }

    function j() {
      _ && L.popups.get("image.alt").find("input").val(_.attr("alt") || "").trigger("change")
    }

    function q() {
      var e = L.popups.get("image.alt");
      e || (e = Z()), N(), L.popups.refresh("image.alt"), L.popups.setContainer("image.alt", L.$sc);
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.alt", n, r, t.outerHeight(), !0)
    }

    function Z(e) {
      if (e) return L.popups.onRefresh("image.alt", j), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.imageAltButtons), "</div>"),
        alt_layer: '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(L.id, '"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(L.id, '" type="text" placeholder="').concat(L.language.translate("Alternative Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(L.language.translate("Update"), "</button></div></div>")
      }, n = L.popups.create("image.alt", t);
      return L.$wp && L.events.$on(L.$wp, "scroll.image-alt", function () {
        _ && L.popups.isVisible("image.alt") && q()
      }), n
    }

    function X() {
      var e = L.popups.get("image.size"), t = _.get(0).style.height ? _.get(0).style.height : "auto",
        n = _.get(0).style.width ? _.get(0).style.width : "auto";
      if (_) if (Le()) {
        var r = _.parent();
        r.get(0).style.width || (r = _.parent().parent()), e.find('input[name="width"]').val(n).trigger("change"), e.find('input[name="height"]').val(t).trigger("change")
      } else e.find('input[name="width"]').val(n).trigger("change"), e.find('input[name="height"]').val(t).trigger("change")
    }

    function Q() {
      var e = L.popups.get("image.size");
      e || (e = J()), N(), L.popups.refresh("image.size"), L.popups.setContainer("image.size", L.$sc);
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.size", n, r, t.outerHeight(), !0)
    }

    function J(e) {
      if (e) return L.popups.onRefresh("image.size", X), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.imageSizeButtons), "</div>"),
        size_layer: '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(L.id, '"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(L.id, '" type="text" name="width" placeholder="').concat(L.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(L.id, '" type="text" name="height" placeholder="').concat(L.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(L.language.translate("Update"), "</button></div></div>")
      }, n = L.popups.create("image.size", t);
      return L.$wp && L.events.$on(L.$wp, "scroll.image-size", function () {
        _ && L.popups.isVisible("image.size") && Q()
      }), n
    }

    function ee(e, t, n, r) {
      return e.pageX = t, E.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), y.call(this, e), x.call(this, e), ++r
    }

    function te(e) {
      if (e = e || ye(), L.opts.trackChangesEnabled && !L.helpers.isMobile() && (!e[0].parentNode || "SPAN" !== e[0].parentNode.tagName || !e[0].parentNode.hasAttribute("data-tracking"))) return L.track_changes.removeSpecialItem(e), L.popups.hideAll(), void fe(!0);
      e && !1 !== L.events.trigger("image.beforeRemove", [e]) && (L.popups.hideAll(), Ce(), fe(!0), L.undo.canDo() || L.undo.saveStep(), e.get(0) == L.el ? e.removeAttr("src") : (e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? (L.selection.setBefore(e.get(0).parentNode) || L.selection.setAfter(e.get(0).parentNode) || e.parent().after(xt.MARKERS), w(e.get(0).parentNode).remove()) : (L.selection.setBefore(e.get(0)) || L.selection.setAfter(e.get(0)) || e.after(xt.MARKERS), e.remove()), L.html.fillEmptyBlocks(), L.selection.restore()), L.undo.saveStep())
    }

    function ne(e) {
      var t = e.which;
      if (_ && (t == xt.KEYCODE.BACKSPACE || t == xt.KEYCODE.DELETE)) return e.preventDefault(), e.stopPropagation(), te(), !1;
      if (_ && t == xt.KEYCODE.ESC) {
        var n = _;
        return fe(!0), L.selection.setAfter(n.get(0)), L.selection.restore(), e.preventDefault(), !1
      }
      if (!_ || t != xt.KEYCODE.ARROW_LEFT && t != xt.KEYCODE.ARROW_RIGHT) return _ && t === xt.KEYCODE.TAB ? (e.preventDefault(), e.stopPropagation(), fe(!0), !1) : _ && t != xt.KEYCODE.F10 && !L.keys.isBrowserAction(e) ? (e.preventDefault(), e.stopPropagation(), !1) : void 0;
      var r = _.get(0);
      return fe(!0), t == xt.KEYCODE.ARROW_LEFT ? L.selection.setBefore(r) : L.selection.setAfter(r), L.selection.restore(), e.preventDefault(), !1
    }

    function re(e) {
      if (e && "IMG" == e.tagName) {
        if (L.node.hasClass(e, "fr-uploading") || L.node.hasClass(e, "fr-error") ? e.parentNode.removeChild(e) : L.node.hasClass(e, "fr-draggable") && e.classList.remove("fr-draggable"), e.parentNode && e.parentNode.parentNode && L.node.hasClass(e.parentNode.parentNode, "fr-img-caption")) {
          var t = e.parentNode.parentNode;
          t.removeAttribute("contenteditable"), t.removeAttribute("draggable"), t.classList.remove("fr-draggable");
          var n = e.nextSibling;
          n && n.removeAttribute("contenteditable")
        }
      } else if (e && e.nodeType == Node.ELEMENT_NODE) for (var r = e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"), a = 0; a < r.length; a++) re(r[a])
    }

    function ae(e) {
      if (!1 === L.events.trigger("image.beforePasteUpload", [e])) return !1;
      _ = w(e), k(), o(), be(), O(), _.on("load", function () {
        var t = [];
        k(), w(L.popups.get("image.insert").get(0)).find("div.fr-active.fr-error").length < 1 && O(), w(this).data("events").filter(function (e) {
          "load" === e[0] && t.push(e)
        }), t.length <= 1 && w(this).off("load")
      });
      for (var t = w(e).attr("src").split(","), n = atob(t[1]), r = [], a = 0; a < n.length; a++) r.push(n.charCodeAt(a));
      V([new Blob([new Uint8Array(r)], {type: t[0].replace(/data\:/g, "").replace(/;base64/g, "")})], _)
    }

    function oe() {
      L.opts.imagePaste ? L.$el.find("img[data-fr-image-pasted]").each(function (e, r) {
        if (L.opts.imagePasteProcess) {
          var t = L.opts.imageDefaultWidth;
          t && "auto" != t && (t += L.opts.imageResizeWithPercent ? "%" : "px"), w(r).css("width", t).removeClass("fr-dii fr-dib fr-fir fr-fil"), ge(w(r), L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign)
        }
        if (0 === r.src.indexOf("data:")) ae(r); else if (0 === r.src.indexOf("blob:") || 0 === r.src.indexOf("http") && L.opts.imageUploadRemoteUrls && L.opts.imageCORSProxy) {
          var n = new Image;
          n.crossOrigin = "Anonymous", n.onload = function () {
            var e, t = L.o_doc.createElement("CANVAS"), n = t.getContext("2d");
            t.height = this.naturalHeight, t.width = this.naturalWidth, n.drawImage(this, 0, 0), setTimeout(function () {
              ae(r)
            }, 0), e = 2e3 < this.naturalWidth || 1500 < this.naturalHeight ? "jpeg" : "png", r.src = t.toDataURL("image/".concat(e))
          }, n.src = (0 === r.src.indexOf("blob:") ? "" : "".concat(L.opts.imageCORSProxy, "/")) + r.src
        } else 0 !== r.src.indexOf("http") || 0 === r.src.indexOf("https://mail.google.com/mail") ? (L.selection.save(), w(r).remove(), L.selection.restore()) : w(r).removeAttr("data-fr-image-pasted")
      }) : L.$el.find("img[data-fr-image-pasted]").remove()
    }

    function ie(e) {
      var t = e.target.result, n = L.opts.imageDefaultWidth;
      n && "auto" != n && (n += L.opts.imageResizeWithPercent ? "%" : "px"), L.undo.saveStep(), L.html.insert('<img data-fr-image-pasted="true" src="'.concat(t, '"').concat(n ? ' style="width: '.concat(n, ';"') : "", ">"));
      var r = L.$el.find('img[data-fr-image-pasted="true"]');
      r && ge(r, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), L.events.trigger("paste.after")
    }

    function se(e, t) {
      var n = new FileReader;
      n.onload = function r(e) {
        var t = L.opts.imageDefaultWidth;
        t && "auto" != t && (t += L.opts.imageResizeWithPercent ? "%" : "px"), L.html.insert('<img data-fr-image-pasted="true" src="'.concat(e, '"').concat(t ? ' style="width: '.concat(t, ';"') : "", ">"));
        var n = L.$el.find('img[data-fr-image-pasted="true"]');
        n && ge(n, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), L.events.trigger("paste.after")
      }(t), n.readAsDataURL(e, t)
    }

    function le(e) {
      if (e && e.clipboardData && e.clipboardData.items) {
        var t = (e.clipboardData || window.clipboardData).getData("text/html") || "",
          n = (new DOMParser).parseFromString(t, "text/html").querySelector("img");
        if (n) {
          if (!n) return !1;
          var r = n.src, a = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) a = e.clipboardData.items[0].getAsFile(); else for (var o = 0; o < e.clipboardData.items.length && !(a = e.clipboardData.items[o].getAsFile()); o++) ;
          if (a) return se(a, r), !1
        } else {
          var i = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) i = e.clipboardData.items[0].getAsFile(); else for (var s = 0; s < e.clipboardData.items.length && !(i = e.clipboardData.items[s].getAsFile()); s++) ;
          if (i) return function l(e) {
            var t = new FileReader;
            t.onload = ie, t.readAsDataURL(e)
          }(i), !1
        }
      }
    }

    function ce(e) {
      return e = e.replace(/<img /gi, '<img data-fr-image-pasted="true" ')
    }

    function de(e) {
      if ("false" == w(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (e && "touchend" == e.type && n) return !0;
      if (e && L.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
      for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != L && xt.INSTANCES[t].events.trigger("image.hideResizer");
      L.toolbar.disable(), e && (e.stopPropagation(), e.preventDefault()), L.helpers.isMobile() && (L.events.disableBlur(), L.$el.blur(), L.events.enableBlur()), L.opts.iframe && L.size.syncIframe(), _ = w(this), Ce(), k(), o(), L.browser.msie ? (L.popups.areVisible() && L.events.disableBlur(), L.win.getSelection && (L.win.getSelection().removeAllRanges(), L.win.getSelection().addRange(L.doc.createRange()))) : L.selection.clear(), L.helpers.isIOS() && (L.events.disableBlur(), L.$el.blur()), L.button.bulkRefresh(), L.events.trigger("video.hideResizer")
    }

    function fe(e) {
      _ && (function t() {
        return pe
      }() || !0 === e) && (L.toolbar.enable(), l.removeClass("fr-active"), L.popups.hideAll(), _ = null, he(), c = null, d && d.hide())
    }

    a[r] = "Image cannot be loaded from the passed link.", a[p] = "No link in upload response.", a[u] = "Error during file upload.", a[h] = "Parsing response failed.", a[T] = "File is too large.", a[S] = "Image file type is invalid.", a[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.";
    var pe = !(a[8] = "Image file is corrupted.");

    function ue() {
      pe = !0
    }

    function he() {
      pe = !1
    }

    function ge(e, t, n) {
      !L.opts.htmlUntouched && L.opts.useClasses ? (e.removeClass("fr-fil fr-fir fr-dib fr-dii"), n && e.addClass("fr-fi".concat(n[0])), t && e.addClass("fr-di".concat(t[0]))) : "inline" == t ? (e.css({
        display: "inline-block",
        verticalAlign: "bottom",
        margin: L.opts.imageDefaultMargin
      }), "center" == n ? e.css({
        "float": "none",
        marginBottom: "",
        marginTop: "",
        maxWidth: "calc(100% - ".concat(2 * L.opts.imageDefaultMargin, "px)"),
        textAlign: "center"
      }) : "left" == n ? e.css({
        "float": "left",
        marginLeft: 0,
        maxWidth: "calc(100% - ".concat(L.opts.imageDefaultMargin, "px)"),
        textAlign: "left"
      }) : e.css({
        "float": "right",
        marginRight: 0,
        maxWidth: "calc(100% - ".concat(L.opts.imageDefaultMargin, "px)"),
        textAlign: "right"
      })) : "block" == t && (e.css({
        display: "block",
        "float": "none",
        verticalAlign: "top",
        margin: "".concat(L.opts.imageDefaultMargin, "px auto"),
        textAlign: "center"
      }), "left" == n ? e.css({marginLeft: 0, textAlign: "left"}) : "right" == n && e.css({
        marginRight: 0,
        textAlign: "right"
      }))
    }

    function me(e) {
      if (void 0 === e && (e = ye()), e) {
        if (e.hasClass("fr-fil")) return "left";
        if (e.hasClass("fr-fir")) return "right";
        if (e.hasClass("fr-dib") || e.hasClass("fr-dii")) return "center";
        var t = e.css("float");
        if (e.css("float", "none"), "block" == e.css("display")) {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), 0 === parseInt(e.css("margin-left"), 10)) return "left";
          if (0 === parseInt(e.css("margin-right"), 10)) return "right"
        } else {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), "left" == e.css("float")) return "left";
          if ("right" == e.css("float")) return "right"
        }
      }
      return "center"
    }

    function ve(e) {
      void 0 === e && (e = ye());
      var t = e.css("float");
      return e.css("float", "none"), "block" == e.css("display") ? (e.css("float", ""), e.css("float") != t && e.css("float", t), "block") : (e.css("float", ""), e.css("float") != t && e.css("float", t), "inline")
    }

    function be() {
      var e = L.popups.get("image.insert");
      e || (e = Y()), L.popups.isVisible("image.insert") || (N(), L.popups.refresh("image.insert"), L.popups.setContainer("image.insert", L.$sc));
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.insert", n, r, t.outerHeight(!0), !0)
    }

    function Ce() {
      if (_) {
        L.events.disableBlur(), L.selection.clear();
        var e = L.doc.createRange();
        e.selectNode(_.get(0)), L.browser.msie && e.collapse(!0), L.selection.get().addRange(e), L.events.enableBlur()
      }
    }

    function Ee() {
      return _
    }

    function ye() {
      return Le() ? _.parents(".fr-img-caption").first() : _
    }

    function Le() {
      return !!_ && 0 < _.parents(".fr-img-caption").length
    }

    function _e(e) {
      for (var t = document.createDocumentFragment(); e.firstChild;) {
        var n = e.removeChild(e.firstChild);
        t.appendChild(n)
      }
      e.parentNode.replaceChild(t, e)
    }

    return {
      _init: function we() {
        var r;
        (function e() {
          L.events.$on(L.$el, L._mousedown, "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == w(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            L.helpers.isMobile() || L.selection.clear(), t = !0, L.popups.areVisible() && L.events.disableBlur(), L.browser.msie && (L.events.disableBlur(), L.$el.attr("contenteditable", !1)), L.draggable || "touchstart" == e.type || e.preventDefault(), e.stopPropagation()
          }), L.events.$on(L.$el, L._mousedown, ".fr-img-caption .fr-inner", function (e) {
            L.core.hasFocus() || L.events.focus(), e.stopPropagation()
          }), L.events.$on(L.$el, "paste", ".fr-img-caption .fr-inner", function (e) {
            !0 === L.opts.toolbarInline && (L.toolbar.hide(), e.stopPropagation())
          }), L.events.$on(L.$el, L._mouseup, "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == w(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            t && (t = !1, e.stopPropagation(), L.browser.msie && (L.$el.attr("contenteditable", !0), L.events.enableBlur()))
          }), L.events.on("keyup", function (e) {
            if (e.shiftKey && "" === L.selection.text().replace(/\n/g, "") && L.keys.isArrow(e.which)) {
              var t = L.selection.element(), n = L.selection.endElement();
              t && "IMG" == t.tagName ? B(w(t)) : n && "IMG" == n.tagName && B(w(n))
            }
          }, !0), L.events.on("drop", G), L.events.on("element.beforeDrop", W), L.events.on("mousedown window.mousedown", ue), L.events.on("window.touchmove", he), L.events.on("mouseup window.mouseup", function () {
            if (_ && !L.helpers.isMobile()) return fe(), !1;
            he()
          }), L.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && fe()
          }), L.events.on("image.resizeEnd", function () {
            L.opts.iframe && L.size.syncIframe()
          }), L.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
            fe(!(t = !1))
          }), L.events.on("modals.hide", function () {
            _ && (Ce(), L.selection.clear())
          }), L.events.on("image.resizeEnd", function () {
            L.win.getSelection && B(_)
          }), L.opts.imageAddNewLine && L.events.on("image.inserted", function (e) {
            var t = e.get(0);
            for (t.nextSibling && "BR" === t.nextSibling.tagName && (t = t.nextSibling); t && !L.node.isElement(t);) t = L.node.isLastSibling(t) ? t.parentNode : null;
            L.node.isElement(t) && (L.opts.enter === xt.ENTER_BR ? e.after("<br>") : w(L.node.blockParent(e.get(0))).after("<".concat(L.html.defaultTag(), "><br></").concat(L.html.defaultTag(), ">")))
          })
        })(), "IMG" == L.el.tagName && L.$el.addClass("fr-view"), L.events.$on(L.$el, L.helpers.isMobile() && !L.helpers.isWindowsPhone() ? "touchend" : "click", "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', de), L.helpers.isMobile() && (L.events.$on(L.$el, "touchstart", "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function () {
          n = !1
        }), L.events.$on(L.$el, "touchmove", function () {
          n = !0
        })), L.$wp ? (L.events.on("window.keydown keydown", ne, !0), L.events.on("keyup", function (e) {
          if (_ && e.which == xt.KEYCODE.ENTER) return !1
        }, !0), L.events.$on(L.$el, "keydown", function () {
          var e = L.selection.element();
          (e.nodeType === Node.TEXT_NODE || "BR" == e.tagName && L.node.isLastSibling(e)) && (e = e.parentNode), L.node.hasClass(e, "fr-inner") || (L.node.hasClass(e, "fr-img-caption") || (e = w(e).parents(".fr-img-caption").get(0)), L.node.hasClass(e, "fr-img-caption") && (L.opts.trackChangesEnabled || w(e).after(xt.INVISIBLE_SPACE + xt.MARKERS), L.selection.restore()))
        })) : L.events.$on(L.$win, "keydown", ne), L.events.on("toolbar.esc", function () {
          if (_) {
            if (L.$wp) L.events.disableBlur(), L.events.focus(); else {
              var e = _;
              fe(!0), L.selection.setAfter(e.get(0)), L.selection.restore()
            }
            return !1
          }
        }, !0), L.events.on("toolbar.focusEditor", function () {
          if (_) return !1
        }, !0), L.events.on("window.cut window.copy", function (e) {
          if (_ && L.popups.isVisible("image.edit") && !L.popups.get("image.edit").find(":focus").length) {
            var t = ye();
            Le() ? (t.before(xt.START_MARKER), t.after(xt.END_MARKER), L.selection.restore(), L.paste.saveCopiedText(t.get(0).outerHTML, t.text())) : (Ce(), L.paste.saveCopiedText(_.get(0).outerHTML, _.attr("alt"))), "copy" == e.type ? setTimeout(function () {
              B(_)
            }) : (fe(!0), L.undo.saveStep(), setTimeout(function () {
              L.undo.saveStep()
            }, 0))
          }
        }, !0), L.browser.msie && L.events.on("keydown", function (e) {
          if (!L.selection.isCollapsed() || !_) return !0;
          var t = e.which;
          t == xt.KEYCODE.C && L.keys.ctrlKey(e) ? L.events.trigger("window.copy") : t == xt.KEYCODE.X && L.keys.ctrlKey(e) && L.events.trigger("window.cut")
        }), L.events.$on(w(L.o_win), "keydown", function (e) {
          var t = e.which;
          if (_ && t == xt.KEYCODE.BACKSPACE) return e.preventDefault(), !1
        }), L.events.$on(L.$win, "keydown", function (e) {
          var t = e.which;
          _ && _.hasClass("fr-uploading") && t == xt.KEYCODE.ESC && _.trigger("abortUpload")
        }), L.events.on("destroy", function () {
          _ && _.hasClass("fr-uploading") && _.trigger("abortUpload")
        }), L.events.on("paste.before", le), L.events.on("paste.beforeCleanup", ce), L.events.on("paste.after", oe), L.events.on("html.set", m), L.events.on("html.inserted", m), m(), L.events.on("destroy", function () {
          s = []
        }), L.events.on("html.processGet", re), L.opts.imageOutputSize && L.events.on("html.beforeGet", function () {
          r = L.el.querySelectorAll("img");
          for (var e = 0; e < r.length; e++) {
            var t = r[e].style.width || w(r[e]).width(), n = r[e].style.height || w(r[e]).height();
            t && r[e].setAttribute("width", "".concat(t).replace(/px/, "")), n && r[e].setAttribute("height", "".concat(n).replace(/px/, ""))
          }
        }), L.opts.iframe && L.events.on("image.loaded", L.size.syncIframe), L.$wp && (v(), L.events.on("contentChanged", v)), L.events.$on(w(L.o_win), "orientationchange.image", function () {
          setTimeout(function () {
            _ && B(_)
          }, 100)
        }), M(!0), Y(!0), J(!0), Z(!0), L.events.on("node.remove", function (e) {
          if ("IMG" == e.get(0).tagName) return te(e), !1
        })
      },
      showInsertPopup: function Ae() {
        var e = L.$tb.find('.fr-command[data-cmd="insertImage"]'), t = L.popups.get("image.insert");
        if (t || (t = Y()), N(), !t.hasClass("fr-active")) if (L.popups.refresh("image.insert"), L.popups.setContainer("image.insert", L.$tb), e.isVisible()) {
          var n = L.button.getPosition(e), r = n.left, a = n.top;
          L.popups.show("image.insert", r, a, e.outerHeight())
        } else L.position.forSelection(t), L.popups.show("image.insert")
      },
      showLayer: function Te(e) {
        var t, n, r = L.popups.get("image.insert");
        if (_ || L.opts.toolbarInline) {
          if (_) {
            var a = ye();
            Le() && (a = a.find(".fr-img-wrap")), n = a.offset().top + a.outerHeight(), t = a.offset().left
          }
        } else {
          var o = L.$tb.find('.fr-command[data-cmd="insertImage"]');
          t = o.offset().left, n = o.offset().top + (L.opts.toolbarBottom ? 10 : o.outerHeight() - 10)
        }
        !_ && L.opts.toolbarInline && (n = r.offset().top - L.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), L.popups.show("image.insert", t, n, _ ? _.outerHeight() : 0), L.accessibility.focusPopup(r)
      },
      refreshUploadButton: function Se(e) {
        var t = L.popups.get("image.insert");
        t && t.find(".fr-image-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      refreshByURLButton: function ke(e) {
        var t = L.popups.get("image.insert");
        t && t.find(".fr-image-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      upload: V,
      insertByURL: function xe() {
        var e = L.popups.get("image.insert").find(".fr-image-by-url-layer input");
        if (0 < e.val().length) {
          O(), I(L.language.translate("Loading image"));
          var t = e.val().trim();
          if (L.opts.imageUploadRemoteUrls && L.opts.imageCORSProxy && L.opts.imageUpload) {
            var n = new XMLHttpRequest;
            n.onload = function () {
              200 == this.status ? V([new Blob([this.response], {type: this.response.type || "image/png"})], _) : R(r)
            }, n.onerror = function () {
              $(t, !0, [], _)
            }, n.open("GET", "".concat(L.opts.imageCORSProxy, "/").concat(t), !0), n.responseType = "blob", n.send()
          } else $(t, !0, [], _);
          e.val(""), e.blur()
        }
      },
      align: function Re(e) {
        var t = ye();
        t.removeClass("fr-fir fr-fil"), !L.opts.htmlUntouched && L.opts.useClasses ? "left" == e ? t.addClass("fr-fil") : "right" == e && t.addClass("fr-fir") : ge(t, ve(), e), Ce(), k(), o(), L.selection.clear()
      },
      refreshAlign: function Me(e) {
        _ && e.find("> *").first().replaceWith(L.icon.create("image-align-".concat(me())))
      },
      refreshAlignOnShow: function Oe(e, t) {
        _ && t.find('.fr-command[data-param1="'.concat(me(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      },
      display: function Ne(e) {
        var t = ye();
        t.removeClass("fr-dii fr-dib"), !L.opts.htmlUntouched && L.opts.useClasses ? "inline" == e ? t.addClass("fr-dii") : "block" == e && t.addClass("fr-dib") : ge(t, e, me()), Ce(), k(), o(), L.selection.clear()
      },
      refreshDisplayOnShow: function Ie(e, t) {
        _ && t.find('.fr-command[data-param1="'.concat(ve(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      },
      replace: be,
      back: function e() {
        _ ? (L.events.disableBlur(), w(".fr-popup input:focus").blur(), B(_)) : (L.events.disableBlur(), L.selection.restore(), L.events.enableBlur(), L.popups.hide("image.insert"), L.toolbar.showInline())
      },
      get: Ee,
      getEl: ye,
      insert: $,
      showProgressBar: O,
      remove: te,
      hideProgressBar: N,
      applyStyle: function De(e, t, n) {
        if (void 0 === t && (t = L.opts.imageStyles), void 0 === n && (n = L.opts.imageMultipleStyles), !_) return !1;
        var r = ye();
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), r.removeClass(a.join(" "))
        }
        "object" == kt(t[e]) ? (r.removeAttr("style"), r.css(t[e].style)) : r.toggleClass(e), B(_)
      },
      showAltPopup: q,
      showSizePopup: Q,
      setAlt: function Be(e) {
        if (_) {
          var t = L.popups.get("image.alt");
          _.attr("alt", e || t.find("input").val() || ""), t.find("input:focus").blur(), B(_)
        }
      },
      setSize: function He(e, t) {
        if (_) {
          var n = L.popups.get("image.size");
          e = e || n.find('input[name="width"]').val() || "", t = t || n.find('input[name="height"]').val() || "";
          var r = /^[\d]+((px)|%)*$/g;
          _.removeAttr("width").removeAttr("height"), e.match(r) ? _.css("width", e) : _.css("width", ""), t.match(r) ? _.css("height", t) : _.css("height", ""), Le() && (_.parents(".fr-img-caption").removeAttr("width").removeAttr("height"), e.match(r) ? _.parents(".fr-img-caption").css("width", e) : _.parents(".fr-img-caption").css("width", ""), t.match(r) ? _.parents(".fr-img-caption").css("height", t) : _.parents(".fr-img-caption").css("height", "")), n && n.find("input:focus").blur(), B(_)
        }
      },
      toggleCaption: function $e() {
        var e;
        if (_ && !Le()) {
          ((e = _).parent().is("a") || _.parent().is("p")) && (e = _.parent());
          var t, n,
            r = _.parents("ul") && 0 < _.parents("ul").length ? _.parents("ul") : _.parents("ol") && 0 < _.parents("ol").length ? _.parents("ol") : [];
          if (0 < r.length) {
            var a = r.find("li").length, o = _.parents("li"), i = document.createElement("li");
            a - 1 === o.index() && (r.append(i), i.innerHTML = "&nbsp;")
          }
          e.attr("style") ? n = -1 < (t = e.attr("style").split(":")).indexOf("width") ? t[t.indexOf("width") + 1].replace(";", "") : "" : e.attr("width") && (n = e.attr("width"));
          var s = L.opts.imageResizeWithPercent ? (-1 < n.indexOf("px") ? null : n) || "100%" : _.width() + "px";
          e.wrap('<div class="fr-img-space-wrap"><span ' + (L.browser.mozilla ? "" : 'contenteditable="false"') + 'class="fr-img-caption ' + _.attr("class") + '" style="' + (L.opts.useClasses ? "" : e.attr("style")) + '" draggable="false"></span></div>'), e.wrap('<span class="fr-img-wrap"></span>'), _.after('<span class="fr-inner"'.concat(L.browser.mozilla ? "" : ' contenteditable="true"', ">").concat(xt.START_MARKER).concat(L.language.translate("Image Caption")).concat(xt.END_MARKER, "</span>")), _.parents(".fr-img-caption").css("width", s), 1 < _.parents(".fr-img-space-wrap").length && (_e(document.querySelector(".fr-img-space-wrap")), _e(document.querySelector(".fr-img-space-wrap2"))), fe(!0), L.selection.restore()
        } else {
          if (e = ye(), _.insertBefore(e), null !== e[0].querySelector("a")) {
            for (var l, c = e[0].querySelector("a"), d = document.createElement("a"), f = 0, p = c.attributes, u = p.length; f < u; f++) l = p[f], d.setAttribute(l.nodeName, l.nodeValue);
            _.wrap(d)
          }
          _.attr("class", e.attr("class").replace("fr-img-caption", "")).attr("style", e.attr("style")), e.remove(), 1 < _.parents(".fr-img-space-wrap").length && (_e(document.querySelector(".fr-img-space-wrap")), _e(document.querySelector(".fr-img-space-wrap2"))), B(_)
        }
      },
      hasCaption: Le,
      exitEdit: fe,
      edit: B
    }
  },xt.DefineIcon("insertImage", {
    NAME: "image",
    SVG_KEY: "insertImage"
  }),xt.RegisterShortcut(xt.KEYCODE.P, "insertImage", null, "P"),xt.RegisterCommand("insertImage", {
    title: "Insert Image",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("image.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("image.insert")) : this.image.showInsertPopup()
    },
    plugin: "image"
  }),xt.DefineIcon("imageUpload", {
    NAME: "upload",
    SVG_KEY: "upload"
  }),xt.RegisterCommand("imageUpload", {
    title: "Upload Image", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.image.showLayer("image-upload")
    }, refresh: function (e) {
      this.image.refreshUploadButton(e)
    }
  }),xt.DefineIcon("imageByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }),xt.RegisterCommand("imageByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.image.showLayer("image-by-url")
    }, refresh: function (e) {
      this.image.refreshByURLButton(e)
    }
  }),xt.RegisterCommand("imageInsertByURL", {
    title: "Insert Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.insertByURL()
    },
    refresh: function (e) {
      this.image.get() ? e.text(this.language.translate("Replace")) : e.text(this.language.translate("Insert"))
    }
  }),xt.DefineIcon("imageDisplay", {
    NAME: "star",
    SVG_KEY: "imageDisplay"
  }),xt.RegisterCommand("imageDisplay", {
    title: "Display",
    type: "dropdown",
    options: {inline: "Inline", block: "Break Text"},
    callback: function (e, t) {
      this.image.display(t)
    },
    refresh: function (e) {
      this.opts.imageTextNear || e.addClass("fr-hidden")
    },
    refreshOnShow: function (e, t) {
      this.image.refreshDisplayOnShow(e, t)
    }
  }),xt.DefineIcon("image-align", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("image-align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("image-align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("image-align-center", {
    NAME: "align-justify",
    SVG_KEY: "alignCenter"
  }),xt.DefineIcon("imageAlign", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.RegisterCommand("imageAlign", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "None", right: "Align Right"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.imageAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("image-align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.image.align(t)
    },
    refresh: function (e) {
      this.image.refreshAlign(e)
    },
    refreshOnShow: function (e, t) {
      this.image.refreshAlignOnShow(e, t)
    }
  }),xt.DefineIcon("imageReplace", {
    NAME: "exchange",
    FA5NAME: "exchange-alt",
    SVG_KEY: "replaceImage"
  }),xt.RegisterCommand("imageReplace", {
    title: "Replace",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.replace()
    }
  }),xt.DefineIcon("imageRemove", {
    NAME: "trash",
    SVG_KEY: "remove"
  }),xt.RegisterCommand("imageRemove", {
    title: "Remove", callback: function () {
      this.image.remove()
    }
  }),xt.DefineIcon("imageBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("imageBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.image.back()
    },
    refresh: function (e) {
      this.$;
      this.image.get() || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.RegisterCommand("imageDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.image.hideProgressBar(!0)
    }
  }),xt.DefineIcon("imageStyle", {
    NAME: "magic",
    SVG_KEY: "imageClass"
  }),xt.RegisterCommand("imageStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.imageStyles;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = t[n];
        "object" == kt(r) && (r = r.title), e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'.concat(n, '">').concat(this.language.translate(r), "</a></li>")
      }
      return e += "</ul>"
    }, callback: function (e, t) {
      this.image.applyStyle(t)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.image.getEl();
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.DefineIcon("imageAlt", {NAME: "info", SVG_KEY: "imageAltText"}),xt.RegisterCommand("imageAlt", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Alternative Text",
    callback: function () {
      this.image.showAltPopup()
    }
  }),xt.RegisterCommand("imageSetAlt", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setAlt()
    }
  }),xt.DefineIcon("imageSize", {NAME: "arrows-alt", SVG_KEY: "imageSize"}),xt.RegisterCommand("imageSize", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Change Size",
    callback: function () {
      this.image.showSizePopup()
    }
  }),xt.RegisterCommand("imageSetSize", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setSize()
    }
  }),xt.DefineIcon("imageCaption", {
    NAME: "commenting",
    FA5NAME: "comment-alt",
    SVG_KEY: "imageCaption"
  }),xt.RegisterCommand("imageCaption", {
    undo: !0,
    focus: !1,
    title: "Image Caption",
    refreshAfterCallback: !0,
    callback: function () {
      this.image.toggleCaption()
    },
    refresh: function (e) {
      this.image.get() && e.toggleClass("fr-active", this.image.hasCaption())
    }
  }),Object.assign(xt.DEFAULTS, {
    imageManagerLoadURL: "https://i.froala.com/load-files",
    imageManagerLoadMethod: "get",
    imageManagerLoadParams: {},
    imageManagerPreloader: null,
    imageManagerDeleteURL: "",
    imageManagerDeleteMethod: "post",
    imageManagerDeleteParams: {},
    imageManagerPageSize: 12,
    imageManagerScrollOffset: 20,
    imageManagerToggleTags: !0
  }),xt.PLUGINS.imageManager = function (s) {
    var l, c, o, i, d, f, p, u, h, g, m, v = s.$, b = "image_manager", e = 10, C = 11, E = 12, y = 13, L = 14, _ = 15,
      n = 21, r = 22, a = {};

    function w() {
      var e = v(window).outerWidth();
      return e < 768 ? 2 : e < 1200 ? 3 : 4
    }

    function A() {
      d.empty();
      for (var e = 0; e < m; e++) d.append('<div class="fr-list-column"></div>')
    }

    function T() {
      if (h < p.length && o[0].scrollTop >= o[0].scrollHeight - s.opts.imageManagerScrollOffset - o.outerHeight()) {
        u++;
        for (var e = s.opts.imageManagerPageSize * (u - 1); e < Math.min(p.length, s.opts.imageManagerPageSize * u); e++) t(p[e])
      }
    }

    function t(a) {
      var o = new Image,
        i = v(document.createElement("div")).attr("class", "fr-image-container fr-empty fr-image-" + g++).attr("data-loading", s.language.translate("Loading") + "..").attr("data-deleting", s.language.translate("Deleting") + "..");
      R(!1), o.onload = function () {
        i.height(Math.floor(i.width() / o.width * o.height));
        var n = v(document.createElement("img"));
        if (a.thumb) n.attr("src", a.thumb); else {
          if (I(L, a), !a.url) return I(_, a), !1;
          n.attr("src", a.url)
        }
        if (a.url && n.attr("data-url", a.url), a.tag) if (c.find(".fr-modal-more.fr-not-available").removeClass("fr-not-available"), c.find(".fr-modal-tags").show(), 0 <= a.tag.indexOf(",")) {
          for (var e = a.tag.split(","), t = 0; t < e.length; t++) e[t] = e[t].trim(), 0 === f.find('a[title="'.concat(e[t], '"]')).length && f.append('<a role="button" title="'.concat(e[t], '">').concat(e[t], "</a>"));
          n.attr("data-tag", e.join())
        } else 0 === f.find('a[title="'.concat(a.tag.trim(), '"]')).length && f.append('<a role="button" title="'.concat(a.tag.trim(), '">').concat(a.tag.trim(), "</a>")), n.attr("data-tag", a.tag.trim());
        for (var r in a.name && n.attr("alt", a.name), a) a.hasOwnProperty(r) && "thumb" !== r && "url" !== r && "tag" !== r && n.attr("data-".concat(r), a[r]);
        i.append(n).append(v(s.icon.create("imageManagerDelete")).addClass("fr-delete-img").attr("title", s.language.translate("Delete"))).append(v(s.icon.create("imageManagerInsert")).addClass("fr-insert-img").attr("title", s.language.translate("Insert"))), f.find(".fr-selected-tag").each(function (e, t) {
          $(n, t.text) || i.hide()
        }), n.on("load", function () {
          i.removeClass("fr-empty"), i.height("auto"), h++, x(k(parseInt(n.parent().attr("class").match(/fr-image-(\d+)/)[1], 10) + 1)), R(!1), h % s.opts.imageManagerPageSize == 0 && T()
        }), s.events.trigger("imageManager.imageLoaded", [n])
      }, o.onerror = function () {
        h++, i.remove(), x(k(parseInt(i.attr("class").match(/fr-image-(\d+)/)[1], 10) + 1)), I(e, a), h % s.opts.imageManagerPageSize == 0 && T()
      }, o.src = a.thumb || a.url, S().append(i)
    }

    function S() {
      var r, a;
      return d.find(".fr-list-column").each(function (e, t) {
        var n = v(t);
        0 === e ? (a = n.outerHeight(), r = n) : n.outerHeight() < a && (a = n.outerHeight(), r = n)
      }), r
    }

    function k(e) {
      e === undefined && (e = 0);
      for (var t = [], n = g - 1; e <= n; n--) {
        var r = d.find(".fr-image-".concat(n));
        r.length && (t.push(r), v(document.createElement("div")).attr("id", "fr-image-hidden-container").append(r), d.find(".fr-image-".concat(n)).remove())
      }
      return t
    }

    function x(e) {
      for (var t = e.length - 1; 0 <= t; t--) S().append(e[t])
    }

    function R(e) {
      if (e === undefined && (e = !0), !l.isVisible()) return !0;
      var t = w();
      if (t !== m) {
        m = t;
        var n = k();
        A(), x(n)
      }
      s.modals.resize(b), e && T()
    }

    function M(e) {
      for (var t, n = e[0].attributes, r = n.length, a = {}; r--;) n[r] && "src" !== (t = n[r].name) && (a[t] = n[r].value);
      return a
    }

    function O(e) {
      var t = v(e.currentTarget).siblings("img"), n = l.data("instance") || s, r = l.data("current-image");
      if (s.modals.hide(b), n.image.showProgressBar(), r) r.data("fr-old-src", r.attr("src")), r.trigger("click"); else {
        n.events.focus(!0), n.selection.restore();
        var a = n.position.getBoundingRect(), o = a.left + a.width / 2 + v(s.doc).scrollLeft(),
          i = a.top + a.height + v(s.doc).scrollTop();
        n.popups.setContainer("image.insert", s.$sc), n.popups.show("image.insert", o, i)
      }
      n.image.insert(t.data("url"), !1, M(t), r)
    }

    function N(e) {
      var o = v(e.currentTarget).siblings("img"), t = s.language.translate("Are you sure? Image will be deleted.");
      confirm(t) && (s.opts.imageManagerDeleteURL ? !1 !== s.events.trigger("imageManager.beforeDeleteImage", [o]) && (o.parent().addClass("fr-image-deleting"), v(this).ajax({
        method: s.opts.imageManagerDeleteMethod,
        url: s.opts.imageManagerDeleteURL,
        data: Object.assign(Object.assign({src: o.attr("src")}, M(o)), s.opts.imageManagerDeleteParams),
        crossDomain: s.opts.requestWithCORS,
        withCredentials: s.opts.requestWithCredentials,
        headers: s.opts.requestHeaders,
        done: function (e, t, n) {
          s.events.trigger("imageManager.imageDeleted", [e]);
          var r = k(parseInt(o.parent().attr("class").match(/fr-image-(\d+)/)[1], 10) + 1);
          o.parent().remove(), x(r), function a() {
            l.find("#fr-modal-tags > a").each(function () {
              0 === l.find('#fr-image-list [data-tag*="'.concat(v(this).text(), '"]')).length && v(this).removeClass("fr-selected-tag").hide()
            }), B()
          }(), R(!0)
        },
        fail: function (e) {
          I(n, e.response || e.responseText)
        }
      })) : I(r))
    }

    function I(e, t) {
      10 <= e && e < 20 ? i.hide() : 20 <= e && e < 30 && v(".fr-image-deleting").removeClass("fr-image-deleting"), s.events.trigger("imageManager.error", [{
        code: e,
        message: a[e]
      }, t])
    }

    function D() {
      var e = c.find(".fr-modal-head-line").outerHeight(), t = f.outerHeight();
      c.toggleClass("fr-show-tags"), c.hasClass("fr-show-tags") ? (c.css("height", e + t), o.css("marginTop", e + t), f.find("a").css("opacity", 1)) : (c.css("height", e), o.css("marginTop", e), f.find("a").css("opacity", 0))
    }

    function B() {
      var e = f.find(".fr-selected-tag");
      0 < e.length ? (d.find("img").parents().show(), e.each(function (e, r) {
        d.find("img").each(function (e, t) {
          var n = v(t);
          $(n, r.text) || n.parent().hide()
        })
      })) : d.find("img").parents().show(), x(k()), T()
    }

    function H(e) {
      e.preventDefault();
      var t = v(e.currentTarget);
      t.toggleClass("fr-selected-tag"), s.opts.imageManagerToggleTags && t.siblings("a").removeClass("fr-selected-tag"), B()
    }

    function $(e, t) {
      for (var n = (e.attr("data-tag") || "").split(","), r = 0; r < n.length; r++) if (n[r] === t) return !0;
      return !1
    }

    return a[e] = "Image cannot be loaded from the passed link.", a[C] = "Error during load images request.", a[E] = "Missing imageManagerLoadURL option.", a[y] = "Parsing load response failed.", a[L] = "Missing image thumb.", a[_] = "Missing image URL.", a[n] = "Error during delete image request.", a[r] = "Missing imageManagerDeleteURL option.", {
      require: ["image"], _init: function F() {
        if (!s.$wp && "IMG" !== s.el.tagName) return !1
      }, show: function P() {
        if (!l) {
          var e,
            t = '<button class="fr-command fr-btn fr-modal-more fr-not-available" id="fr-modal-more-'.concat(s.sid, '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24""><path d="').concat(xt.SVG.tags, '"/></svg></button><h4 data-text="true">').concat(s.language.translate("Manage Images"), '</h4></div>\n      <div class="fr-modal-tags" id="fr-modal-tags">');
          e = s.opts.imageManagerPreloader ? '<img class="fr-preloader" id="fr-preloader" alt="'.concat(s.language.translate("Loading"), '.." src="').concat(s.opts.imageManagerPreloader, '" style="display: none;">') : '<span class="fr-preloader" id="fr-preloader" style="display: none;">'.concat(s.language.translate("Loading"), "</span>"), e += '<div class="fr-image-list" id="fr-image-list"></div>';
          var n = s.modals.create(b, t, e);
          l = n.$modal, c = n.$head, o = n.$body
        }
        l.data("current-image", s.image.get()), s.modals.show(b), i || function r() {
          i = l.find("#fr-preloader"), d = l.find("#fr-image-list"), f = l.find("#fr-modal-tags"), m = w(), A(), c.css("height", c.find(".fr-modal-head-line").outerHeight()), s.events.$on(v(s.o_win), "resize", function () {
            R(!!p)
          }), s.events.bindClick(d, ".fr-insert-img", O), s.events.bindClick(d, ".fr-delete-img", N), s.helpers.isMobile() && (s.events.bindClick(d, "div.fr-image-container", function (e) {
            l.find(".fr-mobile-selected").removeClass("fr-mobile-selected"), v(e.currentTarget).addClass("fr-mobile-selected")
          }), l.on(s._mousedown, function () {
            l.find(".fr-mobile-selected").removeClass("fr-mobile-selected")
          })), l.on(s._mousedown + " " + s._mouseup, function (e) {
            e.stopPropagation()
          }), l.on(s._mousedown, "*", function () {
            s.events.disableBlur()
          }), o.on("scroll", T), s.events.bindClick(l, "button#fr-modal-more-".concat(s.sid), D), s.events.bindClick(f, "a", H)
        }(), function a() {
          i.show(), d.find(".fr-list-column").empty(), s.opts.imageManagerLoadURL ? v(this).ajax({
            url: s.opts.imageManagerLoadURL,
            method: s.opts.imageManagerLoadMethod,
            data: s.opts.imageManagerLoadParams,
            crossDomain: s.opts.requestWithCORS,
            withCredentials: s.opts.requestWithCredentials,
            headers: s.opts.requestHeaders,
            done: function (e, t, n) {
              s.events.trigger("imageManager.imagesLoaded", [e]), function r(e, t) {
                try {
                  d.find(".fr-list-column").empty(), g = h = u = 0, p = JSON.parse(e), T()
                } catch (n) {
                  I(y, t)
                }
              }(e, n.response), i.hide()
            },
            fail: function (e) {
              I(C, e.response || e.responseText)
            }
          }) : I(E)
        }()
      }, hide: function U() {
        s.modals.hide(b)
      }
    }
  },!xt.PLUGINS.image) throw new Error("Image manager plugin requires image plugin.");

  function y(e) {
    var t = {
      omitExtraWLInCodeBlocks: {
        defaultValue: !1,
        describe: "Omit the default extra whiteline added to code blocks",
        type: "boolean"
      },
      noHeaderId: {defaultValue: !1, describe: "Turn on/off generated header id", type: "boolean"},
      prefixHeaderId: {
        defaultValue: !1,
        describe: "Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic 'section-' prefix",
        type: "string"
      },
      rawPrefixHeaderId: {
        defaultValue: !1,
        describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
        type: "boolean"
      },
      ghCompatibleHeaderId: {
        defaultValue: !1,
        describe: "Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)",
        type: "boolean"
      },
      rawHeaderId: {
        defaultValue: !1,
        describe: "Remove only spaces, ' and \" from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids",
        type: "boolean"
      },
      headerLevelStart: {defaultValue: !1, describe: "The header blocks level start", type: "integer"},
      parseImgDimensions: {defaultValue: !1, describe: "Turn on/off image dimension parsing", type: "boolean"},
      simplifiedAutoLink: {defaultValue: !1, describe: "Turn on/off GFM autolink style", type: "boolean"},
      excludeTrailingPunctuationFromURLs: {
        defaultValue: !1,
        describe: "Excludes trailing punctuation from links generated with autoLinking",
        type: "boolean"
      },
      literalMidWordUnderscores: {
        defaultValue: !1,
        describe: "Parse midword underscores as literal underscores",
        type: "boolean"
      },
      literalMidWordAsterisks: {
        defaultValue: !1,
        describe: "Parse midword asterisks as literal asterisks",
        type: "boolean"
      },
      strikethrough: {defaultValue: !1, describe: "Turn on/off strikethrough support", type: "boolean"},
      tables: {defaultValue: !1, describe: "Turn on/off tables support", type: "boolean"},
      tablesHeaderId: {defaultValue: !1, describe: "Add an id to table headers", type: "boolean"},
      ghCodeBlocks: {defaultValue: !0, describe: "Turn on/off GFM fenced code blocks support", type: "boolean"},
      tasklists: {defaultValue: !1, describe: "Turn on/off GFM tasklist support", type: "boolean"},
      smoothLivePreview: {
        defaultValue: !1,
        describe: "Prevents weird effects in live previews due to incomplete input",
        type: "boolean"
      },
      smartIndentationFix: {
        defaultValue: !1,
        description: "Tries to smartly fix indentation in es6 strings",
        type: "boolean"
      },
      disableForced4SpacesIndentedSublists: {
        defaultValue: !1,
        description: "Disables the requirement of indenting nested sublists by 4 spaces",
        type: "boolean"
      },
      simpleLineBreaks: {
        defaultValue: !1,
        description: "Parses simple line breaks as <br> (GFM Style)",
        type: "boolean"
      },
      requireSpaceBeforeHeadingText: {
        defaultValue: !1,
        description: "Makes adding a space between `#` and the header text mandatory (GFM Style)",
        type: "boolean"
      },
      ghMentions: {defaultValue: !1, description: "Enables github @mentions", type: "boolean"},
      ghMentionsLink: {
        defaultValue: "https://github.com/{u}",
        description: "Changes the link generated by @mentions. Only applies if ghMentions option is enabled.",
        type: "string"
      },
      encodeEmails: {
        defaultValue: !0,
        description: "Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities",
        type: "boolean"
      },
      openLinksInNewWindow: {defaultValue: !1, description: "Open all links in new windows", type: "boolean"},
      backslashEscapesHTMLTags: {
        defaultValue: !1,
        description: "Support for HTML Tag escaping. ex: <div>foo</div>",
        type: "boolean"
      },
      emoji: {defaultValue: !1, description: "Enable emoji support. Ex: `this is a :smile: emoji`", type: "boolean"},
      underline: {
        defaultValue: !1,
        description: "Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`",
        type: "boolean"
      },
      completeHTMLDocument: {
        defaultValue: !1,
        description: "Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags",
        type: "boolean"
      },
      metadata: {
        defaultValue: !1,
        description: "Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",
        type: "boolean"
      },
      splitAdjacentBlockquotes: {defaultValue: !1, description: "Split adjacent blockquote blocks", type: "boolean"}
    };
    if (!1 === e) return JSON.parse(JSON.stringify(t));
    var n = {};
    for (var r in t) t.hasOwnProperty(r) && (n[r] = t[r].defaultValue);
    return n
  }

  xt.DEFAULTS.imageInsertButtons.push("imageManager"), xt.RegisterCommand("imageManager", {
    title: "Browse",
    undo: !1,
    focus: !1,
    modal: !0,
    callback: function () {
      this.imageManager.show()
    },
    plugin: "imageManager"
  }), xt.DefineIcon("imageManager", {
    NAME: "folder",
    SVG_KEY: "imageManager"
  }), xt.DefineIcon("imageManagerInsert", {
    NAME: "plus",
    SVG_KEY: "add"
  }), xt.DefineIcon("imageManagerDelete", {
    NAME: "trash",
    SVG_KEY: "remove"
  }), Object.assign(xt.DEFAULTS, {
    inlineClasses: {
      "fr-class-code": "Code",
      "fr-class-highlighted": "Highlighted",
      "fr-class-transparency": "Transparent"
    }
  }), xt.PLUGINS.inlineClass = function (n) {
    var r = n.$;
    return {
      apply: function t(e) {
        n.format.toggle("span", {"class": e})
      }, refreshOnShow: function a(e, t) {
        t.find(".fr-command").each(function () {
          var e = r(this).data("param1"), t = n.format.is("span", {"class": e});
          r(this).toggleClass("fr-active", t).attr("aria-selected", t)
        })
      }
    }
  }, xt.RegisterCommand("inlineClass", {
    type: "dropdown", title: "Inline Class", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.inlineClasses;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineClass" data-param1="'.concat(n, '" title="').concat(t[n], '">').concat(t[n], "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.inlineClass.apply(t)
    }, refreshOnShow: function (e, t) {
      this.inlineClass.refreshOnShow(e, t)
    }, plugin: "inlineClass"
  }), xt.DefineIcon("inlineClass", {
    NAME: "tag",
    SVG_KEY: "inlineClass"
  }), Object.assign(xt.DEFAULTS, {
    inlineStyles: {
      "Big Red": "font-size: 20px; color: red;",
      "Small Blue": "font-size: 14px; color: blue;"
    }
  }), xt.PLUGINS.inlineStyle = function (a) {
    return {
      apply: function o(e) {
        for (var t = e.split(";"), n = 0; n < t.length; n++) {
          var r = t[n].split(":");
          t[n].length && 2 == r.length && a.format.applyStyle(r[0].trim(), r[1].trim())
        }
      }
    }
  }, xt.RegisterCommand("inlineStyle", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.inlineStyles;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = t[n] + (-1 === t[n].indexOf("display:block;") ? " display:block;" : "");
        e += '<li role="presentation"><span style="'.concat(r, '" role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineStyle" data-param1="').concat(t[n], '" title="').concat(this.language.translate(n), '">').concat(this.language.translate(n), "</a></span></li>")
      }
      return e += "</ul>"
    }, title: "Inline Style", callback: function (e, t) {
      this.inlineStyle.apply(t)
    }, plugin: "inlineStyle"
  }), xt.DefineIcon("inlineStyle", {
    NAME: "paint-brush",
    SVG_KEY: "inlineStyle"
  }), Object.assign(xt.DEFAULTS, {
    lineBreakerTags: ["table", "hr", "form", "dl", "span.fr-video", ".fr-embedly", "img"],
    lineBreakerOffset: 15,
    lineBreakerHorizontalOffset: 10
  }), xt.PLUGINS.lineBreaker = function (h) {
    var g, t, a, m = h.$;

    function l(e, t) {
      var n, r, a, o, i, s, l, c;
      if (null == e) i = (o = t.parent()).offset().top, n = (l = t.offset().top) - Math.min((l - i) / 2, h.opts.lineBreakerOffset), a = o.outerWidth(), r = o.offset().left; else if (null == t) (s = (o = e.parent()).offset().top + o.outerHeight()) < (c = e.offset().top + e.outerHeight()) && (s = (o = m(o).parent()).offset().top + o.outerHeight()), n = c + Math.min(Math.abs(s - c) / 2, h.opts.lineBreakerOffset), a = o.outerWidth(), r = o.offset().left; else {
        o = e.parent();
        var d = e.offset().top + e.height(), f = t.offset().top;
        if (f < d) return !1;
        n = (d + f) / 2, a = o.outerWidth(), r = o.offset().left
      }
      if (h.opts.iframe) {
        var p = h.helpers.getPX(h.$wp.find(".fr-iframe").css("padding-top")),
          u = h.helpers.getPX(h.$wp.find(".fr-iframe").css("padding-left"));
        r += h.$iframe.offset().left - h.helpers.scrollLeft() + u, n += h.$iframe.offset().top - h.helpers.scrollTop() + p
      }
      h.$box.append(g), g.css("top", n - h.win.pageYOffset), g.css("left", r - h.win.pageXOffset), g.css("width", a), g.data("tag1", e), g.data("tag2", t), g.addClass("fr-visible").data("instance", h)
    }

    function c(e) {
      if (e) {
        var t = m(e);
        if (0 === h.$el.find(t).length) return null;
        if (e.nodeType != Node.TEXT_NODE && t.is(h.opts.lineBreakerTags.join(","))) return t;
        if (0 < t.parents(h.opts.lineBreakerTags.join(",")).length) return e = t.parents(h.opts.lineBreakerTags.join(",")).get(0), 0 !== h.$el.find(m(e)).length && m(e).is(h.opts.lineBreakerTags.join(",")) ? m(e) : null
      }
      return null
    }

    function o(e, t) {
      var n = h.doc.elementFromPoint(e, t);
      return n && !m(n).closest(".fr-line-breaker").length && !h.node.isElement(n) && n != h.$wp.get(0) && function r(e) {
        if ("undefined" != typeof e.inFroalaWrapper) return e.inFroalaWrapper;
        for (var t = e; e.parentNode && e.parentNode !== h.$wp.get(0);) e = e.parentNode;
        return t.inFroalaWrapper = e.parentNode == h.$wp.get(0), t.inFroalaWrapper
      }(n) ? n : null
    }

    function i(e, t, n) {
      for (var r = n, a = null; r <= h.opts.lineBreakerOffset && !a;) (a = o(e, t - r)) || (a = o(e, t + r)), r += n;
      return a
    }

    function d(e, t, n) {
      for (var r = null, a = 100; !r && e > h.$box.offset().left && e < h.$box.offset().left + h.$box.outerWidth() && 0 < a;) (r = o(e, t)) || (r = i(e, t, 5)), "left" == n ? e -= h.opts.lineBreakerHorizontalOffset : e += h.opts.lineBreakerHorizontalOffset, a -= h.opts.lineBreakerHorizontalOffset;
      return r
    }

    function n(e) {
      var t = a = null, n = null, r = h.doc.elementFromPoint(e.pageX - h.win.pageXOffset, e.pageY - h.win.pageYOffset);
      (t = r && ("HTML" == r.tagName || "BODY" == r.tagName || h.node.isElement(r) || 0 <= (r.getAttribute("class") || "").indexOf("fr-line-breaker")) ? ((n = i(e.pageX - h.win.pageXOffset, e.pageY - h.win.pageYOffset, 1)) || (n = d(e.pageX - h.win.pageXOffset - h.opts.lineBreakerHorizontalOffset, e.pageY - h.win.pageYOffset, "left")), n || (n = d(e.pageX - h.win.pageXOffset + h.opts.lineBreakerHorizontalOffset, e.pageY - h.win.pageYOffset, "right")), c(n)) : c(r)) ? function s(e, t) {
        var n, r, a = e.offset().top, o = e.offset().top + e.outerHeight();
        if (Math.abs(o - t) <= h.opts.lineBreakerOffset || Math.abs(t - a) <= h.opts.lineBreakerOffset) if (Math.abs(o - t) < Math.abs(t - a)) {
          var i = null;
          for ((r = e.get(0)).nextSibling && (i = r.nextSibling.offsetParent ? r.nextSibling : null); i && i.nodeType == Node.TEXT_NODE && 0 === i.textContent.length;) i = i.nextSibling;
          if (!i) return l(e, null), !0;
          if (n = c(i)) return l(e, n), !0
        } else {
          if (!(r = e.get(0)).previousSibling) return l(null, e), !0;
          if (n = c(r.previousSibling)) return l(n, e), !0
        }
        g.removeClass("fr-visible").removeData("instance")
      }(t, e.pageY) : h.core.sameInstance(g) && g.removeClass("fr-visible").removeData("instance")
    }

    function r(e) {
      return !(g.hasClass("fr-visible") && !h.core.sameInstance(g)) && (h.popups.areVisible() || h.el.querySelector(".fr-selected-cell") ? (g.removeClass("fr-visible"), !0) : void (!1 !== t || h.edit.isDisabled() || (a && clearTimeout(a), a = setTimeout(n, 30, e))))
    }

    function s() {
      a && clearTimeout(a), g && g.hasClass("fr-visible") && g.removeClass("fr-visible").removeData("instance")
    }

    var f = function f() {
      t = !0, s()
    }, p = function p() {
      t = !1
    };

    function u(e) {
      e.preventDefault();
      var t = g.data("instance") || h;
      g.removeClass("fr-visible").removeData("instance");
      var n = g.data("tag1"), r = g.data("tag2"), a = h.html.defaultTag();
      null == n ? a && "TD" != r.parent().get(0).tagName && 0 === r.parents(a).length ? r.before("<".concat(a, ">").concat(xt.MARKERS, "<br></").concat(a, ">")) : r.before("".concat(xt.MARKERS, "<br>")) : a && "TD" != n.parent().get(0).tagName && 0 === n.parents(a).length ? n.after("<".concat(a, ">").concat(xt.MARKERS, "<br></").concat(a, ">")) : n.after("".concat(xt.MARKERS, "<br>")), t.selection.restore(), h.toolbar.enable()
    }

    return {
      _init: function v() {
        if (!h.$wp) return !1;
        !function e() {
          h.shared.$line_breaker || (h.shared.$line_breaker = m(document.createElement("div")).attr("class", "fr-line-breaker").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(h.language.translate("Break"), '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="17" y="7" width="2" height="8"/><rect x="10" y="13" width="7" height="2"/><path d="M10.000,10.000 L10.000,18.013 L5.000,14.031 L10.000,10.000 Z"/></svg></a>'))), g = h.shared.$line_breaker, h.events.on("shared.destroy", function () {
            g.html("").removeData().remove(), g = null
          }, !0), h.events.on("destroy", function () {
            g.removeData("instance").removeClass("fr-visible"), m("body").first().append(g), clearTimeout(a)
          }, !0), h.events.$on(g, "mousemove", function (e) {
            e.stopPropagation()
          }, !0), h.events.bindClick(g, "a", u)
        }(), t = !1, h.events.$on(h.$win, "mousemove", r), h.events.$on(m(h.win), "scroll", s), h.events.on("popups.show.table.edit", s), h.events.on("commands.after", s), h.events.$on(m(h.win), "mousedown", f), h.events.$on(m(h.win), "mouseup", p)
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    lineHeights: {
      Default: "",
      Single: "1",
      1.15: "1.15",
      1.5: "1.5",
      Double: "2"
    }
  }), xt.PLUGINS.lineHeight = function (r) {
    var s = r.$;
    return {
      _init: function e() {
      }, apply: function a(e) {
        r.selection.save(), r.html.wrap(!0, !0, !0, !0), r.selection.restore();
        var t = r.selection.blocks();
        t.length && s(t[0]).parent().is("td") && r.format.applyStyle("line-height", e.toString()), r.selection.save();
        for (var n = 0; n < t.length; n++) s(t[n]).css("line-height", e), "" === s(t[n]).attr("style") && s(t[n]).removeAttr("style");
        r.html.unwrap(), r.selection.restore()
      }, refreshOnShow: function o(e, t) {
        var n = r.selection.blocks();
        if (n.length) {
          var i = s(n[0]);
          t.find(".fr-command").each(function () {
            var e = s(this).data("param1"), t = i.attr("style"), n = 0 <= (t || "").indexOf("line-height: " + e + ";");
            if (t) {
              var r = t.substring(t.indexOf("line-height")), a = r.substr(0, r.indexOf(";")), o = a && a.split(":")[1];
              o && o.length || "Default" !== i.text() || (n = !0)
            }
            t && -1 !== t.indexOf("line-height") || "" !== e || (n = !0), s(this).toggleClass("fr-active", n).attr("aria-selected", n)
          })
        }
      }
    }
  }, xt.RegisterCommand("lineHeight", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.lineHeights;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command '.concat(n, '" tabIndex="-1" role="option" data-cmd="lineHeight" data-param1="').concat(t[n], '" title="').concat(this.language.translate(n), '">').concat(this.language.translate(n), "</a></li>"));
      return e += "</ul>"
    }, title: "Line Height", callback: function (e, t) {
      this.lineHeight.apply(t)
    }, refreshOnShow: function (e, t) {
      this.lineHeight.refreshOnShow(e, t)
    }, plugin: "lineHeight"
  }), xt.DefineIcon("lineHeight", {
    NAME: "arrows-v",
    FA5NAME: "arrows-alt-v",
    SVG_KEY: "lineHeight"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "link.edit": "[_BUTTONS_]",
    "link.insert": "[_BUTTONS_][_INPUT_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    linkEditButtons: ["linkOpen", "linkStyle", "linkEdit", "linkRemove"],
    linkInsertButtons: ["linkBack", "|", "linkList"],
    linkAttributes: {},
    linkAutoPrefix: "http://",
    linkStyles: {"fr-green": "Green", "fr-strong": "Thick"},
    linkMultipleStyles: !0,
    linkConvertEmailAddress: !0,
    linkAlwaysBlank: !1,
    linkAlwaysNoFollow: !1,
    linkNoOpener: !0,
    linkNoReferrer: !0,
    linkList: [{text: "Froala", href: "https://froala.com", target: "_blank"}, {
      text: "Google",
      href: "https://google.com",
      target: "_blank"
    }, {displayText: "Facebook", href: "https://facebook.com"}],
    linkText: !0
  }), xt.PLUGINS.link = function (m) {
    var v = m.$;

    function b() {
      var e = m.image ? m.image.get() : null;
      if (e || !m.$wp) return "A" == m.el.tagName ? m.el : e && e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? e.get(0).parentNode : void 0;
      var t = m.selection.ranges(0).commonAncestorContainer;
      try {
        t && (t.contains && t.contains(m.el) || !m.el.contains(t) || m.el == t) && (t = null)
      } catch (a) {
        t = null
      }
      if (t && "A" === t.tagName) return t;
      var n = m.selection.element(), r = m.selection.endElement();
      "A" == n.tagName || m.node.isElement(n) || (n = v(n).parentsUntil(m.$el, "a").first().get(0)), "A" == r.tagName || m.node.isElement(r) || (r = v(r).parentsUntil(m.$el, "a").first().get(0));
      try {
        r && (r.contains && r.contains(m.el) || !m.el.contains(r) || m.el == r) && (r = null)
      } catch (a) {
        r = null
      }
      try {
        n && (n.contains && n.contains(m.el) || !m.el.contains(n) || m.el == n) && (n = null)
      } catch (a) {
        n = null
      }
      return r && r == n && "A" == r.tagName ? (m.browser.msie || m.helpers.isMobile()) && (m.selection.info(n).atEnd || m.selection.info(n).atStart) ? null : n : null
    }

    function C() {
      var e, t, n, r, a = m.image ? m.image.get() : null, o = [];
      if (a) "A" == a.get(0).parentNode.tagName && o.push(a.get(0).parentNode); else if (m.win.getSelection) {
        var i = m.win.getSelection();
        if (i.getRangeAt && i.rangeCount) {
          r = m.doc.createRange();
          for (var s = 0; s < i.rangeCount; ++s) if ((t = (e = i.getRangeAt(s)).commonAncestorContainer) && 1 != t.nodeType && (t = t.parentNode), t && "a" == t.nodeName.toLowerCase()) o.push(t); else {
            n = t.getElementsByTagName("a");
            for (var l = 0; l < n.length; ++l) r.selectNodeContents(n[l]), r.compareBoundaryPoints(e.END_TO_START, e) < 1 && -1 < r.compareBoundaryPoints(e.START_TO_END, e) && o.push(n[l])
          }
        }
      } else if (m.doc.selection && "Control" != m.doc.selection.type) if ("a" == (t = (e = m.doc.selection.createRange()).parentElement()).nodeName.toLowerCase()) o.push(t); else {
        n = t.getElementsByTagName("a"), r = m.doc.body.createTextRange();
        for (var c = 0; c < n.length; ++c) r.moveToElementText(n[c]), -1 < r.compareEndPoints("StartToEnd", e) && r.compareEndPoints("EndToStart", e) < 1 && o.push(n[c])
      }
      return o
    }

    function E(a) {
      if (m.core.hasFocus()) {
        if (o(), a && "keyup" === a.type && (a.altKey || a.which == xt.KEYCODE.ALT)) return !0;
        setTimeout(function () {
          if (!a || a && (1 == a.which || "mouseup" != a.type)) {
            var e = b(), t = m.image ? m.image.get() : null;
            if (e && !t) {
              if (m.image) {
                var n = m.node.contents(e);
                if (1 == n.length && "IMG" == n[0].tagName) {
                  var r = m.selection.ranges(0);
                  return 0 === r.startOffset && 0 === r.endOffset ? v(e).before(xt.MARKERS) : v(e).after(xt.MARKERS), m.selection.restore(), !1
                }
              }
              a && a.stopPropagation(), i(e)
            }
          }
        }, m.helpers.isIOS() ? 100 : 0)
      }
    }

    function i(e) {
      var t = m.popups.get("link.edit");
      t || (t = function o() {
        var e = "";
        1 <= m.opts.linkEditButtons.length && ("A" == m.el.tagName && 0 <= m.opts.linkEditButtons.indexOf("linkRemove") && m.opts.linkEditButtons.splice(m.opts.linkEditButtons.indexOf("linkRemove"), 1), e = '<div class="fr-buttons">'.concat(m.button.buildList(m.opts.linkEditButtons), "</div>"));
        var t = {buttons: e}, n = m.popups.create("link.edit", t);
        m.$wp && m.events.$on(m.$wp, "scroll.link-edit", function () {
          b() && m.popups.isVisible("link.edit") && i(b())
        });
        return n
      }());
      var n = v(e);
      m.popups.isVisible("link.edit") || m.popups.refresh("link.edit"), m.popups.setContainer("link.edit", m.$sc);
      var r = n.offset().left + n.outerWidth() / 2, a = n.offset().top + n.outerHeight();
      m.popups.show("link.edit", r, a, n.outerHeight(), !0)
    }

    function o() {
      m.popups.hide("link.edit")
    }

    function l() {
      var e = m.popups.get("link.insert"), t = b();
      if (t) {
        var n, r, a = v(t), o = e.find('input.fr-link-attr[type="text"]'),
          i = e.find('input.fr-link-attr[type="checkbox"]');
        for (n = 0; n < o.length; n++) (r = v(o[n])).val(a.attr(r.attr("name") || ""));
        for (i.attr("checked", !1), n = 0; n < i.length; n++) r = v(i[n]), a.attr(r.attr("name")) == r.data("checked") && r.attr("checked", !0);
        e.find('input.fr-link-attr[type="text"][name="text"]').val(a.text())
      } else e.find('input.fr-link-attr[type="text"]').val(""), e.find('input.fr-link-attr[type="checkbox"]').attr("checked", !1), e.find('input.fr-link-attr[type="text"][name="text"]').val(m.selection.text());
      e.find("input.fr-link-attr").trigger("change"), (m.image ? m.image.get() : null) ? e.find('.fr-link-attr[name="text"]').parent().hide() : e.find('.fr-link-attr[name="text"]').parent().show()
    }

    function s(e) {
      if (e) return m.popups.onRefresh("link.insert", l), !0;
      var t = "";
      1 <= m.opts.linkInsertButtons.length && (t = '<div class="fr-buttons fr-tabs">'.concat(m.button.buildList(m.opts.linkInsertButtons), "</div>"));
      var n = "", r = 0;
      for (var a in n = '<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-'.concat(m.id, '">'), n += '<div class="fr-input-line"><input id="fr-link-insert-layer-url-'.concat(m.id, '" name="href" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("URL"), '" tabIndex="').concat(++r, '"></div>'), m.opts.linkText && (n += '<div class="fr-input-line"><input id="fr-link-insert-layer-text-'.concat(m.id, '" name="text" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("Text"), '" tabIndex="').concat(++r, '"></div>')), m.opts.linkAttributes) if (m.opts.linkAttributes.hasOwnProperty(a)) {
        var o = m.opts.linkAttributes[a];
        n += '<div class="fr-input-line"><input name="'.concat(a, '" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate(o), '" tabIndex="').concat(++r, '"></div>')
      }
      m.opts.linkAlwaysBlank || (n += '<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-'.concat(m.id, '" tabIndex="').concat(++r, '"><span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '</span></span><label id="fr-label-target-').concat(m.id, '">').concat(m.language.translate("Open in new tab"), "</label></div>"));
      var i = {
        buttons: t,
        input_layer: n += '<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsert" href="#" tabIndex="'.concat(++r, '" type="button">').concat(m.language.translate("Insert"), "</button></div></div>")
      }, s = m.popups.create("link.insert", i);
      return m.$wp && m.events.$on(m.$wp, "scroll.link-insert", function () {
        (m.image ? m.image.get() : null) && m.popups.isVisible("link.insert") && f(), m.popups.isVisible("link.insert") && d()
      }), s
    }

    function c(e, t, n) {
      if (m.opts.trackChangesEnabled) {
        if (m.edit.on(), m.events.focus(!0), m.undo.saveStep(), m.markers.insert(), m.html.wrap(), !m.$el.find(".fr-marker").length) return void m.popups.hide("link.insert");
        m.markers.remove()
      }
      if (void 0 === n && (n = {}), !1 === m.events.trigger("link.beforeInsert", [e, t, n])) return !1;
      var r = m.image ? m.image.get() : null;
      r || "A" == m.el.tagName ? "A" == m.el.tagName && m.$el.focus() : (m.selection.restore(), m.popups.hide("link.insert"));
      var a = e;
      m.opts.linkConvertEmailAddress && m.helpers.isEmail(e) && !/^mailto:.*/i.test(e) && (e = "mailto:".concat(e));
      if ("" === m.opts.linkAutoPrefix || new RegExp("^(" + xt.LinkProtocols.join("|") + "):.", "i").test(e) || /^data:image.*/i.test(e) || /^(https?:|ftps?:|file:|)\/\//i.test(e) || /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e) || ["/", "{", "[", "#", "(", "."].indexOf((e || "")[0]) < 0 && (e = m.opts.linkAutoPrefix + e), e = m.helpers.sanitizeURL(e), m.opts.linkAlwaysBlank && (n.target = "_blank"), m.opts.linkAlwaysNoFollow && (n.rel = "nofollow"), m.helpers.isEmail(a) && (n.target = null, n.rel = null), "_blank" == n.target ? (m.opts.linkNoOpener && (n.rel ? n.rel += " noopener" : n.rel = "noopener"), m.opts.linkNoReferrer && (n.rel ? n.rel += " noreferrer" : n.rel = "noreferrer")) : null == n.target && (n.rel ? n.rel = n.rel.replace(/noopener/, "").replace(/noreferrer/, "") : n.rel = null), t = t || "", e === m.opts.linkAutoPrefix) return m.popups.get("link.insert").find('input[name="href"]').addClass("fr-error"), m.events.trigger("link.bad", [a]), !1;
      var o, i = b();
      if (i) {
        if ((o = v(i)).attr("href", e), 0 < t.length && o.text() != t && !r) {
          if (m.opts.trackChangesEnabled) {
            var s = v(o.get(0).outerHTML);
            s.insertBefore(o.parent());
            var l = m.track_changes.wrapLinkInTracking(s, m.track_changes.getPendingChanges().length - 1),
              c = m.track_changes.wrapInDelete(l);
            o.parent().append(c)
          }
          for (var d = o.get(0); 1 === d.childNodes.length && d.childNodes[0].nodeType == Node.ELEMENT_NODE;) d = d.childNodes[0];
          v(d).text(t)
        }
        for (var f in r || o.prepend(xt.START_MARKER).append(xt.END_MARKER), n) n[f] ? o.attr(f, n[f]) : o.removeAttr(f);
        r || m.selection.restore()
      } else {
        r ? (r.wrap('<a href="'.concat(e, '"></a>')), m.image.hasCaption() && r.parent().append(r.parents(".fr-img-caption").find(".fr-inner"))) : (m.format.remove("a"), m.selection.isCollapsed() ? (t = 0 === t.length ? a : t, m.html.insert('<a href="'.concat(e, '">').concat(xt.START_MARKER).concat(t.replace(/&/g, "&amp;").replace(/</, "&lt;", ">", "&gt;")).concat(xt.END_MARKER, "</a>")), m.selection.restore()) : 0 < t.length && t != m.selection.text().replace(/\n/g, "") ? (m.selection.remove(), m.html.insert('<a href="'.concat(e, '">').concat(xt.START_MARKER).concat(t.replace(/&/g, "&amp;")).concat(xt.END_MARKER, "</a>")), m.selection.restore()) : (!function g() {
          if (!m.selection.isCollapsed()) {
            m.selection.save();
            for (var e = m.$el.find(".fr-marker").addClass("fr-unprocessed").toArray(); e.length;) {
              var t = v(e.pop());
              t.removeClass("fr-unprocessed");
              var n = m.node.deepestParent(t.get(0));
              if (n) {
                for (var r = t.get(0), a = "", o = ""; r = r.parentNode, m.node.isBlock(r) || (a += m.node.closeTagString(r), o = m.node.openTagString(r) + o), r != n;) ;
                var i = m.node.openTagString(t.get(0)) + t.html() + m.node.closeTagString(t.get(0));
                t.replaceWith('<span id="fr-break"></span>');
                var s = n.outerHTML;
                s = (s = s.replace(/<span id="fr-break"><\/span>/g, a + i + o)).replace(o + a, ""), n.outerHTML = s
              }
              e = m.$el.find(".fr-marker.fr-unprocessed").toArray()
            }
            m.html.cleanEmptyTags(), m.selection.restore()
          }
        }(), m.format.apply("a", {href: e})));
        for (var p = C(), u = 0; u < p.length; u++) (o = v(p[u])).attr(n), o.removeAttr("_moz_dirty");
        1 == p.length && m.$wp && !r && (v(p[0]).prepend(xt.START_MARKER).append(xt.END_MARKER), m.selection.restore())
      }
      if (r) {
        var h = m.popups.get("link.insert");
        h && h.find("input:focus").blur(), m.image.edit(r)
      } else E()
    }

    function d() {
      o();
      var e = b();
      if (e) {
        var t = m.popups.get("link.insert");
        t || (t = s()), m.popups.isVisible("link.insert") || (m.popups.refresh("link.insert"), m.selection.save(), m.helpers.isMobile() && (m.events.disableBlur(), m.$el.blur(), m.events.enableBlur())), m.popups.setContainer("link.insert", m.$sc);
        var n = (m.image ? m.image.get() : null) || v(e), r = n.offset().left + n.outerWidth() / 2,
          a = n.offset().top + n.outerHeight();
        m.popups.show("link.insert", r, a, n.outerHeight(), !0)
      }
    }

    function f() {
      var e = m.image ? m.image.getEl() : null;
      if (e) {
        var t = m.popups.get("link.insert");
        m.image.hasCaption() && (e = e.find(".fr-img-wrap")), t || (t = s()), l(), m.popups.setContainer("link.insert", m.$sc);
        var n = e.offset().left + e.outerWidth() / 2, r = e.offset().top + e.outerHeight();
        m.popups.show("link.insert", n, r, e.outerHeight(), !0)
      }
    }

    return {
      _init: function e() {
        m.events.on("keyup", function (e) {
          e.which != xt.KEYCODE.ESC && E(e)
        }), m.events.on("window.mouseup", E), m.events.$on(m.$el, "click", "a", function (e) {
          m.edit.isDisabled() && e.preventDefault()
        }), m.helpers.isMobile() && m.events.$on(m.$doc, "selectionchange", E), s(!0), "A" == m.el.tagName && m.$el.addClass("fr-view"), m.events.on("toolbar.esc", function () {
          if (m.popups.isVisible("link.edit")) return m.events.disableBlur(), m.events.focus(), !1
        }, !0)
      }, remove: function r() {
        var e = b(), t = m.image ? m.image.get() : null;
        if (!1 === m.events.trigger("link.beforeRemove", [e])) return !1;
        if (t && e) if (m.image.hasCaption()) {
          t.addClass("img-link-caption"), v(e).replaceWith(v(e).html());
          var n = document.querySelectorAll("img.img-link-caption");
          m.image.edit(v(n[0])), v(n[0]).removeClass("img-link-caption")
        } else t.unwrap(), m.image.edit(t); else e && (m.selection.save(), v(e).replaceWith(v(e).html()), m.selection.restore(), o())
      }, showInsertPopup: function p() {
        var e = m.$tb.find('.fr-command[data-cmd="insertLink"]'), t = m.popups.get("link.insert");
        if (t || (t = s()), !t.hasClass("fr-active")) if (m.popups.refresh("link.insert"), m.popups.setContainer("link.insert", m.$tb || m.$sc), e.isVisible()) {
          var n = m.button.getPosition(e), r = n.left, a = n.top;
          m.popups.show("link.insert", r, a, e.outerHeight())
        } else m.position.forSelection(t), m.popups.show("link.insert")
      }, usePredefined: function u(e) {
        var t, n, r = m.opts.linkList[e], a = m.popups.get("link.insert"),
          o = a.find('input.fr-link-attr[type="text"]'), i = a.find('input.fr-link-attr[type="checkbox"]');
        for (r.rel && (a.rel = r.rel), n = 0; n < o.length; n++) r[(t = v(o[n])).attr("name")] ? (t.val(r[t.attr("name")]), t.toggleClass("fr-not-empty", !0)) : "text" != t.attr("name") && t.val("");
        for (n = 0; n < i.length; n++) (t = v(i[n])).attr("checked", t.data("checked") == r[t.attr("name")]);
        m.accessibility.focusPopup(a)
      }, insertCallback: function h() {
        var e, t, n = m.popups.get("link.insert"), r = n.find('input.fr-link-attr[type="text"]'),
          a = n.find('input.fr-link-attr[type="checkbox"]'), o = (r.filter('[name="href"]').val() || "").trim(),
          i = m.opts.linkText ? r.filter('[name="text"]').val() : "", s = {};
        for (t = 0; t < r.length; t++) e = v(r[t]), ["href", "text"].indexOf(e.attr("name")) < 0 && (s[e.attr("name")] = e.val());
        for (t = 0; t < a.length; t++) (e = v(a[t])).is(":checked") ? s[e.attr("name")] = e.data("checked") : s[e.attr("name")] = e.data("unchecked") || null;
        n.rel && (s.rel = n.rel);
        var l = m.helpers.scrollTop();
        c(o, i, s), v(m.o_win).scrollTop(l)
      }, insert: c, update: d, get: b, allSelected: C, back: function t() {
        m.image && m.image.get() ? m.image.back() : (m.events.disableBlur(), m.selection.restore(), m.events.enableBlur(), b() && m.$wp ? (m.selection.restore(), o(), E()) : "A" == m.el.tagName ? (m.$el.focus(), E()) : (m.popups.hide("link.insert"), m.toolbar.showInline()))
      }, imageLink: f, applyStyle: function g(e, t, n) {
        void 0 === n && (n = m.opts.linkMultipleStyles), void 0 === t && (t = m.opts.linkStyles);
        var r = b();
        if (!r) return !1;
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), v(r).removeClass(a.join(" "))
        }
        v(r).toggleClass(e), E()
      }
    }
  }, xt.DefineIcon("insertLink", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterShortcut(xt.KEYCODE.K, "insertLink", null, "K"), xt.RegisterCommand("insertLink", {
    title: "Insert Link",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("link.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("link.insert")) : this.link.showInsertPopup()
    },
    plugin: "link"
  }), xt.DefineIcon("linkOpen", {
    NAME: "external-link",
    FA5NAME: "external-link-alt",
    SVG_KEY: "openLink"
  }), xt.RegisterCommand("linkOpen", {
    title: "Open Link", undo: !1, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, callback: function () {
      var e = this.link.get();
      e && (-1 !== e.href.indexOf("mailto:") ? this.o_win.open(e.href).close() : (e.target || (e.target = "_self"), this.browser.msie || this.browser.edge ? this.o_win.open(e.href, e.target) : this.o_win.open(e.href, e.target, "noopener")), this.popups.hide("link.edit"))
    }, plugin: "link"
  }), xt.DefineIcon("linkEdit", {NAME: "edit", SVG_KEY: "edit"}), xt.RegisterCommand("linkEdit", {
    title: "Edit Link",
    undo: !1,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.link.update()
    },
    refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    },
    plugin: "link"
  }), xt.DefineIcon("linkRemove", {
    NAME: "unlink",
    SVG_KEY: "unlink"
  }), xt.RegisterCommand("linkRemove", {
    title: "Unlink", callback: function () {
      this.link.remove()
    }, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, plugin: "link"
  }), xt.DefineIcon("linkBack", {NAME: "arrow-left", SVG_KEY: "back"}), xt.RegisterCommand("linkBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.link.back()
    },
    refresh: function (e) {
      var t = this.link.get() && this.doc.hasFocus();
      (this.image ? this.image.get() : null) || t || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    },
    plugin: "link"
  }), xt.DefineIcon("linkList", {
    NAME: "search",
    SVG_KEY: "search"
  }), xt.RegisterCommand("linkList", {
    title: "Choose Link",
    type: "dropdown",
    focus: !1,
    undo: !1,
    refreshAfterCallback: !1,
    html: function () {
      for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.linkList, n = 0; n < t.length; n++) e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="'.concat(n, '">').concat(t[n].displayText || t[n].text, "</a></li>");
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.link.usePredefined(t)
    },
    plugin: "link"
  }), xt.RegisterCommand("linkInsert", {
    focus: !1, refreshAfterCallback: !1, callback: function () {
      this.link.insertCallback()
    }, refresh: function (e) {
      this.link.get() ? e.text(this.language.translate("Update")) : e.text(this.language.translate("Insert"))
    }, plugin: "link"
  }), xt.DefineIcon("imageLink", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterCommand("imageLink", {
    title: "Insert Link", undo: !1, focus: !1, popup: !0, callback: function () {
      this.link.imageLink()
    }, refresh: function (e) {
      var t;
      this.link.get() ? ((t = e.prev()).hasClass("fr-separator") && t.removeClass("fr-hidden"), e.addClass("fr-hidden")) : ((t = e.prev()).hasClass("fr-separator") && t.addClass("fr-hidden"), e.removeClass("fr-hidden"))
    }, plugin: "link"
  }), xt.DefineIcon("linkStyle", {
    NAME: "magic",
    SVG_KEY: "linkStyles"
  }), xt.RegisterCommand("linkStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.linkStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkStyle" data-param1="'.concat(n, '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.link.applyStyle(t)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.link.get();
      if (r) {
        var a = n(r);
        t.find(".fr-command").each(function () {
          var e = n(this).data("param1"), t = a.hasClass(e);
          n(this).toggleClass("fr-active", t).attr("aria-selected", t)
        })
      }
    }, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, plugin: "link"
  }), Object.assign(xt.DEFAULTS, {listAdvancedTypes: !0}), xt.PLUGINS.lists = function (f) {
    var p = f.$;

    function u(e) {
      return '<span class="fr-open-'.concat(e.toLowerCase(), '"></span>')
    }

    function h(e) {
      return '<span class="fr-close-'.concat(e.toLowerCase(), '"></span>')
    }

    function o(e, t) {
      !function c(e, t) {
        for (var n = [], r = 0; r < e.length; r++) {
          var a = e[r].parentNode;
          "LI" == e[r].tagName && a.tagName != t && n.indexOf(a) < 0 && n.push(a)
        }
        for (var o = n.length - 1; 0 <= o; o--) {
          var i = p(n[o]);
          i.replaceWith("<".concat(t.toLowerCase(), " ").concat(f.node.attributes(i.get(0)), ">").concat(i.html(), "</").concat(t.toLowerCase(), ">"))
        }
      }(e, t);
      var n, r = f.html.defaultTag(), a = null;
      e.length && (n = "rtl" == f.opts.direction || "rtl" == p(e[0]).css("direction") ? "margin-right" : "margin-left");
      for (var o = 0; o < e.length; o++) if ("TD" != e[o].tagName && "TH" != e[o].tagName && "LI" != e[o].tagName) {
        var i = f.helpers.getPX(p(e[o]).css(n)) || 0;
        (e[o].style.marginLeft = null) === a && (a = i);
        var s = 0 < a ? "<".concat(t, ' style="').concat(n, ": ").concat(a, 'px ">') : "<".concat(t, ">"),
          l = "</".concat(t, ">");
        for (i -= a; 0 < i / f.opts.indentMargin;) s += "</".concat(t, ">"), l += l, i -= f.opts.indentMargin;
        r && e[o].tagName.toLowerCase() == r ? p(e[o]).replaceWith("".concat(s, "<li").concat(f.node.attributes(e[o]), ">").concat(p(e[o]).html(), "</li>").concat(l)) : p(e[o]).wrap("".concat(s, "<li></li>").concat(l))
      }
      f.clean.lists()
    }

    function i(e) {
      var t, n;
      for (t = e.length - 1; 0 <= t; t--) for (n = t - 1; 0 <= n; n--) if (p(e[n]).find(e[t]).length || e[n] == e[t]) {
        e.splice(t, 1);
        break
      }
      var r = [];
      for (t = 0; t < e.length; t++) {
        var a = p(e[t]), o = e[t].parentNode, i = a.attr("class");
        if (a.before(h(o.tagName)), "LI" == o.parentNode.tagName) a.before(h("LI")), a.after(u("LI")); else {
          var s = "";
          i && (s += ' class="'.concat(i, '"'));
          var l = "rtl" == f.opts.direction || "rtl" == a.css("direction") ? "margin-right" : "margin-left";
          f.helpers.getPX(p(o).css(l)) && 0 <= (p(o).attr("style") || "").indexOf("".concat(l, ":")) && (s += ' style="'.concat(l, ":").concat(f.helpers.getPX(p(o).css(l)), 'px;"')), f.html.defaultTag() && 0 === a.find(f.html.blockTagsQuery()).length && a.wrapInner(f.html.defaultTag() + s), f.node.isEmpty(a.get(0), !0) || 0 !== a.find(f.html.blockTagsQuery()).length || a.append("<br>"), a.append(u("LI")), a.prepend(h("LI"))
        }
        a.after(u(o.tagName)), "LI" == o.parentNode.tagName && (o = o.parentNode.parentNode), r.indexOf(o) < 0 && r.push(o)
      }
      for (t = 0; t < r.length; t++) {
        var c = p(r[t]), d = c.html();
        d = (d = d.replace(/<span class="fr-close-([a-z]*)"><\/span>/g, "</$1>")).replace(/<span class="fr-open-([a-z]*)"><\/span>/g, "<$1>"), c.replaceWith(f.node.openTagString(c.get(0)) + d + f.node.closeTagString(c.get(0)))
      }
      f.$el.find("li:empty").remove(), f.$el.find("ul:empty, ol:empty").remove(), f.clean.lists(), f.$el.find("ul:empty, ol:empty").remove(), f.html.wrap()
    }

    function l(e) {
      f.selection.save();
      for (var t = 0; t < e.length; t++) {
        var n = e[t].previousSibling;
        if (n) {
          var r = p(e[t]).find("> ul, > ol").last().get(0);
          if (r) {
            var a = p(document.createElement("li"));
            p(r).prepend(a);
            for (var o = f.node.contents(e[t])[0]; o && !f.node.isList(o);) {
              var i = o.nextSibling;
              a.append(o), o = i
            }
            p(n).append(p(r)), p(e[t]).remove()
          } else {
            var s = p(n).find("> ul, > ol").last().get(0);
            if (s) p(s).append(p(e[t])); else {
              var l = p("<".concat(e[t].parentNode.tagName, ">"));
              p(n).append(l), l.append(p(e[t]))
            }
          }
        }
      }
      f.clean.lists(), f.selection.restore()
    }

    function c(e) {
      f.selection.save(), i(e), f.selection.restore()
    }

    function e(e) {
      if ("indent" == e || "outdent" == e) {
        var t = !1, n = f.selection.blocks(), r = [], a = n[0].previousSibling || n[0].parentElement;
        if ("outdent" == e) {
          if ("UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return;
          if (!n[0].previousSibling && "none" == a.parentNode.style.listStyleType) return void function i(e) {
            for (f.selection.save(); 0 < e.childNodes.length;) e.parentNode.parentNode.append(e.childNodes[0]);
            f.clean.lists(), f.selection.restore()
          }(a)
        } else {
          if ("UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return;
          if (!n[0].previousSibling || "LI" != n[0].previousSibling.tagName) return void function s(e) {
            f.selection.save();
            for (var t = "OL" == e.tagName ? document.createElement("ol") : document.createElement("ul"); 0 < e.childNodes.length;) t.append(e.childNodes[0]);
            var n = document.createElement("li");
            t.style.listStyleType = "none", t.append(n), e.append(t), f.clean.lists(), f.selection.restore()
          }(a)
        }
        for (var o = 0; o < n.length; o++) "LI" == n[o].tagName ? (t = !0, r.push(n[o])) : "LI" == n[o].parentNode.tagName && (t = !0, r.push(n[o].parentNode));
        t && ("indent" == e ? l(r) : c(r))
      }
    }

    return {
      _init: function t() {
        f.events.on("commands.after", e), f.events.on("keydown", function (e) {
          if (e.which == xt.KEYCODE.TAB) {
            for (var t = f.selection.blocks(), n = [], r = 0; r < t.length; r++) "LI" == t[r].tagName ? n.push(t[r]) : "LI" == t[r].parentNode.tagName && n.push(t[r].parentNode);
            if (1 < n.length || n.length && (f.selection.info(n[0]).atStart || f.node.isEmpty(n[0]))) return e.preventDefault(), e.stopPropagation(), e.shiftKey ? c(n) : l(n), !1
          }
        }, !0)
      }, format: function s(e, t) {
        var n, r;
        for (f.html.syncInputs(), f.selection.save(), f.html.wrap(!0, !0, !0, !0), f.selection.restore(), r = f.selection.blocks(!0), n = 0; n < r.length; n++) "LI" != r[n].tagName && "LI" == r[n].parentNode.tagName && (r[n] = r[n].parentNode);
        if (f.selection.save(), function a(e, t) {
          for (var n = !0, r = 0; r < e.length; r++) {
            if ("LI" != e[r].tagName) return !1;
            e[r].parentNode.tagName != t && (n = !1)
          }
          return n
        }(r, e) ? t || i(r) : o(r, e), f.html.unwrap(), f.selection.restore(), t = t || "default") {
          for (r = f.selection.blocks(), n = 0; n < r.length; n++) "LI" != r[n].tagName && "LI" == r[n].parentNode.tagName && (r[n] = r[n].parentNode);
          for (n = 0; n < r.length; n++) "LI" == r[n].tagName && (p(r[n].parentNode).css("list-style-type", "default" === t ? "" : t), 0 === (p(r[n].parentNode).attr("style") || "").length && p(r[n].parentNode).removeAttr("style"))
        }
      }, refresh: function a(e, t) {
        var n = p(f.selection.element());
        if (n.get(0) != f.el) {
          var r = n.get(0);
          (r = "LI" != r.tagName && r.firstElementChild && "LI" != r.firstElementChild.tagName ? n.parents("li").get(0) : "LI" == r.tagName || r.firstElementChild ? r.firstElementChild && "LI" == r.firstElementChild.tagName ? n.get(0).firstChild : n.get(0) : n.parents("li").get(0)) && r.parentNode.tagName == t && f.el.contains(r.parentNode) && e.addClass("fr-active")
        }
      }
    }
  }, xt.DefineIcon("formatOLSimple", {
    NAME: "list-ol",
    SVG_KEY: "orderedList"
  }), xt.RegisterCommand("formatOLSimple", {
    title: "Ordered List",
    type: "button",
    options: {"default": "Default", circle: "Circle", disc: "Disc", square: "Square"},
    refresh: function (e) {
      this.lists.refresh(e, "OL")
    },
    callback: function (e, t) {
      this.lists.format("OL", t)
    },
    plugin: "lists"
  }), xt.RegisterCommand("formatUL", {
    title: "Unordered List", type: "button", hasOptions: function () {
      return this.opts.listAdvancedTypes
    }, options: {"default": "Default", circle: "Circle", disc: "Disc", square: "Square"}, refresh: function (e) {
      this.lists.refresh(e, "UL")
    }, callback: function (e, t) {
      this.lists.format("UL", t)
    }, plugin: "lists"
  }), xt.RegisterCommand("formatOL", {
    title: "Ordered List",
    hasOptions: function () {
      return this.opts.listAdvancedTypes
    },
    options: {
      "default": "Default",
      "lower-alpha": "Lower Alpha",
      "lower-greek": "Lower Greek",
      "lower-roman": "Lower Roman",
      "upper-alpha": "Upper Alpha",
      "upper-roman": "Upper Roman"
    },
    refresh: function (e) {
      this.lists.refresh(e, "OL")
    },
    callback: function (e, t) {
      this.lists.format("OL", t)
    },
    plugin: "lists"
  }), xt.DefineIcon("formatUL", {
    NAME: "list-ul",
    SVG_KEY: "unorderedList"
  }), xt.DefineIcon("formatOL", {
    NAME: "list-ol",
    SVG_KEY: "orderedList"
  }), Object.assign(xt.DEFAULTS, {
    paragraphFormat: {
      N: "Normal",
      H1: "Heading 1",
      H2: "Heading 2",
      H3: "Heading 3",
      H4: "Heading 4",
      PRE: "Code"
    }, paragraphFormatSelection: !1, paragraphDefaultSelection: "Paragraph Format"
  }), xt.PLUGINS.paragraphFormat = function (p) {
    var u = p.$;

    function h(e, t) {
      var n = p.html.defaultTag();
      if (t && t.toLowerCase() != n) if (0 < e.find("ul, ol").length) {
        var r = u("<" + t + ">");
        e.prepend(r);
        for (var a = p.node.contents(e.get(0))[0]; a && ["UL", "OL"].indexOf(a.tagName) < 0;) {
          var o = a.nextSibling;
          r.append(a), a = o
        }
      } else e.html("<" + t + ">" + e.html() + "</" + t + ">")
    }

    return {
      apply: function g(e) {
        "N" == e && (e = p.html.defaultTag()), p.selection.save(), p.html.wrap(!0, !0, !p.opts.paragraphFormat.BLOCKQUOTE, !0, !0), p.selection.restore();
        var t, n, r, a, o, i, s, l, c = p.selection.blocks();
        p.selection.save(), p.$el.find("pre").attr("skip", !0);
        for (var d = 0; d < c.length; d++) if (c[d].tagName != e && !p.node.isList(c[d])) {
          var f = u(c[d]);
          "LI" == c[d].tagName ? h(f, e) : "LI" == c[d].parentNode.tagName && c[d] ? (i = f, s = e, l = p.html.defaultTag(), s && s.toLowerCase() != l || (s = 'div class="fr-temp-div"'), i.replaceWith(u("<" + s + ">").html(i.html()))) : 0 <= ["TD", "TH"].indexOf(c[d].parentNode.tagName) ? (r = f, a = e, o = p.html.defaultTag(), a || (a = 'div class="fr-temp-div"' + (p.node.isEmpty(r.get(0), !0) ? ' data-empty="true"' : "")), a.toLowerCase() == o ? (p.node.isEmpty(r.get(0), !0) || r.append("<br/>"), r.replaceWith(r.html())) : r.replaceWith(u("<" + a + ">").html(r.html()))) : (t = f, (n = e) || (n = 'div class="fr-temp-div"' + (p.node.isEmpty(t.get(0), !0) ? ' data-empty="true"' : "")), "H1" != n && "H2" != n && "H3" != n && "H4" != n && "H5" != n || !p.node.attributes(t.get(0)).includes("font-size:") ? t.replaceWith(u("<" + n + " " + p.node.attributes(t.get(0)) + ">").html(t.html()).removeAttr("data-empty")) : t.replaceWith(u("<" + n + " " + p.node.attributes(t.get(0)).replace(/font-size:[0-9]+px;?/, "") + ">").html(t.html()).removeAttr("data-empty")))
        }
        p.$el.find('pre:not([skip="true"]) + pre:not([skip="true"])').each(function () {
          u(this).prev().append("<br>" + u(this).html()), u(this).remove()
        }), p.$el.find("pre").removeAttr("skip"), p.html.unwrap(), p.selection.restore()
      }, refreshOnShow: function i(e, t) {
        var n = p.selection.blocks();
        if (n.length) {
          var r = n[0], a = "N", o = p.html.defaultTag();
          r.tagName.toLowerCase() != o && r != p.el && (a = r.tagName), t.find('.fr-command[data-param1="' + a + '"]').addClass("fr-active").attr("aria-selected", !0)
        } else t.find('.fr-command[data-param1="N"]').addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function o(e) {
        if (p.opts.paragraphFormatSelection) {
          var t = p.selection.blocks();
          if (t.length) {
            var n = t[0], r = "N", a = p.html.defaultTag();
            n.tagName.toLowerCase() != a && n != p.el && (r = n.tagName), 0 <= ["LI", "TD", "TH"].indexOf(r) && (r = "N"), e.find(">span").text(p.language.translate(p.opts.paragraphFormat[r]))
          } else e.find(">span").text(p.language.translate(p.opts.paragraphFormat.N))
        }
      }
    }
  }, xt.RegisterCommand("paragraphFormat", {
    type: "dropdown", displaySelection: function (e) {
      return e.opts.paragraphFormatSelection
    }, defaultSelection: function (e) {
      return e.language.translate(e.opts.paragraphDefaultSelection)
    }, displaySelectionWidth: 80, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.paragraphFormat;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = this.shortcuts.get("paragraphFormat." + n);
        r = r ? '<span class="fr-shortcut">' + r + "</span>" : "", e += '<li role="presentation"><' + ("N" == n ? this.html.defaultTag() || "DIV" : n) + ' style="padding: 0 !important; margin: 0 !important; border: 0 !important; background-color: transparent !important; ' + ("PRE" == n || "N" == n ? "font-size: 15px" : "font-weight: bold !important; ") + ("H1" == n ? "font-size: 2em !important; " : "") + ("H2" == n ? "font-size: 1.5em !important; " : "") + ("H3" == n ? "font-size: 1.17em !important; " : "") + ("H4" == n ? "font-size: 15px !important;" : "") + '"  role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="' + n + '" title="' + this.language.translate(t[n]) + '">' + this.language.translate(t[n]) + "</a></" + ("N" == n ? this.html.defaultTag() || "DIV" : n) + "></li>"
      }
      return e += "</ul>"
    }, title: "Paragraph Format", callback: function (e, t) {
      this.paragraphFormat.apply(t)
    }, refresh: function (e) {
      this.paragraphFormat.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.paragraphFormat.refreshOnShow(e, t)
    }, plugin: "paragraphFormat"
  }), xt.DefineIcon("paragraphFormat", {
    NAME: "paragraph",
    SVG_KEY: "paragraphFormat"
  }), Object.assign(xt.DEFAULTS, {
    paragraphStyles: {
      "fr-text-gray": "Gray",
      "fr-text-bordered": "Bordered",
      "fr-text-spaced": "Spaced",
      "fr-text-uppercase": "Uppercase"
    }, paragraphMultipleStyles: !0
  }), xt.PLUGINS.paragraphStyle = function (s) {
    var l = s.$;
    return {
      _init: function e() {
      }, apply: function c(e, t, n) {
        void 0 === t && (t = s.opts.paragraphStyles), void 0 === n && (n = s.opts.paragraphMultipleStyles);
        var r = "";
        n || ((r = Object.keys(t)).splice(r.indexOf(e), 1), r = r.join(" ")), s.selection.save(), s.html.wrap(!0, !0, !0, !0), s.selection.restore();
        var a = s.selection.blocks();
        s.selection.save();
        for (var o = l(a[0]).hasClass(e), i = 0; i < a.length; i++) l(a[i]).removeClass(r).toggleClass(e, !o), l(a[i]).hasClass("fr-temp-div") && l(a[i]).removeClass("fr-temp-div"), "" === l(a[i]).attr("class") && l(a[i]).removeAttr("class");
        s.html.unwrap(), s.selection.restore()
      }, refreshOnShow: function a(e, t) {
        var n = s.selection.blocks();
        if (n.length) {
          var r = l(n[0]);
          t.find(".fr-command").each(function () {
            var e = l(this).data("param1"), t = r.hasClass(e);
            l(this).toggleClass("fr-active", t).attr("aria-selected", t)
          })
        }
      }
    }
  }, xt.RegisterCommand("paragraphStyle", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.paragraphStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command '.concat(n, '" tabIndex="-1" role="option" data-cmd="paragraphStyle" data-param1="').concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, title: "Paragraph Style", callback: function (e, t) {
      this.paragraphStyle.apply(t)
    }, refreshOnShow: function (e, t) {
      this.paragraphStyle.refreshOnShow(e, t)
    }, plugin: "paragraphStyle"
  }), xt.DefineIcon("paragraphStyle", {
    NAME: "magic",
    SVG_KEY: "paragraphStyle"
  }), Object.assign(xt.DEFAULTS, {html2pdf: window.html2pdf}), xt.PLUGINS.print = function (l) {
    return {
      run: function e() {
        !function s(e) {
          var t = l.html.get(), n = null;
          l.shared.print_iframe ? n = l.shared.print_iframe : ((n = document.createElement("iframe")).name = "fr-print", n.style.position = "fixed", n.style.top = "0", n.style.left = "-9999px", n.style.height = "100%", n.style.width = "0", n.style.overflow = "hidden", n.style["z-index"] = "2147483647", n.style.tabIndex = "-1", l.events.on("shared.destroy", function () {
            n.remove()
          }), l.shared.print_iframe = n);
          try {
            document.body.removeChild(n)
          } catch (i) {
          }
          document.body.appendChild(n);
          var r = function r() {
            e(), n.removeEventListener("load", r)
          };
          n.addEventListener("load", r);
          var a = n.contentWindow;
          a.document.open(), a.document.write("<!DOCTYPE html><html " + (l.opts.documentReady ? 'style="margin: 0; padding: 0;"' : "") + "><head><title>" + document.title + "</title>"), Array.prototype.forEach.call(document.querySelectorAll("style"), function (e) {
            e = e.cloneNode(!0), a.document.write(e.outerHTML)
          });
          var o = document.querySelectorAll("link[rel=stylesheet]");
          Array.prototype.forEach.call(o, function (e) {
            var t = document.createElement("link");
            t.rel = e.rel, t.href = e.href, t.media = "print", t.type = "text/css", t.media = "all", a.document.write(t.outerHTML)
          }), a.document.write('</head><body style="height:auto;text-align: ' + ("rtl" == l.opts.direction ? "right" : "left") + "; direction: " + l.opts.direction + "; " + (l.opts.documentReady ? " padding: 2cm; width: 17cm; margin: 0;" : "") + '"><div class="fr-view">'), a.document.write(t), a.document.write("</div></body></html>"), a.document.close()
        }(function () {
          setTimeout(function () {
            l.events.disableBlur(), window.frames["fr-print"].focus(), window.frames["fr-print"].print(), l.$win.get(0).focus(), l.events.disableBlur(), l.events.focus()
          }, 0)
        })
      }, toPDF: function t() {
        l.opts.html2pdf && (l.$el.css("text-align", "left"), l.opts.html2pdf().set({
          margin: [10, 20],
          html2canvas: {useCORS: !0}
        }).from(l.el).save(), setTimeout(function () {
          l.$el.css("text-align", "")
        }, 100))
      }
    }
  }, xt.DefineIcon("print", {NAME: "print", SVG_KEY: "print"}), xt.RegisterCommand("print", {
    title: "Print",
    undo: !1,
    focus: !1,
    plugin: "print",
    callback: function () {
      this.print.run()
    }
  }), xt.DefineIcon("getPDF", {
    NAME: "file-pdf-o",
    FA5NAME: "file-pdf",
    SVG_KEY: "pdfExport"
  }), xt.RegisterCommand("getPDF", {
    title: "Download PDF", type: "button", focus: !1, undo: !1, callback: function () {
      this.print.toPDF()
    }
  }), Object.assign(xt.DEFAULTS, {
    quickInsertButtons: ["image", "video", "embedly", "table", "ul", "ol", "hr"],
    quickInsertTags: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6", "pre", "blockquote"],
    quickInsertEnabled: !0
  }), xt.QUICK_INSERT_BUTTONS = {}, xt.DefineIcon("quickInsert", {
    SVG_KEY: "add",
    template: "svg"
  }), xt.RegisterQuickInsertButton = function (e, t) {
    xt.QUICK_INSERT_BUTTONS[e] = Object.assign({undo: !0}, t)
  }, xt.RegisterQuickInsertButton("image", {
    icon: "insertImage",
    requiredPlugin: "image",
    title: "Insert Image",
    undo: !1,
    callback: function () {
      var e = this, t = e.$;
      e.shared.$qi_image_input || (e.shared.$qi_image_input = t(document.createElement("input")).attr("accept", "image/" + e.opts.imageAllowedTypes.join(", image/").toLowerCase()).attr("name", "quickInsertImage".concat(this.id)).attr("style", "display: none;").attr("type", "file"), t("body").first().append(e.shared.$qi_image_input), e.events.$on(e.shared.$qi_image_input, "change", function () {
        var e = t(this).data("inst");
        this.files && (e.quickInsert.hide(), e.image.upload(this.files)), t(this).val("")
      }, !0)), e.$qi_image_input = e.shared.$qi_image_input, e.helpers.isMobile() && e.selection.save(), e.events.disableBlur(), e.$qi_image_input.data("inst", e)[0].click()
    }
  }), xt.RegisterQuickInsertButton("video", {
    icon: "insertVideo",
    requiredPlugin: "video",
    title: "Insert Video",
    undo: !1,
    callback: function () {
      var e = prompt(this.language.translate("Paste the URL of the video you want to insert."));
      e && this.video.insertByURL(e)
    }
  }), xt.RegisterQuickInsertButton("embedly", {
    icon: "embedly",
    requiredPlugin: "embedly",
    title: "Embed URL",
    undo: !1,
    callback: function () {
      var e = prompt(this.language.translate("Paste the URL of any web content you want to insert."));
      e && this.embedly.add(e)
    }
  }), xt.RegisterQuickInsertButton("table", {
    icon: "insertTable",
    requiredPlugin: "table",
    title: "Insert Table",
    callback: function () {
      this.table.insert(2, 2)
    }
  }), xt.RegisterQuickInsertButton("ol", {
    icon: "formatOL",
    requiredPlugin: "lists",
    title: "Ordered List",
    callback: function () {
      this.lists.format("OL")
    }
  }), xt.RegisterQuickInsertButton("ul", {
    icon: "formatUL",
    requiredPlugin: "lists",
    title: "Unordered List",
    callback: function () {
      this.lists.format("UL")
    }
  }), xt.RegisterQuickInsertButton("hr", {
    icon: "insertHR", title: "Insert Horizontal Line", callback: function () {
      this.commands.insertHR()
    }
  }), xt.PLUGINS.quickInsert = function (i) {
    var s, l, c = i.$, d = !1;

    function n(e) {
      var t, n, r;
      (t = e.offset().top - i.$box.offset().top, n = (i.$iframe && i.$iframe.offset().left || 0) + e.offset().left - e.position().left - 4 < s.outerWidth() ? e.offset().left + s.outerWidth() : 0 - s.outerWidth(), i.opts.enter != xt.ENTER_BR) ? r = (s.outerHeight() - e.outerHeight()) / 2 : (c(document.createElement("span")).html(xt.INVISIBLE_SPACE).insertAfter(e), r = (s.outerHeight() - e.next().outerHeight()) / 2, e.next().remove());
      if (i.opts.iframe) {
        var a = i.helpers.getPX(i.$wp.find(".fr-iframe").css("padding-top"));
        t += i.$iframe.offset().top + a
      }
      s.hasClass("fr-on") && 0 <= t && l.css("top", t - r), 0 <= t && t - Math.abs(r) <= i.$box.outerHeight() - e.outerHeight() ? (s.hasClass("fr-hidden") && (s.hasClass("fr-on") && f(), s.removeClass("fr-hidden")), s.css("top", t - r)) : s.hasClass("fr-visible") && !i.opts.toolbarInline && (s.addClass("fr-hidden"), p()), s.css("left", n)
    }

    function a(e) {
      i.markdown && i.markdown.isEnabled() || (s || function t() {
        i.shared.$quick_insert || (i.shared.$quick_insert = c(document.createElement("div")).attr("class", "fr-quick-insert").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(i.language.translate("Quick Insert"), '">').concat(i.icon.create("quickInsert"), "</a>")));
        s = i.shared.$quick_insert, i.tooltip.bind(i.$box, ".fr-quick-insert > a.fr-floating-btn"), i.events.on("destroy", function () {
          c("body").first().append(s.removeClass("fr-on")), l && (p(), c("body").first().append(l.css("left", -9999).css("top", -9999)))
        }, !0), i.events.on("shared.destroy", function () {
          s.html("").removeData().remove(), s = null, l && (l.html("").removeData().remove(), l = null)
        }, !0), i.events.on("commands.before", o), i.events.on("commands.after", function () {
          i.popups.areVisible() || r()
        }), i.events.bindClick(i.$box, ".fr-quick-insert > a", f), i.events.bindClick(i.$box, ".fr-qi-helper > a.fr-btn", function (e) {
          var t = c(e.currentTarget).data("cmd");
          if (!1 === i.events.trigger("quickInsert.commands.before", [t])) return !1;
          xt.QUICK_INSERT_BUTTONS[t].callback.apply(i, [e.currentTarget]), xt.QUICK_INSERT_BUTTONS[t].undo && i.undo.saveStep(), i.events.trigger("quickInsert.commands.after", [t]), i.quickInsert.hide()
        }), i.events.$on(i.$wp, "scroll", u), i.events.$on(i.$tb, "transitionend", ".fr-more-toolbar", u)
      }(), s.hasClass("fr-on") && p(), i.$box.append(s), n(e), s.data("tag", e), s.addClass("fr-visible"))
    }

    function r() {
      if (i.core.hasFocus()) {
        var e = i.selection.element();
        if (i.opts.enter == xt.ENTER_BR || i.node.isBlock(e) || (e = i.node.blockParent(e)), i.opts.enter == xt.ENTER_BR && !i.node.isBlock(e)) {
          var t = i.node.deepestParent(e);
          t && (e = t)
        }
        var n = function n() {
          return i.opts.enter != xt.ENTER_BR && i.node.isEmpty(e) && 0 <= i.opts.quickInsertTags.indexOf(e.tagName.toLowerCase())
        }, r = function r() {
          return i.opts.enter == xt.ENTER_BR && ("BR" == e.tagName && (!e.previousSibling || "BR" == e.previousSibling.tagName || i.node.isBlock(e.previousSibling)) || i.node.isEmpty(e) && (!e.previousSibling || "BR" == e.previousSibling.tagName || i.node.isBlock(e.previousSibling)) && (!e.nextSibling || "BR" == e.nextSibling.tagName || i.node.isBlock(e.nextSibling)))
        };
        e && (n() || r()) ? s && s.data("tag").is(c(e)) && s.hasClass("fr-on") ? p() : i.selection.isCollapsed() && a(c(e)) : o()
      }
    }

    function o() {
      s && !d && (s.hasClass("fr-on") && p(), s.removeClass("fr-visible fr-on"), s.css("left", -9999).css("top", -9999))
    }

    function f(e) {
      if (e && e.preventDefault(), s.hasClass("fr-on") && !s.hasClass("fr-hidden")) p(); else {
        if (!i.shared.$qi_helper) {
          for (var t = i.opts.quickInsertButtons, n = '<div class="fr-qi-helper">', r = 0, a = 0; a < t.length; a++) {
            var o = xt.QUICK_INSERT_BUTTONS[t[a]];
            o && (!o.requiredPlugin || xt.PLUGINS[o.requiredPlugin] && 0 <= i.opts.pluginsEnabled.indexOf(o.requiredPlugin)) && (n += '<a class="fr-btn fr-floating-btn" role="button" title="'.concat(i.language.translate(o.title), '" tabIndex="-1" data-cmd="').concat(t[a], '" style="transition-delay: ').concat(.025 * r++, 's;">').concat(i.icon.create(o.icon), "</a>"))
          }
          n += "</div>", i.shared.$qi_helper = c(n), i.tooltip.bind(i.shared.$qi_helper, "a.fr-btn"), i.events.$on(i.shared.$qi_helper, "mousedown", function (e) {
            e.preventDefault()
          }, !0)
        }
        l = i.shared.$qi_helper, i.$box.append(l), d = !0, setTimeout(function () {
          d = !1, l.css("top", parseFloat(s.css("top"))), l.css("left", parseFloat(s.css("left")) + s.outerWidth()), l.find("a").addClass("fr-size-1"), s.addClass("fr-on")
        }, 10)
      }
    }

    function p() {
      var n = i.$box.find(".fr-qi-helper");
      n.length && function () {
        for (var t = n.find("a"), e = 0; e < t.length; e++) !function (e) {
          setTimeout(function () {
            n.children().eq(t.length - 1 - e).removeClass("fr-size-1")
          }, 25 * e)
        }(e);
        setTimeout(function () {
          n.css("left", -9999), s && !s.hasClass("fr-hidden") && s.removeClass("fr-on")
        }, 25 * e)
      }()
    }

    function u() {
      s.hasClass("fr-visible") && n(s.data("tag"))
    }

    return {
      _init: function e() {
        if (!i.$wp || !i.opts.quickInsertEnabled) return !1;
        i.popups.onShow("image.edit", o), i.events.on("mouseup", r), i.helpers.isMobile() && i.events.$on(c(i.o_doc), "selectionchange", r), i.events.on("blur", o), i.events.on("keyup", r), i.events.on("keydown", function () {
          setTimeout(function () {
            r()
          }, 0)
        })
      }, hide: o
    }
  }, xt.PLUGINS.quote = function (o) {
    var i = o.$;

    function s(e) {
      for (; e.parentNode && e.parentNode != o.el;) e = e.parentNode;
      return e
    }

    return {
      apply: function t(e) {
        o.selection.save(), o.html.wrap(!0, !0, !0, !0), o.selection.restore(), "increase" == e ? function r() {
          o.html.unwrap();
          var e, t = o.selection.blocks();
          for (e = 0; e < t.length; e++) t[e] = s(t[e]);
          o.selection.save();
          var n = i(document.createElement("blockquote"));
          for (n.insertBefore(t[0]), e = 0; e < t.length; e++) n.append(t[e]);
          o.opts.trackChangesEnabled && o.track_changes.addQuote(n), o.selection.isCollapsed() || o.selection.restore()
        }() : "decrease" == e && function a() {
          var e = o.opts.trackChangesEnabled;
          o.html.unwrap();
          var t, n = o.selection.blocks();
          for (t = 0; t < n.length; t++) "BLOCKQUOTE" != n[t].tagName && (n[t] = e && i(n[t]).parentsUntil(o.$el, "[data-track-id^=pending]").get(0) || i(n[t]).parentsUntil(o.$el, "BLOCKQUOTE").get(0));
          for (o.selection.save(), t = 0; t < n.length; t++) n[t] && (e ? o.track_changes.removeQuote(i(n[t]), t) : i(n[t]).replaceWith(n[t].innerHTML));
          o.selection.isCollapsed() || o.selection.restore()
        }()
      }
    }
  }, xt.RegisterShortcut(xt.KEYCODE.SINGLE_QUOTE, "quote", "increase", "'"), xt.RegisterShortcut(xt.KEYCODE.SINGLE_QUOTE, "quote", "decrease", "'", !0), xt.RegisterCommand("quote", {
    title: "Quote",
    type: "dropdown",
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = {increase: "Increase", decrease: "Decrease"};
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = this.shortcuts.get("quote.".concat(n));
        e += '<li role="presentation"><a class="fr-command fr-active '.concat(n, '" tabIndex="-1" role="option" data-cmd="quote" data-param1="').concat(n, '" title="').concat(t[n], '">').concat(this.language.translate(t[n])).concat(r ? '<span class="fr-shortcut">'.concat(r, "</span>") : "", "</a></li>")
      }
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.quote.apply(t)
    },
    plugin: "quote"
  }), xt.DefineIcon("quote", {
    NAME: "quote-left",
    SVG_KEY: "blockquote"
  }), Object.assign(xt.DEFAULTS, {
    saveInterval: 1e4,
    saveURL: null,
    saveParams: {},
    saveParam: "body",
    saveMethod: "POST"
  }), xt.PLUGINS.save = function (s) {
    var l = s.$, r = null, c = null, t = !1, d = 1, f = 2, n = {};

    function p(e, t) {
      s.events.trigger("save.error", [{code: e, message: n[e]}, t])
    }

    function a(e) {
      void 0 === e && (e = s.html.get());
      var r = e, t = s.events.trigger("save.before", [e]);
      if (!1 === t) return !1;
      if ("string" == typeof t && (e = t), s.opts.saveURL) {
        var n = {};
        for (var a in s.opts.saveParams) if (s.opts.saveParams.hasOwnProperty(a)) {
          var o = s.opts.saveParams[a];
          n[a] = "function" == typeof o ? o.call(this) : o
        }
        var i = {};
        i[s.opts.saveParam] = e, l(this).ajax({
          method: s.opts.saveMethod,
          url: s.opts.saveURL,
          data: Object.assign(i, n),
          crossDomain: s.opts.requestWithCORS,
          withCredentials: s.opts.requestWithCredentials,
          headers: s.opts.requestHeaders,
          done: function (e, t, n) {
            c = r, s.events.trigger("save.after", [e])
          },
          fail: function (e) {
            p(f, e.response || e.responseText)
          }
        })
      } else p(d)
    }

    function o() {
      clearTimeout(r), r = setTimeout(function () {
        var e = s.html.get();
        (c != e || t) && (t = !1, a(c = e))
      }, 0)
    }

    return n[d] = "Missing saveURL option.", n[f] = "Something went wrong during save.", {
      _init: function i() {
        if (s.opts.letteringClass) for (var e = s.opts.letteringClass, t = s.$el.find(".".concat(e)).length, n = 0; n < t; n++) s.$el.find(".".concat(e))[n].innerHTML = s.$el.find(".".concat(e))[n].innerText.replace(/([\w'-]+|[?.",])/g, "<span class = 'fr-word-select'>$1</span>");
        s.opts.saveInterval && (c = s.html.get(), s.events.on("contentChanged", function () {
          setTimeout(o, s.opts.saveInterval)
        }), s.events.on("keydown destroy", function () {
          clearTimeout(r)
        }))
      }, save: a, reset: function e() {
        o(), t = !1
      }, force: function u() {
        t = !0
      }
    }
  }, xt.DefineIcon("save", {NAME: "floppy-o", FA5NAME: "save"}), xt.RegisterCommand("save", {
    title: "Save",
    undo: !1,
    focus: !1,
    refreshAfterCallback: !1,
    callback: function () {
      this.save.save()
    },
    plugin: "save"
  }), Object.assign(xt.DEFAULTS, {
    specialCharactersSets: [{
      title: "Latin",
      "char": "&iexcl;",
      list: [{"char": "&iexcl;", desc: "INVERTED EXCLAMATION MARK"}, {
        "char": "&cent;",
        desc: "CENT SIGN"
      }, {"char": "&pound;", desc: "POUND SIGN"}, {"char": "&curren;", desc: "CURRENCY SIGN"}, {
        "char": "&yen;",
        desc: "YEN SIGN"
      }, {"char": "&brvbar;", desc: "BROKEN BAR"}, {"char": "&sect;", desc: "SECTION SIGN"}, {
        "char": "&uml;",
        desc: "DIAERESIS"
      }, {"char": "&copy;", desc: "COPYRIGHT SIGN"}, {"char": "&trade;", desc: "TRADEMARK SIGN"}, {
        "char": "&ordf;",
        desc: "FEMININE ORDINAL INDICATOR"
      }, {"char": "&laquo;", desc: "LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"}, {
        "char": "&not;",
        desc: "NOT SIGN"
      }, {"char": "&reg;", desc: "REGISTERED SIGN"}, {"char": "&macr;", desc: "MACRON"}, {
        "char": "&deg;",
        desc: "DEGREE SIGN"
      }, {"char": "&plusmn;", desc: "PLUS-MINUS SIGN"}, {"char": "&sup2;", desc: "SUPERSCRIPT TWO"}, {
        "char": "&sup3;",
        desc: "SUPERSCRIPT THREE"
      }, {"char": "&acute;", desc: "ACUTE ACCENT"}, {"char": "&micro;", desc: "MICRO SIGN"}, {
        "char": "&para;",
        desc: "PILCROW SIGN"
      }, {"char": "&middot;", desc: "MIDDLE DOT"}, {"char": "&cedil;", desc: "CEDILLA"}, {
        "char": "&sup1;",
        desc: "SUPERSCRIPT ONE"
      }, {"char": "&ordm;", desc: "MASCULINE ORDINAL INDICATOR"}, {
        "char": "&raquo;",
        desc: "RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"
      }, {"char": "&frac14;", desc: "VULGAR FRACTION ONE QUARTER"}, {
        "char": "&frac12;",
        desc: "VULGAR FRACTION ONE HALF"
      }, {"char": "&frac34;", desc: "VULGAR FRACTION THREE QUARTERS"}, {
        "char": "&iquest;",
        desc: "INVERTED QUESTION MARK"
      }, {"char": "&Agrave;", desc: "LATIN CAPITAL LETTER A WITH GRAVE"}, {
        "char": "&Aacute;",
        desc: "LATIN CAPITAL LETTER A WITH ACUTE"
      }, {"char": "&Acirc;", desc: "LATIN CAPITAL LETTER A WITH CIRCUMFLEX"}, {
        "char": "&Atilde;",
        desc: "LATIN CAPITAL LETTER A WITH TILDE"
      }, {"char": "&Auml;", desc: "LATIN CAPITAL LETTER A WITH DIAERESIS "}, {
        "char": "&Aring;",
        desc: "LATIN CAPITAL LETTER A WITH RING ABOVE"
      }, {"char": "&AElig;", desc: "LATIN CAPITAL LETTER AE"}, {
        "char": "&Ccedil;",
        desc: "LATIN CAPITAL LETTER C WITH CEDILLA"
      }, {"char": "&Egrave;", desc: "LATIN CAPITAL LETTER E WITH GRAVE"}, {
        "char": "&Eacute;",
        desc: "LATIN CAPITAL LETTER E WITH ACUTE"
      }, {"char": "&Ecirc;", desc: "LATIN CAPITAL LETTER E WITH CIRCUMFLEX"}, {
        "char": "&Euml;",
        desc: "LATIN CAPITAL LETTER E WITH DIAERESIS"
      }, {"char": "&Igrave;", desc: "LATIN CAPITAL LETTER I WITH GRAVE"}, {
        "char": "&Iacute;",
        desc: "LATIN CAPITAL LETTER I WITH ACUTE"
      }, {"char": "&Icirc;", desc: "LATIN CAPITAL LETTER I WITH CIRCUMFLEX"}, {
        "char": "&Iuml;",
        desc: "LATIN CAPITAL LETTER I WITH DIAERESIS"
      }, {"char": "&ETH;", desc: "LATIN CAPITAL LETTER ETH"}, {
        "char": "&Ntilde;",
        desc: "LATIN CAPITAL LETTER N WITH TILDE"
      }, {"char": "&Ograve;", desc: "LATIN CAPITAL LETTER O WITH GRAVE"}, {
        "char": "&Oacute;",
        desc: "LATIN CAPITAL LETTER O WITH ACUTE"
      }, {"char": "&Ocirc;", desc: "LATIN CAPITAL LETTER O WITH CIRCUMFLEX"}, {
        "char": "&Otilde;",
        desc: "LATIN CAPITAL LETTER O WITH TILDE"
      }, {"char": "&Ouml;", desc: "LATIN CAPITAL LETTER O WITH DIAERESIS"}, {
        "char": "&times;",
        desc: "MULTIPLICATION SIGN"
      }, {"char": "&Oslash;", desc: "LATIN CAPITAL LETTER O WITH STROKE"}, {
        "char": "&Ugrave;",
        desc: "LATIN CAPITAL LETTER U WITH GRAVE"
      }, {"char": "&Uacute;", desc: "LATIN CAPITAL LETTER U WITH ACUTE"}, {
        "char": "&Ucirc;",
        desc: "LATIN CAPITAL LETTER U WITH CIRCUMFLEX"
      }, {"char": "&Uuml;", desc: "LATIN CAPITAL LETTER U WITH DIAERESIS"}, {
        "char": "&Yacute;",
        desc: "LATIN CAPITAL LETTER Y WITH ACUTE"
      }, {"char": "&THORN;", desc: "LATIN CAPITAL LETTER THORN"}, {
        "char": "&szlig;",
        desc: "LATIN SMALL LETTER SHARP S"
      }, {"char": "&agrave;", desc: "LATIN SMALL LETTER A WITH GRAVE"}, {
        "char": "&aacute;",
        desc: "LATIN SMALL LETTER A WITH ACUTE "
      }, {"char": "&acirc;", desc: "LATIN SMALL LETTER A WITH CIRCUMFLEX"}, {
        "char": "&atilde;",
        desc: "LATIN SMALL LETTER A WITH TILDE"
      }, {"char": "&auml;", desc: "LATIN SMALL LETTER A WITH DIAERESIS"}, {
        "char": "&aring;",
        desc: "LATIN SMALL LETTER A WITH RING ABOVE"
      }, {"char": "&aelig;", desc: "LATIN SMALL LETTER AE"}, {
        "char": "&ccedil;",
        desc: "LATIN SMALL LETTER C WITH CEDILLA"
      }, {"char": "&egrave;", desc: "LATIN SMALL LETTER E WITH GRAVE"}, {
        "char": "&eacute;",
        desc: "LATIN SMALL LETTER E WITH ACUTE"
      }, {"char": "&ecirc;", desc: "LATIN SMALL LETTER E WITH CIRCUMFLEX"}, {
        "char": "&euml;",
        desc: "LATIN SMALL LETTER E WITH DIAERESIS"
      }, {"char": "&igrave;", desc: "LATIN SMALL LETTER I WITH GRAVE"}, {
        "char": "&iacute;",
        desc: "LATIN SMALL LETTER I WITH ACUTE"
      }, {"char": "&icirc;", desc: "LATIN SMALL LETTER I WITH CIRCUMFLEX"}, {
        "char": "&iuml;",
        desc: "LATIN SMALL LETTER I WITH DIAERESIS"
      }, {"char": "&eth;", desc: "LATIN SMALL LETTER ETH"}, {
        "char": "&ntilde;",
        desc: "LATIN SMALL LETTER N WITH TILDE"
      }, {"char": "&ograve;", desc: "LATIN SMALL LETTER O WITH GRAVE"}, {
        "char": "&oacute;",
        desc: "LATIN SMALL LETTER O WITH ACUTE"
      }, {"char": "&ocirc;", desc: "LATIN SMALL LETTER O WITH CIRCUMFLEX"}, {
        "char": "&otilde;",
        desc: "LATIN SMALL LETTER O WITH TILDE"
      }, {"char": "&ouml;", desc: "LATIN SMALL LETTER O WITH DIAERESIS"}, {
        "char": "&divide;",
        desc: "DIVISION SIGN"
      }, {"char": "&oslash;", desc: "LATIN SMALL LETTER O WITH STROKE"}, {
        "char": "&ugrave;",
        desc: "LATIN SMALL LETTER U WITH GRAVE"
      }, {"char": "&uacute;", desc: "LATIN SMALL LETTER U WITH ACUTE"}, {
        "char": "&ucirc;",
        desc: "LATIN SMALL LETTER U WITH CIRCUMFLEX"
      }, {"char": "&uuml;", desc: "LATIN SMALL LETTER U WITH DIAERESIS"}, {
        "char": "&yacute;",
        desc: "LATIN SMALL LETTER Y WITH ACUTE"
      }, {"char": "&thorn;", desc: "LATIN SMALL LETTER THORN"}, {
        "char": "&yuml;",
        desc: "LATIN SMALL LETTER Y WITH DIAERESIS"
      }]
    }, {
      title: "Greek",
      "char": "&Alpha;",
      list: [{"char": "&Alpha;", desc: "GREEK CAPITAL LETTER ALPHA"}, {
        "char": "&Beta;",
        desc: "GREEK CAPITAL LETTER BETA"
      }, {"char": "&Gamma;", desc: "GREEK CAPITAL LETTER GAMMA"}, {
        "char": "&Delta;",
        desc: "GREEK CAPITAL LETTER DELTA"
      }, {"char": "&Epsilon;", desc: "GREEK CAPITAL LETTER EPSILON"}, {
        "char": "&Zeta;",
        desc: "GREEK CAPITAL LETTER ZETA"
      }, {"char": "&Eta;", desc: "GREEK CAPITAL LETTER ETA"}, {
        "char": "&Theta;",
        desc: "GREEK CAPITAL LETTER THETA"
      }, {"char": "&Iota;", desc: "GREEK CAPITAL LETTER IOTA"}, {
        "char": "&Kappa;",
        desc: "GREEK CAPITAL LETTER KAPPA"
      }, {"char": "&Lambda;", desc: "GREEK CAPITAL LETTER LAMBDA"}, {
        "char": "&Mu;",
        desc: "GREEK CAPITAL LETTER MU"
      }, {"char": "&Nu;", desc: "GREEK CAPITAL LETTER NU"}, {
        "char": "&Xi;",
        desc: "GREEK CAPITAL LETTER XI"
      }, {"char": "&Omicron;", desc: "GREEK CAPITAL LETTER OMICRON"}, {
        "char": "&Pi;",
        desc: "GREEK CAPITAL LETTER PI"
      }, {"char": "&Rho;", desc: "GREEK CAPITAL LETTER RHO"}, {
        "char": "&Sigma;",
        desc: "GREEK CAPITAL LETTER SIGMA"
      }, {"char": "&Tau;", desc: "GREEK CAPITAL LETTER TAU"}, {
        "char": "&Upsilon;",
        desc: "GREEK CAPITAL LETTER UPSILON"
      }, {"char": "&Phi;", desc: "GREEK CAPITAL LETTER PHI"}, {
        "char": "&Chi;",
        desc: "GREEK CAPITAL LETTER CHI"
      }, {"char": "&Psi;", desc: "GREEK CAPITAL LETTER PSI"}, {
        "char": "&Omega;",
        desc: "GREEK CAPITAL LETTER OMEGA"
      }, {"char": "&alpha;", desc: "GREEK SMALL LETTER ALPHA"}, {
        "char": "&beta;",
        desc: "GREEK SMALL LETTER BETA"
      }, {"char": "&gamma;", desc: "GREEK SMALL LETTER GAMMA"}, {
        "char": "&delta;",
        desc: "GREEK SMALL LETTER DELTA"
      }, {"char": "&epsilon;", desc: "GREEK SMALL LETTER EPSILON"}, {
        "char": "&zeta;",
        desc: "GREEK SMALL LETTER ZETA"
      }, {"char": "&eta;", desc: "GREEK SMALL LETTER ETA"}, {
        "char": "&theta;",
        desc: "GREEK SMALL LETTER THETA"
      }, {"char": "&iota;", desc: "GREEK SMALL LETTER IOTA"}, {
        "char": "&kappa;",
        desc: "GREEK SMALL LETTER KAPPA"
      }, {"char": "&lambda;", desc: "GREEK SMALL LETTER LAMBDA"}, {
        "char": "&mu;",
        desc: "GREEK SMALL LETTER MU"
      }, {"char": "&nu;", desc: "GREEK SMALL LETTER NU"}, {
        "char": "&xi;",
        desc: "GREEK SMALL LETTER XI"
      }, {"char": "&omicron;", desc: "GREEK SMALL LETTER OMICRON"}, {
        "char": "&pi;",
        desc: "GREEK SMALL LETTER PI"
      }, {"char": "&rho;", desc: "GREEK SMALL LETTER RHO"}, {
        "char": "&sigmaf;",
        desc: "GREEK SMALL LETTER FINAL SIGMA"
      }, {"char": "&sigma;", desc: "GREEK SMALL LETTER SIGMA"}, {
        "char": "&tau;",
        desc: "GREEK SMALL LETTER TAU"
      }, {"char": "&upsilon;", desc: "GREEK SMALL LETTER UPSILON"}, {
        "char": "&phi;",
        desc: "GREEK SMALL LETTER PHI"
      }, {"char": "&chi;", desc: "GREEK SMALL LETTER CHI"}, {
        "char": "&psi;",
        desc: "GREEK SMALL LETTER PSI"
      }, {"char": "&omega;", desc: "GREEK SMALL LETTER OMEGA"}, {
        "char": "&thetasym;",
        desc: "GREEK THETA SYMBOL"
      }, {"char": "&upsih;", desc: "GREEK UPSILON WITH HOOK SYMBOL"}, {
        "char": "&straightphi;",
        desc: "GREEK PHI SYMBOL"
      }, {"char": "&piv;", desc: "GREEK PI SYMBOL"}, {
        "char": "&Gammad;",
        desc: "GREEK LETTER DIGAMMA"
      }, {"char": "&gammad;", desc: "GREEK SMALL LETTER DIGAMMA"}, {
        "char": "&varkappa;",
        desc: "GREEK KAPPA SYMBOL"
      }, {"char": "&varrho;", desc: "GREEK RHO SYMBOL"}, {
        "char": "&straightepsilon;",
        desc: "GREEK LUNATE EPSILON SYMBOL"
      }, {"char": "&backepsilon;", desc: "GREEK REVERSED LUNATE EPSILON SYMBOL"}]
    }, {
      title: "Cyrillic",
      "char": "&#x400",
      list: [{"char": "&#x400", desc: "CYRILLIC CAPITAL LETTER IE WITH GRAVE"}, {
        "char": "&#x401",
        desc: "CYRILLIC CAPITAL LETTER IO"
      }, {"char": "&#x402", desc: "CYRILLIC CAPITAL LETTER DJE"}, {
        "char": "&#x403",
        desc: "CYRILLIC CAPITAL LETTER GJE"
      }, {"char": "&#x404", desc: "CYRILLIC CAPITAL LETTER UKRAINIAN IE"}, {
        "char": "&#x405",
        desc: "CYRILLIC CAPITAL LETTER DZE"
      }, {"char": "&#x406", desc: "CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"}, {
        "char": "&#x407",
        desc: "CYRILLIC CAPITAL LETTER YI"
      }, {"char": "&#x408", desc: "CYRILLIC CAPITAL LETTER JE"}, {
        "char": "&#x409",
        desc: "CYRILLIC CAPITAL LETTER LJE"
      }, {"char": "&#x40A", desc: "CYRILLIC CAPITAL LETTER NJE"}, {
        "char": "&#x40B",
        desc: "CYRILLIC CAPITAL LETTER TSHE"
      }, {"char": "&#x40C", desc: "CYRILLIC CAPITAL LETTER KJE"}, {
        "char": "&#x40D",
        desc: "CYRILLIC CAPITAL LETTER I WITH GRAVE"
      }, {"char": "&#x40E", desc: "CYRILLIC CAPITAL LETTER SHORT U"}, {
        "char": "&#x40F",
        desc: "CYRILLIC CAPITAL LETTER DZHE"
      }, {"char": "&#x410", desc: "CYRILLIC CAPITAL LETTER A"}, {
        "char": "&#x411",
        desc: "CYRILLIC CAPITAL LETTER BE"
      }, {"char": "&#x412", desc: "CYRILLIC CAPITAL LETTER VE"}, {
        "char": "&#x413",
        desc: "CYRILLIC CAPITAL LETTER GHE"
      }, {"char": "&#x414", desc: "CYRILLIC CAPITAL LETTER DE"}, {
        "char": "&#x415",
        desc: "CYRILLIC CAPITAL LETTER IE"
      }, {"char": "&#x416", desc: "CYRILLIC CAPITAL LETTER ZHE"}, {
        "char": "&#x417",
        desc: "CYRILLIC CAPITAL LETTER ZE"
      }, {"char": "&#x418", desc: "CYRILLIC CAPITAL LETTER I"}, {
        "char": "&#x419",
        desc: "CYRILLIC CAPITAL LETTER SHORT I"
      }, {"char": "&#x41A", desc: "CYRILLIC CAPITAL LETTER KA"}, {
        "char": "&#x41B",
        desc: "CYRILLIC CAPITAL LETTER EL"
      }, {"char": "&#x41C", desc: "CYRILLIC CAPITAL LETTER EM"}, {
        "char": "&#x41D",
        desc: "CYRILLIC CAPITAL LETTER EN"
      }, {"char": "&#x41E", desc: "CYRILLIC CAPITAL LETTER O"}, {
        "char": "&#x41F",
        desc: "CYRILLIC CAPITAL LETTER PE"
      }, {"char": "&#x420", desc: "CYRILLIC CAPITAL LETTER ER"}, {
        "char": "&#x421",
        desc: "CYRILLIC CAPITAL LETTER ES"
      }, {"char": "&#x422", desc: "CYRILLIC CAPITAL LETTER TE"}, {
        "char": "&#x423",
        desc: "CYRILLIC CAPITAL LETTER U"
      }, {"char": "&#x424", desc: "CYRILLIC CAPITAL LETTER EF"}, {
        "char": "&#x425",
        desc: "CYRILLIC CAPITAL LETTER HA"
      }, {"char": "&#x426", desc: "CYRILLIC CAPITAL LETTER TSE"}, {
        "char": "&#x427",
        desc: "CYRILLIC CAPITAL LETTER CHE"
      }, {"char": "&#x428", desc: "CYRILLIC CAPITAL LETTER SHA"}, {
        "char": "&#x429",
        desc: "CYRILLIC CAPITAL LETTER SHCHA"
      }, {"char": "&#x42A", desc: "CYRILLIC CAPITAL LETTER HARD SIGN"}, {
        "char": "&#x42B",
        desc: "CYRILLIC CAPITAL LETTER YERU"
      }, {"char": "&#x42C", desc: "CYRILLIC CAPITAL LETTER SOFT SIGN"}, {
        "char": "&#x42D",
        desc: "CYRILLIC CAPITAL LETTER E"
      }, {"char": "&#x42E", desc: "CYRILLIC CAPITAL LETTER YU"}, {
        "char": "&#x42F",
        desc: "CYRILLIC CAPITAL LETTER YA"
      }, {"char": "&#x430", desc: "CYRILLIC SMALL LETTER A"}, {
        "char": "&#x431",
        desc: "CYRILLIC SMALL LETTER BE"
      }, {"char": "&#x432", desc: "CYRILLIC SMALL LETTER VE"}, {
        "char": "&#x433",
        desc: "CYRILLIC SMALL LETTER GHE"
      }, {"char": "&#x434", desc: "CYRILLIC SMALL LETTER DE"}, {
        "char": "&#x435",
        desc: "CYRILLIC SMALL LETTER IE"
      }, {"char": "&#x436", desc: "CYRILLIC SMALL LETTER ZHE"}, {
        "char": "&#x437",
        desc: "CYRILLIC SMALL LETTER ZE"
      }, {"char": "&#x438", desc: "CYRILLIC SMALL LETTER I"}, {
        "char": "&#x439",
        desc: "CYRILLIC SMALL LETTER SHORT I"
      }, {"char": "&#x43A", desc: "CYRILLIC SMALL LETTER KA"}, {
        "char": "&#x43B",
        desc: "CYRILLIC SMALL LETTER EL"
      }, {"char": "&#x43C", desc: "CYRILLIC SMALL LETTER EM"}, {
        "char": "&#x43D",
        desc: "CYRILLIC SMALL LETTER EN"
      }, {"char": "&#x43E", desc: "CYRILLIC SMALL LETTER O"}, {
        "char": "&#x43F",
        desc: "CYRILLIC SMALL LETTER PE"
      }, {"char": "&#x440", desc: "CYRILLIC SMALL LETTER ER"}, {
        "char": "&#x441",
        desc: "CYRILLIC SMALL LETTER ES"
      }, {"char": "&#x442", desc: "CYRILLIC SMALL LETTER TE"}, {
        "char": "&#x443",
        desc: "CYRILLIC SMALL LETTER U"
      }, {"char": "&#x444", desc: "CYRILLIC SMALL LETTER EF"}, {
        "char": "&#x445",
        desc: "CYRILLIC SMALL LETTER HA"
      }, {"char": "&#x446", desc: "CYRILLIC SMALL LETTER TSE"}, {
        "char": "&#x447",
        desc: "CYRILLIC SMALL LETTER CHE"
      }, {"char": "&#x448", desc: "CYRILLIC SMALL LETTER SHA"}, {
        "char": "&#x449",
        desc: "CYRILLIC SMALL LETTER SHCHA"
      }, {"char": "&#x44A", desc: "CYRILLIC SMALL LETTER HARD SIGN"}, {
        "char": "&#x44B",
        desc: "CYRILLIC SMALL LETTER YERU"
      }, {"char": "&#x44C", desc: "CYRILLIC SMALL LETTER SOFT SIGN"}, {
        "char": "&#x44D",
        desc: "CYRILLIC SMALL LETTER E"
      }, {"char": "&#x44E", desc: "CYRILLIC SMALL LETTER YU"}, {
        "char": "&#x44F",
        desc: "CYRILLIC SMALL LETTER YA"
      }, {"char": "&#x450", desc: "CYRILLIC SMALL LETTER IE WITH GRAVE"}, {
        "char": "&#x451",
        desc: "CYRILLIC SMALL LETTER IO"
      }, {"char": "&#x452", desc: "CYRILLIC SMALL LETTER DJE"}, {
        "char": "&#x453",
        desc: "CYRILLIC SMALL LETTER GJE"
      }, {"char": "&#x454", desc: "CYRILLIC SMALL LETTER UKRAINIAN IE"}, {
        "char": "&#x455",
        desc: "CYRILLIC SMALL LETTER DZE"
      }, {"char": "&#x456", desc: "CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"}, {
        "char": "&#x457",
        desc: "CYRILLIC SMALL LETTER YI"
      }, {"char": "&#x458", desc: "CYRILLIC SMALL LETTER JE"}, {
        "char": "&#x459",
        desc: "CYRILLIC SMALL LETTER LJE"
      }, {"char": "&#x45A", desc: "CYRILLIC SMALL LETTER NJE"}, {
        "char": "&#x45B",
        desc: "CYRILLIC SMALL LETTER TSHE"
      }, {"char": "&#x45C", desc: "CYRILLIC SMALL LETTER KJE"}, {
        "char": "&#x45D",
        desc: "CYRILLIC SMALL LETTER I WITH GRAVE"
      }, {"char": "&#x45E", desc: "CYRILLIC SMALL LETTER SHORT U"}, {
        "char": "&#x45F",
        desc: "CYRILLIC SMALL LETTER DZHE"
      }]
    }, {
      title: "Punctuation",
      "char": "&ndash;",
      list: [{"char": "&ndash;", desc: "EN DASH"}, {"char": "&mdash;", desc: "EM DASH"}, {
        "char": "&lsquo;",
        desc: "LEFT SINGLE QUOTATION MARK"
      }, {"char": "&rsquo;", desc: "RIGHT SINGLE QUOTATION MARK"}, {
        "char": "&sbquo;",
        desc: "SINGLE LOW-9 QUOTATION MARK"
      }, {"char": "&ldquo;", desc: "LEFT DOUBLE QUOTATION MARK"}, {
        "char": "&rdquo;",
        desc: "RIGHT DOUBLE QUOTATION MARK"
      }, {"char": "&bdquo;", desc: "DOUBLE LOW-9 QUOTATION MARK"}, {
        "char": "&dagger;",
        desc: "DAGGER"
      }, {"char": "&Dagger;", desc: "DOUBLE DAGGER"}, {"char": "&bull;", desc: "BULLET"}, {
        "char": "&hellip;",
        desc: "HORIZONTAL ELLIPSIS"
      }, {"char": "&permil;", desc: "PER MILLE SIGN"}, {"char": "&prime;", desc: "PRIME"}, {
        "char": "&Prime;",
        desc: "DOUBLE PRIME"
      }, {"char": "&lsaquo;", desc: "SINGLE LEFT-POINTING ANGLE QUOTATION MARK"}, {
        "char": "&rsaquo;",
        desc: "SINGLE RIGHT-POINTING ANGLE QUOTATION MARK"
      }, {"char": "&oline;", desc: "OVERLINE"}, {"char": "&frasl;", desc: "FRACTION SLASH"}]
    }, {
      title: "Currency",
      "char": "&#x20A0",
      list: [{"char": "&#x20A0", desc: "EURO-CURRENCY SIGN"}, {
        "char": "&#x20A1",
        desc: "COLON SIGN"
      }, {"char": "&#x20A2", desc: "CRUZEIRO SIGN"}, {"char": "&#x20A3", desc: "FRENCH FRANC SIGN"}, {
        "char": "&#x20A4",
        desc: "LIRA SIGN"
      }, {"char": "&#x20A5", desc: "MILL SIGN"}, {"char": "&#x20A6", desc: "NAIRA SIGN"}, {
        "char": "&#x20A7",
        desc: "PESETA SIGN"
      }, {"char": "&#x20A8", desc: "RUPEE SIGN"}, {"char": "&#x20A9", desc: "WON SIGN"}, {
        "char": "&#x20AA",
        desc: "NEW SHEQEL SIGN"
      }, {"char": "&#x20AB", desc: "DONG SIGN"}, {"char": "&#x20AC", desc: "EURO SIGN"}, {
        "char": "&#x20AD",
        desc: "KIP SIGN"
      }, {"char": "&#x20AE", desc: "TUGRIK SIGN"}, {"char": "&#x20AF", desc: "DRACHMA SIGN"}, {
        "char": "&#x20B0",
        desc: "GERMAN PENNY SYMBOL"
      }, {"char": "&#x20B1", desc: "PESO SIGN"}, {"char": "&#x20B2", desc: "GUARANI SIGN"}, {
        "char": "&#x20B3",
        desc: "AUSTRAL SIGN"
      }, {"char": "&#x20B4", desc: "HRYVNIA SIGN"}, {"char": "&#x20B5", desc: "CEDI SIGN"}, {
        "char": "&#x20B6",
        desc: "LIVRE TOURNOIS SIGN"
      }, {"char": "&#x20B7", desc: "SPESMILO SIGN"}, {"char": "&#x20B8", desc: "TENGE SIGN"}, {
        "char": "&#x20B9",
        desc: "INDIAN RUPEE SIGN"
      }]
    }, {
      title: "Arrows",
      "char": "&#x2190",
      list: [{"char": "&#x2190", desc: "LEFTWARDS ARROW"}, {
        "char": "&#x2191",
        desc: "UPWARDS ARROW"
      }, {"char": "&#x2192", desc: "RIGHTWARDS ARROW"}, {
        "char": "&#x2193",
        desc: "DOWNWARDS ARROW"
      }, {"char": "&#x2194", desc: "LEFT RIGHT ARROW"}, {"char": "&#x2195", desc: "UP DOWN ARROW"}, {
        "char": "&#x2196",
        desc: "NORTH WEST ARROW"
      }, {"char": "&#x2197", desc: "NORTH EAST ARROW"}, {
        "char": "&#x2198",
        desc: "SOUTH EAST ARROW"
      }, {"char": "&#x2199", desc: "SOUTH WEST ARROW"}, {
        "char": "&#x219A",
        desc: "LEFTWARDS ARROW WITH STROKE"
      }, {"char": "&#x219B", desc: "RIGHTWARDS ARROW WITH STROKE"}, {
        "char": "&#x219C",
        desc: "LEFTWARDS WAVE ARROW"
      }, {"char": "&#x219D", desc: "RIGHTWARDS WAVE ARROW"}, {
        "char": "&#x219E",
        desc: "LEFTWARDS TWO HEADED ARROW"
      }, {"char": "&#x219F", desc: "UPWARDS TWO HEADED ARROW"}, {
        "char": "&#x21A0",
        desc: "RIGHTWARDS TWO HEADED ARROW"
      }, {"char": "&#x21A1", desc: "DOWNWARDS TWO HEADED ARROW"}, {
        "char": "&#x21A2",
        desc: "LEFTWARDS ARROW WITH TAIL"
      }, {"char": "&#x21A3", desc: "RIGHTWARDS ARROW WITH TAIL"}, {
        "char": "&#x21A4",
        desc: "LEFTWARDS ARROW FROM BAR"
      }, {"char": "&#x21A5", desc: "UPWARDS ARROW FROM BAR"}, {
        "char": "&#x21A6",
        desc: "RIGHTWARDS ARROW FROM BAR"
      }, {"char": "&#x21A7", desc: "DOWNWARDS ARROW FROM BAR"}, {
        "char": "&#x21A8",
        desc: "UP DOWN ARROW WITH BASE"
      }, {"char": "&#x21A9", desc: "LEFTWARDS ARROW WITH HOOK"}, {
        "char": "&#x21AA",
        desc: "RIGHTWARDS ARROW WITH HOOK"
      }, {"char": "&#x21AB", desc: "LEFTWARDS ARROW WITH LOOP"}, {
        "char": "&#x21AC",
        desc: "RIGHTWARDS ARROW WITH LOOP"
      }, {"char": "&#x21AD", desc: "LEFT RIGHT WAVE ARROW"}, {
        "char": "&#x21AE",
        desc: "LEFT RIGHT ARROW WITH STROKE"
      }, {"char": "&#x21AF", desc: "DOWNWARDS ZIGZAG ARROW"}, {
        "char": "&#x21B0",
        desc: "UPWARDS ARROW WITH TIP LEFTWARDS"
      }, {"char": "&#x21B1", desc: "UPWARDS ARROW WITH TIP RIGHTWARDS"}, {
        "char": "&#x21B2",
        desc: "DOWNWARDS ARROW WITH TIP LEFTWARDS"
      }, {"char": "&#x21B3", desc: "DOWNWARDS ARROW WITH TIP RIGHTWARDS"}, {
        "char": "&#x21B4",
        desc: "RIGHTWARDS ARROW WITH CORNER DOWNWARDS"
      }, {"char": "&#x21B5", desc: "DOWNWARDS ARROW WITH CORNER LEFTWARDS"}, {
        "char": "&#x21B6",
        desc: "ANTICLOCKWISE TOP SEMICIRCLE ARROW"
      }, {"char": "&#x21B7", desc: "CLOCKWISE TOP SEMICIRCLE ARROW"}, {
        "char": "&#x21B8",
        desc: "NORTH WEST ARROW TO LONG BAR"
      }, {"char": "&#x21B9", desc: "LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR"}, {
        "char": "&#x21BA",
        desc: "ANTICLOCKWISE OPEN CIRCLE ARROW"
      }, {"char": "&#x21BB", desc: "CLOCKWISE OPEN CIRCLE ARROW"}, {
        "char": "&#x21BC",
        desc: "LEFTWARDS HARPOON WITH BARB UPWARDS"
      }, {"char": "&#x21BD", desc: "LEFTWARDS HARPOON WITH BARB DOWNWARDS"}, {
        "char": "&#x21BE",
        desc: "UPWARDS HARPOON WITH BARB RIGHTWARDS"
      }, {"char": "&#x21BF", desc: "UPWARDS HARPOON WITH BARB LEFTWARDS"}, {
        "char": "&#x21C0",
        desc: "RIGHTWARDS HARPOON WITH BARB UPWARDS"
      }, {"char": "&#x21C1", desc: "RIGHTWARDS HARPOON WITH BARB DOWNWARDS"}, {
        "char": "&#x21C2",
        desc: "DOWNWARDS HARPOON WITH BARB RIGHTWARDS"
      }, {"char": "&#x21C3", desc: "DOWNWARDS HARPOON WITH BARB LEFTWARDS"}, {
        "char": "&#x21C4",
        desc: "RIGHTWARDS ARROW OVER LEFTWARDS ARROW"
      }, {"char": "&#x21C5", desc: "UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW"}, {
        "char": "&#x21C6",
        desc: "LEFTWARDS ARROW OVER RIGHTWARDS ARROW"
      }, {"char": "&#x21C7", desc: "LEFTWARDS PAIRED ARROWS"}, {
        "char": "&#x21C8",
        desc: "UPWARDS PAIRED ARROWS"
      }, {"char": "&#x21C9", desc: "RIGHTWARDS PAIRED ARROWS"}, {
        "char": "&#x21CA",
        desc: "DOWNWARDS PAIRED ARROWS"
      }, {"char": "&#x21CB", desc: "LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON"}, {
        "char": "&#x21CC",
        desc: "RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON"
      }, {"char": "&#x21CD", desc: "LEFTWARDS DOUBLE ARROW WITH STROKE"}, {
        "char": "&#x21CE",
        desc: "LEFT RIGHT DOUBLE ARROW WITH STROKE"
      }, {"char": "&#x21CF", desc: "RIGHTWARDS DOUBLE ARROW WITH STROKE"}, {
        "char": "&#x21D0",
        desc: "LEFTWARDS DOUBLE ARROW"
      }, {"char": "&#x21D1", desc: "UPWARDS DOUBLE ARROW"}, {
        "char": "&#x21D2",
        desc: "RIGHTWARDS DOUBLE ARROW"
      }, {"char": "&#x21D3", desc: "DOWNWARDS DOUBLE ARROW"}, {
        "char": "&#x21D4",
        desc: "LEFT RIGHT DOUBLE ARROW"
      }, {"char": "&#x21D5", desc: "UP DOWN DOUBLE ARROW"}, {
        "char": "&#x21D6",
        desc: "NORTH WEST DOUBLE ARROW"
      }, {"char": "&#x21D7", desc: "NORTH EAST DOUBLE ARROW"}, {
        "char": "&#x21D8",
        desc: "SOUTH EAST DOUBLE ARROW"
      }, {"char": "&#x21D9", desc: "SOUTH WEST DOUBLE ARROW"}, {
        "char": "&#x21DA",
        desc: "LEFTWARDS TRIPLE ARROW"
      }, {"char": "&#x21DB", desc: "RIGHTWARDS TRIPLE ARROW"}, {
        "char": "&#x21DC",
        desc: "LEFTWARDS SQUIGGLE ARROW"
      }, {"char": "&#x21DD", desc: "RIGHTWARDS SQUIGGLE ARROW"}, {
        "char": "&#x21DE",
        desc: "UPWARDS ARROW WITH DOUBLE STROKE"
      }, {"char": "&#x21DF", desc: "DOWNWARDS ARROW WITH DOUBLE STROKE"}, {
        "char": "&#x21E0",
        desc: "LEFTWARDS DASHED ARROW"
      }, {"char": "&#x21E1", desc: "UPWARDS DASHED ARROW"}, {
        "char": "&#x21E2",
        desc: "RIGHTWARDS DASHED ARROW"
      }, {"char": "&#x21E3", desc: "DOWNWARDS DASHED ARROW"}, {
        "char": "&#x21E4",
        desc: "LEFTWARDS ARROW TO BAR"
      }, {"char": "&#x21E5", desc: "RIGHTWARDS ARROW TO BAR"}, {
        "char": "&#x21E6",
        desc: "LEFTWARDS WHITE ARROW"
      }, {"char": "&#x21E7", desc: "UPWARDS WHITE ARROW"}, {
        "char": "&#x21E8",
        desc: "RIGHTWARDS WHITE ARROW"
      }, {"char": "&#x21E9", desc: "DOWNWARDS WHITE ARROW"}, {
        "char": "&#x21EA",
        desc: "UPWARDS WHITE ARROW FROM BAR"
      }, {"char": "&#x21EB", desc: "UPWARDS WHITE ARROW ON PEDESTAL"}, {
        "char": "&#x21EC",
        desc: "UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR"
      }, {"char": "&#x21ED", desc: "UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR"}, {
        "char": "&#x21EE",
        desc: "UPWARDS WHITE DOUBLE ARROW"
      }, {"char": "&#x21EF", desc: "UPWARDS WHITE DOUBLE ARROW ON PEDESTAL"}, {
        "char": "&#x21F0",
        desc: "RIGHTWARDS WHITE ARROW FROM WALL"
      }, {"char": "&#x21F1", desc: "NORTH WEST ARROW TO CORNER"}, {
        "char": "&#x21F2",
        desc: "SOUTH EAST ARROW TO CORNER"
      }, {"char": "&#x21F3", desc: "UP DOWN WHITE ARROW"}, {
        "char": "&#x21F4",
        desc: "RIGHT ARROW WITH SMALL CIRCLE"
      }, {"char": "&#x21F5", desc: "DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW"}, {
        "char": "&#x21F6",
        desc: "THREE RIGHTWARDS ARROWS"
      }, {"char": "&#x21F7", desc: "LEFTWARDS ARROW WITH VERTICAL STROKE"}, {
        "char": "&#x21F8",
        desc: "RIGHTWARDS ARROW WITH VERTICAL STROKE"
      }, {"char": "&#x21F9", desc: "LEFT RIGHT ARROW WITH VERTICAL STROKE"}, {
        "char": "&#x21FA",
        desc: "LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE"
      }, {"char": "&#x21FB", desc: "RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE"}, {
        "char": "&#x21FC",
        desc: "LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE"
      }, {"char": "&#x21FD", desc: "LEFTWARDS OPEN-HEADED ARROW"}, {
        "char": "&#x21FE",
        desc: "RIGHTWARDS OPEN-HEADED ARROW"
      }, {"char": "&#x21FF", desc: "LEFT RIGHT OPEN-HEADED ARROW"}]
    }, {
      title: "Math",
      "char": "&forall;",
      list: [{"char": "&forall;", desc: "FOR ALL"}, {
        "char": "&part;",
        desc: "PARTIAL DIFFERENTIAL"
      }, {"char": "&exist;", desc: "THERE EXISTS"}, {"char": "&empty;", desc: "EMPTY SET"}, {
        "char": "&nabla;",
        desc: "NABLA"
      }, {"char": "&isin;", desc: "ELEMENT OF"}, {"char": "&notin;", desc: "NOT AN ELEMENT OF"}, {
        "char": "&ni;",
        desc: "CONTAINS AS MEMBER"
      }, {"char": "&prod;", desc: "N-ARY PRODUCT"}, {"char": "&sum;", desc: "N-ARY SUMMATION"}, {
        "char": "&minus;",
        desc: "MINUS SIGN"
      }, {"char": "&lowast;", desc: "ASTERISK OPERATOR"}, {"char": "&radic;", desc: "SQUARE ROOT"}, {
        "char": "&prop;",
        desc: "PROPORTIONAL TO"
      }, {"char": "&infin;", desc: "INFINITY"}, {"char": "&ang;", desc: "ANGLE"}, {
        "char": "&and;",
        desc: "LOGICAL AND"
      }, {"char": "&or;", desc: "LOGICAL OR"}, {"char": "&cap;", desc: "INTERSECTION"}, {
        "char": "&cup;",
        desc: "UNION"
      }, {"char": "&int;", desc: "INTEGRAL"}, {"char": "&there4;", desc: "THEREFORE"}, {
        "char": "&sim;",
        desc: "TILDE OPERATOR"
      }, {"char": "&cong;", desc: "APPROXIMATELY EQUAL TO"}, {
        "char": "&asymp;",
        desc: "ALMOST EQUAL TO"
      }, {"char": "&ne;", desc: "NOT EQUAL TO"}, {"char": "&equiv;", desc: "IDENTICAL TO"}, {
        "char": "&le;",
        desc: "LESS-THAN OR EQUAL TO"
      }, {"char": "&ge;", desc: "GREATER-THAN OR EQUAL TO"}, {"char": "&sub;", desc: "SUBSET OF"}, {
        "char": "&sup;",
        desc: "SUPERSET OF"
      }, {"char": "&nsub;", desc: "NOT A SUBSET OF"}, {
        "char": "&sube;",
        desc: "SUBSET OF OR EQUAL TO"
      }, {"char": "&supe;", desc: "SUPERSET OF OR EQUAL TO"}, {
        "char": "&oplus;",
        desc: "CIRCLED PLUS"
      }, {"char": "&otimes;", desc: "CIRCLED TIMES"}, {"char": "&perp;", desc: "UP TACK"}]
    }, {
      title: "Misc",
      "char": "&spades;",
      list: [{"char": "&spades;", desc: "BLACK SPADE SUIT"}, {
        "char": "&clubs;",
        desc: "BLACK CLUB SUIT"
      }, {"char": "&hearts;", desc: "BLACK HEART SUIT"}, {
        "char": "&diams;",
        desc: "BLACK DIAMOND SUIT"
      }, {"char": "&#x2669", desc: "QUARTER NOTE"}, {"char": "&#x266A", desc: "EIGHTH NOTE"}, {
        "char": "&#x266B",
        desc: "BEAMED EIGHTH NOTES"
      }, {"char": "&#x266C", desc: "BEAMED SIXTEENTH NOTES"}, {
        "char": "&#x266D",
        desc: "MUSIC FLAT SIGN"
      }, {"char": "&#x266E", desc: "MUSIC NATURAL SIGN"}, {
        "char": "&#x2600",
        desc: "BLACK SUN WITH RAYS"
      }, {"char": "&#x2601", desc: "CLOUD"}, {"char": "&#x2602", desc: "UMBRELLA"}, {
        "char": "&#x2603",
        desc: "SNOWMAN"
      }, {"char": "&#x2615", desc: "HOT BEVERAGE"}, {"char": "&#x2618", desc: "SHAMROCK"}, {
        "char": "&#x262F",
        desc: "YIN YANG"
      }, {"char": "&#x2714", desc: "HEAVY CHECK MARK"}, {
        "char": "&#x2716",
        desc: "HEAVY MULTIPLICATION X"
      }, {"char": "&#x2744", desc: "SNOWFLAKE"}, {
        "char": "&#x275B",
        desc: "HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT"
      }, {"char": "&#x275C", desc: "HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT"}, {
        "char": "&#x275D",
        desc: "HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT"
      }, {"char": "&#x275E", desc: "HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT"}, {
        "char": "&#x2764",
        desc: "HEAVY BLACK HEART"
      }]
    }], specialCharButtons: ["specialCharBack", "|"]
  }), Object.assign(xt.POPUP_TEMPLATES, {specialCharacters: "[_BUTTONS_][_CUSTOM_LAYER_]"}), xt.PLUGINS.specialCharacters = function (g) {
    var m = g.$, n = g.opts.specialCharactersSets[0], a = g.opts.specialCharactersSets, i = "";

    function s() {
      return '\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n          '.concat(function t(e, n) {
        var r = "";
        return e.forEach(function (e) {
          var t = {
            elementClass: e.title === n.title ? "fr-active fr-active-tab" : "",
            title: e.title,
            dataParam1: e.title,
            desc: e["char"]
          };
          r += '<button class="fr-command fr-btn fr-special-character-category '.concat(t.elementClass, '" title="').concat(t.title, '" data-cmd="setSpecialCharacterCategory" data-param1="').concat(t.dataParam1, '"><span>').concat(t.desc, "</span></button>")
        }), r
      }(a, n), '\n        </div>\n        <div class="fr-icon-container fr-sc-container">\n          ').concat(function r(e) {
        var n = "";
        return e.list.forEach(function (e) {
          var t = {dataParam1: e["char"], title: e.desc, splCharValue: e["char"]};
          n += '<span class="fr-command fr-special-character fr-icon" role="button" \n      data-cmd="insertSpecialCharacter" data-param1="'.concat(t.dataParam1, '" \n      title="').concat(t.title, '">').concat(t.splCharValue, "</span>")
        }), n
      }(n), "\n        </div>")
    }

    return {
      setSpecialCharacterCategory: function r(t) {
        n = a.filter(function (e) {
          return e.title === t
        })[0], function e() {
          g.popups.get("specialCharacters").html(i + s())
        }()
      }, showSpecialCharsPopup: function l() {
        var e = g.popups.get("specialCharacters");
        if (e || (e = function o() {
          g.opts.toolbarInline && 0 < g.opts.specialCharButtons.length && (i = '<div class="fr-buttons fr-tabs">'.concat(g.button.buildList(g.opts.specialCharButtons), "</div>"));
          var e = {buttons: i, custom_layer: s()}, t = g.popups.create("specialCharacters", e);
          return function n(h) {
            g.events.on("popup.tab", function (e) {
              var t = m(e.currentTarget);
              if (!g.popups.isVisible("specialCharacters") || !t.is("span, a")) return !0;
              var n, r, a, o = e.which;
              if (xt.KEYCODE.TAB == o) {
                if (t.is("span.fr-icon") && e.shiftKey || t.is("a") && !e.shiftKey) {
                  var i = h.find(".fr-buttons");
                  n = !g.accessibility.focusToolbar(i, !!e.shiftKey)
                }
                if (!1 !== n) {
                  var s = h.find("span.fr-icon:focus").first().concat(h.findVisible(" span.fr-icon").first().concat(h.find("a")));
                  t.is("span.fr-icon") && (s = s.not("span.fr-icon:not(:focus)")), r = s.index(t), r = e.shiftKey ? ((r - 1) % s.length + s.length) % s.length : (r + 1) % s.length, a = s.get(r), g.events.disableBlur(), a.focus(), n = !1
                }
              } else if (xt.KEYCODE.ARROW_UP == o || xt.KEYCODE.ARROW_DOWN == o || xt.KEYCODE.ARROW_LEFT == o || xt.KEYCODE.ARROW_RIGHT == o) {
                if (t.is("span.fr-icon")) {
                  var l = t.parent().find("span.fr-icon");
                  r = l.index(t);
                  var c = Math.floor(l.length / 11), d = r % 11, f = Math.floor(r / 11), p = 11 * f + d, u = 11 * c;
                  xt.KEYCODE.ARROW_UP == o ? p = ((p - 11) % u + u) % u : xt.KEYCODE.ARROW_DOWN == o ? p = (p + 11) % u : xt.KEYCODE.ARROW_LEFT == o ? p = ((p - 1) % u + u) % u : xt.KEYCODE.ARROW_RIGHT == o && (p = (p + 1) % u), a = m(l.get(p)), g.events.disableBlur(), a.focus(), n = !1
                }
              } else xt.KEYCODE.ENTER == o && (t.is("a") ? t[0].click() : g.button.exec(t), n = !1);
              return !1 === n && (e.preventDefault(), e.stopPropagation()), n
            }, !0)
          }(t), t
        }()), !e.hasClass("fr-active")) {
          g.popups.refresh("specialCharacters"), g.popups.setContainer("specialCharacters", g.$tb);
          var t = g.$tb.find('.fr-command[data-cmd="specialCharacters"]'), n = g.button.getPosition(t), r = n.left,
            a = n.top;
          g.popups.show("specialCharacters", r, a, outerHeight)
        }
      }, back: function e() {
        g.popups.hide("specialCharacters"), g.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("specialCharacters", {
    NAME: "dollar-sign",
    SVG_KEY: "symbols"
  }), xt.RegisterCommand("specialCharacters", {
    title: "Special Characters",
    icon: "specialCharacters",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    plugin: "specialCharacters",
    showOnMobile: !0,
    callback: function () {
      this.popups.isVisible("specialCharacters") ? (this.$el.find(".fr-marker") && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("specialCharacters")) : this.specialCharacters.showSpecialCharsPopup()
    }
  }), xt.RegisterCommand("insertSpecialCharacter", {
    callback: function (e, t) {
      this.undo.saveStep(), this.html.insert(t), this.undo.saveStep(), this.popups.hide("specialCharacters")
    }
  }), xt.RegisterCommand("setSpecialCharacterCategory", {
    undo: !1, focus: !1, callback: function (e, t) {
      this.specialCharacters.setSpecialCharacterCategory(t)
    }
  }), xt.DefineIcon("specialCharBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("specialCharBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.specialCharacters.back()
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "table.insert": "[_BUTTONS_][_ROWS_COLUMNS_]",
    "table.edit": "[_BUTTONS_]",
    "table.colors": "[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]"
  }), Object.assign(xt.DEFAULTS, {
    tableInsertMaxSize: 10,
    tableEditButtons: ["tableHeader", "tableRemove", "tableRows", "tableColumns", "tableStyle", "-", "tableCells", "tableCellBackground", "tableCellVerticalAlign", "tableCellHorizontalAlign", "tableCellStyle"],
    tableInsertButtons: ["tableBack", "|"],
    tableResizer: !0,
    tableDefaultWidth: "100%",
    tableResizerOffset: 5,
    tableResizingLimit: 30,
    tableColorsButtons: ["tableBack", "|"],
    tableColors: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    tableColorsStep: 7,
    tableCellStyles: {"fr-highlighted": "Highlighted", "fr-thick": "Thick"},
    tableStyles: {"fr-dashed-borders": "Dashed Borders", "fr-alternate-rows": "Alternate Rows"},
    tableCellMultipleStyles: !0,
    tableMultipleStyles: !0,
    tableInsertHelper: !0,
    tableInsertHelperOffset: 15
  }), xt.PLUGINS.table = function (L) {
    var _, c, a, o, r, i, w, A = L.$;

    function u() {
      var e = T();
      if (e) {
        var t = L.popups.get("table.edit");
        if (t || (t = p()), t) {
          L.popups.setContainer("table.edit", L.$sc);
          var n = M(e), r = n.left + (n.right - n.left) / 2, a = n.bottom;
          L.popups.show("table.edit", r, a, n.bottom - n.top, !0), L.edit.isDisabled() && (1 < Q().length && L.toolbar.disable(), L.$el.removeClass("fr-no-selection"), L.edit.on(), L.button.bulkRefresh(), L.selection.setAtEnd(L.$el.find(".fr-selected-cell").last().get(0)), L.selection.restore())
        }
      }
    }

    function s() {
      var e = T();
      if (e) {
        var t = L.popups.get("table.colors");
        t || (t = function i() {
          var e = "";
          0 < L.opts.tableColorsButtons.length && (e = '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.tableColorsButtons), "</div>"));
          var t = "";
          L.opts.colorsHEXInput && (t = '<div class="fr-color-hex-layer fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'.concat(L.id, '"><div class="fr-input-line"><input maxlength="7" id="fr-table-colors-hex-layer-text-').concat(L.id, '" type="text" placeholder="').concat(L.language.translate("HEX Color"), '" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="tableCellBackgroundCustomColor" tabIndex="2" role="button">').concat(L.language.translate("OK"), "</button></div></div>"));
          var n = {
            buttons: e, colors: function a() {
              for (var e = '<div class="fr-color-set fr-table-colors">', t = 0; t < L.opts.tableColors.length; t++) 0 !== t && t % L.opts.tableColorsStep == 0 && (e += "<br>"), "REMOVE" != L.opts.tableColors[t] ? e += '<span class="fr-command" style="background: '.concat(L.opts.tableColors[t], ';" tabIndex="-1" role="button" data-cmd="tableCellBackgroundColor" data-param1="').concat(L.opts.tableColors[t], '"><span class="fr-sr-only">').concat(L.language.translate("Color"), " ").concat(L.opts.tableColors[t], "&nbsp;&nbsp;&nbsp;</span></span>") : e += '<span class="fr-command" data-cmd="tableCellBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="'.concat(L.language.translate("Clear Formatting"), '">').concat(L.icon.create("tableColorRemove"), '<span class="fr-sr-only">').concat(L.language.translate("Clear Formatting"), "</span></span>");
              return e += "</div>"
            }(), custom_color: t
          }, r = L.popups.create("table.colors", n);
          return L.events.$on(L.$wp, "scroll.table-colors", function () {
            L.popups.isVisible("table.colors") && s()
          }), function o(h) {
            L.events.on("popup.tab", function (e) {
              var t = A(e.currentTarget);
              if (!L.popups.isVisible("table.colors") || !t.is("span")) return !0;
              var n = e.which, r = !0;
              if (xt.KEYCODE.TAB == n) {
                var a = h.find(".fr-buttons");
                r = !L.accessibility.focusToolbar(a, !!e.shiftKey)
              } else if (xt.KEYCODE.ARROW_UP == n || xt.KEYCODE.ARROW_DOWN == n || xt.KEYCODE.ARROW_LEFT == n || xt.KEYCODE.ARROW_RIGHT == n) {
                var o = t.parent().find("span.fr-command"), i = o.index(t), s = L.opts.colorsStep,
                  l = Math.floor(o.length / s), c = i % s, d = Math.floor(i / s), f = d * s + c, p = l * s;
                xt.KEYCODE.ARROW_UP == n ? f = ((f - s) % p + p) % p : xt.KEYCODE.ARROW_DOWN == n ? f = (f + s) % p : xt.KEYCODE.ARROW_LEFT == n ? f = ((f - 1) % p + p) % p : xt.KEYCODE.ARROW_RIGHT == n && (f = (f + 1) % p);
                var u = A(o.get(f));
                L.events.disableBlur(), u.focus(), r = !1
              } else xt.KEYCODE.ENTER == n && (L.button.exec(t), r = !1);
              return !1 === r && (e.preventDefault(), e.stopPropagation()), r
            }, !0)
          }(r), r
        }()), L.popups.setContainer("table.colors", L.$sc);
        var n = M(e), r = (n.left + n.right) / 2, a = n.bottom;
        !function o() {
          var e = L.popups.get("table.colors"), t = L.$el.find(".fr-selected-cell").first(),
            n = L.helpers.RGBToHex(t.css("background-color")), r = e.find(".fr-table-colors-hex-layer input");
          e.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"), e.find('span[data-param1="'.concat(n, '"]')).addClass("fr-selected-color fr-active-item"), r.val(n).trigger("change")
        }(), L.popups.show("table.colors", r, a, n.bottom - n.top, !0)
      }
    }

    function l() {
      0 === Q().length && L.toolbar.enable()
    }

    function d(e) {
      if (e) return L.popups.onHide("table.insert", function () {
        L.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseover")
      }), !0;
      var t = "";
      0 < L.opts.tableInsertButtons.length && (t = '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.tableInsertButtons), "</div>"));
      var n = {
        buttons: t, rows_columns: function o() {
          for (var e = '<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">', t = 1; t <= L.opts.tableInsertMaxSize; t++) {
            for (var n = 1; n <= L.opts.tableInsertMaxSize; n++) {
              var r = "inline-block";
              2 < t && !L.helpers.isMobile() && (r = "none");
              var a = "fr-table-cell ";
              1 == t && 1 == n && (a += " hover"), e += '<span class="fr-command '.concat(a, '" tabIndex="-1" data-cmd="tableInsert" data-row="').concat(t, '" data-col="').concat(n, '" data-param1="').concat(t, '" data-param2="').concat(n, '" style="display: ').concat(r, ';" role="button"><span></span><span class="fr-sr-only">').concat(t, " &times; ").concat(n, "&nbsp;&nbsp;&nbsp;</span></span>")
            }
            e += '<div class="new-line"></div>'
          }
          return e += "</div></div>"
        }()
      }, r = L.popups.create("table.insert", n);
      return L.events.$on(r, "mouseover", ".fr-table-size .fr-select-table-size .fr-table-cell", function (e) {
        f(A(e.currentTarget))
      }, !0), function a(e) {
        L.events.$on(e, "focus", "[tabIndex]", function (e) {
          var t = A(e.currentTarget);
          f(t)
        }), L.events.on("popup.tab", function (e) {
          var t = A(e.currentTarget);
          if (!L.popups.isVisible("table.insert") || !t.is("span, a")) return !0;
          var n, r = e.which;
          if (xt.KEYCODE.ARROW_UP == r || xt.KEYCODE.ARROW_DOWN == r || xt.KEYCODE.ARROW_LEFT == r || xt.KEYCODE.ARROW_RIGHT == r) {
            if (t.is("span.fr-table-cell")) {
              var a = t.parent().find("span.fr-table-cell"), o = a.index(t), i = L.opts.tableInsertMaxSize, s = o % i,
                l = Math.floor(o / i);
              xt.KEYCODE.ARROW_UP == r ? l = Math.max(0, l - 1) : xt.KEYCODE.ARROW_DOWN == r ? l = Math.min(L.opts.tableInsertMaxSize - 1, l + 1) : xt.KEYCODE.ARROW_LEFT == r ? s = Math.max(0, s - 1) : xt.KEYCODE.ARROW_RIGHT == r && (s = Math.min(L.opts.tableInsertMaxSize - 1, s + 1));
              var c = l * i + s, d = A(a.get(c));
              f(d), L.events.disableBlur(), d.focus(), n = !1
            }
          } else xt.KEYCODE.ENTER == r && (L.button.exec(t), n = !1);
          return !1 === n && (e.preventDefault(), e.stopPropagation()), n
        }, !0)
      }(r), r
    }

    function f(e) {
      var t = e.data("row");
      null !== t && (t = parseInt(t));
      var n = e.data("col");
      null !== n && (n = parseInt(n));
      var r = e.parent();
      r.siblings(".fr-table-size-info").html("".concat(t, " &times; ").concat(n)), r.find("> span").removeClass("hover fr-active-item");
      for (var a = 1; a <= L.opts.tableInsertMaxSize; a++) for (var o = 0; o <= L.opts.tableInsertMaxSize; o++) {
        var i = r.find('> span[data-row="'.concat(a, '"][data-col="').concat(o, '"]'));
        a <= t && o <= n ? i.addClass("hover") : a <= t + 1 || a <= 2 && !L.helpers.isMobile() ? i.css("display", "inline-block") : 2 < a && !L.helpers.isMobile() && i.css("display", "none")
      }
      e.addClass("fr-active-item")
    }

    function p(e) {
      if (e) return L.popups.onHide("table.edit", l), !0;
      if (0 < L.opts.tableEditButtons.length) {
        var t = {buttons: '<div class="fr-buttons">'.concat(L.button.buildList(L.opts.tableEditButtons), "</div>")},
          n = L.popups.create("table.edit", t);
        return L.events.$on(L.$wp, "scroll.table-edit", function () {
          L.popups.isVisible("table.edit") && u()
        }), n
      }
      return !1
    }

    function h() {
      if (0 < Q().length) {
        var e = J();
        L.selection.setBefore(e.get(0)) || L.selection.setAfter(e.get(0)), L.selection.restore(), L.popups.hide("table.edit"), L.opts.trackChangesEnabled ? (L.track_changes.removedTable(e), y()) : e.remove(), L.toolbar.enable()
      }
    }

    function g(e) {
      var t = J();
      if (0 < t.length) {
        if (0 < L.$el.find("th.fr-selected-cell").length && "above" == e) return;
        var n, r, a, o = T(), i = R(o);
        if (null == i) return;
        r = "above" == e ? i.min_i : i.max_i;
        var s = "<tr>";
        for (n = 0; n < o[r].length; n++) {
          if ("below" == e && r < o.length - 1 && o[r][n] == o[r + 1][n] || "above" == e && 0 < r && o[r][n] == o[r - 1][n]) {
            if (0 === n || 0 < n && o[r][n] != o[r][n - 1]) {
              var l = A(o[r][n]);
              l.attr("rowspan", parseInt(l.attr("rowspan"), 10) + 1)
            }
          } else s += '<td style="' + A(o[r][n]).attr("style") + '" ><br></td>'
        }
        s += "</tr>", a = 0 < L.$el.find("th.fr-selected-cell").length && "below" == e ? A(t.find("tbody").not(t.find("> table tbody"))) : A(t.find("tr").not(t.find("> table tr")).get(r)), "below" == e ? "TBODY" == a.attr("tagName") ? a.prepend(s) : a[0].parentNode && a[0].insertAdjacentHTML("afterend", s) : "above" == e && (a.before(s), L.popups.isVisible("table.edit") && u())
      }
    }

    function m(e, t, n) {
      var r, a, o, i, s, l = 0, c = T(n);
      if (e < (t = Math.min(t, c[0].length - 1))) for (a = e; a <= t; a++) if (!(e < a && c[0][a] == c[0][a - 1]) && 1 < (i = Math.min(parseInt(c[0][a].getAttribute("colspan"), 10) || 1, t - e + 1)) && c[0][a] == c[0][a + 1]) for (l = i - 1, r = 1; r < c.length; r++) if (c[r][a] != c[r - 1][a]) {
        for (o = a; o < a + i; o++) if (1 < (s = parseInt(c[r][o].getAttribute("colspan"), 10) || 1) && c[r][o] == c[r][o + 1]) o += l = Math.min(l, s - 1); else if (!(l = Math.max(0, l - 1))) break;
        if (!l) break
      }
      l && b(c, l, "colspan", 0, c.length - 1, e, t)
    }

    function v(e, t, n) {
      var r, a, o, i, s, l = 0, c = T(n);
      if (e < (t = Math.min(t, c.length - 1))) for (r = e; r <= t; r++) if (!(e < r && c[r][0] == c[r - 1][0]) && c[r][0] !== undefined && 1 < (i = Math.min(parseInt(c[r][0].getAttribute("rowspan"), 10) || 1, t - e + 1)) && c[r][0] == c[r + 1][0]) for (l = i - 1, a = 1; a < c[0].length; a++) if (c[r][a] != c[r][a - 1]) {
        for (o = r; o < r + i; o++) if (1 < (s = parseInt(c[o][a].getAttribute("rowspan"), 10) || 1) && c[o][a] == c[o + 1][a]) o += l = Math.min(l, s - 1); else if (!(l = Math.max(0, l - 1))) break;
        if (!l) break
      }
      l && b(c, l, "rowspan", e, t, 0, c[0].length - 1)
    }

    function b(e, t, n, r, a, o, i) {
      var s, l, c;
      for (s = r; s <= a; s++) for (l = o; l <= i; l++) r < s && e[s][l] == e[s - 1][l] || o < l && e[s][l] == e[s][l - 1] || e[s][l] !== undefined && 1 < (c = parseInt(e[s][l].getAttribute(n), 10) || 1) && (1 < c - t ? e[s][l].setAttribute(n, c - t) : e[s][l].removeAttribute(n))
    }

    function C(e, t, n, r, a) {
      v(e, t, a), m(n, r, a)
    }

    function t(e) {
      var t = L.$el.find(".fr-selected-cell");
      "REMOVE" != e ? t.css("background-color", L.helpers.HEXtoRGB(e)) : t.css("background-color", ""), u()
    }

    function T(e) {
      var c = [];
      if (null == (e = e || null) && 0 < Q().length && (e = J()), e) {
        for (var t = e.find("tr:empty"), n = t.length - 1; 0 <= n; n--) A(t[n]).remove();
        e.findVisible("tr").not(e.find("> table tr")).each(function (s, e) {
          var t = A(e), l = 0;
          t.find("> th, > td").each(function (e, t) {
            for (var n = A(t), r = parseInt(n.attr("colspan"), 10) || 1, a = parseInt(n.attr("rowspan"), 10) || 1, o = s; o < s + a; o++) for (var i = l; i < l + r; i++) c[o] || (c[o] = []), c[o][i] ? l++ : c[o][i] = t;
            l += r
          })
        })
      }
      return c
    }

    function S(e, t) {
      for (var n = 0; n < t.length; n++) for (var r = 0; r < t[n].length; r++) if (t[n][r] == e) return {row: n, col: r}
    }

    function k(e, t, n) {
      for (var r = e + 1, a = t + 1; r < n.length;) {
        if (n[r][t] != n[e][t]) {
          r--;
          break
        }
        r++
      }
      for (r == n.length && r--; a < n[e].length;) {
        if (n[e][a] != n[e][t]) {
          a--;
          break
        }
        a++
      }
      return a == n[e].length && a--, {row: r, col: a}
    }

    function E() {
      L.el.querySelector(".fr-cell-fixed") && L.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"), L.el.querySelector(".fr-cell-handler") && L.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler")
    }

    function y() {
      var e = L.$el.find(".fr-selected-cell");
      0 < e.length && e.each(function () {
        var e = A(this);
        e.removeClass("fr-selected-cell"), "" === e.attr("class") && e.removeAttr("class")
      }), E()
    }

    function x() {
      L.events.disableBlur(), L.selection.clear(), L.$el.addClass("fr-no-selection"), L.$el.blur(), L.events.enableBlur()
    }

    function R(e) {
      var t = L.$el.find(".fr-selected-cell");
      if (0 < t.length) {
        var n, r = e.length, a = 0, o = e[0].length, i = 0;
        for (n = 0; n < t.length; n++) {
          var s = S(t[n], e), l = k(s.row, s.col, e);
          r = Math.min(s.row, r), a = Math.max(l.row, a), o = Math.min(s.col, o), i = Math.max(l.col, i)
        }
        return {min_i: r, max_i: a, min_j: o, max_j: i}
      }
      return null
    }

    function M(e) {
      var t = R(e);
      if (null != t) {
        var n = A(e[t.min_i][t.min_j]), r = A(e[t.min_i][t.max_j]), a = A(e[t.max_i][t.min_j]);
        return {
          left: n.length && n.offset().left,
          right: r.length && r.offset().left + r.outerWidth(),
          top: n.length && n.offset().top,
          bottom: a.length && a.offset().top + a.outerHeight()
        }
      }
    }

    function O(e, t) {
      if (A(e).is(t)) y(), A(e).addClass("fr-selected-cell"); else {
        x(), L.edit.off();
        var n = T(), r = S(e, n), a = S(t, n), o = function u(e, t, n, r, a) {
          var o, i, s, l, c = e, d = t, f = n, p = r;
          for (o = c; o <= d; o++) (1 < (parseInt(A(a[o][f]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[o][f]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[o][f], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p)), (1 < (parseInt(A(a[o][p]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[o][p]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[o][p], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p));
          for (i = f; i <= p; i++) (1 < (parseInt(A(a[c][i]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[c][i]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[c][i], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p)), (1 < (parseInt(A(a[d][i]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[d][i]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[d][i], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p));
          return c == e && d == t && f == n && p == r ? {min_i: e, max_i: t, min_j: n, max_j: r} : u(c, d, f, p, a)
        }(Math.min(r.row, a.row), Math.max(r.row, a.row), Math.min(r.col, a.col), Math.max(r.col, a.col), n);
        y(), e.classList.add("fr-cell-fixed"), t.classList.add("fr-cell-handler");
        for (var i = o.min_i; i <= o.max_i; i++) for (var s = o.min_j; s <= o.max_j; s++) A(e).closest("table").is(A(n[i][s]).closest("table")) && A(n[i][s]).addClass("fr-selected-cell")
      }
    }

    function N(e) {
      var t = null, n = A(e.target);
      return "TD" == e.target.tagName || "TH" == e.target.tagName ? t = e.target : 0 < n.closest("th", n.closest("thead")[0]).length ? t = n.closest("th", n.closest("thead")[0]).get(0) : 0 < n.closest("td", n.closest("tr")[0]).length && (t = n.closest("td", n.closest("tr")[0]).get(0)), -1 === L.$el.html.toString().search(t) ? null : t
    }

    function I() {
      y(), L.popups.hide("table.edit")
    }

    function e(e) {
      var t = N(e);
      if ("false" == A(t).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (0 < Q().length && !t && I(), !L.edit.isDisabled() || L.popups.isVisible("table.edit")) if (1 != e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey) (3 == e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey) && t && I(); else if (o = !0, t) {
        0 < Q().length && !e.shiftKey && I(), e.stopPropagation(), L.events.trigger("image.hideResizer"), L.events.trigger("video.hideResizer"), a = !0;
        var n = t.tagName.toLowerCase();
        e.shiftKey && 0 < L.$el.find("".concat(n, ".fr-selected-cell")).length ? A(L.$el.find("".concat(n, ".fr-selected-cell")).closest("table")).is(A(t).closest("table")) ? O(r, t) : x() : ((L.keys.ctrlKey(e) || e.shiftKey) && "TD" === e.currentTarget.tagName && (1 < Q().length || 0 === A(t).find(L.selection.element()).length && !A(t).is(L.selection.element())) && x(), r = t, 0 < L.opts.tableEditButtons.length && O(r, r))
      }
    }

    function n(e) {
      if (!L.edit.isDisabled() && L.popups.areVisible()) return !0;
      if (a || L.$tb.is(e.target) || L.$tb.is(A(e.target).closest(".fr-toolbar")) || (0 < Q().length && L.toolbar.enable(), y()), !(1 != e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey)) {
        if (o = !1, a) a = !1, N(e) || 1 != Q().length ? 0 < Q().length ? L.selection.isCollapsed() ? u() : (y(), L.edit.on()) : Q().length || (L.$el.removeClass("fr-no-selection"), L.edit.on()) : y();
        if (w) {
          w = !1, _.removeClass("fr-moving"), L.$el.removeClass("fr-no-selection"), L.edit.on();
          var t = parseFloat(_.css("left")) + L.opts.tableResizerOffset + L.$wp.offset().left;
          L.opts.iframe && (t -= L.$iframe.offset().left), _.data("release-position", t), _.removeData("max-left"), _.removeData("max-right"), function E() {
            var e = _.data("origin"), t = _.data("release-position");
            if (e !== t) {
              var n = _.data("first"), r = _.data("second"), a = _.data("table"), o = a.outerWidth();
              if (L.undo.canDo() || L.undo.saveStep(), null != n && null != r) {
                var i, s, l, c = T(a), d = [], f = [], p = [], u = [];
                for (i = 0; i < c.length; i++) s = A(c[i][n]), l = A(c[i][r]), d[i] = s.outerWidth(), p[i] = l.outerWidth(), f[i] = d[i] / o * 100, u[i] = p[i] / o * 100;
                for (i = 0; i < c.length; i++) if (s = A(c[i][n]), l = A(c[i][r]), c[i][n] != c[i][r]) {
                  var h = (f[i] * (d[i] + t - e) / d[i]).toFixed(4);
                  s.css("width", h + "%"), l.css("width", (f[i] + u[i] - h).toFixed(4) + "%")
                }
              } else {
                var g, m = a.parent(), v = o / m.width() * 100,
                  b = (parseInt(a.css("margin-left"), 10) || 0) / m.width() * 100,
                  C = (parseInt(a.css("margin-right"), 10) || 0) / m.width() * 100;
                "rtl" == L.opts.direction && 0 === r || "rtl" != L.opts.direction && 0 !== r ? (g = (o + t - e) / o * v, a.css("margin-right", "calc(100% - ".concat(Math.round(g).toFixed(4), "% - ").concat(Math.round(b).toFixed(4), "%)"))) : ("rtl" == L.opts.direction && 0 !== r || "rtl" != L.opts.direction && 0 === r) && (g = (o - t + e) / o * v, a.css("margin-left", "calc(100% - ".concat(Math.round(g).toFixed(4), "% - ").concat(Math.round(C).toFixed(4), "%)"))), a.css("width", "".concat(Math.round(g).toFixed(4), "%"))
              }
              L.selection.restore(), L.undo.saveStep(), L.events.trigger("table.resized", [a.get(0)])
            }
            _.removeData("origin"), _.removeData("release-position"), _.removeData("first"), _.removeData("second"), _.removeData("table")
          }(), F()
        }
      }
    }

    function D(e) {
      if (!(A(e.currentTarget).is(A(e.originalEvent.relatedTarget)) || e.currentTarget.contains(e.originalEvent.relatedTarget) || e.originalEvent.relatedTarget && e.originalEvent.relatedTarget.contains(e.currentTarget)) && (L.events.$on(A("input"), "click", ee), !0 === a && 0 < L.opts.tableEditButtons.length)) {
        if (A(e.currentTarget).closest("table").is(J())) {
          if ("TD" == e.currentTarget.tagName && 0 === L.$el.find("th.fr-selected-cell").length) return void O(r, e.currentTarget);
          if ("TH" == e.currentTarget.tagName && 0 === L.$el.find("td.fr-selected-cell").length) return void O(r, e.currentTarget)
        }
        x()
      }
    }

    function B(e, t, n, r) {
      for (var a, o = t; o != L.el && "TD" != o.tagName && "TH" != o.tagName && ("up" == r ? a = o.previousElementSibling : "down" == r && (a = o.nextElementSibling), !a);) o = o.parentNode;
      "TD" == o.tagName || "TH" == o.tagName ? function i(e, t) {
        for (var n = e; n && "TABLE" != n.tagName && n.parentNode != L.el;) n = n.parentNode;
        if (n && "TABLE" == n.tagName) {
          var r = T(A(n));
          "up" == t ? H(S(e, r), n, r) : "down" == t && $(S(e, r), n, r)
        }
      }(o, r) : a && ("up" == r && L.selection.setAtEnd(a), "down" == r && L.selection.setAtStart(a))
    }

    function H(e, t, n) {
      0 < A(".tribute-container").length && "none" != A(".tribute-container").css("display") || (0 < e.row ? L.selection.setAtEnd(n[e.row - 1][e.col]) : B(0, t, 0, "up"))
    }

    function $(e, t, n) {
      if (!(0 < A(".tribute-container").length && "none" != A(".tribute-container").css("display"))) {
        var r = parseInt(n[e.row][e.col].getAttribute("rowspan"), 10) || 1;
        e.row < n.length - r ? L.selection.setAtStart(n[e.row + r][e.col]) : B(0, t, 0, "down")
      }
    }

    function F() {
      _ && (_.find("div").css("opacity", 0), _.css("top", 0), _.css("left", 0), _.css("height", 0), _.find("div").css("height", 0), _.hide())
    }

    function P() {
      c && c.removeClass("fr-visible").css("left", "-9999px")
    }

    function U(e, t) {
      var n = A(t), r = n.closest("table"), a = r.parent();
      if (t && "TD" != t.tagName && "TH" != t.tagName && (0 < n.closest("td").length ? t = n.closest("td") : 0 < n.closest("th").length && (t = n.closest("th"))), !t || "TD" != t.tagName && "TH" != t.tagName) _ && n.get(0) != _.get(0) && n.parent().get(0) != _.get(0) && L.core.sameInstance(_) && F(); else {
        if (n = A(t), 0 === L.$el.find(n).length) return !1;
        var o = n.offset().left - 1, i = o + n.outerWidth();
        if (Math.abs(e.pageX - o) <= L.opts.tableResizerOffset || Math.abs(i - e.pageX) <= L.opts.tableResizerOffset) {
          var s, l, c, d, f, p = T(r), u = S(t, p), h = k(u.row, u.col, p), g = r.offset().top, m = r.outerHeight() - 1;
          "rtl" != L.opts.direction ? e.pageX - o <= L.opts.tableResizerOffset ? (c = o, 0 < u.col ? (d = o - G(u.col - 1, p) + L.opts.tableResizingLimit, f = o + G(u.col, p) - L.opts.tableResizingLimit, s = u.col - 1, l = u.col) : (s = null, l = 0, d = r.offset().left - 1 - parseInt(r.css("margin-left"), 10), f = r.offset().left - 1 + r.width() - p[0].length * L.opts.tableResizingLimit)) : i - e.pageX <= L.opts.tableResizerOffset && (c = i, h.col < p[h.row].length && p[h.row][h.col + 1] ? (d = i - G(h.col, p) + L.opts.tableResizingLimit, f = i + G(h.col + 1, p) - L.opts.tableResizingLimit, s = h.col, l = h.col + 1) : (s = h.col, l = null, d = r.offset().left - 1 + p[0].length * L.opts.tableResizingLimit, f = a.offset().left - 1 + a.width() + parseFloat(a.css("padding-left")))) : i - e.pageX <= L.opts.tableResizerOffset ? (c = i, 0 < u.col ? (d = i - G(u.col, p) + L.opts.tableResizingLimit, f = i + G(u.col - 1, p) - L.opts.tableResizingLimit, s = u.col, l = u.col - 1) : (s = null, l = 0, d = r.offset().left + p[0].length * L.opts.tableResizingLimit, f = a.offset().left - 1 + a.width() + parseFloat(a.css("padding-left")))) : e.pageX - o <= L.opts.tableResizerOffset && (c = o, h.col < p[h.row].length && p[h.row][h.col + 1] ? (d = o - G(h.col + 1, p) + L.opts.tableResizingLimit, f = o + G(h.col, p) - L.opts.tableResizingLimit, s = h.col + 1, l = h.col) : (s = h.col, l = null, d = a.offset().left + parseFloat(a.css("padding-left")), f = r.offset().left - 1 + r.width() - p[0].length * L.opts.tableResizingLimit)), _ || function y() {
            L.shared.$table_resizer || (L.shared.$table_resizer = A(document.createElement("div")).attr("class", "fr-table-resizer").html("<div></div>")), _ = L.shared.$table_resizer, L.events.$on(_, "mousedown", function (e) {
              return !L.core.sameInstance(_) || (0 < Q().length && I(), 1 == e.which ? (L.selection.save(), w = !0, _.addClass("fr-moving"), x(), L.edit.off(), _.find("div").css("opacity", 1), !1) : void 0)
            }), L.events.$on(_, "mousemove", function (e) {
              if (!L.core.sameInstance(_)) return !0;
              w && (L.opts.iframe && (e.pageX -= L.$iframe.offset().left), j(e))
            }), L.events.on("shared.destroy", function () {
              _.html("").removeData().remove(), _ = null
            }, !0), L.events.on("destroy", function () {
              L.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"), A("body").first().append(_.hide())
            }, !0)
          }(), _.data("table", r), _.data("first", s), _.data("second", l), _.data("instance", L), L.$wp.append(_);
          var v = c - L.win.pageXOffset - L.opts.tableResizerOffset - L.$wp.offset().left,
            b = g - L.$wp.offset().top + L.$wp.scrollTop();
          if (L.opts.iframe) {
            var C = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
              E = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
            v += L.$iframe.offset().left + E, b += L.$iframe.offset().top + C, d += L.$iframe.offset().left, f += L.$iframe.offset().left
          }
          _.data("max-left", d), _.data("max-right", f), _.data("origin", c - L.win.pageXOffset), _.css("top", b), _.css("left", v), _.css("height", m), _.find("div").css("height", m), _.css("padding-left", L.opts.tableResizerOffset), _.css("padding-right", L.opts.tableResizerOffset), _.show()
        } else L.core.sameInstance(_) && F()
      }
    }

    function z(e, t) {
      if (L.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || Z(), L.$box.append(c), c.data("instance", L);
      var n, r = A(t).find("tr").first(), a = e.pageX, o = 0, i = 0;
      if (L.opts.iframe) {
        var s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
          l = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
        o += L.$iframe.offset().left - L.helpers.scrollLeft() + l, i += L.$iframe.offset().top - L.helpers.scrollTop() + s
      }
      r.find("th, td").each(function () {
        var e = A(this);
        return e.offset().left <= a && a < e.offset().left + e.outerWidth() / 2 ? (n = parseInt(c.find("a").css("width"), 10), c.css("top", i + e.offset().top - L.$box.offset().top - n - 5), c.css("left", o + e.offset().left - L.$box.offset().left - n / 2), c.data("selected-cell", e), c.data("position", "before"), c.addClass("fr-visible"), !1) : e.offset().left + e.outerWidth() / 2 <= a && a < e.offset().left + e.outerWidth() ? (n = parseInt(c.find("a").css("width"), 10), c.css("top", i + e.offset().top - L.$box.offset().top - n - 5), c.css("left", o + e.offset().left - L.$box.offset().left + e.outerWidth() - n / 2), c.data("selected-cell", e), c.data("position", "after"), c.addClass("fr-visible"), !1) : void 0
      })
    }

    function K(e, t) {
      if (L.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || Z(), L.$box.append(c), c.data("instance", L);
      var n, r = A(t), a = e.pageY, o = 0, i = 0;
      if (L.opts.iframe) {
        var s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
          l = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
        o += L.$iframe.offset().left - L.helpers.scrollLeft() + l, i += L.$iframe.offset().top - L.helpers.scrollTop() + s
      }
      r.find("tr").each(function () {
        var e = A(this);
        n = parseInt(c.find("a").css("width"), 10);
        var t = o + e.offset().left - L.$box.offset().left;
        return t = 0 !== L.$box.offset().left ? t - n - 5 : t + n - 5, e.offset().top <= a && a < e.offset().top + e.outerHeight() / 2 ? (c.css("top", i + e.offset().top - L.$box.offset().top - n / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "above"), c.addClass("fr-visible"), !1) : e.offset().top + e.outerHeight() / 2 <= a && a < e.offset().top + e.outerHeight() ? (c.css("top", i + e.offset().top - L.$box.offset().top + e.outerHeight() - n / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "below"), c.addClass("fr-visible"), !1) : void 0
      })
    }

    function V(e) {
      i = null;
      var t = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset, e.pageY - L.win.pageYOffset);
      L.opts.tableResizer && (!L.popups.areVisible() || L.popups.areVisible() && L.popups.isVisible("table.edit")) && U(e, t), !L.opts.tableInsertHelper || L.popups.areVisible() || L.$tb.hasClass("fr-inline") && L.$tb.isVisible() || function o(e, t) {
        if (0 === Q().length) {
          var n, r, a;
          if (t && ("HTML" == t.tagName || "BODY" == t.tagName || L.node.isElement(t))) for (n = 1; n <= L.opts.tableInsertHelperOffset; n++) {
            if (r = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset, e.pageY - L.win.pageYOffset + n), A(r).hasClass("fr-tooltip")) return !0;
            if (r && ("TH" == r.tagName || "TD" == r.tagName || "TABLE" == r.tagName) && (A(r).parents(".fr-wrapper").length || L.opts.iframe) && "false" != A(r).closest("table").attr("contenteditable")) return z(e, A(r).closest("table")), !0;
            if (a = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset + n, e.pageY - L.win.pageYOffset), A(a).hasClass("fr-tooltip")) return !0;
            if (a && ("TH" == a.tagName || "TD" == a.tagName || "TABLE" == a.tagName) && (A(a).parents(".fr-wrapper").length || L.opts.iframe) && "false" != A(a).closest("table").attr("contenteditable")) return K(e, A(a).closest("table")), !0
          }
          L.core.sameInstance(c) && P()
        }
      }(e, t)
    }

    function W() {
      if (w) {
        var e = _.data("table").offset().top - L.win.pageYOffset;
        if (L.opts.iframe) {
          var t = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top"));
          e += L.$iframe.offset().top - L.helpers.scrollTop() + t
        }
        _.css("top", e)
      }
    }

    function G(e, t) {
      var n, r = A(t[0][e]).outerWidth();
      for (n = 1; n < t.length; n++) r = Math.min(r, A(t[n][e]).outerWidth());
      return r
    }

    function Y(e, t, n) {
      var r, a = 0;
      for (r = e; r <= t; r++) a += G(r, n);
      return a
    }

    function j(e) {
      if (1 < Q().length && o && x(), !1 === o && !1 === a && !1 === w) i && clearTimeout(i), L.edit.isDisabled() && !L.popups.isVisible("table.edit") || (i = setTimeout(V, 30, e)); else if (w) {
        var t = e.pageX - L.win.pageXOffset;
        L.opts.iframe && (t += L.$iframe.offset().left);
        var n = _.data("max-left"), r = _.data("max-right");
        n <= t && t <= r ? _.css("left", t - L.opts.tableResizerOffset - L.$wp.offset().left) : t < n && parseFloat(_.css("left"), 10) > n - L.opts.tableResizerOffset ? _.css("left", n - L.opts.tableResizerOffset - L.$wp.offset().left) : r < t && parseFloat(_.css("left"), 10) < r - L.opts.tableResizerOffset && _.css("left", r - L.opts.tableResizerOffset - L.$wp.offset().left)
      } else o && P()
    }

    function q(e) {
      L.node.isEmpty(e.get(0)) ? e.prepend(xt.MARKERS) : e.prepend(xt.START_MARKER).append(xt.END_MARKER)
    }

    function Z() {
      L.shared.$ti_helper || (L.shared.$ti_helper = A(document.createElement("div")).attr("class", "fr-insert-helper").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(L.language.translate("Insert"), '"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a>')), L.events.bindClick(L.shared.$ti_helper, "a", function () {
        var e = c.data("selected-cell"), t = c.data("position"), n = c.data("instance") || L;
        "before" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertColumn(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "after" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertColumn(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "above" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertRow(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "below" == t && (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertRow(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()), P()
      }), L.events.on("shared.destroy", function () {
        L.shared.$ti_helper.html("").removeData().remove(), L.shared.$ti_helper = null
      }, !0), L.events.$on(L.shared.$ti_helper, "mousemove", function (e) {
        e.stopPropagation()
      }, !0), L.events.$on(A(L.o_win), "scroll", function () {
        P()
      }, !0), L.events.$on(L.$wp, "scroll", function () {
        P()
      }, !0)), c = L.shared.$ti_helper, L.events.on("destroy", function () {
        c = null
      }), L.tooltip.bind(L.$box, ".fr-insert-helper > a.fr-floating-btn")
    }

    function X() {
      r = null, clearTimeout(i)
    }

    function Q() {
      return L.el.querySelectorAll(".fr-selected-cell")
    }

    function J() {
      var e = Q();
      if (e.length) {
        for (var t = e[0]; t && "TABLE" != t.tagName && t.parentNode != L.el;) t = t.parentNode;
        return t && "TABLE" == t.tagName ? A(t) : A([])
      }
      return A([])
    }

    function ee(e) {
      a = !1
    }

    return {
      _init: function te() {
        if (!L.$wp) return !1;
        if (L.helpers.isMobile() && (L.events.$on(L.$el, "mousedown", e), L.events.$on(L.$win, "mouseup", n)), !L.helpers.isMobile()) {
          w = a = o = !1, L.events.$on(L.$el, "mousedown", e), L.popups.onShow("image.edit", function () {
            y(), a = o = !1
          }), L.popups.onShow("link.edit", function () {
            y(), a = o = !1
          }), L.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && y()
          }), L.events.$on(L.$el, "mouseover", "th, td", D), L.events.$on(L.$win, "mouseup", n), L.opts.iframe && L.events.$on(A(L.o_win), "mouseup", n), L.events.$on(L.$win, "mousemove", j), L.events.$on(A(L.o_win), "scroll", W), L.events.on("contentChanged", function () {
            0 < Q().length && (u(), L.$el.find("img").on("load.selected-cells", function () {
              A(this).off("load.selected-cells"), 0 < Q().length && u()
            }))
          }), L.events.$on(A(L.o_win), "resize", function () {
            y()
          }), L.events.on("toolbar.esc", function () {
            if (0 < Q().length) return L.events.disableBlur(), L.events.focus(), !1
          }, !0), L.events.$on(A(L.o_win), "keydown", function () {
            o && a && (a = o = !1, L.$el.removeClass("fr-no-selection"), L.edit.on(), L.selection.setAtEnd(L.$el.find(".fr-selected-cell").last().get(0)), L.selection.restore(), y())
          }), L.events.$on(L.$el, "keydown", function (e) {
            e.shiftKey ? !1 === function i(e) {
              var t = Q();
              if (null != t && 0 < t.length) {
                var n, r = T(), a = e.which,
                  o = S(1 == t.length ? n = t[0] : (n = L.el.querySelector(".fr-cell-fixed"), L.el.querySelector(".fr-cell-handler")), r);
                if (xt.KEYCODE.ARROW_RIGHT == a) {
                  if (o.col < r[0].length - 1) return O(n, r[o.row][o.col + 1]), !1
                } else if (xt.KEYCODE.ARROW_DOWN == a) {
                  if (o.row < r.length - 1) return O(n, r[o.row + 1][o.col]), !1
                } else if (xt.KEYCODE.ARROW_LEFT == a) {
                  if (0 < o.col) return O(n, r[o.row][o.col - 1]), !1
                } else if (xt.KEYCODE.ARROW_UP == a && 0 < o.row) return O(n, r[o.row - 1][o.col]), !1
              }
            }(e) && setTimeout(function () {
              u()
            }, 0) : function s(e) {
              var t = e.which, n = L.selection.blocks();
              if (n.length && ("TD" == (n = n[0]).tagName || "TH" == n.tagName)) {
                for (var r = n; r && "TABLE" != r.tagName && r.parentNode != L.el;) r = r.parentNode;
                if (r && "TABLE" == r.tagName && (xt.KEYCODE.ARROW_LEFT == t || xt.KEYCODE.ARROW_UP == t || xt.KEYCODE.ARROW_RIGHT == t || xt.KEYCODE.ARROW_DOWN == t) && (0 < Q().length && I(), L.browser.webkit && (xt.KEYCODE.ARROW_UP == t || xt.KEYCODE.ARROW_DOWN == t))) {
                  var a = L.selection.ranges(0).startContainer;
                  if (a.nodeType == Node.TEXT_NODE && (xt.KEYCODE.ARROW_UP == t && (a.previousSibling && "BR" !== a.previousSibling.tagName || a.previousSibling && "BR" === a.previousSibling.tagName && a.previousSibling.previousSibling) || xt.KEYCODE.ARROW_DOWN == t && (a.nextSibling && "BR" !== a.nextSibling.tagName || a.nextSibling && "BR" === a.nextSibling.tagName && a.nextSibling.nextSibling))) return;
                  e.preventDefault(), e.stopPropagation();
                  var o = T(A(r)), i = S(n, o);
                  return xt.KEYCODE.ARROW_UP == t ? H(i, r, o) : xt.KEYCODE.ARROW_DOWN == t && $(i, r, o), L.selection.restore(), !1
                }
              }
            }(e)
          }), L.events.on("keydown", function (e) {
            if (!1 === function r(e) {
              if (e.which == xt.KEYCODE.TAB) {
                var t;
                if (0 < Q().length) t = L.$el.find(".fr-selected-cell").last(); else {
                  var n = L.selection.element();
                  "TD" == n.tagName || "TH" == n.tagName ? t = A(n) : n != L.el && (0 < A(n).parentsUntil(L.$el, "td").length ? t = A(n).parents("td").first() : 0 < A(n).parentsUntil(L.$el, "th").length && (t = A(n).parents("th").first()))
                }
                if (t) return e.preventDefault(), !!(0 === L.selection.get().focusOffset && 0 < A(L.selection.element()).parentsUntil(L.$el, "ol, ul").length && (0 < A(L.selection.element()).closest("li").prev().length || A(L.selection.element()).is("li") && 0 < A(L.selection.element()).prev().length)) || (I(), e.shiftKey ? 0 < t.prev().length ? q(t.prev()) : 0 < t.closest("tr").length && 0 < t.closest("tr").prev().length ? q(t.closest("tr").prev().find("td").last()) : 0 < t.closest("tbody").length && 0 < t.closest("table").find("thead tr").length && q(t.closest("table").find("thead tr th").last()) : 0 < t.next().length ? q(t.next()) : 0 < t.closest("tr").length && 0 < t.closest("tr").next().length ? q(t.closest("tr").next().find("td").first()) : 0 < t.closest("thead").length && 0 < t.closest("table").find("tbody tr").length ? q(t.closest("table").find("tbody tr td").first()) : (t.addClass("fr-selected-cell"), g("below"), y(), q(t.closest("tr").next().find("td").first())), L.selection.restore(), !1)
              }
            }(e)) return !1;
            var t = Q();
            if (0 < t.length) {
              if (0 < t.length && L.keys.ctrlKey(e) && e.which == xt.KEYCODE.A) return y(), L.popups.isVisible("table.edit") && L.popups.hide("table.edit"), t = [], !0;
              if (e.which == xt.KEYCODE.ESC && L.popups.isVisible("table.edit")) return y(), L.popups.hide("table.edit"), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), !(t = []);
              if (1 < t.length && (e.which == xt.KEYCODE.BACKSPACE || e.which == xt.KEYCODE.DELETE)) {
                L.undo.saveStep();
                for (var n = 0; n < t.length; n++) A(t[n]).html("<br>"), n == t.length - 1 && A(t[n]).prepend(xt.MARKERS);
                return L.selection.restore(), L.undo.saveStep(), !(t = [])
              }
              if (1 < t.length && e.which != xt.KEYCODE.F10 && !L.keys.isBrowserAction(e)) return e.preventDefault(), !(t = [])
            } else if (!(t = []) === function a(e) {
              if (e.altKey && e.which == xt.KEYCODE.SPACE) {
                var t, n = L.selection.element();
                if ("TD" == n.tagName || "TH" == n.tagName ? t = n : 0 < A(n).closest("td").length ? t = A(n).closest("td").get(0) : 0 < A(n).closest("th").length && (t = A(n).closest("th").get(0)), t) return e.preventDefault(), O(t, t), u(), !1
              }
            }(e)) return !1
          }, !0);
          var t = [];
          L.events.on("html.beforeGet", function () {
            t = Q();
            for (var e = 0; e < t.length; e++) t[e].className = (t[e].className || "").replace(/fr-selected-cell/g, "")
          }), L.events.on("html.afterGet", function () {
            for (var e = 0; e < t.length; e++) t[e].className = (t[e].className ? t[e].className.trim() + " " : "") + "fr-selected-cell";
            t = []
          }), d(!0), p(!0)
        }
        L.events.on("destroy", X)
      }, insert: function ne(e, t) {
        var n, r,
          a = "<table " + (L.opts.tableDefaultWidth ? 'style="width: ' + L.opts.tableDefaultWidth + ';" ' : "") + 'class="fr-inserted-table"><tbody>',
          o = 100 / t;
        for (n = 0; n < e; n++) {
          for (a += "<tr>", r = 0; r < t; r++) a += "<td" + (L.opts.tableDefaultWidth ? ' style="width: ' + o.toFixed(4) + '%;"' : "") + ">", 0 === n && 0 === r && (a += xt.MARKERS), a += "<br></td>";
          a += "</tr>"
        }
        if (a += "</tbody></table>", L.opts.trackChangesEnabled) {
          L.edit.on(), L.events.focus(!0), L.selection.restore(), L.undo.saveStep(), L.markers.insert(), L.html.wrap();
          var i = L.$el.find(".fr-marker");
          L.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a), L.selection.clear()
        } else L.html.insert(a);
        L.selection.restore();
        var s = L.$el.find(".fr-inserted-table");
        s.removeClass("fr-inserted-table"), L.events.trigger("table.inserted", [s.get(0)])
      }, remove: h, insertRow: g, deleteRow: function re() {
        var e = J();
        if (0 < e.length) {
          var t, n, r, a = T(), o = R(a);
          if (null == o) return;
          if (0 === o.min_i && o.max_i == a.length - 1) h(); else {
            for (t = o.max_i; t >= o.min_i; t--) {
              for (r = A(e.find("tr").not(e.find("> table tr")).get(t)), n = 0; n < a[t].length; n++) if (0 === n || a[t][n] != a[t][n - 1]) {
                var i = A(a[t][n]);
                if (1 < parseInt(i.attr("rowspan"), 10)) {
                  var s = parseInt(i.attr("rowspan"), 10) - 1;
                  1 == s ? i.removeAttr("rowspan") : i.attr("rowspan", s)
                }
                if (t < a.length - 1 && a[t][n] == a[t + 1][n] && (0 === t || a[t][n] != a[t - 1][n])) {
                  for (var l = a[t][n], c = n; 0 < c && a[t][c] == a[t][c - 1];) c--;
                  0 === c ? A(e.find("tr").not(e.find("> table tr")).get(t + 1)).prepend(l) : A(a[t + 1][c - 1])[0].parentNode && A(a[t + 1][c - 1])[0].insertAdjacentElement("afterend", l)
                }
              }
              var d = r.parent();
              r.remove(), 0 === d.find("tr").length && d.remove(), a = T(e)
            }
            C(0, a.length - 1, 0, a[0].length - 1, e), 0 < o.min_i ? L.selection.setAtEnd(a[o.min_i - 1][0]) : L.selection.setAtEnd(a[0][0]), L.selection.restore(), L.popups.hide("table.edit")
          }
        }
      }, insertColumn: function ae(l) {
        var e = J();
        if (0 < e.length) {
          var c, d = T(), t = R(d);
          c = "before" == l ? t.min_j : t.max_j;
          var n, f = 100 / d[0].length, p = 100 / (d[0].length + 1);
          e.find("th, td").each(function () {
            (n = A(this)).data("old-width", n.outerWidth() / e.outerWidth() * 100)
          }), e.find("tr").not(e.find("> table tr")).each(function (e) {
            for (var t, n = A(this), r = 0, a = 0; r - 1 < c;) {
              if (!(t = n.find("> th, > td").get(a))) {
                t = null;
                break
              }
              t == d[e][r] ? (r += parseInt(A(t).attr("colspan"), 10) || 1, a++) : (r += parseInt(A(d[e][r]).attr("colspan"), 10) || 1, "after" == l && (t = 0 === a ? -1 : n.find("> th, > td").get(a - 1)))
            }
            var o, i = A(t);
            if ("after" == l && c < r - 1 || "before" == l && 0 < c && d[e][c] == d[e][c - 1]) {
              if (0 === e || 0 < e && d[e][c] != d[e - 1][c]) {
                var s = parseInt(i.attr("colspan"), 10) + 1;
                i.attr("colspan", s), i.css("width", (i.data("old-width") * p / f + p).toFixed(4) + "%"), i.removeData("old-width")
              }
            } else o = 0 < n.find("th").length ? '<th style="width: '.concat(p.toFixed(4), '%;"><br></th>') : '<td style="width: '.concat(p.toFixed(4), '%;"><br></td>'), -1 == t ? n.prepend(o) : null == t ? n.append(o) : "before" == l ? i.before(o) : "after" == l && i[0].parentNode && i[0].insertAdjacentHTML("afterend", o)
          }), e.find("th, td").each(function () {
            (n = A(this)).data("old-width") && (n.css("width", (n.data("old-width") * p / f).toFixed(4) + "%"), n.removeData("old-width"))
          }), L.popups.isVisible("table.edit") && u()
        }
      }, deleteColumn: function oe() {
        var e = J();
        if (0 < e.length) {
          var t, n, r, a = T(), o = R(a);
          if (null == o) return;
          if (0 === o.min_j && o.max_j == a[0].length - 1) h(); else {
            var i = 0;
            for (t = 0; t < a.length; t++) for (n = 0; n < a[0].length; n++) (r = A(a[t][n])).hasClass("fr-selected-cell") || (r.data("old-width", r.outerWidth() / e.outerWidth() * 100), (n < o.min_j || n > o.max_j) && (i += r.outerWidth() / e.outerWidth() * 100));
            for (i /= a.length, n = o.max_j; n >= o.min_j; n--) for (t = 0; t < a.length; t++) if (0 === t || a[t][n] != a[t - 1][n]) if (r = A(a[t][n]), 1 < (parseInt(r.attr("colspan"), 10) || 1)) {
              var s = parseInt(r.attr("colspan"), 10) - 1;
              1 == s ? r.removeAttr("colspan") : r.attr("colspan", s), r.css("width", (100 * (r.data("old-width") - G(n, a)) / i).toFixed(4) + "%"), r.removeData("old-width")
            } else {
              var l = A(r.parent().get(0));
              r.remove(), 0 === l.find("> th, > td").length && (0 === l.prev().length || 0 === l.next().length || l.prev().find("> th[rowspan], > td[rowspan]").length < l.prev().find("> th, > td").length) && l.remove()
            }
            C(0, a.length - 1, 0, a[0].length - 1, e), 0 < o.min_j ? L.selection.setAtEnd(a[o.min_i][o.min_j - 1]) : L.selection.setAtEnd(a[o.min_i][0]), L.selection.restore(), L.popups.hide("table.edit"), e.find("th, td").each(function () {
              (r = A(this)).data("old-width") && (r.css("width", (100 * r.data("old-width") / i).toFixed(4) + "%"), r.removeData("old-width"))
            })
          }
        }
      }, mergeCells: function ie() {
        if (1 < Q().length && (0 === L.$el.find("th.fr-selected-cell").length || 0 === L.$el.find("td.fr-selected-cell").length)) {
          E();
          var e, t, n = R(T());
          if (null == n) return;
          var r = L.$el.find(".fr-selected-cell"), a = A(r[0]), o = a.parent().find(".fr-selected-cell"),
            i = a.closest("table"), s = a.html(), l = 0;
          for (e = 0; e < o.length; e++) l += A(o[e]).outerWidth();
          for (a.css("width", Math.min(100, l / i.outerWidth() * 100).toFixed(4) + "%"), n.min_j < n.max_j && a.attr("colspan", n.max_j - n.min_j + 1), n.min_i < n.max_i && a.attr("rowspan", n.max_i - n.min_i + 1), e = 1; e < r.length; e++) "<br>" != (t = A(r[e])).html() && "" !== t.html() && (s += "<br>".concat(t.html())), t.remove();
          a.html(s), L.selection.setAtEnd(a.get(0)), L.selection.restore(), L.toolbar.enable(), v(n.min_i, n.max_i, i);
          var c = i.find("tr:empty");
          for (e = c.length - 1; 0 <= e; e--) A(c[e]).remove();
          m(n.min_j, n.max_j, i), u()
        }
      }, splitCellVertically: function se() {
        if (1 == Q().length) {
          var e = L.$el.find(".fr-selected-cell"), t = parseInt(e.attr("colspan"), 10) || 1,
            n = e.parent().outerWidth(), r = e.outerWidth(), a = e.clone().html("<br>"), o = T(), i = S(e.get(0), o);
          if (1 < t) {
            var s = Math.ceil(t / 2);
            r = Y(i.col, i.col + s - 1, o) / n * 100;
            var l = Y(i.col + s, i.col + t - 1, o) / n * 100;
            1 < s ? e.attr("colspan", s) : e.removeAttr("colspan"), 1 < t - s ? a.attr("colspan", t - s) : a.removeAttr("colspan"), e.css("width", r.toFixed(4) + "%"), a.css("width", l.toFixed(4) + "%")
          } else {
            var c;
            for (c = 0; c < o.length; c++) if (0 === c || o[c][i.col] != o[c - 1][i.col]) {
              var d = A(o[c][i.col]);
              if (!d.is(e)) {
                var f = (parseInt(d.attr("colspan"), 10) || 1) + 1;
                d.attr("colspan", f)
              }
            }
            r = r / n * 100 / 2, e.css("width", "".concat(r.toFixed(4), "%")), a.css("width", "".concat(r.toFixed(4), "%"))
          }
          e[0].parentNode && e[0].insertAdjacentElement("afterend", a[0]), y(), L.popups.hide("table.edit")
        }
      }, splitCellHorizontally: function le() {
        if (1 == Q().length) {
          var e = L.$el.find(".fr-selected-cell"), t = e.parent(), n = e.closest("table"),
            r = parseInt(e.attr("rowspan"), 10), a = T(), o = S(e.get(0), a), i = e.clone().html("<br>");
          if (1 < r) {
            var s = Math.ceil(r / 2);
            1 < s ? e.attr("rowspan", s) : e.removeAttr("rowspan"), 1 < r - s ? i.attr("rowspan", r - s) : i.removeAttr("rowspan");
            for (var l = o.row + s, c = 0 === o.col ? o.col : o.col - 1; 0 <= c && (a[l][c] == a[l][c - 1] || 0 < l && a[l][c] == a[l - 1][c]);) c--;
            -1 == c ? A(n.find("tr").not(n.find("> table tr")).get(l)).prepend(i) : A(a[l][c])[0].parentNode && A(a[l][c])[0].insertAdjacentElement("afterend", i[0])
          } else {
            var d, f = A(document.createElement("tr")).append(i);
            for (d = 0; d < a[0].length; d++) if (0 === d || a[o.row][d] != a[o.row][d - 1]) {
              var p = A(a[o.row][d]);
              p.is(e) || p.attr("rowspan", (parseInt(p.attr("rowspan"), 10) || 1) + 1)
            }
            t[0].parentNode && t[0].insertAdjacentElement("afterend", f[0])
          }
          y(), L.popups.hide("table.edit")
        }
      }, addHeader: function ce() {
        var e = J();
        if (0 < e.length && 0 === e.find("th").length) {
          var t, n = "<thead><tr>", r = 0;
          for (e.find("tr").first().find("> td").each(function () {
            var e = A(this);
            r += parseInt(e.attr("colspan"), 10) || 1
          }), t = 0; t < r; t++) n += "<th><br></th>";
          n += "</tr></thead>", e.prepend(n), u()
        }
      }, removeHeader: function de() {
        var e = J(), t = e.find("thead");
        if (0 < t.length) if (0 === e.find("tbody tr").length) h(); else if (t.remove(), 0 < Q().length) u(); else {
          L.popups.hide("table.edit");
          var n = e.find("tbody tr").first().find("td").first().get(0);
          n && (L.selection.setAtEnd(n), L.selection.restore())
        }
      }, setBackground: t, showInsertPopup: function fe() {
        var e = L.$tb.find('.fr-command[data-cmd="insertTable"]'), t = L.popups.get("table.insert");
        if (t || (t = d()), !t.hasClass("fr-active")) {
          L.popups.refresh("table.insert"), L.popups.setContainer("table.insert", L.$tb);
          var n = L.button.getPosition(e), r = n.left, a = n.top;
          L.popups.show("table.insert", r, a, e.outerHeight())
        }
      }, showEditPopup: u, showColorsPopup: s, back: function pe() {
        0 < Q().length ? u() : (L.popups.hide("table.insert"), L.toolbar.showInline())
      }, verticalAlign: function ue(e) {
        L.$el.find(".fr-selected-cell").css("vertical-align", e)
      }, horizontalAlign: function he(e) {
        L.$el.find(".fr-selected-cell").css("text-align", e)
      }, applyStyle: function ge(e, t, n, r) {
        if (0 < t.length) {
          if (!n) {
            var a = Object.keys(r);
            a.splice(a.indexOf(e), 1), t.removeClass(a.join(" "))
          }
          t.toggleClass(e)
        }
      }, selectedTable: J, selectedCells: Q, customColor: function me() {
        var e = L.popups.get("table.colors").find(".fr-table-colors-hex-layer input");
        e.length && t(e.val())
      }, selectCells: O
    }
  }, xt.DefineIcon("insertTable", {
    NAME: "table",
    SVG_KEY: "insertTable"
  }), xt.RegisterCommand("insertTable", {
    title: "Insert Table",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("table.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("table.insert")) : this.table.showInsertPopup()
    },
    plugin: "table"
  }), xt.RegisterCommand("tableInsert", {
    callback: function (e, t, n) {
      this.table.insert(t, n), this.popups.hide("table.insert")
    }
  }), xt.DefineIcon("tableHeader", {
    NAME: "header",
    FA5NAME: "heading",
    SVG_KEY: "tableHeader"
  }), xt.RegisterCommand("tableHeader", {
    title: "Table Header", focus: !1, toggle: !0, callback: function () {
      this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active") ? this.table.removeHeader() : this.table.addHeader()
    }, refresh: function (e) {
      var t = this.table.selectedTable();
      0 < t.length && (0 === t.find("th").length ? e.removeClass("fr-active").attr("aria-pressed", !1) : e.addClass("fr-active").attr("aria-pressed", !0))
    }
  }), xt.DefineIcon("tableRows", {NAME: "bars", SVG_KEY: "row"}),xt.RegisterCommand("tableRows", {
    type: "dropdown",
    focus: !1,
    title: "Row",
    options: {above: "Insert row above", below: "Insert row below", "delete": "Delete row"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableRows.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="' + n + '" title="' + this.language.translate(t[n]) + '">' + this.language.translate(t[n]) + "</a></li>");
      return e += "</ul>"
    },
    callback: function (e, t) {
      "above" == t || "below" == t ? this.table.insertRow(t) : this.table.deleteRow()
    }
  }),xt.DefineIcon("tableColumns", {
    NAME: "bars fa-rotate-90",
    SVG_KEY: "columns"
  }),xt.RegisterCommand("tableColumns", {
    type: "dropdown",
    focus: !1,
    title: "Column",
    options: {before: "Insert column before", after: "Insert column after", "delete": "Delete column"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableColumns.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      "before" == t || "after" == t ? this.table.insertColumn(t) : this.table.deleteColumn()
    }
  }),xt.DefineIcon("tableCells", {
    NAME: "square-o",
    FA5NAME: "square",
    SVG_KEY: "cellOptions"
  }),xt.RegisterCommand("tableCells", {
    type: "dropdown",
    focus: !1,
    title: "Cell",
    options: {merge: "Merge cells", "vertical-split": "Vertical split", "horizontal-split": "Horizontal split"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCells.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      "merge" == t ? this.table.mergeCells() : "vertical-split" == t ? this.table.splitCellVertically() : this.table.splitCellHorizontally()
    },
    refreshOnShow: function (e, t) {
      1 < this.$el.find(".fr-selected-cell").length ? (t.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled", !1)) : (t.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled", !1), t.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled", !1))
    }
  }),xt.DefineIcon("tableRemove", {
    NAME: "trash",
    SVG_KEY: "removeTable"
  }),xt.RegisterCommand("tableRemove", {
    title: "Remove Table", focus: !1, callback: function () {
      this.table.remove()
    }
  }),xt.DefineIcon("tableStyle", {
    NAME: "paint-brush",
    SVG_KEY: "tableStyle"
  }),xt.RegisterCommand("tableStyle", {
    title: "Table Style", type: "dropdown", focus: !1, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.tableStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.table.applyStyle(t, this.$el.find(".fr-selected-cell").closest("table"), this.opts.tableMultipleStyles, this.opts.tableStyles)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.$el.find(".fr-selected-cell").closest("table");
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.DefineIcon("tableCellBackground", {
    NAME: "tint",
    SVG_KEY: "cellBackground"
  }),xt.RegisterCommand("tableCellBackground", {
    title: "Cell Background", focus: !1, popup: !0, callback: function () {
      this.table.showColorsPopup()
    }
  }),xt.RegisterCommand("tableCellBackgroundColor", {
    undo: !0, focus: !1, callback: function (e, t) {
      this.table.setBackground(t)
    }
  }),xt.DefineIcon("tableBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("tableBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.table.back()
    },
    refresh: function (e) {
      0 !== this.table.selectedCells().length || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.DefineIcon("tableCellVerticalAlign", {
    NAME: "arrows-v",
    FA5NAME: "arrows-alt-v",
    SVG_KEY: "verticalAlignMiddle"
  }),xt.RegisterCommand("tableCellVerticalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Vertical Align",
    options: {Top: "Align Top", Middle: "Align Middle", Bottom: "Align Bottom"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCellVerticalAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'.concat(n.toLowerCase(), '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(n), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.table.verticalAlign(t)
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.$el.find(".fr-selected-cell").css("vertical-align") + '"]').addClass("fr-active").attr("aria-selected", !0)
    }
  }),xt.DefineIcon("tableCellHorizontalAlign", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("align-center", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }),xt.DefineIcon("align-justify", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.RegisterCommand("tableCellHorizontalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Horizontal Align",
    options: {left: "Align Left", center: "Align Center", right: "Align Right", justify: "Align Justify"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCellHorizontalAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.table.horizontalAlign(t)
    },
    refresh: function (e) {
      var t = this.table.selectedCells(), n = this.$;
      t.length && e.find("> *").first().replaceWith(this.icon.create("align-".concat(this.helpers.getAlignment(n(t[0])))))
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.helpers.getAlignment(this.$el.find(".fr-selected-cell").first()) + '"]').addClass("fr-active").attr("aria-selected", !0)
    }
  }),xt.DefineIcon("tableCellStyle", {
    NAME: "magic",
    SVG_KEY: "cellStyle"
  }),xt.RegisterCommand("tableCellStyle", {
    title: "Cell Style", type: "dropdown", focus: !1, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.tableCellStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.table.applyStyle(t, this.$el.find(".fr-selected-cell"), this.opts.tableCellMultipleStyles, this.opts.tableCellStyles)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.$el.find(".fr-selected-cell").first();
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.RegisterCommand("tableCellBackgroundCustomColor", {
    title: "OK", undo: !0, callback: function () {
      this.table.customColor()
    }
  }),xt.DefineIcon("tableColorRemove", {
    NAME: "eraser",
    SVG_KEY: "remove"
  }),xt.URLRegEx = "(^| |\\u00A0)(".concat(xt.LinkRegEx, "|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\.[a-z0-9+-_]{1,}))$"),xt.PLUGINS.url = function (i) {
    var s = i.$, o = null;

    function t(e, t, n) {
      for (var r = ""; n.length && "." == n[n.length - 1];) r += ".", n = n.substring(0, n.length - 1);
      var a = n;
      if (i.opts.linkConvertEmailAddress) i.helpers.isEmail(a) && !/^mailto:.*/i.test(a) && (a = "mailto:".concat(a)); else if (i.helpers.isEmail(a)) return t + n;
      return /^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\:)/i.test(a) || (a = "//".concat(a)), (t || "") + "<a".concat(i.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(o ? ' rel="'.concat(o, '"') : "", ' data-fr-linked="true" href="').concat(a, '">').concat(n.replace(/&amp;/g, "&").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "</a>").concat(r)
    }

    var l = function l() {
      return new RegExp(xt.URLRegEx, "gi")
    };

    function c(e) {
      return i.opts.linkAlwaysNoFollow && (o = "nofollow"), i.opts.linkAlwaysBlank && (i.opts.linkNoOpener && (o ? o += " noopener" : o = "noopener"), i.opts.linkNoReferrer && (o ? o += " noreferrer" : o = "noreferrer")), e.replace(l(), t)
    }

    function d(e) {
      var t = e.split(" ");
      return t[t.length - 1]
    }

    function n() {
      var e = i.selection.ranges(0), t = e.startContainer;
      if (!t || t.nodeType !== Node.TEXT_NODE || e.startOffset !== (t.textContent || "").length) return !1;
      if (function o(e) {
        return !!e && ("A" === e.tagName || !(!e.parentNode || e.parentNode == i.el) && o(e.parentNode))
      }(t)) return !1;
      if (l().test(d(t.textContent))) {
        s(t).before(c(t.textContent));
        var n = s(t.parentNode).find("a[data-fr-linked]");
        n.removeAttr("data-fr-linked"), t.parentNode.removeChild(t), i.events.trigger("url.linked", [n.get(0)])
      } else if (t.textContent.split(" ").length <= 2 && t.previousSibling && "A" === t.previousSibling.tagName) {
        var r = t.previousSibling.innerText + t.textContent;
        if (l().test(d(r))) {
          var a = (new DOMParser).parseFromString(c(r), "text/html").body.childNodes;
          t.parentNode.replaceChild(a[0], t.previousSibling), a.length && s(t).before(a[0]), t.parentNode.removeChild(t)
        }
      }
    }

    return {
      _init: function e() {
        i.events.on("keypress", function (e) {
          !i.selection.isCollapsed() || ")" != e.key && "(" != e.key || n()
        }, !0), i.events.on("keydown", function (e) {
          var t = e.which;
          !i.selection.isCollapsed() || t != xt.KEYCODE.ENTER && t != xt.KEYCODE.SPACE || n()
        }, !0), i.events.on("paste.beforeCleanup", function (e) {
          if (i.helpers.isURL(e)) {
            var t = null;
            return i.opts.linkAlwaysBlank && (i.opts.linkNoOpener && (t ? t += " noopener" : t = "noopener"), i.opts.linkNoReferrer && (t ? t += " noreferrer" : t = "noreferrer")), "<a".concat(i.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(t ? ' rel="'.concat(t, '"') : "", ' href="').concat(e, '" >').concat(e, "</a>")
          }
        })
      }
    }
  },Object.assign(xt.POPUP_TEMPLATES, {
    "video.insert": "[_BUTTONS_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_LAYER_][_PROGRESS_BAR_]",
    "video.edit": "[_BUTTONS_]",
    "video.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }),Object.assign(xt.DEFAULTS, {
    videoAllowedTypes: ["mp4", "webm", "ogg", "mp3", "mpeg", "url"],
    videoAllowedProviders: [".*"],
    videoDefaultAlign: "center",
    videoDefaultDisplay: "block",
    videoDefaultWidth: 600,
    videoEditButtons: ["videoReplace", "videoRemove", "videoDisplay", "videoAlign", "videoSize", "autoplay"],
    videoInsertButtons: ["videoBack", "|", "videoByURL", "videoEmbed", "videoUpload"],
    videoMaxSize: 52428800,
    videoMove: !0,
    videoResize: !0,
    videoResponsive: !1,
    videoSizeButtons: ["videoBack", "|"],
    videoSplitHTML: !1,
    videoTextNear: !0,
    videoUpload: !0,
    videoUploadMethod: "POST",
    videoUploadParam: "file",
    videoUploadParams: {},
    videoUploadToS3: !1,
    videoUploadToAzure: !1,
    videoUploadURL: null
  }),xt.VIDEO_PROVIDERS = [{
    test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
    url_text: "https://www.youtube.com/embed/$1?$2",
    html: '<iframe width="640" height="360" src="{url}&wmode=opaque&rel=0" frameborder="0" allowfullscreen></iframe>',
    provider: "youtube"
  }, {
    test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
    url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,
    url_text: "https://player.vimeo.com/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vimeo"
  }, {
    test_regex: /^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,
    url_text: "https://www.dailymotion.com/embed/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "dailymotion"
  }, {
    test_regex: /^.+(screen.yahoo.com)\/[^_&]+/,
    url_regex: "",
    url_text: "",
    html: '<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "yahoo"
  }, {
    test_regex: /^.+(rutube.ru)\/[^_&]+/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,
    url_text: "https://rutube.ru/play/embed/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "rutube"
  }, {
    test_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
    url_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,
    url_text: "https://play.vidyard.com/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vidyard"
  }, {
    test_regex: /.*\.mp4\??.*$/i,
    url_regex: "",
      url_text: "",
      html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
      provider: "*"
    },
  ],xt.VIDEO_EMBED_REGEX = /^\W*((<iframe(.|\n)*>(\s|\n)*<\/iframe>)|(<embed(.|\n)*>))\W*$/i,xt.PLUGINS.video = function (E) {
    var s, d, f, y, r, n, L = E.$, _ = "https://i.froala.com/upload", p = 2, u = 3, h = 4, w = 5, A = 6, a = {};

    function g() {
      var e = E.popups.get("video.insert");
      e.find(".fr-video-by-url-layer input").val("").trigger("change");
      var t = e.find(".fr-video-embed-layer textarea");
      t.val("").trigger("change"), (t = e.find(".fr-video-upload-layer input")).val("").trigger("change")
    }

    function o() {
      var e = E.popups.get("video.edit");
      if (e || (e = function i() {
        var e = "";
        if (0 < E.opts.videoEditButtons.length) {
          E.opts.videoResponsive && (-1 < E.opts.videoEditButtons.indexOf("videoSize") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoSize"), 1), -1 < E.opts.videoEditButtons.indexOf("videoDisplay") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoDisplay"), 1), -1 < E.opts.videoEditButtons.indexOf("videoAlign") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoAlign"), 1));
          var t = {buttons: e += '<div class="fr-buttons"> \n      '.concat(E.button.buildList(E.opts.videoEditButtons), " \n      </div>")},
            n = E.popups.create("video.edit", t);
          return E.events.$on(E.$wp, "scroll.video-edit", function () {
            y && E.popups.isVisible("video.edit") && (E.events.disableBlur(), C(y))
          }), n
        }
        return !1
      }()), e) {
        E.popups.setContainer("video.edit", E.$sc), E.popups.refresh("video.edit");
        var t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight(),
          a = t.get(0).src ? t.get(0).src : t.get(0).currentSrc,
          o = !(!(a = (a = a.split("."))[a.length - 1]).includes("pdf") && !a.includes("txt"));
        t.hasClass("fr-file") || o || y.find("audio").get(0) ? (document.getElementById("autoplay-".concat(E.id)) && (document.getElementById("autoplay-".concat(E.id)).style.display = "none"), document.getElementById("videoReplace-".concat(E.id)) && (document.getElementById("videoReplace-".concat(E.id)).style.display = "none")) : (document.getElementById("autoplay-".concat(E.id)) && (document.getElementById("autoplay-".concat(E.id)).style.display = ""), document.getElementById("videoReplace-".concat(E.id)) && (document.getElementById("videoReplace-".concat(E.id)).style.display = "")), E.popups.show("video.edit", n, r, t.outerHeight(), !0)
      }
    }

    function i(e) {
      if (e) return E.popups.onRefresh("video.insert", g), E.popups.onHide("video.insert", Z), !0;
      var t = "";
      E.opts.videoUpload || -1 === E.opts.videoInsertButtons.indexOf("videoUpload") || E.opts.videoInsertButtons.splice(E.opts.videoInsertButtons.indexOf("videoUpload"), 1);
      var n = E.button.buildList(E.opts.videoInsertButtons);
      "" !== n && (t = '<div class="fr-buttons">' + n + "</div>");
      var r, a = "", o = E.opts.videoInsertButtons.indexOf("videoUpload"),
        i = E.opts.videoInsertButtons.indexOf("videoByURL"), s = E.opts.videoInsertButtons.indexOf("videoEmbed");
      if (0 <= i) {
        r = " fr-active", (o < i && 0 <= o || s < i && 0 <= s) && (r = "");
        a = '<div class="fr-video-by-url-layer fr-layer'.concat(r, '" id="fr-video-by-url-layer-').concat(E.id, '"><div class="fr-input-line"><input id="fr-video-by-url-layer-text-').concat(E.id, '" type="text" placeholder="').concat(E.language.translate("Paste in a video URL"), '" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><span style=\'float:left\'><div class="fr-checkbox-line fr-autoplay-margin"><span class="fr-checkbox"> <input id=\'videoPluginAutoplay\' data-checked="_blank" type="checkbox"> <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '</span></span> <label id="fr-label-target-').concat(E.id, '">Autoplay</label></div> </span><button type="button" class="fr-command fr-submit" data-cmd="videoInsertByURL" tabIndex="2" role="button">').concat(E.language.translate("Insert"), "</button></div></div>")
      }
      var l = "";
      0 <= s && (r = " fr-active", (o < s && 0 <= o || i < s && 0 <= i) && (r = ""), l = '<div class="fr-video-embed-layer fr-layer'.concat(r, '" id="fr-video-embed-layer-').concat(E.id, '"><div class="fr-input-line"><textarea id="fr-video-embed-layer-text').concat(E.id, '" type="text" placeholder="').concat(E.language.translate("Embedded Code"), '" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertEmbed" tabIndex="2" role="button">').concat(E.language.translate("Insert"), "</button></div></div>"));
      var c = "";
      0 <= o && (r = " fr-active", (s < o && 0 <= s || i < o && 0 <= i) && (r = ""), c = '<div class="fr-video-upload-layer fr-layer'.concat(r, '" id="fr-video-upload-layer-').concat(E.id, '"><strong>').concat(E.language.translate("Drop video"), "</strong><br>(").concat(E.language.translate("or click"), ')<div class="fr-form"><input type="file" accept="video/').concat(E.opts.videoAllowedTypes.join(", video/").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-video-upload-layer-').concat(E.id, '" role="button"></div></div>'));
      var d = {
        buttons: t,
        by_url_layer: a,
        embed_layer: l,
        upload_layer: c,
        progress_bar: '<div class="fr-video-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="videoDismissError" tabIndex="2" role="button">OK</button></div></div>'
      }, f = E.popups.create("video.insert", d);
      return function p(r) {
        E.events.$on(r, "dragover dragenter", ".fr-video-upload-layer", function () {
          return L(this).addClass("fr-drop"), !1
        }, !0), E.events.$on(r, "dragleave dragend", ".fr-video-upload-layer", function () {
          return L(this).removeClass("fr-drop"), !1
        }, !0), E.events.$on(r, "drop", ".fr-video-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), L(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          if (t && t.files) {
            var n = r.data("instance") || E;
            n.events.disableBlur(), n.video.upload(t.files), n.events.enableBlur()
          }
        }, !0), E.helpers.isIOS() && E.events.$on(r, "touchstart", '.fr-video-upload-layer input[type="file"]', function () {
          L(this).trigger("click")
        }, !0);
        E.events.$on(r, "change", '.fr-video-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = r.data("instance") || E;
            e.events.disableBlur(), r.find("input:focus").blur(), e.events.enableBlur(), e.video.upload(this.files)
          }
          L(this).val("")
        }, !0)
      }(f), f
    }

    function l(e) {
      E.events.focus(!0), E.selection.restore();
      var t = !1;
      if (y && (q(), t = !0), E.opts.trackChangesEnabled) {
        E.edit.on(), E.events.focus(!0), E.selection.restore(), E.undo.saveStep(), E.markers.insert(), E.html.wrap();
        var n = E.$el.find(".fr-marker");
        E.node.isLastSibling(n) && n.parent().hasClass("fr-deletable") && n.insertAfter(n.parent()), n.replaceWith('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e, "</span>")), E.selection.clear()
      } else E.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e, "</span>"), !1, E.opts.videoSplitHTML);
      E.popups.hide("video.insert");
      var r = E.$el.find(".fr-jiv");
      r.removeClass("fr-jiv"), r.toggleClass("fr-rv", E.opts.videoResponsive), X(r, E.opts.videoDefaultDisplay, E.opts.videoDefaultAlign), r.toggleClass("fr-draggable", E.opts.videoMove), E.events.trigger(t ? "video.replaced" : "video.inserted", [r])
    }

    function m() {
      var e = L(this);
      E.popups.hide("video.insert"), e.removeClass("fr-uploading"), e.parent().next().is("br") && e.parent().next().remove(), C(e.parent()), E.events.trigger("video.loaded", [e.parent()])
    }

    function T(s, e, c, d, f) {
      E.edit.off(), v("Loading video"), e && (s = E.helpers.sanitizeURL(s));
      var p = function p() {
        var e, t;
        if (d) {
          E.undo.canDo() || d.find("video").hasClass("fr-uploading") || E.undo.saveStep();
          var n = d.find("video").data("fr-old-src"), r = d.data("fr-replaced");
          d.data("fr-replaced", !1), E.$wp ? ((e = d.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"), e.find("video").off("canplay"), n && d.find("video").attr("src", n), d.replaceWith(e)) : e = d;
          for (var a = e.find("video").get(0).attributes, o = 0; o < a.length; o++) {
            var i = a[o];
            0 === i.nodeName.indexOf("data-") && e.find("video").removeAttr(i.nodeName)
          }
          if (void 0 !== c) for (t in c) c.hasOwnProperty(t) && "link" != t && e.find("video").attr("data-".concat(t), c[t]);
          e.find("video").on("canplay", m), e.find("video").attr("src", s), E.edit.on(), H(), E.undo.saveStep(), E.$el.blur(), E.events.trigger(r ? "video.replaced" : "video.inserted", [e, f])
        } else e = function l(e, t, n) {
          var r, a = "";
          if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (a += " data-".concat(r, '="').concat(t[r], '"'));
          var o = E.opts.videoDefaultWidth;
          o && "auto" != o && (o = "".concat(o, "px"));
          var i = L(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + E.opts.videoDefaultDisplay[0] + ("center" != E.opts.videoDefaultAlign ? " fr-fv" + E.opts.videoDefaultAlign[0] : "")).html('<video src="' + e + '" ' + a + (o ? ' style="width: ' + o + ';" ' : "") + " controls>" + E.language.translate("Your browser does not support HTML5 video.") + "</video>");
          i.toggleClass("fr-draggable", E.opts.videoMove), E.edit.on(), E.events.focus(!0), E.selection.restore(), E.undo.saveStep(), E.opts.videoSplitHTML ? E.markers.split() : E.markers.insert();
          E.html.wrap();
          var s = E.$el.find(".fr-marker");
          E.node.isLastSibling(s) && s.parent().hasClass("fr-deletable") && s.insertAfter(s.parent());
          s.replaceWith(i), E.selection.clear(), i.find("video").get(0).readyState > i.find("video").get(0).HAVE_FUTURE_DATA || E.helpers.isIOS() ? n.call(i.find("video").get(0)) : i.find("video").on("canplaythrough load", n);
          return i
        }(s, c, m), H(), E.undo.saveStep(), E.events.trigger("video.inserted", [e, f])
      };
      S("Loading video"), p()
    }

    function S(e) {
      var t = E.popups.get("video.insert");
      if (t || (t = i()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-video-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), y) {
        var n = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
        E.popups.setContainer("video.insert", E.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        E.popups.show("video.insert", r, a, n.outerHeight())
      }
      void 0 === e && v(E.language.translate("Uploading"), 0)
    }

    function c(e) {
      var t = E.popups.get("video.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-video-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || E.$el.find("video.fr-error").length)) {
        if (E.events.focus(), E.$el.find("video.fr-error").length && (E.$el.find("video.fr-error").parent().remove(), E.undo.saveStep(), E.undo.run(), E.undo.dropRedo()), !E.$wp && y) {
          var n = y;
          F(!0), E.selection.setAfter(n.find("video").get(0)), E.selection.restore()
        }
        E.popups.hide("video.insert")
      }
    }

    function v(e, t) {
      var n = E.popups.get("video.insert");
      if (n) {
        var r = n.find(".fr-video-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function b(e) {
      S();
      var t = E.popups.get("video.insert").find(".fr-video-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), E.events.disableBlur(), n.focus()
    }

    function C(e) {
      t.call(e.get(0))
    }

    function k(e, t, n) {
      v("Loading video");
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (E.opts.videoUploadToS3 || E.opts.videoUploadToAzure) if (201 == r) {
          var s;
          if (E.opts.videoUploadToAzure) {
            if (!1 === E.events.trigger("video.uploadedToAzure", [this.responseURL, n, a], !0)) return E.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = L(e).find("Location").text(), n = L(e).find("Key").text();
              return !1 === E.events.trigger("video.uploadedToS3", [t, n, e], !0) ? (E.edit.on(), !1) : t
            } catch (r) {
              return V(h, e), !1
            }
          }(o);
          s && T(s, !1, [], e, a || o)
        } else V(h, a || o); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === E.events.trigger("video.uploaded", [e], !0)) return E.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (V(p, e), !1)
            } catch (n) {
              return V(h, e), !1
            }
          }(i);
          l && T(l.link, !1, l, e, a || i)
        } else V(u, a || i)
      } catch (f) {
        V(h, a || i)
      }
    }

    function x() {
      V(h, this.response || this.responseText || this.responseXML)
    }

    function R(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        v(E.language.translate("Uploading"), t)
      }
    }

    function M() {
      E.edit.on(), c(!0)
    }

    function O(e) {
      if (!E.core.sameInstance(f)) return !0;
      e.preventDefault(), e.stopPropagation();
      var t = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null),
        n = e.pageY || (e.originalEvent.touches ? e.originalEvent.touches[0].pageY : null);
      if (!t || !n) return !1;
      if ("mousedown" == e.type) {
        var r = E.$oel.get(0).ownerDocument, a = r.defaultView || r.parentWindow, o = !1;
        try {
          o = a.location != a.parent.location && !(a.$ && a.$.FE)
        } catch (i) {
        }
        o && a.frameElement && (t += E.helpers.getPX(L(a.frameElement).offset().left) + a.frameElement.clientLeft, n = e.clientY + E.helpers.getPX(L(a.frameElement).offset().top) + a.frameElement.clientTop)
      }
      E.undo.canDo() || E.undo.saveStep(), (d = L(this)).data("start-x", t), d.data("start-y", n), s.show(), E.popups.hideAll(), U()
    }

    function N(e) {
      if (!E.core.sameInstance(f)) return !0;
      if (d) {
        e.preventDefault();
        var t = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null),
          n = e.pageY || (e.originalEvent.touches ? e.originalEvent.touches[0].pageY : null);
        if (!t || !n) return !1;
        var r = d.data("start-x"), a = d.data("start-y");
        d.data("start-x", t), d.data("start-y", n);
        var o = t - r, i = n - a,
          s = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          l = s.width(), c = s.height();
        (d.hasClass("fr-hnw") || d.hasClass("fr-hsw")) && (o = 0 - o), (d.hasClass("fr-hnw") || d.hasClass("fr-hne")) && (i = 0 - i), s.css("width", l + o), s.css("height", c + i), s.removeAttr("width"), s.removeAttr("height"), $()
      }
    }

    function I(e) {
      if (!E.core.sameInstance(f)) return !0;
      d && y && (e && e.stopPropagation(), d = null, s.hide(), $(), o(), E.undo.saveStep())
    }

    function D(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function B(e, t, n, r) {
      return e.pageX = t, e.pageY = t, O.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), e.pageY = e.pageY + n * Math.floor(Math.pow(1.1, r)), N.call(this, e), I.call(this, e), ++r
    }

    function H() {
      var e, t = Array.prototype.slice.call(E.el.querySelectorAll("video, .fr-video > *")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("src")), L(t[e]).toggleClass("fr-draggable", E.opts.videoMove), "" === t[e].getAttribute("class") && t[e].removeAttribute("class"), "" === t[e].getAttribute("style") && t[e].removeAttribute("style");
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("src")) < 0 && E.events.trigger("video.removed", [L(r[e])]);
      r = t
    }

    function $() {
      f || function i() {
        var e;
        if (E.shared.$video_resizer ? (f = E.shared.$video_resizer, s = E.shared.$vid_overlay, E.events.on("destroy", function () {
          L("body").first().append(f.removeClass("fr-active"))
        }, !0)) : (E.shared.$video_resizer = L(document.createElement("div")).attr("class", "fr-video-resizer"), f = E.shared.$video_resizer, E.events.$on(f, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), E.opts.videoResize && (f.append(D("nw") + D("ne") + D("sw") + D("se")), E.shared.$vid_overlay = L(document.createElement("div")).attr("class", "fr-video-overlay"), s = E.shared.$vid_overlay, e = f.get(0).ownerDocument, L(e).find("body").first().append(s))), E.events.on("shared.destroy", function () {
          f.html("").removeData().remove(), f = null, E.opts.videoResize && (s.remove(), s = null)
        }, !0), E.helpers.isMobile() || E.events.$on(L(E.o_win), "resize.video", function () {
          F(!0)
        }), E.opts.videoResize) {
          e = f.get(0).ownerDocument, E.events.$on(f, E._mousedown, ".fr-handler", O), E.events.$on(L(e), E._mousemove, N), E.events.$on(L(e.defaultView || e.parentWindow), E._mouseup, I), E.events.$on(s, "mouseleave", I);
          var r = 1, a = null, o = 0;
          E.events.on("keydown", function (e) {
            if (y) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || E.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = B.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || E.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey && (r = B.call(this, e, 2, -1, r)), a = n, o = e.timeStamp
            }
          }), E.events.on("keyup", function () {
            r = 1
          })
        }
      }(), (E.$wp || E.$sc).append(f), f.data("instance", E);
      var e = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")), t = 0, n = 0;
      E.opts.iframe && (n = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-top")), t = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-left"))), f.css("top", (E.opts.iframe ? e.offset().top + n - 1 : e.offset().top - E.$wp.offset().top - 1) + E.$wp.scrollTop()).css("left", (E.opts.iframe ? e.offset().left + t - 1 : e.offset().left - E.$wp.offset().left - 1) + E.$wp.scrollLeft()).css("width", e.get(0).getBoundingClientRect().width).css("height", e.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function t(e) {
      if (e && "touchend" == e.type && n) return !0;
      if (e && E.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
      if (E.edit.isDisabled()) return !1;
      for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != E && xt.INSTANCES[t].events.trigger("video.hideResizer");
      E.toolbar.disable(), E.helpers.isMobile() && (E.events.disableBlur(), E.$el.blur(), E.events.enableBlur()), E.$el.find(".fr-video.fr-active").removeClass("fr-active"), (y = L(this)).addClass("fr-active"), E.opts.iframe && E.size.syncIframe(), ee(), $(), o(), E.selection.clear(), E.button.bulkRefresh(), E.events.trigger("image.hideResizer")
    }

    function F(e) {
      y && (function t() {
        return E.shared.vid_exit_flag
      }() || !0 === e) && (f.removeClass("fr-active"), E.toolbar.enable(), y.removeClass("fr-active"), y = null, U())
    }

    function P() {
      E.shared.vid_exit_flag = !0
    }

    function U() {
      E.shared.vid_exit_flag = !1
    }

    function z(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && n.type && -1 !== n.type.indexOf("video")) {
          if (!E.opts.videoUpload) return e.preventDefault(), e.stopPropagation(), !1;
          E.markers.remove(), E.markers.insertAtPoint(e.originalEvent), E.$el.find(".fr-marker").replaceWith(xt.MARKERS), E.popups.hideAll();
          var r = E.popups.get("video.insert");
          return r || (r = i()), E.popups.setContainer("video.insert", E.$sc), E.popups.show("video.insert", e.originalEvent.pageX, e.originalEvent.pageY), S(), 0 <= E.opts.videoAllowedTypes.indexOf(n.type.replace(/video\//g, "")) ? K(t.files) : V(A), e.preventDefault(), e.stopPropagation(), !1
        }
      }
    }

    function K(e) {
      if (void 0 !== e && 0 < e.length) {
        if (!1 === E.events.trigger("video.beforeUpload", [e])) return !1;
        var t, n = e[0];
        if (!(null !== E.opts.videoUploadURL && E.opts.videoUploadURL != _ || E.opts.videoUploadToS3 || E.opts.videoUploadToAzure)) return function C(r) {
          y && y.find("iframe") && y.find("iframe").length && q();
          var a = new FileReader;
          a.onload = function () {
            a.result;
            for (var e = atob(a.result.split(",")[1]), t = [], n = 0; n < e.length; n++) t.push(e.charCodeAt(n));
            T(window.URL.createObjectURL(new Blob([new Uint8Array(t)], {type: r.type})), !1, null, y)
          }, S(), a.readAsDataURL(r)
        }(n), !1;
        if (n.size > E.opts.videoMaxSize) return V(w), !1;
        if (E.opts.videoAllowedTypes.indexOf(n.type.replace(/video\//g, "")) < 0) return V(A), !1;
        if (E.drag_support.formdata && (t = E.drag_support.formdata ? new FormData : null), t) {
          var r;
          if (!1 !== E.opts.videoUploadToS3) for (r in t.append("key", E.opts.videoUploadToS3.keyStart + (new Date).getTime() + "-" + (n.name || "untitled")), t.append("success_action_status", "201"), t.append("X-Requested-With", "xhr"), t.append("Content-Type", n.type), E.opts.videoUploadToS3.params) E.opts.videoUploadToS3.params.hasOwnProperty(r) && t.append(r, E.opts.videoUploadToS3.params[r]);
          for (r in E.opts.videoUploadParams) E.opts.videoUploadParams.hasOwnProperty(r) && t.append(r, E.opts.videoUploadParams[r]);
          t.append(E.opts.videoUploadParam, n);
          var a, o, i = E.opts.videoUploadURL;
          E.opts.videoUploadToS3 && (i = E.opts.videoUploadToS3.uploadURL ? E.opts.videoUploadToS3.uploadURL : "https://".concat(E.opts.videoUploadToS3.region, ".amazonaws.com/").concat(E.opts.videoUploadToS3.bucket));
          var s = E.opts.videoUploadMethod;
          E.opts.videoUploadToAzure && (i = E.opts.videoUploadToAzure.uploadURL ? "".concat(E.opts.videoUploadToAzure.uploadURL, "/").concat(n.name) : encodeURI("https://".concat(E.opts.videoUploadToAzure.account, ".blob.core.windows.net/").concat(E.opts.videoUploadToAzure.container, "/").concat(n.name)), a = i, E.opts.videoUploadToAzure.SASToken && (i += E.opts.videoUploadToAzure.SASToken), s = "PUT");
          var l = E.core.getXHR(i, s);
          if (E.opts.videoUploadToAzure) {
            var c = (new Date).toUTCString();
            if (!E.opts.videoUploadToAzure.SASToken && E.opts.videoUploadToAzure.accessKey) {
              var d = E.opts.videoUploadToAzure.account, f = E.opts.videoUploadToAzure.container;
              if (E.opts.videoUploadToAzure.uploadURL) {
                var p = E.opts.videoUploadToAzure.uploadURL.split("/");
                f = p.pop(), d = p.pop().split(".")[0]
              }
              var u = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(c, "\nx-ms-version:2019-07-07"),
                h = encodeURI("/" + d + "/" + f + "/" + n.name),
                g = s + "\n\n\n" + n.size + "\n\n" + n.type + "\n\n\n\n\n\n\n" + u + "\n" + h,
                m = E.cryptoJSPlugin.cryptoJS.HmacSHA256(g, E.cryptoJSPlugin.cryptoJS.enc.Base64.parse(E.opts.videoUploadToAzure.accessKey)).toString(E.cryptoJSPlugin.cryptoJS.enc.Base64),
                v = "SharedKey " + d + ":" + m;
              o = m, l.setRequestHeader("Authorization", v)
            }
            for (r in l.setRequestHeader("x-ms-version", "2019-07-07"), l.setRequestHeader("x-ms-date", c), l.setRequestHeader("Content-Type", n.type), l.setRequestHeader("x-ms-blob-type", "BlockBlob"), E.opts.videoUploadParams) E.opts.videoUploadParams.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.videoUploadParams[r]);
            for (r in E.opts.videoUploadToAzure.params) E.opts.videoUploadToAzure.params.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.videoUploadToAzure.params[r])
          }
          l.onload = function () {
            k.call(l, y, a, o)
          }, l.onerror = x, l.upload.onprogress = R, l.onabort = M, S(), E.events.disableBlur(), E.edit.off(), E.events.enableBlur();
          var b = E.popups.get("video.insert");
          b && L(b.off("abortUpload")).on("abortUpload", function () {
            4 != l.readyState && l.abort()
          }), l.send(E.opts.videoUploadToAzure ? n : t)
        }
      }
    }

    function V(e, t) {
      E.edit.on(), y && y.find("video").addClass("fr-error"), b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.error", [{
        code: e,
        message: a[e]
      }, t])
    }

    function W() {
      if (y) {
        var e = E.popups.get("video.size"),
          t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
        e.find('input[name="width"]').val(t.get(0).style.width || t.attr("width")).trigger("change"), e.find('input[name="height"]').val(t.get(0).style.height || t.attr("height")).trigger("change")
      }
    }

    function G(e) {
      if (e) return E.popups.onRefresh("video.size", W), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(E.button.buildList(E.opts.videoSizeButtons), "</div>"),
        size_layer: '<div class="fr-video-size-layer fr-layer fr-active" id="fr-video-size-layer-'.concat(E.id, '"><div class="fr-video-group"><div class="fr-input-line"><input id="fr-video-size-layer-width-').concat(E.id, '" type="text" name="width" placeholder="').concat(E.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-video-size-layer-height-').concat(E.id, '" type="text" name="height" placeholder="').concat(E.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoSetSize" tabIndex="2" role="button">').concat(E.language.translate("Update"), "</button></div></div>")
      }, n = E.popups.create("video.size", t);
      return E.events.$on(E.$wp, "scroll", function () {
        y && E.popups.isVisible("video.size") && (E.events.disableBlur(), C(y))
      }), n
    }

    function Y(e) {
      if (void 0 === e && (e = y), e) {
        if (e.hasClass("fr-fvl")) return "left";
        if (e.hasClass("fr-fvr")) return "right";
        if (e.hasClass("fr-dvb") || e.hasClass("fr-dvi")) return "center";
        if ("block" == e.css("display")) {
          if ("left" == e.css("text-algin")) return "left";
          if ("right" == e.css("text-align")) return "right"
        } else {
          if ("left" == e.css("float")) return "left";
          if ("right" == e.css("float")) return "right"
        }
      }
      return "center"
    }

    function j(e) {
      void 0 === e && (e = y);
      var t = e.css("float");
      return e.css("float", "none"), "block" == e.css("display") ? (e.css("float", ""), e.css("float") != t && e.css("float", t), "block") : (e.css("float", ""), e.css("float") != t && e.css("float", t), "inline")
    }

    function q() {
      if (y && !1 !== E.events.trigger("video.beforeRemove", [y])) {
        var e = y;
        if (E.popups.hideAll(), F(!0), E.opts.trackChangesEnabled && (!e[0].parentNode || "SPAN" !== e[0].parentNode.tagName || !e[0].parentNode.hasAttribute("data-tracking"))) return void E.track_changes.removeSpecialItem(e);
        E.selection.setBefore(e.get(0)) || E.selection.setAfter(e.get(0)), e.remove(), E.selection.restore(), E.html.fillEmptyBlocks()
      }
    }

    function Z() {
      c()
    }

    function X(e, t, n) {
      !E.opts.htmlUntouched && E.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
        display: "block",
        clear: "both"
      }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
    }

    function Q() {
      var e = E.$el.find("video").filter(function () {
        return 0 === L(this).parents("span.fr-video").length
      });
      if (0 != e.length) {
        e.wrap(L(document.createElement("span")).attr("class", "fr-video fr-deletable").attr("contenteditable", "false")), E.$el.find("embed, iframe").filter(function () {
          if (E.browser.safari && this.getAttribute("src") && this.setAttribute("src", this.src), 0 < L(this).parents("span.fr-video").length) return !1;
          for (var e = L(this).attr("src"), t = 0; t < xt.VIDEO_PROVIDERS.length; t++) {
            var n = xt.VIDEO_PROVIDERS[t];
            if (n.test_regex.test(e) && new RegExp(E.opts.videoAllowedProviders.join("|")).test(n.provider)) return !0
          }
          return !1
        }).map(function () {
          return 0 === L(this).parents("object").length ? this : L(this).parents("object").get(0)
        }).wrap(L(document.createElement("span")).attr("class", "fr-video").attr("contenteditable", "false"));
        for (var t, n, r, a, o = E.$el.find("span.fr-video, video"), i = 0; i < o.length; i++) {
          var s = L(o[i]);
          !E.opts.htmlUntouched && E.opts.useClasses ? ((a = s).hasClass("fr-dvi") || a.hasClass("fr-dvb") || (a.addClass("fr-fv".concat(Y(a)[0])), a.addClass("fr-dv".concat(j(a)[0]))), E.opts.videoTextNear || s.removeClass("fr-dvi").addClass("fr-dvb")) : E.opts.htmlUntouched || E.opts.useClasses || (void 0, n = (t = s).hasClass("fr-dvb") ? "block" : t.hasClass("fr-dvi") ? "inline" : null, r = t.hasClass("fr-fvl") ? "left" : t.hasClass("fr-fvr") ? "right" : Y(t), X(t, n, r), t.removeClass("fr-dvb fr-dvi fr-fvr fr-fvl"))
        }
        o.toggleClass("fr-draggable", E.opts.videoMove)
      }
    }

    function J(e) {
      document.getElementById("autoplay-".concat(E.id)).style.cssText = "background:".concat(e)
    }

    function ee() {
      if (y) {
        E.selection.clear();
        var e = E.doc.createRange();
        e.selectNode(y.get(0)), E.selection.get().addRange(e)
      }
    }

    return a[1] = "Video cannot be loaded from the passed link.", a[p] = "No link in upload response.", a[u] = "Error during file upload.", a[h] = "Parsing response failed.", a[w] = "File is too large.", a[A] = "Video file type is invalid.", a[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", E.shared.vid_exit_flag = !1, {
      _init: function te() {
        E.opts.videoResponsive && (E.opts.videoResize = !1), function e() {
          E.events.on("drop", z, !0), E.events.on("mousedown window.mousedown", P), E.events.on("window.touchmove", U), E.events.on("mouseup window.mouseup", F), E.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && F()
          }), E.events.on("video.hideResizer commands.undo commands.redo element.dropped", function () {
            F(!0)
          })
        }(), E.helpers.isMobile() && (E.events.$on(E.$el, "touchstart", "span.fr-video", function () {
          n = !1
        }), E.events.$on(E.$el, "touchmove", function () {
          n = !0
        })), E.events.on("html.set", Q), Q(), E.events.$on(E.$el, "mousedown", "span.fr-video", function (e) {
          e.stopPropagation(), (E.browser.msie || E.browser.edge) && (e.target.innerText || (e.target.dragDrop(), t.call(this, e)))
        }), E.events.$on(E.$el, "click touchend", "span.fr-video", function (e) {
          if (e.target.innerText.length || "false" == L(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
          t.call(this, e)
        }), E.events.on("keydown", function (e) {
          var t = e.which;
          return !y || t != xt.KEYCODE.BACKSPACE && t != xt.KEYCODE.DELETE ? y && t == xt.KEYCODE.ESC ? (F(!0), e.preventDefault(), !1) : y && t != xt.KEYCODE.F10 && !E.keys.isBrowserAction(e) ? (e.preventDefault(), !1) : void 0 : (e.preventDefault(), q(), E.undo.saveStep(), !1)
        }, !0), E.events.on("toolbar.esc", function () {
          if (y) return E.events.disableBlur(), E.events.focus(), !1
        }, !0), E.events.on("toolbar.focusEditor", function () {
          if (y) return !1
        }, !0), E.events.on("keydown", function () {
          E.$el.find("span.fr-video:empty").remove()
        }), E.$wp && (H(), E.events.on("contentChanged", H)), i(!0), G(!0)
      }, showInsertPopup: function ne() {
        var e = E.$tb.find('.fr-command[data-cmd="insertVideo"]'), t = E.popups.get("video.insert");
        if (t || (t = i()), c(), !t.hasClass("fr-active")) if (E.popups.refresh("video.insert"), E.popups.setContainer("video.insert", E.$tb), e.isVisible()) {
          var n = E.button.getPosition(e), r = n.left, a = n.top;
          E.popups.show("video.insert", r, a, e.outerHeight())
        } else E.position.forSelection(t), E.popups.show("video.insert")
      }, showLayer: function re(e) {
        var t, n, r = E.popups.get("video.insert");
        if (!y && !E.opts.toolbarInline) {
          var a = E.$tb.find('.fr-command[data-cmd="insertVideo"]');
          t = a.offset().left, n = a.offset().top + (E.opts.toolbarBottom ? 10 : a.outerHeight() - 10)
        }
        E.opts.toolbarInline && (n = r.offset().top - E.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), E.popups.show("video.insert", t, n, 0), E.accessibility.focusPopup(r)
      }, refreshByURLButton: function ae(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, refreshEmbedButton: function oe(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-embed-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, refreshUploadButton: function ie(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, upload: K, insertByURL: function se(e) {
        var t = !!document.getElementById("videoPluginAutoplay") && document.getElementById("videoPluginAutoplay").checked;
        void 0 === e && (e = (E.popups.get("video.insert").find('.fr-video-by-url-layer input[type="text"]').val() || "").trim());
        var n = null;
        if (/^http/.test(e) || (e = "https://".concat(e)), E.helpers.isURL(e)) for (var r = 0; r < xt.VIDEO_PROVIDERS.length; r++) {
          var a = xt.VIDEO_PROVIDERS[r], o = "autoplay=1";
          if (a.html.includes("autoplay=1") && document.getElementById("videoPluginAutoplay").checked) a.html = a.html, document.getElementById("videoPluginAutoplay").checked = !1; else if (t) {
            var i = a.html.indexOf("{url}") + 5;
            a.html = [a.html.slice(0, i), o, a.html.slice(i)].join(""), t = !1, document.getElementById("videoPluginAutoplay").checked = !1
          } else (a = xt.VIDEO_PROVIDERS[r]).html = a.html.replace(o, "");
          if (a.test_regex.test(e) && new RegExp(E.opts.videoAllowedProviders.join("|")).test(a.provider)) {
            n = e.replace(a.url_regex, a.url_text), n = a.html.replace(/\{url\}/, n);
            break
          }
        }
        n ? l(n) : (b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.linkError", [e]))
      }, insertEmbed: function le(e) {
        void 0 === e && (e = E.popups.get("video.insert").find(".fr-video-embed-layer textarea").val() || ""), 0 !== e.length && xt.VIDEO_EMBED_REGEX.test(e) ? l(e) : (b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.codeError", [e]))
      }, insert: l, align: function ce(e) {
        y.removeClass("fr-fvr fr-fvl"), !E.opts.htmlUntouched && E.opts.useClasses ? "left" == e ? y.addClass("fr-fvl") : "right" == e && y.addClass("fr-fvr") : X(y, j(), e), ee(), $(), o(), E.selection.clear()
      }, refreshAlign: function de(e) {
        if (!y) return !1;
        e.find(">*").first().replaceWith(E.icon.create("video-align-".concat(Y())))
      }, refreshAlignOnShow: function fe(e, t) {
        y && t.find('.fr-command[data-param1="'.concat(Y(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, display: function pe(e) {
        y.removeClass("fr-dvi fr-dvb"), !E.opts.htmlUntouched && E.opts.useClasses ? "inline" == e ? y.addClass("fr-dvi") : "block" == e && y.addClass("fr-dvb") : X(y, e, Y()), ee(), $(), o(), E.selection.clear()
      }, refreshDisplayOnShow: function ue(e, t) {
        y && t.find('.fr-command[data-param1="'.concat(j(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, remove: q, hideProgressBar: c, showSizePopup: function he() {
        var e = E.popups.get("video.size");
        e || (e = G()), c(), E.popups.refresh("video.size"), E.popups.setContainer("video.size", E.$sc);
        var t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.height();
        E.popups.show("video.size", n, r, t.height(), !0)
      }, replace: function ge() {
        var e = E.popups.get("video.insert");
        e || (e = i()), E.popups.isVisible("video.insert") || (c(), E.popups.refresh("video.insert"), E.popups.setContainer("video.insert", E.$sc));
        var t = y.offset().left + y.outerWidth() / 2, n = y.offset().top + y.height();
        E.popups.show("video.insert", t, n, y.outerHeight(), !0)
      }, back: function e() {
        y ? (E.events.disableBlur(), y[0].click()) : (E.events.disableBlur(), E.selection.restore(), E.events.enableBlur(), E.popups.hide("video.insert"), E.toolbar.showInline())
      }, setSize: function me(e, t) {
        if (y) {
          var n = E.popups.get("video.size"),
            r = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
          r.css("width", e || n.find('input[name="width"]').val()), r.css("height", t || n.find('input[name="height"]').val()), r.get(0).style.width && r.removeAttr("width"), r.get(0).style.height && r.removeAttr("height"), n.find("input:focus").blur(), setTimeout(function () {
            y.trigger("click")
          }, E.helpers.isAndroid() ? 50 : 0)
        }
      }, get: function ve() {
        return y
      }, showProgressBar: S, _editVideo: C, setAutoplay: function be() {
        var e;
        if (y.find("iframe, embed, audio").get(0)) (e = y.find("iframe, embed, audio")).get(0).src.includes("autoplay=1") ? (J("#FFFFFF"), e.get(0).src = e.get(0).src.replace("&autoplay=1", "")) : (J("#D6D6D6"), e.get(0).src = e.get(0).src + "&autoplay=1"); else if ((e = y.find("iframe, embed, video")).get(0).outerHTML.includes("autoplay")) J("#FFFFFF"), e.get(0).outerHTML = e.get(0).outerHTML.replace("autoplay", ""); else {
          J("#D6D6D6");
          var t = e.get(0).outerHTML.indexOf("class") - 1;
          e.get(0).outerHTML = [e.get(0).outerHTML.slice(0, t), "autoplay", e.get(0).outerHTML.slice(t)].join("")
        }
      }
    }
  },xt.RegisterCommand("insertVideo", {
    title: "Insert Video",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("video.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("video.insert")) : this.video.showInsertPopup()
    },
    plugin: "video"
  }),xt.DefineIcon("insertVideo", {
    NAME: "video-camera",
    FA5NAME: "camera",
    SVG_KEY: "insertVideo"
  }),xt.DefineIcon("videoByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }),xt.RegisterCommand("videoByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-by-url")
    }, refresh: function (e) {
      this.video.refreshByURLButton(e)
    }
  }),xt.DefineIcon("videoEmbed", {
    NAME: "code",
    SVG_KEY: "codeView"
  }),xt.RegisterCommand("videoEmbed", {
    title: "Embedded Code", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-embed")
    }, refresh: function (e) {
      this.video.refreshEmbedButton(e)
    }
  }),xt.DefineIcon("videoUpload", {
    NAME: "upload",
    SVG_KEY: "upload"
  }),xt.RegisterCommand("videoUpload", {
    title: "Upload Video", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-upload")
    }, refresh: function (e) {
      this.video.refreshUploadButton(e)
    }
  }),xt.RegisterCommand("videoInsertByURL", {
    undo: !0, focus: !0, callback: function () {
      this.video.insertByURL()
    }
  }),xt.RegisterCommand("videoInsertEmbed", {
    undo: !0, focus: !0, callback: function () {
      this.video.insertEmbed()
    }
  }),xt.DefineIcon("videoDisplay", {
    NAME: "star",
    SVG_KEY: "star"
  }),xt.RegisterCommand("videoDisplay", {
    title: "Display",
    type: "dropdown",
    options: {inline: "Inline", block: "Break Text"},
    callback: function (e, t) {
      this.video.display(t)
    },
    refresh: function (e) {
      this.opts.videoTextNear || e.addClass("fr-hidden")
    },
    refreshOnShow: function (e, t) {
      this.video.refreshDisplayOnShow(e, t)
    }
  }),xt.DefineIcon("video-align", {
    NAME: "align-left",
    SVG_KEY: "align Left"
  }),xt.DefineIcon("video-align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("video-align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("video-align-center", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.DefineIcon("videoAlign", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }),xt.RegisterCommand("videoAlign", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "None", right: "Align Right"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.videoAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="videoAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("video-align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.video.align(t)
    },
    refresh: function (e) {
      this.video.refreshAlign(e)
    },
    refreshOnShow: function (e, t) {
      this.video.refreshAlignOnShow(e, t)
    }
  }),xt.DefineIcon("videoReplace", {
    NAME: "exchange",
    FA5NAME: "exchange-alt",
    SVG_KEY: "replaceImage"
  }),xt.RegisterCommand("videoReplace", {
    title: "Replace",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.video.replace()
    }
  }),xt.DefineIcon("videoRemove", {
    NAME: "trash",
    SVG_KEY: "remove"
  }),xt.RegisterCommand("videoRemove", {
    title: "Remove", callback: function () {
      this.video.remove()
    }
  }),xt.DefineIcon("autoplay", {NAME: "autoplay", SVG_KEY: "autoplay"}),xt.RegisterCommand("autoplay", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Autoplay",
    callback: function () {
      this.video.setAutoplay()
    }
  }),xt.DefineIcon("videoSize", {NAME: "arrows-alt", SVG_KEY: "imageSize"}),xt.RegisterCommand("videoSize", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Change Size",
    callback: function () {
      this.video.showSizePopup()
    }
  }),xt.DefineIcon("videoBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("videoBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.video.back()
    },
    refresh: function (e) {
      this.video.get() || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.RegisterCommand("videoDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.video.hideProgressBar(!0)
    }
  }),xt.RegisterCommand("videoSetSize", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.video.setSize()
    }
  }),Object.assign(xt.DEFAULTS, {
    wordDeniedTags: [],
    wordDeniedAttrs: [],
    wordAllowedStyleProps: ["font-family", "font-size", "background", "color", "width", "text-align", "vertical-align", "background-color", "padding", "margin", "height", "margin-top", "margin-left", "margin-right", "margin-bottom", "text-decoration", "font-weight", "font-style", "text-indent", "border", "border-.*", "line-height", "list-style-type"],
    wordPasteModal: !0,
    wordPasteKeepFormatting: !0
  }),xt.PLUGINS.wordPaste = function (L) {
    var i, a, c = L.$, s = "word_paste", p = {};

    function t(e) {
      var t = L.opts.wordAllowedStyleProps;
      e || (L.opts.wordAllowedStyleProps = []), 0 === a.indexOf("<colgroup>") && (a = "<table>" + a + "</table>"), a = o(a = a.replace(/<span[\n\r ]*style='mso-spacerun:yes'>([\r\n\u00a0 ]*)<\/span>/g, function (e, t) {
        for (var n = "", r = 0; r++ < t.length;) n += "&nbsp;";
        return n
      }), L.paste.getRtfClipboard());
      var n = L.doc.createElement("DIV");
      n.innerHTML = a, L.html.cleanBlankSpaces(n), a = n.innerHTML, a = (a = L.paste.cleanEmptyTagsAndDivs(a)).replace(/\u200b/g, ""), function r() {
        L.modals.hide(s)
      }(), L.paste.clean(a, !0, !0), L.opts.wordAllowedStyleProps = t
    }

    function _(e) {
      e.parentNode && e.parentNode.removeChild(e)
    }

    function u(e, t) {
      if (t(e)) for (var n = e.firstChild; n;) {
        var r = n, a = n.previousSibling;
        n = n.nextSibling, u(r, t), r.previousSibling || r.nextSibling || r.parentNode || !n || a === n.previousSibling || !n.parentNode ? r.previousSibling || r.nextSibling || r.parentNode || !n || n.previousSibling || n.nextSibling || n.parentNode || (a ? n = a.nextSibling ? a.nextSibling.nextSibling : null : e.firstChild && (n = e.firstChild.nextSibling)) : n = a ? a.nextSibling : e.firstChild
      }
    }

    function R(e) {
      if (!e.getAttribute("style") || !/mso-list:[\s]*l/gi.test(e.getAttribute("style").replace(/\n/gi, ""))) return !1;
      try {
        if (!e.querySelector('[style="mso-list:Ignore"]')) return !!(e.outerHTML && 0 <= e.outerHTML.indexOf("\x3c!--[if !supportLists]--\x3e"))
      } catch (t) {
        return !1
      }
      return !0
    }

    function M(e) {
      return e.getAttribute("style").replace(/\n/gi, "").replace(/.*level([0-9]+?).*/gi, "$1")
    }

    function O(e, r) {
      var t = e.cloneNode(!0);
      if (-1 !== ["H1", "H2", "H3", "H4", "H5", "H6"].indexOf(e.tagName)) {
        var n = document.createElement(e.tagName.toLowerCase());
        n.setAttribute("style", e.getAttribute("style")), n.innerHTML = t.innerHTML, t.innerHTML = n.outerHTML
      }
      u(t, function (e) {
        if (e.nodeType == Node.COMMENT_NODE && (L.browser.msie || L.browser.safari || L.browser.edge)) try {
          if ("[if !supportLists]" === e.data) {
            for (e = e.nextSibling; e && e.nodeType !== Node.COMMENT_NODE;) {
              var t = e.nextSibling;
              e.parentNode.removeChild(e), e = t
            }
            e && e.nodeType == Node.COMMENT_NODE && e.parentNode.removeChild(e)
          }
        } catch (n) {
        }
        return e.nodeType === Node.ELEMENT_NODE && ("mso-list:\nIgnore" === e.getAttribute("style") && e.setAttribute("style", "mso-list:Ignore"), "mso-list:Ignore" === e.getAttribute("style") && e.parentNode.removeChild(e), e.setAttribute("style", function a(e) {
          var n = "", r = e.getAttribute("style");
          r && ["line-height", "font-family", "font-size", "color", "background"].forEach(function (e) {
            var t = r.match(new RegExp(e + ":.*(;|)"));
            t && (n += t[0] + ";")
          });
          return n
        }(e)), m(e, r)), !0
      });
      var a = t.innerHTML;
      return a = a.replace(/<!--[\s\S]*?-->/gi, "")
    }

    function w(e) {
      var t = e.getAttribute("align");
      t && (e.style["text-align"] = t, e.removeAttribute("align"))
    }

    function A(e) {
      return e.replace(/\n|\r|\n\r|&quot;/g, "")
    }

    function T(e, t, n) {
      if (t) {
        var r = e.getAttribute("style");
        r && ";" !== r.slice(-1) && (r += ";"), t && ";" !== t.slice(-1) && (t += ";"), t = t.replace(/\n/gi, "");
        var a = null;
        a = n ? (r || "") + t : t + (r || ""), e.setAttribute("style", a)
      }
    }

    var h = null;

    function d(e, t, n) {
      for (var r = e.split(n), a = 1; a < r.length; a++) {
        var o = r[a];
        if (1 < (o = o.split("shplid")).length) {
          o = o[1];
          for (var i = "", s = 0; s < o.length && "\\" !== o[s] && "{" !== o[s] && " " !== o[s] && "\r" !== o[s] && "\n" !== o[s];) i += o[s], s++;
          var l = o.split("bliptag");
          if (l && l.length < 2) continue;
          var c = null;
          if (-1 !== l[0].indexOf("pngblip") ? c = "image/png" : -1 !== l[0].indexOf("jpegblip") && (c = "image/jpeg"), !c) continue;
          var d = l[1].split("}");
          if (d && d.length < 2) continue;
          var f = void 0;
          if (2 < d.length && -1 !== d[0].indexOf("blipuid")) f = d[1].split(" "); else {
            if ((f = d[0].split(" ")) && f.length < 2) continue;
            f.shift()
          }
          var p = f.join("");
          h[t + i] = {image_hex: p, image_type: c}
        }
      }
    }

    function g(e, t) {
      if (t) {
        var n;
        if ("IMG" === e.tagName) {
          var r = e.getAttribute("src");
          if (!r || -1 === r.indexOf("file://")) return;
          if (0 === r.indexOf("file://") && L.helpers.isURL(e.getAttribute("alt"))) return void e.setAttribute("src", e.getAttribute("alt"));
          (n = p[e.getAttribute("v:shapes")]) || (n = e.getAttribute("v:shapes"), e.parentNode && e.parentNode.parentNode && 0 <= e.parentNode.parentNode.innerHTML.indexOf("msEquation") && (n = null))
        } else n = e.parentNode.getAttribute("o:spid");
        if (e.removeAttribute("height"), n) {
          !function s(e) {
            h = {}, d(e, "i", "\\shppict"), d(e, "s", "\\shp{")
          }(t);
          var a = h[n.substring(7)];
          if (a) {
            var o = function l(e) {
              for (var t = e.match(/[0-9a-f]{2}/gi), n = [], r = 0; r < t.length; r++) n.push(String.fromCharCode(parseInt(t[r], 16)));
              var a = n.join("");
              return btoa(a)
            }(a.image_hex), i = "data:" + a.image_type + ";base64," + o;
            "IMG" === e.tagName ? (e.src = i, e.setAttribute("data-fr-image-pasted", !0)) : c(e.parentNode).before('<img data-fr-image-pasted="true" src="' + i + '" style="' + e.parentNode.getAttribute("style") + '">').remove()
          }
        }
      }
    }

    function m(e, t) {
      var n = e.tagName, r = n.toLowerCase();
      if (-1 !== ["SCRIPT", "APPLET", "EMBED", "NOFRAMES", "NOSCRIPT"].indexOf(n)) return _(e), !1;
      for (var a = ["META", "LINK", "XML", "ST1:", "O:", "W:", "FONT"], o = 0; o < a.length; o++) if (-1 !== n.indexOf(a[o])) return e.innerHTML && (e.outerHTML = e.innerHTML), _(e), !1;
      for (var i = ["I", "U"], s = 0; s < i.length; s++) if (n === i[s]) return e.innerHTML && (e.outerHTML = e.innerHTML), _(e), !1;
      if ("TD" !== n) {
        var l = e.getAttribute("class") || "MsoNormal";
        if (t && l) {
          for (var c = (l = A(l)).split(" "), d = 0; d < c.length; d++) {
            var f = [], p = "." + c[d];
            f.push(p), p = r + p, f.push(p);
            for (var u = 0; u < f.length; u++) t[f[u]] && T(e, t[f[u]])
          }
          e.removeAttribute("class")
        }
        t && t[r] && T(e, t[r])
      }
      if (-1 !== ["P", "H1", "H2", "H3", "H4", "H5", "H6", "PRE"].indexOf(n)) {
        var h = e.getAttribute("class");
        if (h && (t && t[n.toLowerCase() + "." + h] && T(e, t[n.toLowerCase() + "." + h]), -1 !== h.toLowerCase().indexOf("mso"))) {
          var g = A(h);
          (g = g.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi, "")) ? e.setAttribute("class", g) : e.removeAttribute("class")
        }
        var m = e.getAttribute("style");
        if (m) {
          var v = m.match(/text-align:.+?[; "]{1,1}/gi);
          v && v[v.length - 1].replace(/(text-align:.+?[; "]{1,1})/gi, "$1")
        }
        w(e)
      }
      if ("TR" === n && function y(e, t) {
        L.node.clearAttributes(e);
        for (var n = e.firstElementChild, r = 0, a = !1, o = null; n;) {
          n.firstElementChild && -1 !== n.firstElementChild.tagName.indexOf("W:") && (n.innerHTML = n.firstElementChild.innerHTML), (o = n.getAttribute("width")) || a || (a = !0), r += parseInt(o, 10), (!n.firstChild || n.firstChild && n.firstChild.data === xt.UNICODE_NBSP) && (n.firstChild && _(n.firstChild), n.innerHTML = "<br>");
          for (var i = n.firstElementChild, s = 1 === n.children.length; i;) "P" !== i.tagName || R(i) || s && w(i), i = i.nextElementSibling;
          if (t) {
            var l = n.getAttribute("class");
            if (l) {
              var c = (l = A(l)).match(/xl[0-9]+/gi);
              if (c) {
                var d = "." + c[0];
                t[d] && T(n, t[d])
              }
            }
            t.td && T(n, t.td)
          }
          var f = n.getAttribute("style");
          f && (f = A(f)) && ";" !== f.slice(-1) && (f += ";");
          var p = n.getAttribute("valign");
          if (!p && f) {
            var u = f.match(/vertical-align:.+?[; "]{1,1}/gi);
            u && (p = u[u.length - 1].replace(/vertical-align:(.+?)[; "]{1,1}/gi, "$1"))
          }
          var h = null;
          if (f) {
            var g = f.match(/text-align:.+?[; "]{1,1}/gi);
            g && (h = g[g.length - 1].replace(/text-align:(.+?)[; "]{1,1}/gi, "$1")), "general" === h && (h = null)
          }
          var m = null;
          if (f) {
            var v = f.match(/background:.+?[; "]{1,1}/gi);
            v && (m = v[v.length - 1].replace(/background:(.+?)[; "]{1,1}/gi, "$1"))
          }
          var b = n.getAttribute("colspan"), C = n.getAttribute("rowspan");
          b && n.setAttribute("colspan", b), C && n.setAttribute("rowspan", C), p && (n.style["vertical-align"] = p), h && (n.style["text-align"] = h), m && (n.style["background-color"] = m), o && n.setAttribute("width", o), n = n.nextElementSibling
        }
        for (n = e.firstElementChild; n;) o = n.getAttribute("width"), a ? n.removeAttribute("width") : n.setAttribute("width", 100 * parseInt(o, 10) / r + "%"), n = n.nextElementSibling
      }(e, t), "A" !== n || e.attributes.getNamedItem("href") || e.attributes.getNamedItem("name") || !e.innerHTML || (e.outerHTML = e.innerHTML), "A" == n && e.getAttribute("href") && e.querySelector("img")) for (var b = e.querySelectorAll("span"), C = 0; C < b.length; C++) b[C].innerText || (b[C].outerHTML = b[C].innerHTML);
      if ("TD" !== n && "TH" !== n || e.innerHTML || (e.innerHTML = "<br>"), "TABLE" === n && (e.style.width = e.style.width), e.getAttribute("lang") && e.removeAttribute("lang"), e.getAttribute("style") && -1 !== e.getAttribute("style").toLowerCase().indexOf("mso")) {
        var E = A(e.getAttribute("style"));
        (E = E.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi, "")) ? e.setAttribute("style", E) : e.removeAttribute("style")
      }
      return !0
    }

    function o(e, t) {
      0 <= e.indexOf("<html") && (e = e.replace(/[.\s\S\w\W<>]*(<html[^>]*>[.\s\S\w\W<>]*<\/html>)[.\s\S\w\W<>]*/i, "$1")), function d(e) {
        for (var t = e.split("v:shape"), n = 1; n < t.length; n++) {
          var r = t[n], a = r.split(' id="')[1];
          if (a && 1 < a.length) {
            a = a.split('"')[0];
            var o = r.split(' o:spid="')[1];
            o && 1 < o.length && (o = o.split('"')[0], p[a] = o)
          }
        }
      }(e);
      var n = (new DOMParser).parseFromString(e, "text/html"), r = n.head, a = n.body, l = function f(e) {
        var t = {}, n = e.getElementsByTagName("style");
        if (n.length) {
          var r = n[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);
          if (r) for (var a = 0; a < r.length; a++) {
            var o = r[a], i = o.replace(/([\S ]+\s+){[\s\S]+?}/gi, "$1"),
              s = o.replace(/[\S ]+\s+{([\s\S]+?)}/gi, "$1");
            i = i.replace(/^[\s]|[\s]$/gm, ""), s = s.replace(/^[\s]|[\s]$/gm, ""), i = i.replace(/\n|\r|\n\r/g, ""), s = s.replace(/\n|\r|\n\r/g, "");
            for (var l = i.split(", "), c = 0; c < l.length; c++) t[l[c]] = s
          }
        }
        return t
      }(r);
      u(a, function (e) {
        if (e.nodeType === Node.TEXT_NODE && /\n|\u00a0|\r/.test(e.data)) {
          if (!/\S| /.test(e.data) && !/[\u00a0]+/.test(e.data)) return e.data === xt.UNICODE_NBSP ? (e.data = "\u200b", !0) : 1 === e.data.length && 10 === e.data.charCodeAt(0) ? (e.data = " ", !0) : (_(e), !1);
          e.data = e.data.replace(/\n|\r/gi, " ")
        }
        return !0
      }), u(a, function (e) {
        return e.nodeType !== Node.ELEMENT_NODE || "V:IMAGEDATA" !== e.tagName && "IMG" !== e.tagName || g(e, t), !0
      });
      for (var o = a.querySelectorAll("ul > ul, ul > ol, ol > ul, ol > ol"), i = o.length - 1; 0 <= i; i--) o[i].previousElementSibling && "LI" === o[i].previousElementSibling.tagName && o[i].previousElementSibling.appendChild(o[i]);
      u(a, function (e) {
        if (e.nodeType === Node.TEXT_NODE) return e.data = e.data.replace(/<br>(\n|\r)/gi, "<br>"), !1;
        if (e.nodeType === Node.ELEMENT_NODE) {
          if (R(e)) {
            var t = e.parentNode, n = e.previousSibling, r = function x(e, t, n, r) {
              var a, o, i = /[0-9a-zA-Z]./gi, s = !1, l = navigator.userAgent.toLowerCase();
              -1 != l.indexOf("safari") && (l = -1 < l.indexOf("chrome") ? 1 : "safari"), e.innerHTML.includes("mso-list:\nIgnore") && (e.innerHTML = e.innerHTML.replace(/mso-list:\nIgnore/gi, "mso-list:Ignore"));
              var c, d, f, p, u = e.querySelector('span[style="mso-list:Ignore"]');
              null == u && "safari" == l && (u = e.querySelector('span[lang="PT-BR"]'));
              var h;
              u && (s = s || i.test(u.textContent)), null !== u && (h = u.textContent.trim().split(".")[0]), f = 1 == s ? ("1" == (h = u.textContent.trim().split(".")[0]) ? p = "decimal;" : "i" == h ? p = "lower-roman;" : "I" == h ? p = "upper-roman;" : "o" == h ? p = "circle;" : h.match(/^v$/) || (h.match(/^[a-z]$/) || h.match(/^[a-z]\)$/) ? p = "lower-alpha;" : (h.match(/^[A-Z]$/) || h.match(/^[A-Z]\)$/)) && (p = "upper-alpha;")), p = "list-style-type: " + p, "ol") : (null != u && (h = u.textContent.trim().split(".")[0]), "\xa7" == h ? p = "square;" : "\xb7" == h && (p = "disc;"), p = "list-style-type: " + p, "ul");
              var g, m = "";
              u == undefined || u.textContent == undefined || isNaN(parseInt(u.textContent.trim().split(".")[1], 10)) || (m = ' class="decimal_type" ');
              var v, b = M(e), C = e.style.marginLeft;
              if (C.includes("in") ? (v = "in", C = parseFloat(C) - .5) : C.includes("pt") && (v = "px", C = parseFloat(C) - 10), 1 == b) if (g = p ? "<" + f + ' style = "' + p + "; margin-left:" + C + v + ';">' : "<" + f + ' style="margin-left:' + C + v + ';">', "list-style-type: upper-alpha;" == p) {
                var E = h.charCodeAt(0) - 64;
                g = p ? "<" + f + m + ' start="' + E + '" style = "' + p + " margin-left:" + C + v + ';">' : "<" + f + ">"
              } else if ("list-style-type: lower-alpha;" == p) {
                var y = h.charCodeAt(0) - 96;
                g = p ? "<" + f + m + ' start="' + y + '" style = "' + p + "margin-left:" + C + v + ';">' : "<" + f + ">"
              } else g = p ? "<" + f + m + ' style = "' + p + ";margin-left:" + C + v + ';">' : "<" + f + ' style="margin-left:' + C + v + ';">'; else if ("list-style-type: upper-alpha;" == p) {
                var L = h.charCodeAt(0) - 64;
                g = p ? "<" + f + m + ' style = "' + p + ' start="' + L + '">' : "<" + f + ">"
              } else if ("list-style-type: lower-alpha;" == p) {
                var _ = h.charCodeAt(0) - 96;
                g = p ? "<" + f + m + ' style = "' + p + ' start="' + _ + '">' : "<" + f + ">"
              } else g = p ? "<" + f + m + ' style = "' + p + '">' : "<" + f + ">";
              for (var w = !1; e;) {
                if (!R(e)) {
                  if (e.outerHTML && 0 < e.outerHTML.indexOf("mso-bookmark") && 0 == (e.textContent || "").length) {
                    e = e.nextElementSibling;
                    continue
                  }
                  break
                }
                var A = M(e);
                if ((n = n || A) < A) g += (d = x(e, t, A, e.style.marginLeft)).el.outerHTML, e = d.currentNode; else {
                  if (A < n) break;
                  e.firstElementChild && e.firstElementChild.firstElementChild && e.firstElementChild.firstElementChild.firstChild && (i.lastIndex = 0), o && o.firstElementChild && o.firstElementChild.firstElementChild && o.firstElementChild.firstElementChild.firstChild && (i.lastIndex = 0, a = i.test(o.firstElementChild.firstElementChild.firstChild.data || o.firstElementChild.firstElementChild.firstChild.firstChild && o.firstElementChild.firstElementChild.firstChild.firstChild.data || ""));
                  var T = !1;
                  (!r && !e.style.marginLeft || r && e.style.marginLeft && r === e.style.marginLeft) && (T = !0), r = e.style.marginLeft, T || a === undefined ? (c = O(e, t), e.nextSibling.innerText == undefined || e.nextSibling.innerText == undefined || g.includes('class="decimal_type"') || isNaN(parseInt(e.nextSibling.innerText.trim().split(".")[1], 10)) || (g = g.substring(3, 0) + ' class="decimal_type"' + g.substring(3, g.length)), g += "<li>" + c + "</li>") : (1 == A && (g += "</" + f + ">", w = !0, o = null), g += (d = x(e, t, A, e.style.marginLeft)).el.outerHTML, e = d.currentNode);
                  var S = e && e.nextElementSibling;
                  if (S && (o = S.previousElementSibling), e && !R(e)) {
                    if (e.outerHTML && 0 < e.outerHTML.indexOf("mso-bookmark") && 0 == (e.textContent || "").length) {
                      e = e.nextElementSibling;
                      continue
                    }
                    break
                  }
                  e && e.parentNode && e.parentNode.removeChild(e), e = S
                }
              }
              w || (g += "</" + f + ">");
              var k = document.createElement("div");
              return k.innerHTML = g, {el: k, currentNode: e}
            }(e, l).el, a = null;
            return (a = n ? n.nextSibling : t.firstChild) ? t.insertBefore(r, a) : t.appendChild(r), !1
          }
          return "FONT" === e.tagName && l["." + e.getAttribute("class")] && (e = function s(e, t) {
            for (var n = document.createElement(t), r = 0; r < e.attributes.length; r++) {
              var a = e.attributes[r].name;
              n.setAttribute(a, e.getAttribute(a))
            }
            return n.innerHTML = e.innerHTML, e.parentNode.replaceChild(n, e), n
          }(e, "span")), m(e, l)
        }
        if (e.nodeType !== Node.COMMENT_NODE) return !0;
        if (-1 < e.data.indexOf("[if !supportLineBreakNewLine]")) for (var o = e.nextSibling; o;) (o = e.nextSibling) && _(o), o.data && -1 < o.data.indexOf("[endif]") && (o = null);
        if (-1 < e.data.indexOf("[if supportFields]") && -1 < e.data.indexOf("FORMCHECKBOX")) {
          var i = document.createElement("input");
          i.type = "checkbox", e.parentNode.insertBefore(i, e.nextSibling)
        }
        return _(e), !1
      }), u(a, function (e) {
        if (e.nodeType === Node.ELEMENT_NODE) {
          var t = e.tagName;
          if (!e.innerHTML && -1 === ["BR", "IMG", "INPUT"].indexOf(t)) {
            for (var n = e.parentNode; n && (_(e), !(e = n).innerHTML) && "TD" !== e.parentNode.tagName;) n = e.parentNode;
            return !1
          }
          !function d(e) {
            var t = e.getAttribute("style");
            if (t) {
              (t = A(t)) && ";" !== t.slice(-1) && (t += ";");
              var n = t.match(/(^|\S+?):.+?;{1,1}/gi);
              if (n) {
                for (var r = {}, a = 0; a < n.length; a++) {
                  var o = n[a].split(":");
                  2 === o.length && ("text-align" === o[0] && "SPAN" === e.tagName || (r[o[0]] = o[1]))
                }
                var i = "";
                for (var s in r) if (r.hasOwnProperty(s)) {
                  if ("font-size" === s && "pt;" === r[s].slice(-3)) {
                    var l = null;
                    try {
                      l = parseFloat(r[s].slice(0, -3), 10)
                    } catch (c) {
                      l = null
                    }
                    l && (l = Math.round(1.33 * l), r[s] = l + "px;")
                  }
                  i += s + ":" + r[s]
                }
                i && e.setAttribute("style", i)
              }
            }
          }(e)
        }
        return !0
      }), u(a, function (e) {
        if (e && "A" === e.nodeName && "" === e.href) {
          for (var t = document.createDocumentFragment(); e.firstChild;) t.appendChild(e.firstChild);
          e.parentNode.replaceChild(t, e)
        }
        return !0
      }), u(a, function (e) {
        return !e || "B" !== e.nodeName || (e.outerHTML = e.innerHTML, _(e), !1)
      });
      var s = a.outerHTML, c = L.opts.htmlAllowedStyleProps;
      return L.opts.htmlAllowedStyleProps = L.opts.wordAllowedStyleProps, s = L.clean.html(s, L.opts.wordDeniedTags, L.opts.wordDeniedAttrs, !1), L.opts.htmlAllowedStyleProps = c, s
    }

    return {
      _init: function e() {
        L.events.on("paste.wordPaste", function (e) {
          return a = e, L.opts.wordPasteModal ? function o() {
            if (!i) {
              var e = '<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> ' + L.language.translate("Word Paste Detected") + "</h4>",
                t = function a() {
                  var e = '<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';
                  return e += '<p style="text-align: left;">' + L.language.translate("The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?") + "</p>", e += '<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">' + L.language.translate("Clean") + '</button> <button class="fr-keep-word fr-command">' + L.language.translate("Keep") + "</button></div>", e += "</div>"
                }(), n = L.modals.create(s, e, t), r = n.$body;
              i = n.$modal, n.$modal.addClass("fr-middle"), L.events.bindClick(r, "button.fr-remove-word", function () {
                var e = i.data("instance") || L;
                e.wordPaste.clean()
              }), L.events.bindClick(r, "button.fr-keep-word", function () {
                var e = i.data("instance") || L;
                e.wordPaste.clean(!0)
              }), L.events.$on(c(L.o_win), "resize", function () {
                L.modals.resize(s)
              })
            }
            L.modals.show(s), L.modals.resize(s)
          }() : t(L.opts.wordPasteKeepFormatting), !1
        })
      }, clean: t, _wordClean: o
    }
  };
  var L = {}, n = {}, _ = {}, w = y(!0), A = "vanilla", T = {
    github: {
      omitExtraWLInCodeBlocks: !0,
      simplifiedAutoLink: !0,
      excludeTrailingPunctuationFromURLs: !0,
      literalMidWordUnderscores: !0,
      strikethrough: !0,
      tables: !0,
      tablesHeaderId: !0,
      ghCodeBlocks: !0,
      tasklists: !0,
      disableForced4SpacesIndentedSublists: !0,
      simpleLineBreaks: !0,
      requireSpaceBeforeHeadingText: !0,
      ghCompatibleHeaderId: !0,
      ghMentions: !0,
      backslashEscapesHTMLTags: !0,
      emoji: !0,
      splitAdjacentBlockquotes: !0
    },
    original: {noHeaderId: !0, ghCodeBlocks: !1},
    ghost: {
      omitExtraWLInCodeBlocks: !0,
      parseImgDimensions: !0,
      simplifiedAutoLink: !0,
      excludeTrailingPunctuationFromURLs: !0,
      literalMidWordUnderscores: !0,
      strikethrough: !0,
      tables: !0,
      tablesHeaderId: !0,
      ghCodeBlocks: !0,
      tasklists: !0,
      smoothLivePreview: !0,
      simpleLineBreaks: !0,
      requireSpaceBeforeHeadingText: !0,
      ghMentions: !1,
      encodeEmails: !0
    },
    vanilla: y(!0),
    allOn: function H() {
      var e = y(!0), t = {};
      for (var n in e) e.hasOwnProperty(n) && (t[n] = !0);
      return t
    }()
  };

  function S(e, t) {
    var n = t ? "Error in " + t + " extension->" : "Error in unnamed extension", r = {valid: !0, error: ""};
    L.helper.isArray(e) || (e = [e]);
    for (var a = 0; a < e.length; ++a) {
      var o = n + " sub-extension " + a + ": ", i = e[a];
      if ("object" !== kt(i)) return r.valid = !1, r.error = o + "must be an object, but " + kt(i) + " given", r;
      if (!L.helper.isString(i.type)) return r.valid = !1, r.error = o + 'property "type" must be a string, but ' + kt(i.type) + " given", r;
      var s = i.type = i.type.toLowerCase();
      if ("language" === s && (s = i.type = "lang"), "html" === s && (s = i.type = "output"), "lang" !== s && "output" !== s && "listener" !== s) return r.valid = !1, r.error = o + "type " + s + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"', r;
      if ("listener" === s) {
        if (L.helper.isUndefined(i.listeners)) return r.valid = !1, r.error = o + '. Extensions of type "listener" must have a property called "listeners"', r
      } else if (L.helper.isUndefined(i.filter) && L.helper.isUndefined(i.regex)) return r.valid = !1, r.error = o + s + ' extensions must define either a "regex" property or a "filter" method', r;
      if (i.listeners) {
        if ("object" !== kt(i.listeners)) return r.valid = !1, r.error = o + '"listeners" property must be an object but ' + kt(i.listeners) + " given", r;
        for (var l in i.listeners) if (i.listeners.hasOwnProperty(l) && "function" != typeof i.listeners[l]) return r.valid = !1, r.error = o + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + l + " must be a function but " + kt(i.listeners[l]) + " given", r
      }
      if (i.filter) {
        if ("function" != typeof i.filter) return r.valid = !1, r.error = o + '"filter" must be a function, but ' + kt(i.filter) + " given", r
      } else if (i.regex) {
        if (L.helper.isString(i.regex) && (i.regex = new RegExp(i.regex, "g")), !(i.regex instanceof RegExp)) return r.valid = !1, r.error = o + '"regex" property must either be a string or a RegExp object, but ' + kt(i.regex) + " given", r;
        if (L.helper.isUndefined(i.replace)) return r.valid = !1, r.error = o + '"regex" extensions must implement a replace string or function', r
      }
    }
    return r
  }

  function k(e, t) {
    return "\xa8E" + t.charCodeAt(0) + "E"
  }

  L.helper = {}, L.extensions = {}, L.setOption = function (e, t) {
    return w[e] = t, this
  }, L.getOption = function (e) {
    return w[e]
  }, L.getOptions = function () {
    return w
  }, L.resetOptions = function () {
    w = y(!0)
  }, L.setFlavor = function (e) {
    if (!T.hasOwnProperty(e)) throw Error(e + " flavor was not found");
    L.resetOptions();
    var t = T[e];
    for (var n in A = e, t) t.hasOwnProperty(n) && (w[n] = t[n])
  }, L.getFlavor = function () {
    return A
  }, L.getFlavorOptions = function (e) {
    if (T.hasOwnProperty(e)) return T[e]
  }, L.getDefaultOptions = function (e) {
    return y(e)
  }, L.subParser = function (e, t) {
    if (L.helper.isString(e)) {
      if (void 0 === t) {
        if (n.hasOwnProperty(e)) return n[e];
        throw Error("SubParser named " + e + " not registered!")
      }
      n[e] = t
    }
  }, L.extension = function (e, t) {
    if (!L.helper.isString(e)) throw Error("Extension 'name' must be a string");
    if (e = L.helper.stdExtName(e), L.helper.isUndefined(t)) {
      if (!_.hasOwnProperty(e)) throw Error("Extension named " + e + " is not registered!");
      return _[e]
    }
    "function" == typeof t && (t = t()), L.helper.isArray(t) || (t = [t]);
    var n = S(t, e);
    if (!n.valid) throw Error(n.error);
    _[e] = t
  }, L.getAllExtensions = function () {
    return _
  }, L.removeExtension = function (e) {
    delete _[e]
  }, L.resetExtensions = function () {
    _ = {}
  }, L.validateExtension = function (e) {
    var t = S(e, null);
    return !!t.valid
  }, L.hasOwnProperty("helper") || (L.helper = {}), L.helper.isString = function (e) {
    return "string" == typeof e || e instanceof String
  }, L.helper.isFunction = function (e) {
    return e && "[object Function]" === {}.toString.call(e)
  }, L.helper.isArray = function (e) {
    return Array.isArray(e)
  }, L.helper.isUndefined = function (e) {
    return void 0 === e
  }, L.helper.forEach = function (e, t) {
    if (L.helper.isUndefined(e)) throw new Error("obj param is required");
    if (L.helper.isUndefined(t)) throw new Error("callback param is required");
    if (!L.helper.isFunction(t)) throw new Error("callback param must be a function/closure");
    if ("function" == typeof e.forEach) e.forEach(t); else if (L.helper.isArray(e)) for (var n = 0; n < e.length; n++) t(e[n], n, e); else {
      if ("object" !== kt(e)) throw new Error("obj does not seem to be an array or an iterable object");
      for (var r in e) e.hasOwnProperty(r) && t(e[r], r, e)
    }
  }, L.helper.stdExtName = function (e) {
    return e.replace(/[_?*+\/\\.^-]/g, "").replace(/\s/g, "").toLowerCase()
  }, L.helper.escapeCharactersCallback = k, L.helper.escapeCharacters = function (e, t, n) {
    var r = "([" + t.replace(/([\[\]\\])/g, "\\$1") + "])";
    n && (r = "\\\\" + r);
    var a = new RegExp(r, "g");
    return e = e.replace(a, k)
  }, L.helper.unescapeHTMLEntities = function (e) {
    return e.replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&")
  };
  var x = function x(e, t, n, r) {
    var a, o, i, s, l, c = r || "", d = -1 < c.indexOf("g"), f = new RegExp(t + "|" + n, "g" + c.replace(/g/g, "")),
      p = new RegExp(t, c.replace(/g/g, "")), u = [];
    do {
      for (a = 0; i = f.exec(e);) if (p.test(i[0])) a++ || (s = (o = f.lastIndex) - i[0].length); else if (a && !--a) {
        l = i.index + i[0].length;
        var h = {
          left: {start: s, end: o},
          match: {start: o, end: i.index},
          right: {start: i.index, end: l},
          wholeMatch: {start: s, end: l}
        };
        if (u.push(h), !d) return u
      }
    } while (a && (f.lastIndex = o));
    return u
  };
  L.helper.matchRecursiveRegExp = function (e, t, n, r) {
    for (var a = x(e, t, n, r), o = [], i = 0; i < a.length; ++i) o.push([e.slice(a[i].wholeMatch.start, a[i].wholeMatch.end), e.slice(a[i].match.start, a[i].match.end), e.slice(a[i].left.start, a[i].left.end), e.slice(a[i].right.start, a[i].right.end)]);
    return o
  }, L.helper.replaceRecursiveRegExp = function (e, t, n, r, a) {
    if (!L.helper.isFunction(t)) {
      var o = t;
      t = function t() {
        return o
      }
    }
    var i = x(e, n, r, a), s = e, l = i.length;
    if (0 < l) {
      var c = [];
      0 !== i[0].wholeMatch.start && c.push(e.slice(0, i[0].wholeMatch.start));
      for (var d = 0; d < l; ++d) c.push(t(e.slice(i[d].wholeMatch.start, i[d].wholeMatch.end), e.slice(i[d].match.start, i[d].match.end), e.slice(i[d].left.start, i[d].left.end), e.slice(i[d].right.start, i[d].right.end))), d < l - 1 && c.push(e.slice(i[d].wholeMatch.end, i[d + 1].wholeMatch.start));
      i[l - 1].wholeMatch.end < e.length && c.push(e.slice(i[l - 1].wholeMatch.end)), s = c.join("")
    }
    return s
  }, L.helper.regexIndexOf = function (e, t, n) {
    if (!L.helper.isString(e)) throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
    if (t instanceof RegExp == !1) throw"InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp";
    var r = e.substring(n || 0).search(t);
    return 0 <= r ? r + (n || 0) : r
  }, L.helper.splitAtIndex = function (e, t) {
    if (!L.helper.isString(e)) throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
    return [e.substring(0, t), e.substring(t)]
  }, L.helper.encodeEmailAddress = function (e) {
    var n = [function (e) {
      return "&#" + e.charCodeAt(0) + ";"
    }, function (e) {
      return "&#x" + e.charCodeAt(0).toString(16) + ";"
    }, function (e) {
      return e
    }];
    return e = e.replace(/./g, function (e) {
      if ("@" === e) e = n[Math.floor(2 * Math.random())](e); else {
        var t = Math.random();
        e = .9 < t ? n[2](e) : .45 < t ? n[1](e) : n[0](e)
      }
      return e
    })
  }, L.helper.padEnd = function (e, t, n) {
    return t >>= 0, n = String(n || " "), e.length > t ? String(e) : ((t -= e.length) > n.length && (n += n.repeat(t / n.length)), String(e) + n.slice(0, t))
  }, "undefined" == typeof console && (console = {
    warn: function (e) {
      alert(e)
    }, log: function (e) {
      alert(e)
    }, error: function (e) {
      throw e
    }
  }), L.helper.regexes = {asteriskDashAndColon: /([*_:~])/g}, L.helper.emojis = {
    "+1": "\ud83d\udc4d",
    "-1": "\ud83d\udc4e",
    100: "\ud83d\udcaf",
    1234: "\ud83d\udd22",
    "1st_place_medal": "\ud83e\udd47",
    "2nd_place_medal": "\ud83e\udd48",
    "3rd_place_medal": "\ud83e\udd49",
    "8ball": "\ud83c\udfb1",
    a: "\ud83c\udd70\ufe0f",
    ab: "\ud83c\udd8e",
    abc: "\ud83d\udd24",
    abcd: "\ud83d\udd21",
    accept: "\ud83c\ude51",
    aerial_tramway: "\ud83d\udea1",
    airplane: "\u2708\ufe0f",
    alarm_clock: "\u23f0",
    alembic: "\u2697\ufe0f",
    alien: "\ud83d\udc7d",
    ambulance: "\ud83d\ude91",
    amphora: "\ud83c\udffa",
    anchor: "\u2693\ufe0f",
    angel: "\ud83d\udc7c",
    anger: "\ud83d\udca2",
    angry: "\ud83d\ude20",
    anguished: "\ud83d\ude27",
    ant: "\ud83d\udc1c",
    apple: "\ud83c\udf4e",
    aquarius: "\u2652\ufe0f",
    aries: "\u2648\ufe0f",
    arrow_backward: "\u25c0\ufe0f",
    arrow_double_down: "\u23ec",
    arrow_double_up: "\u23eb",
    arrow_down: "\u2b07\ufe0f",
    arrow_down_small: "\ud83d\udd3d",
    arrow_forward: "\u25b6\ufe0f",
    arrow_heading_down: "\u2935\ufe0f",
    arrow_heading_up: "\u2934\ufe0f",
    arrow_left: "\u2b05\ufe0f",
    arrow_lower_left: "\u2199\ufe0f",
    arrow_lower_right: "\u2198\ufe0f",
    arrow_right: "\u27a1\ufe0f",
    arrow_right_hook: "\u21aa\ufe0f",
    arrow_up: "\u2b06\ufe0f",
    arrow_up_down: "\u2195\ufe0f",
    arrow_up_small: "\ud83d\udd3c",
    arrow_upper_left: "\u2196\ufe0f",
    arrow_upper_right: "\u2197\ufe0f",
    arrows_clockwise: "\ud83d\udd03",
    arrows_counterclockwise: "\ud83d\udd04",
    art: "\ud83c\udfa8",
    articulated_lorry: "\ud83d\ude9b",
    artificial_satellite: "\ud83d\udef0",
    astonished: "\ud83d\ude32",
    athletic_shoe: "\ud83d\udc5f",
    atm: "\ud83c\udfe7",
    atom_symbol: "\u269b\ufe0f",
    avocado: "\ud83e\udd51",
    b: "\ud83c\udd71\ufe0f",
    baby: "\ud83d\udc76",
    baby_bottle: "\ud83c\udf7c",
    baby_chick: "\ud83d\udc24",
    baby_symbol: "\ud83d\udebc",
    back: "\ud83d\udd19",
    bacon: "\ud83e\udd53",
    badminton: "\ud83c\udff8",
    baggage_claim: "\ud83d\udec4",
    baguette_bread: "\ud83e\udd56",
    balance_scale: "\u2696\ufe0f",
    balloon: "\ud83c\udf88",
    ballot_box: "\ud83d\uddf3",
    ballot_box_with_check: "\u2611\ufe0f",
    bamboo: "\ud83c\udf8d",
    banana: "\ud83c\udf4c",
    bangbang: "\u203c\ufe0f",
    bank: "\ud83c\udfe6",
    bar_chart: "\ud83d\udcca",
    barber: "\ud83d\udc88",
    baseball: "\u26be\ufe0f",
    basketball: "\ud83c\udfc0",
    basketball_man: "\u26f9\ufe0f",
    basketball_woman: "\u26f9\ufe0f&zwj;\u2640\ufe0f",
    bat: "\ud83e\udd87",
    bath: "\ud83d\udec0",
    bathtub: "\ud83d\udec1",
    battery: "\ud83d\udd0b",
    beach_umbrella: "\ud83c\udfd6",
    bear: "\ud83d\udc3b",
    bed: "\ud83d\udecf",
    bee: "\ud83d\udc1d",
    beer: "\ud83c\udf7a",
    beers: "\ud83c\udf7b",
    beetle: "\ud83d\udc1e",
    beginner: "\ud83d\udd30",
    bell: "\ud83d\udd14",
    bellhop_bell: "\ud83d\udece",
    bento: "\ud83c\udf71",
    biking_man: "\ud83d\udeb4",
    bike: "\ud83d\udeb2",
    biking_woman: "\ud83d\udeb4&zwj;\u2640\ufe0f",
    bikini: "\ud83d\udc59",
    biohazard: "\u2623\ufe0f",
    bird: "\ud83d\udc26",
    birthday: "\ud83c\udf82",
    black_circle: "\u26ab\ufe0f",
    black_flag: "\ud83c\udff4",
    black_heart: "\ud83d\udda4",
    black_joker: "\ud83c\udccf",
    black_large_square: "\u2b1b\ufe0f",
    black_medium_small_square: "\u25fe\ufe0f",
    black_medium_square: "\u25fc\ufe0f",
    black_nib: "\u2712\ufe0f",
    black_small_square: "\u25aa\ufe0f",
    black_square_button: "\ud83d\udd32",
    blonde_man: "\ud83d\udc71",
    blonde_woman: "\ud83d\udc71&zwj;\u2640\ufe0f",
    blossom: "\ud83c\udf3c",
    blowfish: "\ud83d\udc21",
    blue_book: "\ud83d\udcd8",
    blue_car: "\ud83d\ude99",
    blue_heart: "\ud83d\udc99",
    blush: "\ud83d\ude0a",
    boar: "\ud83d\udc17",
    boat: "\u26f5\ufe0f",
    bomb: "\ud83d\udca3",
    book: "\ud83d\udcd6",
    bookmark: "\ud83d\udd16",
    bookmark_tabs: "\ud83d\udcd1",
    books: "\ud83d\udcda",
    boom: "\ud83d\udca5",
    boot: "\ud83d\udc62",
    bouquet: "\ud83d\udc90",
    bowing_man: "\ud83d\ude47",
    bow_and_arrow: "\ud83c\udff9",
    bowing_woman: "\ud83d\ude47&zwj;\u2640\ufe0f",
    bowling: "\ud83c\udfb3",
    boxing_glove: "\ud83e\udd4a",
    boy: "\ud83d\udc66",
    bread: "\ud83c\udf5e",
    bride_with_veil: "\ud83d\udc70",
    bridge_at_night: "\ud83c\udf09",
    briefcase: "\ud83d\udcbc",
    broken_heart: "\ud83d\udc94",
    bug: "\ud83d\udc1b",
    building_construction: "\ud83c\udfd7",
    bulb: "\ud83d\udca1",
    bullettrain_front: "\ud83d\ude85",
    bullettrain_side: "\ud83d\ude84",
    burrito: "\ud83c\udf2f",
    bus: "\ud83d\ude8c",
    business_suit_levitating: "\ud83d\udd74",
    busstop: "\ud83d\ude8f",
    bust_in_silhouette: "\ud83d\udc64",
    busts_in_silhouette: "\ud83d\udc65",
    butterfly: "\ud83e\udd8b",
    cactus: "\ud83c\udf35",
    cake: "\ud83c\udf70",
    calendar: "\ud83d\udcc6",
    call_me_hand: "\ud83e\udd19",
    calling: "\ud83d\udcf2",
    camel: "\ud83d\udc2b",
    camera: "\ud83d\udcf7",
    camera_flash: "\ud83d\udcf8",
    camping: "\ud83c\udfd5",
    cancer: "\u264b\ufe0f",
    candle: "\ud83d\udd6f",
    candy: "\ud83c\udf6c",
    canoe: "\ud83d\udef6",
    capital_abcd: "\ud83d\udd20",
    capricorn: "\u2651\ufe0f",
    car: "\ud83d\ude97",
    card_file_box: "\ud83d\uddc3",
    card_index: "\ud83d\udcc7",
    card_index_dividers: "\ud83d\uddc2",
    carousel_horse: "\ud83c\udfa0",
    carrot: "\ud83e\udd55",
    cat: "\ud83d\udc31",
    cat2: "\ud83d\udc08",
    cd: "\ud83d\udcbf",
    chains: "\u26d3",
    champagne: "\ud83c\udf7e",
    chart: "\ud83d\udcb9",
    chart_with_downwards_trend: "\ud83d\udcc9",
    chart_with_upwards_trend: "\ud83d\udcc8",
    checkered_flag: "\ud83c\udfc1",
    cheese: "\ud83e\uddc0",
    cherries: "\ud83c\udf52",
    cherry_blossom: "\ud83c\udf38",
    chestnut: "\ud83c\udf30",
    chicken: "\ud83d\udc14",
    children_crossing: "\ud83d\udeb8",
    chipmunk: "\ud83d\udc3f",
    chocolate_bar: "\ud83c\udf6b",
    christmas_tree: "\ud83c\udf84",
    church: "\u26ea\ufe0f",
    cinema: "\ud83c\udfa6",
    circus_tent: "\ud83c\udfaa",
    city_sunrise: "\ud83c\udf07",
    city_sunset: "\ud83c\udf06",
    cityscape: "\ud83c\udfd9",
    cl: "\ud83c\udd91",
    clamp: "\ud83d\udddc",
    clap: "\ud83d\udc4f",
    clapper: "\ud83c\udfac",
    classical_building: "\ud83c\udfdb",
    clinking_glasses: "\ud83e\udd42",
    clipboard: "\ud83d\udccb",
    clock1: "\ud83d\udd50",
    clock10: "\ud83d\udd59",
    clock1030: "\ud83d\udd65",
    clock11: "\ud83d\udd5a",
    clock1130: "\ud83d\udd66",
    clock12: "\ud83d\udd5b",
    clock1230: "\ud83d\udd67",
    clock130: "\ud83d\udd5c",
    clock2: "\ud83d\udd51",
    clock230: "\ud83d\udd5d",
    clock3: "\ud83d\udd52",
    clock330: "\ud83d\udd5e",
    clock4: "\ud83d\udd53",
    clock430: "\ud83d\udd5f",
    clock5: "\ud83d\udd54",
    clock530: "\ud83d\udd60",
    clock6: "\ud83d\udd55",
    clock630: "\ud83d\udd61",
    clock7: "\ud83d\udd56",
    clock730: "\ud83d\udd62",
    clock8: "\ud83d\udd57",
    clock830: "\ud83d\udd63",
    clock9: "\ud83d\udd58",
    clock930: "\ud83d\udd64",
    closed_book: "\ud83d\udcd5",
    closed_lock_with_key: "\ud83d\udd10",
    closed_umbrella: "\ud83c\udf02",
    cloud: "\u2601\ufe0f",
    cloud_with_lightning: "\ud83c\udf29",
    cloud_with_lightning_and_rain: "\u26c8",
    cloud_with_rain: "\ud83c\udf27",
    cloud_with_snow: "\ud83c\udf28",
    clown_face: "\ud83e\udd21",
    clubs: "\u2663\ufe0f",
    cocktail: "\ud83c\udf78",
    coffee: "\u2615\ufe0f",
    coffin: "\u26b0\ufe0f",
    cold_sweat: "\ud83d\ude30",
    comet: "\u2604\ufe0f",
    computer: "\ud83d\udcbb",
    computer_mouse: "\ud83d\uddb1",
    confetti_ball: "\ud83c\udf8a",
    confounded: "\ud83d\ude16",
    confused: "\ud83d\ude15",
    congratulations: "\u3297\ufe0f",
    construction: "\ud83d\udea7",
    construction_worker_man: "\ud83d\udc77",
    construction_worker_woman: "\ud83d\udc77&zwj;\u2640\ufe0f",
    control_knobs: "\ud83c\udf9b",
    convenience_store: "\ud83c\udfea",
    cookie: "\ud83c\udf6a",
    cool: "\ud83c\udd92",
    policeman: "\ud83d\udc6e",
    copyright: "\xa9\ufe0f",
    corn: "\ud83c\udf3d",
    couch_and_lamp: "\ud83d\udecb",
    couple: "\ud83d\udc6b",
    couple_with_heart_woman_man: "\ud83d\udc91",
    couple_with_heart_man_man: "\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68",
    couple_with_heart_woman_woman: "\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69",
    couplekiss_man_man: "\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68",
    couplekiss_man_woman: "\ud83d\udc8f",
    couplekiss_woman_woman: "\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69",
    cow: "\ud83d\udc2e",
    cow2: "\ud83d\udc04",
    cowboy_hat_face: "\ud83e\udd20",
    crab: "\ud83e\udd80",
    crayon: "\ud83d\udd8d",
    credit_card: "\ud83d\udcb3",
    crescent_moon: "\ud83c\udf19",
    cricket: "\ud83c\udfcf",
    crocodile: "\ud83d\udc0a",
    croissant: "\ud83e\udd50",
    crossed_fingers: "\ud83e\udd1e",
    crossed_flags: "\ud83c\udf8c",
    crossed_swords: "\u2694\ufe0f",
    crown: "\ud83d\udc51",
    cry: "\ud83d\ude22",
    crying_cat_face: "\ud83d\ude3f",
    crystal_ball: "\ud83d\udd2e",
    cucumber: "\ud83e\udd52",
    cupid: "\ud83d\udc98",
    curly_loop: "\u27b0",
    currency_exchange: "\ud83d\udcb1",
    curry: "\ud83c\udf5b",
    custard: "\ud83c\udf6e",
    customs: "\ud83d\udec3",
    cyclone: "\ud83c\udf00",
    dagger: "\ud83d\udde1",
    dancer: "\ud83d\udc83",
    dancing_women: "\ud83d\udc6f",
    dancing_men: "\ud83d\udc6f&zwj;\u2642\ufe0f",
    dango: "\ud83c\udf61",
    dark_sunglasses: "\ud83d\udd76",
    dart: "\ud83c\udfaf",
    dash: "\ud83d\udca8",
    date: "\ud83d\udcc5",
    deciduous_tree: "\ud83c\udf33",
    deer: "\ud83e\udd8c",
    department_store: "\ud83c\udfec",
    derelict_house: "\ud83c\udfda",
    desert: "\ud83c\udfdc",
    desert_island: "\ud83c\udfdd",
    desktop_computer: "\ud83d\udda5",
    male_detective: "\ud83d\udd75\ufe0f",
    diamond_shape_with_a_dot_inside: "\ud83d\udca0",
    diamonds: "\u2666\ufe0f",
    disappointed: "\ud83d\ude1e",
    disappointed_relieved: "\ud83d\ude25",
    dizzy: "\ud83d\udcab",
    dizzy_face: "\ud83d\ude35",
    do_not_litter: "\ud83d\udeaf",
    dog: "\ud83d\udc36",
    dog2: "\ud83d\udc15",
    dollar: "\ud83d\udcb5",
    dolls: "\ud83c\udf8e",
    dolphin: "\ud83d\udc2c",
    door: "\ud83d\udeaa",
    doughnut: "\ud83c\udf69",
    dove: "\ud83d\udd4a",
    dragon: "\ud83d\udc09",
    dragon_face: "\ud83d\udc32",
    dress: "\ud83d\udc57",
    dromedary_camel: "\ud83d\udc2a",
    drooling_face: "\ud83e\udd24",
    droplet: "\ud83d\udca7",
    drum: "\ud83e\udd41",
    duck: "\ud83e\udd86",
    dvd: "\ud83d\udcc0",
    "e-mail": "\ud83d\udce7",
    eagle: "\ud83e\udd85",
    ear: "\ud83d\udc42",
    ear_of_rice: "\ud83c\udf3e",
    earth_africa: "\ud83c\udf0d",
    earth_americas: "\ud83c\udf0e",
    earth_asia: "\ud83c\udf0f",
    egg: "\ud83e\udd5a",
    eggplant: "\ud83c\udf46",
    eight_pointed_black_star: "\u2734\ufe0f",
    eight_spoked_asterisk: "\u2733\ufe0f",
    electric_plug: "\ud83d\udd0c",
    elephant: "\ud83d\udc18",
    email: "\u2709\ufe0f",
    end: "\ud83d\udd1a",
    envelope_with_arrow: "\ud83d\udce9",
    euro: "\ud83d\udcb6",
    european_castle: "\ud83c\udff0",
    european_post_office: "\ud83c\udfe4",
    evergreen_tree: "\ud83c\udf32",
    exclamation: "\u2757\ufe0f",
    expressionless: "\ud83d\ude11",
    eye: "\ud83d\udc41",
    eye_speech_bubble: "\ud83d\udc41&zwj;\ud83d\udde8",
    eyeglasses: "\ud83d\udc53",
    eyes: "\ud83d\udc40",
    face_with_head_bandage: "\ud83e\udd15",
    face_with_thermometer: "\ud83e\udd12",
    fist_oncoming: "\ud83d\udc4a",
    factory: "\ud83c\udfed",
    fallen_leaf: "\ud83c\udf42",
    family_man_woman_boy: "\ud83d\udc6a",
    family_man_boy: "\ud83d\udc68&zwj;\ud83d\udc66",
    family_man_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_girl: "\ud83d\udc68&zwj;\ud83d\udc67",
    family_man_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_man_man_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66",
    family_man_man_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_man_girl: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67",
    family_man_man_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_man_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_man_woman_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_woman_girl: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
    family_man_woman_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_woman_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_woman_boy: "\ud83d\udc69&zwj;\ud83d\udc66",
    family_woman_boy_boy: "\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_woman_girl: "\ud83d\udc69&zwj;\ud83d\udc67",
    family_woman_girl_boy: "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_woman_girl_girl: "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_woman_woman_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66",
    family_woman_woman_boy_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_woman_woman_girl: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
    family_woman_woman_girl_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_woman_woman_girl_girl: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    fast_forward: "\u23e9",
    fax: "\ud83d\udce0",
    fearful: "\ud83d\ude28",
    feet: "\ud83d\udc3e",
    female_detective: "\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f",
    ferris_wheel: "\ud83c\udfa1",
    ferry: "\u26f4",
    field_hockey: "\ud83c\udfd1",
    file_cabinet: "\ud83d\uddc4",
    file_folder: "\ud83d\udcc1",
    film_projector: "\ud83d\udcfd",
    film_strip: "\ud83c\udf9e",
    fire: "\ud83d\udd25",
    fire_engine: "\ud83d\ude92",
    fireworks: "\ud83c\udf86",
    first_quarter_moon: "\ud83c\udf13",
    first_quarter_moon_with_face: "\ud83c\udf1b",
    fish: "\ud83d\udc1f",
    fish_cake: "\ud83c\udf65",
    fishing_pole_and_fish: "\ud83c\udfa3",
    fist_raised: "\u270a",
    fist_left: "\ud83e\udd1b",
    fist_right: "\ud83e\udd1c",
    flags: "\ud83c\udf8f",
    flashlight: "\ud83d\udd26",
    fleur_de_lis: "\u269c\ufe0f",
    flight_arrival: "\ud83d\udeec",
    flight_departure: "\ud83d\udeeb",
    floppy_disk: "\ud83d\udcbe",
    flower_playing_cards: "\ud83c\udfb4",
    flushed: "\ud83d\ude33",
    fog: "\ud83c\udf2b",
    foggy: "\ud83c\udf01",
    football: "\ud83c\udfc8",
    footprints: "\ud83d\udc63",
    fork_and_knife: "\ud83c\udf74",
    fountain: "\u26f2\ufe0f",
    fountain_pen: "\ud83d\udd8b",
    four_leaf_clover: "\ud83c\udf40",
    fox_face: "\ud83e\udd8a",
    framed_picture: "\ud83d\uddbc",
    free: "\ud83c\udd93",
    fried_egg: "\ud83c\udf73",
    fried_shrimp: "\ud83c\udf64",
    fries: "\ud83c\udf5f",
    frog: "\ud83d\udc38",
    frowning: "\ud83d\ude26",
    frowning_face: "\u2639\ufe0f",
    frowning_man: "\ud83d\ude4d&zwj;\u2642\ufe0f",
    frowning_woman: "\ud83d\ude4d",
    middle_finger: "\ud83d\udd95",
    fuelpump: "\u26fd\ufe0f",
    full_moon: "\ud83c\udf15",
    full_moon_with_face: "\ud83c\udf1d",
    funeral_urn: "\u26b1\ufe0f",
    game_die: "\ud83c\udfb2",
    gear: "\u2699\ufe0f",
    gem: "\ud83d\udc8e",
    gemini: "\u264a\ufe0f",
    ghost: "\ud83d\udc7b",
    gift: "\ud83c\udf81",
    gift_heart: "\ud83d\udc9d",
    girl: "\ud83d\udc67",
    globe_with_meridians: "\ud83c\udf10",
    goal_net: "\ud83e\udd45",
    goat: "\ud83d\udc10",
    golf: "\u26f3\ufe0f",
    golfing_man: "\ud83c\udfcc\ufe0f",
    golfing_woman: "\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f",
    gorilla: "\ud83e\udd8d",
    grapes: "\ud83c\udf47",
    green_apple: "\ud83c\udf4f",
    green_book: "\ud83d\udcd7",
    green_heart: "\ud83d\udc9a",
    green_salad: "\ud83e\udd57",
    grey_exclamation: "\u2755",
    grey_question: "\u2754",
    grimacing: "\ud83d\ude2c",
    grin: "\ud83d\ude01",
    grinning: "\ud83d\ude00",
    guardsman: "\ud83d\udc82",
    guardswoman: "\ud83d\udc82&zwj;\u2640\ufe0f",
    guitar: "\ud83c\udfb8",
    gun: "\ud83d\udd2b",
    haircut_woman: "\ud83d\udc87",
    haircut_man: "\ud83d\udc87&zwj;\u2642\ufe0f",
    hamburger: "\ud83c\udf54",
    hammer: "\ud83d\udd28",
    hammer_and_pick: "\u2692",
    hammer_and_wrench: "\ud83d\udee0",
    hamster: "\ud83d\udc39",
    hand: "\u270b",
    handbag: "\ud83d\udc5c",
    handshake: "\ud83e\udd1d",
    hankey: "\ud83d\udca9",
    hatched_chick: "\ud83d\udc25",
    hatching_chick: "\ud83d\udc23",
    headphones: "\ud83c\udfa7",
    hear_no_evil: "\ud83d\ude49",
    heart: "\u2764\ufe0f",
    heart_decoration: "\ud83d\udc9f",
    heart_eyes: "\ud83d\ude0d",
    heart_eyes_cat: "\ud83d\ude3b",
    heartbeat: "\ud83d\udc93",
    heartpulse: "\ud83d\udc97",
    hearts: "\u2665\ufe0f",
    heavy_check_mark: "\u2714\ufe0f",
    heavy_division_sign: "\u2797",
    heavy_dollar_sign: "\ud83d\udcb2",
    heavy_heart_exclamation: "\u2763\ufe0f",
    heavy_minus_sign: "\u2796",
    heavy_multiplication_x: "\u2716\ufe0f",
    heavy_plus_sign: "\u2795",
    helicopter: "\ud83d\ude81",
    herb: "\ud83c\udf3f",
    hibiscus: "\ud83c\udf3a",
    high_brightness: "\ud83d\udd06",
    high_heel: "\ud83d\udc60",
    hocho: "\ud83d\udd2a",
    hole: "\ud83d\udd73",
    honey_pot: "\ud83c\udf6f",
    horse: "\ud83d\udc34",
    horse_racing: "\ud83c\udfc7",
    hospital: "\ud83c\udfe5",
    hot_pepper: "\ud83c\udf36",
    hotdog: "\ud83c\udf2d",
    hotel: "\ud83c\udfe8",
    hotsprings: "\u2668\ufe0f",
    hourglass: "\u231b\ufe0f",
    hourglass_flowing_sand: "\u23f3",
    house: "\ud83c\udfe0",
    house_with_garden: "\ud83c\udfe1",
    houses: "\ud83c\udfd8",
    hugs: "\ud83e\udd17",
    hushed: "\ud83d\ude2f",
    ice_cream: "\ud83c\udf68",
    ice_hockey: "\ud83c\udfd2",
    ice_skate: "\u26f8",
    icecream: "\ud83c\udf66",
    id: "\ud83c\udd94",
    ideograph_advantage: "\ud83c\ude50",
    imp: "\ud83d\udc7f",
    inbox_tray: "\ud83d\udce5",
    incoming_envelope: "\ud83d\udce8",
    tipping_hand_woman: "\ud83d\udc81",
    information_source: "\u2139\ufe0f",
    innocent: "\ud83d\ude07",
    interrobang: "\u2049\ufe0f",
    iphone: "\ud83d\udcf1",
    izakaya_lantern: "\ud83c\udfee",
    jack_o_lantern: "\ud83c\udf83",
    japan: "\ud83d\uddfe",
    japanese_castle: "\ud83c\udfef",
    japanese_goblin: "\ud83d\udc7a",
    japanese_ogre: "\ud83d\udc79",
    jeans: "\ud83d\udc56",
    joy: "\ud83d\ude02",
    joy_cat: "\ud83d\ude39",
    joystick: "\ud83d\udd79",
    kaaba: "\ud83d\udd4b",
    key: "\ud83d\udd11",
    keyboard: "\u2328\ufe0f",
    keycap_ten: "\ud83d\udd1f",
    kick_scooter: "\ud83d\udef4",
    kimono: "\ud83d\udc58",
    kiss: "\ud83d\udc8b",
    kissing: "\ud83d\ude17",
    kissing_cat: "\ud83d\ude3d",
    kissing_closed_eyes: "\ud83d\ude1a",
    kissing_heart: "\ud83d\ude18",
    kissing_smiling_eyes: "\ud83d\ude19",
    kiwi_fruit: "\ud83e\udd5d",
    koala: "\ud83d\udc28",
    koko: "\ud83c\ude01",
    label: "\ud83c\udff7",
    large_blue_circle: "\ud83d\udd35",
    large_blue_diamond: "\ud83d\udd37",
    large_orange_diamond: "\ud83d\udd36",
    last_quarter_moon: "\ud83c\udf17",
    last_quarter_moon_with_face: "\ud83c\udf1c",
    latin_cross: "\u271d\ufe0f",
    laughing: "\ud83d\ude06",
    leaves: "\ud83c\udf43",
    ledger: "\ud83d\udcd2",
    left_luggage: "\ud83d\udec5",
    left_right_arrow: "\u2194\ufe0f",
    leftwards_arrow_with_hook: "\u21a9\ufe0f",
    lemon: "\ud83c\udf4b",
    leo: "\u264c\ufe0f",
    leopard: "\ud83d\udc06",
    level_slider: "\ud83c\udf9a",
    libra: "\u264e\ufe0f",
    light_rail: "\ud83d\ude88",
    link: "\ud83d\udd17",
    lion: "\ud83e\udd81",
    lips: "\ud83d\udc44",
    lipstick: "\ud83d\udc84",
    lizard: "\ud83e\udd8e",
    lock: "\ud83d\udd12",
    lock_with_ink_pen: "\ud83d\udd0f",
    lollipop: "\ud83c\udf6d",
    loop: "\u27bf",
    loud_sound: "\ud83d\udd0a",
    loudspeaker: "\ud83d\udce2",
    love_hotel: "\ud83c\udfe9",
    love_letter: "\ud83d\udc8c",
    low_brightness: "\ud83d\udd05",
    lying_face: "\ud83e\udd25",
    m: "\u24c2\ufe0f",
    mag: "\ud83d\udd0d",
    mag_right: "\ud83d\udd0e",
    mahjong: "\ud83c\udc04\ufe0f",
    mailbox: "\ud83d\udceb",
    mailbox_closed: "\ud83d\udcea",
    mailbox_with_mail: "\ud83d\udcec",
    mailbox_with_no_mail: "\ud83d\udced",
    man: "\ud83d\udc68",
    man_artist: "\ud83d\udc68&zwj;\ud83c\udfa8",
    man_astronaut: "\ud83d\udc68&zwj;\ud83d\ude80",
    man_cartwheeling: "\ud83e\udd38&zwj;\u2642\ufe0f",
    man_cook: "\ud83d\udc68&zwj;\ud83c\udf73",
    man_dancing: "\ud83d\udd7a",
    man_facepalming: "\ud83e\udd26&zwj;\u2642\ufe0f",
    man_factory_worker: "\ud83d\udc68&zwj;\ud83c\udfed",
    man_farmer: "\ud83d\udc68&zwj;\ud83c\udf3e",
    man_firefighter: "\ud83d\udc68&zwj;\ud83d\ude92",
    man_health_worker: "\ud83d\udc68&zwj;\u2695\ufe0f",
    man_in_tuxedo: "\ud83e\udd35",
    man_judge: "\ud83d\udc68&zwj;\u2696\ufe0f",
    man_juggling: "\ud83e\udd39&zwj;\u2642\ufe0f",
    man_mechanic: "\ud83d\udc68&zwj;\ud83d\udd27",
    man_office_worker: "\ud83d\udc68&zwj;\ud83d\udcbc",
    man_pilot: "\ud83d\udc68&zwj;\u2708\ufe0f",
    man_playing_handball: "\ud83e\udd3e&zwj;\u2642\ufe0f",
    man_playing_water_polo: "\ud83e\udd3d&zwj;\u2642\ufe0f",
    man_scientist: "\ud83d\udc68&zwj;\ud83d\udd2c",
    man_shrugging: "\ud83e\udd37&zwj;\u2642\ufe0f",
    man_singer: "\ud83d\udc68&zwj;\ud83c\udfa4",
    man_student: "\ud83d\udc68&zwj;\ud83c\udf93",
    man_teacher: "\ud83d\udc68&zwj;\ud83c\udfeb",
    man_technologist: "\ud83d\udc68&zwj;\ud83d\udcbb",
    man_with_gua_pi_mao: "\ud83d\udc72",
    man_with_turban: "\ud83d\udc73",
    tangerine: "\ud83c\udf4a",
    mans_shoe: "\ud83d\udc5e",
    mantelpiece_clock: "\ud83d\udd70",
    maple_leaf: "\ud83c\udf41",
    martial_arts_uniform: "\ud83e\udd4b",
    mask: "\ud83d\ude37",
    massage_woman: "\ud83d\udc86",
    massage_man: "\ud83d\udc86&zwj;\u2642\ufe0f",
    meat_on_bone: "\ud83c\udf56",
    medal_military: "\ud83c\udf96",
    medal_sports: "\ud83c\udfc5",
    mega: "\ud83d\udce3",
    melon: "\ud83c\udf48",
    memo: "\ud83d\udcdd",
    men_wrestling: "\ud83e\udd3c&zwj;\u2642\ufe0f",
    menorah: "\ud83d\udd4e",
    mens: "\ud83d\udeb9",
    metal: "\ud83e\udd18",
    metro: "\ud83d\ude87",
    microphone: "\ud83c\udfa4",
    microscope: "\ud83d\udd2c",
    milk_glass: "\ud83e\udd5b",
    milky_way: "\ud83c\udf0c",
    minibus: "\ud83d\ude90",
    minidisc: "\ud83d\udcbd",
    mobile_phone_off: "\ud83d\udcf4",
    money_mouth_face: "\ud83e\udd11",
    money_with_wings: "\ud83d\udcb8",
    moneybag: "\ud83d\udcb0",
    monkey: "\ud83d\udc12",
    monkey_face: "\ud83d\udc35",
    monorail: "\ud83d\ude9d",
    moon: "\ud83c\udf14",
    mortar_board: "\ud83c\udf93",
    mosque: "\ud83d\udd4c",
    motor_boat: "\ud83d\udee5",
    motor_scooter: "\ud83d\udef5",
    motorcycle: "\ud83c\udfcd",
    motorway: "\ud83d\udee3",
    mount_fuji: "\ud83d\uddfb",
    mountain: "\u26f0",
    mountain_biking_man: "\ud83d\udeb5",
    mountain_biking_woman: "\ud83d\udeb5&zwj;\u2640\ufe0f",
    mountain_cableway: "\ud83d\udea0",
    mountain_railway: "\ud83d\ude9e",
    mountain_snow: "\ud83c\udfd4",
    mouse: "\ud83d\udc2d",
    mouse2: "\ud83d\udc01",
    movie_camera: "\ud83c\udfa5",
    moyai: "\ud83d\uddff",
    mrs_claus: "\ud83e\udd36",
    muscle: "\ud83d\udcaa",
    mushroom: "\ud83c\udf44",
    musical_keyboard: "\ud83c\udfb9",
    musical_note: "\ud83c\udfb5",
    musical_score: "\ud83c\udfbc",
    mute: "\ud83d\udd07",
    nail_care: "\ud83d\udc85",
    name_badge: "\ud83d\udcdb",
    national_park: "\ud83c\udfde",
    nauseated_face: "\ud83e\udd22",
    necktie: "\ud83d\udc54",
    negative_squared_cross_mark: "\u274e",
    nerd_face: "\ud83e\udd13",
    neutral_face: "\ud83d\ude10",
    "new": "\ud83c\udd95",
    new_moon: "\ud83c\udf11",
    new_moon_with_face: "\ud83c\udf1a",
    newspaper: "\ud83d\udcf0",
    newspaper_roll: "\ud83d\uddde",
    next_track_button: "\u23ed",
    ng: "\ud83c\udd96",
    no_good_man: "\ud83d\ude45&zwj;\u2642\ufe0f",
    no_good_woman: "\ud83d\ude45",
    night_with_stars: "\ud83c\udf03",
    no_bell: "\ud83d\udd15",
    no_bicycles: "\ud83d\udeb3",
    no_entry: "\u26d4\ufe0f",
    no_entry_sign: "\ud83d\udeab",
    no_mobile_phones: "\ud83d\udcf5",
    no_mouth: "\ud83d\ude36",
    no_pedestrians: "\ud83d\udeb7",
    no_smoking: "\ud83d\udead",
    "non-potable_water": "\ud83d\udeb1",
    nose: "\ud83d\udc43",
    notebook: "\ud83d\udcd3",
    notebook_with_decorative_cover: "\ud83d\udcd4",
    notes: "\ud83c\udfb6",
    nut_and_bolt: "\ud83d\udd29",
    o: "\u2b55\ufe0f",
    o2: "\ud83c\udd7e\ufe0f",
    ocean: "\ud83c\udf0a",
    octopus: "\ud83d\udc19",
    oden: "\ud83c\udf62",
    office: "\ud83c\udfe2",
    oil_drum: "\ud83d\udee2",
    ok: "\ud83c\udd97",
    ok_hand: "\ud83d\udc4c",
    ok_man: "\ud83d\ude46&zwj;\u2642\ufe0f",
    ok_woman: "\ud83d\ude46",
    old_key: "\ud83d\udddd",
    older_man: "\ud83d\udc74",
    older_woman: "\ud83d\udc75",
    om: "\ud83d\udd49",
    on: "\ud83d\udd1b",
    oncoming_automobile: "\ud83d\ude98",
    oncoming_bus: "\ud83d\ude8d",
    oncoming_police_car: "\ud83d\ude94",
    oncoming_taxi: "\ud83d\ude96",
    open_file_folder: "\ud83d\udcc2",
    open_hands: "\ud83d\udc50",
    open_mouth: "\ud83d\ude2e",
    open_umbrella: "\u2602\ufe0f",
    ophiuchus: "\u26ce",
    orange_book: "\ud83d\udcd9",
    orthodox_cross: "\u2626\ufe0f",
    outbox_tray: "\ud83d\udce4",
    owl: "\ud83e\udd89",
    ox: "\ud83d\udc02",
    "package": "\ud83d\udce6",
    page_facing_up: "\ud83d\udcc4",
    page_with_curl: "\ud83d\udcc3",
    pager: "\ud83d\udcdf",
    paintbrush: "\ud83d\udd8c",
    palm_tree: "\ud83c\udf34",
    pancakes: "\ud83e\udd5e",
    panda_face: "\ud83d\udc3c",
    paperclip: "\ud83d\udcce",
    paperclips: "\ud83d\udd87",
    parasol_on_ground: "\u26f1",
    parking: "\ud83c\udd7f\ufe0f",
    part_alternation_mark: "\u303d\ufe0f",
    partly_sunny: "\u26c5\ufe0f",
    passenger_ship: "\ud83d\udef3",
    passport_control: "\ud83d\udec2",
    pause_button: "\u23f8",
    peace_symbol: "\u262e\ufe0f",
    peach: "\ud83c\udf51",
    peanuts: "\ud83e\udd5c",
    pear: "\ud83c\udf50",
    pen: "\ud83d\udd8a",
    pencil2: "\u270f\ufe0f",
    penguin: "\ud83d\udc27",
    pensive: "\ud83d\ude14",
    performing_arts: "\ud83c\udfad",
    persevere: "\ud83d\ude23",
    person_fencing: "\ud83e\udd3a",
    pouting_woman: "\ud83d\ude4e",
    phone: "\u260e\ufe0f",
    pick: "\u26cf",
    pig: "\ud83d\udc37",
    pig2: "\ud83d\udc16",
    pig_nose: "\ud83d\udc3d",
    pill: "\ud83d\udc8a",
    pineapple: "\ud83c\udf4d",
    ping_pong: "\ud83c\udfd3",
    pisces: "\u2653\ufe0f",
    pizza: "\ud83c\udf55",
    place_of_worship: "\ud83d\uded0",
    plate_with_cutlery: "\ud83c\udf7d",
    play_or_pause_button: "\u23ef",
    point_down: "\ud83d\udc47",
    point_left: "\ud83d\udc48",
    point_right: "\ud83d\udc49",
    point_up: "\u261d\ufe0f",
    point_up_2: "\ud83d\udc46",
    police_car: "\ud83d\ude93",
    policewoman: "\ud83d\udc6e&zwj;\u2640\ufe0f",
    poodle: "\ud83d\udc29",
    popcorn: "\ud83c\udf7f",
    post_office: "\ud83c\udfe3",
    postal_horn: "\ud83d\udcef",
    postbox: "\ud83d\udcee",
    potable_water: "\ud83d\udeb0",
    potato: "\ud83e\udd54",
    pouch: "\ud83d\udc5d",
    poultry_leg: "\ud83c\udf57",
    pound: "\ud83d\udcb7",
    rage: "\ud83d\ude21",
    pouting_cat: "\ud83d\ude3e",
    pouting_man: "\ud83d\ude4e&zwj;\u2642\ufe0f",
    pray: "\ud83d\ude4f",
    prayer_beads: "\ud83d\udcff",
    pregnant_woman: "\ud83e\udd30",
    previous_track_button: "\u23ee",
    prince: "\ud83e\udd34",
    princess: "\ud83d\udc78",
    printer: "\ud83d\udda8",
    purple_heart: "\ud83d\udc9c",
    purse: "\ud83d\udc5b",
    pushpin: "\ud83d\udccc",
    put_litter_in_its_place: "\ud83d\udeae",
    question: "\u2753",
    rabbit: "\ud83d\udc30",
    rabbit2: "\ud83d\udc07",
    racehorse: "\ud83d\udc0e",
    racing_car: "\ud83c\udfce",
    radio: "\ud83d\udcfb",
    radio_button: "\ud83d\udd18",
    radioactive: "\u2622\ufe0f",
    railway_car: "\ud83d\ude83",
    railway_track: "\ud83d\udee4",
    rainbow: "\ud83c\udf08",
    rainbow_flag: "\ud83c\udff3\ufe0f&zwj;\ud83c\udf08",
    raised_back_of_hand: "\ud83e\udd1a",
    raised_hand_with_fingers_splayed: "\ud83d\udd90",
    raised_hands: "\ud83d\ude4c",
    raising_hand_woman: "\ud83d\ude4b",
    raising_hand_man: "\ud83d\ude4b&zwj;\u2642\ufe0f",
    ram: "\ud83d\udc0f",
    ramen: "\ud83c\udf5c",
    rat: "\ud83d\udc00",
    record_button: "\u23fa",
    recycle: "\u267b\ufe0f",
    red_circle: "\ud83d\udd34",
    registered: "\xae\ufe0f",
    relaxed: "\u263a\ufe0f",
    relieved: "\ud83d\ude0c",
    reminder_ribbon: "\ud83c\udf97",
    repeat: "\ud83d\udd01",
    repeat_one: "\ud83d\udd02",
    rescue_worker_helmet: "\u26d1",
    restroom: "\ud83d\udebb",
    revolving_hearts: "\ud83d\udc9e",
    rewind: "\u23ea",
    rhinoceros: "\ud83e\udd8f",
    ribbon: "\ud83c\udf80",
    rice: "\ud83c\udf5a",
    rice_ball: "\ud83c\udf59",
    rice_cracker: "\ud83c\udf58",
    rice_scene: "\ud83c\udf91",
    right_anger_bubble: "\ud83d\uddef",
    ring: "\ud83d\udc8d",
    robot: "\ud83e\udd16",
    rocket: "\ud83d\ude80",
    rofl: "\ud83e\udd23",
    roll_eyes: "\ud83d\ude44",
    roller_coaster: "\ud83c\udfa2",
    rooster: "\ud83d\udc13",
    rose: "\ud83c\udf39",
    rosette: "\ud83c\udff5",
    rotating_light: "\ud83d\udea8",
    round_pushpin: "\ud83d\udccd",
    rowing_man: "\ud83d\udea3",
    rowing_woman: "\ud83d\udea3&zwj;\u2640\ufe0f",
    rugby_football: "\ud83c\udfc9",
    running_man: "\ud83c\udfc3",
    running_shirt_with_sash: "\ud83c\udfbd",
    running_woman: "\ud83c\udfc3&zwj;\u2640\ufe0f",
    sa: "\ud83c\ude02\ufe0f",
    sagittarius: "\u2650\ufe0f",
    sake: "\ud83c\udf76",
    sandal: "\ud83d\udc61",
    santa: "\ud83c\udf85",
    satellite: "\ud83d\udce1",
    saxophone: "\ud83c\udfb7",
    school: "\ud83c\udfeb",
    school_satchel: "\ud83c\udf92",
    scissors: "\u2702\ufe0f",
    scorpion: "\ud83e\udd82",
    scorpius: "\u264f\ufe0f",
    scream: "\ud83d\ude31",
    scream_cat: "\ud83d\ude40",
    scroll: "\ud83d\udcdc",
    seat: "\ud83d\udcba",
    secret: "\u3299\ufe0f",
    see_no_evil: "\ud83d\ude48",
    seedling: "\ud83c\udf31",
    selfie: "\ud83e\udd33",
    shallow_pan_of_food: "\ud83e\udd58",
    shamrock: "\u2618\ufe0f",
    shark: "\ud83e\udd88",
    shaved_ice: "\ud83c\udf67",
    sheep: "\ud83d\udc11",
    shell: "\ud83d\udc1a",
    shield: "\ud83d\udee1",
    shinto_shrine: "\u26e9",
    ship: "\ud83d\udea2",
    shirt: "\ud83d\udc55",
    shopping: "\ud83d\udecd",
    shopping_cart: "\ud83d\uded2",
    shower: "\ud83d\udebf",
    shrimp: "\ud83e\udd90",
    signal_strength: "\ud83d\udcf6",
    six_pointed_star: "\ud83d\udd2f",
    ski: "\ud83c\udfbf",
    skier: "\u26f7",
    skull: "\ud83d\udc80",
    skull_and_crossbones: "\u2620\ufe0f",
    sleeping: "\ud83d\ude34",
    sleeping_bed: "\ud83d\udecc",
    sleepy: "\ud83d\ude2a",
    slightly_frowning_face: "\ud83d\ude41",
    slightly_smiling_face: "\ud83d\ude42",
    slot_machine: "\ud83c\udfb0",
    small_airplane: "\ud83d\udee9",
    small_blue_diamond: "\ud83d\udd39",
    small_orange_diamond: "\ud83d\udd38",
    small_red_triangle: "\ud83d\udd3a",
    small_red_triangle_down: "\ud83d\udd3b",
    smile: "\ud83d\ude04",
    smile_cat: "\ud83d\ude38",
    smiley: "\ud83d\ude03",
    smiley_cat: "\ud83d\ude3a",
    smiling_imp: "\ud83d\ude08",
    smirk: "\ud83d\ude0f",
    smirk_cat: "\ud83d\ude3c",
    smoking: "\ud83d\udeac",
    snail: "\ud83d\udc0c",
    snake: "\ud83d\udc0d",
    sneezing_face: "\ud83e\udd27",
    snowboarder: "\ud83c\udfc2",
    snowflake: "\u2744\ufe0f",
    snowman: "\u26c4\ufe0f",
    snowman_with_snow: "\u2603\ufe0f",
    sob: "\ud83d\ude2d",
    soccer: "\u26bd\ufe0f",
    soon: "\ud83d\udd1c",
    sos: "\ud83c\udd98",
    sound: "\ud83d\udd09",
    space_invader: "\ud83d\udc7e",
    spades: "\u2660\ufe0f",
    spaghetti: "\ud83c\udf5d",
    sparkle: "\u2747\ufe0f",
    sparkler: "\ud83c\udf87",
    sparkles: "\u2728",
    sparkling_heart: "\ud83d\udc96",
    speak_no_evil: "\ud83d\ude4a",
    speaker: "\ud83d\udd08",
    speaking_head: "\ud83d\udde3",
    speech_balloon: "\ud83d\udcac",
    speedboat: "\ud83d\udea4",
    spider: "\ud83d\udd77",
    spider_web: "\ud83d\udd78",
    spiral_calendar: "\ud83d\uddd3",
    spiral_notepad: "\ud83d\uddd2",
    spoon: "\ud83e\udd44",
    squid: "\ud83e\udd91",
    stadium: "\ud83c\udfdf",
    star: "\u2b50\ufe0f",
    star2: "\ud83c\udf1f",
    star_and_crescent: "\u262a\ufe0f",
    star_of_david: "\u2721\ufe0f",
    stars: "\ud83c\udf20",
    station: "\ud83d\ude89",
    statue_of_liberty: "\ud83d\uddfd",
    steam_locomotive: "\ud83d\ude82",
    stew: "\ud83c\udf72",
    stop_button: "\u23f9",
    stop_sign: "\ud83d\uded1",
    stopwatch: "\u23f1",
    straight_ruler: "\ud83d\udccf",
    strawberry: "\ud83c\udf53",
    stuck_out_tongue: "\ud83d\ude1b",
    stuck_out_tongue_closed_eyes: "\ud83d\ude1d",
    stuck_out_tongue_winking_eye: "\ud83d\ude1c",
    studio_microphone: "\ud83c\udf99",
    stuffed_flatbread: "\ud83e\udd59",
    sun_behind_large_cloud: "\ud83c\udf25",
    sun_behind_rain_cloud: "\ud83c\udf26",
    sun_behind_small_cloud: "\ud83c\udf24",
    sun_with_face: "\ud83c\udf1e",
    sunflower: "\ud83c\udf3b",
    sunglasses: "\ud83d\ude0e",
    sunny: "\u2600\ufe0f",
    sunrise: "\ud83c\udf05",
    sunrise_over_mountains: "\ud83c\udf04",
    surfing_man: "\ud83c\udfc4",
    surfing_woman: "\ud83c\udfc4&zwj;\u2640\ufe0f",
    sushi: "\ud83c\udf63",
    suspension_railway: "\ud83d\ude9f",
    sweat: "\ud83d\ude13",
    sweat_drops: "\ud83d\udca6",
    sweat_smile: "\ud83d\ude05",
    sweet_potato: "\ud83c\udf60",
    swimming_man: "\ud83c\udfca",
    swimming_woman: "\ud83c\udfca&zwj;\u2640\ufe0f",
    symbols: "\ud83d\udd23",
    synagogue: "\ud83d\udd4d",
    syringe: "\ud83d\udc89",
    taco: "\ud83c\udf2e",
    tada: "\ud83c\udf89",
    tanabata_tree: "\ud83c\udf8b",
    taurus: "\u2649\ufe0f",
    taxi: "\ud83d\ude95",
    tea: "\ud83c\udf75",
    telephone_receiver: "\ud83d\udcde",
    telescope: "\ud83d\udd2d",
    tennis: "\ud83c\udfbe",
    tent: "\u26fa\ufe0f",
    thermometer: "\ud83c\udf21",
    thinking: "\ud83e\udd14",
    thought_balloon: "\ud83d\udcad",
    ticket: "\ud83c\udfab",
    tickets: "\ud83c\udf9f",
    tiger: "\ud83d\udc2f",
    tiger2: "\ud83d\udc05",
    timer_clock: "\u23f2",
    tipping_hand_man: "\ud83d\udc81&zwj;\u2642\ufe0f",
    tired_face: "\ud83d\ude2b",
    tm: "\u2122\ufe0f",
    toilet: "\ud83d\udebd",
    tokyo_tower: "\ud83d\uddfc",
    tomato: "\ud83c\udf45",
    tongue: "\ud83d\udc45",
    top: "\ud83d\udd1d",
    tophat: "\ud83c\udfa9",
    tornado: "\ud83c\udf2a",
    trackball: "\ud83d\uddb2",
    tractor: "\ud83d\ude9c",
    traffic_light: "\ud83d\udea5",
    train: "\ud83d\ude8b",
    train2: "\ud83d\ude86",
    tram: "\ud83d\ude8a",
    triangular_flag_on_post: "\ud83d\udea9",
    triangular_ruler: "\ud83d\udcd0",
    trident: "\ud83d\udd31",
    triumph: "\ud83d\ude24",
    trolleybus: "\ud83d\ude8e",
    trophy: "\ud83c\udfc6",
    tropical_drink: "\ud83c\udf79",
    tropical_fish: "\ud83d\udc20",
    truck: "\ud83d\ude9a",
    trumpet: "\ud83c\udfba",
    tulip: "\ud83c\udf37",
    tumbler_glass: "\ud83e\udd43",
    turkey: "\ud83e\udd83",
    turtle: "\ud83d\udc22",
    tv: "\ud83d\udcfa",
    twisted_rightwards_arrows: "\ud83d\udd00",
    two_hearts: "\ud83d\udc95",
    two_men_holding_hands: "\ud83d\udc6c",
    two_women_holding_hands: "\ud83d\udc6d",
    u5272: "\ud83c\ude39",
    u5408: "\ud83c\ude34",
    u55b6: "\ud83c\ude3a",
    u6307: "\ud83c\ude2f\ufe0f",
    u6708: "\ud83c\ude37\ufe0f",
    u6709: "\ud83c\ude36",
    u6e80: "\ud83c\ude35",
    u7121: "\ud83c\ude1a\ufe0f",
    u7533: "\ud83c\ude38",
    u7981: "\ud83c\ude32",
    u7a7a: "\ud83c\ude33",
    umbrella: "\u2614\ufe0f",
    unamused: "\ud83d\ude12",
    underage: "\ud83d\udd1e",
    unicorn: "\ud83e\udd84",
    unlock: "\ud83d\udd13",
    up: "\ud83c\udd99",
    upside_down_face: "\ud83d\ude43",
    v: "\u270c\ufe0f",
    vertical_traffic_light: "\ud83d\udea6",
    vhs: "\ud83d\udcfc",
    vibration_mode: "\ud83d\udcf3",
    video_camera: "\ud83d\udcf9",
    video_game: "\ud83c\udfae",
    violin: "\ud83c\udfbb",
    virgo: "\u264d\ufe0f",
    volcano: "\ud83c\udf0b",
    volleyball: "\ud83c\udfd0",
    vs: "\ud83c\udd9a",
    vulcan_salute: "\ud83d\udd96",
    walking_man: "\ud83d\udeb6",
    walking_woman: "\ud83d\udeb6&zwj;\u2640\ufe0f",
    waning_crescent_moon: "\ud83c\udf18",
    waning_gibbous_moon: "\ud83c\udf16",
    warning: "\u26a0\ufe0f",
    wastebasket: "\ud83d\uddd1",
    watch: "\u231a\ufe0f",
    water_buffalo: "\ud83d\udc03",
    watermelon: "\ud83c\udf49",
    wave: "\ud83d\udc4b",
    wavy_dash: "\u3030\ufe0f",
    waxing_crescent_moon: "\ud83c\udf12",
    wc: "\ud83d\udebe",
    weary: "\ud83d\ude29",
    wedding: "\ud83d\udc92",
    weight_lifting_man: "\ud83c\udfcb\ufe0f",
    weight_lifting_woman: "\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f",
    whale: "\ud83d\udc33",
    whale2: "\ud83d\udc0b",
    wheel_of_dharma: "\u2638\ufe0f",
    wheelchair: "\u267f\ufe0f",
    white_check_mark: "\u2705",
    white_circle: "\u26aa\ufe0f",
    white_flag: "\ud83c\udff3\ufe0f",
    white_flower: "\ud83d\udcae",
    white_large_square: "\u2b1c\ufe0f",
    white_medium_small_square: "\u25fd\ufe0f",
    white_medium_square: "\u25fb\ufe0f",
    white_small_square: "\u25ab\ufe0f",
    white_square_button: "\ud83d\udd33",
    wilted_flower: "\ud83e\udd40",
    wind_chime: "\ud83c\udf90",
    wind_face: "\ud83c\udf2c",
    wine_glass: "\ud83c\udf77",
    wink: "\ud83d\ude09",
    wolf: "\ud83d\udc3a",
    woman: "\ud83d\udc69",
    woman_artist: "\ud83d\udc69&zwj;\ud83c\udfa8",
    woman_astronaut: "\ud83d\udc69&zwj;\ud83d\ude80",
    woman_cartwheeling: "\ud83e\udd38&zwj;\u2640\ufe0f",
    woman_cook: "\ud83d\udc69&zwj;\ud83c\udf73",
    woman_facepalming: "\ud83e\udd26&zwj;\u2640\ufe0f",
    woman_factory_worker: "\ud83d\udc69&zwj;\ud83c\udfed",
    woman_farmer: "\ud83d\udc69&zwj;\ud83c\udf3e",
    woman_firefighter: "\ud83d\udc69&zwj;\ud83d\ude92",
    woman_health_worker: "\ud83d\udc69&zwj;\u2695\ufe0f",
    woman_judge: "\ud83d\udc69&zwj;\u2696\ufe0f",
    woman_juggling: "\ud83e\udd39&zwj;\u2640\ufe0f",
    woman_mechanic: "\ud83d\udc69&zwj;\ud83d\udd27",
    woman_office_worker: "\ud83d\udc69&zwj;\ud83d\udcbc",
    woman_pilot: "\ud83d\udc69&zwj;\u2708\ufe0f",
    woman_playing_handball: "\ud83e\udd3e&zwj;\u2640\ufe0f",
    woman_playing_water_polo: "\ud83e\udd3d&zwj;\u2640\ufe0f",
    woman_scientist: "\ud83d\udc69&zwj;\ud83d\udd2c",
    woman_shrugging: "\ud83e\udd37&zwj;\u2640\ufe0f",
    woman_singer: "\ud83d\udc69&zwj;\ud83c\udfa4",
    woman_student: "\ud83d\udc69&zwj;\ud83c\udf93",
    woman_teacher: "\ud83d\udc69&zwj;\ud83c\udfeb",
    woman_technologist: "\ud83d\udc69&zwj;\ud83d\udcbb",
    woman_with_turban: "\ud83d\udc73&zwj;\u2640\ufe0f",
    womans_clothes: "\ud83d\udc5a",
    womans_hat: "\ud83d\udc52",
    women_wrestling: "\ud83e\udd3c&zwj;\u2640\ufe0f",
    womens: "\ud83d\udeba",
    world_map: "\ud83d\uddfa",
    worried: "\ud83d\ude1f",
    wrench: "\ud83d\udd27",
    writing_hand: "\u270d\ufe0f",
    x: "\u274c",
    yellow_heart: "\ud83d\udc9b",
    yen: "\ud83d\udcb4",
    yin_yang: "\u262f\ufe0f",
    yum: "\ud83d\ude0b",
    zap: "\u26a1\ufe0f",
    zipper_mouth_face: "\ud83e\udd10",
    zzz: "\ud83d\udca4",
    octocat: '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
    showdown: "<span style=\"font-family: 'Anonymous Pro', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;\">S</span>"
  }, L.Converter = function (n) {
    var a = {}, i = [], s = [], l = {}, r = A, o = {parsed: {}, raw: "", format: ""};

    function c(e, t) {
      if (t = t || null, L.helper.isString(e)) {
        if (t = e = L.helper.stdExtName(e), L.extensions[e]) return void function o(e, t) {
          "function" == typeof e && (e = e(new L.Converter));
          L.helper.isArray(e) || (e = [e]);
          var n = S(e, t);
          if (!n.valid) throw Error(n.error);
          for (var r = 0; r < e.length; ++r) switch (e[r].type) {
            case"lang":
              i.push(e[r]);
              break;
            case"output":
              s.push(e[r]);
              break;
            default:
              throw Error("Extension loader error: Type unrecognized!!!")
          }
        }(L.extensions[e], e);
        if (L.helper.isUndefined(_[e])) throw Error('Extension "' + e + '" could not be loaded. It was either not found or is not a valid extension.');
        e = _[e]
      }
      "function" == typeof e && (e = e()), L.helper.isArray(e) || (e = [e]);
      var n = S(e, t);
      if (!n.valid) throw Error(n.error);
      for (var r = 0; r < e.length; ++r) {
        switch (e[r].type) {
          case"lang":
            i.push(e[r]);
            break;
          case"output":
            s.push(e[r])
        }
        if (e[r].hasOwnProperty("listeners")) for (var a in e[r].listeners) e[r].listeners.hasOwnProperty(a) && d(a, e[r].listeners[a])
      }
    }

    function d(e, t) {
      if (!L.helper.isString(e)) throw Error("Invalid argument in converter.listen() method: name must be a string, but " + kt(e) + " given");
      if ("function" != typeof t) throw Error("Invalid argument in converter.listen() method: callback must be a function, but " + kt(t) + " given");
      l.hasOwnProperty(e) || (l[e] = []), l[e].push(t)
    }

    !function f() {
      for (var e in n = n || {}, w) w.hasOwnProperty(e) && (a[e] = w[e]);
      {
        if ("object" !== kt(n)) throw Error("Converter expects the passed parameter to be an object, but " + kt(n) + " was passed instead.");
        for (var t in n) n.hasOwnProperty(t) && (a[t] = n[t])
      }
      a.extensions && L.helper.forEach(a.extensions, c)
    }(), this._dispatch = function (e, t, n, r) {
      if (l.hasOwnProperty(e)) for (var a = 0; a < l[e].length; ++a) {
        var o = l[e][a](e, t, this, n, r);
        o && void 0 !== o && (t = o)
      }
      return t
    }, this.listen = function (e, t) {
      return d(e, t), this
    }, this.makeHtml = function (t) {
      if (!t) return t;
      var n = {
        gHtmlBlocks: [],
        gHtmlMdBlocks: [],
        gHtmlSpans: [],
        gUrls: {},
        gTitles: {},
        gDimensions: {},
        gListLevel: 0,
        hashLinkCounts: {},
        langExtensions: i,
        outputModifiers: s,
        converter: this,
        ghCodeBlocks: [],
        metadata: {parsed: {}, raw: "", format: ""}
      };
      return t = (t = (t = (t = (t = t.replace(/\xa8/g, "\xa8T")).replace(/\$/g, "\xa8D")).replace(/\r\n/g, "\n")).replace(/\r/g, "\n")).replace(/\u00A0/g, "&nbsp;"), a.smartIndentationFix && (t = function r(e) {
        var t = e.match(/^\s*/)[0].length, n = new RegExp("^\\s{0," + t + "}", "gm");
        return e.replace(n, "")
      }(t)), t = "\n\n" + t + "\n\n", t = (t = L.subParser("detab")(t, a, n)).replace(/^[ \t]+$/gm, ""), L.helper.forEach(i, function (e) {
        t = L.subParser("runExtension")(e, t, a, n)
      }), t = L.subParser("metadata")(t, a, n), t = L.subParser("hashPreCodeTags")(t, a, n), t = L.subParser("githubCodeBlocks")(t, a, n), t = L.subParser("hashHTMLBlocks")(t, a, n), t = L.subParser("hashCodeTags")(t, a, n), t = L.subParser("stripLinkDefinitions")(t, a, n), t = L.subParser("blockGamut")(t, a, n), t = L.subParser("unhashHTMLSpans")(t, a, n), t = (t = (t = L.subParser("unescapeSpecialChars")(t, a, n)).replace(/\xa8D/g, "$$")).replace(/\xa8T/g, "\xa8"), t = L.subParser("completeHTMLDocument")(t, a, n), L.helper.forEach(s, function (e) {
        t = L.subParser("runExtension")(e, t, a, n)
      }), o = n.metadata, t
    }, this.makeMarkdown = this.makeMd = function (e, t) {
      if (e = (e = (e = e.replace(/\r\n/g, "\n")).replace(/\r/g, "\n")).replace(/>[ \t]+</, ">\xa8NBSP;<"), !t) {
        if (!window || !window.document) throw new Error("HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM");
        t = window.document
      }
      var n = t.createElement("div");
      n.innerHTML = e;
      var r = {
        preList: function c(e) {
          for (var t = e.querySelectorAll("pre"), n = [], r = 0; r < t.length; ++r) if (1 === t[r].childElementCount && "code" === t[r].firstChild.tagName.toLowerCase()) {
            var a = t[r].firstChild.innerHTML.trim(), o = t[r].firstChild.getAttribute("data-language") || "";
            if ("" === o) for (var i = t[r].firstChild.className.split(" "), s = 0; s < i.length; ++s) {
              var l = i[s].match(/^language-(.+)$/);
              if (null !== l) {
                o = l[1];
                break
              }
            }
            a = L.helper.unescapeHTMLEntities(a), n.push(a), t[r].outerHTML = '<precode language="' + o + '" precodenum="' + r.toString() + '"></precode>'
          } else n.push(t[r].innerHTML), t[r].innerHTML = "", t[r].setAttribute("prenum", r.toString());
          return n
        }(n)
      };
      !function s(e) {
        for (var t = 0; t < e.childNodes.length; ++t) {
          var n = e.childNodes[t];
          3 === n.nodeType ? /\S/.test(n.nodeValue) ? (n.nodeValue = n.nodeValue.split("\n").join(" "), n.nodeValue = n.nodeValue.replace(/(\s)+/g, "$1")) : (e.removeChild(n), --t) : 1 === n.nodeType && s(n)
        }
      }(n);
      for (var a = n.childNodes, o = "", i = 0; i < a.length; i++) o += L.subParser("makeMarkdown.node")(a[i], r);
      return o
    }, this.setOption = function (e, t) {
      a[e] = t
    }, this.getOption = function (e) {
      return a[e]
    }, this.getOptions = function () {
      return a
    }, this.addExtension = function (e, t) {
      c(e, t = t || null)
    }, this.useExtension = function (e) {
      c(e)
    }, this.setFlavor = function (e) {
      if (!T.hasOwnProperty(e)) throw Error(e + " flavor was not found");
      var t = T[e];
      for (var n in r = e, t) t.hasOwnProperty(n) && (a[n] = t[n])
    }, this.getFlavor = function () {
      return r
    }, this.removeExtension = function (e) {
      L.helper.isArray(e) || (e = [e]);
      for (var t = 0; t < e.length; ++t) {
        for (var n = e[t], r = 0; r < i.length; ++r) i[r] === n && i[r].splice(r, 1);
        for (; 0 < s.length; ++r) s[0] === n && s[0].splice(r, 1)
      }
    }, this.getAllExtensions = function () {
      return {language: i, output: s}
    }, this.getMetadata = function (e) {
      return e ? o.raw : o.parsed
    }, this.getMetadataFormat = function () {
      return o.format
    }, this._setMetadataPair = function (e, t) {
      o.parsed[e] = t
    }, this._setMetadataFormat = function (e) {
      o.format = e
    }, this._setMetadataRaw = function (e) {
      o.raw = e
    }
  }, L.subParser("anchors", function (e, l, c) {
    var d = function d(e, t, n, r, a, o, i) {
      if (L.helper.isUndefined(i) && (i = ""), n = n.toLowerCase(), -1 < e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m)) r = ""; else if (!r) {
        if (n || (n = t.toLowerCase().replace(/ ?\n/g, " ")), r = "#" + n, L.helper.isUndefined(c.gUrls[n])) return e;
        r = c.gUrls[n], L.helper.isUndefined(c.gTitles[n]) || (i = c.gTitles[n])
      }
      var s = '<a href="' + (r = r.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"';
      return "" !== i && null !== i && (s += ' title="' + (i = (i = i.replace(/"/g, "&quot;")).replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"'), l.openLinksInNewWindow && !/^#/.test(r) && (s += ' rel="noopener noreferrer" target="\xa8E95Eblank"'), s += ">" + t + "</a>"
    };
    return e = (e = (e = (e = (e = c.converter._dispatch("anchors.before", e, l, c)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, d)).replace(/\[([^\[\]]+)]()()()()()/g, d), l.ghMentions && (e = e.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gim, function (e, t, n, r, a) {
      if ("\\" === n) return t + r;
      if (!L.helper.isString(l.ghMentionsLink)) throw new Error("ghMentionsLink option must be a string");
      var o = l.ghMentionsLink.replace(/\{u}/g, a), i = "";
      return l.openLinksInNewWindow && (i = ' rel="noopener noreferrer" target="\xa8E95Eblank"'), t + '<a href="' + o + '"' + i + ">" + r + "</a>"
    })), e = c.converter._dispatch("anchors.after", e, l, c)
  });
  var R = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,
    M = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,
    O = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,
    N = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gim,
    I = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi, D = function D(p) {
      return function (e, t, n, r, a, o, i) {
        var s = n = n.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback), l = "", c = "",
          d = t || "", f = i || "";
        return /^www\./i.test(n) && (n = n.replace(/^www\./i, "http://www.")), p.excludeTrailingPunctuationFromURLs && o && (l = o), p.openLinksInNewWindow && (c = ' rel="noopener noreferrer" target="\xa8E95Eblank"'), d + '<a href="' + n + '"' + c + ">" + s + "</a>" + l + f
      }
    }, B = function B(a, o) {
      return function (e, t, n) {
        var r = "mailto:";
        return t = t || "", n = L.subParser("unescapeSpecialChars")(n, a, o), a.encodeEmails ? (r = L.helper.encodeEmailAddress(r + n), n = L.helper.encodeEmailAddress(n)) : r += n, t + '<a href="' + r + '">' + n + "</a>"
      }
    };
  return L.subParser("autoLinks", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("autoLinks.before", e, t, n)).replace(O, D(t))).replace(I, B(t, n)), e = n.converter._dispatch("autoLinks.after", e, t, n)
  }), L.subParser("simplifiedAutoLinks", function (e, t, n) {
    return t.simplifiedAutoLink ? (e = n.converter._dispatch("simplifiedAutoLinks.before", e, t, n), e = (e = t.excludeTrailingPunctuationFromURLs ? e.replace(M, D(t)) : e.replace(R, D(t))).replace(N, B(t, n)), e = n.converter._dispatch("simplifiedAutoLinks.after", e, t, n)) : e
  }), L.subParser("blockGamut", function (e, t, n) {
    return e = n.converter._dispatch("blockGamut.before", e, t, n), e = L.subParser("blockQuotes")(e, t, n), e = L.subParser("headers")(e, t, n), e = L.subParser("horizontalRule")(e, t, n), e = L.subParser("lists")(e, t, n), e = L.subParser("codeBlocks")(e, t, n), e = L.subParser("tables")(e, t, n), e = L.subParser("hashHTMLBlocks")(e, t, n), e = L.subParser("paragraphs")(e, t, n), e = n.converter._dispatch("blockGamut.after", e, t, n)
  }), L.subParser("blockQuotes", function (e, t, n) {
    e = n.converter._dispatch("blockQuotes.before", e, t, n), e += "\n\n";
    var r = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;
    return t.splitAdjacentBlockquotes && (r = /^ {0,3}>[\s\S]*?(?:\n\n)/gm), e = e.replace(r, function (e) {
      return e = (e = (e = e.replace(/^[ \t]*>[ \t]?/gm, "")).replace(/\xa80/g, "")).replace(/^[ \t]+$/gm, ""), e = L.subParser("githubCodeBlocks")(e, t, n), e = (e = (e = L.subParser("blockGamut")(e, t, n)).replace(/(^|\n)/g, "$1  ")).replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (e, t) {
        var n = t;
        return n = (n = n.replace(/^ {2}/gm, "\xa80")).replace(/\xa80/g, "")
      }), L.subParser("hashBlock")("<blockquote>\n" + e + "\n</blockquote>", t, n)
    }), e = n.converter._dispatch("blockQuotes.after", e, t, n)
  }), L.subParser("codeBlocks", function (e, i, s) {
    e = s.converter._dispatch("codeBlocks.before", e, i, s);
    return e = (e = (e += "\xa80").replace(/(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=\xa80))/g, function (e, t, n) {
      var r = t, a = n, o = "\n";
      return r = L.subParser("outdent")(r, i, s), r = L.subParser("encodeCode")(r, i, s), r = (r = (r = L.subParser("detab")(r, i, s)).replace(/^\n+/g, "")).replace(/\n+$/g, ""), i.omitExtraWLInCodeBlocks && (o = ""), r = "<pre><code>" + r + o + "</code></pre>", L.subParser("hashBlock")(r, i, s) + a
    })).replace(/\xa80/, ""), e = s.converter._dispatch("codeBlocks.after", e, i, s)
  }), L.subParser("codeSpans", function (e, o, i) {
    return void 0 === (e = i.converter._dispatch("codeSpans.before", e, o, i)) && (e = ""), e = e.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function (e, t, n, r) {
      var a = r;
      return a = (a = a.replace(/^([ \t]*)/g, "")).replace(/[ \t]*$/g, ""), a = t + "<code>" + (a = L.subParser("encodeCode")(a, o, i)) + "</code>", a = L.subParser("hashHTMLSpans")(a, o, i)
    }), e = i.converter._dispatch("codeSpans.after", e, o, i)
  }), L.subParser("completeHTMLDocument", function (e, t, n) {
    if (!t.completeHTMLDocument) return e;
    e = n.converter._dispatch("completeHTMLDocument.before", e, t, n);
    var r = "html", a = "<!DOCTYPE HTML>\n", o = "", i = '<meta charset="utf-8">\n', s = "", l = "";
    for (var c in "undefined" != typeof n.metadata.parsed.doctype && (a = "<!DOCTYPE " + n.metadata.parsed.doctype + ">\n", "html" !== (r = n.metadata.parsed.doctype.toString().toLowerCase()) && "html5" !== r || (i = '<meta charset="utf-8">')), n.metadata.parsed) if (n.metadata.parsed.hasOwnProperty(c)) switch (c.toLowerCase()) {
      case"doctype":
        break;
      case"title":
        o = "<title>" + n.metadata.parsed.title + "</title>\n";
        break;
      case"charset":
        i = "html" === r || "html5" === r ? '<meta charset="' + n.metadata.parsed.charset + '">\n' : '<meta name="charset" content="' + n.metadata.parsed.charset + '">\n';
        break;
      case"language":
      case"lang":
        s = ' lang="' + n.metadata.parsed[c] + '"', l += '<meta name="' + c + '" content="' + n.metadata.parsed[c] + '">\n';
        break;
      default:
        l += '<meta name="' + c + '" content="' + n.metadata.parsed[c] + '">\n'
    }
    return e = a + "<html" + s + ">\n<head>\n" + o + i + l + "</head>\n<body>\n" + e.trim() + "\n</body>\n</html>", e = n.converter._dispatch("completeHTMLDocument.after", e, t, n)
  }), L.subParser("detab", function (e, t, n) {
    return e = (e = (e = (e = (e = (e = n.converter._dispatch("detab.before", e, t, n)).replace(/\t(?=\t)/g, "    ")).replace(/\t/g, "\xa8A\xa8B")).replace(/\xa8B(.+?)\xa8A/g, function (e, t) {
      for (var n = t, r = 4 - n.length % 4, a = 0; a < r; a++) n += " ";
      return n
    })).replace(/\xa8A/g, "    ")).replace(/\xa8B/g, ""), e = n.converter._dispatch("detab.after", e, t, n)
  }), L.subParser("ellipsis", function (e, t, n) {
    return e = (e = n.converter._dispatch("ellipsis.before", e, t, n)).replace(/\.\.\./g, "\u2026"), e = n.converter._dispatch("ellipsis.after", e, t, n)
  }), L.subParser("emoji", function (e, t, n) {
    if (!t.emoji) return e;
    return e = (e = n.converter._dispatch("emoji.before", e, t, n)).replace(/:([\S]+?):/g, function (e, t) {
      return L.helper.emojis.hasOwnProperty(t) ? L.helper.emojis[t] : e
    }), e = n.converter._dispatch("emoji.after", e, t, n)
  }), L.subParser("encodeAmpsAndAngles", function (e, t, n) {
    return e = (e = (e = (e = (e = n.converter._dispatch("encodeAmpsAndAngles.before", e, t, n)).replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, "&amp;")).replace(/<(?![a-z\/?$!])/gi, "&lt;")).replace(/</g, "&lt;")).replace(/>/g, "&gt;"), e = n.converter._dispatch("encodeAmpsAndAngles.after", e, t, n)
  }), L.subParser("encodeBackslashEscapes", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("encodeBackslashEscapes.before", e, t, n)).replace(/\\(\\)/g, L.helper.escapeCharactersCallback)).replace(/\\([`*_{}\[\]()>#+.!~=|-])/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("encodeBackslashEscapes.after", e, t, n)
  }), L.subParser("encodeCode", function (e, t, n) {
    return e = (e = n.converter._dispatch("encodeCode.before", e, t, n)).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/([*_{}\[\]\\=~-])/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("encodeCode.after", e, t, n)
  }), L.subParser("escapeSpecialCharsWithinTagAttributes", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("escapeSpecialCharsWithinTagAttributes.before", e, t, n)).replace(/<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi, function (e) {
      return e.replace(/(.)<\/?code>(?=.)/g, "$1`").replace(/([\\`*_~=|])/g, L.helper.escapeCharactersCallback)
    })).replace(/<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi, function (e) {
      return e.replace(/([\\`*_~=|])/g, L.helper.escapeCharactersCallback)
    }), e = n.converter._dispatch("escapeSpecialCharsWithinTagAttributes.after", e, t, n)
  }), L.subParser("githubCodeBlocks", function (e, o, i) {
    return o.ghCodeBlocks ? (e = i.converter._dispatch("githubCodeBlocks.before", e, o, i), e = (e = (e += "\xa80").replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function (e, t, n, r) {
      var a = o.omitExtraWLInCodeBlocks ? "" : "\n";
      return r = L.subParser("encodeCode")(r, o, i), r = "<pre><code" + (n ? ' class="' + n + " language-" + n + '"' : "") + ">" + (r = (r = (r = L.subParser("detab")(r, o, i)).replace(/^\n+/g, "")).replace(/\n+$/g, "")) + a + "</code></pre>", r = L.subParser("hashBlock")(r, o, i), "\n\n\xa8G" + (i.ghCodeBlocks.push({
        text: e,
        codeblock: r
      }) - 1) + "G\n\n"
    })).replace(/\xa80/, ""), i.converter._dispatch("githubCodeBlocks.after", e, o, i)) : e
  }), L.subParser("hashBlock", function (e, t, n) {
    return e = (e = n.converter._dispatch("hashBlock.before", e, t, n)).replace(/(^\n+|\n+$)/g, ""), e = "\n\n\xa8K" + (n.gHtmlBlocks.push(e) - 1) + "K\n\n", e = n.converter._dispatch("hashBlock.after", e, t, n)
  }), L.subParser("hashCodeTags", function (e, o, i) {
    e = i.converter._dispatch("hashCodeTags.before", e, o, i);
    var s = function s(e, t, n, r) {
      var a = n + L.subParser("encodeCode")(t, o, i) + r;
      return "\xa8C" + (i.gHtmlSpans.push(a) - 1) + "C"
    };
    return e = L.helper.replaceRecursiveRegExp(e, s, "<code\\b[^>]*>", "</code>", "gim"), e = i.converter._dispatch("hashCodeTags.after", e, o, i)
  }), L.subParser("hashElement", function (e, t, r) {
    return function (e, t) {
      var n = t;
      return n = (n = (n = n.replace(/\n\n/g, "\n")).replace(/^\n/, "")).replace(/\n+$/g, ""), n = "\n\n\xa8K" + (r.gHtmlBlocks.push(n) - 1) + "K\n\n"
    }
  }), L.subParser("hashHTMLBlocks", function (e, t, o) {
    e = o.converter._dispatch("hashHTMLBlocks.before", e, t, o);
    var n = ["pre", "div", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "table", "dl", "ol", "ul", "script", "noscript", "form", "fieldset", "iframe", "math", "style", "section", "header", "footer", "nav", "article", "aside", "address", "audio", "canvas", "figure", "hgroup", "output", "video", "p"],
      i = function i(e, t, n, r) {
        var a = e;
        return -1 !== n.search(/\bmarkdown\b/) && (a = n + o.converter.makeHtml(t) + r), "\n\n\xa8K" + (o.gHtmlBlocks.push(a) - 1) + "K\n\n"
      };
    t.backslashEscapesHTMLTags && (e = e.replace(/\\<(\/?[^>]+?)>/g, function (e, t) {
      return "&lt;" + t + "&gt;"
    }));
    for (var r = 0; r < n.length; ++r) for (var a, s = new RegExp("^ {0,3}(<" + n[r] + "\\b[^>]*>)", "im"), l = "<" + n[r] + "\\b[^>]*>", c = "</" + n[r] + ">"; -1 !== (a = L.helper.regexIndexOf(e, s));) {
      var d = L.helper.splitAtIndex(e, a), f = L.helper.replaceRecursiveRegExp(d[1], i, l, c, "im");
      if (f === d[1]) break;
      e = d[0].concat(f)
    }
    return e = e.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, L.subParser("hashElement")(e, t, o)), e = (e = L.helper.replaceRecursiveRegExp(e, function (e) {
      return "\n\n\xa8K" + (o.gHtmlBlocks.push(e) - 1) + "K\n\n"
    }, "^ {0,3}\x3c!--", "--\x3e", "gm")).replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, L.subParser("hashElement")(e, t, o)), e = o.converter._dispatch("hashHTMLBlocks.after", e, t, o)
  }), L.subParser("hashHTMLSpans", function (e, t, n) {
    function r(e) {
      return "\xa8C" + (n.gHtmlSpans.push(e) - 1) + "C"
    }

    return e = (e = (e = (e = (e = n.converter._dispatch("hashHTMLSpans.before", e, t, n)).replace(/<[^>]+?\/>/gi, function (e) {
      return r(e)
    })).replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function (e) {
      return r(e)
    })).replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function (e) {
      return r(e)
    })).replace(/<[^>]+?>/gi, function (e) {
      return r(e)
    }), e = n.converter._dispatch("hashHTMLSpans.after", e, t, n)
  }), L.subParser("unhashHTMLSpans", function (e, t, n) {
    e = n.converter._dispatch("unhashHTMLSpans.before", e, t, n);
    for (var r = 0; r < n.gHtmlSpans.length; ++r) {
      for (var a = n.gHtmlSpans[r], o = 0; /\xa8C(\d+)C/.test(a);) {
        var i = RegExp.$1;
        if (a = a.replace("\xa8C" + i + "C", n.gHtmlSpans[i]), 10 === o) break;
        ++o
      }
      e = e.replace("\xa8C" + r + "C", a)
    }
    return e = n.converter._dispatch("unhashHTMLSpans.after", e, t, n)
  }), L.subParser("hashPreCodeTags", function (e, o, i) {
    e = i.converter._dispatch("hashPreCodeTags.before", e, o, i);
    var s = function s(e, t, n, r) {
      var a = n + L.subParser("encodeCode")(t, o, i) + r;
      return "\n\n\xa8G" + (i.ghCodeBlocks.push({text: e, codeblock: a}) - 1) + "G\n\n"
    };
    return e = L.helper.replaceRecursiveRegExp(e, s, "^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>", "^ {0,3}</code>\\s*</pre>", "gim"), e = i.converter._dispatch("hashPreCodeTags.after", e, o, i)
  }), L.subParser("headers", function (e, l, c) {
    e = c.converter._dispatch("headers.before", e, l, c);
    var d = isNaN(parseInt(l.headerLevelStart)) ? 1 : parseInt(l.headerLevelStart),
      t = l.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
      n = l.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
    e = (e = e.replace(t, function (e, t) {
      var n = L.subParser("spanGamut")(t, l, c), r = l.noHeaderId ? "" : ' id="' + f(t) + '"',
        a = "<h" + d + r + ">" + n + "</h" + d + ">";
      return L.subParser("hashBlock")(a, l, c)
    })).replace(n, function (e, t) {
      var n = L.subParser("spanGamut")(t, l, c), r = l.noHeaderId ? "" : ' id="' + f(t) + '"', a = d + 1,
        o = "<h" + a + r + ">" + n + "</h" + a + ">";
      return L.subParser("hashBlock")(o, l, c)
    });
    var r = l.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;

    function f(e) {
      var t, n;
      if (l.customizedHeaderId) {
        var r = e.match(/\{([^{]+?)}\s*$/);
        r && r[1] && (e = r[1])
      }
      return t = e, n = L.helper.isString(l.prefixHeaderId) ? l.prefixHeaderId : !0 === l.prefixHeaderId ? "section-" : "", l.rawPrefixHeaderId || (t = n + t), t = l.ghCompatibleHeaderId ? t.replace(/ /g, "-").replace(/&amp;/g, "").replace(/\xa8T/g, "").replace(/\xa8D/g, "").replace(/[&+$,\/:;=?@"#{}|^\xa8~\[\]`\\*)(%.!'<>]/g, "").toLowerCase() : l.rawHeaderId ? t.replace(/ /g, "-").replace(/&amp;/g, "&").replace(/\xa8T/g, "\xa8").replace(/\xa8D/g, "$").replace(/["']/g, "-").toLowerCase() : t.replace(/[^\w]/g, "").toLowerCase(), l.rawPrefixHeaderId && (t = n + t), c.hashLinkCounts[t] ? t = t + "-" + c.hashLinkCounts[t]++ : c.hashLinkCounts[t] = 1, t
    }

    return e = e.replace(r, function (e, t, n) {
      var r = n;
      l.customizedHeaderId && (r = n.replace(/\s?\{([^{]+?)}\s*$/, ""));
      var a = L.subParser("spanGamut")(r, l, c), o = l.noHeaderId ? "" : ' id="' + f(n) + '"', i = d - 1 + t.length,
        s = "<h" + i + o + ">" + a + "</h" + i + ">";
      return L.subParser("hashBlock")(s, l, c)
    }), e = c.converter._dispatch("headers.after", e, l, c)
  }), L.subParser("horizontalRule", function (e, t, n) {
    e = n.converter._dispatch("horizontalRule.before", e, t, n);
    var r = L.subParser("hashBlock")("<hr />", t, n);
    return e = (e = (e = e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, r)).replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, r)).replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, r), e = n.converter._dispatch("horizontalRule.after", e, t, n)
  }), L.subParser("images", function (e, t, p) {
    function l(e, t, n, r, a, o, i, s) {
      var l = p.gUrls, c = p.gTitles, d = p.gDimensions;
      if (n = n.toLowerCase(), s || (s = ""), -1 < e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m)) r = ""; else if ("" === r || null === r) {
        if ("" !== n && null !== n || (n = t.toLowerCase().replace(/ ?\n/g, " ")), r = "#" + n, L.helper.isUndefined(l[n])) return e;
        r = l[n], L.helper.isUndefined(c[n]) || (s = c[n]), L.helper.isUndefined(d[n]) || (a = d[n].width, o = d[n].height)
      }
      t = t.replace(/"/g, "&quot;").replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback);
      var f = '<img src="' + (r = r.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '" alt="' + t + '"';
      return s && L.helper.isString(s) && (f += ' title="' + (s = s.replace(/"/g, "&quot;").replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"'), a && o && (f += ' width="' + (a = "*" === a ? "auto" : a) + '"', f += ' height="' + (o = "*" === o ? "auto" : o) + '"'), f += " />"
    }

    return e = (e = (e = (e = (e = (e = p.converter._dispatch("images.before", e, t, p)).replace(/!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g, l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, function c(e, t, n, r, a, o, i, s) {
      return l(e, t, n, r = r.replace(/\s/g, ""), a, o, 0, s)
    })).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g, l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, l)).replace(/!\[([^\[\]]+)]()()()()()/g, l), e = p.converter._dispatch("images.after", e, t, p)
  }), L.subParser("italicsAndBold", function (e, t, n) {
    function r(e, t, n) {
      return t + e + n
    }

    return e = n.converter._dispatch("italicsAndBold.before", e, t, n), e = t.literalMidWordUnderscores ? (e = (e = e.replace(/\b___(\S[\s\S]*?)___\b/g, function (e, t) {
      return r(t, "<strong><em>", "</em></strong>")
    })).replace(/\b__(\S[\s\S]*?)__\b/g, function (e, t) {
      return r(t, "<strong>", "</strong>")
    })).replace(/\b_(\S[\s\S]*?)_\b/g, function (e, t) {
      return r(t, "<em>", "</em>")
    }) : (e = (e = e.replace(/___(\S[\s\S]*?)___/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong><em>", "</em></strong>") : e
    })).replace(/__(\S[\s\S]*?)__/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong>", "</strong>") : e
    })).replace(/_([^\s_][\s\S]*?)_/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<em>", "</em>") : e
    }), e = t.literalMidWordAsterisks ? (e = (e = e.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<strong><em>", "</em></strong>")
    })).replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<strong>", "</strong>")
    })).replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<em>", "</em>")
    }) : (e = (e = e.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong><em>", "</em></strong>") : e
    })).replace(/\*\*(\S[\s\S]*?)\*\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong>", "</strong>") : e
    })).replace(/\*([^\s*][\s\S]*?)\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<em>", "</em>") : e
    }), e = n.converter._dispatch("italicsAndBold.after", e, t, n)
  }), L.subParser("lists", function (e, p, d) {
    function u(e, t) {
      d.gListLevel++, e = e.replace(/\n{2,}$/, "\n");
      var n = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
        c = /\n[ \t]*\n(?!\xa80)/.test(e += "\xa80");
      return p.disableForced4SpacesIndentedSublists && (n = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80|\2([*+-]|\d+[.])[ \t]+))/gm), e = (e = e.replace(n, function (e, t, n, r, a, o, i) {
        i = i && "" !== i.trim();
        var s = L.subParser("outdent")(a, p, d), l = "";
        return o && p.tasklists && (l = ' class="task-list-item" style="list-style-type: none;"', s = s.replace(/^[ \t]*\[(x|X| )?]/m, function () {
          var e = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
          return i && (e += " checked"), e += ">"
        })), s = s.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (e) {
          return "\xa8A" + e
        }), s = "<li" + l + ">" + (s = (s = t || -1 < s.search(/\n{2,}/) ? (s = L.subParser("githubCodeBlocks")(s, p, d), L.subParser("blockGamut")(s, p, d)) : (s = (s = L.subParser("lists")(s, p, d)).replace(/\n$/, ""), s = (s = L.subParser("hashHTMLBlocks")(s, p, d)).replace(/\n\n+/g, "\n\n"), c ? L.subParser("paragraphs")(s, p, d) : L.subParser("spanGamut")(s, p, d))).replace("\xa8A", "")) + "</li>\n"
      })).replace(/\xa80/g, ""), d.gListLevel--, t && (e = e.replace(/\s+$/, "")), e
    }

    function h(e, t) {
      if ("ol" === t) {
        var n = e.match(/^ *(\d+)\./);
        if (n && "1" !== n[1]) return ' start="' + n[1] + '"'
      }
      return ""
    }

    function a(r, a, o) {
      var i = p.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm,
        s = p.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm, l = "ul" === a ? i : s,
        c = "",
        d = "ul" === a ? " style='list-style: disc !important;padding: 0px 0px 0px 40px !important;'" : " style='list-style: decimal !important;padding: 0px 0px 0px 40px !important;'";
      if (-1 !== r.search(l)) !function f(e) {
        var t = e.search(l), n = h(r, a);
        -1 !== t ? (c += "\n\n<" + a + d + n + ">\n" + u(e.slice(0, t), !!o) + "</" + a + ">\n", l = "ul" === (a = "ul" === a ? "ol" : "ul") ? i : s, f(e.slice(t))) : c += "\n\n<" + a + d + n + ">\n" + u(e, !!o) + "</" + a + ">\n"
      }(r); else {
        var e = h(r, a);
        c = "\n\n<" + a + d + e + ">\n" + u(r, !!o) + "</" + a + ">\n"
      }
      return c
    }

    return e = d.converter._dispatch("lists.before", e, p, d), e += "\xa80", e = (e = d.gListLevel ? e.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (e, t, n) {
      return a(t, -1 < n.search(/[*+-]/g) ? "ul" : "ol", !0)
    }) : e.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (e, t, n, r) {
      return a(n, -1 < r.search(/[*+-]/g) ? "ul" : "ol", !1)
    })).replace(/\xa80/, ""), e = d.converter._dispatch("lists.after", e, p, d)
  }), L.subParser("metadata", function (e, t, r) {
    if (!t.metadata) return e;

    function a(e) {
      (e = (e = (r.metadata.raw = e).replace(/&/g, "&amp;").replace(/"/g, "&quot;")).replace(/\n {4}/g, " ")).replace(/^([\S ]+): +([\s\S]+?)$/gm, function (e, t, n) {
        return r.metadata.parsed[t] = n, ""
      })
    }

    return e = (e = (e = (e = r.converter._dispatch("metadata.before", e, t, r)).replace(/^\s*\xab\xab\xab+(\S*?)\n([\s\S]+?)\n\xbb\xbb\xbb+\n/, function (e, t, n) {
      return a(n), "\xa8M"
    })).replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function (e, t, n) {
      return t && (r.metadata.format = t), a(n), "\xa8M"
    })).replace(/\xa8M/g, ""), e = r.converter._dispatch("metadata.after", e, t, r)
  }), L.subParser("outdent", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("outdent.before", e, t, n)).replace(/^(\t|[ ]{1,4})/gm, "\xa80")).replace(/\xa80/g, ""), e = n.converter._dispatch("outdent.after", e, t, n)
  }), L.subParser("paragraphs", function (e, t, n) {
    for (var r = (e = (e = (e = n.converter._dispatch("paragraphs.before", e, t, n)).replace(/^\n+/g, "")).replace(/\n+$/g, "")).split(/\n{2,}/g), a = [], o = r.length, i = 0; i < o; i++) {
      var s = r[i];
      0 <= s.search(/\xa8(K|G)(\d+)\1/g) ? a.push(s) : 0 <= s.search(/\S/) && (s = (s = L.subParser("spanGamut")(s, t, n)).replace(/^([ \t]*)/g, "<p>"), s += "</p>", a.push(s))
    }
    for (o = a.length, i = 0; i < o; i++) {
      for (var l = "", c = a[i], d = !1; /\xa8(K|G)(\d+)\1/.test(c);) {
        var f = RegExp.$1, p = RegExp.$2;
        l = (l = "K" === f ? n.gHtmlBlocks[p] : d ? L.subParser("encodeCode")(n.ghCodeBlocks[p].text, t, n) : n.ghCodeBlocks[p].codeblock).replace(/\$/g, "$$$$"), c = c.replace(/(\n\n)?\xa8(K|G)\d+\2(\n\n)?/, l), /^<pre\b[^>]*>\s*<code\b[^>]*>/.test(c) && (d = !0)
      }
      a[i] = c
    }
    return e = (e = (e = a.join("\n")).replace(/^\n+/g, "")).replace(/\n+$/g, ""), n.converter._dispatch("paragraphs.after", e, t, n)
  }), L.subParser("runExtension", function (e, t, n, r) {
    if (e.filter) t = e.filter(t, r.converter, n); else if (e.regex) {
      var a = e.regex;
      a instanceof RegExp || (a = new RegExp(a, "g")), t = t.replace(a, e.replace)
    }
    return t
  }), L.subParser("spanGamut", function (e, t, n) {
    return e = n.converter._dispatch("spanGamut.before", e, t, n), e = L.subParser("codeSpans")(e, t, n), e = L.subParser("escapeSpecialCharsWithinTagAttributes")(e, t, n), e = L.subParser("encodeBackslashEscapes")(e, t, n), e = L.subParser("images")(e, t, n), e = L.subParser("anchors")(e, t, n), e = L.subParser("autoLinks")(e, t, n), e = L.subParser("simplifiedAutoLinks")(e, t, n), e = L.subParser("emoji")(e, t, n), e = L.subParser("underline")(e, t, n), e = L.subParser("italicsAndBold")(e, t, n), e = L.subParser("strikethrough")(e, t, n), e = L.subParser("ellipsis")(e, t, n), e = L.subParser("hashHTMLSpans")(e, t, n), e = L.subParser("encodeAmpsAndAngles")(e, t, n), t.simpleLineBreaks ? /\n\n\xa8K/.test(e) || (e = e.replace(/\n+/g, "<br />\n")) : e = e.replace(/  +\n/g, "<br />\n"), e = n.converter._dispatch("spanGamut.after", e, t, n)
  }), L.subParser("strikethrough", function (e, r, a) {
    return r.strikethrough && (e = (e = a.converter._dispatch("strikethrough.before", e, r, a)).replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function (e, t) {
      return function n(e) {
        return r.simplifiedAutoLink && (e = L.subParser("simplifiedAutoLinks")(e, r, a)), "<del>" + e + "</del>"
      }(t)
    }), e = a.converter._dispatch("strikethrough.after", e, r, a)), e
  }), L.subParser("stripLinkDefinitions", function (e, s, l) {
    var c = function c(e, t, n, r, a, o, i) {
      return t = t.toLowerCase(), n.match(/^data:.+?\/.+?;base64,/) ? l.gUrls[t] = n.replace(/\s/g, "") : l.gUrls[t] = L.subParser("encodeAmpsAndAngles")(n, s, l), o ? o + i : (i && (l.gTitles[t] = i.replace(/"|'/g, "&quot;")), s.parseImgDimensions && r && a && (l.gDimensions[t] = {
        width: r,
        height: a
      }), "")
    };
    return e = (e = (e = (e += "\xa80").replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=\xa80)|(?=\n\[))/gm, c)).replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=\xa80))/gm, c)).replace(/\xa80/, "")
  }), L.subParser("tables", function (e, v, b) {
    if (!v.tables) return e;

    function t(e) {
      var t, n = e.split("\n");
      for (t = 0; t < n.length; ++t) /^ {0,3}\|/.test(n[t]) && (n[t] = n[t].replace(/^ {0,3}\|/, "")), /\|[ \t]*$/.test(n[t]) && (n[t] = n[t].replace(/\|[ \t]*$/, "")), n[t] = L.subParser("codeSpans")(n[t], v, b);
      var r, a, o, i, s, l = n[0].split("|").map(function (e) {
        return e.trim()
      }), c = n[1].split("|").map(function (e) {
        return e.trim()
      }), d = [], f = [], p = [], u = [];
      for (n.shift(), n.shift(), t = 0; t < n.length; ++t) "" !== n[t].trim() && d.push(n[t].split("|").map(function (e) {
        return e.trim()
      }));
      if (l.length < c.length) return e;
      for (t = 0; t < c.length; ++t) p.push((r = c[t], /^:[ \t]*--*$/.test(r) ? ' style="text-align:left;"' : /^--*[ \t]*:[ \t]*$/.test(r) ? ' style="text-align:right;"' : /^:[ \t]*--*[ \t]*:$/.test(r) ? ' style="text-align:center;"' : ""));
      for (t = 0; t < l.length; ++t) L.helper.isUndefined(p[t]) && (p[t] = ""), f.push((a = l[t], o = p[t], i = void 0, i = "", a = a.trim(), (v.tablesHeaderId || v.tableHeaderId) && (i = ' id="' + a.replace(/ /g, "_").toLowerCase() + '"'), "<th" + i + o + ">" + (a = L.subParser("spanGamut")(a, v, b)) + "</th>\n"));
      for (t = 0; t < d.length; ++t) {
        for (var h = [], g = 0; g < f.length; ++g) L.helper.isUndefined(d[t][g]), h.push((s = d[t][g], "<td" + p[g] + ">" + L.subParser("spanGamut")(s, v, b) + "</td>\n"));
        u.push(h)
      }
      return function m(e, t) {
        for (var n = "<table>\n<thead>\n<tr>\n", r = e.length, a = 0; a < r; ++a) n += e[a];
        for (n += "</tr>\n</thead>\n<tbody>\n", a = 0; a < t.length; ++a) {
          n += "<tr>\n";
          for (var o = 0; o < r; ++o) n += t[a][o];
          n += "</tr>\n"
        }
        return n += "</tbody>\n</table>\n"
      }(f, u)
    }

    return e = (e = (e = (e = b.converter._dispatch("tables.before", e, v, b)).replace(/\\(\|)/g, L.helper.escapeCharactersCallback)).replace(/^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|\xa80)/gm, t)).replace(/^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|\xa80)/gm, t), e = b.converter._dispatch("tables.after", e, v, b)
  }), L.subParser("underline", function (e, t, n) {
    return t.underline ? (e = n.converter._dispatch("underline.before", e, t, n), e = (e = t.literalMidWordUnderscores ? (e = e.replace(/\b___(\S[\s\S]*?)___\b/g, function (e, t) {
      return "<u>" + t + "</u>"
    })).replace(/\b__(\S[\s\S]*?)__\b/g, function (e, t) {
      return "<u>" + t + "</u>"
    }) : (e = e.replace(/___(\S[\s\S]*?)___/g, function (e, t) {
      return /\S$/.test(t) ? "<u>" + t + "</u>" : e
    })).replace(/__(\S[\s\S]*?)__/g, function (e, t) {
      return /\S$/.test(t) ? "<u>" + t + "</u>" : e
    })).replace(/(_)/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("underline.after", e, t, n)) : e
  }), L.subParser("unescapeSpecialChars", function (e, t, n) {
    return e = (e = n.converter._dispatch("unescapeSpecialChars.before", e, t, n)).replace(/\xa8E(\d+)E/g, function (e, t) {
      var n = parseInt(t);
      return String.fromCharCode(n)
    }), e = n.converter._dispatch("unescapeSpecialChars.after", e, t, n)
  }), L.subParser("makeMarkdown.blockquote", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) {
      var i = L.subParser("makeMarkdown.node")(r[o], t);
      "" !== i && (n += i)
    }
    return n = "> " + (n = n.trim()).split("\n").join("\n> ")
  }), L.subParser("makeMarkdown.codeBlock", function (e, t) {
    var n = e.getAttribute("language"), r = e.getAttribute("precodenum");
    return "```" + n + "\n" + t.preList[r] + "\n```"
  }), L.subParser("makeMarkdown.codeSpan", function (e) {
    return "`" + e.innerHTML + "`"
  }), L.subParser("makeMarkdown.emphasis", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "*";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "*"
    }
    return n
  }), L.subParser("makeMarkdown.header", function (e, t, n) {
    var r = new Array(n + 1).join("#"), a = "";
    if (e.hasChildNodes()) {
      a = r + " ";
      for (var o = e.childNodes, i = o.length, s = 0; s < i; ++s) a += L.subParser("makeMarkdown.node")(o[s], t)
    }
    return a
  }), L.subParser("makeMarkdown.hr", function () {
    return "---"
  }), L.subParser("makeMarkdown.image", function (e) {
    var t = "";
    return e.hasAttribute("src") && (t += "![" + e.getAttribute("alt") + "](", t += "<" + e.getAttribute("src") + ">", e.hasAttribute("width") && e.hasAttribute("height") && (t += " =" + e.getAttribute("width") + "x" + e.getAttribute("height")), e.hasAttribute("title") && (t += ' "' + e.getAttribute("title") + '"'), t += ")"), t
  }), L.subParser("makeMarkdown.links", function (e, t) {
    var n = "";
    if (e.hasChildNodes() && e.hasAttribute("href")) {
      var r = e.childNodes, a = r.length;
      n = "[";
      for (var o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "](", n += "<" + e.getAttribute("href") + ">", e.hasAttribute("title") && (n += ' "' + e.getAttribute("title") + '"'), n += ")"
    }
    return n
  }), L.subParser("makeMarkdown.list", function (e, t, n) {
    var r = "";
    if (!e.hasChildNodes()) return "";
    for (var a = e.childNodes, o = a.length, i = e.getAttribute("start") || 1, s = 0; s < o; ++s) if ("undefined" != typeof a[s].tagName && "li" === a[s].tagName.toLowerCase()) {
      r += ("ol" === n ? i.toString() + ". " : "- ") + L.subParser("makeMarkdown.listItem")(a[s], t), ++i
    }
    return (r += "\n\x3c!-- --\x3e\n").trim()
  }), L.subParser("makeMarkdown.listItem", function (e, t) {
    for (var n = "", r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
    return /\n$/.test(n) ? n = n.split("\n").join("\n    ").replace(/^ {4}$/gm, "").replace(/\n\n+/g, "\n\n") : n += "\n", n
  }), L.subParser("makeMarkdown.node", function (e, t, n) {
    n = n || !1;
    var r = "";
    if (3 === e.nodeType) return L.subParser("makeMarkdown.txt")(e, t);
    if (8 === e.nodeType) return "\x3c!--" + e.data + "--\x3e\n\n";
    if (1 !== e.nodeType) return "";
    switch (e.tagName.toLowerCase()) {
      case"h1":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 1) + "\n\n");
        break;
      case"h2":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 2) + "\n\n");
        break;
      case"h3":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 3) + "\n\n");
        break;
      case"h4":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 4) + "\n\n");
        break;
      case"h5":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 5) + "\n\n");
        break;
      case"h6":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 6) + "\n\n");
        break;
      case"p":
        n || (r = L.subParser("makeMarkdown.paragraph")(e, t) + "\n\n");
        break;
      case"blockquote":
        n || (r = L.subParser("makeMarkdown.blockquote")(e, t) + "\n\n");
        break;
      case"hr":
        n || (r = L.subParser("makeMarkdown.hr")(e, t) + "\n\n");
        break;
      case"ol":
        n || (r = L.subParser("makeMarkdown.list")(e, t, "ol") + "\n\n");
        break;
      case"ul":
        n || (r = L.subParser("makeMarkdown.list")(e, t, "ul") + "\n\n");
        break;
      case"precode":
        n || (r = L.subParser("makeMarkdown.codeBlock")(e, t) + "\n\n");
        break;
      case"pre":
        n || (r = L.subParser("makeMarkdown.pre")(e, t) + "\n\n");
        break;
      case"table":
        n || (r = L.subParser("makeMarkdown.table")(e, t) + "\n\n");
        break;
      case"code":
        r = L.subParser("makeMarkdown.codeSpan")(e, t);
        break;
      case"em":
      case"i":
        r = L.subParser("makeMarkdown.emphasis")(e, t);
        break;
      case"strong":
      case"b":
        r = L.subParser("makeMarkdown.strong")(e, t);
        break;
      case"del":
        r = L.subParser("makeMarkdown.strikethrough")(e, t);
        break;
      case"a":
        r = L.subParser("makeMarkdown.links")(e, t);
        break;
      case"img":
        r = L.subParser("makeMarkdown.image")(e, t);
        break;
      default:
        r = e.outerHTML + "\n\n"
    }
    return r
  }), L.subParser("makeMarkdown.paragraph", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
    return n = n.trim()
  }), L.subParser("makeMarkdown.pre", function (e, t) {
    var n = e.getAttribute("prenum");
    return "<pre>" + t.preList[n] + "</pre>"
  }), L.subParser("makeMarkdown.strikethrough", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "~~";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "~~"
    }
    return n
  }), L.subParser("makeMarkdown.strong", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "**";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "**"
    }
    return n
  }), L.subParser("makeMarkdown.table", function (e, t) {
    var n, r, a = "", o = [[], []], i = e.querySelectorAll("thead>tr>th"), s = e.querySelectorAll("tbody>tr");
    for (n = 0; n < i.length; ++n) {
      var l = L.subParser("makeMarkdown.tableCell")(i[n], t), c = "---";
      if (i[n].hasAttribute("style")) switch (i[n].getAttribute("style").toLowerCase().replace(/\s/g, "")) {
        case"text-align:left;":
          c = ":---";
          break;
        case"text-align:right;":
          c = "---:";
          break;
        case"text-align:center;":
          c = ":---:"
      }
      o[0][n] = l.trim(), o[1][n] = c
    }
    for (n = 0; n < s.length; ++n) {
      var d = o.push([]) - 1, f = s[n].getElementsByTagName("td");
      for (r = 0; r < i.length; ++r) {
        var p = " ";
        "undefined" != typeof f[r] && (p = L.subParser("makeMarkdown.tableCell")(f[r], t)), o[d].push(p)
      }
    }
    var u = 3;
    for (n = 0; n < o.length; ++n) for (r = 0; r < o[n].length; ++r) {
      var h = o[n][r].length;
      u < h && (u = h)
    }
    for (n = 0; n < o.length; ++n) {
      for (r = 0; r < o[n].length; ++r) 1 === n ? ":" === o[n][r].slice(-1) ? o[n][r] = L.helper.padEnd(o[n][r].slice(-1), u - 1, "-") + ":" : o[n][r] = L.helper.padEnd(o[n][r], u, "-") : o[n][r] = L.helper.padEnd(o[n][r], u);
      a += "| " + o[n].join(" | ") + " |\n"
    }
    return a.trim()
  }), L.subParser("makeMarkdown.tableCell", function (e, t) {
    var n = "";
    if (!e.hasChildNodes()) return "";
    for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t, !0);
    return n.trim()
  }), L.subParser("makeMarkdown.txt", function (e) {
    var t = e.nodeValue;
    return t = (t = t.replace(/ +/g, " ")).replace(/\xa8NBSP;/g, " "), t = (t = (t = (t = (t = (t = (t = (t = (t = L.helper.unescapeHTMLEntities(t)).replace(/([*_~|`])/g, "\\$1")).replace(/^(\s*)>/g, "\\$1>")).replace(/^#/gm, "\\#")).replace(/^(\s*)([-=]{3,})(\s*)$/, "$1\\$2$3")).replace(/^( {0,3}\d+)\./gm, "$1\\.")).replace(/^( {0,3})([+-])/gm, "$1\\$2")).replace(/]([\s]*)\(/g, "\\]$1\\(")).replace(/^ {0,3}\[([\S \t]*?)]:/gm, "\\[$1]:")
  }), xt.PLUGINS.markdown = function (o) {
    var i, l, n, r, s, c = o.$, a = !1, d = "", f = "";

    function p(e) {
      e = function u(e) {
        var t = e, n = e.match(/(\[\^(.+?)\])[^:]/g), r = e.match(/(\[\^(.+?)\]:)/g);
        if (n && r) {
          n.forEach(function (e, t, n) {
            n[t] = n[t].substring(0, n[t].length - 1)
          }), n = n.filter(function (e, t) {
            return n.indexOf(e) === t
          }), r = r.filter(function (e, t) {
            return r.indexOf(e) === t
          });
          for (var a = 1, o = 0; o < n.length; o++) {
            var i = "";
            if (1 == a && (i = '<hr class="footnote-sep"><ol>'), -1 < r.indexOf(n[o] + ":")) {
              for (var s = -1 < (t = (t = t.split(r[o]).join("{ftnt-plc}")).replace(r[o].substring(0, r[o].length - 1), '<sup id="fnref:'.concat(a, '"><a href="#fn:').concat(a, '" class="footnote-a">').concat(a, "</a></sup>"))).indexOf(n[o]) ? 1 : 0, l = 0; s && (l++, t = t.replace(r[o].substring(0, r[o].length - 1), '<sup id="fnref:'.concat(a, ":").concat(l, '"><a href="#fn:').concat(a, ":").concat(l, '" class="footnote-a">').concat(a, ":").concat(l, "</a></sup>")), s = -1 < t.indexOf(n[o]) ? 1 : 0);) ;
              var c = (t = t.split("{ftnt-plc}").join(r[o])).indexOf(r[o]), d = t, f = d.substring(c, d.length - 1);
              if (f = f.split("\n")[0], t = t.replace(f, ""), -1 < f.indexOf(": ")) {
                f = f.split(": ")[1], f += '<a href="#fnref:'.concat(a, '" class="footnote-a">\u21a9</a>');
                for (var p = l; 0 != l;) f += '<a href="#fnref:'.concat(a, ":").concat(p - l + 1, '" class="footnote-a">\u21a9</a>'), l--;
                f += "</p></li>", t = t + i + '<li id="fn:'.concat(a, '"><p>') + f, a++
              }
            }
          }
          1 != a && (t += "</ol>")
        }
        return e = t
      }(e = function s(e) {
        for (var t = /^[A-Za-z0-9]/g, n = /^:[ ]{1}(.+?)+/g, r = e.split("\n"), a = r, o = r.length - 1, i = 1; i < o; i++) null !== r[i].match(n) && (null !== r[i - 1].match(t) && i < o - 1 && null !== r[i + 1].match(n) ? (a[i - 1] = "<dl><dt>" + r[i - 1] + "</dt>", a[i] = "<dd>" + r[i].substring(2) + "</dd>") : null !== r[i - 1].match(t) && (i < o - 1 && null === r[i + 1].match(n) || i == o - 1) ? (a[i - 1] = "<dl><dt>" + r[i - 1] + "</dt>", a[i] = "<dd>" + r[i].substring(2) + "</dd></dl>") : i < o - 1 && null !== r[i + 1].match(n) ? a[i] = "<dd>" + r[i].substring(2) + "</dd>" : a[i] = "<dd>" + r[i].substring(2) + "</dd></dl>");
        return e = a.join("\n")
      }(e = function t(e) {
        var r = e.indexOf("```"), a = 0;
        -1 < r && (a = -1 < (a = e.substring(r + 1).indexOf("```")) ? a + 3 : a);
        return e = e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, function (e, t, n) {
          return r < n && n < a ? "---" : "<hr />\n"
        })
      }(e = function n(e) {
        return -1 < (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.split("</p>").join("</p>\n")).split("</div>").join("\n")).replace(/(<([^>]+)>)/gi, "")).replace(/&gt;/gi, ">")).replace(/&lt;/gi, "<")).split("&quot;").join('"')).split("&amp;").join("&")).split("&#39;").join("'")).split("&nbsp;").join(" ")).replace(/\|+\n[^\|]/g, function (e) {
          return e.replace("\n", "\n\n")
        })).indexOf("Powered by Froala Editor") && (e = e.replace("Powered by Froala Editor", "")), e
      }(e)))), e = r.makeHtml(e), o.$wp.find(l)[0].innerHTML = e
    }

    return {
      _init: function t() {
        if (function e() {
          o.events.on("contentChanged", function () {
            a && p(o.html.get(!1, !1))
          }, !0), o.events.$on(c(o.o_win), "resize", function () {
            a && (l[0].style.width = o.$wp[0].clientWidth - o.$el[0].clientWidth + 2 + "px")
          })
        }(), r = new L.Converter({
          strikethrough: !0,
          tables: !0,
          tablesHeaderId: !0,
          simpleLineBreaks: !0,
          ghCodeBlocks: !0,
          tasklists: !0,
          customizedHeaderId: !0,
          requireSpaceBeforeHeadingText: !0,
          underline: !0
        }), n = o.$tb ? o.$tb.find('.fr-command[data-cmd="markdown"]') : null, !o.$wp) return !1
      }, refresh: function u(e) {
        var t = a;
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }, toggle: function h() {
        a ? function e() {
          f = o.html.get(!0, !0), o.opts.pastePlain = !1, o.$el.removeClass("fr-markdown-editor"), o.$wp.append(s[0].firstChild), c(s).remove(), o.$wp.find(i).remove(), o.$wp.find(l).remove(), o.$wp[0].lastChild.after(o.$placeholder[0]), o.$el.removeAttr("style"), o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(n).removeClass("fr-disabled").attr("aria-disabled", !1), o.html.set(d)
        }() : function t() {
          var a;
          d = o.html.get(!0, !0), o.html.set(f), o.opts.pastePlain = !0, o.$el.addClass("fr-markdown-editor"), s = c('<div class="fr-wrapper-markdown" />'), o.$wp.append(s), s[0].appendChild(o.$el[0]), i = c('<div class="gutter-horizontal"><div class="e-resize-handler"><i class="fa fa-circle-thin" aria-hidden="true"></i></div></div>'), c(s).append(i[0]), l = c('<div class="fr-element fr-markdown-view"></div>'), c(s).append(l[0]), c(s).after(o.$placeholder[0]), o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(n).filter(function () {
            return "fullscreen" !== c(this).data("cmd") && "moreMisc" !== c(this).data("cmd")
          }).addClass("fr-disabled").attr("aria-disabled", !0), c(i).on("mousedown touchstart", function (e) {
            a = {
              e: e,
              offsetLeft: i[0].offsetLeft,
              offsetTop: i[0].offsetTop,
              firstWidth: o.$el[0].offsetWidth,
              secondWidth: l[0].offsetWidth
            };
            var n = function n(e) {
              o.selection.clear();
              var t = {x: e.clientX - a.e.clientX, y: e.clientY - a.e.clientY};
              t.x = Math.min(Math.max(t.x, -a.firstWidth), a.secondWidth), a.firstWidth + t.x < 125 || a.secondWidth - t.x < 125 || (i[0].style.left = a.offsetLeft + t.x + "px", o.$el[0].style.width = a.firstWidth + t.x + "px", l[0].style.width = a.secondWidth - t.x + "px")
            }, r = function r(e) {
              o.selection.clear();
              var t = {
                x: e.changedTouches[0].clientX - a.e.changedTouches[0].clientX,
                y: e.changedTouches[0].clientY - a.e.changedTouches[0].clientY
              };
              t.x = Math.min(Math.max(t.x, -a.firstWidth), a.secondWidth), a.firstWidth + t.x < 100 || a.secondWidth - t.x < 100 || (i[0].style.left = a.offsetLeft + t.x + "px", o.$el[0].style.width = a.firstWidth + t.x + "px", l[0].style.width = a.secondWidth - t.x + "px")
            }, t = function t() {
              document.onmousemove = document.onmouseup = null, document.ontouchmove = document.ontouchend = null
            };
            document.onmousemove = n, document.ontouchmove = r, document.onmouseup = t, document.ontouchend = t
          }), p(f)
        }(), a = !a
      }, isEnabled: function e() {
        return a
      }
    }
  }, xt.DefineIcon("markdown", {
    NAME: "markdown",
    SVG_KEY: "markdown"
  }), xt.RegisterCommand("markdown", {
    title: "Markdown",
    undo: !1,
    focus: !1,
    toggle: !0,
    forcedRefresh: !0,
    accessibilityFocus: !0,
    callback: function () {
      this.markdown.toggle()
    },
    refresh: function (e) {
      this.markdown.refresh(e)
    },
    plugin: "markdown"
  }), xt
});

/*!
 * froala_editor v4.0.1 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

!function(e,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-editor")):"function"==typeof define&&define.amd?define(["froala-editor"],a):a(e.FroalaEditor)}(this,function(g){"use strict";g=g&&g.hasOwnProperty("default")?g["default"]:g,Object.assign(g.DEFAULTS,{fontAwesomeTemplate:'<i class="fa  fa-[NAME] fr-deletable" aria-hidden="true">&nbsp;</i>',fontAwesomeTemplate5:'<i class="fa [FPREFIX] fa-[NAME] fr-deletable" aria-hidden="true">&nbsp;</i>',fontAwesomeSets:[{title:"Web Application Icons",icon:"address-book",list:["address-book","address-book-o","address-card","address-card-o","adjust","american-sign-language-interpreting","anchor","archive","area-chart","arrows","arrows-h","arrows-v","asl-interpreting ","assistive-listening-systems","asterisk","at","audio-description","automobile ","balance-scale","ban","bank ","bar-chart","bar-chart-o ","barcode","bars","bath","bathtub ","battery ","battery-0 ","battery-1 ","battery-2 ","battery-3 ","battery-4 ","battery-empty","battery-full","battery-half","battery-quarter","battery-three-quarters","bed","beer","bell","bell-o","bell-slash","bell-slash-o","bicycle","binoculars","birthday-cake","blind","bluetooth","bluetooth-b","bolt","bomb","book","bookmark","bookmark-o","braille","briefcase","bug","building","building-o","bullhorn","bullseye","bus","cab ","calculator","calendar","calendar-check-o","calendar-minus-o","calendar-o","calendar-plus-o","calendar-times-o","camera","camera-retro","car","caret-square-o-down","caret-square-o-left","caret-square-o-right","caret-square-o-up","cart-arrow-down","cart-plus","cc","certificate","check","check-circle","check-circle-o","check-square","check-square-o","child","circle","circle-o","circle-o-notch","circle-thin","clock-o","clone","close ","cloud","cloud-download","cloud-upload","code","code-fork","coffee","cog","cogs","comment","comment-o","commenting","commenting-o","comments","comments-o","compass","copyright","creative-commons","credit-card","credit-card-alt","crop","crosshairs","cube","cubes","cutlery","dashboard ","database","deaf","deafness ","desktop","diamond","dot-circle-o","download","drivers-license ","drivers-license-o ","edit ","ellipsis-h","ellipsis-v","envelope","envelope-o","envelope-open","envelope-open-o","envelope-square","eraser","exchange","exclamation","exclamation-circle","exclamation-triangle","external-link","external-link-square","eye","eye-slash","eyedropper","fax","feed ","female","fighter-jet","file-archive-o","file-audio-o","file-code-o","file-excel-o","file-image-o","file-movie-o ","file-pdf-o","file-photo-o ","file-picture-o ","file-powerpoint-o","file-sound-o ","file-video-o","file-word-o","file-zip-o ","film","filter","fire","fire-extinguisher","flag","flag-checkered","flag-o","flash ","flask","folder","folder-o","folder-open","folder-open-o","frown-o","futbol-o","gamepad","gavel","gear ","gears ","gift","glass","globe","graduation-cap","group ","hand-grab-o ","hand-lizard-o","hand-paper-o","hand-peace-o","hand-pointer-o","hand-rock-o","hand-scissors-o","hand-spock-o","hand-stop-o ","handshake-o","hard-of-hearing ","hashtag","hdd-o","headphones","heart","heart-o","heartbeat","history","home","hotel ","hourglass","hourglass-1 ","hourglass-2 ","hourglass-3 ","hourglass-end","hourglass-half","hourglass-o","hourglass-start","i-cursor","id-badge","id-card","id-card-o","image ","inbox","industry","info","info-circle","institution ","key","keyboard-o","language","laptop","leaf","legal ","lemon-o","level-down","level-up","life-bouy ","life-buoy ","life-ring","life-saver ","lightbulb-o","line-chart","location-arrow","lock","low-vision","magic","magnet","mail-forward ","mail-reply ","mail-reply-all ","male","map","map-marker","map-o","map-pin","map-signs","meh-o","microchip","microphone","microphone-slash","minus","minus-circle","minus-square","minus-square-o","mobile","mobile-phone ","money","moon-o","mortar-board ","motorcycle","mouse-pointer","music","navicon ","newspaper-o","object-group","object-ungroup","paint-brush","paper-plane","paper-plane-o","paw","pencil","pencil-square","pencil-square-o","percent","phone","phone-square","photo ","picture-o","pie-chart","plane","plug","plus","plus-circle","plus-square","plus-square-o","podcast","power-off","print","puzzle-piece","qrcode","question","question-circle","question-circle-o","quote-left","quote-right","random","recycle","refresh","registered","remove ","reorder ","reply","reply-all","retweet","road","rocket","rss","rss-square","s15 ","search","search-minus","search-plus","send ","send-o ","server","share","share-alt","share-alt-square","share-square","share-square-o","shield","ship","shopping-bag","shopping-basket","shopping-cart","shower","sign-in","sign-language","sign-out","signal","signing ","sitemap","sliders","smile-o","snowflake-o","soccer-ball-o ","sort","sort-alpha-asc","sort-alpha-desc","sort-amount-asc","sort-amount-desc","sort-asc","sort-desc","sort-down ","sort-numeric-asc","sort-numeric-desc","sort-up ","space-shuttle","spinner","spoon","square","square-o","star","star-half","star-half-empty ","star-half-full ","star-half-o","star-o","sticky-note","sticky-note-o","street-view","suitcase","sun-o","support ","tablet","tachometer","tag","tags","tasks","taxi","television","terminal","thermometer ","thermometer-0 ","thermometer-1 ","thermometer-2 ","thermometer-3 ","thermometer-4 ","thermometer-empty","thermometer-full","thermometer-half","thermometer-quarter","thermometer-three-quarters","thumb-tack","thumbs-down","thumbs-o-down","thumbs-o-up","thumbs-up","ticket","times","times-circle","times-circle-o","times-rectangle ","times-rectangle-o ","tint","toggle-down ","toggle-left ","toggle-off","toggle-on","toggle-right ","toggle-up ","trademark","trash","trash-o","tree","trophy","truck","tty","tv ","umbrella","universal-access","university","unlock","unlock-alt","unsorted ","upload","user","user-circle","user-circle-o","user-o","user-plus","user-secret","user-times","users","vcard ","vcard-o ","video-camera","volume-control-phone","volume-down","volume-off","volume-up","warning ","wheelchair","wheelchair-alt","wifi","window-close","window-close-o","window-maximize","window-minimize","window-restore","wrench"]},{title:"Accessibility Icons",icon:"american-sign-language-interpreting",list:["american-sign-language-interpreting","asl-interpreting ","assistive-listening-systems","audio-description","blind","braille","cc","deaf","deafness ","hard-of-hearing ","low-vision","question-circle-o","sign-language","signing ","tty","universal-access","volume-control-phone","wheelchair","wheelchair-alt"]},{title:"Hand Icons",icon:"hand-grab-o",list:["hand-grab-o ","hand-lizard-o","hand-o-down","hand-o-left","hand-o-right","hand-o-up","hand-paper-o","hand-peace-o","hand-pointer-o","hand-rock-o","hand-scissors-o","hand-spock-o","hand-stop-o ","thumbs-down","thumbs-o-down","thumbs-o-up","thumbs-up"]},{title:"Transportation Icons",icon:"ambulance",list:["ambulance","automobile ","bicycle","bus","cab ","car","fighter-jet","motorcycle","plane","rocket","ship","space-shuttle","subway","taxi","train","truck","wheelchair","wheelchair-alt"]},{title:"Gender Icons",icon:"genderless",list:["genderless","intersex ","mars","mars-double","mars-stroke","mars-stroke-h","mars-stroke-v","mercury","neuter","transgender","transgender-alt","venus","venus-double","venus-mars"]},{title:"Form Control Icons",icon:"check-square",list:["check-square","check-square-o","circle","circle-o","dot-circle-o","minus-square","minus-square-o","plus-square","plus-square-o","square","square-o"]},{title:"Payment Icons",icon:"cc-amex",list:["cc-amex","cc-diners-club","cc-discover","cc-jcb","cc-mastercard","cc-paypal","cc-stripe","cc-visa","credit-card","credit-card-alt","google-wallet","paypal"]},{title:"Chart Icons",icon:"area-chart",list:["area-chart","bar-chart","bar-chart-o ","line-chart","pie-chart"]},{title:"Currency Icons",icon:"bitcoin",list:["bitcoin ","btc","cny ","dollar ","eur","euro ","gbp","gg","gg-circle","ils","inr","jpy","krw","money","rmb ","rouble ","rub","ruble ","rupee ","shekel ","sheqel ","try","turkish-lira ","usd","viacoin","won ","yen"]},{title:"Text Editor Icons",icon:"align-center",list:["align-center","align-justify","align-left","align-right","bold","chain ","chain-broken","clipboard","columns","copy ","cut ","dedent ","eraser","file","file-o","file-text","file-text-o","files-o","floppy-o","font","header","indent","italic","link","list","list-alt","list-ol","list-ul","outdent","paperclip","paragraph","paste ","repeat","rotate-left ","rotate-right ","save ","scissors","strikethrough","subscript","superscript","table","text-height","text-width","th","th-large","th-list","underline","undo","unlink"]},{title:"Brand Icons",icon:"500px",list:["500px","adn","amazon","android","angellist","apple","bandcamp","behance","behance-square","bitbucket","bitbucket-square","bitcoin ","black-tie","bluetooth","bluetooth-b","btc","buysellads","cc-amex","cc-diners-club","cc-discover","cc-jcb","cc-mastercard","cc-paypal","cc-stripe","cc-visa","chrome","codepen","codiepie","connectdevelop","contao","css3","dashcube","delicious","deviantart","digg","dribbble","dropbox","drupal","edge","eercast","empire","envira","etsy","expeditedssl","fa ","facebook","facebook-f ","facebook-official","facebook-square","firefox","first-order","flickr","font-awesome","fonticons","fort-awesome","forumbee","foursquare","free-code-camp","ge ","get-pocket","gg","gg-circle","git","git-square","github","github-alt","github-square","gitlab","gittip ","glide","glide-g","google","google-plus","google-plus-circle ","google-plus-official","google-plus-square","google-wallet","gratipay","grav","hacker-news","houzz","html5","imdb","instagram","internet-explorer","ioxhost","joomla","jsfiddle","lastfm","lastfm-square","leanpub","linkedin","linkedin-square","linode","linux","maxcdn","meanpath","medium","meetup","mixcloud","modx","odnoklassniki","odnoklassniki-square","opencart","openid","opera","optin-monster","pagelines","paypal","pied-piper","pied-piper-alt","pied-piper-pp","pinterest","pinterest-p","pinterest-square","product-hunt","qq","quora","ra ","ravelry","rebel","reddit","reddit-alien","reddit-square","renren","resistance ","safari","scribd","sellsy","share-alt","share-alt-square","shirtsinbulk","simplybuilt","skyatlas","skype","slack","slideshare","snapchat","snapchat-ghost","snapchat-square","soundcloud","spotify","stack-exchange","stack-overflow","steam","steam-square","stumbleupon","stumbleupon-circle","superpowers","telegram","tencent-weibo","themeisle","trello","tripadvisor","tumblr","tumblr-square","twitch","twitter","twitter-square","usb","viacoin","viadeo","viadeo-square","vimeo","vimeo-square","vine","vk","wechat ","weibo","weixin","whatsapp","wikipedia-w","windows","wordpress","wpbeginner","wpexplorer","wpforms","xing","xing-square","y-combinator","y-combinator-square ","yahoo","yc ","yc-square ","yelp","yoast","youtube","youtube-play","youtube-square"]}],fontAwesome5Sets:[{title:"Web Application Icons",icon:"address-book",list:["address-book","far address-book","fas address-card","far address-card","adjust","fas american-sign-language-interpreting","anchor","archive","fas chart-area","fas arrows-alt","fas arrows-alt-h","fas arrows-alt-v","assistive-listening-systems","asterisk","at","audio-description","fas car","balance-scale","ban","fas university","far chart-bar","barcode","bars","fas bath","fas battery-full","fas battery-empty","fas battery-quarter","fas battery-half","fas battery-three-quarters","bed","beer","bell","far bell","bell-slash","far bell-slash","bicycle","binoculars","birthday-cake","blind","fab bluetooth","fab bluetooth-b","bolt","bomb","book","bookmark","far bookmark","braille","briefcase","bug","building","far building","bullhorn","bullseye","bus","fas taxi","calculator","calendar","far calendar-check","far calendar-minus","far calendar","far calendar-plus","far calendar-times","camera","camera-retro","car","far caret-square-down","far caret-square-left","far caret-square-right","far caret-square-up","cart-arrow-down","cart-plus","far closed-captioning","certificate","check","check-circle","far check-circle","check-square","far check-square","child","circle","far circle","fas circle-notch","far clock","clone","fas times","cloud","fas cloud-download-alt","fas cloud-upload-alt","code","fas code-branch","coffee","fas cog","fas cogs","comment","far comment","comments","far comments","compass","copyright","fab creative-commons","far credit-card","fas credit-card","crop","crosshairs","cube","cubes","fas utensils","fas tachometer-alt","database","fas deaf","desktop","far gem","far dot-circle","download","fas id-card","far id-card","edit ","ellipsis-h","ellipsis-v","envelope","far envelope","envelope-open","far envelope-open","envelope-square","eraser","fas exchange-alt","exclamation","exclamation-circle","fas exclamation-triangle","fas external-link-alt","fas external-link-square-alt","eye","eye-slash","fas eye-dropper","fax","fas rss","female","fighter-jet","far file-archive","far file-audio","far file-code","far file-excel","far file-image","far file-video","far file-pdf","far file-powerpoint","far file-word","film","filter","fire","fire-extinguisher","flag","flag-checkered","far flag","fas bolt","flask","folder","far folder","folder-open","far folder-open","far frown","far futbol","gamepad","fas gavel","gift","fas glass-martini","globe","fas graduation-cap","fas users","far hand-rock","far hand-lizard","far hand-paper","far hand-peace","far hand-pointer","far hand-scissors","far hand-spock","far handshake","hashtag","far hdd","headphones","heart","far heart","heartbeat","history","home","fas bed","hourglass","fas hourglass-start","fas hourglass-half","fas hourglass-end","far hourglass","i-cursor","id-badge","image ","inbox","industry","info","info-circle","key","far keyboard","language","laptop","leaf","far lemon","fas level-down-alt","fas level-up-alt","far life-ring","far lightbulb","fas chart-line","location-arrow","lock","low-vision","magic","magnet","fas share","fas reply ","fas reply-all ","male","map","map-marker","far map","map-pin","map-signs","far meh","microchip","microphone","microphone-slash","minus","minus-circle","minus-square","far minus-square","mobile","far money-bill-alt","far moon","motorcycle","mouse-pointer","music","fas bars","far newspaper","object-group","object-ungroup","paint-brush","fas paper-plane","far paper-plane","paw","fas pencil-alt","fas pen-square","far edit","percent","phone","phone-square","far image","fas chart-pie","plane","plug","plus","plus-circle","plus-square","far plus-square","podcast","power-off","print","puzzle-piece","qrcode","question","question-circle","far question-circle","quote-left","quote-right","random","recycle","fas sync","registered","reply","reply-all","retweet","road","rocket","rss","rss-square","search","search-minus","search-plus","server","share-alt","share-alt-square","share-square","far share-square","fas shield-alt","ship","shopping-bag","shopping-basket","shopping-cart","shower","fas sign-in-alt","fas sign-language","fas sign-out-alt","signal","sitemap","fas sliders-h","far smile","far snowflake","sort","fas sort-alpha-down","fas sort-alpha-up","fas sort-amount-down","fas sort-amount-up","fas sort-up","fas sort-down","fas sort-numeric-down","fas sort-numeric-up","space-shuttle","spinner","fas utensil-spoon","square","far square","star","far star-half","far star","sticky-note","far sticky-note","street-view","suitcase","far sun","tablet","tag","tags","tasks","taxi","fas tv","terminal","fas thermometer-empty","fas thermometer-full","fas thermometer-half","fas thermometer-quarter","fas thermometer-three-quarters","fas thumbtack","thumbs-down","far thumbs-down","far thumbs-up","thumbs-up","fas ticket-alt","times","times-circle","far times-circle","fas window-close","far window-close ","tint","toggle-off","toggle-on","trademark","trash","far trash-alt","tree","trophy","truck","tty","tv ","umbrella","universal-access","university","unlock","unlock-alt","fas sort","upload","user","user-circle","far user-circle","far user","user-plus","user-secret","user-times","fas video","fas phone-volume","volume-down","volume-off","volume-up","wheelchair","fab accessible-icon","wifi","window-maximize","window-minimize","window-restore","wrench"]},{title:"Accessibility Icons",icon:"american-sign-language-interpreting",list:["fas american-sign-language-interpreting","assistive-listening-systems","audio-description","blind","braille","far closed-captioning","fas deaf","low-vision","far question-circle","fas sign-language","tty","universal-access","fas phone-volume","wheelchair","fab accessible-icon"]},{title:"Hand Icons",icon:"hand-grab-o",list:["far hand-rock","far hand-lizard","far hand-point-down","far hand-point-left","far hand-point-right","far hand-point-up","far hand-paper","far hand-peace","far hand-pointer","far hand-scissors","far hand-spock","thumbs-down","far thumbs-down","far thumbs-up","thumbs-up"]},{title:"Transportation Icons",icon:"ambulance",list:["ambulance","fas car","bicycle","bus","fas taxi","car","fighter-jet","motorcycle","plane","rocket","ship","space-shuttle","subway","taxi","train","truck","wheelchair","fab accessible-icon"]},{title:"Gender Icons",icon:"genderless",list:["genderless","mars","mars-double","mars-stroke","mars-stroke-h","mars-stroke-v","mercury","neuter","fas transgender","transgender-alt","venus","venus-double","venus-mars"]},{title:"Form Control Icons",icon:"check-square",list:["check-square","far check-square","circle","far circle","far dot-circle","minus-square","far minus-square","plus-square","far plus-square","square","far square"]},{title:"Payment Icons",icon:"cc-amex",list:["fab cc-amex","fab cc-diners-club","fab cc-discover","fab cc-jcb","fab cc-mastercard","fab cc-paypal","fab cc-stripe","fab cc-visa","far credit-card","fas credit-card","fab google-wallet","fab paypal"]},{title:"Chart Icons",icon:"area-chart",list:["fas chart-area","far chart-bar","fas chart-line","fas chart-pie"]},{title:"Currency Icons",icon:"bitcoin",list:["fab btc","fas yen-sign","fas dollar-sign","fas euro-sign","fas pound-sign","fab gg","fab gg-circle","fas shekel-sign","fas rupee-sign","fas won-sign","far money-bill-alt","fas ruble-sign ","fas lira-sign","fab viacoin"]},{title:"Text Editor Icons",icon:"align-center",list:["align-center","align-justify","align-left","align-right","bold","fas link","fas unlink","clipboard","columns","copy ","cut ","fas outdent","eraser","file","far file","fas file-alt","far file-alt","far copy","far save","font","fas heading","indent","italic","list","list-alt","list-ol","list-ul","paperclip","paragraph","paste ","fas undo","fas redo ","save","strikethrough","subscript","superscript","table","text-height","text-width","th","th-large","th-list","underline"]},{title:"Brand Icons",icon:"500px",list:["fab 500px","fab adn","fab amazon","fab android","fab angellist","fab apple","fab bandcamp","fab behance","fab behance-square","fab bitbucket","fab btc","fab black-tie","fab bluetooth","fab bluetooth-b","fab buysellads","fab cc-amex","fab cc-diners-club","fab cc-discover","fab cc-jcb","fab cc-mastercard","fab cc-paypal","fab cc-stripe","fab cc-visa","fab chrome","fab codepen","fab codiepie","fab connectdevelop","fab contao","fab css3","fab dashcube","fab delicious","fab deviantart","fab digg","fab dribbble","fab dropbox","fab drupal","fab edge","fab sellcast","fab empire","fab envira","fab etsy","fab expeditedssl","fab font-awesome","fab facebook-f","fab facebook","fab facebook-square","fab firefox","fab first-order","fab flickr","fab fonticons","fab fort-awesome","fab forumbee","fab foursquare","fab free-code-camp","fab get-pocket","fab gg","fab gg-circle","fab git","fab git-square","fab github","fab github-alt","fab github-square","fab gitlab","fab gratipay","fab glide","fab glide-g","fab google","fab google-plus-g","fab google-plus","fab google-plus-square","fab google-wallet","fab grav","fab hacker-news","fab houzz","fab html5","fab imdb","fab instagram","fab internet-explorer","fab ioxhost","fab joomla","fab jsfiddle","fab lastfm","fab lastfm-square","fab leanpub","fab linkedin-in","fab linkedin","fab linode","fab linux","fab maxcdn","fab medium","fab meetup","fab mixcloud","fab modx","fab odnoklassniki","fab odnoklassniki-square","fab opencart","fab openid","fab opera","fab optin-monster","fab pagelines","fab paypal","fab pied-piper","fab pied-piper-alt","fab pied-piper-pp","fab pinterest","fab pinterest-p","fab pinterest-square","fab product-hunt","fab qq","fab quora","fab rebel","fab ravelry","fab reddit","fab reddit-alien","fab reddit-square","fab renren","fab safari","fab scribd","fab sellsy","share-alt","share-alt-square","fab shirtsinbulk","fab simplybuilt","fab skyatlas","fab skype","fab slack","fab slideshare","fab snapchat","fab snapchat-ghost","fab snapchat-square","fab soundcloud","fab spotify","fab stack-exchange","fab stack-overflow","fab steam","fab steam-square","fab stumbleupon","fab stumbleupon-circle","fab superpowers","fab telegram","fab tencent-weibo","fab themeisle","fab trello","fab tripadvisor","fab tumblr","fab tumblr-square","fab twitch","fab twitter","fab twitter-square","fab usb","fab viacoin","fab viadeo","fab viadeo-square","fab vimeo","fab vimeo-square","fab vine","fab vk","fab weixin","fab weibo","fab whatsapp","fab wikipedia-w","fab windows","fab wordpress","fab wpbeginner","fab wpexplorer","fab wpforms","fab xing","fab xing-square","fab y-combinator","fab yahoo","fab yelp","fab yoast","fab youtube","fab youtube-square"]}],faButtons:["fontAwesomeBack","|"]}),Object.assign(g.POPUP_TEMPLATES,{fontAwesome:"[_BUTTONS_][_CUSTOM_LAYER_]"}),g.PLUGINS.fontAwesome=function(h){var m=h.$;"font_awesome_5"===h.opts.iconsTemplate&&(h.opts.fontAwesomeSets=h.opts.fontAwesome5Sets,h.opts.fontAwesomeTemplate=h.opts.fontAwesomeTemplate5);var t=h.opts.fontAwesomeSets[0],o=h.opts.fontAwesomeSets,r="";function i(){h.opts.toolbarInline&&0<h.opts.faButtons.length&&(r='<div class="fr-buttons fr-tabs">'.concat(h.button.buildList(h.opts.faButtons),"</div>"));var e={buttons:r,custom_layer:s()},a=h.popups.create("fontAwesome",e);return function t(d){h.events.on("popup.tab",function(e){var a=m(e.currentTarget);if(!h.popups.isVisible("fontAwesome")||!a.is("span, a"))return!0;var t,r,s,o=e.which;if(g.KEYCODE.TAB==o){if(a.is("span.fr-icon")&&e.shiftKey||a.is("a")&&!e.shiftKey){var i=d.find(".fr-buttons");t=!h.accessibility.focusToolbar(i,!!e.shiftKey)}if(!1!==t){var n=d.find("span.fr-icon:focus").first().concat(d.findVisible(" span.fr-icon").first().concat(d.find("a")));a.is("span.fr-icon")&&(n=n.not("span.fr-icon:not(:focus)")),r=n.index(a),r=e.shiftKey?((r-1)%n.length+n.length)%n.length:(r+1)%n.length,s=n.get(r),h.events.disableBlur(),s.focus(),t=!1}}else if(g.KEYCODE.ARROW_UP==o||g.KEYCODE.ARROW_DOWN==o||g.KEYCODE.ARROW_LEFT==o||g.KEYCODE.ARROW_RIGHT==o){if(a.is("span.fr-icon")){var l=a.parent().find("span.fr-icon");r=l.index(a);var c=Math.floor(l.length/8),f=r%8,u=Math.floor(r/8),p=8*u+f,b=8*c;g.KEYCODE.ARROW_UP==o?p=((p-8)%b+b)%b:g.KEYCODE.ARROW_DOWN==o?p=(p+8)%b:g.KEYCODE.ARROW_LEFT==o?p=((p-1)%b+b)%b:g.KEYCODE.ARROW_RIGHT==o&&(p=(p+1)%b),s=m(l.get(p)),h.events.disableBlur(),s.focus(),t=!1}}else g.KEYCODE.ENTER==o&&(a.is("a")?a[0].click():h.button.exec(a),t=!1);return!1===t&&(e.preventDefault(),e.stopPropagation()),t},!0)}(a),a}function s(){return"".concat(function r(e,a,t){return'\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n            '.concat(function n(e,t,r){var s="";if("font_awesome_5"===h.opts.iconsTemplate){var o="",i=r;e.forEach(function(e){o="cc-amex"===e.icon||"bitcoin"==e.icon||"500px"==e.icon?i.replace("fa ","fab "):r;var a={elementClass:e.title===t.title?"fr-active fr-active-tab":"",title:e.title,dataCmd:"setIconCategory",dataParam1:e.title,iconValue:o.replace(/\[NAME\]/g,e.icon)};s+='<button class="fr-fa-icon-category fr-command fr-btn '.concat(a.elementClass,'" title="').concat(a.title,'" data-cmd="').concat(a.dataCmd,'" data-param1="').concat(a.dataParam1,'"</button><span>').concat(a.iconValue,"</span>")})}else e.forEach(function(e){var a={elementClass:e.title===t.title?"fr-active fr-active-tab":"",title:e.title,dataCmd:"setIconCategory",dataParam1:e.title,iconValue:r.replace(/\[NAME\]/g,e.icon)};s+='<button class="fr-fa-icon-category fr-command fr-btn '.concat(a.elementClass,'" title="').concat(a.title,'" data-cmd="').concat(a.dataCmd,'" data-param1="').concat(a.dataParam1,'"</button><span>').concat(a.iconValue,"</span>")});return s}(e,a,t),"\n        </div>\n        ")}(o,t,h.opts.fontAwesomeTemplate),"\n                     ").concat(function s(e,a){return'\n        <div class="fr-icon-container fr-fa-container">\n            '.concat(function t(e,n){var l="";return e.list.forEach(function(e){if("font_awesome_5"===h.opts.iconsTemplate){var a={name:e,fprefix:"fa"},t=e.trim().split(" ");1<t.length&&(a={name:t[1],fprefix:t[0]});var r=h.opts.fontAwesomeTemplate.replace(/\[NAME\]|\[FPREFIX\]/g,function(e){return a[e.substring(1,e.length-1).toLowerCase()]});0<r.search("fab")&&(r=r.replace("fa",""));var s=e,o=e;n.replace(/\[NAME\]/g,e),l+='<span class="fr-command fr-fa-icon fr-icon" data-cmd="insertIcon" data-param1="'+s+'" title="'+o+'" tabIndex="-1"  role="button" value="'+a.name+'" data-fprefix="'+a.fprefix+'">'+r+'<span class="fr-sr-only">'+h.language.translate("Example of")+a.name+"&nbsp;&nbsp;&nbsp;</span></span>"}else{var i={dataParam1:e,title:e,iconValue:n.replace(/\[NAME\]/g,e)};l+='<span class="fr-command fr-fa-icon fr-icon" role="button" data-cmd="insertIcon" data-param1="'.concat(i.dataParam1,'" title="').concat(i.title,'">').concat(i.iconValue,"</span>")}}),l}(e,a),"\n        </div>\n        ")}(t,h.opts.fontAwesomeTemplate))}return{setIconCategory:function n(a){t=o.filter(function(e){return e.title===a})[0],function e(){h.popups.get("fontAwesome").html(r+s())}()},showFontAwesomePopup:function l(){var e=h.popups.get("fontAwesome");if(e||(e=i()),!e.hasClass("fr-active")){h.popups.refresh("fontAwesome"),h.popups.setContainer("fontAwesome",h.$tb);var a=h.$tb.find('.fr-command[data-cmd="fontAwesome"]'),t=h.button.getPosition(a),r=t.left,s=t.top;h.popups.show("fontAwesome",r,s,a.outerHeight())}},back:function e(){h.popups.hide("fontAwesome"),h.toolbar.showInline()}}},g.DefineIcon("fontAwesome",{NAME:"flag",SVG_KEY:"fontAwesome"}),g.RegisterCommand("fontAwesome",{title:"Font Awesome",icon:"fontAwesome",undo:!1,focus:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("fontAwesome")?(this.$el.find(".fr-marker")&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("fontAwesome")):this.fontAwesome.showFontAwesomePopup()},plugin:"fontAwesome",showOnMobile:!0}),g.RegisterCommand("insertIcon",{callback:function(e,a){if(this.opts&&"font_awesome_5"===this.opts.iconsTemplate){var t={name:a,fprefix:"fa"},r=this.opts.fontAwesomeTemplate.replace(/\[NAME\]|\[FPREFIX\]/g,function(e){return t[e.substring(1,e.length-1).toLowerCase()]});this.undo.saveStep(),this.html.insert(r,!0),this.undo.saveStep()}else this.undo.saveStep(),this.html.insert("".concat(this.opts.fontAwesomeTemplate.replace(/\[NAME\]/g,a),"&nbsp;")),this.undo.saveStep();this.popups.hide("fontAwesome")}}),g.RegisterCommand("setIconCategory",{undo:!1,focus:!1,callback:function(e,a){this.fontAwesome.setIconCategory(a)}}),g.DefineIcon("fontAwesomeBack",{NAME:"arrow-left",SVG_KEY:"back"}),g.RegisterCommand("fontAwesomeBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.fontAwesome.back()}})});

(function(){function o(n){var i=e;n&&(e[n]||(e[n]={}),i=e[n]);if(!i.define||!i.define.packaged)t.original=i.define,i.define=t,i.define.packaged=!0;if(!i.require||!i.require.packaged)r.original=i.require,i.require=r,i.require.packaged=!0}var ACE_NAMESPACE="",e=function(){return this}();!e&&typeof window!="undefined"&&(e=window);if(!ACE_NAMESPACE&&typeof requirejs!="undefined")return;var t=function(e,n,r){if(typeof e!="string"){t.original?t.original.apply(this,arguments):(console.error("dropping module because define wasn't a string."),console.trace());return}arguments.length==2&&(r=n),t.modules[e]||(t.payloads[e]=r,t.modules[e]=null)};t.modules={},t.payloads={};var n=function(e,t,n){if(typeof t=="string"){var i=s(e,t);if(i!=undefined)return n&&n(),i}else if(Object.prototype.toString.call(t)==="[object Array]"){var o=[];for(var u=0,a=t.length;u<a;++u){var f=s(e,t[u]);if(f==undefined&&r.original)return;o.push(f)}return n&&n.apply(null,o)||!0}},r=function(e,t){var i=n("",e,t);return i==undefined&&r.original?r.original.apply(this,arguments):i},i=function(e,t){if(t.indexOf("!")!==-1){var n=t.split("!");return i(e,n[0])+"!"+i(e,n[1])}if(t.charAt(0)=="."){var r=e.split("/").slice(0,-1).join("/");t=r+"/"+t;while(t.indexOf(".")!==-1&&s!=t){var s=t;t=t.replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"")}}return t},s=function(e,r){r=i(e,r);var s=t.modules[r];if(!s){s=t.payloads[r];if(typeof s=="function"){var o={},u={id:r,uri:"",exports:o,packaged:!0},a=function(e,t){return n(r,e,t)},f=s(a,o,u);o=f||u.exports,t.modules[r]=o,delete t.payloads[r]}s=t.modules[r]=o||s}return s};o(ACE_NAMESPACE)})(),define("ace/lib/es6-shim",["require","exports","module"],function(e,t,n){function r(e,t,n){Object.defineProperty(e,t,{value:n,enumerable:!1,writable:!0,configurable:!0})}String.prototype.startsWith||r(String.prototype,"startsWith",function(e,t){return t=t||0,this.lastIndexOf(e,t)===t}),String.prototype.endsWith||r(String.prototype,"endsWith",function(e,t){var n=this;if(t===undefined||t>n.length)t=n.length;t-=e.length;var r=n.indexOf(e,t);return r!==-1&&r===t}),String.prototype.repeat||r(String.prototype,"repeat",function(e){var t="",n=this;while(e>0){e&1&&(t+=n);if(e>>=1)n+=n}return t}),String.prototype.includes||r(String.prototype,"includes",function(e,t){return this.indexOf(e,t)!=-1}),Object.assign||(Object.assign=function(e){if(e===undefined||e===null)throw new TypeError("Cannot convert undefined or null to object");var t=Object(e);for(var n=1;n<arguments.length;n++){var r=arguments[n];r!==undefined&&r!==null&&Object.keys(r).forEach(function(e){t[e]=r[e]})}return t}),Object.values||(Object.values=function(e){return Object.keys(e).map(function(t){return e[t]})}),Array.prototype.find||r(Array.prototype,"find",function(e){var t=this.length,n=arguments[1];for(var r=0;r<t;r++){var i=this[r];if(e.call(n,i,r,this))return i}}),Array.prototype.findIndex||r(Array.prototype,"findIndex",function(e){var t=this.length,n=arguments[1];for(var r=0;r<t;r++){var i=this[r];if(e.call(n,i,r,this))return r}}),Array.prototype.includes||r(Array.prototype,"includes",function(e,t){return this.indexOf(e,t)!=-1}),Array.prototype.fill||r(Array.prototype,"fill",function(e){var t=this,n=t.length>>>0,r=arguments[1],i=r>>0,s=i<0?Math.max(n+i,0):Math.min(i,n),o=arguments[2],u=o===undefined?n:o>>0,a=u<0?Math.max(n+u,0):Math.min(u,n);while(s<a)t[s]=e,s++;return t}),Array.of||r(Array,"of",function(){return Array.prototype.slice.call(arguments)})}),define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/es6-shim"],function(e,t,n){"use strict";e("./es6-shim")}),define("ace/lib/deep_copy",["require","exports","module"],function(e,t,n){t.deepCopy=function r(e){if(typeof e!="object"||!e)return e;var t;if(Array.isArray(e)){t=[];for(var n=0;n<e.length;n++)t[n]=r(e[n]);return t}if(Object.prototype.toString.call(e)!=="[object Object]")return e;t={};for(var n in e)t[n]=r(e[n]);return t}}),define("ace/lib/lang",["require","exports","module","ace/lib/deep_copy"],function(e,t,n){"use strict";t.last=function(e){return e[e.length-1]},t.stringReverse=function(e){return e.split("").reverse().join("")},t.stringRepeat=function(e,t){var n="";while(t>0){t&1&&(n+=e);if(t>>=1)e+=e}return n};var r=/^\s\s*/,i=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(r,"")},t.stringTrimRight=function(e){return e.replace(i,"")},t.copyObject=function(e){var t={};for(var n in e)t[n]=e[n];return t},t.copyArray=function(e){var t=[];for(var n=0,r=e.length;n<r;n++)e[n]&&typeof e[n]=="object"?t[n]=this.copyObject(e[n]):t[n]=e[n];return t},t.deepCopy=e("./deep_copy").deepCopy,t.arrayToMap=function(e){var t={};for(var n=0;n<e.length;n++)t[e[n]]=1;return t},t.createMap=function(e){var t=Object.create(null);for(var n in e)t[n]=e[n];return t},t.arrayRemove=function(e,t){for(var n=0;n<=e.length;n++)t===e[n]&&e.splice(n,1)},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1")},t.escapeHTML=function(e){return(""+e).replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;")},t.getMatchOffsets=function(e,t){var n=[];return e.replace(t,function(e){n.push({offset:arguments[arguments.length-2],length:e.length})}),n},t.deferredCall=function(e){var t=null,n=function(){t=null,e()},r=function(e){return r.cancel(),t=setTimeout(n,e||0),r};return r.schedule=r,r.call=function(){return this.cancel(),e(),r},r.cancel=function(){return clearTimeout(t),t=null,r},r.isPending=function(){return t},r},t.delayedCall=function(e,t){var n=null,r=function(){n=null,e()},i=function(e){n==null&&(n=setTimeout(r,e||t))};return i.delay=function(e){n&&clearTimeout(n),n=setTimeout(r,e||t)},i.schedule=i,i.call=function(){this.cancel(),e()},i.cancel=function(){n&&clearTimeout(n),n=null},i.isPending=function(){return n},i},t.supportsLookbehind=function(){try{new RegExp("(?<=.)")}catch(e){return!1}return!0},t.skipEmptyMatch=function(e,t,n){return n&&e.codePointAt(t)>65535?2:1}}),define("ace/lib/useragent",["require","exports","module"],function(e,t,n){"use strict";t.OS={LINUX:"LINUX",MAC:"MAC",WINDOWS:"WINDOWS"},t.getOS=function(){return t.isMac?t.OS.MAC:t.isLinux?t.OS.LINUX:t.OS.WINDOWS};var r=typeof navigator=="object"?navigator:{},i=(/mac|win|linux/i.exec(r.platform)||["other"])[0].toLowerCase(),s=r.userAgent||"",o=r.appName||"";t.isWin=i=="win",t.isMac=i=="mac",t.isLinux=i=="linux",t.isIE=o=="Microsoft Internet Explorer"||o.indexOf("MSAppHost")>=0?parseFloat((s.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]):parseFloat((s.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]),t.isOldIE=t.isIE&&t.isIE<9,t.isGecko=t.isMozilla=s.match(/ Gecko\/\d+/),t.isOpera=typeof opera=="object"&&Object.prototype.toString.call(window["opera"])=="[object Opera]",t.isWebKit=parseFloat(s.split("WebKit/")[1])||undefined,t.isChrome=parseFloat(s.split(" Chrome/")[1])||undefined,t.isSafari=parseFloat(s.split(" Safari/")[1])&&!t.isChrome||undefined,t.isEdge=parseFloat(s.split(" Edge/")[1])||undefined,t.isAIR=s.indexOf("AdobeAIR")>=0,t.isAndroid=s.indexOf("Android")>=0,t.isChromeOS=s.indexOf(" CrOS ")>=0,t.isIOS=/iPad|iPhone|iPod/.test(s)&&!window.MSStream,t.isIOS&&(t.isMac=!0),t.isMobile=t.isIOS||t.isAndroid}),define("ace/lib/dom",["require","exports","module","ace/lib/useragent"],function(e,t,n){"use strict";function u(){var e=o;o=null,e&&e.forEach(function(e){a(e[0],e[1])})}function a(e,n,r){if(typeof document=="undefined")return;if(o)if(r)u();else if(r===!1)return o.push([e,n]);if(s)return;var i=r;if(!r||!r.getRootNode)i=document;else{i=r.getRootNode();if(!i||i==r)i=document}var a=i.ownerDocument||i;if(n&&t.hasCssString(n,i))return null;n&&(e+="\n/*# sourceURL=ace/css/"+n+" */");var f=t.createElement("style");f.appendChild(a.createTextNode(e)),n&&(f.id=n),i==a&&(i=t.getDocumentHead(a)),i.insertBefore(f,i.firstChild)}var r=e("./useragent"),i="http://www.w3.org/1999/xhtml";t.buildDom=function l(e,t,n){if(typeof e=="string"&&e){var r=document.createTextNode(e);return t&&t.appendChild(r),r}if(!Array.isArray(e))return e&&e.appendChild&&t&&t.appendChild(e),e;if(typeof e[0]!="string"||!e[0]){var i=[];for(var s=0;s<e.length;s++){var o=l(e[s],t,n);o&&i.push(o)}return i}var u=document.createElement(e[0]),a=e[1],f=1;a&&typeof a=="object"&&!Array.isArray(a)&&(f=2);for(var s=f;s<e.length;s++)l(e[s],u,n);return f==2&&Object.keys(a).forEach(function(e){var t=a[e];e==="class"?u.className=Array.isArray(t)?t.join(" "):t:typeof t=="function"||e=="value"||e[0]=="$"?u[e]=t:e==="ref"?n&&(n[t]=u):e==="style"?typeof t=="string"&&(u.style.cssText=t):t!=null&&u.setAttribute(e,t)}),t&&t.appendChild(u),u},t.getDocumentHead=function(e){return e||(e=document),e.head||e.getElementsByTagName("head")[0]||e.documentElement},t.createElement=function(e,t){return document.createElementNS?document.createElementNS(t||i,e):document.createElement(e)},t.removeChildren=function(e){e.innerHTML=""},t.createTextNode=function(e,t){var n=t?t.ownerDocument:document;return n.createTextNode(e)},t.createFragment=function(e){var t=e?e.ownerDocument:document;return t.createDocumentFragment()},t.hasCssClass=function(e,t){var n=(e.className+"").split(/\s+/g);return n.indexOf(t)!==-1},t.addCssClass=function(e,n){t.hasCssClass(e,n)||(e.className+=" "+n)},t.removeCssClass=function(e,t){var n=e.className.split(/\s+/g);for(;;){var r=n.indexOf(t);if(r==-1)break;n.splice(r,1)}e.className=n.join(" ")},t.toggleCssClass=function(e,t){var n=e.className.split(/\s+/g),r=!0;for(;;){var i=n.indexOf(t);if(i==-1)break;r=!1,n.splice(i,1)}return r&&n.push(t),e.className=n.join(" "),r},t.setCssClass=function(e,n,r){r?t.addCssClass(e,n):t.removeCssClass(e,n)},t.hasCssString=function(e,t){var n=0,r;t=t||document;if(r=t.querySelectorAll("style"))while(n<r.length)if(r[n++].id===e)return!0},t.removeElementById=function(e,t){t=t||document,t.getElementById(e)&&t.getElementById(e).remove()};var s,o=[];t.useStrictCSP=function(e){s=e,e==0?u():o||(o=[])},t.importCssString=a,t.importCssStylsheet=function(e,n){t.buildDom(["link",{rel:"stylesheet",href:e}],t.getDocumentHead(n))},t.scrollbarWidth=function(e){var n=t.createElement("ace_inner");n.style.width="100%",n.style.minWidth="0px",n.style.height="200px",n.style.display="block";var r=t.createElement("ace_outer"),i=r.style;i.position="absolute",i.left="-10000px",i.overflow="hidden",i.width="200px",i.minWidth="0px",i.height="150px",i.display="block",r.appendChild(n);var s=e&&e.documentElement||document&&document.documentElement;if(!s)return 0;s.appendChild(r);var o=n.offsetWidth;i.overflow="scroll";var u=n.offsetWidth;return o===u&&(u=r.clientWidth),s.removeChild(r),o-u},t.computedStyle=function(e,t){return window.getComputedStyle(e,"")||{}},t.setStyle=function(e,t,n){e[t]!==n&&(e[t]=n)},t.HAS_CSS_ANIMATION=!1,t.HAS_CSS_TRANSFORMS=!1,t.HI_DPI=r.isWin?typeof window!="undefined"&&window.devicePixelRatio>=1.5:!0,r.isChromeOS&&(t.HI_DPI=!1);if(typeof document!="undefined"){var f=document.createElement("div");t.HI_DPI&&f.style.transform!==undefined&&(t.HAS_CSS_TRANSFORMS=!0),!r.isEdge&&typeof f.style.animationName!="undefined"&&(t.HAS_CSS_ANIMATION=!0),f=null}t.HAS_CSS_TRANSFORMS?t.translate=function(e,t,n){e.style.transform="translate("+Math.round(t)+"px, "+Math.round(n)+"px)"}:t.translate=function(e,t,n){e.style.top=Math.round(n)+"px",e.style.left=Math.round(t)+"px"}}),define("ace/lib/net",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./dom");t.get=function(e,t){var n=new XMLHttpRequest;n.open("GET",e,!0),n.onreadystatechange=function(){n.readyState===4&&t(n.responseText)},n.send(null)},t.loadScript=function(e,t){var n=r.getDocumentHead(),i=document.createElement("script");i.src=e,n.appendChild(i),i.onload=i.onreadystatechange=function(e,n){if(n||!i.readyState||i.readyState=="loaded"||i.readyState=="complete")i=i.onload=i.onreadystatechange=null,n||t()}},t.qualifyURL=function(e){var t=document.createElement("a");return t.href=e,t.href}}),define("ace/lib/oop",["require","exports","module"],function(e,t,n){"use strict";t.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})},t.mixin=function(e,t){for(var n in t)e[n]=t[n];return e},t.implement=function(e,n){t.mixin(e,n)}}),define("ace/lib/event_emitter",["require","exports","module"],function(e,t,n){"use strict";var r={},i=function(){this.propagationStopped=!0},s=function(){this.defaultPrevented=!0};r._emit=r._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var n=this._eventRegistry[e]||[],r=this._defaultHandlers[e];if(!n.length&&!r)return;if(typeof t!="object"||!t)t={};t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=i),t.preventDefault||(t.preventDefault=s),n=n.slice();for(var o=0;o<n.length;o++){n[o](t,this);if(t.propagationStopped)break}if(r&&!t.defaultPrevented)return r(t,this)},r._signal=function(e,t){var n=(this._eventRegistry||{})[e];if(!n)return;n=n.slice();for(var r=0;r<n.length;r++)n[r](t,this)},r.once=function(e,t){var n=this;this.on(e,function r(){n.off(e,r),t.apply(null,arguments)});if(!t)return new Promise(function(e){t=e})},r.setDefaultHandler=function(e,t){var n=this._defaultHandlers;n||(n=this._defaultHandlers={_disabled_:{}});if(n[e]){var r=n[e],i=n._disabled_[e];i||(n._disabled_[e]=i=[]),i.push(r);var s=i.indexOf(t);s!=-1&&i.splice(s,1)}n[e]=t},r.removeDefaultHandler=function(e,t){var n=this._defaultHandlers;if(!n)return;var r=n._disabled_[e];if(n[e]==t)r&&this.setDefaultHandler(e,r.pop());else if(r){var i=r.indexOf(t);i!=-1&&r.splice(i,1)}},r.on=r.addEventListener=function(e,t,n){this._eventRegistry=this._eventRegistry||{};var r=this._eventRegistry[e];return r||(r=this._eventRegistry[e]=[]),r.indexOf(t)==-1&&r[n?"unshift":"push"](t),t},r.off=r.removeListener=r.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];if(!n)return;var r=n.indexOf(t);r!==-1&&n.splice(r,1)},r.removeAllListeners=function(e){e||(this._eventRegistry=this._defaultHandlers=undefined),this._eventRegistry&&(this._eventRegistry[e]=undefined),this._defaultHandlers&&(this._defaultHandlers[e]=undefined)},t.EventEmitter=r}),define("ace/lib/report_error",["require","exports","module"],function(e,t,n){t.reportError=function(t,n){var r=new Error(t);r.data=n,typeof console=="object"&&console.error&&console.error(r),setTimeout(function(){throw r})}}),define("ace/lib/default_english_messages",["require","exports","module"],function(e,t,n){var r={"autocomplete.popup.aria-roledescription":"Autocomplete suggestions","autocomplete.popup.aria-label":"Autocomplete suggestions","autocomplete.popup.item.aria-roledescription":"item","autocomplete.loading":"Loading...","editor.scroller.aria-roledescription":"editor","editor.scroller.aria-label":"Editor content, press Enter to start editing, press Escape to exit","editor.gutter.aria-roledescription":"editor gutter","editor.gutter.aria-label":"Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit","error-marker.good-state":"Looks good!","prompt.recently-used":"Recently used","prompt.other-commands":"Other commands","prompt.no-matching-commands":"No matching commands","search-box.find.placeholder":"Search for","search-box.find-all.text":"All","search-box.replace.placeholder":"Replace with","search-box.replace-next.text":"Replace","search-box.replace-all.text":"All","search-box.toggle-replace.title":"Toggle Replace mode","search-box.toggle-regexp.title":"RegExp Search","search-box.toggle-case.title":"CaseSensitive Search","search-box.toggle-whole-word.title":"Whole Word Search","search-box.toggle-in-selection.title":"Search In Selection","search-box.search-counter":"$0 of $1","text-input.aria-roledescription":"editor","text-input.aria-label":"Cursor at row $0","gutter.code-folding.range.aria-label":"Toggle code folding, rows $0 through $1","gutter.code-folding.closed.aria-label":"Toggle code folding, rows $0 through $1","gutter.code-folding.open.aria-label":"Toggle code folding, row $0","gutter.code-folding.closed.title":"Unfold code","gutter.code-folding.open.title":"Fold code","gutter.annotation.aria-label.error":"Error, read annotations row $0","gutter.annotation.aria-label.warning":"Warning, read annotations row $0","gutter.annotation.aria-label.info":"Info, read annotations row $0","inline-fold.closed.title":"Unfold code","gutter-tooltip.aria-label.error.singular":"error","gutter-tooltip.aria-label.error.plural":"errors","gutter-tooltip.aria-label.warning.singular":"warning","gutter-tooltip.aria-label.warning.plural":"warnings","gutter-tooltip.aria-label.info.singular":"information message","gutter-tooltip.aria-label.info.plural":"information messages","gutter.annotation.aria-label.security":"Security finding, read annotations row $0","gutter.annotation.aria-label.hint":"Suggestion, read annotations row $0","gutter-tooltip.aria-label.security.singular":"security finding","gutter-tooltip.aria-label.security.plural":"security findings","gutter-tooltip.aria-label.hint.singular":"suggestion","gutter-tooltip.aria-label.hint.plural":"suggestions","editor.tooltip.disable-editing":"Editing is disabled"};t.defaultEnglishMessages=r}),define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/report_error","ace/lib/default_english_messages"],function(e,t,n){"no use strict";function a(e){typeof console!="undefined"&&console.warn&&console.warn.apply(console,arguments)}var r=e("./oop"),i=e("./event_emitter").EventEmitter,s=e("./report_error").reportError,o=e("./default_english_messages").defaultEnglishMessages,u={setOptions:function(e){Object.keys(e).forEach(function(t){this.setOption(t,e[t])},this)},getOptions:function(e){var t={};if(!e){var n=this.$options;e=Object.keys(n).filter(function(e){return!n[e].hidden})}else Array.isArray(e)||(t=e,e=Object.keys(t));return e.forEach(function(e){t[e]=this.getOption(e)},this),t},setOption:function(e,t){if(this["$"+e]===t)return;var n=this.$options[e];if(!n)return a('misspelled option "'+e+'"');if(n.forwardTo)return this[n.forwardTo]&&this[n.forwardTo].setOption(e,t);n.handlesSet||(this["$"+e]=t),n&&n.set&&n.set.call(this,t)},getOption:function(e){var t=this.$options[e];return t?t.forwardTo?this[t.forwardTo]&&this[t.forwardTo].getOption(e):t&&t.get?t.get.call(this):this["$"+e]:a('misspelled option "'+e+'"')}},f,l,c=function(){function e(){this.$defaultOptions={},f=o,l="dollarSigns"}return e.prototype.defineOptions=function(e,t,n){return e.$options||(this.$defaultOptions[t]=e.$options={}),Object.keys(n).forEach(function(t){var r=n[t];typeof r=="string"&&(r={forwardTo:r}),r.name||(r.name=t),e.$options[r.name]=r,"initialValue"in r&&(e["$"+r.name]=r.initialValue)}),r.implement(e,u),this},e.prototype.resetOptions=function(e){Object.keys(e.$options).forEach(function(t){var n=e.$options[t];"value"in n&&e.setOption(t,n.value)})},e.prototype.setDefaultValue=function(e,t,n){if(!e){for(e in this.$defaultOptions)if(this.$defaultOptions[e][t])break;if(!this.$defaultOptions[e][t])return!1}var r=this.$defaultOptions[e]||(this.$defaultOptions[e]={});r[t]&&(r.forwardTo?this.setDefaultValue(r.forwardTo,t,n):r[t].value=n)},e.prototype.setDefaultValues=function(e,t){Object.keys(t).forEach(function(n){this.setDefaultValue(e,n,t[n])},this)},e.prototype.setMessages=function(e,t){f=e,t&&t.placeholders&&(l=t.placeholders)},e.prototype.nls=function(e,t,n){f[e]||(a("No message found for the key '"+e+"' in messages with id "+f.$id+", trying to find a translation for the default string '"+t+"'."),f[t]||a("No message found for the default string '"+t+"' in the provided messages. Falling back to the default English message."));var r=f[e]||f[t]||t;return n&&(l==="dollarSigns"&&(r=r.replace(/\$(\$|[\d]+)/g,function(e,t){return t=="$"?"$":n[t]})),l==="curlyBrackets"&&(r=r.replace(/\{([^\}]+)\}/g,function(e,t){return n[t]}))),r},e}();c.prototype.warn=a,c.prototype.reportError=s,r.implement(c.prototype,i),t.AppConfig=c}),define("ace/theme/textmate-css",["require","exports","module"],function(e,t,n){n.exports='.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n'}),define("ace/theme/textmate",["require","exports","module","ace/theme/textmate-css","ace/lib/dom"],function(e,t,n){"use strict";t.isDark=!1,t.cssClass="ace-tm",t.cssText=e("./textmate-css"),t.$id="ace/theme/textmate";var r=e("../lib/dom");r.importCssString(t.cssText,t.cssClass,!1)}),define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/net","ace/lib/dom","ace/lib/app_config","ace/theme/textmate"],function(e,t,n){"no use strict";var r=e("./lib/lang"),i=e("./lib/net"),s=e("./lib/dom"),o=e("./lib/app_config").AppConfig;n.exports=t=new o;var u={packaged:!1,workerPath:null,modePath:null,themePath:null,basePath:"",suffix:".js",$moduleUrls:{},loadWorkerFromBlob:!0,sharedPopups:!1,useStrictCSP:null};t.get=function(e){if(!u.hasOwnProperty(e))throw new Error("Unknown config key: "+e);return u[e]},t.set=function(e,t){if(u.hasOwnProperty(e))u[e]=t;else if(this.setDefaultValue("",e,t)==0)throw new Error("Unknown config key: "+e);e=="useStrictCSP"&&s.useStrictCSP(t)},t.all=function(){return r.copyObject(u)},t.$modes={},t.moduleUrl=function(e,t){if(u.$moduleUrls[e])return u.$moduleUrls[e];var n=e.split("/");t=t||n[n.length-2]||"";var r=t=="snippets"?"/":"-",i=n[n.length-1];if(t=="worker"&&r=="-"){var s=new RegExp("^"+t+"[\\-_]|[\\-_]"+t+"$","g");i=i.replace(s,"")}(!i||i==t)&&n.length>1&&(i=n[n.length-2]);var o=u[t+"Path"];return o==null?o=u.basePath:r=="/"&&(t=r=""),o&&o.slice(-1)!="/"&&(o+="/"),o+t+r+i+this.get("suffix")},t.setModuleUrl=function(e,t){return u.$moduleUrls[e]=t};var a=function(t,n){if(t==="ace/theme/textmate"||t==="./theme/textmate")return n(null,e("./theme/textmate"));if(f)return f(t,n);console.error("loader is not configured")},f;t.setLoader=function(e){f=e},t.dynamicModules=Object.create(null),t.$loading={},t.$loaded={},t.loadModule=function(e,n){var r;if(Array.isArray(e))var s=e[0],o=e[1];else if(typeof e=="string")var o=e;var u=function(e){if(e&&!t.$loading[o])return n&&n(e);t.$loading[o]||(t.$loading[o]=[]),t.$loading[o].push(n);if(t.$loading[o].length>1)return;var r=function(){a(o,function(e,n){n&&(t.$loaded[o]=n),t._emit("load.module",{name:o,module:n});var r=t.$loading[o];t.$loading[o]=null,r.forEach(function(e){e&&e(n)})})};if(!t.get("packaged"))return r();i.loadScript(t.moduleUrl(o,s),r),l()};if(t.dynamicModules[o])t.dynamicModules[o]().then(function(e){e.default?u(e.default):u(e)});else{try{r=this.$require(o)}catch(f){}u(r||t.$loaded[o])}},t.$require=function(e){if(typeof n["require"]=="function"){var t="require";return n[t](e)}},t.setModuleLoader=function(e,n){t.dynamicModules[e]=n};var l=function(){!u.basePath&&!u.workerPath&&!u.modePath&&!u.themePath&&!Object.keys(u.$moduleUrls).length&&(console.error("Unable to infer path to ace from script src,","use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes","or with webpack use ace/webpack-resolver"),l=function(){})};t.version="1.39.1"}),define("ace/loader_build",["require","exports","module","ace/lib/fixoldbrowsers","ace/config"],function(e,t,n){"use strict";function s(t){if(!i||!i.document)return;r.set("packaged",t||e.packaged||n.packaged||i.define&&define.packaged);var s={},u="",a=document.currentScript||document._currentScript,f=a&&a.ownerDocument||document;a&&a.src&&(u=a.src.split(/[?#]/)[0].split("/").slice(0,-1).join("/")||"");var l=f.getElementsByTagName("script");for(var c=0;c<l.length;c++){var h=l[c],p=h.src||h.getAttribute("src");if(!p)continue;var d=h.attributes;for(var v=0,m=d.length;v<m;v++){var g=d[v];g.name.indexOf("data-ace-")===0&&(s[o(g.name.replace(/^data-ace-/,""))]=g.value)}var y=p.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);y&&(u=y[1])}u&&(s.base=s.base||u,s.packaged=!0),s.basePath=s.base,s.workerPath=s.workerPath||s.base,s.modePath=s.modePath||s.base,s.themePath=s.themePath||s.base,delete s.base;for(var b in s)typeof s[b]!="undefined"&&r.set(b,s[b])}function o(e){return e.replace(/-(.)/g,function(e,t){return t.toUpperCase()})}e("./lib/fixoldbrowsers");var r=e("./config");r.setLoader(function(t,n){e([t],function(e){n(null,e)})});var i=function(){return this||typeof window!="undefined"&&window}();n.exports=function(t){r.init=s,r.$require=e,t.require=e,typeof define=="function"&&(t.define=define)}}),define("ace/range",["require","exports","module"],function(e,t,n){"use strict";var r=function(){function e(e,t,n,r){this.start={row:e,column:t},this.end={row:n,column:r}}return e.prototype.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column},e.prototype.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},e.prototype.contains=function(e,t){return this.compare(e,t)==0},e.prototype.compareRange=function(e){var t,n=e.end,r=e.start;return t=this.compare(n.row,n.column),t==1?(t=this.compare(r.row,r.column),t==1?2:t==0?1:0):t==-1?-2:(t=this.compare(r.row,r.column),t==-1?-1:t==1?42:0)},e.prototype.comparePoint=function(e){return this.compare(e.row,e.column)},e.prototype.containsRange=function(e){return this.comparePoint(e.start)==0&&this.comparePoint(e.end)==0},e.prototype.intersects=function(e){var t=this.compareRange(e);return t==-1||t==0||t==1},e.prototype.isEnd=function(e,t){return this.end.row==e&&this.end.column==t},e.prototype.isStart=function(e,t){return this.start.row==e&&this.start.column==t},e.prototype.setStart=function(e,t){typeof e=="object"?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t)},e.prototype.setEnd=function(e,t){typeof e=="object"?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t)},e.prototype.inside=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)||this.isStart(e,t)?!1:!0:!1},e.prototype.insideStart=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)?!1:!0:!1},e.prototype.insideEnd=function(e,t){return this.compare(e,t)==0?this.isStart(e,t)?!1:!0:!1},e.prototype.compare=function(e,t){return!this.isMultiLine()&&e===this.start.row?t<this.start.column?-1:t>this.end.column?1:0:e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row===e?t<=this.end.column?0:1:0},e.prototype.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},e.prototype.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t)},e.prototype.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},e.prototype.clipRows=function(t,n){if(this.end.row>n)var r={row:n+1,column:0};else if(this.end.row<t)var r={row:t,column:0};if(this.start.row>n)var i={row:n+1,column:0};else if(this.start.row<t)var i={row:t,column:0};return e.fromPoints(i||this.start,r||this.end)},e.prototype.extend=function(t,n){var r=this.compare(t,n);if(r==0)return this;if(r==-1)var i={row:t,column:n};else var s={row:t,column:n};return e.fromPoints(i||this.start,s||this.end)},e.prototype.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},e.prototype.isMultiLine=function(){return this.start.row!==this.end.row},e.prototype.clone=function(){return e.fromPoints(this.start,this.end)},e.prototype.collapseRows=function(){return this.end.column==0?new e(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new e(this.start.row,0,this.end.row,0)},e.prototype.toScreenRange=function(t){var n=t.documentToScreenPosition(this.start),r=t.documentToScreenPosition(this.end);return new e(n.row,n.column,r.row,r.column)},e.prototype.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t},e}();r.fromPoints=function(e,t){return new r(e.row,e.column,t.row,t.column)},r.comparePoints=function(e,t){return e.row-t.row||e.column-t.column},t.Range=r}),define("ace/lib/keys",["require","exports","module","ace/lib/oop"],function(e,t,n){"use strict";var r=e("./oop"),i={MODIFIER_KEYS:{16:"Shift",17:"Ctrl",18:"Alt",224:"Meta",91:"MetaLeft",92:"MetaRight",93:"ContextMenu"},KEY_MODS:{ctrl:1,alt:2,option:2,shift:4,"super":8,meta:8,command:8,cmd:8,control:1},FUNCTION_KEYS:{8:"Backspace",9:"Tab",13:"Return",19:"Pause",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"Print",45:"Insert",46:"Delete","-13":"NumpadEnter",144:"Numlock",145:"Scrolllock"},PRINTABLE_KEYS:{32:" ",59:";",61:"=",107:"+",109:"-",110:".",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",111:"/",106:"*"}},s={Command:224,Backspace:8,Tab:9,Return:13,Enter:13,Pause:19,Escape:27,PageUp:33,PageDown:34,End:35,Home:36,Insert:45,Delete:46,ArrowLeft:37,ArrowUp:38,ArrowRight:39,ArrowDown:40,Backquote:192,Minus:189,Equal:187,BracketLeft:219,Backslash:220,BracketRight:221,Semicolon:186,Quote:222,Comma:188,Period:190,Slash:191,Space:32,NumpadAdd:107,NumpadDecimal:110,NumpadSubtract:109,NumpadDivide:111,NumpadMultiply:106};for(var o=0;o<10;o++)s["Digit"+o]=48+o,s["Numpad"+o]=96+o,i.PRINTABLE_KEYS[48+o]=""+o,i.FUNCTION_KEYS[96+o]="Numpad"+o;for(var o=65;o<91;o++){var u=String.fromCharCode(o+32);s["Key"+u.toUpperCase()]=o,i.PRINTABLE_KEYS[o]=u}for(var o=1;o<13;o++)s["F"+o]=111+o,i.FUNCTION_KEYS[111+o]="F"+o;var a={Shift:16,Control:17,Alt:18,Meta:224};for(var f in a)s[f]=s[f+"Left"]=s[f+"Right"]=a[f];t.$codeToKeyCode=s,i.PRINTABLE_KEYS[173]="-";for(var l in i.FUNCTION_KEYS){var c=i.FUNCTION_KEYS[l].toLowerCase();i[c]=parseInt(l,10)}for(var l in i.PRINTABLE_KEYS){var c=i.PRINTABLE_KEYS[l].toLowerCase();i[c]=parseInt(l,10)}r.mixin(i,i.MODIFIER_KEYS),r.mixin(i,i.PRINTABLE_KEYS),r.mixin(i,i.FUNCTION_KEYS),i.enter=i["return"],i.escape=i.esc,i.del=i["delete"],function(){var e=["cmd","ctrl","alt","shift"];for(var t=Math.pow(2,e.length);t--;)i.KEY_MODS[t]=e.filter(function(e){return t&i.KEY_MODS[e]}).join("-")+"-"}(),i.KEY_MODS[0]="",i.KEY_MODS[-1]="input-",r.mixin(t,i),t.default=t,t.keyCodeToString=function(e){var t=i[e];return typeof t!="string"&&(t=String.fromCharCode(e)),t.toLowerCase()}}),define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function a(){u=!1;try{document.createComment("").addEventListener("test",function(){},{get passive(){return u={passive:!1},!0}})}catch(e){}}function f(){return u==undefined&&a(),u}function l(e,t,n){this.elem=e,this.type=t,this.callback=n}function p(e){return 0|(e.ctrlKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.metaKey?8:0)}function d(e,t,n){var u=p(t);!n&&t.code&&(n=r.$codeToKeyCode[t.code]||n);if(!i.isMac&&s){t.getModifierState&&(t.getModifierState("OS")||t.getModifierState("Win"))&&(u|=8);if(s.altGr){if((3&u)==3)return;s.altGr=0}if(n===18||n===17){var a=t.location;if(n===17&&a===1)s[n]==1&&(o=t.timeStamp);else if(n===18&&u===3&&a===2){var f=t.timeStamp-o;f<50&&(s.altGr=!0)}}}n in r.MODIFIER_KEYS&&(n=-1);if(!u&&n===13&&t.location===3){e(t,u,-n);if(t.defaultPrevented)return}if(i.isChromeOS&&u&8){e(t,u,n);if(t.defaultPrevented)return;u&=-9}return!!u||n in r.FUNCTION_KEYS||n in r.PRINTABLE_KEYS?e(t,u,n):!1}function v(){s=Object.create(null)}var r=e("./keys"),i=e("./useragent"),s=null,o=0,u;l.prototype.destroy=function(){h(this.elem,this.type,this.callback),this.elem=this.type=this.callback=undefined};var c=t.addListener=function(e,t,n,r){e.addEventListener(t,n,f()),r&&r.$toDestroy.push(new l(e,t,n))},h=t.removeListener=function(e,t,n){e.removeEventListener(t,n,f())};t.stopEvent=function(e){return t.stopPropagation(e),t.preventDefault(e),!1},t.stopPropagation=function(e){e.stopPropagation&&e.stopPropagation()},t.preventDefault=function(e){e.preventDefault&&e.preventDefault()},t.getButton=function(e){return e.type=="dblclick"?0:e.type=="contextmenu"||i.isMac&&e.ctrlKey&&!e.altKey&&!e.shiftKey?2:e.button},t.capture=function(e,t,n){function i(e){t&&t(e),n&&n(e),h(r,"mousemove",t),h(r,"mouseup",i),h(r,"dragstart",i)}var r=e&&e.ownerDocument||document;return c(r,"mousemove",t),c(r,"mouseup",i),c(r,"dragstart",i),i},t.addMouseWheelListener=function(e,t,n){c(e,"wheel",function(e){var n=.15,r=e.deltaX||0,i=e.deltaY||0;switch(e.deltaMode){case e.DOM_DELTA_PIXEL:e.wheelX=r*n,e.wheelY=i*n;break;case e.DOM_DELTA_LINE:var s=15;e.wheelX=r*s,e.wheelY=i*s;break;case e.DOM_DELTA_PAGE:var o=150;e.wheelX=r*o,e.wheelY=i*o}t(e)},n)},t.addMultiMouseDownListener=function(e,n,r,s,o){function p(e){t.getButton(e)!==0?u=0:e.detail>1?(u++,u>4&&(u=1)):u=1;if(i.isIE){var o=Math.abs(e.clientX-a)>5||Math.abs(e.clientY-f)>5;if(!l||o)u=1;l&&clearTimeout(l),l=setTimeout(function(){l=null},n[u-1]||600),u==1&&(a=e.clientX,f=e.clientY)}e._clicks=u,r[s]("mousedown",e);if(u>4)u=0;else if(u>1)return r[s](h[u],e)}var u=0,a,f,l,h={2:"dblclick",3:"tripleclick",4:"quadclick"};Array.isArray(e)||(e=[e]),e.forEach(function(e){c(e,"mousedown",p,o)})},t.getModifierString=function(e){return r.KEY_MODS[p(e)]},t.addCommandKeyListener=function(e,n,r){var i=null;c(e,"keydown",function(e){s[e.keyCode]=(s[e.keyCode]||0)+1;var t=d(n,e,e.keyCode);return i=e.defaultPrevented,t},r),c(e,"keypress",function(e){i&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&(t.stopEvent(e),i=null)},r),c(e,"keyup",function(e){s[e.keyCode]=null},r),s||(v(),c(window,"focus",v))};if(typeof window=="object"&&window.postMessage&&!i.isOldIE){var m=1;t.nextTick=function(e,n){n=n||window;var r="zero-timeout-message-"+m++,i=function(s){s.data==r&&(t.stopPropagation(s),h(n,"message",i),e())};c(n,"message",i),n.postMessage(r,"*")}}t.$idleBlocked=!1,t.onIdle=function(e,n){return setTimeout(function r(){t.$idleBlocked?setTimeout(r,100):e()},n)},t.$idleBlockId=null,t.blockIdle=function(e){t.$idleBlockId&&clearTimeout(t.$idleBlockId),t.$idleBlocked=!0,t.$idleBlockId=setTimeout(function(){t.$idleBlocked=!1},e||100)},t.nextFrame=typeof window=="object"&&(window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame),t.nextFrame?t.nextFrame=t.nextFrame.bind(window):t.nextFrame=function(e){setTimeout(e,17)}}),define("ace/clipboard",["require","exports","module"],function(e,t,n){"use strict";var r;n.exports={lineMode:!1,pasteCancelled:function(){return r&&r>Date.now()-50?!0:r=!1},cancel:function(){r=Date.now()}}}),define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/config","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/clipboard","ace/lib/keys"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../config").nls,s=e("../lib/useragent"),o=e("../lib/dom"),u=e("../lib/lang"),a=e("../clipboard"),f=s.isChrome<18,l=s.isIE,c=s.isChrome>63,h=400,p=e("../lib/keys"),d=p.KEY_MODS,v=s.isIOS,m=v?/\s/:/\n/,g=s.isMobile,y;y=function(e,t){function Q(){T=!0,n.blur(),n.focus(),T=!1}function Y(e){e.keyCode==27&&n.value.length<n.selectionStart&&(w||(N=n.value),C=k=-1,H()),G()}function et(){clearTimeout(Z),Z=setTimeout(function(){S&&(n.style.cssText=S,S=""),t.renderer.$isMousePressed=!1,t.renderer.$keepTextAreaAtCursor&&t.renderer.$moveTextAreaToCursor()},0)}function nt(e,t,n){var r=null,i=!1;n.addEventListener("keydown",function(e){r&&clearTimeout(r),i=!0},!0),n.addEventListener("keyup",function(e){r=setTimeout(function(){i=!1},100)},!0);var s=function(e){if(document.activeElement!==n)return;if(i||w||t.$mouseHandler.isMousePressed)return;if(y)return;var r=n.selectionStart,s=n.selectionEnd,o=null,u=0;if(r==0)o=p.up;else if(r==1)o=p.home;else if(s>k&&N[s]=="\n")o=p.end;else if(r<C&&N[r-1]==" ")o=p.left,u=d.option;else if(r<C||r==C&&k!=C&&r==s)o=p.left;else if(s>k&&N.slice(0,s).split("\n").length>2)o=p.down;else if(s>k&&N[s-1]==" ")o=p.right,u=d.option;else if(s>k||s==k&&k!=C&&r==s)o=p.right;r!==s&&(u|=d.shift);if(o){var a=t.onCommandKey({},u,o);if(!a&&t.commands){o=p.keyCodeToString(o);var f=t.commands.findKeyCommand(u,o);f&&t.execCommand(f)}C=r,k=s,H("")}};document.addEventListener("selectionchange",s),t.on("destroy",function(){document.removeEventListener("selectionchange",s)})}var n=o.createElement("textarea");n.className="ace_text-input",n.setAttribute("wrap","off"),n.setAttribute("autocorrect","off"),n.setAttribute("autocapitalize","off"),n.setAttribute("spellcheck","false"),n.style.opacity="0",e.insertBefore(n,e.firstChild);var y=!1,b=!1,w=!1,E=!1,S="";g||(n.style.fontSize="1px");var x=!1,T=!1,N="",C=0,k=0,L=0,A=Number.MAX_SAFE_INTEGER,O=Number.MIN_SAFE_INTEGER,M=0;try{var _=document.activeElement===n}catch(D){}this.setNumberOfExtraLines=function(e){A=Number.MAX_SAFE_INTEGER,O=Number.MIN_SAFE_INTEGER;if(e<0){M=0;return}M=e},this.setAriaLabel=function(){var e="";t.$textInputAriaLabel&&(e+="".concat(t.$textInputAriaLabel,", "));if(t.session){var r=t.session.selection.cursor.row;e+=i("text-input.aria-label","Cursor at row $0",[r+1])}n.setAttribute("aria-label",e)},this.setAriaOptions=function(e){e.activeDescendant?(n.setAttribute("aria-haspopup","true"),n.setAttribute("aria-autocomplete",e.inline?"both":"list"),n.setAttribute("aria-activedescendant",e.activeDescendant)):(n.setAttribute("aria-haspopup","false"),n.setAttribute("aria-autocomplete","both"),n.removeAttribute("aria-activedescendant")),e.role&&n.setAttribute("role",e.role),e.setLabel&&(n.setAttribute("aria-roledescription",i("text-input.aria-roledescription","editor")),this.setAriaLabel())},this.setAriaOptions({role:"textbox"}),r.addListener(n,"blur",function(e){if(T)return;t.onBlur(e),_=!1},t),r.addListener(n,"focus",function(e){if(T)return;_=!0;if(s.isEdge)try{if(!document.hasFocus())return}catch(e){}t.onFocus(e),s.isEdge?setTimeout(H):H()},t),this.$focusScroll=!1,this.focus=function(){this.setAriaOptions({setLabel:t.renderer.enableKeyboardAccessibility});if(S||c||this.$focusScroll=="browser")return n.focus({preventScroll:!0});var e=n.style.top;n.style.position="fixed",n.style.top="0px";try{var r=n.getBoundingClientRect().top!=0}catch(i){return}var s=[];if(r){var o=n.parentElement;while(o&&o.nodeType==1)s.push(o),o.setAttribute("ace_nocontext","true"),!o.parentElement&&o.getRootNode?o=o.getRootNode().host:o=o.parentElement}n.focus({preventScroll:!0}),r&&s.forEach(function(e){e.removeAttribute("ace_nocontext")}),setTimeout(function(){n.style.position="",n.style.top=="0px"&&(n.style.top=e)},0)},this.blur=function(){n.blur()},this.isFocused=function(){return _},t.on("beforeEndOperation",function(){var e=t.curOp,r=e&&e.command&&e.command.name;if(r=="insertstring")return;var i=r&&(e.docChanged||e.selectionChanged);w&&i&&(N=n.value="",K()),H()}),t.on("changeSelection",this.setAriaLabel);var P=function(e,n){var r=n;for(var i=1;i<=e-A&&i<2*M+1;i++)r+=t.session.getLine(e-i).length+1;return r},H=v?function(e){if(!_||y&&!e||E)return;e||(e="");var r="\n ab"+e+"cde fg\n";r!=n.value&&(n.value=N=r);var i=4,s=4+(e.length||(t.selection.isEmpty()?0:1));(C!=i||k!=s)&&n.setSelectionRange(i,s),C=i,k=s}:function(){if(w||E)return;if(!_&&!I)return;w=!0;var e=0,r=0,i="";if(t.session){var s=t.selection,o=s.getRange(),u=s.cursor.row;if(u===O+1)A=O+1,O=A+2*M;else if(u===A-1)O=A-1,A=O-2*M;else if(u<A-1||u>O+1)A=u>M?u-M:0,O=u>M?u+M:2*M;var a=[];for(var f=A;f<=O;f++)a.push(t.session.getLine(f));i=a.join("\n"),e=P(o.start.row,o.start.column),r=P(o.end.row,o.end.column);if(o.start.row<A){var l=t.session.getLine(A-1);e=o.start.row<A-1?0:e,r+=l.length+1,i=l+"\n"+i}else if(o.end.row>O){var c=t.session.getLine(O+1);r=o.end.row>O+1?c.length:o.end.column,r+=i.length+1,i=i+"\n"+c}else g&&u>0&&(i="\n"+i,r+=1,e+=1);i.length>h&&(e<h&&r<h?i=i.slice(0,h):(i="\n",e==r?e=r=0:(e=0,r=1)));var p=i+"\n\n";p!=N&&(n.value=N=p,C=k=p.length)}I&&(C=n.selectionStart,k=n.selectionEnd);if(k!=r||C!=e||n.selectionEnd!=k)try{n.setSelectionRange(e,r),C=e,k=r}catch(d){}w=!1};this.resetSelection=H,_&&t.onFocus();var B=function(e){return e.selectionStart===0&&e.selectionEnd>=N.length&&e.value===N&&N&&e.selectionEnd!==k},j=function(e){if(w)return;y?y=!1:B(n)?(t.selectAll(),H()):g&&n.selectionStart!=C&&H()},F=null;this.setInputHandler=function(e){F=e},this.getInputHandler=function(){return F};var I=!1,q=function(e,r){I&&(I=!1);if(b)return H(),e&&t.onPaste(e),b=!1,"";var i=n.selectionStart,o=n.selectionEnd,u=C,a=N.length-k,f=e,l=e.length-i,c=e.length-o,h=0;while(u>0&&N[h]==e[h])h++,u--;f=f.slice(h),h=1;while(a>0&&N.length-h>C-1&&N[N.length-h]==e[e.length-h])h++,a--;l-=h-1,c-=h-1;var p=f.length-h+1;p<0&&(u=-p,p=0),f=f.slice(0,p);if(!r&&!f&&!l&&!u&&!a&&!c)return"";E=!0;var d=!1;return s.isAndroid&&f==". "&&(f="  ",d=!0),f&&!u&&!a&&!l&&!c||x?t.onTextInput(f):t.onTextInput(f,{extendLeft:u,extendRight:a,restoreStart:l,restoreEnd:c}),E=!1,N=e,C=i,k=o,L=c,d?"\n":f},R=function(e){if(w)return J();if(e&&e.inputType){if(e.inputType=="historyUndo")return t.execCommand("undo");if(e.inputType=="historyRedo")return t.execCommand("redo")}var r=n.value,i=q(r,!0);(r.length>h+100||m.test(i)||g&&C<1&&C==k)&&H()},U=function(e,t,n){var r=e.clipboardData||window.clipboardData;if(!r||f)return;var i=l||n?"Text":"text/plain";try{return t?r.setData(i,t)!==!1:r.getData(i)}catch(e){if(!n)return U(e,t,!0)}},z=function(e,i){var s=t.getCopyText();if(!s)return r.preventDefault(e);U(e,s)?(v&&(H(s),y=s,setTimeout(function(){y=!1},10)),i?t.onCut():t.onCopy(),r.preventDefault(e)):(y=!0,n.value=s,n.select(),setTimeout(function(){y=!1,H(),i?t.onCut():t.onCopy()}))},W=function(e){z(e,!0)},X=function(e){z(e,!1)},V=function(e){var i=U(e);if(a.pasteCancelled())return;typeof i=="string"?(i&&t.onPaste(i,e),s.isIE&&setTimeout(H),r.preventDefault(e)):(n.value="",b=!0)};r.addCommandKeyListener(n,function(e,n,r){if(w)return;return t.onCommandKey(e,n,r)},t),r.addListener(n,"select",j,t),r.addListener(n,"input",R,t),r.addListener(n,"cut",W,t),r.addListener(n,"copy",X,t),r.addListener(n,"paste",V,t),(!("oncut"in n)||!("oncopy"in n)||!("onpaste"in n))&&r.addListener(e,"keydown",function(e){if(s.isMac&&!e.metaKey||!e.ctrlKey)return;switch(e.keyCode){case 67:X(e);break;case 86:V(e);break;case 88:W(e)}},t);var $=function(e){if(w||!t.onCompositionStart||t.$readOnly)return;w={};if(x)return;e.data&&(w.useTextareaForIME=!1),setTimeout(J,0),t._signal("compositionStart"),t.on("mousedown",Q);var r=t.getSelectionRange();r.end.row=r.start.row,r.end.column=r.start.column,w.markerRange=r,w.selectionStart=C,t.onCompositionStart(w),w.useTextareaForIME?(N=n.value="",C=0,k=0):(n.msGetInputContext&&(w.context=n.msGetInputContext()),n.getInputContext&&(w.context=n.getInputContext()))},J=function(){if(!w||!t.onCompositionUpdate||t.$readOnly)return;if(x)return Q();if(w.useTextareaForIME)t.onCompositionUpdate(n.value);else{var e=n.value;q(e),w.markerRange&&(w.context&&(w.markerRange.start.column=w.selectionStart=w.context.compositionStartOffset),w.markerRange.end.column=w.markerRange.start.column+k-w.selectionStart+L)}},K=function(e){if(!t.onCompositionEnd||t.$readOnly)return;w=!1,t.onCompositionEnd(),t.off("mousedown",Q),e&&R()},G=u.delayedCall(J,50).schedule.bind(null,null);r.addListener(n,"compositionstart",$,t),r.addListener(n,"compositionupdate",J,t),r.addListener(n,"keyup",Y,t),r.addListener(n,"keydown",G,t),r.addListener(n,"compositionend",K,t),this.getElement=function(){return n},this.setCommandMode=function(e){x=e,n.readOnly=!1},this.setReadOnly=function(e){x||(n.readOnly=e)},this.setCopyWithEmptySelection=function(e){},this.onContextMenu=function(e){I=!0,H(),t._emit("nativecontextmenu",{target:t,domEvent:e}),this.moveToMouse(e,!0)},this.moveToMouse=function(e,i){S||(S=n.style.cssText),n.style.cssText=(i?"z-index:100000;":"")+(s.isIE?"opacity:0.1;":"")+"text-indent: -"+(C+k)*t.renderer.characterWidth*.5+"px;";var u=t.container.getBoundingClientRect(),a=o.computedStyle(t.container),f=u.top+(parseInt(a.borderTopWidth)||0),l=u.left+(parseInt(a.borderLeftWidth)||0),c=u.bottom-f-n.clientHeight-2,h=function(e){o.translate(n,e.clientX-l-2,Math.min(e.clientY-f-2,c))};h(e);if(e.type!="mousedown")return;t.renderer.$isMousePressed=!0,clearTimeout(Z),s.isWin&&r.capture(t.container,h,et)},this.onContextMenuClose=et;var Z,tt=function(e){t.textInput.onContextMenu(e),et()};r.addListener(n,"mouseup",tt,t),r.addListener(n,"mousedown",function(e){e.preventDefault(),et()},t),r.addListener(t.renderer.scroller,"contextmenu",tt,t),r.addListener(n,"contextmenu",tt,t),v&&nt(e,t,n),this.destroy=function(){n.parentElement&&n.parentElement.removeChild(n)}},t.TextInput=y,t.$setUserAgentForTests=function(e,t){g=e,v=t}}),define("ace/mouse/default_handlers",["require","exports","module","ace/lib/useragent"],function(e,t,n){"use strict";function u(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}function a(e,t){if(e.start.row==e.end.row)var n=2*t.column-e.start.column-e.end.column;else if(e.start.row==e.end.row-1&&!e.start.column&&!e.end.column)var n=t.column-4;else var n=2*t.row-e.start.row-e.end.row;return n<0?{cursor:e.start,anchor:e.end}:{cursor:e.end,anchor:e.start}}var r=e("../lib/useragent"),i=0,s=550,o=function(){function e(e){e.$clickSelection=null;var t=e.editor;t.setDefaultHandler("mousedown",this.onMouseDown.bind(e)),t.setDefaultHandler("dblclick",this.onDoubleClick.bind(e)),t.setDefaultHandler("tripleclick",this.onTripleClick.bind(e)),t.setDefaultHandler("quadclick",this.onQuadClick.bind(e)),t.setDefaultHandler("mousewheel",this.onMouseWheel.bind(e));var n=["select","startSelect","selectEnd","selectAllEnd","selectByWordsEnd","selectByLinesEnd","dragWait","dragWaitEnd","focusWait"];n.forEach(function(t){e[t]=this[t]},this),e.selectByLines=this.extendSelectionBy.bind(e,"getLineRange"),e.selectByWords=this.extendSelectionBy.bind(e,"getWordRange")}return e.prototype.onMouseDown=function(e){var t=e.inSelection(),n=e.getDocumentPosition();this.mousedownEvent=e;var i=this.editor,s=e.getButton();if(s!==0){var o=i.getSelectionRange(),u=o.isEmpty();(u||s==1)&&i.selection.moveToPosition(n),s==2&&(i.textInput.onContextMenu(e.domEvent),r.isMozilla||e.preventDefault());return}this.mousedownEvent.time=Date.now();if(t&&!i.isFocused()){i.focus();if(this.$focusTimeout&&!this.$clickSelection&&!i.inMultiSelectMode){this.setState("focusWait"),this.captureMouse(e);return}}return this.captureMouse(e),this.startSelect(n,e.domEvent._clicks>1),e.preventDefault()},e.prototype.startSelect=function(e,t){e=e||this.editor.renderer.screenToTextCoordinates(this.x,this.y);var n=this.editor;if(!this.mousedownEvent)return;this.mousedownEvent.getShiftKey()?n.selection.selectToPosition(e):t||n.selection.moveToPosition(e),t||this.select(),n.setStyle("ace_selecting"),this.setState("select")},e.prototype.select=function(){var e,t=this.editor,n=t.renderer.screenToTextCoordinates(this.x,this.y);if(this.$clickSelection){var r=this.$clickSelection.comparePoint(n);if(r==-1)e=this.$clickSelection.end;else if(r==1)e=this.$clickSelection.start;else{var i=a(this.$clickSelection,n);n=i.cursor,e=i.anchor}t.selection.setSelectionAnchor(e.row,e.column)}t.selection.selectToPosition(n),t.renderer.scrollCursorIntoView()},e.prototype.extendSelectionBy=function(e){var t,n=this.editor,r=n.renderer.screenToTextCoordinates(this.x,this.y),i=n.selection[e](r.row,r.column);if(this.$clickSelection){var s=this.$clickSelection.comparePoint(i.start),o=this.$clickSelection.comparePoint(i.end);if(s==-1&&o<=0){t=this.$clickSelection.end;if(i.end.row!=r.row||i.end.column!=r.column)r=i.start}else if(o==1&&s>=0){t=this.$clickSelection.start;if(i.start.row!=r.row||i.start.column!=r.column)r=i.end}else if(s==-1&&o==1)r=i.end,t=i.start;else{var u=a(this.$clickSelection,r);r=u.cursor,t=u.anchor}n.selection.setSelectionAnchor(t.row,t.column)}n.selection.selectToPosition(r),n.renderer.scrollCursorIntoView()},e.prototype.selectByLinesEnd=function(){this.$clickSelection=null,this.editor.unsetStyle("ace_selecting")},e.prototype.focusWait=function(){var e=u(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y),t=Date.now();(e>i||t-this.mousedownEvent.time>this.$focusTimeout)&&this.startSelect(this.mousedownEvent.getDocumentPosition())},e.prototype.onDoubleClick=function(e){var t=e.getDocumentPosition(),n=this.editor,r=n.session,i=r.getBracketRange(t);i?(i.isEmpty()&&(i.start.column--,i.end.column++),this.setState("select")):(i=n.selection.getWordRange(t.row,t.column),this.setState("selectByWords")),this.$clickSelection=i,this.select()},e.prototype.onTripleClick=function(e){var t=e.getDocumentPosition(),n=this.editor;this.setState("selectByLines");var r=n.getSelectionRange();r.isMultiLine()&&r.contains(t.row,t.column)?(this.$clickSelection=n.selection.getLineRange(r.start.row),this.$clickSelection.end=n.selection.getLineRange(r.end.row).end):this.$clickSelection=n.selection.getLineRange(t.row),this.select()},e.prototype.onQuadClick=function(e){var t=this.editor;t.selectAll(),this.$clickSelection=t.getSelectionRange(),this.setState("selectAll")},e.prototype.onMouseWheel=function(e){if(e.getAccelKey())return;e.getShiftKey()&&e.wheelY&&!e.wheelX&&(e.wheelX=e.wheelY,e.wheelY=0);var t=this.editor;this.$lastScroll||(this.$lastScroll={t:0,vx:0,vy:0,allowed:0});var n=this.$lastScroll,r=e.domEvent.timeStamp,i=r-n.t,o=i?e.wheelX/i:n.vx,u=i?e.wheelY/i:n.vy;i<s&&(o=(o+n.vx)/2,u=(u+n.vy)/2);var a=Math.abs(o/u),f=!1;a>=1&&t.renderer.isScrollableBy(e.wheelX*e.speed,0)&&(f=!0),a<=1&&t.renderer.isScrollableBy(0,e.wheelY*e.speed)&&(f=!0);if(f)n.allowed=r;else if(r-n.allowed<s){var l=Math.abs(o)<=1.5*Math.abs(n.vx)&&Math.abs(u)<=1.5*Math.abs(n.vy);l?(f=!0,n.allowed=r):n.allowed=0}n.t=r,n.vx=o,n.vy=u;if(f)return t.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()},e}();o.prototype.selectEnd=o.prototype.selectByLinesEnd,o.prototype.selectAllEnd=o.prototype.selectByLinesEnd,o.prototype.selectByWordsEnd=o.prototype.selectByLinesEnd,t.DefaultHandlers=o}),define("ace/lib/scroll",["require","exports","module"],function(e,t,n){t.preventParentScroll=function(t){t.stopPropagation();var n=t.currentTarget,r=n.scrollHeight>n.clientHeight;r||t.preventDefault()}}),define("ace/tooltip",["require","exports","module","ace/lib/dom","ace/lib/event","ace/range","ace/lib/scroll"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},s=e("./lib/dom"),o=e("./lib/event"),u=e("./range").Range,a=e("./lib/scroll").preventParentScroll,f="ace_tooltip",l=function(){function e(e){this.isOpen=!1,this.$element=null,this.$parentNode=e}return e.prototype.$init=function(){return this.$element=s.createElement("div"),this.$element.className=f,this.$element.style.display="none",this.$parentNode.appendChild(this.$element),this.$element},e.prototype.getElement=function(){return this.$element||this.$init()},e.prototype.setText=function(e){this.getElement().textContent=e},e.prototype.setHtml=function(e){this.getElement().innerHTML=e},e.prototype.setPosition=function(e,t){this.getElement().style.left=e+"px",this.getElement().style.top=t+"px"},e.prototype.setClassName=function(e){s.addCssClass(this.getElement(),e)},e.prototype.setTheme=function(e){this.$element.className=f+" "+(e.isDark?"ace_dark ":"")+(e.cssClass||"")},e.prototype.show=function(e,t,n){e!=null&&this.setText(e),t!=null&&n!=null&&this.setPosition(t,n),this.isOpen||(this.getElement().style.display="block",this.isOpen=!0)},e.prototype.hide=function(e){this.isOpen&&(this.getElement().style.display="none",this.getElement().className=f,this.isOpen=!1)},e.prototype.getHeight=function(){return this.getElement().offsetHeight},e.prototype.getWidth=function(){return this.getElement().offsetWidth},e.prototype.destroy=function(){this.isOpen=!1,this.$element&&this.$element.parentNode&&this.$element.parentNode.removeChild(this.$element)},e}(),c=function(){function e(){this.popups=[]}return e.prototype.addPopup=function(e){this.popups.push(e),this.updatePopups()},e.prototype.removePopup=function(e){var t=this.popups.indexOf(e);t!==-1&&(this.popups.splice(t,1),this.updatePopups())},e.prototype.updatePopups=function(){var e,t,n,r;this.popups.sort(function(e,t){return t.priority-e.priority});var s=[];try{for(var o=i(this.popups),u=o.next();!u.done;u=o.next()){var a=u.value,f=!0;try{for(var l=(n=void 0,i(s)),c=l.next();!c.done;c=l.next()){var h=c.value;if(this.doPopupsOverlap(h,a)){f=!1;break}}}catch(p){n={error:p}}finally{try{c&&!c.done&&(r=l.return)&&r.call(l)}finally{if(n)throw n.error}}f?s.push(a):a.hide()}}catch(d){e={error:d}}finally{try{u&&!u.done&&(t=o.return)&&t.call(o)}finally{if(e)throw e.error}}},e.prototype.doPopupsOverlap=function(e,t){var n=e.getElement().getBoundingClientRect(),r=t.getElement().getBoundingClientRect();return n.left<r.right&&n.right>r.left&&n.top<r.bottom&&n.bottom>r.top},e}(),h=new c;t.popupManager=h,t.Tooltip=l;var p=function(e){function t(t){t===void 0&&(t=document.body);var n=e.call(this,t)||this;n.timeout=undefined,n.lastT=0,n.idleTime=350,n.lastEvent=undefined,n.onMouseOut=n.onMouseOut.bind(n),n.onMouseMove=n.onMouseMove.bind(n),n.waitForHover=n.waitForHover.bind(n),n.hide=n.hide.bind(n);var r=n.getElement();return r.style.whiteSpace="pre-wrap",r.style.pointerEvents="auto",r.addEventListener("mouseout",n.onMouseOut),r.tabIndex=-1,r.addEventListener("blur",function(){r.contains(document.activeElement)||this.hide()}.bind(n)),r.addEventListener("wheel",a),n}return r(t,e),t.prototype.addToEditor=function(e){e.on("mousemove",this.onMouseMove),e.on("mousedown",this.hide),e.renderer.getMouseEventTarget().addEventListener("mouseout",this.onMouseOut,!0)},t.prototype.removeFromEditor=function(e){e.off("mousemove",this.onMouseMove),e.off("mousedown",this.hide),e.renderer.getMouseEventTarget().removeEventListener("mouseout",this.onMouseOut,!0),this.timeout&&(clearTimeout(this.timeout),this.timeout=null)},t.prototype.onMouseMove=function(e,t){this.lastEvent=e,this.lastT=Date.now();var n=t.$mouseHandler.isMousePressed;if(this.isOpen){var r=this.lastEvent&&this.lastEvent.getDocumentPosition();(!this.range||!this.range.contains(r.row,r.column)||n||this.isOutsideOfText(this.lastEvent))&&this.hide()}if(this.timeout||n)return;this.lastEvent=e,this.timeout=setTimeout(this.waitForHover,this.idleTime)},t.prototype.waitForHover=function(){this.timeout&&clearTimeout(this.timeout);var e=Date.now()-this.lastT;if(this.idleTime-e>10){this.timeout=setTimeout(this.waitForHover,this.idleTime-e);return}this.timeout=null,this.lastEvent&&!this.isOutsideOfText(this.lastEvent)&&this.$gatherData(this.lastEvent,this.lastEvent.editor)},t.prototype.isOutsideOfText=function(e){var t=e.editor,n=e.getDocumentPosition(),r=t.session.getLine(n.row);if(n.column==r.length){var i=t.renderer.pixelToScreenCoordinates(e.clientX,e.clientY),s=t.session.documentToScreenPosition(n.row,n.column);if(s.column!=i.column||s.row!=i.row)return!0}return!1},t.prototype.setDataProvider=function(e){this.$gatherData=e},t.prototype.showForRange=function(e,t,n,r){var i=10;if(r&&r!=this.lastEvent)return;if(this.isOpen&&document.activeElement==this.getElement())return;var s=e.renderer;this.isOpen||(h.addPopup(this),this.$registerCloseEvents(),this.setTheme(s.theme)),this.isOpen=!0,this.addMarker(t,e.session),this.range=u.fromPoints(t.start,t.end);var o=s.textToScreenCoordinates(t.start.row,t.start.column),a=s.scroller.getBoundingClientRect();o.pageX<a.left&&(o.pageX=a.left);var f=this.getElement();f.innerHTML="",f.appendChild(n),f.style.maxHeight="",f.style.display="block";var l=f.clientHeight,c=f.clientWidth,p=window.innerHeight-o.pageY-s.lineHeight,d=!0;o.pageY-l<0&&o.pageY<p&&(d=!1),f.style.maxHeight=(d?o.pageY:p)-i+"px",f.style.top=d?"":o.pageY+s.lineHeight+"px",f.style.bottom=d?window.innerHeight-o.pageY+"px":"",f.style.left=Math.min(o.pageX,window.innerWidth-c-i)+"px"},t.prototype.addMarker=function(e,t){this.marker&&this.$markerSession.removeMarker(this.marker),this.$markerSession=t,this.marker=t&&t.addMarker(e,"ace_highlight-marker","text")},t.prototype.hide=function(e){if(!e&&document.activeElement==this.getElement())return;if(e&&e.target&&(e.type!="keydown"||e.ctrlKey||e.metaKey)&&this.$element.contains(e.target))return;this.lastEvent=null,this.timeout&&clearTimeout(this.timeout),this.timeout=null,this.addMarker(null),this.isOpen&&(this.$removeCloseEvents(),this.getElement().style.display="none",this.isOpen=!1,h.removePopup(this))},t.prototype.$registerCloseEvents=function(){window.addEventListener("keydown",this.hide,!0),window.addEventListener("wheel",this.hide,!0),window.addEventListener("mousedown",this.hide,!0)},t.prototype.$removeCloseEvents=function(){window.removeEventListener("keydown",this.hide,!0),window.removeEventListener("wheel",this.hide,!0),window.removeEventListener("mousedown",this.hide,!0)},t.prototype.onMouseOut=function(e){this.timeout&&(clearTimeout(this.timeout),this.timeout=null),this.lastEvent=null;if(!this.isOpen)return;if(!e.relatedTarget||this.getElement().contains(e.relatedTarget))return;if(e&&e.currentTarget.contains(e.relatedTarget))return;e.relatedTarget.classList.contains("ace_content")||this.hide()},t}(l);t.HoverTooltip=p}),define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/tooltip","ace/config"],function(e,t,n){"use strict";function c(e){function a(){var i=u.getDocumentPosition().row,s=t.session.getLength();if(i==s){var o=t.renderer.pixelToScreenCoordinates(0,u.y).row,a=u.$pos;if(o>t.session.documentToScreenRow(a.row,a.column))return c()}r.showTooltip(i);if(!r.isOpen)return;t.on("mousewheel",c),t.on("changeSession",c),window.addEventListener("keydown",c,!0);if(e.$tooltipFollowsMouse)p(u);else{var h=u.getGutterRow(),d=n.$lines.get(h);if(d){var v=d.element.querySelector(".ace_gutter_annotation"),m=v.getBoundingClientRect(),g=r.getElement().style;g.left=m.right-f+"px",g.top=m.bottom-l+"px"}else p(u)}}function c(e){if(e&&e.type==="keydown"&&(e.ctrlKey||e.metaKey))return;if(e&&e.type==="mouseout"&&(!e.relatedTarget||r.getElement().contains(e.relatedTarget)))return;i&&(i=clearTimeout(i)),r.isOpen&&(r.hideTooltip(),t.off("mousewheel",c),t.off("changeSession",c),window.removeEventListener("keydown",c,!0))}function p(e){r.setPosition(e.x,e.y)}var t=e.editor,n=t.renderer.$gutterLayer,r=new h(t,!0);e.editor.setDefaultHandler("guttermousedown",function(r){if(!t.isFocused()||r.getButton()!=0)return;var i=n.getRegion(r);if(i=="foldWidgets")return;var s=r.getDocumentPosition().row,o=t.session.selection;if(r.getShiftKey())o.selectTo(s,0);else{if(r.domEvent.detail==2)return t.selectAll(),r.preventDefault();e.$clickSelection=t.selection.getLineRange(s)}return e.setState("selectByLines"),e.captureMouse(r),r.preventDefault()});var i,u;e.editor.setDefaultHandler("guttermousemove",function(t){var n=t.domEvent.target||t.domEvent.srcElement;if(s.hasCssClass(n,"ace_fold-widget"))return c();r.isOpen&&e.$tooltipFollowsMouse&&p(t),u=t;if(i)return;i=setTimeout(function(){i=null,u&&!e.isMousePressed&&a()},50)}),o.addListener(t.renderer.$gutter,"mouseout",function(e){u=null;if(!r.isOpen)return;i=setTimeout(function(){i=null,c(e)},50)},t)}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},s=e("../lib/dom"),o=e("../lib/event"),u=e("../tooltip").Tooltip,a=e("../config").nls,f=5,l=3;t.GUTTER_TOOLTIP_LEFT_OFFSET=f,t.GUTTER_TOOLTIP_TOP_OFFSET=l,t.GutterHandler=c;var h=function(e){function t(t,n){n===void 0&&(n=!1);var r=e.call(this,t.container)||this;r.editor=t,r.visibleTooltipRow;var i=r.getElement();return i.setAttribute("role","tooltip"),i.style.pointerEvents="auto",n&&(r.onMouseOut=r.onMouseOut.bind(r),i.addEventListener("mouseout",r.onMouseOut)),r}return r(t,e),t.prototype.onMouseOut=function(e){if(!this.isOpen)return;if(!e.relatedTarget||this.getElement().contains(e.relatedTarget))return;if(e&&e.currentTarget.contains(e.relatedTarget))return;this.hideTooltip()},t.prototype.setPosition=function(e,t){var n=window.innerWidth||document.documentElement.clientWidth,r=window.innerHeight||document.documentElement.clientHeight,i=this.getWidth(),s=this.getHeight();e+=15,t+=15,e+i>n&&(e-=e+i-n),t+s>r&&(t-=20+s),u.prototype.setPosition.call(this,e,t)},Object.defineProperty(t,"annotationLabels",{get:function(){return{error:{singular:a("gutter-tooltip.aria-label.error.singular","error"),plural:a("gutter-tooltip.aria-label.error.plural","errors")},security:{singular:a("gutter-tooltip.aria-label.security.singular","security finding"),plural:a("gutter-tooltip.aria-label.security.plural","security findings")},warning:{singular:a("gutter-tooltip.aria-label.warning.singular","warning"),plural:a("gutter-tooltip.aria-label.warning.plural","warnings")},info:{singular:a("gutter-tooltip.aria-label.info.singular","information message"),plural:a("gutter-tooltip.aria-label.info.plural","information messages")},hint:{singular:a("gutter-tooltip.aria-label.hint.singular","suggestion"),plural:a("gutter-tooltip.aria-label.hint.plural","suggestions")}}},enumerable:!1,configurable:!0}),t.prototype.showTooltip=function(e){var n,r=this.editor.renderer.$gutterLayer,i=r.$annotations[e],o;i?o={displayText:Array.from(i.displayText),type:Array.from(i.type)}:o={displayText:[],type:[]};var u=r.session.getFoldLine(e);if(u&&r.$showFoldedAnnotations){var a={error:[],security:[],warning:[],info:[],hint:[]},f={error:1,security:2,warning:3,info:4,hint:5},l;for(var c=e+1;c<=u.end.row;c++){if(!r.$annotations[c])continue;for(var h=0;h<r.$annotations[c].text.length;h++){var p=r.$annotations[c].type[h];a[p].push(r.$annotations[c].text[h]);if(!l||f[p]<f[l])l=p}}if(["error","security","warning"].includes(l)){var d="".concat(t.annotationsToSummaryString(a)," in folded code.");o.displayText.push(d),o.type.push(l+"_fold")}}if(o.displayText.length===0)return this.hideTooltip();var v={error:[],security:[],warning:[],info:[],hint:[]},m=r.$useSvgGutterIcons?"ace_icon_svg":"ace_icon";for(var c=0;c<o.displayText.length;c++){var g=s.createElement("span"),y=s.createElement("span");(n=y.classList).add.apply(n,["ace_".concat(o.type[c]),m]),y.setAttribute("aria-label","".concat(t.annotationLabels[o.type[c].replace("_fold","")].singular)),y.setAttribute("role","img"),y.appendChild(s.createTextNode(" ")),g.appendChild(y),g.appendChild(s.createTextNode(o.displayText[c])),g.appendChild(s.createElement("br")),v[o.type[c].replace("_fold","")].push(g)}var b=this.getElement();s.removeChildren(b),v.error.forEach(function(e){return b.appendChild(e)}),v.security.forEach(function(e){return b.appendChild(e)}),v.warning.forEach(function(e){return b.appendChild(e)}),v.info.forEach(function(e){return b.appendChild(e)}),v.hint.forEach(function(e){return b.appendChild(e)}),b.setAttribute("aria-live","polite"),this.isOpen||(this.setTheme(this.editor.renderer.theme),this.setClassName("ace_gutter-tooltip")),this.show(),this.visibleTooltipRow=e,this.editor._signal("showGutterTooltip",this)},t.prototype.hideTooltip=function(){if(!this.isOpen)return;this.$element.removeAttribute("aria-live"),this.hide(),this.visibleTooltipRow=undefined,this.editor._signal("hideGutterTooltip",this)},t.annotationsToSummaryString=function(e){var n,r,s=[],o=["error","security","warning","info","hint"];try{for(var u=i(o),a=u.next();!a.done;a=u.next()){var f=a.value;if(!e[f].length)continue;var l=e[f].length===1?t.annotationLabels[f].singular:t.annotationLabels[f].plural;s.push("".concat(e[f].length," ").concat(l))}}catch(c){n={error:c}}finally{try{a&&!a.done&&(r=u.return)&&r.call(u)}finally{if(n)throw n.error}}return s.join(", ")},t}(u);t.GutterTooltip=h}),define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=function(){function e(e,t){this.speed,this.wheelX,this.wheelY,this.domEvent=e,this.editor=t,this.x=this.clientX=e.clientX,this.y=this.clientY=e.clientY,this.$pos=null,this.$inSelection=null,this.propagationStopped=!1,this.defaultPrevented=!1}return e.prototype.stopPropagation=function(){r.stopPropagation(this.domEvent),this.propagationStopped=!0},e.prototype.preventDefault=function(){r.preventDefault(this.domEvent),this.defaultPrevented=!0},e.prototype.stop=function(){this.stopPropagation(),this.preventDefault()},e.prototype.getDocumentPosition=function(){return this.$pos?this.$pos:(this.$pos=this.editor.renderer.screenToTextCoordinates(this.clientX,this.clientY),this.$pos)},e.prototype.getGutterRow=function(){var e=this.getDocumentPosition().row,t=this.editor.session.documentToScreenRow(e,0),n=this.editor.session.documentToScreenRow(this.editor.renderer.$gutterLayer.$lines.get(0).row,0);return t-n},e.prototype.inSelection=function(){if(this.$inSelection!==null)return this.$inSelection;var e=this.editor,t=e.getSelectionRange();if(t.isEmpty())this.$inSelection=!1;else{var n=this.getDocumentPosition();this.$inSelection=t.contains(n.row,n.column)}return this.$inSelection},e.prototype.getButton=function(){return r.getButton(this.domEvent)},e.prototype.getShiftKey=function(){return this.domEvent.shiftKey},e.prototype.getAccelKey=function(){return i.isMac?this.domEvent.metaKey:this.domEvent.ctrlKey},e}();t.MouseEvent=s}),define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";function f(e){function T(e,n){var r=Date.now(),i=!n||e.row!=n.row,s=!n||e.column!=n.column;if(!S||i||s)t.moveCursorToPosition(e),S=r,x={x:p,y:d};else{var o=l(x.x,x.y,p,d);o>a?S=null:r-S>=u&&(t.renderer.scrollCursorIntoView(),S=null)}}function N(e,n){var r=Date.now(),i=t.renderer.layerConfig.lineHeight,s=t.renderer.layerConfig.characterWidth,u=t.renderer.scroller.getBoundingClientRect(),a={x:{left:p-u.left,right:u.right-p},y:{top:d-u.top,bottom:u.bottom-d}},f=Math.min(a.x.left,a.x.right),l=Math.min(a.y.top,a.y.bottom),c={row:e.row,column:e.column};f/s<=2&&(c.column+=a.x.left<a.x.right?-3:2),l/i<=1&&(c.row+=a.y.top<a.y.bottom?-1:1);var h=e.row!=c.row,v=e.column!=c.column,m=!n||e.row!=n.row;h||v&&!m?E?r-E>=o&&t.renderer.scrollCursorIntoView(c):E=r:E=null}function C(){var e=g;g=t.renderer.screenToTextCoordinates(p,d),T(g,e),N(g,e)}function k(){m=t.selection.toOrientedRange(),h=t.session.addMarker(m,"ace_selection",t.getSelectionStyle()),t.clearSelection(),t.isFocused()&&t.renderer.$cursorLayer.setBlinking(!1),clearInterval(v),C(),v=setInterval(C,20),y=0,i.addListener(document,"mousemove",O)}function L(){clearInterval(v),t.session.removeMarker(h),h=null,t.selection.fromOrientedRange(m),t.isFocused()&&!w&&t.$resetCursorStyle(),m=null,g=null,y=0,E=null,S=null,i.removeListener(document,"mousemove",O)}function O(){A==null&&(A=setTimeout(function(){A!=null&&h&&L()},20))}function M(e){var t=e.types;return!t||Array.prototype.some.call(t,function(e){return e=="text/plain"||e=="Text"})}function _(e){var t=["copy","copymove","all","uninitialized"],n=["move","copymove","linkmove","all","uninitialized"],r=s.isMac?e.altKey:e.ctrlKey,i="uninitialized";try{i=e.dataTransfer.effectAllowed.toLowerCase()}catch(e){}var o="none";return r&&t.indexOf(i)>=0?o="copy":n.indexOf(i)>=0?o="move":t.indexOf(i)>=0&&(o="copy"),o}var t=e.editor,n=r.createElement("div");n.style.cssText="top:-100px;position:absolute;z-index:2147483647;opacity:0.5",n.textContent="\u00a0";var f=["dragWait","dragWaitEnd","startDrag","dragReadyEnd","onMouseDrag"];f.forEach(function(t){e[t]=this[t]},this),t.on("mousedown",this.onMouseDown.bind(e));var c=t.container,h,p,d,v,m,g,y=0,b,w,E,S,x;this.onDragStart=function(e){if(this.cancelDrag||!c.draggable){var r=this;return setTimeout(function(){r.startSelect(),r.captureMouse(e)},0),e.preventDefault()}m=t.getSelectionRange();var i=e.dataTransfer;i.effectAllowed=t.getReadOnly()?"copy":"copyMove",t.container.appendChild(n),i.setDragImage&&i.setDragImage(n,0,0),setTimeout(function(){t.container.removeChild(n)}),i.clearData(),i.setData("Text",t.session.getTextRange()),w=!0,this.setState("drag")},this.onDragEnd=function(e){c.draggable=!1,w=!1,this.setState(null);if(!t.getReadOnly()){var n=e.dataTransfer.dropEffect;!b&&n=="move"&&t.session.remove(t.getSelectionRange()),t.$resetCursorStyle()}this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle("")},this.onDragEnter=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||k(),y++,e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragOver=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||(k(),y++),A!==null&&(A=null),e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragLeave=function(e){y--;if(y<=0&&h)return L(),b=null,i.preventDefault(e)},this.onDrop=function(e){if(!g)return;var n=e.dataTransfer;if(w)switch(b){case"move":m.contains(g.row,g.column)?m={start:g,end:g}:m=t.moveText(m,g);break;case"copy":m=t.moveText(m,g,!0)}else{var r=n.getData("Text");m={start:g,end:t.session.insert(g,r)},t.focus(),b=null}return L(),i.preventDefault(e)},i.addListener(c,"dragstart",this.onDragStart.bind(e),t),i.addListener(c,"dragend",this.onDragEnd.bind(e),t),i.addListener(c,"dragenter",this.onDragEnter.bind(e),t),i.addListener(c,"dragover",this.onDragOver.bind(e),t),i.addListener(c,"dragleave",this.onDragLeave.bind(e),t),i.addListener(c,"drop",this.onDrop.bind(e),t);var A=null}function l(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}var r=e("../lib/dom"),i=e("../lib/event"),s=e("../lib/useragent"),o=200,u=200,a=5;(function(){this.dragWait=function(){var e=Date.now()-this.mousedownEvent.time;e>this.editor.getDragDelay()&&this.startDrag()},this.dragWaitEnd=function(){var e=this.editor.container;e.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()),this.selectEnd()},this.dragReadyEnd=function(e){this.editor.$resetCursorStyle(),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle(""),this.dragWaitEnd()},this.startDrag=function(){this.cancelDrag=!1;var e=this.editor,t=e.container;t.draggable=!0,e.renderer.$cursorLayer.setBlinking(!1),e.setStyle("ace_dragging");var n=s.isWin?"default":"move";e.renderer.setCursorStyle(n),this.setState("dragReady")},this.onMouseDrag=function(e){var t=this.editor.container;if(s.isIE&&this.state=="dragReady"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>3&&t.dragDrop()}if(this.state==="dragWait"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>0&&(t.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()))}},this.onMouseDown=function(e){if(!this.$dragEnabled)return;this.mousedownEvent=e;var t=this.editor,n=e.inSelection(),r=e.getButton(),i=e.domEvent.detail||1;if(i===1&&r===0&&n){if(e.editor.inMultiSelectMode&&(e.getAccelKey()||e.getShiftKey()))return;this.mousedownEvent.time=Date.now();var o=e.domEvent.target||e.domEvent.srcElement;"unselectable"in o&&(o.unselectable="on");if(t.getDragDelay()){if(s.isWebKit){this.cancelDrag=!0;var u=t.container;u.draggable=!0}this.setState("dragWait")}else this.startDrag();this.captureMouse(e,this.onMouseDrag.bind(this)),e.defaultPrevented=!0}}}).call(f.prototype),t.DragdropHandler=f}),define("ace/mouse/touch_handler",["require","exports","module","ace/mouse/mouse_event","ace/lib/event","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./mouse_event").MouseEvent,i=e("../lib/event"),s=e("../lib/dom");t.addTouchListeners=function(e,t){function b(){var e=window.navigator&&window.navigator.clipboard,r=!1,i=function(){var n=t.getCopyText(),i=t.session.getUndoManager().hasUndo();y.replaceChild(s.buildDom(r?["span",!n&&o("selectall")&&["span",{"class":"ace_mobile-button",action:"selectall"},"Select All"],n&&o("copy")&&["span",{"class":"ace_mobile-button",action:"copy"},"Copy"],n&&o("cut")&&["span",{"class":"ace_mobile-button",action:"cut"},"Cut"],e&&o("paste")&&["span",{"class":"ace_mobile-button",action:"paste"},"Paste"],i&&o("undo")&&["span",{"class":"ace_mobile-button",action:"undo"},"Undo"],o("find")&&["span",{"class":"ace_mobile-button",action:"find"},"Find"],o("openCommandPalette")&&["span",{"class":"ace_mobile-button",action:"openCommandPalette"},"Palette"]]:["span"]),y.firstChild)},o=function(e){return t.commands.canExecute(e,t)},u=function(n){var s=n.target.getAttribute("action");if(s=="more"||!r)return r=!r,i();if(s=="paste")e.readText().then(function(e){t.execCommand(s,e)});else if(s){if(s=="cut"||s=="copy")e?e.writeText(t.getCopyText()):document.execCommand("copy");t.execCommand(s)}y.firstChild.style.display="none",r=!1,s!="openCommandPalette"&&t.focus()};y=s.buildDom(["div",{"class":"ace_mobile-menu",ontouchstart:function(e){n="menu",e.stopPropagation(),e.preventDefault(),t.textInput.focus()},ontouchend:function(e){e.stopPropagation(),e.preventDefault(),u(e)},onclick:u},["span"],["span",{"class":"ace_mobile-button",action:"more"},"..."]],t.container)}function w(){if(!t.getOption("enableMobileMenu")){y&&E();return}y||b();var e=t.selection.cursor,n=t.renderer.textToScreenCoordinates(e.row,e.column),r=t.renderer.textToScreenCoordinates(0,0).pageX,i=t.renderer.scrollLeft,s=t.container.getBoundingClientRect();y.style.top=n.pageY-s.top-3+"px",n.pageX-s.left<s.width-70?(y.style.left="",y.style.right="10px"):(y.style.right="",y.style.left=r+i-s.left+"px"),y.style.display="",y.firstChild.style.display="none",t.on("input",E)}function E(e){y&&(y.style.display="none"),t.off("input",E)}function S(){l=null,clearTimeout(l);var e=t.selection.getRange(),r=e.contains(p.row,p.column);if(e.isEmpty()||!r)t.selection.moveToPosition(p),t.selection.selectWord();n="wait",w()}function x(){l=null,clearTimeout(l),t.selection.moveToPosition(p);var e=d>=2?t.selection.getLineRange(p.row):t.session.getBracketRange(p);e&&!e.isEmpty()?t.selection.setRange(e):t.selection.selectWord(),n="wait"}function T(){h+=60,c=setInterval(function(){h--<=0&&(clearInterval(c),c=null),Math.abs(v)<.01&&(v=0),Math.abs(m)<.01&&(m=0),h<20&&(v=.9*v),h<20&&(m=.9*m);var e=t.session.getScrollTop();t.renderer.scrollBy(10*v,10*m),e==t.session.getScrollTop()&&(h=0)},10)}var n="scroll",o,u,a,f,l,c,h=0,p,d=0,v=0,m=0,g,y;i.addListener(e,"contextmenu",function(e){if(!g)return;var n=t.textInput.getElement();n.focus()},t),i.addListener(e,"touchstart",function(e){var i=e.touches;if(l||i.length>1){clearTimeout(l),l=null,a=-1,n="zoom";return}g=t.$mouseHandler.isMousePressed=!0;var s=t.renderer.layerConfig.lineHeight,c=t.renderer.layerConfig.lineHeight,y=e.timeStamp;f=y;var b=i[0],w=b.clientX,E=b.clientY;Math.abs(o-w)+Math.abs(u-E)>s&&(a=-1),o=e.clientX=w,u=e.clientY=E,v=m=0;var T=new r(e,t);p=T.getDocumentPosition();if(y-a<500&&i.length==1&&!h)d++,e.preventDefault(),e.button=0,x();else{d=0;var N=t.selection.cursor,C=t.selection.isEmpty()?N:t.selection.anchor,k=t.renderer.$cursorLayer.getPixelPosition(N,!0),L=t.renderer.$cursorLayer.getPixelPosition(C,!0),A=t.renderer.scroller.getBoundingClientRect(),O=t.renderer.layerConfig.offset,M=t.renderer.scrollLeft,_=function(e,t){return e/=c,t=t/s-.75,e*e+t*t};if(e.clientX<A.left){n="zoom";return}var D=_(e.clientX-A.left-k.left+M,e.clientY-A.top-k.top+O),P=_(e.clientX-A.left-L.left+M,e.clientY-A.top-L.top+O);D<3.5&&P<3.5&&(n=D>P?"cursor":"anchor"),P<3.5?n="anchor":D<3.5?n="cursor":n="scroll",l=setTimeout(S,450)}a=y},t),i.addListener(e,"touchend",function(e){g=t.$mouseHandler.isMousePressed=!1,c&&clearInterval(c),n=="zoom"?(n="",h=0):l?(t.selection.moveToPosition(p),h=0,w()):n=="scroll"?(T(),E()):w(),clearTimeout(l),l=null},t),i.addListener(e,"touchmove",function(e){l&&(clearTimeout(l),l=null);var i=e.touches;if(i.length>1||n=="zoom")return;var s=i[0],a=o-s.clientX,c=u-s.clientY;if(n=="wait"){if(!(a*a+c*c>4))return e.preventDefault();n="cursor"}o=s.clientX,u=s.clientY,e.clientX=s.clientX,e.clientY=s.clientY;var h=e.timeStamp,p=h-f;f=h;if(n=="scroll"){var d=new r(e,t);d.speed=1,d.wheelX=a,d.wheelY=c,10*Math.abs(a)<Math.abs(c)&&(a=0),10*Math.abs(c)<Math.abs(a)&&(c=0),p!=0&&(v=a/p,m=c/p),t._emit("mousewheel",d),d.propagationStopped||(v=m=0)}else{var g=new r(e,t),y=g.getDocumentPosition();n=="cursor"?t.selection.moveCursorToPosition(y):n=="anchor"&&t.selection.setSelectionAnchor(y.row,y.column),t.renderer.scrollCursorIntoView(y),e.preventDefault()}},t)}}),define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/mouse/touch_handler","ace/config"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=e("./default_handlers").DefaultHandlers,o=e("./default_gutter_handler").GutterHandler,u=e("./mouse_event").MouseEvent,a=e("./dragdrop_handler").DragdropHandler,f=e("./touch_handler").addTouchListeners,l=e("../config"),c=function(){function e(e){this.$dragDelay,this.$dragEnabled,this.$mouseMoved,this.mouseEvent,this.$focusTimeout;var t=this;this.editor=e,new s(this),new o(this),new a(this);var n=function(t){var n=!document.hasFocus||!document.hasFocus()||!e.isFocused()&&document.activeElement==(e.textInput&&e.textInput.getElement());n&&window.focus(),e.focus(),setTimeout(function(){e.isFocused()||e.focus()})},u=e.renderer.getMouseEventTarget();r.addListener(u,"click",this.onMouseEvent.bind(this,"click"),e),r.addListener(u,"mousemove",this.onMouseMove.bind(this,"mousemove"),e),r.addMultiMouseDownListener([u,e.renderer.scrollBarV&&e.renderer.scrollBarV.inner,e.renderer.scrollBarH&&e.renderer.scrollBarH.inner,e.textInput&&e.textInput.getElement()].filter(Boolean),[400,300,250],this,"onMouseEvent",e),r.addMouseWheelListener(e.container,this.onMouseWheel.bind(this,"mousewheel"),e),f(e.container,e);var l=e.renderer.$gutter;r.addListener(l,"mousedown",this.onMouseEvent.bind(this,"guttermousedown"),e),r.addListener(l,"click",this.onMouseEvent.bind(this,"gutterclick"),e),r.addListener(l,"dblclick",this.onMouseEvent.bind(this,"gutterdblclick"),e),r.addListener(l,"mousemove",this.onMouseEvent.bind(this,"guttermousemove"),e),r.addListener(u,"mousedown",n,e),r.addListener(l,"mousedown",n,e),i.isIE&&e.renderer.scrollBarV&&(r.addListener(e.renderer.scrollBarV.element,"mousedown",n,e),r.addListener(e.renderer.scrollBarH.element,"mousedown",n,e)),e.on("mousemove",function(n){if(t.state||t.$dragDelay||!t.$dragEnabled)return;var r=e.renderer.screenToTextCoordinates(n.x,n.y),i=e.session.selection.getRange(),s=e.renderer;!i.isEmpty()&&i.insideStart(r.row,r.column)?s.setCursorStyle("default"):s.setCursorStyle("")},e)}return e.prototype.onMouseEvent=function(e,t){if(!this.editor.session)return;this.editor._emit(e,new u(t,this.editor))},e.prototype.onMouseMove=function(e,t){var n=this.editor._eventRegistry&&this.editor._eventRegistry.mousemove;if(!n||!n.length)return;this.editor._emit(e,new u(t,this.editor))},e.prototype.onMouseWheel=function(e,t){var n=new u(t,this.editor);n.speed=this.$scrollSpeed*2,n.wheelX=t.wheelX,n.wheelY=t.wheelY,this.editor._emit(e,n)},e.prototype.setState=function(e){this.state=e},e.prototype.captureMouse=function(e,t){this.x=e.x,this.y=e.y,this.isMousePressed=!0;var n=this.editor,s=this.editor.renderer;s.$isMousePressed=!0;var o=this,a=function(e){if(!e)return;if(i.isWebKit&&!e.which&&o.releaseMouse)return o.releaseMouse();o.x=e.clientX,o.y=e.clientY,t&&t(e),o.mouseEvent=new u(e,o.editor),o.$mouseMoved=!0},f=function(e){n.off("beforeEndOperation",c),clearInterval(h),n.session&&l(),o[o.state+"End"]&&o[o.state+"End"](e),o.state="",o.isMousePressed=s.$isMousePressed=!1,s.$keepTextAreaAtCursor&&s.$moveTextAreaToCursor(),o.$onCaptureMouseMove=o.releaseMouse=null,e&&o.onMouseEvent("mouseup",e),n.endOperation()},l=function(){o[o.state]&&o[o.state](),o.$mouseMoved=!1};if(i.isOldIE&&e.domEvent.type=="dblclick")return setTimeout(function(){f(e)});var c=function(e){if(!o.releaseMouse)return;n.curOp.command.name&&n.curOp.selectionChanged&&(o[o.state+"End"]&&o[o.state+"End"](),o.state="",o.releaseMouse())};n.on("beforeEndOperation",c),n.startOperation({command:{name:"mouse"}}),o.$onCaptureMouseMove=a,o.releaseMouse=r.capture(this.editor.container,a,f);var h=setInterval(l,20)},e.prototype.cancelContextMenu=function(){var e=function(t){if(t&&t.domEvent&&t.domEvent.type!="contextmenu")return;this.editor.off("nativecontextmenu",e),t&&t.domEvent&&r.stopEvent(t.domEvent)}.bind(this);setTimeout(e,10),this.editor.on("nativecontextmenu",e)},e.prototype.destroy=function(){this.releaseMouse&&this.releaseMouse()},e}();c.prototype.releaseMouse=null,l.defineOptions(c.prototype,"mouseHandler",{scrollSpeed:{initialValue:2},dragDelay:{initialValue:i.isMac?150:0},dragEnabled:{initialValue:!0},focusTimeout:{initialValue:0},tooltipFollowsMouse:{initialValue:!0}}),t.MouseHandler=c}),define("ace/mouse/fold_handler",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e){e.on("click",function(t){var n=t.getDocumentPosition(),i=e.session,s=i.getFoldAt(n.row,n.column,1);s&&(t.getAccelKey()?i.removeFold(s):i.expandFold(s),t.stop());var o=t.domEvent&&t.domEvent.target;o&&r.hasCssClass(o,"ace_inline_button")&&r.hasCssClass(o,"ace_toggle_wrap")&&(i.setOption("wrap",!i.getUseWrapMode()),e.renderer.scrollCursorIntoView())}),e.on("gutterclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session;i.foldWidgets&&i.foldWidgets[r]&&e.session.onFoldWidgetClick(r,t),e.isFocused()||e.focus(),t.stop()}}),e.on("gutterdblclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session,s=i.getParentFoldRangeData(r,!0),o=s.range||s.firstRange;if(o){r=o.start.row;var u=i.getFoldAt(r,i.getLine(r).length,1);u?i.removeFold(u):(i.addFold("...",o),e.renderer.scrollCursorIntoView({row:o.start.row,column:0}))}t.stop()}})}return e}();t.FoldHandler=i}),define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"],function(e,t,n){"use strict";var r=e("../lib/keys"),i=e("../lib/event"),s=function(){function e(e){this.$editor=e,this.$data={editor:e},this.$handlers=[],this.setDefaultHandler(e.commands)}return e.prototype.setDefaultHandler=function(e){this.removeKeyboardHandler(this.$defaultHandler),this.$defaultHandler=e,this.addKeyboardHandler(e,0)},e.prototype.setKeyboardHandler=function(e){var t=this.$handlers;if(t[t.length-1]==e)return;while(t[t.length-1]&&t[t.length-1]!=this.$defaultHandler)this.removeKeyboardHandler(t[t.length-1]);this.addKeyboardHandler(e,1)},e.prototype.addKeyboardHandler=function(e,t){if(!e)return;typeof e=="function"&&!e.handleKeyboard&&(e.handleKeyboard=e);var n=this.$handlers.indexOf(e);n!=-1&&this.$handlers.splice(n,1),t==undefined?this.$handlers.push(e):this.$handlers.splice(t,0,e),n==-1&&e.attach&&e.attach(this.$editor)},e.prototype.removeKeyboardHandler=function(e){var t=this.$handlers.indexOf(e);return t==-1?!1:(this.$handlers.splice(t,1),e.detach&&e.detach(this.$editor),!0)},e.prototype.getKeyboardHandler=function(){return this.$handlers[this.$handlers.length-1]},e.prototype.getStatusText=function(){var e=this.$data,t=e.editor;return this.$handlers.map(function(n){return n.getStatusText&&n.getStatusText(t,e)||""}).filter(Boolean).join(" ")},e.prototype.$callKeyboardHandlers=function(e,t,n,r){var s,o=!1,u=this.$editor.commands;for(var a=this.$handlers.length;a--;){s=this.$handlers[a].handleKeyboard(this.$data,e,t,n,r);if(!s||!s.command)continue;s.command=="null"?o=!0:o=u.exec(s.command,this.$editor,s.args,r),o&&r&&e!=-1&&s["passEvent"]!=1&&s.command["passEvent"]!=1&&i.stopEvent(r);if(o)break}return!o&&e==-1&&(s={command:"insertstring"},o=u.exec("insertstring",this.$editor,t)),o&&this.$editor._signal&&this.$editor._signal("keyboardActivity",s),o},e.prototype.onCommandKey=function(e,t,n){var i=r.keyCodeToString(n);return this.$callKeyboardHandlers(t,i,n,e)},e.prototype.onTextInput=function(e){return this.$callKeyboardHandlers(-1,e)},e}();t.KeyBinding=s}),define("ace/lib/bidiutil",["require","exports","module"],function(e,t,n){"use strict";function F(e,t,n,r){var i=s?d:p,c=null,h=null,v=null,m=0,g=null,y=null,b=-1,w=null,E=null,T=[];if(!r)for(w=0,r=[];w<n;w++)r[w]=R(e[w]);o=s,u=!1,a=!1,f=!1,l=!1;for(E=0;E<n;E++){c=m,T[E]=h=q(e,r,T,E),m=i[c][h],g=m&240,m&=15,t[E]=v=i[m][5];if(g>0)if(g==16){for(w=b;w<E;w++)t[w]=1;b=-1}else b=-1;y=i[m][6];if(y)b==-1&&(b=E);else if(b>-1){for(w=b;w<E;w++)t[w]=v;b=-1}r[E]==S&&(t[E]=0),o|=v}if(l)for(w=0;w<n;w++)if(r[w]==x){t[w]=s;for(var C=w-1;C>=0;C--){if(r[C]!=N)break;t[C]=s}}}function I(e,t,n){if(o<e)return;if(e==1&&s==m&&!f){n.reverse();return}var r=n.length,i=0,u,a,l,c;while(i<r){if(t[i]>=e){u=i+1;while(u<r&&t[u]>=e)u++;for(a=i,l=u-1;a<l;a++,l--)c=n[a],n[a]=n[l],n[l]=c;i=u}i++}}function q(e,t,n,r){var i=t[r],o,c,h,p;switch(i){case g:case y:u=!1;case E:case w:return i;case b:return u?w:b;case T:return u=!0,a=!0,y;case N:return E;case C:if(r<1||r+1>=t.length||(o=n[r-1])!=b&&o!=w||(c=t[r+1])!=b&&c!=w)return E;return u&&(c=w),c==o?c:E;case k:o=r>0?n[r-1]:S;if(o==b&&r+1<t.length&&t[r+1]==b)return b;return E;case L:if(r>0&&n[r-1]==b)return b;if(u)return E;p=r+1,h=t.length;while(p<h&&t[p]==L)p++;if(p<h&&t[p]==b)return b;return E;case A:h=t.length,p=r+1;while(p<h&&t[p]==A)p++;if(p<h){var d=e[r],v=d>=1425&&d<=2303||d==64286;o=t[p];if(v&&(o==y||o==T))return y}if(r<1||(o=t[r-1])==S)return E;return n[r-1];case S:return u=!1,f=!0,s;case x:return l=!0,E;case O:case M:case D:case P:case _:u=!1;case H:return E}}function R(e){var t=e.charCodeAt(0),n=t>>8;return n==0?t>191?g:B[t]:n==5?/[\u0591-\u05f4]/.test(e)?y:g:n==6?/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e)?A:/[\u0660-\u0669\u066b-\u066c]/.test(e)?w:t==1642?L:/[\u06f0-\u06f9]/.test(e)?b:T:n==32&&t<=8287?j[t&255]:n==254?t>=65136?T:E:E}function U(e){return e>="\u064b"&&e<="\u0655"}var r=["\u0621","\u0641"],i=["\u063a","\u064a"],s=0,o=0,u=!1,a=!1,f=!1,l=!1,c=!1,h=!1,p=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],d=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v=0,m=1,g=0,y=1,b=2,w=3,E=4,S=5,x=6,T=7,N=8,C=9,k=10,L=11,A=12,O=13,M=14,_=15,D=16,P=17,H=18,B=[H,H,H,H,H,H,H,H,H,x,S,x,N,S,H,H,H,H,H,H,H,H,H,H,H,H,H,H,S,S,S,x,N,E,E,L,L,L,E,E,E,E,E,k,C,k,C,C,b,b,b,b,b,b,b,b,b,b,C,E,E,E,E,E,E,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,E,E,E,E,E,E,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,E,E,E,E,H,H,H,H,H,H,S,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,C,E,L,L,L,L,E,E,E,E,g,E,E,H,E,E,L,L,b,b,E,g,E,E,E,b,g,E,E,E,E,E],j=[N,N,N,N,N,N,N,N,N,N,N,H,H,H,g,y,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,N,S,O,M,_,D,P,C,L,L,L,L,L,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,C,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,N];t.L=g,t.R=y,t.EN=b,t.ON_R=3,t.AN=4,t.R_H=5,t.B=6,t.RLE=7,t.DOT="\u00b7",t.doBidiReorder=function(e,n,r){if(e.length<2)return{};var i=e.split(""),o=new Array(i.length),u=new Array(i.length),a=[];s=r?m:v,F(i,a,i.length,n);for(var f=0;f<o.length;o[f]=f,f++);I(2,a,o),I(1,a,o);for(var f=0;f<o.length-1;f++)n[f]===w?a[f]=t.AN:a[f]===y&&(n[f]>T&&n[f]<O||n[f]===E||n[f]===H)?a[f]=t.ON_R:f>0&&i[f-1]==="\u0644"&&/\u0622|\u0623|\u0625|\u0627/.test(i[f])&&(a[f-1]=a[f]=t.R_H,f++);i[i.length-1]===t.DOT&&(a[i.length-1]=t.B),i[0]==="\u202b"&&(a[0]=t.RLE);for(var f=0;f<o.length;f++)u[f]=a[o[f]];return{logicalFromVisual:o,bidiLevels:u}},t.hasBidiCharacters=function(e,t){var n=!1;for(var r=0;r<e.length;r++)t[r]=R(e.charAt(r)),!n&&(t[r]==y||t[r]==T||t[r]==w)&&(n=!0);return n},t.getVisualFromLogicalIdx=function(e,t){for(var n=0;n<t.logicalFromVisual.length;n++)if(t.logicalFromVisual[n]==e)return n;return 0}}),define("ace/bidihandler",["require","exports","module","ace/lib/bidiutil","ace/lib/lang"],function(e,t,n){"use strict";var r=e("./lib/bidiutil"),i=e("./lib/lang"),s=/[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/,o=function(){function e(e){this.session=e,this.bidiMap={},this.currentRow=null,this.bidiUtil=r,this.charWidths=[],this.EOL="\u00ac",this.showInvisibles=!0,this.isRtlDir=!1,this.$isRtl=!1,this.line="",this.wrapIndent=0,this.EOF="\u00b6",this.RLE="\u202b",this.contentWidth=0,this.fontMetrics=null,this.rtlLineOffset=0,this.wrapOffset=0,this.isMoveLeftOperation=!1,this.seenBidi=s.test(e.getValue())}return e.prototype.isBidiRow=function(e,t,n){return this.seenBidi?(e!==this.currentRow&&(this.currentRow=e,this.updateRowLine(t,n),this.updateBidiMap()),this.bidiMap.bidiLevels):!1},e.prototype.onChange=function(e){this.seenBidi?this.currentRow=null:e.action=="insert"&&s.test(e.lines.join("\n"))&&(this.seenBidi=!0,this.currentRow=null)},e.prototype.getDocumentRow=function(){var e=0,t=this.session.$screenRowCache;if(t.length){var n=this.session.$getRowCacheIndex(t,this.currentRow);n>=0&&(e=this.session.$docRowCache[n])}return e},e.prototype.getSplitIndex=function(){var e=0,t=this.session.$screenRowCache;if(t.length){var n,r=this.session.$getRowCacheIndex(t,this.currentRow);while(this.currentRow-e>0){n=this.session.$getRowCacheIndex(t,this.currentRow-e-1);if(n!==r)break;r=n,e++}}else e=this.currentRow;return e},e.prototype.updateRowLine=function(e,t){e===undefined&&(e=this.getDocumentRow());var n=e===this.session.getLength()-1,s=n?this.EOF:this.EOL;this.wrapIndent=0,this.line=this.session.getLine(e),this.isRtlDir=this.$isRtl||this.line.charAt(0)===this.RLE;if(this.session.$useWrapMode){var o=this.session.$wrapData[e];o&&(t===undefined&&(t=this.getSplitIndex()),t>0&&o.length?(this.wrapIndent=o.indent,this.wrapOffset=this.wrapIndent*this.charWidths[r.L],this.line=t<o.length?this.line.substring(o[t-1],o[t]):this.line.substring(o[o.length-1])):this.line=this.line.substring(0,o[t]),t==o.length&&(this.line+=this.showInvisibles?s:r.DOT))}else this.line+=this.showInvisibles?s:r.DOT;var u=this.session,a=0,f;this.line=this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g,function(e,t){return e==="	"||u.isFullWidth(e.charCodeAt(0))?(f=e==="	"?u.getScreenTabSize(t+a):2,a+=f-1,i.stringRepeat(r.DOT,f)):e}),this.isRtlDir&&(this.fontMetrics.$main.textContent=this.line.charAt(this.line.length-1)==r.DOT?this.line.substr(0,this.line.length-1):this.line,this.rtlLineOffset=this.contentWidth-this.fontMetrics.$main.getBoundingClientRect().width)},e.prototype.updateBidiMap=function(){var e=[];r.hasBidiCharacters(this.line,e)||this.isRtlDir?this.bidiMap=r.doBidiReorder(this.line,e,this.isRtlDir):this.bidiMap={}},e.prototype.markAsDirty=function(){this.currentRow=null},e.prototype.updateCharacterWidths=function(e){if(this.characterWidth===e.$characterSize.width)return;this.fontMetrics=e;var t=this.characterWidth=e.$characterSize.width,n=e.$measureCharWidth("\u05d4");this.charWidths[r.L]=this.charWidths[r.EN]=this.charWidths[r.ON_R]=t,this.charWidths[r.R]=this.charWidths[r.AN]=n,this.charWidths[r.R_H]=n*.45,this.charWidths[r.B]=this.charWidths[r.RLE]=0,this.currentRow=null},e.prototype.setShowInvisibles=function(e){this.showInvisibles=e,this.currentRow=null},e.prototype.setEolChar=function(e){this.EOL=e},e.prototype.setContentWidth=function(e){this.contentWidth=e},e.prototype.isRtlLine=function(e){return this.$isRtl?!0:e!=undefined?this.session.getLine(e).charAt(0)==this.RLE:this.isRtlDir},e.prototype.setRtlDirection=function(e,t){var n=e.getCursorPosition();for(var r=e.selection.getSelectionAnchor().row;r<=n.row;r++)!t&&e.session.getLine(r).charAt(0)===e.session.$bidiHandler.RLE?e.session.doc.removeInLine(r,0,1):t&&e.session.getLine(r).charAt(0)!==e.session.$bidiHandler.RLE&&e.session.doc.insert({column:0,row:r},e.session.$bidiHandler.RLE)},e.prototype.getPosLeft=function(e){e-=this.wrapIndent;var t=this.line.charAt(0)===this.RLE?1:0,n=e>t?this.session.getOverwrite()?e:e-1:t,i=r.getVisualFromLogicalIdx(n,this.bidiMap),s=this.bidiMap.bidiLevels,o=0;!this.session.getOverwrite()&&e<=t&&s[i]%2!==0&&i++;for(var u=0;u<i;u++)o+=this.charWidths[s[u]];return!this.session.getOverwrite()&&e>t&&s[i]%2===0&&(o+=this.charWidths[s[i]]),this.wrapIndent&&(o+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset),this.isRtlDir&&(o+=this.rtlLineOffset),o},e.prototype.getSelections=function(e,t){var n=this.bidiMap,r=n.bidiLevels,i,s=[],o=0,u=Math.min(e,t)-this.wrapIndent,a=Math.max(e,t)-this.wrapIndent,f=!1,l=!1,c=0;this.wrapIndent&&(o+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);for(var h,p=0;p<r.length;p++)h=n.logicalFromVisual[p],i=r[p],f=h>=u&&h<a,f&&!l?c=o:!f&&l&&s.push({left:c,width:o-c}),o+=this.charWidths[i],l=f;f&&p===r.length&&s.push({left:c,width:o-c});if(this.isRtlDir)for(var d=0;d<s.length;d++)s[d].left+=this.rtlLineOffset;return s},e.prototype.offsetToCol=function(e){this.isRtlDir&&(e-=this.rtlLineOffset);var t=0,e=Math.max(e,0),n=0,r=0,i=this.bidiMap.bidiLevels,s=this.charWidths[i[r]];this.wrapIndent&&(e-=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);while(e>n+s/2){n+=s;if(r===i.length-1){s=0;break}s=this.charWidths[i[++r]]}return r>0&&i[r-1]%2!==0&&i[r]%2===0?(e<n&&r--,t=this.bidiMap.logicalFromVisual[r]):r>0&&i[r-1]%2===0&&i[r]%2!==0?t=1+(e>n?this.bidiMap.logicalFromVisual[r]:this.bidiMap.logicalFromVisual[r-1]):this.isRtlDir&&r===i.length-1&&s===0&&i[r-1]%2===0||!this.isRtlDir&&r===0&&i[r]%2!==0?t=1+this.bidiMap.logicalFromVisual[r]:(r>0&&i[r-1]%2!==0&&s!==0&&r--,t=this.bidiMap.logicalFromVisual[r]),t===0&&this.isRtlDir&&t++,t+this.wrapIndent},e}();t.BidiHandler=o}),define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=function(){function e(e){this.session=e,this.doc=e.getDocument(),this.clearSelection(),this.cursor=this.lead=this.doc.createAnchor(0,0),this.anchor=this.doc.createAnchor(0,0),this.$silent=!1;var t=this;this.cursor.on("change",function(e){t.$cursorChanged=!0,t.$silent||t._emit("changeCursor"),!t.$isEmpty&&!t.$silent&&t._emit("changeSelection"),!t.$keepDesiredColumnOnChange&&e.old.column!=e.value.column&&(t.$desiredColumn=null)}),this.anchor.on("change",function(){t.$anchorChanged=!0,!t.$isEmpty&&!t.$silent&&t._emit("changeSelection")})}return e.prototype.isEmpty=function(){return this.$isEmpty||this.anchor.row==this.lead.row&&this.anchor.column==this.lead.column},e.prototype.isMultiLine=function(){return!this.$isEmpty&&this.anchor.row!=this.cursor.row},e.prototype.getCursor=function(){return this.lead.getPosition()},e.prototype.setAnchor=function(e,t){this.$isEmpty=!1,this.anchor.setPosition(e,t)},e.prototype.getAnchor=function(){return this.$isEmpty?this.getSelectionLead():this.anchor.getPosition()},e.prototype.getSelectionLead=function(){return this.lead.getPosition()},e.prototype.isBackwards=function(){var e=this.anchor,t=this.lead;return e.row>t.row||e.row==t.row&&e.column>t.column},e.prototype.getRange=function(){var e=this.anchor,t=this.lead;return this.$isEmpty?o.fromPoints(t,t):this.isBackwards()?o.fromPoints(t,e):o.fromPoints(e,t)},e.prototype.clearSelection=function(){this.$isEmpty||(this.$isEmpty=!0,this._emit("changeSelection"))},e.prototype.selectAll=function(){this.$setSelection(0,0,Number.MAX_VALUE,Number.MAX_VALUE)},e.prototype.setRange=function(e,t){var n=t?e.end:e.start,r=t?e.start:e.end;this.$setSelection(n.row,n.column,r.row,r.column)},e.prototype.$setSelection=function(e,t,n,r){if(this.$silent)return;var i=this.$isEmpty,s=this.inMultiSelectMode;this.$silent=!0,this.$cursorChanged=this.$anchorChanged=!1,this.anchor.setPosition(e,t),this.cursor.setPosition(n,r),this.$isEmpty=!o.comparePoints(this.anchor,this.cursor),this.$silent=!1,this.$cursorChanged&&this._emit("changeCursor"),(this.$cursorChanged||this.$anchorChanged||i!=this.$isEmpty||s)&&this._emit("changeSelection")},e.prototype.$moveSelection=function(e){var t=this.lead;this.$isEmpty&&this.setSelectionAnchor(t.row,t.column),e.call(this)},e.prototype.selectTo=function(e,t){this.$moveSelection(function(){this.moveCursorTo(e,t)})},e.prototype.selectToPosition=function(e){this.$moveSelection(function(){this.moveCursorToPosition(e)})},e.prototype.moveTo=function(e,t){this.clearSelection(),this.moveCursorTo(e,t)},e.prototype.moveToPosition=function(e){this.clearSelection(),this.moveCursorToPosition(e)},e.prototype.selectUp=function(){this.$moveSelection(this.moveCursorUp)},e.prototype.selectDown=function(){this.$moveSelection(this.moveCursorDown)},e.prototype.selectRight=function(){this.$moveSelection(this.moveCursorRight)},e.prototype.selectLeft=function(){this.$moveSelection(this.moveCursorLeft)},e.prototype.selectLineStart=function(){this.$moveSelection(this.moveCursorLineStart)},e.prototype.selectLineEnd=function(){this.$moveSelection(this.moveCursorLineEnd)},e.prototype.selectFileEnd=function(){this.$moveSelection(this.moveCursorFileEnd)},e.prototype.selectFileStart=function(){this.$moveSelection(this.moveCursorFileStart)},e.prototype.selectWordRight=function(){this.$moveSelection(this.moveCursorWordRight)},e.prototype.selectWordLeft=function(){this.$moveSelection(this.moveCursorWordLeft)},e.prototype.getWordRange=function(e,t){if(typeof t=="undefined"){var n=e||this.lead;e=n.row,t=n.column}return this.session.getWordRange(e,t)},e.prototype.selectWord=function(){this.setSelectionRange(this.getWordRange())},e.prototype.selectAWord=function(){var e=this.getCursor(),t=this.session.getAWordRange(e.row,e.column);this.setSelectionRange(t)},e.prototype.getLineRange=function(e,t){var n=typeof e=="number"?e:this.lead.row,r,i=this.session.getFoldLine(n);return i?(n=i.start.row,r=i.end.row):r=n,t===!0?new o(n,0,r,this.session.getLine(r).length):new o(n,0,r+1,0)},e.prototype.selectLine=function(){this.setSelectionRange(this.getLineRange())},e.prototype.moveCursorUp=function(){this.moveCursorBy(-1,0)},e.prototype.moveCursorDown=function(){this.moveCursorBy(1,0)},e.prototype.wouldMoveIntoSoftTab=function(e,t,n){var r=e.column,i=e.column+t;return n<0&&(r=e.column-t,i=e.column),this.session.isTabStop(e)&&this.doc.getLine(e.row).slice(r,i).split(" ").length-1==t},e.prototype.moveCursorLeft=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,-1))this.moveCursorTo(t.start.row,t.start.column);else if(e.column===0)e.row>0&&this.moveCursorTo(e.row-1,this.doc.getLine(e.row-1).length);else{var n=this.session.getTabSize();this.wouldMoveIntoSoftTab(e,n,-1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,-n):this.moveCursorBy(0,-1)}},e.prototype.moveCursorRight=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,1))this.moveCursorTo(t.end.row,t.end.column);else if(this.lead.column==this.doc.getLine(this.lead.row).length)this.lead.row<this.doc.getLength()-1&&this.moveCursorTo(this.lead.row+1,0);else{var n=this.session.getTabSize(),e=this.lead;this.wouldMoveIntoSoftTab(e,n,1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,n):this.moveCursorBy(0,1)}},e.prototype.moveCursorLineStart=function(){var e=this.lead.row,t=this.lead.column,n=this.session.documentToScreenRow(e,t),r=this.session.screenToDocumentPosition(n,0),i=this.session.getDisplayLine(e,null,r.row,r.column),s=i.match(/^\s*/);s[0].length!=t&&!this.session.$useEmacsStyleLineStart&&(r.column+=s[0].length),this.moveCursorToPosition(r)},e.prototype.moveCursorLineEnd=function(){var e=this.lead,t=this.session.getDocumentLastRowColumnPosition(e.row,e.column);if(this.lead.column==t.column){var n=this.session.getLine(t.row);if(t.column==n.length){var r=n.search(/\s+$/);r>0&&(t.column=r)}}this.moveCursorTo(t.row,t.column)},e.prototype.moveCursorFileEnd=function(){var e=this.doc.getLength()-1,t=this.doc.getLine(e).length;this.moveCursorTo(e,t)},e.prototype.moveCursorFileStart=function(){this.moveCursorTo(0,0)},e.prototype.moveCursorLongWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;var i=this.session.getFoldAt(e,t,1);if(i){this.moveCursorTo(i.end.row,i.end.column);return}this.session.nonTokenRe.exec(r)&&(t+=this.session.nonTokenRe.lastIndex,this.session.nonTokenRe.lastIndex=0,r=n.substring(t));if(t>=n.length){this.moveCursorTo(e,n.length),this.moveCursorRight(),e<this.doc.getLength()-1&&this.moveCursorWordRight();return}this.session.tokenRe.exec(r)&&(t+=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(e,t)},e.prototype.moveCursorLongWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1)){this.moveCursorTo(n.start.row,n.start.column);return}var r=this.session.getFoldStringAt(e,t,-1);r==null&&(r=this.doc.getLine(e).substring(0,t));var s=i.stringReverse(r);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0,this.session.nonTokenRe.exec(s)&&(t-=this.session.nonTokenRe.lastIndex,s=s.slice(this.session.nonTokenRe.lastIndex),this.session.nonTokenRe.lastIndex=0);if(t<=0){this.moveCursorTo(e,0),this.moveCursorLeft(),e>0&&this.moveCursorWordLeft();return}this.session.tokenRe.exec(s)&&(t-=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(e,t)},e.prototype.$shortWordEndIndex=function(e){var t=0,n,r=/\s/,i=this.session.tokenRe;i.lastIndex=0;if(this.session.tokenRe.exec(e))t=this.session.tokenRe.lastIndex;else{while((n=e[t])&&r.test(n))t++;if(t<1){i.lastIndex=0;while((n=e[t])&&!i.test(n)){i.lastIndex=0,t++;if(r.test(n)){if(t>2){t--;break}while((n=e[t])&&r.test(n))t++;if(t>2)break}}}}return i.lastIndex=0,t},e.prototype.moveCursorShortWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t),i=this.session.getFoldAt(e,t,1);if(i)return this.moveCursorTo(i.end.row,i.end.column);if(t==n.length){var s=this.doc.getLength();do e++,r=this.doc.getLine(e);while(e<s&&/^\s*$/.test(r));/^\s+/.test(r)||(r=""),t=0}var o=this.$shortWordEndIndex(r);this.moveCursorTo(e,t+o)},e.prototype.moveCursorShortWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1))return this.moveCursorTo(n.start.row,n.start.column);var r=this.session.getLine(e).substring(0,t);if(t===0){do e--,r=this.doc.getLine(e);while(e>0&&/^\s*$/.test(r));t=r.length,/\s+$/.test(r)||(r="")}var s=i.stringReverse(r),o=this.$shortWordEndIndex(s);return this.moveCursorTo(e,t-o)},e.prototype.moveCursorWordRight=function(){this.session.$selectLongWords?this.moveCursorLongWordRight():this.moveCursorShortWordRight()},e.prototype.moveCursorWordLeft=function(){this.session.$selectLongWords?this.moveCursorLongWordLeft():this.moveCursorShortWordLeft()},e.prototype.moveCursorBy=function(e,t){var n=this.session.documentToScreenPosition(this.lead.row,this.lead.column),r;t===0&&(e!==0&&(this.session.$bidiHandler.isBidiRow(n.row,this.lead.row)?(r=this.session.$bidiHandler.getPosLeft(n.column),n.column=Math.round(r/this.session.$bidiHandler.charWidths[0])):r=n.column*this.session.$bidiHandler.charWidths[0]),this.$desiredColumn?n.column=this.$desiredColumn:this.$desiredColumn=n.column);if(e!=0&&this.session.lineWidgets&&this.session.lineWidgets[this.lead.row]){var i=this.session.lineWidgets[this.lead.row];e<0?e-=i.rowsAbove||0:e>0&&(e+=i.rowCount-(i.rowsAbove||0))}var s=this.session.screenToDocumentPosition(n.row+e,n.column,r);e!==0&&t===0&&s.row===this.lead.row&&s.column===this.lead.column,this.moveCursorTo(s.row,s.column+t,t===0)},e.prototype.moveCursorToPosition=function(e){this.moveCursorTo(e.row,e.column)},e.prototype.moveCursorTo=function(e,t,n){var r=this.session.getFoldAt(e,t,1);r&&(e=r.start.row,t=r.start.column),this.$keepDesiredColumnOnChange=!0;var i=this.session.getLine(e);/[\uDC00-\uDFFF]/.test(i.charAt(t))&&i.charAt(t-1)&&(this.lead.row==e&&this.lead.column==t+1?t-=1:t+=1),this.lead.setPosition(e,t),this.$keepDesiredColumnOnChange=!1,n||(this.$desiredColumn=null)},e.prototype.moveCursorToScreen=function(e,t,n){var r=this.session.screenToDocumentPosition(e,t);this.moveCursorTo(r.row,r.column,n)},e.prototype.detach=function(){this.lead.detach(),this.anchor.detach()},e.prototype.fromOrientedRange=function(e){this.setSelectionRange(e,e.cursor==e.start),this.$desiredColumn=e.desiredColumn||this.$desiredColumn},e.prototype.toOrientedRange=function(e){var t=this.getRange();return e?(e.start.column=t.start.column,e.start.row=t.start.row,e.end.column=t.end.column,e.end.row=t.end.row):e=t,e.cursor=this.isBackwards()?e.start:e.end,e.desiredColumn=this.$desiredColumn,e},e.prototype.getRangeOfMovements=function(e){var t=this.getCursor();try{e(this);var n=this.getCursor();return o.fromPoints(t,n)}catch(r){return o.fromPoints(t,t)}finally{this.moveCursorToPosition(t)}},e.prototype.toJSON=function(){if(this.rangeCount)var e=this.ranges.map(function(e){var t=e.clone();return t.isBackwards=e.cursor==e.start,t});else{var e=this.getRange();e.isBackwards=this.isBackwards()}return e},e.prototype.fromJSON=function(e){if(e.start==undefined){if(this.rangeList&&e.length>1){this.toSingleRange(e[0]);for(var t=e.length;t--;){var n=o.fromPoints(e[t].start,e[t].end);e[t].isBackwards&&(n.cursor=n.start),this.addRange(n,!0)}return}e=e[0]}this.rangeList&&this.toSingleRange(e),this.setSelectionRange(e,e.isBackwards)},e.prototype.isEqual=function(e){if((e.length||this.rangeCount)&&e.length!=this.rangeCount)return!1;if(!e.length||!this.ranges)return this.getRange().isEqual(e);for(var t=this.ranges.length;t--;)if(!this.ranges[t].isEqual(e[t]))return!1;return!0},e}();u.prototype.setSelectionAnchor=u.prototype.setAnchor,u.prototype.getSelectionAnchor=u.prototype.getAnchor,u.prototype.setSelectionRange=u.prototype.setRange,r.implement(u.prototype,s),t.Selection=u}),define("ace/tokenizer",["require","exports","module","ace/lib/report_error"],function(e,t,n){"use strict";var r=e("./lib/report_error").reportError,i=2e3,s=function(){function e(e){this.splitRegex,this.states=e,this.regExps={},this.matchMappings={};for(var t in this.states){var n=this.states[t],r=[],i=0,s=this.matchMappings[t]={defaultToken:"text"},o="g",u=[];for(var a=0;a<n.length;a++){var f=n[a];f.defaultToken&&(s.defaultToken=f.defaultToken),f.caseInsensitive&&o.indexOf("i")===-1&&(o+="i"),f.unicode&&o.indexOf("u")===-1&&(o+="u");if(f.regex==null)continue;f.regex instanceof RegExp&&(f.regex=f.regex.toString().slice(1,-1));var l=f.regex,c=(new RegExp("(?:("+l+")|(.))")).exec("a").length-2;Array.isArray(f.token)?f.token.length==1||c==1?f.token=f.token[0]:c-1!=f.token.length?(this.reportError("number of classes and regexp groups doesn't match",{rule:f,groupCount:c-1}),f.token=f.token[0]):(f.tokenArray=f.token,f.token=null,f.onMatch=this.$arrayTokens):typeof f.token=="function"&&!f.onMatch&&(c>1?f.onMatch=this.$applyToken:f.onMatch=f.token),c>1&&(/\\\d/.test(f.regex)?l=f.regex.replace(/\\([0-9]+)/g,function(e,t){return"\\"+(parseInt(t,10)+i+1)}):(c=1,l=this.removeCapturingGroups(f.regex)),!f.splitRegex&&typeof f.token!="string"&&u.push(f)),s[i]=a,i+=c,r.push(l),f.onMatch||(f.onMatch=null)}r.length||(s[0]=0,r.push("$")),u.forEach(function(e){e.splitRegex=this.createSplitterRegexp(e.regex,o)},this),this.regExps[t]=new RegExp("("+r.join(")|(")+")|($)",o)}}return e.prototype.$setMaxTokenCount=function(e){i=e|0},e.prototype.$applyToken=function(e){var t=this.splitRegex.exec(e).slice(1),n=this.token.apply(this,t);if(typeof n=="string")return[{type:n,value:e}];var r=[];for(var i=0,s=n.length;i<s;i++)t[i]&&(r[r.length]={type:n[i],value:t[i]});return r},e.prototype.$arrayTokens=function(e){if(!e)return[];var t=this.splitRegex.exec(e);if(!t)return"text";var n=[],r=this.tokenArray;for(var i=0,s=r.length;i<s;i++)t[i+1]&&(n[n.length]={type:r[i],value:t[i+1]});return n},e.prototype.removeCapturingGroups=function(e){var t=e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g,function(e,t){return t?"(?:":e});return t},e.prototype.createSplitterRegexp=function(e,t){if(e.indexOf("(?=")!=-1){var n=0,r=!1,i={};e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g,function(e,t,s,o,u,a){return r?r=u!="]":u?r=!0:o?(n==i.stack&&(i.end=a+1,i.stack=-1),n--):s&&(n++,s.length!=1&&(i.stack=n,i.start=a)),e}),i.end!=null&&/^\)*$/.test(e.substr(i.end))&&(e=e.substring(0,i.start)+e.substr(i.end))}return e.charAt(0)!="^"&&(e="^"+e),e.charAt(e.length-1)!="$"&&(e+="$"),new RegExp(e,(t||"").replace("g",""))},e.prototype.getLineTokens=function(e,t){if(t&&typeof t!="string"){var n=t.slice(0);t=n[0],t==="#tmp"&&(n.shift(),t=n.shift())}else var n=[];var r=t||"start",s=this.states[r];s||(r="start",s=this.states[r]);var o=this.matchMappings[r],u=this.regExps[r];u.lastIndex=0;var a,f=[],l=0,c=0,h={type:null,value:""};while(a=u.exec(e)){var p=o.defaultToken,d=null,v=a[0],m=u.lastIndex;if(m-v.length>l){var g=e.substring(l,m-v.length);h.type==p?h.value+=g:(h.type&&f.push(h),h={type:p,value:g})}for(var y=0;y<a.length-2;y++){if(a[y+1]===undefined)continue;d=s[o[y]],d.onMatch?p=d.onMatch(v,r,n,e):p=d.token,d.next&&(typeof d.next=="string"?r=d.next:r=d.next(r,n),s=this.states[r],s||(this.reportError("state doesn't exist",r),r="start",s=this.states[r]),o=this.matchMappings[r],l=m,u=this.regExps[r],u.lastIndex=m),d.consumeLineEnd&&(l=m);break}if(v)if(typeof p=="string")!!d&&d.merge===!1||h.type!==p?(h.type&&f.push(h),h={type:p,value:v}):h.value+=v;else if(p){h.type&&f.push(h),h={type:null,value:""};for(var y=0;y<p.length;y++)f.push(p[y])}if(l==e.length)break;l=m;if(c++>i){c>2*e.length&&this.reportError("infinite loop with in ace tokenizer",{startState:t,line:e});while(l<e.length)h.type&&f.push(h),h={value:e.substring(l,l+=500),type:"overflow"};r="start",n=[];break}}return h.type&&f.push(h),n.length>1&&n[0]!==r&&n.unshift("#tmp",r),{tokens:f,state:n.length?n:r}},e}();s.prototype.reportError=r,t.Tokenizer=s}),define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/deep_copy"],function(e,t,n){"use strict";var r=e("../lib/deep_copy").deepCopy,i;i=function(){this.$rules={start:[{token:"empty_line",regex:"^$"},{defaultToken:"text"}]}},function(){this.addRules=function(e,t){if(!t){for(var n in e)this.$rules[n]=e[n];return}for(var n in e){var r=e[n];for(var i=0;i<r.length;i++){var s=r[i];if(s.next||s.onMatch)typeof s.next=="string"&&s.next.indexOf(t)!==0&&(s.next=t+s.next),s.nextState&&s.nextState.indexOf(t)!==0&&(s.nextState=t+s.nextState)}this.$rules[t+n]=r}},this.getRules=function(){return this.$rules},this.embedRules=function(e,t,n,i,s){var o=typeof e=="function"?(new e).getRules():e;if(i)for(var u=0;u<i.length;u++)i[u]=t+i[u];else{i=[];for(var a in o)i.push(t+a)}this.addRules(o,t);if(n){var f=Array.prototype[s?"push":"unshift"];for(var u=0;u<i.length;u++)f.apply(this.$rules[i[u]],r(n))}this.$embeds||(this.$embeds=[]),this.$embeds.push(t)},this.getEmbeds=function(){return this.$embeds};var e=function(e,t){return(e!="start"||t.length)&&t.unshift(this.nextState,e),this.nextState},t=function(e,t){return t.shift(),t.shift()||"start"};this.normalizeRules=function(){function i(s){var o=r[s];o.processed=!0;for(var u=0;u<o.length;u++){var a=o[u],f=null;Array.isArray(a)&&(f=a,a={}),!a.regex&&a.start&&(a.regex=a.start,a.next||(a.next=[]),a.next.push({defaultToken:a.token},{token:a.token+".end",regex:a.end||a.start,next:"pop"}),a.token=a.token+".start",a.push=!0);var l=a.next||a.push;if(l&&Array.isArray(l)){var c=a.stateName;c||(c=a.token,typeof c!="string"&&(c=c[0]||""),r[c]&&(c+=n++)),r[c]=l,a.next=c,i(c)}else l=="pop"&&(a.next=t);a.push&&(a.nextState=a.next||a.push,a.next=e,delete a.push);if(a.rules)for(var h in a.rules)r[h]?r[h].push&&r[h].push.apply(r[h],a.rules[h]):r[h]=a.rules[h];var p=typeof a=="string"?a:a.include;p&&(p==="$self"&&(p="start"),Array.isArray(p)?f=p.map(function(e){return r[e]}):f=r[p]);if(f){var d=[u,1].concat(f);a.noEscape&&(d=d.filter(function(e){return!e.next})),o.splice.apply(o,d),u--}a.keywordMap&&(a.token=this.createKeywordMapper(a.keywordMap,a.defaultToken||"text",a.caseInsensitive),delete a.defaultToken)}}var n=0,r=this.$rules;Object.keys(r).forEach(i,this)},this.createKeywordMapper=function(e,t,n,r){var i=Object.create(null);return this.$keywordList=[],Object.keys(e).forEach(function(t){var s=e[t],o=s.split(r||"|");for(var u=o.length;u--;){var a=o[u];this.$keywordList.push(a),n&&(a=a.toLowerCase()),i[a]=t}},this),e=null,n?function(e){return i[e.toLowerCase()]||t}:function(e){return i[e]||t}},this.getKeywords=function(){return this.$keywords}}.call(i.prototype),t.TextHighlightRules=i}),define("ace/mode/behaviour",["require","exports","module"],function(e,t,n){"use strict";var r;r=function(){this.$behaviours={}},function(){this.add=function(e,t,n){switch(undefined){case this.$behaviours:this.$behaviours={};case this.$behaviours[e]:this.$behaviours[e]={}}this.$behaviours[e][t]=n},this.addBehaviours=function(e){for(var t in e)for(var n in e[t])this.add(t,n,e[t][n])},this.remove=function(e){this.$behaviours&&this.$behaviours[e]&&delete this.$behaviours[e]},this.inherit=function(e,t){if(typeof e=="function")var n=(new e).getBehaviours(t);else var n=e.getBehaviours(t);this.addBehaviours(n)},this.getBehaviours=function(e){if(!e)return this.$behaviours;var t={};for(var n=0;n<e.length;n++)this.$behaviours[e[n]]&&(t[e[n]]=this.$behaviours[e[n]]);return t}}.call(r.prototype),t.Behaviour=r}),define("ace/token_iterator",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("./range").Range,i=function(){function e(e,t,n){this.$session=e,this.$row=t,this.$rowTokens=e.getTokens(t);var r=e.getTokenAt(t,n);this.$tokenIndex=r?r.index:-1}return e.prototype.stepBackward=function(){this.$tokenIndex-=1;while(this.$tokenIndex<0){this.$row-=1;if(this.$row<0)return this.$row=0,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=this.$rowTokens.length-1}return this.$rowTokens[this.$tokenIndex]},e.prototype.stepForward=function(){this.$tokenIndex+=1;var e;while(this.$tokenIndex>=this.$rowTokens.length){this.$row+=1,e||(e=this.$session.getLength());if(this.$row>=e)return this.$row=e-1,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=0}return this.$rowTokens[this.$tokenIndex]},e.prototype.getCurrentToken=function(){return this.$rowTokens[this.$tokenIndex]},e.prototype.getCurrentTokenRow=function(){return this.$row},e.prototype.getCurrentTokenColumn=function(){var e=this.$rowTokens,t=this.$tokenIndex,n=e[t].start;if(n!==undefined)return n;n=0;while(t>0)t-=1,n+=e[t].value.length;return n},e.prototype.getCurrentTokenPosition=function(){return{row:this.$row,column:this.getCurrentTokenColumn()}},e.prototype.getCurrentTokenRange=function(){var e=this.$rowTokens[this.$tokenIndex],t=this.getCurrentTokenColumn();return new r(this.$row,t,this.$row,t+e.value.length)},e}();t.TokenIterator=i}),define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../behaviour").Behaviour,s=e("../../token_iterator").TokenIterator,o=e("../../lib/lang"),u=["text","paren.rparen","rparen","paren","punctuation.operator"],a=["text","paren.rparen","rparen","paren","punctuation.operator","comment"],f,l={},c={'"':'"',"'":"'"},h=function(e){var t=-1;e.multiSelect&&(t=e.selection.index,l.rangeCount!=e.multiSelect.rangeCount&&(l={rangeCount:e.multiSelect.rangeCount}));if(l[t])return f=l[t];f=l[t]={autoInsertedBrackets:0,autoInsertedRow:-1,autoInsertedLineEnd:"",maybeInsertedBrackets:0,maybeInsertedRow:-1,maybeInsertedLineStart:"",maybeInsertedLineEnd:""}},p=function(e,t,n,r){var i=e.end.row-e.start.row;return{text:n+t+r,selection:[0,e.start.column+1,i,e.end.column+(i?0:1)]}},d;d=function(e){e=e||{},this.add("braces","insertion",function(t,n,r,i,s){var u=r.getCursorPosition(),a=i.doc.getLine(u.row);if(s=="{"){h(r);var l=r.getSelectionRange(),c=i.doc.getTextRange(l),v=i.getTokenAt(u.row,u.column);if(c!==""&&c!=="{"&&r.getWrapBehavioursEnabled())return p(l,c,"{","}");if(v&&/(?:string)\.quasi|\.xml/.test(v.type)){var m=[/tag\-(?:open|name)/,/attribute\-name/];if(m.some(function(e){return e.test(v.type)})||/(string)\.quasi/.test(v.type)&&v.value[u.column-v.start-1]!=="$")return;return d.recordAutoInsert(r,i,"}"),{text:"{}",selection:[1,1]}}if(d.isSaneInsertion(r,i))return/[\]\}\)]/.test(a[u.column])||r.inMultiSelectMode||e.braces?(d.recordAutoInsert(r,i,"}"),{text:"{}",selection:[1,1]}):(d.recordMaybeInsert(r,i,"{"),{text:"{",selection:[1,1]})}else if(s=="}"){h(r);var g=a.substring(u.column,u.column+1);if(g=="}"){var y=i.$findOpeningBracket("}",{column:u.column+1,row:u.row});if(y!==null&&d.isAutoInsertedClosing(u,a,s))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}else{if(s=="\n"||s=="\r\n"){h(r);var b="";d.isMaybeInsertedClosing(u,a)&&(b=o.stringRepeat("}",f.maybeInsertedBrackets),d.clearMaybeInsertedClosing());var g=a.substring(u.column,u.column+1);if(g==="}"){var w=i.findMatchingBracket({row:u.row,column:u.column+1},"}");if(!w)return null;var E=this.$getIndent(i.getLine(w.row))}else{if(!b){d.clearMaybeInsertedClosing();return}var E=this.$getIndent(a)}var S=E+i.getTabString();return{text:"\n"+S+"\n"+E+b,selection:[1,S.length,1,S.length]}}d.clearMaybeInsertedClosing()}}),this.add("braces","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="{"){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.end.column,i.end.column+1);if(u=="}")return i.end.column++,i;f.maybeInsertedBrackets--}}),this.add("parens","insertion",function(e,t,n,r,i){if(i=="("){h(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return p(s,o,"(",")");if(d.isSaneInsertion(n,r))return d.recordAutoInsert(n,r,")"),{text:"()",selection:[1,1]}}else if(i==")"){h(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f==")"){var l=r.$findOpeningBracket(")",{column:u.column+1,row:u.row});if(l!==null&&d.isAutoInsertedClosing(u,a,i))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("parens","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="("){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u==")")return i.end.column++,i}}),this.add("brackets","insertion",function(e,t,n,r,i){if(i=="["){h(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return p(s,o,"[","]");if(d.isSaneInsertion(n,r))return d.recordAutoInsert(n,r,"]"),{text:"[]",selection:[1,1]}}else if(i=="]"){h(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f=="]"){var l=r.$findOpeningBracket("]",{column:u.column+1,row:u.row});if(l!==null&&d.isAutoInsertedClosing(u,a,i))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("brackets","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="["){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u=="]")return i.end.column++,i}}),this.add("string_dquotes","insertion",function(e,t,n,r,i){var s=r.$mode.$quotes||c;if(i.length==1&&s[i]){if(this.lineCommentStart&&this.lineCommentStart.indexOf(i)!=-1)return;h(n);var o=i,u=n.getSelectionRange(),a=r.doc.getTextRange(u);if(a!==""&&(a.length!=1||!s[a])&&n.getWrapBehavioursEnabled())return p(u,a,o,o);if(!a){var f=n.getCursorPosition(),l=r.doc.getLine(f.row),d=l.substring(f.column-1,f.column),v=l.substring(f.column,f.column+1),m=r.getTokenAt(f.row,f.column),g=r.getTokenAt(f.row,f.column+1);if(d=="\\"&&m&&/escape/.test(m.type))return null;var y=m&&/string|escape/.test(m.type),b=!g||/string|escape/.test(g.type),w;if(v==o)w=y!==b,w&&/string\.end/.test(g.type)&&(w=!1);else{if(y&&!b)return null;if(y&&b)return null;var E=r.$mode.tokenRe;E.lastIndex=0;var S=E.test(d);E.lastIndex=0;var x=E.test(v),T=r.$mode.$pairQuotesAfter,N=T&&T[o]&&T[o].test(d);if(!N&&S||x)return null;if(v&&!/[\s;,.})\]\\]/.test(v))return null;var C=l[f.column-2];if(!(d!=o||C!=o&&!E.test(C)))return null;w=!0}return{text:w?o+o:"",selection:[1,1]}}}}),this.add("string_dquotes","deletion",function(e,t,n,r,i){var s=r.$mode.$quotes||c,o=r.doc.getTextRange(i);if(!i.isMultiLine()&&s.hasOwnProperty(o)){h(n);var u=r.doc.getLine(i.start.row),a=u.substring(i.start.column+1,i.start.column+2);if(a==o)return i.end.column++,i}}),e.closeDocComment!==!1&&this.add("doc comment end","insertion",function(e,t,n,r,i){if(e==="doc-start"&&(i==="\n"||i==="\r\n")&&n.selection.isEmpty()){var s=n.getCursorPosition();if(s.column===0)return;var o=r.doc.getLine(s.row),u=r.doc.getLine(s.row+1),a=r.getTokens(s.row),f=0;for(var l=0;l<a.length;l++){f+=a[l].value.length;var c=a[l];if(f>=s.column){if(f===s.column){if(!/\.doc/.test(c.type))return;if(/\*\//.test(c.value)){var h=a[l+1];if(!h||!/\.doc/.test(h.type))return}}var p=s.column-(f-c.value.length),d=c.value.indexOf("*/"),v=c.value.indexOf("/**",d>-1?d+2:0);if(v!==-1&&p>v&&p<v+3)return;if(d!==-1&&v!==-1&&p>=d&&p<=v||!/\.doc/.test(c.type))return;break}}var m=this.$getIndent(o);if(/\s*\*/.test(u))return/^\s*\*/.test(o)?{text:i+m+"* ",selection:[1,2+m.length,1,2+m.length]}:{text:i+m+" * ",selection:[1,3+m.length,1,3+m.length]};if(/\/\*\*/.test(o.substring(0,s.column)))return{text:i+m+" * "+i+" "+m+"*/",selection:[1,4+m.length,1,4+m.length]}}})},d.isSaneInsertion=function(e,t){var n=e.getCursorPosition(),r=new s(t,n.row,n.column);if(!this.$matchTokenType(r.getCurrentToken()||"text",u)){if(/[)}\]]/.test(e.session.getLine(n.row)[n.column]))return!0;var i=new s(t,n.row,n.column+1);if(!this.$matchTokenType(i.getCurrentToken()||"text",u))return!1}return r.stepForward(),r.getCurrentTokenRow()!==n.row||this.$matchTokenType(r.getCurrentToken()||"text",a)},d.$matchTokenType=function(e,t){return t.indexOf(e.type||e)>-1},d.recordAutoInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isAutoInsertedClosing(r,i,f.autoInsertedLineEnd[0])||(f.autoInsertedBrackets=0),f.autoInsertedRow=r.row,f.autoInsertedLineEnd=n+i.substr(r.column),f.autoInsertedBrackets++},d.recordMaybeInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isMaybeInsertedClosing(r,i)||(f.maybeInsertedBrackets=0),f.maybeInsertedRow=r.row,f.maybeInsertedLineStart=i.substr(0,r.column)+n,f.maybeInsertedLineEnd=i.substr(r.column),f.maybeInsertedBrackets++},d.isAutoInsertedClosing=function(e,t,n){return f.autoInsertedBrackets>0&&e.row===f.autoInsertedRow&&n===f.autoInsertedLineEnd[0]&&t.substr(e.column)===f.autoInsertedLineEnd},d.isMaybeInsertedClosing=function(e,t){return f.maybeInsertedBrackets>0&&e.row===f.maybeInsertedRow&&t.substr(e.column)===f.maybeInsertedLineEnd&&t.substr(0,e.column)==f.maybeInsertedLineStart},d.popAutoInsertedClosing=function(){f.autoInsertedLineEnd=f.autoInsertedLineEnd.substr(1),f.autoInsertedBrackets--},d.clearMaybeInsertedClosing=function(){f&&(f.maybeInsertedBrackets=0,f.maybeInsertedRow=-1)},r.inherits(d,i),t.CstyleBehaviour=d}),define("ace/unicode",["require","exports","module"],function(e,t,n){"use strict";var r=[48,9,8,25,5,0,2,25,48,0,11,0,5,0,6,22,2,30,2,457,5,11,15,4,8,0,2,0,18,116,2,1,3,3,9,0,2,2,2,0,2,19,2,82,2,138,2,4,3,155,12,37,3,0,8,38,10,44,2,0,2,1,2,1,2,0,9,26,6,2,30,10,7,61,2,9,5,101,2,7,3,9,2,18,3,0,17,58,3,100,15,53,5,0,6,45,211,57,3,18,2,5,3,11,3,9,2,1,7,6,2,2,2,7,3,1,3,21,2,6,2,0,4,3,3,8,3,1,3,3,9,0,5,1,2,4,3,11,16,2,2,5,5,1,3,21,2,6,2,1,2,1,2,1,3,0,2,4,5,1,3,2,4,0,8,3,2,0,8,15,12,2,2,8,2,2,2,21,2,6,2,1,2,4,3,9,2,2,2,2,3,0,16,3,3,9,18,2,2,7,3,1,3,21,2,6,2,1,2,4,3,8,3,1,3,2,9,1,5,1,2,4,3,9,2,0,17,1,2,5,4,2,2,3,4,1,2,0,2,1,4,1,4,2,4,11,5,4,4,2,2,3,3,0,7,0,15,9,18,2,2,7,2,2,2,22,2,9,2,4,4,7,2,2,2,3,8,1,2,1,7,3,3,9,19,1,2,7,2,2,2,22,2,9,2,4,3,8,2,2,2,3,8,1,8,0,2,3,3,9,19,1,2,7,2,2,2,22,2,15,4,7,2,2,2,3,10,0,9,3,3,9,11,5,3,1,2,17,4,23,2,8,2,0,3,6,4,0,5,5,2,0,2,7,19,1,14,57,6,14,2,9,40,1,2,0,3,1,2,0,3,0,7,3,2,6,2,2,2,0,2,0,3,1,2,12,2,2,3,4,2,0,2,5,3,9,3,1,35,0,24,1,7,9,12,0,2,0,2,0,5,9,2,35,5,19,2,5,5,7,2,35,10,0,58,73,7,77,3,37,11,42,2,0,4,328,2,3,3,6,2,0,2,3,3,40,2,3,3,32,2,3,3,6,2,0,2,3,3,14,2,56,2,3,3,66,5,0,33,15,17,84,13,619,3,16,2,25,6,74,22,12,2,6,12,20,12,19,13,12,2,2,2,1,13,51,3,29,4,0,5,1,3,9,34,2,3,9,7,87,9,42,6,69,11,28,4,11,5,11,11,39,3,4,12,43,5,25,7,10,38,27,5,62,2,28,3,10,7,9,14,0,89,75,5,9,18,8,13,42,4,11,71,55,9,9,4,48,83,2,2,30,14,230,23,280,3,5,3,37,3,5,3,7,2,0,2,0,2,0,2,30,3,52,2,6,2,0,4,2,2,6,4,3,3,5,5,12,6,2,2,6,67,1,20,0,29,0,14,0,17,4,60,12,5,0,4,11,18,0,5,0,3,9,2,0,4,4,7,0,2,0,2,0,2,3,2,10,3,3,6,4,5,0,53,1,2684,46,2,46,2,132,7,6,15,37,11,53,10,0,17,22,10,6,2,6,2,6,2,6,2,6,2,6,2,6,2,6,2,31,48,0,470,1,36,5,2,4,6,1,5,85,3,1,3,2,2,89,2,3,6,40,4,93,18,23,57,15,513,6581,75,20939,53,1164,68,45,3,268,4,27,21,31,3,13,13,1,2,24,9,69,11,1,38,8,3,102,3,1,111,44,25,51,13,68,12,9,7,23,4,0,5,45,3,35,13,28,4,64,15,10,39,54,10,13,3,9,7,22,4,1,5,66,25,2,227,42,2,1,3,9,7,11171,13,22,5,48,8453,301,3,61,3,105,39,6,13,4,6,11,2,12,2,4,2,0,2,1,2,1,2,107,34,362,19,63,3,53,41,11,5,15,17,6,13,1,25,2,33,4,2,134,20,9,8,25,5,0,2,25,12,88,4,5,3,5,3,5,3,2],i=0,s=[];for(var o=0;o<r.length;o+=2)s.push(i+=r[o]),r[o+1]&&s.push(45,i+=r[o+1]);t.wordChars=String.fromCharCode.apply(null,s)}),define("ace/mode/text",["require","exports","module","ace/config","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"],function(e,t,n){"use strict";var r=e("../config"),i=e("../tokenizer").Tokenizer,s=e("./text_highlight_rules").TextHighlightRules,o=e("./behaviour/cstyle").CstyleBehaviour,u=e("../unicode"),a=e("../lib/lang"),f=e("../token_iterator").TokenIterator,l=e("../range").Range,c;c=function(){this.HighlightRules=s},function(){this.$defaultBehaviour=new o,this.tokenRe=new RegExp("^["+u.wordChars+"\\$_]+","g"),this.nonTokenRe=new RegExp("^(?:[^"+u.wordChars+"\\$_]|\\s])+","g"),this.getTokenizer=function(){return this.$tokenizer||(this.$highlightRules=this.$highlightRules||new this.HighlightRules(this.$highlightRuleConfig),this.$tokenizer=new i(this.$highlightRules.getRules())),this.$tokenizer},this.lineCommentStart="",this.blockComment="",this.toggleCommentLines=function(e,t,n,r){function w(e){for(var t=n;t<=r;t++)e(i.getLine(t),t)}var i=t.doc,s=!0,o=!0,u=Infinity,f=t.getTabSize(),l=!1;if(!this.lineCommentStart){if(!this.blockComment)return!1;var c=this.blockComment.start,h=this.blockComment.end,p=new RegExp("^(\\s*)(?:"+a.escapeRegExp(c)+")"),d=new RegExp("(?:"+a.escapeRegExp(h)+")\\s*$"),v=function(e,t){if(g(e,t))return;if(!s||/\S/.test(e))i.insertInLine({row:t,column:e.length},h),i.insertInLine({row:t,column:u},c)},m=function(e,t){var n;(n=e.match(d))&&i.removeInLine(t,e.length-n[0].length,e.length),(n=e.match(p))&&i.removeInLine(t,n[1].length,n[0].length)},g=function(e,n){if(p.test(e))return!0;var r=t.getTokens(n);for(var i=0;i<r.length;i++)if(r[i].type==="comment")return!0}}else{if(Array.isArray(this.lineCommentStart))var p=this.lineCommentStart.map(a.escapeRegExp).join("|"),c=this.lineCommentStart[0];else var p=a.escapeRegExp(this.lineCommentStart),c=this.lineCommentStart;p=new RegExp("^(\\s*)(?:"+p+") ?"),l=t.getUseSoftTabs();var m=function(e,t){var n=e.match(p);if(!n)return;var r=n[1].length,s=n[0].length;!b(e,r,s)&&n[0][s-1]==" "&&s--,i.removeInLine(t,r,s)},y=c+" ",v=function(e,t){if(!s||/\S/.test(e))b(e,u,u)?i.insertInLine({row:t,column:u},y):i.insertInLine({row:t,column:u},c)},g=function(e,t){return p.test(e)},b=function(e,t,n){var r=0;while(t--&&e.charAt(t)==" ")r++;if(r%f!=0)return!1;var r=0;while(e.charAt(n++)==" ")r++;return f>2?r%f!=f-1:r%f==0}}var E=Infinity;w(function(e,t){var n=e.search(/\S/);n!==-1?(n<u&&(u=n),o&&!g(e,t)&&(o=!1)):E>e.length&&(E=e.length)}),u==Infinity&&(u=E,s=!1,o=!1),l&&u%f!=0&&(u=Math.floor(u/f)*f),w(o?m:v)},this.toggleBlockComment=function(e,t,n,r){var i=this.blockComment;if(!i)return;!i.start&&i[0]&&(i=i[0]);var s=new f(t,r.row,r.column),o=s.getCurrentToken(),u=t.selection,a=t.selection.toOrientedRange(),c,h;if(o&&/comment/.test(o.type)){var p,d;while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.start);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;p=new l(m,g,m,g+i.start.length);break}o=s.stepBackward()}var s=new f(t,r.row,r.column),o=s.getCurrentToken();while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.end);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;d=new l(m,g,m,g+i.end.length);break}o=s.stepForward()}d&&t.remove(d),p&&(t.remove(p),c=p.start.row,h=-i.start.length)}else h=i.start.length,c=n.start.row,t.insert(n.end,i.end),t.insert(n.start,i.start);a.start.row==c&&(a.start.column+=h),a.end.row==c&&(a.end.column+=h),t.selection.fromOrientedRange(a)},this.getNextLineIndent=function(e,t,n){return this.$getIndent(t)},this.checkOutdent=function(e,t,n){return!1},this.autoOutdent=function(e,t,n){},this.$getIndent=function(e){return e.match(/^\s*/)[0]},this.createWorker=function(e){return null},this.createModeDelegates=function(e){this.$embeds=[],this.$modes={};for(var t in e)if(e[t]){var n=e[t],i=n.prototype.$id,s=r.$modes[i];s||(r.$modes[i]=s=new n),r.$modes[t]||(r.$modes[t]=s),this.$embeds.push(t),this.$modes[t]=s}var o=["toggleBlockComment","toggleCommentLines","getNextLineIndent","checkOutdent","autoOutdent","transformAction","getCompletions"],u=function(e){(function(t){var n=o[e],r=t[n];t[o[e]]=function(){return this.$delegator(n,arguments,r)}})(a)},a=this;for(var t=0;t<o.length;t++)u(t)},this.$delegator=function(e,t,n){var r=t[0]||"start";if(typeof r!="string"){if(Array.isArray(r[2])){var i=r[2][r[2].length-1],s=this.$modes[i];if(s)return s[e].apply(s,[r[1]].concat([].slice.call(t,1)))}r=r[0]||"start"}for(var o=0;o<this.$embeds.length;o++){if(!this.$modes[this.$embeds[o]])continue;var u=r.split(this.$embeds[o]);if(!u[0]&&u[1]){t[0]=u[1];var s=this.$modes[this.$embeds[o]];return s[e].apply(s,t)}}var a=n.apply(this,t);return n?a:undefined},this.transformAction=function(e,t,n,r,i){if(this.$behaviour){var s=this.$behaviour.getBehaviours();for(var o in s)if(s[o][t]){var u=s[o][t].apply(this,arguments);if(u)return u}}},this.getKeywords=function(e){if(!this.completionKeywords){var t=this.$tokenizer.rules,n=[];for(var r in t){var i=t[r];for(var s=0,o=i.length;s<o;s++)if(typeof i[s].token=="string")/keyword|support|storage/.test(i[s].token)&&n.push(i[s].regex);else if(typeof i[s].token=="object")for(var u=0,a=i[s].token.length;u<a;u++)if(/keyword|support|storage/.test(i[s].token[u])){var r=i[s].regex.match(/\(.+?\)/g)[u];n.push(r.substr(1,r.length-2))}}this.completionKeywords=n}return e?n.concat(this.$keywordList||[]):this.$keywordList},this.$createKeywordList=function(){return this.$highlightRules||this.getTokenizer(),this.$keywordList=this.$highlightRules.$keywordList||[]},this.getCompletions=function(e,t,n,r){var i=this.$keywordList||this.$createKeywordList();return i.map(function(e){return{name:e,value:e,score:0,meta:"keyword"}})},this.$id="ace/mode/text"}.call(c.prototype),t.Mode=c}),define("ace/line_widgets",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./lib/dom"),i=function(){function e(e){this.session=e,this.session.widgetManager=this,this.session.getRowLength=this.getRowLength,this.session.$getWidgetScreenLength=this.$getWidgetScreenLength,this.updateOnChange=this.updateOnChange.bind(this),this.renderWidgets=this.renderWidgets.bind(this),this.measureWidgets=this.measureWidgets.bind(this),this.session._changedWidgets=[],this.$onChangeEditor=this.$onChangeEditor.bind(this),this.session.on("change",this.updateOnChange),this.session.on("changeFold",this.updateOnFold),this.session.on("changeEditor",this.$onChangeEditor)}return e.prototype.getRowLength=function(e){var t;return this.lineWidgets?t=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0:t=0,!this.$useWrapMode||!this.$wrapData[e]?1+t:this.$wrapData[e].length+1+t},e.prototype.$getWidgetScreenLength=function(){var e=0;return this.lineWidgets.forEach(function(t){t&&t.rowCount&&!t.hidden&&(e+=t.rowCount)}),e},e.prototype.$onChangeEditor=function(e){this.attach(e.editor)},e.prototype.attach=function(e){e&&e.widgetManager&&e.widgetManager!=this&&e.widgetManager.detach();if(this.editor==e)return;this.detach(),this.editor=e,e&&(e.widgetManager=this,e.renderer.on("beforeRender",this.measureWidgets),e.renderer.on("afterRender",this.renderWidgets))},e.prototype.detach=function(e){var t=this.editor;if(!t)return;this.editor=null,t.widgetManager=null,t.renderer.off("beforeRender",this.measureWidgets),t.renderer.off("afterRender",this.renderWidgets);var n=this.session.lineWidgets;n&&n.forEach(function(e){e&&e.el&&e.el.parentNode&&(e._inDocument=!1,e.el.parentNode.removeChild(e.el))})},e.prototype.updateOnFold=function(e,t){var n=t.lineWidgets;if(!n||!e.action)return;var r=e.data,i=r.start.row,s=r.end.row,o=e.action=="add";for(var u=i+1;u<s;u++)n[u]&&(n[u].hidden=o);n[s]&&(o?n[i]?n[s].hidden=o:n[i]=n[s]:(n[i]==n[s]&&(n[i]=undefined),n[s].hidden=o))},e.prototype.updateOnChange=function(e){var t=this.session.lineWidgets;if(!t)return;var n=e.start.row,r=e.end.row-n;if(r!==0)if(e.action=="remove"){var i=t.splice(n+1,r);!t[n]&&i[i.length-1]&&(t[n]=i.pop()),i.forEach(function(e){e&&this.removeLineWidget(e)},this),this.$updateRows()}else{var s=new Array(r);t[n]&&t[n].column!=null&&e.start.column>t[n].column&&n++,s.unshift(n,0),t.splice.apply(t,s),this.$updateRows()}},e.prototype.$updateRows=function(){var e=this.session.lineWidgets;if(!e)return;var t=!0;e.forEach(function(e,n){if(e){t=!1,e.row=n;while(e.$oldWidget)e.$oldWidget.row=n,e=e.$oldWidget}}),t&&(this.session.lineWidgets=null)},e.prototype.$registerLineWidget=function(e){this.session.lineWidgets||(this.session.lineWidgets=new Array(this.session.getLength()));var t=this.session.lineWidgets[e.row];return t&&(e.$oldWidget=t,t.el&&t.el.parentNode&&(t.el.parentNode.removeChild(t.el),t._inDocument=!1)),this.session.lineWidgets[e.row]=e,e},e.prototype.addLineWidget=function(e){this.$registerLineWidget(e),e.session=this.session;if(!this.editor)return e;var t=this.editor.renderer;e.html&&!e.el&&(e.el=r.createElement("div"),e.el.innerHTML=e.html),e.text&&!e.el&&(e.el=r.createElement("div"),e.el.textContent=e.text),e.el&&(r.addCssClass(e.el,"ace_lineWidgetContainer"),e.className&&r.addCssClass(e.el,e.className),e.el.style.position="absolute",e.el.style.zIndex="5",t.container.appendChild(e.el),e._inDocument=!0,e.coverGutter||(e.el.style.zIndex="3"),e.pixelHeight==null&&(e.pixelHeight=e.el.offsetHeight)),e.rowCount==null&&(e.rowCount=e.pixelHeight/t.layerConfig.lineHeight);var n=this.session.getFoldAt(e.row,0);e.$fold=n;if(n){var i=this.session.lineWidgets;e.row==n.end.row&&!i[n.start.row]?i[n.start.row]=e:e.hidden=!0}return this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows(),this.renderWidgets(null,t),this.onWidgetChanged(e),e},e.prototype.removeLineWidget=function(e){e._inDocument=!1,e.session=null,e.el&&e.el.parentNode&&e.el.parentNode.removeChild(e.el);if(e.editor&&e.editor.destroy)try{e.editor.destroy()}catch(t){}if(this.session.lineWidgets){var n=this.session.lineWidgets[e.row];if(n==e)this.session.lineWidgets[e.row]=e.$oldWidget,e.$oldWidget&&this.onWidgetChanged(e.$oldWidget);else while(n){if(n.$oldWidget==e){n.$oldWidget=e.$oldWidget;break}n=n.$oldWidget}}this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows()},e.prototype.getWidgetsAtRow=function(e){var t=this.session.lineWidgets,n=t&&t[e],r=[];while(n)r.push(n),n=n.$oldWidget;return r},e.prototype.onWidgetChanged=function(e){this.session._changedWidgets.push(e),this.editor&&this.editor.renderer.updateFull()},e.prototype.measureWidgets=function(e,t){var n=this.session._changedWidgets,r=t.layerConfig;if(!n||!n.length)return;var i=Infinity;for(var s=0;s<n.length;s++){var o=n[s];if(!o||!o.el)continue;if(o.session!=this.session)continue;if(!o._inDocument){if(this.session.lineWidgets[o.row]!=o)continue;o._inDocument=!0,t.container.appendChild(o.el)}o.h=o.el.offsetHeight,o.fixedWidth||(o.w=o.el.offsetWidth,o.screenWidth=Math.ceil(o.w/r.characterWidth));var u=o.h/r.lineHeight;o.coverLine&&(u-=this.session.getRowLineCount(o.row),u<0&&(u=0)),o.rowCount!=u&&(o.rowCount=u,o.row<i&&(i=o.row))}i!=Infinity&&(this.session._emit("changeFold",{data:{start:{row:i}}}),this.session.lineWidgetWidth=null),this.session._changedWidgets=[]},e.prototype.renderWidgets=function(e,t){var n=t.layerConfig,r=this.session.lineWidgets;if(!r)return;var i=Math.min(this.firstRow,n.firstRow),s=Math.max(this.lastRow,n.lastRow,r.length);while(i>0&&!r[i])i--;this.firstRow=n.firstRow,this.lastRow=n.lastRow,t.$cursorLayer.config=n;for(var o=i;o<=s;o++){var u=r[o];if(!u||!u.el)continue;if(u.hidden){u.el.style.top=-100-(u.pixelHeight||0)+"px";continue}u._inDocument||(u._inDocument=!0,t.container.appendChild(u.el));var a=t.$cursorLayer.getPixelPosition({row:o,column:0},!0).top;u.coverLine||(a+=n.lineHeight*this.session.getRowLineCount(u.row)),u.el.style.top=a-n.offset+"px";var f=u.coverGutter?0:t.gutterWidth;u.fixedWidth||(f-=t.scrollLeft),u.el.style.left=f+"px",u.fullWidth&&u.screenWidth&&(u.el.style.minWidth=n.width+2*n.padding+"px"),u.fixedWidth?u.el.style.right=t.scrollBar.getWidth()+"px":u.el.style.right=""}},e}();t.LineWidgets=i}),define("ace/apply_delta",["require","exports","module"],function(e,t,n){"use strict";function r(e,t){throw console.log("Invalid Delta:",e),"Invalid Delta: "+t}function i(e,t){return t.row>=0&&t.row<e.length&&t.column>=0&&t.column<=e[t.row].length}function s(e,t){t.action!="insert"&&t.action!="remove"&&r(t,"delta.action must be 'insert' or 'remove'"),t.lines instanceof Array||r(t,"delta.lines must be an Array"),(!t.start||!t.end)&&r(t,"delta.start/end must be an present");var n=t.start;i(e,t.start)||r(t,"delta.start must be contained in document");var s=t.end;t.action=="remove"&&!i(e,s)&&r(t,"delta.end must contained in document for 'remove' actions");var o=s.row-n.row,u=s.column-(o==0?n.column:0);(o!=t.lines.length-1||t.lines[o].length!=u)&&r(t,"delta.range must match delta lines")}t.applyDelta=function(e,t,n){var r=t.start.row,i=t.start.column,s=e[r]||"";switch(t.action){case"insert":var o=t.lines;if(o.length===1)e[r]=s.substring(0,i)+t.lines[0]+s.substring(i);else{var u=[r,1].concat(t.lines);e.splice.apply(e,u),e[r]=s.substring(0,i)+e[r],e[r+t.lines.length-1]+=s.substring(i)}break;case"remove":var a=t.end.column,f=t.end.row;r===f?e[r]=s.substring(0,i)+s.substring(a):e.splice(r,f-r+1,s.substring(0,i)+e[f].substring(a))}}}),define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";function o(e,t,n){var r=n?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&r}function u(e,t,n){var r=e.action=="insert",i=(r?1:-1)*(e.end.row-e.start.row),s=(r?1:-1)*(e.end.column-e.start.column),u=e.start,a=r?u:e.end;return o(t,u,n)?{row:t.row,column:t.column}:o(a,t,!n)?{row:t.row+i,column:t.column+(t.row==a.row?s:0)}:{row:u.row,column:u.column}}var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=function(){function e(e,t,n){this.$onChange=this.onChange.bind(this),this.attach(e),typeof t!="number"?this.setPosition(t.row,t.column):this.setPosition(t,n)}return e.prototype.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},e.prototype.getDocument=function(){return this.document},e.prototype.onChange=function(e){if(e.start.row==e.end.row&&e.start.row!=this.row)return;if(e.start.row>this.row)return;var t=u(e,{row:this.row,column:this.column},this.$insertRight);this.setPosition(t.row,t.column,!0)},e.prototype.setPosition=function(e,t,n){var r;n?r={row:e,column:t}:r=this.$clipPositionToDocument(e,t);if(this.row==r.row&&this.column==r.column)return;var i={row:this.row,column:this.column};this.row=r.row,this.column=r.column,this._signal("change",{old:i,value:r})},e.prototype.detach=function(){this.document.off("change",this.$onChange)},e.prototype.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange)},e.prototype.$clipPositionToDocument=function(e,t){var n={};return e>=this.document.getLength()?(n.row=Math.max(0,this.document.getLength()-1),n.column=this.document.getLine(n.row).length):e<0?(n.row=0,n.column=0):(n.row=e,n.column=Math.min(this.document.getLine(n.row).length,Math.max(0,t))),t<0&&(n.column=0),n},e}();s.prototype.$insertRight=!1,r.implement(s.prototype,i),t.Anchor=s}),define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./apply_delta").applyDelta,s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=e("./anchor").Anchor,a=function(){function e(e){this.$lines=[""],e.length===0?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e)}return e.prototype.setValue=function(e){var t=this.getLength()-1;this.remove(new o(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e||"")},e.prototype.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},e.prototype.createAnchor=function(e,t){return new u(this,e,t)},e.prototype.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode")},e.prototype.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n"}},e.prototype.setNewLineMode=function(e){if(this.$newLineMode===e)return;this.$newLineMode=e,this._signal("changeNewLineMode")},e.prototype.getNewLineMode=function(){return this.$newLineMode},e.prototype.isNewLine=function(e){return e=="\r\n"||e=="\r"||e=="\n"},e.prototype.getLine=function(e){return this.$lines[e]||""},e.prototype.getLines=function(e,t){return this.$lines.slice(e,t+1)},e.prototype.getAllLines=function(){return this.getLines(0,this.getLength())},e.prototype.getLength=function(){return this.$lines.length},e.prototype.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter())},e.prototype.getLinesForRange=function(e){var t;if(e.start.row===e.end.row)t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)];else{t=this.getLines(e.start.row,e.end.row),t[0]=(t[0]||"").substring(e.start.column);var n=t.length-1;e.end.row-e.start.row==n&&(t[n]=t[n].substring(0,e.end.column))}return t},e.prototype.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t)},e.prototype.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t)},e.prototype.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""])},e.prototype.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t))},e.prototype.insertInLine=function(e,t){var n=this.clippedPos(e.row,e.column),r=this.pos(e.row,e.column+t.length);return this.applyDelta({start:n,end:r,action:"insert",lines:[t]},!0),this.clonePos(r)},e.prototype.clippedPos=function(e,t){var n=this.getLength();e===undefined?e=n:e<0?e=0:e>=n&&(e=n-1,t=undefined);var r=this.getLine(e);return t==undefined&&(t=r.length),t=Math.min(Math.max(t,0),r.length),{row:e,column:t}},e.prototype.clonePos=function(e){return{row:e.row,column:e.column}},e.prototype.pos=function(e,t){return{row:e,column:t}},e.prototype.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e},e.prototype.insertFullLines=function(e,t){e=Math.min(Math.max(e,0),this.getLength());var n=0;e<this.getLength()?(t=t.concat([""]),n=0):(t=[""].concat(t),e--,n=this.$lines[e].length),this.insertMergedLines({row:e,column:n},t)},e.prototype.insertMergedLines=function(e,t){var n=this.clippedPos(e.row,e.column),r={row:n.row+t.length-1,column:(t.length==1?n.column:0)+t[t.length-1].length};return this.applyDelta({start:n,end:r,action:"insert",lines:t}),this.clonePos(r)},e.prototype.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),n=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:n,action:"remove",lines:this.getLinesForRange({start:t,end:n})}),this.clonePos(t)},e.prototype.removeInLine=function(e,t,n){var r=this.clippedPos(e,t),i=this.clippedPos(e,n);return this.applyDelta({start:r,end:i,action:"remove",lines:this.getLinesForRange({start:r,end:i})},!0),this.clonePos(r)},e.prototype.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1),t=Math.min(Math.max(0,t),this.getLength()-1);var n=t==this.getLength()-1&&e>0,r=t<this.getLength()-1,i=n?e-1:e,s=n?this.getLine(i).length:0,u=r?t+1:t,a=r?0:this.getLine(u).length,f=new o(i,s,u,a),l=this.$lines.slice(e,t+1);return this.applyDelta({start:f.start,end:f.end,action:"remove",lines:this.getLinesForRange(f)}),l},e.prototype.removeNewLine=function(e){e<this.getLength()-1&&e>=0&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]})},e.prototype.replace=function(e,t){e instanceof o||(e=o.fromPoints(e.start,e.end));if(t.length===0&&e.isEmpty())return e.start;if(t==this.getTextRange(e))return e.end;this.remove(e);var n;return t?n=this.insert(e.start,t):n=e.start,n},e.prototype.applyDeltas=function(e){for(var t=0;t<e.length;t++)this.applyDelta(e[t])},e.prototype.revertDeltas=function(e){for(var t=e.length-1;t>=0;t--)this.revertDelta(e[t])},e.prototype.applyDelta=function(e,t){var n=e.action=="insert";if(n?e.lines.length<=1&&!e.lines[0]:!o.comparePoints(e.start,e.end))return;n&&e.lines.length>2e4?this.$splitAndapplyLargeDelta(e,2e4):(i(this.$lines,e,t),this._signal("change",e))},e.prototype.$safeApplyDelta=function(e){var t=this.$lines.length;(e.action=="remove"&&e.start.row<t&&e.end.row<t||e.action=="insert"&&e.start.row<=t)&&this.applyDelta(e)},e.prototype.$splitAndapplyLargeDelta=function(e,t){var n=e.lines,r=n.length-t+1,i=e.start.row,s=e.start.column;for(var o=0,u=0;o<r;o=u){u+=t-1;var a=n.slice(o,u);a.push(""),this.applyDelta({start:this.pos(i+o,s),end:this.pos(i+u,s=0),action:e.action,lines:a},!0)}e.lines=n.slice(o),e.start.row=i+o,e.start.column=s,this.applyDelta(e,!0)},e.prototype.revertDelta=function(e){this.$safeApplyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:e.action=="insert"?"remove":"insert",lines:e.lines.slice()})},e.prototype.indexToPosition=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length;for(var i=t||0,s=n.length;i<s;i++){e-=n[i].length+r;if(e<0)return{row:i,column:e+n[i].length+r}}return{row:s-1,column:e+n[s-1].length+r}},e.prototype.positionToIndex=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length,i=0,s=Math.min(e.row,n.length);for(var o=t||0;o<s;++o)i+=n[o].length+r;return i+e.column},e.prototype.$split=function(e){return e.split(/\r\n|\r|\n/)},e}();a.prototype.$autoNewLine="",a.prototype.$newLineMode="auto",r.implement(a.prototype,s),t.Document=a}),define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=function(){function e(e,t){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.tokenizer=e;var n=this;this.$worker=function(){if(!n.running)return;var e=new Date,t=n.currentLine,r=-1,i=n.doc,s=t;while(n.lines[t])t++;var o=i.getLength(),u=0;n.running=!1;while(t<o){n.$tokenizeRow(t),r=t;do t++;while(n.lines[t]);u++;if(u%5===0&&new Date-e>20){n.running=setTimeout(n.$worker,20);break}}n.currentLine=t,r==-1&&(r=t),s<=r&&n.fireUpdateEvent(s,r)}}return e.prototype.setTokenizer=function(e){this.tokenizer=e,this.lines=[],this.states=[],this.start(0)},e.prototype.setDocument=function(e){this.doc=e,this.lines=[],this.states=[],this.stop()},e.prototype.fireUpdateEvent=function(e,t){var n={first:e,last:t};this._signal("update",{data:n})},e.prototype.start=function(e){this.currentLine=Math.min(e||0,this.currentLine,this.doc.getLength()),this.lines.splice(this.currentLine,this.lines.length),this.states.splice(this.currentLine,this.states.length),this.stop(),this.running=setTimeout(this.$worker,700)},e.prototype.scheduleStart=function(){this.running||(this.running=setTimeout(this.$worker,700))},e.prototype.$updateOnChange=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.lines[t]=null;else if(e.action=="remove")this.lines.splice(t,n+1,null),this.states.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.lines.splice.apply(this.lines,r),this.states.splice.apply(this.states,r)}this.currentLine=Math.min(t,this.currentLine,this.doc.getLength()),this.stop()},e.prototype.stop=function(){this.running&&clearTimeout(this.running),this.running=!1},e.prototype.getTokens=function(e){return this.lines[e]||this.$tokenizeRow(e)},e.prototype.getState=function(e){return this.currentLine==e&&this.$tokenizeRow(e),this.states[e]||"start"},e.prototype.$tokenizeRow=function(e){var t=this.doc.getLine(e),n=this.states[e-1],r=this.tokenizer.getLineTokens(t,n,e);return this.states[e]+""!=r.state+""?(this.states[e]=r.state,this.lines[e+1]=null,this.currentLine>e+1&&(this.currentLine=e+1)):this.currentLine==e&&(this.currentLine=e+1),this.lines[e]=r.tokens},e.prototype.cleanup=function(){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.removeAllListeners()},e}();r.implement(s.prototype,i),t.BackgroundTokenizer=s}),define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/range"],function(e,t,n){"use strict";var r=e("./lib/lang"),i=e("./range").Range,s=function(){function e(e,t,n){n===void 0&&(n="text"),this.setRegexp(e),this.clazz=t,this.type=n,this.docLen=0}return e.prototype.setRegexp=function(e){if(this.regExp+""==e+"")return;this.regExp=e,this.cache=[]},e.prototype.update=function(e,t,n,s){if(!this.regExp)return;var o=s.firstRow,u=s.lastRow,a={},f=n.$editor.$search,l=f.$isMultilineSearch(n.$editor.getLastSearchOptions());for(var c=o;c<=u;c++){var h=this.cache[c];if(h==null||n.getValue().length!=this.docLen){if(l){h=[];var p=f.$multiLineForward(n,this.regExp,c,u);if(p){var d=p.endRow<=u?p.endRow-1:u;d>c&&(c=d),h.push(new i(p.startRow,p.startCol,p.endRow,p.endCol))}h.length>this.MAX_RANGES&&(h=h.slice(0,this.MAX_RANGES))}else h=r.getMatchOffsets(n.getLine(c),this.regExp),h.length>this.MAX_RANGES&&(h=h.slice(0,this.MAX_RANGES)),h=h.map(function(e){return new i(c,e.offset,c,e.offset+e.length)});this.cache[c]=h.length?h:""}if(h.length===0)continue;for(var v=h.length;v--;){var m=h[v].toScreenRange(n),g=m.toString();if(a[g])continue;a[g]=!0,t.drawSingleLineMarker(e,m,this.clazz,s)}}this.docLen=n.getValue().length},e}();s.prototype.MAX_RANGES=500,t.SearchHighlight=s}),define("ace/undomanager",["require","exports","module","ace/range"],function(e,t,n){"use strict";function i(e,t){for(var n=t;n--;){var r=e[n];if(r&&!r[0].ignore){while(n<t-1){var i=d(e[n],e[n+1]);e[n]=i[0],e[n+1]=i[1],n++}return!0}}}function a(e){var t=e.action=="insert",n=e.start,r=e.end,i=(r.row-n.row)*(t?1:-1),s=(r.column-n.column)*(t?1:-1);t&&(r=n);for(var o in this.marks){var a=this.marks[o],f=u(a,n);if(f<0)continue;if(f===0&&t){if(a.bias!=1){a.bias==-1;continue}f=1}var l=t?f:u(a,r);if(l>0){a.row+=i,a.column+=a.row==r.row?s:0;continue}!t&&l<=0&&(a.row=n.row,a.column=n.column,l===0&&(a.bias=1))}}function f(e){return{row:e.row,column:e.column}}function l(e){return{start:f(e.start),end:f(e.end),action:e.action,lines:e.lines.slice()}}function c(e){e=e||this;if(Array.isArray(e))return e.map(c).join("\n");var t="";e.action?(t=e.action=="insert"?"+":"-",t+="["+e.lines+"]"):e.value&&(Array.isArray(e.value)?t=e.value.map(h).join("\n"):t=h(e.value)),e.start&&(t+=h(e));if(e.id||e.rev)t+="	("+(e.id||e.rev)+")";return t}function h(e){return e.start.row+":"+e.start.column+"=>"+e.end.row+":"+e.end.column}function p(e,t){var n=e.action=="insert",r=t.action=="insert";if(n&&r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.start,e.start)<=0))return null;m(e,t,1)}else if(n&&!r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.end,e.start)<=0))return null;m(e,t,-1)}else if(!n&&r)if(o(t.start,e.start)>=0)m(t,e,1);else{if(!(o(t.start,e.start)<=0))return null;m(e,t,1)}else if(!n&&!r)if(o(t.start,e.start)>=0)m(t,e,1);else{if(!(o(t.end,e.start)<=0))return null;m(e,t,-1)}return[t,e]}function d(e,t){for(var n=e.length;n--;)for(var r=0;r<t.length;r++)if(!p(e[n],t[r])){while(n<e.length){while(r--)p(t[r],e[n]);r=t.length,n++}return[e,t]}return e.selectionBefore=t.selectionBefore=e.selectionAfter=t.selectionAfter=null,[t,e]}function v(e,t){var n=e.action=="insert",r=t.action=="insert";if(n&&r)o(e.start,t.start)<0?m(t,e,1):m(e,t,1);else if(n&&!r)o(e.start,t.end)>=0?m(e,t,-1):o(e.start,t.start)<=0?m(t,e,1):(m(e,s.fromPoints(t.start,e.start),-1),m(t,e,1));else if(!n&&r)o(t.start,e.end)>=0?m(t,e,-1):o(t.start,e.start)<=0?m(e,t,1):(m(t,s.fromPoints(e.start,t.start),-1),m(e,t,1));else if(!n&&!r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.end,e.start)<=0)){var i,u;return o(e.start,t.start)<0&&(i=e,e=y(e,t.start)),o(e.end,t.end)>0&&(u=y(e,t.end)),g(t.end,e.start,e.end,-1),u&&!i&&(e.lines=u.lines,e.start=u.start,e.end=u.end,u=e),[t,i,u].filter(Boolean)}m(e,t,-1)}return[t,e]}function m(e,t,n){g(e.start,t.start,t.end,n),g(e.end,t.start,t.end,n)}function g(e,t,n,r){e.row==(r==1?t:n).row&&(e.column+=r*(n.column-t.column)),e.row+=r*(n.row-t.row)}function y(e,t){var n=e.lines,r=e.end;e.end=f(t);var i=e.end.row-e.start.row,s=n.splice(i,n.length),o=i?t.column:t.column-e.start.column;n.push(s[0].substring(0,o)),s[0]=s[0].substr(o);var u={start:f(t),end:r,lines:s,action:e.action};return u}function b(e,t){t=l(t);for(var n=e.length;n--;){var r=e[n];for(var i=0;i<r.length;i++){var s=r[i],o=v(s,t);t=o[0],o.length!=2&&(o[2]?(r.splice(i+1,1,o[1],o[2]),i++):o[1]||(r.splice(i,1),i--))}r.length||e.splice(n,1)}return e}function w(e,t){for(var n=0;n<t.length;n++){var r=t[n];for(var i=0;i<r.length;i++)b(e,r[i])}}var r=function(){function e(){this.$keepRedoStack,this.$maxRev=0,this.$fromUndo=!1,this.$undoDepth=Infinity,this.reset()}return e.prototype.addSession=function(e){this.$session=e},e.prototype.add=function(e,t,n){if(this.$fromUndo)return;if(e==this.$lastDelta)return;this.$keepRedoStack||(this.$redoStack.length=0);if(t===!1||!this.lastDeltas){this.lastDeltas=[];var r=this.$undoStack.length;r>this.$undoDepth-1&&this.$undoStack.splice(0,r-this.$undoDepth+1),this.$undoStack.push(this.lastDeltas),e.id=this.$rev=++this.$maxRev}if(e.action=="remove"||e.action=="insert")this.$lastDelta=e;this.lastDeltas.push(e)},e.prototype.addSelection=function(e,t){this.selections.push({value:e,rev:t||this.$rev})},e.prototype.startNewGroup=function(){return this.lastDeltas=null,this.$rev},e.prototype.markIgnored=function(e,t){t==null&&(t=this.$rev+1);var n=this.$undoStack;for(var r=n.length;r--;){var i=n[r][0];if(i.id<=e)break;i.id<t&&(i.ignore=!0)}this.lastDeltas=null},e.prototype.getSelection=function(e,t){var n=this.selections;for(var r=n.length;r--;){var i=n[r];if(i.rev<e)return t&&(i=n[r+1]),i}},e.prototype.getRevision=function(){return this.$rev},e.prototype.getDeltas=function(e,t){t==null&&(t=this.$rev+1);var n=this.$undoStack,r=null,i=0;for(var s=n.length;s--;){var o=n[s][0];o.id<t&&!r&&(r=s+1);if(o.id<=e){i=s+1;break}}return n.slice(i,r)},e.prototype.getChangedRanges=function(e,t){t==null&&(t=this.$rev+1)},e.prototype.getChangedLines=function(e,t){t==null&&(t=this.$rev+1)},e.prototype.undo=function(e,t){this.lastDeltas=null;var n=this.$undoStack;if(!i(n,n.length))return;e||(e=this.$session),this.$redoStackBaseRev!==this.$rev&&this.$redoStack.length&&(this.$redoStack=[]),this.$fromUndo=!0;var r=n.pop(),s=null;return r&&(s=e.undoChanges(r,t),this.$redoStack.push(r),this.$syncRev()),this.$fromUndo=!1,s},e.prototype.redo=function(e,t){this.lastDeltas=null,e||(e=this.$session),this.$fromUndo=!0;if(this.$redoStackBaseRev!=this.$rev){var n=this.getDeltas(this.$redoStackBaseRev,this.$rev+1);w(this.$redoStack,n),this.$redoStackBaseRev=this.$rev,this.$redoStack.forEach(function(e){e[0].id=++this.$maxRev},this)}var r=this.$redoStack.pop(),i=null;return r&&(i=e.redoChanges(r,t),this.$undoStack.push(r),this.$syncRev()),this.$fromUndo=!1,i},e.prototype.$syncRev=function(){var e=this.$undoStack,t=e[e.length-1],n=t&&t[0].id||0;this.$redoStackBaseRev=n,this.$rev=n},e.prototype.reset=function(){this.lastDeltas=null,this.$lastDelta=null,this.$undoStack=[],this.$redoStack=[],this.$rev=0,this.mark=0,this.$redoStackBaseRev=this.$rev,this.selections=[]},e.prototype.canUndo=function(){return this.$undoStack.length>0},e.prototype.canRedo=function(){return this.$redoStack.length>0},e.prototype.bookmark=function(e){e==undefined&&(e=this.$rev),this.mark=e},e.prototype.isAtBookmark=function(){return this.$rev===this.mark},e.prototype.toJSON=function(){return{$redoStack:this.$redoStack,$undoStack:this.$undoStack}},e.prototype.fromJSON=function(e){this.reset(),this.$undoStack=e.$undoStack,this.$redoStack=e.$redoStack},e.prototype.$prettyPrint=function(e){return e?c(e):c(this.$undoStack)+"\n---\n"+c(this.$redoStack)},e}();r.prototype.hasUndo=r.prototype.canUndo,r.prototype.hasRedo=r.prototype.canRedo,r.prototype.isClean=r.prototype.isAtBookmark,r.prototype.markClean=r.prototype.bookmark;var s=e("./range").Range,o=s.comparePoints,u=s.comparePoints;t.UndoManager=r}),define("ace/edit_session/fold_line",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){function e(e,t){this.foldData=e,Array.isArray(t)?this.folds=t:t=this.folds=[t];var n=t[t.length-1];this.range=new r(t[0].start.row,t[0].start.column,n.end.row,n.end.column),this.start=this.range.start,this.end=this.range.end,this.folds.forEach(function(e){e.setFoldLine(this)},this)}return e.prototype.shiftRow=function(e){this.start.row+=e,this.end.row+=e,this.folds.forEach(function(t){t.start.row+=e,t.end.row+=e})},e.prototype.addFold=function(e){if(e.sameRow){if(e.start.row<this.startRow||e.endRow>this.endRow)throw new Error("Can't add a fold to this FoldLine as it has no connection");this.folds.push(e),this.folds.sort(function(e,t){return-e.range.compareEnd(t.start.row,t.start.column)}),this.range.compareEnd(e.start.row,e.start.column)>0?(this.end.row=e.end.row,this.end.column=e.end.column):this.range.compareStart(e.end.row,e.end.column)<0&&(this.start.row=e.start.row,this.start.column=e.start.column)}else if(e.start.row==this.end.row)this.folds.push(e),this.end.row=e.end.row,this.end.column=e.end.column;else{if(e.end.row!=this.start.row)throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");this.folds.unshift(e),this.start.row=e.start.row,this.start.column=e.start.column}e.foldLine=this},e.prototype.containsRow=function(e){return e>=this.start.row&&e<=this.end.row},e.prototype.walk=function(e,t,n){var r=0,i=this.folds,s,o,u,a=!0;t==null&&(t=this.end.row,n=this.end.column);for(var f=0;f<i.length;f++){s=i[f],o=s.range.compareStart(t,n);if(o==-1){e(null,t,n,r,a);return}u=e(null,s.start.row,s.start.column,r,a),u=!u&&e(s.placeholder,s.start.row,s.start.column,r);if(u||o===0)return;a=!s.sameRow,r=s.end.column}e(null,t,n,r,a)},e.prototype.getNextFoldTo=function(e,t){var n,r;for(var i=0;i<this.folds.length;i++){n=this.folds[i],r=n.range.compareEnd(e,t);if(r==-1)return{fold:n,kind:"after"};if(r===0)return{fold:n,kind:"inside"}}return null},e.prototype.addRemoveChars=function(e,t,n){var r=this.getNextFoldTo(e,t),i,s;if(r){i=r.fold;if(r.kind=="inside"&&i.start.column!=t&&i.start.row!=e)window.console&&window.console.log(e,t,i);else if(i.start.row==e){s=this.folds;var o=s.indexOf(i);o===0&&(this.start.column+=n);for(o;o<s.length;o++){i=s[o],i.start.column+=n;if(!i.sameRow)return;i.end.column+=n}this.end.column+=n}}},e.prototype.split=function(t,n){var r=this.getNextFoldTo(t,n);if(!r||r.kind=="inside")return null;var i=r.fold,s=this.folds,o=this.foldData,u=s.indexOf(i),a=s[u-1];this.end.row=a.end.row,this.end.column=a.end.column,s=s.splice(u,s.length-u);var f=new e(o,s);return o.splice(o.indexOf(this)+1,0,f),f},e.prototype.merge=function(e){var t=e.folds;for(var n=0;n<t.length;n++)this.addFold(t[n]);var r=this.foldData;r.splice(r.indexOf(e),1)},e.prototype.toString=function(){var e=[this.range.toString()+": ["];return this.folds.forEach(function(t){e.push("  "+t.toString())}),e.push("]"),e.join("\n")},e.prototype.idxToPosition=function(e){var t=0;for(var n=0;n<this.folds.length;n++){var r=this.folds[n];e-=r.start.column-t;if(e<0)return{row:r.start.row,column:r.start.column+e};e-=r.placeholder.length;if(e<0)return r.start;t=r.end.column}return{row:this.end.row,column:this.end.column+e}},e}();t.FoldLine=i}),define("ace/range_list",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("./range").Range,i=r.comparePoints,s=function(){function e(){this.ranges=[],this.$bias=1}return e.prototype.pointIndex=function(e,t,n){var r=this.ranges;for(var s=n||0;s<r.length;s++){var o=r[s],u=i(e,o.end);if(u>0)continue;var a=i(e,o.start);return u===0?t&&a!==0?-s-2:s:a>0||a===0&&!t?s:-s-1}return-s-1},e.prototype.add=function(e){var t=!e.isEmpty(),n=this.pointIndex(e.start,t);n<0&&(n=-n-1);var r=this.pointIndex(e.end,t,n);return r<0?r=-r-1:r++,this.ranges.splice(n,r-n,e)},e.prototype.addList=function(e){var t=[];for(var n=e.length;n--;)t.push.apply(t,this.add(e[n]));return t},e.prototype.substractPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges.splice(t,1)},e.prototype.merge=function(){var e=[],t=this.ranges;t=t.sort(function(e,t){return i(e.start,t.start)});var n=t[0],r;for(var s=1;s<t.length;s++){r=n,n=t[s];var o=i(r.end,n.start);if(o<0)continue;if(o==0&&!r.isEmpty()&&!n.isEmpty())continue;i(r.end,n.end)<0&&(r.end.row=n.end.row,r.end.column=n.end.column),t.splice(s,1),e.push(n),n=r,s--}return this.ranges=t,e},e.prototype.contains=function(e,t){return this.pointIndex({row:e,column:t})>=0},e.prototype.containsPoint=function(e){return this.pointIndex(e)>=0},e.prototype.rangeAtPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges[t]},e.prototype.clipRows=function(e,t){var n=this.ranges;if(n[0].start.row>t||n[n.length-1].start.row<e)return[];var r=this.pointIndex({row:e,column:0});r<0&&(r=-r-1);var i=this.pointIndex({row:t,column:0},r);i<0&&(i=-i-1);var s=[];for(var o=r;o<i;o++)s.push(n[o]);return s},e.prototype.removeAll=function(){return this.ranges.splice(0,this.ranges.length)},e.prototype.attach=function(e){this.session&&this.detach(),this.session=e,this.onChange=this.$onChange.bind(this),this.session.on("change",this.onChange)},e.prototype.detach=function(){if(!this.session)return;this.session.removeListener("change",this.onChange),this.session=null},e.prototype.$onChange=function(e){var t=e.start,n=e.end,r=t.row,i=n.row,s=this.ranges;for(var o=0,u=s.length;o<u;o++){var a=s[o];if(a.end.row>=r)break}if(e.action=="insert"){var f=i-r,l=-t.column+n.column;for(;o<u;o++){var a=s[o];if(a.start.row>r)break;a.start.row==r&&a.start.column>=t.column&&(a.start.column==t.column&&this.$bias<=0||(a.start.column+=l,a.start.row+=f));if(a.end.row==r&&a.end.column>=t.column){if(a.end.column==t.column&&this.$bias<0)continue;a.end.column==t.column&&l>0&&o<u-1&&a.end.column>a.start.column&&a.end.column==s[o+1].start.column&&(a.end.column-=l),a.end.column+=l,a.end.row+=f}}}else{var f=r-i,l=t.column-n.column;for(;o<u;o++){var a=s[o];if(a.start.row>i)break;if(a.end.row<i&&(r<a.end.row||r==a.end.row&&t.column<a.end.column))a.end.row=r,a.end.column=t.column;else if(a.end.row==i)if(a.end.column<=n.column){if(f||a.end.column>t.column)a.end.column=t.column,a.end.row=t.row}else a.end.column+=l,a.end.row+=f;else a.end.row>i&&(a.end.row+=f);if(a.start.row<i&&(r<a.start.row||r==a.start.row&&t.column<a.start.column))a.start.row=r,a.start.column=t.column;else if(a.start.row==i)if(a.start.column<=n.column){if(f||a.start.column>t.column)a.start.column=t.column,a.start.row=t.row}else a.start.column+=l,a.start.row+=f;else a.start.row>i&&(a.start.row+=f)}}if(f!=0&&o<u)for(;o<u;o++){var a=s[o];a.start.row+=f,a.end.row+=f}},e}();s.prototype.comparePoints=i,t.RangeList=s}),define("ace/edit_session/fold",["require","exports","module","ace/range_list"],function(e,t,n){"use strict";function o(e,t){e.row-=t.row,e.row==0&&(e.column-=t.column)}function u(e,t){o(e.start,t),o(e.end,t)}function a(e,t){e.row==0&&(e.column+=t.column),e.row+=t.row}function f(e,t){a(e.start,t),a(e.end,t)}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../range_list").RangeList,s=function(e){function t(t,n){var r=e.call(this)||this;return r.foldLine=null,r.placeholder=n,r.range=t,r.start=t.start,r.end=t.end,r.sameRow=t.start.row==t.end.row,r.subFolds=r.ranges=[],r}return r(t,e),t.prototype.toString=function(){return'"'+this.placeholder+'" '+this.range.toString()},t.prototype.setFoldLine=function(e){this.foldLine=e,this.subFolds.forEach(function(t){t.setFoldLine(e)})},t.prototype.clone=function(){var e=this.range.clone(),n=new t(e,this.placeholder);return this.subFolds.forEach(function(e){n.subFolds.push(e.clone())}),n.collapseChildren=this.collapseChildren,n},t.prototype.addSubFold=function(e){if(this.range.isEqual(e))return;u(e,this.start);var t=e.start.row,n=e.start.column;for(var r=0,i=-1;r<this.subFolds.length;r++){i=this.subFolds[r].range.compare(t,n);if(i!=1)break}var s=this.subFolds[r],o=0;if(i==0){if(s.range.containsRange(e))return s.addSubFold(e);o=1}var t=e.range.end.row,n=e.range.end.column;for(var a=r,i=-1;a<this.subFolds.length;a++){i=this.subFolds[a].range.compare(t,n);if(i!=1)break}i==0&&a++;var f=this.subFolds.splice(r,a-r,e),l=i==0?f.length-1:f.length;for(var c=o;c<l;c++)e.addSubFold(f[c]);return e.setFoldLine(this.foldLine),e},t.prototype.restoreRange=function(e){return f(e,this.start)},t}(i);t.Fold=s}),define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator","ace/mouse/mouse_event"],function(e,t,n){"use strict";function a(){this.getFoldAt=function(e,t,n){var r=this.getFoldLine(e);if(!r)return null;var i=r.folds;for(var s=0;s<i.length;s++){var o=i[s].range;if(o.contains(e,t)){if(n==1&&o.isEnd(e,t)&&!o.isEmpty())continue;if(n==-1&&o.isStart(e,t)&&!o.isEmpty())continue;return i[s]}}},this.getFoldsInRange=function(e){var t=e.start,n=e.end,r=this.$foldData,i=[];t.column+=1,n.column-=1;for(var s=0;s<r.length;s++){var o=r[s].range.compareRange(e);if(o==2)continue;if(o==-2)break;var u=r[s].folds;for(var a=0;a<u.length;a++){var f=u[a];o=f.range.compareRange(e);if(o==-2)break;if(o==2)continue;if(o==42)break;i.push(f)}}return t.column-=1,n.column+=1,i},this.getFoldsInRangeList=function(e){if(Array.isArray(e)){var t=[];e.forEach(function(e){t=t.concat(this.getFoldsInRange(e))},this)}else var t=this.getFoldsInRange(e);return t},this.getAllFolds=function(){var e=[],t=this.$foldData;for(var n=0;n<t.length;n++)for(var r=0;r<t[n].folds.length;r++)e.push(t[n].folds[r]);return e},this.getFoldStringAt=function(e,t,n,r){r=r||this.getFoldLine(e);if(!r)return null;var i={end:{column:0}},s,o;for(var u=0;u<r.folds.length;u++){o=r.folds[u];var a=o.range.compareEnd(e,t);if(a==-1){s=this.getLine(o.start.row).substring(i.end.column,o.start.column);break}if(a===0)return null;i=o}return s||(s=this.getLine(o.start.row).substring(i.end.column)),n==-1?s.substring(0,t-i.end.column):n==1?s.substring(t-i.end.column):s},this.getFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.start.row<=e&&i.end.row>=e)return i;if(i.end.row>e)return null}return null},this.getNextFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.end.row>=e)return i}return null},this.getFoldedRowCount=function(e,t){var n=this.$foldData,r=t-e+1;for(var i=0;i<n.length;i++){var s=n[i],o=s.end.row,u=s.start.row;if(o>=t){u<t&&(u>=e?r-=t-u:r=0);break}o>=e&&(u>=e?r-=o-u:r-=o-e+1)}return r},this.$addFoldLine=function(e){return this.$foldData.push(e),this.$foldData.sort(function(e,t){return e.start.row-t.start.row}),e},this.addFold=function(e,t){var n=this.$foldData,r=!1,o;e instanceof s?o=e:(o=new s(t,e),o.collapseChildren=t.collapseChildren),this.$clipRangeToDocument(o.range);var u=o.start.row,a=o.start.column,f=o.end.row,l=o.end.column,c=this.getFoldAt(u,a,1),h=this.getFoldAt(f,l,-1);if(c&&h==c)return c.addSubFold(o);c&&!c.range.isStart(u,a)&&this.removeFold(c),h&&!h.range.isEnd(f,l)&&this.removeFold(h);var p=this.getFoldsInRange(o.range);p.length>0&&(this.removeFolds(p),o.collapseChildren||p.forEach(function(e){o.addSubFold(e)}));for(var d=0;d<n.length;d++){var v=n[d];if(f==v.start.row){v.addFold(o),r=!0;break}if(u==v.end.row){v.addFold(o),r=!0;if(!o.sameRow){var m=n[d+1];if(m&&m.start.row==f){v.merge(m);break}}break}if(f<=v.start.row)break}return r||(v=this.$addFoldLine(new i(this.$foldData,o))),this.$useWrapMode?this.$updateWrapData(v.start.row,v.start.row):this.$updateRowLengthCache(v.start.row,v.start.row),this.$modified=!0,this._signal("changeFold",{data:o,action:"add"}),o},this.addFolds=function(e){e.forEach(function(e){this.addFold(e)},this)},this.removeFold=function(e){var t=e.foldLine,n=t.start.row,r=t.end.row,i=this.$foldData,s=t.folds;if(s.length==1)i.splice(i.indexOf(t),1);else if(t.range.isEnd(e.end.row,e.end.column))s.pop(),t.end.row=s[s.length-1].end.row,t.end.column=s[s.length-1].end.column;else if(t.range.isStart(e.start.row,e.start.column))s.shift(),t.start.row=s[0].start.row,t.start.column=s[0].start.column;else if(e.sameRow)s.splice(s.indexOf(e),1);else{var o=t.split(e.start.row,e.start.column);s=o.folds,s.shift(),o.start.row=s[0].start.row,o.start.column=s[0].start.column}this.$updating||(this.$useWrapMode?this.$updateWrapData(n,r):this.$updateRowLengthCache(n,r)),this.$modified=!0,this._signal("changeFold",{data:e,action:"remove"})},this.removeFolds=function(e){var t=[];for(var n=0;n<e.length;n++)t.push(e[n]);t.forEach(function(e){this.removeFold(e)},this),this.$modified=!0},this.expandFold=function(e){this.removeFold(e),e.subFolds.forEach(function(t){e.restoreRange(t),this.addFold(t)},this),e.collapseChildren>0&&this.foldAll(e.start.row+1,e.end.row,e.collapseChildren-1),e.subFolds=[]},this.expandFolds=function(e){e.forEach(function(e){this.expandFold(e)},this)},this.unfold=function(e,t){var n,i;if(e==null)n=new r(0,0,this.getLength(),0),t==null&&(t=!0);else if(typeof e=="number")n=new r(e,0,e,this.getLine(e).length);else if("row"in e)n=r.fromPoints(e,e);else{if(Array.isArray(e))return i=[],e.forEach(function(e){i=i.concat(this.unfold(e))},this),i;n=e}i=this.getFoldsInRangeList(n);var s=i;while(i.length==1&&r.comparePoints(i[0].start,n.start)<0&&r.comparePoints(i[0].end,n.end)>0)this.expandFolds(i),i=this.getFoldsInRangeList(n);t!=0?this.removeFolds(i):this.expandFolds(i);if(s.length)return s},this.isRowFolded=function(e,t){return!!this.getFoldLine(e,t)},this.getRowFoldEnd=function(e,t){var n=this.getFoldLine(e,t);return n?n.end.row:e},this.getRowFoldStart=function(e,t){var n=this.getFoldLine(e,t);return n?n.start.row:e},this.getFoldDisplayLine=function(e,t,n,r,i){r==null&&(r=e.start.row),i==null&&(i=0),t==null&&(t=e.end.row),n==null&&(n=this.getLine(t).length);var s=this.doc,o="";return e.walk(function(e,t,n,u){if(t<r)return;if(t==r){if(n<i)return;u=Math.max(i,u)}e!=null?o+=e:o+=s.getLine(t).substring(u,n)},t,n),o},this.getDisplayLine=function(e,t,n,r){var i=this.getFoldLine(e);if(!i){var s;return s=this.doc.getLine(e),s.substring(r||0,t||s.length)}return this.getFoldDisplayLine(i,e,t,n,r)},this.$cloneFoldData=function(){var e=[];return e=this.$foldData.map(function(t){var n=t.folds.map(function(e){return e.clone()});return new i(e,n)}),e},this.toggleFold=function(e){var t=this.selection,n=t.getRange(),r,i;if(n.isEmpty()){var s=n.start;r=this.getFoldAt(s.row,s.column);if(r){this.expandFold(r);return}(i=this.findMatchingBracket(s))?n.comparePoint(i)==1?n.end=i:(n.start=i,n.start.column++,n.end.column--):(i=this.findMatchingBracket({row:s.row,column:s.column+1}))?(n.comparePoint(i)==1?n.end=i:n.start=i,n.start.column++):n=this.getCommentFoldRange(s.row,s.column)||n}else{var o=this.getFoldsInRange(n);if(e&&o.length){this.expandFolds(o);return}o.length==1&&(r=o[0])}r||(r=this.getFoldAt(n.start.row,n.start.column));if(r&&r.range.toString()==n.toString()){this.expandFold(r);return}var u="...";if(!n.isMultiLine()){u=this.getTextRange(n);if(u.length<4)return;u=u.trim().substring(0,2)+".."}this.addFold(u,n)},this.getCommentFoldRange=function(e,t,n){var i=new o(this,e,t),s=i.getCurrentToken(),u=s&&s.type;if(s&&/^comment|string/.test(u)){u=u.match(/comment|string/)[0],u=="comment"&&(u+="|doc-start|\\.doc");var a=new RegExp(u),f=new r;if(n!=1){do s=i.stepBackward();while(s&&a.test(s.type));s=i.stepForward()}f.start.row=i.getCurrentTokenRow(),f.start.column=i.getCurrentTokenColumn()+s.value.length,i=new o(this,e,t);var l=this.getState(i.$row);if(n!=-1){var c=-1;do{s=i.stepForward();if(c==-1){var h=this.getState(i.$row);l.toString()!==h.toString()&&(c=i.$row)}else if(i.$row>c)break}while(s&&a.test(s.type));s=i.stepBackward()}else s=i.getCurrentToken();return f.end.row=i.getCurrentTokenRow(),f.end.column=i.getCurrentTokenColumn(),f}},this.foldAll=function(e,t,n,r){n==undefined&&(n=1e5);var i=this.foldWidgets;if(!i)return;t=t||this.getLength(),e=e||0;for(var s=e;s<t;s++){i[s]==null&&(i[s]=this.getFoldWidget(s));if(i[s]!="start")continue;if(r&&!r(s))continue;var o=this.getFoldWidgetRange(s);o&&o.isMultiLine()&&o.end.row<=t&&o.start.row>=e&&(s=o.end.row,o.collapseChildren=n,this.addFold("...",o))}},this.foldToLevel=function(e){this.foldAll();while(e-->0)this.unfold(null,!1)},this.foldAllComments=function(){var e=this;this.foldAll(null,null,null,function(t){var n=e.getTokens(t);for(var r=0;r<n.length;r++){var i=n[r];if(i.type=="text"&&/^\s+$/.test(i.value))continue;return/comment/.test(i.type)?!0:!1}})},this.$foldStyles={manual:1,markbegin:1,markbeginend:1},this.$foldStyle="markbegin",this.setFoldStyle=function(e){if(!this.$foldStyles[e])throw new Error("invalid fold style: "+e+"["+Object.keys(this.$foldStyles).join(", ")+"]");if(this.$foldStyle==e)return;this.$foldStyle=e,e=="manual"&&this.unfold();var t=this.$foldMode;this.$setFolding(null),this.$setFolding(t)},this.$setFolding=function(e){if(this.$foldMode==e)return;this.$foldMode=e,this.off("change",this.$updateFoldWidgets),this.off("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets),this._signal("changeAnnotation");if(!e||this.$foldStyle=="manual"){this.foldWidgets=null;return}this.foldWidgets=[],this.getFoldWidget=e.getFoldWidget.bind(e,this,this.$foldStyle),this.getFoldWidgetRange=e.getFoldWidgetRange.bind(e,this,this.$foldStyle),this.$updateFoldWidgets=this.updateFoldWidgets.bind(this),this.$tokenizerUpdateFoldWidgets=this.tokenizerUpdateFoldWidgets.bind(this),this.on("change",this.$updateFoldWidgets),this.on("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets)},this.getParentFoldRangeData=function(e,t){var n=this.foldWidgets;if(!n||t&&n[e])return{};var r=e-1,i;while(r>=0){var s=n[r];s==null&&(s=n[r]=this.getFoldWidget(r));if(s=="start"){var o=this.getFoldWidgetRange(r);i||(i=o);if(o&&o.end.row>=e)break}r--}return{range:r!==-1&&o,firstRange:i}},this.onFoldWidgetClick=function(e,t){t instanceof u&&(t=t.domEvent);var n={children:t.shiftKey,all:t.ctrlKey||t.metaKey,siblings:t.altKey},r=this.$toggleFoldWidget(e,n);if(!r){var i=t.target||t.srcElement;i&&/ace_fold-widget/.test(i.className)&&(i.className+=" ace_invalid")}},this.$toggleFoldWidget=function(e,t){if(!this.getFoldWidget)return;var n=this.getFoldWidget(e),r=this.getLine(e),i=n==="end"?-1:1,s=this.getFoldAt(e,i===-1?0:r.length,i);if(s)return t.children||t.all?this.removeFold(s):this.expandFold(s),s;var o=this.getFoldWidgetRange(e,!0);if(o&&!o.isMultiLine()){s=this.getFoldAt(o.start.row,o.start.column,1);if(s&&o.isEqual(s.range))return this.removeFold(s),s}if(t.siblings){var u=this.getParentFoldRangeData(e);if(u.range)var a=u.range.start.row+1,f=u.range.end.row;this.foldAll(a,f,t.all?1e4:0)}else t.children?(f=o?o.end.row:this.getLength(),this.foldAll(e+1,f,t.all?1e4:0)):o&&(t.all&&(o.collapseChildren=1e4),this.addFold("...",o));return o},this.toggleFoldWidget=function(e){var t=this.selection.getCursor().row;t=this.getRowFoldStart(t);var n=this.$toggleFoldWidget(t,{});if(n)return;var r=this.getParentFoldRangeData(t,!0);n=r.range||r.firstRange;if(n){t=n.start.row;var i=this.getFoldAt(t,this.getLine(t).length,1);i?this.removeFold(i):this.addFold("...",n)}},this.updateFoldWidgets=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.foldWidgets[t]=null;else if(e.action=="remove")this.foldWidgets.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.foldWidgets.splice.apply(this.foldWidgets,r)}},this.tokenizerUpdateFoldWidgets=function(e){var t=e.data;t.first!=t.last&&this.foldWidgets.length>t.first&&this.foldWidgets.splice(t.first,this.foldWidgets.length)}}var r=e("../range").Range,i=e("./fold_line").FoldLine,s=e("./fold").Fold,o=e("../token_iterator").TokenIterator,u=e("../mouse/mouse_event").MouseEvent;t.Folding=a}),define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"],function(e,t,n){"use strict";function s(){this.findMatchingBracket=function(e,t){if(e.column==0)return null;var n=t||this.getLine(e.row).charAt(e.column-1);if(n=="")return null;var r=n.match(/([\(\[\{])|([\)\]\}])/);return r?r[1]?this.$findClosingBracket(r[1],e):this.$findOpeningBracket(r[2],e):null},this.getBracketRange=function(e){var t=this.getLine(e.row),n=!0,r,s=t.charAt(e.column-1),o=s&&s.match(/([\(\[\{])|([\)\]\}])/);o||(s=t.charAt(e.column),e={row:e.row,column:e.column+1},o=s&&s.match(/([\(\[\{])|([\)\]\}])/),n=!1);if(!o)return null;if(o[1]){var u=this.$findClosingBracket(o[1],e);if(!u)return null;r=i.fromPoints(e,u),n||(r.end.column++,r.start.column--),r.cursor=r.end}else{var u=this.$findOpeningBracket(o[2],e);if(!u)return null;r=i.fromPoints(u,e),n||(r.start.column++,r.end.column--),r.cursor=r.start}return r},this.getMatchingBracketRanges=function(e,t){var n=this.getLine(e.row),r=/([\(\[\{])|([\)\]\}])/,s=!t&&n.charAt(e.column-1),o=s&&s.match(r);o||(s=(t===undefined||t)&&n.charAt(e.column),e={row:e.row,column:e.column+1},o=s&&s.match(r));if(!o)return null;var u=new i(e.row,e.column-1,e.row,e.column),a=o[1]?this.$findClosingBracket(o[1],e):this.$findOpeningBracket(o[2],e);if(!a)return[u];var f=new i(a.row,a.column,a.row,a.column+1);return[u,f]},this.$brackets={")":"(","(":")","]":"[","[":"]","{":"}","}":"{","<":">",">":"<"},this.$findOpeningBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("rparen",".paren").replace(/\b(?:end)\b/,"(?:start|begin|end)").replace(/-close\b/,"-(close|open)")+")+"));var a=t.column-o.getCurrentTokenColumn()-2,f=u.value;for(;;){while(a>=0){var l=f.charAt(a);if(l==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else l==e&&(s+=1);a-=1}do u=o.stepBackward();while(u&&!n.test(u.type));if(u==null)break;f=u.value,a=f.length-1}return null},this.$findClosingBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("lparen",".paren").replace(/\b(?:start|begin)\b/,"(?:start|begin|end)").replace(/-open\b/,"-(close|open)")+")+"));var a=t.column-o.getCurrentTokenColumn();for(;;){var f=u.value,l=f.length;while(a<l){var c=f.charAt(a);if(c==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else c==e&&(s+=1);a+=1}do u=o.stepForward();while(u&&!n.test(u.type));if(u==null)break;a=0}return null},this.getMatchingTags=function(e){var t=new r(this,e.row,e.column),n=this.$findTagName(t);if(!n)return;var i=t.stepBackward();return i.value==="<"?this.$findClosingTag(t,n):this.$findOpeningTag(t,n)},this.$findTagName=function(e){var t=e.getCurrentToken(),n=!1,r=!1;if(t&&t.type.indexOf("tag-name")===-1)do r?t=e.stepBackward():t=e.stepForward(),t&&(t.value==="/>"?r=!0:t.type.indexOf("tag-name")!==-1&&(n=!0));while(t&&!n);return t},this.$findClosingTag=function(e,t){var n,r=t.value,s=t.value,o=0,u=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);t=e.stepForward();var a=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length),f=!1;do{n=t;if(n.type.indexOf("tag-close")!==-1&&!f){var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);f=!0}t=e.stepForward();if(t){if(t.value===">"&&!f){var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);f=!0}if(t.type.indexOf("tag-name")!==-1){r=t.value;if(s===r)if(n.value==="<")o++;else if(n.value==="</"){o--;if(o<0){e.stepBackward();var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+2);t=e.stepForward();var h=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length);t.type.indexOf("tag-close")===-1&&(t=e.stepForward());if(!t||t.value!==">")return;var p=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1)}}}else if(s===r&&t.value==="/>"){o--;if(o<0)var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+2),h=c,p=h,l=new i(a.end.row,a.end.column,a.end.row,a.end.column+1)}}}while(t&&o>=0);if(u&&l&&c&&p&&a&&h)return{openTag:new i(u.start.row,u.start.column,l.end.row,l.end.column),closeTag:new i(c.start.row,c.start.column,p.end.row,p.end.column),openTagName:a,closeTagName:h}},this.$findOpeningTag=function(e,t){var n=e.getCurrentToken(),r=t.value,s=0,o=e.getCurrentTokenRow(),u=e.getCurrentTokenColumn(),a=u+2,f=new i(o,u,o,a);e.stepForward();var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length);t.type.indexOf("tag-close")===-1&&(t=e.stepForward());if(!t||t.value!==">")return;var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);e.stepBackward(),e.stepBackward();do{t=n,o=e.getCurrentTokenRow(),u=e.getCurrentTokenColumn(),a=u+t.value.length,n=e.stepBackward();if(t)if(t.type.indexOf("tag-name")!==-1){if(r===t.value)if(n.value==="<"){s++;if(s>0){var h=new i(o,u,o,a),p=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);do t=e.stepForward();while(t&&t.value!==">");var d=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1)}}else n.value==="</"&&s--}else if(t.value==="/>"){var v=0,m=n;while(m){if(m.type.indexOf("tag-name")!==-1&&m.value===r){s--;break}if(m.value==="<")break;m=e.stepBackward(),v++}for(var g=0;g<v;g++)e.stepForward()}}while(n&&s<=0);if(p&&d&&f&&c&&h&&l)return{openTag:new i(p.start.row,p.start.column,d.end.row,d.end.column),closeTag:new i(f.start.row,f.start.column,c.end.row,c.end.column),openTagName:h,closeTagName:l}}}var r=e("../token_iterator").TokenIterator,i=e("../range").Range;t.BracketMatch=s}),define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/bidihandler","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/line_widgets","ace/document","ace/background_tokenizer","ace/search_highlight","ace/undomanager","ace/edit_session/folding","ace/edit_session/bracket_match"],function(e,t,n){"use strict";function N(e){return e<4352?!1:e>=4352&&e<=4447||e>=4515&&e<=4519||e>=4602&&e<=4607||e>=9001&&e<=9002||e>=11904&&e<=11929||e>=11931&&e<=12019||e>=12032&&e<=12245||e>=12272&&e<=12283||e>=12288&&e<=12350||e>=12353&&e<=12438||e>=12441&&e<=12543||e>=12549&&e<=12589||e>=12593&&e<=12686||e>=12688&&e<=12730||e>=12736&&e<=12771||e>=12784&&e<=12830||e>=12832&&e<=12871||e>=12880&&e<=13054||e>=13056&&e<=19903||e>=19968&&e<=42124||e>=42128&&e<=42182||e>=43360&&e<=43388||e>=44032&&e<=55203||e>=55216&&e<=55238||e>=55243&&e<=55291||e>=63744&&e<=64255||e>=65040&&e<=65049||e>=65072&&e<=65106||e>=65108&&e<=65126||e>=65128&&e<=65131||e>=65281&&e<=65376||e>=65504&&e<=65510}var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./bidihandler").BidiHandler,o=e("./config"),u=e("./lib/event_emitter").EventEmitter,a=e("./selection").Selection,f=e("./mode/text").Mode,l=e("./range").Range,c=e("./line_widgets").LineWidgets,h=e("./document").Document,p=e("./background_tokenizer").BackgroundTokenizer,d=e("./search_highlight").SearchHighlight,v=e("./undomanager").UndoManager,m=function(){function e(t,n){this.doc,this.$breakpoints=[],this.$decorations=[],this.$frontMarkers={},this.$backMarkers={},this.$markerId=1,this.$undoSelect=!0,this.$editor=null,this.prevOp={},this.$foldData=[],this.id="session"+ ++e.$uid,this.$foldData.toString=function(){return this.join("\n")},this.bgTokenizer=new p((new f).getTokenizer(),this);var r=this;this.bgTokenizer.on("update",function(e){r._signal("tokenizerUpdate",e)}),this.on("changeFold",this.onChangeFold.bind(this)),this.$onChange=this.onChange.bind(this);if(typeof t!="object"||!t.getLine)t=new h(t);this.setDocument(t),this.selection=new a(this),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.selection.on("changeCursor",this.$onSelectionChange),this.$bidiHandler=new s(this),o.resetOptions(this),this.setMode(n),o._signal("session",this),this.destroyed=!1,this.$initOperationListeners()}return e.prototype.$initOperationListeners=function(){var e=this;this.curOp=null,this.on("change",function(){e.curOp||(e.startOperation(),e.curOp.selectionBefore=e.$lastSel),e.curOp.docChanged=!0},!0),this.on("changeSelection",function(){e.curOp||(e.startOperation(),e.curOp.selectionBefore=e.$lastSel),e.curOp.selectionChanged=!0},!0),this.$operationResetTimer=i.delayedCall(this.endOperation.bind(this,!0))},e.prototype.startOperation=function(e){if(this.curOp){if(!e||this.curOp.command)return;this.prevOp=this.curOp}e||(e={}),this.$operationResetTimer.schedule(),this.curOp={command:e.command||{},args:e.args},this.curOp.selectionBefore=this.selection.toJSON(),this._signal("startOperation",e)},e.prototype.endOperation=function(e){if(this.curOp){if(e&&e.returnValue===!1){this.curOp=null,this._signal("endOperation",e);return}if(e==1&&this.curOp.command&&this.curOp.command.name=="mouse")return;var t=this.selection.toJSON();this.curOp.selectionAfter=t,this.$lastSel=this.selection.toJSON(),this.getUndoManager().addSelection(t),this._signal("beforeEndOperation"),this.prevOp=this.curOp,this.curOp=null,this._signal("endOperation",e)}},e.prototype.setDocument=function(e){this.doc&&this.doc.off("change",this.$onChange),this.doc=e,e.on("change",this.$onChange,!0),this.bgTokenizer.setDocument(this.getDocument()),this.resetCaches()},e.prototype.getDocument=function(){return this.doc},Object.defineProperty(e.prototype,"widgetManager",{get:function(){var e=new c(this);return this.widgetManager=e,this.$editor&&e.attach(this.$editor),e},set:function(e){Object.defineProperty(this,"widgetManager",{writable:!0,enumerable:!0,configurable:!0,value:e})},enumerable:!1,configurable:!0}),e.prototype.$resetRowCache=function(e){if(!e){this.$docRowCache=[],this.$screenRowCache=[];return}var t=this.$docRowCache.length,n=this.$getRowCacheIndex(this.$docRowCache,e)+1;t>n&&(this.$docRowCache.splice(n,t),this.$screenRowCache.splice(n,t))},e.prototype.$getRowCacheIndex=function(e,t){var n=0,r=e.length-1;while(n<=r){var i=n+r>>1,s=e[i];if(t>s)n=i+1;else{if(!(t<s))return i;r=i-1}}return n-1},e.prototype.resetCaches=function(){this.$modified=!0,this.$wrapData=[],this.$rowLengthCache=[],this.$resetRowCache(0),this.destroyed||this.bgTokenizer.start(0)},e.prototype.onChangeFold=function(e){var t=e.data;this.$resetRowCache(t.start.row)},e.prototype.onChange=function(e){this.$modified=!0,this.$bidiHandler.onChange(e),this.$resetRowCache(e.start.row);var t=this.$updateInternalDataOnChange(e);!this.$fromUndo&&this.$undoManager&&(t&&t.length&&(this.$undoManager.add({action:"removeFolds",folds:t},this.mergeUndoDeltas),this.mergeUndoDeltas=!0),this.$undoManager.add(e,this.mergeUndoDeltas),this.mergeUndoDeltas=!0,this.$informUndoManager.schedule()),this.bgTokenizer.$updateOnChange(e),this._signal("change",e)},e.prototype.onSelectionChange=function(){this._signal("changeSelection")},e.prototype.setValue=function(e){this.doc.setValue(e),this.selection.moveTo(0,0),this.$resetRowCache(0),this.setUndoManager(this.$undoManager),this.getUndoManager().reset()},e.fromJSON=function(t){typeof t=="string"&&(t=JSON.parse(t));var n=new v;n.$undoStack=t.history.undo,n.$redoStack=t.history.redo,n.mark=t.history.mark,n.$rev=t.history.rev;var r=new e(t.value);return t.folds.forEach(function(e){r.addFold("...",l.fromPoints(e.start,e.end))}),r.setAnnotations(t.annotations),r.setBreakpoints(t.breakpoints),r.setMode(t.mode),r.setScrollLeft(t.scrollLeft),r.setScrollTop(t.scrollTop),r.setUndoManager(n),r.selection.fromJSON(t.selection),r},e.prototype.toJSON=function(){return{annotations:this.$annotations,breakpoints:this.$breakpoints,folds:this.getAllFolds().map(function(e){return e.range}),history:this.getUndoManager(),mode:this.$mode.$id,scrollLeft:this.$scrollLeft,scrollTop:this.$scrollTop,selection:this.selection.toJSON(),value:this.doc.getValue()}},e.prototype.toString=function(){return this.doc.getValue()},e.prototype.getSelection=function(){return this.selection},e.prototype.getState=function(e){return this.bgTokenizer.getState(e)},e.prototype.getTokens=function(e){return this.bgTokenizer.getTokens(e)},e.prototype.getTokenAt=function(e,t){var n=this.bgTokenizer.getTokens(e),r,i=0;if(t==null){var s=n.length-1;i=this.getLine(e).length}else for(var s=0;s<n.length;s++){i+=n[s].value.length;if(i>=t)break}return r=n[s],r?(r.index=s,r.start=i-r.value.length,r):null},e.prototype.setUndoManager=function(e){this.$undoManager=e,this.$informUndoManager&&this.$informUndoManager.cancel();if(e){var t=this;e.addSession(this),this.$syncInformUndoManager=function(){t.$informUndoManager.cancel(),t.mergeUndoDeltas=!1},this.$informUndoManager=i.delayedCall(this.$syncInformUndoManager)}else this.$syncInformUndoManager=function(){}},e.prototype.markUndoGroup=function(){this.$syncInformUndoManager&&this.$syncInformUndoManager()},e.prototype.getUndoManager=function(){return this.$undoManager||this.$defaultUndoManager},e.prototype.getTabString=function(){return this.getUseSoftTabs()?i.stringRepeat(" ",this.getTabSize()):"	"},e.prototype.setUseSoftTabs=function(e){this.setOption("useSoftTabs",e)},e.prototype.getUseSoftTabs=function(){return this.$useSoftTabs&&!this.$mode.$indentWithTabs},e.prototype.setTabSize=function(e){this.setOption("tabSize",e)},e.prototype.getTabSize=function(){return this.$tabSize},e.prototype.isTabStop=function(e){return this.$useSoftTabs&&e.column%this.$tabSize===0},e.prototype.setNavigateWithinSoftTabs=function(e){this.setOption("navigateWithinSoftTabs",e)},e.prototype.getNavigateWithinSoftTabs=function(){return this.$navigateWithinSoftTabs},e.prototype.setOverwrite=function(e){this.setOption("overwrite",e)},e.prototype.getOverwrite=function(){return this.$overwrite},e.prototype.toggleOverwrite=function(){this.setOverwrite(!this.$overwrite)},e.prototype.addGutterDecoration=function(e,t){this.$decorations[e]||(this.$decorations[e]=""),this.$decorations[e]+=" "+t,this._signal("changeBreakpoint",{})},e.prototype.removeGutterDecoration=function(e,t){this.$decorations[e]=(this.$decorations[e]||"").replace(" "+t,""),this._signal("changeBreakpoint",{})},e.prototype.getBreakpoints=function(){return this.$breakpoints},e.prototype.setBreakpoints=function(e){this.$breakpoints=[];for(var t=0;t<e.length;t++)this.$breakpoints[e[t]]="ace_breakpoint";this._signal("changeBreakpoint",{})},e.prototype.clearBreakpoints=function(){this.$breakpoints=[],this._signal("changeBreakpoint",{})},e.prototype.setBreakpoint=function(e,t){t===undefined&&(t="ace_breakpoint"),t?this.$breakpoints[e]=t:delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},e.prototype.clearBreakpoint=function(e){delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},e.prototype.addMarker=function(e,t,n,r){var i=this.$markerId++,s={range:e,type:n||"line",renderer:typeof n=="function"?n:null,clazz:t,inFront:!!r,id:i};return r?(this.$frontMarkers[i]=s,this._signal("changeFrontMarker")):(this.$backMarkers[i]=s,this._signal("changeBackMarker")),i},e.prototype.addDynamicMarker=function(e,t){if(!e.update)return;var n=this.$markerId++;return e.id=n,e.inFront=!!t,t?(this.$frontMarkers[n]=e,this._signal("changeFrontMarker")):(this.$backMarkers[n]=e,this._signal("changeBackMarker")),e},e.prototype.removeMarker=function(e){var t=this.$frontMarkers[e]||this.$backMarkers[e];if(!t)return;var n=t.inFront?this.$frontMarkers:this.$backMarkers;delete n[e],this._signal(t.inFront?"changeFrontMarker":"changeBackMarker")},e.prototype.getMarkers=function(e){return e?this.$frontMarkers:this.$backMarkers},e.prototype.highlight=function(e){if(!this.$searchHighlight){var t=new d(null,"ace_selected-word","text");this.$searchHighlight=this.addDynamicMarker(t)}this.$searchHighlight.setRegexp(e)},e.prototype.highlightLines=function(e,t,n,r){typeof t!="number"&&(n=t,t=e),n||(n="ace_step");var i=new l(e,0,t,Infinity);return i.id=this.addMarker(i,n,"fullLine",r),i},e.prototype.setAnnotations=function(e){this.$annotations=e,this._signal("changeAnnotation",{})},e.prototype.getAnnotations=function(){return this.$annotations||[]},e.prototype.clearAnnotations=function(){this.setAnnotations([])},e.prototype.$detectNewLine=function(e){var t=e.match(/^.*?(\r?\n)/m);t?this.$autoNewLine=t[1]:this.$autoNewLine="\n"},e.prototype.getWordRange=function(e,t){var n=this.getLine(e),r=!1;t>0&&(r=!!n.charAt(t-1).match(this.tokenRe)),r||(r=!!n.charAt(t).match(this.tokenRe));if(r)var i=this.tokenRe;else if(/^\s+$/.test(n.slice(t-1,t+1)))var i=/\s/;else var i=this.nonTokenRe;var s=t;if(s>0){do s--;while(s>=0&&n.charAt(s).match(i));s++}var o=t;while(o<n.length&&n.charAt(o).match(i))o++;return new l(e,s,e,o)},e.prototype.getAWordRange=function(e,t){var n=this.getWordRange(e,t),r=this.getLine(n.end.row);while(r.charAt(n.end.column).match(/[ \t]/))n.end.column+=1;return n},e.prototype.setNewLineMode=function(e){this.doc.setNewLineMode(e)},e.prototype.getNewLineMode=function(){return this.doc.getNewLineMode()},e.prototype.setUseWorker=function(e){this.setOption("useWorker",e)},e.prototype.getUseWorker=function(){return this.$useWorker},e.prototype.onReloadTokenizer=function(e){var t=e.data;this.bgTokenizer.start(t.first),this._signal("tokenizerUpdate",e)},e.prototype.setMode=function(e,t){if(e&&typeof e=="object"){if(e.getTokenizer)return this.$onChangeMode(e);var n=e,r=n.path}else r=e||"ace/mode/text";this.$modes["ace/mode/text"]||(this.$modes["ace/mode/text"]=new f);if(this.$modes[r]&&!n){this.$onChangeMode(this.$modes[r]),t&&t();return}this.$modeId=r,o.loadModule(["mode",r],function(e){if(this.destroyed)return;if(this.$modeId!==r)return t&&t();this.$modes[r]&&!n?this.$onChangeMode(this.$modes[r]):e&&e.Mode&&(e=new e.Mode(n),n||(this.$modes[r]=e,e.$id=r),this.$onChangeMode(e)),t&&t()}.bind(this)),this.$mode||this.$onChangeMode(this.$modes["ace/mode/text"],!0)},e.prototype.$onChangeMode=function(e,t){t||(this.$modeId=e.$id);if(this.$mode===e)return;var n=this.$mode;this.$mode=e,this.$stopWorker(),this.$useWorker&&this.$startWorker();var r=e.getTokenizer();if(r.on!==undefined){var i=this.onReloadTokenizer.bind(this);r.on("update",i)}this.bgTokenizer.setTokenizer(r),this.bgTokenizer.setDocument(this.getDocument()),this.tokenRe=e.tokenRe,this.nonTokenRe=e.nonTokenRe,t||(e.attachToSession&&e.attachToSession(this),this.$options.wrapMethod.set.call(this,this.$wrapMethod),this.$setFolding(e.foldingRules),this.bgTokenizer.start(0),this._emit("changeMode",{oldMode:n,mode:e}))},e.prototype.$stopWorker=function(){this.$worker&&(this.$worker.terminate(),this.$worker=null)},e.prototype.$startWorker=function(){try{this.$worker=this.$mode.createWorker(this)}catch(e){o.warn("Could not load worker",e),this.$worker=null}},e.prototype.getMode=function(){return this.$mode},e.prototype.setScrollTop=function(e){if(this.$scrollTop===e||isNaN(e))return;this.$scrollTop=e,this._signal("changeScrollTop",e)},e.prototype.getScrollTop=function(){return this.$scrollTop},e.prototype.setScrollLeft=function(e){if(this.$scrollLeft===e||isNaN(e))return;this.$scrollLeft=e,this._signal("changeScrollLeft",e)},e.prototype.getScrollLeft=function(){return this.$scrollLeft},e.prototype.getScreenWidth=function(){return this.$computeWidth(),this.lineWidgets?Math.max(this.getLineWidgetMaxWidth(),this.screenWidth):this.screenWidth},e.prototype.getLineWidgetMaxWidth=function(){if(this.lineWidgetsWidth!=null)return this.lineWidgetsWidth;var e=0;return this.lineWidgets.forEach(function(t){t&&t.screenWidth>e&&(e=t.screenWidth)}),this.lineWidgetWidth=e},e.prototype.$computeWidth=function(e){if(this.$modified||e){this.$modified=!1;if(this.$useWrapMode)return this.screenWidth=this.$wrapLimit;var t=this.doc.getAllLines(),n=this.$rowLengthCache,r=0,i=0,s=this.$foldData[i],o=s?s.start.row:Infinity,u=t.length;for(var a=0;a<u;a++){if(a>o){a=s.end.row+1;if(a>=u)break;s=this.$foldData[i++],o=s?s.start.row:Infinity}n[a]==null&&(n[a]=this.$getStringScreenWidth(t[a])[0]),n[a]>r&&(r=n[a])}this.screenWidth=r}},e.prototype.getLine=function(e){return this.doc.getLine(e)},e.prototype.getLines=function(e,t){return this.doc.getLines(e,t)},e.prototype.getLength=function(){return this.doc.getLength()},e.prototype.getTextRange=function(e){return this.doc.getTextRange(e||this.selection.getRange())},e.prototype.insert=function(e,t){return this.doc.insert(e,t)},e.prototype.remove=function(e){return this.doc.remove(e)},e.prototype.removeFullLines=function(e,t){return this.doc.removeFullLines(e,t)},e.prototype.undoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;for(var n=e.length-1;n!=-1;n--){var r=e[n];r.action=="insert"||r.action=="remove"?this.doc.revertDelta(r):r.folds&&this.addFolds(r.folds)}!t&&this.$undoSelect&&(e.selectionBefore?this.selection.fromJSON(e.selectionBefore):this.selection.setRange(this.$getUndoSelection(e,!0))),this.$fromUndo=!1},e.prototype.redoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;for(var n=0;n<e.length;n++){var r=e[n];(r.action=="insert"||r.action=="remove")&&this.doc.$safeApplyDelta(r)}!t&&this.$undoSelect&&(e.selectionAfter?this.selection.fromJSON(e.selectionAfter):this.selection.setRange(this.$getUndoSelection(e,!1))),this.$fromUndo=!1},e.prototype.setUndoSelect=function(e){this.$undoSelect=e},e.prototype.$getUndoSelection=function(e,t){function n(e){return t?e.action!=="insert":e.action==="insert"}var r,i;for(var s=0;s<e.length;s++){var o=e[s];if(!o.start)continue;if(!r){n(o)?r=l.fromPoints(o.start,o.end):r=l.fromPoints(o.start,o.start);continue}n(o)?(i=o.start,r.compare(i.row,i.column)==-1&&r.setStart(i),i=o.end,r.compare(i.row,i.column)==1&&r.setEnd(i)):(i=o.start,r.compare(i.row,i.column)==-1&&(r=l.fromPoints(o.start,o.start)))}return r},e.prototype.replace=function(e,t){return this.doc.replace(e,t)},e.prototype.moveText=function(e,t,n){var r=this.getTextRange(e),i=this.getFoldsInRange(e),s=l.fromPoints(t,t);if(!n){this.remove(e);var o=e.start.row-e.end.row,u=o?-e.end.column:e.start.column-e.end.column;u&&(s.start.row==e.end.row&&s.start.column>e.end.column&&(s.start.column+=u),s.end.row==e.end.row&&s.end.column>e.end.column&&(s.end.column+=u)),o&&s.start.row>=e.end.row&&(s.start.row+=o,s.end.row+=o)}s.end=this.insert(s.start,r);if(i.length){var a=e.start,f=s.start,o=f.row-a.row,u=f.column-a.column;this.addFolds(i.map(function(e){return e=e.clone(),e.start.row==a.row&&(e.start.column+=u),e.end.row==a.row&&(e.end.column+=u),e.start.row+=o,e.end.row+=o,e}))}return s},e.prototype.indentRows=function(e,t,n){n=n.replace(/\t/g,this.getTabString());for(var r=e;r<=t;r++)this.doc.insertInLine({row:r,column:0},n)},e.prototype.outdentRows=function(e){var t=e.collapseRows(),n=new l(0,0,0,0),r=this.getTabSize();for(var i=t.start.row;i<=t.end.row;++i){var s=this.getLine(i);n.start.row=i,n.end.row=i;for(var o=0;o<r;++o)if(s.charAt(o)!=" ")break;o<r&&s.charAt(o)=="	"?(n.start.column=o,n.end.column=o+1):(n.start.column=0,n.end.column=o),this.remove(n)}},e.prototype.$moveLines=function(e,t,n){e=this.getRowFoldStart(e),t=this.getRowFoldEnd(t);if(n<0){var r=this.getRowFoldStart(e+n);if(r<0)return 0;var i=r-e}else if(n>0){var r=this.getRowFoldEnd(t+n);if(r>this.doc.getLength()-1)return 0;var i=r-t}else{e=this.$clipRowToDocument(e),t=this.$clipRowToDocument(t);var i=t-e+1}var s=new l(e,0,t,Number.MAX_VALUE),o=this.getFoldsInRange(s).map(function(e){return e=e.clone(),e.start.row+=i,e.end.row+=i,e}),u=n==0?this.doc.getLines(e,t):this.doc.removeFullLines(e,t);return this.doc.insertFullLines(e+i,u),o.length&&this.addFolds(o),i},e.prototype.moveLinesUp=function(e,t){return this.$moveLines(e,t,-1)},e.prototype.moveLinesDown=function(e,t){return this.$moveLines(e,t,1)},e.prototype.duplicateLines=function(e,t){return this.$moveLines(e,t,0)},e.prototype.$clipRowToDocument=function(e){return Math.max(0,Math.min(e,this.doc.getLength()-1))},e.prototype.$clipColumnToRow=function(e,t){return t<0?0:Math.min(this.doc.getLine(e).length,t)},e.prototype.$clipPositionToDocument=function(e,t){t=Math.max(0,t);if(e<0)e=0,t=0;else{var n=this.doc.getLength();e>=n?(e=n-1,t=this.doc.getLine(n-1).length):t=Math.min(this.doc.getLine(e).length,t)}return{row:e,column:t}},e.prototype.$clipRangeToDocument=function(e){e.start.row<0?(e.start.row=0,e.start.column=0):e.start.column=this.$clipColumnToRow(e.start.row,e.start.column);var t=this.doc.getLength()-1;return e.end.row>t?(e.end.row=t,e.end.column=this.doc.getLine(t).length):e.end.column=this.$clipColumnToRow(e.end.row,e.end.column),e},e.prototype.setUseWrapMode=function(e){if(e!=this.$useWrapMode){this.$useWrapMode=e,this.$modified=!0,this.$resetRowCache(0);if(e){var t=this.getLength();this.$wrapData=Array(t),this.$updateWrapData(0,t-1)}this._signal("changeWrapMode")}},e.prototype.getUseWrapMode=function(){return this.$useWrapMode},e.prototype.setWrapLimitRange=function(e,t){if(this.$wrapLimitRange.min!==e||this.$wrapLimitRange.max!==t)this.$wrapLimitRange={min:e,max:t},this.$modified=!0,this.$bidiHandler.markAsDirty(),this.$useWrapMode&&this._signal("changeWrapMode")},e.prototype.adjustWrapLimit=function(e,t){var n=this.$wrapLimitRange;n.max<0&&(n={min:t,max:t});var r=this.$constrainWrapLimit(e,n.min,n.max);return r!=this.$wrapLimit&&r>1?(this.$wrapLimit=r,this.$modified=!0,this.$useWrapMode&&(this.$updateWrapData(0,this.getLength()-1),this.$resetRowCache(0),this._signal("changeWrapLimit")),!0):!1},e.prototype.$constrainWrapLimit=function(e,t,n){return t&&(e=Math.max(t,e)),n&&(e=Math.min(n,e)),e},e.prototype.getWrapLimit=function(){return this.$wrapLimit},e.prototype.setWrapLimit=function(e){this.setWrapLimitRange(e,e)},e.prototype.getWrapLimitRange=function(){return{min:this.$wrapLimitRange.min,max:this.$wrapLimitRange.max}},e.prototype.$updateInternalDataOnChange=function(e){var t=this.$useWrapMode,n=e.action,r=e.start,i=e.end,s=r.row,o=i.row,u=o-s,a=null;this.$updating=!0;if(u!=0)if(n==="remove"){this[t?"$wrapData":"$rowLengthCache"].splice(s,u);var f=this.$foldData;a=this.getFoldsInRange(e),this.removeFolds(a);var l=this.getFoldLine(i.row),c=0;if(l){l.addRemoveChars(i.row,i.column,r.column-i.column),l.shiftRow(-u);var h=this.getFoldLine(s);h&&h!==l&&(h.merge(l),l=h),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=i.row&&l.shiftRow(-u)}o=s}else{var p=Array(u);p.unshift(s,0);var d=t?this.$wrapData:this.$rowLengthCache;d.splice.apply(d,p);var f=this.$foldData,l=this.getFoldLine(s),c=0;if(l){var v=l.range.compareInside(r.row,r.column);v==0?(l=l.split(r.row,r.column),l&&(l.shiftRow(u),l.addRemoveChars(o,0,i.column-r.column))):v==-1&&(l.addRemoveChars(s,0,i.column-r.column),l.shiftRow(u)),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=s&&l.shiftRow(u)}}else{u=Math.abs(e.start.column-e.end.column),n==="remove"&&(a=this.getFoldsInRange(e),this.removeFolds(a),u=-u);var l=this.getFoldLine(s);l&&l.addRemoveChars(s,r.column,u)}return t&&this.$wrapData.length!=this.doc.getLength()&&console.error("doc.getLength() and $wrapData.length have to be the same!"),this.$updating=!1,t?this.$updateWrapData(s,o):this.$updateRowLengthCache(s,o),a},e.prototype.$updateRowLengthCache=function(e,t){this.$rowLengthCache[e]=null,this.$rowLengthCache[t]=null},e.prototype.$updateWrapData=function(e,t){var n=this.doc.getAllLines(),r=this.getTabSize(),i=this.$wrapData,s=this.$wrapLimit,o,u,a=e;t=Math.min(t,n.length-1);while(a<=t)u=this.getFoldLine(a,u),u?(o=[],u.walk(function(e,t,r,i){var s;if(e!=null){s=this.$getDisplayTokens(e,o.length),s[0]=b;for(var u=1;u<s.length;u++)s[u]=w}else s=this.$getDisplayTokens(n[t].substring(i,r),o.length);o=o.concat(s)}.bind(this),u.end.row,n[u.end.row].length+1),i[u.start.row]=this.$computeWrapSplits(o,s,r),a=u.end.row+1):(o=this.$getDisplayTokens(n[a]),i[a]=this.$computeWrapSplits(o,s,r),a++)},e.prototype.$computeWrapSplits=function(e,t,n){function l(){var t=0;if(f===0)return t;if(a)for(var r=0;r<e.length;r++){var i=e[r];if(i==S)t+=1;else{if(i!=x){if(i==T)continue;break}t+=n}}return u&&a!==!1&&(t+=n),Math.min(t,f)}function c(t){var n=t-s;for(var i=s;i<t;i++){var u=e[i];if(u===12||u===2)n-=1}r.length||(h=l(),r.indent=h),o+=n,r.push(o),s=t}if(e.length==0)return[];var r=[],i=e.length,s=0,o=0,u=this.$wrapAsCode,a=this.$indentedSoftWrap,f=t<=Math.max(2*n,8)||a===!1?0:Math.floor(t/2),h=0;while(i-s>t-h){var p=s+t-h;if(e[p-1]>=S&&e[p]>=S){c(p);continue}if(e[p]==b||e[p]==w){for(p;p!=s-1;p--)if(e[p]==b)break;if(p>s){c(p);continue}p=s+t;for(p;p<e.length;p++)if(e[p]!=w)break;if(p==e.length)break;c(p);continue}var d=Math.max(p-(t-(t>>2)),s-1);while(p>d&&e[p]<b)p--;if(u){while(p>d&&e[p]<b)p--;while(p>d&&e[p]==E)p--}else while(p>d&&e[p]<S)p--;if(p>d){c(++p);continue}p=s+t,e[p]==y&&p--,c(p-h)}return r},e.prototype.$getDisplayTokens=function(e,t){var n=[],r;t=t||0;for(var i=0;i<e.length;i++){var s=e.charCodeAt(i);if(s==9){r=this.getScreenTabSize(n.length+t),n.push(x);for(var o=1;o<r;o++)n.push(T)}else s==32?n.push(S):s>39&&s<48||s>57&&s<64?n.push(E):s>=4352&&N(s)?n.push(g,y):n.push(g)}return n},e.prototype.$getStringScreenWidth=function(e,t,n){if(t==0)return[0,0];t==null&&(t=Infinity),n=n||0;var r,i;for(i=0;i<e.length;i++){r=e.charCodeAt(i),r==9?n+=this.getScreenTabSize(n):r>=4352&&N(r)?n+=2:n+=1;if(n>t)break}return[n,i]},e.prototype.getRowLength=function(e){var t=1;return this.lineWidgets&&(t+=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0),!this.$useWrapMode||!this.$wrapData[e]?t:this.$wrapData[e].length+t},e.prototype.getRowLineCount=function(e){return!this.$useWrapMode||!this.$wrapData[e]?1:this.$wrapData[e].length+1},e.prototype.getRowWrapIndent=function(e){if(this.$useWrapMode){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE),n=this.$wrapData[t.row];return n.length&&n[0]<t.column?n.indent:0}return 0},e.prototype.getScreenLastRowColumn=function(e){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE);return this.documentToScreenColumn(t.row,t.column)},e.prototype.getDocumentLastRowColumn=function(e,t){var n=this.documentToScreenRow(e,t);return this.getScreenLastRowColumn(n)},e.prototype.getDocumentLastRowColumnPosition=function(e,t){var n=this.documentToScreenRow(e,t);return this.screenToDocumentPosition(n,Number.MAX_VALUE/10)},e.prototype.getRowSplitData=function(e){return this.$useWrapMode?this.$wrapData[e]:undefined},e.prototype.getScreenTabSize=function(e){return this.$tabSize-(e%this.$tabSize|0)},e.prototype.screenToDocumentRow=function(e,t){return this.screenToDocumentPosition(e,t).row},e.prototype.screenToDocumentColumn=function(e,t){return this.screenToDocumentPosition(e,t).column},e.prototype.screenToDocumentPosition=function(e,t,n){if(e<0)return{row:0,column:0};var r,i=0,s=0,o,u=0,a=0,f=this.$screenRowCache,l=this.$getRowCacheIndex(f,e),c=f.length;if(c&&l>=0)var u=f[l],i=this.$docRowCache[l],h=e>f[c-1];else var h=!c;var p=this.getLength()-1,d=this.getNextFoldLine(i),v=d?d.start.row:Infinity;while(u<=e){a=this.getRowLength(i);if(u+a>e||i>=p)break;u+=a,i++,i>v&&(i=d.end.row+1,d=this.getNextFoldLine(i,d),v=d?d.start.row:Infinity),h&&(this.$docRowCache.push(i),this.$screenRowCache.push(u))}if(d&&d.start.row<=i)r=this.getFoldDisplayLine(d),i=d.start.row;else{if(u+a<=e||i>p)return{row:p,column:this.getLine(p).length};r=this.getLine(i),d=null}var m=0,g=Math.floor(e-u);if(this.$useWrapMode){var y=this.$wrapData[i];y&&(o=y[g],g>0&&y.length&&(m=y.indent,s=y[g-1]||y[y.length-1],r=r.substring(s)))}return n!==undefined&&this.$bidiHandler.isBidiRow(u+g,i,g)&&(t=this.$bidiHandler.offsetToCol(n)),s+=this.$getStringScreenWidth(r,t-m)[1],this.$useWrapMode&&s>=o&&(s=o-1),d?d.idxToPosition(s):{row:i,column:s}},e.prototype.documentToScreenPosition=function(e,t){if(typeof t=="undefined")var n=this.$clipPositionToDocument(e.row,e.column);else n=this.$clipPositionToDocument(e,t);e=n.row,t=n.column;var r=0,i=null,s=null;s=this.getFoldAt(e,t,1),s&&(e=s.start.row,t=s.start.column);var o,u=0,a=this.$docRowCache,f=this.$getRowCacheIndex(a,e),l=a.length;if(l&&f>=0)var u=a[f],r=this.$screenRowCache[f],c=e>a[l-1];else var c=!l;var h=this.getNextFoldLine(u),p=h?h.start.row:Infinity;while(u<e){if(u>=p){o=h.end.row+1;if(o>e)break;h=this.getNextFoldLine(o,h),p=h?h.start.row:Infinity}else o=u+1;r+=this.getRowLength(u),u=o,c&&(this.$docRowCache.push(u),this.$screenRowCache.push(r))}var d="";h&&u>=p?(d=this.getFoldDisplayLine(h,e,t),i=h.start.row):(d=this.getLine(e).substring(0,t),i=e);var v=0;if(this.$useWrapMode){var m=this.$wrapData[i];if(m){var g=0;while(d.length>=m[g])r++,g++;d=d.substring(m[g-1]||0,d.length),v=g>0?m.indent:0}}return this.lineWidgets&&this.lineWidgets[u]&&this.lineWidgets[u].rowsAbove&&(r+=this.lineWidgets[u].rowsAbove),{row:r,column:v+this.$getStringScreenWidth(d)[0]}},e.prototype.documentToScreenColumn=function(e,t){return this.documentToScreenPosition(e,t).column},e.prototype.documentToScreenRow=function(e,t){return this.documentToScreenPosition(e,t).row},e.prototype.getScreenLength=function(){var e=0,t=null;if(!this.$useWrapMode){e=this.getLength();var n=this.$foldData;for(var r=0;r<n.length;r++)t=n[r],e-=t.end.row-t.start.row}else{var i=this.$wrapData.length,s=0,r=0,t=this.$foldData[r++],o=t?t.start.row:Infinity;while(s<i){var u=this.$wrapData[s];e+=u?u.length+1:1,s++,s>o&&(s=t.end.row+1,t=this.$foldData[r++],o=t?t.start.row:Infinity)}}return this.lineWidgets&&(e+=this.$getWidgetScreenLength()),e},e.prototype.$setFontMetrics=function(e){if(!this.$enableVarChar)return;this.$getStringScreenWidth=function(t,n,r){if(n===0)return[0,0];n||(n=Infinity),r=r||0;var i,s;for(s=0;s<t.length;s++){i=t.charAt(s),i==="	"?r+=this.getScreenTabSize(r):r+=e.getCharacterWidth(i);if(r>n)break}return[r,s]}},e.prototype.getPrecedingCharacter=function(){var e=this.selection.getCursor();if(e.column===0)return e.row===0?"":this.doc.getNewLineCharacter();var t=this.getLine(e.row);return t[e.column-1]},e.prototype.destroy=function(){this.destroyed||(this.bgTokenizer.setDocument(null),this.bgTokenizer.cleanup(),this.destroyed=!0),this.endOperation(),this.$stopWorker(),this.removeAllListeners(),this.doc&&this.doc.off("change",this.$onChange),this.selection&&(this.selection.off("changeCursor",this.$onSelectionChange),this.selection.off("changeSelection",this.$onSelectionChange)),this.selection.detach()},e}();m.$uid=0,m.prototype.$modes=o.$modes,m.prototype.getValue=m.prototype.toString,m.prototype.$defaultUndoManager={undo:function(){},redo:function(){},hasUndo:function(){},hasRedo:function(){},reset:function(){},add:function(){},addSelection:function(){},startNewGroup:function(){},addSession:function(){}},m.prototype.$overwrite=!1,m.prototype.$mode=null,m.prototype.$modeId=null,m.prototype.$scrollTop=0,m.prototype.$scrollLeft=0,m.prototype.$wrapLimit=80,m.prototype.$useWrapMode=!1,m.prototype.$wrapLimitRange={min:null,max:null},m.prototype.lineWidgets=null,m.prototype.isFullWidth=N,r.implement(m.prototype,u);var g=1,y=2,b=3,w=4,E=9,S=10,x=11,T=12;e("./edit_session/folding").Folding.call(m.prototype),e("./edit_session/bracket_match").BracketMatch.call(m.prototype),o.defineOptions(m.prototype,"session",{wrap:{set:function(e){!e||e=="off"?e=!1:e=="free"?e=!0:e=="printMargin"?e=-1:typeof e=="string"&&(e=parseInt(e,10)||!1);if(this.$wrap==e)return;this.$wrap=e;if(!e)this.setUseWrapMode(!1);else{var t=typeof e=="number"?e:null;this.setWrapLimitRange(t,t),this.setUseWrapMode(!0)}},get:function(){return this.getUseWrapMode()?this.$wrap==-1?"printMargin":this.getWrapLimitRange().min?this.$wrap:"free":"off"},handlesSet:!0},wrapMethod:{set:function(e){e=e=="auto"?this.$mode.type!="text":e!="text",e!=this.$wrapAsCode&&(this.$wrapAsCode=e,this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0)))},initialValue:"auto"},indentedSoftWrap:{set:function(){this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0))},initialValue:!0},firstLineNumber:{set:function(){this._signal("changeBreakpoint")},initialValue:1},useWorker:{set:function(e){this.$useWorker=e,this.$stopWorker(),e&&this.$startWorker()},initialValue:!0},useSoftTabs:{initialValue:!0},tabSize:{set:function(e){e=parseInt(e),e>0&&this.$tabSize!==e&&(this.$modified=!0,this.$rowLengthCache=[],this.$tabSize=e,this._signal("changeTabSize"))},initialValue:4,handlesSet:!0},navigateWithinSoftTabs:{initialValue:!1},foldStyle:{set:function(e){this.setFoldStyle(e)},handlesSet:!0},overwrite:{set:function(e){this._signal("changeOverwrite")},initialValue:!1},newLineMode:{set:function(e){this.doc.setNewLineMode(e)},get:function(){return this.doc.getNewLineMode()},handlesSet:!0},mode:{set:function(e){this.setMode(e)},get:function(){return this.$modeId},handlesSet:!0}}),t.EditSession=m}),define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,n){"use strict";function u(e,t){function i(e,r){r===void 0&&(r=!0);var i=n&&t.$supportsUnicodeFlag?new RegExp("[\\p{L}\\p{N}_]","u"):new RegExp("\\w");if(i.test(e)||t.regExp)return n&&t.$supportsUnicodeFlag?r?"(?<=^|[^\\p{L}\\p{N}_])":"(?=[^\\p{L}\\p{N}_]|$)":"\\b";return""}var n=r.supportsLookbehind(),s=Array.from(e),o=s[0],u=s[s.length-1];return i(o)+e+i(u,!1)}function a(e,t,n){var r=null,i=0;while(i<=e.length){t.lastIndex=i;var s=t.exec(e);if(!s)break;var o=s.index+s[0].length;if(o>e.length-n)break;if(!r||o>r.index+r[0].length)r=s;i=s.index+1}return r}function f(e,t){var n=5e3,r={row:t,column:0},i=e.doc.positionToIndex(r),s=i+n,o=e.doc.indexToPosition(s),u=o.row;return u+1}var r=e("./lib/lang"),i=e("./lib/oop"),s=e("./range").Range,o=function(){function e(){this.$options={}}return e.prototype.set=function(e){return i.mixin(this.$options,e),this},e.prototype.getOptions=function(){return r.copyObject(this.$options)},e.prototype.setOptions=function(e){this.$options=e},e.prototype.find=function(e){var t=this.$options,n=this.$matchIterator(e,t);if(!n)return!1;var r=null;return n.forEach(function(e,n,i,o){return r=new s(e,n,i,o),n==o&&t.start&&t.start.start&&t.skipCurrent!=0&&r.isEqual(t.start)?(r=null,!1):!0}),r},e.prototype.findAll=function(e){var t=this.$options;if(!t.needle)return[];this.$assembleRegExp(t);var n=t.range,i=n?e.getLines(n.start.row,n.end.row):e.doc.getAllLines(),o=[],u=t.re;if(t.$isMultiLine){var a=u.length,f=i.length-a,l;e:for(var c=u.offset||0;c<=f;c++){for(var h=0;h<a;h++)if(i[c+h].search(u[h])==-1)continue e;var p=i[c],d=i[c+a-1],v=p.length-p.match(u[0])[0].length,m=d.match(u[a-1])[0].length;if(l&&l.end.row===c&&l.end.column>v)continue;o.push(l=new s(c,v,c+a-1,m)),a>2&&(c=c+a-2)}}else for(var g,y=0;y<i.length;y++)if(this.$isMultilineSearch(t)){var b=i.length-1;g=this.$multiLineForward(e,u,y,b);if(g){var w=g.endRow<=b?g.endRow-1:b;w>y&&(y=w),o.push(new s(g.startRow,g.startCol,g.endRow,g.endCol))}}else{g=r.getMatchOffsets(i[y],u);for(var h=0;h<g.length;h++){var E=g[h];o.push(new s(y,E.offset,y,E.offset+E.length))}}if(n){var S=n.start.column,x=n.end.column,y=0,h=o.length-1;while(y<h&&o[y].start.column<S&&o[y].start.row==0)y++;var T=n.end.row-n.start.row;while(y<h&&o[h].end.column>x&&o[h].end.row==T)h--;o=o.slice(y,h+1);for(y=0,h=o.length;y<h;y++)o[y].start.row+=n.start.row,o[y].end.row+=n.start.row}return o},e.prototype.parseReplaceString=function(e){var t={DollarSign:36,Ampersand:38,Digit0:48,Digit1:49,Digit9:57,Backslash:92,n:110,t:116},n="";for(var r=0,i=e.length;r<i;r++){var s=e.charCodeAt(r);if(s===t.Backslash){r++;if(r>=i){n+="\\";break}var o=e.charCodeAt(r);switch(o){case t.Backslash:n+="\\";break;case t.n:n+="\n";break;case t.t:n+="	"}continue}if(s===t.DollarSign){r++;if(r>=i){n+="$";break}var u=e.charCodeAt(r);if(u===t.DollarSign){n+="$$";continue}if(u===t.Digit0||u===t.Ampersand){n+="$&";continue}if(t.Digit1<=u&&u<=t.Digit9){n+="$"+e[r];continue}}n+=e[r]}return n||e},e.prototype.replace=function(e,t){var n=this.$options,r=this.$assembleRegExp(n);if(n.$isMultiLine)return t;if(!r)return;var i=this.$isMultilineSearch(n);i&&(e=e.replace(/\r\n|\r|\n/g,"\n"));var s=r.exec(e);if(!s||!i&&s[0].length!=e.length)return null;t=n.regExp?this.parseReplaceString(t):t.replace(/\$/g,"$$$$"),t=e.replace(r,t);if(n.preserveCase){t=t.split("");for(var o=Math.min(e.length,e.length);o--;){var u=e[o];u&&u.toLowerCase()!=u?t[o]=t[o].toUpperCase():t[o]=t[o].toLowerCase()}t=t.join("")}return t},e.prototype.$assembleRegExp=function(e,t){if(e.needle instanceof RegExp)return e.re=e.needle;var n=e.needle;if(!e.needle)return e.re=!1;e.regExp||(n=r.escapeRegExp(n));var i=e.caseSensitive?"gm":"gmi";try{new RegExp(n,"u"),e.$supportsUnicodeFlag=!0,i+="u"}catch(s){e.$supportsUnicodeFlag=!1}e.wholeWord&&(n=u(n,e)),e.$isMultiLine=!t&&/[\n\r]/.test(n);if(e.$isMultiLine)return e.re=this.$assembleMultilineRegExp(n,i);try{var o=new RegExp(n,i)}catch(s){o=!1}return e.re=o},e.prototype.$assembleMultilineRegExp=function(e,t){var n=e.replace(/\r\n|\r|\n/g,"$\n^").split("\n"),r=[];for(var i=0;i<n.length;i++)try{r.push(new RegExp(n[i],t))}catch(s){return!1}return r},e.prototype.$isMultilineSearch=function(e){return e.re&&/\\r\\n|\\r|\\n/.test(e.re.source)&&e.regExp&&!e.$isMultiLine},e.prototype.$multiLineForward=function(e,t,n,r){var i,s=f(e,n);for(var o=n;o<=r;){for(var u=0;u<s;u++){if(o>r)break;var a=e.getLine(o++);i=i==null?a:i+"\n"+a}var l=t.exec(i);t.lastIndex=0;if(l){var c=i.slice(0,l.index).split("\n"),h=l[0].split("\n"),p=n+c.length-1,d=c[c.length-1].length,v=p+h.length-1,m=h.length==1?d+h[0].length:h[h.length-1].length;return{startRow:p,startCol:d,endRow:v,endCol:m}}}return null},e.prototype.$multiLineBackward=function(e,t,n,r,i){var s,o=f(e,r),u=e.getLine(r).length-n;for(var l=r;l>=i;){for(var c=0;c<o&&l>=i;c++){var h=e.getLine(l--);s=s==null?h:h+"\n"+s}var p=a(s,t,u);if(p){var d=s.slice(0,p.index).split("\n"),v=p[0].split("\n"),m=l+d.length,g=d[d.length-1].length,y=m+v.length-1,b=v.length==1?g+v[0].length:v[v.length-1].length;return{startRow:m,startCol:g,endRow:y,endCol:b}}}return null},e.prototype.$matchIterator=function(e,t){var n=this.$assembleRegExp(t);if(!n)return!1;var i=this.$isMultilineSearch(t),s=this.$multiLineForward,o=this.$multiLineBackward,u=t.backwards==1,a=t.skipCurrent!=0,f=n.unicode,l=t.range,c=t.start;c||(c=l?l[u?"end":"start"]:e.selection.getRange()),c.start&&(c=c[a!=u?"end":"start"]);var h=l?l.start.row:0,p=l?l.end.row:e.getLength()-1;if(u)var d=function(e){var n=c.row;if(m(n,c.column,e))return;for(n--;n>=h;n--)if(m(n,Number.MAX_VALUE,e))return;if(t.wrap==0)return;for(n=p,h=c.row;n>=h;n--)if(m(n,Number.MAX_VALUE,e))return};else var d=function(e){var n=c.row;if(m(n,c.column,e))return;for(n+=1;n<=p;n++)if(m(n,0,e))return;if(t.wrap==0)return;for(n=h,p=c.row;n<=p;n++)if(m(n,0,e))return};if(t.$isMultiLine)var v=n.length,m=function(t,r,i){var s=u?t-v+1:t;if(s<0||s+v>e.getLength())return;var o=e.getLine(s),a=o.search(n[0]);if(!u&&a<r||a===-1)return;for(var f=1;f<v;f++){o=e.getLine(s+f);if(o.search(n[f])==-1)return}var l=o.match(n[v-1])[0].length;if(u&&l>r)return;if(i(s,a,s+v-1,l))return!0};else if(u)var m=function(t,s,u){if(i){var a=o(e,n,s,t,h);if(!a)return!1;if(u(a.startRow,a.startCol,a.endRow,a.endCol))return!0}else{var l=e.getLine(t),c=[],p,d=0;n.lastIndex=0;while(p=n.exec(l)){var v=p[0].length;d=p.index;if(!v){if(d>=l.length)break;n.lastIndex=d+=r.skipEmptyMatch(l,d,f)}if(p.index+v>s)break;c.push(p.index,v)}for(var m=c.length-1;m>=0;m-=2){var g=c[m-1],v=c[m];if(u(t,g,t,g+v))return!0}}};else var m=function(t,o,u){n.lastIndex=o;if(i){var a=s(e,n,t,p);if(a){var l=a.endRow<=p?a.endRow-1:p;l>t&&(t=l)}if(!a)return!1;if(u(a.startRow,a.startCol,a.endRow,a.endCol))return!0}else{var c=e.getLine(t),h,d;while(d=n.exec(c)){var v=d[0].length;h=d.index;if(u(t,h,t,h+v))return!0;if(!v){n.lastIndex=h+=r.skipEmptyMatch(c,h,f);if(h>=c.length)return!1}}}};return{forEach:d}},e}();t.Search=o}),define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function a(e){return typeof e=="object"&&e.bindKey&&e.bindKey.position||(e.isDefault?-100:0)}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../lib/keys"),s=e("../lib/useragent"),o=i.KEY_MODS,u=function(){function e(e,t){this.$init(e,t,!1)}return e.prototype.$init=function(e,t,n){this.platform=t||(s.isMac?"mac":"win"),this.commands={},this.commandKeyBinding={},this.addCommands(e),this.$singleCommand=n},e.prototype.addCommand=function(e){this.commands[e.name]&&this.removeCommand(e),this.commands[e.name]=e,e.bindKey&&this._buildKeyHash(e)},e.prototype.removeCommand=function(e,t){var n=e&&(typeof e=="string"?e:e.name);e=this.commands[n],t||delete this.commands[n];var r=this.commandKeyBinding;for(var i in r){var s=r[i];if(s==e)delete r[i];else if(Array.isArray(s)){var o=s.indexOf(e);o!=-1&&(s.splice(o,1),s.length==1&&(r[i]=s[0]))}}},e.prototype.bindKey=function(e,t,n){typeof e=="object"&&e&&(n==undefined&&(n=e.position),e=e[this.platform]);if(!e)return;if(typeof t=="function")return this.addCommand({exec:t,bindKey:e,name:t.name||e});e.split("|").forEach(function(e){var r="";if(e.indexOf(" ")!=-1){var i=e.split(/\s+/);e=i.pop(),i.forEach(function(e){var t=this.parseKeys(e),n=o[t.hashId]+t.key;r+=(r?" ":"")+n,this._addCommandToBinding(r,"chainKeys")},this),r+=" "}var s=this.parseKeys(e),u=o[s.hashId]+s.key;this._addCommandToBinding(r+u,t,n)},this)},e.prototype._addCommandToBinding=function(e,t,n){var r=this.commandKeyBinding,i;if(!t)delete r[e];else if(!r[e]||this.$singleCommand)r[e]=t;else{Array.isArray(r[e])?(i=r[e].indexOf(t))!=-1&&r[e].splice(i,1):r[e]=[r[e]],typeof n!="number"&&(n=a(t));var s=r[e];for(i=0;i<s.length;i++){var o=s[i],u=a(o);if(u>n)break}s.splice(i,0,t)}},e.prototype.addCommands=function(e){e&&Object.keys(e).forEach(function(t){var n=e[t];if(!n)return;if(typeof n=="string")return this.bindKey(n,t);typeof n=="function"&&(n={exec:n});if(typeof n!="object")return;n.name||(n.name=t),this.addCommand(n)},this)},e.prototype.removeCommands=function(e){Object.keys(e).forEach(function(t){this.removeCommand(e[t])},this)},e.prototype.bindKeys=function(e){Object.keys(e).forEach(function(t){this.bindKey(t,e[t])},this)},e.prototype._buildKeyHash=function(e){this.bindKey(e.bindKey,e)},e.prototype.parseKeys=function(e){var t=e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e){return e}),n=t.pop(),r=i[n];if(i.FUNCTION_KEYS[r])n=i.FUNCTION_KEYS[r].toLowerCase();else{if(!t.length)return{key:n,hashId:-1};if(t.length==1&&t[0]=="shift")return{key:n.toUpperCase(),hashId:-1}}var s=0;for(var o=t.length;o--;){var u=i.KEY_MODS[t[o]];if(u==null)return typeof console!="undefined"&&console.error("invalid modifier "+t[o]+" in "+e),!1;s|=u}return{key:n,hashId:s}},e.prototype.findKeyCommand=function(e,t){var n=o[e]+t;return this.commandKeyBinding[n]},e.prototype.handleKeyboard=function(e,t,n,r){if(r<0)return;var i=o[t]+n,s=this.commandKeyBinding[i];e.$keyChain&&(e.$keyChain+=" "+i,s=this.commandKeyBinding[e.$keyChain]||s);if(s)if(s=="chainKeys"||s[s.length-1]=="chainKeys")return e.$keyChain=e.$keyChain||i,{command:"null"};if(e.$keyChain)if(!!t&&t!=4||n.length!=1){if(t==-1||r>0)e.$keyChain=""}else e.$keyChain=e.$keyChain.slice(0,-i.length-1);return{command:s}},e.prototype.getStatusText=function(e,t){return t.$keyChain||""},e}(),f=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.$singleCommand=!0,r}return r(t,e),t}(u);f.call=function(e,t,n){u.prototype.$init.call(e,t,n,!0)},u.call=function(e,t,n){u.prototype.$init.call(e,t,n,!1)},t.HashHandler=f,t.MultiHashHandler=u}),define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../lib/oop"),s=e("../keyboard/hash_handler").MultiHashHandler,o=e("../lib/event_emitter").EventEmitter,u=function(e){function t(t,n){var r=e.call(this,n,t)||this;return r.byName=r.commands,r.setDefaultHandler("exec",function(e){return e.args?e.command.exec(e.editor,e.args,e.event,!1):e.command.exec(e.editor,{},e.event,!0)}),r}return r(t,e),t.prototype.exec=function(e,t,n){if(Array.isArray(e)){for(var r=e.length;r--;)if(this.exec(e[r],t,n))return!0;return!1}typeof e=="string"&&(e=this.commands[e]);var i={editor:t,command:e,args:n};return this.canExecute(e,t)?(i.returnValue=this._emit("exec",i),this._signal("afterExec",i),i.returnValue===!1?!1:!0):(this._signal("commandUnavailable",i),!1)},t.prototype.canExecute=function(e,t){return typeof e=="string"&&(e=this.commands[e]),e?t&&t.$readOnly&&!e.readOnly?!1:this.$checkCommandState!=0&&e.isAvailable&&!e.isAvailable(t)?!1:!0:!1},t.prototype.toggleRecording=function(e){if(this.$inReplay)return;return e&&e._emit("changeStatus"),this.recording?(this.macro.pop(),this.off("exec",this.$addCommandToMacro),this.macro.length||(this.macro=this.oldMacro),this.recording=!1):(this.$addCommandToMacro||(this.$addCommandToMacro=function(e){this.macro.push([e.command,e.args])}.bind(this)),this.oldMacro=this.macro,this.macro=[],this.on("exec",this.$addCommandToMacro),this.recording=!0)},t.prototype.replay=function(e){if(this.$inReplay||!this.macro)return;if(this.recording)return this.toggleRecording(e);try{this.$inReplay=!0,this.macro.forEach(function(t){typeof t=="string"?this.exec(t,e):this.exec(t[0],e,t[1])},this)}finally{this.$inReplay=!1}},t.prototype.trimMacro=function(e){return e.map(function(e){return typeof e[0]!="string"&&(e[0]=e[0].name),e[1]||(e=e[0]),e})},t}(s);i.implement(u.prototype,o),t.CommandManager=u}),define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"],function(e,t,n){"use strict";function o(e,t){return{win:e,mac:t}}var r=e("../lib/lang"),i=e("../config"),s=e("../range").Range;t.commands=[{name:"showSettingsMenu",description:"Show settings menu",bindKey:o("Ctrl-,","Command-,"),exec:function(e){i.loadModule("ace/ext/settings_menu",function(t){t.init(e),e.showSettingsMenu()})},readOnly:!0},{name:"goToNextError",description:"Go to next error",bindKey:o("Alt-E","F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,1)})},scrollIntoView:"animate",readOnly:!0},{name:"goToPreviousError",description:"Go to previous error",bindKey:o("Alt-Shift-E","Shift-F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,-1)})},scrollIntoView:"animate",readOnly:!0},{name:"selectall",description:"Select all",bindKey:o("Ctrl-A","Command-A"),exec:function(e){e.selectAll()},readOnly:!0},{name:"centerselection",description:"Center selection",bindKey:o(null,"Ctrl-L"),exec:function(e){e.centerSelection()},readOnly:!0},{name:"gotoline",description:"Go to line...",bindKey:o("Ctrl-L","Command-L"),exec:function(e,t){typeof t=="number"&&!isNaN(t)&&e.gotoLine(t),e.prompt({$type:"gotoLine"})},readOnly:!0},{name:"fold",bindKey:o("Alt-L|Ctrl-F1","Command-Alt-L|Command-F1"),exec:function(e){e.session.toggleFold(!1)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"unfold",bindKey:o("Alt-Shift-L|Ctrl-Shift-F1","Command-Alt-Shift-L|Command-Shift-F1"),exec:function(e){e.session.toggleFold(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleFoldWidget",description:"Toggle fold widget",bindKey:o("F2","F2"),exec:function(e){e.session.toggleFoldWidget()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleParentFoldWidget",description:"Toggle parent fold widget",bindKey:o("Alt-F2","Alt-F2"),exec:function(e){e.session.toggleFoldWidget(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"foldall",description:"Fold all",bindKey:o(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAll()},scrollIntoView:"center",readOnly:!0},{name:"foldAllComments",description:"Fold all comments",bindKey:o(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAllComments()},scrollIntoView:"center",readOnly:!0},{name:"foldOther",description:"Fold other",bindKey:o("Alt-0","Command-Option-0"),exec:function(e){e.session.foldAll(),e.session.unfold(e.selection.getAllRanges())},scrollIntoView:"center",readOnly:!0},{name:"unfoldall",description:"Unfold all",bindKey:o("Alt-Shift-0","Command-Option-Shift-0"),exec:function(e){e.session.unfold()},scrollIntoView:"center",readOnly:!0},{name:"findnext",description:"Find next",bindKey:o("Ctrl-K","Command-G"),exec:function(e){e.findNext()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"findprevious",description:"Find previous",bindKey:o("Ctrl-Shift-K","Command-Shift-G"),exec:function(e){e.findPrevious()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"selectOrFindNext",description:"Select or find next",bindKey:o("Alt-K","Ctrl-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findNext()},readOnly:!0},{name:"selectOrFindPrevious",description:"Select or find previous",bindKey:o("Alt-Shift-K","Ctrl-Shift-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findPrevious()},readOnly:!0},{name:"find",description:"Find",bindKey:o("Ctrl-F","Command-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e)})},readOnly:!0},{name:"overwrite",description:"Overwrite",bindKey:"Insert",exec:function(e){e.toggleOverwrite()},readOnly:!0},{name:"selecttostart",description:"Select to start",bindKey:o("Ctrl-Shift-Home","Command-Shift-Home|Command-Shift-Up"),exec:function(e){e.getSelection().selectFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotostart",description:"Go to start",bindKey:o("Ctrl-Home","Command-Home|Command-Up"),exec:function(e){e.navigateFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectup",description:"Select up",bindKey:o("Shift-Up","Shift-Up|Ctrl-Shift-P"),exec:function(e){e.getSelection().selectUp()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golineup",description:"Go line up",bindKey:o("Up","Up|Ctrl-P"),exec:function(e,t){e.navigateUp(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttoend",description:"Select to end",bindKey:o("Ctrl-Shift-End","Command-Shift-End|Command-Shift-Down"),exec:function(e){e.getSelection().selectFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotoend",description:"Go to end",bindKey:o("Ctrl-End","Command-End|Command-Down"),exec:function(e){e.navigateFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectdown",description:"Select down",bindKey:o("Shift-Down","Shift-Down|Ctrl-Shift-N"),exec:function(e){e.getSelection().selectDown()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golinedown",description:"Go line down",bindKey:o("Down","Down|Ctrl-N"),exec:function(e,t){e.navigateDown(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordleft",description:"Select word left",bindKey:o("Ctrl-Shift-Left","Option-Shift-Left"),exec:function(e){e.getSelection().selectWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordleft",description:"Go to word left",bindKey:o("Ctrl-Left","Option-Left"),exec:function(e){e.navigateWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolinestart",description:"Select to line start",bindKey:o("Alt-Shift-Left","Command-Shift-Left|Ctrl-Shift-A"),exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolinestart",description:"Go to line start",bindKey:o("Alt-Left|Home","Command-Left|Home|Ctrl-A"),exec:function(e){e.navigateLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectleft",description:"Select left",bindKey:o("Shift-Left","Shift-Left|Ctrl-Shift-B"),exec:function(e){e.getSelection().selectLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoleft",description:"Go to left",bindKey:o("Left","Left|Ctrl-B"),exec:function(e,t){e.navigateLeft(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordright",description:"Select word right",bindKey:o("Ctrl-Shift-Right","Option-Shift-Right"),exec:function(e){e.getSelection().selectWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordright",description:"Go to word right",bindKey:o("Ctrl-Right","Option-Right"),exec:function(e){e.navigateWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolineend",description:"Select to line end",bindKey:o("Alt-Shift-Right","Command-Shift-Right|Shift-End|Ctrl-Shift-E"),exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolineend",description:"Go to line end",bindKey:o("Alt-Right|End","Command-Right|End|Ctrl-E"),exec:function(e){e.navigateLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectright",description:"Select right",bindKey:o("Shift-Right","Shift-Right"),exec:function(e){e.getSelection().selectRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoright",description:"Go to right",bindKey:o("Right","Right|Ctrl-F"),exec:function(e,t){e.navigateRight(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectpagedown",description:"Select page down",bindKey:"Shift-PageDown",exec:function(e){e.selectPageDown()},readOnly:!0},{name:"pagedown",description:"Page down",bindKey:o(null,"Option-PageDown"),exec:function(e){e.scrollPageDown()},readOnly:!0},{name:"gotopagedown",description:"Go to page down",bindKey:o("PageDown","PageDown|Ctrl-V"),exec:function(e){e.gotoPageDown()},readOnly:!0},{name:"selectpageup",description:"Select page up",bindKey:"Shift-PageUp",exec:function(e){e.selectPageUp()},readOnly:!0},{name:"pageup",description:"Page up",bindKey:o(null,"Option-PageUp"),exec:function(e){e.scrollPageUp()},readOnly:!0},{name:"gotopageup",description:"Go to page up",bindKey:"PageUp",exec:function(e){e.gotoPageUp()},readOnly:!0},{name:"scrollup",description:"Scroll up",bindKey:o("Ctrl-Up",null),exec:function(e){e.renderer.scrollBy(0,-2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"scrolldown",description:"Scroll down",bindKey:o("Ctrl-Down",null),exec:function(e){e.renderer.scrollBy(0,2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"selectlinestart",description:"Select line start",bindKey:"Shift-Home",exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectlineend",description:"Select line end",bindKey:"Shift-End",exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"togglerecording",description:"Toggle recording",bindKey:o("Ctrl-Alt-E","Command-Option-E"),exec:function(e){e.commands.toggleRecording(e)},readOnly:!0},{name:"replaymacro",description:"Replay macro",bindKey:o("Ctrl-Shift-E","Command-Shift-E"),exec:function(e){e.commands.replay(e)},readOnly:!0},{name:"jumptomatching",description:"Jump to matching",bindKey:o("Ctrl-\\|Ctrl-P","Command-\\"),exec:function(e){e.jumpToMatching()},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"selecttomatching",description:"Select to matching",bindKey:o("Ctrl-Shift-\\|Ctrl-Shift-P","Command-Shift-\\"),exec:function(e){e.jumpToMatching(!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"expandToMatching",description:"Expand to matching",bindKey:o("Ctrl-Shift-M","Ctrl-Shift-M"),exec:function(e){e.jumpToMatching(!0,!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"passKeysToBrowser",description:"Pass keys to browser",bindKey:o(null,null),exec:function(){},passEvent:!0,readOnly:!0},{name:"copy",description:"Copy",exec:function(e){},readOnly:!0},{name:"cut",description:"Cut",exec:function(e){var t=e.$copyWithEmptySelection&&e.selection.isEmpty(),n=t?e.selection.getLineRange():e.selection.getRange();e._emit("cut",n),n.isEmpty()||e.session.remove(n),e.clearSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"paste",description:"Paste",exec:function(e,t){e.$handlePaste(t)},scrollIntoView:"cursor"},{name:"removeline",description:"Remove line",bindKey:o("Ctrl-D","Command-D"),exec:function(e){e.removeLines()},scrollIntoView:"cursor",multiSelectAction:"forEachLine"},{name:"duplicateSelection",description:"Duplicate selection",bindKey:o("Ctrl-Shift-D","Command-Shift-D"),exec:function(e){e.duplicateSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"sortlines",description:"Sort lines",bindKey:o("Ctrl-Alt-S","Command-Alt-S"),exec:function(e){e.sortLines()},scrollIntoView:"selection",multiSelectAction:"forEachLine"},{name:"togglecomment",description:"Toggle comment",bindKey:o("Ctrl-/","Command-/"),exec:function(e){e.toggleCommentLines()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"toggleBlockComment",description:"Toggle block comment",bindKey:o("Ctrl-Shift-/","Command-Shift-/"),exec:function(e){e.toggleBlockComment()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"modifyNumberUp",description:"Modify number up",bindKey:o("Ctrl-Shift-Up","Alt-Shift-Up"),exec:function(e){e.modifyNumber(1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"modifyNumberDown",description:"Modify number down",bindKey:o("Ctrl-Shift-Down","Alt-Shift-Down"),exec:function(e){e.modifyNumber(-1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"replace",description:"Replace",bindKey:o("Ctrl-H","Command-Option-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e,!0)})}},{name:"undo",description:"Undo",bindKey:o("Ctrl-Z","Command-Z"),exec:function(e){e.undo()}},{name:"redo",description:"Redo",bindKey:o("Ctrl-Shift-Z|Ctrl-Y","Command-Shift-Z|Command-Y"),exec:function(e){e.redo()}},{name:"copylinesup",description:"Copy lines up",bindKey:o("Alt-Shift-Up","Command-Option-Up"),exec:function(e){e.copyLinesUp()},scrollIntoView:"cursor"},{name:"movelinesup",description:"Move lines up",bindKey:o("Alt-Up","Option-Up"),exec:function(e){e.moveLinesUp()},scrollIntoView:"cursor"},{name:"copylinesdown",description:"Copy lines down",bindKey:o("Alt-Shift-Down","Command-Option-Down"),exec:function(e){e.copyLinesDown()},scrollIntoView:"cursor"},{name:"movelinesdown",description:"Move lines down",bindKey:o("Alt-Down","Option-Down"),exec:function(e){e.moveLinesDown()},scrollIntoView:"cursor"},{name:"del",description:"Delete",bindKey:o("Delete","Delete|Ctrl-D|Shift-Delete"),exec:function(e){e.remove("right")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"backspace",description:"Backspace",bindKey:o("Shift-Backspace|Backspace","Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),exec:function(e){e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"cut_or_delete",description:"Cut or delete",bindKey:o("Shift-Delete",null),exec:function(e){if(!e.selection.isEmpty())return!1;e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestart",description:"Remove to line start",bindKey:o("Alt-Backspace","Command-Backspace"),exec:function(e){e.removeToLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineend",description:"Remove to line end",bindKey:o("Alt-Delete","Ctrl-K|Command-Delete"),exec:function(e){e.removeToLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestarthard",description:"Remove to line start hard",bindKey:o("Ctrl-Shift-Backspace",null),exec:function(e){var t=e.selection.getRange();t.start.column=0,e.session.remove(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineendhard",description:"Remove to line end hard",bindKey:o("Ctrl-Shift-Delete",null),exec:function(e){var t=e.selection.getRange();t.end.column=Number.MAX_VALUE,e.session.remove(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordleft",description:"Remove word left",bindKey:o("Ctrl-Backspace","Alt-Backspace|Ctrl-Alt-Backspace"),exec:function(e){e.removeWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordright",description:"Remove word right",bindKey:o("Ctrl-Delete","Alt-Delete"),exec:function(e){e.removeWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"outdent",description:"Outdent",bindKey:o("Shift-Tab","Shift-Tab"),exec:function(e){e.blockOutdent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"indent",description:"Indent",bindKey:o("Tab","Tab"),exec:function(e){e.indent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"blockoutdent",description:"Block outdent",bindKey:o("Ctrl-[","Ctrl-["),exec:function(e){e.blockOutdent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"blockindent",description:"Block indent",bindKey:o("Ctrl-]","Ctrl-]"),exec:function(e){e.blockIndent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"insertstring",description:"Insert string",exec:function(e,t){e.insert(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"inserttext",description:"Insert text",exec:function(e,t){e.insert(r.stringRepeat(t.text||"",t.times||1))},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"splitline",description:"Split line",bindKey:o(null,"Ctrl-O"),exec:function(e){e.splitLine()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"transposeletters",description:"Transpose letters",bindKey:o("Alt-Shift-X","Ctrl-T"),exec:function(e){e.transposeLetters()},multiSelectAction:function(e){e.transposeSelections(1)},scrollIntoView:"cursor"},{name:"touppercase",description:"To uppercase",bindKey:o("Ctrl-U","Ctrl-U"),exec:function(e){e.toUpperCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"tolowercase",description:"To lowercase",bindKey:o("Ctrl-Shift-U","Ctrl-Shift-U"),exec:function(e){e.toLowerCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"autoindent",description:"Auto Indent",bindKey:o(null,null),exec:function(e){e.autoIndent()},scrollIntoView:"animate"},{name:"expandtoline",description:"Expand to line",bindKey:o("Ctrl-Shift-L","Command-Shift-L"),exec:function(e){var t=e.selection.getRange();t.start.column=t.end.column=0,t.end.row++,e.selection.setRange(t,!1)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"openlink",bindKey:o("Ctrl+F3","F3"),exec:function(e){e.openLink()}},{name:"joinlines",description:"Join lines",bindKey:o(null,null),exec:function(e){var t=e.selection.isBackwards(),n=t?e.selection.getSelectionLead():e.selection.getSelectionAnchor(),i=t?e.selection.getSelectionAnchor():e.selection.getSelectionLead(),o=e.session.doc.getLine(n.row).length,u=e.session.doc.getTextRange(e.selection.getRange()),a=u.replace(/\n\s*/," ").length,f=e.session.doc.getLine(n.row);for(var l=n.row+1;l<=i.row+1;l++){var c=r.stringTrimLeft(r.stringTrimRight(e.session.doc.getLine(l)));c.length!==0&&(c=" "+c),f+=c}i.row+1<e.session.doc.getLength()-1&&(f+=e.session.doc.getNewLineCharacter()),e.clearSelection(),e.session.doc.replace(new s(n.row,0,i.row+2,0),f),a>0?(e.selection.moveCursorTo(n.row,n.column),e.selection.selectTo(n.row,n.column+a)):(o=e.session.doc.getLine(n.row).length>o?o+1:o,e.selection.moveCursorTo(n.row,o))},multiSelectAction:"forEach",readOnly:!0},{name:"invertSelection",description:"Invert selection",bindKey:o(null,null),exec:function(e){var t=e.session.doc.getLength()-1,n=e.session.doc.getLine(t).length,r=e.selection.rangeList.ranges,i=[];r.length<1&&(r=[e.selection.getRange()]);for(var o=0;o<r.length;o++)o==r.length-1&&(r[o].end.row!==t||r[o].end.column!==n)&&i.push(new s(r[o].end.row,r[o].end.column,t,n)),o===0?(r[o].start.row!==0||r[o].start.column!==0)&&i.push(new s(0,0,r[o].start.row,r[o].start.column)):i.push(new s(r[o-1].end.row,r[o-1].end.column,r[o].start.row,r[o].start.column));e.exitMultiSelectMode(),e.clearSelection();for(var o=0;o<i.length;o++)e.selection.addRange(i[o],!1)},readOnly:!0,scrollIntoView:"none"},{name:"addLineAfter",description:"Add new line after the current line",exec:function(e){e.selection.clearSelection(),e.navigateLineEnd(),e.insert("\n")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"addLineBefore",description:"Add new line before the current line",exec:function(e){e.selection.clearSelection();var t=e.getCursorPosition();e.selection.moveTo(t.row-1,Number.MAX_VALUE),e.insert("\n"),t.row===0&&e.navigateUp()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"openCommandPallete",exec:function(e){console.warn("This is an obsolete command. Please use `openCommandPalette` instead."),e.prompt({$type:"commands"})},readOnly:!0},{name:"openCommandPalette",description:"Open command palette",bindKey:o("F1","F1"),exec:function(e){e.prompt({$type:"commands"})},readOnly:!0},{name:"modeSelect",description:"Change language mode...",bindKey:o(null,null),exec:function(e){e.prompt({$type:"modes"})},readOnly:!0}];for(var u=1;u<9;u++)t.commands.push({name:"foldToLevel"+u,description:"Fold To Level "+u,level:u,exec:function(e){e.session.foldToLevel(this.level)},scrollIntoView:"center",readOnly:!0})}),define("ace/keyboard/gutter_handler",["require","exports","module","ace/lib/keys","ace/mouse/default_gutter_handler"],function(e,t,n){"use strict";var r=e("../lib/keys"),i=e("../mouse/default_gutter_handler").GutterTooltip,s=function(){function e(e){this.editor=e,this.gutterLayer=e.renderer.$gutterLayer,this.element=e.renderer.$gutter,this.lines=e.renderer.$gutterLayer.$lines,this.activeRowIndex=null,this.activeLane=null,this.annotationTooltip=new i(this.editor)}return e.prototype.addListener=function(){this.element.addEventListener("keydown",this.$onGutterKeyDown.bind(this)),this.element.addEventListener("focusout",this.$blurGutter.bind(this)),this.editor.on("mousewheel",this.$blurGutter.bind(this))},e.prototype.removeListener=function(){this.element.removeEventListener("keydown",this.$onGutterKeyDown.bind(this)),this.element.removeEventListener("focusout",this.$blurGutter.bind(this)),this.editor.off("mousewheel",this.$blurGutter.bind(this))},e.prototype.$onGutterKeyDown=function(e){if(this.annotationTooltip.isOpen){e.preventDefault(),e.keyCode===r.escape&&this.annotationTooltip.hideTooltip();return}if(e.target===this.element){if(e.keyCode!=r["enter"])return;e.preventDefault();var t=this.editor.getCursorPosition().row;this.editor.isRowVisible(t)||this.editor.scrollToLine(t,!0,!0),setTimeout(function(){var e=this.$rowToRowIndex(this.gutterLayer.$cursorCell.row),t=this.$findNearestFoldWidget(e),n=this.$findNearestAnnotation(e);if(t===null&&n===null)return;if(t===null&&n!==null){this.activeRowIndex=n,this.activeLane="annotation",this.$focusAnnotation(this.activeRowIndex);return}if(t!==null&&n===null){this.activeRowIndex=t,this.activeLane="fold",this.$focusFoldWidget(this.activeRowIndex);return}if(Math.abs(n-e)<Math.abs(t-e)){this.activeRowIndex=n,this.activeLane="annotation",this.$focusAnnotation(this.activeRowIndex);return}this.activeRowIndex=t,this.activeLane="fold",this.$focusFoldWidget(this.activeRowIndex);return}.bind(this),10);return}this.$handleGutterKeyboardInteraction(e),setTimeout(function(){this.editor._signal("gutterkeydown",new o(e,this))}.bind(this),10)},e.prototype.$handleGutterKeyboardInteraction=function(e){if(e.keyCode===r.tab){e.preventDefault();return}if(e.keyCode===r.escape){e.preventDefault(),this.$blurGutter(),this.element.focus(),this.lane=null;return}if(e.keyCode===r.up){e.preventDefault();switch(this.activeLane){case"fold":this.$moveFoldWidgetUp();break;case"annotation":this.$moveAnnotationUp()}return}if(e.keyCode===r.down){e.preventDefault();switch(this.activeLane){case"fold":this.$moveFoldWidgetDown();break;case"annotation":this.$moveAnnotationDown()}return}if(e.keyCode===r.left){e.preventDefault(),this.$switchLane("annotation");return}if(e.keyCode===r.right){e.preventDefault(),this.$switchLane("fold");return}if(e.keyCode===r.enter||e.keyCode===r.space){e.preventDefault();switch(this.activeLane){case"fold":if(this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]==="start"){var t=this.$rowIndexToRow(this.activeRowIndex);this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex),e),setTimeout(function(){this.$rowIndexToRow(this.activeRowIndex)!==t&&(this.$blurFoldWidget(this.activeRowIndex),this.activeRowIndex=this.$rowToRowIndex(t),this.$focusFoldWidget(this.activeRowIndex))}.bind(this),10);break}if(this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]==="end")break;return;case"annotation":var n=this.lines.cells[this.activeRowIndex].element.childNodes[2],i=n.getBoundingClientRect(),s=this.annotationTooltip.getElement().style;s.left=i.right+"px",s.top=i.bottom+"px",this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex))}return}},e.prototype.$blurGutter=function(){if(this.activeRowIndex!==null)switch(this.activeLane){case"fold":this.$blurFoldWidget(this.activeRowIndex);break;case"annotation":this.$blurAnnotation(this.activeRowIndex)}this.annotationTooltip.isOpen&&this.annotationTooltip.hideTooltip();return},e.prototype.$isFoldWidgetVisible=function(e){var t=this.editor.isRowFullyVisible(this.$rowIndexToRow(e)),n=this.$getFoldWidget(e).style.display!=="none";return t&&n},e.prototype.$isAnnotationVisible=function(e){var t=this.editor.isRowFullyVisible(this.$rowIndexToRow(e)),n=this.$getAnnotation(e).style.display!=="none";return t&&n},e.prototype.$getFoldWidget=function(e){var t=this.lines.get(e),n=t.element;return n.childNodes[1]},e.prototype.$getAnnotation=function(e){var t=this.lines.get(e),n=t.element;return n.childNodes[2]},e.prototype.$findNearestFoldWidget=function(e){if(this.$isFoldWidgetVisible(e))return e;var t=0;while(e-t>0||e+t<this.lines.getLength()-1){t++;if(e-t>=0&&this.$isFoldWidgetVisible(e-t))return e-t;if(e+t<=this.lines.getLength()-1&&this.$isFoldWidgetVisible(e+t))return e+t}return null},e.prototype.$findNearestAnnotation=function(e){if(this.$isAnnotationVisible(e))return e;var t=0;while(e-t>0||e+t<this.lines.getLength()-1){t++;if(e-t>=0&&this.$isAnnotationVisible(e-t))return e-t;if(e+t<=this.lines.getLength()-1&&this.$isAnnotationVisible(e+t))return e+t}return null},e.prototype.$focusFoldWidget=function(e){if(e==null)return;var t=this.$getFoldWidget(e);t.classList.add(this.editor.renderer.keyboardFocusClassName),t.focus()},e.prototype.$focusAnnotation=function(e){if(e==null)return;var t=this.$getAnnotation(e);t.classList.add(this.editor.renderer.keyboardFocusClassName),t.focus()},e.prototype.$blurFoldWidget=function(e){var t=this.$getFoldWidget(e);t.classList.remove(this.editor.renderer.keyboardFocusClassName),t.blur()},e.prototype.$blurAnnotation=function(e){var t=this.$getAnnotation(e);t.classList.remove(this.editor.renderer.keyboardFocusClassName),t.blur()},e.prototype.$moveFoldWidgetUp=function(){var e=this.activeRowIndex;while(e>0){e--;if(this.$isFoldWidgetVisible(e)){this.$blurFoldWidget(this.activeRowIndex),this.activeRowIndex=e,this.$focusFoldWidget(this.activeRowIndex);return}}return},e.prototype.$moveFoldWidgetDown=function(){var e=this.activeRowIndex;while(e<this.lines.getLength()-1){e++;if(this.$isFoldWidgetVisible(e)){this.$blurFoldWidget(this.activeRowIndex),this.activeRowIndex=e,this.$focusFoldWidget(this.activeRowIndex);return}}return},e.prototype.$moveAnnotationUp=function(){var e=this.activeRowIndex;while(e>0){e--;if(this.$isAnnotationVisible(e)){this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=e,this.$focusAnnotation(this.activeRowIndex);return}}return},e.prototype.$moveAnnotationDown=function(){var e=this.activeRowIndex;while(e<this.lines.getLength()-1){e++;if(this.$isAnnotationVisible(e)){this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=e,this.$focusAnnotation(this.activeRowIndex);return}}return},e.prototype.$switchLane=function(e){switch(e){case"annotation":if(this.activeLane==="annotation")break;var t=this.$findNearestAnnotation(this.activeRowIndex);if(t==null)break;this.activeLane="annotation",this.$blurFoldWidget(this.activeRowIndex),this.activeRowIndex=t,this.$focusAnnotation(this.activeRowIndex);break;case"fold":if(this.activeLane==="fold")break;var n=this.$findNearestFoldWidget(this.activeRowIndex);if(n==null)break;this.activeLane="fold",this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=n,this.$focusFoldWidget(this.activeRowIndex)}return},e.prototype.$rowIndexToRow=function(e){var t=this.lines.get(e);return t?t.row:null},e.prototype.$rowToRowIndex=function(e){for(var t=0;t<this.lines.getLength();t++){var n=this.lines.get(t);if(n.row==e)return t}return null},e}();t.GutterKeyboardHandler=s;var o=function(){function e(e,t){this.gutterKeyboardHandler=t,this.domEvent=e}return e.prototype.getKey=function(){return r.keyCodeToString(this.domEvent.keyCode)},e.prototype.getRow=function(){return this.gutterKeyboardHandler.$rowIndexToRow(this.gutterKeyboardHandler.activeRowIndex)},e.prototype.isInAnnotationLane=function(){return this.gutterKeyboardHandler.activeLane==="annotation"},e.prototype.isInFoldLane=function(){return this.gutterKeyboardHandler.activeLane==="fold"},e}();t.GutterKeyboardEvent=o}),define("ace/editor",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator","ace/keyboard/gutter_handler","ace/config","ace/clipboard","ace/lib/keys","ace/lib/event","ace/tooltip"],function(e,t,n){"use strict";var r=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/lang"),u=e("./lib/useragent"),a=e("./keyboard/textinput").TextInput,f=e("./mouse/mouse_handler").MouseHandler,l=e("./mouse/fold_handler").FoldHandler,c=e("./keyboard/keybinding").KeyBinding,h=e("./edit_session").EditSession,p=e("./search").Search,d=e("./range").Range,v=e("./lib/event_emitter").EventEmitter,m=e("./commands/command_manager").CommandManager,g=e("./commands/default_commands").commands,y=e("./config"),b=e("./token_iterator").TokenIterator,w=e("./keyboard/gutter_handler").GutterKeyboardHandler,E=e("./config").nls,S=e("./clipboard"),x=e("./lib/keys"),T=e("./lib/event"),N=e("./tooltip").HoverTooltip,C=function(){function e(t,n,r){this.session,this.$toDestroy=[];var i=t.getContainerElement();this.container=i,this.renderer=t,this.id="editor"+ ++e.$uid,this.commands=new m(u.isMac?"mac":"win",g),typeof document=="object"&&(this.textInput=new a(t.getTextAreaContainer(),this),this.renderer.textarea=this.textInput.getElement(),this.$mouseHandler=new f(this),new l(this)),this.keyBinding=new c(this),this.$search=(new p).set({wrap:!0}),this.$historyTracker=this.$historyTracker.bind(this),this.commands.on("exec",this.$historyTracker),this.$initOperationListeners(),this._$emitInputEvent=o.delayedCall(function(){this._signal("input",{}),this.session&&!this.session.destroyed&&this.session.bgTokenizer.scheduleStart()}.bind(this)),this.on("change",function(e,t){t._$emitInputEvent.schedule(31)}),this.setSession(n||r&&r.session||new h("")),y.resetOptions(this),r&&this.setOptions(r),y._signal("editor",this)}return e.prototype.$initOperationListeners=function(){this.commands.on("exec",this.startOperation.bind(this),!0),this.commands.on("afterExec",this.endOperation.bind(this),!0)},e.prototype.startOperation=function(e){this.session.startOperation(e)},e.prototype.endOperation=function(e){this.session.endOperation(e)},e.prototype.onStartOperation=function(e){this.curOp=this.session.curOp,this.curOp.scrollTop=this.renderer.scrollTop,this.prevOp=this.session.prevOp,e||(this.previousCommand=null)},e.prototype.onEndOperation=function(e){if(this.curOp&&this.session){if(e&&e.returnValue===!1){this.curOp=null;return}this._signal("beforeEndOperation");if(!this.curOp)return;var t=this.curOp.command,n=t&&t.scrollIntoView;if(n){switch(n){case"center-animate":n="animate";case"center":this.renderer.scrollCursorIntoView(null,.5);break;case"animate":case"cursor":this.renderer.scrollCursorIntoView();break;case"selectionPart":var r=this.selection.getRange(),i=this.renderer.layerConfig;(r.start.row>=i.lastRow||r.end.row<=i.firstRow)&&this.renderer.scrollSelectionIntoView(this.selection.anchor,this.selection.lead);break;default:}n=="animate"&&this.renderer.animateScrolling(this.curOp.scrollTop)}this.$lastSel=this.session.selection.toJSON(),this.prevOp=this.curOp,this.curOp=null}},e.prototype.$historyTracker=function(e){if(!this.$mergeUndoDeltas)return;var t=this.prevOp,n=this.$mergeableCommands,r=t.command&&e.command.name==t.command.name;if(e.command.name=="insertstring"){var i=e.args;this.mergeNextCommand===undefined&&(this.mergeNextCommand=!0),r=r&&this.mergeNextCommand&&(!/\s/.test(i)||/\s/.test(t.args)),this.mergeNextCommand=!0}else r=r&&n.indexOf(e.command.name)!==-1;this.$mergeUndoDeltas!="always"&&Date.now()-this.sequenceStartTime>2e3&&(r=!1),r?this.session.mergeUndoDeltas=!0:n.indexOf(e.command.name)!==-1&&(this.sequenceStartTime=Date.now())},e.prototype.setKeyboardHandler=function(e,t){if(e&&typeof e=="string"&&e!="ace"){this.$keybindingId=e;var n=this;y.loadModule(["keybinding",e],function(r){n.$keybindingId==e&&n.keyBinding.setKeyboardHandler(r&&r.handler),t&&t()})}else this.$keybindingId=null,this.keyBinding.setKeyboardHandler(e),t&&t()},e.prototype.getKeyboardHandler=function(){return this.keyBinding.getKeyboardHandler()},e.prototype.setSession=function(e){if(this.session==e)return;this.curOp&&this.endOperation(),this.curOp={};var t=this.session;if(t){this.session.off("change",this.$onDocumentChange),this.session.off("changeMode",this.$onChangeMode),this.session.off("tokenizerUpdate",this.$onTokenizerUpdate),this.session.off("changeTabSize",this.$onChangeTabSize),this.session.off("changeWrapLimit",this.$onChangeWrapLimit),this.session.off("changeWrapMode",this.$onChangeWrapMode),this.session.off("changeFold",this.$onChangeFold),this.session.off("changeFrontMarker",this.$onChangeFrontMarker),this.session.off("changeBackMarker",this.$onChangeBackMarker),this.session.off("changeBreakpoint",this.$onChangeBreakpoint),this.session.off("changeAnnotation",this.$onChangeAnnotation),this.session.off("changeOverwrite",this.$onCursorChange),this.session.off("changeScrollTop",this.$onScrollTopChange),this.session.off("changeScrollLeft",this.$onScrollLeftChange),this.session.off("startOperation",this.$onStartOperation),this.session.off("endOperation",this.$onEndOperation);var n=this.session.getSelection();n.off("changeCursor",this.$onCursorChange),n.off("changeSelection",this.$onSelectionChange)}this.session=e,e?(this.$onDocumentChange=this.onDocumentChange.bind(this),e.on("change",this.$onDocumentChange),this.renderer.setSession(e),this.$onChangeMode=this.onChangeMode.bind(this),e.on("changeMode",this.$onChangeMode),this.$onTokenizerUpdate=this.onTokenizerUpdate.bind(this),e.on("tokenizerUpdate",this.$onTokenizerUpdate),this.$onChangeTabSize=this.renderer.onChangeTabSize.bind(this.renderer),e.on("changeTabSize",this.$onChangeTabSize),this.$onChangeWrapLimit=this.onChangeWrapLimit.bind(this),e.on("changeWrapLimit",this.$onChangeWrapLimit),this.$onChangeWrapMode=this.onChangeWrapMode.bind(this),e.on("changeWrapMode",this.$onChangeWrapMode),this.$onChangeFold=this.onChangeFold.bind(this),e.on("changeFold",this.$onChangeFold),this.$onChangeFrontMarker=this.onChangeFrontMarker.bind(this),this.session.on("changeFrontMarker",this.$onChangeFrontMarker),this.$onChangeBackMarker=this.onChangeBackMarker.bind(this),this.session.on("changeBackMarker",this.$onChangeBackMarker),this.$onChangeBreakpoint=this.onChangeBreakpoint.bind(this),this.session.on("changeBreakpoint",this.$onChangeBreakpoint),this.$onChangeAnnotation=this.onChangeAnnotation.bind(this),this.session.on("changeAnnotation",this.$onChangeAnnotation),this.$onCursorChange=this.onCursorChange.bind(this),this.session.on("changeOverwrite",this.$onCursorChange),this.$onScrollTopChange=this.onScrollTopChange.bind(this),this.session.on("changeScrollTop",this.$onScrollTopChange),this.$onScrollLeftChange=this.onScrollLeftChange.bind(this),this.session.on("changeScrollLeft",this.$onScrollLeftChange),this.selection=e.getSelection(),this.selection.on("changeCursor",this.$onCursorChange),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.$onStartOperation=this.onStartOperation.bind(this),this.session.on("startOperation",this.$onStartOperation),this.$onEndOperation=this.onEndOperation.bind(this),this.session.on("endOperation",this.$onEndOperation),this.onChangeMode(),this.onCursorChange(),this.onScrollTopChange(),this.onScrollLeftChange(),this.onSelectionChange(),this.onChangeFrontMarker(),this.onChangeBackMarker(),this.onChangeBreakpoint(),this.onChangeAnnotation(),this.session.getUseWrapMode()&&this.renderer.adjustWrapLimit(),this.renderer.updateFull()):(this.selection=null,this.renderer.setSession(e)),this._signal("changeSession",{session:e,oldSession:t}),this.curOp=null,t&&t._signal("changeEditor",{oldEditor:this}),t&&(t.$editor=null),e&&e._signal("changeEditor",{editor:this}),e&&(e.$editor=this),e&&!e.destroyed&&e.bgTokenizer.scheduleStart()},e.prototype.getSession=function(){return this.session},e.prototype.setValue=function(e,t){return this.session.doc.setValue(e),t?t==1?this.navigateFileEnd():t==-1&&this.navigateFileStart():this.selectAll(),e},e.prototype.getValue=function(){return this.session.getValue()},e.prototype.getSelection=function(){return this.selection},e.prototype.resize=function(e){this.renderer.onResize(e)},e.prototype.setTheme=function(e,t){this.renderer.setTheme(e,t)},e.prototype.getTheme=function(){return this.renderer.getTheme()},e.prototype.setStyle=function(e){this.renderer.setStyle(e)},e.prototype.unsetStyle=function(e){this.renderer.unsetStyle(e)},e.prototype.getFontSize=function(){return this.getOption("fontSize")||s.computedStyle(this.container).fontSize},e.prototype.setFontSize=function(e){this.setOption("fontSize",e)},e.prototype.$highlightBrackets=function(){if(this.$highlightPending)return;var e=this;this.$highlightPending=!0,setTimeout(function(){e.$highlightPending=!1;var t=e.session;if(!t||t.destroyed)return;t.$bracketHighlight&&(t.$bracketHighlight.markerIds.forEach(function(e){t.removeMarker(e)}),t.$bracketHighlight=null);var n=e.getCursorPosition(),r=e.getKeyboardHandler(),i=r&&r.$getDirectionForHighlight&&r.$getDirectionForHighlight(e),s=t.getMatchingBracketRanges(n,i);if(!s){var o=new b(t,n.row,n.column),u=o.getCurrentToken();if(u&&/\b(?:tag-open|tag-name)/.test(u.type)){var a=t.getMatchingTags(n);a&&(s=[a.openTagName.isEmpty()?a.openTag:a.openTagName,a.closeTagName.isEmpty()?a.closeTag:a.closeTagName])}}!s&&t.$mode.getMatching&&(s=t.$mode.getMatching(e.session));if(!s){e.getHighlightIndentGuides()&&e.renderer.$textLayer.$highlightIndentGuide();return}var f="ace_bracket";Array.isArray(s)?s.length==1&&(f="ace_error_bracket"):s=[s],s.length==2&&(d.comparePoints(s[0].end,s[1].start)==0?s=[d.fromPoints(s[0].start,s[1].end)]:d.comparePoints(s[0].start,s[1].end)==0&&(s=[d.fromPoints(s[1].start,s[0].end)])),t.$bracketHighlight={ranges:s,markerIds:s.map(function(e){return t.addMarker(e,f,"text")})},e.getHighlightIndentGuides()&&e.renderer.$textLayer.$highlightIndentGuide()},50)},e.prototype.focus=function(){this.textInput.focus()},e.prototype.isFocused=function(){return this.textInput.isFocused()},e.prototype.blur=function(){this.textInput.blur()},e.prototype.onFocus=function(e){if(this.$isFocused)return;this.$isFocused=!0,this.renderer.showCursor(),this.renderer.visualizeFocus(),this._emit("focus",e)},e.prototype.onBlur=function(e){if(!this.$isFocused)return;this.$isFocused=!1,this.renderer.hideCursor(),this.renderer.visualizeBlur(),this._emit("blur",e)},e.prototype.$cursorChange=function(){this.renderer.updateCursor(),this.$highlightBrackets(),this.$updateHighlightActiveLine()},e.prototype.onDocumentChange=function(e){var t=this.session.$useWrapMode,n=e.start.row==e.end.row?e.end.row:Infinity;this.renderer.updateLines(e.start.row,n,t),this._signal("change",e),this.$cursorChange()},e.prototype.onTokenizerUpdate=function(e){var t=e.data;this.renderer.updateLines(t.first,t.last)},e.prototype.onScrollTopChange=function(){this.renderer.scrollToY(this.session.getScrollTop())},e.prototype.onScrollLeftChange=function(){this.renderer.scrollToX(this.session.getScrollLeft())},e.prototype.onCursorChange=function(){this.$cursorChange(),this._signal("changeSelection")},e.prototype.$updateHighlightActiveLine=function(){var e=this.getSession(),t;if(this.$highlightActiveLine){if(this.$selectionStyle!="line"||!this.selection.isMultiLine())t=this.getCursorPosition();this.renderer.theme&&this.renderer.theme.$selectionColorConflict&&!this.selection.isEmpty()&&(t=!1),this.renderer.$maxLines&&this.session.getLength()===1&&!(this.renderer.$minLines>1)&&(t=!1)}if(e.$highlightLineMarker&&!t)e.removeMarker(e.$highlightLineMarker.id),e.$highlightLineMarker=null;else if(!e.$highlightLineMarker&&t){var n=new d(t.row,t.column,t.row,Infinity);n.id=e.addMarker(n,"ace_active-line","screenLine"),e.$highlightLineMarker=n}else t&&(e.$highlightLineMarker.start.row=t.row,e.$highlightLineMarker.end.row=t.row,e.$highlightLineMarker.start.column=t.column,e._signal("changeBackMarker"))},e.prototype.onSelectionChange=function(e){var t=this.session;t.$selectionMarker&&t.removeMarker(t.$selectionMarker),t.$selectionMarker=null;if(!this.selection.isEmpty()){var n=this.selection.getRange(),r=this.getSelectionStyle();t.$selectionMarker=t.addMarker(n,"ace_selection",r)}else this.$updateHighlightActiveLine();var i=this.$highlightSelectedWord&&this.$getSelectionHighLightRegexp();this.session.highlight(i),this._signal("changeSelection")},e.prototype.$getSelectionHighLightRegexp=function(){var e=this.session,t=this.getSelectionRange();if(t.isEmpty()||t.isMultiLine())return;var n=t.start.column,r=t.end.column,i=e.getLine(t.start.row),s=i.substring(n,r);if(s.length>5e3||!/[\w\d]/.test(s))return;var o=this.$search.$assembleRegExp({wholeWord:!0,caseSensitive:!0,needle:s}),u=i.substring(n-1,r+1);if(!o.test(u))return;return o},e.prototype.onChangeFrontMarker=function(){this.renderer.updateFrontMarkers()},e.prototype.onChangeBackMarker=function(){this.renderer.updateBackMarkers()},e.prototype.onChangeBreakpoint=function(){this.renderer.updateBreakpoints()},e.prototype.onChangeAnnotation=function(){this.renderer.setAnnotations(this.session.getAnnotations())},e.prototype.onChangeMode=function(e){this.renderer.updateText(),this._emit("changeMode",e)},e.prototype.onChangeWrapLimit=function(){this.renderer.updateFull()},e.prototype.onChangeWrapMode=function(){this.renderer.onResize(!0)},e.prototype.onChangeFold=function(){this.$updateHighlightActiveLine(),this.renderer.updateFull()},e.prototype.getSelectedText=function(){return this.session.getTextRange(this.getSelectionRange())},e.prototype.getCopyText=function(){var e=this.getSelectedText(),t=this.session.doc.getNewLineCharacter(),n=!1;if(!e&&this.$copyWithEmptySelection){n=!0;var r=this.selection.getAllRanges();for(var i=0;i<r.length;i++){var s=r[i];if(i&&r[i-1].start.row==s.start.row)continue;e+=this.session.getLine(s.start.row)+t}}var o={text:e};return this._signal("copy",o),S.lineMode=n?o.text:!1,o.text},e.prototype.onCopy=function(){this.commands.exec("copy",this)},e.prototype.onCut=function(){this.commands.exec("cut",this)},e.prototype.onPaste=function(e,t){var n={text:e,event:t};this.commands.exec("paste",this,n)},e.prototype.$handlePaste=function(e){typeof e=="string"&&(e={text:e}),this._signal("paste",e);var t=e.text,n=t===S.lineMode,r=this.session;if(!this.inMultiSelectMode||this.inVirtualSelectionMode)n?r.insert({row:this.selection.lead.row,column:0},t):this.insert(t);else if(n)this.selection.rangeList.ranges.forEach(function(e){r.insert({row:e.start.row,column:0},t)});else{var i=t.split(/\r\n|\r|\n/),s=this.selection.rangeList.ranges,o=i.length==2&&(!i[0]||!i[1]);if(i.length!=s.length||o)return this.commands.exec("insertstring",this,t);for(var u=s.length;u--;){var a=s[u];a.isEmpty()||r.remove(a),r.insert(a.start,i[u])}}},e.prototype.execCommand=function(e,t){return this.commands.exec(e,this,t)},e.prototype.insert=function(e,t){var n=this.session,r=n.getMode(),i=this.getCursorPosition();if(this.getBehavioursEnabled()&&!t){var s=r.transformAction(n.getState(i.row),"insertion",this,n,e);s&&(e!==s.text&&(this.inVirtualSelectionMode||(this.session.mergeUndoDeltas=!1,this.mergeNextCommand=!1)),e=s.text)}e=="	"&&(e=this.session.getTabString());if(!this.selection.isEmpty()){var o=this.getSelectionRange();i=this.session.remove(o),this.clearSelection()}else if(this.session.getOverwrite()&&e.indexOf("\n")==-1){var o=d.fromPoints(i,i);o.end.column+=e.length,this.session.remove(o)}if(e=="\n"||e=="\r\n"){var u=n.getLine(i.row);if(i.column>u.search(/\S|$/)){var a=u.substr(i.column).search(/\S|$/);n.doc.removeInLine(i.row,i.column,i.column+a)}}this.clearSelection();var f=i.column,l=n.getState(i.row),u=n.getLine(i.row),c=r.checkOutdent(l,u,e);n.insert(i,e),s&&s.selection&&(s.selection.length==2?this.selection.setSelectionRange(new d(i.row,f+s.selection[0],i.row,f+s.selection[1])):this.selection.setSelectionRange(new d(i.row+s.selection[0],s.selection[1],i.row+s.selection[2],s.selection[3])));if(this.$enableAutoIndent){if(n.getDocument().isNewLine(e)){var h=r.getNextLineIndent(l,u.slice(0,i.column),n.getTabString());n.insert({row:i.row+1,column:0},h)}c&&r.autoOutdent(l,n,i.row)}},e.prototype.autoIndent=function(){var e=this.session,t=e.getMode(),n=this.selection.isEmpty()?[new d(0,0,e.doc.getLength()-1,0)]:this.selection.getAllRanges(),r="",i="",s="",o=e.getTabString();for(var u=0;u<n.length;u++){var a=n[u].start.row,f=n[u].end.row;for(var l=a;l<=f;l++){l>0&&(r=e.getState(l-1),i=e.getLine(l-1),s=t.getNextLineIndent(r,i,o));var c=e.getLine(l),h=t.$getIndent(c);if(s!==h){if(h.length>0){var p=new d(l,0,l,h.length);e.remove(p)}s.length>0&&e.insert({row:l,column:0},s)}t.autoOutdent(r,e,l)}}},e.prototype.onTextInput=function(e,t){if(!t)return this.keyBinding.onTextInput(e);this.startOperation({command:{name:"insertstring"}});var n=this.applyComposition.bind(this,e,t);this.selection.rangeCount?this.forEachSelection(n):n(),this.endOperation()},e.prototype.applyComposition=function(e,t){if(t.extendLeft||t.extendRight){var n=this.selection.getRange();n.start.column-=t.extendLeft,n.end.column+=t.extendRight,n.start.column<0&&(n.start.row--,n.start.column+=this.session.getLine(n.start.row).length+1),this.selection.setRange(n),!e&&!n.isEmpty()&&this.remove()}(e||!this.selection.isEmpty())&&this.insert(e,!0);if(t.restoreStart||t.restoreEnd){var n=this.selection.getRange();n.start.column-=t.restoreStart,n.end.column-=t.restoreEnd,this.selection.setRange(n)}},e.prototype.onCommandKey=function(e,t,n){return this.keyBinding.onCommandKey(e,t,n)},e.prototype.setOverwrite=function(e){this.session.setOverwrite(e)},e.prototype.getOverwrite=function(){return this.session.getOverwrite()},e.prototype.toggleOverwrite=function(){this.session.toggleOverwrite()},e.prototype.setScrollSpeed=function(e){this.setOption("scrollSpeed",e)},e.prototype.getScrollSpeed=function(){return this.getOption("scrollSpeed")},e.prototype.setDragDelay=function(e){this.setOption("dragDelay",e)},e.prototype.getDragDelay=function(){return this.getOption("dragDelay")},e.prototype.setSelectionStyle=function(e){this.setOption("selectionStyle",e)},e.prototype.getSelectionStyle=function(){return this.getOption("selectionStyle")},e.prototype.setHighlightActiveLine=function(e){this.setOption("highlightActiveLine",e)},e.prototype.getHighlightActiveLine=function(){return this.getOption("highlightActiveLine")},e.prototype.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},e.prototype.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},e.prototype.setHighlightSelectedWord=function(e){this.setOption("highlightSelectedWord",e)},e.prototype.getHighlightSelectedWord=function(){return this.$highlightSelectedWord},e.prototype.setAnimatedScroll=function(e){this.renderer.setAnimatedScroll(e)},e.prototype.getAnimatedScroll=function(){return this.renderer.getAnimatedScroll()},e.prototype.setShowInvisibles=function(e){this.renderer.setShowInvisibles(e)},e.prototype.getShowInvisibles=function(){return this.renderer.getShowInvisibles()},e.prototype.setDisplayIndentGuides=function(e){this.renderer.setDisplayIndentGuides(e)},e.prototype.getDisplayIndentGuides=function(){return this.renderer.getDisplayIndentGuides()},e.prototype.setHighlightIndentGuides=function(e){this.renderer.setHighlightIndentGuides(e)},e.prototype.getHighlightIndentGuides=function(){return this.renderer.getHighlightIndentGuides()},e.prototype.setShowPrintMargin=function(e){this.renderer.setShowPrintMargin(e)},e.prototype.getShowPrintMargin=function(){return this.renderer.getShowPrintMargin()},e.prototype.setPrintMarginColumn=function(e){this.renderer.setPrintMarginColumn(e)},e.prototype.getPrintMarginColumn=function(){return this.renderer.getPrintMarginColumn()},e.prototype.setReadOnly=function(e){this.setOption("readOnly",e)},e.prototype.getReadOnly=function(){return this.getOption("readOnly")},e.prototype.setBehavioursEnabled=function(e){this.setOption("behavioursEnabled",e)},e.prototype.getBehavioursEnabled=function(){return this.getOption("behavioursEnabled")},e.prototype.setWrapBehavioursEnabled=function(e){this.setOption("wrapBehavioursEnabled",e)},e.prototype.getWrapBehavioursEnabled=function(){return this.getOption("wrapBehavioursEnabled")},e.prototype.setShowFoldWidgets=function(e){this.setOption("showFoldWidgets",e)},e.prototype.getShowFoldWidgets=function(){return this.getOption("showFoldWidgets")},e.prototype.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},e.prototype.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},e.prototype.remove=function(e){this.selection.isEmpty()&&(e=="left"?this.selection.selectLeft():this.selection.selectRight());var t=this.getSelectionRange();if(this.getBehavioursEnabled()){var n=this.session,r=n.getState(t.start.row),i=n.getMode().transformAction(r,"deletion",this,n,t);if(t.end.column===0){var s=n.getTextRange(t);if(s[s.length-1]=="\n"){var o=n.getLine(t.end.row);/^\s+$/.test(o)&&(t.end.column=o.length)}}i&&(t=i)}this.session.remove(t),this.clearSelection()},e.prototype.removeWordRight=function(){this.selection.isEmpty()&&this.selection.selectWordRight(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeWordLeft=function(){this.selection.isEmpty()&&this.selection.selectWordLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeToLineStart=function(){this.selection.isEmpty()&&this.selection.selectLineStart(),this.selection.isEmpty()&&this.selection.selectLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeToLineEnd=function(){this.selection.isEmpty()&&this.selection.selectLineEnd();var e=this.getSelectionRange();e.start.column==e.end.column&&e.start.row==e.end.row&&(e.end.column=0,e.end.row++),this.session.remove(e),this.clearSelection()},e.prototype.splitLine=function(){this.selection.isEmpty()||(this.session.remove(this.getSelectionRange()),this.clearSelection());var e=this.getCursorPosition();this.insert("\n"),this.moveCursorToPosition(e)},e.prototype.setGhostText=function(e,t){this.renderer.setGhostText(e,t)},e.prototype.removeGhostText=function(){this.renderer.removeGhostText()},e.prototype.transposeLetters=function(){if(!this.selection.isEmpty())return;var e=this.getCursorPosition(),t=e.column;if(t===0)return;var n=this.session.getLine(e.row),r,i;t<n.length?(r=n.charAt(t)+n.charAt(t-1),i=new d(e.row,t-1,e.row,t+1)):(r=n.charAt(t-1)+n.charAt(t-2),i=new d(e.row,t-2,e.row,t)),this.session.replace(i,r),this.session.selection.moveToPosition(i.end)},e.prototype.toLowerCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toLowerCase()),this.selection.setSelectionRange(e)},e.prototype.toUpperCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toUpperCase()),this.selection.setSelectionRange(e)},e.prototype.indent=function(){var e=this.session,t=this.getSelectionRange();if(t.start.row<t.end.row){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}if(t.start.column<t.end.column){var r=e.getTextRange(t);if(!/^\s+$/.test(r)){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}}var i=e.getLine(t.start.row),s=t.start,u=e.getTabSize(),a=e.documentToScreenColumn(s.row,s.column);if(this.session.getUseSoftTabs())var f=u-a%u,l=o.stringRepeat(" ",f);else{var f=a%u;while(i[t.start.column-1]==" "&&f)t.start.column--,f--;this.selection.setSelectionRange(t),l="	"}return this.insert(l)},e.prototype.blockIndent=function(){var e=this.$getSelectedRows();this.session.indentRows(e.first,e.last,"	")},e.prototype.blockOutdent=function(){var e=this.session.getSelection();this.session.outdentRows(e.getRange())},e.prototype.sortLines=function(){var e=this.$getSelectedRows(),t=this.session,n=[];for(var r=e.first;r<=e.last;r++)n.push(t.getLine(r));n.sort(function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:e.toLowerCase()>t.toLowerCase()?1:0});var i=new d(0,0,0,0);for(var r=e.first;r<=e.last;r++){var s=t.getLine(r);i.start.row=r,i.end.row=r,i.end.column=s.length,t.replace(i,n[r-e.first])}},e.prototype.toggleCommentLines=function(){var e=this.session.getState(this.getCursorPosition().row),t=this.$getSelectedRows();this.session.getMode().toggleCommentLines(e,this.session,t.first,t.last)},e.prototype.toggleBlockComment=function(){var e=this.getCursorPosition(),t=this.session.getState(e.row),n=this.getSelectionRange();this.session.getMode().toggleBlockComment(t,this.session,n,e)},e.prototype.getNumberAt=function(e,t){var n=/[\-]?[0-9]+(?:\.[0-9]+)?/g;n.lastIndex=0;var r=this.session.getLine(e);while(n.lastIndex<t){var i=n.exec(r);if(i.index<=t&&i.index+i[0].length>=t){var s={value:i[0],start:i.index,end:i.index+i[0].length};return s}}return null},e.prototype.modifyNumber=function(e){var t=this.selection.getCursor().row,n=this.selection.getCursor().column,r=new d(t,n-1,t,n),i=this.session.getTextRange(r);if(!isNaN(parseFloat(i))&&isFinite(i)){var s=this.getNumberAt(t,n);if(s){var o=s.value.indexOf(".")>=0?s.start+s.value.indexOf(".")+1:s.end,u=s.start+s.value.length-o,a=parseFloat(s.value);a*=Math.pow(10,u),o!==s.end&&n<o?e*=Math.pow(10,s.end-n-1):e*=Math.pow(10,s.end-n),a+=e,a/=Math.pow(10,u);var f=a.toFixed(u),l=new d(t,s.start,t,s.end);this.session.replace(l,f),this.moveCursorTo(t,Math.max(s.start+1,n+f.length-s.value.length))}}else this.toggleWord()},e.prototype.toggleWord=function(){var e=this.selection.getCursor().row,t=this.selection.getCursor().column;this.selection.selectWord();var n=this.getSelectedText(),r=this.selection.getWordRange().start.column,i=n.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g,"$1 ").split(/\s/),s=t-r-1;s<0&&(s=0);var u=0,a=0,f=this;n.match(/[A-Za-z0-9_]+/)&&i.forEach(function(t,i){a=u+t.length,s>=u&&s<=a&&(n=t,f.selection.clearSelection(),f.moveCursorTo(e,u+r),f.selection.selectTo(e,a+r)),u=a});var l=this.$toggleWordPairs,c;for(var h=0;h<l.length;h++){var p=l[h];for(var d=0;d<=1;d++){var v=+!d,m=n.match(new RegExp("^\\s?_?("+o.escapeRegExp(p[d])+")\\s?$","i"));if(m){var g=n.match(new RegExp("([_]|^|\\s)("+o.escapeRegExp(m[1])+")($|\\s)","g"));g&&(c=n.replace(new RegExp(o.escapeRegExp(p[d]),"i"),function(e){var t=p[v];return e.toUpperCase()==e?t=t.toUpperCase():e.charAt(0).toUpperCase()==e.charAt(0)&&(t=t.substr(0,0)+p[v].charAt(0).toUpperCase()+t.substr(1)),t}),this.insert(c),c="")}}}},e.prototype.findLinkAt=function(e,t){var n,i,s=this.session.getLine(e),o=s.split(/((?:https?|ftp):\/\/[\S]+)/),u=t;u<0&&(u=0);var a=0,f=0,l;try{for(var c=r(o),h=c.next();!h.done;h=c.next()){var p=h.value;f=a+p.length;if(u>=a&&u<=f&&p.match(/((?:https?|ftp):\/\/[\S]+)/)){l=p.replace(/[\s:.,'";}\]]+$/,"");break}a=f}}catch(d){n={error:d}}finally{try{h&&!h.done&&(i=c.return)&&i.call(c)}finally{if(n)throw n.error}}return l},e.prototype.openLink=function(){var e=this.selection.getCursor(),t=this.findLinkAt(e.row,e.column);return t&&window.open(t,"_blank"),t!=null},e.prototype.removeLines=function(){var e=this.$getSelectedRows();this.session.removeFullLines(e.first,e.last),this.clearSelection()},e.prototype.duplicateSelection=function(){var e=this.selection,t=this.session,n=e.getRange(),r=e.isBackwards();if(n.isEmpty()){var i=n.start.row;t.duplicateLines(i,i)}else{var s=r?n.start:n.end,o=t.insert(s,t.getTextRange(n));n.start=s,n.end=o,e.setSelectionRange(n,r)}},e.prototype.moveLinesDown=function(){this.$moveLines(1,!1)},e.prototype.moveLinesUp=function(){this.$moveLines(-1,!1)},e.prototype.moveText=function(e,t,n){return this.session.moveText(e,t,n)},e.prototype.copyLinesUp=function(){this.$moveLines(-1,!0)},e.prototype.copyLinesDown=function(){this.$moveLines(1,!0)},e.prototype.$moveLines=function(e,t){var n,r,i=this.selection;if(!i.inMultiSelectMode||this.inVirtualSelectionMode){var s=i.toOrientedRange();n=this.$getSelectedRows(s),r=this.session.$moveLines(n.first,n.last,t?0:e),t&&e==-1&&(r=0),s.moveBy(r,0),i.fromOrientedRange(s)}else{var o=i.rangeList.ranges;i.rangeList.detach(this.session),this.inVirtualSelectionMode=!0;var u=0,a=0,f=o.length;for(var l=0;l<f;l++){var c=l;o[l].moveBy(u,0),n=this.$getSelectedRows(o[l]);var h=n.first,p=n.last;while(++l<f){a&&o[l].moveBy(a,0);var d=this.$getSelectedRows(o[l]);if(t&&d.first!=p)break;if(!t&&d.first>p+1)break;p=d.last}l--,u=this.session.$moveLines(h,p,t?0:e),t&&e==-1&&(c=l+1);while(c<=l)o[c].moveBy(u,0),c++;t||(u=0),a+=u}i.fromOrientedRange(i.ranges[0]),i.rangeList.attach(this.session),this.inVirtualSelectionMode=!1}},e.prototype.$getSelectedRows=function(e){return e=(e||this.getSelectionRange()).collapseRows(),{first:this.session.getRowFoldStart(e.start.row),last:this.session.getRowFoldEnd(e.end.row)}},e.prototype.onCompositionStart=function(e){this.renderer.showComposition(e)},e.prototype.onCompositionUpdate=function(e){this.renderer.setCompositionText(e)},e.prototype.onCompositionEnd=function(){this.renderer.hideComposition()},e.prototype.getFirstVisibleRow=function(){return this.renderer.getFirstVisibleRow()},e.prototype.getLastVisibleRow=function(){return this.renderer.getLastVisibleRow()},e.prototype.isRowVisible=function(e){return e>=this.getFirstVisibleRow()&&e<=this.getLastVisibleRow()},e.prototype.isRowFullyVisible=function(e){return e>=this.renderer.getFirstFullyVisibleRow()&&e<=this.renderer.getLastFullyVisibleRow()},e.prototype.$getVisibleRowCount=function(){return this.renderer.getScrollBottomRow()-this.renderer.getScrollTopRow()+1},e.prototype.$moveByPage=function(e,t){var n=this.renderer,r=this.renderer.layerConfig,i=e*Math.floor(r.height/r.lineHeight);t===!0?this.selection.$moveSelection(function(){this.moveCursorBy(i,0)}):t===!1&&(this.selection.moveCursorBy(i,0),this.selection.clearSelection());var s=n.scrollTop;n.scrollBy(0,i*r.lineHeight),t!=null&&n.scrollCursorIntoView(null,.5),n.animateScrolling(s)},e.prototype.selectPageDown=function(){this.$moveByPage(1,!0)},e.prototype.selectPageUp=function(){this.$moveByPage(-1,!0)},e.prototype.gotoPageDown=function(){this.$moveByPage(1,!1)},e.prototype.gotoPageUp=function(){this.$moveByPage(-1,!1)},e.prototype.scrollPageDown=function(){this.$moveByPage(1)},e.prototype.scrollPageUp=function(){this.$moveByPage(-1)},e.prototype.scrollToRow=function(e){this.renderer.scrollToRow(e)},e.prototype.scrollToLine=function(e,t,n,r){this.renderer.scrollToLine(e,t,n,r)},e.prototype.centerSelection=function(){var e=this.getSelectionRange(),t={row:Math.floor(e.start.row+(e.end.row-e.start.row)/2),column:Math.floor(e.start.column+(e.end.column-e.start.column)/2)};this.renderer.alignCursor(t,.5)},e.prototype.getCursorPosition=function(){return this.selection.getCursor()},e.prototype.getCursorPositionScreen=function(){return this.session.documentToScreenPosition(this.getCursorPosition())},e.prototype.getSelectionRange=function(){return this.selection.getRange()},e.prototype.selectAll=function(){this.selection.selectAll()},e.prototype.clearSelection=function(){this.selection.clearSelection()},e.prototype.moveCursorTo=function(e,t){this.selection.moveCursorTo(e,t)},e.prototype.moveCursorToPosition=function(e){this.selection.moveCursorToPosition(e)},e.prototype.jumpToMatching=function(e,t){var n=this.getCursorPosition(),r=new b(this.session,n.row,n.column),i=r.getCurrentToken(),s=0;i&&i.type.indexOf("tag-name")!==-1&&(i=r.stepBackward());var o=i||r.stepForward();if(!o)return;var u,a=!1,f={},l=n.column-o.start,c,h={")":"(","(":"(","]":"[","[":"[","{":"{","}":"{"};do{if(o.value.match(/[{}()\[\]]/g))for(;l<o.value.length&&!a;l++){if(!h[o.value[l]])continue;c=h[o.value[l]]+"."+o.type.replace("rparen","lparen"),isNaN(f[c])&&(f[c]=0);switch(o.value[l]){case"(":case"[":case"{":f[c]++;break;case")":case"]":case"}":f[c]--,f[c]===-1&&(u="bracket",a=!0)}}else o.type.indexOf("tag-name")!==-1&&(isNaN(f[o.value])&&(f[o.value]=0),i.value==="<"&&s>1?f[o.value]++:i.value==="</"&&f[o.value]--,f[o.value]===-1&&(u="tag",a=!0));a||(i=o,s++,o=r.stepForward(),l=0)}while(o&&!a);if(!u)return;var p,v;if(u==="bracket"){p=this.session.getBracketRange(n);if(!p){p=new d(r.getCurrentTokenRow(),r.getCurrentTokenColumn()+l-1,r.getCurrentTokenRow(),r.getCurrentTokenColumn()+l-1),v=p.start;if(t||v.row===n.row&&Math.abs(v.column-n.column)<2)p=this.session.getBracketRange(v)}}else if(u==="tag"){if(!o||o.type.indexOf("tag-name")===-1)return;p=new d(r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2,r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2);if(p.compare(n.row,n.column)===0){var m=this.session.getMatchingTags(n);m&&(m.openTag.contains(n.row,n.column)?(p=m.closeTag,v=p.start):(p=m.openTag,m.closeTag.start.row===n.row&&m.closeTag.start.column===n.column?v=p.end:v=p.start))}v=v||p.start}v=p&&p.cursor||v,v&&(e?p&&t?this.selection.setRange(p):p&&p.isEqual(this.getSelectionRange())?this.clearSelection():this.selection.selectTo(v.row,v.column):this.selection.moveTo(v.row,v.column))},e.prototype.gotoLine=function(e,t,n){this.selection.clearSelection(),this.session.unfold({row:e-1,column:t||0}),this.exitMultiSelectMode&&this.exitMultiSelectMode(),this.moveCursorTo(e-1,t||0),this.isRowFullyVisible(e-1)||this.scrollToLine(e-1,!0,n)},e.prototype.navigateTo=function(e,t){this.selection.moveTo(e,t)},e.prototype.navigateUp=function(e){if(this.selection.isMultiLine()&&!this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(-e||-1,0)},e.prototype.navigateDown=function(e){if(this.selection.isMultiLine()&&this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(e||1,0)},e.prototype.navigateLeft=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().start;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorLeft()}this.clearSelection()},e.prototype.navigateRight=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().end;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorRight()}this.clearSelection()},e.prototype.navigateLineStart=function(){this.selection.moveCursorLineStart(),this.clearSelection()},e.prototype.navigateLineEnd=function(){this.selection.moveCursorLineEnd(),this.clearSelection()},e.prototype.navigateFileEnd=function(){this.selection.moveCursorFileEnd(),this.clearSelection()},e.prototype.navigateFileStart=function(){this.selection.moveCursorFileStart(),this.clearSelection()},e.prototype.navigateWordRight=function(){this.selection.moveCursorWordRight(),this.clearSelection()},e.prototype.navigateWordLeft=function(){this.selection.moveCursorWordLeft(),this.clearSelection()},e.prototype.replace=function(e,t){t&&this.$search.set(t);var n=this.$search.find(this.session),r=0;return n?(this.$tryReplace(n,e)&&(r=1),this.selection.setSelectionRange(n),this.renderer.scrollSelectionIntoView(n.start,n.end),r):r},e.prototype.replaceAll=function(e,t){t&&this.$search.set(t);var n=this.$search.findAll(this.session),r=0;if(!n.length)return r;var i=this.getSelectionRange();this.selection.moveTo(0,0);for(var s=n.length-1;s>=0;--s)this.$tryReplace(n[s],e)&&r++;return this.selection.setSelectionRange(i),r},e.prototype.$tryReplace=function(e,t){var n=this.session.getTextRange(e);return t=this.$search.replace(n,t),t!==null?(e.end=this.session.replace(e,t),e):null},e.prototype.getLastSearchOptions=function(){return this.$search.getOptions()},e.prototype.find=function(e,t,n){t||(t={}),typeof e=="string"||e instanceof RegExp?t.needle=e:typeof e=="object"&&i.mixin(t,e);var r=this.selection.getRange();t.needle==null&&(e=this.session.getTextRange(r)||this.$search.$options.needle,e||(r=this.session.getWordRange(r.start.row,r.start.column),e=this.session.getTextRange(r)),this.$search.set({needle:e})),this.$search.set(t),t.start||this.$search.set({start:r});var s=this.$search.find(this.session);if(t.preventScroll)return s;if(s)return this.revealRange(s,n),s;t.backwards?r.start=r.end:r.end=r.start,this.selection.setRange(r)},e.prototype.findNext=function(e,t){this.find({skipCurrent:!0,backwards:!1},e,t)},e.prototype.findPrevious=function(e,t){this.find(e,{skipCurrent:!0,backwards:!0},t)},e.prototype.revealRange=function(e,t){this.session.unfold(e),this.selection.setSelectionRange(e);var n=this.renderer.scrollTop;this.renderer.scrollSelectionIntoView(e.start,e.end,.5),t!==!1&&this.renderer.animateScrolling(n)},e.prototype.undo=function(){this.session.getUndoManager().undo(this.session),this.renderer.scrollCursorIntoView(null,.5)},e.prototype.redo=function(){this.session.getUndoManager().redo(this.session),this.renderer.scrollCursorIntoView(null,.5)},e.prototype.destroy=function(){this.$toDestroy&&(this.$toDestroy.forEach(function(e){e.destroy()}),this.$toDestroy=null),this.$mouseHandler&&this.$mouseHandler.destroy(),this.renderer.destroy(),this._signal("destroy",this),this.session&&this.session.destroy(),this._$emitInputEvent&&this._$emitInputEvent.cancel(),this.removeAllListeners()},e.prototype.setAutoScrollEditorIntoView=function(e){if(!e)return;var t,n=this,r=!1;this.$scrollAnchor||(this.$scrollAnchor=document.createElement("div"));var i=this.$scrollAnchor;i.style.cssText="position:absolute",this.container.insertBefore(i,this.container.firstChild);var s=this.on("changeSelection",function(){r=!0}),o=this.renderer.on("beforeRender",function(){r&&(t=n.renderer.container.getBoundingClientRect())}),u=this.renderer.on("afterRender",function(){if(r&&t&&(n.isFocused()||n.searchBox&&n.searchBox.isFocused())){var e=n.renderer,s=e.$cursorLayer.$pixelPos,o=e.layerConfig,u=s.top-o.offset;s.top>=0&&u+t.top<0?r=!0:s.top<o.height&&s.top+t.top+o.lineHeight>window.innerHeight?r=!1:r=null,r!=null&&(i.style.top=u+"px",i.style.left=s.left+"px",i.style.height=o.lineHeight+"px",i.scrollIntoView(r)),r=t=null}});this.setAutoScrollEditorIntoView=function(e){if(e)return;delete this.setAutoScrollEditorIntoView,this.off("changeSelection",s),this.renderer.off("afterRender",u),this.renderer.off("beforeRender",o)}},e.prototype.$resetCursorStyle=function(){var e=this.$cursorStyle||"ace",t=this.renderer.$cursorLayer;if(!t)return;t.setSmoothBlinking(/smooth/.test(e)),t.isBlinking=!this.$readOnly&&e!="wide",s.setCssClass(t.element,"ace_slim-cursors",/slim/.test(e))},e.prototype.prompt=function(e,t,n){var r=this;y.loadModule("ace/ext/prompt",function(i){i.prompt(r,e,t,n)})},e}();C.$uid=0,C.prototype.curOp=null,C.prototype.prevOp={},C.prototype.$mergeableCommands=["backspace","del","insertstring"],C.prototype.$toggleWordPairs=[["first","last"],["true","false"],["yes","no"],["width","height"],["top","bottom"],["right","left"],["on","off"],["x","y"],["get","set"],["max","min"],["horizontal","vertical"],["show","hide"],["add","remove"],["up","down"],["before","after"],["even","odd"],["in","out"],["inside","outside"],["next","previous"],["increase","decrease"],["attach","detach"],["&&","||"],["==","!="]],i.implement(C.prototype,v),y.defineOptions(C.prototype,"editor",{selectionStyle:{set:function(e){this.onSelectionChange(),this._signal("changeSelectionStyle",{data:e})},initialValue:"line"},highlightActiveLine:{set:function(){this.$updateHighlightActiveLine()},initialValue:!0},highlightSelectedWord:{set:function(e){this.$onSelectionChange()},initialValue:!0},readOnly:{set:function(e){var t=this;this.textInput.setReadOnly(e),this.$resetCursorStyle(),this.$readOnlyCallback||(this.$readOnlyCallback=function(e){var n=!1;if(e&&e.type=="keydown"){n=e&&e.key&&e.key.length==1&&!e.ctrlKey&&!e.metaKey;if(!n)return}else e&&e.type!=="exec"&&(n=!0);if(n){t.hoverTooltip||(t.hoverTooltip=new N);var r=s.createElement("div");r.textContent=E("editor.tooltip.disable-editing","Editing is disabled"),t.hoverTooltip.isOpen||t.hoverTooltip.showForRange(t,t.getSelectionRange(),r)}else t.hoverTooltip&&t.hoverTooltip.isOpen&&t.hoverTooltip.hide()});var n=this.textInput.getElement();e?(T.addListener(n,"keydown",this.$readOnlyCallback,this),this.commands.on("exec",this.$readOnlyCallback),this.commands.on("commandUnavailable",this.$readOnlyCallback)):(T.removeListener(n,"keydown",this.$readOnlyCallback),this.commands.off("exec",this.$readOnlyCallback),this.commands.off("commandUnavailable",this.$readOnlyCallback),this.hoverTooltip&&(this.hoverTooltip.destroy(),this.hoverTooltip=null))},initialValue:!1},copyWithEmptySelection:{set:function(e){this.textInput.setCopyWithEmptySelection(e)},initialValue:!1},cursorStyle:{set:function(e){this.$resetCursorStyle()},values:["ace","slim","smooth","wide"],initialValue:"ace"},mergeUndoDeltas:{values:[!1,!0,"always"],initialValue:!0},behavioursEnabled:{initialValue:!0},wrapBehavioursEnabled:{initialValue:!0},enableAutoIndent:{initialValue:!0},autoScrollEditorIntoView:{set:function(e){this.setAutoScrollEditorIntoView(e)}},keyboardHandler:{set:function(e){this.setKeyboardHandler(e)},get:function(){return this.$keybindingId},handlesSet:!0},value:{set:function(e){this.session.setValue(e)},get:function(){return this.getValue()},handlesSet:!0,hidden:!0},session:{set:function(e){this.setSession(e)},get:function(){return this.session},handlesSet:!0,hidden:!0},showLineNumbers:{set:function(e){this.renderer.$gutterLayer.setShowLineNumbers(e),this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER),e&&this.$relativeLineNumbers?k.attach(this):k.detach(this)},initialValue:!0},relativeLineNumbers:{set:function(e){this.$showLineNumbers&&e?k.attach(this):k.detach(this)}},placeholder:{set:function(e){this.$updatePlaceholder||(this.$updatePlaceholder=function(){var e=this.session&&(this.renderer.$composition||this.session.getLength()>1||this.session.getLine(0).length>0);if(e&&this.renderer.placeholderNode)this.renderer.off("afterRender",this.$updatePlaceholder),s.removeCssClass(this.container,"ace_hasPlaceholder"),this.renderer.placeholderNode.remove(),this.renderer.placeholderNode=null;else if(!e&&!this.renderer.placeholderNode){this.renderer.on("afterRender",this.$updatePlaceholder),s.addCssClass(this.container,"ace_hasPlaceholder");var t=s.createElement("div");t.className="ace_placeholder",t.textContent=this.$placeholder||"",this.renderer.placeholderNode=t,this.renderer.content.appendChild(this.renderer.placeholderNode)}else!e&&this.renderer.placeholderNode&&(this.renderer.placeholderNode.textContent=this.$placeholder||"")}.bind(this),this.on("input",this.$updatePlaceholder)),this.$updatePlaceholder()}},enableKeyboardAccessibility:{set:function(e){var t={name:"blurTextInput",description:"Set focus to the editor content div to allow tabbing through the page",bindKey:"Esc",exec:function(e){e.blur(),e.renderer.scroller.focus()},readOnly:!0},n=function(e){if(e.target==this.renderer.scroller&&e.keyCode===x.enter){e.preventDefault();var t=this.getCursorPosition().row;this.isRowVisible(t)||this.scrollToLine(t,!0,!0),this.focus()}},r;e?(this.renderer.enableKeyboardAccessibility=!0,this.renderer.keyboardFocusClassName="ace_keyboard-focus",this.textInput.getElement().setAttribute("tabindex",-1),this.textInput.setNumberOfExtraLines(u.isWin?3:0),this.renderer.scroller.setAttribute("tabindex",0),this.renderer.scroller.setAttribute("role","group"),this.renderer.scroller.setAttribute("aria-roledescription",E("editor.scroller.aria-roledescription","editor")),this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName),this.renderer.scroller.setAttribute("aria-label",E("editor.scroller.aria-label","Editor content, press Enter to start editing, press Escape to exit")),this.renderer.scroller.addEventListener("keyup",n.bind(this)),this.commands.addCommand(t),this.renderer.$gutter.setAttribute("tabindex",0),this.renderer.$gutter.setAttribute("aria-hidden",!1),this.renderer.$gutter.setAttribute("role","group"),this.renderer.$gutter.setAttribute("aria-roledescription",E("editor.gutter.aria-roledescription","editor gutter")),this.renderer.$gutter.setAttribute("aria-label",E("editor.gutter.aria-label","Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit")),this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName),this.renderer.content.setAttribute("aria-hidden",!0),r||(r=new w(this)),r.addListener(),this.textInput.setAriaOptions({setLabel:!0})):(this.renderer.enableKeyboardAccessibility=!1,this.textInput.getElement().setAttribute("tabindex",0),this.textInput.setNumberOfExtraLines(0),this.renderer.scroller.setAttribute("tabindex",-1),this.renderer.scroller.removeAttribute("role"),this.renderer.scroller.removeAttribute("aria-roledescription"),this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName),this.renderer.scroller.removeAttribute("aria-label"),this.renderer.scroller.removeEventListener("keyup",n.bind(this)),this.commands.removeCommand(t),this.renderer.content.removeAttribute("aria-hidden"),this.renderer.$gutter.setAttribute("tabindex",-1),this.renderer.$gutter.setAttribute("aria-hidden",!0),this.renderer.$gutter.removeAttribute("role"),this.renderer.$gutter.removeAttribute("aria-roledescription"),this.renderer.$gutter.removeAttribute("aria-label"),this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName),r&&r.removeListener())},initialValue:!1},textInputAriaLabel:{set:function(e){this.$textInputAriaLabel=e},initialValue:""},enableMobileMenu:{set:function(e){this.$enableMobileMenu=e},initialValue:!0},customScrollbar:"renderer",hScrollBarAlwaysVisible:"renderer",vScrollBarAlwaysVisible:"renderer",highlightGutterLine:"renderer",animatedScroll:"renderer",showInvisibles:"renderer",showPrintMargin:"renderer",printMarginColumn:"renderer",printMargin:"renderer",fadeFoldWidgets:"renderer",showFoldWidgets:"renderer",displayIndentGuides:"renderer",highlightIndentGuides:"renderer",showGutter:"renderer",fontSize:"renderer",fontFamily:"renderer",maxLines:"renderer",minLines:"renderer",scrollPastEnd:"renderer",fixedWidthGutter:"renderer",theme:"renderer",hasCssTransforms:"renderer",maxPixelHeight:"renderer",useTextareaForIME:"renderer",useResizeObserver:"renderer",useSvgGutterIcons:"renderer",showFoldedAnnotations:"renderer",scrollSpeed:"$mouseHandler",dragDelay:"$mouseHandler",dragEnabled:"$mouseHandler",focusTimeout:"$mouseHandler",tooltipFollowsMouse:"$mouseHandler",firstLineNumber:"session",overwrite:"session",newLineMode:"session",useWorker:"session",useSoftTabs:"session",navigateWithinSoftTabs:"session",tabSize:"session",wrap:"session",indentedSoftWrap:"session",foldStyle:"session",mode:"session"});var k={getText:function(e,t){return(Math.abs(e.selection.lead.row-t)||t+1+(t<9?"\u00b7":""))+""},getWidth:function(e,t,n){return Math.max(t.toString().length,(n.lastRow+1).toString().length,2)*n.characterWidth},update:function(e,t){t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER)},attach:function(e){e.renderer.$gutterLayer.$renderer=this,e.on("changeSelection",this.update),this.update(null,e)},detach:function(e){e.renderer.$gutterLayer.$renderer==this&&(e.renderer.$gutterLayer.$renderer=null),e.off("changeSelection",this.update),this.update(null,e)}};t.Editor=C}),define("ace/layer/lines",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e,t){this.element=e,this.canvasHeight=t||5e5,this.element.style.height=this.canvasHeight*2+"px",this.cells=[],this.cellCache=[],this.$offsetCoefficient=0}return e.prototype.moveContainer=function(e){r.translate(this.element,0,-(e.firstRowScreen*e.lineHeight%this.canvasHeight)-e.offset*this.$offsetCoefficient)},e.prototype.pageChanged=function(e,t){return Math.floor(e.firstRowScreen*e.lineHeight/this.canvasHeight)!==Math.floor(t.firstRowScreen*t.lineHeight/this.canvasHeight)},e.prototype.computeLineTop=function(e,t,n){var r=t.firstRowScreen*t.lineHeight,i=Math.floor(r/this.canvasHeight),s=n.documentToScreenRow(e,0)*t.lineHeight;return s-i*this.canvasHeight},e.prototype.computeLineHeight=function(e,t,n){return t.lineHeight*n.getRowLineCount(e)},e.prototype.getLength=function(){return this.cells.length},e.prototype.get=function(e){return this.cells[e]},e.prototype.shift=function(){this.$cacheCell(this.cells.shift())},e.prototype.pop=function(){this.$cacheCell(this.cells.pop())},e.prototype.push=function(e){if(Array.isArray(e)){this.cells.push.apply(this.cells,e);var t=r.createFragment(this.element);for(var n=0;n<e.length;n++)t.appendChild(e[n].element);this.element.appendChild(t)}else this.cells.push(e),this.element.appendChild(e.element)},e.prototype.unshift=function(e){if(Array.isArray(e)){this.cells.unshift.apply(this.cells,e);var t=r.createFragment(this.element);for(var n=0;n<e.length;n++)t.appendChild(e[n].element);this.element.firstChild?this.element.insertBefore(t,this.element.firstChild):this.element.appendChild(t)}else this.cells.unshift(e),this.element.insertAdjacentElement("afterbegin",e.element)},e.prototype.last=function(){return this.cells.length?this.cells[this.cells.length-1]:null},e.prototype.$cacheCell=function(e){if(!e)return;e.element.remove(),this.cellCache.push(e)},e.prototype.createCell=function(e,t,n,i){var s=this.cellCache.pop();if(!s){var o=r.createElement("div");i&&i(o),this.element.appendChild(o),s={element:o,text:"",row:e}}return s.row=e,s},e}();t.Lines=i}),define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/layer/lines","ace/config"],function(e,t,n){"use strict";function l(e){var t=document.createTextNode("");e.appendChild(t);var n=r.createElement("span");e.appendChild(n);var i=r.createElement("span");e.appendChild(i);var s=r.createElement("span");return i.appendChild(s),e}var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/lang"),o=e("../lib/event_emitter").EventEmitter,u=e("./lines").Lines,a=e("../config").nls,f=function(){function e(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_gutter-layer",e.appendChild(this.element),this.setShowFoldWidgets(this.$showFoldWidgets),this.gutterWidth=0,this.$annotations=[],this.$updateAnnotations=this.$updateAnnotations.bind(this),this.$lines=new u(this.element),this.$lines.$offsetCoefficient=1}return e.prototype.setSession=function(e){this.session&&this.session.off("change",this.$updateAnnotations),this.session=e,e&&e.on("change",this.$updateAnnotations)},e.prototype.addGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.addGutterDecoration"),this.session.addGutterDecoration(e,t)},e.prototype.removeGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.removeGutterDecoration"),this.session.removeGutterDecoration(e,t)},e.prototype.setAnnotations=function(e){this.$annotations=[];for(var t=0;t<e.length;t++){var n=e[t],r=n.row,i=this.$annotations[r];i||(i=this.$annotations[r]={text:[],type:[],displayText:[]});var o=n.text,u=n.text,a=n.type;o=o?s.escapeHTML(o):n.html||"",u=u?u:n.html||"",i.text.indexOf(o)===-1&&(i.text.push(o),i.type.push(a),i.displayText.push(u));var f=n.className;f?i.className=f:a==="error"?i.className=" ace_error":a==="security"&&!/\bace_error\b/.test(i.className)?i.className=" ace_security":a==="warning"&&!/\bace_(error|security)\b/.test(i.className)?i.className=" ace_warning":a==="info"&&!i.className?i.className=" ace_info":a==="hint"&&!i.className&&(i.className=" ace_hint")}},e.prototype.$updateAnnotations=function(e){if(!this.$annotations.length)return;var t=e.start.row,n=e.end.row-t;if(n!==0)if(e.action=="remove")this.$annotations.splice(t,n+1,null);else{var r=new Array(n+1);r.unshift(t,1),this.$annotations.splice.apply(this.$annotations,r)}},e.prototype.update=function(e){this.config=e;var t=this.session,n=e.firstRow,r=Math.min(e.lastRow+e.gutterOffset,t.getLength()-1);this.oldLastRow=r,this.config=e,this.$lines.moveContainer(e),this.$updateCursorRow();var i=t.getNextFoldLine(n),s=i?i.start.row:Infinity,o=null,u=-1,a=n;for(;;){a>s&&(a=i.end.row+1,i=t.getNextFoldLine(a,i),s=i?i.start.row:Infinity);if(a>r){while(this.$lines.getLength()>u+1)this.$lines.pop();break}o=this.$lines.get(++u),o?o.row=a:(o=this.$lines.createCell(a,e,this.session,l),this.$lines.push(o)),this.$renderCell(o,e,i,a),a++}this._signal("afterRender"),this.$updateGutterWidth(e)},e.prototype.$updateGutterWidth=function(e){var t=this.session,n=t.gutterRenderer||this.$renderer,r=t.$firstLineNumber,i=this.$lines.last()?this.$lines.last().text:"";if(this.$fixedWidth||t.$useWrapMode)i=t.getLength()+r-1;var s=n?n.getWidth(t,i,e):i.toString().length*e.characterWidth,o=this.$padding||this.$computePadding();s+=o.left+o.right,s!==this.gutterWidth&&!isNaN(s)&&(this.gutterWidth=s,this.element.parentNode.style.width=this.element.style.width=Math.ceil(this.gutterWidth)+"px",this._signal("changeGutterWidth",s))},e.prototype.$updateCursorRow=function(){if(!this.$highlightGutterLine)return;var e=this.session.selection.getCursor();if(this.$cursorRow===e.row)return;this.$cursorRow=e.row},e.prototype.updateLineHighlight=function(){if(!this.$highlightGutterLine)return;var e=this.session.selection.cursor.row;this.$cursorRow=e;if(this.$cursorCell&&this.$cursorCell.row==e)return;this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ",""));var t=this.$lines.cells;this.$cursorCell=null;for(var n=0;n<t.length;n++){var r=t[n];if(r.row>=this.$cursorRow){if(r.row>this.$cursorRow){var i=this.session.getFoldLine(this.$cursorRow);if(!(n>0&&i&&i.start.row==t[n-1].row))break;r=t[n-1]}r.element.className="ace_gutter-active-line "+r.element.className,this.$cursorCell=r;break}}},e.prototype.scrollLines=function(e){var t=this.config;this.config=e,this.$updateCursorRow();if(this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var n=Math.min(e.lastRow+e.gutterOffset,this.session.getLength()-1),r=this.oldLastRow;this.oldLastRow=n;if(!t||r<e.firstRow)return this.update(e);if(n<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var i=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);i>0;i--)this.$lines.shift();if(r>n)for(var i=this.session.getFoldedRowCount(n+1,r);i>0;i--)this.$lines.pop();e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLines(e,e.firstRow,t.firstRow-1)),n>r&&this.$lines.push(this.$renderLines(e,r+1,n)),this.updateLineHighlight(),this._signal("afterRender"),this.$updateGutterWidth(e)},e.prototype.$renderLines=function(e,t,n){var r=[],i=t,s=this.session.getNextFoldLine(i),o=s?s.start.row:Infinity;for(;;){i>o&&(i=s.end.row+1,s=this.session.getNextFoldLine(i,s),o=s?s.start.row:Infinity);if(i>n)break;var u=this.$lines.createCell(i,e,this.session,l);this.$renderCell(u,e,s,i),r.push(u),i++}return r},e.prototype.$renderCell=function(e,t,n,i){var s=e.element,o=this.session,u=s.childNodes[0],f=s.childNodes[1],l=s.childNodes[2],c=l.firstChild,h=o.$firstLineNumber,p=o.$breakpoints,d=o.$decorations,v=o.gutterRenderer||this.$renderer,m=this.$showFoldWidgets&&o.foldWidgets,g=n?n.start.row:Number.MAX_VALUE,y=t.lineHeight+"px",b=this.$useSvgGutterIcons?"ace_gutter-cell_svg-icons ":"ace_gutter-cell ",w=this.$useSvgGutterIcons?"ace_icon_svg":"ace_icon",E=(v?v.getText(o,i):i+h).toString();this.$highlightGutterLine&&(i==this.$cursorRow||n&&i<this.$cursorRow&&i>=g&&this.$cursorRow<=n.end.row)&&(b+="ace_gutter-active-line ",this.$cursorCell!=e&&(this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ","")),this.$cursorCell=e)),p[i]&&(b+=p[i]),d[i]&&(b+=d[i]),this.$annotations[i]&&i!==g&&(b+=this.$annotations[i].className);if(m){var S=m[i];S==null&&(S=m[i]=o.getFoldWidget(i))}if(S){var x="ace_fold-widget ace_"+S,T=S=="start"&&i==g&&i<n.end.row;if(T){x+=" ace_closed";var N="",C=!1;for(var k=i+1;k<=n.end.row;k++){if(!this.$annotations[k])continue;if(this.$annotations[k].className===" ace_error"){C=!0,N=" ace_error_fold";break}this.$annotations[k].className===" ace_security"?(C=!0,N=" ace_security_fold"):this.$annotations[k].className===" ace_warning"&&N!==" ace_security_fold"&&(C=!0,N=" ace_warning_fold")}b+=N}else x+=" ace_open";f.className!=x&&(f.className=x),r.setStyle(f.style,"height",y),r.setStyle(f.style,"display","inline-block"),f.setAttribute("role","button"),f.setAttribute("tabindex","-1");var L=o.getFoldWidgetRange(i);L?f.setAttribute("aria-label",a("gutter.code-folding.range.aria-label","Toggle code folding, rows $0 through $1",[L.start.row+1,L.end.row+1])):n?f.setAttribute("aria-label",a("gutter.code-folding.closed.aria-label","Toggle code folding, rows $0 through $1",[n.start.row+1,n.end.row+1])):f.setAttribute("aria-label",a("gutter.code-folding.open.aria-label","Toggle code folding, row $0",[i+1])),T?(f.setAttribute("aria-expanded","false"),f.setAttribute("title",a("gutter.code-folding.closed.title","Unfold code"))):(f.setAttribute("aria-expanded","true"),f.setAttribute("title",a("gutter.code-folding.open.title","Fold code")))}else f&&(r.setStyle(f.style,"display","none"),f.setAttribute("tabindex","0"),f.removeAttribute("role"),f.removeAttribute("aria-label"));if(C&&this.$showFoldedAnnotations){l.className="ace_gutter_annotation",c.className=w,c.className+=N,r.setStyle(c.style,"height",y),r.setStyle(l.style,"display","block"),r.setStyle(l.style,"height",y);var A;switch(N){case" ace_error_fold":A=a("gutter.annotation.aria-label.error","Error, read annotations row $0",[E]);break;case" ace_security_fold":A=a("gutter.annotation.aria-label.security","Security finding, read annotations row $0",[E]);break;case" ace_warning_fold":A=a("gutter.annotation.aria-label.warning","Warning, read annotations row $0",[E])}l.setAttribute("aria-label",A),l.setAttribute("tabindex","-1"),l.setAttribute("role","button")}else if(this.$annotations[i]){l.className="ace_gutter_annotation",c.className=w,this.$useSvgGutterIcons?c.className+=this.$annotations[i].className:s.classList.add(this.$annotations[i].className.replace(" ","")),r.setStyle(c.style,"height",y),r.setStyle(l.style,"display","block"),r.setStyle(l.style,"height",y);var A;switch(this.$annotations[i].className){case" ace_error":A=a("gutter.annotation.aria-label.error","Error, read annotations row $0",[E]);break;case" ace_security":A=a("gutter.annotation.aria-label.security","Security finding, read annotations row $0",[E]);break;case" ace_warning":A=a("gutter.annotation.aria-label.warning","Warning, read annotations row $0",[E]);break;case" ace_info":A=a("gutter.annotation.aria-label.info","Info, read annotations row $0",[E]);break;case" ace_hint":A=a("gutter.annotation.aria-label.hint","Suggestion, read annotations row $0",[E])}l.setAttribute("aria-label",A),l.setAttribute("tabindex","-1"),l.setAttribute("role","button")}else r.setStyle(l.style,"display","none"),l.removeAttribute("aria-label"),l.removeAttribute("role"),l.setAttribute("tabindex","0");return E!==u.data&&(u.data=E),s.className!=b&&(s.className=b),r.setStyle(e.element.style,"height",this.$lines.computeLineHeight(i,t,o)+"px"),r.setStyle(e.element.style,"top",this.$lines.computeLineTop(i,t,o)+"px"),e.text=E,l.style.display==="none"&&f.style.display==="none"?e.element.setAttribute("aria-hidden",!0):e.element.setAttribute("aria-hidden",!1),e},e.prototype.setHighlightGutterLine=function(e){this.$highlightGutterLine=e},e.prototype.setShowLineNumbers=function(e){this.$renderer=!e&&{getWidth:function(){return 0},getText:function(){return""}}},e.prototype.getShowLineNumbers=function(){return this.$showLineNumbers},e.prototype.setShowFoldWidgets=function(e){e?r.addCssClass(this.element,"ace_folding-enabled"):r.removeCssClass(this.element,"ace_folding-enabled"),this.$showFoldWidgets=e,this.$padding=null},e.prototype.getShowFoldWidgets=function(){return this.$showFoldWidgets},e.prototype.$computePadding=function(){if(!this.element.firstChild)return{left:0,right:0};var e=r.computedStyle(this.element.firstChild);return this.$padding={},this.$padding.left=(parseInt(e.borderLeftWidth)||0)+(parseInt(e.paddingLeft)||0)+1,this.$padding.right=(parseInt(e.borderRightWidth)||0)+(parseInt(e.paddingRight)||0),this.$padding},e.prototype.getRegion=function(e){var t=this.$padding||this.$computePadding(),n=this.element.getBoundingClientRect();if(e.x<t.left+n.left)return"markers";if(this.$showFoldWidgets&&e.x>n.right-t.right)return"foldWidgets"},e}();f.prototype.$fixedWidth=!1,f.prototype.$highlightGutterLine=!0,f.prototype.$renderer="",f.prototype.$showLineNumbers=!0,f.prototype.$showFoldWidgets=!0,i.implement(f.prototype,o),t.Gutter=f}),define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"],function(e,t,n){"use strict";function o(e,t,n,r){return(e?1:0)|(t?2:0)|(n?4:0)|(r?8:0)}var r=e("../range").Range,i=e("../lib/dom"),s=function(){function e(e){this.element=i.createElement("div"),this.element.className="ace_layer ace_marker-layer",e.appendChild(this.element)}return e.prototype.setPadding=function(e){this.$padding=e},e.prototype.setSession=function(e){this.session=e},e.prototype.setMarkers=function(e){this.markers=e},e.prototype.elt=function(e,t){var n=this.i!=-1&&this.element.childNodes[this.i];n?this.i++:(n=document.createElement("div"),this.element.appendChild(n),this.i=-1),n.style.cssText=t,n.className=e},e.prototype.update=function(e){if(!e)return;this.config=e,this.i=0;var t;for(var n in this.markers){var r=this.markers[n];if(!r.range){r.update(t,this,this.session,e);continue}var i=r.range.clipRows(e.firstRow,e.lastRow);if(i.isEmpty())continue;i=i.toScreenRange(this.session);if(r.renderer){var s=this.$getTop(i.start.row,e),o=this.$padding+i.start.column*e.characterWidth;r.renderer(t,i,o,s,e)}else r.type=="fullLine"?this.drawFullLineMarker(t,i,r.clazz,e):r.type=="screenLine"?this.drawScreenLineMarker(t,i,r.clazz,e):i.isMultiLine()?r.type=="text"?this.drawTextMarker(t,i,r.clazz,e):this.drawMultiLineMarker(t,i,r.clazz,e):this.drawSingleLineMarker(t,i,r.clazz+" ace_start"+" ace_br15",e)}if(this.i!=-1)while(this.i<this.element.childElementCount)this.element.removeChild(this.element.lastChild)},e.prototype.$getTop=function(e,t){return(e-t.firstRowScreen)*t.lineHeight},e.prototype.drawTextMarker=function(e,t,n,i,s){var u=this.session,a=t.start.row,f=t.end.row,l=a,c=0,h=0,p=u.getScreenLastRowColumn(l),d=new r(l,t.start.column,l,h);for(;l<=f;l++)d.start.row=d.end.row=l,d.start.column=l==a?t.start.column:u.getRowWrapIndent(l),d.end.column=p,c=h,h=p,p=l+1<f?u.getScreenLastRowColumn(l+1):l==f?0:t.end.column,this.drawSingleLineMarker(e,d,n+(l==a?" ace_start":"")+" ace_br"+o(l==a||l==a+1&&t.start.column,c<h,h>p,l==f),i,l==f?0:1,s)},e.prototype.drawMultiLineMarker=function(e,t,n,r,i){var s=this.$padding,o=r.lineHeight,u=this.$getTop(t.start.row,r),a=s+t.start.column*r.characterWidth;i=i||"";if(this.session.$bidiHandler.isBidiRow(t.start.row)){var f=t.clone();f.end.row=f.start.row,f.end.column=this.session.getLine(f.start.row).length,this.drawBidiSingleLineMarker(e,f,n+" ace_br1 ace_start",r,null,i)}else this.elt(n+" ace_br1 ace_start","height:"+o+"px;"+"right:"+s+"px;"+"top:"+u+"px;left:"+a+"px;"+(i||""));if(this.session.$bidiHandler.isBidiRow(t.end.row)){var f=t.clone();f.start.row=f.end.row,f.start.column=0,this.drawBidiSingleLineMarker(e,f,n+" ace_br12",r,null,i)}else{u=this.$getTop(t.end.row,r);var l=t.end.column*r.characterWidth;this.elt(n+" ace_br12","height:"+o+"px;"+"width:"+l+"px;"+"top:"+u+"px;"+"left:"+s+"px;"+(i||""))}o=(t.end.row-t.start.row-1)*r.lineHeight;if(o<=0)return;u=this.$getTop(t.start.row+1,r);var c=(t.start.column?1:0)|(t.end.column?0:8);this.elt(n+(c?" ace_br"+c:""),"height:"+o+"px;"+"right:"+s+"px;"+"top:"+u+"px;"+"left:"+s+"px;"+(i||""))},e.prototype.drawSingleLineMarker=function(e,t,n,r,i,s){if(this.session.$bidiHandler.isBidiRow(t.start.row))return this.drawBidiSingleLineMarker(e,t,n,r,i,s);var o=r.lineHeight,u=(t.end.column+(i||0)-t.start.column)*r.characterWidth,a=this.$getTop(t.start.row,r),f=this.$padding+t.start.column*r.characterWidth;this.elt(n,"height:"+o+"px;"+"width:"+u+"px;"+"top:"+a+"px;"+"left:"+f+"px;"+(s||""))},e.prototype.drawBidiSingleLineMarker=function(e,t,n,r,i,s){var o=r.lineHeight,u=this.$getTop(t.start.row,r),a=this.$padding,f=this.session.$bidiHandler.getSelections(t.start.column,t.end.column);f.forEach(function(e){this.elt(n,"height:"+o+"px;"+"width:"+(e.width+(i||0))+"px;"+"top:"+u+"px;"+"left:"+(a+e.left)+"px;"+(s||""))},this)},e.prototype.drawFullLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;t.start.row!=t.end.row&&(o+=this.$getTop(t.end.row,r)-s),this.elt(n,"height:"+o+"px;"+"top:"+s+"px;"+"left:0;right:0;"+(i||""))},e.prototype.drawScreenLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;this.elt(n,"height:"+o+"px;"+"top:"+s+"px;"+"left:0;right:0;"+(i||""))},e}();s.prototype.$padding=0,t.Marker=s}),define("ace/layer/text_util",["require","exports","module"],function(e,t,n){var r=new Set(["text","rparen","lparen"]);t.isTextToken=function(e){return r.has(e)}}),define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/layer/lines","ace/lib/event_emitter","ace/config","ace/layer/text_util"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("./lines").Lines,u=e("../lib/event_emitter").EventEmitter,a=e("../config").nls,f=e("./text_util").isTextToken,l=function(){function e(e){this.dom=i,this.element=this.dom.createElement("div"),this.element.className="ace_layer ace_text-layer",e.appendChild(this.element),this.$updateEolChar=this.$updateEolChar.bind(this),this.$lines=new o(this.element)}return e.prototype.$updateEolChar=function(){var e=this.session.doc,t=e.getNewLineCharacter()=="\n"&&e.getNewLineMode()!="windows",n=t?this.EOL_CHAR_LF:this.EOL_CHAR_CRLF;if(this.EOL_CHAR!=n)return this.EOL_CHAR=n,!0},e.prototype.setPadding=function(e){this.$padding=e,this.element.style.margin="0 "+e+"px"},e.prototype.getLineHeight=function(){return this.$fontMetrics.$characterSize.height||0},e.prototype.getCharacterWidth=function(){return this.$fontMetrics.$characterSize.width||0},e.prototype.$setFontMetrics=function(e){this.$fontMetrics=e,this.$fontMetrics.on("changeCharacterSize",function(e){this._signal("changeCharacterSize",e)}.bind(this)),this.$pollSizeChanges()},e.prototype.checkForSizeChanges=function(){this.$fontMetrics.checkForSizeChanges()},e.prototype.$pollSizeChanges=function(){return this.$pollSizeChangesTimer=this.$fontMetrics.$pollSizeChanges()},e.prototype.setSession=function(e){this.session=e,e&&this.$computeTabString()},e.prototype.setShowInvisibles=function(e){return this.showInvisibles==e?!1:(this.showInvisibles=e,typeof e=="string"?(this.showSpaces=/tab/i.test(e),this.showTabs=/space/i.test(e),this.showEOL=/eol/i.test(e)):this.showSpaces=this.showTabs=this.showEOL=e,this.$computeTabString(),!0)},e.prototype.setDisplayIndentGuides=function(e){return this.displayIndentGuides==e?!1:(this.displayIndentGuides=e,this.$computeTabString(),!0)},e.prototype.setHighlightIndentGuides=function(e){return this.$highlightIndentGuides===e?!1:(this.$highlightIndentGuides=e,e)},e.prototype.$computeTabString=function(){var e=this.session.getTabSize();this.tabSize=e;var t=this.$tabStrings=[0];for(var n=1;n<e+1;n++)if(this.showTabs){var r=this.dom.createElement("span");r.className="ace_invisible ace_invisible_tab",r.textContent=s.stringRepeat(this.TAB_CHAR,n),t.push(r)}else t.push(this.dom.createTextNode(s.stringRepeat(" ",n),this.element));if(this.displayIndentGuides){this.$indentGuideRe=/\s\S| \t|\t |\s$/;var i="ace_indent-guide",o=this.showSpaces?" ace_invisible ace_invisible_space":"",u=this.showSpaces?s.stringRepeat(this.SPACE_CHAR,this.tabSize):s.stringRepeat(" ",this.tabSize),a=this.showTabs?" ace_invisible ace_invisible_tab":"",f=this.showTabs?s.stringRepeat(this.TAB_CHAR,this.tabSize):u,r=this.dom.createElement("span");r.className=i+o,r.textContent=u,this.$tabStrings[" "]=r;var r=this.dom.createElement("span");r.className=i+a,r.textContent=f,this.$tabStrings["	"]=r}},e.prototype.updateLines=function(e,t,n){if(this.config.lastRow!=e.lastRow||this.config.firstRow!=e.firstRow)return this.update(e);this.config=e;var r=Math.max(t,e.firstRow),i=Math.min(n,e.lastRow),s=this.element.childNodes,o=0;for(var u=e.firstRow;u<r;u++){var a=this.session.getFoldLine(u);if(a){if(a.containsRow(r)){r=a.start.row;break}u=a.end.row}o++}var f=!1,u=r,a=this.session.getNextFoldLine(u),l=a?a.start.row:Infinity;for(;;){u>l&&(u=a.end.row+1,a=this.session.getNextFoldLine(u,a),l=a?a.start.row:Infinity);if(u>i)break;var c=s[o++];if(c){this.dom.removeChildren(c),this.$renderLine(c,u,u==l?a:!1),f&&(c.style.top=this.$lines.computeLineTop(u,e,this.session)+"px");var h=e.lineHeight*this.session.getRowLength(u)+"px";c.style.height!=h&&(f=!0,c.style.height=h)}u++}if(f)while(o<this.$lines.cells.length){var p=this.$lines.cells[o++];p.element.style.top=this.$lines.computeLineTop(p.row,e,this.session)+"px"}},e.prototype.scrollLines=function(e){var t=this.config;this.config=e;if(this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var n=e.lastRow,r=t?t.lastRow:-1;if(!t||r<e.firstRow)return this.update(e);if(n<t.firstRow)return this.update(e);if(!t||t.lastRow<e.firstRow)return this.update(e);if(e.lastRow<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var i=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);i>0;i--)this.$lines.shift();if(t.lastRow>e.lastRow)for(var i=this.session.getFoldedRowCount(e.lastRow+1,t.lastRow);i>0;i--)this.$lines.pop();e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLinesFragment(e,e.firstRow,t.firstRow-1)),e.lastRow>t.lastRow&&this.$lines.push(this.$renderLinesFragment(e,t.lastRow+1,e.lastRow)),this.$highlightIndentGuide()},e.prototype.$renderLinesFragment=function(e,t,n){var r=[],s=t,o=this.session.getNextFoldLine(s),u=o?o.start.row:Infinity;for(;;){s>u&&(s=o.end.row+1,o=this.session.getNextFoldLine(s,o),u=o?o.start.row:Infinity);if(s>n)break;var a=this.$lines.createCell(s,e,this.session),f=a.element;this.dom.removeChildren(f),i.setStyle(f.style,"height",this.$lines.computeLineHeight(s,e,this.session)+"px"),i.setStyle(f.style,"top",this.$lines.computeLineTop(s,e,this.session)+"px"),this.$renderLine(f,s,s==u?o:!1),this.$useLineGroups()?f.className="ace_line_group":f.className="ace_line",r.push(a),s++}return r},e.prototype.update=function(e){this.$lines.moveContainer(e),this.config=e;var t=e.firstRow,n=e.lastRow,r=this.$lines;while(r.getLength())r.pop();r.push(this.$renderLinesFragment(e,t,n))},e.prototype.$renderToken=function(e,t,n,r){var i=this,o=/(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069\u2060\u2061\u2062\u2063\u2064\u206A\u206B\u206B\u206C\u206D\u206E\u206F]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g,u=this.dom.createFragment(this.element),l,c=0;while(l=o.exec(r)){var h=l[1],p=l[2],d=l[3],v=l[4],m=l[5];if(!i.showSpaces&&p)continue;var g=c!=l.index?r.slice(c,l.index):"";c=l.index+l[0].length,g&&u.appendChild(this.dom.createTextNode(g,this.element));if(h){var y=i.session.getScreenTabSize(t+l.index);u.appendChild(i.$tabStrings[y].cloneNode(!0)),t+=y-1}else if(p)if(i.showSpaces){var b=this.dom.createElement("span");b.className="ace_invisible ace_invisible_space",b.textContent=s.stringRepeat(i.SPACE_CHAR,p.length),u.appendChild(b)}else u.appendChild(this.dom.createTextNode(p,this.element));else if(d){var b=this.dom.createElement("span");b.className="ace_invisible ace_invisible_space ace_invalid",b.textContent=s.stringRepeat(i.SPACE_CHAR,d.length),u.appendChild(b)}else if(v){t+=1;var b=this.dom.createElement("span");b.style.width=i.config.characterWidth*2+"px",b.className=i.showSpaces?"ace_cjk ace_invisible ace_invisible_space":"ace_cjk",b.textContent=i.showSpaces?i.SPACE_CHAR:v,u.appendChild(b)}else if(m){t+=1;var b=this.dom.createElement("span");b.style.width=i.config.characterWidth*2+"px",b.className="ace_cjk",b.textContent=m,u.appendChild(b)}}u.appendChild(this.dom.createTextNode(c?r.slice(c):r,this.element));if(!f(n.type)){var w="ace_"+n.type.replace(/\./g," ace_"),b=this.dom.createElement("span");n.type=="fold"&&(b.style.width=n.value.length*this.config.characterWidth+"px",b.setAttribute("title",a("inline-fold.closed.title","Unfold code"))),b.className=w,b.appendChild(u),e.appendChild(b)}else e.appendChild(u);return t+r.length},e.prototype.renderIndentGuide=function(e,t,n){var r=t.search(this.$indentGuideRe);if(r<=0||r>=n)return t;if(t[0]==" "){r-=r%this.tabSize;var i=r/this.tabSize;for(var s=0;s<i;s++)e.appendChild(this.$tabStrings[" "].cloneNode(!0));return this.$highlightIndentGuide(),t.substr(r)}if(t[0]=="	"){for(var s=0;s<r;s++)e.appendChild(this.$tabStrings["	"].cloneNode(!0));return this.$highlightIndentGuide(),t.substr(r)}return this.$highlightIndentGuide(),t},e.prototype.$highlightIndentGuide=function(){if(!this.$highlightIndentGuides||!this.displayIndentGuides)return;this.$highlightIndentGuideMarker={indentLevel:undefined,start:undefined,end:undefined,dir:undefined};var e=this.session.doc.$lines;if(!e)return;var t=this.session.selection.getCursor(),n=/^\s*/.exec(this.session.doc.getLine(t.row))[0].length,r=Math.floor(n/this.tabSize);this.$highlightIndentGuideMarker={indentLevel:r,start:t.row};var i=this.session.$bracketHighlight;if(i){var s=this.session.$bracketHighlight.ranges;for(var o=0;o<s.length;o++)if(t.row!==s[o].start.row){this.$highlightIndentGuideMarker.end=s[o].start.row+1,t.row>s[o].start.row?this.$highlightIndentGuideMarker.dir=-1:this.$highlightIndentGuideMarker.dir=1;break}}if(!this.$highlightIndentGuideMarker.end&&e[t.row]!==""&&t.column===e[t.row].length){this.$highlightIndentGuideMarker.dir=1;for(var o=t.row+1;o<e.length;o++){var u=e[o],a=/^\s*/.exec(u)[0].length;if(u!==""){this.$highlightIndentGuideMarker.end=o;if(a<=n)break}}}this.$renderHighlightIndentGuide()},e.prototype.$clearActiveIndentGuide=function(){var e=this.element.querySelectorAll(".ace_indent-guide-active");for(var t=0;t<e.length;t++)e[t].classList.remove("ace_indent-guide-active")},e.prototype.$setIndentGuideActive=function(e,t){var n=this.session.doc.getLine(e.row);if(n!==""){var r=e.element;if(e.element.classList&&e.element.classList.contains("ace_line_group")){if(!(e.element.childNodes.length>0))return;r=e.element.childNodes[0]}var i=r.childNodes;if(i){var s=i[t-1];s&&s.classList&&s.classList.contains("ace_indent-guide")&&s.classList.add("ace_indent-guide-active")}}},e.prototype.$renderHighlightIndentGuide=function(){if(!this.$lines)return;var e=this.$lines.cells;this.$clearActiveIndentGuide();var t=this.$highlightIndentGuideMarker.indentLevel;if(t!==0)if(this.$highlightIndentGuideMarker.dir===1)for(var n=0;n<e.length;n++){var r=e[n];if(this.$highlightIndentGuideMarker.end&&r.row>=this.$highlightIndentGuideMarker.start+1){if(r.row>=this.$highlightIndentGuideMarker.end)break;this.$setIndentGuideActive(r,t)}}else for(var n=e.length-1;n>=0;n--){var r=e[n];if(this.$highlightIndentGuideMarker.end&&r.row<this.$highlightIndentGuideMarker.start){if(r.row<this.$highlightIndentGuideMarker.end)break;this.$setIndentGuideActive(r,t)}}},e.prototype.$createLineElement=function(e){var t=this.dom.createElement("div");return t.className="ace_line",t.style.height=this.config.lineHeight+"px",t},e.prototype.$renderWrappedLine=function(e,t,n){var r=0,i=0,o=n[0],u=0,a=this.$createLineElement();e.appendChild(a);for(var f=0;f<t.length;f++){var l=t[f],c=l.value;if(f==0&&this.displayIndentGuides){r=c.length,c=this.renderIndentGuide(a,c,o);if(!c)continue;r-=c.length}if(r+c.length<o)u=this.$renderToken(a,u,l,c),r+=c.length;else{while(r+c.length>=o)u=this.$renderToken(a,u,l,c.substring(0,o-r)),c=c.substring(o-r),r=o,a=this.$createLineElement(),e.appendChild(a),a.appendChild(this.dom.createTextNode(s.stringRepeat("\u00a0",n.indent),this.element)),i++,u=0,o=n[i]||Number.MAX_VALUE;c.length!=0&&(r+=c.length,u=this.$renderToken(a,u,l,c))}}n[n.length-1]>this.MAX_LINE_LENGTH&&this.$renderOverflowMessage(a,u,null,"",!0)},e.prototype.$renderSimpleLine=function(e,t){var n=0;for(var r=0;r<t.length;r++){var i=t[r],s=i.value;if(r==0&&this.displayIndentGuides){s=this.renderIndentGuide(e,s);if(!s)continue}if(n+s.length>this.MAX_LINE_LENGTH)return this.$renderOverflowMessage(e,n,i,s);n=this.$renderToken(e,n,i,s)}},e.prototype.$renderOverflowMessage=function(e,t,n,r,i){n&&this.$renderToken(e,t,n,r.slice(0,this.MAX_LINE_LENGTH-t));var s=this.dom.createElement("span");s.className="ace_inline_button ace_keyword ace_toggle_wrap",s.textContent=i?"<hide>":"<click to see more...>",e.appendChild(s)},e.prototype.$renderLine=function(e,t,n){!n&&n!=0&&(n=this.session.getFoldLine(t));if(n)var r=this.$getFoldLineTokens(t,n);else var r=this.session.getTokens(t);var i=e;if(r.length){var s=this.session.getRowSplitData(t);if(s&&s.length){this.$renderWrappedLine(e,r,s);var i=e.lastChild}else{var i=e;this.$useLineGroups()&&(i=this.$createLineElement(),e.appendChild(i)),this.$renderSimpleLine(i,r)}}else this.$useLineGroups()&&(i=this.$createLineElement(),e.appendChild(i));if(this.showEOL&&i){n&&(t=n.end.row);var o=this.dom.createElement("span");o.className="ace_invisible ace_invisible_eol",o.textContent=t==this.session.getLength()-1?this.EOF_CHAR:this.EOL_CHAR,i.appendChild(o)}},e.prototype.$getFoldLineTokens=function(e,t){function i(e,t,n){var i=0,s=0;while(s+e[i].value.length<t){s+=e[i].value.length,i++;if(i==e.length)return}if(s!=t){var o=e[i].value.substring(t-s);o.length>n-t&&(o=o.substring(0,n-t)),r.push({type:e[i].type,value:o}),s=t+o.length,i+=1}while(s<n&&i<e.length){var o=e[i].value;o.length+s>n?r.push({type:e[i].type,value:o.substring(0,n-s)}):r.push(e[i]),s+=o.length,i+=1}}var n=this.session,r=[],s=n.getTokens(e);return t.walk(function(e,t,o,u,a){e!=null?r.push({type:"fold",value:e}):(a&&(s=n.getTokens(t)),s.length&&i(s,u,o))},t.end.row,this.session.getLine(t.end.row).length),r},e.prototype.$useLineGroups=function(){return this.session.getUseWrapMode()},e}();l.prototype.EOF_CHAR="\u00b6",l.prototype.EOL_CHAR_LF="\u00ac",l.prototype.EOL_CHAR_CRLF="\u00a4",l.prototype.EOL_CHAR=l.prototype.EOL_CHAR_LF,l.prototype.TAB_CHAR="\u2014",l.prototype.SPACE_CHAR="\u00b7",l.prototype.$padding=0,l.prototype.MAX_LINE_LENGTH=1e4,l.prototype.showInvisibles=!1,l.prototype.showSpaces=!1,l.prototype.showTabs=!1,l.prototype.showEOL=!1,l.prototype.displayIndentGuides=!0,l.prototype.$highlightIndentGuides=!0,l.prototype.$tabStrings=[],l.prototype.destroy={},l.prototype.onChangeTabSize=l.prototype.$computeTabString,r.implement(l.prototype,u),t.Text=l}),define("ace/layer/cursor",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_cursor-layer",e.appendChild(this.element),this.isVisible=!1,this.isBlinking=!0,this.blinkInterval=1e3,this.smoothBlinking=!1,this.cursors=[],this.cursor=this.addCursor(),r.addCssClass(this.element,"ace_hidden-cursors"),this.$updateCursors=this.$updateOpacity.bind(this)}return e.prototype.$updateOpacity=function(e){var t=this.cursors;for(var n=t.length;n--;)r.setStyle(t[n].style,"opacity",e?"":"0")},e.prototype.$startCssAnimation=function(){var e=this.cursors;for(var t=e.length;t--;)e[t].style.animationDuration=this.blinkInterval+"ms";this.$isAnimating=!0,setTimeout(function(){this.$isAnimating&&r.addCssClass(this.element,"ace_animate-blinking")}.bind(this))},e.prototype.$stopCssAnimation=function(){this.$isAnimating=!1,r.removeCssClass(this.element,"ace_animate-blinking")},e.prototype.setPadding=function(e){this.$padding=e},e.prototype.setSession=function(e){this.session=e},e.prototype.setBlinking=function(e){e!=this.isBlinking&&(this.isBlinking=e,this.restartTimer())},e.prototype.setBlinkInterval=function(e){e!=this.blinkInterval&&(this.blinkInterval=e,this.restartTimer())},e.prototype.setSmoothBlinking=function(e){e!=this.smoothBlinking&&(this.smoothBlinking=e,r.setCssClass(this.element,"ace_smooth-blinking",e),this.$updateCursors(!0),this.restartTimer())},e.prototype.addCursor=function(){var e=r.createElement("div");return e.className="ace_cursor",this.element.appendChild(e),this.cursors.push(e),e},e.prototype.removeCursor=function(){if(this.cursors.length>1){var e=this.cursors.pop();return e.parentNode.removeChild(e),e}},e.prototype.hideCursor=function(){this.isVisible=!1,r.addCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},e.prototype.showCursor=function(){this.isVisible=!0,r.removeCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},e.prototype.restartTimer=function(){var e=this.$updateCursors;clearInterval(this.intervalId),clearTimeout(this.timeoutId),this.$stopCssAnimation(),this.smoothBlinking&&(this.$isSmoothBlinking=!1,r.removeCssClass(this.element,"ace_smooth-blinking")),e(!0);if(!this.isBlinking||!this.blinkInterval||!this.isVisible){this.$stopCssAnimation();return}this.smoothBlinking&&(this.$isSmoothBlinking=!0,setTimeout(function(){this.$isSmoothBlinking&&r.addCssClass(this.element,"ace_smooth-blinking")}.bind(this)));if(r.HAS_CSS_ANIMATION)this.$startCssAnimation();else{var t=function(){this.timeoutId=setTimeout(function(){e(!1)},.6*this.blinkInterval)}.bind(this);this.intervalId=setInterval(function(){e(!0),t()},this.blinkInterval),t()}},e.prototype.getPixelPosition=function(e,t){if(!this.config||!this.session)return{left:0,top:0};e||(e=this.session.selection.getCursor());var n=this.session.documentToScreenPosition(e),r=this.$padding+(this.session.$bidiHandler.isBidiRow(n.row,e.row)?this.session.$bidiHandler.getPosLeft(n.column):n.column*this.config.characterWidth),i=(n.row-(t?this.config.firstRowScreen:0))*this.config.lineHeight;return{left:r,top:i}},e.prototype.isCursorInView=function(e,t){return e.top>=0&&e.top<t.maxHeight},e.prototype.update=function(e){this.config=e;var t=this.session.$selectionMarkers,n=0,i=0;if(t===undefined||t.length===0)t=[{cursor:null}];for(var n=0,s=t.length;n<s;n++){var o=this.getPixelPosition(t[n].cursor,!0);if((o.top>e.height+e.offset||o.top<0)&&n>1)continue;var u=this.cursors[i++]||this.addCursor(),a=u.style;this.drawCursor?this.drawCursor(u,o,e,t[n],this.session):this.isCursorInView(o,e)?(r.setStyle(a,"display","block"),r.translate(u,o.left,o.top),r.setStyle(a,"width",Math.round(e.characterWidth)+"px"),r.setStyle(a,"height",e.lineHeight+"px")):r.setStyle(a,"display","none")}while(this.cursors.length>i)this.removeCursor();var f=this.session.getOverwrite();this.$setOverwrite(f),this.$pixelPos=o,this.restartTimer()},e.prototype.$setOverwrite=function(e){e!=this.overwrite&&(this.overwrite=e,e?r.addCssClass(this.element,"ace_overwrite-cursors"):r.removeCssClass(this.element,"ace_overwrite-cursors"))},e.prototype.destroy=function(){clearInterval(this.intervalId),clearTimeout(this.timeoutId)},e}();i.prototype.$padding=0,i.prototype.drawCursor=null,t.Cursor=i}),define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/event"),u=e("./lib/event_emitter").EventEmitter,a=32768,f=function(){function e(e,t){this.element=s.createElement("div"),this.element.className="ace_scrollbar ace_scrollbar"+t,this.inner=s.createElement("div"),this.inner.className="ace_scrollbar-inner",this.inner.textContent="\u00a0",this.element.appendChild(this.inner),e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,o.addListener(this.element,"scroll",this.onScroll.bind(this)),o.addListener(this.element,"mousedown",o.preventDefault)}return e.prototype.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1},e}();i.implement(f.prototype,u);var l=function(e){function t(t,n){var r=e.call(this,t,"-v")||this;return r.scrollTop=0,r.scrollHeight=0,n.$scrollbarWidth=r.width=s.scrollbarWidth(t.ownerDocument),r.inner.style.width=r.element.style.width=(r.width||15)+5+"px",r.$minWidth=0,r}return r(t,e),t.prototype.onScroll=function(){if(!this.skipEvent){this.scrollTop=this.element.scrollTop;if(this.coeff!=1){var e=this.element.clientHeight/this.scrollHeight;this.scrollTop=this.scrollTop*(1-e)/(this.coeff-e)}this._emit("scroll",{data:this.scrollTop})}this.skipEvent=!1},t.prototype.getWidth=function(){return Math.max(this.isVisible?this.width:0,this.$minWidth||0)},t.prototype.setHeight=function(e){this.element.style.height=e+"px"},t.prototype.setScrollHeight=function(e){this.scrollHeight=e,e>a?(this.coeff=a/e,e=a):this.coeff!=1&&(this.coeff=1),this.inner.style.height=e+"px"},t.prototype.setScrollTop=function(e){this.scrollTop!=e&&(this.skipEvent=!0,this.scrollTop=e,this.element.scrollTop=e*this.coeff)},t}(f);l.prototype.setInnerHeight=l.prototype.setScrollHeight;var c=function(e){function t(t,n){var r=e.call(this,t,"-h")||this;return r.scrollLeft=0,r.height=n.$scrollbarWidth,r.inner.style.height=r.element.style.height=(r.height||15)+5+"px",r}return r(t,e),t.prototype.onScroll=function(){this.skipEvent||(this.scrollLeft=this.element.scrollLeft,this._emit("scroll",{data:this.scrollLeft})),this.skipEvent=!1},t.prototype.getHeight=function(){return this.isVisible?this.height:0},t.prototype.setWidth=function(e){this.element.style.width=e+"px"},t.prototype.setInnerWidth=function(e){this.inner.style.width=e+"px"},t.prototype.setScrollWidth=function(e){this.inner.style.width=e+"px"},t.prototype.setScrollLeft=function(e){this.scrollLeft!=e&&(this.skipEvent=!0,this.scrollLeft=this.element.scrollLeft=e)},t}(f);t.ScrollBar=l,t.ScrollBarV=l,t.ScrollBarH=c,t.VScrollBar=l,t.HScrollBar=c}),define("ace/scrollbar_custom",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/event"),u=e("./lib/event_emitter").EventEmitter;s.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}","ace_scrollbar.css",!1);var a=function(){function e(e,t){this.element=s.createElement("div"),this.element.className="ace_sb"+t,this.inner=s.createElement("div"),this.inner.className="",this.element.appendChild(this.inner),this.VScrollWidth=12,this.HScrollHeight=12,e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,o.addMultiMouseDownListener(this.element,[500,300,300],this,"onMouseDown")}return e.prototype.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1},e}();i.implement(a.prototype,u);var f=function(e){function t(t,n){var r=e.call(this,t,"-v")||this;return r.scrollTop=0,r.scrollHeight=0,r.parent=t,r.width=r.VScrollWidth,r.renderer=n,r.inner.style.width=r.element.style.width=(r.width||15)+"px",r.$minWidth=0,r}return r(t,e),t.prototype.onMouseDown=function(e,t){if(e!=="mousedown")return;if(o.getButton(t)!==0||t.detail===2)return;if(t.target===this.inner){var n=this,r=t.clientY,i=function(e){r=e.clientY},s=function(){clearInterval(l)},u=t.clientY,a=this.thumbTop,f=function(){if(r===undefined)return;var e=n.scrollTopFromThumbTop(a+r-u);if(e===n.scrollTop)return;n._emit("scroll",{data:e})};o.capture(this.inner,i,s);var l=setInterval(f,20);return o.preventDefault(t)}var c=t.clientY-this.element.getBoundingClientRect().top-this.thumbHeight/2;return this._emit("scroll",{data:this.scrollTopFromThumbTop(c)}),o.preventDefault(t)},t.prototype.getHeight=function(){return this.height},t.prototype.scrollTopFromThumbTop=function(e){var t=e*(this.pageHeight-this.viewHeight)/(this.slideHeight-this.thumbHeight);return t>>=0,t<0?t=0:t>this.pageHeight-this.viewHeight&&(t=this.pageHeight-this.viewHeight),t},t.prototype.getWidth=function(){return Math.max(this.isVisible?this.width:0,this.$minWidth||0)},t.prototype.setHeight=function(e){this.height=Math.max(0,e),this.slideHeight=this.height,this.viewHeight=this.height,this.setScrollHeight(this.pageHeight,!0)},t.prototype.setScrollHeight=function(e,t){if(this.pageHeight===e&&!t)return;this.pageHeight=e,this.thumbHeight=this.slideHeight*this.viewHeight/this.pageHeight,this.thumbHeight>this.slideHeight&&(this.thumbHeight=this.slideHeight),this.thumbHeight<15&&(this.thumbHeight=15),this.inner.style.height=this.thumbHeight+"px",this.scrollTop>this.pageHeight-this.viewHeight&&(this.scrollTop=this.pageHeight-this.viewHeight,this.scrollTop<0&&(this.scrollTop=0),this._emit("scroll",{data:this.scrollTop}))},t.prototype.setScrollTop=function(e){this.scrollTop=e,e<0&&(e=0),this.thumbTop=e*(this.slideHeight-this.thumbHeight)/(this.pageHeight-this.viewHeight),this.inner.style.top=this.thumbTop+"px"},t}(a);f.prototype.setInnerHeight=f.prototype.setScrollHeight;var l=function(e){function t(t,n){var r=e.call(this,t,"-h")||this;return r.scrollLeft=0,r.scrollWidth=0,r.height=r.HScrollHeight,r.inner.style.height=r.element.style.height=(r.height||12)+"px",r.renderer=n,r}return r(t,e),t.prototype.onMouseDown=function(e,t){if(e!=="mousedown")return;if(o.getButton(t)!==0||t.detail===2)return;if(t.target===this.inner){var n=this,r=t.clientX,i=function(e){r=e.clientX},s=function(){clearInterval(l)},u=t.clientX,a=this.thumbLeft,f=function(){if(r===undefined)return;var e=n.scrollLeftFromThumbLeft(a+r-u);if(e===n.scrollLeft)return;n._emit("scroll",{data:e})};o.capture(this.inner,i,s);var l=setInterval(f,20);return o.preventDefault(t)}var c=t.clientX-this.element.getBoundingClientRect().left-this.thumbWidth/2;return this._emit("scroll",{data:this.scrollLeftFromThumbLeft(c)}),o.preventDefault(t)},t.prototype.getHeight=function(){return this.isVisible?this.height:0},t.prototype.scrollLeftFromThumbLeft=function(e){var t=e*(this.pageWidth-this.viewWidth)/(this.slideWidth-this.thumbWidth);return t>>=0,t<0?t=0:t>this.pageWidth-this.viewWidth&&(t=this.pageWidth-this.viewWidth),t},t.prototype.setWidth=function(e){this.width=Math.max(0,e),this.element.style.width=this.width+"px",this.slideWidth=this.width,this.viewWidth=this.width,this.setScrollWidth(this.pageWidth,!0)},t.prototype.setScrollWidth=function(e,t){if(this.pageWidth===e&&!t)return;this.pageWidth=e,this.thumbWidth=this.slideWidth*this.viewWidth/this.pageWidth,this.thumbWidth>this.slideWidth&&(this.thumbWidth=this.slideWidth),this.thumbWidth<15&&(this.thumbWidth=15),this.inner.style.width=this.thumbWidth+"px",this.scrollLeft>this.pageWidth-this.viewWidth&&(this.scrollLeft=this.pageWidth-this.viewWidth,this.scrollLeft<0&&(this.scrollLeft=0),this._emit("scroll",{data:this.scrollLeft}))},t.prototype.setScrollLeft=function(e){this.scrollLeft=e,e<0&&(e=0),this.thumbLeft=e*(this.slideWidth-this.thumbWidth)/(this.pageWidth-this.viewWidth),this.inner.style.left=this.thumbLeft+"px"},t}(a);l.prototype.setInnerWidth=l.prototype.setScrollWidth,t.ScrollBar=f,t.ScrollBarV=f,t.ScrollBarH=l,t.VScrollBar=f,t.HScrollBar=l}),define("ace/renderloop",["require","exports","module","ace/lib/event"],function(e,t,n){"use strict";var r=e("./lib/event"),i=function(){function e(e,t){this.onRender=e,this.pending=!1,this.changes=0,this.$recursionLimit=2,this.window=t||window;var n=this;this._flush=function(e){n.pending=!1;var t=n.changes;t&&(r.blockIdle(100),n.changes=0,n.onRender(t));if(n.changes){if(n.$recursionLimit--<0)return;n.schedule()}else n.$recursionLimit=2}}return e.prototype.schedule=function(e){this.changes=this.changes|e,this.changes&&!this.pending&&(r.nextFrame(this._flush),this.pending=!0)},e.prototype.clear=function(e){var t=this.changes;return this.changes=0,t},e}();t.RenderLoop=i}),define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("../lib/event"),u=e("../lib/useragent"),a=e("../lib/event_emitter").EventEmitter,f=512,l=typeof ResizeObserver=="function",c=200,h=function(){function e(e){this.el=i.createElement("div"),this.$setMeasureNodeStyles(this.el.style,!0),this.$main=i.createElement("div"),this.$setMeasureNodeStyles(this.$main.style),this.$measureNode=i.createElement("div"),this.$setMeasureNodeStyles(this.$measureNode.style),this.el.appendChild(this.$main),this.el.appendChild(this.$measureNode),e.appendChild(this.el),this.$measureNode.textContent=s.stringRepeat("X",f),this.$characterSize={width:0,height:0},l?this.$addObserver():this.checkForSizeChanges()}return e.prototype.$setMeasureNodeStyles=function(e,t){e.width=e.height="auto",e.left=e.top="0px",e.visibility="hidden",e.position="absolute",e.whiteSpace="pre",u.isIE<8?e["font-family"]="inherit":e.font="inherit",e.overflow=t?"hidden":"visible"},e.prototype.checkForSizeChanges=function(e){e===undefined&&(e=this.$measureSizes());if(e&&(this.$characterSize.width!==e.width||this.$characterSize.height!==e.height)){this.$measureNode.style.fontWeight="bold";var t=this.$measureSizes();this.$measureNode.style.fontWeight="",this.$characterSize=e,this.charSizes=Object.create(null),this.allowBoldFonts=t&&t.width===e.width&&t.height===e.height,this._emit("changeCharacterSize",{data:e})}},e.prototype.$addObserver=function(){var e=this;this.$observer=new window.ResizeObserver(function(t){e.checkForSizeChanges()}),this.$observer.observe(this.$measureNode)},e.prototype.$pollSizeChanges=function(){if(this.$pollSizeChangesTimer||this.$observer)return this.$pollSizeChangesTimer;var e=this;return this.$pollSizeChangesTimer=o.onIdle(function t(){e.checkForSizeChanges(),o.onIdle(t,500)},500)},e.prototype.setPolling=function(e){e?this.$pollSizeChanges():this.$pollSizeChangesTimer&&(clearInterval(this.$pollSizeChangesTimer),this.$pollSizeChangesTimer=0)},e.prototype.$measureSizes=function(e){var t={height:(e||this.$measureNode).clientHeight,width:(e||this.$measureNode).clientWidth/f};return t.width===0||t.height===0?null:t},e.prototype.$measureCharWidth=function(e){this.$main.textContent=s.stringRepeat(e,f);var t=this.$main.getBoundingClientRect();return t.width/f},e.prototype.getCharacterWidth=function(e){var t=this.charSizes[e];return t===undefined&&(t=this.charSizes[e]=this.$measureCharWidth(e)/this.$characterSize.width),t},e.prototype.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.$observer&&this.$observer.disconnect(),this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el)},e.prototype.$getZoom=function(e){return!e||!e.parentElement?1:(Number(window.getComputedStyle(e).zoom)||1)*this.$getZoom(e.parentElement)},e.prototype.$initTransformMeasureNodes=function(){var e=function(e,t){return["div",{style:"position: absolute;top:"+e+"px;left:"+t+"px;"}]};this.els=i.buildDom([e(0,0),e(c,0),e(0,c),e(c,c)],this.el)},e.prototype.transformCoordinates=function(e,t){function r(e,t,n){var r=e[1]*t[0]-e[0]*t[1];return[(-t[1]*n[0]+t[0]*n[1])/r,(+e[1]*n[0]-e[0]*n[1])/r]}function i(e,t){return[e[0]-t[0],e[1]-t[1]]}function s(e,t){return[e[0]+t[0],e[1]+t[1]]}function o(e,t){return[e*t[0],e*t[1]]}function u(e){var t=e.getBoundingClientRect();return[t.left,t.top]}if(e){var n=this.$getZoom(this.el);e=o(1/n,e)}this.els||this.$initTransformMeasureNodes();var a=u(this.els[0]),f=u(this.els[1]),l=u(this.els[2]),h=u(this.els[3]),p=r(i(h,f),i(h,l),i(s(f,l),s(h,a))),d=o(1+p[0],i(f,a)),v=o(1+p[1],i(l,a));if(t){var m=t,g=p[0]*m[0]/c+p[1]*m[1]/c+1,y=s(o(m[0],d),o(m[1],v));return s(o(1/g/c,y),a)}var b=i(e,a),w=r(i(d,o(p[0],b)),i(v,o(p[1],b)),b);return o(c,w)},e}();h.prototype.$characterSize={width:0,height:0},r.implement(h.prototype,a),t.FontMetrics=h}),define("ace/css/editor-css",["require","exports","module"],function(e,t,n){n.exports='\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    forced-color-adjust: none;\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n.ace_invisible {\n    font-variant-ligatures: none;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold, .ace_gutter-cell.ace_security, .ace_icon.ace_security, .ace_icon.ace_security_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info, .ace_gutter-cell.ace_hint, .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info, .ace_dark .ace_gutter-cell.ace_hint, .ace_dark .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iZGFya29yYW5nZSIgZmlsbD0ibm9uZSIgc2hhcGUtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iPgogICAgICAgIDxwYXRoIGNsYXNzPSJzdHJva2UtbGluZWpvaW4tcm91bmQiIGQ9Ik04IDE0LjgzMDdDOCAxNC44MzA3IDIgMTIuOTA0NyAyIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOEM3Ljk4OTk5IDEuMzQ5MTggMTAuNjkgMy4yNjU0OCAxNCAzLjI2NTQ4VjguMDg5OTJDMTQgMTIuOTA0NyA4IDE0LjgzMDcgOCAxNC44MzA3WiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMy45OSA4LjA4OTkyVjMuMjY1NDhDMTAuNjggMy4yNjU0OCA4IDEuMzQ5MTggOCAxLjM0OTE4Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggNFY5Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggMTBWMTIiLz4KICAgIDwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n.ace_icon_svg.ace_hint {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0ic2lsdmVyIiBmaWxsPSJub25lIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTYgMTRIMTAiLz4KICAgICAgICA8cGF0aCBkPSJNOCAxMUg5QzkgOS40NzAwMiAxMiA4LjU0MDAyIDEyIDUuNzYwMDJDMTIuMDIgNC40MDAwMiAxMS4zOSAzLjM2MDAyIDEwLjQzIDIuNjcwMDJDOSAxLjY0MDAyIDcuMDAwMDEgMS42NDAwMiA1LjU3MDAxIDIuNjcwMDJDNC42MTAwMSAzLjM2MDAyIDMuOTggNC40MDAwMiA0IDUuNzYwMDJDNCA4LjU0MDAyIDcuMDAwMDEgOS40NzAwMiA3LjAwMDAxIDExSDhaIi8+CiAgICA8L2c+Cjwvc3ZnPg==");\n    background-color: silver;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,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");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n    overflow: auto;\n    max-width: min(33em, 66vw);\n    overscroll-behavior: contain;\n}\n.ace_tooltip pre {\n    white-space: pre-wrap;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    position: relative;\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n    z-index: 1;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n}\n\n.ace_ghost_text_container > div {\n    white-space: pre;\n}\n\n.ghost_text_line_wrapped::after {\n    content: "\u21a9";\n    position: absolute;\n}\n\n.ace_lineWidgetContainer.ace_ghost_text {\n    margin: 0px 4px\n}\n\n.ace_screenreader-only {\n    position:absolute;\n    left:-10000px;\n    top:auto;\n    width:1px;\n    height:1px;\n    overflow:hidden;\n}\n\n.ace_hidden_token {\n    display: none;\n}'}),define("ace/layer/decorators",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/event_emitter").EventEmitter,o=function(){function e(e,t){this.canvas=r.createElement("canvas"),this.renderer=t,this.pixelRatio=1,this.maxHeight=t.layerConfig.maxHeight,this.lineHeight=t.layerConfig.lineHeight,this.canvasHeight=e.parent.scrollHeight,this.heightRatio=this.canvasHeight/this.maxHeight,this.canvasWidth=e.width,this.minDecorationHeight=2*this.pixelRatio|0,this.halfMinDecorationHeight=this.minDecorationHeight/2|0,this.canvas.width=this.canvasWidth,this.canvas.height=this.canvasHeight,this.canvas.style.top="0px",this.canvas.style.right="0px",this.canvas.style.zIndex="7px",this.canvas.style.position="absolute",this.colors={},this.colors.dark={error:"rgba(255, 18, 18, 1)",warning:"rgba(18, 136, 18, 1)",info:"rgba(18, 18, 136, 1)"},this.colors.light={error:"rgb(255,51,51)",warning:"rgb(32,133,72)",info:"rgb(35,68,138)"},e.element.appendChild(this.canvas)}return e.prototype.$updateDecorators=function(e){function i(e,t){return e.priority<t.priority?-1:e.priority>t.priority?1:0}var t=this.renderer.theme.isDark===!0?this.colors.dark:this.colors.light;if(e){this.maxHeight=e.maxHeight,this.lineHeight=e.lineHeight,this.canvasHeight=e.height;var n=(e.lastRow+1)*this.lineHeight;n<this.canvasHeight?this.heightRatio=1:this.heightRatio=this.canvasHeight/this.maxHeight}var r=this.canvas.getContext("2d"),s=this.renderer.session.$annotations;r.clearRect(0,0,this.canvas.width,this.canvas.height);if(s){var o={info:1,warning:2,error:3};s.forEach(function(e){e.priority=o[e.type]||null}),s=s.sort(i);var u=this.renderer.session.$foldData;for(var a=0;a<s.length;a++){var f=s[a].row,l=this.compensateFoldRows(f,u),c=Math.round((f-l)*this.lineHeight*this.heightRatio),h=Math.round((f-l)*this.lineHeight*this.heightRatio),p=Math.round(((f-l)*this.lineHeight+this.lineHeight)*this.heightRatio),d=p-h;if(d<this.minDecorationHeight){var v=(h+p)/2|0;v<this.halfMinDecorationHeight?v=this.halfMinDecorationHeight:v+this.halfMinDecorationHeight>this.canvasHeight&&(v=this.canvasHeight-this.halfMinDecorationHeight),h=Math.round(v-this.halfMinDecorationHeight),p=Math.round(v+this.halfMinDecorationHeight)}r.fillStyle=t[s[a].type]||null,r.fillRect(0,c,this.canvasWidth,p-h)}}var m=this.renderer.session.selection.getCursor();if(m){var l=this.compensateFoldRows(m.row,u),c=Math.round((m.row-l)*this.lineHeight*this.heightRatio);r.fillStyle="rgba(0, 0, 0, 0.5)",r.fillRect(0,c,this.canvasWidth,2)}},e.prototype.compensateFoldRows=function(e,t){var n=0;if(t&&t.length>0)for(var r=0;r<t.length;r++)e>t[r].start.row&&e<t[r].end.row?n+=e-t[r].start.row:e>=t[r].end.row&&(n+=t[r].end.row-t[r].start.row);return n},e}();i.implement(o.prototype,s),t.Decorator=o}),define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/config","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/scrollbar_custom","ace/scrollbar_custom","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter","ace/css/editor-css","ace/layer/decorators","ace/lib/useragent","ace/layer/text_util"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./lib/lang"),o=e("./config"),u=e("./layer/gutter").Gutter,a=e("./layer/marker").Marker,f=e("./layer/text").Text,l=e("./layer/cursor").Cursor,c=e("./scrollbar").HScrollBar,h=e("./scrollbar").VScrollBar,p=e("./scrollbar_custom").HScrollBar,d=e("./scrollbar_custom").VScrollBar,v=e("./renderloop").RenderLoop,m=e("./layer/font_metrics").FontMetrics,g=e("./lib/event_emitter").EventEmitter,y=e("./css/editor-css"),b=e("./layer/decorators").Decorator,w=e("./lib/useragent"),E=e("./layer/text_util").isTextToken;i.importCssString(y,"ace_editor.css",!1);var S=function(){function e(e,t){var n=this;this.container=e||i.createElement("div"),i.addCssClass(this.container,"ace_editor"),i.HI_DPI&&i.addCssClass(this.container,"ace_hidpi"),this.setTheme(t),o.get("useStrictCSP")==null&&o.set("useStrictCSP",!1),this.$gutter=i.createElement("div"),this.$gutter.className="ace_gutter",this.container.appendChild(this.$gutter),this.$gutter.setAttribute("aria-hidden","true"),this.scroller=i.createElement("div"),this.scroller.className="ace_scroller",this.container.appendChild(this.scroller),this.content=i.createElement("div"),this.content.className="ace_content",this.scroller.appendChild(this.content),this.$gutterLayer=new u(this.$gutter),this.$gutterLayer.on("changeGutterWidth",this.onGutterResize.bind(this)),this.$markerBack=new a(this.content);var r=this.$textLayer=new f(this.content);this.canvas=r.element,this.$markerFront=new a(this.content),this.$cursorLayer=new l(this.content),this.$horizScroll=!1,this.$vScroll=!1,this.scrollBar=this.scrollBarV=new h(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.on("scroll",function(e){n.$scrollAnimation||n.session.setScrollTop(e.data-n.scrollMargin.top)}),this.scrollBarH.on("scroll",function(e){n.$scrollAnimation||n.session.setScrollLeft(e.data-n.scrollMargin.left)}),this.scrollTop=0,this.scrollLeft=0,this.cursorPos={row:0,column:0},this.$fontMetrics=new m(this.container),this.$textLayer.$setFontMetrics(this.$fontMetrics),this.$textLayer.on("changeCharacterSize",function(e){n.updateCharacterSize(),n.onResize(!0,n.gutterWidth,n.$size.width,n.$size.height),n._signal("changeCharacterSize",e)}),this.$size={width:0,height:0,scrollerHeight:0,scrollerWidth:0,$dirty:!0},this.layerConfig={width:1,padding:0,firstRow:0,firstRowScreen:0,lastRow:0,lineHeight:0,characterWidth:0,minHeight:1,maxHeight:1,offset:0,height:1,gutterOffset:1},this.scrollMargin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.margin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.$keepTextAreaAtCursor=!w.isIOS,this.$loop=new v(this.$renderChanges.bind(this),this.container.ownerDocument.defaultView),this.$loop.schedule(this.CHANGE_FULL),this.updateCharacterSize(),this.setPadding(4),this.$addResizeObserver(),o.resetOptions(this),o._signal("renderer",this)}return e.prototype.updateCharacterSize=function(){this.$textLayer.allowBoldFonts!=this.$allowBoldFonts&&(this.$allowBoldFonts=this.$textLayer.allowBoldFonts,this.setStyle("ace_nobold",!this.$allowBoldFonts)),this.layerConfig.characterWidth=this.characterWidth=this.$textLayer.getCharacterWidth(),this.layerConfig.lineHeight=this.lineHeight=this.$textLayer.getLineHeight(),this.$updatePrintMargin(),i.setStyle(this.scroller.style,"line-height",this.lineHeight+"px")},e.prototype.setSession=function(e){this.session&&this.session.doc.off("changeNewLineMode",this.onChangeNewLineMode),this.session=e,e&&this.scrollMargin.top&&e.getScrollTop()<=0&&e.setScrollTop(-this.scrollMargin.top),this.$cursorLayer.setSession(e),this.$markerBack.setSession(e),this.$markerFront.setSession(e),this.$gutterLayer.setSession(e),this.$textLayer.setSession(e);if(!e)return;this.$loop.schedule(this.CHANGE_FULL),this.session.$setFontMetrics(this.$fontMetrics),this.scrollBarH.scrollLeft=this.scrollBarV.scrollTop=null,this.onChangeNewLineMode=this.onChangeNewLineMode.bind(this),this.onChangeNewLineMode(),this.session.doc.on("changeNewLineMode",this.onChangeNewLineMode)},e.prototype.updateLines=function(e,t,n){t===undefined&&(t=Infinity),this.$changedLines?(this.$changedLines.firstRow>e&&(this.$changedLines.firstRow=e),this.$changedLines.lastRow<t&&(this.$changedLines.lastRow=t)):this.$changedLines={firstRow:e,lastRow:t};if(this.$changedLines.lastRow<this.layerConfig.firstRow){if(!n)return;this.$changedLines.lastRow=this.layerConfig.lastRow}if(this.$changedLines.firstRow>this.layerConfig.lastRow)return;this.$loop.schedule(this.CHANGE_LINES)},e.prototype.onChangeNewLineMode=function(){this.$loop.schedule(this.CHANGE_TEXT),this.$textLayer.$updateEolChar(),this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR)},e.prototype.onChangeTabSize=function(){this.$loop.schedule(this.CHANGE_TEXT|this.CHANGE_MARKER),this.$textLayer.onChangeTabSize()},e.prototype.updateText=function(){this.$loop.schedule(this.CHANGE_TEXT)},e.prototype.updateFull=function(e){e?this.$renderChanges(this.CHANGE_FULL,!0):this.$loop.schedule(this.CHANGE_FULL)},e.prototype.updateFontSize=function(){this.$textLayer.checkForSizeChanges()},e.prototype.$updateSizeAsync=function(){this.$loop.pending?this.$size.$dirty=!0:this.onResize()},e.prototype.onResize=function(e,t,n,r){if(this.resizing>2)return;this.resizing>0?this.resizing++:this.resizing=e?1:0;var i=this.container;r||(r=i.clientHeight||i.scrollHeight),!r&&this.$maxLines&&this.lineHeight>1&&(!i.style.height||i.style.height=="0px")&&(i.style.height="1px",r=i.clientHeight||i.scrollHeight),n||(n=i.clientWidth||i.scrollWidth);var s=this.$updateCachedSize(e,t,n,r);this.$resizeTimer&&this.$resizeTimer.cancel();if(!this.$size.scrollerHeight||!n&&!r)return this.resizing=0;e&&(this.$gutterLayer.$padding=null),e?this.$renderChanges(s|this.$changes,!0):this.$loop.schedule(s|this.$changes),this.resizing&&(this.resizing=0),this.scrollBarH.scrollLeft=this.scrollBarV.scrollTop=null,this.$customScrollbar&&this.$updateCustomScrollbar(!0)},e.prototype.$updateCachedSize=function(e,t,n,r){r-=this.$extraHeight||0;var s=0,o=this.$size,u={width:o.width,height:o.height,scrollerHeight:o.scrollerHeight,scrollerWidth:o.scrollerWidth};r&&(e||o.height!=r)&&(o.height=r,s|=this.CHANGE_SIZE,o.scrollerHeight=o.height,this.$horizScroll&&(o.scrollerHeight-=this.scrollBarH.getHeight()),this.scrollBarV.setHeight(o.scrollerHeight),this.scrollBarV.element.style.bottom=this.scrollBarH.getHeight()+"px",s|=this.CHANGE_SCROLL);if(n&&(e||o.width!=n)){s|=this.CHANGE_SIZE,o.width=n,t==null&&(t=this.$showGutter?this.$gutter.offsetWidth:0),this.gutterWidth=t,i.setStyle(this.scrollBarH.element.style,"left",t+"px"),i.setStyle(this.scroller.style,"left",t+this.margin.left+"px"),o.scrollerWidth=Math.max(0,n-t-this.scrollBarV.getWidth()-this.margin.h),i.setStyle(this.$gutter.style,"left",this.margin.left+"px");var a=this.scrollBarV.getWidth()+"px";i.setStyle(this.scrollBarH.element.style,"right",a),i.setStyle(this.scroller.style,"right",a),i.setStyle(this.scroller.style,"bottom",this.scrollBarH.getHeight()),this.scrollBarH.setWidth(o.scrollerWidth);if(this.session&&this.session.getUseWrapMode()&&this.adjustWrapLimit()||e)s|=this.CHANGE_FULL}return o.$dirty=!n||!r,s&&this._signal("resize",u),s},e.prototype.onGutterResize=function(e){var t=this.$showGutter?e:0;t!=this.gutterWidth&&(this.$changes|=this.$updateCachedSize(!0,t,this.$size.width,this.$size.height)),this.session.getUseWrapMode()&&this.adjustWrapLimit()?this.$loop.schedule(this.CHANGE_FULL):this.$size.$dirty?this.$loop.schedule(this.CHANGE_FULL):this.$computeLayerConfig()},e.prototype.adjustWrapLimit=function(){var e=this.$size.scrollerWidth-this.$padding*2,t=Math.floor(e/this.characterWidth);return this.session.adjustWrapLimit(t,this.$showPrintMargin&&this.$printMarginColumn)},e.prototype.setAnimatedScroll=function(e){this.setOption("animatedScroll",e)},e.prototype.getAnimatedScroll=function(){return this.$animatedScroll},e.prototype.setShowInvisibles=function(e){this.setOption("showInvisibles",e),this.session.$bidiHandler.setShowInvisibles(e)},e.prototype.getShowInvisibles=function(){return this.getOption("showInvisibles")},e.prototype.getDisplayIndentGuides=function(){return this.getOption("displayIndentGuides")},e.prototype.setDisplayIndentGuides=function(e){this.setOption("displayIndentGuides",e)},e.prototype.getHighlightIndentGuides=function(){return this.getOption("highlightIndentGuides")},e.prototype.setHighlightIndentGuides=function(e){this.setOption("highlightIndentGuides",e)},e.prototype.setShowPrintMargin=function(e){this.setOption("showPrintMargin",e)},e.prototype.getShowPrintMargin=function(){return this.getOption("showPrintMargin")},e.prototype.setPrintMarginColumn=function(e){this.setOption("printMarginColumn",e)},e.prototype.getPrintMarginColumn=function(){return this.getOption("printMarginColumn")},e.prototype.getShowGutter=function(){return this.getOption("showGutter")},e.prototype.setShowGutter=function(e){return this.setOption("showGutter",e)},e.prototype.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},e.prototype.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},e.prototype.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},e.prototype.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},e.prototype.$updatePrintMargin=function(){if(!this.$showPrintMargin&&!this.$printMarginEl)return;if(!this.$printMarginEl){var e=i.createElement("div");e.className="ace_layer ace_print-margin-layer",this.$printMarginEl=i.createElement("div"),this.$printMarginEl.className="ace_print-margin",e.appendChild(this.$printMarginEl),this.content.insertBefore(e,this.content.firstChild)}var t=this.$printMarginEl.style;t.left=Math.round(this.characterWidth*this.$printMarginColumn+this.$padding)+"px",t.visibility=this.$showPrintMargin?"visible":"hidden",this.session&&this.session.$wrap==-1&&this.adjustWrapLimit()},e.prototype.getContainerElement=function(){return this.container},e.prototype.getMouseEventTarget=function(){return this.scroller},e.prototype.getTextAreaContainer=function(){return this.container},e.prototype.$moveTextAreaToCursor=function(){if(this.$isMousePressed)return;var e=this.textarea.style,t=this.$composition;if(!this.$keepTextAreaAtCursor&&!t){i.translate(this.textarea,-100,0);return}var n=this.$cursorLayer.$pixelPos;if(!n)return;t&&t.markerRange&&(n=this.$cursorLayer.getPixelPosition(t.markerRange.start,!0));var r=this.layerConfig,s=n.top,o=n.left;s-=r.offset;var u=t&&t.useTextareaForIME||w.isMobile?this.lineHeight:1;if(s<0||s>r.height-u){i.translate(this.textarea,0,0);return}var a=1,f=this.$size.height-u;if(!t)s+=this.lineHeight;else if(t.useTextareaForIME){var l=this.textarea.value;a=this.characterWidth*this.session.$getStringScreenWidth(l)[0]}else s+=this.lineHeight+2;o-=this.scrollLeft,o>this.$size.scrollerWidth-a&&(o=this.$size.scrollerWidth-a),o+=this.gutterWidth+this.margin.left,i.setStyle(e,"height",u+"px"),i.setStyle(e,"width",a+"px"),i.translate(this.textarea,Math.min(o,this.$size.scrollerWidth-a),Math.min(s,f))},e.prototype.getFirstVisibleRow=function(){return this.layerConfig.firstRow},e.prototype.getFirstFullyVisibleRow=function(){return this.layerConfig.firstRow+(this.layerConfig.offset===0?0:1)},e.prototype.getLastFullyVisibleRow=function(){var e=this.layerConfig,t=e.lastRow,n=this.session.documentToScreenRow(t,0)*e.lineHeight;return n-this.session.getScrollTop()>e.height-e.lineHeight?t-1:t},e.prototype.getLastVisibleRow=function(){return this.layerConfig.lastRow},e.prototype.setPadding=function(e){this.$padding=e,this.$textLayer.setPadding(e),this.$cursorLayer.setPadding(e),this.$markerFront.setPadding(e),this.$markerBack.setPadding(e),this.$loop.schedule(this.CHANGE_FULL),this.$updatePrintMargin()},e.prototype.setScrollMargin=function(e,t,n,r){var i=this.scrollMargin;i.top=e|0,i.bottom=t|0,i.right=r|0,i.left=n|0,i.v=i.top+i.bottom,i.h=i.left+i.right,i.top&&this.scrollTop<=0&&this.session&&this.session.setScrollTop(-i.top),this.updateFull()},e.prototype.setMargin=function(e,t,n,r){var i=this.margin;i.top=e|0,i.bottom=t|0,i.right=r|0,i.left=n|0,i.v=i.top+i.bottom,i.h=i.left+i.right,this.$updateCachedSize(!0,this.gutterWidth,this.$size.width,this.$size.height),this.updateFull()},e.prototype.getHScrollBarAlwaysVisible=function(){return this.$hScrollBarAlwaysVisible},e.prototype.setHScrollBarAlwaysVisible=function(e){this.setOption("hScrollBarAlwaysVisible",e)},e.prototype.getVScrollBarAlwaysVisible=function(){return this.$vScrollBarAlwaysVisible},e.prototype.setVScrollBarAlwaysVisible=function(e){this.setOption("vScrollBarAlwaysVisible",e)},e.prototype.$updateScrollBarV=function(){var e=this.layerConfig.maxHeight,t=this.$size.scrollerHeight;!this.$maxLines&&this.$scrollPastEnd&&(e-=(t-this.lineHeight)*this.$scrollPastEnd,this.scrollTop>e-t&&(e=this.scrollTop+t,this.scrollBarV.scrollTop=null)),this.scrollBarV.setScrollHeight(e+this.scrollMargin.v),this.scrollBarV.setScrollTop(this.scrollTop+this.scrollMargin.top)},e.prototype.$updateScrollBarH=function(){this.scrollBarH.setScrollWidth(this.layerConfig.width+2*this.$padding+this.scrollMargin.h),this.scrollBarH.setScrollLeft(this.scrollLeft+this.scrollMargin.left)},e.prototype.freeze=function(){this.$frozen=!0},e.prototype.unfreeze=function(){this.$frozen=!1},e.prototype.$renderChanges=function(e,t){this.$changes&&(e|=this.$changes,this.$changes=0);if(!this.session||!this.container.offsetWidth||this.$frozen||!e&&!t){this.$changes|=e;return}if(this.$size.$dirty)return this.$changes|=e,this.onResize(!0);this.lineHeight||this.$textLayer.checkForSizeChanges(),this._signal("beforeRender",e),this.session&&this.session.$bidiHandler&&this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);var n=this.layerConfig;if(e&this.CHANGE_FULL||e&this.CHANGE_SIZE||e&this.CHANGE_TEXT||e&this.CHANGE_LINES||e&this.CHANGE_SCROLL||e&this.CHANGE_H_SCROLL){e|=this.$computeLayerConfig()|this.$loop.clear();if(n.firstRow!=this.layerConfig.firstRow&&n.firstRowScreen==this.layerConfig.firstRowScreen){var r=this.scrollTop+(n.firstRow-Math.max(this.layerConfig.firstRow,0))*this.lineHeight;r>0&&(this.scrollTop=r,e|=this.CHANGE_SCROLL,e|=this.$computeLayerConfig()|this.$loop.clear())}n=this.layerConfig,this.$updateScrollBarV(),e&this.CHANGE_H_SCROLL&&this.$updateScrollBarH(),i.translate(this.content,-this.scrollLeft,-n.offset);var s=n.width+2*this.$padding+"px",o=n.minHeight+"px";i.setStyle(this.content.style,"width",s),i.setStyle(this.content.style,"height",o)}e&this.CHANGE_H_SCROLL&&(i.translate(this.content,-this.scrollLeft,-n.offset),this.scroller.className=this.scrollLeft<=0?"ace_scroller ":"ace_scroller ace_scroll-left ",this.enableKeyboardAccessibility&&(this.scroller.className+=this.keyboardFocusClassName));if(e&this.CHANGE_FULL){this.$changedLines=null,this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this._signal("afterRender",e);return}if(e&this.CHANGE_SCROLL){this.$changedLines=null,e&this.CHANGE_TEXT||e&this.CHANGE_LINES?this.$textLayer.update(n):this.$textLayer.scrollLines(n),this.$showGutter&&(e&this.CHANGE_GUTTER||e&this.CHANGE_LINES?this.$gutterLayer.update(n):this.$gutterLayer.scrollLines(n)),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this._signal("afterRender",e);return}e&this.CHANGE_TEXT?(this.$changedLines=null,this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_LINES?((this.$updateLines()||e&this.CHANGE_GUTTER&&this.$showGutter)&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_TEXT||e&this.CHANGE_GUTTER?(this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_CURSOR&&(this.$highlightGutterLine&&this.$gutterLayer.updateLineHighlight(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)),e&this.CHANGE_CURSOR&&(this.$cursorLayer.update(n),this.$moveTextAreaToCursor()),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_FRONT)&&this.$markerFront.update(n),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_BACK)&&this.$markerBack.update(n),this._signal("afterRender",e)},e.prototype.$autosize=function(){var e=this.session.getScreenLength()*this.lineHeight,t=this.$maxLines*this.lineHeight,n=Math.min(t,Math.max((this.$minLines||1)*this.lineHeight,e))+this.scrollMargin.v+(this.$extraHeight||0);this.$horizScroll&&(n+=this.scrollBarH.getHeight()),this.$maxPixelHeight&&n>this.$maxPixelHeight&&(n=this.$maxPixelHeight);var r=n<=2*this.lineHeight,i=!r&&e>t;if(n!=this.desiredHeight||this.$size.height!=this.desiredHeight||i!=this.$vScroll){i!=this.$vScroll&&(this.$vScroll=i,this.scrollBarV.setVisible(i));var s=this.container.clientWidth;this.container.style.height=n+"px",this.$updateCachedSize(!0,this.$gutterWidth,s,n),this.desiredHeight=n,this._signal("autosize")}},e.prototype.$computeLayerConfig=function(){var e=this.session,t=this.$size,n=t.height<=2*this.lineHeight,r=this.session.getScreenLength(),i=r*this.lineHeight,s=this.$getLongestLine(),o=!n&&(this.$hScrollBarAlwaysVisible||t.scrollerWidth-s-2*this.$padding<0),u=this.$horizScroll!==o;u&&(this.$horizScroll=o,this.scrollBarH.setVisible(o));var a=this.$vScroll;this.$maxLines&&this.lineHeight>1&&(this.$autosize(),n=t.height<=2*this.lineHeight);var f=t.scrollerHeight+this.lineHeight,l=!this.$maxLines&&this.$scrollPastEnd?(t.scrollerHeight-this.lineHeight)*this.$scrollPastEnd:0;i+=l;var c=this.scrollMargin;this.session.setScrollTop(Math.max(-c.top,Math.min(this.scrollTop,i-t.scrollerHeight+c.bottom))),this.session.setScrollLeft(Math.max(-c.left,Math.min(this.scrollLeft,s+2*this.$padding-t.scrollerWidth+c.right)));var h=!n&&(this.$vScrollBarAlwaysVisible||t.scrollerHeight-i+l<0||this.scrollTop>c.top),p=a!==h;p&&(this.$vScroll=h,this.scrollBarV.setVisible(h));var d=this.scrollTop%this.lineHeight,v=Math.ceil(f/this.lineHeight)-1,m=Math.max(0,Math.round((this.scrollTop-d)/this.lineHeight)),g=m+v,y,b,w=this.lineHeight;m=e.screenToDocumentRow(m,0);var E=e.getFoldLine(m);E&&(m=E.start.row),y=e.documentToScreenRow(m,0),b=e.getRowLength(m)*w,g=Math.min(e.screenToDocumentRow(g,0),e.getLength()-1),f=t.scrollerHeight+e.getRowLength(g)*w+b,d=this.scrollTop-y*w;var S=0;if(this.layerConfig.width!=s||u)S=this.CHANGE_H_SCROLL;if(u||p)S|=this.$updateCachedSize(!0,this.gutterWidth,t.width,t.height),this._signal("scrollbarVisibilityChanged"),p&&(s=this.$getLongestLine());return this.layerConfig={width:s,padding:this.$padding,firstRow:m,firstRowScreen:y,lastRow:g,lineHeight:w,characterWidth:this.characterWidth,minHeight:f,maxHeight:i,offset:d,gutterOffset:w?Math.max(0,Math.ceil((d+t.height-t.scrollerHeight)/w)):0,height:this.$size.scrollerHeight},this.session.$bidiHandler&&this.session.$bidiHandler.setContentWidth(s-this.$padding),S},e.prototype.$updateLines=function(){if(!this.$changedLines)return;var e=this.$changedLines.firstRow,t=this.$changedLines.lastRow;this.$changedLines=null;var n=this.layerConfig;if(e>n.lastRow+1)return;if(t<n.firstRow)return;if(t===Infinity){this.$showGutter&&this.$gutterLayer.update(n),this.$textLayer.update(n);return}return this.$textLayer.updateLines(n,e,t),!0},e.prototype.$getLongestLine=function(){var e=this.session.getScreenWidth();return this.showInvisibles&&!this.session.$useWrapMode&&(e+=1),this.$textLayer&&e>this.$textLayer.MAX_LINE_LENGTH&&(e=this.$textLayer.MAX_LINE_LENGTH+30),Math.max(this.$size.scrollerWidth-2*this.$padding,Math.round(e*this.characterWidth))},e.prototype.updateFrontMarkers=function(){this.$markerFront.setMarkers(this.session.getMarkers(!0)),this.$loop.schedule(this.CHANGE_MARKER_FRONT)},e.prototype.updateBackMarkers=function(){this.$markerBack.setMarkers(this.session.getMarkers()),this.$loop.schedule(this.CHANGE_MARKER_BACK)},e.prototype.addGutterDecoration=function(e,t){this.$gutterLayer.addGutterDecoration(e,t)},e.prototype.removeGutterDecoration=function(e,t){this.$gutterLayer.removeGutterDecoration(e,t)},e.prototype.updateBreakpoints=function(e){this._rows=e,this.$loop.schedule(this.CHANGE_GUTTER)},e.prototype.setAnnotations=function(e){this.$gutterLayer.setAnnotations(e),this.$loop.schedule(this.CHANGE_GUTTER)},e.prototype.updateCursor=function(){this.$loop.schedule(this.CHANGE_CURSOR)},e.prototype.hideCursor=function(){this.$cursorLayer.hideCursor()},e.prototype.showCursor=function(){this.$cursorLayer.showCursor()},e.prototype.scrollSelectionIntoView=function(e,t,n){this.scrollCursorIntoView(e,n),this.scrollCursorIntoView(t,n)},e.prototype.scrollCursorIntoView=function(e,t,n){if(this.$size.scrollerHeight===0)return;var r=this.$cursorLayer.getPixelPosition(e),i=r.left,s=r.top,o=n&&n.top||0,u=n&&n.bottom||0;this.$scrollAnimation&&(this.$stopAnimation=!0);var a=this.$scrollAnimation?this.session.getScrollTop():this.scrollTop;a+o>s?(t&&a+o>s+this.lineHeight&&(s-=t*this.$size.scrollerHeight),s===0&&(s=-this.scrollMargin.top),this.session.setScrollTop(s)):a+this.$size.scrollerHeight-u<s+this.lineHeight&&(t&&a+this.$size.scrollerHeight-u<s-this.lineHeight&&(s+=t*this.$size.scrollerHeight),this.session.setScrollTop(s+this.lineHeight+u-this.$size.scrollerHeight));var f=this.scrollLeft,l=2*this.layerConfig.characterWidth;i-l<f?(i-=l,i<this.$padding+l&&(i=-this.scrollMargin.left),this.session.setScrollLeft(i)):(i+=l,f+this.$size.scrollerWidth<i+this.characterWidth?this.session.setScrollLeft(Math.round(i+this.characterWidth-this.$size.scrollerWidth)):f<=this.$padding&&i-f<this.characterWidth&&this.session.setScrollLeft(0))},e.prototype.getScrollTop=function(){return this.session.getScrollTop()},e.prototype.getScrollLeft=function(){return this.session.getScrollLeft()},e.prototype.getScrollTopRow=function(){return this.scrollTop/this.lineHeight},e.prototype.getScrollBottomRow=function(){return Math.max(0,Math.floor((this.scrollTop+this.$size.scrollerHeight)/this.lineHeight)-1)},e.prototype.scrollToRow=function(e){this.session.setScrollTop(e*this.lineHeight)},e.prototype.alignCursor=function(e,t){typeof e=="number"&&(e={row:e,column:0});var n=this.$cursorLayer.getPixelPosition(e),r=this.$size.scrollerHeight-this.lineHeight,i=n.top-r*(t||0);return this.session.setScrollTop(i),i},e.prototype.$calcSteps=function(e,t){var n=0,r=this.STEPS,i=[],s=function(e,t,n){return n*(Math.pow(e-1,3)+1)+t};for(n=0;n<r;++n)i.push(s(n/this.STEPS,e,t-e));return i},e.prototype.scrollToLine=function(e,t,n,r){var i=this.$cursorLayer.getPixelPosition({row:e,column:0}),s=i.top;t&&(s-=this.$size.scrollerHeight/2);var o=this.scrollTop;this.session.setScrollTop(s),n!==!1&&this.animateScrolling(o,r)},e.prototype.animateScrolling=function(e,t){function o(){r.$timer=clearInterval(r.$timer),r.$scrollAnimation=null,r.$stopAnimation=!1,t&&t()}var n=this.scrollTop;if(!this.$animatedScroll)return;var r=this;if(e==n)return;if(this.$scrollAnimation){var i=this.$scrollAnimation.steps;if(i.length){e=i[0];if(e==n)return}}var s=r.$calcSteps(e,n);this.$scrollAnimation={from:e,to:n,steps:s},clearInterval(this.$timer),r.session.setScrollTop(s.shift()),r.session.$scrollTop=n,this.$timer=setInterval(function(){if(r.$stopAnimation){o();return}if(!r.session)return clearInterval(r.$timer);s.length?(r.session.setScrollTop(s.shift()),r.session.$scrollTop=n):n!=null?(r.session.$scrollTop=-1,r.session.setScrollTop(n),n=null):o()},10)},e.prototype.scrollToY=function(e){this.scrollTop!==e&&(this.$loop.schedule(this.CHANGE_SCROLL),this.scrollTop=e)},e.prototype.scrollToX=function(e){this.scrollLeft!==e&&(this.scrollLeft=e),this.$loop.schedule(this.CHANGE_H_SCROLL)},e.prototype.scrollTo=function(e,t){this.session.setScrollTop(t),this.session.setScrollLeft(e)},e.prototype.scrollBy=function(e,t){t&&this.session.setScrollTop(this.session.getScrollTop()+t),e&&this.session.setScrollLeft(this.session.getScrollLeft()+e)},e.prototype.isScrollableBy=function(e,t){if(t<0&&this.session.getScrollTop()>=1-this.scrollMargin.top)return!0;if(t>0&&this.session.getScrollTop()+this.$size.scrollerHeight-this.layerConfig.maxHeight<-1+this.scrollMargin.bottom)return!0;if(e<0&&this.session.getScrollLeft()>=1-this.scrollMargin.left)return!0;if(e>0&&this.session.getScrollLeft()+this.$size.scrollerWidth-this.layerConfig.width<-1+this.scrollMargin.right)return!0},e.prototype.pixelToScreenCoordinates=function(e,t){var n;if(this.$hasCssTransforms){n={top:0,left:0};var r=this.$fontMetrics.transformCoordinates([e,t]);e=r[1]-this.gutterWidth-this.margin.left,t=r[0]}else n=this.scroller.getBoundingClientRect();var i=e+this.scrollLeft-n.left-this.$padding,s=i/this.characterWidth,o=Math.floor((t+this.scrollTop-n.top)/this.lineHeight),u=this.$blockCursor?Math.floor(s):Math.round(s);return{row:o,column:u,side:s-u>0?1:-1,offsetX:i}},e.prototype.screenToTextCoordinates=function(e,t){var n;if(this.$hasCssTransforms){n={top:0,left:0};var r=this.$fontMetrics.transformCoordinates([e,t]);e=r[1]-this.gutterWidth-this.margin.left,t=r[0]}else n=this.scroller.getBoundingClientRect();var i=e+this.scrollLeft-n.left-this.$padding,s=i/this.characterWidth,o=this.$blockCursor?Math.floor(s):Math.round(s),u=Math.floor((t+this.scrollTop-n.top)/this.lineHeight);return this.session.screenToDocumentPosition(u,Math.max(o,0),i)},e.prototype.textToScreenCoordinates=function(e,t){var n=this.scroller.getBoundingClientRect(),r=this.session.documentToScreenPosition(e,t),i=this.$padding+(this.session.$bidiHandler.isBidiRow(r.row,e)?this.session.$bidiHandler.getPosLeft(r.column):Math.round(r.column*this.characterWidth)),s=r.row*this.lineHeight;return{pageX:n.left+i-this.scrollLeft,pageY:n.top+s-this.scrollTop}},e.prototype.visualizeFocus=function(){i.addCssClass(this.container,"ace_focus")},e.prototype.visualizeBlur=function(){i.removeCssClass(this.container,"ace_focus")},e.prototype.showComposition=function(e){this.$composition=e,e.cssText||(e.cssText=this.textarea.style.cssText),e.useTextareaForIME==undefined&&(e.useTextareaForIME=this.$useTextareaForIME),this.$useTextareaForIME?(i.addCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText="",this.$moveTextAreaToCursor(),this.$cursorLayer.element.style.display="none"):e.markerId=this.session.addMarker(e.markerRange,"ace_composition_marker","text")},e.prototype.setCompositionText=function(e){var t=this.session.selection.cursor;this.addToken(e,"composition_placeholder",t.row,t.column),this.$moveTextAreaToCursor()},e.prototype.hideComposition=function(){if(!this.$composition)return;this.$composition.markerId&&this.session.removeMarker(this.$composition.markerId),i.removeCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText=this.$composition.cssText;var e=this.session.selection.cursor;this.removeExtraToken(e.row,e.column),this.$composition=null,this.$cursorLayer.element.style.display=""},e.prototype.setGhostText=function(e,t){var n=this.session.selection.cursor,r=t||{row:n.row,column:n.column};this.removeGhostText();var s=this.$calculateWrappedTextChunks(e,r);this.addToken(s[0].text,"ghost_text",r.row,r.column),this.$ghostText={text:e,position:{row:r.row,column:r.column}};var o=i.createElement("div");if(s.length>1){var u=this.hideTokensAfterPosition(r.row,r.column),a;s.slice(1).forEach(function(e){var t=i.createElement("div"),n=i.createElement("span");n.className="ace_ghost_text",e.wrapped&&(t.className="ghost_text_line_wrapped"),e.text.length===0&&(e.text=" "),n.appendChild(i.createTextNode(e.text)),t.appendChild(n),o.appendChild(t),a=t}),u.forEach(function(e){var t=i.createElement("span");E(e.type)||(t.className="ace_"+e.type.replace(/\./g," ace_")),t.appendChild(i.createTextNode(e.value)),a.appendChild(t)}),this.$ghostTextWidget={el:o,row:r.row,column:r.column,className:"ace_ghost_text_container"},this.session.widgetManager.addLineWidget(this.$ghostTextWidget);var f=this.$cursorLayer.getPixelPosition(r,!0),l=this.container,c=l.getBoundingClientRect().height,h=s.length*this.lineHeight,p=h<c-f.top;if(p)return;h<c?this.scrollBy(0,(s.length-1)*this.lineHeight):this.scrollToRow(r.row)}},e.prototype.$calculateWrappedTextChunks=function(e,t){var n=this.$size.scrollerWidth-this.$padding*2,r=Math.floor(n/this.characterWidth)-2;r=r<=0?60:r;var i=e.split(/\r?\n/),s=[];for(var o=0;o<i.length;o++){var u=this.session.$getDisplayTokens(i[o],t.column),a=this.session.$computeWrapSplits(u,r,this.session.$tabSize);if(a.length>0){var f=0;a.push(i[o].length);for(var l=0;l<a.length;l++){var c=i[o].slice(f,a[l]);s.push({text:c,wrapped:!0}),f=a[l]}}else s.push({text:i[o],wrapped:!1})}return s},e.prototype.removeGhostText=function(){if(!this.$ghostText)return;var e=this.$ghostText.position;this.removeExtraToken(e.row,e.column),this.$ghostTextWidget&&(this.session.widgetManager.removeLineWidget(this.$ghostTextWidget),this.$ghostTextWidget=null),this.$ghostText=null},e.prototype.addToken=function(e,t,n,r){var i=this.session;i.bgTokenizer.lines[n]=null;var s={type:t,value:e},o=i.getTokens(n);if(r==null||!o.length)o.push(s);else{var u=0;for(var a=0;a<o.length;a++){var f=o[a];u+=f.value.length;if(r<=u){var l=f.value.length-(u-r),c=f.value.slice(0,l),h=f.value.slice(l);o.splice(a,1,{type:f.type,value:c},s,{type:f.type,value:h});break}}}this.updateLines(n,n)},e.prototype.hideTokensAfterPosition=function(e,t){var n=this.session.getTokens(e),r=0,i=!1,s=[];for(var o=0;o<n.length;o++){var u=n[o];r+=u.value.length;if(u.type==="ghost_text")continue;if(i){s.push({type:u.type,value:u.value}),u.type="hidden_token";continue}r===t&&(i=!0)}return this.updateLines(e,e),s},e.prototype.removeExtraToken=function(e,t){this.session.bgTokenizer.lines[e]=null,this.updateLines(e,e)},e.prototype.setTheme=function(e,t){function s(r){if(n.$themeId!=e)return t&&t();if(!r||!r.cssClass)throw new Error("couldn't load module "+e+" or it didn't call define");r.$id&&(n.$themeId=r.$id),i.importCssString(r.cssText,r.cssClass,n.container),n.theme&&i.removeCssClass(n.container,n.theme.cssClass);var s="padding"in r?r.padding:"padding"in(n.theme||{})?4:n.$padding;n.$padding&&s!=n.$padding&&n.setPadding(s),n.$theme=r.cssClass,n.theme=r,i.addCssClass(n.container,r.cssClass),i.setCssClass(n.container,"ace_dark",r.isDark),n.$size&&(n.$size.width=0,n.$updateSizeAsync()),n._dispatchEvent("themeLoaded",{theme:r}),t&&t(),w.isSafari&&n.scroller&&(n.scroller.style.background="red",n.scroller.style.background="")}var n=this;this.$themeId=e,n._dispatchEvent("themeChange",{theme:e});if(!e||typeof e=="string"){var r=e||this.$options.theme.initialValue;o.loadModule(["theme",r],s)}else s(e)},e.prototype.getTheme=function(){return this.$themeId},e.prototype.setStyle=function(e,t){i.setCssClass(this.container,e,t!==!1)},e.prototype.unsetStyle=function(e){i.removeCssClass(this.container,e)},e.prototype.setCursorStyle=function(e){i.setStyle(this.scroller.style,"cursor",e)},e.prototype.setMouseCursor=function(e){i.setStyle(this.scroller.style,"cursor",e)},e.prototype.attachToShadowRoot=function(){i.importCssString(y,"ace_editor.css",this.container)},e.prototype.destroy=function(){this.freeze(),this.$fontMetrics.destroy(),this.$cursorLayer.destroy(),this.removeAllListeners(),this.container.textContent="",this.setOption("useResizeObserver",!1)},e.prototype.$updateCustomScrollbar=function(e){var t=this;this.$horizScroll=this.$vScroll=null,this.scrollBarV.element.remove(),this.scrollBarH.element.remove(),this.$scrollDecorator&&delete this.$scrollDecorator,e===!0?(this.scrollBarV=new d(this.container,this),this.scrollBarH=new p(this.container,this),this.scrollBarV.setHeight(this.$size.scrollerHeight),this.scrollBarH.setWidth(this.$size.scrollerWidth),this.scrollBarV.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollTop(e.data-t.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollLeft(e.data-t.scrollMargin.left)}),this.$scrollDecorator=new b(this.scrollBarV,this),this.$scrollDecorator.$updateDecorators()):(this.scrollBarV=new h(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollTop(e.data-t.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollLeft(e.data-t.scrollMargin.left)}))},e.prototype.$addResizeObserver=function(){if(!window.ResizeObserver||this.$resizeObserver)return;var e=this;this.$resizeTimer=s.delayedCall(function(){e.destroyed||e.onResize()},50),this.$resizeObserver=new window.ResizeObserver(function(t){var n=t[0].contentRect.width,r=t[0].contentRect.height;Math.abs(e.$size.width-n)>1||Math.abs(e.$size.height-r)>1?e.$resizeTimer.delay():e.$resizeTimer.cancel()}),this.$resizeObserver.observe(this.container)},e}();S.prototype.CHANGE_CURSOR=1,S.prototype.CHANGE_MARKER=2,S.prototype.CHANGE_GUTTER=4,S.prototype.CHANGE_SCROLL=8,S.prototype.CHANGE_LINES=16,S.prototype.CHANGE_TEXT=32,S.prototype.CHANGE_SIZE=64,S.prototype.CHANGE_MARKER_BACK=128,S.prototype.CHANGE_MARKER_FRONT=256,S.prototype.CHANGE_FULL=512,S.prototype.CHANGE_H_SCROLL=1024,S.prototype.$changes=0,S.prototype.$padding=null,S.prototype.$frozen=!1,S.prototype.STEPS=8,r.implement(S.prototype,g),o.defineOptions(S.prototype,"renderer",{useResizeObserver:{set:function(e){!e&&this.$resizeObserver?(this.$resizeObserver.disconnect(),this.$resizeTimer.cancel(),this.$resizeTimer=this.$resizeObserver=null):e&&!this.$resizeObserver&&this.$addResizeObserver()}},animatedScroll:{initialValue:!1},showInvisibles:{set:function(e){this.$textLayer.setShowInvisibles(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!1},showPrintMargin:{set:function(){this.$updatePrintMargin()},initialValue:!0},printMarginColumn:{set:function(){this.$updatePrintMargin()},initialValue:80},printMargin:{set:function(e){typeof e=="number"&&(this.$printMarginColumn=e),this.$showPrintMargin=!!e,this.$updatePrintMargin()},get:function(){return this.$showPrintMargin&&this.$printMarginColumn}},showGutter:{set:function(e){this.$gutter.style.display=e?"block":"none",this.$loop.schedule(this.CHANGE_FULL),this.onGutterResize()},initialValue:!0},useSvgGutterIcons:{set:function(e){this.$gutterLayer.$useSvgGutterIcons=e},initialValue:!1},showFoldedAnnotations:{set:function(e){this.$gutterLayer.$showFoldedAnnotations=e},initialValue:!1},fadeFoldWidgets:{set:function(e){i.setCssClass(this.$gutter,"ace_fade-fold-widgets",e)},initialValue:!1},showFoldWidgets:{set:function(e){this.$gutterLayer.setShowFoldWidgets(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},displayIndentGuides:{set:function(e){this.$textLayer.setDisplayIndentGuides(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!0},highlightIndentGuides:{set:function(e){this.$textLayer.setHighlightIndentGuides(e)==1?this.$textLayer.$highlightIndentGuide():this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells)},initialValue:!0},highlightGutterLine:{set:function(e){this.$gutterLayer.setHighlightGutterLine(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},hScrollBarAlwaysVisible:{set:function(e){(!this.$hScrollBarAlwaysVisible||!this.$horizScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},vScrollBarAlwaysVisible:{set:function(e){(!this.$vScrollBarAlwaysVisible||!this.$vScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},fontSize:{set:function(e){typeof e=="number"&&(e+="px"),this.container.style.fontSize=e,this.updateFontSize()},initialValue:12},fontFamily:{set:function(e){this.container.style.fontFamily=e,this.updateFontSize()}},maxLines:{set:function(e){this.updateFull()}},minLines:{set:function(e){this.$minLines<562949953421311||(this.$minLines=0),this.updateFull()}},maxPixelHeight:{set:function(e){this.updateFull()},initialValue:0},scrollPastEnd:{set:function(e){e=+e||0;if(this.$scrollPastEnd==e)return;this.$scrollPastEnd=e,this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:0,handlesSet:!0},fixedWidthGutter:{set:function(e){this.$gutterLayer.$fixedWidth=!!e,this.$loop.schedule(this.CHANGE_GUTTER)}},customScrollbar:{set:function(e){this.$updateCustomScrollbar(e)},initialValue:!1},theme:{set:function(e){this.setTheme(e)},get:function(){return this.$themeId||this.theme},initialValue:"./theme/textmate",handlesSet:!0},hasCssTransforms:{},useTextareaForIME:{initialValue:!w.isMobile&&!w.isIE}}),t.VirtualRenderer=S}),define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"],function(e,t,n){"use strict";function u(e){var t="importScripts('"+i.qualifyURL(e)+"');";try{return new Blob([t],{type:"application/javascript"})}catch(n){var r=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder,s=new r;return s.append(t),s.getBlob("application/javascript")}}function a(e){if(typeof Worker=="undefined")return{postMessage:function(){},terminate:function(){}};if(o.get("loadWorkerFromBlob")){var t=u(e),n=window.URL||window.webkitURL,r=n.createObjectURL(t);return new Worker(r)}return new Worker(e)}var r=e("../lib/oop"),i=e("../lib/net"),s=e("../lib/event_emitter").EventEmitter,o=e("../config"),f=function(e){e.postMessage||(e=this.$createWorkerFromOldConfig.apply(this,arguments)),this.$worker=e,this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.onMessage=this.onMessage.bind(this),this.callbackId=1,this.callbacks={},this.$worker.onmessage=this.onMessage};(function(){r.implement(this,s),this.$createWorkerFromOldConfig=function(t,n,r,i,s){e.nameToUrl&&!e.toUrl&&(e.toUrl=e.nameToUrl);if(o.get("packaged")||!e.toUrl)i=i||o.moduleUrl(n,"worker");else{var u=this.$normalizePath;i=i||u(e.toUrl("ace/worker/worker.js",null,"_"));var f={};t.forEach(function(t){f[t]=u(e.toUrl(t,null,"_").replace(/(\.js)?(\?.*)?$/,""))})}return this.$worker=a(i),s&&this.send("importScripts",s),this.$worker.postMessage({init:!0,tlns:f,module:n,classname:r}),this.$worker},this.onMessage=function(e){var t=e.data;switch(t.type){case"event":this._signal(t.name,{data:t.data});break;case"call":var n=this.callbacks[t.id];n&&(n(t.data),delete this.callbacks[t.id]);break;case"error":this.reportError(t.data);break;case"log":window.console&&console.log&&console.log.apply(console,t.data)}},this.reportError=function(e){window.console&&console.error&&console.error(e)},this.$normalizePath=function(e){return i.qualifyURL(e)},this.terminate=function(){this._signal("terminate",{}),this.deltaQueue=null,this.$worker.terminate(),this.$worker.onerror=function(e){e.preventDefault()},this.$worker=null,this.$doc&&this.$doc.off("change",this.changeListener),this.$doc=null},this.send=function(e,t){this.$worker.postMessage({command:e,args:t})},this.call=function(e,t,n){if(n){var r=this.callbackId++;this.callbacks[r]=n,t.push(r)}this.send(e,t)},this.emit=function(e,t){try{t.data&&t.data.err&&(t.data.err={message:t.data.err.message,stack:t.data.err.stack,code:t.data.err.code}),this.$worker&&this.$worker.postMessage({event:e,data:{data:t.data}})}catch(n){console.error(n.stack)}},this.attachToDocument=function(e){this.$doc&&this.terminate(),this.$doc=e,this.call("setValue",[e.getValue()]),e.on("change",this.changeListener,!0)},this.changeListener=function(e){this.deltaQueue||(this.deltaQueue=[],setTimeout(this.$sendDeltaQueue,0)),e.action=="insert"?this.deltaQueue.push(e.start,e.lines):this.deltaQueue.push(e.start,e.end)},this.$sendDeltaQueue=function(){var e=this.deltaQueue;if(!e)return;this.deltaQueue=null,e.length>50&&e.length>this.$doc.getLength()>>1?this.call("setValue",[this.$doc.getValue()]):this.emit("change",{data:e})}}).call(f.prototype);var l=function(e,t,n){var r=null,i=!1,u=Object.create(s),a=[],l=new f({messageBuffer:a,terminate:function(){},postMessage:function(e){a.push(e);if(!r)return;i?setTimeout(c):c()}});l.setEmitSync=function(e){i=e};var c=function(){var e=a.shift();e.command?r[e.command].apply(r,e.args):e.event&&u._signal(e.event,e.data)};return u.postMessage=function(e){l.onMessage({data:e})},u.callback=function(e,t){this.postMessage({type:"call",id:t,data:e})},u.emit=function(e,t){this.postMessage({type:"event",name:e,data:t})},o.loadModule(["worker",t],function(e){r=new e[n](u);while(a.length)c()}),l};t.UIWorkerClient=l,t.WorkerClient=f,t.createWorker=a}),define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"],function(e,t,n){"use strict";var r=e("./range").Range,i=e("./lib/event_emitter").EventEmitter,s=e("./lib/oop"),o=function(){function e(e,t,n,r,i,s){var o=this;this.length=t,this.session=e,this.doc=e.getDocument(),this.mainClass=i,this.othersClass=s,this.$onUpdate=this.onUpdate.bind(this),this.doc.on("change",this.$onUpdate,!0),this.$others=r,this.$onCursorChange=function(){setTimeout(function(){o.onCursorChange()})},this.$pos=n;var u=e.getUndoManager().$undoStack||e.getUndoManager().$undostack||{length:-1};this.$undoStackDepth=u.length,this.setup(),e.selection.on("changeCursor",this.$onCursorChange)}return e.prototype.setup=function(){var e=this,t=this.doc,n=this.session;this.selectionBefore=n.selection.toJSON(),n.selection.inMultiSelectMode&&n.selection.toSingleRange(),this.pos=t.createAnchor(this.$pos.row,this.$pos.column);var i=this.pos;i.$insertRight=!0,i.detach(),i.markerId=n.addMarker(new r(i.row,i.column,i.row,i.column+this.length),this.mainClass,null,!1),this.others=[],this.$others.forEach(function(n){var r=t.createAnchor(n.row,n.column);r.$insertRight=!0,r.detach(),e.others.push(r)}),n.setUndoSelect(!1)},e.prototype.showOtherMarkers=function(){if(this.othersActive)return;var e=this.session,t=this;this.othersActive=!0,this.others.forEach(function(n){n.markerId=e.addMarker(new r(n.row,n.column,n.row,n.column+t.length),t.othersClass,null,!1)})},e.prototype.hideOtherMarkers=function(){if(!this.othersActive)return;this.othersActive=!1;for(var e=0;e<this.others.length;e++)this.session.removeMarker(this.others[e].markerId)},e.prototype.onUpdate=function(e){if(this.$updating)return this.updateAnchors(e);var t=e;if(t.start.row!==t.end.row)return;if(t.start.row!==this.pos.row)return;this.$updating=!0;var n=e.action==="insert"?t.end.column-t.start.column:t.start.column-t.end.column,i=t.start.column>=this.pos.column&&t.start.column<=this.pos.column+this.length+1,s=t.start.column-this.pos.column;this.updateAnchors(e),i&&(this.length+=n);if(i&&!this.session.$fromUndo)if(e.action==="insert")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.insertMergedLines(a,e.lines)}else if(e.action==="remove")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.remove(new r(a.row,a.column,a.row,a.column-n))}this.$updating=!1,this.updateMarkers()},e.prototype.updateAnchors=function(e){this.pos.onChange(e);for(var t=this.others.length;t--;)this.others[t].onChange(e);this.updateMarkers()},e.prototype.updateMarkers=function(){if(this.$updating)return;var e=this,t=this.session,n=function(n,i){t.removeMarker(n.markerId),n.markerId=t.addMarker(new r(n.row,n.column,n.row,n.column+e.length),i,null,!1)};n(this.pos,this.mainClass);for(var i=this.others.length;i--;)n(this.others[i],this.othersClass)},e.prototype.onCursorChange=function(e){if(this.$updating||!this.session)return;var t=this.session.selection.getCursor();t.row===this.pos.row&&t.column>=this.pos.column&&t.column<=this.pos.column+this.length?(this.showOtherMarkers(),this._emit("cursorEnter",e)):(this.hideOtherMarkers(),this._emit("cursorLeave",e))},e.prototype.detach=function(){this.session.removeMarker(this.pos&&this.pos.markerId),this.hideOtherMarkers(),this.doc.off("change",this.$onUpdate),this.session.selection.off("changeCursor",this.$onCursorChange),this.session.setUndoSelect(!0),this.session=null},e.prototype.cancel=function(){if(this.$undoStackDepth===-1)return;var e=this.session.getUndoManager(),t=(e.$undoStack||e.$undostack).length-this.$undoStackDepth;for(var n=0;n<t;n++)e.undo(this.session,!0);this.selectionBefore&&this.session.selection.fromJSON(this.selectionBefore)},e}();s.implement(o.prototype,i),t.PlaceHolder=o}),define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){function s(e,t){return e.row==t.row&&e.column==t.column}function o(e){var t=e.domEvent,n=t.altKey,o=t.shiftKey,u=t.ctrlKey,a=e.getAccelKey(),f=e.getButton();u&&i.isMac&&(f=t.button);if(e.editor.inMultiSelectMode&&f==2){e.editor.textInput.onContextMenu(e.domEvent);return}if(!u&&!n&&!a){f===0&&e.editor.inMultiSelectMode&&e.editor.exitMultiSelectMode();return}if(f!==0)return;var l=e.editor,c=l.selection,h=l.inMultiSelectMode,p=e.getDocumentPosition(),d=c.getCursor(),v=e.inSelection()||c.isEmpty()&&s(p,d),m=e.x,g=e.y,y=function(e){m=e.clientX,g=e.clientY},b=l.session,w=l.renderer.pixelToScreenCoordinates(m,g),E=w,S;if(l.$mouseHandler.$enableJumpToDef)u&&n||a&&n?S=o?"block":"add":n&&l.$blockSelectEnabled&&(S="block");else if(a&&!n){S="add";if(!h&&o)return}else n&&l.$blockSelectEnabled&&(S="block");S&&i.isMac&&t.ctrlKey&&l.$mouseHandler.cancelContextMenu();if(S=="add"){if(!h&&v)return;if(!h){var x=c.toOrientedRange();l.addSelectionMarker(x)}var T=c.rangeList.rangeAtPoint(p);l.inVirtualSelectionMode=!0,o&&(T=null,x=c.ranges[0]||x,l.removeSelectionMarker(x)),l.once("mouseup",function(){var e=c.toOrientedRange();T&&e.isEmpty()&&s(T.cursor,e.cursor)?c.substractPoint(e.cursor):(o?c.substractPoint(x.cursor):x&&(l.removeSelectionMarker(x),c.addRange(x)),c.addRange(e)),l.inVirtualSelectionMode=!1})}else if(S=="block"){e.stop(),l.inVirtualSelectionMode=!0;var N,C=[],k=function(){var e=l.renderer.pixelToScreenCoordinates(m,g),t=b.screenToDocumentPosition(e.row,e.column,e.offsetX);if(s(E,e)&&s(t,c.lead))return;E=e,l.selection.moveToPosition(t),l.renderer.scrollCursorIntoView(),l.removeSelectionMarkers(C),C=c.rectangularRangeBlock(E,w),l.$mouseHandler.$clickSelection&&C.length==1&&C[0].isEmpty()&&(C[0]=l.$mouseHandler.$clickSelection.clone()),C.forEach(l.addSelectionMarker,l),l.updateSelectionMarkers()};h&&!a?c.toSingleRange():!h&&a&&(N=c.toOrientedRange(),l.addSelectionMarker(N)),o?w=b.documentToScreenPosition(c.lead):c.moveToPosition(p),E={row:-1,column:-1};var L=function(e){k(),clearInterval(O),l.removeSelectionMarkers(C),C.length||(C=[c.toOrientedRange()]),N&&(l.removeSelectionMarker(N),c.toSingleRange(N));for(var t=0;t<C.length;t++)c.addRange(C[t]);l.inVirtualSelectionMode=!1,l.$mouseHandler.$clickSelection=null},A=k;r.capture(l.container,y,L);var O=setInterval(function(){A()},20);return e.preventDefault()}}var r=e("../lib/event"),i=e("../lib/useragent");t.onMouseDown=o}),define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"],function(e,t,n){t.defaultCommands=[{name:"addCursorAbove",description:"Add cursor above",exec:function(e){e.selectMoreLines(-1)},bindKey:{win:"Ctrl-Alt-Up",mac:"Ctrl-Alt-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelow",description:"Add cursor below",exec:function(e){e.selectMoreLines(1)},bindKey:{win:"Ctrl-Alt-Down",mac:"Ctrl-Alt-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorAboveSkipCurrent",description:"Add cursor above (skip current)",exec:function(e){e.selectMoreLines(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Up",mac:"Ctrl-Alt-Shift-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelowSkipCurrent",description:"Add cursor below (skip current)",exec:function(e){e.selectMoreLines(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Down",mac:"Ctrl-Alt-Shift-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreBefore",description:"Select more before",exec:function(e){e.selectMore(-1)},bindKey:{win:"Ctrl-Alt-Left",mac:"Ctrl-Alt-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreAfter",description:"Select more after",exec:function(e){e.selectMore(1)},bindKey:{win:"Ctrl-Alt-Right",mac:"Ctrl-Alt-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextBefore",description:"Select next before",exec:function(e){e.selectMore(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Left",mac:"Ctrl-Alt-Shift-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextAfter",description:"Select next after",exec:function(e){e.selectMore(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Right",mac:"Ctrl-Alt-Shift-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"toggleSplitSelectionIntoLines",description:"Split selection into lines",exec:function(e){e.multiSelect.rangeCount>1?e.multiSelect.joinSelections():e.multiSelect.splitIntoLines()},bindKey:{win:"Ctrl-Alt-L",mac:"Ctrl-Alt-L"},readOnly:!0},{name:"splitSelectionIntoLines",description:"Split into lines",exec:function(e){e.multiSelect.splitIntoLines()},readOnly:!0},{name:"alignCursors",description:"Align cursors",exec:function(e){e.alignCursors()},bindKey:{win:"Ctrl-Alt-A",mac:"Ctrl-Alt-A"},scrollIntoView:"cursor"},{name:"findAll",description:"Find all",exec:function(e){e.findAll()},bindKey:{win:"Ctrl-Alt-K",mac:"Ctrl-Alt-G"},scrollIntoView:"cursor",readOnly:!0}],t.multiSelectCommands=[{name:"singleSelection",description:"Single selection",bindKey:"esc",exec:function(e){e.exitMultiSelectMode()},scrollIntoView:"cursor",readOnly:!0,isAvailable:function(e){return e&&e.inMultiSelectMode}}];var r=e("../keyboard/hash_handler").HashHandler;t.keyboardHandler=new r(t.multiSelectCommands)}),define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"],function(e,t,n){function h(e,t,n){return c.$options.wrap=!0,c.$options.needle=t,c.$options.backwards=n==-1,c.find(e)}function v(e,t){return e.row==t.row&&e.column==t.column}function m(e){if(e.$multiselectOnSessionChange)return;e.$onAddRange=e.$onAddRange.bind(e),e.$onRemoveRange=e.$onRemoveRange.bind(e),e.$onMultiSelect=e.$onMultiSelect.bind(e),e.$onSingleSelect=e.$onSingleSelect.bind(e),e.$multiselectOnSessionChange=t.onSessionChange.bind(e),e.$checkMultiselectChange=e.$checkMultiselectChange.bind(e),e.$multiselectOnSessionChange(e),e.on("changeSession",e.$multiselectOnSessionChange),e.on("mousedown",o),e.commands.addCommands(f.defaultCommands),g(e)}function g(e){function r(t){n&&(e.renderer.setMouseCursor(""),n=!1)}if(!e.textInput)return;var t=e.textInput.getElement(),n=!1;u.addListener(t,"keydown",function(t){var i=t.keyCode==18&&!(t.ctrlKey||t.shiftKey||t.metaKey);e.$blockSelectEnabled&&i?n||(e.renderer.setMouseCursor("crosshair"),n=!0):n&&r()},e),u.addListener(t,"keyup",r,e),u.addListener(t,"blur",r,e)}var r=e("./range_list").RangeList,i=e("./range").Range,s=e("./selection").Selection,o=e("./mouse/multi_select_handler").onMouseDown,u=e("./lib/event"),a=e("./lib/lang"),f=e("./commands/multi_select_commands");t.commands=f.defaultCommands.concat(f.multiSelectCommands);var l=e("./search").Search,c=new l,p=e("./edit_session").EditSession;(function(){this.getSelectionMarkers=function(){return this.$selectionMarkers}}).call(p.prototype),function(){this.ranges=null,this.rangeList=null,this.addRange=function(e,t){if(!e)return;if(!this.inMultiSelectMode&&this.rangeCount===0){var n=this.toOrientedRange();this.rangeList.add(n),this.rangeList.add(e);if(this.rangeList.ranges.length!=2)return this.rangeList.removeAll(),t||this.fromOrientedRange(e);this.rangeList.removeAll(),this.rangeList.add(n),this.$onAddRange(n)}e.cursor||(e.cursor=e.end);var r=this.rangeList.add(e);return this.$onAddRange(e),r.length&&this.$onRemoveRange(r),this.rangeCount>1&&!this.inMultiSelectMode&&(this._signal("multiSelect"),this.inMultiSelectMode=!0,this.session.$undoSelect=!1,this.rangeList.attach(this.session)),t||this.fromOrientedRange(e)},this.toSingleRange=function(e){e=e||this.ranges[0];var t=this.rangeList.removeAll();t.length&&this.$onRemoveRange(t),e&&this.fromOrientedRange(e)},this.substractPoint=function(e){var t=this.rangeList.substractPoint(e);if(t)return this.$onRemoveRange(t),t[0]},this.mergeOverlappingRanges=function(){var e=this.rangeList.merge();e.length&&this.$onRemoveRange(e)},this.$onAddRange=function(e){this.rangeCount=this.rangeList.ranges.length,this.ranges.unshift(e),this._signal("addRange",{range:e})},this.$onRemoveRange=function(e){this.rangeCount=this.rangeList.ranges.length;if(this.rangeCount==1&&this.inMultiSelectMode){var t=this.rangeList.ranges.pop();e.push(t),this.rangeCount=0}for(var n=e.length;n--;){var r=this.ranges.indexOf(e[n]);this.ranges.splice(r,1)}this._signal("removeRange",{ranges:e}),this.rangeCount===0&&this.inMultiSelectMode&&(this.inMultiSelectMode=!1,this._signal("singleSelect"),this.session.$undoSelect=!0,this.rangeList.detach(this.session)),t=t||this.ranges[0],t&&!t.isEqual(this.getRange())&&this.fromOrientedRange(t)},this.$initRangeList=function(){if(this.rangeList)return;this.rangeList=new r,this.ranges=[],this.rangeCount=0},this.getAllRanges=function(){return this.rangeCount?this.rangeList.ranges.concat():[this.getRange()]},this.splitIntoLines=function(){var e=this.ranges.length?this.ranges:[this.getRange()],t=[];for(var n=0;n<e.length;n++){var r=e[n],s=r.start.row,o=r.end.row;if(s===o)t.push(r.clone());else{t.push(new i(s,r.start.column,s,this.session.getLine(s).length));while(++s<o)t.push(this.getLineRange(s,!0));t.push(new i(o,0,o,r.end.column))}n==0&&!this.isBackwards()&&(t=t.reverse())}this.toSingleRange();for(var n=t.length;n--;)this.addRange(t[n])},this.joinSelections=function(){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)},this.toggleBlockSelection=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)}else{var r=this.session.documentToScreenPosition(this.cursor),s=this.session.documentToScreenPosition(this.anchor),o=this.rectangularRangeBlock(r,s);o.forEach(this.addRange,this)}},this.rectangularRangeBlock=function(e,t,n){var r=[],s=e.column<t.column;if(s)var o=e.column,u=t.column,a=e.offsetX,f=t.offsetX;else var o=t.column,u=e.column,a=t.offsetX,f=e.offsetX;var l=e.row<t.row;if(l)var c=e.row,h=t.row;else var c=t.row,h=e.row;o<0&&(o=0),c<0&&(c=0),c==h&&(n=!0);var p;for(var d=c;d<=h;d++){var m=i.fromPoints(this.session.screenToDocumentPosition(d,o,a),this.session.screenToDocumentPosition(d,u,f));if(m.isEmpty()){if(p&&v(m.end,p))break;p=m.end}m.cursor=s?m.start:m.end,r.push(m)}l&&r.reverse();if(!n){var g=r.length-1;while(r[g].isEmpty()&&g>0)g--;if(g>0){var y=0;while(r[y].isEmpty())y++}for(var b=g;b>=y;b--)r[b].isEmpty()&&r.splice(b,1)}return r}}.call(s.prototype);var d=e("./editor").Editor;(function(){this.updateSelectionMarkers=function(){this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.addSelectionMarker=function(e){e.cursor||(e.cursor=e.end);var t=this.getSelectionStyle();return e.marker=this.session.addMarker(e,"ace_selection",t),this.session.$selectionMarkers.push(e),this.session.selectionMarkerCount=this.session.$selectionMarkers.length,e},this.removeSelectionMarker=function(e){if(!e.marker)return;this.session.removeMarker(e.marker);var t=this.session.$selectionMarkers.indexOf(e);t!=-1&&this.session.$selectionMarkers.splice(t,1),this.session.selectionMarkerCount=this.session.$selectionMarkers.length},this.removeSelectionMarkers=function(e){var t=this.session.$selectionMarkers;for(var n=e.length;n--;){var r=e[n];if(!r.marker)continue;this.session.removeMarker(r.marker);var i=t.indexOf(r);i!=-1&&t.splice(i,1)}this.session.selectionMarkerCount=t.length},this.$onAddRange=function(e){this.addSelectionMarker(e.range),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onRemoveRange=function(e){this.removeSelectionMarkers(e.ranges),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onMultiSelect=function(e){if(this.inMultiSelectMode)return;this.inMultiSelectMode=!0,this.setStyle("ace_multiselect"),this.keyBinding.addKeyboardHandler(f.keyboardHandler),this.commands.setDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onSingleSelect=function(e){if(this.session.multiSelect.inVirtualMode)return;this.inMultiSelectMode=!1,this.unsetStyle("ace_multiselect"),this.keyBinding.removeKeyboardHandler(f.keyboardHandler),this.commands.removeDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers(),this._emit("changeSelection")},this.$onMultiSelectExec=function(e){var t=e.command,n=e.editor;if(!n.multiSelect)return;if(!t.multiSelectAction){var r=t.exec(n,e.args||{});n.multiSelect.addRange(n.multiSelect.toOrientedRange()),n.multiSelect.mergeOverlappingRanges()}else t.multiSelectAction=="forEach"?r=n.forEachSelection(t,e.args):t.multiSelectAction=="forEachLine"?r=n.forEachSelection(t,e.args,!0):t.multiSelectAction=="single"?(n.exitMultiSelectMode(),r=t.exec(n,e.args||{})):r=t.multiSelectAction(n,e.args||{});return r},this.forEachSelection=function(e,t,n){if(this.inVirtualSelectionMode)return;var r=n&&n.keepOrder,i=n==1||n&&n.$byLines,o=this.session,u=this.selection,a=u.rangeList,f=(r?u:a).ranges,l;if(!f.length)return e.exec?e.exec(this,t||{}):e(this,t||{});var c=u._eventRegistry;u._eventRegistry={};var h=new s(o);this.inVirtualSelectionMode=!0;for(var p=f.length;p--;){if(i)while(p>0&&f[p].start.row==f[p-1].end.row)p--;h.fromOrientedRange(f[p]),h.index=p,this.selection=o.selection=h;var d=e.exec?e.exec(this,t||{}):e(this,t||{});!l&&d!==undefined&&(l=d),h.toOrientedRange(f[p])}h.detach(),this.selection=o.selection=u,this.inVirtualSelectionMode=!1,u._eventRegistry=c,u.mergeOverlappingRanges(),u.ranges[0]&&u.fromOrientedRange(u.ranges[0]);var v=this.renderer.$scrollAnimation;return this.onCursorChange(),this.onSelectionChange(),v&&v.from==v.to&&this.renderer.animateScrolling(v.from),l},this.exitMultiSelectMode=function(){if(!this.inMultiSelectMode||this.inVirtualSelectionMode)return;this.multiSelect.toSingleRange()},this.getSelectedText=function(){var e="";if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var t=this.multiSelect.rangeList.ranges,n=[];for(var r=0;r<t.length;r++)n.push(this.session.getTextRange(t[r]));var i=this.session.getDocument().getNewLineCharacter();e=n.join(i),e.length==(n.length-1)*i.length&&(e="")}else this.selection.isEmpty()||(e=this.session.getTextRange(this.getSelectionRange()));return e},this.$checkMultiselectChange=function(e,t){if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var n=this.multiSelect.ranges[0];if(this.multiSelect.isEmpty()&&t==this.multiSelect.anchor)return;var r=t==this.multiSelect.anchor?n.cursor==n.start?n.end:n.start:n.cursor;r.row!=t.row||this.session.$clipPositionToDocument(r.row,r.column).column!=t.column?this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange()):this.multiSelect.mergeOverlappingRanges()}},this.findAll=function(e,t,n){t=t||{},t.needle=e||t.needle;if(t.needle==undefined){var r=this.selection.isEmpty()?this.selection.getWordRange():this.selection.getRange();t.needle=this.session.getTextRange(r)}this.$search.set(t);var i=this.$search.findAll(this.session);if(!i.length)return 0;var s=this.multiSelect;n||s.toSingleRange(i[0]);for(var o=i.length;o--;)s.addRange(i[o],!0);return r&&s.rangeList.rangeAtPoint(r.start)&&s.addRange(r,!0),i.length},this.selectMoreLines=function(e,t){var n=this.selection.toOrientedRange(),r=n.cursor==n.end,s=this.session.documentToScreenPosition(n.cursor);this.selection.$desiredColumn&&(s.column=this.selection.$desiredColumn);var o=this.session.screenToDocumentPosition(s.row+e,s.column);if(!n.isEmpty())var u=this.session.documentToScreenPosition(r?n.end:n.start),a=this.session.screenToDocumentPosition(u.row+e,u.column);else var a=o;if(r){var f=i.fromPoints(o,a);f.cursor=f.start}else{var f=i.fromPoints(a,o);f.cursor=f.end}f.desiredColumn=s.column;if(!this.selection.inMultiSelectMode)this.selection.addRange(n);else if(t)var l=n.cursor;this.selection.addRange(f),l&&this.selection.substractPoint(l)},this.transposeSelections=function(e){var t=this.session,n=t.multiSelect,r=n.ranges;for(var i=r.length;i--;){var s=r[i];if(s.isEmpty()){var o=t.getWordRange(s.start.row,s.start.column);s.start.row=o.start.row,s.start.column=o.start.column,s.end.row=o.end.row,s.end.column=o.end.column}}n.mergeOverlappingRanges();var u=[];for(var i=r.length;i--;){var s=r[i];u.unshift(t.getTextRange(s))}e<0?u.unshift(u.pop()):u.push(u.shift());for(var i=r.length;i--;){var s=r[i],a=s.clone();t.replace(s,u[i]),s.start.row=a.start.row,s.start.column=a.start.column}n.fromOrientedRange(n.ranges[0])},this.selectMore=function(e,t,n){var r=this.session,i=r.multiSelect,s=i.toOrientedRange();if(s.isEmpty()){s=r.getWordRange(s.start.row,s.start.column),s.cursor=e==-1?s.start:s.end,this.multiSelect.addRange(s);if(n)return}var o=r.getTextRange(s),u=h(r,o,e);u&&(u.cursor=e==-1?u.start:u.end,this.session.unfold(u),this.multiSelect.addRange(u),this.renderer.scrollCursorIntoView(null,.5)),t&&this.multiSelect.substractPoint(s.cursor)},this.alignCursors=function(){var e=this.session,t=e.multiSelect,n=t.ranges,r=-1,s=n.filter(function(e){if(e.cursor.row==r)return!0;r=e.cursor.row});if(!n.length||s.length==n.length-1){var o=this.selection.getRange(),u=o.start.row,f=o.end.row,l=u==f;if(l){var c=this.session.getLength(),h;do h=this.session.getLine(f);while(/[=:]/.test(h)&&++f<c);do h=this.session.getLine(u);while(/[=:]/.test(h)&&--u>0);u<0&&(u=0),f>=c&&(f=c-1)}var p=this.session.removeFullLines(u,f);p=this.$reAlignText(p,l),this.session.insert({row:u,column:0},p.join("\n")+"\n"),l||(o.start.column=0,o.end.column=p[p.length-1].length),this.selection.setRange(o)}else{s.forEach(function(e){t.substractPoint(e.cursor)});var d=0,v=Infinity,m=n.map(function(t){var n=t.cursor,r=e.getLine(n.row),i=r.substr(n.column).search(/\S/g);return i==-1&&(i=0),n.column>d&&(d=n.column),i<v&&(v=i),i});n.forEach(function(t,n){var r=t.cursor,s=d-r.column,o=m[n]-v;s>o?e.insert(r,a.stringRepeat(" ",s-o)):e.remove(new i(r.row,r.column,r.row,r.column-s+o)),t.start.column=t.end.column=d,t.start.row=t.end.row=r.row,t.cursor=t.end}),t.fromOrientedRange(n[0]),this.renderer.updateCursor(),this.renderer.updateBackMarkers()}},this.$reAlignText=function(e,t){function u(e){return a.stringRepeat(" ",e)}function f(e){return e[2]?u(i)+e[2]+u(s-e[2].length+o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function l(e){return e[2]?u(i+s-e[2].length)+e[2]+u(o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function c(e){return e[2]?u(i)+e[2]+u(o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}var n=!0,r=!0,i,s,o;return e.map(function(e){var t=e.match(/(\s*)(.*?)(\s*)([=:].*)/);return t?i==null?(i=t[1].length,s=t[2].length,o=t[3].length,t):(i+s+o!=t[1].length+t[2].length+t[3].length&&(r=!1),i!=t[1].length&&(n=!1),i>t[1].length&&(i=t[1].length),s<t[2].length&&(s=t[2].length),o>t[3].length&&(o=t[3].length),t):[e]}).map(t?f:n?r?l:f:c)}}).call(d.prototype),t.onSessionChange=function(e){var t=e.session;t&&!t.multiSelect&&(t.$selectionMarkers=[],t.selection.$initRangeList(),t.multiSelect=t.selection),this.multiSelect=t&&t.multiSelect;var n=e.oldSession;n&&(n.multiSelect.off("addRange",this.$onAddRange),n.multiSelect.off("removeRange",this.$onRemoveRange),n.multiSelect.off("multiSelect",this.$onMultiSelect),n.multiSelect.off("singleSelect",this.$onSingleSelect),n.multiSelect.lead.off("change",this.$checkMultiselectChange),n.multiSelect.anchor.off("change",this.$checkMultiselectChange)),t&&(t.multiSelect.on("addRange",this.$onAddRange),t.multiSelect.on("removeRange",this.$onRemoveRange),t.multiSelect.on("multiSelect",this.$onMultiSelect),t.multiSelect.on("singleSelect",this.$onSingleSelect),t.multiSelect.lead.on("change",this.$checkMultiselectChange),t.multiSelect.anchor.on("change",this.$checkMultiselectChange)),t&&this.inMultiSelectMode!=t.selection.inMultiSelectMode&&(t.selection.inMultiSelectMode?this.$onMultiSelect():this.$onSingleSelect())},t.MultiSelect=m,e("./config").defineOptions(d.prototype,"editor",{enableMultiselect:{set:function(e){m(this),e?this.on("mousedown",o):this.off("mousedown",o)},value:!0},enableBlockSelect:{set:function(e){this.$blockSelectEnabled=e},value:!0}})}),define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../../range").Range,i=t.FoldMode=function(){};(function(){this.foldingStartMarker=null,this.foldingStopMarker=null,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);return this.foldingStartMarker.test(r)?"start":t=="markbeginend"&&this.foldingStopMarker&&this.foldingStopMarker.test(r)?"end":""},this.getFoldWidgetRange=function(e,t,n){return null},this.indentationBlock=function(e,t,n){var i=/\S/,s=e.getLine(t),o=s.search(i);if(o==-1)return;var u=n||s.length,a=e.getLength(),f=t,l=t;while(++t<a){var c=e.getLine(t).search(i);if(c==-1)continue;if(c<=o){var h=e.getTokenAt(t,0);if(!h||h.type!=="string")break}l=t}if(l>f){var p=e.getLine(l).length;return new r(f,u,l,p)}},this.openingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i+1},u=e.$findClosingBracket(t,o,s);if(!u)return;var a=e.foldWidgets[u.row];return a==null&&(a=e.getFoldWidget(u.row)),a=="start"&&u.row>o.row&&(u.row--,u.column=e.getLine(u.row).length),r.fromPoints(o,u)},this.closingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i},u=e.$findOpeningBracket(t,o);if(!u)return;return u.column++,o.column--,r.fromPoints(u,o)}}).call(i.prototype)}),define("ace/ext/error_marker",["require","exports","module","ace/lib/dom","ace/range","ace/config"],function(e,t,n){"use strict";function o(e,t,n){var r=0,i=e.length-1;while(r<=i){var s=r+i>>1,o=n(t,e[s]);if(o>0)r=s+1;else{if(!(o<0))return s;i=s-1}}return-(r+1)}function u(e,t,n){var r=e.getAnnotations().sort(i.comparePoints);if(!r.length)return;var s=o(r,{row:t,column:-1},i.comparePoints);s<0&&(s=-s-1),s>=r.length?s=n>0?0:r.length-1:s===0&&n<0&&(s=r.length-1);var u=r[s];if(!u||!n)return;if(u.row===t){do u=r[s+=n];while(u&&u.row===t);if(!u)return r.slice()}var a=[];t=u.row;do a[n<0?"unshift":"push"](u),u=r[s+=n];while(u&&u.row==t);return a.length&&a}var r=e("../lib/dom"),i=e("../range").Range,s=e("../config").nls;t.showErrorMarker=function(e,t){var n=e.session,i=e.getCursorPosition(),o=i.row,a=n.widgetManager.getWidgetsAtRow(o).filter(function(e){return e.type=="errorMarker"})[0];a?a.destroy():o-=t;var f=u(n,o,t),l;if(f){var c=f[0];i.column=(c.pos&&typeof c.column!="number"?c.pos.sc:c.column)||0,i.row=c.row,l=e.renderer.$gutterLayer.$annotations[i.row]}else{if(a)return;l={displayText:[s("error-marker.good-state","Looks good!")],className:"ace_ok"}}e.session.unfold(i.row),e.selection.moveToPosition(i);var h={row:i.row,fixedWidth:!0,coverGutter:!0,el:r.createElement("div"),type:"errorMarker"},p=h.el.appendChild(r.createElement("div")),d=h.el.appendChild(r.createElement("div"));d.className="error_widget_arrow "+l.className;var v=e.renderer.$cursorLayer.getPixelPosition(i).left;d.style.left=v+e.renderer.gutterWidth-5+"px",h.el.className="error_widget_wrapper",p.className="error_widget "+l.className,l.displayText.forEach(function(e,t){p.appendChild(r.createTextNode(e)),t<l.displayText.length-1&&p.appendChild(r.createElement("br"))}),p.appendChild(r.createElement("div"));var m=function(e,t,n){if(t===0&&(n==="esc"||n==="return"))return h.destroy(),{command:"null"}};h.destroy=function(){if(e.$mouseHandler.isMousePressed)return;e.keyBinding.removeKeyboardHandler(m),n.widgetManager.removeLineWidget(h),e.off("changeSelection",h.destroy),e.off("changeSession",h.destroy),e.off("mouseup",h.destroy),e.off("change",h.destroy)},e.keyBinding.addKeyboardHandler(m),e.on("changeSelection",h.destroy),e.on("changeSession",h.destroy),e.on("mouseup",h.destroy),e.on("change",h.destroy),e.session.widgetManager.addLineWidget(h),h.el.onmousedown=e.focus.bind(e),e.renderer.scrollCursorIntoView(null,.5,{bottom:h.el.offsetHeight})},r.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n","error_marker.css",!1)}),define("ace/ace",["require","exports","module","ace/lib/dom","ace/range","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config","ace/loader_build"],function(e,t,n){"use strict";e("./loader_build")(t);var r=e("./lib/dom"),i=e("./range").Range,s=e("./editor").Editor,o=e("./edit_session").EditSession,u=e("./undomanager").UndoManager,a=e("./virtual_renderer").VirtualRenderer;e("./worker/worker_client"),e("./keyboard/hash_handler"),e("./placeholder"),e("./multi_select"),e("./mode/folding/fold_mode"),e("./theme/textmate"),e("./ext/error_marker"),t.config=e("./config"),t.edit=function(e,n){if(typeof e=="string"){var i=e;e=document.getElementById(i);if(!e)throw new Error("ace.edit can't find div #"+i)}if(e&&e.env&&e.env.editor instanceof s)return e.env.editor;var o="";if(e&&/input|textarea/i.test(e.tagName)){var u=e;o=u.value,e=r.createElement("pre"),u.parentNode.replaceChild(e,u)}else e&&(o=e.textContent,e.innerHTML="");var f=t.createEditSession(o),l=new s(new a(e),f,n),c={document:f,editor:l,onResize:l.resize.bind(l,null)};return u&&(c.textarea=u),l.on("destroy",function(){c.editor.container.env=null}),l.container.env=l.env=c,l},t.createEditSession=function(e,t){var n=new o(e,t);return n.setUndoManager(new u),n},t.Range=i,t.Editor=s,t.EditSession=o,t.UndoManager=u,t.VirtualRenderer=a;var f=t.config.version;t.version=f});            (function() {
                window.require(["ace/ace"], function(a) {
                    if (a) {
                        a.config.init(true);
                        a.define = window.define;
                    }
                    var global = (function () {
                        return this;
                    })();
                    if (!global && typeof window != "undefined") global = window; // can happen in strict mode
                    if (!global && typeof self != "undefined") global = self; // can happen in webworker
                    
                    if (!global.ace)
                        global.ace = a;
                    for (var key in a) if (a.hasOwnProperty(key))
                        global.ace[key] = a[key];
                    global.ace["default"] = global.ace;
                    if (typeof module == "object" && typeof exports == "object" && module) {
                        module.exports = global.ace;
                    }
                });
            })();
        